import _objectWithoutProperties3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _get2 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _toArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _defineProperty3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _assertThisInitialized3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf4 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits3 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var _ConsoleMethod, _PLATFORM_LOG_STRING, _ERRORS$, _ERRORS, _SERVER_ERROR_MAP;

function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _ownKeys(source, true).forEach(function (key) { _defineProperty3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

import * as React from "react";
import React__default, { createElement as createElement$1, useRef, useLayoutEffect, useEffect, useReducer, useState, isValidElement, cloneElement, forwardRef as forwardRef$1, useContext, createContext, useMemo, useCallback, Component as Component$1, Fragment as Fragment$1 } from "react";
import require$$1, { render as render$1, createPortal, unstable_batchedUpdates } from "react-dom";
var tailwindcss = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}

function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var a = Object.defineProperty({}, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function (k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d2.get ? d2 : {
      enumerable: true,
      get: function get() {
        return n2[k2];
      }
    });
  });
  return a;
}

function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var axios$2 = {
  exports: {}
};

var bind$2 = function bind(fn3, thisArg) {
  return function wrap2() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn3.apply(thisArg, args);
  };
};

var bind$1 = bind$2;
var toString$5 = Object.prototype.toString;

function isArray$6(val) {
  return Array.isArray(val);
}

function isUndefined(val) {
  return typeof val === "undefined";
}

function isBuffer$3(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}

function isArrayBuffer(val) {
  return toString$5.call(val) === "[object ArrayBuffer]";
}

function isFormData(val) {
  return toString$5.call(val) === "[object FormData]";
}

function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }

  return result;
}

function isString(val) {
  return typeof val === "string";
}

function isNumber(val) {
  return typeof val === "number";
}

function isObject$7(val) {
  return val !== null && typeof val === "object";
}

function isPlainObject(val) {
  if (toString$5.call(val) !== "[object Object]") {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

function isDate(val) {
  return toString$5.call(val) === "[object Date]";
}

function isFile(val) {
  return toString$5.call(val) === "[object File]";
}

function isBlob(val) {
  return toString$5.call(val) === "[object Blob]";
}

function isFunction$3(val) {
  return toString$5.call(val) === "[object Function]";
}

function isStream(val) {
  return isObject$7(val) && isFunction$3(val.pipe);
}

function isURLSearchParams(val) {
  return toString$5.call(val) === "[object URLSearchParams]";
}

function trim$1(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}

function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }

  return typeof window !== "undefined" && typeof document !== "undefined";
}

function forEach(obj, fn3) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }

  if (typeof obj !== "object") {
    obj = [obj];
  }

  if (isArray$6(obj)) {
    for (var i = 0, l2 = obj.length; i < l2; i++) {
      fn3.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn3.call(null, obj[key], key, obj);
      }
    }
  }
}

function merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray$6(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l2 = arguments.length; i < l2; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}

function extend(a, b2, thisArg) {
  forEach(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }

  return content;
}

var utils$e = {
  isArray: isArray$6,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$3,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject$7,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$3,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim$1,
  stripBOM: stripBOM
};
var utils$d = utils$e;

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}

var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize2(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v2) {
        if (utils$d.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$d.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }

        parts.push(encode(key) + "=" + encode(v2));
      });
    });
    serializedParams = parts.join("&");
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }

  return url;
};

var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options2) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options2 ? options2.synchronous : false,
    runWhen: options2 ? options2.runWhen : null
  });
  return this.handlers.length - 1;
};

InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

InterceptorManager$1.prototype.forEach = function forEach2(fn3) {
  utils$c.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn3(h2);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};

var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request2;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };

  return error;
};

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var enhanceError$1 = enhanceError$2;

var createError$2 = function createError(message, config, code, request2, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request2, response);
};

var createError$1 = createError$2;

var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;

  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};

var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write2(name2, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));

      if (utils$a.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }

      if (utils$a.isString(path)) {
        cookie.push("path=" + path);
      }

      if (utils$a.isString(domain)) {
        cookie.push("domain=" + domain);
      }

      if (secure === true) {
        cookie.push("secure");
      }

      document.cookie = cookie.join("; ");
    },
    read: function read2(name2) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write2() {},
    read: function read2() {
      return null;
    },
    remove: function remove() {}
  };
}();

var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;

var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }

  return requestedURL;
};

var utils$9 = utils$e;
var ignoreDuplicateOf = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils$9.forEach(headers.split("\n"), function parser(line2) {
    i = line2.indexOf(":");
    key = utils$9.trim(line2.substr(0, i)).toLowerCase();
    val = utils$9.trim(line2.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};

var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;

  function resolveURL(url) {
    var href = url;

    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();

function Cancel$3(message) {
  this.message = message;
}

Cancel$3.prototype.toString = function toString() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};

Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var transitionalDefaults$1 = transitional;
var Cancel$2 = Cancel_1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;

    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }

    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }

    var request2 = new XMLHttpRequest();

    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }

    var fullPath = buildFullPath2(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;

    function onloadend() {
      if (!request2) {
        return;
      }

      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config: config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }

    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }

        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }

        setTimeout(onloadend);
      };
    }

    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }

      reject(createError2("Request aborted", config, "ECONNABORTED", request2));
      request2 = null;
    };

    request2.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request2));
      request2 = null;
    };

    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config.transitional || transitionalDefaults$1;

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError2(timeoutErrorMessage, config, transitional3.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
      request2 = null;
    };

    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    if ("setRequestHeader" in request2) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }

    if (!utils$7.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }

    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }

    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }

    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      onCanceled = function onCanceled(cancel) {
        if (!request2) {
          return;
        }

        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request2.abort();
        request2 = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);

      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    request2.send(requestData);
  });
};

var utils$6 = utils$e;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var transitionalDefaults = transitional;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$4 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");

    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }

    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }

    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }

    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }

    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$4.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";

    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError2(e2, this, "E_JSON_PARSE");
          }

          throw e2;
        }
      }
    }

    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$4.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$4.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$4;
var utils$5 = utils$e;
var defaults$3 = defaults_1;

var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$3;
  utils$5.forEach(fns, function transform(fn3) {
    data2 = fn3.call(context, data2, headers);
  });
  return data2;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$4 = utils$e;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$2 = defaults_1;
var Cancel$1 = Cancel_1;

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}

var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$4.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$2.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);

      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

var utils$3 = utils$e;

var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }

    return source2;
  }

  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }

  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }

  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }

  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }

  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};

var data = {
  "version": "0.26.1"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function (type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};

validators$1.transitional = function transitional2(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }

  return function (value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }

    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }

    return validator2 ? validator2(value, opt, opts) : true;
  };
};

function assertOptions(options2, schema, allowUnknown) {
  if (typeof options2 !== "object") {
    throw new TypeError("options must be an object");
  }

  var keys2 = Object.keys(options2);
  var i = keys2.length;

  while (i-- > 0) {
    var opt = keys2[i];
    var validator2 = schema[opt];

    if (validator2) {
      var value = options2[opt];
      var result = value === void 0 || validator2(value, opt, options2);

      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;

function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig$1(this.defaults, config);

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }

  var transitional3 = config.transitional;

  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};

utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function (url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function (url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;

function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token2 = this;
  this.promise.then(function (cancel) {
    if (!token2._listeners) return;
    var i;
    var l2 = token2._listeners.length;

    for (i = 0; i < l2; i++) {
      token2._listeners[i](cancel);
    }

    token2._listeners = null;
  });

  this.promise.then = function (onfulfilled) {
    var _resolve;

    var promise = new Promise(function (resolve) {
      token2.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token2.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token2.reason) {
      return;
    }

    token2.reason = new Cancel(message);
    resolvePromise(token2.reason);
  });
}

CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }

  var index2 = this._listeners.indexOf(listener);

  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};

CancelToken.source = function source() {
  var cancel;
  var token2 = new CancelToken(function executor(c2) {
    cancel = c2;
  });
  return {
    token: token2,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

var spread = function spread2(callback) {
  return function wrap2(arr) {
    return callback.apply(null, arr);
  };
};

var utils$1 = utils$e;

var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};

var utils = utils$e;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults$1 = defaults_1;

function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);

  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };

  return instance;
}

var axios$1 = createInstance(defaults$1);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var stringToByteArray$1 = function stringToByteArray$1(str) {
  var out = [];
  var p2 = 0;

  for (var _i4 = 0; _i4 < str.length; _i4++) {
    var c2 = str.charCodeAt(_i4);

    if (c2 < 128) {
      out[p2++] = c2;
    } else if (c2 < 2048) {
      out[p2++] = c2 >> 6 | 192;
      out[p2++] = c2 & 63 | 128;
    } else if ((c2 & 64512) === 55296 && _i4 + 1 < str.length && (str.charCodeAt(_i4 + 1) & 64512) === 56320) {
      c2 = 65536 + ((c2 & 1023) << 10) + (str.charCodeAt(++_i4) & 1023);
      out[p2++] = c2 >> 18 | 240;
      out[p2++] = c2 >> 12 & 63 | 128;
      out[p2++] = c2 >> 6 & 63 | 128;
      out[p2++] = c2 & 63 | 128;
    } else {
      out[p2++] = c2 >> 12 | 224;
      out[p2++] = c2 >> 6 & 63 | 128;
      out[p2++] = c2 & 63 | 128;
    }
  }

  return out;
};

var byteArrayToString = function byteArrayToString(bytes) {
  var out = [];
  var pos = 0,
      c2 = 0;

  while (pos < bytes.length) {
    var c1 = bytes[pos++];

    if (c1 < 128) {
      out[c2++] = String.fromCharCode(c1);
    } else if (c1 > 191 && c1 < 224) {
      var c22 = bytes[pos++];
      out[c2++] = String.fromCharCode((c1 & 31) << 6 | c22 & 63);
    } else if (c1 > 239 && c1 < 365) {
      var _c2 = bytes[pos++];
      var c3 = bytes[pos++];
      var c4 = bytes[pos++];
      var u2 = ((c1 & 7) << 18 | (_c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 65536;
      out[c2++] = String.fromCharCode(55296 + (u2 >> 10));
      out[c2++] = String.fromCharCode(56320 + (u2 & 1023));
    } else {
      var _c3 = bytes[pos++];
      var _c4 = bytes[pos++];
      out[c2++] = String.fromCharCode((c1 & 15) << 12 | (_c3 & 63) << 6 | _c4 & 63);
    }
  }

  return out.join("");
};

var base64 = {
  byteToCharMap_: null,
  charToByteMap_: null,
  byteToCharMapWebSafe_: null,
  charToByteMapWebSafe_: null,
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",

  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },

  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },

  HAS_NATIVE_SUPPORT: typeof atob === "function",
  encodeByteArray: function encodeByteArray(input, webSafe) {
    if (!Array.isArray(input)) {
      throw Error("encodeByteArray takes an array as a parameter");
    }

    this.init_();
    var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
    var output = [];

    for (var _i5 = 0; _i5 < input.length; _i5 += 3) {
      var byte1 = input[_i5];
      var haveByte2 = _i5 + 1 < input.length;
      var byte2 = haveByte2 ? input[_i5 + 1] : 0;
      var haveByte3 = _i5 + 2 < input.length;
      var byte3 = haveByte3 ? input[_i5 + 2] : 0;
      var outByte1 = byte1 >> 2;
      var outByte2 = (byte1 & 3) << 4 | byte2 >> 4;
      var outByte3 = (byte2 & 15) << 2 | byte3 >> 6;
      var outByte4 = byte3 & 63;

      if (!haveByte3) {
        outByte4 = 64;

        if (!haveByte2) {
          outByte3 = 64;
        }
      }

      output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
    }

    return output.join("");
  },
  encodeString: function encodeString(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return btoa(input);
    }

    return this.encodeByteArray(stringToByteArray$1(input), webSafe);
  },
  decodeString: function decodeString(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return atob(input);
    }

    return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
  },
  decodeStringToByteArray: function decodeStringToByteArray(input, webSafe) {
    this.init_();
    var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
    var output = [];

    for (var _i6 = 0; _i6 < input.length;) {
      var byte1 = charToByteMap[input.charAt(_i6++)];
      var haveByte2 = _i6 < input.length;
      var byte2 = haveByte2 ? charToByteMap[input.charAt(_i6)] : 0;
      ++_i6;
      var haveByte3 = _i6 < input.length;
      var byte3 = haveByte3 ? charToByteMap[input.charAt(_i6)] : 64;
      ++_i6;
      var haveByte4 = _i6 < input.length;
      var byte4 = haveByte4 ? charToByteMap[input.charAt(_i6)] : 64;
      ++_i6;

      if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
        throw new DecodeBase64StringError();
      }

      var outByte1 = byte1 << 2 | byte2 >> 4;
      output.push(outByte1);

      if (byte3 !== 64) {
        var outByte2 = byte2 << 4 & 240 | byte3 >> 2;
        output.push(outByte2);

        if (byte4 !== 64) {
          var outByte3 = byte3 << 6 & 192 | byte4;
          output.push(outByte3);
        }
      }
    }

    return output;
  },
  init_: function init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {};
      this.charToByteMap_ = {};
      this.byteToCharMapWebSafe_ = {};
      this.charToByteMapWebSafe_ = {};

      for (var _i7 = 0; _i7 < this.ENCODED_VALS.length; _i7++) {
        this.byteToCharMap_[_i7] = this.ENCODED_VALS.charAt(_i7);
        this.charToByteMap_[this.byteToCharMap_[_i7]] = _i7;
        this.byteToCharMapWebSafe_[_i7] = this.ENCODED_VALS_WEBSAFE.charAt(_i7);
        this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[_i7]] = _i7;

        if (_i7 >= this.ENCODED_VALS_BASE.length) {
          this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(_i7)] = _i7;
          this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(_i7)] = _i7;
        }
      }
    }
  }
};

var DecodeBase64StringError =
/*#__PURE__*/
function (_Error) {
  _inherits3(DecodeBase64StringError, _Error);

  function DecodeBase64StringError() {
    var _this12;

    _classCallCheck3(this, DecodeBase64StringError);

    _this12 = _possibleConstructorReturn3(this, _getPrototypeOf4(DecodeBase64StringError).apply(this, arguments));
    _this12.name = "DecodeBase64StringError";
    return _this12;
  }

  return DecodeBase64StringError;
}(_wrapNativeSuper(Error));

var base64Encode = function base64Encode(str) {
  var utf8Bytes = stringToByteArray$1(str);
  return base64.encodeByteArray(utf8Bytes, true);
};

var base64urlEncodeWithoutPadding = function base64urlEncodeWithoutPadding(str) {
  return base64Encode(str).replace(/\./g, "");
};

var base64Decode = function base64Decode(str) {
  try {
    return base64.decodeString(str, true);
  } catch (e2) {
    console.error("base64Decode failed: ", e2);
  }

  return null;
};

function deepExtend(target, source2) {
  if (!(source2 instanceof Object)) {
    return source2;
  }

  switch (source2.constructor) {
    case Date:
      var dateValue = source2;
      return new Date(dateValue.getTime());

    case Object:
      if (target === void 0) {
        target = {};
      }

      break;

    case Array:
      target = [];
      break;

    default:
      return source2;
  }

  for (var prop in source2) {
    if (!source2.hasOwnProperty(prop) || !isValidKey(prop)) {
      continue;
    }

    target[prop] = deepExtend(target[prop], source2[prop]);
  }

  return target;
}

function isValidKey(key) {
  return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getGlobal() {
  if (typeof self !== "undefined") {
    return self;
  }

  if (typeof window !== "undefined") {
    return window;
  }

  if (typeof global !== "undefined") {
    return global;
  }

  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var getDefaultsFromGlobal = function getDefaultsFromGlobal() {
  return getGlobal().__FIREBASE_DEFAULTS__;
};

var getDefaultsFromEnvVariable = function getDefaultsFromEnvVariable() {
  if (typeof process === "undefined" || typeof process.env === "undefined") {
    return;
  }

  var defaultsJsonString = {}.__FIREBASE_DEFAULTS__;

  if (defaultsJsonString) {
    return JSON.parse(defaultsJsonString);
  }
};

var getDefaultsFromCookie = function getDefaultsFromCookie() {
  if (typeof document === "undefined") {
    return;
  }

  var match2;

  try {
    match2 = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch (e2) {
    return;
  }

  var decoded = match2 && base64Decode(match2[1]);
  return decoded && JSON.parse(decoded);
};

var getDefaults = function getDefaults() {
  try {
    return getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
  } catch (e2) {
    console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e2));
    return;
  }
};

var getDefaultEmulatorHost = function getDefaultEmulatorHost(productName) {
  var _a2, _b;

  return (_b = (_a2 = getDefaults()) === null || _a2 === void 0 ? void 0 : _a2.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};

var getDefaultAppConfig = function getDefaultAppConfig() {
  var _a2;

  return (_a2 = getDefaults()) === null || _a2 === void 0 ? void 0 : _a2.config;
};

var getExperimentalSetting = function getExperimentalSetting(name2) {
  var _a2;

  return (_a2 = getDefaults()) === null || _a2 === void 0 ? void 0 : _a2["_".concat(name2)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Deferred =
/*#__PURE__*/
function () {
  function Deferred() {
    var _this13 = this;

    _classCallCheck3(this, Deferred);

    this.reject = function () {};

    this.resolve = function () {};

    this.promise = new Promise(function (resolve, reject) {
      _this13.resolve = resolve;
      _this13.reject = reject;
    });
  }

  _createClass3(Deferred, [{
    key: "wrapCallback",
    value: function wrapCallback(callback) {
      var _this14 = this;

      return function (error, value) {
        if (error) {
          _this14.reject(error);
        } else {
          _this14.resolve(value);
        }

        if (typeof callback === "function") {
          _this14.promise.catch(function () {});

          if (callback.length === 1) {
            callback(error);
          } else {
            callback(error, value);
          }
        }
      };
    }
  }]);

  return Deferred;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getUA() {
  if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") {
    return navigator["userAgent"];
  } else {
    return "";
  }
}

function isMobileCordova() {
  return typeof window !== "undefined" && !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}

function isNode$1() {
  var _a2;

  var forceEnvironment = (_a2 = getDefaults()) === null || _a2 === void 0 ? void 0 : _a2.forceEnvironment;

  if (forceEnvironment === "node") {
    return true;
  } else if (forceEnvironment === "browser") {
    return false;
  }

  try {
    return Object.prototype.toString.call(global.process) === "[object process]";
  } catch (e2) {
    return false;
  }
}

function isBrowser$3() {
  return typeof self === "object" && self.self === self;
}

function isBrowserExtension() {
  var runtime2 = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : void 0;
  return typeof runtime2 === "object" && runtime2.id !== void 0;
}

function isReactNative() {
  return typeof navigator === "object" && navigator["product"] === "ReactNative";
}

function isIE() {
  var ua2 = getUA();
  return ua2.indexOf("MSIE ") >= 0 || ua2.indexOf("Trident/") >= 0;
}

function isIndexedDBAvailable() {
  try {
    return typeof indexedDB === "object";
  } catch (e2) {
    return false;
  }
}

function validateIndexedDBOpenable() {
  return new Promise(function (resolve, reject) {
    try {
      var preExist = true;
      var DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
      var request2 = self.indexedDB.open(DB_CHECK_NAME);

      request2.onsuccess = function () {
        request2.result.close();

        if (!preExist) {
          self.indexedDB.deleteDatabase(DB_CHECK_NAME);
        }

        resolve(true);
      };

      request2.onupgradeneeded = function () {
        preExist = false;
      };

      request2.onerror = function () {
        var _a2;

        reject(((_a2 = request2.error) === null || _a2 === void 0 ? void 0 : _a2.message) || "");
      };
    } catch (error) {
      reject(error);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERROR_NAME = "FirebaseError";

var FirebaseError =
/*#__PURE__*/
function (_Error2) {
  _inherits3(FirebaseError, _Error2);

  function FirebaseError(code, message, customData) {
    var _this15;

    _classCallCheck3(this, FirebaseError);

    _this15 = _possibleConstructorReturn3(this, _getPrototypeOf4(FirebaseError).call(this, message));
    _this15.code = code;
    _this15.customData = customData;
    _this15.name = ERROR_NAME;
    Object.setPrototypeOf(_assertThisInitialized3(_this15), FirebaseError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized3(_this15), ErrorFactory.prototype.create);
    }

    return _this15;
  }

  return FirebaseError;
}(_wrapNativeSuper(Error));

var ErrorFactory =
/*#__PURE__*/
function () {
  function ErrorFactory(service, serviceName, errors) {
    _classCallCheck3(this, ErrorFactory);

    this.service = service;
    this.serviceName = serviceName;
    this.errors = errors;
  }

  _createClass3(ErrorFactory, [{
    key: "create",
    value: function create(code) {
      var customData = (arguments.length <= 1 ? undefined : arguments[1]) || {};
      var fullCode = "".concat(this.service, "/").concat(code);
      var template = this.errors[code];
      var message = template ? replaceTemplate(template, customData) : "Error";
      var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
      var error = new FirebaseError(fullCode, fullMessage, customData);
      return error;
    }
  }]);

  return ErrorFactory;
}();

function replaceTemplate(template, data2) {
  return template.replace(PATTERN, function (_2, key) {
    var value = data2[key];
    return value != null ? String(value) : "<".concat(key, "?>");
  });
}

var PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function contains$1(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function isEmpty(obj) {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }

  return true;
}

function deepEqual$1(a, b2) {
  if (a === b2) {
    return true;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b2);

  for (var _i8 = 0, _aKeys = aKeys; _i8 < _aKeys.length; _i8++) {
    var k2 = _aKeys[_i8];

    if (!bKeys.includes(k2)) {
      return false;
    }

    var aProp = a[k2];
    var bProp = b2[k2];

    if (isObject$6(aProp) && isObject$6(bProp)) {
      if (!deepEqual$1(aProp, bProp)) {
        return false;
      }
    } else if (aProp !== bProp) {
      return false;
    }
  }

  for (var _i9 = 0, _bKeys = bKeys; _i9 < _bKeys.length; _i9++) {
    var _k2 = _bKeys[_i9];

    if (!aKeys.includes(_k2)) {
      return false;
    }
  }

  return true;
}

function isObject$6(thing) {
  return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function querystring(querystringParams) {
  var params = [];

  var _loop3 = function _loop3() {
    var _ref9 = _Object$entries[_i10];
    _ref10 = _slicedToArray3(_ref9, 2);
    var key = _ref10[0];
    var value = _ref10[1];

    if (Array.isArray(value)) {
      value.forEach(function (arrayVal) {
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
      });
    } else {
      params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  };

  for (var _i10 = 0, _Object$entries = Object.entries(querystringParams); _i10 < _Object$entries.length; _i10++) {
    var _ref10;

    _loop3();
  }

  return params.length ? "&" + params.join("&") : "";
}

function querystringDecode(querystring2) {
  var obj = {};
  var tokens = querystring2.replace(/^\?/, "").split("&");
  tokens.forEach(function (token2) {
    if (token2) {
      var _token2$split = token2.split("="),
          _token2$split2 = _slicedToArray3(_token2$split, 2),
          key = _token2$split2[0],
          value = _token2$split2[1];

      obj[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  });
  return obj;
}

function extractQuerystring(url) {
  var queryStart = url.indexOf("?");

  if (!queryStart) {
    return "";
  }

  var fragmentStart = url.indexOf("#", queryStart);
  return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : void 0);
}

function createSubscribe(executor, onNoObservers) {
  var proxy = new ObserverProxy(executor, onNoObservers);
  return proxy.subscribe.bind(proxy);
}

var ObserverProxy =
/*#__PURE__*/
function () {
  function ObserverProxy(executor, onNoObservers) {
    var _this16 = this;

    _classCallCheck3(this, ObserverProxy);

    this.observers = [];
    this.unsubscribes = [];
    this.observerCount = 0;
    this.task = Promise.resolve();
    this.finalized = false;
    this.onNoObservers = onNoObservers;
    this.task.then(function () {
      executor(_this16);
    }).catch(function (e2) {
      _this16.error(e2);
    });
  }

  _createClass3(ObserverProxy, [{
    key: "next",
    value: function next(value) {
      this.forEachObserver(function (observer) {
        observer.next(value);
      });
    }
  }, {
    key: "error",
    value: function error(_error) {
      this.forEachObserver(function (observer) {
        observer.error(_error);
      });
      this.close(_error);
    }
  }, {
    key: "complete",
    value: function complete() {
      this.forEachObserver(function (observer) {
        observer.complete();
      });
      this.close();
    }
  }, {
    key: "subscribe",
    value: function subscribe(nextOrObserver, error, complete) {
      var _this17 = this;

      var observer;

      if (nextOrObserver === void 0 && error === void 0 && complete === void 0) {
        throw new Error("Missing Observer.");
      }

      if (implementsAnyMethods(nextOrObserver, ["next", "error", "complete"])) {
        observer = nextOrObserver;
      } else {
        observer = {
          next: nextOrObserver,
          error: error,
          complete: complete
        };
      }

      if (observer.next === void 0) {
        observer.next = noop$1;
      }

      if (observer.error === void 0) {
        observer.error = noop$1;
      }

      if (observer.complete === void 0) {
        observer.complete = noop$1;
      }

      var unsub = this.unsubscribeOne.bind(this, this.observers.length);

      if (this.finalized) {
        this.task.then(function () {
          try {
            if (_this17.finalError) {
              observer.error(_this17.finalError);
            } else {
              observer.complete();
            }
          } catch (e2) {}

          return;
        });
      }

      this.observers.push(observer);
      return unsub;
    }
  }, {
    key: "unsubscribeOne",
    value: function unsubscribeOne(i) {
      if (this.observers === void 0 || this.observers[i] === void 0) {
        return;
      }

      delete this.observers[i];
      this.observerCount -= 1;

      if (this.observerCount === 0 && this.onNoObservers !== void 0) {
        this.onNoObservers(this);
      }
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(fn3) {
      if (this.finalized) {
        return;
      }

      for (var _i11 = 0; _i11 < this.observers.length; _i11++) {
        this.sendOne(_i11, fn3);
      }
    }
  }, {
    key: "sendOne",
    value: function sendOne(i, fn3) {
      var _this18 = this;

      this.task.then(function () {
        if (_this18.observers !== void 0 && _this18.observers[i] !== void 0) {
          try {
            fn3(_this18.observers[i]);
          } catch (e2) {
            if (typeof console !== "undefined" && console.error) {
              console.error(e2);
            }
          }
        }
      });
    }
  }, {
    key: "close",
    value: function close(err) {
      var _this19 = this;

      if (this.finalized) {
        return;
      }

      this.finalized = true;

      if (err !== void 0) {
        this.finalError = err;
      }

      this.task.then(function () {
        _this19.observers = void 0;
        _this19.onNoObservers = void 0;
      });
    }
  }]);

  return ObserverProxy;
}();

function implementsAnyMethods(obj, methods) {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var method = _step.value;

      if (method in obj && typeof obj[method] === "function") {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function noop$1() {}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getModularInstance(service) {
  if (service && service._delegate) {
    return service._delegate;
  } else {
    return service;
  }
}

var Component =
/*#__PURE__*/
function () {
  function Component(name2, instanceFactory, type) {
    _classCallCheck3(this, Component);

    this.name = name2;
    this.instanceFactory = instanceFactory;
    this.type = type;
    this.multipleInstances = false;
    this.serviceProps = {};
    this.instantiationMode = "LAZY";
    this.onInstanceCreated = null;
  }

  _createClass3(Component, [{
    key: "setInstantiationMode",
    value: function setInstantiationMode(mode) {
      this.instantiationMode = mode;
      return this;
    }
  }, {
    key: "setMultipleInstances",
    value: function setMultipleInstances(multipleInstances) {
      this.multipleInstances = multipleInstances;
      return this;
    }
  }, {
    key: "setServiceProps",
    value: function setServiceProps(props) {
      this.serviceProps = props;
      return this;
    }
  }, {
    key: "setInstanceCreatedCallback",
    value: function setInstanceCreatedCallback(callback) {
      this.onInstanceCreated = callback;
      return this;
    }
  }]);

  return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ENTRY_NAME$1 = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Provider =
/*#__PURE__*/
function () {
  function Provider(name2, container) {
    _classCallCheck3(this, Provider);

    this.name = name2;
    this.container = container;
    this.component = null;
    this.instances =
    /* @__PURE__ */
    new Map();
    this.instancesDeferred =
    /* @__PURE__ */
    new Map();
    this.instancesOptions =
    /* @__PURE__ */
    new Map();
    this.onInitCallbacks =
    /* @__PURE__ */
    new Map();
  }

  _createClass3(Provider, [{
    key: "get",
    value: function get(identifier2) {
      var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier2);

      if (!this.instancesDeferred.has(normalizedIdentifier)) {
        var deferred = new Deferred();
        this.instancesDeferred.set(normalizedIdentifier, deferred);

        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
          try {
            var instance = this.getOrInitializeService({
              instanceIdentifier: normalizedIdentifier
            });

            if (instance) {
              deferred.resolve(instance);
            }
          } catch (e2) {}
        }
      }

      return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
  }, {
    key: "getImmediate",
    value: function getImmediate(options2) {
      var _a2;

      var normalizedIdentifier = this.normalizeInstanceIdentifier(options2 === null || options2 === void 0 ? void 0 : options2.identifier);
      var optional = (_a2 = options2 === null || options2 === void 0 ? void 0 : options2.optional) !== null && _a2 !== void 0 ? _a2 : false;

      if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
        try {
          return this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier
          });
        } catch (e2) {
          if (optional) {
            return null;
          } else {
            throw e2;
          }
        }
      } else {
        if (optional) {
          return null;
        } else {
          throw Error("Service ".concat(this.name, " is not available"));
        }
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "setComponent",
    value: function setComponent(component) {
      if (component.name !== this.name) {
        throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
      }

      if (this.component) {
        throw Error("Component for ".concat(this.name, " has already been provided"));
      }

      this.component = component;

      if (!this.shouldAutoInitialize()) {
        return;
      }

      if (isComponentEager(component)) {
        try {
          this.getOrInitializeService({
            instanceIdentifier: DEFAULT_ENTRY_NAME$1
          });
        } catch (e2) {}
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.instancesDeferred.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref13 = _step2.value;

          var _ref12 = _slicedToArray3(_ref13, 2);

          var instanceIdentifier = _ref12[0];
          var instanceDeferred = _ref12[1];
          var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);

          try {
            var instance = this.getOrInitializeService({
              instanceIdentifier: normalizedIdentifier
            });
            instanceDeferred.resolve(instance);
          } catch (e2) {}
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "clearInstance",
    value: function clearInstance() {
      var identifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      this.instancesDeferred.delete(identifier2);
      this.instancesOptions.delete(identifier2);
      this.instances.delete(identifier2);
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var services;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                services = Array.from(this.instances.values());
                _context.next = 3;
                return Promise.all([].concat(_toConsumableArray3(services.filter(function (service) {
                  return "INTERNAL" in service;
                }).map(function (service) {
                  return service.INTERNAL.delete();
                })), _toConsumableArray3(services.filter(function (service) {
                  return "_delete" in service;
                }).map(function (service) {
                  return service._delete();
                }))));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "isComponentSet",
    value: function isComponentSet() {
      return this.component != null;
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      var identifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      return this.instances.has(identifier2);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var identifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      return this.instancesOptions.get(identifier2) || {};
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$options = opts.options,
          options2 = _opts$options === void 0 ? {} : _opts$options;
      var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);

      if (this.isInitialized(normalizedIdentifier)) {
        throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
      }

      if (!this.isComponentSet()) {
        throw Error("Component ".concat(this.name, " has not been registered yet"));
      }

      var instance = this.getOrInitializeService({
        instanceIdentifier: normalizedIdentifier,
        options: options2
      });
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.instancesDeferred.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref16 = _step3.value;

          var _ref15 = _slicedToArray3(_ref16, 2);

          var instanceIdentifier = _ref15[0];
          var instanceDeferred = _ref15[1];
          var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);

          if (normalizedIdentifier === normalizedDeferredIdentifier) {
            instanceDeferred.resolve(instance);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return instance;
    }
  }, {
    key: "onInit",
    value: function onInit(callback, identifier2) {
      var _a2;

      var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier2);
      var existingCallbacks = (_a2 = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a2 !== void 0 ? _a2 :
      /* @__PURE__ */
      new Set();
      existingCallbacks.add(callback);
      this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
      var existingInstance = this.instances.get(normalizedIdentifier);

      if (existingInstance) {
        callback(existingInstance, normalizedIdentifier);
      }

      return function () {
        existingCallbacks.delete(callback);
      };
    }
  }, {
    key: "invokeOnInitCallbacks",
    value: function invokeOnInitCallbacks(instance, identifier2) {
      var callbacks = this.onInitCallbacks.get(identifier2);

      if (!callbacks) {
        return;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = callbacks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var callback = _step4.value;

          try {
            callback(instance, identifier2);
          } catch (_a2) {}
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: "getOrInitializeService",
    value: function getOrInitializeService(_ref17) {
      var instanceIdentifier = _ref17.instanceIdentifier,
          _ref17$options = _ref17.options,
          options2 = _ref17$options === void 0 ? {} : _ref17$options;
      var instance = this.instances.get(instanceIdentifier);

      if (!instance && this.component) {
        instance = this.component.instanceFactory(this.container, {
          instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
          options: options2
        });
        this.instances.set(instanceIdentifier, instance);
        this.instancesOptions.set(instanceIdentifier, options2);
        this.invokeOnInitCallbacks(instance, instanceIdentifier);

        if (this.component.onInstanceCreated) {
          try {
            this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
          } catch (_a2) {}
        }
      }

      return instance || null;
    }
  }, {
    key: "normalizeInstanceIdentifier",
    value: function normalizeInstanceIdentifier() {
      var identifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;

      if (this.component) {
        return this.component.multipleInstances ? identifier2 : DEFAULT_ENTRY_NAME$1;
      } else {
        return identifier2;
      }
    }
  }, {
    key: "shouldAutoInitialize",
    value: function shouldAutoInitialize() {
      return !!this.component && this.component.instantiationMode !== "EXPLICIT";
    }
  }]);

  return Provider;
}();

function normalizeIdentifierForFactory(identifier2) {
  return identifier2 === DEFAULT_ENTRY_NAME$1 ? void 0 : identifier2;
}

function isComponentEager(component) {
  return component.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ComponentContainer =
/*#__PURE__*/
function () {
  function ComponentContainer(name2) {
    _classCallCheck3(this, ComponentContainer);

    this.name = name2;
    this.providers =
    /* @__PURE__ */
    new Map();
  }

  _createClass3(ComponentContainer, [{
    key: "addComponent",
    value: function addComponent(component) {
      var provider = this.getProvider(component.name);

      if (provider.isComponentSet()) {
        throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
      }

      provider.setComponent(component);
    }
  }, {
    key: "addOrOverwriteComponent",
    value: function addOrOverwriteComponent(component) {
      var provider = this.getProvider(component.name);

      if (provider.isComponentSet()) {
        this.providers.delete(component.name);
      }

      this.addComponent(component);
    }
  }, {
    key: "getProvider",
    value: function getProvider(name2) {
      if (this.providers.has(name2)) {
        return this.providers.get(name2);
      }

      var provider = new Provider(name2, this);
      this.providers.set(name2, provider);
      return provider;
    }
  }, {
    key: "getProviders",
    value: function getProviders() {
      return Array.from(this.providers.values());
    }
  }]);

  return ComponentContainer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var instances = [];
var LogLevel;

(function (LogLevel2) {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["VERBOSE"] = 1] = "VERBOSE";
  LogLevel2[LogLevel2["INFO"] = 2] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 3] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 4] = "ERROR";
  LogLevel2[LogLevel2["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));

var levelStringToEnum = {
  "debug": LogLevel.DEBUG,
  "verbose": LogLevel.VERBOSE,
  "info": LogLevel.INFO,
  "warn": LogLevel.WARN,
  "error": LogLevel.ERROR,
  "silent": LogLevel.SILENT
};
var defaultLogLevel = LogLevel.INFO;
var ConsoleMethod = (_ConsoleMethod = {}, _defineProperty3(_ConsoleMethod, LogLevel.DEBUG, "log"), _defineProperty3(_ConsoleMethod, LogLevel.VERBOSE, "log"), _defineProperty3(_ConsoleMethod, LogLevel.INFO, "info"), _defineProperty3(_ConsoleMethod, LogLevel.WARN, "warn"), _defineProperty3(_ConsoleMethod, LogLevel.ERROR, "error"), _ConsoleMethod);

var defaultLogHandler = function defaultLogHandler(instance, logType) {
  if (logType < instance.logLevel) {
    return;
  }

  var now2 = new Date().toISOString();
  var method = ConsoleMethod[logType];

  if (method) {
    var _console2;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    (_console2 = console)[method].apply(_console2, ["[".concat(now2, "]  ").concat(instance.name, ":")].concat(args));
  } else {
    throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(name2) {
    _classCallCheck3(this, Logger);

    this.name = name2;
    this._logLevel = defaultLogLevel;
    this._logHandler = defaultLogHandler;
    this._userLogHandler = null;
    instances.push(this);
  }

  _createClass3(Logger, [{
    key: "setLogLevel",
    value: function setLogLevel(val) {
      this._logLevel = typeof val === "string" ? levelStringToEnum[val] : val;
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.DEBUG].concat(args));

      this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));

      this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.INFO].concat(args));

      this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.WARN].concat(args));

      this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.ERROR].concat(args));

      this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    }
  }, {
    key: "logLevel",
    get: function get() {
      return this._logLevel;
    },
    set: function set(val) {
      if (!(val in LogLevel)) {
        throw new TypeError("Invalid value \"".concat(val, "\" assigned to `logLevel`"));
      }

      this._logLevel = val;
    }
  }, {
    key: "logHandler",
    get: function get() {
      return this._logHandler;
    },
    set: function set(val) {
      if (typeof val !== "function") {
        throw new TypeError("Value assigned to `logHandler` must be a function");
      }

      this._logHandler = val;
    }
  }, {
    key: "userLogHandler",
    get: function get() {
      return this._userLogHandler;
    },
    set: function set(val) {
      this._userLogHandler = val;
    }
  }]);

  return Logger;
}();

function setLogLevel$1(level) {
  instances.forEach(function (inst) {
    inst.setLogLevel(level);
  });
}

function setUserLogHandler(logCallback, options2) {
  var _loop4 = function _loop4() {
    var instance = _instances[_i12];
    var customLogLevel = null;

    if (options2 && options2.level) {
      customLogLevel = levelStringToEnum[options2.level];
    }

    if (logCallback === null) {
      instance.userLogHandler = null;
    } else {
      instance.userLogHandler = function (instance2, level) {
        for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
          args[_key9 - 2] = arguments[_key9];
        }

        var message = args.map(function (arg) {
          if (arg == null) {
            return null;
          } else if (typeof arg === "string") {
            return arg;
          } else if (typeof arg === "number" || typeof arg === "boolean") {
            return arg.toString();
          } else if (arg instanceof Error) {
            return arg.message;
          } else {
            try {
              return JSON.stringify(arg);
            } catch (ignored) {
              return null;
            }
          }
        }).filter(function (arg) {
          return arg;
        }).join(" ");

        if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance2.logLevel)) {
          logCallback({
            level: LogLevel[level].toLowerCase(),
            message: message,
            args: args,
            type: instance2.name
          });
        }
      };
    }
  };

  for (var _i12 = 0, _instances = instances; _i12 < _instances.length; _i12++) {
    _loop4();
  }
}

var instanceOfAny = function instanceOfAny(object, constructors) {
  return constructors.some(function (c2) {
    return object instanceof c2;
  });
};

var idbProxyableTypes;
var cursorAdvanceMethods;

function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}

function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}

var cursorRequestMap =
/* @__PURE__ */
new WeakMap();
var transactionDoneMap =
/* @__PURE__ */
new WeakMap();
var transactionStoreNamesMap =
/* @__PURE__ */
new WeakMap();
var transformCache =
/* @__PURE__ */
new WeakMap();
var reverseTransformCache =
/* @__PURE__ */
new WeakMap();

function promisifyRequest(request2) {
  var promise = new Promise(function (resolve, reject) {
    var unlisten = function unlisten() {
      request2.removeEventListener("success", success);
      request2.removeEventListener("error", error);
    };

    var success = function success() {
      resolve(wrap(request2.result));
      unlisten();
    };

    var error = function error() {
      reject(request2.error);
      unlisten();
    };

    request2.addEventListener("success", success);
    request2.addEventListener("error", error);
  });
  promise.then(function (value) {
    if (value instanceof IDBCursor) {
      cursorRequestMap.set(value, request2);
    }
  }).catch(function () {});
  reverseTransformCache.set(promise, request2);
  return promise;
}

function cacheDonePromiseForTransaction(tx) {
  if (transactionDoneMap.has(tx)) return;
  var done = new Promise(function (resolve, reject) {
    var unlisten = function unlisten() {
      tx.removeEventListener("complete", complete);
      tx.removeEventListener("error", error);
      tx.removeEventListener("abort", error);
    };

    var complete = function complete() {
      resolve();
      unlisten();
    };

    var error = function error() {
      reject(tx.error || new DOMException("AbortError", "AbortError"));
      unlisten();
    };

    tx.addEventListener("complete", complete);
    tx.addEventListener("error", error);
    tx.addEventListener("abort", error);
  });
  transactionDoneMap.set(tx, done);
}

var idbProxyTraps = {
  get: function get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      if (prop === "done") return transactionDoneMap.get(target);

      if (prop === "objectStoreNames") {
        return target.objectStoreNames || transactionStoreNamesMap.get(target);
      }

      if (prop === "store") {
        return receiver.objectStoreNames[1] ? void 0 : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }

    return wrap(target[prop]);
  },
  set: function set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has: function has(target, prop) {
    if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) {
      return true;
    }

    return prop in target;
  }
};

function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}

function wrapFunction(func) {
  if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) {
    return function (storeNames) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      var tx = func.call.apply(func, [unwrap$1(this), storeNames].concat(args));
      transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
      return wrap(tx);
    };
  }

  if (getCursorAdvanceMethods().includes(func)) {
    return function () {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      func.apply(unwrap$1(this), args);
      return wrap(cursorRequestMap.get(this));
    };
  }

  return function () {
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    return wrap(func.apply(unwrap$1(this), args));
  };
}

function transformCachableValue(value) {
  if (typeof value === "function") return wrapFunction(value);
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
  return value;
}

function wrap(value) {
  if (value instanceof IDBRequest) return promisifyRequest(value);
  if (transformCache.has(value)) return transformCache.get(value);
  var newValue = transformCachableValue(value);

  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }

  return newValue;
}

var unwrap$1 = function unwrap$1(value) {
  return reverseTransformCache.get(value);
};

function openDB(name2, version2) {
  var _ref18 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      blocked = _ref18.blocked,
      upgrade = _ref18.upgrade,
      blocking = _ref18.blocking,
      terminated = _ref18.terminated;

  var request2 = indexedDB.open(name2, version2);
  var openPromise = wrap(request2);

  if (upgrade) {
    request2.addEventListener("upgradeneeded", function (event) {
      upgrade(wrap(request2.result), event.oldVersion, event.newVersion, wrap(request2.transaction), event);
    });
  }

  if (blocked) {
    request2.addEventListener("blocked", function (event) {
      return blocked(event.oldVersion, event.newVersion, event);
    });
  }

  openPromise.then(function (db) {
    if (terminated) db.addEventListener("close", function () {
      return terminated();
    });

    if (blocking) {
      db.addEventListener("versionchange", function (event) {
        return blocking(event.oldVersion, event.newVersion, event);
      });
    }
  }).catch(function () {});
  return openPromise;
}

var readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"];
var writeMethods = ["put", "add", "delete", "clear"];
var cachedMethods =
/* @__PURE__ */
new Map();

function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) {
    return;
  }

  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  var targetFuncName = prop.replace(/FromIndex$/, "");
  var useIndex = prop !== targetFuncName;
  var isWrite = writeMethods.includes(targetFuncName);

  if (!(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }

  var method =
  /*#__PURE__*/
  function () {
    var _ref19 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(storeName) {
      var _target;

      var tx,
          target2,
          _len13,
          args,
          _key13,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
              target2 = tx.store;

              for (_len13 = _args2.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
                args[_key13 - 1] = _args2[_key13];
              }

              if (useIndex) target2 = target2.index(args.shift());
              _context2.next = 6;
              return Promise.all([(_target = target2)[targetFuncName].apply(_target, args), isWrite && tx.done]);

            case 6:
              return _context2.abrupt("return", _context2.sent[0]);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function method(_x) {
      return _ref19.apply(this, arguments);
    };
  }();

  cachedMethods.set(prop, method);
  return method;
}

replaceTraps(function (oldTraps) {
  return _objectSpread3({}, oldTraps, {
    get: function get(target, prop, receiver) {
      return getMethod(target, prop) || oldTraps.get(target, prop, receiver);
    },
    has: function has(target, prop) {
      return !!getMethod(target, prop) || oldTraps.has(target, prop);
    }
  });
});
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var PlatformLoggerServiceImpl =
/*#__PURE__*/
function () {
  function PlatformLoggerServiceImpl(container) {
    _classCallCheck3(this, PlatformLoggerServiceImpl);

    this.container = container;
  }

  _createClass3(PlatformLoggerServiceImpl, [{
    key: "getPlatformInfoString",
    value: function getPlatformInfoString() {
      var providers = this.container.getProviders();
      return providers.map(function (provider) {
        if (isVersionServiceProvider(provider)) {
          var service = provider.getImmediate();
          return "".concat(service.library, "/").concat(service.version);
        } else {
          return null;
        }
      }).filter(function (logString) {
        return logString;
      }).join(" ");
    }
  }]);

  return PlatformLoggerServiceImpl;
}();

function isVersionServiceProvider(provider) {
  var component = provider.getComponent();
  return (component === null || component === void 0 ? void 0 : component.type) === "VERSION";
}

var name$o = "@firebase/app";
var version$1$1 = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var logger$1 = new Logger("@firebase/app");
var name$n = "@firebase/app-compat";
var name$m = "@firebase/analytics-compat";
var name$l = "@firebase/analytics";
var name$k = "@firebase/app-check-compat";
var name$j = "@firebase/app-check";
var name$i = "@firebase/auth";
var name$h = "@firebase/auth-compat";
var name$g = "@firebase/database";
var name$f = "@firebase/database-compat";
var name$e = "@firebase/functions";
var name$d = "@firebase/functions-compat";
var name$c = "@firebase/installations";
var name$b = "@firebase/installations-compat";
var name$a = "@firebase/messaging";
var name$9 = "@firebase/messaging-compat";
var name$8 = "@firebase/performance";
var name$7 = "@firebase/performance-compat";
var name$6 = "@firebase/remote-config";
var name$5 = "@firebase/remote-config-compat";
var name$4 = "@firebase/storage";
var name$3$1 = "@firebase/storage-compat";
var name$2$1 = "@firebase/firestore";
var name$1$1 = "@firebase/firestore-compat";
var name$p = "firebase";
var version$4 = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DEFAULT_ENTRY_NAME = "[DEFAULT]";
var PLATFORM_LOG_STRING = (_PLATFORM_LOG_STRING = {}, _defineProperty3(_PLATFORM_LOG_STRING, name$o, "fire-core"), _defineProperty3(_PLATFORM_LOG_STRING, name$n, "fire-core-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$l, "fire-analytics"), _defineProperty3(_PLATFORM_LOG_STRING, name$m, "fire-analytics-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$j, "fire-app-check"), _defineProperty3(_PLATFORM_LOG_STRING, name$k, "fire-app-check-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$i, "fire-auth"), _defineProperty3(_PLATFORM_LOG_STRING, name$h, "fire-auth-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$g, "fire-rtdb"), _defineProperty3(_PLATFORM_LOG_STRING, name$f, "fire-rtdb-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$e, "fire-fn"), _defineProperty3(_PLATFORM_LOG_STRING, name$d, "fire-fn-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$c, "fire-iid"), _defineProperty3(_PLATFORM_LOG_STRING, name$b, "fire-iid-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$a, "fire-fcm"), _defineProperty3(_PLATFORM_LOG_STRING, name$9, "fire-fcm-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$8, "fire-perf"), _defineProperty3(_PLATFORM_LOG_STRING, name$7, "fire-perf-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$6, "fire-rc"), _defineProperty3(_PLATFORM_LOG_STRING, name$5, "fire-rc-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$4, "fire-gcs"), _defineProperty3(_PLATFORM_LOG_STRING, name$3$1, "fire-gcs-compat"), _defineProperty3(_PLATFORM_LOG_STRING, name$2$1, "fire-fst"), _defineProperty3(_PLATFORM_LOG_STRING, name$1$1, "fire-fst-compat"), _defineProperty3(_PLATFORM_LOG_STRING, "fire-js", "fire-js"), _defineProperty3(_PLATFORM_LOG_STRING, name$p, "fire-js-all"), _PLATFORM_LOG_STRING);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _apps =
/* @__PURE__ */
new Map();

var _components =
/* @__PURE__ */
new Map();

function _addComponent2(app, component) {
  try {
    app.container.addComponent(component);
  } catch (e2) {
    logger$1.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e2);
  }
}

function _addOrOverwriteComponent2(app, component) {
  app.container.addOrOverwriteComponent(component);
}

function _registerComponent(component) {
  var componentName = component.name;

  if (_components.has(componentName)) {
    logger$1.debug("There were multiple attempts to register component ".concat(componentName, "."));
    return false;
  }

  _components.set(componentName, component);

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = _apps.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var app = _step5.value;

      _addComponent2(app, component);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return true;
}

function _getProvider(app, name2) {
  var heartbeatController = app.container.getProvider("heartbeat").getImmediate({
    optional: true
  });

  if (heartbeatController) {
    void heartbeatController.triggerHeartbeat();
  }

  return app.container.getProvider(name2);
}

function _removeServiceInstance(app, name2) {
  var instanceIdentifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ENTRY_NAME;

  _getProvider(app, name2).clearInstance(instanceIdentifier);
}

function _clearComponents() {
  _components.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERRORS$1 = (_ERRORS$ = {}, _defineProperty3(_ERRORS$, "no-app", "No Firebase App '{$appName}' has been created - call initializeApp() first"), _defineProperty3(_ERRORS$, "bad-app-name", "Illegal App name: '{$appName}"), _defineProperty3(_ERRORS$, "duplicate-app", "Firebase App named '{$appName}' already exists with different options or config"), _defineProperty3(_ERRORS$, "app-deleted", "Firebase App named '{$appName}' already deleted"), _defineProperty3(_ERRORS$, "no-options", "Need to provide options, when not being deployed to hosting via source."), _defineProperty3(_ERRORS$, "invalid-app-argument", "firebase.{$appName}() takes either no argument or a Firebase App instance."), _defineProperty3(_ERRORS$, "invalid-log-argument", "First argument to `onLog` must be null or a function."), _defineProperty3(_ERRORS$, "idb-open", "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty3(_ERRORS$, "idb-get", "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty3(_ERRORS$, "idb-set", "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty3(_ERRORS$, "idb-delete", "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), _ERRORS$);
var ERROR_FACTORY$1 = new ErrorFactory("app", "Firebase", ERRORS$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FirebaseAppImpl$1 =
/*#__PURE__*/
function () {
  function FirebaseAppImpl$1(options2, config, container) {
    var _this20 = this;

    _classCallCheck3(this, FirebaseAppImpl$1);

    this._isDeleted = false;
    this._options = Object.assign({}, options2);
    this._config = Object.assign({}, config);
    this._name = config.name;
    this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
    this._container = container;
    this.container.addComponent(new Component("app", function () {
      return _this20;
    }, "PUBLIC"));
  }

  _createClass3(FirebaseAppImpl$1, [{
    key: "checkDestroyed",
    value: function checkDestroyed() {
      if (this.isDeleted) {
        throw ERROR_FACTORY$1.create("app-deleted", {
          appName: this._name
        });
      }
    }
  }, {
    key: "automaticDataCollectionEnabled",
    get: function get() {
      this.checkDestroyed();
      return this._automaticDataCollectionEnabled;
    },
    set: function set(val) {
      this.checkDestroyed();
      this._automaticDataCollectionEnabled = val;
    }
  }, {
    key: "name",
    get: function get() {
      this.checkDestroyed();
      return this._name;
    }
  }, {
    key: "options",
    get: function get() {
      this.checkDestroyed();
      return this._options;
    }
  }, {
    key: "config",
    get: function get() {
      this.checkDestroyed();
      return this._config;
    }
  }, {
    key: "container",
    get: function get() {
      return this._container;
    }
  }, {
    key: "isDeleted",
    get: function get() {
      return this._isDeleted;
    },
    set: function set(val) {
      this._isDeleted = val;
    }
  }]);

  return FirebaseAppImpl$1;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var SDK_VERSION = version$4;

function initializeApp(_options) {
  var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options2 = _options;

  if (typeof rawConfig !== "object") {
    var name3 = rawConfig;
    rawConfig = {
      name: name3
    };
  }

  var config = Object.assign({
    name: DEFAULT_ENTRY_NAME,
    automaticDataCollectionEnabled: false
  }, rawConfig);
  var name2 = config.name;

  if (typeof name2 !== "string" || !name2) {
    throw ERROR_FACTORY$1.create("bad-app-name", {
      appName: String(name2)
    });
  }

  options2 || (options2 = getDefaultAppConfig());

  if (!options2) {
    throw ERROR_FACTORY$1.create("no-options");
  }

  var existingApp = _apps.get(name2);

  if (existingApp) {
    if (deepEqual$1(options2, existingApp.options) && deepEqual$1(config, existingApp.config)) {
      return existingApp;
    } else {
      throw ERROR_FACTORY$1.create("duplicate-app", {
        appName: name2
      });
    }
  }

  var container = new ComponentContainer(name2);
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = _components.values()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var component = _step6.value;
      container.addComponent(component);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  var newApp = new FirebaseAppImpl$1(options2, config, container);

  _apps.set(name2, newApp);

  return newApp;
}

function getApp() {
  var name2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

  var app = _apps.get(name2);

  if (!app && name2 === DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
    return initializeApp();
  }

  if (!app) {
    throw ERROR_FACTORY$1.create("no-app", {
      appName: name2
    });
  }

  return app;
}

function getApps() {
  return Array.from(_apps.values());
}

function deleteApp(_x2) {
  return _deleteApp.apply(this, arguments);
}

function _deleteApp() {
  _deleteApp = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee646(app) {
    var name2;
    return _regeneratorRuntime.wrap(function _callee646$(_context647) {
      while (1) {
        switch (_context647.prev = _context647.next) {
          case 0:
            name2 = app.name;

            if (!_apps.has(name2)) {
              _context647.next = 6;
              break;
            }

            _apps.delete(name2);

            _context647.next = 5;
            return Promise.all(app.container.getProviders().map(function (provider) {
              return provider.delete();
            }));

          case 5:
            app.isDeleted = true;

          case 6:
          case "end":
            return _context647.stop();
        }
      }
    }, _callee646);
  }));
  return _deleteApp.apply(this, arguments);
}

function registerVersion(libraryKeyOrName, version2, variant) {
  var _a2;

  var library = (_a2 = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a2 !== void 0 ? _a2 : libraryKeyOrName;

  if (variant) {
    library += "-".concat(variant);
  }

  var libraryMismatch = library.match(/\s|\//);
  var versionMismatch = version2.match(/\s|\//);

  if (libraryMismatch || versionMismatch) {
    var warning = ["Unable to register library \"".concat(library, "\" with version \"").concat(version2, "\":")];

    if (libraryMismatch) {
      warning.push("library name \"".concat(library, "\" contains illegal characters (whitespace or \"/\")"));
    }

    if (libraryMismatch && versionMismatch) {
      warning.push("and");
    }

    if (versionMismatch) {
      warning.push("version name \"".concat(version2, "\" contains illegal characters (whitespace or \"/\")"));
    }

    logger$1.warn(warning.join(" "));
    return;
  }

  _registerComponent(new Component("".concat(library, "-version"), function () {
    return {
      library: library,
      version: version2
    };
  }, "VERSION"));
}

function onLog(logCallback, options2) {
  if (logCallback !== null && typeof logCallback !== "function") {
    throw ERROR_FACTORY$1.create("invalid-log-argument");
  }

  setUserLogHandler(logCallback, options2);
}

function setLogLevel(logLevel) {
  setLogLevel$1(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME$1 = "firebase-heartbeat-database";
var DB_VERSION$1 = 1;
var STORE_NAME = "firebase-heartbeat-store";
var dbPromise = null;

function getDbPromise() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME$1, DB_VERSION$1, {
      upgrade: function upgrade(db, oldVersion) {
        switch (oldVersion) {
          case 0:
            db.createObjectStore(STORE_NAME);
        }
      }
    }).catch(function (e2) {
      throw ERROR_FACTORY$1.create("idb-open", {
        originalErrorMessage: e2.message
      });
    });
  }

  return dbPromise;
}

function readHeartbeatsFromIndexedDB(_x3) {
  return _readHeartbeatsFromIndexedDB.apply(this, arguments);
}

function _readHeartbeatsFromIndexedDB() {
  _readHeartbeatsFromIndexedDB = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee647(app) {
    var db, result, idbGetError;
    return _regeneratorRuntime.wrap(function _callee647$(_context648) {
      while (1) {
        switch (_context648.prev = _context648.next) {
          case 0:
            _context648.prev = 0;
            _context648.next = 3;
            return getDbPromise();

          case 3:
            db = _context648.sent;
            _context648.next = 6;
            return db.transaction(STORE_NAME).objectStore(STORE_NAME).get(computeKey(app));

          case 6:
            result = _context648.sent;
            return _context648.abrupt("return", result);

          case 10:
            _context648.prev = 10;
            _context648.t0 = _context648["catch"](0);

            if (_context648.t0 instanceof FirebaseError) {
              logger$1.warn(_context648.t0.message);
            } else {
              idbGetError = ERROR_FACTORY$1.create("idb-get", {
                originalErrorMessage: _context648.t0 === null || _context648.t0 === void 0 ? void 0 : _context648.t0.message
              });
              logger$1.warn(idbGetError.message);
            }

          case 13:
          case "end":
            return _context648.stop();
        }
      }
    }, _callee647, null, [[0, 10]]);
  }));
  return _readHeartbeatsFromIndexedDB.apply(this, arguments);
}

function writeHeartbeatsToIndexedDB(_x4, _x5) {
  return _writeHeartbeatsToIndexedDB.apply(this, arguments);
}

function _writeHeartbeatsToIndexedDB() {
  _writeHeartbeatsToIndexedDB = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee648(app, heartbeatObject) {
    var db, tx, objectStore, idbGetError;
    return _regeneratorRuntime.wrap(function _callee648$(_context649) {
      while (1) {
        switch (_context649.prev = _context649.next) {
          case 0:
            _context649.prev = 0;
            _context649.next = 3;
            return getDbPromise();

          case 3:
            db = _context649.sent;
            tx = db.transaction(STORE_NAME, "readwrite");
            objectStore = tx.objectStore(STORE_NAME);
            _context649.next = 8;
            return objectStore.put(heartbeatObject, computeKey(app));

          case 8:
            _context649.next = 10;
            return tx.done;

          case 10:
            _context649.next = 15;
            break;

          case 12:
            _context649.prev = 12;
            _context649.t0 = _context649["catch"](0);

            if (_context649.t0 instanceof FirebaseError) {
              logger$1.warn(_context649.t0.message);
            } else {
              idbGetError = ERROR_FACTORY$1.create("idb-set", {
                originalErrorMessage: _context649.t0 === null || _context649.t0 === void 0 ? void 0 : _context649.t0.message
              });
              logger$1.warn(idbGetError.message);
            }

          case 15:
          case "end":
            return _context649.stop();
        }
      }
    }, _callee648, null, [[0, 12]]);
  }));
  return _writeHeartbeatsToIndexedDB.apply(this, arguments);
}

function computeKey(app) {
  return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var MAX_HEADER_BYTES = 1024;
var STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1e3;

var HeartbeatServiceImpl =
/*#__PURE__*/
function () {
  function HeartbeatServiceImpl(container) {
    var _this21 = this;

    _classCallCheck3(this, HeartbeatServiceImpl);

    this.container = container;
    this._heartbeatsCache = null;
    var app = this.container.getProvider("app").getImmediate();
    this._storage = new HeartbeatStorageImpl(app);
    this._heartbeatsCachePromise = this._storage.read().then(function (result) {
      _this21._heartbeatsCache = result;
      return result;
    });
  }

  _createClass3(HeartbeatServiceImpl, [{
    key: "triggerHeartbeat",
    value: function () {
      var _triggerHeartbeat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var platformLogger, agent, date;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                platformLogger = this.container.getProvider("platform-logger").getImmediate();
                agent = platformLogger.getPlatformInfoString();
                date = getUTCDateString();

                if (!(this._heartbeatsCache === null)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 6;
                return this._heartbeatsCachePromise;

              case 6:
                this._heartbeatsCache = _context3.sent;

              case 7:
                if (!(this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some(function (singleDateHeartbeat) {
                  return singleDateHeartbeat.date === date;
                }))) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return");

              case 11:
                this._heartbeatsCache.heartbeats.push({
                  date: date,
                  agent: agent
                });

              case 12:
                this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(function (singleDateHeartbeat) {
                  var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                  var now2 = Date.now();
                  return now2 - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                });
                return _context3.abrupt("return", this._storage.overwrite(this._heartbeatsCache));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function triggerHeartbeat() {
        return _triggerHeartbeat.apply(this, arguments);
      }

      return triggerHeartbeat;
    }()
  }, {
    key: "getHeartbeatsHeader",
    value: function () {
      var _getHeartbeatsHeader = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var date, _extractHeartbeatsFor, heartbeatsToSend, unsentEntries, headerString;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this._heartbeatsCache === null)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this._heartbeatsCachePromise;

              case 3:
                if (!(this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", "");

              case 5:
                date = getUTCDateString();
                _extractHeartbeatsFor = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsFor.heartbeatsToSend, unsentEntries = _extractHeartbeatsFor.unsentEntries;
                headerString = base64urlEncodeWithoutPadding(JSON.stringify({
                  version: 2,
                  heartbeats: heartbeatsToSend
                }));
                this._heartbeatsCache.lastSentHeartbeatDate = date;

                if (!(unsentEntries.length > 0)) {
                  _context4.next = 15;
                  break;
                }

                this._heartbeatsCache.heartbeats = unsentEntries;
                _context4.next = 13;
                return this._storage.overwrite(this._heartbeatsCache);

              case 13:
                _context4.next = 17;
                break;

              case 15:
                this._heartbeatsCache.heartbeats = [];
                void this._storage.overwrite(this._heartbeatsCache);

              case 17:
                return _context4.abrupt("return", headerString);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getHeartbeatsHeader() {
        return _getHeartbeatsHeader.apply(this, arguments);
      }

      return getHeartbeatsHeader;
    }()
  }]);

  return HeartbeatServiceImpl;
}();

function getUTCDateString() {
  var today = new Date();
  return today.toISOString().substring(0, 10);
}

function extractHeartbeatsForHeader(heartbeatsCache) {
  var maxSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_HEADER_BYTES;
  var heartbeatsToSend = [];
  var unsentEntries = heartbeatsCache.slice();
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    var _loop5 = function _loop5() {
      var singleDateHeartbeat = _step7.value;
      var heartbeatEntry = heartbeatsToSend.find(function (hb) {
        return hb.agent === singleDateHeartbeat.agent;
      });

      if (!heartbeatEntry) {
        heartbeatsToSend.push({
          agent: singleDateHeartbeat.agent,
          dates: [singleDateHeartbeat.date]
        });

        if (countBytes(heartbeatsToSend) > maxSize) {
          heartbeatsToSend.pop();
          return "break";
        }
      } else {
        heartbeatEntry.dates.push(singleDateHeartbeat.date);

        if (countBytes(heartbeatsToSend) > maxSize) {
          heartbeatEntry.dates.pop();
          return "break";
        }
      }

      unsentEntries = unsentEntries.slice(1);
    };

    for (var _iterator7 = heartbeatsCache[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var _ret2 = _loop5();

      if (_ret2 === "break") break;
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return {
    heartbeatsToSend: heartbeatsToSend,
    unsentEntries: unsentEntries
  };
}

var HeartbeatStorageImpl =
/*#__PURE__*/
function () {
  function HeartbeatStorageImpl(app) {
    _classCallCheck3(this, HeartbeatStorageImpl);

    this.app = app;
    this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }

  _createClass3(HeartbeatStorageImpl, [{
    key: "runIndexedDBEnvironmentCheck",
    value: function () {
      var _runIndexedDBEnvironmentCheck = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (isIndexedDBAvailable()) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", false);

              case 4:
                return _context5.abrupt("return", validateIndexedDBOpenable().then(function () {
                  return true;
                }).catch(function () {
                  return false;
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function runIndexedDBEnvironmentCheck() {
        return _runIndexedDBEnvironmentCheck.apply(this, arguments);
      }

      return runIndexedDBEnvironmentCheck;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var canUseIndexedDB, idbHeartbeatObject;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context6.sent;

                if (canUseIndexedDB) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", {
                  heartbeats: []
                });

              case 7:
                _context6.next = 9;
                return readHeartbeatsFromIndexedDB(this.app);

              case 9:
                idbHeartbeatObject = _context6.sent;
                return _context6.abrupt("return", idbHeartbeatObject || {
                  heartbeats: []
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "overwrite",
    value: function () {
      var _overwrite = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(heartbeatsObject) {
        var _a2, canUseIndexedDB, existingHeartbeatsObject;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context7.sent;

                if (canUseIndexedDB) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt("return");

              case 7:
                _context7.next = 9;
                return this.read();

              case 9:
                existingHeartbeatsObject = _context7.sent;
                return _context7.abrupt("return", writeHeartbeatsToIndexedDB(this.app, {
                  lastSentHeartbeatDate: (_a2 = heartbeatsObject.lastSentHeartbeatDate) !== null && _a2 !== void 0 ? _a2 : existingHeartbeatsObject.lastSentHeartbeatDate,
                  heartbeats: heartbeatsObject.heartbeats
                }));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function overwrite(_x6) {
        return _overwrite.apply(this, arguments);
      }

      return overwrite;
    }()
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(heartbeatsObject) {
        var _a2, canUseIndexedDB, existingHeartbeatsObject;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context8.sent;

                if (canUseIndexedDB) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt("return");

              case 7:
                _context8.next = 9;
                return this.read();

              case 9:
                existingHeartbeatsObject = _context8.sent;
                return _context8.abrupt("return", writeHeartbeatsToIndexedDB(this.app, {
                  lastSentHeartbeatDate: (_a2 = heartbeatsObject.lastSentHeartbeatDate) !== null && _a2 !== void 0 ? _a2 : existingHeartbeatsObject.lastSentHeartbeatDate,
                  heartbeats: [].concat(_toConsumableArray3(existingHeartbeatsObject.heartbeats), _toConsumableArray3(heartbeatsObject.heartbeats))
                }));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function add(_x7) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
  }]);

  return HeartbeatStorageImpl;
}();

function countBytes(heartbeatsCache) {
  return base64urlEncodeWithoutPadding(JSON.stringify({
    version: 2,
    heartbeats: heartbeatsCache
  })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function registerCoreComponents$1(variant) {
  _registerComponent(new Component("platform-logger", function (container) {
    return new PlatformLoggerServiceImpl(container);
  }, "PRIVATE"));

  _registerComponent(new Component("heartbeat", function (container) {
    return new HeartbeatServiceImpl(container);
  }, "PRIVATE"));

  registerVersion(name$o, version$1$1, variant);
  registerVersion(name$o, version$1$1, "esm2017");
  registerVersion("fire-js", "");
}

registerCoreComponents$1("");
var modularAPIs =
/* @__PURE__ */
Object.freeze(
/* @__PURE__ */
Object.defineProperty({
  __proto__: null,
  SDK_VERSION: SDK_VERSION,
  _DEFAULT_ENTRY_NAME: DEFAULT_ENTRY_NAME,
  _addComponent: _addComponent2,
  _addOrOverwriteComponent: _addOrOverwriteComponent2,
  _apps: _apps,
  _clearComponents: _clearComponents,
  _components: _components,
  _getProvider: _getProvider,
  _registerComponent: _registerComponent,
  _removeServiceInstance: _removeServiceInstance,
  deleteApp: deleteApp,
  getApp: getApp,
  getApps: getApps,
  initializeApp: initializeApp,
  onLog: onLog,
  registerVersion: registerVersion,
  setLogLevel: setLogLevel,
  FirebaseError: FirebaseError
}, Symbol.toStringTag, {
  value: "Module"
}));
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FirebaseAppImpl =
/*#__PURE__*/
function () {
  function FirebaseAppImpl(_delegate, firebase2) {
    var _this22 = this;

    _classCallCheck3(this, FirebaseAppImpl);

    this._delegate = _delegate;
    this.firebase = firebase2;

    _addComponent2(_delegate, new Component("app-compat", function () {
      return _this22;
    }, "PUBLIC"));

    this.container = _delegate.container;
  }

  _createClass3(FirebaseAppImpl, [{
    key: "delete",
    value: function _delete() {
      var _this23 = this;

      return new Promise(function (resolve) {
        _this23._delegate.checkDestroyed();

        resolve();
      }).then(function () {
        _this23.firebase.INTERNAL.removeApp(_this23.name);

        return deleteApp(_this23._delegate);
      });
    }
  }, {
    key: "_getService",
    value: function _getService(name2) {
      var instanceIdentifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ENTRY_NAME;

      var _a2;

      this._delegate.checkDestroyed();

      var provider = this._delegate.container.getProvider(name2);

      if (!provider.isInitialized() && ((_a2 = provider.getComponent()) === null || _a2 === void 0 ? void 0 : _a2.instantiationMode) === "EXPLICIT") {
        provider.initialize();
      }

      return provider.getImmediate({
        identifier: instanceIdentifier
      });
    }
  }, {
    key: "_removeServiceInstance",
    value: function _removeServiceInstance(name2) {
      var instanceIdentifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ENTRY_NAME;

      this._delegate.container.getProvider(name2).clearInstance(instanceIdentifier);
    }
  }, {
    key: "_addComponent",
    value: function _addComponent(component) {
      _addComponent2(this._delegate, component);
    }
  }, {
    key: "_addOrOverwriteComponent",
    value: function _addOrOverwriteComponent(component) {
      _addOrOverwriteComponent2(this._delegate, component);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
        options: this.options
      };
    }
  }, {
    key: "automaticDataCollectionEnabled",
    get: function get() {
      return this._delegate.automaticDataCollectionEnabled;
    },
    set: function set(val) {
      this._delegate.automaticDataCollectionEnabled = val;
    }
  }, {
    key: "name",
    get: function get() {
      return this._delegate.name;
    }
  }, {
    key: "options",
    get: function get() {
      return this._delegate.options;
    }
  }]);

  return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERRORS = (_ERRORS = {}, _defineProperty3(_ERRORS, "no-app", "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()"), _defineProperty3(_ERRORS, "invalid-app-argument", "firebase.{$appName}() takes either no argument or a Firebase App instance."), _ERRORS);
var ERROR_FACTORY = new ErrorFactory("app-compat", "Firebase", ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createFirebaseNamespaceCore(firebaseAppImpl) {
  var apps = {};
  var namespace = {
    __esModule: true,
    initializeApp: initializeAppCompat,
    app: app,
    registerVersion: registerVersion,
    setLogLevel: setLogLevel,
    onLog: onLog,
    apps: null,
    SDK_VERSION: SDK_VERSION,
    INTERNAL: {
      registerComponent: registerComponentCompat,
      removeApp: removeApp,
      useAsService: useAsService,
      modularAPIs: modularAPIs
    }
  };
  namespace["default"] = namespace;
  Object.defineProperty(namespace, "apps", {
    get: getApps2
  });

  function removeApp(name2) {
    delete apps[name2];
  }

  function app(name2) {
    name2 = name2 || DEFAULT_ENTRY_NAME;

    if (!contains$1(apps, name2)) {
      throw ERROR_FACTORY.create("no-app", {
        appName: name2
      });
    }

    return apps[name2];
  }

  app["App"] = firebaseAppImpl;

  function initializeAppCompat(options2) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var app2 = initializeApp(options2, rawConfig);

    if (contains$1(apps, app2.name)) {
      return apps[app2.name];
    }

    var appCompat = new firebaseAppImpl(app2, namespace);
    apps[app2.name] = appCompat;
    return appCompat;
  }

  function getApps2() {
    return Object.keys(apps).map(function (name2) {
      return apps[name2];
    });
  }

  function registerComponentCompat(component) {
    var componentName = component.name;
    var componentNameWithoutCompat = componentName.replace("-compat", "");

    if (_registerComponent(component) && component.type === "PUBLIC") {
      var serviceNamespace = function serviceNamespace() {
        var appArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app();

        if (typeof appArg[componentNameWithoutCompat] !== "function") {
          throw ERROR_FACTORY.create("invalid-app-argument", {
            appName: componentName
          });
        }

        return appArg[componentNameWithoutCompat]();
      };

      if (component.serviceProps !== void 0) {
        deepExtend(serviceNamespace, component.serviceProps);
      }

      namespace[componentNameWithoutCompat] = serviceNamespace;

      firebaseAppImpl.prototype[componentNameWithoutCompat] = function () {
        var serviceFxn = this._getService.bind(this, componentName);

        for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          args[_key14] = arguments[_key14];
        }

        return serviceFxn.apply(this, component.multipleInstances ? args : []);
      };
    }

    return component.type === "PUBLIC" ? namespace[componentNameWithoutCompat] : null;
  }

  function useAsService(app2, name2) {
    if (name2 === "serverAuth") {
      return null;
    }

    var useService = name2;
    return useService;
  }

  return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function createFirebaseNamespace() {
  var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
  namespace.INTERNAL = Object.assign(Object.assign({}, namespace.INTERNAL), {
    createFirebaseNamespace: createFirebaseNamespace,
    extendNamespace: extendNamespace,
    createSubscribe: createSubscribe,
    ErrorFactory: ErrorFactory,
    deepExtend: deepExtend
  });

  function extendNamespace(props) {
    deepExtend(namespace, props);
  }

  return namespace;
}

var firebase$1 = createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var logger = new Logger("@firebase/app-compat");
var name$3 = "@firebase/app-compat";
var version$3 = "0.2.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function registerCoreComponents(variant) {
  registerVersion(name$3, version$3, variant);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


if (isBrowser$3() && self.firebase !== void 0) {
  logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
  var sdkVersion = self.firebase.SDK_VERSION;

  if (sdkVersion && sdkVersion.indexOf("LITE") >= 0) {
    logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
  }
}

var firebase = firebase$1;
registerCoreComponents();
var name$2 = "firebase";
var version$2 = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

firebase.registerVersion(name$2, version$2, "app-compat");
var runtime = {
  exports: {}
};

(function (module) {
  var runtime2 = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;

    var defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    };

    var undefined$1;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap2(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
      defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      });
      return generator;
    }

    exports.wrap = wrap2;

    function tryCatch(fn3, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn3.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {}

    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value2) {
              invoke("next", value2, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }

      defineProperty(this, "_invoke", {
        value: enqueue
      });
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator;

    exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap2(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self2, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self2, context);

          if (record.type === "normal") {
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method;
      var method = delegate.iterator[methodName];

      if (method === undefined$1) {
        context.delegate = null;

        if (methodName === "throw" && delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }

        if (methodName !== "return") {
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        context[delegate.resultName] = info.value;
        context.next = delegate.nextLoc;

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        return info;
      }

      context.delegate = null;
      return ContinueSentinel;
    }

    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (val) {
      var object = Object(val);
      var keys2 = [];

      for (var key in object) {
        keys2.push(key);
      }

      keys2.reverse();
      return function next2() {
        while (keys2.length) {
          var key2 = keys2.pop();

          if (key2 in object) {
            next2.value = key2;
            next2.done = false;
            return next2;
          }
        }

        next2.done = true;
        return next2;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next2 = function next3() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next3.value = iterable[i];
                next3.done = false;
                return next3;
              }
            }

            next3.value = undefined$1;
            next3.done = true;
            return next3;
          };

          return next2.next = next2;
        }
      }

      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name2 in this) {
            if (name2.charAt(0) === "t" && hasOwn.call(this, name2) && !isNaN(+name2.slice(1))) {
              this[name2] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    };
    return exports;
  }(module.exports);

  try {
    regeneratorRuntime = runtime2;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime2;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime2);
    }
  }
})(runtime);

var getToken =
/*#__PURE__*/
function () {
  var _ref20 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9() {
    var user;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            user = firebase.auth().currentUser;

            if (!user) {
              _context9.next = 5;
              break;
            }

            _context9.next = 4;
            return user.getIdToken();

          case 4:
            return _context9.abrupt("return", _context9.sent);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getToken() {
    return _ref20.apply(this, arguments);
  };
}();

var predictionApiBaseUrl = function predictionApiBaseUrl(environment) {
  if (environment === "dev") return "http://localhost:8040/v1";else if (environment === "staging") return "https://prediction.fansunitedstagingapi.com/v1";else if (environment === "watg") return "https://prediction.watg.fansunitedapi.com/v1";
  return "https://prediction.fansunitedapi.com/v1";
};

var loyaltyApiBaseUrl = function loyaltyApiBaseUrl(environment) {
  if (environment === "dev") return "http://localhost:8060/v1";else if (environment === "staging") return "https://loyalty.fansunitedstagingapi.com/v1";else if (environment === "watg") return "https://loyalty.watg.fansunitedapi.com/v1";
  return "https://loyalty.fansunitedapi.com/v1";
};

var clientApiBaseUrl = function clientApiBaseUrl(environment) {
  if (environment === "dev") return "http://localhost:8070/v1";else if (environment === "staging") return "https://client.fansunitedstagingapi.com/v1";else if (environment === "watg") return "https://client.watg.fansunitedapi.com/v1";
  return "https://client.fansunitedapi.com/v1";
};

var HttpsService = function HttpsService(config) {
  var _this24 = this;

  _classCallCheck3(this, HttpsService);

  this.apiSignInUrl = null;
  this.apiKey = null;
  this.clientId = null;
  this.environment = null;
  this.axiosAuthInstance = null;
  this.predictionBaseUrl = null;
  this.loyaltyBaseUrl = null;
  this.clientBaseUrl = null;

  this.createGame =
  /*#__PURE__*/
  function () {
    var _ref21 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10(requestBody) {
      var url;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _this24.apiSignInUrl = "/games?key=".concat(_this24.apiKey, "&client_id=").concat(_this24.clientId);
              url = _this24.predictionBaseUrl + _this24.apiSignInUrl;
              _context10.prev = 2;
              _context10.next = 5;
              return _this24.axiosAuthInstance.post(url, JSON.stringify(requestBody));

            case 5:
              _context10.next = 11;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](2);
              console.error("There was a problem with creating TOP X game:", _context10.t0);
              throw _context10.t0;

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 7]]);
    }));

    return function (_x8) {
      return _ref21.apply(this, arguments);
    };
  }();

  this.editGame =
  /*#__PURE__*/
  function () {
    var _ref23 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11(requestBody, gameId) {
      var url;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _this24.apiSignInUrl = "/games/".concat(gameId, "?key=").concat(_this24.apiKey, "&client_id=").concat(_this24.clientId);
              url = _this24.predictionBaseUrl + _this24.apiSignInUrl;
              _context11.prev = 2;
              _context11.next = 5;
              return _this24.axiosAuthInstance.patch(url, JSON.stringify(requestBody));

            case 5:
              _context11.next = 11;
              break;

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](2);
              console.error("There was a problem with updating TOP X game:", _context11.t0);
              throw _context11.t0;

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 7]]);
    }));

    return function (_x9, _x10) {
      return _ref23.apply(this, arguments);
    };
  }();

  this.createWinners =
  /*#__PURE__*/
  function () {
    var _ref24 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12(requestBody) {
      var url;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _this24.apiSignInUrl = "/winners?key=".concat(_this24.apiKey, "&client_id=").concat(_this24.clientId);
              url = _this24.predictionBaseUrl + _this24.apiSignInUrl;
              _context12.prev = 2;
              _context12.next = 5;
              return _this24.axiosAuthInstance.post(url, JSON.stringify(requestBody));

            case 5:
              _context12.next = 11;
              break;

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12["catch"](2);
              console.error("There was a problem with creating winners for TOP X game:", _context12.t0);
              throw _context12.t0;

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 7]]);
    }));

    return function (_x11) {
      return _ref24.apply(this, arguments);
    };
  }();

  this.editWinners =
  /*#__PURE__*/
  function () {
    var _ref25 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13(requestBody) {
      var url;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _this24.apiSignInUrl = "/winners?key=".concat(_this24.apiKey, "&client_id=").concat(_this24.clientId);
              url = _this24.predictionBaseUrl + _this24.apiSignInUrl;
              _context13.prev = 2;
              _context13.next = 5;
              return _this24.axiosAuthInstance.put(url, JSON.stringify(requestBody));

            case 5:
              _context13.next = 11;
              break;

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](2);
              console.error("There was a problem with editing winners for TOP X game:", _context13.t0);
              throw _context13.t0;

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[2, 7]]);
    }));

    return function (_x12) {
      return _ref25.apply(this, arguments);
    };
  }();

  this.exportDetailedLeaderboard =
  /*#__PURE__*/
  function () {
    var _ref26 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14(gameId, limit) {
      var url;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _this24.apiSignInUrl = "/leaderboard/games/".concat(gameId, "/detailed?key=").concat(_this24.apiKey, "&client_id=").concat(_this24.clientId, "&limit=").concat(limit);
              url = _this24.loyaltyBaseUrl + _this24.apiSignInUrl;
              _context14.prev = 2;
              _context14.next = 5;
              return _this24.axiosAuthInstance.get(url);

            case 5:
              return _context14.abrupt("return", _context14.sent);

            case 8:
              _context14.prev = 8;
              _context14.t0 = _context14["catch"](2);
              console.error("There was a problem with getting detailed leaderboard info:", _context14.t0);
              throw _context14.t0;

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[2, 8]]);
    }));

    return function (_x13, _x14) {
      return _ref26.apply(this, arguments);
    };
  }();

  this.generateSignedInUrl =
  /*#__PURE__*/
  function () {
    var _ref27 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee15(requestBody) {
      var url;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _this24.apiSignInUrl = "/clients/".concat(_this24.clientId, "/generate-signed-url?key=").concat(_this24.apiKey);
              url = _this24.clientBaseUrl + _this24.apiSignInUrl;
              _context15.prev = 2;
              _context15.next = 5;
              return _this24.axiosAuthInstance.post(url, JSON.stringify(requestBody));

            case 5:
              return _context15.abrupt("return", _context15.sent);

            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](2);
              console.error("There was a problem with generating signed in URL: ", _context15.t0);
              throw _context15.t0;

            case 12:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[2, 8]]);
    }));

    return function (_x15) {
      return _ref27.apply(this, arguments);
    };
  }();

  this.storeInBucket =
  /*#__PURE__*/
  function () {
    var _ref28 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee16(signedInUrl, file, headers) {
      var response, responseString;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return fetch(signedInUrl, {
                headers: headers,
                method: "PUT",
                body: file
              });

            case 2:
              response = _context16.sent;

              if (!response.ok) {
                _context16.next = 5;
                break;
              }

              return _context16.abrupt("return", _this24.constructAssetsUrl(file.name));

            case 5:
              _context16.next = 7;
              return response.text();

            case 7:
              responseString = _context16.sent;

              _this24.throwErrorFromXmlResponse(responseString);

            case 9:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x16, _x17, _x18) {
      return _ref28.apply(this, arguments);
    };
  }();

  this.constructAssetsUrl = function (fileName) {
    if (_this24.environment === "dev") {
      return "https://storage.googleapis.com/client_images_cms_fans-united-dev/".concat(_this24.clientId, "/").concat(fileName);
    } else if (_this24.environment === "staging") {
      return "https://storage.googleapis.com/client_images_cms_fans-united-stage/".concat(_this24.clientId, "/").concat(fileName);
    }

    return "https://uploads.fansunitedassets.com/".concat(_this24.clientId, "/").concat(fileName);
  };

  this.throwErrorFromXmlResponse = function (responseString) {
    var document2 = new window.DOMParser().parseFromString(responseString, "text/xml");
    var message = document2.getElementsByTagName("Message") && document2.getElementsByTagName("Code").length > 0 ? document2.getElementsByTagName("Message")[0].textContent : "";
    var details = document2.getElementsByTagName("Details") && document2.getElementsByTagName("Code").length > 0 ? document2.getElementsByTagName("Details")[0].textContent : "";
    throw new Error(message + " " + details);
  };

  this.apiKey = config.apiKey;
  this.clientId = config.clientId;
  this.environment = config.environment;
  this.predictionBaseUrl = predictionApiBaseUrl(config.environment);
  this.loyaltyBaseUrl = loyaltyApiBaseUrl(config.environment);
  this.clientBaseUrl = clientApiBaseUrl(config.environment);
  this.axiosAuthInstance = axios.create({
    headers: {
      "Content-Type": "application/json"
    }
  });
  this.axiosAuthInstance.interceptors.request.use(
  /*#__PURE__*/
  function () {
    var _ref29 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee17(config2) {
      var token2;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return getToken();

            case 2:
              token2 = _context17.sent;

              if (token2) {
                config2.headers.Authorization = "Bearer " + token2;
              }

              return _context17.abrupt("return", config2);

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x19) {
      return _ref29.apply(this, arguments);
    };
  }(), function (error) {
    return Promise.reject(error);
  });
};

var Es = Object.create;
var Ao = Object.defineProperty;
var Rs = Object.getOwnPropertyDescriptor;
var Ss = Object.getOwnPropertyNames;
var Cs = Object.getPrototypeOf,
    As = Object.prototype.hasOwnProperty;

var Ls = function Ls(o, t2, e2) {
  return t2 in o ? Ao(o, t2, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: e2
  }) : o[t2] = e2;
};

var Mo = function Mo(o, t2) {
  return function () {
    return t2 || o((t2 = {
      exports: {}
    }).exports, t2), t2.exports;
  };
};

var Os = function Os(o, t2, e2, i) {
  if (t2 && typeof t2 == "object" || typeof t2 == "function") {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      var _loop6 = function _loop6() {
        var a = _step8.value;
        !As.call(o, a) && a !== e2 && Ao(o, a, {
          get: function get() {
            return t2[a];
          },
          enumerable: !(i = Rs(t2, a)) || i.enumerable
        });
      };

      for (var _iterator8 = Ss(t2)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        _loop6();
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  }

  return o;
};

var Ds = function Ds(o, t2, e2) {
  return e2 = o != null ? Es(Cs(o)) : {}, Os(t2 || !o || !o.__esModule ? Ao(e2, "default", {
    value: o,
    enumerable: true
  }) : e2, o);
};

var Lo = function Lo(o, t2, e2) {
  return Ls(o, typeof t2 != "symbol" ? t2 + "" : t2, e2), e2;
};

var rs = Mo(function (zn, vo) {
  var Us = function () {
    function o(c2, d2) {
      return d2 != null && c2 instanceof d2;
    }

    var t2;

    try {
      t2 = Map;
    } catch (_unused) {
      t2 = function t2() {};
    }

    var e2;

    try {
      e2 = Set;
    } catch (_unused2) {
      e2 = function e2() {};
    }

    var i;

    try {
      i = Promise;
    } catch (_unused3) {
      i = function i() {};
    }

    function a(c2, d2, m2, y2, h2) {
      typeof d2 == "object" && (m2 = d2.depth, y2 = d2.prototype, h2 = d2.includeNonEnumerable, d2 = d2.circular);
      var It = [],
          St = [],
          Ct = typeof Buffer < "u";
      typeof d2 > "u" && (d2 = true), typeof m2 > "u" && (m2 = 1 / 0);

      function k2(f2, lt) {
        if (f2 === null) return null;
        if (lt === 0) return f2;
        var T, Ke;
        if (typeof f2 != "object") return f2;
        if (o(f2, t2)) T = new t2();else if (o(f2, e2)) T = new e2();else if (o(f2, i)) T = new i(function (je, g2) {
          f2.then(function (qe) {
            je(k2(qe, lt - 1));
          }, function (qe) {
            g2(k2(qe, lt - 1));
          });
        });else if (a.__isArray(f2)) T = [];else if (a.__isRegExp(f2)) T = new RegExp(f2.source, l2(f2)), f2.lastIndex && (T.lastIndex = f2.lastIndex);else if (a.__isDate(f2)) T = new Date(f2.getTime());else {
          if (Ct && Buffer.isBuffer(f2)) return Buffer.allocUnsafe ? T = Buffer.allocUnsafe(f2.length) : T = new Buffer(f2.length), f2.copy(T), T;
          o(f2, Error) ? T = Object.create(f2) : typeof y2 > "u" ? (Ke = Object.getPrototypeOf(f2), T = Object.create(Ke)) : (T = Object.create(y2), Ke = y2);
        }

        if (d2) {
          var Ko = It.indexOf(f2);
          if (Ko != -1) return St[Ko];
          It.push(f2), St.push(T);
        }

        o(f2, t2) && f2.forEach(function (je, g2) {
          var qe = k2(g2, lt - 1),
              Fs = k2(je, lt - 1);
          T.set(qe, Fs);
        }), o(f2, e2) && f2.forEach(function (je) {
          var g2 = k2(je, lt - 1);
          T.add(g2);
        });

        for (var Q in f2) {
          var Co;
          Ke && (Co = Object.getOwnPropertyDescriptor(Ke, Q)), !(Co && Co.set == null) && (T[Q] = k2(f2[Q], lt - 1));
        }

        if (Object.getOwnPropertySymbols) for (var jo = Object.getOwnPropertySymbols(f2), Q = 0; Q < jo.length; Q++) {
          var fo = jo[Q],
              Le = Object.getOwnPropertyDescriptor(f2, fo);
          Le && !Le.enumerable && !h2 || (T[fo] = k2(f2[fo], lt - 1), Le.enumerable || Object.defineProperty(T, fo, {
            enumerable: false
          }));
        }
        if (h2) for (var qo = Object.getOwnPropertyNames(f2), Q = 0; Q < qo.length; Q++) {
          var yo = qo[Q],
              Le = Object.getOwnPropertyDescriptor(f2, yo);
          Le && Le.enumerable || (T[yo] = k2(f2[yo], lt - 1), Object.defineProperty(T, yo, {
            enumerable: false
          }));
        }
        return T;
      }

      return k2(c2, m2);
    }

    a.clonePrototype = function (d2) {
      if (d2 === null) return null;

      var m2 = function m2() {};

      return m2.prototype = d2, new m2();
    };

    function r2(c2) {
      return Object.prototype.toString.call(c2);
    }

    a.__objToStr = r2;

    function s(c2) {
      return typeof c2 == "object" && r2(c2) === "[object Date]";
    }

    a.__isDate = s;

    function p2(c2) {
      return typeof c2 == "object" && r2(c2) === "[object Array]";
    }

    a.__isArray = p2;

    function n2(c2) {
      return typeof c2 == "object" && r2(c2) === "[object RegExp]";
    }

    a.__isRegExp = n2;

    function l2(c2) {
      var d2 = "";
      return c2.global && (d2 += "g"), c2.ignoreCase && (d2 += "i"), c2.multiline && (d2 += "m"), d2;
    }

    return a.__getRegExpFlags = l2, a;
  }();

  typeof vo == "object" && vo.exports && (vo.exports = Us);
});
var gs = Mo(function (Qn, Ho) {
  var De = typeof Reflect == "object" ? Reflect : null,
      os = De && typeof De.apply == "function" ? De.apply : function (t2, e2, i) {
    return Function.prototype.apply.call(t2, e2, i);
  },
      To;
  De && typeof De.ownKeys == "function" ? To = De.ownKeys : Object.getOwnPropertySymbols ? To = function To(t2) {
    return Object.getOwnPropertyNames(t2).concat(Object.getOwnPropertySymbols(t2));
  } : To = function To(t2) {
    return Object.getOwnPropertyNames(t2);
  };

  function Hs(o) {
    console && console.warn && console.warn(o);
  }

  var ns = Number.isNaN || function (t2) {
    return t2 !== t2;
  };

  function I() {
    I.init.call(this);
  }

  Ho.exports = I;
  Ho.exports.once = $s;
  I.EventEmitter = I;
  I.prototype._events = void 0;
  I.prototype._eventsCount = 0;
  I.prototype._maxListeners = void 0;
  var ss = 10;

  function _o(o) {
    if (typeof o != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof o);
  }

  Object.defineProperty(I, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
      return ss;
    },
    set: function set(o) {
      if (typeof o != "number" || o < 0 || ns(o)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + o + ".");
      ss = o;
    }
  });

  I.init = function () {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events =
    /* @__PURE__ */
    Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  };

  I.prototype.setMaxListeners = function (t2) {
    if (typeof t2 != "number" || t2 < 0 || ns(t2)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t2 + ".");
    return this._maxListeners = t2, this;
  };

  function ls(o) {
    return o._maxListeners === void 0 ? I.defaultMaxListeners : o._maxListeners;
  }

  I.prototype.getMaxListeners = function () {
    return ls(this);
  };

  I.prototype.emit = function (t2) {
    for (var e2 = [], i = 1; i < arguments.length; i++) {
      e2.push(arguments[i]);
    }

    var a = t2 === "error",
        r2 = this._events;
    if (r2 !== void 0) a = a && r2.error === void 0;else if (!a) return false;

    if (a) {
      var s;
      if (e2.length > 0 && (s = e2[0]), s instanceof Error) throw s;
      var p2 = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
      throw p2.context = s, p2;
    }

    var n2 = r2[t2];
    if (n2 === void 0) return false;
    if (typeof n2 == "function") os(n2, this, e2);else for (var l2 = n2.length, c2 = us(n2, l2), i = 0; i < l2; ++i) {
      os(c2[i], this, e2);
    }
    return true;
  };

  function ps(o, t2, e2, i) {
    var a, r2, s;
    if (_o(e2), r2 = o._events, r2 === void 0 ? (r2 = o._events =
    /* @__PURE__ */
    Object.create(null), o._eventsCount = 0) : (r2.newListener !== void 0 && (o.emit("newListener", t2, e2.listener ? e2.listener : e2), r2 = o._events), s = r2[t2]), s === void 0) s = r2[t2] = e2, ++o._eventsCount;else if (typeof s == "function" ? s = r2[t2] = i ? [e2, s] : [s, e2] : i ? s.unshift(e2) : s.push(e2), a = ls(o), a > 0 && s.length > a && !s.warned) {
      s.warned = true;
      var p2 = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t2) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      p2.name = "MaxListenersExceededWarning", p2.emitter = o, p2.type = t2, p2.count = s.length, Hs(p2);
    }
    return o;
  }

  I.prototype.addListener = function (t2, e2) {
    return ps(this, t2, e2, false);
  };

  I.prototype.on = I.prototype.addListener;

  I.prototype.prependListener = function (t2, e2) {
    return ps(this, t2, e2, true);
  };

  function ks() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = true, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }

  function cs(o, t2, e2) {
    var i = {
      fired: false,
      wrapFn: void 0,
      target: o,
      type: t2,
      listener: e2
    },
        a = ks.bind(i);
    return a.listener = e2, i.wrapFn = a, a;
  }

  I.prototype.once = function (t2, e2) {
    return _o(e2), this.on(t2, cs(this, t2, e2)), this;
  };

  I.prototype.prependOnceListener = function (t2, e2) {
    return _o(e2), this.prependListener(t2, cs(this, t2, e2)), this;
  };

  I.prototype.removeListener = function (t2, e2) {
    var i, a, r2, s, p2;
    if (_o(e2), a = this._events, a === void 0) return this;
    if (i = a[t2], i === void 0) return this;
    if (i === e2 || i.listener === e2) --this._eventsCount === 0 ? this._events =
    /* @__PURE__ */
    Object.create(null) : (delete a[t2], a.removeListener && this.emit("removeListener", t2, i.listener || e2));else if (typeof i != "function") {
      for (r2 = -1, s = i.length - 1; s >= 0; s--) {
        if (i[s] === e2 || i[s].listener === e2) {
          p2 = i[s].listener, r2 = s;
          break;
        }
      }

      if (r2 < 0) return this;
      r2 === 0 ? i.shift() : Gs(i, r2), i.length === 1 && (a[t2] = i[0]), a.removeListener !== void 0 && this.emit("removeListener", t2, p2 || e2);
    }
    return this;
  };

  I.prototype.off = I.prototype.removeListener;

  I.prototype.removeAllListeners = function (t2) {
    var e2, i, a;
    if (i = this._events, i === void 0) return this;
    if (i.removeListener === void 0) return arguments.length === 0 ? (this._events =
    /* @__PURE__ */
    Object.create(null), this._eventsCount = 0) : i[t2] !== void 0 && (--this._eventsCount === 0 ? this._events =
    /* @__PURE__ */
    Object.create(null) : delete i[t2]), this;

    if (arguments.length === 0) {
      var r2 = Object.keys(i),
          s;

      for (a = 0; a < r2.length; ++a) {
        s = r2[a], s !== "removeListener" && this.removeAllListeners(s);
      }

      return this.removeAllListeners("removeListener"), this._events =
      /* @__PURE__ */
      Object.create(null), this._eventsCount = 0, this;
    }

    if (e2 = i[t2], typeof e2 == "function") this.removeListener(t2, e2);else if (e2 !== void 0) for (a = e2.length - 1; a >= 0; a--) {
      this.removeListener(t2, e2[a]);
    }
    return this;
  };

  function ds(o, t2, e2) {
    var i = o._events;
    if (i === void 0) return [];
    var a = i[t2];
    return a === void 0 ? [] : typeof a == "function" ? e2 ? [a.listener || a] : [a] : e2 ? Vs(a) : us(a, a.length);
  }

  I.prototype.listeners = function (t2) {
    return ds(this, t2, true);
  };

  I.prototype.rawListeners = function (t2) {
    return ds(this, t2, false);
  };

  I.listenerCount = function (o, t2) {
    return typeof o.listenerCount == "function" ? o.listenerCount(t2) : ms.call(o, t2);
  };

  I.prototype.listenerCount = ms;

  function ms(o) {
    var t2 = this._events;

    if (t2 !== void 0) {
      var e2 = t2[o];
      if (typeof e2 == "function") return 1;
      if (e2 !== void 0) return e2.length;
    }

    return 0;
  }

  I.prototype.eventNames = function () {
    return this._eventsCount > 0 ? To(this._events) : [];
  };

  function us(o, t2) {
    for (var e2 = new Array(t2), i = 0; i < t2; ++i) {
      e2[i] = o[i];
    }

    return e2;
  }

  function Gs(o, t2) {
    for (; t2 + 1 < o.length; t2++) {
      o[t2] = o[t2 + 1];
    }

    o.pop();
  }

  function Vs(o) {
    for (var t2 = new Array(o.length), e2 = 0; e2 < t2.length; ++e2) {
      t2[e2] = o[e2].listener || o[e2];
    }

    return t2;
  }

  function $s(o, t2) {
    return new Promise(function (e2, i) {
      function a(s) {
        o.removeListener(t2, r2), i(s);
      }

      function r2() {
        typeof o.removeListener == "function" && o.removeListener("error", a), e2([].slice.call(arguments));
      }

      hs(o, t2, r2, {
        once: true
      }), t2 !== "error" && Ws(o, a, {
        once: true
      });
    });
  }

  function Ws(o, t2, e2) {
    typeof o.on == "function" && hs(o, "error", t2, e2);
  }

  function hs(o, t2, e2, i) {
    if (typeof o.on == "function") i.once ? o.once(t2, e2) : o.on(t2, e2);else if (typeof o.addEventListener == "function") o.addEventListener(t2, function a(r2) {
      i.once && o.removeEventListener(t2, a), e2(r2);
    });else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof o);
  }
});
var Ms = Mo(function (fs, ys) {
  (function () {
    var o,
        e2,
        i = [].splice,
        a = function a(s, p2) {
      if (!(s instanceof p2)) throw new Error("Bound instance method accessed before binding");
    },
        r2 = [].indexOf;

    e2 = rs(), o = gs().EventEmitter, ys.exports = function () {
      var s =
      /*#__PURE__*/
      function (_o2) {
        _inherits3(s, _o2);

        function s() {
          var _this25;

          var n2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck3(this, s);

          _this25 = _possibleConstructorReturn3(this, _getPrototypeOf4(s).call(this)), _this25.get = _this25.get.bind(_assertThisInitialized3(_this25)), _this25.mget = _this25.mget.bind(_assertThisInitialized3(_this25)), _this25.set = _this25.set.bind(_assertThisInitialized3(_this25)), _this25.mset = _this25.mset.bind(_assertThisInitialized3(_this25)), _this25.del = _this25.del.bind(_assertThisInitialized3(_this25)), _this25.take = _this25.take.bind(_assertThisInitialized3(_this25)), _this25.ttl = _this25.ttl.bind(_assertThisInitialized3(_this25)), _this25.getTtl = _this25.getTtl.bind(_assertThisInitialized3(_this25)), _this25.keys = _this25.keys.bind(_assertThisInitialized3(_this25)), _this25.has = _this25.has.bind(_assertThisInitialized3(_this25)), _this25.getStats = _this25.getStats.bind(_assertThisInitialized3(_this25)), _this25.flushAll = _this25.flushAll.bind(_assertThisInitialized3(_this25)), _this25.flushStats = _this25.flushStats.bind(_assertThisInitialized3(_this25)), _this25.close = _this25.close.bind(_assertThisInitialized3(_this25)), _this25._checkData = _this25._checkData.bind(_assertThisInitialized3(_this25)), _this25._check = _this25._check.bind(_assertThisInitialized3(_this25)), _this25._isInvalidKey = _this25._isInvalidKey.bind(_assertThisInitialized3(_this25)), _this25._wrap = _this25._wrap.bind(_assertThisInitialized3(_this25)), _this25._getValLength = _this25._getValLength.bind(_assertThisInitialized3(_this25)), _this25._error = _this25._error.bind(_assertThisInitialized3(_this25)), _this25._initErrors = _this25._initErrors.bind(_assertThisInitialized3(_this25)), _this25.options = n2, _this25._initErrors(), _this25.data = {}, _this25.options = Object.assign({
            forceString: false,
            objectValueSize: 80,
            promiseValueSize: 80,
            arrayValueSize: 40,
            stdTTL: 0,
            checkperiod: 600,
            useClones: true,
            deleteOnExpire: true,
            enableLegacyCallbacks: false,
            maxKeys: -1
          }, _this25.options), _this25.options.enableLegacyCallbacks && (console.warn("WARNING! node-cache legacy callback support will drop in v6.x"), ["get", "mget", "set", "del", "ttl", "getTtl", "keys", "has"].forEach(function (l2) {
            var c2;
            c2 = _this25[l2], _this25[l2] = function () {
              var _h2, _h3, _i$call, _i$call2;

              for (var _len15 = arguments.length, d2 = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
                d2[_key15] = arguments[_key15];
              }

              var m2, y2, h2, It;
              if (h2 = d2, (_h2 = h2, _h3 = _toArray(_h2), d2 = _h3.slice(0), _h2), (_i$call = i.call(d2, -1), _i$call2 = _slicedToArray3(_i$call, 1), m2 = _i$call2[0], _i$call), typeof m2 == "function") try {
                It = c2.apply(void 0, _toConsumableArray3(d2)), m2(null, It);
              } catch (St) {
                y2 = St, m2(y2);
              } else return c2.apply(void 0, _toConsumableArray3(d2).concat([m2]));
            };
          })), _this25.stats = {
            hits: 0,
            misses: 0,
            keys: 0,
            ksize: 0,
            vsize: 0
          }, _this25.validKeyTypes = ["string", "number"], _this25._checkData();
          return _this25;
        }

        _createClass3(s, [{
          key: "get",
          value: function get(n2) {
            var l2, c2;
            if (a(this, s), (c2 = this._isInvalidKey(n2)) != null) throw c2;
            if (this.data[n2] != null && this._check(n2, this.data[n2])) return this.stats.hits++, l2 = this._unwrap(this.data[n2]), l2;
            this.stats.misses++;
          }
        }, {
          key: "mget",
          value: function mget(n2) {
            var l2, c2, d2, m2, y2, h2;
            if (a(this, s), !Array.isArray(n2)) throw l2 = this._error("EKEYSTYPE"), l2;

            for (h2 = {}, d2 = 0, y2 = n2.length; d2 < y2; d2++) {
              if (m2 = n2[d2], (c2 = this._isInvalidKey(m2)) != null) throw c2;
              this.data[m2] != null && this._check(m2, this.data[m2]) ? (this.stats.hits++, h2[m2] = this._unwrap(this.data[m2])) : this.stats.misses++;
            }

            return h2;
          }
        }, {
          key: "set",
          value: function set(n2, l2, c2) {
            var d2, m2, y2;
            if (a(this, s), this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) throw d2 = this._error("ECACHEFULL"), d2;
            if (this.options.forceString && !typeof l2 === "string" && (l2 = JSON.stringify(l2)), c2 == null && (c2 = this.options.stdTTL), (m2 = this._isInvalidKey(n2)) != null) throw m2;
            return y2 = false, this.data[n2] && (y2 = true, this.stats.vsize -= this._getValLength(this._unwrap(this.data[n2], false))), this.data[n2] = this._wrap(l2, c2), this.stats.vsize += this._getValLength(l2), y2 || (this.stats.ksize += this._getKeyLength(n2), this.stats.keys++), this.emit("set", n2, l2), true;
          }
        }, {
          key: "mset",
          value: function mset(n2) {
            var l2, c2, d2, m2, y2, h2, It, St, Ct, k2;
            if (a(this, s), this.options.maxKeys > -1 && this.stats.keys + n2.length >= this.options.maxKeys) throw l2 = this._error("ECACHEFULL"), l2;

            for (d2 = 0, It = n2.length; d2 < It; d2++) {
              var _h4;

              if (h2 = n2[d2], (_h4 = h2, y2 = _h4.key, k2 = _h4.val, Ct = _h4.ttl, _h4), Ct && typeof Ct != "number") throw l2 = this._error("ETTLTYPE"), l2;
              if ((c2 = this._isInvalidKey(y2)) != null) throw c2;
            }

            for (m2 = 0, St = n2.length; m2 < St; m2++) {
              var _h5;

              h2 = n2[m2], (_h5 = h2, y2 = _h5.key, k2 = _h5.val, Ct = _h5.ttl, _h5), this.set(y2, k2, Ct);
            }

            return true;
          }
        }, {
          key: "del",
          value: function del(n2) {
            var l2, c2, d2, m2, y2, h2;

            for (a(this, s), Array.isArray(n2) || (n2 = [n2]), l2 = 0, d2 = 0, y2 = n2.length; d2 < y2; d2++) {
              if (m2 = n2[d2], (c2 = this._isInvalidKey(m2)) != null) throw c2;
              this.data[m2] != null && (this.stats.vsize -= this._getValLength(this._unwrap(this.data[m2], false)), this.stats.ksize -= this._getKeyLength(m2), this.stats.keys--, l2++, h2 = this.data[m2], delete this.data[m2], this.emit("del", m2, h2.v));
            }

            return l2;
          }
        }, {
          key: "take",
          value: function take(n2) {
            var l2;
            return a(this, s), l2 = this.get(n2), l2 != null && this.del(n2), l2;
          }
        }, {
          key: "ttl",
          value: function ttl(n2, l2) {
            var c2;
            if (a(this, s), l2 || (l2 = this.options.stdTTL), !n2) return false;
            if ((c2 = this._isInvalidKey(n2)) != null) throw c2;
            return this.data[n2] != null && this._check(n2, this.data[n2]) ? (l2 >= 0 ? this.data[n2] = this._wrap(this.data[n2].v, l2, false) : this.del(n2), true) : false;
          }
        }, {
          key: "getTtl",
          value: function getTtl(n2) {
            var l2, c2;

            if (a(this, s), !!n2) {
              if ((c2 = this._isInvalidKey(n2)) != null) throw c2;
              if (this.data[n2] != null && this._check(n2, this.data[n2])) return l2 = this.data[n2].t, l2;
            }
          }
        }, {
          key: "keys",
          value: function keys() {
            var n2;
            return a(this, s), n2 = Object.keys(this.data), n2;
          }
        }, {
          key: "has",
          value: function has(n2) {
            var l2;
            return a(this, s), l2 = this.data[n2] != null && this._check(n2, this.data[n2]), l2;
          }
        }, {
          key: "getStats",
          value: function getStats() {
            return a(this, s), this.stats;
          }
        }, {
          key: "flushAll",
          value: function flushAll() {
            var n2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            a(this, s), this.data = {}, this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            }, this._killCheckPeriod(), this._checkData(n2), this.emit("flush");
          }
        }, {
          key: "flushStats",
          value: function flushStats() {
            a(this, s), this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            }, this.emit("flush_stats");
          }
        }, {
          key: "close",
          value: function close() {
            a(this, s), this._killCheckPeriod();
          }
        }, {
          key: "_checkData",
          value: function _checkData() {
            var n2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var l2, c2, d2;
            a(this, s), c2 = this.data;

            for (l2 in c2) {
              d2 = c2[l2], this._check(l2, d2);
            }

            n2 && this.options.checkperiod > 0 && (this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1e3, n2), this.checkTimeout != null && this.checkTimeout.unref != null && this.checkTimeout.unref());
          }
        }, {
          key: "_killCheckPeriod",
          value: function _killCheckPeriod() {
            if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
          }
        }, {
          key: "_check",
          value: function _check(n2, l2) {
            var c2;
            return a(this, s), c2 = true, l2.t !== 0 && l2.t < Date.now() && (this.options.deleteOnExpire && (c2 = false, this.del(n2)), this.emit("expired", n2, this._unwrap(l2))), c2;
          }
        }, {
          key: "_isInvalidKey",
          value: function _isInvalidKey(n2) {
            var l2;
            if (a(this, s), l2 = typeof n2, r2.call(this.validKeyTypes, l2) < 0) return this._error("EKEYTYPE", {
              type: typeof n2
            });
          }
        }, {
          key: "_wrap",
          value: function _wrap(n2, l2) {
            var c2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var d2, m2, h2;
            return a(this, s), this.options.useClones || (c2 = false), m2 = Date.now(), d2 = 0, h2 = 1e3, l2 === 0 ? d2 = 0 : l2 ? d2 = m2 + l2 * h2 : this.options.stdTTL === 0 ? d2 = this.options.stdTTL : d2 = m2 + this.options.stdTTL * h2, {
              t: d2,
              v: c2 ? e2(n2) : n2
            };
          }
        }, {
          key: "_unwrap",
          value: function _unwrap(n2) {
            var l2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return this.options.useClones || (l2 = false), n2.v != null ? l2 ? e2(n2.v) : n2.v : null;
          }
        }, {
          key: "_getKeyLength",
          value: function _getKeyLength(n2) {
            return n2.toString().length;
          }
        }, {
          key: "_getValLength",
          value: function _getValLength(n2) {
            return a(this, s), typeof n2 == "string" ? n2.length : this.options.forceString ? JSON.stringify(n2).length : Array.isArray(n2) ? this.options.arrayValueSize * n2.length : typeof n2 == "number" ? 8 : typeof (n2 == null ? void 0 : n2.then) == "function" ? this.options.promiseValueSize : typeof Buffer < "u" && Buffer !== null && Buffer.isBuffer(n2) ? n2.length : n2 != null && typeof n2 == "object" ? this.options.objectValueSize * Object.keys(n2).length : typeof n2 == "boolean" ? 8 : 0;
          }
        }, {
          key: "_error",
          value: function _error(n2) {
            var l2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var c2;
            return a(this, s), c2 = new Error(), c2.name = n2, c2.errorcode = n2, c2.message = this.ERRORS[n2] != null ? this.ERRORS[n2](l2) : "-", c2.data = l2, c2;
          }
        }, {
          key: "_initErrors",
          value: function _initErrors() {
            var n2, l2, c2;
            a(this, s), this.ERRORS = {}, c2 = this._ERRORS;

            for (l2 in c2) {
              n2 = c2[l2], this.ERRORS[l2] = this.createErrorMessage(n2);
            }
          }
        }, {
          key: "createErrorMessage",
          value: function createErrorMessage(n2) {
            return function (l2) {
              return n2.replace("__key", l2.type);
            };
          }
        }]);

        return s;
      }(o);

      return s.prototype._ERRORS = {
        ENOTFOUND: "Key `__key` not found",
        ECACHEFULL: "Cache max keys amount exceeded",
        EKEYTYPE: "The key argument has to be of type `string` or `number`. Found: `__key`",
        EKEYSTYPE: "The keys argument has to be an array.",
        ETTLTYPE: "The ttl argument has to be a number."
      }, s;
    }.call(this);
  }).call(fs);
});
var Is = Mo(function (bs, ws) {
  (function () {
    var o;
    o = ws.exports = Ms(), o.version = "5.1.2";
  }).call(bs);
});

var Oo = function Oo(o) {
  var t2 = 200,
      e2 = [],
      i = 0;
  return e2[i] = [], o.forEach(function (a) {
    e2[i].length <= t2 - 1 ? e2[i].push(a) : (i++, e2[i] = [a]);
  }), e2;
},
    At = function At(o, t2) {
  var e2 = [];

  for (; o.length > t2;) {
    var _i13 = o.splice(0, t2);

    e2.push(_i13);
  }

  return e2.push(o), e2;
},
    R = function R(o, t2) {
  var e2 = "",
      i = {
    profile: "https://profile.fansunitedapi.com/v1",
    football: "https://football.fansunitedapi.com/v1",
    idMapping: "https://id-mapping.fansunitedapi.com/v1",
    predictor: "https://prediction.fansunitedapi.com/v1",
    client: "https://client.fansunitedapi.com/v1",
    loyalty: "https://loyalty.fansunitedapi.com/v1",
    miniGames: "https://mini-games.fansunitedapi.com/v1",
    discussions: "https://discussions.fansunitedapi.com/v1",
    privateLeagues: "https://private-leagues.fansunitedapi.com/v1"
  },
      a = {
    profile: "https://profile.watg.fansunitedapi.com/v1",
    football: "https://football.watg.fansunitedapi.com/v1",
    idMapping: "https://id-mapping.watg.fansunitedapi.com/v1",
    predictor: "https://prediction.watg.fansunitedapi.com/v1",
    client: "https://client.watg.fansunitedapi.com/v1",
    loyalty: "https://loyalty.watg.fansunitedapi.com/v1",
    miniGames: "https://mini-games.watg.fansunitedapi.com/v1",
    discussions: "https://discussions.watg.fansunitedapi.com/v1",
    privateLeagues: "https://private-leagues.watg.fansunitedapi.com/v1"
  },
      r2 = {
    profile: "http://localhost:8010/v1",
    football: "http://localhost:8080/v1",
    idMapping: "http://localhost:8030/v1",
    predictor: "http://localhost:8040/v1",
    client: "http://localhost:8070/v1",
    loyalty: "http://localhost:8060/v1",
    miniGames: "http://localhost:9040/v1",
    discussions: "http://localhost:9020/v1",
    privateLeagues: "http://localhost:9010/v1"
  },
      s = {
    profile: "https://profile.fansunitedstagingapi.com/v1",
    football: "https://football.fansunitedstagingapi.com/v1",
    idMapping: "https://id-mapping.fansunitedstagingapi.com/v1",
    predictor: "https://prediction.fansunitedstagingapi.com/v1",
    client: "https://client.fansunitedstagingapi.com/v1",
    loyalty: "https://loyalty.fansunitedstagingapi.com/v1",
    miniGames: "https://mini-games.fansunitedstagingapi.com/v1",
    discussions: "https://discussions.fansunitedstagingapi.com/v1",
    privateLeagues: "https://private-leagues.fansunitedstagingapi.com/v1"
  };
  return o === "prod" ? e2 = i[t2] : o === "dev" ? e2 = r2[t2] : o === "watg" ? e2 = a[t2] : e2 = s[t2], e2;
},
    Pt = function Pt(o) {
  return o.filter(function (e2, i, a) {
    return i === a.indexOf(e2);
  });
},
    P = function P(o) {
  return o || false;
},
    w$2 = function w$2() {
  return "&disable_cache=".concat(Date.now());
},
    bo = function bo(o) {
  return JSON.parse(JSON.stringify(o.sort(function (t2, e2) {
    return t2.localeCompare(e2);
  })));
};

var ze = function ze() {
  _classCallCheck3(this, ze);

  __publicField(this, "id", null);

  __publicField(this, "name", null);

  __publicField(this, "nickname", null);

  __publicField(this, "avatar", null);

  __publicField(this, "gender", null);

  __publicField(this, "country", null);

  __publicField(this, "birthDate", null);

  __publicField(this, "interests", []);

  __publicField(this, "followingCount", 0);

  __publicField(this, "followersCount", 0);
};

var Qe = function Qe() {
  var _this26 = this;

  _classCallCheck3(this, Qe);

  __publicField(this, "profilesFromResponse", function (t2) {
    return t2 ? t2.map(function (e2) {
      return _this26.fullProfileFromResponse(e2);
    }) : null;
  });

  __publicField(this, "fullProfileFromResponse", function (t2) {
    var e2 = new ze();
    return e2.id = t2.id, e2.name = t2.name, e2.nickname = t2.nickname, e2.avatar = t2.avatar, e2.gender = t2.gender, e2.country = t2.country, e2.birthDate = t2.birth_date, e2.interests = t2.interests ? t2.interests : [], e2.followingCount = t2.following_count, e2.followersCount = t2.followers_count, e2;
  });
};

var Lt = function Lt() {
  _classCallCheck3(this, Lt);

  __publicField(this, "nextPageStartsAfter", null);

  __publicField(this, "itemsPerPage", null);
};

var G = function G() {
  _classCallCheck3(this, G);

  __publicField(this, "pagination", new Lt());
};

var E = function E() {
  _classCallCheck3(this, E);

  __publicField(this, "meta", new G());

  __publicField(this, "data", []);
};

var Xe = function Xe() {
  _classCallCheck3(this, Xe);

  __publicField(this, "avatar", null);

  __publicField(this, "followingId", null);

  __publicField(this, "name", null);

  __publicField(this, "nickname", null);

  __publicField(this, "profileId", null);
};

var Ye = function Ye() {
  var _this27 = this;

  _classCallCheck3(this, Ye);

  __publicField(this, "followResponse", function (t2) {
    return t2.map(function (e2) {
      return _this27.remapResponse(e2);
    });
  });

  __publicField(this, "followingFromResponse", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this27.remapResponse(i);
    }), e2;
  });

  __publicField(this, "remapResponse", function (t2) {
    var e2 = new Xe();
    return e2.avatar = t2.avatar, e2.followingId = t2.following_id, e2.name = t2.name, e2.profileId = t2.profile_id, e2.nickname = t2.nickname, e2;
  });
};

var Je = function Je() {
  _classCallCheck3(this, Je);

  __publicField(this, "avatar", null);

  __publicField(this, "followerId", null);

  __publicField(this, "name", null);

  __publicField(this, "nickname", null);

  __publicField(this, "profileId", null);
};

var Ze = function Ze() {
  var _this28 = this;

  _classCallCheck3(this, Ze);

  __publicField(this, "followersFromResponse", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this28.remapResponse(i);
    }), e2;
  });

  __publicField(this, "remapResponse", function (t2) {
    var e2 = new Je();
    return e2.avatar = t2.avatar, e2.followerId = t2.follower_id, e2.name = t2.name, e2.profileId = t2.profile_id, e2;
  });
};

var Oe = function Oe() {
  _classCallCheck3(this, Oe);

  __publicField(this, "profile_ids", []);
};

function Do(o) {
  this.message = o;
}

Do.prototype = new Error(), Do.prototype.name = "InvalidCharacterError";

var Qo = typeof window < "u" && window.atob && window.atob.bind(window) || function (o) {
  var t2 = String(o).replace(/=+$/, "");
  if (t2.length % 4 == 1) throw new Do("'atob' failed: The string to be decoded is not correctly encoded.");

  for (var e2, i, a = 0, r2 = 0, s = ""; i = t2.charAt(r2++); ~i && (e2 = a % 4 ? 64 * e2 + i : i, a++ % 4) ? s += String.fromCharCode(255 & e2 >> (-2 * a & 6)) : 0) {
    i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
  }

  return s;
};

function xs(o) {
  var t2 = o.replace(/-/g, "+").replace(/_/g, "/");

  switch (t2.length % 4) {
    case 0:
      break;

    case 2:
      t2 += "==";
      break;

    case 3:
      t2 += "=";
      break;

    default:
      throw "Illegal base64url string!";
  }

  try {
    return function (e2) {
      return decodeURIComponent(Qo(e2).replace(/(.)/g, function (i, a) {
        var r2 = a.charCodeAt(0).toString(16).toUpperCase();
        return r2.length < 2 && (r2 = "0" + r2), "%" + r2;
      }));
    }(t2);
  } catch (_unused4) {
    return Qo(t2);
  }
}

function wo(o) {
  this.message = o;
}

function Bs(o, t2) {
  if (typeof o != "string") throw new wo("Invalid token specified");
  var e2 = (t2 = t2 || {}).header === true ? 0 : 1;

  try {
    return JSON.parse(xs(o.split(".")[e2]));
  } catch (i) {
    throw new wo("Invalid token specified: " + i.message);
  }
}

wo.prototype = new Error(), wo.prototype.name = "InvalidTokenError";
var Xo = Bs;
var C = {
  native: "id",
  sportradar: "sportradar_id",
  sportal365: "sportal365_id",
  enetpulse: "enetpulse_id",
  api_football: "api_football_id"
},
    xo = {
  PREDICTOR_USER_RELATED_OPERATION: "https://docs.fansunitedmedia.com/docs/predictor-operations#user-related-operations"
},
    Bo = ["matchId", "matchType", "market", "prediction"],
    Yo =
/* @__PURE__ */
new Map().set("FT_1X2", "fullTimeOneXTwo").set("HT_1X2", "halfTimeOneXTwo").set("BOTH_TEAMS_SCORE", "bothTeamsScore").set("DOUBLE_CHANCE", "doubleChance").set("HT_FT", "halfTimeFullTime").set("PLAYER_SCORE", "playerScore").set("PLAYER_YELLOW_CARD", "playerYellowCard").set("PLAYER_RED_CARD", "playerRedCard").set("RED_CARD_MATCH", "redCardMatch").set("PENALTY_MATCH", "penaltyMatch").set("PLAYER_SCORE_FIRST_GOAL", "playerScoreFirstGoal").set("CORNERS_MATCH", "cornersMatch").set("CORRECT_SCORE", "correctScore").set("CORRECT_SCORE_ADVANCED", "correctScoreAdvanced").set("CORRECT_SCORE_HT", "correctScoreHalfTime").set("PLAYER_SCORE_HATTRICK", "playerScoreHattrick").set("PLAYER_SCORE_TWICE", "playerScoreTwice").set("OVER_GOALS_0_5", "overZeroPointFiveGoals").set("OVER_GOALS_1_5", "overOnePointFiveGoals").set("OVER_GOALS_2_5", "overTwoPointFiveGoals").set("OVER_GOALS_3_5", "overThreePointFiveGoals").set("OVER_GOALS_4_5", "overFourPointFiveGoals").set("OVER_GOALS_5_5", "overFivePointFiveGoals").set("OVER_GOALS_6_5", "overSixPointFiveGoals").set("OVER_CORNERS_6_5", "overSixPointFiveCorners").set("OVER_CORNERS_7_5", "overSevenPointFiveCorners").set("OVER_CORNERS_8_5", "overEightPointFiveCorners").set("OVER_CORNERS_9_5", "overNinePointFiveCorners").set("OVER_CORNERS_10_5", "overTenPointFiveCorners").set("OVER_CORNERS_11_5", "overElevenPointFiveCorners").set("OVER_CORNERS_12_5", "overTwelvePointFiveCorners").set("OVER_CORNERS_13_5", "overThirteenPointFiveCorners");

var No = {
  UNEXPECTED_STATUS_PROP: "Unexpected provided property 'status'. You can NOT use this property for this method. For more information visit our documentation: \n ".concat(xo.PREDICTOR_USER_RELATED_OPERATION),
  UNEXPECTED_TYPE_PROP: "Unexpected provided property 'type'. You can NOT use this property for this method. For more information visit our documentation: \n ".concat(xo.PREDICTOR_USER_RELATED_OPERATION)
},
    Jo = function Jo(o, t2) {
  return "The prediction '".concat(o, "' is invalid for market '").concat(t2, "'. Please check again have you passed appropriate prediction model. For more information please visit our documentation: https://docs.fansunitedmedia.com/sdks/js/match.quiz#gamerelatedoperations");
},
    Io = function Io(o) {
  return "The market '".concat(o, "' is not supported from Fans United. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction");
},
    Zo = function Zo(o) {
  return "The market '".concat(o, "' is not valid for Top X game. The only available market is CORRECT_SCORE.");
},
    ts = function ts(o) {
  return "The field/s '".concat(o.length > 1 ? o.join(", ") : o[0], "' is/are invalid. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/javascript-sdk");
},
    es = function es(o, t2) {
  return "The following field/s is/are missing from ".concat(o, ": '").concat(t2.length > 1 ? t2.join(", ") : t2[0], "'. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction");
},
    is = function is(o, t2) {
  return "The field ".concat(o, " has incorrect type. The correct type is ").concat(t2);
};

var vt = function vt(t2, e2) {
  var _this29 = this;

  _classCallCheck3(this, vt);

  __publicField(this, "data", {
    error: {
      code: 0,
      status: "",
      message: ""
    }
  });

  __publicField(this, "status", 0);

  __publicField(this, "statusText", "");

  __publicField(this, "headers", null);

  __publicField(this, "errorMessage", function () {
    return _this29.data.error.message;
  });

  this.data.error.code = e2.code, this.data.error.status = e2.status, this.data.error.message = e2.message, this.status = t2.status, this.statusText = t2.statusText, this.headers = t2.headers;
};

var u = function u(t2, e2, i) {
  _classCallCheck3(this, u);

  __publicField(this, "error", {
    code: 0,
    status: "",
    message: ""
  });

  this.error.code = t2, this.error.status = e2, this.error.message = i;
};

var _ = function _(t2, e2) {
  var _this30 = this;

  _classCallCheck3(this, _);

  __publicField(this, "baseUrl", null);

  __publicField(this, "apiSignInUrl", null);

  __publicField(this, "jwtToken", null);

  __publicField(this, "idSchema", null);

  __publicField(this, "retryRequest", false);

  __publicField(this, "headers", null);

  __publicField(this, "authHeaders", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "fetchWithoutAuth",
  /*#__PURE__*/
  function () {
    var _ref30 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee18(t2, e2) {
      var i, a, r2;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return fetch(_this30.baseUrl + t2, {
                headers: _this30.headers
              });

            case 2:
              i = _context18.sent;
              _context18.next = 5;
              return i.json();

            case 5:
              a = _context18.sent;

              if (i.ok) {
                _context18.next = 9;
                break;
              }

              r2 = _this30.transformFetchException(i, a);
              throw console.warn(e2, r2), r2;

            case 9:
              return _context18.abrupt("return", a);

            case 10:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x20, _x21) {
      return _ref30.apply(this, arguments);
    };
  }());

  __publicField(this, "fetchWithAuth",
  /*#__PURE__*/
  function () {
    var _ref31 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee19(t2, e2, i, a) {
      var r2, s, p2;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _this30.validateJWTToken();

              r2 = null, s = null;

              if (!(i && a)) {
                _context19.next = 8;
                break;
              }

              _context19.next = 5;
              return fetch(_this30.baseUrl + t2, {
                method: i,
                headers: _this30.authHeaders,
                body: JSON.stringify(a)
              });

            case 5:
              r2 = _context19.sent;
              _context19.next = 17;
              break;

            case 8:
              if (!(i && !a)) {
                _context19.next = 14;
                break;
              }

              _context19.next = 11;
              return fetch(_this30.baseUrl + t2, {
                method: i,
                headers: _this30.authHeaders
              });

            case 11:
              r2 = _context19.sent;
              _context19.next = 17;
              break;

            case 14:
              _context19.next = 16;
              return fetch(_this30.baseUrl + t2, {
                headers: _this30.authHeaders
              });

            case 16:
              r2 = _context19.sent;

            case 17:
              _context19.t0 = i !== "DELETE";

              if (!_context19.t0) {
                _context19.next = 22;
                break;
              }

              _context19.next = 21;
              return r2.json();

            case 21:
              s = _context19.sent;

            case 22:
              if (r2.ok) {
                _context19.next = 39;
                break;
              }

              _context19.t1 = (r2.status === 401 || r2.status === 403) && !_this30.retryRequest;

              if (!_context19.t1) {
                _context19.next = 28;
                break;
              }

              _this30.retryRequest = true;
              _context19.next = 28;
              return _this30.fetchWithAuth(t2, e2, i, a);

            case 28:
              _this30.retryRequest = false;
              _context19.t2 = _this30;
              _context19.t3 = r2;
              _context19.t4 = s;

              if (_context19.t4) {
                _context19.next = 36;
                break;
              }

              _context19.next = 35;
              return r2.json();

            case 35:
              _context19.t4 = _context19.sent;

            case 36:
              _context19.t5 = _context19.t4;
              p2 = _context19.t2.transformFetchException.call(_context19.t2, _context19.t3, _context19.t5);
              throw console.warn(e2, p2), p2;

            case 39:
              return _context19.abrupt("return", (_this30.retryRequest = false, s));

            case 40:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x22, _x23, _x24, _x25) {
      return _ref31.apply(this, arguments);
    };
  }());

  __publicField(this, "fetchWithAuthNewBaseURL",
  /*#__PURE__*/
  function () {
    var _ref33 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee20(t2, e2, i, a, r2) {
      var s, p2, n2;
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _this30.validateJWTToken();

              s = null, p2 = null;

              if (!(a && r2)) {
                _context20.next = 8;
                break;
              }

              _context20.next = 5;
              return fetch(t2 + e2, {
                method: a,
                headers: _this30.authHeaders,
                body: JSON.stringify(r2)
              });

            case 5:
              s = _context20.sent;
              _context20.next = 17;
              break;

            case 8:
              if (!(a && !r2)) {
                _context20.next = 14;
                break;
              }

              _context20.next = 11;
              return fetch(t2 + e2, {
                method: a,
                headers: _this30.authHeaders
              });

            case 11:
              s = _context20.sent;
              _context20.next = 17;
              break;

            case 14:
              _context20.next = 16;
              return fetch(t2 + e2, {
                headers: _this30.authHeaders
              });

            case 16:
              s = _context20.sent;

            case 17:
              _context20.t0 = a !== "DELETE";

              if (!_context20.t0) {
                _context20.next = 22;
                break;
              }

              _context20.next = 21;
              return s.json();

            case 21:
              p2 = _context20.sent;

            case 22:
              if (s.ok) {
                _context20.next = 39;
                break;
              }

              _context20.t1 = (s.status === 401 || s.status === 403) && !_this30.retryRequest;

              if (!_context20.t1) {
                _context20.next = 28;
                break;
              }

              _this30.retryRequest = true;
              _context20.next = 28;
              return _this30.fetchWithAuthNewBaseURL(t2, e2, i, a, r2);

            case 28:
              _this30.retryRequest = false;
              _context20.t2 = _this30;
              _context20.t3 = s;
              _context20.t4 = p2;

              if (_context20.t4) {
                _context20.next = 36;
                break;
              }

              _context20.next = 35;
              return s.json();

            case 35:
              _context20.t4 = _context20.sent;

            case 36:
              _context20.t5 = _context20.t4;
              n2 = _context20.t2.transformFetchException.call(_context20.t2, _context20.t3, _context20.t5);
              throw console.warn(i, n2), n2;

            case 39:
              return _context20.abrupt("return", (_this30.retryRequest = false, p2));

            case 40:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x26, _x27, _x28, _x29, _x30) {
      return _ref33.apply(this, arguments);
    };
  }());

  __publicField(this, "transformFetchException", function (t2, e2) {
    if (!e2 && t2.status === 401) {
      if (_this30.errorHandlingMode === "standard") return new u(401, "unauthorized", "Invalid JWT token is provided");
      var s = {
        code: 401,
        status: "unauthorized",
        message: "Invalid JWT token is provided"
      };
      return new vt(t2, s);
    }

    var _e2$error = e2.error,
        i = _e2$error.code,
        a = _e2$error.status,
        r2 = _e2$error.message;
    return _this30.errorHandlingMode === "standard" ? new u(i, a, r2) : new vt(t2, e2.error);
  });

  __publicField(this, "validateJWTToken", function () {
    var t2 = null;

    try {
      t2 = Xo(_this30.jwtToken);
    } catch (i) {
      if (_this30.errorHandlingMode === "default") {
        var a = {
          status: 401,
          statusText: i.message,
          headers: {}
        },
            r2 = {
          code: 401,
          status: "invalid_token",
          message: "Invalid JWT token is provided"
        };
        throw new vt(a, r2);
      } else if (_this30.errorHandlingMode === "standard") throw new u(401, "invalid_token", "Invalid JWT token is provided");
    }

    if (Date.now() > t2.exp * 1e3) {
      if (_this30.errorHandlingMode === "default") {
        var _i14 = {
          status: 401,
          statusText: "",
          headers: {}
        },
            _a4 = {
          code: 401,
          status: "invalid_token",
          message: "The provided JWT token is expired"
        };
        throw new vt(_i14, _a4);
      } else if (_this30.errorHandlingMode === "standard") throw new u(401, "invalid_token", "The provided JWT token is expired");
    }
  });

  this.baseUrl = e2, this.apiSignInUrl = "?key=".concat(t2.apiKey, "&client_id=").concat(t2.clientId), this.jwtToken = t2.authProvider.getIdToken(), this.errorHandlingMode = t2.errorHandlingMode, this.idSchema = t2.idSchema, this.headers = {
    "Content-Type": "application/json"
  }, this.authHeaders = {
    "Content-Type": "application/json",
    Authorization: "Bearer ".concat(t2.authProvider.getIdToken())
  };
};

var Ns = "/countries",
    U = "/profile",
    Po = "/profiles",
    Ot =
/*#__PURE__*/
function (_ref34) {
  _inherits3(Ot, _ref34);

  function Ot(t2) {
    var _this31;

    _classCallCheck3(this, Ot);

    _this31 = _possibleConstructorReturn3(this, _getPrototypeOf4(Ot).call(this, t2, R(t2.environment, "profile")));

    __publicField(_assertThisInitialized3(_this31), "profileRemapper", null);

    __publicField(_assertThisInitialized3(_this31), "followingRemapper", null);

    __publicField(_assertThisInitialized3(_this31), "followersRemapper", null);

    __publicField(_assertThisInitialized3(_this31), "lang", null);

    __publicField(_assertThisInitialized3(_this31), "limitIds", 100);

    __publicField(_assertThisInitialized3(_this31), "getCountries",
    /*#__PURE__*/
    function () {
      var _ref35 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                e2 = "&lang=".concat(_this31.lang), i = "".concat(Ns).concat(_this31.apiSignInUrl).concat(e2), a = Date.now(), r2 = "There was a problem fetching profile countries";
                t2 && (i += "&disable_cache=".concat(a));
                _context21.next = 4;
                return _this31.fetchWithoutAuth(i, r2);

              case 4:
                return _context21.abrupt("return", _context21.sent.data);

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x31) {
        return _ref35.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "getProfile",
    /*#__PURE__*/
    function () {
      var _ref36 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(t2) {
        var e2, i, a, _a5;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                e2 = "".concat(U).concat(_this31.apiSignInUrl), i = "";

                if (!t2) {
                  _context22.next = 9;
                  break;
                }

                e2 = "".concat(Po, "/").concat(t2).concat(_this31.apiSignInUrl), i = "There was a problem fetching the following profile: ".concat(t2);
                _context22.next = 5;
                return _this31.fetchWithoutAuth(e2, i);

              case 5:
                a = _context22.sent;
                return _context22.abrupt("return", _this31.profileRemapper.fullProfileFromResponse(a.data));

              case 9:
                i = "There was a problem fetching your profile from API";
                _context22.next = 12;
                return _this31.fetchWithAuth(e2, i);

              case 12:
                _a5 = _context22.sent;
                return _context22.abrupt("return", _this31.profileRemapper.fullProfileFromResponse(_a5.data));

              case 14:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x32) {
        return _ref36.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "getProfiles",
    /*#__PURE__*/
    function () {
      var _ref37 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23(t2, e2, i) {
        var a, r2, c2, d2, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, m2, y2, h2, n2, l2, s, p2;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                a = Date.now(), r2 = "There was a problem fetching the following profiles: ".concat(t2.join(","));

                if (!(t2 && t2.length)) {
                  _context23.next = 41;
                  break;
                }

                if (!(t2.length > _this31.limitIds)) {
                  _context23.next = 35;
                  break;
                }

                c2 = [], d2 = At(t2, _this31.limitIds);
                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context23.prev = 7;
                _iterator9 = d2[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                  _context23.next = 20;
                  break;
                }

                m2 = _step9.value;
                y2 = "".concat(Po).concat(_this31.apiSignInUrl, "&profile_ids=").concat(m2.join(","));
                r2 = "There was a problem fetching the following profiles: ".concat(m2.join(",")), i && (y2 += "&disable_cache=".concat(a));
                _context23.next = 15;
                return _this31.fetchWithoutAuth(y2, r2);

              case 15:
                h2 = _context23.sent;
                c2.push.apply(c2, _toConsumableArray3(_this31.profileRemapper.profilesFromResponse(h2.data)));

              case 17:
                _iteratorNormalCompletion9 = true;
                _context23.next = 9;
                break;

              case 20:
                _context23.next = 26;
                break;

              case 22:
                _context23.prev = 22;
                _context23.t0 = _context23["catch"](7);
                _didIteratorError9 = true;
                _iteratorError9 = _context23.t0;

              case 26:
                _context23.prev = 26;
                _context23.prev = 27;

                if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                  _iterator9.return();
                }

              case 29:
                _context23.prev = 29;

                if (!_didIteratorError9) {
                  _context23.next = 32;
                  break;
                }

                throw _iteratorError9;

              case 32:
                return _context23.finish(29);

              case 33:
                return _context23.finish(26);

              case 34:
                return _context23.abrupt("return", c2);

              case 35:
                n2 = "".concat(Po).concat(_this31.apiSignInUrl, "&profile_ids=").concat(t2.join(","));
                i && (n2 += "&disable_cache=".concat(a));
                _context23.next = 39;
                return _this31.fetchWithoutAuth(n2, r2);

              case 39:
                l2 = _context23.sent;
                return _context23.abrupt("return", _this31.profileRemapper.profilesFromResponse(l2.data));

              case 41:
                s = "".concat(Po).concat(_this31.apiSignInUrl, "&search=").concat(e2);
                i && (s += "&disable_cache=".concat(a));
                _context23.next = 45;
                return _this31.fetchWithoutAuth(s, r2);

              case 45:
                p2 = _context23.sent;
                return _context23.abrupt("return", _this31.profileRemapper.profilesFromResponse(p2.data));

              case 47:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, null, [[7, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function (_x33, _x34, _x35) {
        return _ref37.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "getFollowers",
    /*#__PURE__*/
    function () {
      var _ref38 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(t2, e2) {
        var i, a, s, _s3, r2;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                i = "".concat(U, "/followers").concat(_this31.apiSignInUrl), a = "There was a problem fetching the followers for own profile";

                if (!(t2 && !e2)) {
                  _context24.next = 9;
                  break;
                }

                i = "".concat(U, "/followers").concat(_this31.apiSignInUrl).concat(t2.constructFilterUrl());
                _context24.next = 5;
                return _this31.fetchWithAuth(i, a);

              case 5:
                s = _context24.sent;
                return _context24.abrupt("return", _this31.followersRemapper.followersFromResponse(s));

              case 9:
                if (!(!t2 && !e2)) {
                  _context24.next = 14;
                  break;
                }

                _context24.next = 12;
                return _this31.fetchWithAuth(i, a);

              case 12:
                _s3 = _context24.sent;
                return _context24.abrupt("return", _this31.followersRemapper.followersFromResponse(_s3));

              case 14:
                t2 && e2 ? i = "".concat(U, "/").concat(e2, "/followers").concat(_this31.apiSignInUrl).concat(t2.constructFilterUrl()) : !t2 && e2 && (i = "".concat(U, "/").concat(e2, "/followers").concat(_this31.apiSignInUrl)), a = "There was a problem fetching the followers for profile: ".concat(e2);
                _context24.next = 17;
                return _this31.fetchWithoutAuth(i, a);

              case 17:
                r2 = _context24.sent;
                return _context24.abrupt("return", _this31.followersRemapper.followersFromResponse(r2));

              case 19:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      return function (_x36, _x37) {
        return _ref38.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "getFollowing",
    /*#__PURE__*/
    function () {
      var _ref39 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25(t2, e2) {
        var i, a, s, _s4, r2;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                i = "".concat(U, "/following").concat(_this31.apiSignInUrl), a = "There was a problem fetching the followers of own profile";

                if (!(t2 && !e2)) {
                  _context25.next = 9;
                  break;
                }

                i = "".concat(U, "/following").concat(_this31.apiSignInUrl).concat(t2.constructFilterUrl());
                _context25.next = 5;
                return _this31.fetchWithAuth(i, a);

              case 5:
                s = _context25.sent;
                return _context25.abrupt("return", _this31.followingRemapper.followingFromResponse(s));

              case 9:
                if (!(!t2 && !e2)) {
                  _context25.next = 14;
                  break;
                }

                _context25.next = 12;
                return _this31.fetchWithAuth(i, a);

              case 12:
                _s4 = _context25.sent;
                return _context25.abrupt("return", _this31.followingRemapper.followingFromResponse(_s4));

              case 14:
                t2 && e2 ? i = "".concat(U, "/").concat(e2, "/following").concat(_this31.apiSignInUrl).concat(t2.constructFilterUrl()) : !t2 && e2 && (i = "".concat(U, "/").concat(e2, "/following").concat(_this31.apiSignInUrl)), a = "There was a problem fetching the followers of the following profile: ".concat(e2);
                _context25.next = 17;
                return _this31.fetchWithoutAuth(i, a);

              case 17:
                r2 = _context25.sent;
                return _context25.abrupt("return", _this31.followingRemapper.followingFromResponse(r2));

              case 19:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      return function (_x38, _x39) {
        return _ref39.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "follow",
    /*#__PURE__*/
    function () {
      var _ref40 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(t2) {
        var e2, i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                e2 = new Oe();
                e2.profile_ids = t2;
                i = U + "/follow".concat(_this31.apiSignInUrl);
                a = "There was a problem with following profiles: ".concat(t2.join(","));
                r2 = "POST";
                _context26.next = 7;
                return _this31.fetchWithAuth(i, a, r2, e2);

              case 7:
                s = _context26.sent;
                return _context26.abrupt("return", _this31.followingRemapper.followResponse(s.data));

              case 9:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      return function (_x40) {
        return _ref40.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "unfollow",
    /*#__PURE__*/
    function () {
      var _ref41 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                e2 = new Oe();
                e2.profile_ids = t2;
                i = U + "/follow".concat(_this31.apiSignInUrl), a = "There was a problem with unfollowing profiles: ".concat(t2.join(",")), r2 = "DELETE";
                _context27.next = 5;
                return _this31.fetchWithAuth(i, a, r2, e2);

              case 5:
                return _context27.abrupt("return", true);

              case 6:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      return function (_x41) {
        return _ref41.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "getBadges",
    /*#__PURE__*/
    function () {
      var _ref42 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28(t2) {
        var e2, i;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                e2 = "".concat(U, "/badges").concat(_this31.apiSignInUrl), i = "There was a problem with fetching own badges";

                if (!t2) {
                  _context28.next = 9;
                  break;
                }

                e2 = "".concat(U, "/").concat(t2, "/badges").concat(_this31.apiSignInUrl);
                i = "There was a problem with fetching the badges";
                _context28.next = 6;
                return _this31.fetchWithoutAuth(e2, i);

              case 6:
                _context28.t0 = _context28.sent.data;
                _context28.next = 12;
                break;

              case 9:
                _context28.next = 11;
                return _this31.fetchWithAuth(e2, i);

              case 11:
                _context28.t0 = _context28.sent.data;

              case 12:
                return _context28.abrupt("return", _context28.t0);

              case 13:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      return function (_x42) {
        return _ref42.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this31), "updateProfile",
    /*#__PURE__*/
    function () {
      var _ref43 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                e2 = U + _this31.apiSignInUrl;
                i = "There was a problem updating the own profile";
                a = "PATCH";
                _context29.next = 5;
                return _this31.fetchWithAuth(e2, i, a, t2);

              case 5:
                r2 = _context29.sent;
                return _context29.abrupt("return", _this31.profileRemapper.fullProfileFromResponse(r2.data));

              case 7:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      return function (_x43) {
        return _ref43.apply(this, arguments);
      };
    }());

    _this31.lang = t2.lang, _this31.profileRemapper = new Qe(), _this31.followingRemapper = new Ye(), _this31.followersRemapper = new Ze();
    return _this31;
  }

  return Ot;
}(_);

var D = function (r2) {
  return r2.NATIVE = "native", r2.ENETPULSE = "enetpulse", r2.SPORTRADAR = "sportradar", r2.SPORTAL_365 = "sportal365", r2.API_FOOTBALL = "api_football", r2;
}(D || {});

var ti = {
  player: "players",
  team: "teams",
  homeTeam: "teams",
  awayTeam: "teams",
  country: "countries",
  competition: "competitions",
  match: "matches"
},
    ei =
/*#__PURE__*/
function (_ref44) {
  _inherits3(ei, _ref44);

  function ei(t2) {
    var _this32;

    _classCallCheck3(this, ei);

    _this32 = _possibleConstructorReturn3(this, _getPrototypeOf4(ei).call(this, t2, R(t2.environment, "idMapping")));

    __publicField(_assertThisInitialized3(_this32), "getEntityById",
    /*#__PURE__*/
    function () {
      var _ref45 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30(t2, e2) {
        var i, a;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                i = "/football".concat(_this32.apiSignInUrl, "&input_provider=").concat(_this32.idSchema, "&").concat(ti[t2], "=").concat(e2), a = "There was a problem with id mapping request for the following id: ".concat(e2);
                _context30.next = 3;
                return _this32.fetchWithoutAuth(i, a);

              case 3:
                return _context30.abrupt("return", _context30.sent);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      return function (_x44, _x45) {
        return _ref45.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this32), "getEntityByIdAndSchema",
    /*#__PURE__*/
    function () {
      var _ref46 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31(t2, e2, i) {
        var a, r2;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                a = "/football".concat(_this32.apiSignInUrl, "&input_provider=").concat(i, "&").concat(ti[t2], "=").concat(e2), r2 = "There was a problem with id mapping request for the following id: ".concat(e2);
                _context31.next = 3;
                return _this32.fetchWithoutAuth(a, r2);

              case 3:
                return _context31.abrupt("return", _context31.sent);

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      return function (_x46, _x47, _x48) {
        return _ref46.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this32), "getEntityIdsByIdsAndSchema",
    /*#__PURE__*/
    function () {
      var _ref47 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32(t2, e2, i) {
        var a, r2;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                a = "/football".concat(_this32.apiSignInUrl, "&input_provider=").concat(i, "&").concat(ti[t2], "=").concat(e2.join(",")), r2 = "There was a problem with id mapping request for the following ids: ".concat(e2.join(","));
                _context32.next = 3;
                return _this32.fetchWithoutAuth(a, r2);

              case 3:
                return _context32.abrupt("return", _context32.sent);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      return function (_x49, _x50, _x51) {
        return _ref47.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this32), "getEntitiesByIds",
    /*#__PURE__*/
    function () {
      var _ref48 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33(t2, e2, i) {
        var a, r2, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, s, p2, n2, l2;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                e2.sort(function (s, p2) {
                  return s.localeCompare(p2);
                });
                a = Oo(e2), r2 = [];
                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context33.prev = 5;
                _iterator10 = a[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context33.next = 18;
                  break;
                }

                s = _step10.value;
                p2 = "/football".concat(_this32.apiSignInUrl, "&input_provider=").concat(i, "&").concat(ti[t2], "=").concat(s.join(","));
                n2 = "There was a problem with id mapping request for the following ids :".concat(s.join(","));
                _context33.next = 13;
                return _this32.fetchWithoutAuth(p2, n2);

              case 13:
                l2 = _context33.sent;
                r2 = [].concat(_toConsumableArray3(r2), _toConsumableArray3(l2.data));

              case 15:
                _iteratorNormalCompletion10 = true;
                _context33.next = 7;
                break;

              case 18:
                _context33.next = 24;
                break;

              case 20:
                _context33.prev = 20;
                _context33.t0 = _context33["catch"](5);
                _didIteratorError10 = true;
                _iteratorError10 = _context33.t0;

              case 24:
                _context33.prev = 24;
                _context33.prev = 25;

                if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                  _iterator10.return();
                }

              case 27:
                _context33.prev = 27;

                if (!_didIteratorError10) {
                  _context33.next = 30;
                  break;
                }

                throw _iteratorError10;

              case 30:
                return _context33.finish(27);

              case 31:
                return _context33.finish(24);

              case 32:
                return _context33.abrupt("return", r2);

              case 33:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, null, [[5, 20, 24, 32], [25,, 27, 31]]);
      }));

      return function (_x52, _x53, _x54) {
        return _ref48.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this32), "getEntitiesByIdObjs",
    /*#__PURE__*/
    function () {
      var _ref49 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34(t2, e2) {
        var i, a, r2, s, p2, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _loop7, _iterator11, _step11;

        return _regeneratorRuntime.wrap(function _callee34$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                i = [], a = {}, r2 = [];
                Object.keys(t2).forEach(function (l2) {
                  i.push.apply(i, t2[l2]);
                });
                s = Pt(i), p2 = Oo(s);
                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context35.prev = 6;
                _loop7 =
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _loop7() {
                  var l2, c2, d2, m2, y2;
                  return _regeneratorRuntime.wrap(function _loop7$(_context34) {
                    while (1) {
                      switch (_context34.prev = _context34.next) {
                        case 0:
                          l2 = _step11.value;
                          c2 = "";

                          if (!(Object.keys(t2).forEach(function (d2) {
                            a[d2] = [];
                            var m2 = l2.filter(function (y2) {
                              return t2[d2].includes(y2);
                            });
                            m2 && m2.length > 0 && (a[d2] = m2);
                          }), Object.keys(a).forEach(function (d2) {
                            a[d2].length > 0 && (a[d2].sort(function (m2, y2) {
                              return m2.localeCompare(y2);
                            }), c2 += "&", c2 += "".concat(ti[d2], "=").concat(a[d2].join(",")));
                          }), c2 && c2.length > 0)) {
                            _context34.next = 11;
                            break;
                          }

                          d2 = "/football".concat(_this32.apiSignInUrl, "&input_provider=").concat(e2 || "native").concat(c2);
                          m2 = "There was a problem with id mapping request";
                          _context34.next = 7;
                          return _this32.fetchWithoutAuth(d2, m2);

                        case 7:
                          y2 = _context34.sent;
                          r2.push(y2.data);
                          _context34.next = 12;
                          break;

                        case 11:
                          r2.push([]);

                        case 12:
                        case "end":
                          return _context34.stop();
                      }
                    }
                  }, _loop7);
                });
                _iterator11 = p2[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                  _context35.next = 14;
                  break;
                }

                return _context35.delegateYield(_loop7(), "t0", 11);

              case 11:
                _iteratorNormalCompletion11 = true;
                _context35.next = 9;
                break;

              case 14:
                _context35.next = 20;
                break;

              case 16:
                _context35.prev = 16;
                _context35.t1 = _context35["catch"](6);
                _didIteratorError11 = true;
                _iteratorError11 = _context35.t1;

              case 20:
                _context35.prev = 20;
                _context35.prev = 21;

                if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                  _iterator11.return();
                }

              case 23:
                _context35.prev = 23;

                if (!_didIteratorError11) {
                  _context35.next = 26;
                  break;
                }

                throw _iteratorError11;

              case 26:
                return _context35.finish(23);

              case 27:
                return _context35.finish(20);

              case 28:
                return _context35.abrupt("return", Array.prototype.concat.apply([], r2));

              case 29:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee34, null, [[6, 16, 20, 28], [21,, 23, 27]]);
      }));

      return function (_x55, _x56) {
        return _ref49.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this32), "getTopEntities",
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee35() {
      var t2, e2;
      return _regeneratorRuntime.wrap(function _callee35$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              t2 = "/football/top".concat(_this32.apiSignInUrl), e2 = "There was a problem with top id mappings request";
              _context36.next = 3;
              return _this32.fetchWithoutAuth(t2, e2);

            case 3:
              return _context36.abrupt("return", _context36.sent.data);

            case 4:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee35);
    })));

    return _this32;
  }

  return ei;
}(_);

var as = "FansUnited",
    Uo = {
  football: {
    ids: [],
    countries: [],
    competitions: [],
    expirations: {
      ids: 0
    }
  },
  profile: {
    info: {},
    statistics: {},
    badges: null,
    countries: [],
    expirations: {
      profile: 0,
      statistics: 0,
      badges: 0
    }
  },
  client: {
    features: {},
    expirations: {
      features: 0
    }
  }
},
    ii = function ii(t2) {
  var _this33 = this;

  _classCallCheck3(this, ii);

  __publicField(this, "idSchema", "");

  __publicField(this, "expirationProfileTimeout", 600);

  __publicField(this, "expirationBadgesTimeout", 3600);

  __publicField(this, "expirationClientFeaturesTimeout", 14400);

  __publicField(this, "expirationFootballIdsTimeout", 604800);

  __publicField(this, "clearData", function () {
    _this33.setData(Uo);
  });

  __publicField(this, "getEntityById", function () {
    var t2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var e2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return _this33.getData().football.ids.find(function (i) {
      var a = C[_this33.idSchema];
      return i && "".concat(i[a]) === e2 && i.resource === t2;
    });
  });

  __publicField(this, "getEntity", function (t2, e2, i) {
    return Array.isArray(t2) ? _this33.getData().football.ids.filter(function (a) {
      var r2 = C[i];
      return a && t2.includes("".concat(a[r2])) && a.resource === e2;
    }) : _this33.getData().football.ids.find(function (a) {
      var r2 = C[i];
      return a && "".concat(a[r2]) === t2 && a.resource === e2;
    });
  });

  __publicField(this, "getEntityByNativeId", function () {
    var t2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var e2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return _this33.getData().football.ids.find(function (i) {
      return i && "".concat(i.id) === e2 && i.resource === t2;
    });
  });

  __publicField(this, "checkForExistingIdObjs", function (t2, e2) {
    var i = C[e2],
        a = {};
    return Object.keys(t2).forEach(function (r2) {
      var s = t2[r2],
          n2 = _this33.getEntity(s, r2, e2).map(function (c2) {
        return c2[i];
      }),
          l2 = t2[r2].filter(function (c2) {
        return !n2.includes(c2);
      });

      a[r2] = s.map(function (c2) {
        return l2.includes(c2) ? {
          id: c2,
          exists: false
        } : {
          id: c2,
          exists: true
        };
      });
    }), a;
  });

  __publicField(this, "getIdsByType", function (t2, e2, i) {
    var a = C[i],
        r2 = C[e2],
        s = {};
    return Object.keys(t2).forEach(function (p2) {
      var n2 = t2[p2],
          l2 = [];
      _this33.getData().football.ids.forEach(function (c2) {
        n2.forEach(function (d2, m2) {
          d2 === c2[r2] && p2 === c2.resource && (l2[m2] = c2[a]);
        });
      }), s[p2] = l2;
    }), s;
  });

  __publicField(this, "addIdMapping", function (t2) {
    var e2 = _this33.getData();

    e2.football.ids.push(t2), _this33.setData(e2);
  });

  __publicField(this, "addIdMappings", function (t2) {
    var e2 = _this33.getData(),
        i = e2.football.ids;

    i = [].concat(_toConsumableArray3(i), _toConsumableArray3(t2)), e2.football.ids = i, _this33.setData(e2);
  });

  __publicField(this, "addTopIdMappings", function (t2) {
    var e2 = _this33.getData();

    if (e2.football.ids.length) {
      var _i15 = JSON.parse(JSON.stringify(e2.football.ids));

      _i15 = _i15.filter(function (a) {
        return a.resource !== "match";
      }), t2 = t2.filter(function (a) {
        return a.resource === "match";
      }), _i15 = [].concat(_toConsumableArray3(_i15), _toConsumableArray3(t2)), e2.football.ids = _i15;
    } else e2.football.ids = t2;

    e2.football.expirations.ids = Math.floor(Date.now() / 1e3) + _this33.expirationFootballIdsTimeout, _this33.setData(e2);
  });

  __publicField(this, "setOwnProfile", function (t2) {
    var e2 = _this33.getData();

    e2.profile.info = t2, e2.profile.expirations.profile = Math.floor(Date.now() / 1e3) + _this33.expirationProfileTimeout, _this33.setData(e2);
  });

  __publicField(this, "getOwnProfile", function () {
    return _this33.getData().profile.info;
  });

  __publicField(this, "getProfileCountries", function () {
    return _this33.getData().profile.countries;
  });

  __publicField(this, "setProfileCountries", function (t2) {
    var e2 = _this33.getData();

    e2.profile.countries = t2, _this33.setData(e2);
  });

  __publicField(this, "getProfileStats", function () {
    return _this33.getData().profile.statistics;
  });

  __publicField(this, "setProfileStats", function (t2) {
    var e2 = _this33.getData();

    e2.profile.statistics = t2, e2.profile.expirations.statistics = Math.floor(Date.now() / 1e3) + _this33.expirationProfileTimeout, _this33.setData(e2);
  });

  __publicField(this, "getProfileBadges", function () {
    return _this33.getData().profile.badges;
  });

  __publicField(this, "setProfileBadges", function (t2) {
    var e2 = _this33.getData();

    e2.profile.badges = t2, e2.profile.expirations.badges = Math.floor(Date.now() / 1e3) + _this33.expirationBadgesTimeout, _this33.setData(e2);
  });

  __publicField(this, "getFootballCountries", function () {
    return _this33.getData().football.countries;
  });

  __publicField(this, "setFootballCountries", function (t2) {
    var e2 = _this33.getData();

    e2.football.countries = t2, _this33.setData(e2);
  });

  __publicField(this, "getCompetitions", function (t2) {
    var e2 = _this33.getData();

    return t2 ? t2.competitionSearchFilter(e2.football.competitions) : e2.football.competitions;
  });

  __publicField(this, "setCompetitions", function (t2) {
    var e2 = _this33.getData(),
        i = _toConsumableArray3(e2.football.competitions);

    i.push.apply(i, _toConsumableArray3(t2)), e2.football.competitions = _this33.makeCompetitionsUnique(i), _this33.setData(e2);
  });

  __publicField(this, "getCompetitionsLength", function () {
    var _this33$getData = _this33.getData(),
        t2 = _this33$getData.football;

    return t2.competitions.length;
  });

  __publicField(this, "getClientFeatures", function () {
    return _this33.getData().client.features;
  });

  __publicField(this, "setClientFeatures", function (t2) {
    var e2 = _this33.getData(),
        i = JSON.parse(JSON.stringify(t2));

    e2.client.expirations.features = Math.floor(Date.now() / 1e3) + _this33.expirationClientFeaturesTimeout, e2.client.features = i, _this33.setData(e2);
  });

  __publicField(this, "deleteClientFeatures", function () {
    var t2 = _this33.getData(),
        e2 = JSON.parse(JSON.stringify(t2));

    e2.client = {
      features: {},
      expirations: {
        features: 0
      }
    }, _this33.setData(e2);
  });

  __publicField(this, "getExpiration", function (t2, e2) {
    _this33.initialNewSchema(t2, "expirations");

    var i = _this33.getData();

    switch (e2) {
      case "profile":
        return i.profile.expirations.profile;

      case "statistics":
        return i.profile.expirations.statistics;

      case "badges":
        return i.profile.expirations.badges;

      case "features":
        return i.client.expirations.features;

      case "ids":
        return i.football.expirations.ids;
    }
  });

  __publicField(this, "makeCompetitionsUnique", function (t2) {
    var e2 =
    /* @__PURE__ */
    new Set();
    return t2.filter(function (i) {
      var a = !e2.has(i.id);
      return e2.add(i.id), a;
    });
  });

  __publicField(this, "getData", function () {
    return JSON.parse(localStorage.getItem(as));
  });

  __publicField(this, "setData", function (t2) {
    localStorage.setItem(as, JSON.stringify(t2));
  });

  __publicField(this, "initialNewSchema", function (t2, e2) {
    var i = _this33.getData();

    (!i || !i[t2] || !i[t2][e2]) && _this33.setData(Uo);
  });

  this.idSchema = t2, (this.getData() === void 0 || this.getData() === null) && this.setData(Uo);
};

var Ps = Ds(Is());

var M =
/*#__PURE__*/
function () {
  function M(t2) {
    var _this34 = this;

    _classCallCheck3(this, M);

    __publicField(this, "profileTTL", 600);

    __publicField(this, "clientTTL", 14400);

    __publicField(this, "profileBadgesTTL", 3600);

    __publicField(this, "idMappingsExpiration", 0);

    __publicField(this, "idSchema", "");

    __publicField(this, "clearData", function () {
      return M.nodeCache.flushAll();
    });

    __publicField(this, "getEntityById", function (t2, e2) {
      var i = M.nodeCache.get("ids");
      return i ? i.find(function (a) {
        var r2 = C[_this34.idSchema];
        return a && "".concat(a[r2]) === e2 && a.resource === t2;
      }) : null;
    });

    __publicField(this, "getEntity", function (t2, e2, i) {
      var a = M.nodeCache.get("ids");
      return a ? Array.isArray(t2) ? [] : null : Array.isArray(t2) ? a.filter(function (r2) {
        var s = C[i];
        return r2 && t2.includes("".concat(r2[s])) && r2.resource === e2;
      }) : a.find(function (r2) {
        var s = C[i];
        return r2 && "".concat(r2[s]) === t2 && r2.resource === e2;
      });
    });

    __publicField(this, "checkForExistingIdObjs", function (t2, e2) {
      var i = C[e2],
          a = {};
      return Object.keys(t2).forEach(function (r2) {
        var s = t2[r2],
            n2 = _this34.getEntity(s, r2, e2).map(function (c2) {
          return c2[i];
        }),
            l2 = t2[r2].filter(function (c2) {
          return !n2.includes(c2);
        });

        a[r2] = s.map(function (c2) {
          return l2.includes(c2) ? {
            id: c2,
            exists: false
          } : {
            id: c2,
            exists: true
          };
        });
      }), a;
    });

    __publicField(this, "getIdsByType", function (t2, e2, i) {
      var a = C[i],
          r2 = C[e2],
          s = M.nodeCache.get("ids"),
          p2 = {};
      return s ? (Object.keys(t2).forEach(function (n2) {
        var l2 = t2[n2],
            c2 = [];
        s.forEach(function (d2) {
          l2.forEach(function (m2, y2) {
            m2 === d2[r2] && n2 === d2.resource && (c2[y2] = d2[a]);
          });
        }), p2[n2] = c2;
      }), p2) : null;
    });

    __publicField(this, "addIdMapping", function (t2) {
      var e2 = M.nodeCache.get("ids");
      e2.push(t2), M.nodeCache.set("ids", e2);
    });

    __publicField(this, "addIdMappings", function (t2) {
      var e2 = M.nodeCache.get("ids");
      e2 = [].concat(_toConsumableArray3(e2), _toConsumableArray3(t2)), M.nodeCache.set("ids", e2);
    });

    __publicField(this, "addTopIdMappings", function (t2) {
      var e2 = M.nodeCache.get("ids"),
          i = 604800;

      if (e2) {
        var a = JSON.parse(JSON.stringify(e2));
        a = a.filter(function (r2) {
          return r2.resource !== "match";
        }), t2 = t2.filter(function (r2) {
          return r2.resource === "match";
        }), a = [].concat(_toConsumableArray3(a), _toConsumableArray3(t2)), M.nodeCache.set("ids", a);
      } else M.nodeCache.set("ids", t2);

      _this34.idMappingsExpiration = Math.floor(Date.now() / 1e3) + i;
    });

    __publicField(this, "setOwnProfile", function (t2) {
      return M.nodeCache.set("profile", t2, _this34.profileTTL);
    });

    __publicField(this, "getOwnProfile", function () {
      return M.nodeCache.get("profile");
    });

    __publicField(this, "getProfileCountries", function () {
      return M.nodeCache.get("profile_countries");
    });

    __publicField(this, "setProfileCountries", function (t2) {
      return M.nodeCache.set("profile_countries", t2);
    });

    __publicField(this, "getProfileStats", function () {
      return M.nodeCache.get("profile_stats");
    });

    __publicField(this, "setProfileStats", function (t2) {
      return M.nodeCache.set("profile_stats", t2, _this34.profileTTL);
    });

    __publicField(this, "getProfileBadges", function () {
      return M.nodeCache.get("profile_badges");
    });

    __publicField(this, "setProfileBadges", function (t2) {
      M.nodeCache.set("profile_badges", t2, _this34.profileBadgesTTL);
    });

    __publicField(this, "getFootballCountries", function () {
      return M.nodeCache.get("football_countries");
    });

    __publicField(this, "setFootballCountries", function (t2) {
      return M.nodeCache.set("football_countries", t2);
    });

    __publicField(this, "getCompetitions", function (t2) {
      var e2 = M.nodeCache.get("football_competitions");
      return e2 ? t2 ? t2.competitionSearchFilter(e2) : e2 : null;
    });

    __publicField(this, "setCompetitions", function (t2) {
      return M.nodeCache.set("football_competitions", t2);
    });

    __publicField(this, "getCompetitionsLength", function () {
      var t2 = M.nodeCache.get("football_competitions");
      return t2 ? t2.length : 0;
    });

    __publicField(this, "getClientFeatures", function () {
      return M.nodeCache.get("client");
    });

    __publicField(this, "setClientFeatures", function (t2) {
      return M.nodeCache.set("client", t2, _this34.clientTTL);
    });

    __publicField(this, "deleteClientFeatures", function () {
      return M.nodeCache.del("client");
    });

    __publicField(this, "getExpiration", function (t2, e2) {
      var i = _this34.getKeyFromExpirationType(e2);

      return i === "ids" ? _this34.idMappingsExpiration : M.nodeCache.getTtl(i);
    });

    __publicField(this, "getKeyFromExpirationType", function (t2) {
      switch (t2) {
        case "profile":
          return "profile";

        case "statistics":
          return "profile_stats";

        case "badges":
          return "profile_badges";

        case "features":
          return "client";

        case "ids":
          return "ids";
      }
    });
  }

  _createClass3(M, null, [{
    key: "getInstance",
    value: function getInstance(t2) {
      return M.instance || (M.instance = new M(t2), M.nodeCache.options.useClones = false), M.instance;
    }
  }]);

  return M;
}(),
    Dt = M;

Lo(Dt, "instance"), Lo(Dt, "nodeCache", new Ps.default());

var V = function V() {
  _classCallCheck3(this, V);

  __publicField(this, "createLocalCacheInstance", function (t2) {
    return typeof window > "u" ? Dt.getInstance(t2) : new ii(t2);
  });
};

var ai = function ai(t2) {
  var _this35 = this;

  _classCallCheck3(this, ai);

  __publicField(this, "localCache", null);

  __publicField(this, "https", null);

  __publicField(this, "getEntitiesByIds",
  /*#__PURE__*/
  function () {
    var _ref51 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee36(t2, e2, i) {
      var a, r2, s;
      return _regeneratorRuntime.wrap(function _callee36$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return _this35.setTopIdMappings();

            case 2:
              _context37.prev = 2;
              a = _this35.localCache.checkForExistingIdObjs(t2, e2);
              r2 = _this35.splitForRequestAndExisting(a);
              _context37.next = 7;
              return _this35.https.getEntitiesByIdObjs(r2.request, e2);

            case 7:
              s = _context37.sent;
              return _context37.abrupt("return", (_this35.localCache.addIdMappings(s), _this35.localCache.getIdsByType(t2, e2, i)));

            case 11:
              _context37.prev = 11;
              _context37.t0 = _context37["catch"](2);
              return _context37.abrupt("return", (console.warn("There was a problem retrieving the entity ids ", _context37.t0), Promise.resolve([])));

            case 14:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee36, null, [[2, 11]]);
    }));

    return function (_x57, _x58, _x59) {
      return _ref51.apply(this, arguments);
    };
  }());

  __publicField(this, "getEntityById",
  /*#__PURE__*/
  function () {
    var _ref52 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee37(t2, e2, i) {
      var a, r2;
      return _regeneratorRuntime.wrap(function _callee37$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              a = _this35.localCache.getEntity(t2, e2, i);

              if (!a) {
                _context38.next = 3;
                break;
              }

              return _context38.abrupt("return", a);

            case 3:
              _context38.next = 5;
              return _this35.requestEntity(t2, e2, i);

            case 5:
              r2 = _context38.sent;
              return _context38.abrupt("return", (_this35.localCache.addIdMappings(r2), r2));

            case 7:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee37);
    }));

    return function (_x60, _x61, _x62) {
      return _ref52.apply(this, arguments);
    };
  }());

  __publicField(this, "splitForRequestAndExisting", function (t2) {
    var e2 = {},
        i = {};
    return Object.keys(t2).forEach(function (a) {
      e2[a] = t2[a].filter(function (r2) {
        return !r2.exists;
      }).map(function (r2) {
        return r2.id;
      }), i[a] = t2[a].filter(function (r2) {
        return r2.exists;
      }).map(function (r2) {
        return r2.id;
      });
    }), {
      existing: i,
      request: e2
    };
  });

  __publicField(this, "requestEntity",
  /*#__PURE__*/
  function () {
    var _ref53 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee38(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee38$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;
              t2 = Array.isArray(t2) ? t2 : [t2];
              _context39.next = 4;
              return _this35.https.getEntitiesByIds(e2, t2, i);

            case 4:
              return _context39.abrupt("return", _context39.sent);

            case 7:
              _context39.prev = 7;
              _context39.t0 = _context39["catch"](0);
              return _context39.abrupt("return", (console.warn("There was a problem retrieving the requested entity: ".concat(_context39.t0)), null));

            case 10:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee38, null, [[0, 7]]);
    }));

    return function (_x63, _x64, _x65) {
      return _ref53.apply(this, arguments);
    };
  }());

  __publicField(this, "setTopIdMappings",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee39() {
    var t2, i;
    return _regeneratorRuntime.wrap(function _callee39$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            t2 = Math.floor(Date.now() / 1e3);

            if (!(_this35.localCache.getExpiration("football", "ids") > t2)) {
              _context40.next = 3;
              break;
            }

            return _context40.abrupt("return", Promise.resolve());

          case 3:
            _context40.next = 5;
            return _this35.https.getTopEntities();

          case 5:
            i = _context40.sent;

            _this35.localCache.addTopIdMappings(i);

          case 7:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee39);
  })));

  this.localCache = new V().createLocalCacheInstance(t2.idSchema), this.https = new ei(t2);
};

var Fo = function Fo(o) {
  switch (o) {
    case "competitions":
      return "competition";

    case "players":
    case "relatedPlayer":
    case "squad":
      return "player";

    case "teams":
    case "participants":
    case "homeTeam":
    case "awayTeam":
    case "timeline":
    case "teamId":
      return "team";

    default:
      return o;
  }
};

var ri = function ri() {
  var _this36 = this;

  _classCallCheck3(this, ri);

  __publicField(this, "extractedObjIds", {});

  __publicField(this, "traverse", function (t2, e2) {
    return e2 = Fo(e2), Array.isArray(t2) ? _this36.traverseArrExtract(t2, e2) : t2 && typeof t2 == "object" && _this36.traverseObjExtract(t2, e2), _this36.extractedObjIds;
  });

  __publicField(this, "traverseArrExtract", function (t2, e2) {
    t2 && t2.length > 0 && t2.forEach(function (i) {
      _this36.traverseObjExtract(i, e2);
    });
  });

  __publicField(this, "traverseObjExtract", function (t2, e2) {
    t2 && Object.keys(t2).length > 0 && Object.keys(t2).forEach(function (i) {
      var a = t2[i];
      i === "id" || i === "teamId" ? (_this36.extractedObjIds.hasOwnProperty(e2) || (_this36.extractedObjIds[e2] = []), a && _this36.extractedObjIds[e2].push(a)) : t2[i] && _this36.traverse(t2[i], i);
    });
  });
};

var oi = function oi() {
  var _this37 = this;

  _classCallCheck3(this, oi);

  __publicField(this, "replaceObjIdsIndex", null);

  __publicField(this, "remappedIdsObj", {});

  __publicField(this, "traverse", function (t2, e2, i) {
    return e2 = Fo(e2), _this37.replaceObjIdsIndex === null && (_this37.initReplaceObjIdsIndex(i), _this37.remappedIdsObj = i), Array.isArray(t2) ? _this37.traverseArrReplace(t2, e2) : t2 && typeof t2 == "object" && _this37.traverseObjReplace(t2, e2), t2;
  });

  __publicField(this, "initReplaceObjIdsIndex", function (t2) {
    _this37.replaceObjIdsIndex = {}, Object.keys(t2).forEach(function (e2) {
      _this37.replaceObjIdsIndex[e2] = 0;
    });
  });

  __publicField(this, "traverseArrReplace", function (t2, e2) {
    t2 && t2.length > 0 && t2.forEach(function (i) {
      _this37.traverseObjReplace(i, e2);
    });
  });

  __publicField(this, "traverseObjReplace", function (t2, e2) {
    t2 && Object.keys(t2).length > 0 && Object.keys(t2).forEach(function (i) {
      i === "id" || i === "teamId" ? t2[i] && (t2[i] = _this37.remappedIdsObj[e2][_this37.replaceObjIdsIndex[e2]], _this37.replaceObjIdsIndex[e2] = _this37.replaceObjIdsIndex[e2] + 1) : t2[i] && _this37.traverse(t2[i], i, _this37.remappedIdsObj);
    });
  });
};

var F = function F(t2) {
  var _this38 = this;

  _classCallCheck3(this, F);

  __publicField(this, "idSchema", "");

  __publicField(this, "idMappingFacade", null);

  __publicField(this, "getEntityIdBySchemaId", function (t2, e2) {
    return _this38.idMappingFacade.getEntityById(e2, t2, _this38.idSchema);
  });

  __publicField(this, "remapEntities",
  /*#__PURE__*/
  function () {
    var _ref55 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee40(t2, e2) {
      var i, r2;
      return _regeneratorRuntime.wrap(function _callee40$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              i = JSON.parse(JSON.stringify(t2));
              _context41.prev = 1;

              if (!(_this38.idSchema !== "native")) {
                _context41.next = 7;
                break;
              }

              r2 = new ri().traverse(i, e2);
              return _context41.abrupt("return", _this38.idMappingFacade.getEntitiesByIds(r2, "native", _this38.idSchema).then(function (s) {
                return new oi().traverse(i, e2, s);
              }));

            case 7:
              return _context41.abrupt("return", t2);

            case 8:
              _context41.next = 13;
              break;

            case 10:
              _context41.prev = 10;
              _context41.t0 = _context41["catch"](1);
              return _context41.abrupt("return", (console.warn("There was a problem remapping entity: ".concat(e2, " with inner entity "), _context41.t0), []));

            case 13:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee40, null, [[1, 10]]);
    }));

    return function (_x66, _x67) {
      return _ref55.apply(this, arguments);
    };
  }());

  __publicField(this, "getEntityIdsBySchemaId",
  /*#__PURE__*/
  function () {
    var _ref56 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee41(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee41$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              a = {};
              a[e2] = t2;

              if (!(_this38.idSchema !== "native")) {
                _context42.next = 8;
                break;
              }

              _context42.next = 5;
              return _this38.idMappingFacade.getEntitiesByIds(a, _this38.idSchema, i);

            case 5:
              _context42.t0 = _context42.sent;
              _context42.next = 9;
              break;

            case 8:
              _context42.t0 = a;

            case 9:
              return _context42.abrupt("return", _context42.t0);

            case 10:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee41);
    }));

    return function (_x68, _x69, _x70) {
      return _ref56.apply(this, arguments);
    };
  }());

  this.idSchema = t2.idSchema, this.idMappingFacade = new ai(t2);
};

var H = function H(t2) {
  _classCallCheck3(this, H);

  __publicField(this, "completed", false);

  __publicField(this, "percentage");

  this.percentage = t2;
};

var si = function si() {
  _classCallCheck3(this, si);

  __publicField(this, "teamFollowed", new H(10));

  __publicField(this, "teamFavourite", new H(15));

  __publicField(this, "playerFollowed", new H(10));

  __publicField(this, "playerFavourite", new H(10));

  __publicField(this, "competitionFollowed", new H(10));

  __publicField(this, "competitionFavourite", new H(5));

  __publicField(this, "addedBirthdate", new H(10));

  __publicField(this, "addedGender", new H(10));

  __publicField(this, "addedCountry", new H(10));

  __publicField(this, "addedAvatar", new H(10));
};

var ni = function ni() {
  _classCallCheck3(this, ni);

  __publicField(this, "totalPercentage");

  __publicField(this, "breakdown", new si());
};

var xe = function xe(t2) {
  var _this39 = this;

  _classCallCheck3(this, xe);

  __publicField(this, "limit", 0);

  __publicField(this, "startAfter", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this39.limit && (t2 = t2 + "&", t2 = t2 + "limit=".concat(_this39.limit)), _this39.startAfter && (t2 = t2 + "&", t2 = t2 + "start_after=".concat(_this39.startAfter)), t2;
  });

  this.limit = t2.limit ? t2.limit : 20, this.startAfter = t2.startAfter ? t2.startAfter : null;
};

var J = function J(t2, e2, i) {
  var _this40 = this;

  _classCallCheck3(this, J);

  __publicField(this, "localCache");

  __publicField(this, "profileHttps", null);

  __publicField(this, "activityHttps", null);

  __publicField(this, "getOwn",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee42() {
    var t2, _e3;

    return _regeneratorRuntime.wrap(function _callee42$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            t2 = _this40.getLocalStorageData("profile");

            if (!t2) {
              _context43.next = 3;
              break;
            }

            return _context43.abrupt("return", JSON.parse(JSON.stringify(t2)));

          case 3:
            _context43.prev = 3;
            _context43.next = 6;
            return _this40.profileHttps.getProfile();

          case 6:
            _e3 = _context43.sent;
            return _context43.abrupt("return", (_this40.localCache.setOwnProfile(_e3), _e3));

          case 10:
            _context43.prev = 10;
            _context43.t0 = _context43["catch"](3);
            throw console.warn("There was a problem retrieving your profile: ", _context43.t0), _context43.t0;

          case 13:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee42, null, [[3, 10]]);
  })));

  __publicField(this, "updateOwnProfile",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee43() {
    var _t;

    return _regeneratorRuntime.wrap(function _callee43$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.prev = 0;
            _context44.next = 3;
            return _this40.profileHttps.getProfile();

          case 3:
            _t = _context44.sent;
            return _context44.abrupt("return", (_this40.localCache.setOwnProfile(_t), _t));

          case 7:
            _context44.prev = 7;
            _context44.t0 = _context44["catch"](0);
            throw console.warn("There was a problem retrieving your profile: ", _context44.t0), _context44.t0;

          case 10:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee43, null, [[0, 7]]);
  })));

  __publicField(this, "getByIds",
  /*#__PURE__*/
  function () {
    var _ref59 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee44(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee44$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              if (!(t2 && t2.length > 0 && e2 || !t2 && t2.length === 0 && !e2)) {
                _context45.next = 2;
                break;
              }

              throw new u(400, "invalid_method_call", "The method 'getByIds' from Profile namespace is not called correctly. You need to provide 'profileIds' OR 'search' parameters to the method, but you can't use both of them or neither of them.");

            case 2:
              _context45.prev = 2;
              _context45.next = 5;
              return _this40.profileHttps.getProfiles(t2, e2, i);

            case 5:
              return _context45.abrupt("return", _context45.sent);

            case 8:
              _context45.prev = 8;
              _context45.t0 = _context45["catch"](2);
              throw console.warn("There was a problem retrieving the selected profiles: ".concat(t2.join(","), " "), _context45.t0), _context45.t0;

            case 11:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee44, null, [[2, 8]]);
    }));

    return function (_x71, _x72, _x73) {
      return _ref59.apply(this, arguments);
    };
  }());

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref60 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee45(t2) {
      return _regeneratorRuntime.wrap(function _callee45$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.prev = 0;
              _context46.next = 3;
              return _this40.profileHttps.getProfile(t2);

            case 3:
              return _context46.abrupt("return", _context46.sent);

            case 6:
              _context46.prev = 6;
              _context46.t0 = _context46["catch"](0);
              throw console.warn("There was a problem retrieving the selected profile: ".concat(t2, " "), _context46.t0), _context46.t0;

            case 9:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee45, null, [[0, 6]]);
    }));

    return function (_x74) {
      return _ref60.apply(this, arguments);
    };
  }());

  __publicField(this, "getCountries",
  /*#__PURE__*/
  function () {
    var _ref61 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee46(t2) {
      var e2, _i16;

      return _regeneratorRuntime.wrap(function _callee46$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              t2 = t2 || false;
              e2 = _this40.localCache.getProfileCountries();

              if (!(e2 && e2.length > 0)) {
                _context47.next = 4;
                break;
              }

              return _context47.abrupt("return", e2);

            case 4:
              _context47.prev = 4;
              _context47.next = 7;
              return _this40.profileHttps.getCountries(t2);

            case 7:
              _i16 = _context47.sent;
              return _context47.abrupt("return", (_this40.localCache.setProfileCountries(_i16), _i16));

            case 11:
              _context47.prev = 11;
              _context47.t0 = _context47["catch"](4);
              throw console.warn("There was a problem retrieving profile countries: ", _context47.t0), _context47.t0;

            case 14:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee46, null, [[4, 11]]);
    }));

    return function (_x75) {
      return _ref61.apply(this, arguments);
    };
  }());

  __publicField(this, "getFollowers",
  /*#__PURE__*/
  function () {
    var _ref62 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee47(t2, e2) {
      var _i17, a, r2, s;

      return _regeneratorRuntime.wrap(function _callee47$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              _context48.prev = 0;
              t2 && (t2 = new xe(t2));
              _context48.next = 4;
              return _this40.profileHttps.getFollowers(t2, e2);

            case 4:
              _i17 = _context48.sent;
              a = _i17.data.map(function (r2) {
                return r2.followerId;
              });

              if (!a.length) {
                _context48.next = 12;
                break;
              }

              _context48.next = 9;
              return _this40.getByIds(a);

            case 9:
              r2 = _context48.sent;
              s = _i17.data.map(function (p2) {
                return r2.forEach(function (n2) {
                  p2.followerId === n2.id && (p2.name = n2.name, p2.nickname = n2.nickname, p2.avatar = n2.avatar);
                }), p2;
              });
              return _context48.abrupt("return", (_i17.data = s, _i17));

            case 12:
              return _context48.abrupt("return", _i17);

            case 15:
              _context48.prev = 15;
              _context48.t0 = _context48["catch"](0);
              throw console.warn("There was a problem retrieving your followers: ", _context48.t0), _context48.t0;

            case 18:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee47, null, [[0, 15]]);
    }));

    return function (_x76, _x77) {
      return _ref62.apply(this, arguments);
    };
  }());

  __publicField(this, "getFollowing",
  /*#__PURE__*/
  function () {
    var _ref63 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee48(t2, e2) {
      var _i18, a, r2, s;

      return _regeneratorRuntime.wrap(function _callee48$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _context49.prev = 0;
              t2 && (t2 = new xe(t2));
              _context49.next = 4;
              return _this40.profileHttps.getFollowing(t2, e2);

            case 4:
              _i18 = _context49.sent;
              a = _i18.data.map(function (r2) {
                return r2.followingId;
              });

              if (!a.length) {
                _context49.next = 12;
                break;
              }

              _context49.next = 9;
              return _this40.getByIds(a);

            case 9:
              r2 = _context49.sent;
              s = _i18.data.map(function (p2) {
                return r2.forEach(function (n2) {
                  p2.followingId === n2.id && (p2.name = n2.name, p2.nickname = n2.nickname, p2.avatar = n2.avatar);
                }), p2;
              });
              return _context49.abrupt("return", (_i18.data = s, _i18));

            case 12:
              return _context49.abrupt("return", _i18);

            case 15:
              _context49.prev = 15;
              _context49.t0 = _context49["catch"](0);
              throw console.warn("There was a problem retrieving your following profiles: ", _context49.t0), _context49.t0;

            case 18:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee48, null, [[0, 15]]);
    }));

    return function (_x78, _x79) {
      return _ref63.apply(this, arguments);
    };
  }());

  __publicField(this, "follow",
  /*#__PURE__*/
  function () {
    var _ref64 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee49(t2) {
      return _regeneratorRuntime.wrap(function _callee49$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              _context50.prev = 0;
              _context50.next = 3;
              return _this40.profileHttps.follow(t2);

            case 3:
              return _context50.abrupt("return", _context50.sent);

            case 6:
              _context50.prev = 6;
              _context50.t0 = _context50["catch"](0);
              throw console.warn("There was a problem following profiles: ".concat(t2.join(","), " "), _context50.t0), _context50.t0;

            case 9:
            case "end":
              return _context50.stop();
          }
        }
      }, _callee49, null, [[0, 6]]);
    }));

    return function (_x80) {
      return _ref64.apply(this, arguments);
    };
  }());

  __publicField(this, "unfollow",
  /*#__PURE__*/
  function () {
    var _ref65 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee50(t2) {
      return _regeneratorRuntime.wrap(function _callee50$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              _context51.prev = 0;
              _context51.next = 3;
              return _this40.profileHttps.unfollow(t2);

            case 3:
              return _context51.abrupt("return", _context51.sent);

            case 6:
              _context51.prev = 6;
              _context51.t0 = _context51["catch"](0);
              throw console.warn("There was a problem unfollowing profiles: ".concat(t2.join(","), " "), _context51.t0), _context51.t0;

            case 9:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee50, null, [[0, 6]]);
    }));

    return function (_x81) {
      return _ref65.apply(this, arguments);
    };
  }());

  __publicField(this, "showFullnessProfile", function (t2) {
    var e2 = new ni(),
        i = 0;
    return t2.avatar && (e2.breakdown.addedAvatar.completed = true, i += e2.breakdown.addedAvatar.percentage), t2.birthDate && (e2.breakdown.addedBirthdate.completed = true, i += e2.breakdown.addedBirthdate.percentage), t2.country && (e2.breakdown.addedCountry.completed = true, i += e2.breakdown.addedCountry.percentage), t2.gender && (e2.breakdown.addedGender.completed = true, i += e2.breakdown.addedGender.percentage), t2.interests && t2.interests.length > 0 && (t2.interests.find(function (c2) {
      return c2.type === "team" && c2.favourite;
    }) && (e2.breakdown.teamFavourite.completed = true, i += e2.breakdown.teamFavourite.percentage), t2.interests.find(function (c2) {
      return c2.type === "team";
    }) && (e2.breakdown.teamFollowed.completed = true, i += e2.breakdown.teamFollowed.percentage), t2.interests.find(function (c2) {
      return c2.type === "player" && c2.favourite;
    }) && (e2.breakdown.playerFavourite.completed = true, i += e2.breakdown.playerFavourite.percentage), t2.interests.find(function (c2) {
      return c2.type === "player";
    }) && (e2.breakdown.playerFollowed.completed = true, i += e2.breakdown.playerFollowed.percentage), t2.interests.find(function (c2) {
      return c2.type === "competition" && c2.favourite;
    }) && (e2.breakdown.competitionFavourite.completed = true, i += e2.breakdown.competitionFavourite.percentage), t2.interests.find(function (c2) {
      return c2.type === "competition";
    }) && (e2.breakdown.competitionFollowed.completed = true, i += e2.breakdown.competitionFollowed.percentage)), e2.totalPercentage = i, e2;
  });

  __publicField(this, "getStats",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee51() {
    var t2, e2, i, a;
    return _regeneratorRuntime.wrap(function _callee51$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            t2 = ["predictionsMade", "predictions", "tiers", "badges"], e2 = _this40.getLocalStorageData("statistics"), i = e2 ? t2.every(function (a) {
              return Object.keys(e2).includes(a);
            }) : false;

            if (!(e2 && Object.keys(e2).length && i)) {
              _context52.next = 3;
              break;
            }

            return _context52.abrupt("return", JSON.parse(JSON.stringify(e2)));

          case 3:
            _context52.prev = 3;
            _context52.next = 6;
            return _this40.activityHttps.getStats();

          case 6:
            a = _context52.sent;
            return _context52.abrupt("return", (_this40.localCache.setProfileStats(a), a));

          case 10:
            _context52.prev = 10;
            _context52.t0 = _context52["catch"](3);
            throw console.warn("There was a problem retrieving own profile statistics: ", _context52.t0), _context52.t0;

          case 13:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee51, null, [[3, 10]]);
  })));

  __publicField(this, "getBadges",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee52() {
    var t2, _e4;

    return _regeneratorRuntime.wrap(function _callee52$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            t2 = _this40.getLocalStorageData("badges");

            if (!t2) {
              _context53.next = 3;
              break;
            }

            return _context53.abrupt("return", t2);

          case 3:
            _context53.prev = 3;
            _context53.next = 6;
            return _this40.profileHttps.getBadges();

          case 6:
            _e4 = _context53.sent;
            return _context53.abrupt("return", (_this40.localCache.setProfileBadges(_e4), _e4));

          case 10:
            _context53.prev = 10;
            _context53.t0 = _context53["catch"](3);
            throw console.warn("There was a problem retrieving own profile badges: ", _context53.t0), _context53.t0;

          case 13:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee52, null, [[3, 10]]);
  })));

  __publicField(this, "getLocalStorageData", function (t2) {
    var e2 = Math.floor(Date.now() / 1e3),
        i = _this40.localCache.getExpiration("profile", t2);

    switch (t2) {
      case "profile":
        if (i > e2) return _this40.localCache.getOwnProfile();

      case "statistics":
        if (i > e2) return _this40.localCache.getProfileStats();

      case "badges":
        if (i > e2) return _this40.localCache.getProfileBadges();

      default:
        return null;
    }
  });

  this.localCache = t2, this.profileHttps = e2, this.activityHttps = i;
};

var li = function li() {
  _classCallCheck3(this, li);

  __publicField(this, "id", null);

  __publicField(this, "name", null);

  __publicField(this, "assets", null);
};

var pi = function pi() {
  var _this41 = this;

  _classCallCheck3(this, pi);

  __publicField(this, "extractUpdatedProps", function (t2, e2) {
    var i = ["name", "nickname", "gender", "avatar"],
        a = {};
    return Object.keys(t2).forEach(function (r2) {
      if (i.includes(r2) && t2[r2] !== e2[r2]) a[r2] = e2[r2];else if (r2 === "birthDate") (e2[r2] === null || t2[r2] === null && e2[r2] || t2[r2] !== e2[r2]) && (a.birth_date = e2[r2]);else if (r2 === "country") e2[r2] === null ? a.country_id = e2[r2] : (t2[r2] === null && e2[r2] || t2[r2].id !== e2[r2].id) && (a.country_id = e2[r2].id);else if (r2 === "interests") {
        var s = t2[r2],
            p2 = e2[r2];
        p2.length && _this41.isNewInterest(s, p2) ? a[r2] = _this41.updateInterests(s, p2) : (!p2.length && s.length || s.length !== p2.length && !_this41.isNewInterest(s, p2)) && (a[r2] = p2);
      }
    }), a;
  });

  __publicField(this, "updateInterests", function (t2, e2) {
    if (t2.length === e2.length) {
      var _this41$extractSameAn = _this41.extractSameAndNewInterests(t2, e2),
          _this41$extractSameAn2 = _slicedToArray3(_this41$extractSameAn, 2),
          _i19 = _this41$extractSameAn2[0],
          a = _this41$extractSameAn2[1];

      return [].concat(_toConsumableArray3(a), _toConsumableArray3(_i19));
    } else return e2;
  });

  __publicField(this, "isNewInterest", function (t2, e2) {
    var i = false,
        _this41$extractSameAn3 = _this41.extractSameAndNewInterests(t2, e2),
        _this41$extractSameAn4 = _slicedToArray3(_this41$extractSameAn3, 1),
        a = _this41$extractSameAn4[0];

    return a.length && (i = true), i;
  });

  __publicField(this, "extractSameAndNewInterests", function (t2, e2) {
    var i = e2.filter(function (r2) {
      return t2.some(function (s) {
        return r2.id === s.id && r2.type === s.type && r2.source === s.source && r2.favourite === s.favourite;
      });
    });
    return [e2.filter(function (r2) {
      return !t2.some(function (s) {
        return r2.id === s.id && r2.type === s.type && r2.source === s.source && r2.favourite === s.favourite;
      });
    }), i];
  });

  __publicField(this, "isAvatarValidURL", function (t2) {
    try {
      return new URL(t2), true;
    } catch (_unused5) {
      return false;
    }
  });
};

var b$1 =
/*#__PURE__*/
function (_Error3) {
  _inherits3(b$1, _Error3);

  function b$1(t2, e2, i) {
    var _this42;

    _classCallCheck3(this, b$1);

    _this42 = _possibleConstructorReturn3(this, _getPrototypeOf4(b$1).call(this));

    __publicField(_assertThisInitialized3(_this42), "code", 0);

    __publicField(_assertThisInitialized3(_this42), "status", null);

    __publicField(_assertThisInitialized3(_this42), "message", null);

    __publicField(_assertThisInitialized3(_this42), "errorMessage", function () {
      return _this42.message;
    });

    _this42.code = t2, _this42.status = e2, _this42.message = i;
    return _this42;
  }

  return b$1;
}(_wrapNativeSuper(Error));

var ci = function ci(t2, e2, i, a, r2) {
  var _this43 = this;

  _classCallCheck3(this, ci);

  __publicField(this, "idsRemapper", null);

  __publicField(this, "profileHttps", null);

  __publicField(this, "profileService", null);

  __publicField(this, "localCache", null);

  __publicField(this, "profileFacade", null);

  __publicField(this, "ownProfile", null);

  __publicField(this, "modified", false);

  __publicField(this, "expireAt", 0);

  __publicField(this, "promises", []);

  __publicField(this, "isFetching", false);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "getOwnProfile",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee53() {
    var t2, _e5;

    return _regeneratorRuntime.wrap(function _callee53$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            if (!_this43.isFetching) {
              _context54.next = 6;
              break;
            }

            console.log("Another thread is fetching profile...");
            _context54.next = 4;
            return _this43.delay(100);

          case 4:
            _context54.next = 0;
            break;

          case 6:
            if (!(_this43.modified && _this43.ownProfile)) {
              _context54.next = 8;
              break;
            }

            return _context54.abrupt("return", (console.log("Timestamp is less than 10 minutes OR profile is modifying "), _this43.ownProfile));

          case 8:
            t2 = Math.floor(Date.now() / 1e3);

            if (!(!_this43.ownProfile || _this43.expireAt < t2)) {
              _context54.next = 22;
              break;
            }

            _this43.isFetching = true, _this43.expireAt = Math.floor(Date.now() / 1e3) + 600;
            _context54.prev = 11;
            _context54.next = 14;
            return _this43.profileFacade.getOwn();

          case 14:
            _e5 = _context54.sent;

            _this43.setOwnProfile(_e5);

            _context54.next = 21;
            break;

          case 18:
            _context54.prev = 18;
            _context54.t0 = _context54["catch"](11);
            throw _this43.isFetching = false, _context54.t0;

          case 21:
            return _context54.abrupt("return", (_this43.modified = false, _this43.isFetching = false, _this43.ownProfile));

          case 22:
            return _context54.abrupt("return", _this43.ownProfile);

          case 23:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee53, null, [[11, 18]]);
  })));

  __publicField(this, "delay", function (t2) {
    return new Promise(function (e2) {
      setTimeout(e2, t2);
    });
  });

  __publicField(this, "setOwnProfile", function (t2) {
    _this43.ownProfile = t2;
  });

  __publicField(this, "getInfo",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee54() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee54$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            _context55.next = 2;
            return _this43.getOwnProfile();

          case 2:
            t2 = _context55.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            return _context55.abrupt("return", (delete e2.interests, e2));

          case 5:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee54);
  })));

  __publicField(this, "showInterests",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee55() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee55$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _context56.next = 2;
            return _this43.getOwnProfile();

          case 2:
            t2 = _context56.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            _context56.next = 6;
            return _this43.idsRemapper.remapInterests(e2.interests);

          case 6:
            return _context56.abrupt("return", _context56.sent);

          case 7:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee55);
  })));

  __publicField(this, "showFullInterests",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee56() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee56$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            _context57.next = 2;
            return _this43.getOwnProfile();

          case 2:
            t2 = _context57.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            _context57.next = 6;
            return _this43.idsRemapper.showFullInterests(e2.interests);

          case 6:
            return _context57.abrupt("return", _context57.sent);

          case 7:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee56);
  })));

  __publicField(this, "getFollowers",
  /*#__PURE__*/
  function () {
    var _ref72 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee57(t2) {
      return _regeneratorRuntime.wrap(function _callee57$(_context58) {
        while (1) {
          switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return _this43.profileFacade.getFollowers(t2);

            case 2:
              return _context58.abrupt("return", _context58.sent);

            case 3:
            case "end":
              return _context58.stop();
          }
        }
      }, _callee57);
    }));

    return function (_x82) {
      return _ref72.apply(this, arguments);
    };
  }());

  __publicField(this, "getFollowing",
  /*#__PURE__*/
  function () {
    var _ref73 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee58(t2) {
      return _regeneratorRuntime.wrap(function _callee58$(_context59) {
        while (1) {
          switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return _this43.profileFacade.getFollowing(t2);

            case 2:
              return _context59.abrupt("return", _context59.sent);

            case 3:
            case "end":
              return _context59.stop();
          }
        }
      }, _callee58);
    }));

    return function (_x83) {
      return _ref73.apply(this, arguments);
    };
  }());

  __publicField(this, "follow",
  /*#__PURE__*/
  function () {
    var _ref74 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee59(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee59$(_context60) {
        while (1) {
          switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return _this43.profileFacade.follow(t2);

            case 2:
              e2 = _context60.sent;
              _context60.next = 5;
              return _this43.profileFacade.updateOwnProfile();

            case 5:
              i = _context60.sent;
              return _context60.abrupt("return", (_this43.setOwnProfile(i), e2));

            case 7:
            case "end":
              return _context60.stop();
          }
        }
      }, _callee59);
    }));

    return function (_x84) {
      return _ref74.apply(this, arguments);
    };
  }());

  __publicField(this, "unfollow",
  /*#__PURE__*/
  function () {
    var _ref75 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee60(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee60$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 2;
              return _this43.profileFacade.unfollow(t2);

            case 2:
              e2 = _context61.sent;
              _context61.next = 5;
              return _this43.profileFacade.updateOwnProfile();

            case 5:
              i = _context61.sent;
              return _context61.abrupt("return", (_this43.setOwnProfile(i), e2));

            case 7:
            case "end":
              return _context61.stop();
          }
        }
      }, _callee60);
    }));

    return function (_x85) {
      return _ref75.apply(this, arguments);
    };
  }());

  __publicField(this, "getStats",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee61() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee61$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.next = 2;
            return _this43.profileFacade.getStats();

          case 2:
            t2 = _context62.sent;
            _context62.next = 5;
            return _this43.idsRemapper.remapProfileStats(t2);

          case 5:
            return _context62.abrupt("return", _context62.sent);

          case 6:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee61);
  })));

  __publicField(this, "getBadges",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee62() {
    return _regeneratorRuntime.wrap(function _callee62$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            _context63.next = 2;
            return _this43.profileFacade.getBadges();

          case 2:
            return _context63.abrupt("return", _context63.sent);

          case 3:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee62);
  })));

  __publicField(this, "addInterestPromise",
  /*#__PURE__*/
  function () {
    var _ref78 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee63(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee63$(_context64) {
        while (1) {
          switch (_context64.prev = _context64.next) {
            case 0:
              _this43.modified = true;
              e2 = _objectSpread3({}, t2);
              _context64.next = 4;
              return _this43.getOwnProfile();

            case 4:
              i = null;

              if (!(t2.source !== "custom")) {
                _context64.next = 11;
                break;
              }

              _context64.next = 8;
              return _this43.idsRemapper.remapInterestToNative(e2);

            case 8:
              i = _context64.sent;
              _context64.next = 12;
              break;

            case 11:
              i = e2;

            case 12:
              a = _this43.ownProfile.interests.filter(function (r2) {
                return r2.id !== i.id || r2.type !== i.type || r2.source !== i.source;
              });
              return _context64.abrupt("return", (_this43.ownProfile.interests = _toConsumableArray3(a), _this43.ownProfile.interests.push(i), _this43));

            case 14:
            case "end":
              return _context64.stop();
          }
        }
      }, _callee63);
    }));

    return function (_x86) {
      return _ref78.apply(this, arguments);
    };
  }());

  __publicField(this, "addInterest", function (t2) {
    return _this43.promises.push(_this43.addInterestPromise(t2)), _this43;
  });

  __publicField(this, "removeInterestPromise",
  /*#__PURE__*/
  function () {
    var _ref79 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee64(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee64$(_context65) {
        while (1) {
          switch (_context65.prev = _context65.next) {
            case 0:
              _this43.modified = true;
              e2 = _objectSpread3({}, t2);
              _context65.next = 4;
              return _this43.getOwnProfile();

            case 4:
              i = null;

              if (!(t2.source !== "custom")) {
                _context65.next = 11;
                break;
              }

              _context65.next = 8;
              return _this43.idsRemapper.remapInterestToNative(e2);

            case 8:
              i = _context65.sent;
              _context65.next = 12;
              break;

            case 11:
              i = e2;

            case 12:
              _this43.ownProfile.interests = _this43.ownProfile.interests.filter(function (a) {
                return a.id !== i.id || a.type !== i.type || a.source !== i.source;
              });
              return _context65.abrupt("return", _this43);

            case 14:
            case "end":
              return _context65.stop();
          }
        }
      }, _callee64);
    }));

    return function (_x87) {
      return _ref79.apply(this, arguments);
    };
  }());

  __publicField(this, "removeInterest", function (t2) {
    return _this43.promises.push(_this43.removeInterestPromise(t2)), _this43;
  });

  __publicField(this, "setBirthdatePromise",
  /*#__PURE__*/
  function () {
    var _ref80 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee65(t2) {
      return _regeneratorRuntime.wrap(function _callee65$(_context66) {
        while (1) {
          switch (_context66.prev = _context66.next) {
            case 0:
              _this43.modified = true;
              _context66.next = 3;
              return _this43.getOwnProfile();

            case 3:
              t2 ? _this43.ownProfile.birthDate = t2 : _this43.ownProfile.birthDate = null;
              return _context66.abrupt("return", _this43);

            case 5:
            case "end":
              return _context66.stop();
          }
        }
      }, _callee65);
    }));

    return function (_x88) {
      return _ref80.apply(this, arguments);
    };
  }());

  __publicField(this, "setBirthdate", function (t2) {
    return _this43.promises.push(_this43.setBirthdatePromise(t2)), _this43;
  });

  __publicField(this, "setGenderPromise",
  /*#__PURE__*/
  function () {
    var _ref81 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee66(t2) {
      return _regeneratorRuntime.wrap(function _callee66$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              _this43.modified = true;
              _context67.next = 3;
              return _this43.getOwnProfile();

            case 3:
              t2 === "male" || t2 === "female" ? _this43.ownProfile.gender = t2 : _this43.ownProfile.gender = "unspecified";
              return _context67.abrupt("return", _this43);

            case 5:
            case "end":
              return _context67.stop();
          }
        }
      }, _callee66);
    }));

    return function (_x89) {
      return _ref81.apply(this, arguments);
    };
  }());

  __publicField(this, "setGender", function (t2) {
    return _this43.promises.push(_this43.setGenderPromise(t2)), _this43;
  });

  __publicField(this, "setNicknamePromise",
  /*#__PURE__*/
  function () {
    var _ref82 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee67(t2) {
      return _regeneratorRuntime.wrap(function _callee67$(_context68) {
        while (1) {
          switch (_context68.prev = _context68.next) {
            case 0:
              _this43.modified = true;
              _context68.next = 3;
              return _this43.getOwnProfile();

            case 3:
              _this43.ownProfile.nickname = t2;
              return _context68.abrupt("return", _this43);

            case 5:
            case "end":
              return _context68.stop();
          }
        }
      }, _callee67);
    }));

    return function (_x90) {
      return _ref82.apply(this, arguments);
    };
  }());

  __publicField(this, "setNickname", function (t2) {
    return _this43.promises.push(_this43.setNicknamePromise(t2)), _this43;
  });

  __publicField(this, "setNamePromise",
  /*#__PURE__*/
  function () {
    var _ref83 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee68(t2) {
      return _regeneratorRuntime.wrap(function _callee68$(_context69) {
        while (1) {
          switch (_context69.prev = _context69.next) {
            case 0:
              _this43.modified = true;
              _context69.next = 3;
              return _this43.getOwnProfile();

            case 3:
              _this43.ownProfile.name = t2;
              return _context69.abrupt("return", _this43);

            case 5:
            case "end":
              return _context69.stop();
          }
        }
      }, _callee68);
    }));

    return function (_x91) {
      return _ref83.apply(this, arguments);
    };
  }());

  __publicField(this, "setName", function (t2) {
    return _this43.promises.push(_this43.setNamePromise(t2)), _this43;
  });

  __publicField(this, "setCountryPromise",
  /*#__PURE__*/
  function () {
    var _ref84 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee69(t2) {
      return _regeneratorRuntime.wrap(function _callee69$(_context70) {
        while (1) {
          switch (_context70.prev = _context70.next) {
            case 0:
              _this43.modified = true;
              _context70.next = 3;
              return _this43.getOwnProfile();

            case 3:
              t2 && !_this43.ownProfile.country ? (_this43.ownProfile.country = new li(), _this43.ownProfile.country.id = t2) : t2 && _this43.ownProfile.country ? _this43.ownProfile.country.id = t2 : _this43.ownProfile.country = null;
              return _context70.abrupt("return", _this43);

            case 5:
            case "end":
              return _context70.stop();
          }
        }
      }, _callee69);
    }));

    return function (_x92) {
      return _ref84.apply(this, arguments);
    };
  }());

  __publicField(this, "setCountry", function (t2) {
    return _this43.promises.push(_this43.setCountryPromise(t2)), _this43;
  });

  __publicField(this, "showFullnessProfile",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee70() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee70$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            _context71.next = 2;
            return _this43.getOwnProfile();

          case 2:
            t2 = _context71.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            return _context71.abrupt("return", _this43.profileFacade.showFullnessProfile(e2));

          case 5:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee70);
  })));

  __publicField(this, "setAvatarPromise",
  /*#__PURE__*/
  function () {
    var _ref86 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee71(t2) {
      return _regeneratorRuntime.wrap(function _callee71$(_context72) {
        while (1) {
          switch (_context72.prev = _context72.next) {
            case 0:
              _this43.modified = true;
              _context72.next = 3;
              return _this43.getOwnProfile();

            case 3:
              if (!_this43.profileService.isAvatarValidURL(t2)) {
                _context72.next = 7;
                break;
              }

              _this43.ownProfile.avatar = t2;
              _context72.next = 11;
              break;

            case 7:
              if (!(_this43.errorHandlingMode === "default")) {
                _context72.next = 9;
                break;
              }

              throw new b$1(400, "invalid_avatar", "Invalid URL syntax for avatar image.");

            case 9:
              if (!(_this43.errorHandlingMode === "standard")) {
                _context72.next = 11;
                break;
              }

              throw new u(400, "invalid_avatar", "Invalid URL syntax for avatar image.");

            case 11:
              return _context72.abrupt("return", _this43);

            case 12:
            case "end":
              return _context72.stop();
          }
        }
      }, _callee71);
    }));

    return function (_x93) {
      return _ref86.apply(this, arguments);
    };
  }());

  __publicField(this, "setAvatar", function (t2) {
    return _this43.promises.push(_this43.setAvatarPromise(t2)), _this43;
  });

  __publicField(this, "update",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee72() {
    var t2, e2, i, _r2, s, a;

    return _regeneratorRuntime.wrap(function _callee72$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            if (!(_this43.promises.length === 0)) {
              _context73.next = 2;
              break;
            }

            return _context73.abrupt("return", _this43.ownProfile);

          case 2:
            _context73.next = 4;
            return Promise.all(_this43.promises);

          case 4:
            _context73.next = 6;
            return _this43.profileFacade.getOwn();

          case 6:
            t2 = _context73.sent;
            _context73.next = 9;
            return _this43.getOwnProfile();

          case 9:
            e2 = _context73.sent;
            i = _this43.profileService.extractUpdatedProps(t2, e2);

            if (!(_this43.modified = false, _this43.expireAt = 0, Object.keys(i).length)) {
              _context73.next = 17;
              break;
            }

            _context73.next = 14;
            return _this43.profileHttps.updateProfile(i);

          case 14:
            _r2 = _context73.sent;
            s = JSON.parse(JSON.stringify(_r2));
            return _context73.abrupt("return", (_this43.setOwnProfile(s), _this43.localCache.setOwnProfile(s), delete _r2.interests, _r2));

          case 17:
            a = JSON.parse(JSON.stringify(_this43.ownProfile));
            return _context73.abrupt("return", (delete a.interests, a));

          case 19:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee72);
  })));

  this.idsRemapper = t2, this.localCache = e2, this.profileHttps = i, this.errorHandlingMode = r2, this.profileService = new pi(), this.profileFacade = new J(e2, i, a);
};

var di = function di(t2, e2, i, a) {
  var _this44 = this;

  _classCallCheck3(this, di);

  __publicField(this, "idsRemapper", null);

  __publicField(this, "profileHttps", null);

  __publicField(this, "activityHttps", null);

  __publicField(this, "profileFacade", null);

  __publicField(this, "profileId", "");

  __publicField(this, "setId", function (t2) {
    return _this44.profileId = t2, _this44;
  });

  __publicField(this, "getProfile",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee73() {
    return _regeneratorRuntime.wrap(function _callee73$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            _context74.next = 2;
            return _this44.profileFacade.getById(_this44.profileId);

          case 2:
            return _context74.abrupt("return", _context74.sent);

          case 3:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee73);
  })));

  __publicField(this, "getInfo",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee74() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee74$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            _context75.next = 2;
            return _this44.getProfile();

          case 2:
            t2 = _context75.sent;
            return _context75.abrupt("return", (delete t2.interests, t2));

          case 4:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee74);
  })));

  __publicField(this, "showInterests",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee75() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee75$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            _context76.next = 2;
            return _this44.getProfile();

          case 2:
            t2 = _context76.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            _context76.next = 6;
            return _this44.idsRemapper.remapInterests(e2.interests);

          case 6:
            return _context76.abrupt("return", _context76.sent);

          case 7:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee75);
  })));

  __publicField(this, "showFullInterests",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee76() {
    var t2, e2;
    return _regeneratorRuntime.wrap(function _callee76$(_context77) {
      while (1) {
        switch (_context77.prev = _context77.next) {
          case 0:
            _context77.next = 2;
            return _this44.getProfile();

          case 2:
            t2 = _context77.sent;
            e2 = JSON.parse(JSON.stringify(t2));
            _context77.next = 6;
            return _this44.idsRemapper.showFullInterests(e2.interests);

          case 6:
            return _context77.abrupt("return", _context77.sent);

          case 7:
          case "end":
            return _context77.stop();
        }
      }
    }, _callee76);
  })));

  __publicField(this, "getFollowers",
  /*#__PURE__*/
  function () {
    var _ref92 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee77(t2) {
      return _regeneratorRuntime.wrap(function _callee77$(_context78) {
        while (1) {
          switch (_context78.prev = _context78.next) {
            case 0:
              _context78.next = 2;
              return _this44.profileFacade.getFollowers(t2, _this44.profileId);

            case 2:
              return _context78.abrupt("return", _context78.sent);

            case 3:
            case "end":
              return _context78.stop();
          }
        }
      }, _callee77);
    }));

    return function (_x94) {
      return _ref92.apply(this, arguments);
    };
  }());

  __publicField(this, "getFollowing",
  /*#__PURE__*/
  function () {
    var _ref93 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee78(t2) {
      return _regeneratorRuntime.wrap(function _callee78$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return _this44.profileFacade.getFollowing(t2, _this44.profileId);

            case 2:
              return _context79.abrupt("return", _context79.sent);

            case 3:
            case "end":
              return _context79.stop();
          }
        }
      }, _callee78);
    }));

    return function (_x95) {
      return _ref93.apply(this, arguments);
    };
  }());

  __publicField(this, "showFullnessProfile",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee79() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee79$(_context80) {
      while (1) {
        switch (_context80.prev = _context80.next) {
          case 0:
            _context80.next = 2;
            return _this44.getProfile();

          case 2:
            t2 = _context80.sent;
            return _context80.abrupt("return", _this44.profileFacade.showFullnessProfile(t2));

          case 4:
          case "end":
            return _context80.stop();
        }
      }
    }, _callee79);
  })));

  __publicField(this, "getStats",
  /*#__PURE__*/
  function () {
    var _ref95 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee80(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee80$(_context81) {
        while (1) {
          switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return _this44.activityHttps.getStats(_this44.profileId, t2);

            case 2:
              e2 = _context81.sent;
              _context81.next = 5;
              return _this44.idsRemapper.remapProfileStats(e2);

            case 5:
              return _context81.abrupt("return", _context81.sent);

            case 6:
            case "end":
              return _context81.stop();
          }
        }
      }, _callee80);
    }));

    return function (_x96) {
      return _ref95.apply(this, arguments);
    };
  }());

  __publicField(this, "getBadges",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee81() {
    return _regeneratorRuntime.wrap(function _callee81$(_context82) {
      while (1) {
        switch (_context82.prev = _context82.next) {
          case 0:
            _context82.next = 2;
            return _this44.profileHttps.getBadges(_this44.profileId);

          case 2:
            return _context82.abrupt("return", _context82.sent);

          case 3:
          case "end":
            return _context82.stop();
        }
      }
    }, _callee81);
  })));

  this.idsRemapper = t2, this.profileHttps = i, this.activityHttps = a, this.profileFacade = new J(e2, i, a);
};

var mi = function mi(t2, e2, i) {
  var _this45 = this;

  _classCallCheck3(this, mi);

  __publicField(this, "localCache", null);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "getCountriesWithIdMapping",
  /*#__PURE__*/
  function () {
    var _ref97 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee82(t2) {
      var _e6;

      return _regeneratorRuntime.wrap(function _callee82$(_context83) {
        while (1) {
          switch (_context83.prev = _context83.next) {
            case 0:
              _context83.prev = 0;
              _context83.next = 3;
              return _this45.getCountries(t2);

            case 3:
              _e6 = _context83.sent;
              return _context83.abrupt("return", _this45.idMapping.remapEntities(_e6, "country"));

            case 7:
              _context83.prev = 7;
              _context83.t0 = _context83["catch"](0);
              throw console.warn("There was a problem browsing countries as football entities", _context83.t0), _context83.t0;

            case 10:
            case "end":
              return _context83.stop();
          }
        }
      }, _callee82, null, [[0, 7]]);
    }));

    return function (_x97) {
      return _ref97.apply(this, arguments);
    };
  }());

  __publicField(this, "getCountries",
  /*#__PURE__*/
  function () {
    var _ref98 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee83(t2) {
      var e2, _i20;

      return _regeneratorRuntime.wrap(function _callee83$(_context84) {
        while (1) {
          switch (_context84.prev = _context84.next) {
            case 0:
              t2 = t2 || false;
              e2 = _this45.localCache.getFootballCountries();

              if (!(e2 && e2.length > 0)) {
                _context84.next = 4;
                break;
              }

              return _context84.abrupt("return", e2);

            case 4:
              _context84.prev = 4;
              _context84.next = 7;
              return _this45.https.getCountries(t2);

            case 7:
              _i20 = _context84.sent;
              return _context84.abrupt("return", (_this45.localCache.setFootballCountries(_i20), _i20));

            case 11:
              _context84.prev = 11;
              _context84.t0 = _context84["catch"](4);
              throw console.warn("There was a problem retrieving countries as football entities", _context84.t0), _context84.t0;

            case 14:
            case "end":
              return _context84.stop();
          }
        }
      }, _callee83, null, [[4, 11]]);
    }));

    return function (_x98) {
      return _ref98.apply(this, arguments);
    };
  }());

  this.localCache = t2, this.idMapping = i, this.https = e2;
};

var Be = function Be(t2) {
  var _this46 = this;

  _classCallCheck3(this, Be);

  __publicField(this, "countryId", null);

  __publicField(this, "name", null);

  __publicField(this, "gender", null);

  __publicField(this, "type", null);

  __publicField(this, "sortField", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "competitionIds", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this46.countryId && (t2 = t2 + "&", t2 = t2 + "country_id=".concat(_this46.countryId)), _this46.gender && (t2 = t2 + "&", t2 = t2 + "gender=".concat(_this46.gender)), _this46.type && (t2 = t2 + "&", t2 = t2 + "type=".concat(_this46.type)), _this46.sortField && (t2 = t2 + "&", t2 = t2 + "sort_field=".concat(_this46.sortField)), _this46.sortOrder && (t2 = t2 + "&", t2 = t2 + "sort_order=".concat(_this46.sortOrder)), _this46.name && (t2 = t2 + "&", t2 = t2 + "name=".concat(_this46.name)), _this46.competitionIds && (t2 = t2 + "&", t2 = t2 + "competition_ids=".concat(_this46.competitionIds.join(","))), t2;
  });

  __publicField(this, "competitionSearchFilter", function (t2) {
    try {
      var e2 = _this46.filter(t2);

      return _this46.sortField || _this46.sortOrder ? _this46.sort(e2) : e2;
    } catch (e2) {
      return console.warn("There was a problem filtering the local competitions", e2), [];
    }
  });

  __publicField(this, "filter", function (t2) {
    var e2 = _this46.entitiesToSearchWith();

    return t2.filter(function (i) {
      var a = true;
      return e2.forEach(function (r2) {
        r2 !== "sortOrder" && r2 !== "sortField" && (r2 === "countryId" ? a && (a = i.country.id === _this46[r2]) : r2 === "name" ? a && (a = i.name.toLocaleLowerCase().includes(_this46[r2].toLocaleLowerCase())) : r2 === "competitionIds" ? a && (a = _this46[r2].some(function (s) {
          return i.id === s;
        })) : a && (a = i[r2].toLocaleLowerCase() === _this46[r2].toLocaleLowerCase()));
      }), a;
    });
  });

  __publicField(this, "entitiesToSearchWith", function () {
    var t2 = [];
    return _this46.countryId && t2.push("countryId"), _this46.name && t2.push("name"), _this46.gender && t2.push("gender"), _this46.type && t2.push("type"), _this46.sortField && t2.push("sortField"), _this46.sortOrder && t2.push("sortOrder"), _this46.competitionIds && t2.push("competitionIds"), t2;
  });

  __publicField(this, "sort", function (t2) {
    var e2 = [];
    return _this46.sortField === "name" ? e2 = t2.sort(function (i, a) {
      return _this46.sortOrder && _this46.sortOrder === "desc" ? a.name.localeCompare(i.name) : i.name.localeCompare(a.name);
    }) : _this46.sortField === "country" ? e2 = t2.sort(function (i, a) {
      return _this46.sortOrder && _this46.sortOrder === "desc" ? a.country.name.localeCompare(i.country.name) : i.country.name.localeCompare(a.country.name);
    }) : _this46.sortField === "scope" ? t2.forEach(function (i) {
      return e2[_this46.competitionIds.indexOf(i.id)] = i;
    }) : !_this46.sortField && _this46.sortOrder === "desc" && (e2 = t2.sort(function (i, a) {
      return a.id.localeCompare(i.id);
    })), e2;
  });

  this.countryId = t2.countryId ? "".concat(t2.countryId) : null, this.name = t2.name ? t2.name : null, this.gender = t2.gender ? t2.gender : null, this.type = t2.type ? t2.type : null, this.sortField = t2.sortField ? "".concat(t2.sortField) : null, this.sortOrder = t2.sortOrder ? "".concat(t2.sortOrder) : null, this.competitionIds = t2.competitionIds ? t2.competitionIds : null;
};

var ui = function ui(t2, e2, i) {
  var _this47 = this;

  _classCallCheck3(this, ui);

  __publicField(this, "localStorage", null);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "getCompetitionsIdMapping",
  /*#__PURE__*/
  function () {
    var _ref99 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee84(t2, e2) {
      var _i21, r2, _r3, a;

      return _regeneratorRuntime.wrap(function _callee84$(_context85) {
        while (1) {
          switch (_context85.prev = _context85.next) {
            case 0:
              _context85.prev = 0;
              _i21 = false;

              if (!t2) {
                _context85.next = 15;
                break;
              }

              if (!(t2 = new Be(t2), t2.countryId)) {
                _context85.next = 8;
                break;
              }

              _context85.next = 6;
              return _this47.idMapping.getEntityIdsBySchemaId(["".concat(t2.countryId)], "country", "native");

            case 6:
              r2 = _context85.sent;
              r2.country.length === 0 && (_i21 = true), t2.countryId = r2.country[0];

            case 8:
              if (!t2.competitionIds) {
                _context85.next = 13;
                break;
              }

              _context85.next = 11;
              return _this47.idMapping.getEntityIdsBySchemaId(t2.competitionIds, "competition", "native");

            case 11:
              _r3 = _context85.sent;
              _r3.competition.length === 0 && (_i21 = true), t2.competitionIds = _r3.competition;

            case 13:
              if (!_i21) {
                _context85.next = 15;
                break;
              }

              return _context85.abrupt("return", []);

            case 15:
              _context85.next = 17;
              return _this47.getCompetitions(t2, e2);

            case 17:
              a = _context85.sent;
              _context85.next = 20;
              return _this47.idMapping.remapEntities(a, "competition");

            case 20:
              return _context85.abrupt("return", _context85.sent);

            case 23:
              _context85.prev = 23;
              _context85.t0 = _context85["catch"](0);
              throw console.warn("There was a problem browsing all of the competitions", _context85.t0), _context85.t0;

            case 26:
            case "end":
              return _context85.stop();
          }
        }
      }, _callee84, null, [[0, 23]]);
    }));

    return function (_x99, _x100) {
      return _ref99.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionsMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref100 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee85(t2) {
      var e2, i, a, r2, s, p2;
      return _regeneratorRuntime.wrap(function _callee85$(_context86) {
        while (1) {
          switch (_context86.prev = _context86.next) {
            case 0:
              e2 =
              /* @__PURE__ */
              new Map();
              i = t2.length;
              a = new Be({
                competitionIds: t2,
                limit: i
              });
              _context86.next = 5;
              return _this47.getCompetitions(a);

            case 5:
              r2 = _context86.sent;
              r2.sort(function (n2, l2) {
                return n2.id.localeCompare(l2.id);
              });
              s = bo(t2);
              _context86.next = 10;
              return _this47.idMapping.remapEntities(r2, "competition");

            case 10:
              p2 = _context86.sent;
              return _context86.abrupt("return", (s.forEach(function (n2, l2) {
                return e2.set(n2, p2[l2]);
              }), e2));

            case 12:
            case "end":
              return _context86.stop();
          }
        }
      }, _callee85);
    }));

    return function (_x101) {
      return _ref100.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitions",
  /*#__PURE__*/
  function () {
    var _ref101 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee86(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee86$(_context87) {
        while (1) {
          switch (_context87.prev = _context87.next) {
            case 0:
              i = null;

              if (_this47.localStorage.getCompetitionsLength()) {
                _context87.next = 12;
                break;
              }

              _context87.prev = 2;
              _context87.next = 5;
              return _this47.https.getCompetitions();

            case 5:
              i = _context87.sent;
              _context87.next = 11;
              break;

            case 8:
              _context87.prev = 8;
              _context87.t0 = _context87["catch"](2);
              throw console.warn("There was a problem retrieving all competitions", _context87.t0), _context87.t0;

            case 11:
              _this47.localStorage.setCompetitions(i);

            case 12:
              return _context87.abrupt("return", _this47.localStorage.getCompetitions(t2));

            case 13:
            case "end":
              return _context87.stop();
          }
        }
      }, _callee86, null, [[2, 8]]);
    }));

    return function (_x102, _x103) {
      return _ref101.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionByIdIdMapping",
  /*#__PURE__*/
  function () {
    var _ref102 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee87(t2, e2) {
      var a, r2;
      return _regeneratorRuntime.wrap(function _callee87$(_context88) {
        while (1) {
          switch (_context88.prev = _context88.next) {
            case 0:
              _context88.prev = 0;
              _context88.next = 3;
              return _this47.idMapping.getEntityIdsBySchemaId([t2], "competition", "native");

            case 3:
              a = _context88.sent.competition[0];
              _context88.next = 6;
              return _this47.getCompetitionById(a, e2);

            case 6:
              r2 = _context88.sent;
              _context88.next = 9;
              return _this47.idMapping.remapEntities(r2, "competition");

            case 9:
              return _context88.abrupt("return", _context88.sent);

            case 12:
              _context88.prev = 12;
              _context88.t0 = _context88["catch"](0);
              throw console.warn("There was a problem browsing the following competition:".concat(t2), _context88.t0), _context88.t0;

            case 15:
            case "end":
              return _context88.stop();
          }
        }
      }, _callee87, null, [[0, 12]]);
    }));

    return function (_x104, _x105) {
      return _ref102.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionById",
  /*#__PURE__*/
  function () {
    var _ref103 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee88(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee88$(_context89) {
        while (1) {
          switch (_context89.prev = _context89.next) {
            case 0:
              _context89.prev = 0;
              e2 = e2 || false;
              _context89.next = 4;
              return _this47.https.getCompetitionById(t2, e2);

            case 4:
              return _context89.abrupt("return", _context89.sent);

            case 7:
              _context89.prev = 7;
              _context89.t0 = _context89["catch"](0);
              throw console.warn("There was a problem retrieving the competition with the following id: ".concat(t2), _context89.t0), _context89.t0;

            case 10:
            case "end":
              return _context89.stop();
          }
        }
      }, _callee88, null, [[0, 7]]);
    }));

    return function (_x106, _x107) {
      return _ref103.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopCompetitionsIdMapping",
  /*#__PURE__*/
  function () {
    var _ref104 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee89(t2) {
      var _e7;

      return _regeneratorRuntime.wrap(function _callee89$(_context90) {
        while (1) {
          switch (_context90.prev = _context90.next) {
            case 0:
              _context90.prev = 0;
              _context90.next = 3;
              return _this47.getTopCompetitions(t2);

            case 3:
              _e7 = _context90.sent;
              _context90.next = 6;
              return _this47.idMapping.remapEntities(_e7, "competition");

            case 6:
              return _context90.abrupt("return", _context90.sent);

            case 9:
              _context90.prev = 9;
              _context90.t0 = _context90["catch"](0);
              throw console.warn("There was a problem browsing the top competitions", _context90.t0), _context90.t0;

            case 12:
            case "end":
              return _context90.stop();
          }
        }
      }, _callee89, null, [[0, 9]]);
    }));

    return function (_x108) {
      return _ref104.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopCompetitions",
  /*#__PURE__*/
  function () {
    var _ref105 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee90(t2) {
      return _regeneratorRuntime.wrap(function _callee90$(_context91) {
        while (1) {
          switch (_context91.prev = _context91.next) {
            case 0:
              _context91.prev = 0;
              t2 = t2 || false;
              _context91.next = 4;
              return _this47.https.getTopCompetitions(t2);

            case 4:
              return _context91.abrupt("return", _context91.sent);

            case 7:
              _context91.prev = 7;
              _context91.t0 = _context91["catch"](0);
              throw console.warn("There was a problem retrieving the top competitions", _context91.t0), _context91.t0;

            case 10:
            case "end":
              return _context91.stop();
          }
        }
      }, _callee90, null, [[0, 7]]);
    }));

    return function (_x109) {
      return _ref105.apply(this, arguments);
    };
  }());

  this.localStorage = t2, this.idMapping = i, this.https = e2;
};

var Ne = function Ne(t2) {
  var _this48 = this;

  _classCallCheck3(this, Ne);

  __publicField(this, "name", null);

  __publicField(this, "countryId", null);

  __publicField(this, "national", false);

  __publicField(this, "gender", null);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "scope", null);

  __publicField(this, "sortField", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "teamIds", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this48.name && (t2 = t2 + "&", t2 = t2 + "name=".concat(_this48.name)), _this48.countryId && (t2 = t2 + "&", t2 = t2 + "country_id=".concat(_this48.countryId)), _this48.national && (t2 = t2 + "&", t2 = t2 + "national=".concat(_this48.national)), _this48.gender && (t2 = t2 + "&", t2 = t2 + "gender=".concat(_this48.gender)), _this48.limit && (t2 = t2 + "&", t2 = t2 + "limit=".concat(_this48.limit)), _this48.scope && (t2 = t2 + "&", t2 = t2 + "scope=".concat(_this48.scope.join(","))), _this48.page && (t2 = t2 + "&", t2 = t2 + "page=".concat(_this48.page)), _this48.sortField && (t2 = t2 + "&", t2 = t2 + "sort_field=".concat(_this48.sortField)), _this48.sortOrder && (t2 = t2 + "&", t2 = t2 + "sort_order=".concat(_this48.sortOrder)), _this48.teamIds && (t2 = t2 + "&", t2 = t2 + "team_ids=".concat(_this48.teamIds.join(","))), t2;
  });

  this.name = t2.name ? t2.name : null, this.countryId = t2.countryId ? "".concat(t2.countryId) : null, this.national = t2.national ? t2.national : false, this.gender = t2.gender ? t2.gender : null, this.limit = t2.limit ? t2.limit : null, this.page = t2.page ? t2.page : null, this.scope = t2.scope ? t2.scope : null, this.sortField = t2.sortField ? "".concat(t2.sortField) : null, this.sortOrder = t2.sortOrder ? "".concat(t2.sortOrder) : null, this.teamIds = t2.teamIds ? t2.teamIds : null;
};

var hi = function hi() {
  _classCallCheck3(this, hi);

  __publicField(this, "reason", "");

  __publicField(this, "words", []);
};

var xt = function xt() {
  _classCallCheck3(this, xt);

  __publicField(this, "enabled", false);

  __publicField(this, "moderateLinks", false);

  __publicField(this, "linksWhitelist", []);

  __publicField(this, "moderatorProfileId", "");

  __publicField(this, "dictionary", new hi());
};

var gi = function gi() {
  _classCallCheck3(this, gi);

  __publicField(this, "enabled", false);

  __publicField(this, "clientId", null);

  __publicField(this, "automaticModeration", new xt());
};

var fi = function fi() {
  _classCallCheck3(this, fi);

  __publicField(this, "general", []);

  __publicField(this, "predictor", []);

  __publicField(this, "topX", []);

  __publicField(this, "matchQuiz", []);
};

var pt = function pt() {
  _classCallCheck3(this, pt);

  __publicField(this, "points", null);

  __publicField(this, "gameParticipationCount", null);

  __publicField(this, "entityId", null);

  __publicField(this, "entityType", null);

  __publicField(this, "predictionsMade", null);

  __publicField(this, "correctPredictions", null);
};

var yi = function yi() {
  _classCallCheck3(this, yi);

  __publicField(this, "id");

  __publicField(this, "label");

  __publicField(this, "assets", {
    mainImageUrl: ""
  });

  __publicField(this, "enabled");

  __publicField(this, "requirements", new pt());
};

var Bt =
/*#__PURE__*/
function (_pt) {
  _inherits3(Bt, _pt);

  function Bt() {
    var _this49;

    _classCallCheck3(this, Bt);

    _this49 = _possibleConstructorReturn3(this, _getPrototypeOf4(Bt).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this49), "postPoints", null);

    __publicField(_assertThisInitialized3(_this49), "postsCount", null);

    __publicField(_assertThisInitialized3(_this49), "reactionsCount", null);

    __publicField(_assertThisInitialized3(_this49), "totalDiscussionPoints", null);

    return _this49;
  }

  return Bt;
}(pt);

var Mi = function Mi() {
  _classCallCheck3(this, Mi);

  __publicField(this, "id");

  __publicField(this, "label");

  __publicField(this, "assets", {
    mainImageUrl: ""
  });

  __publicField(this, "enabled");

  __publicField(this, "requirements", new Bt());
};

var bi = function bi() {
  _classCallCheck3(this, bi);

  __publicField(this, "id");

  __publicField(this, "weight");

  __publicField(this, "multiplier");

  __publicField(this, "conditions");
};

var wi = function wi() {
  _classCallCheck3(this, wi);

  __publicField(this, "value", [new bi()]);
};

var Nt = function Nt() {
  _classCallCheck3(this, Nt);

  __publicField(this, "points", null);

  __publicField(this, "tiers", null);

  __publicField(this, "badges", null);
};

var Ii = function Ii() {
  _classCallCheck3(this, Ii);

  __publicField(this, "enabled", false);

  __publicField(this, "clientId", null);

  __publicField(this, "conditions", {
    list: null
  });

  __publicField(this, "actions", new wi());

  __publicField(this, "rewards", new Nt());
};

var Pi = function Pi() {
  _classCallCheck3(this, Pi);

  __publicField(this, "general", null);

  __publicField(this, "predictor", null);

  __publicField(this, "activity", null);

  __publicField(this, "topX", null);

  __publicField(this, "matchQuiz", null);

  __publicField(this, "discussionPost", null);
};

var Ut = function Ut() {
  _classCallCheck3(this, Ut);

  __publicField(this, "enabled", false);

  __publicField(this, "clientId", null);

  __publicField(this, "defaultMarkets", null);

  __publicField(this, "competitionsWhitelist", null);
};

var Ht = function Ht() {
  _classCallCheck3(this, Ht);

  __publicField(this, "enabled", false);

  __publicField(this, "clientId", null);

  __publicField(this, "minFixtures", null);

  __publicField(this, "maxFixtures", null);

  __publicField(this, "competitionsWhitelist", null);
};

var vi = function vi() {
  _classCallCheck3(this, vi);

  __publicField(this, "competitions", []);

  __publicField(this, "teams", []);

  __publicField(this, "markets", []);
};

var kt = function kt() {
  _classCallCheck3(this, kt);

  __publicField(this, "enabled", false);

  __publicField(this, "clientId", null);

  __publicField(this, "fullCoverageCompetitions", null);

  __publicField(this, "markets", null);

  __publicField(this, "successRateScopes", new vi());

  __publicField(this, "userDataConfig", null);
};

var Ti = function Ti() {
  _classCallCheck3(this, Ti);

  __publicField(this, "storeIp", false);

  __publicField(this, "storeDeviceId", false);

  __publicField(this, "storeAgent", false);
};

var _i = function _i() {
  var _this50 = this;

  _classCallCheck3(this, _i);

  __publicField(this, "remapPredictorConfig", function (t2) {
    var e2 = new kt();
    return e2.enabled = t2.enabled, e2.clientId = t2.client_id, e2.fullCoverageCompetitions = t2.full_coverage_competitions, e2.markets = t2.markets, e2.successRateScopes = t2.success_rate_scopes, e2.userDataConfig = t2.user_data_config ? _this50.remapUserDataConfig(t2.user_data_config) : null, e2;
  });

  __publicField(this, "remapTopXConfig", function (t2) {
    var e2 = new Ht();
    return e2.enabled = t2.enabled, e2.clientId = t2.client_id, e2.minFixtures = t2.min_fixtures, e2.maxFixtures = t2.max_fixtures, e2.competitionsWhitelist = t2.competitions_whitelist, e2;
  });

  __publicField(this, "remapMatchQuizConfig", function (t2) {
    var e2 = new Ut();
    return e2.enabled = t2.enabled, e2.clientId = t2.client_id, e2.defaultMarkets = t2.default_markets, e2.competitionsWhitelist = t2.competitions_whitelist, e2;
  });

  __publicField(this, "remapLoyaltyConfig", function (t2) {
    var e2 = new Ii();
    return e2.enabled = t2.enabled, e2.clientId = t2.client_id, e2.conditions.list = t2.conditions.list, e2.actions.value = t2.actions.value, e2.rewards = _this50.remapRewards(t2.rewards), e2;
  });

  __publicField(this, "remapDiscussionsConfig", function (t2) {
    var e2 = new gi();
    return e2.enabled = t2.enabled, e2.clientId = t2.client_id, e2.automaticModeration = t2.automatic_moderation ? _this50.remapAutomaticModeration(t2.automatic_moderation) : null, e2;
  });

  __publicField(this, "remapAutomaticModeration", function (t2) {
    var e2 = new xt();
    return e2.enabled = t2.enabled, e2.moderateLinks = t2.moderate_links, e2.linksWhitelist = t2.links_whitelist, e2.moderatorProfileId = t2.moderator_profile_id, e2.dictionary = t2.dictionary, e2;
  });

  __publicField(this, "remapRewards", function (t2) {
    var e2 = new Nt();
    return e2.points = _this50.remapPoints(t2.points), e2.tiers = t2.tiers, e2.badges = _this50.remapBadges(t2.badges), e2;
  });

  __publicField(this, "remapPoints", function (t2) {
    var e2 = new Pi();
    return e2.general = t2.general, e2.discussionPost = t2.discussion_post, e2.predictor = t2.predictor, e2.activity = t2.activity, e2.topX = t2.top_x, e2.matchQuiz = t2.match_quiz, e2;
  });

  __publicField(this, "remapBadges", function (t2) {
    var e2 = new fi();
    return e2.general = _this50.remapGeneralBadgeValues(t2.general), e2.predictor = _this50.remapBadgeValues(t2.predictor), e2.topX = _this50.remapBadgeValues(t2.top_x), e2.matchQuiz = _this50.remapBadgeValues(t2.match_quiz), e2;
  });

  __publicField(this, "remapBadgeValues", function (t2) {
    return t2.map(function (e2) {
      var i = new yi();
      return i.id = e2.id, i.label = e2.label, i.enabled = e2.enabled, e2.assets ? i.assets.mainImageUrl = e2.assets.main_image_url : i.assets = e2.assets, i.requirements = _this50.remapRequirements(e2.requirements), i;
    });
  });

  __publicField(this, "remapRequirements", function (t2) {
    var e2 = new pt();
    return e2.points = t2.points, e2.gameParticipationCount = t2.game_participation_count, e2.entityId = t2.entity_id, e2.entityType = t2.entity_type, e2.predictionsMade = t2.predictions_made, e2.correctPredictions = t2.correct_predictions, e2;
  });

  __publicField(this, "remapUserDataConfig", function (t2) {
    var e2 = new Ti();
    return e2.storeIp = t2.store_ip, e2.storeDeviceId = t2.store_device_id, e2.storeAgent = t2.store_agent, e2;
  });

  __publicField(this, "remapGeneralBadgeValues", function (t2) {
    return t2.map(function (e2) {
      var i = new Mi();
      return i.id = e2.id, i.label = e2.label, i.enabled = e2.enabled, e2.assets ? i.assets.mainImageUrl = e2.assets.main_image_url : i.assets = e2.assets, i.requirements = _this50.remapGeneralRequirements(e2.requirements), i;
    });
  });

  __publicField(this, "remapGeneralRequirements", function (t2) {
    var e2 = new Bt();
    return e2.points = t2.points, e2.gameParticipationCount = t2.game_participation_count, e2.entityId = t2.entity_id, e2.entityType = t2.entity_type, e2.predictionsMade = t2.predictions_made, e2.correctPredictions = t2.correct_predictions, e2.postPoints = t2.post_points, e2.postsCount = t2.posts_count, e2.reactionsCount = t2.reactions_count, e2.totalDiscussionPoints = t2.total_discussion_points, e2;
  });
};

var x$1 =
/*#__PURE__*/
function (_ref106) {
  _inherits3(x$1, _ref106);

  function x$1(t2) {
    var _this51;

    _classCallCheck3(this, x$1);

    _this51 = _possibleConstructorReturn3(this, _getPrototypeOf4(x$1).call(this, t2, R(t2.environment, "client")));

    __publicField(_assertThisInitialized3(_this51), "featureConfigRemapper", null);

    __publicField(_assertThisInitialized3(_this51), "localStorage", null);

    __publicField(_assertThisInitialized3(_this51), "clientId", null);

    __publicField(_assertThisInitialized3(_this51), "getConfig",
    /*#__PURE__*/
    function () {
      var _ref107 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee91(t2) {
        var e2, _i22, a, r2, s;

        return _regeneratorRuntime.wrap(function _callee91$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                e2 = _this51.getCachedFeatures();

                if (e2) {
                  _context92.next = 7;
                  break;
                }

                _i22 = "/clients/".concat(_this51.clientId, "/features"), a = _this51.apiSignInUrl.split("&")[0], r2 = _i22 + a, s = "There was a problem fetching client features from Client API";
                _context92.next = 5;
                return _this51.fetchWithoutAuth(r2, s);

              case 5:
                e2 = _context92.sent.data;

                _this51.localStorage.setClientFeatures(e2);

              case 7:
                _context92.t0 = t2;
                _context92.next = _context92.t0 === "predictor" ? 10 : _context92.t0 === "topX" ? 11 : _context92.t0 === "matchQuiz" ? 12 : _context92.t0 === "loyalty" ? 13 : _context92.t0 === "discussions" ? 14 : 15;
                break;

              case 10:
                return _context92.abrupt("return", _this51.featureConfigRemapper.remapPredictorConfig(e2.predictor));

              case 11:
                return _context92.abrupt("return", _this51.featureConfigRemapper.remapTopXConfig(e2.top_x));

              case 12:
                return _context92.abrupt("return", _this51.featureConfigRemapper.remapMatchQuizConfig(e2.match_quiz));

              case 13:
                return _context92.abrupt("return", _this51.featureConfigRemapper.remapLoyaltyConfig(e2.loyalty));

              case 14:
                return _context92.abrupt("return", _this51.featureConfigRemapper.remapDiscussionsConfig(e2.discussions));

              case 15:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee91);
      }));

      return function (_x110) {
        return _ref107.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this51), "getCachedFeatures", function () {
      var t2 = _this51.getLocalStorageData();

      if (!(!t2 || !Object.keys(t2).length)) return t2.predictor.client_id && t2.predictor.client_id !== _this51.clientId ? (_this51.localStorage.deleteClientFeatures(), null) : t2;
    });

    __publicField(_assertThisInitialized3(_this51), "getLocalStorageData", function () {
      var t2 = Math.floor(Date.now() / 1e3);
      return _this51.localStorage.getExpiration("client", "features") > t2 ? _this51.localStorage.getClientFeatures() : null;
    });

    _this51.clientId = t2.clientId, _this51.localStorage = new V().createLocalCacheInstance(t2.idSchema), _this51.featureConfigRemapper = new _i();
    return _this51;
  }

  return x$1;
}(_);

var ct = function ct(t2) {
  var _this52 = this;

  _classCallCheck3(this, ct);

  __publicField(this, "clientHttps", null);

  __publicField(this, "setAvailableMarketsForMatch",
  /*#__PURE__*/
  function () {
    var _ref108 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee92(t2) {
      var _ref109, e2, i;

      return _regeneratorRuntime.wrap(function _callee92$(_context93) {
        while (1) {
          switch (_context93.prev = _context93.next) {
            case 0:
              _context93.next = 2;
              return _this52.clientHttps.getConfig("predictor");

            case 2:
              _ref109 = _context93.sent;
              e2 = _ref109.fullCoverageCompetitions;
              i = _ref109.markets;

              if (!Array.isArray(t2)) {
                _context93.next = 7;
                break;
              }

              return _context93.abrupt("return", t2.map(function (a) {
                return _this52.setAvailableMarkets(a, e2, i);
              }));

            case 7:
              if (!(typeof t2 == "object" && Object.keys(t2).length)) {
                _context93.next = 9;
                break;
              }

              return _context93.abrupt("return", _this52.setAvailableMarkets(t2, e2, i));

            case 9:
            case "end":
              return _context93.stop();
          }
        }
      }, _callee92);
    }));

    return function (_x111) {
      return _ref108.apply(this, arguments);
    };
  }());

  __publicField(this, "setAvailableMarkets", function (t2, e2, i) {
    var _a2;

    var a = (_a2 = t2.context.competition) == null ? void 0 : _a2.id;
    return a && _this52.isMatchInCoverageCompetition(a, e2) ? (t2.availableMarkets = i.all, t2) : (t2.availableMarkets = i.main, t2);
  });

  __publicField(this, "isMatchInCoverageCompetition", function (t2, e2) {
    var i = false;
    return e2.includes(t2) && (i = true), i;
  });

  this.clientHttps = new x$1(t2);
};

var Ei = function Ei(t2, e2, i) {
  var _this53 = this;

  _classCallCheck3(this, Ei);

  __publicField(this, "footballService", null);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "getTeamsIdMapping",
  /*#__PURE__*/
  function () {
    var _ref110 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee93(t2, e2) {
      var _i23, r2, _r4, _r5, a;

      return _regeneratorRuntime.wrap(function _callee93$(_context94) {
        while (1) {
          switch (_context94.prev = _context94.next) {
            case 0:
              _context94.prev = 0;
              _i23 = false;

              if (!t2) {
                _context94.next = 18;
                break;
              }

              if (!(t2 = new Ne(t2), t2.countryId)) {
                _context94.next = 8;
                break;
              }

              _context94.next = 6;
              return _this53.idMapping.getEntityIdsBySchemaId(["".concat(t2.countryId)], "country", "native");

            case 6:
              r2 = _context94.sent;
              r2.country.length === 0 && (_i23 = true), t2.countryId = r2.country[0];

            case 8:
              if (!t2.scope) {
                _context94.next = 13;
                break;
              }

              _context94.next = 11;
              return _this53.idMapping.getEntityIdsBySchemaId(t2.scope, "competition", "native");

            case 11:
              _r4 = _context94.sent;
              _r4.competition.length === 0 && (_i23 = true), t2.scope = _r4.competition;

            case 13:
              if (!t2.teamIds) {
                _context94.next = 18;
                break;
              }

              _context94.next = 16;
              return _this53.idMapping.getEntityIdsBySchemaId(t2.teamIds, "team", "native");

            case 16:
              _r5 = _context94.sent;
              _r5.team.length === 0 && (_i23 = true), t2.teamIds = _r5.team;

            case 18:
              if (!_i23) {
                _context94.next = 20;
                break;
              }

              return _context94.abrupt("return", []);

            case 20:
              _context94.next = 22;
              return _this53.getTeams(t2, e2);

            case 22:
              a = _context94.sent;
              _context94.next = 25;
              return _this53.idMapping.remapEntities(a.data, "team");

            case 25:
              a.data = _context94.sent;
              return _context94.abrupt("return", a);

            case 29:
              _context94.prev = 29;
              _context94.t0 = _context94["catch"](0);
              throw console.warn("There was a problem browsing all teams", _context94.t0), _context94.t0;

            case 32:
            case "end":
              return _context94.stop();
          }
        }
      }, _callee93, null, [[0, 29]]);
    }));

    return function (_x112, _x113) {
      return _ref110.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamsMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref111 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee94(t2) {
      var e2, i, a, _ref112, r2, s, p2;

      return _regeneratorRuntime.wrap(function _callee94$(_context95) {
        while (1) {
          switch (_context95.prev = _context95.next) {
            case 0:
              e2 =
              /* @__PURE__ */
              new Map();
              i = t2.length;
              a = new Ne({
                teamIds: t2,
                limit: i
              });
              _context95.next = 5;
              return _this53.getTeams(a);

            case 5:
              _ref112 = _context95.sent;
              r2 = _ref112.data;
              r2.sort(function (n2, l2) {
                return n2.id.localeCompare(l2.id);
              });
              s = bo(t2);
              _context95.next = 11;
              return _this53.idMapping.remapEntities(r2, "team");

            case 11:
              p2 = _context95.sent;
              return _context95.abrupt("return", (s.forEach(function (n2, l2) {
                return e2.set(n2, p2[l2]);
              }), e2));

            case 13:
            case "end":
              return _context95.stop();
          }
        }
      }, _callee94);
    }));

    return function (_x114) {
      return _ref111.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeams",
  /*#__PURE__*/
  function () {
    var _ref113 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee95(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee95$(_context96) {
        while (1) {
          switch (_context96.prev = _context96.next) {
            case 0:
              _context96.prev = 0;
              e2 = e2 || false;
              _context96.next = 4;
              return _this53.https.getTeams(t2, e2);

            case 4:
              return _context96.abrupt("return", _context96.sent);

            case 7:
              _context96.prev = 7;
              _context96.t0 = _context96["catch"](0);
              throw console.warn("There was a problem retrieving all teams", _context96.t0), _context96.t0;

            case 10:
            case "end":
              return _context96.stop();
          }
        }
      }, _callee95, null, [[0, 7]]);
    }));

    return function (_x115, _x116) {
      return _ref113.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamByIdIdMapping",
  /*#__PURE__*/
  function () {
    var _ref114 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee96(t2, e2) {
      var a;
      return _regeneratorRuntime.wrap(function _callee96$(_context97) {
        while (1) {
          switch (_context97.prev = _context97.next) {
            case 0:
              _context97.prev = 0;
              _context97.next = 3;
              return _this53.idMapping.getEntityIdsBySchemaId([t2], "team", "native");

            case 3:
              t2 = _context97.sent.team[0];
              _context97.next = 6;
              return _this53.getTeamById(t2, e2);

            case 6:
              a = _context97.sent;
              _context97.next = 9;
              return _this53.idMapping.remapEntities(a, "team");

            case 9:
              return _context97.abrupt("return", _context97.sent);

            case 12:
              _context97.prev = 12;
              _context97.t0 = _context97["catch"](0);
              throw console.warn("There was a problem browsing the following team:".concat(t2), _context97.t0), _context97.t0;

            case 15:
            case "end":
              return _context97.stop();
          }
        }
      }, _callee96, null, [[0, 12]]);
    }));

    return function (_x117, _x118) {
      return _ref114.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamById",
  /*#__PURE__*/
  function () {
    var _ref115 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee97(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee97$(_context98) {
        while (1) {
          switch (_context98.prev = _context98.next) {
            case 0:
              _context98.prev = 0;
              e2 = e2 || false;
              _context98.next = 4;
              return _this53.https.getTeamById(t2, e2);

            case 4:
              return _context98.abrupt("return", _context98.sent);

            case 7:
              _context98.prev = 7;
              _context98.t0 = _context98["catch"](0);
              throw console.warn("There was a problem retrieving the following team: ".concat(t2), _context98.t0), _context98.t0;

            case 10:
            case "end":
              return _context98.stop();
          }
        }
      }, _callee97, null, [[0, 7]]);
    }));

    return function (_x119, _x120) {
      return _ref115.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopTeamsIdMapping",
  /*#__PURE__*/
  function () {
    var _ref116 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee98(t2) {
      var _e8;

      return _regeneratorRuntime.wrap(function _callee98$(_context99) {
        while (1) {
          switch (_context99.prev = _context99.next) {
            case 0:
              _context99.prev = 0;
              _context99.next = 3;
              return _this53.getTopTeams(t2);

            case 3:
              _e8 = _context99.sent;
              _context99.next = 6;
              return _this53.idMapping.remapEntities(_e8, "team");

            case 6:
              return _context99.abrupt("return", _context99.sent);

            case 9:
              _context99.prev = 9;
              _context99.t0 = _context99["catch"](0);
              throw console.warn("There was a problem browsing the top teams", _context99.t0), _context99.t0;

            case 12:
            case "end":
              return _context99.stop();
          }
        }
      }, _callee98, null, [[0, 9]]);
    }));

    return function (_x121) {
      return _ref116.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopTeams",
  /*#__PURE__*/
  function () {
    var _ref117 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee99(t2) {
      return _regeneratorRuntime.wrap(function _callee99$(_context100) {
        while (1) {
          switch (_context100.prev = _context100.next) {
            case 0:
              _context100.prev = 0;
              t2 = t2 || false;
              _context100.next = 4;
              return _this53.https.getTopTeams(t2);

            case 4:
              return _context100.abrupt("return", _context100.sent);

            case 7:
              _context100.prev = 7;
              _context100.t0 = _context100["catch"](0);
              throw console.warn("There was a problem retrieving the top teams", _context100.t0), _context100.t0;

            case 10:
            case "end":
              return _context100.stop();
          }
        }
      }, _callee99, null, [[0, 7]]);
    }));

    return function (_x122) {
      return _ref117.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForTeamIdMapping",
  /*#__PURE__*/
  function () {
    var _ref118 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee100(t2, e2) {
      var a;
      return _regeneratorRuntime.wrap(function _callee100$(_context101) {
        while (1) {
          switch (_context101.prev = _context101.next) {
            case 0:
              _context101.prev = 0;
              _context101.next = 3;
              return _this53.idMapping.getEntityIdsBySchemaId([t2], "team", "native");

            case 3:
              t2 = _context101.sent.team[0];
              _context101.next = 6;
              return _this53.getNextMatchForTeam(t2, e2);

            case 6:
              a = _context101.sent;
              _context101.next = 9;
              return _this53.idMapping.remapEntities(a, "match");

            case 9:
              return _context101.abrupt("return", _context101.sent);

            case 12:
              _context101.prev = 12;
              _context101.t0 = _context101["catch"](0);
              throw console.warn("There was a problem browsing the next match for the following team:".concat(t2), _context101.t0), _context101.t0;

            case 15:
            case "end":
              return _context101.stop();
          }
        }
      }, _callee100, null, [[0, 12]]);
    }));

    return function (_x123, _x124) {
      return _ref118.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref119 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee101(t2, e2) {
      var _i24;

      return _regeneratorRuntime.wrap(function _callee101$(_context102) {
        while (1) {
          switch (_context102.prev = _context102.next) {
            case 0:
              _context102.prev = 0;
              e2 = e2 || false;
              _context102.next = 4;
              return _this53.https.getNextMatchForTeam(t2, e2);

            case 4:
              _i24 = _context102.sent;
              _context102.next = 7;
              return _this53.footballService.setAvailableMarketsForMatch(_i24);

            case 7:
              return _context102.abrupt("return", _context102.sent);

            case 10:
              _context102.prev = 10;
              _context102.t0 = _context102["catch"](0);
              throw console.warn("There was a problem retrieving the next match for the following team: ".concat(t2), _context102.t0), _context102.t0;

            case 13:
            case "end":
              return _context102.stop();
          }
        }
      }, _callee101, null, [[0, 10]]);
    }));

    return function (_x125, _x126) {
      return _ref119.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForTeamIdMapping",
  /*#__PURE__*/
  function () {
    var _ref120 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee102(t2, e2) {
      var a;
      return _regeneratorRuntime.wrap(function _callee102$(_context103) {
        while (1) {
          switch (_context103.prev = _context103.next) {
            case 0:
              _context103.prev = 0;
              _context103.next = 3;
              return _this53.idMapping.getEntityIdsBySchemaId([t2], "team", "native");

            case 3:
              t2 = _context103.sent.team[0];
              _context103.next = 6;
              return _this53.getPrevMatchForTeam(t2, e2);

            case 6:
              a = _context103.sent;
              _context103.next = 9;
              return _this53.idMapping.remapEntities(a, "match");

            case 9:
              return _context103.abrupt("return", _context103.sent);

            case 12:
              _context103.prev = 12;
              _context103.t0 = _context103["catch"](0);
              throw console.warn("There was a problem browsing the previous match for the following team:".concat(t2), _context103.t0), _context103.t0;

            case 15:
            case "end":
              return _context103.stop();
          }
        }
      }, _callee102, null, [[0, 12]]);
    }));

    return function (_x127, _x128) {
      return _ref120.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref121 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee103(t2, e2) {
      var _i25;

      return _regeneratorRuntime.wrap(function _callee103$(_context104) {
        while (1) {
          switch (_context104.prev = _context104.next) {
            case 0:
              _context104.prev = 0;
              e2 = e2 || false;
              _context104.next = 4;
              return _this53.https.getPrevMatchForTeam(t2, e2);

            case 4:
              _i25 = _context104.sent;
              _context104.next = 7;
              return _this53.footballService.setAvailableMarketsForMatch(_i25);

            case 7:
              return _context104.abrupt("return", _context104.sent);

            case 10:
              _context104.prev = 10;
              _context104.t0 = _context104["catch"](0);
              throw console.warn("There was a problem retrieving the previous match for the following team: ".concat(t2), _context104.t0), _context104.t0;

            case 13:
            case "end":
              return _context104.stop();
          }
        }
      }, _callee103, null, [[0, 10]]);
    }));

    return function (_x129, _x130) {
      return _ref121.apply(this, arguments);
    };
  }());

  this.idMapping = i, this.https = e2, this.footballService = new ct(t2);
};

var Ue = function Ue(t2) {
  var _this54 = this;

  _classCallCheck3(this, Ue);

  __publicField(this, "countryId", null);

  __publicField(this, "scope", null);

  __publicField(this, "name", null);

  __publicField(this, "playerIds", null);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "sortField", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this54.countryId && (t2 = t2 + "&", t2 = t2 + "country_id=".concat(_this54.countryId)), _this54.scope && (t2 = t2 + "&", t2 = t2 + "scope=".concat(_this54.scope.join(","))), _this54.name && (t2 = t2 + "&", t2 = t2 + "name=".concat(_this54.name)), _this54.playerIds && (t2 = t2 + "&", t2 = t2 + "player_ids=".concat(_this54.playerIds.join(","))), _this54.limit && (t2 = t2 + "&", t2 = t2 + "limit=".concat(_this54.limit)), _this54.page && (t2 = t2 + "&", t2 = t2 + "page=".concat(_this54.page)), _this54.sortField && (t2 = t2 + "&", t2 = t2 + "sort_field=".concat(_this54.sortField)), _this54.sortOrder && (t2 = t2 + "&", t2 = t2 + "sort_order=".concat(_this54.sortOrder)), t2;
  });

  this.countryId = t2.countryId ? t2.countryId : null, this.scope = t2.scope ? t2.scope : null, this.name = t2.name ? t2.name : null, this.playerIds = t2.playerIds ? t2.playerIds : null, this.limit = t2.limit ? t2.limit : null, this.page = t2.page ? t2.page : null, this.sortField = t2.sortField ? t2.sortField : null, this.sortOrder = t2.sortOrder ? t2.sortOrder : null;
};

var dt = function dt(t2, e2, i) {
  var _this55 = this;

  _classCallCheck3(this, dt);

  __publicField(this, "https", null);

  __publicField(this, "footballService", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "getPlayersIdMapping",
  /*#__PURE__*/
  function () {
    var _ref122 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee104(t2, e2) {
      var _i26, r2, _r6, _r7, a;

      return _regeneratorRuntime.wrap(function _callee104$(_context105) {
        while (1) {
          switch (_context105.prev = _context105.next) {
            case 0:
              _context105.prev = 0;
              _i26 = false;

              if (!t2) {
                _context105.next = 20;
                break;
              }

              if (!(t2 = new Ue(t2), t2.countryId)) {
                _context105.next = 8;
                break;
              }

              _context105.next = 6;
              return _this55.idMapping.getEntityIdsBySchemaId([t2.countryId], "country", "native");

            case 6:
              r2 = _context105.sent;
              r2.country.length === 0 && (_i26 = true), t2.countryId = r2.country[0];

            case 8:
              if (!t2.playerIds) {
                _context105.next = 13;
                break;
              }

              _context105.next = 11;
              return _this55.idMapping.getEntityIdsBySchemaId(t2.playerIds, "player", "native");

            case 11:
              _r6 = _context105.sent;
              _r6.player.length === 0 && (_i26 = true), t2.playerIds = _r6.player;

            case 13:
              if (!t2.scope) {
                _context105.next = 18;
                break;
              }

              _context105.next = 16;
              return _this55.idMapping.getEntityIdsBySchemaId(t2.scope, "competition", "native");

            case 16:
              _r7 = _context105.sent;
              _r7.competition.length === 0 && (_i26 = true), t2.scope = _r7.competition;

            case 18:
              if (!_i26) {
                _context105.next = 20;
                break;
              }

              return _context105.abrupt("return", []);

            case 20:
              _context105.next = 22;
              return _this55.getPlayers(t2, e2);

            case 22:
              a = _context105.sent;
              _context105.next = 25;
              return _this55.idMapping.remapEntities(a.data, "player");

            case 25:
              a.data = _context105.sent;
              return _context105.abrupt("return", a);

            case 29:
              _context105.prev = 29;
              _context105.t0 = _context105["catch"](0);
              throw console.warn("There was a problem browsing the players", _context105.t0), _context105.t0;

            case 32:
            case "end":
              return _context105.stop();
          }
        }
      }, _callee104, null, [[0, 29]]);
    }));

    return function (_x131, _x132) {
      return _ref122.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayersWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref123 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee105(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee105$(_context106) {
        while (1) {
          switch (_context106.prev = _context106.next) {
            case 0:
              e2 = t2.length;
              i = new Ue({
                playerIds: t2,
                limit: e2
              });
              _context106.next = 4;
              return _this55.getPlayers(i);

            case 4:
              a = _context106.sent;
              a.data.sort(function (r2, s) {
                return r2.id.localeCompare(s.id);
              });
              _context106.next = 8;
              return _this55.idMapping.remapEntities(a.data, "player");

            case 8:
              return _context106.abrupt("return", _context106.sent);

            case 9:
            case "end":
              return _context106.stop();
          }
        }
      }, _callee105);
    }));

    return function (_x133) {
      return _ref123.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayersMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref124 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee106(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee106$(_context107) {
        while (1) {
          switch (_context107.prev = _context107.next) {
            case 0:
              e2 = {}, i = Pt(t2);
              i.sort(function (r2, s) {
                return r2.localeCompare(s);
              });
              _context107.next = 4;
              return _this55.getPlayersWithNativeIds(i);

            case 4:
              a = _context107.sent;
              return _context107.abrupt("return", (i.forEach(function (r2, s) {
                return e2[r2] = a[s];
              }), e2));

            case 6:
            case "end":
              return _context107.stop();
          }
        }
      }, _callee106);
    }));

    return function (_x134) {
      return _ref124.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayers",
  /*#__PURE__*/
  function () {
    var _ref125 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee107(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee107$(_context108) {
        while (1) {
          switch (_context108.prev = _context108.next) {
            case 0:
              _context108.prev = 0;
              e2 = e2 || false;
              _context108.next = 4;
              return _this55.https.getPlayers(t2, e2);

            case 4:
              return _context108.abrupt("return", _context108.sent);

            case 7:
              _context108.prev = 7;
              _context108.t0 = _context108["catch"](0);
              throw console.warn("There was a problem retrieving the players", _context108.t0), _context108.t0;

            case 10:
            case "end":
              return _context108.stop();
          }
        }
      }, _callee107, null, [[0, 7]]);
    }));

    return function (_x135, _x136) {
      return _ref125.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayerIdMapping",
  /*#__PURE__*/
  function () {
    var _ref126 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee108(t2, e2) {
      var _i27, a;

      return _regeneratorRuntime.wrap(function _callee108$(_context109) {
        while (1) {
          switch (_context109.prev = _context109.next) {
            case 0:
              _context109.prev = 0;
              _context109.next = 3;
              return _this55.idMapping.getEntityIdsBySchemaId([t2], "player", "native");

            case 3:
              _i27 = _context109.sent;
              _context109.next = 6;
              return _this55.getPlayerById(_i27.player[0], e2);

            case 6:
              a = _context109.sent;
              _context109.next = 9;
              return _this55.idMapping.remapEntities(a, "player");

            case 9:
              return _context109.abrupt("return", _context109.sent);

            case 12:
              _context109.prev = 12;
              _context109.t0 = _context109["catch"](0);
              throw console.warn("There was a problem browsing the following player:".concat(t2), _context109.t0), _context109.t0;

            case 15:
            case "end":
              return _context109.stop();
          }
        }
      }, _callee108, null, [[0, 12]]);
    }));

    return function (_x137, _x138) {
      return _ref126.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayerById",
  /*#__PURE__*/
  function () {
    var _ref127 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee109(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee109$(_context110) {
        while (1) {
          switch (_context110.prev = _context110.next) {
            case 0:
              _context110.prev = 0;
              e2 = e2 || false;
              _context110.next = 4;
              return _this55.https.getPlayerById(t2, e2);

            case 4:
              return _context110.abrupt("return", _context110.sent);

            case 7:
              _context110.prev = 7;
              _context110.t0 = _context110["catch"](0);
              throw console.warn("There was a problem retrieving the following player: ".concat(t2), _context110.t0), _context110.t0;

            case 10:
            case "end":
              return _context110.stop();
          }
        }
      }, _callee109, null, [[0, 7]]);
    }));

    return function (_x139, _x140) {
      return _ref127.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopPlayersIdMapping",
  /*#__PURE__*/
  function () {
    var _ref128 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee110(t2) {
      var _e9;

      return _regeneratorRuntime.wrap(function _callee110$(_context111) {
        while (1) {
          switch (_context111.prev = _context111.next) {
            case 0:
              _context111.prev = 0;
              _context111.next = 3;
              return _this55.getTopPlayers(t2);

            case 3:
              _e9 = _context111.sent;
              _context111.next = 6;
              return _this55.idMapping.remapEntities(_e9, "player");

            case 6:
              return _context111.abrupt("return", _context111.sent);

            case 9:
              _context111.prev = 9;
              _context111.t0 = _context111["catch"](0);
              throw console.warn("There was a problem browsing the top players", _context111.t0), _context111.t0;

            case 12:
            case "end":
              return _context111.stop();
          }
        }
      }, _callee110, null, [[0, 9]]);
    }));

    return function (_x141) {
      return _ref128.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopPlayers",
  /*#__PURE__*/
  function () {
    var _ref129 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee111(t2) {
      return _regeneratorRuntime.wrap(function _callee111$(_context112) {
        while (1) {
          switch (_context112.prev = _context112.next) {
            case 0:
              _context112.prev = 0;
              t2 = t2 || false;
              _context112.next = 4;
              return _this55.https.getTopPlayers(t2);

            case 4:
              return _context112.abrupt("return", _context112.sent);

            case 7:
              _context112.prev = 7;
              _context112.t0 = _context112["catch"](0);
              throw console.warn("There was a problem retrieving the top players", _context112.t0), _context112.t0;

            case 10:
            case "end":
              return _context112.stop();
          }
        }
      }, _callee111, null, [[0, 7]]);
    }));

    return function (_x142) {
      return _ref129.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForPlayerIdMapping",
  /*#__PURE__*/
  function () {
    var _ref130 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee112(t2, e2) {
      var a;
      return _regeneratorRuntime.wrap(function _callee112$(_context113) {
        while (1) {
          switch (_context113.prev = _context113.next) {
            case 0:
              _context113.prev = 0;
              _context113.next = 3;
              return _this55.idMapping.getEntityIdsBySchemaId([t2], "player", "native");

            case 3:
              t2 = _context113.sent.player[0];
              _context113.next = 6;
              return _this55.getNextMatchForPlayer(t2, e2);

            case 6:
              a = _context113.sent;
              _context113.next = 9;
              return _this55.idMapping.remapEntities(a, "match");

            case 9:
              return _context113.abrupt("return", _context113.sent);

            case 12:
              _context113.prev = 12;
              _context113.t0 = _context113["catch"](0);
              throw console.warn("There was a problem browsing the next match for player:".concat(t2), _context113.t0), _context113.t0;

            case 15:
            case "end":
              return _context113.stop();
          }
        }
      }, _callee112, null, [[0, 12]]);
    }));

    return function (_x143, _x144) {
      return _ref130.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref131 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee113(t2, e2) {
      var _i28;

      return _regeneratorRuntime.wrap(function _callee113$(_context114) {
        while (1) {
          switch (_context114.prev = _context114.next) {
            case 0:
              _context114.prev = 0;
              e2 = e2 || false;
              _context114.next = 4;
              return _this55.https.getNextMatchForPlayer(t2, e2);

            case 4:
              _i28 = _context114.sent;
              _context114.next = 7;
              return _this55.footballService.setAvailableMarketsForMatch(_i28);

            case 7:
              return _context114.abrupt("return", _context114.sent);

            case 10:
              _context114.prev = 10;
              _context114.t0 = _context114["catch"](0);
              throw console.warn("There was a problem retrieving the next match for player: ".concat(t2), _context114.t0), _context114.t0;

            case 13:
            case "end":
              return _context114.stop();
          }
        }
      }, _callee113, null, [[0, 10]]);
    }));

    return function (_x145, _x146) {
      return _ref131.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForPlayerIdMapping",
  /*#__PURE__*/
  function () {
    var _ref132 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee114(t2, e2) {
      var a;
      return _regeneratorRuntime.wrap(function _callee114$(_context115) {
        while (1) {
          switch (_context115.prev = _context115.next) {
            case 0:
              _context115.prev = 0;
              _context115.next = 3;
              return _this55.idMapping.getEntityIdsBySchemaId([t2], "player", "native");

            case 3:
              t2 = _context115.sent.player[0];
              _context115.next = 6;
              return _this55.getPrevMatchForPlayer(t2, e2);

            case 6:
              a = _context115.sent;
              _context115.next = 9;
              return _this55.idMapping.remapEntities(a, "match");

            case 9:
              return _context115.abrupt("return", _context115.sent);

            case 12:
              _context115.prev = 12;
              _context115.t0 = _context115["catch"](0);
              throw console.warn("There was a problem browsing the previous match for player:".concat(t2), _context115.t0), _context115.t0;

            case 15:
            case "end":
              return _context115.stop();
          }
        }
      }, _callee114, null, [[0, 12]]);
    }));

    return function (_x147, _x148) {
      return _ref132.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref133 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee115(t2, e2) {
      var _i29;

      return _regeneratorRuntime.wrap(function _callee115$(_context116) {
        while (1) {
          switch (_context116.prev = _context116.next) {
            case 0:
              _context116.prev = 0;
              e2 = e2 || false;
              _context116.next = 4;
              return _this55.https.getPrevMatchForPlayer(t2, e2);

            case 4:
              _i29 = _context116.sent;
              _context116.next = 7;
              return _this55.footballService.setAvailableMarketsForMatch(_i29);

            case 7:
              return _context116.abrupt("return", _context116.sent);

            case 10:
              _context116.prev = 10;
              _context116.t0 = _context116["catch"](0);
              throw console.warn("There was a problem retrieving the previous match for player: ".concat(t2), _context116.t0), _context116.t0;

            case 13:
            case "end":
              return _context116.stop();
          }
        }
      }, _callee115, null, [[0, 10]]);
    }));

    return function (_x149, _x150) {
      return _ref133.apply(this, arguments);
    };
  }());

  this.idMapping = i, this.https = e2, this.footballService = new ct(t2);
};

var Gt = function Gt(t2) {
  var _this56 = this;

  _classCallCheck3(this, Gt);

  __publicField(this, "countryIds", null);

  __publicField(this, "competitionIds", null);

  __publicField(this, "matchIds", null);

  __publicField(this, "status", null);

  __publicField(this, "teamIds", null);

  __publicField(this, "fromDate", null);

  __publicField(this, "toDate", null);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "sortField", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this56.countryIds && (t2 = t2 + "&", t2 = t2 + "countries=".concat(_this56.countryIds.join(","))), _this56.competitionIds && (t2 = t2 + "&", t2 = t2 + "competitions=".concat(_this56.competitionIds.join(","))), _this56.matchIds && (t2 = t2 + "&", t2 = t2 + "matches=".concat(_this56.matchIds.join(","))), _this56.status && (t2 = t2 + "&", t2 = t2 + "status=".concat(_this56.status)), _this56.teamIds && (t2 = t2 + "&", t2 = t2 + "teams=".concat(_this56.teamIds.join(","))), _this56.fromDate && (t2 = t2 + "&", t2 = t2 + "from_date=".concat(_this56.fromDate)), _this56.toDate && (t2 = t2 + "&", t2 = t2 + "to_date=".concat(_this56.toDate)), _this56.limit && (t2 = t2 + "&", t2 = t2 + "limit=".concat(_this56.limit)), _this56.page && (t2 = t2 + "&", t2 = t2 + "page=".concat(_this56.page)), _this56.sortField && (t2 = t2 + "&", t2 = t2 + "sort_field=".concat(_this56.sortField)), _this56.sortOrder && (t2 = t2 + "&", t2 = t2 + "sort_order=".concat(_this56.sortOrder)), t2;
  });

  this.countryIds = t2.countryIds ? t2.countryIds : null, this.competitionIds = t2.competitionIds ? t2.competitionIds : null, this.matchIds = t2.matchIds ? t2.matchIds : null, this.status = t2.status ? t2.status : null, this.teamIds = t2.teamIds ? t2.teamIds : null, this.fromDate = t2.fromDate ? t2.fromDate : null, this.toDate = t2.toDate ? t2.toDate : null, this.limit = t2.limit ? t2.limit : null, this.page = t2.page ? t2.page : null, this.sortField = t2.sortField ? t2.sortField : null, this.sortOrder = t2.sortOrder ? t2.sortOrder : null;
};

var mt = function mt(t2, e2, i) {
  var _this57 = this;

  _classCallCheck3(this, mt);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "footballService", null);

  __publicField(this, "getMatchesIdMapping",
  /*#__PURE__*/
  function () {
    var _ref134 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee116(t2, e2) {
      var a, _a6, _a7, _a8, _i30;

      return _regeneratorRuntime.wrap(function _callee116$(_context117) {
        while (1) {
          switch (_context117.prev = _context117.next) {
            case 0:
              _context117.prev = 0;

              if (!t2) {
                _context117.next = 22;
                break;
              }

              if (!(t2 = new Gt(t2), t2.countryIds)) {
                _context117.next = 7;
                break;
              }

              _context117.next = 5;
              return _this57.idMapping.getEntityIdsBySchemaId(t2.countryIds, "country", "native");

            case 5:
              a = _context117.sent;
              t2.countryIds = a.country;

            case 7:
              if (!t2.competitionIds) {
                _context117.next = 12;
                break;
              }

              _context117.next = 10;
              return _this57.idMapping.getEntityIdsBySchemaId(t2.competitionIds, "competition", "native");

            case 10:
              _a6 = _context117.sent;
              t2.competitionIds = _a6.competition;

            case 12:
              if (!t2.matchIds) {
                _context117.next = 17;
                break;
              }

              _context117.next = 15;
              return _this57.idMapping.getEntityIdsBySchemaId(t2.matchIds, "match", "native");

            case 15:
              _a7 = _context117.sent;
              t2.matchIds = _a7.match;

            case 17:
              if (!t2.teamIds) {
                _context117.next = 22;
                break;
              }

              _context117.next = 20;
              return _this57.idMapping.getEntityIdsBySchemaId(t2.teamIds, "team", "native");

            case 20:
              _a8 = _context117.sent;
              t2.teamIds = _a8.team;

            case 22:
              _context117.next = 24;
              return _this57.getMatches(t2, e2);

            case 24:
              _i30 = _context117.sent;
              _context117.next = 27;
              return _this57.footballService.setAvailableMarketsForMatch(_toConsumableArray3(_i30.data));

            case 27:
              _i30.data = _context117.sent;
              _context117.next = 30;
              return _this57.idMapping.remapEntities(_i30.data, "match");

            case 30:
              _i30.data = _context117.sent;
              return _context117.abrupt("return", _i30);

            case 34:
              _context117.prev = 34;
              _context117.t0 = _context117["catch"](0);
              throw console.warn("There was a problem browsing the matches", _context117.t0), _context117.t0;

            case 37:
            case "end":
              return _context117.stop();
          }
        }
      }, _callee116, null, [[0, 34]]);
    }));

    return function (_x151, _x152) {
      return _ref134.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchesWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref135 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee117(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee117$(_context118) {
        while (1) {
          switch (_context118.prev = _context118.next) {
            case 0:
              e2 = t2.length;
              i = new Gt({
                matchIds: t2,
                limit: e2
              });
              _context118.next = 4;
              return _this57.getMatches(i);

            case 4:
              a = _context118.sent;
              a.data.sort(function (r2, s) {
                return r2.id.localeCompare(s.id);
              });
              _context118.next = 8;
              return _this57.idMapping.remapEntities(a.data, "match");

            case 8:
              return _context118.abrupt("return", _context118.sent);

            case 9:
            case "end":
              return _context118.stop();
          }
        }
      }, _callee117);
    }));

    return function (_x153) {
      return _ref135.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchesMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref136 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee118(t2) {
      var e2, i, a, r2, s, p2;
      return _regeneratorRuntime.wrap(function _callee118$(_context119) {
        while (1) {
          switch (_context119.prev = _context119.next) {
            case 0:
              e2 = {}, i = Pt(t2);
              i.sort(function (r2, s) {
                return r2.localeCompare(s);
              });
              _context119.next = 4;
              return _this57.getMatchesWithNativeIds(i);

            case 4:
              a = _context119.sent;

              if (!(i.length !== a.length)) {
                _context119.next = 12;
                break;
              }

              r2 = new Gt({
                matchIds: i,
                limit: i.length
              });
              _context119.next = 9;
              return _this57.getMatches(r2);

            case 9:
              s = _context119.sent;
              p2 = i.filter(function (n2) {
                if (s.data.every(function (l2) {
                  return l2.id !== n2;
                })) return n2;
              });
              i = i.filter(function (n2) {
                if (!p2.includes(n2)) return n2;
              });

            case 12:
              return _context119.abrupt("return", (i.forEach(function (r2, s) {
                return e2[r2] = a[s];
              }), e2));

            case 13:
            case "end":
              return _context119.stop();
          }
        }
      }, _callee118);
    }));

    return function (_x154) {
      return _ref136.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatches",
  /*#__PURE__*/
  function () {
    var _ref137 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee119(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee119$(_context120) {
        while (1) {
          switch (_context120.prev = _context120.next) {
            case 0:
              _context120.prev = 0;
              e2 = e2 || false;
              _context120.next = 4;
              return _this57.https.getMatches(t2, e2);

            case 4:
              return _context120.abrupt("return", _context120.sent);

            case 7:
              _context120.prev = 7;
              _context120.t0 = _context120["catch"](0);
              throw console.warn("There was a problem retrieving the matches", _context120.t0), _context120.t0;

            case 10:
            case "end":
              return _context120.stop();
          }
        }
      }, _callee119, null, [[0, 7]]);
    }));

    return function (_x155, _x156) {
      return _ref137.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchIdMapping",
  /*#__PURE__*/
  function () {
    var _ref138 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee120(t2, e2) {
      var _i31, a, r2;

      return _regeneratorRuntime.wrap(function _callee120$(_context121) {
        while (1) {
          switch (_context121.prev = _context121.next) {
            case 0:
              _context121.prev = 0;
              _context121.next = 3;
              return _this57.idMapping.getEntityIdsBySchemaId([t2], "match", "native");

            case 3:
              _i31 = _context121.sent;
              _context121.next = 6;
              return _this57.getMatchById(_i31.match[0], e2);

            case 6:
              a = _context121.sent;
              _context121.next = 9;
              return _this57.footballService.setAvailableMarketsForMatch(a);

            case 9:
              r2 = _context121.sent;
              _context121.next = 12;
              return _this57.idMapping.remapEntities(r2, "match");

            case 12:
              return _context121.abrupt("return", _context121.sent);

            case 15:
              _context121.prev = 15;
              _context121.t0 = _context121["catch"](0);
              throw console.warn("There was a problem browsing the following match: ".concat(t2), _context121.t0), _context121.t0;

            case 18:
            case "end":
              return _context121.stop();
          }
        }
      }, _callee120, null, [[0, 15]]);
    }));

    return function (_x157, _x158) {
      return _ref138.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchById",
  /*#__PURE__*/
  function () {
    var _ref139 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee121(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee121$(_context122) {
        while (1) {
          switch (_context122.prev = _context122.next) {
            case 0:
              _context122.prev = 0;
              e2 = e2 || false;
              _context122.next = 4;
              return _this57.https.getMatchById(t2, e2);

            case 4:
              return _context122.abrupt("return", _context122.sent);

            case 7:
              _context122.prev = 7;
              _context122.t0 = _context122["catch"](0);
              throw console.warn("There was a problem retrieving the following match: ".concat(t2), _context122.t0), _context122.t0;

            case 10:
            case "end":
              return _context122.stop();
          }
        }
      }, _callee121, null, [[0, 7]]);
    }));

    return function (_x159, _x160) {
      return _ref139.apply(this, arguments);
    };
  }());

  this.https = e2, this.idMapping = i, this.footballService = new ct(t2);
};

var Ri = function Ri(t2) {
  var _this58 = this;

  _classCallCheck3(this, Ri);

  __publicField(this, "entities", null);

  __publicField(this, "query", null);

  __publicField(this, "scope", null);

  __publicField(this, "constructFilterUrl", function () {
    var t2 = "";
    return _this58.entities && (t2 = t2 + "&", t2 = t2 + "entities=".concat(_this58.entities.join(","))), _this58.query && (t2 = t2 + "&", t2 = t2 + "q=".concat(_this58.query)), _this58.scope && (t2 = t2 + "&", t2 = t2 + "scope=".concat(_this58.scope.join(","))), t2;
  });

  this.entities = t2.entities ? t2.entities : null, this.query = t2.query ? t2.query : null, this.scope = t2.scope ? t2.scope : null;
};

var Si = function Si(t2, e2) {
  var _this59 = this;

  _classCallCheck3(this, Si);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "searchIdMapping",
  /*#__PURE__*/
  function () {
    var _ref140 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee122(t2, e2) {
      var a, _i32, _a9, _a10, _a11;

      return _regeneratorRuntime.wrap(function _callee122$(_context123) {
        while (1) {
          switch (_context123.prev = _context123.next) {
            case 0:
              _context123.prev = 0;

              if (!(t2 = new Ri(t2), t2.scope)) {
                _context123.next = 6;
                break;
              }

              _context123.next = 4;
              return _this59.idMapping.getEntityIdsBySchemaId(t2.scope, "competition", "native");

            case 4:
              a = _context123.sent;
              t2.scope = a.competition;

            case 6:
              _context123.next = 8;
              return _this59.search(t2, e2);

            case 8:
              _i32 = _context123.sent;

              if (!(_i32.teams && _i32.teams.length > 0)) {
                _context123.next = 14;
                break;
              }

              _context123.next = 12;
              return _this59.idMapping.remapEntities(_i32.teams, "team");

            case 12:
              _a9 = _context123.sent;
              _i32.teams = _a9;

            case 14:
              if (!(_i32.players && _i32.players.length > 0)) {
                _context123.next = 19;
                break;
              }

              _context123.next = 17;
              return _this59.idMapping.remapEntities(_i32.players, "player");

            case 17:
              _a10 = _context123.sent;
              _i32.players = _a10;

            case 19:
              if (!(_i32.competitions && _i32.competitions.length > 0)) {
                _context123.next = 24;
                break;
              }

              _context123.next = 22;
              return _this59.idMapping.remapEntities(_i32.competitions, "competition");

            case 22:
              _a11 = _context123.sent;
              _i32.competitions = _a11;

            case 24:
              return _context123.abrupt("return", _i32);

            case 27:
              _context123.prev = 27;
              _context123.t0 = _context123["catch"](0);
              throw console.warn("There was a problem with browsing the search result", _context123.t0), _context123.t0;

            case 30:
            case "end":
              return _context123.stop();
          }
        }
      }, _callee122, null, [[0, 27]]);
    }));

    return function (_x161, _x162) {
      return _ref140.apply(this, arguments);
    };
  }());

  __publicField(this, "search",
  /*#__PURE__*/
  function () {
    var _ref141 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee123(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee123$(_context124) {
        while (1) {
          switch (_context124.prev = _context124.next) {
            case 0:
              _context124.prev = 0;
              _context124.next = 3;
              return _this59.https.search(t2, e2);

            case 3:
              return _context124.abrupt("return", _context124.sent);

            case 6:
              _context124.prev = 6;
              _context124.t0 = _context124["catch"](0);
              throw console.warn("There was a problem retrieving the search response", _context124.t0), _context124.t0;

            case 9:
            case "end":
              return _context124.stop();
          }
        }
      }, _callee123, null, [[0, 6]]);
    }));

    return function (_x163, _x164) {
      return _ref141.apply(this, arguments);
    };
  }());

  this.https = t2, this.idMapping = e2;
};

var Vt = function Vt(t2, e2, i, a) {
  var _this60 = this;

  _classCallCheck3(this, Vt);

  __publicField(this, "countriesFacade", null);

  __publicField(this, "competitionsFacade", null);

  __publicField(this, "teamsFacade", null);

  __publicField(this, "playerFacade", null);

  __publicField(this, "matchFacade", null);

  __publicField(this, "searchFacade", null);

  __publicField(this, "getCountries",
  /*#__PURE__*/
  function () {
    var _ref142 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee124(t2) {
      return _regeneratorRuntime.wrap(function _callee124$(_context125) {
        while (1) {
          switch (_context125.prev = _context125.next) {
            case 0:
              return _context125.abrupt("return", _this60.countriesFacade.getCountriesWithIdMapping(t2));

            case 1:
            case "end":
              return _context125.stop();
          }
        }
      }, _callee124);
    }));

    return function (_x165) {
      return _ref142.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitions",
  /*#__PURE__*/
  function () {
    var _ref143 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee125(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee125$(_context126) {
        while (1) {
          switch (_context126.prev = _context126.next) {
            case 0:
              return _context126.abrupt("return", _this60.competitionsFacade.getCompetitionsIdMapping(t2, e2));

            case 1:
            case "end":
              return _context126.stop();
          }
        }
      }, _callee125);
    }));

    return function (_x166, _x167) {
      return _ref143.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionById",
  /*#__PURE__*/
  function () {
    var _ref144 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee126(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee126$(_context127) {
        while (1) {
          switch (_context127.prev = _context127.next) {
            case 0:
              return _context127.abrupt("return", _this60.competitionsFacade.getCompetitionByIdIdMapping(t2, e2));

            case 1:
            case "end":
              return _context127.stop();
          }
        }
      }, _callee126);
    }));

    return function (_x168, _x169) {
      return _ref144.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopCompetitions",
  /*#__PURE__*/
  function () {
    var _ref145 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee127(t2) {
      return _regeneratorRuntime.wrap(function _callee127$(_context128) {
        while (1) {
          switch (_context128.prev = _context128.next) {
            case 0:
              return _context128.abrupt("return", _this60.competitionsFacade.getTopCompetitionsIdMapping(t2));

            case 1:
            case "end":
              return _context128.stop();
          }
        }
      }, _callee127);
    }));

    return function (_x170) {
      return _ref145.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionsMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref146 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee128(t2) {
      return _regeneratorRuntime.wrap(function _callee128$(_context129) {
        while (1) {
          switch (_context129.prev = _context129.next) {
            case 0:
              _context129.next = 2;
              return _this60.competitionsFacade.getCompetitionsMapWithNativeIds(t2);

            case 2:
              return _context129.abrupt("return", _context129.sent);

            case 3:
            case "end":
              return _context129.stop();
          }
        }
      }, _callee128);
    }));

    return function (_x171) {
      return _ref146.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeams",
  /*#__PURE__*/
  function () {
    var _ref147 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee129(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee129$(_context130) {
        while (1) {
          switch (_context130.prev = _context130.next) {
            case 0:
              return _context130.abrupt("return", _this60.teamsFacade.getTeamsIdMapping(t2, e2));

            case 1:
            case "end":
              return _context130.stop();
          }
        }
      }, _callee129);
    }));

    return function (_x172, _x173) {
      return _ref147.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamById",
  /*#__PURE__*/
  function () {
    var _ref148 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee130(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee130$(_context131) {
        while (1) {
          switch (_context131.prev = _context131.next) {
            case 0:
              return _context131.abrupt("return", _this60.teamsFacade.getTeamByIdIdMapping(t2, e2));

            case 1:
            case "end":
              return _context131.stop();
          }
        }
      }, _callee130);
    }));

    return function (_x174, _x175) {
      return _ref148.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopTeams",
  /*#__PURE__*/
  function () {
    var _ref149 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee131(t2) {
      return _regeneratorRuntime.wrap(function _callee131$(_context132) {
        while (1) {
          switch (_context132.prev = _context132.next) {
            case 0:
              return _context132.abrupt("return", _this60.teamsFacade.getTopTeamsIdMapping(t2));

            case 1:
            case "end":
              return _context132.stop();
          }
        }
      }, _callee131);
    }));

    return function (_x176) {
      return _ref149.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref150 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee132(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee132$(_context133) {
        while (1) {
          switch (_context133.prev = _context133.next) {
            case 0:
              return _context133.abrupt("return", _this60.teamsFacade.getNextMatchForTeamIdMapping(t2, e2));

            case 1:
            case "end":
              return _context133.stop();
          }
        }
      }, _callee132);
    }));

    return function (_x177, _x178) {
      return _ref150.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref151 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee133(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee133$(_context134) {
        while (1) {
          switch (_context134.prev = _context134.next) {
            case 0:
              return _context134.abrupt("return", _this60.teamsFacade.getPrevMatchForTeamIdMapping(t2, e2));

            case 1:
            case "end":
              return _context134.stop();
          }
        }
      }, _callee133);
    }));

    return function (_x179, _x180) {
      return _ref151.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamsMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref152 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee134(t2) {
      return _regeneratorRuntime.wrap(function _callee134$(_context135) {
        while (1) {
          switch (_context135.prev = _context135.next) {
            case 0:
              _context135.next = 2;
              return _this60.teamsFacade.getTeamsMapWithNativeIds(t2);

            case 2:
              return _context135.abrupt("return", _context135.sent);

            case 3:
            case "end":
              return _context135.stop();
          }
        }
      }, _callee134);
    }));

    return function (_x181) {
      return _ref152.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayers",
  /*#__PURE__*/
  function () {
    var _ref153 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee135(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee135$(_context136) {
        while (1) {
          switch (_context136.prev = _context136.next) {
            case 0:
              return _context136.abrupt("return", _this60.playerFacade.getPlayersIdMapping(t2, e2));

            case 1:
            case "end":
              return _context136.stop();
          }
        }
      }, _callee135);
    }));

    return function (_x182, _x183) {
      return _ref153.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayerById",
  /*#__PURE__*/
  function () {
    var _ref154 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee136(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee136$(_context137) {
        while (1) {
          switch (_context137.prev = _context137.next) {
            case 0:
              return _context137.abrupt("return", _this60.playerFacade.getPlayerIdMapping(t2, e2));

            case 1:
            case "end":
              return _context137.stop();
          }
        }
      }, _callee136);
    }));

    return function (_x184, _x185) {
      return _ref154.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopPlayers",
  /*#__PURE__*/
  function () {
    var _ref155 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee137(t2) {
      return _regeneratorRuntime.wrap(function _callee137$(_context138) {
        while (1) {
          switch (_context138.prev = _context138.next) {
            case 0:
              return _context138.abrupt("return", _this60.playerFacade.getTopPlayersIdMapping(t2));

            case 1:
            case "end":
              return _context138.stop();
          }
        }
      }, _callee137);
    }));

    return function (_x186) {
      return _ref155.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref156 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee138(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee138$(_context139) {
        while (1) {
          switch (_context139.prev = _context139.next) {
            case 0:
              return _context139.abrupt("return", _this60.playerFacade.getNextMatchForPlayerIdMapping(t2, e2));

            case 1:
            case "end":
              return _context139.stop();
          }
        }
      }, _callee138);
    }));

    return function (_x187, _x188) {
      return _ref156.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref157 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee139(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee139$(_context140) {
        while (1) {
          switch (_context140.prev = _context140.next) {
            case 0:
              return _context140.abrupt("return", _this60.playerFacade.getPrevMatchForPlayerIdMapping(t2, e2));

            case 1:
            case "end":
              return _context140.stop();
          }
        }
      }, _callee139);
    }));

    return function (_x189, _x190) {
      return _ref157.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayersMapWithNativeIds",
  /*#__PURE__*/
  function () {
    var _ref158 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee140(t2) {
      return _regeneratorRuntime.wrap(function _callee140$(_context141) {
        while (1) {
          switch (_context141.prev = _context141.next) {
            case 0:
              return _context141.abrupt("return", _this60.playerFacade.getPlayersMapWithNativeIds(t2));

            case 1:
            case "end":
              return _context141.stop();
          }
        }
      }, _callee140);
    }));

    return function (_x191) {
      return _ref158.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatches",
  /*#__PURE__*/
  function () {
    var _ref159 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee141(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee141$(_context142) {
        while (1) {
          switch (_context142.prev = _context142.next) {
            case 0:
              return _context142.abrupt("return", _this60.matchFacade.getMatchesIdMapping(t2, e2));

            case 1:
            case "end":
              return _context142.stop();
          }
        }
      }, _callee141);
    }));

    return function (_x192, _x193) {
      return _ref159.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchById",
  /*#__PURE__*/
  function () {
    var _ref160 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee142(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee142$(_context143) {
        while (1) {
          switch (_context143.prev = _context143.next) {
            case 0:
              return _context143.abrupt("return", _this60.matchFacade.getMatchIdMapping(t2, e2));

            case 1:
            case "end":
              return _context143.stop();
          }
        }
      }, _callee142);
    }));

    return function (_x194, _x195) {
      return _ref160.apply(this, arguments);
    };
  }());

  __publicField(this, "search",
  /*#__PURE__*/
  function () {
    var _ref161 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee143(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee143$(_context144) {
        while (1) {
          switch (_context144.prev = _context144.next) {
            case 0:
              return _context144.abrupt("return", _this60.searchFacade.searchIdMapping(t2, e2));

            case 1:
            case "end":
              return _context144.stop();
          }
        }
      }, _callee143);
    }));

    return function (_x196, _x197) {
      return _ref161.apply(this, arguments);
    };
  }());

  this.countriesFacade = new mi(e2, i, a), this.competitionsFacade = new ui(e2, i, a), this.teamsFacade = new Ei(t2, i, a), this.playerFacade = new dt(t2, i, a), this.matchFacade = new mt(t2, i, a), this.searchFacade = new Si(i, a);
};

var Ci = function Ci() {
  _classCallCheck3(this, Ci);

  __publicField(this, "id", "");

  __publicField(this, "alias", "");

  __publicField(this, "countryCode", "");

  __publicField(this, "assets", null);

  __publicField(this, "name", "");
};

var S = function S() {
  var _this61 = this;

  _classCallCheck3(this, S);

  __publicField(this, "countriesFromResponse", function (t2) {
    if (t2) return t2.map(function (e2) {
      return _this61.countryFromResponse(e2);
    });
  });

  __publicField(this, "countryFromResponse", function (t2) {
    try {
      if (t2) {
        var e2 = new Ci();
        return e2.id = t2.id, e2.alias = t2.alias, e2.assets = t2.assets, e2.countryCode = t2.country_code, e2.name = t2.name, e2;
      }
    } catch (e2) {
      throw e2;
    }

    return null;
  });
};

var Ai = function Ai() {
  _classCallCheck3(this, Ai);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "gender", "");

  __publicField(this, "assets", null);

  __publicField(this, "type", "");

  __publicField(this, "name", "");
};

var B =
/*#__PURE__*/
function () {
  function B() {
    _classCallCheck3(this, B);

    __publicField(this, "countryRemapper", null);

    this.countryRemapper = new S();
  }

  _createClass3(B, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Ai();
        return e2.id = t2.id, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.gender = t2.gender, e2.assets = t2.assets, e2.type = t2.type, e2.name = t2.name, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the competition response", e2), e2;
      }
    }
  }]);

  return B;
}();

var Li = function Li() {
  _classCallCheck3(this, Li);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "gender", "");

  __publicField(this, "assets", null);

  __publicField(this, "type", "");

  __publicField(this, "name", "");

  __publicField(this, "participants", []);
};

var Oi = function Oi() {
  _classCallCheck3(this, Oi);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "gender", "");

  __publicField(this, "assets", null);

  __publicField(this, "name", "");

  __publicField(this, "code", "");

  __publicField(this, "national", false);

  __publicField(this, "fullName", "");

  __publicField(this, "shortName", "");

  __publicField(this, "isDeleted", false);
};

var A$1 =
/*#__PURE__*/
function () {
  function A$1() {
    _classCallCheck3(this, A$1);

    __publicField(this, "countryRemapper", null);

    this.countryRemapper = new S();
  }

  _createClass3(A$1, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Oi();
        return e2.id = t2.id, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.gender = t2.gender, e2.assets = t2.assets, e2.code = t2.code, e2.national = t2.national, e2.fullName = t2.full_name, e2.shortName = t2.short_name, e2.name = t2.name, e2.isDeleted = t2.is_deleted, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping teams response", e2), e2;
      }
    }
  }]);

  return A$1;
}();

var Di =
/*#__PURE__*/
function () {
  function Di() {
    _classCallCheck3(this, Di);

    __publicField(this, "countryRemapper", null);

    __publicField(this, "teamBasicRemapper", null);

    this.countryRemapper = new S(), this.teamBasicRemapper = new A$1();
  }

  _createClass3(Di, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this62 = this;

      try {
        var e2 = new Li();
        return e2.id = t2.id, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.gender = t2.gender, e2.assets = t2.assets, e2.type = t2.type, e2.name = t2.name, e2.participants = t2.participants.map(function (i) {
          return _this62.teamBasicRemapper.fromResponse(i);
        }), e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the competition response", e2), e2;
      }
    }
  }]);

  return Di;
}();

var xi = function xi() {
  _classCallCheck3(this, xi);

  __publicField(this, "primary", null);

  __publicField(this, "secondary", null);

  __publicField(this, "tertiary", null);
};

var Bi = function Bi() {
  _classCallCheck3(this, Bi);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "gender", "");

  __publicField(this, "assets", null);

  __publicField(this, "name", "");

  __publicField(this, "competitions", []);

  __publicField(this, "code", "");

  __publicField(this, "national", false);

  __publicField(this, "fullName", "");

  __publicField(this, "shortName", "");

  __publicField(this, "isDeleted", false);

  __publicField(this, "colors", new xi());

  __publicField(this, "squad", []);
};

var Ni = function Ni() {
  _classCallCheck3(this, Ni);

  __publicField(this, "id", "");

  __publicField(this, "startDate", "");

  __publicField(this, "endDate", "");

  __publicField(this, "shirtNumber");

  __publicField(this, "loan", false);

  __publicField(this, "position", "");

  __publicField(this, "country", null);

  __publicField(this, "name", "");

  __publicField(this, "assets", null);

  __publicField(this, "birthDate", "");
};

var Ui =
/*#__PURE__*/
function () {
  function Ui() {
    _classCallCheck3(this, Ui);

    __publicField(this, "countryRemapper", null);

    this.countryRemapper = new S();
  }

  _createClass3(Ui, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Ni();
        return e2.id = t2.id, e2.startDate = t2.start_date, e2.endDate = t2.end_date, e2.shirtNumber = t2.shirt_number, e2.loan = t2.loan, e2.position = t2.position, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.name = t2.name, e2.assets = t2.assets, e2.birthDate = t2.birth_date, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the player from squad", e2), e2;
      }
    }
  }]);

  return Ui;
}();

var Hi =
/*#__PURE__*/
function () {
  function Hi() {
    _classCallCheck3(this, Hi);

    __publicField(this, "countryRemapper", null);

    __publicField(this, "competitionRemapper", null);

    __publicField(this, "playerRemapper", null);

    this.countryRemapper = new S(), this.competitionRemapper = new B(), this.playerRemapper = new Ui();
  }

  _createClass3(Hi, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this63 = this;

      try {
        var e2 = new Bi();
        return e2.id = t2.id, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.gender = t2.gender, e2.assets = t2.assets, e2.code = t2.code, e2.national = t2.national, e2.fullName = t2.full_name, e2.shortName = t2.short_name, e2.name = t2.name, e2.isDeleted = t2.is_deleted, e2.competitions = t2.competitions ? t2.competitions.map(function (i) {
          return _this63.competitionRemapper.fromResponse(i);
        }) : [], e2.colors = t2.colors ? t2.colors : e2.colors, e2.squad = t2.squad ? t2.squad.map(function (i) {
          return _this63.playerRemapper.fromResponse(i);
        }) : [], e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping team response", e2), e2;
      }
    }
  }]);

  return Hi;
}();

var ki = function ki() {
  _classCallCheck3(this, ki);

  __publicField(this, "id", "");

  __publicField(this, "kickoffAt", "");

  __publicField(this, "finishedAt", "");

  __publicField(this, "updatedAt", "");

  __publicField(this, "availableMarkets", null);

  __publicField(this, "homeTeam", null);

  __publicField(this, "awayTeam", null);

  __publicField(this, "isDeleted", false);

  __publicField(this, "lineupsConfirmed", false);

  __publicField(this, "startedAt", "");

  __publicField(this, "minute", "");

  __publicField(this, "scores", null);

  __publicField(this, "context", {
    competition: null
  });

  __publicField(this, "status", {
    type: null,
    subType: null
  });
};

var Gi = function Gi() {
  _classCallCheck3(this, Gi);

  __publicField(this, "ftScore", null);

  __publicField(this, "htScore", null);

  __publicField(this, "aetScore", null);

  __publicField(this, "aggScore", null);

  __publicField(this, "penScore", null);
};

var $t =
/*#__PURE__*/
function () {
  function $t() {
    _classCallCheck3(this, $t);

    __publicField(this, "statEntityFromResponse", function (t2) {
      return {
        homeGoals: t2.home_goals,
        awayGoals: t2.away_goals
      };
    });
  }

  _createClass3($t, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Gi();
        return e2.ftScore = this.statEntityFromResponse(t2.ft_score), e2.htScore = this.statEntityFromResponse(t2.ht_score), e2.aetScore = this.statEntityFromResponse(t2.aet_score), e2.aggScore = this.statEntityFromResponse(t2.agg_score), e2.penScore = this.statEntityFromResponse(t2.pen_score), e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the scores", e2), e2;
      }
    }
  }]);

  return $t;
}();

var Vi =
/*#__PURE__*/
function () {
  function Vi() {
    _classCallCheck3(this, Vi);

    __publicField(this, "teamRemapper", null);

    __publicField(this, "competitionRemapper", null);

    __publicField(this, "scoresRemapper", null);

    this.teamRemapper = new A$1(), this.competitionRemapper = new B(), this.scoresRemapper = new $t();
  }

  _createClass3(Vi, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new ki();
        return e2.id = t2.id, e2.kickoffAt = t2.kickoff_at, e2.finishedAt = t2.finished_at, e2.updatedAt = t2.updated_at, e2.isDeleted = t2.is_deleted, e2.homeTeam = this.teamRemapper.fromResponse(t2.home_team), e2.awayTeam = this.teamRemapper.fromResponse(t2.away_team), e2.lineupsConfirmed = t2.lineups_confirmed, e2.startedAt = t2.started_at, e2.minute = t2.minute, e2.scores = this.scoresRemapper.fromResponse(t2.scores), e2.context = {
          competition: t2.context.competition ? this.competitionRemapper.fromResponse(t2.context.competition) : null
        }, e2.status = {
          type: t2.status.type,
          subType: t2.status.sub_type
        }, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the match response", e2), e2;
      }
    }
  }]);

  return Vi;
}();

var $ = function $() {
  _classCallCheck3(this, $);

  __publicField(this, "type", null);

  __publicField(this, "subType", null);
};

var $i = function $i() {
  _classCallCheck3(this, $i);

  __publicField(this, "id", "");

  __publicField(this, "kickoffAt", "");

  __publicField(this, "finishedAt", "");

  __publicField(this, "updatedAt", "");

  __publicField(this, "availableMarkets", null);

  __publicField(this, "isDeleted", false);

  __publicField(this, "homeTeam", null);

  __publicField(this, "awayTeam", null);

  __publicField(this, "lineupsConfirmed", false);

  __publicField(this, "startedAt", "");

  __publicField(this, "minute", "");

  __publicField(this, "scores", null);

  __publicField(this, "stats", null);

  __publicField(this, "context", {
    competition: null
  });

  __publicField(this, "timeline", []);

  __publicField(this, "status", new $());

  __publicField(this, "lineups", null);
};

var Wi = function Wi() {
  _classCallCheck3(this, Wi);

  __publicField(this, "corners", null);

  __publicField(this, "cornersFirstHalf", null);

  __publicField(this, "cornersSecondHalf", null);

  __publicField(this, "cornersExtraTime", null);

  __publicField(this, "crosses", null);

  __publicField(this, "crossesFirstHalf", null);

  __publicField(this, "crossesSecondHalf", null);

  __publicField(this, "crossesExtraTime", null);

  __publicField(this, "offside", null);

  __publicField(this, "offsideFirstHalf", null);

  __publicField(this, "offsideSecondHalf", null);

  __publicField(this, "offsideExtraTime", null);

  __publicField(this, "shotsOn", null);

  __publicField(this, "shotsOnFirstHalf", null);

  __publicField(this, "shotsOnSecondHalf", null);

  __publicField(this, "shotsOnExtraTime", null);

  __publicField(this, "throwIn", null);

  __publicField(this, "throwInFirstHalf", null);

  __publicField(this, "throwInSecondHalf", null);

  __publicField(this, "throwInExtraTime", null);

  __publicField(this, "redCards", null);

  __publicField(this, "redCardsFirstHalf", null);

  __publicField(this, "redCardsSecondHalf", null);

  __publicField(this, "redCardsExtraTime", null);

  __publicField(this, "shotsOff", null);

  __publicField(this, "shotsOffFirstHalf", null);

  __publicField(this, "shotsOffSecondHalf", null);

  __publicField(this, "shotsOffExtraTime", null);

  __publicField(this, "goalKicks", null);

  __publicField(this, "goalKicksFirstHalf", null);

  __publicField(this, "goalKicksSecondHalf", null);

  __publicField(this, "goalKicksExtraTime", null);

  __publicField(this, "possession", null);

  __publicField(this, "possessionFirstHalf", null);

  __publicField(this, "possessionSecondHalf", null);

  __publicField(this, "possessionExtraTime", null);

  __publicField(this, "treatments", null);

  __publicField(this, "treatmentsFirstHalf", null);

  __publicField(this, "treatmentsSecondHalf", null);

  __publicField(this, "treatmentsExtraTime", null);

  __publicField(this, "yellowCards", null);

  __publicField(this, "yellowCardsFirstHalf", null);

  __publicField(this, "yellowCardsSecondHalf", null);

  __publicField(this, "yellowCardsExtraTime", null);

  __publicField(this, "shotsBlocked", null);

  __publicField(this, "shotsBlockedFirstHalf", null);

  __publicField(this, "shotsBlockedSecondHalf", null);

  __publicField(this, "shotsBlockedExtraTime", null);

  __publicField(this, "substitutions", null);

  __publicField(this, "substitutionsFirstHalf", null);

  __publicField(this, "substitutionsSecondHalf", null);

  __publicField(this, "substitutionsExtraTime", null);

  __publicField(this, "counterAttacks", null);

  __publicField(this, "counterAttacksFirstHalf", null);

  __publicField(this, "counterAttacksSecondHalf", null);

  __publicField(this, "counterAttacksExtraTime", null);

  __publicField(this, "foulsCommitted", null);

  __publicField(this, "foulsCommittedFirstHalf", null);

  __publicField(this, "foulsCommittedSecondHalf", null);

  __publicField(this, "foulsCommittedExtraTime", null);
};

var Ki =
/*#__PURE__*/
function () {
  function Ki() {
    _classCallCheck3(this, Ki);

    __publicField(this, "statEntityFromResponse", function (t2) {
      return {
        homeTeam: t2 ? t2.home_team : null,
        awayTeam: t2 ? t2.away_team : null
      };
    });
  }

  _createClass3(Ki, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Wi();
        return e2.corners = this.statEntityFromResponse(t2.corners), e2.cornersFirstHalf = this.statEntityFromResponse(t2.corners_1h), e2.cornersSecondHalf = this.statEntityFromResponse(t2.corners_2h), e2.cornersExtraTime = this.statEntityFromResponse(t2.corners_et), e2.crosses = this.statEntityFromResponse(t2.crosses), e2.crossesFirstHalf = this.statEntityFromResponse(t2.crosses_1h), e2.crossesSecondHalf = this.statEntityFromResponse(t2.crosses_2h), e2.crossesExtraTime = this.statEntityFromResponse(t2.crosses_et), e2.offside = this.statEntityFromResponse(t2.offside), e2.offsideFirstHalf = this.statEntityFromResponse(t2.offside_1h), e2.offsideSecondHalf = this.statEntityFromResponse(t2.offside_2h), e2.offsideExtraTime = this.statEntityFromResponse(t2.offside_et), e2.shotsOn = this.statEntityFromResponse(t2.shots_on), e2.shotsOnFirstHalf = this.statEntityFromResponse(t2.shots_on_1h), e2.shotsOnSecondHalf = this.statEntityFromResponse(t2.shots_on_2h), e2.shotsOnExtraTime = this.statEntityFromResponse(t2.shots_on_et), e2.throwIn = this.statEntityFromResponse(t2.throw_in), e2.throwInFirstHalf = this.statEntityFromResponse(t2.throw_in_1h), e2.throwInSecondHalf = this.statEntityFromResponse(t2.throw_in_2h), e2.throwInExtraTime = this.statEntityFromResponse(t2.throw_in_et), e2.redCards = this.statEntityFromResponse(t2.red_cards), e2.redCardsFirstHalf = this.statEntityFromResponse(t2.red_cards_1h), e2.redCardsSecondHalf = this.statEntityFromResponse(t2.red_cards_2h), e2.redCardsExtraTime = this.statEntityFromResponse(t2.red_cards_et), e2.shotsOff = this.statEntityFromResponse(t2.shots_off), e2.shotsOffFirstHalf = this.statEntityFromResponse(t2.shots_off_1h), e2.shotsOffSecondHalf = this.statEntityFromResponse(t2.shots_off_2h), e2.shotsOffExtraTime = this.statEntityFromResponse(t2.shots_off_et), e2.goalKicks = this.statEntityFromResponse(t2.goal_kicks), e2.goalKicksFirstHalf = this.statEntityFromResponse(t2.goal_kicks_1h), e2.goalKicksSecondHalf = this.statEntityFromResponse(t2.goal_kicks_2h), e2.goalKicksExtraTime = this.statEntityFromResponse(t2.goal_kicks_et), e2.possession = this.statEntityFromResponse(t2.possession), e2.possessionFirstHalf = this.statEntityFromResponse(t2.possession_1h), e2.possessionSecondHalf = this.statEntityFromResponse(t2.possession_2h), e2.possessionExtraTime = this.statEntityFromResponse(t2.possession_et), e2.treatments = this.statEntityFromResponse(t2.treatments), e2.treatmentsFirstHalf = this.statEntityFromResponse(t2.treatments_1h), e2.treatmentsSecondHalf = this.statEntityFromResponse(t2.treatments_2h), e2.treatmentsExtraTime = this.statEntityFromResponse(t2.treatments_et), e2.yellowCards = this.statEntityFromResponse(t2.yellow_cards), e2.yellowCardsFirstHalf = this.statEntityFromResponse(t2.yellow_cards_1h), e2.yellowCardsSecondHalf = this.statEntityFromResponse(t2.yellow_cards_2h), e2.yellowCardsExtraTime = this.statEntityFromResponse(t2.yellow_cards_et), e2.shotsBlocked = this.statEntityFromResponse(t2.shots_blocked), e2.shotsBlockedFirstHalf = this.statEntityFromResponse(t2.shots_blocked_1h), e2.shotsBlockedSecondHalf = this.statEntityFromResponse(t2.shots_blocked_2h), e2.shotsBlockedExtraTime = this.statEntityFromResponse(t2.shots_blocked_et), e2.substitutions = this.statEntityFromResponse(t2.substitutions), e2.substitutionsFirstHalf = this.statEntityFromResponse(t2.substitutions_1h), e2.substitutionsSecondHalf = this.statEntityFromResponse(t2.substitutions_2h), e2.substitutionsExtraTime = this.statEntityFromResponse(t2.substitutions_et), e2.counterAttacks = this.statEntityFromResponse(t2.counter_attacks), e2.counterAttacksFirstHalf = this.statEntityFromResponse(t2.counter_attacks_1h), e2.counterAttacksSecondHalf = this.statEntityFromResponse(t2.counter_attacks_2h), e2.counterAttacksExtraTime = this.statEntityFromResponse(t2.counter_attacks_et), e2.foulsCommitted = this.statEntityFromResponse(t2.fouls_committed), e2.foulsCommittedFirstHalf = this.statEntityFromResponse(t2.fouls_committed_1h), e2.foulsCommittedSecondHalf = this.statEntityFromResponse(t2.fouls_committed_2h), e2.foulsCommittedExtraTime = this.statEntityFromResponse(t2.fouls_committed_et), e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the stats", e2), e2;
      }
    }
  }]);

  return Ki;
}();

var Wt = function Wt() {
  _classCallCheck3(this, Wt);

  __publicField(this, "homeTeam", {
    players: []
  });

  __publicField(this, "awayTeam", {
    players: []
  });
};

var ji = function ji() {
  _classCallCheck3(this, ji);

  __publicField(this, "id", "");

  __publicField(this, "name", "");

  __publicField(this, "position", "");

  __publicField(this, "shirtNumber");

  __publicField(this, "assets", null);

  __publicField(this, "type", "");
};

var Kt =
/*#__PURE__*/
function () {
  function Kt() {
    _classCallCheck3(this, Kt);
  }

  _createClass3(Kt, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new ji();
        return e2.id = t2.id, e2.name = t2.name, e2.position = t2.position, e2.shirtNumber = t2.shirt_number, e2.assets = t2.assets, e2.type = t2.type, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the player from timeline", e2), e2;
      }
    }
  }]);

  return Kt;
}();

var qi =
/*#__PURE__*/
function () {
  function qi() {
    _classCallCheck3(this, qi);

    __publicField(this, "playerRemapper", null);

    this.playerRemapper = new Kt();
  }

  _createClass3(qi, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this64 = this;

      try {
        var e2 = new Wt();
        return e2.homeTeam.players = t2.home_team && t2.home_team.players ? t2.home_team.players.map(function (i) {
          return _this64.playerRemapper.fromResponse(i);
        }) : [], e2.awayTeam.players = t2.away_team && t2.away_team.players ? t2.away_team.players.map(function (i) {
          return _this64.playerRemapper.fromResponse(i);
        }) : [], e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the lineups", e2), e2;
      }
    }
  }]);

  return qi;
}();

var zi = function zi() {
  _classCallCheck3(this, zi);

  __publicField(this, "minute", "");

  __publicField(this, "type", "");

  __publicField(this, "teamId", "");

  __publicField(this, "player", null);

  __publicField(this, "relatedPlayer", null);

  __publicField(this, "updatedAt", "");
};

var Qi =
/*#__PURE__*/
function () {
  function Qi() {
    _classCallCheck3(this, Qi);

    __publicField(this, "playerRemapper", null);

    this.playerRemapper = new Kt();
  }

  _createClass3(Qi, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new zi();
        return e2.minute = t2.minute, e2.type = t2.type, e2.teamId = t2.team_id, e2.player = this.playerRemapper.fromResponse(t2.player), e2.relatedPlayer = t2.related_player ? this.playerRemapper.fromResponse(t2.related_player) : null, e2.updatedAt = t2.updated_at, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping timeline", e2), e2;
      }
    }
  }]);

  return Qi;
}();

var Xi =
/*#__PURE__*/
function () {
  function Xi() {
    _classCallCheck3(this, Xi);

    __publicField(this, "teamMapper", null);

    __publicField(this, "competitionsMapper", null);

    __publicField(this, "lineupsMapper", null);

    __publicField(this, "scoresMapper", null);

    __publicField(this, "statsMapper", null);

    __publicField(this, "timelineMapper", null);

    this.teamMapper = new A$1(), this.competitionsMapper = new B(), this.lineupsMapper = new qi(), this.scoresMapper = new $t(), this.statsMapper = new Ki(), this.timelineMapper = new Qi();
  }

  _createClass3(Xi, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this65 = this;

      try {
        var e2 = new $i();
        return e2.id = t2.id, e2.kickoffAt = t2.kickoff_at, e2.finishedAt = t2.finished_at, e2.updatedAt = t2.updated_at, e2.isDeleted = t2.is_deleted, e2.homeTeam = t2.home_team ? this.teamMapper.fromResponse(t2.home_team) : null, e2.awayTeam = t2.away_team ? this.teamMapper.fromResponse(t2.away_team) : null, e2.lineupsConfirmed = t2.lineups_confirmed, e2.startedAt = t2.started_at, e2.minute = t2.minute, e2.scores = this.scoresMapper.fromResponse(t2.scores), e2.stats = this.statsMapper.fromResponse(t2.stats), e2.context = {
          competition: this.competitionsMapper.fromResponse(t2.context.competition)
        }, e2.timeline = t2.timeline ? t2.timeline.map(function (i) {
          return _this65.timelineMapper.fromResponse(i);
        }) : [], e2.status = {
          type: t2.status.type,
          subType: t2.status.sub_type
        }, e2.lineups = t2.lineups ? this.lineupsMapper.fromResponse(t2.lineups) : new Wt(), e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping the match response", e2), e2;
      }
    }
  }]);

  return Xi;
}();

var Yi = function Yi() {
  _classCallCheck3(this, Yi);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "birthDate", "");

  __publicField(this, "firstName", "");

  __publicField(this, "lastName", "");

  __publicField(this, "name", "");

  __publicField(this, "position", "");

  __publicField(this, "assets", null);
};

var Ji =
/*#__PURE__*/
function () {
  function Ji() {
    _classCallCheck3(this, Ji);

    __publicField(this, "countryRemapper", null);

    this.countryRemapper = new S();
  }

  _createClass3(Ji, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      try {
        var e2 = new Yi();
        return e2.id = t2.id, e2.firstName = t2.first_name ? t2.first_name : null, e2.lastName = t2.last_name ? t2.last_name : null, e2.name = t2.name ? t2.name : null, e2.birthDate = t2.birth_date, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.assets = t2.assets, e2.position = t2.position, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping top player response", e2), e2;
      }
    }
  }]);

  return Ji;
}();

var Zi = function Zi() {
  _classCallCheck3(this, Zi);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "birthDate", "");

  __publicField(this, "firstName", "");

  __publicField(this, "lastName", "");

  __publicField(this, "name", "");

  __publicField(this, "position", "");

  __publicField(this, "assets", null);

  __publicField(this, "isDeleted", false);

  __publicField(this, "teams", []);
};

var jt =
/*#__PURE__*/
function () {
  function jt() {
    _classCallCheck3(this, jt);

    __publicField(this, "countryRemapper", null);

    __publicField(this, "teamRemapper", null);

    this.countryRemapper = new S(), this.teamRemapper = new A$1();
  }

  _createClass3(jt, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this66 = this;

      try {
        var e2 = new Zi();
        return e2.id = t2.id, e2.firstName = t2.first_name ? t2.first_name : null, e2.lastName = t2.last_name ? t2.last_name : null, e2.name = t2.name ? t2.name : null, e2.birthDate = t2.birth_date, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.assets = t2.assets, e2.teams = t2.teams ? t2.teams.map(function (i) {
          return _this66.teamRemapper.fromResponse(i);
        }) : [], e2.position = t2.position, e2.isDeleted = t2.is_deleted, e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping players response", e2), e2;
      }
    }
  }]);

  return jt;
}();

var ta = function ta() {
  _classCallCheck3(this, ta);

  __publicField(this, "id", "");

  __publicField(this, "country", null);

  __publicField(this, "birthDate", "");

  __publicField(this, "firstName", "");

  __publicField(this, "lastName", "");

  __publicField(this, "name", "");

  __publicField(this, "position", "");

  __publicField(this, "assets", null);

  __publicField(this, "isDeleted", false);

  __publicField(this, "competitions", []);

  __publicField(this, "teams", []);
};

var ea =
/*#__PURE__*/
function () {
  function ea() {
    _classCallCheck3(this, ea);

    __publicField(this, "countryRemapper", null);

    __publicField(this, "teamRemapper", null);

    __publicField(this, "competitionRemapper", null);

    this.countryRemapper = new S(), this.teamRemapper = new A$1(), this.competitionRemapper = new B();
  }

  _createClass3(ea, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this67 = this;

      try {
        var e2 = new ta();
        return e2.id = t2.id, e2.firstName = t2.first_name ? t2.first_name : null, e2.lastName = t2.last_name ? t2.last_name : null, e2.name = t2.name ? t2.name : null, e2.birthDate = t2.birth_date, e2.country = this.countryRemapper.countryFromResponse(t2.country), e2.assets = t2.assets, e2.teams = t2.teams ? t2.teams.map(function (i) {
          return _this67.teamRemapper.fromResponse(i);
        }) : [], e2.position = t2.position, e2.isDeleted = t2.is_deleted, e2.competitions = t2.competitions ? t2.competitions.map(function (i) {
          return _this67.competitionRemapper.fromResponse(i);
        }) : [], e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping player response", e2), e2;
      }
    }
  }]);

  return ea;
}();

var ia = function ia() {
  _classCallCheck3(this, ia);

  __publicField(this, "teams", null);

  __publicField(this, "players", null);

  __publicField(this, "competitions", null);
};

var aa =
/*#__PURE__*/
function () {
  function aa() {
    _classCallCheck3(this, aa);

    __publicField(this, "teamRemapper", null);

    __publicField(this, "playerRemapper", null);

    __publicField(this, "competitionremapper", null);

    this.teamRemapper = new A$1(), this.playerRemapper = new jt(), this.competitionremapper = new B();
  }

  _createClass3(aa, [{
    key: "fromResponse",
    value: function fromResponse(t2) {
      var _this68 = this;

      try {
        var e2 = new ia();
        return e2.teams = t2.teams ? t2.teams.map(function (i) {
          return _this68.teamRemapper.fromResponse(i);
        }) : [], e2.players = t2.players ? t2.players.map(function (i) {
          return _this68.playerRemapper.fromResponse(i);
        }) : [], e2.competitions = t2.competitions ? t2.competitions.map(function (i) {
          return _this68.competitionremapper.fromResponse(i);
        }) : [], e2;
      } catch (e2) {
        throw console.warn("There was a problem remapping search response", e2), e2;
      }
    }
  }]);

  return aa;
}();

var ut = function ut() {
  _classCallCheck3(this, ut);

  __publicField(this, "currentPage", null);

  __publicField(this, "itemsPerPage", null);

  __publicField(this, "totalItems", null);

  __publicField(this, "numberOfPages", null);
};

var W = function W() {
  _classCallCheck3(this, W);

  __publicField(this, "pagination", new ut());
};

var qt = function qt() {
  _classCallCheck3(this, qt);

  __publicField(this, "meta", new W());

  __publicField(this, "data", []);
};

var ra = function ra() {
  _classCallCheck3(this, ra);

  __publicField(this, "remapMetaProp", function (t2) {
    var e2 = new W();
    return e2.pagination.currentPage = t2.pagination.current_page, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.totalItems = t2.pagination.total_items, e2.pagination.numberOfPages = t2.pagination.number_of_pages, e2;
  });
};

var Z =
/*#__PURE__*/
function (_ref162) {
  _inherits3(Z, _ref162);

  function Z(t2) {
    var _this69;

    _classCallCheck3(this, Z);

    _this69 = _possibleConstructorReturn3(this, _getPrototypeOf4(Z).call(this, t2, R(t2.environment, "football")));

    __publicField(_assertThisInitialized3(_this69), "limitIds", 200);

    __publicField(_assertThisInitialized3(_this69), "countryRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "competitionBasicRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "competitionFullRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "teamBasicRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "teamFullRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "matchBasicRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "matchFullRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "playerBasicRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "playerFullRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "topPlayerRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "searchRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "footballMetaRemapper", null);

    __publicField(_assertThisInitialized3(_this69), "getCountries",
    /*#__PURE__*/
    function () {
      var _ref163 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee144(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee144$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                e2 = "There was a problem with the football countries request", i = "/countries".concat(_this69.apiSignInUrl), a = Date.now();
                t2 && (i += "&disable_cache=".concat(a));
                _context145.next = 4;
                return _this69.fetchWithoutAuth(i, e2);

              case 4:
                r2 = _context145.sent;
                return _context145.abrupt("return", _this69.countryRemapper.countriesFromResponse(r2.data));

              case 6:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee144);
      }));

      return function (_x198) {
        return _ref163.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getCompetitions",
    /*#__PURE__*/
    function () {
      var _ref164 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee145(t2, e2) {
        var i, a, r2, s, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, n2, l2, c2, _r8;

        return _regeneratorRuntime.wrap(function _callee145$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                i = Date.now(), a = "There was a problem with football competitions request";

                if (!(e2 = e2 || false, t2 && t2.competitionIds && t2.competitionIds.length > _this69.limitIds - 1)) {
                  _context146.next = 37;
                  break;
                }

                r2 = [], s = At(t2.competitionIds, _this69.limitIds);
                _iteratorNormalCompletion12 = true;
                _didIteratorError12 = false;
                _iteratorError12 = undefined;
                _context146.prev = 6;
                _iterator12 = s[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                  _context146.next = 20;
                  break;
                }

                n2 = _step12.value;
                t2.competitionIds = n2;
                l2 = "/competitions".concat(_this69.apiSignInUrl).concat(t2.constructFilterUrl());
                e2 && (l2 += "&disable_cache=".concat(i));
                _context146.next = 15;
                return _this69.fetchWithoutAuth(l2, a);

              case 15:
                c2 = _context146.sent;
                r2.push(c2.data.map(function (d2) {
                  return _this69.competitionBasicRemapper.fromResponse(d2);
                }));

              case 17:
                _iteratorNormalCompletion12 = true;
                _context146.next = 8;
                break;

              case 20:
                _context146.next = 26;
                break;

              case 22:
                _context146.prev = 22;
                _context146.t0 = _context146["catch"](6);
                _didIteratorError12 = true;
                _iteratorError12 = _context146.t0;

              case 26:
                _context146.prev = 26;
                _context146.prev = 27;

                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }

              case 29:
                _context146.prev = 29;

                if (!_didIteratorError12) {
                  _context146.next = 32;
                  break;
                }

                throw _iteratorError12;

              case 32:
                return _context146.finish(29);

              case 33:
                return _context146.finish(26);

              case 34:
                return _context146.abrupt("return", Array.prototype.concat.apply([], r2));

              case 37:
                _r8 = "/competitions".concat(_this69.apiSignInUrl);
                t2 && (_r8 += "".concat(t2.constructFilterUrl()));
                e2 && (_r8 += "&disable_cache=".concat(i));
                _context146.next = 42;
                return _this69.fetchWithoutAuth(_r8, a);

              case 42:
                _context146.t1 = function (p2) {
                  return _this69.competitionBasicRemapper.fromResponse(p2);
                };

                return _context146.abrupt("return", _context146.sent.data.map(_context146.t1));

              case 44:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee145, null, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function (_x199, _x200) {
        return _ref164.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getCompetitionById",
    /*#__PURE__*/
    function () {
      var _ref165 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee146(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee146$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                i = "/competitions/".concat(t2).concat(_this69.apiSignInUrl), a = "There was a problem with football competition by ID request", r2 = Date.now();
                e2 && (i += "&disable_cache=".concat(r2));
                _context147.next = 4;
                return _this69.fetchWithoutAuth(i, a);

              case 4:
                s = _context147.sent;
                return _context147.abrupt("return", _this69.competitionFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee146);
      }));

      return function (_x201, _x202) {
        return _ref165.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getTopCompetitions",
    /*#__PURE__*/
    function () {
      var _ref166 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee147(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee147$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                e2 = "There was a problem with top football competitions request", i = "/competitions/top".concat(_this69.apiSignInUrl), a = Date.now();
                t2 && (i += "&disable_cache=".concat(a));
                _context148.next = 4;
                return _this69.fetchWithoutAuth(i, e2);

              case 4:
                _context148.t0 = function (s) {
                  return _this69.competitionBasicRemapper.fromResponse(s);
                };

                return _context148.abrupt("return", _context148.sent.data.map(_context148.t0));

              case 6:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee147);
      }));

      return function (_x203) {
        return _ref166.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getTeams",
    /*#__PURE__*/
    function () {
      var _ref167 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee148(t2, e2) {
        var i, a, r2, s, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, n2, l2, c2, _r9, _s5, p2;

        return _regeneratorRuntime.wrap(function _callee148$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                i = Date.now(), a = "There was a problem with football teams request";

                if (!(t2 && t2.teamIds && t2.teamIds.length > _this69.limitIds)) {
                  _context149.next = 37;
                  break;
                }

                r2 = [], s = At(t2.teamIds, _this69.limitIds);
                _iteratorNormalCompletion13 = true;
                _didIteratorError13 = false;
                _iteratorError13 = undefined;
                _context149.prev = 6;
                _iterator13 = s[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                  _context149.next = 20;
                  break;
                }

                n2 = _step13.value;
                t2.teamIds = n2;
                l2 = "/teams".concat(_this69.apiSignInUrl).concat(t2.constructFilterUrl());
                e2 && (l2 += "disable_cache=".concat(i));
                _context149.next = 15;
                return _this69.fetchWithoutAuth(l2, a);

              case 15:
                c2 = _context149.sent;
                r2.push(c2.data.map(function (d2) {
                  return _this69.teamBasicRemapper.fromResponse(d2);
                }));

              case 17:
                _iteratorNormalCompletion13 = true;
                _context149.next = 8;
                break;

              case 20:
                _context149.next = 26;
                break;

              case 22:
                _context149.prev = 22;
                _context149.t0 = _context149["catch"](6);
                _didIteratorError13 = true;
                _iteratorError13 = _context149.t0;

              case 26:
                _context149.prev = 26;
                _context149.prev = 27;

                if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                  _iterator13.return();
                }

              case 29:
                _context149.prev = 29;

                if (!_didIteratorError13) {
                  _context149.next = 32;
                  break;
                }

                throw _iteratorError13;

              case 32:
                return _context149.finish(29);

              case 33:
                return _context149.finish(26);

              case 34:
                return _context149.abrupt("return", Array.prototype.concat.apply([], r2));

              case 37:
                _r9 = new qt(), _s5 = "/teams".concat(_this69.apiSignInUrl);
                t2 && (_s5 += "".concat(t2.constructFilterUrl())), e2 && (_s5 += "&disable_cache=".concat(i));
                _context149.next = 41;
                return _this69.fetchWithoutAuth(_s5, a);

              case 41:
                p2 = _context149.sent;
                return _context149.abrupt("return", (_r9.meta = _this69.footballMetaRemapper.remapMetaProp(p2.meta), _r9.data = p2.data.map(function (n2) {
                  return _this69.teamBasicRemapper.fromResponse(n2);
                }), _r9));

              case 43:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee148, null, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function (_x204, _x205) {
        return _ref167.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getTeamById",
    /*#__PURE__*/
    function () {
      var _ref168 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee149(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee149$(_context150) {
          while (1) {
            switch (_context150.prev = _context150.next) {
              case 0:
                i = "There was a problem with football team by ID request", a = "/teams/".concat(t2).concat(_this69.apiSignInUrl), r2 = Date.now();
                e2 && (a += "disable_cache=".concat(r2));
                _context150.next = 4;
                return _this69.fetchWithoutAuth(a, i);

              case 4:
                s = _context150.sent;
                return _context150.abrupt("return", _this69.teamFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context150.stop();
            }
          }
        }, _callee149);
      }));

      return function (_x206, _x207) {
        return _ref168.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getTopTeams",
    /*#__PURE__*/
    function () {
      var _ref169 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee150(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee150$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                e2 = "/teams/top".concat(_this69.apiSignInUrl), i = "There was a problem with top football teams request", a = Date.now();
                t2 && (e2 += "$disable_cache=".concat(a));
                _context151.next = 4;
                return _this69.fetchWithoutAuth(e2, i);

              case 4:
                r2 = _context151.sent;
                return _context151.abrupt("return", r2.data ? r2.data.map(function (s) {
                  return _this69.teamBasicRemapper.fromResponse(s);
                }) : []);

              case 6:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee150);
      }));

      return function (_x208) {
        return _ref169.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getNextMatchForTeam",
    /*#__PURE__*/
    function () {
      var _ref170 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee151(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee151$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                i = "/teams/".concat(t2, "/next-match").concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with next match for team request";
                e2 && (i += "&disable_cache=".concat(a));
                _context152.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context152.sent;
                return _context152.abrupt("return", _this69.matchFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee151);
      }));

      return function (_x209, _x210) {
        return _ref170.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getPrevMatchForTeam",
    /*#__PURE__*/
    function () {
      var _ref171 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee152(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee152$(_context153) {
          while (1) {
            switch (_context153.prev = _context153.next) {
              case 0:
                i = "/teams/".concat(t2, "/previous-match").concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with previous match for team request";
                e2 && (i += "disable_cache=".concat(a));
                _context153.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context153.sent;
                return _context153.abrupt("return", _this69.matchFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context153.stop();
            }
          }
        }, _callee152);
      }));

      return function (_x211, _x212) {
        return _ref171.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getPlayers",
    /*#__PURE__*/
    function () {
      var _ref172 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee153(t2, e2) {
        var i, a, r2, s, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, n2, l2, c2, _r10, _s6, p2;

        return _regeneratorRuntime.wrap(function _callee153$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                i = Date.now(), a = "There was a problem with football players request";

                if (!(t2 && t2.playerIds && t2.playerIds.length > _this69.limitIds - 1)) {
                  _context154.next = 37;
                  break;
                }

                r2 = [], s = At(t2.playerIds, _this69.limitIds);
                _iteratorNormalCompletion14 = true;
                _didIteratorError14 = false;
                _iteratorError14 = undefined;
                _context154.prev = 6;
                _iterator14 = s[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                  _context154.next = 20;
                  break;
                }

                n2 = _step14.value;
                t2.playerIds = n2;
                l2 = "/players".concat(_this69.apiSignInUrl).concat(t2.constructFilterUrl());
                e2 && (l2 += "&disable_cache=".concat(i));
                _context154.next = 15;
                return _this69.fetchWithoutAuth(l2, a);

              case 15:
                c2 = _context154.sent;
                r2.push(c2.data.map(function (d2) {
                  return _this69.teamBasicRemapper.fromResponse(d2);
                }));

              case 17:
                _iteratorNormalCompletion14 = true;
                _context154.next = 8;
                break;

              case 20:
                _context154.next = 26;
                break;

              case 22:
                _context154.prev = 22;
                _context154.t0 = _context154["catch"](6);
                _didIteratorError14 = true;
                _iteratorError14 = _context154.t0;

              case 26:
                _context154.prev = 26;
                _context154.prev = 27;

                if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                  _iterator14.return();
                }

              case 29:
                _context154.prev = 29;

                if (!_didIteratorError14) {
                  _context154.next = 32;
                  break;
                }

                throw _iteratorError14;

              case 32:
                return _context154.finish(29);

              case 33:
                return _context154.finish(26);

              case 34:
                return _context154.abrupt("return", Array.prototype.concat.apply([], r2));

              case 37:
                _r10 = new qt(), _s6 = "/players".concat(_this69.apiSignInUrl);
                t2 && (_s6 += "".concat(t2.constructFilterUrl())), e2 && (_s6 += "&disable_cache=".concat(i));
                _context154.next = 41;
                return _this69.fetchWithoutAuth(_s6, a);

              case 41:
                p2 = _context154.sent;
                return _context154.abrupt("return", (_r10.meta = _this69.footballMetaRemapper.remapMetaProp(p2.meta), _r10.data = p2.data.map(function (n2) {
                  return _this69.playerBasicRemapper.fromResponse(n2);
                }), _r10));

              case 43:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee153, null, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function (_x213, _x214) {
        return _ref172.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getPlayerById",
    /*#__PURE__*/
    function () {
      var _ref173 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee154(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee154$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                i = "/players/".concat(t2).concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with football player by ID request";
                e2 && (i += "&disable_cache=".concat(a));
                _context155.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context155.sent;
                return _context155.abrupt("return", _this69.playerFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee154);
      }));

      return function (_x215, _x216) {
        return _ref173.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getTopPlayers",
    /*#__PURE__*/
    function () {
      var _ref174 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee155(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee155$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                e2 = "/players/top".concat(_this69.apiSignInUrl), i = Date.now(), a = "There was a problem with top football players request";
                t2 && (e2 += "&disable_cache=".concat(i));
                _context156.next = 4;
                return _this69.fetchWithoutAuth(e2, a);

              case 4:
                _context156.t0 = function (s) {
                  return _this69.topPlayerRemapper.fromResponse(s);
                };

                return _context156.abrupt("return", _context156.sent.data.map(_context156.t0));

              case 6:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee155);
      }));

      return function (_x217) {
        return _ref174.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getNextMatchForPlayer",
    /*#__PURE__*/
    function () {
      var _ref175 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee156(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee156$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                i = "/players/".concat(t2, "/next-match").concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with next match for player request";
                e2 && (i += "&disable_cache=".concat(a));
                _context157.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context157.sent;
                return _context157.abrupt("return", _this69.matchFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee156);
      }));

      return function (_x218, _x219) {
        return _ref175.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getPrevMatchForPlayer",
    /*#__PURE__*/
    function () {
      var _ref176 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee157(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee157$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                i = "/players/".concat(t2, "/previous-match").concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with previous match for player request";
                e2 && (i += "&disable_cache=".concat(a));
                _context158.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context158.sent;
                return _context158.abrupt("return", _this69.matchFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee157);
      }));

      return function (_x220, _x221) {
        return _ref176.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getMatchById",
    /*#__PURE__*/
    function () {
      var _ref177 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee158(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee158$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                i = "/matches/".concat(t2).concat(_this69.apiSignInUrl), a = Date.now(), r2 = "There was a problem with match by ID request";
                e2 && (i += "&disable_cache=".concat(a));
                _context159.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context159.sent;
                return _context159.abrupt("return", _this69.matchFullRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee158);
      }));

      return function (_x222, _x223) {
        return _ref177.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "getMatches",
    /*#__PURE__*/
    function () {
      var _ref178 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee159(t2, e2) {
        var i, a, r2, s, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, n2, l2, c2, p2, _r11, _s7;

        return _regeneratorRuntime.wrap(function _callee159$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                i = new qt(), a = "There was a problem with football matches request";

                if (!(t2 && t2.matchIds && t2.matchIds.length > _this69.limitIds - 1)) {
                  _context160.next = 38;
                  break;
                }

                r2 = [], s = At(t2.matchIds, _this69.limitIds);
                _iteratorNormalCompletion15 = true;
                _didIteratorError15 = false;
                _iteratorError15 = undefined;
                _context160.prev = 6;
                _iterator15 = s[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                  _context160.next = 20;
                  break;
                }

                n2 = _step15.value;
                t2.matchIds = n2;
                l2 = "/matches".concat(_this69.apiSignInUrl).concat(t2.constructFilterUrl());
                e2 && (l2 += w$2());
                _context160.next = 15;
                return _this69.fetchWithoutAuth(l2, a);

              case 15:
                c2 = _context160.sent;
                i.meta = _this69.footballMetaRemapper.remapMetaProp(c2.meta), r2.push(c2.data.map(function (d2) {
                  return _this69.matchBasicRemapper.fromResponse(d2);
                }));

              case 17:
                _iteratorNormalCompletion15 = true;
                _context160.next = 8;
                break;

              case 20:
                _context160.next = 26;
                break;

              case 22:
                _context160.prev = 22;
                _context160.t0 = _context160["catch"](6);
                _didIteratorError15 = true;
                _iteratorError15 = _context160.t0;

              case 26:
                _context160.prev = 26;
                _context160.prev = 27;

                if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                  _iterator15.return();
                }

              case 29:
                _context160.prev = 29;

                if (!_didIteratorError15) {
                  _context160.next = 32;
                  break;
                }

                throw _iteratorError15;

              case 32:
                return _context160.finish(29);

              case 33:
                return _context160.finish(26);

              case 34:
                p2 = Array.prototype.concat.apply([], r2);
                return _context160.abrupt("return", (i.data = p2, i));

              case 38:
                _r11 = "/matches".concat(_this69.apiSignInUrl);
                t2 && (_r11 += "".concat(t2.constructFilterUrl())), e2 && (_r11 += w$2());
                _context160.next = 42;
                return _this69.fetchWithoutAuth(_r11, a);

              case 42:
                _s7 = _context160.sent;
                return _context160.abrupt("return", (i.meta = _this69.footballMetaRemapper.remapMetaProp(_s7.meta), i.data = _s7.data.map(function (p2) {
                  return _this69.matchBasicRemapper.fromResponse(p2);
                }), i));

              case 44:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee159, null, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function (_x224, _x225) {
        return _ref178.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this69), "search",
    /*#__PURE__*/
    function () {
      var _ref179 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee160(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee160$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                i = "/search".concat(_this69.apiSignInUrl).concat(t2.constructFilterUrl()), a = Date.now(), r2 = "There was a problem with football search request";
                e2 && (i += "&disable_cache=".concat(a));
                _context161.next = 4;
                return _this69.fetchWithoutAuth(i, r2);

              case 4:
                s = _context161.sent;
                return _context161.abrupt("return", _this69.searchRemapper.fromResponse(s.data));

              case 6:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee160);
      }));

      return function (_x226, _x227) {
        return _ref179.apply(this, arguments);
      };
    }());

    _this69.apiSignInUrl = t2.lang !== "en" ? _this69.apiSignInUrl + "&lang=".concat(t2.lang) : _this69.apiSignInUrl, _this69.countryRemapper = new S(), _this69.competitionBasicRemapper = new B(), _this69.competitionFullRemapper = new Di(), _this69.teamBasicRemapper = new A$1(), _this69.teamFullRemapper = new Hi(), _this69.matchBasicRemapper = new Vi(), _this69.matchFullRemapper = new Xi(), _this69.playerBasicRemapper = new jt(), _this69.playerFullRemapper = new ea(), _this69.topPlayerRemapper = new Ji(), _this69.searchRemapper = new aa(), _this69.footballMetaRemapper = new ra();
    return _this69;
  }

  return Z;
}(_);

var K = function (g2) {
  return g2.FT_1X2 = "FT_1X2", g2.HT_1X2 = "HT_1X2", g2.BOTH_TEAMS_SCORE = "BOTH_TEAMS_SCORE", g2.DOUBLE_CHANCE = "DOUBLE_CHANCE", g2.HT_FT = "HT_FT", g2.PLAYER_SCORE = "PLAYER_SCORE", g2.PLAYER_YELLOW_CARD = "PLAYER_YELLOW_CARD", g2.PLAYER_RED_CARD = "PLAYER_RED_CARD", g2.RED_CARD_MATCH = "RED_CARD_MATCH", g2.PENALTY_MATCH = "PENALTY_MATCH", g2.PLAYER_SCORE_FIRST_GOAL = "PLAYER_SCORE_FIRST_GOAL", g2.CORNERS_MATCH = "CORNERS_MATCH", g2.CORRECT_SCORE = "CORRECT_SCORE", g2.CORRECT_SCORE_ADVANCED = "CORRECT_SCORE_ADVANCED", g2.CORRECT_SCORE_HT = "CORRECT_SCORE_HT", g2.PLAYER_SCORE_HATTRICK = "PLAYER_SCORE_HATTRICK", g2.PLAYER_SCORE_TWICE = "PLAYER_SCORE_TWICE", g2.OVER_GOALS_0_5 = "OVER_GOALS_0_5", g2.OVER_GOALS_1_5 = "OVER_GOALS_1_5", g2.OVER_GOALS_2_5 = "OVER_GOALS_2_5", g2.OVER_GOALS_3_5 = "OVER_GOALS_3_5", g2.OVER_GOALS_4_5 = "OVER_GOALS_4_5", g2.OVER_GOALS_5_5 = "OVER_GOALS_5_5", g2.OVER_GOALS_6_5 = "OVER_GOALS_6_5", g2.OVER_CORNERS_6_5 = "OVER_CORNERS_6_5", g2.OVER_CORNERS_7_5 = "OVER_CORNERS_7_5", g2.OVER_CORNERS_8_5 = "OVER_CORNERS_8_5", g2.OVER_CORNERS_9_5 = "OVER_CORNERS_9_5", g2.OVER_CORNERS_10_5 = "OVER_CORNERS_10_5", g2.OVER_CORNERS_11_5 = "OVER_CORNERS_11_5", g2.OVER_CORNERS_12_5 = "OVER_CORNERS_12_5", g2.OVER_CORNERS_13_5 = "OVER_CORNERS_13_5", g2;
}(K || {}),
    vs = ["OVER_GOALS_0_5", "OVER_GOALS_1_5", "OVER_GOALS_2_5", "OVER_GOALS_3_5", "OVER_GOALS_4_5", "OVER_GOALS_5_5", "OVER_GOALS_6_5"],
    Ts = ["OVER_CORNERS_6_5", "OVER_CORNERS_7_5", "OVER_CORNERS_8_5", "OVER_CORNERS_9_5", "OVER_CORNERS_10_5", "OVER_CORNERS_11_5", "OVER_CORNERS_12_5", "OVER_CORNERS_13_5"],
    tt = ["PLAYER_RED_CARD", "PLAYER_SCORE", "PLAYER_SCORE_FIRST_GOAL", "PLAYER_SCORE_HATTRICK", "PLAYER_SCORE_TWICE", "PLAYER_YELLOW_CARD"],
    _s = ["FT_1X2", "HT_1X2", "HT_FT", "DOUBLE_CHANCE", "CORNERS_MATCH", "CORRECT_SCORE", "CORRECT_SCORE_HT", "CORRECT_SCORE_ADVANCED"],
    He = "PLAYER_SCORE_FIRST_GOAL";

var oa = function oa() {
  _classCallCheck3(this, oa);

  __publicField(this, "id", "");

  __publicField(this, "achievedAt", "");
};

var zt = function zt() {
  _classCallCheck3(this, zt);

  __publicField(this, "totalPoints", null);

  __publicField(this, "postPoints", null);

  __publicField(this, "postsMade", null);

  __publicField(this, "reactionPoints", null);

  __publicField(this, "reactionCount", null);
};

var ke = function ke() {
  _classCallCheck3(this, ke);

  __publicField(this, "participations", 0);

  __publicField(this, "points", 0);
};

var Tt = function Tt() {
  _classCallCheck3(this, Tt);

  __publicField(this, "footballCompetitions", []);

  __publicField(this, "footballTeams", []);
};

var Qt = function Qt() {
  _classCallCheck3(this, Qt);

  __publicField(this, "predictionsMade", 0);

  __publicField(this, "correct", 0);

  __publicField(this, "points", 0);

  __publicField(this, "breakdown", new Tt());
};

var Xt = function Xt() {
  _classCallCheck3(this, Xt);

  __publicField(this, "single", new Qt());

  __publicField(this, "topX", new ke());

  __publicField(this, "matchQuiz", new ke());
};

var sa = function sa() {
  _classCallCheck3(this, sa);

  __publicField(this, "overallPercent");

  __publicField(this, "byFootballCompetition");

  __publicField(this, "byFootballTeam");

  __publicField(this, "byFootballMarket");
};

var na = function na() {
  _classCallCheck3(this, na);

  __publicField(this, "profileId");

  __publicField(this, "tier");

  __publicField(this, "points");

  __publicField(this, "predictionsMade");

  __publicField(this, "successRates", new sa());

  __publicField(this, "predictions", new Xt());

  __publicField(this, "tiers", []);

  __publicField(this, "badges", []);

  __publicField(this, "discussions", new zt());
};

var la = function la() {
  _classCallCheck3(this, la);

  __publicField(this, "entityId", "");

  __publicField(this, "entityType", "");

  __publicField(this, "entitySource", "");

  __publicField(this, "model", null);

  __publicField(this, "predictionsMade", 0);

  __publicField(this, "correct", 0);

  __publicField(this, "points", 0);
};

var pa = function pa() {
  _classCallCheck3(this, pa);

  __publicField(this, "successRatePercent");

  __publicField(this, "model", null);
};

var Yt = function Yt() {
  _classCallCheck3(this, Yt);

  __publicField(this, "content", null);

  __publicField(this, "tags", []);

  __publicField(this, "campaign", null);
};

var Jt = function Jt() {
  _classCallCheck3(this, Jt);

  __publicField(this, "id", null);

  __publicField(this, "profileId", null);

  __publicField(this, "property", null);

  __publicField(this, "value", null);

  __publicField(this, "action", null);

  __publicField(this, "context", new Yt());

  __publicField(this, "points", 0);
};

var ca = function ca() {
  _classCallCheck3(this, ca);

  __publicField(this, "meta", new W());

  __publicField(this, "data", [new Jt()]);
};

var da = function da() {
  var _this70 = this;

  _classCallCheck3(this, da);

  __publicField(this, "remapSingleResponse", function (t2) {
    var e2 = new Jt();
    return e2.id = t2.id, e2.profileId = t2.profile_id, e2.property = t2.property, e2.value = t2.value, e2.action = t2.action, e2.context.content = t2.context.content, e2.context.tags = t2.context.tags, e2.context.campaign = t2.context.campaign, e2.points = t2.points, e2;
  });

  __publicField(this, "remapActivitiesResponse", function (t2) {
    var e2 = new ca();
    return e2.meta.pagination.currentPage = t2.meta.pagination.current_page, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.meta.pagination.numberOfPages = t2.meta.pagination.number_of_pages, e2.meta.pagination.totalItems = t2.meta.pagination.total_items, e2.data = t2.data.map(function (i) {
      return _this70.remapSingleResponse(i);
    }), e2;
  });

  __publicField(this, "remapStatsResponse", function (t2) {
    var e2 = new na();
    return e2.profileId = t2.profile_id, e2.tier = t2.tier, e2.points = t2.points, e2.predictionsMade = t2.predictions_made, e2.successRates.overallPercent = t2.success_rates.overall_percent, e2.successRates.byFootballCompetition = _this70.constructNewRecord(t2.success_rates.by_competition), e2.successRates.byFootballTeam = _this70.constructNewRecord(t2.success_rates.by_team), e2.successRates.byFootballMarket = _this70.constructNewRecord(t2.success_rates.by_market), e2.predictions = t2.predictions ? _this70.remapPredictionsStats(t2.predictions) : null, e2.tiers = t2.tiers ? _this70.remapAchievementsStats(t2.tiers) : null, e2.badges = t2.badges ? _this70.remapAchievementsStats(t2.badges) : null, e2.discussions = t2.discussions ? _this70.remapDiscussionStats(t2.discussions) : null, e2;
  });

  __publicField(this, "constructNewRecord", function (t2) {
    var e2;
    if (Object.entries(t2).length) Object.entries(t2).forEach(function (_ref180) {
      var _ref181 = _slicedToArray3(_ref180, 2),
          i = _ref181[0],
          a = _ref181[1];

      e2 = _objectSpread3({}, e2, _defineProperty3({}, i, _this70.remapSuccessRatePercent(a))), K[i] && delete e2[i].model;
    });else return t2;
    return e2;
  });

  __publicField(this, "remapSuccessRatePercent", function (t2) {
    var e2 = new pa();
    return e2.successRatePercent = t2.success_rate_percent, e2;
  });

  __publicField(this, "remapPredictionsStats", function (t2) {
    var e2 = new Xt();
    return e2.single = _this70.remapSinglePredictionsStats(t2.single), e2.topX = t2.top_x, e2.matchQuiz = t2.match_quiz, e2;
  });

  __publicField(this, "remapSinglePredictionsStats", function (t2) {
    var e2 = new Qt();
    return e2.predictionsMade = t2.predictions_made, e2.correct = t2.correct, e2.points = t2.points, e2.breakdown = _this70.remapBreakdownSinglePredictionsStats(t2.breakdown), e2;
  });

  __publicField(this, "remapBreakdownSinglePredictionsStats", function (t2) {
    if (t2 && Object.keys(t2).length) {
      var e2 = new Tt(),
          _i33 = [],
          a = [];
      return Object.keys(t2).forEach(function (r2) {
        var s = new la();
        s.entityId = r2, s.entityType = t2[r2].entity_type, s.entitySource = t2[r2].entity_source, s.predictionsMade = t2[r2].predictions_made, s.correct = t2[r2].correct, s.points = t2[r2].points, s.entityType === "competition" ? _i33.push(s) : s.entityType === "team" && a.push(s);
      }), e2.footballCompetitions = _i33, e2.footballTeams = a, e2;
    }

    return new Tt();
  });

  __publicField(this, "remapAchievementsStats", function (t2) {
    return t2.map(function (e2) {
      var i = new oa();
      return i.id = e2.id, i.achievedAt = e2.achieved_at, i;
    });
  });

  __publicField(this, "remapDiscussionStats", function (t2) {
    var e2 = new zt();
    return e2.totalPoints = t2.total_points, e2.postPoints = t2.post_points, e2.postsMade = t2.posts_made, e2.reactionPoints = t2.reaction_points, e2.reactionCount = t2.reaction_count, e2;
  });
};

var Zt =
/*#__PURE__*/
function (_ref182) {
  _inherits3(Zt, _ref182);

  function Zt(t2) {
    var _this71;

    _classCallCheck3(this, Zt);

    _this71 = _possibleConstructorReturn3(this, _getPrototypeOf4(Zt).call(this, t2, R(t2.environment, "loyalty")));

    __publicField(_assertThisInitialized3(_this71), "activityRemapper", null);

    __publicField(_assertThisInitialized3(_this71), "createActivity",
    /*#__PURE__*/
    function () {
      var _ref183 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee161(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee161$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                e2 = "/activities".concat(_this71.apiSignInUrl);
                i = "There was a problem with creating activity";
                a = "POST";
                _context162.next = 5;
                return _this71.fetchWithAuth(e2, i, a, t2);

              case 5:
                r2 = _context162.sent;
                return _context162.abrupt("return", _this71.activityRemapper.remapSingleResponse(r2));

              case 7:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee161);
      }));

      return function (_x228) {
        return _ref183.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this71), "deleteActivity",
    /*#__PURE__*/
    function () {
      var _ref184 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee162(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee162$(_context163) {
          while (1) {
            switch (_context163.prev = _context163.next) {
              case 0:
                e2 = "/activities/".concat(t2).concat(_this71.apiSignInUrl), i = "There was a problem deleting the following activity: ".concat(t2), a = "DELETE";
                _context163.next = 3;
                return _this71.fetchWithAuth(e2, i, a);

              case 3:
                return _context163.abrupt("return", true);

              case 4:
              case "end":
                return _context163.stop();
            }
          }
        }, _callee162);
      }));

      return function (_x229) {
        return _ref184.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this71), "getOwnActivities",
    /*#__PURE__*/
    function () {
      var _ref185 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee163(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee163$(_context164) {
          while (1) {
            switch (_context164.prev = _context164.next) {
              case 0:
                i = "/activities".concat(_this71.apiSignInUrl), a = Date.now(), r2 = "There was a problem with fetching own activities";
                t2 && (i += "".concat(t2.constructFilterUrl())), e2 && (i += "disable_cache=".concat(a));
                _context164.next = 4;
                return _this71.fetchWithAuth(i, r2);

              case 4:
                s = _context164.sent;
                return _context164.abrupt("return", _this71.activityRemapper.remapActivitiesResponse(s));

              case 6:
              case "end":
                return _context164.stop();
            }
          }
        }, _callee163);
      }));

      return function (_x230, _x231) {
        return _ref185.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this71), "getActivitiesForUser",
    /*#__PURE__*/
    function () {
      var _ref186 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee164(t2, e2, i) {
        var a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee164$(_context165) {
          while (1) {
            switch (_context165.prev = _context165.next) {
              case 0:
                a = "/users/".concat(t2, "/activities").concat(_this71.apiSignInUrl), r2 = Date.now(), s = "There was a problem with fetching activities for user: ".concat(t2);
                e2 && (a += "".concat(e2.constructFilterUrl())), i && (a += "disable_cache=".concat(r2));
                _context165.next = 4;
                return _this71.fetchWithoutAuth(a, s);

              case 4:
                p2 = _context165.sent;
                return _context165.abrupt("return", _this71.activityRemapper.remapActivitiesResponse(p2));

              case 6:
              case "end":
                return _context165.stop();
            }
          }
        }, _callee164);
      }));

      return function (_x232, _x233, _x234) {
        return _ref186.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this71), "getStats",
    /*#__PURE__*/
    function () {
      var _ref187 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee165(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee165$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                i = "", a = "", r2 = null;

                if (!t2) {
                  _context166.next = 9;
                  break;
                }

                i += P(e2) ? "/users/".concat(t2, "/statistics").concat(_this71.apiSignInUrl).concat(w$2()) : "/users/".concat(t2, "/statistics").concat(_this71.apiSignInUrl);
                a = "There was a problem fetching statistics for profile: ".concat(t2);
                _context166.next = 6;
                return _this71.fetchWithoutAuth(i, a);

              case 6:
                r2 = _context166.sent;
                _context166.next = 14;
                break;

              case 9:
                i += "/statistics".concat(_this71.apiSignInUrl);
                a = "There was a problem fetching profile`s statistics";
                _context166.next = 13;
                return _this71.fetchWithAuth(i, a);

              case 13:
                r2 = _context166.sent;

              case 14:
                return _context166.abrupt("return", _this71.activityRemapper.remapStatsResponse(r2.data));

              case 15:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee165);
      }));

      return function (_x235, _x236) {
        return _ref187.apply(this, arguments);
      };
    }());

    _this71.activityRemapper = new da();
    return _this71;
  }

  return Zt;
}(_);

var ma = function ma() {
  _classCallCheck3(this, ma);

  __publicField(this, "id", "");

  __publicField(this, "source", "");

  __publicField(this, "type", "");

  __publicField(this, "favourite", false);
};

var ua =
/*#__PURE__*/
function (_ma) {
  _inherits3(ua, _ma);

  function ua() {
    var _this72;

    _classCallCheck3(this, ua);

    _this72 = _possibleConstructorReturn3(this, _getPrototypeOf4(ua).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this72), "model", null);

    return _this72;
  }

  return ua;
}(ma);

var ha = function ha(t2, e2, i) {
  var _this73 = this;

  _classCallCheck3(this, ha);

  __publicField(this, "idMapping", null);

  __publicField(this, "idSchema", null);

  __publicField(this, "native", "native");

  __publicField(this, "footballFacade", null);

  __publicField(this, "remapProfileStats",
  /*#__PURE__*/
  function () {
    var _ref188 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee166(t2) {
      var e2, i, a, r2, s, p2, _r12, _s8, _p;

      return _regeneratorRuntime.wrap(function _callee166$(_context167) {
        while (1) {
          switch (_context167.prev = _context167.next) {
            case 0:
              if (t2.predictions) {
                _context167.next = 2;
                break;
              }

              return _context167.abrupt("return", t2);

            case 2:
              e2 = t2.successRates, i = t2.predictions, a = {
                competition: _this73.getIdsKeys(e2.byFootballCompetition, i.single.breakdown.footballCompetitions),
                team: _this73.getIdsKeys(e2.byFootballTeam, i.single.breakdown.footballTeams)
              };

              if (!Object.values(a.competition).length) {
                _context167.next = 12;
                break;
              }

              r2 = JSON.parse(JSON.stringify(t2.successRates.byFootballCompetition));
              _context167.next = 7;
              return _this73.getEntitiesMap(a.competition, "competition");

            case 7:
              s = _context167.sent;
              _context167.next = 10;
              return _this73.setSuccessRatesModels(r2, s);

            case 10:
              p2 = _context167.sent;
              t2.successRates.byFootballCompetition = p2, i.single.breakdown.footballCompetitions = _this73.reconstructBreakdown(i.single.breakdown.footballCompetitions, s);

            case 12:
              if (!Object.values(a.team).length) {
                _context167.next = 21;
                break;
              }

              _r12 = JSON.parse(JSON.stringify(t2.successRates.byFootballTeam));
              _context167.next = 16;
              return _this73.getEntitiesMap(a.team, "team");

            case 16:
              _s8 = _context167.sent;
              _context167.next = 19;
              return _this73.setSuccessRatesModels(_r12, _s8);

            case 19:
              _p = _context167.sent;
              t2.successRates.byFootballTeam = _p, i.single.breakdown.footballTeams = _this73.reconstructBreakdown(i.single.breakdown.footballTeams, _s8);

            case 21:
              return _context167.abrupt("return", t2);

            case 22:
            case "end":
              return _context167.stop();
          }
        }
      }, _callee166);
    }));

    return function (_x237) {
      return _ref188.apply(this, arguments);
    };
  }());

  __publicField(this, "setSuccessRatesModels",
  /*#__PURE__*/
  function () {
    var _ref189 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee167(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee167$(_context168) {
        while (1) {
          switch (_context168.prev = _context168.next) {
            case 0:
              return _context168.abrupt("return", _this73.reconstructRecords(t2, i, e2));

            case 1:
            case "end":
              return _context168.stop();
          }
        }
      }, _callee167);
    }));

    return function (_x238, _x239) {
      return _ref189.apply(this, arguments);
    };
  }());

  __publicField(this, "getEntitiesMap",
  /*#__PURE__*/
  function () {
    var _ref190 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee168(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee168$(_context169) {
        while (1) {
          switch (_context169.prev = _context169.next) {
            case 0:
              _context169.t0 = e2;
              _context169.next = _context169.t0 === "competition" ? 3 : _context169.t0 === "team" ? 6 : 9;
              break;

            case 3:
              _context169.next = 5;
              return _this73.footballFacade.getCompetitionsMapWithNativeIds(t2);

            case 5:
              return _context169.abrupt("return", _context169.sent);

            case 6:
              _context169.next = 8;
              return _this73.footballFacade.getTeamsMapWithNativeIds(t2);

            case 8:
              return _context169.abrupt("return", _context169.sent);

            case 9:
            case "end":
              return _context169.stop();
          }
        }
      }, _callee168);
    }));

    return function (_x240, _x241) {
      return _ref190.apply(this, arguments);
    };
  }());

  __publicField(this, "reconstructRecords", function (t2, e2, i) {
    return t2 && Object.keys(t2).length ? (Object.keys(t2).forEach(function (a) {
      var r2 = i.get(a);
      e2 = _objectSpread3({}, e2, _defineProperty3({}, r2.id, t2[a])), e2[r2.id].model = r2;
    }), e2) : t2;
  });

  __publicField(this, "reconstructBreakdown", function (t2, e2) {
    return t2.length ? t2.map(function (i) {
      var a = e2.get(i.entityId);
      return i.entityId = a.id, i.model = a, i;
    }) : t2;
  });

  __publicField(this, "getIdsKeys", function (t2, e2) {
    var i = Object.keys(t2);

    if (e2.length) {
      var a = e2.map(function (r2) {
        return r2.entityId;
      });
      return Array.from(
      /* @__PURE__ */
      new Set([].concat(_toConsumableArray3(i), _toConsumableArray3(a))));
    }

    return i;
  });

  __publicField(this, "remapInterestsToIdSchema",
  /*#__PURE__*/
  function () {
    var _ref191 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee170(t2) {
      var _ret3;

      return _regeneratorRuntime.wrap(function _callee170$(_context171) {
        while (1) {
          switch (_context171.prev = _context171.next) {
            case 0:
              if (!(_this73.idSchema !== _this73.native)) {
                _context171.next = 9;
                break;
              }

              if (!(t2 && t2.length > 0)) {
                _context171.next = 8;
                break;
              }

              return _context171.delegateYield(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee169() {
                var e2, i, a, r2, s, p2, _loop8, _i34, _Object$entries2, _ref193;

                return _regeneratorRuntime.wrap(function _callee169$(_context170) {
                  while (1) {
                    switch (_context170.prev = _context170.next) {
                      case 0:
                        e2 = {}, i = {}, a = t2.filter(function (n2) {
                          return n2.source.toLocaleUpperCase() === "FOOTBALL";
                        }), r2 = t2.filter(function (n2) {
                          return n2.source.toLocaleUpperCase() !== "FOOTBALL";
                        });
                        a.forEach(function (n2) {
                          e2.hasOwnProperty(n2.type) || (e2[n2.type] = [], i[n2.type] = []), e2[n2.type].push(n2.id), i[n2.type].push(n2);
                        });
                        _context170.next = 4;
                        return _this73.remapIdsObj(e2, _this73.native, _this73.idSchema);

                      case 4:
                        s = _context170.sent;
                        p2 = [];

                        _loop8 = function _loop8() {
                          var _ref192 = _Object$entries2[_i34];
                          _ref193 = _slicedToArray3(_ref192, 2);
                          var n2 = _ref193[0];
                          var l2 = _ref193[1];
                          l2.forEach(function (c2, d2) {
                            c2.id = s[n2][d2], p2.push(c2);
                          });
                        };

                        for (_i34 = 0, _Object$entries2 = Object.entries(i); _i34 < _Object$entries2.length; _i34++) {
                          _loop8();
                        }

                        return _context170.abrupt("return", {
                          v: p2.concat(r2)
                        });

                      case 9:
                      case "end":
                        return _context170.stop();
                    }
                  }
                }, _callee169);
              })(), "t0", 3);

            case 3:
              _ret3 = _context171.t0;

              if (!(typeof _ret3 === "object")) {
                _context171.next = 6;
                break;
              }

              return _context171.abrupt("return", _ret3.v);

            case 6:
              _context171.next = 9;
              break;

            case 8:
              return _context171.abrupt("return", t2);

            case 9:
              return _context171.abrupt("return", t2);

            case 10:
            case "end":
              return _context171.stop();
          }
        }
      }, _callee170);
    }));

    return function (_x242) {
      return _ref191.apply(this, arguments);
    };
  }());

  __publicField(this, "remapInterestToNative",
  /*#__PURE__*/
  function () {
    var _ref194 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee171(t2) {
      var _e10, _i35, a, r2;

      return _regeneratorRuntime.wrap(function _callee171$(_context172) {
        while (1) {
          switch (_context172.prev = _context172.next) {
            case 0:
              if (!(_this73.idSchema !== _this73.native && t2.source.toLocaleUpperCase() === "FOOTBALL")) {
                _context172.next = 7;
                break;
              }

              _e10 = {}, _i35 = t2.id, a = t2.type;
              _e10[a] = [_i35];
              _context172.next = 5;
              return _this73.remapIdsObj(_e10, _this73.idSchema, _this73.native);

            case 5:
              r2 = _context172.sent;
              return _context172.abrupt("return", (t2.id = r2[a][0], t2));

            case 7:
              return _context172.abrupt("return", t2);

            case 8:
            case "end":
              return _context172.stop();
          }
        }
      }, _callee171);
    }));

    return function (_x243) {
      return _ref194.apply(this, arguments);
    };
  }());

  __publicField(this, "inquiryCustomInterests", function (t2, e2) {
    var i = [];
    return t2 && t2.length > 0 && (i = t2.filter(function (a) {
      return a.source.toLocaleUpperCase() === "CUSTOM";
    }), e2) ? i.map(function (a) {
      var r2 = new ua();
      return r2.id = a.id, r2.type = a.type, r2.source = a.source, r2.favourite = a.favourite, r2;
    }) : i;
  });

  __publicField(this, "remapInterests",
  /*#__PURE__*/
  function () {
    var _ref195 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee172(t2) {
      var i, a, r2;
      return _regeneratorRuntime.wrap(function _callee172$(_context173) {
        while (1) {
          switch (_context173.prev = _context173.next) {
            case 0:
              i = _this73.inquiryCustomInterests(t2, false);

              if (!(i && i.length > 0)) {
                _context173.next = 7;
                break;
              }

              a = t2.filter(function (s) {
                return s.source.toLocaleUpperCase() !== "CUSTOM";
              });
              _context173.next = 5;
              return _this73.remapInterestsToIdSchema(a);

            case 5:
              r2 = _context173.sent;
              return _context173.abrupt("return", (i.forEach(function (s) {
                return r2.push(s);
              }), r2));

            case 7:
              _context173.next = 9;
              return _this73.remapInterestsToIdSchema(t2);

            case 9:
              return _context173.abrupt("return", _context173.sent);

            case 10:
            case "end":
              return _context173.stop();
          }
        }
      }, _callee172);
    }));

    return function (_x244) {
      return _ref195.apply(this, arguments);
    };
  }());

  __publicField(this, "showFullInterests",
  /*#__PURE__*/
  function () {
    var _ref196 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee173(t2) {
      var e2, a, r2, _ref197, _s9, _p2, n2, l2;

      return _regeneratorRuntime.wrap(function _callee173$(_context174) {
        while (1) {
          switch (_context174.prev = _context174.next) {
            case 0:
              e2 = [];

              if (!(t2 && t2.length > 0)) {
                _context174.next = 13;
                break;
              }

              a = _this73.inquiryCustomInterests(t2, true);
              e2.push(a);
              r2 = t2.filter(function (c2) {
                return c2.source.toLocaleUpperCase() !== "CUSTOM";
              });
              _context174.next = 7;
              return _this73.getInterestsEntitiesMap(r2);

            case 7:
              _ref197 = _context174.sent;
              _s9 = _ref197.competitionsMap;
              _p2 = _ref197.teamsMap;
              n2 = _ref197.playersMap;
              l2 = r2.map(function (c2) {
                var d2 = null;

                if (c2.source.toLocaleUpperCase() === "FOOTBALL") {
                  if (c2.type === "competition") return d2 = _s9.get(c2.id), d2 && (c2.id = d2.id), c2.model = d2, c2;
                  if (c2.type === "team") return d2 = _p2.get(c2.id), d2 && (c2.id = d2.id), c2.model = d2, c2;
                  if (c2.type === "player") return n2 ? (c2.model = n2[c2.id], c2.id = n2[c2.id].id) : c2.model = d2, c2;
                } else return c2.model = d2, c2;
              });
              return _context174.abrupt("return", (e2.push(l2), e2.flat()));

            case 13:
              return _context174.abrupt("return", e2);

            case 14:
            case "end":
              return _context174.stop();
          }
        }
      }, _callee173);
    }));

    return function (_x245) {
      return _ref196.apply(this, arguments);
    };
  }());

  __publicField(this, "getInterestsEntitiesMap",
  /*#__PURE__*/
  function () {
    var _ref198 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee174(t2) {
      var e2, i, a, r2, s, p2;
      return _regeneratorRuntime.wrap(function _callee174$(_context175) {
        while (1) {
          switch (_context175.prev = _context175.next) {
            case 0:
              e2 = [], i = [], a = [], r2 =
              /* @__PURE__ */
              new Map(), s =
              /* @__PURE__ */
              new Map(), p2 = null;
              t2.forEach(function (n2) {
                n2.type === "competition" && n2.source.toLocaleUpperCase() === "FOOTBALL" ? e2.push(n2.id) : n2.type === "team" && n2.source.toLocaleUpperCase() === "FOOTBALL" ? i.push(n2.id) : n2.type === "player" && n2.source.toLocaleUpperCase() === "FOOTBALL" && a.push(n2.id);
              });
              _context175.t0 = e2.length;

              if (!_context175.t0) {
                _context175.next = 7;
                break;
              }

              _context175.next = 6;
              return _this73.footballFacade.getCompetitionsMapWithNativeIds(e2);

            case 6:
              r2 = _context175.sent;

            case 7:
              _context175.t1 = i.length;

              if (!_context175.t1) {
                _context175.next = 12;
                break;
              }

              _context175.next = 11;
              return _this73.footballFacade.getTeamsMapWithNativeIds(i);

            case 11:
              s = _context175.sent;

            case 12:
              _context175.t2 = a.length;

              if (!_context175.t2) {
                _context175.next = 17;
                break;
              }

              _context175.next = 16;
              return _this73.footballFacade.getPlayersMapWithNativeIds(a);

            case 16:
              p2 = _context175.sent;

            case 17:
              return _context175.abrupt("return", {
                competitionsMap: r2,
                teamsMap: s,
                playersMap: p2
              });

            case 18:
            case "end":
              return _context175.stop();
          }
        }
      }, _callee174);
    }));

    return function (_x246) {
      return _ref198.apply(this, arguments);
    };
  }());

  __publicField(this, "remapIdsObj",
  /*#__PURE__*/
  function () {
    var _ref199 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee175(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee175$(_context176) {
        while (1) {
          switch (_context176.prev = _context176.next) {
            case 0:
              _context176.next = 2;
              return _this73.idMapping.idMappingFacade.getEntitiesByIds(t2, e2, i);

            case 2:
              return _context176.abrupt("return", _context176.sent);

            case 3:
            case "end":
              return _context176.stop();
          }
        }
      }, _callee175);
    }));

    return function (_x247, _x248, _x249) {
      return _ref199.apply(this, arguments);
    };
  }());

  this.idMapping = i, this.idSchema = t2.idSchema, this.footballFacade = e2;
};

var ga = function ga(t2, e2) {
  var _this74 = this;

  _classCallCheck3(this, ga);

  __publicField(this, "idMapping", null);

  __publicField(this, "profileOperations", null);

  __publicField(this, "remapProfileStats",
  /*#__PURE__*/
  function () {
    var _ref200 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee176(t2) {
      return _regeneratorRuntime.wrap(function _callee176$(_context177) {
        while (1) {
          switch (_context177.prev = _context177.next) {
            case 0:
              _context177.next = 2;
              return _this74.profileOperations.remapProfileStats(t2);

            case 2:
              return _context177.abrupt("return", _context177.sent);

            case 3:
            case "end":
              return _context177.stop();
          }
        }
      }, _callee176);
    }));

    return function (_x250) {
      return _ref200.apply(this, arguments);
    };
  }());

  __publicField(this, "remapInterestToNative",
  /*#__PURE__*/
  function () {
    var _ref201 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee177(t2) {
      return _regeneratorRuntime.wrap(function _callee177$(_context178) {
        while (1) {
          switch (_context178.prev = _context178.next) {
            case 0:
              _context178.next = 2;
              return _this74.profileOperations.remapInterestToNative(t2);

            case 2:
              return _context178.abrupt("return", _context178.sent);

            case 3:
            case "end":
              return _context178.stop();
          }
        }
      }, _callee177);
    }));

    return function (_x251) {
      return _ref201.apply(this, arguments);
    };
  }());

  __publicField(this, "remapInterests",
  /*#__PURE__*/
  function () {
    var _ref202 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee178(t2) {
      return _regeneratorRuntime.wrap(function _callee178$(_context179) {
        while (1) {
          switch (_context179.prev = _context179.next) {
            case 0:
              _context179.next = 2;
              return _this74.profileOperations.remapInterests(t2);

            case 2:
              return _context179.abrupt("return", _context179.sent);

            case 3:
            case "end":
              return _context179.stop();
          }
        }
      }, _callee178);
    }));

    return function (_x252) {
      return _ref202.apply(this, arguments);
    };
  }());

  __publicField(this, "showFullInterests",
  /*#__PURE__*/
  function () {
    var _ref203 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee179(t2) {
      return _regeneratorRuntime.wrap(function _callee179$(_context180) {
        while (1) {
          switch (_context180.prev = _context180.next) {
            case 0:
              _context180.next = 2;
              return _this74.profileOperations.showFullInterests(t2);

            case 2:
              return _context180.abrupt("return", _context180.sent);

            case 3:
            case "end":
              return _context180.stop();
          }
        }
      }, _callee179);
    }));

    return function (_x253) {
      return _ref203.apply(this, arguments);
    };
  }());

  this.idMapping = new F(t2), this.profileOperations = new ha(t2, e2, this.idMapping);
};

var L = function L(t2) {
  var _this75 = this;

  _classCallCheck3(this, L);

  __publicField(this, "idsRemapper", null);

  __publicField(this, "profileHttps", null);

  __publicField(this, "activityHttps", null);

  __publicField(this, "footballHttps", null);

  __publicField(this, "footballFacade", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "localCache", null);

  __publicField(this, "profileFacade", null);

  __publicField(this, "ownProfileBuilder", null);

  __publicField(this, "profileBuilder", null);

  __publicField(this, "getOwn", function () {
    return _this75.ownProfileBuilder;
  });

  __publicField(this, "getById", function (t2) {
    return _this75.profileBuilder.setId(t2);
  });

  __publicField(this, "getCountries",
  /*#__PURE__*/
  function () {
    var _ref204 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee180(t2) {
      return _regeneratorRuntime.wrap(function _callee180$(_context181) {
        while (1) {
          switch (_context181.prev = _context181.next) {
            case 0:
              _context181.next = 2;
              return _this75.profileFacade.getCountries(t2);

            case 2:
              return _context181.abrupt("return", _context181.sent);

            case 3:
            case "end":
              return _context181.stop();
          }
        }
      }, _callee180);
    }));

    return function (_x254) {
      return _ref204.apply(this, arguments);
    };
  }());

  __publicField(this, "getByIds",
  /*#__PURE__*/
  function () {
    var _ref205 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee181(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee181$(_context182) {
        while (1) {
          switch (_context182.prev = _context182.next) {
            case 0:
              _context182.next = 2;
              return _this75.profileFacade.getByIds(t2, e2, i);

            case 2:
              return _context182.abrupt("return", _context182.sent);

            case 3:
            case "end":
              return _context182.stop();
          }
        }
      }, _callee181);
    }));

    return function (_x255, _x256, _x257) {
      return _ref205.apply(this, arguments);
    };
  }());

  this.profileHttps = new Ot(t2), this.activityHttps = new Zt(t2), this.footballHttps = new Z(t2), this.idMapping = new F(t2), this.localCache = new V().createLocalCacheInstance(t2.idSchema), this.footballFacade = new Vt(t2, this.localCache, this.footballHttps, this.idMapping), this.profileFacade = new J(this.localCache, this.profileHttps, this.activityHttps), this.idsRemapper = new ga(t2, this.footballFacade), this.ownProfileBuilder = new ci(this.idsRemapper, this.localCache, this.profileHttps, this.activityHttps, t2.errorHandlingMode), this.profileBuilder = new di(this.idsRemapper, this.localCache, this.profileHttps, this.activityHttps);
};

var Eo = function (h2) {
  return h2.EN = "en", h2.BG = "bg", h2.RO = "ro", h2.EL = "el", h2.SK = "sk", h2.PT = "pt", h2.SR = "sr", h2.HU = "hu", h2.SV = "sv", h2.ES = "es", h2.FR = "fr", h2.NL = "nl", h2.DE = "de", h2.IT = "it", h2;
}(Eo || {});

var fa = function fa() {
  var _this76 = this;

  _classCallCheck3(this, fa);

  __publicField(this, "validate", function (t2) {
    var e2 = _this76.validateField(t2.lang),
        i = _this76.generateMessage(e2);

    return {
      validation: e2,
      message: i
    };
  });

  __publicField(this, "validateField", function (t2) {
    var e2 = Object.values(Eo),
        i = null;
    return t2 != null && t2.length > 0 ? e2.includes(t2) ? i = "valid" : i = "invalid" : i = "missing", i;
  });

  __publicField(this, "generateMessage", function (t2) {
    var e2 = null,
        i = "warning";
    return t2 === "missing" && (e2 = "If no lang is passed the default one will be set which is: en"), t2 === "invalid" && (e2 = "This lang value is not supported, the default one will be set which is: en"), t2 === "valid" && (e2 = null, i = null), {
      text: e2,
      type: i
    };
  });
};

var ya =
/*#__PURE__*/
function () {
  function ya() {
    _classCallCheck3(this, ya);

    __publicField(this, "validateField", function (t2) {
      var e2 = ["dev", "staging", "prod", "watg"],
          i = null;
      return t2 != null && t2.length > 0 ? e2.includes(t2) ? i = "valid" : i = "invalid" : i = "missing", i;
    });

    __publicField(this, "generateMessage", function (t2) {
      var e2 = null,
          i = "warning";
      return t2 === "missing" && (e2 = "If no environment is passed the default one will be set which is: prod"), t2 === "invalid" && (e2 = "This environment value is not supported, the default one will be set which is: prod"), t2 === "valid" && (e2 = null, i = null), {
        text: e2,
        type: i
      };
    });
  }

  _createClass3(ya, [{
    key: "validate",
    value: function validate(t2) {
      var e2 = this.validateField(t2.environment),
          i = this.generateMessage(e2);
      return {
        validation: e2,
        message: i
      };
    }
  }]);

  return ya;
}();

var Ma =
/*#__PURE__*/
function () {
  function Ma() {
    _classCallCheck3(this, Ma);

    __publicField(this, "validateField", function (t2) {
      var e2 = null;
      return t2 != null && t2.length > 0 ? e2 = "valid" : e2 = "missing", e2;
    });

    __publicField(this, "generateMessage", function (t2) {
      var e2 = null,
          i = "error";
      return t2 === "missing" && (e2 = "The field apiKey with valid value must be provided to use Fans United JS SDK"), t2 === "valid" && (i = null), {
        text: e2,
        type: i
      };
    });
  }

  _createClass3(Ma, [{
    key: "validate",
    value: function validate(t2) {
      var e2 = this.validateField(t2.apiKey),
          i = this.generateMessage(e2);
      return {
        validation: e2,
        message: i
      };
    }
  }]);

  return Ma;
}();

var ba =
/*#__PURE__*/
function () {
  function ba() {
    _classCallCheck3(this, ba);

    __publicField(this, "validateField", function (t2) {
      var e2 = Object.values(D),
          i = null;
      return t2 != null && t2.length > 0 ? e2.includes(t2) ? i = "valid" : i = "invalid" : i = "missing", i;
    });

    __publicField(this, "generateMessage", function (t2) {
      var e2 = null,
          i = "warning";
      return t2 === "missing" && (e2 = "If no idSchema is passed the default one will be set which is: native"), t2 === "invalid" && (e2 = "This idSchema value is not supported, the default one will be set which is: native"), t2 === "valid" && (e2 = null, i = null), {
        text: e2,
        type: i
      };
    });
  }

  _createClass3(ba, [{
    key: "validate",
    value: function validate(t2) {
      var e2 = this.validateField(t2.idSchema),
          i = this.generateMessage(e2);
      return {
        validation: e2,
        message: i
      };
    }
  }]);

  return ba;
}();

var Ft = function Ft() {
  _classCallCheck3(this, Ft);

  __publicField(this, "getIdToken", null);

  __publicField(this, "logout", null);
};

var ee = function ee() {
  _classCallCheck3(this, ee);

  __publicField(this, "text", null);

  __publicField(this, "type", null);
};

var wa = function wa() {
  _classCallCheck3(this, wa);

  __publicField(this, "validation", null);

  __publicField(this, "message", new ee());

  __publicField(this, "getIdToken", {
    validation: null,
    message: new ee()
  });

  __publicField(this, "logout", {
    validation: null,
    message: new ee()
  });
};

var Ia =
/*#__PURE__*/
function () {
  function Ia() {
    _classCallCheck3(this, Ia);

    __publicField(this, "validateAuthProvider", function (t2) {
      var e2 = Object.keys(new Ft()),
          i = new wa();

      if (t2) {
        var r2 = Object.keys(t2).filter(function (s) {
          return !e2.includes(s);
        });
        r2.length > 0 ? (i.validation = "invalid", i.message.type = "warning", i.message.text = "You have passed a property which is not supported for the authentication provider:".concat(" ", r2.join(","))) : i.validation = "valid";
      } else i.validation = "missing", i.message.type = "error", i.message.text = "The field authProvider must be provided to use this SDK";

      return i;
    });

    __publicField(this, "validateAuthProviderConfigFields", function (t2, e2) {
      return Object.keys(new Ft()).forEach(function (a) {
        t2[a] ? e2[a].validation = "valid" : e2[a].validation = "missing";
      }), e2;
    });

    __publicField(this, "generateAuthProviderConfigMessages", function (t2) {
      return Object.keys(t2).filter(function (e2) {
        return e2 !== "validation" && e2 !== "message";
      }).forEach(function (e2) {
        var i = t2[e2];
        i.validation === "missing" && (i.message.text = "The following property is missing from the authProvider object:".concat(" ", e2), i.message.type = "error");
      }), t2;
    });

    __publicField(this, "checkAuthProviderConfigMessagesForErrors", function (t2) {
      return Object.keys(t2).filter(function (e2) {
        return e2 !== "validation" && e2 !== "message";
      }).forEach(function (e2) {
        t2[e2].validation === "missing" && t2.validation === "valid" && (t2.validation = "invalid", t2.message.type = "error", t2.message.text = "The field authProvider has missing properties");
      }), t2;
    });
  }

  _createClass3(Ia, [{
    key: "validate",
    value: function validate(t2) {
      var e2 = this.validateAuthProvider(t2.authProvider);
      return e2.validation !== "missing" && (e2 = this.validateAuthProviderConfigFields(t2.authProvider, e2), e2 = this.generateAuthProviderConfigMessages(e2), e2 = this.checkAuthProviderConfigMessagesForErrors(e2)), e2;
    }
  }]);

  return Ia;
}();

var Ve = function Ve() {
  _classCallCheck3(this, Ve);

  __publicField(this, "validation");

  __publicField(this, "message");
};

var Pa = function Pa() {
  _classCallCheck3(this, Pa);

  __publicField(this, "apiKey", null);

  __publicField(this, "environment", null);

  __publicField(this, "idSchema", null);

  __publicField(this, "clientId", null);

  __publicField(this, "lang", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "authProvider", {
    getIdToken: new Ve(),
    logout: new Ve()
  });

  __publicField(this, "isValid", false);
};

var va =
/*#__PURE__*/
function () {
  function va() {
    _classCallCheck3(this, va);

    __publicField(this, "validateField", function (t2) {
      var e2 = null;
      return t2 != null && t2.length > 0 ? e2 = "valid" : e2 = "missing", e2;
    });

    __publicField(this, "generateMessage", function (t2) {
      var e2 = null,
          i = "error";
      return t2 === "missing" && (e2 = "The field clientId must be provided to use Fans United JS SDK"), t2 === "valid" && (e2 = null, i = null), {
        text: e2,
        type: i
      };
    });
  }

  _createClass3(va, [{
    key: "validate",
    value: function validate(t2) {
      var e2 = this.validateField(t2.clientId),
          i = this.generateMessage(e2);
      return {
        validation: e2,
        message: i
      };
    }
  }]);

  return va;
}();

var Ta = function Ta() {
  var _this77 = this;

  _classCallCheck3(this, Ta);

  __publicField(this, "validate", function (t2) {
    var e2 = _this77.validateField(t2.errorHandlingMode),
        i = _this77.generateMessage(e2);

    return {
      validation: e2,
      message: i
    };
  });

  __publicField(this, "validateField", function (t2) {
    var e2 = ["default", "standard"],
        i = null;
    return t2 ? e2.includes(t2) ? i = "valid" : i = "invalid" : i = "missing", i;
  });

  __publicField(this, "generateMessage", function (t2) {
    var e2 = null,
        i = "warning";
    return t2 === "missing" && (e2 = "If no errorHandlingMode is passed the default one will be set which is: default"), t2 === "invalid" && (e2 = "This errorHandlingMode value is not supported, the default one will be set which is: default"), t2 === "valid" && (e2 = null, i = null), {
      text: e2,
      type: i
    };
  });
};

var _a = function _a() {
  var _this78 = this;

  _classCallCheck3(this, _a);

  __publicField(this, "validate", function (t2) {
    var e2 = _this78.checkFieldsForValues(t2);

    return e2.isValid = _this78.containsErrorMessage(e2), e2;
  });

  __publicField(this, "checkFieldsForValues", function (t2) {
    var e2 = new Pa(),
        i = {
      apiKey: new Ma(),
      environment: new ya(),
      idSchema: new ba(),
      clientId: new va(),
      lang: new fa(),
      errorHandlingMode: new Ta(),
      authProvider: new Ia()
    };

    for (var _i36 = 0, _Object$entries3 = Object.entries(e2); _i36 < _Object$entries3.length; _i36++) {
      var _ref208 = _Object$entries3[_i36];

      var _ref207 = _slicedToArray3(_ref208, 2);

      var a = _ref207[0];
      var r2 = _ref207[1];
      a !== "isValid" && (r2 = i[a].validate(t2));
    }

    return Object.keys(i).forEach(function (a) {
      e2[a] = i[a].validate(t2);
    }), e2;
  });

  __publicField(this, "containsErrorMessage", function (t2) {
    var e2 = true;

    for (var _i37 = 0, _Object$entries4 = Object.entries(t2); _i37 < _Object$entries4.length; _i37++) {
      var _ref211 = _Object$entries4[_i37];

      var _ref210 = _slicedToArray3(_ref211, 2);

      var _i38 = _ref210[0];
      var a = _ref210[1];

      if (_i38 !== "authProvider") {
        if (_i38 !== "isValid" && a.message.type === "error") return e2 = false, e2;
        if (_i38 !== "isValid" && a.message.type === "warning") return e2 = true, e2;
      } else if (a.message.type === "error") return e2 = false, e2;
    }

    return e2;
  });
};

var ie = function ie(t2) {
  var _this79 = this;

  _classCallCheck3(this, ie);

  __publicField(this, "https", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "localCache", null);

  __publicField(this, "footballFacade", null);

  __publicField(this, "getCountries",
  /*#__PURE__*/
  function () {
    var _ref212 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee182(t2) {
      return _regeneratorRuntime.wrap(function _callee182$(_context183) {
        while (1) {
          switch (_context183.prev = _context183.next) {
            case 0:
              _context183.next = 2;
              return _this79.footballFacade.getCountries(t2);

            case 2:
              return _context183.abrupt("return", _context183.sent);

            case 3:
            case "end":
              return _context183.stop();
          }
        }
      }, _callee182);
    }));

    return function (_x258) {
      return _ref212.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitions",
  /*#__PURE__*/
  function () {
    var _ref213 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee183(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee183$(_context184) {
        while (1) {
          switch (_context184.prev = _context184.next) {
            case 0:
              _context184.next = 2;
              return _this79.footballFacade.getCompetitions(t2, e2);

            case 2:
              return _context184.abrupt("return", _context184.sent);

            case 3:
            case "end":
              return _context184.stop();
          }
        }
      }, _callee183);
    }));

    return function (_x259, _x260) {
      return _ref213.apply(this, arguments);
    };
  }());

  __publicField(this, "getCompetitionById",
  /*#__PURE__*/
  function () {
    var _ref214 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee184(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee184$(_context185) {
        while (1) {
          switch (_context185.prev = _context185.next) {
            case 0:
              _context185.next = 2;
              return _this79.footballFacade.getCompetitionById(t2, e2);

            case 2:
              return _context185.abrupt("return", _context185.sent);

            case 3:
            case "end":
              return _context185.stop();
          }
        }
      }, _callee184);
    }));

    return function (_x261, _x262) {
      return _ref214.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopCompetitions",
  /*#__PURE__*/
  function () {
    var _ref215 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee185(t2) {
      return _regeneratorRuntime.wrap(function _callee185$(_context186) {
        while (1) {
          switch (_context186.prev = _context186.next) {
            case 0:
              _context186.next = 2;
              return _this79.footballFacade.getTopCompetitions(t2);

            case 2:
              return _context186.abrupt("return", _context186.sent);

            case 3:
            case "end":
              return _context186.stop();
          }
        }
      }, _callee185);
    }));

    return function (_x263) {
      return _ref215.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeams",
  /*#__PURE__*/
  function () {
    var _ref216 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee186(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee186$(_context187) {
        while (1) {
          switch (_context187.prev = _context187.next) {
            case 0:
              _context187.next = 2;
              return _this79.footballFacade.getTeams(t2, e2);

            case 2:
              return _context187.abrupt("return", _context187.sent);

            case 3:
            case "end":
              return _context187.stop();
          }
        }
      }, _callee186);
    }));

    return function (_x264, _x265) {
      return _ref216.apply(this, arguments);
    };
  }());

  __publicField(this, "getTeamById",
  /*#__PURE__*/
  function () {
    var _ref217 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee187(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee187$(_context188) {
        while (1) {
          switch (_context188.prev = _context188.next) {
            case 0:
              _context188.next = 2;
              return _this79.footballFacade.getTeamById(t2, e2);

            case 2:
              return _context188.abrupt("return", _context188.sent);

            case 3:
            case "end":
              return _context188.stop();
          }
        }
      }, _callee187);
    }));

    return function (_x266, _x267) {
      return _ref217.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopTeams",
  /*#__PURE__*/
  function () {
    var _ref218 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee188(t2) {
      return _regeneratorRuntime.wrap(function _callee188$(_context189) {
        while (1) {
          switch (_context189.prev = _context189.next) {
            case 0:
              _context189.next = 2;
              return _this79.footballFacade.getTopTeams(t2);

            case 2:
              return _context189.abrupt("return", _context189.sent);

            case 3:
            case "end":
              return _context189.stop();
          }
        }
      }, _callee188);
    }));

    return function (_x268) {
      return _ref218.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref219 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee189(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee189$(_context190) {
        while (1) {
          switch (_context190.prev = _context190.next) {
            case 0:
              _context190.next = 2;
              return _this79.footballFacade.getNextMatchForTeam(t2, e2);

            case 2:
              return _context190.abrupt("return", _context190.sent);

            case 3:
            case "end":
              return _context190.stop();
          }
        }
      }, _callee189);
    }));

    return function (_x269, _x270) {
      return _ref219.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForTeam",
  /*#__PURE__*/
  function () {
    var _ref220 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee190(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee190$(_context191) {
        while (1) {
          switch (_context191.prev = _context191.next) {
            case 0:
              _context191.next = 2;
              return _this79.footballFacade.getPrevMatchForTeam(t2, e2);

            case 2:
              return _context191.abrupt("return", _context191.sent);

            case 3:
            case "end":
              return _context191.stop();
          }
        }
      }, _callee190);
    }));

    return function (_x271, _x272) {
      return _ref220.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayers",
  /*#__PURE__*/
  function () {
    var _ref221 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee191(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee191$(_context192) {
        while (1) {
          switch (_context192.prev = _context192.next) {
            case 0:
              _context192.next = 2;
              return _this79.footballFacade.getPlayers(t2, e2);

            case 2:
              return _context192.abrupt("return", _context192.sent);

            case 3:
            case "end":
              return _context192.stop();
          }
        }
      }, _callee191);
    }));

    return function (_x273, _x274) {
      return _ref221.apply(this, arguments);
    };
  }());

  __publicField(this, "getPlayerById",
  /*#__PURE__*/
  function () {
    var _ref222 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee192(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee192$(_context193) {
        while (1) {
          switch (_context193.prev = _context193.next) {
            case 0:
              _context193.next = 2;
              return _this79.footballFacade.getPlayerById(t2, e2);

            case 2:
              return _context193.abrupt("return", _context193.sent);

            case 3:
            case "end":
              return _context193.stop();
          }
        }
      }, _callee192);
    }));

    return function (_x275, _x276) {
      return _ref222.apply(this, arguments);
    };
  }());

  __publicField(this, "getTopPlayers",
  /*#__PURE__*/
  function () {
    var _ref223 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee193(t2) {
      return _regeneratorRuntime.wrap(function _callee193$(_context194) {
        while (1) {
          switch (_context194.prev = _context194.next) {
            case 0:
              _context194.next = 2;
              return _this79.footballFacade.getTopPlayers(t2);

            case 2:
              return _context194.abrupt("return", _context194.sent);

            case 3:
            case "end":
              return _context194.stop();
          }
        }
      }, _callee193);
    }));

    return function (_x277) {
      return _ref223.apply(this, arguments);
    };
  }());

  __publicField(this, "getNextMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref224 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee194(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee194$(_context195) {
        while (1) {
          switch (_context195.prev = _context195.next) {
            case 0:
              _context195.next = 2;
              return _this79.footballFacade.getNextMatchForPlayer(t2, e2);

            case 2:
              return _context195.abrupt("return", _context195.sent);

            case 3:
            case "end":
              return _context195.stop();
          }
        }
      }, _callee194);
    }));

    return function (_x278, _x279) {
      return _ref224.apply(this, arguments);
    };
  }());

  __publicField(this, "getPrevMatchForPlayer",
  /*#__PURE__*/
  function () {
    var _ref225 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee195(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee195$(_context196) {
        while (1) {
          switch (_context196.prev = _context196.next) {
            case 0:
              _context196.next = 2;
              return _this79.footballFacade.getPrevMatchForPlayer(t2, e2);

            case 2:
              return _context196.abrupt("return", _context196.sent);

            case 3:
            case "end":
              return _context196.stop();
          }
        }
      }, _callee195);
    }));

    return function (_x280, _x281) {
      return _ref225.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatches",
  /*#__PURE__*/
  function () {
    var _ref226 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee196(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee196$(_context197) {
        while (1) {
          switch (_context197.prev = _context197.next) {
            case 0:
              _context197.next = 2;
              return _this79.footballFacade.getMatches(t2, e2);

            case 2:
              return _context197.abrupt("return", _context197.sent);

            case 3:
            case "end":
              return _context197.stop();
          }
        }
      }, _callee196);
    }));

    return function (_x282, _x283) {
      return _ref226.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchById",
  /*#__PURE__*/
  function () {
    var _ref227 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee197(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee197$(_context198) {
        while (1) {
          switch (_context198.prev = _context198.next) {
            case 0:
              _context198.next = 2;
              return _this79.footballFacade.getMatchById(t2, e2);

            case 2:
              return _context198.abrupt("return", _context198.sent);

            case 3:
            case "end":
              return _context198.stop();
          }
        }
      }, _callee197);
    }));

    return function (_x284, _x285) {
      return _ref227.apply(this, arguments);
    };
  }());

  __publicField(this, "search",
  /*#__PURE__*/
  function () {
    var _ref228 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee198(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee198$(_context199) {
        while (1) {
          switch (_context199.prev = _context199.next) {
            case 0:
              _context199.next = 2;
              return _this79.footballFacade.search(t2, e2);

            case 2:
              return _context199.abrupt("return", _context199.sent);

            case 3:
            case "end":
              return _context199.stop();
          }
        }
      }, _callee198);
    }));

    return function (_x286, _x287) {
      return _ref228.apply(this, arguments);
    };
  }());

  this.https = new Z(t2), this.idMapping = new F(t2), this.localCache = new V().createLocalCacheInstance(t2.idSchema), this.footballFacade = new Vt(t2, this.localCache, this.https, this.idMapping);
};

var Fa = function Fa() {
  _classCallCheck3(this, Fa);

  __publicField(this, "value", null);

  __publicField(this, "playerId", null);

  __publicField(this, "playerModel", null);
};

var ae = function ae() {
  _classCallCheck3(this, ae);

  __publicField(this, "market", null);

  __publicField(this, "matchId", null);

  __publicField(this, "matchType", null);

  __publicField(this, "matchModel", null);

  __publicField(this, "prediction", new Fa());

  __publicField(this, "result", null);
};

var Ea = function Ea() {
  _classCallCheck3(this, Ea);

  __publicField(this, "value", false);

  __publicField(this, "playerId", null);
};

var j$1 = function j$1(t2, e2, i, a) {
  _classCallCheck3(this, j$1);

  __publicField(this, "matchId", null);

  __publicField(this, "market", null);

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.market = e2, this.prediction = new Ea(), this.prediction.value = i, this.prediction.playerId = a;
};

var re = function re() {
  _classCallCheck3(this, re);

  __publicField(this, "settledAt", null);

  __publicField(this, "resettledAt", null);

  __publicField(this, "status", null);

  __publicField(this, "outcome", null);

  __publicField(this, "points", 0);
};

var Ra = function Ra() {
  _classCallCheck3(this, Ra);

  __publicField(this, "value", null);
};

var ht = function ht(t2, e2, i) {
  _classCallCheck3(this, ht);

  __publicField(this, "matchId", null);

  __publicField(this, "market", null);

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.market = e2, this.prediction = new Ra(), this.prediction.value = i;
};

var q$2 = function q$2() {
  _classCallCheck3(this, q$2);

  __publicField(this, "value", false);
};

var oe = function oe(t2, e2, i) {
  _classCallCheck3(this, oe);

  __publicField(this, "matchId", null);

  __publicField(this, "market", null);

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.market = e2, this.prediction = new q$2(), this.prediction.value = i;
};

var se = function se(t2, e2, i) {
  _classCallCheck3(this, se);

  __publicField(this, "matchId", null);

  __publicField(this, "market", null);

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.market = e2, this.prediction = new q$2(), this.prediction.value = i;
};

var Sa = function Sa(t2, e2, i) {
  var _this80 = this;

  _classCallCheck3(this, Sa);

  __publicField(this, "matchFacade", null);

  __publicField(this, "playerFacade", null);

  __publicField(this, "predictorService", null);

  __publicField(this, "remapFixturesRequest", function (t2) {
    var e2 = {};
    if (e2.match_id = t2.matchId, e2.match_type = "FOOTBALL", t2 instanceof j$1) e2.market = t2.market, e2.prediction = t2.prediction.value, e2.player_id = t2.prediction.playerId;else if (t2 instanceof oe || t2 instanceof se) e2.market = t2.market, e2.prediction = t2.prediction.value;else if (t2 instanceof ht) {
      e2.market = t2.market;

      var _i39 = t2.prediction.value.split(":");

      e2.goals_home = Number(_i39[0]), e2.goals_away = Number(_i39[1]);
    } else e2.market = t2.market, e2.prediction = t2.prediction.value;
    return e2;
  });

  __publicField(this, "remapFixturesResponse",
  /*#__PURE__*/
  function () {
    var _ref229 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee199(t2) {
      var e2, i, a, r2, s, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, n2, p2, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, _n2, l2;

      return _regeneratorRuntime.wrap(function _callee199$(_context200) {
        while (1) {
          switch (_context200.prev = _context200.next) {
            case 0:
              e2 = "OWN_GOAL", i = [], a = [], r2 = null, s = [];
              t2.length > 1 && t2.sort(function (n2, l2) {
                return n2.match_id.localeCompare(l2.match_id);
              });
              _iteratorNormalCompletion16 = true;
              _didIteratorError16 = false;
              _iteratorError16 = undefined;
              _context200.prev = 5;

              for (_iterator16 = t2[Symbol.iterator](); !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                n2 = _step16.value;
                i.push(n2.match_id), n2.player_id && !a.includes(n2.player_id) && a.push(n2.player_id);
              }

              _context200.next = 13;
              break;

            case 9:
              _context200.prev = 9;
              _context200.t0 = _context200["catch"](5);
              _didIteratorError16 = true;
              _iteratorError16 = _context200.t0;

            case 13:
              _context200.prev = 13;
              _context200.prev = 14;

              if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                _iterator16.return();
              }

            case 16:
              _context200.prev = 16;

              if (!_didIteratorError16) {
                _context200.next = 19;
                break;
              }

              throw _iteratorError16;

            case 19:
              return _context200.finish(16);

            case 20:
              return _context200.finish(13);

            case 21:
              _context200.next = 23;
              return _this80.matchFacade.getMatchesMapWithNativeIds(i);

            case 23:
              p2 = _context200.sent;
              a.sort(function (n2, l2) {
                return n2.localeCompare(l2);
              });
              _context200.t1 = a && a.length > 0 && !a.includes(e2);

              if (!_context200.t1) {
                _context200.next = 30;
                break;
              }

              _context200.next = 29;
              return _this80.playerFacade.getPlayersMapWithNativeIds(a);

            case 29:
              r2 = _context200.sent;

            case 30:
              _iteratorNormalCompletion17 = true;
              _didIteratorError17 = false;
              _iteratorError17 = undefined;
              _context200.prev = 33;

              for (_iterator17 = t2[Symbol.iterator](); !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                _n2 = _step17.value;
                l2 = new ae();
                _n2.target ? l2.market = _this80.predictorService.convertMarketForResponseModel(_n2.market, _n2.target) : l2.market = _n2.market, l2.matchId = p2[_n2.match_id].id, l2.matchType = _n2.match_type, l2.matchModel = p2 ? p2[_n2.match_id] : null, delete l2.matchModel.availableMarkets, _n2.goals_home !== void 0 && _n2.goals_away !== void 0 ? l2.prediction.value = _n2.goals_home.toString() + ":" + _n2.goals_away.toString() : l2.prediction.value = _n2.prediction, l2.prediction.playerId = _n2.player_id ? _n2.player_id : null, l2.prediction.playerId && l2.prediction.playerId !== e2 && (l2.prediction.playerModel = r2[_n2.player_id], l2.prediction.playerId = r2[_n2.player_id].id), l2.result = _this80.remapResult(_n2.result), s.push(l2);
              }

              _context200.next = 41;
              break;

            case 37:
              _context200.prev = 37;
              _context200.t2 = _context200["catch"](33);
              _didIteratorError17 = true;
              _iteratorError17 = _context200.t2;

            case 41:
              _context200.prev = 41;
              _context200.prev = 42;

              if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                _iterator17.return();
              }

            case 44:
              _context200.prev = 44;

              if (!_didIteratorError17) {
                _context200.next = 47;
                break;
              }

              throw _iteratorError17;

            case 47:
              return _context200.finish(44);

            case 48:
              return _context200.finish(41);

            case 49:
              return _context200.abrupt("return", s);

            case 50:
            case "end":
              return _context200.stop();
          }
        }
      }, _callee199, null, [[5, 9, 13, 21], [14,, 16, 20], [33, 37, 41, 49], [42,, 44, 48]]);
    }));

    return function (_x288) {
      return _ref229.apply(this, arguments);
    };
  }());

  __publicField(this, "remapResult", function (t2) {
    var e2 = new re();
    return e2.settledAt = t2.settled_at, e2.resettledAt = t2.resettled_at, e2.status = t2.status, e2.outcome = t2.outcome, e2.points = t2.points, e2;
  });

  this.matchFacade = t2, this.playerFacade = e2, this.predictorService = i;
};

var et = function et() {
  _classCallCheck3(this, et);

  __publicField(this, "goldenGoal", null);
};

var $e = function $e() {
  _classCallCheck3(this, $e);

  __publicField(this, "id", null);

  __publicField(this, "gameInstanceId", null);

  __publicField(this, "gameType", null);

  __publicField(this, "wager", null);

  __publicField(this, "totalFixtures", null);

  __publicField(this, "settledFixtures", null);

  __publicField(this, "userId", null);

  __publicField(this, "fixtures", []);

  __publicField(this, "status", null);

  __publicField(this, "tiebreaker", new et());

  __publicField(this, "points", null);

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);
};

var v$1 = function v$1() {
  _classCallCheck3(this, v$1);

  __publicField(this, "no", 0);

  __publicField(this, "yes", 0);
};

var Ca = function Ca() {
  _classCallCheck3(this, Ca);

  __publicField(this, "fullTimeOneXTwo", {});

  __publicField(this, "halfTimeOneXTwo", {});

  __publicField(this, "bothTeamsScore", new v$1());

  __publicField(this, "doubleChance", {});

  __publicField(this, "halfTimeFullTime", {});

  __publicField(this, "playerScore", {});

  __publicField(this, "playerYellowCard", {});

  __publicField(this, "playerRedCard", {});

  __publicField(this, "redCardMatch", new v$1());

  __publicField(this, "penaltyMatch", new v$1());

  __publicField(this, "playerScoreFirstGoal", {});

  __publicField(this, "cornersMatch", {});

  __publicField(this, "correctScore", {});

  __publicField(this, "correctScoreHalfTime", {});

  __publicField(this, "correctScoreAdvanced", {});

  __publicField(this, "playerScoreHattrick", {});

  __publicField(this, "playerScoreTwice", {});

  __publicField(this, "overZeroPointFiveGoals", new v$1());

  __publicField(this, "overOnePointFiveGoals", new v$1());

  __publicField(this, "overTwoPointFiveGoals", new v$1());

  __publicField(this, "overThreePointFiveGoals", new v$1());

  __publicField(this, "overFourPointFiveGoals", new v$1());

  __publicField(this, "overFivePointFiveGoals", new v$1());

  __publicField(this, "overSixPointFiveGoals", new v$1());

  __publicField(this, "overSixPointFiveCorners", new v$1());

  __publicField(this, "overSevenPointFiveCorners", new v$1());

  __publicField(this, "overEightPointFiveCorners", new v$1());

  __publicField(this, "overNinePointFiveCorners", new v$1());

  __publicField(this, "overTenPointFiveCorners", new v$1());

  __publicField(this, "overElevenPointFiveCorners", new v$1());

  __publicField(this, "overTwelvePointFiveCorners", new v$1());

  __publicField(this, "overThirteenPointFiveCorners", new v$1());
};

var it = function it() {
  _classCallCheck3(this, it);

  __publicField(this, "timeTiebreaker", false);
};

var gt = function gt() {
  _classCallCheck3(this, gt);

  __publicField(this, "id", null);

  __publicField(this, "title", null);

  __publicField(this, "description", null);

  __publicField(this, "type", null);

  __publicField(this, "status", null);

  __publicField(this, "outcome", null);

  __publicField(this, "predictionsCutoff", null);

  __publicField(this, "fixtures", []);

  __publicField(this, "tiebreaker", new it());

  __publicField(this, "predictionId", null);

  __publicField(this, "participantsCount", 0);

  __publicField(this, "related", null);

  __publicField(this, "excludedProfileIds", null);

  __publicField(this, "rules", null);

  __publicField(this, "flags", null);

  __publicField(this, "points", null);

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);

  __publicField(this, "predictionsMadeAt", null);

  __publicField(this, "scheduleOpenAt", null);

  __publicField(this, "images", null);

  __publicField(this, "predictionTiebreaker", new et());
};

var Et = function Et() {
  _classCallCheck3(this, Et);

  __publicField(this, "userId", null);

  __publicField(this, "points", null);

  __publicField(this, "results", []);

  __publicField(this, "tiebreaker", null);
};

var Ro = function (r2) {
  return r2.ACTIVE = "ACTIVE", r2.WON = "WON", r2.LOST = "LOST", r2.PARTIALLY_WON = "PARTIALLY_WON", r2.CANCELED = "CANCELED", r2;
}(Ro || {}),
    ko = ["WON", "LOST", "PARTIALLY_WON", "CANCELED"];

var O = function O(t2) {
  var _this81 = this;

  _classCallCheck3(this, O);

  __publicField(this, "limit", null);

  __publicField(this, "startAfter", null);

  __publicField(this, "status", null);

  __publicField(this, "type", null);

  __publicField(this, "matchIds", null);

  __publicField(this, "gameIds", null);

  __publicField(this, "constructFiltersUrl", function () {
    var t2 = "",
        e2 = false;
    return _this81.status && (e2 = Object.values(Ro).some(function (i) {
      return _this81.status.includes(i);
    })), _this81.limit && (t2 += "&", t2 += "limit=".concat(_this81.limit)), _this81.startAfter && (t2 += "&", t2 += "start_after=".concat(_this81.startAfter)), _this81.status && e2 && (t2 += "&", t2 += "status=".concat(_this81.status.join(","))), _this81.type && (t2 += "&", t2 += "game_types=".concat(_this81.type)), _this81.matchIds && (t2 += "&", t2 += "match_ids=".concat(_this81.matchIds.join(","))), _this81.gameIds && (t2 += "&", t2 += "game_ids=".concat(_this81.gameIds.join(","))), t2;
  });

  this.limit = t2.limit ? t2.limit : null, this.startAfter = t2.startAfter ? t2.startAfter : null, this.status = t2.status ? t2.status : null, this.type = t2.type ? t2.type : null, this.matchIds = t2.matchIds ? t2.matchIds : null, this.gameIds = t2.gameIds ? t2.gameIds : null;
};

var N =
/*#__PURE__*/
function () {
  function N(t2) {
    _classCallCheck3(this, N);

    __publicField(this, "limit");

    __publicField(this, "startAfter");

    this.limit = t2 && t2.limit ? t2.limit : null, this.startAfter = t2 && t2.startAfter ? t2.startAfter : null;
  }

  _createClass3(N, [{
    key: "constructMainFiltersUrl",
    value: function constructMainFiltersUrl() {
      var t2 = "";
      return this.limit && (t2 += "&", t2 += "limit=".concat(this.limit)), this.startAfter && (t2 += "&", t2 += "start_after=".concat(this.startAfter)), t2;
    }
  }]);

  return N;
}();

var Aa = function (s) {
  return s.OPEN = "OPEN", s.LIVE = "LIVE", s.PENDING = "PENDING", s.CANCELED = "CANCELED", s.CLOSED = "CLOSED", s.SETTLED = "SETTLED", s;
}(Aa || {});

var z$1 =
/*#__PURE__*/
function (_N) {
  _inherits3(z$1, _N);

  function z$1(t2) {
    var _this82;

    _classCallCheck3(this, z$1);

    _this82 = _possibleConstructorReturn3(this, _getPrototypeOf4(z$1).call(this, t2));

    __publicField(_assertThisInitialized3(_this82), "status", null);

    __publicField(_assertThisInitialized3(_this82), "type", null);

    __publicField(_assertThisInitialized3(_this82), "gameIds", null);

    __publicField(_assertThisInitialized3(_this82), "sortOrder", null);

    __publicField(_assertThisInitialized3(_this82), "constructFiltersUrl", function () {
      var t2 = _get2(_getPrototypeOf4(z$1.prototype), "constructMainFiltersUrl", _assertThisInitialized3(_this82)).call(_assertThisInitialized3(_this82));

      return _this82.status && Object.values(Aa).includes(_this82.status) && (t2 += "&", t2 += "status=".concat(_this82.status)), _this82.type && (t2 += "&", t2 += "type=".concat(_this82.type)), _this82.gameIds && _this82.gameIds.length > 0 && (t2 += "&", t2 += "game_ids=".concat(_this82.gameIds.join(","))), _this82.sortOrder && (t2 += "&", t2 += "sort_order=".concat(_this82.sortOrder)), t2;
    });

    _this82.status = t2.status ? t2.status : null, _this82.type = t2.type ? t2.type : null, _this82.gameIds = t2.gameIds ? t2.gameIds : null, _this82.sortOrder = t2.sortOrder ? t2.sortOrder : null;
    return _this82;
  }

  return z$1;
}(N);

var ft = function ft() {
  _classCallCheck3(this, ft);

  __publicField(this, "main", null);

  __publicField(this, "cover", null);

  __publicField(this, "mobile", null);
};

var st = function st() {
  _classCallCheck3(this, st);

  __publicField(this, "id", null);

  __publicField(this, "title", null);

  __publicField(this, "description", null);

  __publicField(this, "type", null);

  __publicField(this, "status", null);

  __publicField(this, "scheduleOpenAt", null);

  __publicField(this, "predictionsCutoff", null);

  __publicField(this, "fixtures", []);

  __publicField(this, "tiebreaker", new it());

  __publicField(this, "participantsCount", 0);

  __publicField(this, "related", null);

  __publicField(this, "excludedProfileIds", null);

  __publicField(this, "rules", null);

  __publicField(this, "labels", null);

  __publicField(this, "customFields", null);

  __publicField(this, "flags", null);

  __publicField(this, "images", new ft());

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);
};

var nt = function nt() {
  _classCallCheck3(this, nt);

  __publicField(this, "id", null);

  __publicField(this, "title", null);

  __publicField(this, "description", null);

  __publicField(this, "type", null);

  __publicField(this, "status", null);

  __publicField(this, "outcome", null);

  __publicField(this, "predictionsCutoff", null);

  __publicField(this, "fixtures", []);

  __publicField(this, "tiebreaker", new it());

  __publicField(this, "predictionId", null);

  __publicField(this, "participantsCount", 0);

  __publicField(this, "related", null);

  __publicField(this, "excludedProfileIds", null);

  __publicField(this, "rules", null);

  __publicField(this, "flags", null);

  __publicField(this, "points", null);

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);

  __publicField(this, "predictionsMadeAt", null);

  __publicField(this, "images", null);

  __publicField(this, "scheduleOpenAt", null);
};

var ne =
/*#__PURE__*/
function (_st) {
  _inherits3(ne, _st);

  function ne() {
    var _this83;

    _classCallCheck3(this, ne);

    _this83 = _possibleConstructorReturn3(this, _getPrototypeOf4(ne).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this83), "adContent", null);

    return _this83;
  }

  return ne;
}(st);

var at = function at(t2, e2) {
  var _this84 = this;

  _classCallCheck3(this, at);

  __publicField(this, "footballHttps", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "matchFacade", null);

  __publicField(this, "playerFacade", null);

  __publicField(this, "profileNamespace", null);

  __publicField(this, "remapMatchIdToNative",
  /*#__PURE__*/
  function () {
    var _ref230 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee200(t2) {
      return _regeneratorRuntime.wrap(function _callee200$(_context201) {
        while (1) {
          switch (_context201.prev = _context201.next) {
            case 0:
              _context201.next = 2;
              return _this84.idMapping.getEntityIdsBySchemaId(t2, "match", "native");

            case 2:
              return _context201.abrupt("return", _context201.sent.match);

            case 3:
            case "end":
              return _context201.stop();
          }
        }
      }, _callee200);
    }));

    return function (_x289) {
      return _ref230.apply(this, arguments);
    };
  }());

  __publicField(this, "remapPlayerIdToNative",
  /*#__PURE__*/
  function () {
    var _ref231 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee201(t2) {
      return _regeneratorRuntime.wrap(function _callee201$(_context202) {
        while (1) {
          switch (_context202.prev = _context202.next) {
            case 0:
              _context202.next = 2;
              return _this84.idMapping.getEntityIdsBySchemaId(t2, "player", "native");

            case 2:
              return _context202.abrupt("return", _context202.sent.player[0]);

            case 3:
            case "end":
              return _context202.stop();
          }
        }
      }, _callee201);
    }));

    return function (_x290) {
      return _ref231.apply(this, arguments);
    };
  }());

  __publicField(this, "remapPlayerIdMapToNative",
  /*#__PURE__*/
  function () {
    var _ref232 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee202(t2) {
      var e2, i, r2;
      return _regeneratorRuntime.wrap(function _callee202$(_context203) {
        while (1) {
          switch (_context203.prev = _context203.next) {
            case 0:
              e2 = {};
              i = Pt(t2);
              _context203.next = 4;
              return _this84.idMapping.getEntityIdsBySchemaId(i, "player", "native");

            case 4:
              r2 = _context203.sent.player;
              return _context203.abrupt("return", (i.forEach(function (s, p2) {
                return e2[s] = r2[p2];
              }), e2));

            case 6:
            case "end":
              return _context203.stop();
          }
        }
      }, _callee202);
    }));

    return function (_x291) {
      return _ref232.apply(this, arguments);
    };
  }());

  __publicField(this, "remapPlayerIdToIdSchema",
  /*#__PURE__*/
  function () {
    var _ref233 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee203(t2) {
      var e2, i, _i40, _Object$entries5, _ref238, _ref235, r2, _s10, _i42, _Object$keys, _p3, a, _i41, _Object$entries6, _ref239, _ref237, _r13, _s11, _i43, _Object$keys2, _p4;

      return _regeneratorRuntime.wrap(function _callee203$(_context204) {
        while (1) {
          switch (_context204.prev = _context204.next) {
            case 0:
              e2 = ["playerScore", "playerYellowCard", "playerRedCard", "playerScoreFirstGoal", "playerScoreHattrick", "playerScoreTwice"], i = [];

              for (_i40 = 0, _Object$entries5 = Object.entries(t2); _i40 < _Object$entries5.length; _i40++) {
                _ref238 = _Object$entries5[_i40];
                _ref235 = _slicedToArray3(_ref238, 2);
                r2 = _ref235[0];
                _s10 = _ref235[1];

                if (e2.includes(r2)) {
                  for (_i42 = 0, _Object$keys = Object.keys(_s10); _i42 < _Object$keys.length; _i42++) {
                    _p3 = _Object$keys[_i42];
                    _p3 !== "NOBODY" && _p3 !== "OWN_GOAL" && i.push(_p3);
                  }
                }
              }

              if (i.length) {
                _context204.next = 4;
                break;
              }

              return _context204.abrupt("return", t2);

            case 4:
              _context204.next = 6;
              return _this84.playerFacade.getPlayersMapWithNativeIds(i);

            case 6:
              a = _context204.sent;

              for (_i41 = 0, _Object$entries6 = Object.entries(t2); _i41 < _Object$entries6.length; _i41++) {
                _ref239 = _Object$entries6[_i41];
                _ref237 = _slicedToArray3(_ref239, 2);
                _r13 = _ref237[0];
                _s11 = _ref237[1];

                if (e2.includes(_r13)) {
                  for (_i43 = 0, _Object$keys2 = Object.keys(_s11); _i43 < _Object$keys2.length; _i43++) {
                    _p4 = _Object$keys2[_i43];
                    _p4 !== "NOBODY" && _p4 !== "OWN_GOAL" && (_s11[a[_p4].id] = _s11[_p4], _s11[a[_p4].id].model = a[_p4], _this84.idMapping.idSchema !== "native" && delete _s11[_p4]);
                  }
                }
              }

              return _context204.abrupt("return", t2);

            case 9:
            case "end":
              return _context204.stop();
          }
        }
      }, _callee203);
    }));

    return function (_x292) {
      return _ref233.apply(this, arguments);
    };
  }());

  __publicField(this, "convertMarketForResponseModel", function (t2, e2) {
    var i = e2.toString();
    return t2 + "_" + i;
  });

  __publicField(this, "getMarketSummary",
  /*#__PURE__*/
  function () {
    var _ref240 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee204(t2, e2, i) {
      var a, r2, _p5, n2, _p6, _n3;

      return _regeneratorRuntime.wrap(function _callee204$(_context205) {
        while (1) {
          switch (_context205.prev = _context205.next) {
            case 0:
              a = Yo.get(e2), r2 = {};

              if (!(r2.matchId = t2.matchId, r2.matchType = t2.matchType, Object.keys(t2.predictions).includes(a))) {
                _context205.next = 5;
                break;
              }

              r2[a] = t2.predictions[a];
              _context205.next = 6;
              break;

            case 5:
              throw new Error("You have passed invalid market");

            case 6:
              if (!(tt.includes(e2) && i)) {
                _context205.next = 23;
                break;
              }

              _p5 = "";
              _context205.t0 = i !== "OWN_GOAL" && i !== "NOBODY";

              if (!_context205.t0) {
                _context205.next = 13;
                break;
              }

              _context205.next = 12;
              return _this84.idMapping.idMappingFacade.getEntitiesByIds({
                player: [i]
              }, _this84.idMapping.idSchema, "native");

            case 12:
              _p5 = _context205.sent.player[0];

            case 13:
              if (!(_p5 && r2[a][_p5])) {
                _context205.next = 20;
                break;
              }

              _context205.next = 16;
              return _this84.playerFacade.getPlayersMapWithNativeIds([_p5]);

            case 16:
              n2 = _context205.sent;
              return _context205.abrupt("return", (r2[a][_p5].model = n2[_p5], r2[a][_p5]));

            case 20:
              return _context205.abrupt("return", _p5 ? (r2[a][_p5] = new v$1(), r2[a][_p5]) : r2[a][i]);

            case 21:
              _context205.next = 34;
              break;

            case 23:
              if (!(tt.includes(e2) && !i)) {
                _context205.next = 34;
                break;
              }

              _p6 = Object.keys(r2[a]).filter(function (l2) {
                return l2 !== "NOBODY" && l2 !== "OWN_GOAL";
              });

              if (!_p6.length) {
                _context205.next = 31;
                break;
              }

              _context205.next = 28;
              return _this84.playerFacade.getPlayersMapWithNativeIds(_p6);

            case 28:
              _context205.t1 = _context205.sent;
              _context205.next = 32;
              break;

            case 31:
              _context205.t1 = {};

            case 32:
              _n3 = _context205.t1;
              Object.keys(_n3).length && Object.keys(r2[a]).forEach(function (l2) {
                l2 !== "NOBODY" && l2 !== "OWN_GOAL" && (r2[a][_n3[l2].id] = r2[a][l2], r2[a][_n3[l2].id].model = _n3[l2], _this84.idMapping.idSchema !== "native" && delete r2[a][l2]);
              });

            case 34:
              return _context205.abrupt("return", r2);

            case 35:
            case "end":
              return _context205.stop();
          }
        }
      }, _callee204);
    }));

    return function (_x293, _x294, _x295) {
      return _ref240.apply(this, arguments);
    };
  }());

  __publicField(this, "remapCompetitionsFromConfig",
  /*#__PURE__*/
  function () {
    var _ref241 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee205(t2) {
      var _e11, _i44, a, r2, _s12, _p7, _e12, _i45;

      return _regeneratorRuntime.wrap(function _callee205$(_context206) {
        while (1) {
          switch (_context206.prev = _context206.next) {
            case 0:
              if (!(t2 instanceof kt)) {
                _context206.next = 14;
                break;
              }

              _e11 = {
                competition: t2.fullCoverageCompetitions
              };
              _i44 = {
                competition: t2.successRateScopes.competitions
              };
              a = {
                team: t2.successRateScopes.teams
              };
              _context206.next = 6;
              return _this84.idMapping.idMappingFacade.getEntitiesByIds(_e11, "native", _this84.idMapping.idSchema);

            case 6:
              r2 = _context206.sent;
              _context206.next = 9;
              return _this84.idMapping.idMappingFacade.getEntitiesByIds(_i44, "native", _this84.idMapping.idSchema);

            case 9:
              _s12 = _context206.sent;
              _context206.next = 12;
              return _this84.idMapping.idMappingFacade.getEntitiesByIds(a, "native", _this84.idMapping.idSchema);

            case 12:
              _p7 = _context206.sent;
              return _context206.abrupt("return", (t2.fullCoverageCompetitions = r2.competition, t2.successRateScopes.competitions = _s12.competition, t2.successRateScopes.teams = _p7.team, t2));

            case 14:
              if (!(t2 instanceof Ht || t2 instanceof Ut)) {
                _context206.next = 20;
                break;
              }

              _e12 = {
                competition: t2.competitionsWhitelist
              };
              _context206.next = 18;
              return _this84.idMapping.idMappingFacade.getEntitiesByIds(_e12, "native", _this84.idMapping.idSchema);

            case 18:
              _i45 = _context206.sent;
              return _context206.abrupt("return", (t2.competitionsWhitelist = _i45.competition, t2));

            case 20:
            case "end":
              return _context206.stop();
          }
        }
      }, _callee205);
    }));

    return function (_x296) {
      return _ref241.apply(this, arguments);
    };
  }());

  __publicField(this, "remapMatchIdsFixtures",
  /*#__PURE__*/
  function () {
    var _ref242 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee206(t2) {
      var _e13, _i46;

      return _regeneratorRuntime.wrap(function _callee206$(_context207) {
        while (1) {
          switch (_context207.prev = _context207.next) {
            case 0:
              if (!Array.isArray(t2.data)) {
                _context207.next = 12;
                break;
              }

              if (!(t2.data.length > 0)) {
                _context207.next = 9;
                break;
              }

              _e13 = [], _i46 = [];
              t2.data.forEach(function (a) {
                a instanceof st || a instanceof gt || a instanceof nt || a instanceof ne ? (a.fixtures.forEach(function (r2) {
                  return _e13.push(r2.matchId);
                }), a instanceof nt && a.fixtures.forEach(function (r2) {
                  r2.prediction.playerId && r2.prediction.playerId !== "OWN_GOAL" && _i46.push(r2.prediction.playerId);
                })) : a instanceof Et && a.results.forEach(function (r2) {
                  return _e13.push(r2.matchId);
                });
              });
              _context207.next = 6;
              return _this84.refactorResponseArrModel(t2, _e13, _i46);

            case 6:
              return _context207.abrupt("return", _context207.sent);

            case 9:
              return _context207.abrupt("return", t2);

            case 10:
              _context207.next = 15;
              break;

            case 12:
              _context207.next = 14;
              return _this84.refactorResponseObjModel(t2);

            case 14:
              return _context207.abrupt("return", _context207.sent);

            case 15:
            case "end":
              return _context207.stop();
          }
        }
      }, _callee206);
    }));

    return function (_x297) {
      return _ref242.apply(this, arguments);
    };
  }());

  __publicField(this, "refactorResponseArrModel",
  /*#__PURE__*/
  function () {
    var _ref243 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee207(t2, e2, i) {
      var a, r2, s;
      return _regeneratorRuntime.wrap(function _callee207$(_context208) {
        while (1) {
          switch (_context208.prev = _context208.next) {
            case 0:
              a = [];
              _context208.next = 3;
              return _this84.matchFacade.getMatchesMapWithNativeIds(e2);

            case 3:
              r2 = _context208.sent;
              s = {};
              _context208.t0 = i.length > 0;

              if (!_context208.t0) {
                _context208.next = 10;
                break;
              }

              _context208.next = 9;
              return _this84.playerFacade.getPlayersMapWithNativeIds(i);

            case 9:
              s = _context208.sent;

            case 10:
              t2.data.forEach(function (p2) {
                p2 instanceof st || p2 instanceof gt || p2 instanceof nt ? (p2.fixtures.forEach(function (n2) {
                  _this84.handleMatchModel(r2, n2), p2 instanceof nt && n2.prediction.playerId && n2.prediction.playerId !== "OWN_GOAL" && (n2.prediction.playerModel = s[n2.prediction.playerId], n2.prediction.playerId = s[n2.prediction.playerId].id);
                }), a.push(p2)) : p2 instanceof Et && (p2.results.forEach(function (n2) {
                  n2.matchModel = r2[n2.matchId], delete n2.matchModel.availableMarkets, n2.matchId = n2.matchModel.id;
                }), a.push(p2));
              });
              t2.data = a;
              return _context208.abrupt("return", t2);

            case 13:
            case "end":
              return _context208.stop();
          }
        }
      }, _callee207);
    }));

    return function (_x298, _x299, _x300) {
      return _ref243.apply(this, arguments);
    };
  }());

  __publicField(this, "refactorResponseObjModel",
  /*#__PURE__*/
  function () {
    var _ref244 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee208(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee208$(_context209) {
        while (1) {
          switch (_context209.prev = _context209.next) {
            case 0:
              e2 = [];
              t2.fixtures.forEach(function (a) {
                return e2.push(a.matchId);
              });
              _context209.next = 4;
              return _this84.matchFacade.getMatchesMapWithNativeIds(e2);

            case 4:
              i = _context209.sent;
              return _context209.abrupt("return", (t2.fixtures.forEach(function (a) {
                return _this84.handleMatchModel(i, a);
              }), t2));

            case 6:
            case "end":
              return _context209.stop();
          }
        }
      }, _callee208);
    }));

    return function (_x301) {
      return _ref244.apply(this, arguments);
    };
  }());

  __publicField(this, "getCurrentGameId", function (t2) {
    var e2 = new Date();

    if (t2.data.length > 1) {
      var _i47 = [];
      return t2.data.forEach(function (r2) {
        return _i47.push(r2.predictionsCutoff);
      }), t2.data.sort(function (r2, s) {
        var _map5 = [r2.predictionsCutoff, s.predictionsCutoff].map(function (l2) {
          return Math.abs(new Date(l2) - e2);
        }),
            _map6 = _slicedToArray3(_map5, 2),
            p2 = _map6[0],
            n2 = _map6[1];

        return p2 - n2;
      })[0].id;
    } else return t2.data[0].id;
  });

  __publicField(this, "initGameTypePredictions", function (t2, e2) {
    var i = {
      type: t2,
      limit: null,
      startAfter: null
    };
    return e2 && (i = _objectSpread3({}, i, {
      limit: e2.limit,
      startAfter: e2.startAfter
    })), i = new O(i), i;
  });

  __publicField(this, "initGameFilters", function (t2, e2, i) {
    if (e2 && i) return e2.type = t2, e2.gameIds = i, e2 = new z$1(e2), e2;
    if (e2 && !i) return e2.type = t2, e2 = new z$1(e2), e2;

    if (!e2 && i) {
      var a = {
        type: t2,
        gameIds: i
      };
      return a = new z$1(a), a;
    } else {
      var _a12 = {
        type: t2
      };
      return _a12 = new z$1(_a12), _a12;
    }
  });

  __publicField(this, "addPredictionProp",
  /*#__PURE__*/
  function () {
    var _ref245 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee209(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee209$(_context210) {
        while (1) {
          switch (_context210.prev = _context210.next) {
            case 0:
              e2.data.forEach(function (i) {
                t2.data.forEach(function (a) {
                  i.id === a.game_instance_id && (i.predictionId = a.id, i.outcome = a.status, i.fixtures.forEach(function (r2, s) {
                    a.fixtures[s].goals_home !== void 0 && a.fixtures[s].goals_away !== void 0 ? r2.prediction.value = a.fixtures[s].goals_home + ":" + a.fixtures[s].goals_away : r2.prediction.value = a.fixtures[s].prediction, a.fixtures[s].player_id ? r2.prediction.playerId = a.fixtures[s].player_id : a.fixtures[s].target && (r2.prediction.target = a.fixtures[s].target), r2.prediction.result = _this84.remapResult(a.fixtures[s].result);
                  }), i.predictionsMadeAt = a.created_at, i.points = a.points, i instanceof gt && (a.tiebreaker ? i.predictionTiebreaker.goldenGoal = a.tiebreaker.golden_goal : i.predictionTiebreaker = a.tiebreaker));
                });
              });
              e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after;
              _context210.next = 4;
              return _this84.remapMatchIdsFixtures(e2);

            case 4:
              return _context210.abrupt("return", _context210.sent);

            case 5:
            case "end":
              return _context210.stop();
          }
        }
      }, _callee209);
    }));

    return function (_x302, _x303) {
      return _ref245.apply(this, arguments);
    };
  }());

  __publicField(this, "remapResult", function (t2) {
    var e2 = new re();
    return e2.settledAt = t2.settled_at, e2.resettledAt = t2.resettled_at, e2.status = t2.status, e2.outcome = t2.outcome, e2.points = t2.points, e2;
  });

  __publicField(this, "areIdsExceeded", function (t2) {
    return t2.length > 10;
  });

  __publicField(this, "initPredictionsFilters", function (t2, e2, i) {
    switch (e2) {
      case "user":
        t2 && (t2 = new O(t2));
        break;

      case "current":
        if (t2) _this84.deleteUnexpectedProperties(t2), t2.status = ["ACTIVE"], t2 = new O(t2);else {
          var a = {
            status: ["ACTIVE"]
          };
          t2 = new O(a);
        }
        break;

      case "past":
        if (t2) _this84.deleteUnexpectedProperties(t2), t2.status = ko, t2 = new O(t2);else {
          var _a13 = {
            status: ko
          };
          t2 = new O(_a13);
        }
        break;

      case "matches":
        if (t2) _this84.deleteUnexpectedProperties(t2), t2.matchIds = i, t2 = new O(t2);else {
          var _a14 = {
            matchIds: i
          };
          t2 = new O(_a14);
        }
        break;
    }

    return t2;
  });

  __publicField(this, "completeGameMarketResults",
  /*#__PURE__*/
  function () {
    var _ref246 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee210(t2, e2) {
      var _i48, a, r2, _s13, _p8, n2, l2, c2;

      return _regeneratorRuntime.wrap(function _callee210$(_context211) {
        while (1) {
          switch (_context211.prev = _context211.next) {
            case 0:
              _context211.t0 = e2;
              _context211.next = _context211.t0 === "MATCH_QUIZ" ? 3 : _context211.t0 === "TOP_X" ? 16 : 27;
              break;

            case 3:
              _i48 = {};
              a = t2.results[0].matchId;
              r2 = t2.results.map(function (l2) {
                return tt.includes(l2.market) && !l2.result.includes("OWN_GOAL") ? _toConsumableArray3(l2.result) : [];
              }).flat();
              _context211.next = 8;
              return _this84.matchFacade.getMatchesMapWithNativeIds([a]);

            case 8:
              _s13 = _context211.sent;
              _context211.t1 = r2.length;

              if (!_context211.t1) {
                _context211.next = 14;
                break;
              }

              _context211.next = 13;
              return _this84.playerFacade.getPlayersMapWithNativeIds(r2);

            case 13:
              _i48 = _context211.sent;

            case 14:
              t2.results = t2.results.map(function (l2) {
                if (l2.matchModel = _s13[l2.matchId] ? _s13[l2.matchId] : null, l2.playerModels && Object.keys(_i48).length && l2.result.forEach(function (d2) {
                  var m2 = _i48[d2];
                  l2.playerModels.push(m2);
                }), _this84.idMapping.idSchema !== "native" && (_this84.remapMatchIdForResultsMarkets(_s13, l2), l2.playerModels && Object.keys(_i48).length)) {
                  var c2 = l2.result;
                  l2.result = c2.map(function (d2) {
                    return _i48[d2].id;
                  });
                }

                return l2;
              });
              return _context211.abrupt("return", t2);

            case 16:
              _p8 = t2.results.map(function (l2) {
                return l2.matchId;
              });
              _context211.next = 19;
              return _this84.matchFacade.getMatchesMapWithNativeIds(_p8);

            case 19:
              n2 = _context211.sent;

              if (!(t2.results = t2.results.map(function (l2) {
                return l2.matchModel = n2[l2.matchId] ? n2[l2.matchId] : null, _this84.idMapping.idSchema !== "native" && _this84.remapMatchIdForResultsMarkets(n2, l2), l2;
              }), t2.tieBreakers.goldenGoals.length)) {
                _context211.next = 26;
                break;
              }

              l2 = t2.tieBreakers.goldenGoals.map(function (d2) {
                return d2.playerId;
              });
              _context211.next = 24;
              return _this84.playerFacade.getPlayersMapWithNativeIds(l2);

            case 24:
              c2 = _context211.sent;
              t2.tieBreakers.goldenGoals = t2.tieBreakers.goldenGoals.map(function (d2) {
                return d2.matchModel = n2[d2.matchId], d2.playerModel = c2[d2.playerId], _this84.idMapping.idSchema !== "native" && (d2.matchId = n2[d2.matchId].id, d2.playerId = c2[d2.playerId].id), d2;
              });

            case 26:
              return _context211.abrupt("return", t2);

            case 27:
            case "end":
              return _context211.stop();
          }
        }
      }, _callee210);
    }));

    return function (_x304, _x305) {
      return _ref246.apply(this, arguments);
    };
  }());

  __publicField(this, "completeContestWinners",
  /*#__PURE__*/
  function () {
    var _ref247 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee211(t2) {
      var _e14, _i49;

      return _regeneratorRuntime.wrap(function _callee211$(_context212) {
        while (1) {
          switch (_context212.prev = _context212.next) {
            case 0:
              if (!(t2.userList && t2.userList.length)) {
                _context212.next = 6;
                break;
              }

              _e14 = t2.userList.map(function (a) {
                return a.profileId;
              });
              _context212.next = 4;
              return _this84.profileNamespace.getByIds(_e14);

            case 4:
              _i49 = _context212.sent;
              t2.userList.forEach(function (a) {
                var r2 = _i49.filter(function (s) {
                  return s.id === a.profileId;
                })[0];

                delete r2.interests, a.profileModel = r2;
              });

            case 6:
              return _context212.abrupt("return", t2);

            case 7:
            case "end":
              return _context212.stop();
          }
        }
      }, _callee211);
    }));

    return function (_x306) {
      return _ref247.apply(this, arguments);
    };
  }());

  __publicField(this, "handleMatchModel", function (t2, e2) {
    t2[e2.matchId] ? (e2.matchModel = t2[e2.matchId], delete e2.matchModel.availableMarkets, e2.matchId = e2.matchModel.id) : (e2.matchModel = null, _this84.idMapping.idSchema !== "native" && _this84.idMapping.idMappingFacade.getEntityById(e2.matchId, "match", "native").then(function (i) {
      e2.matchId = i[C[_this84.idMapping.idSchema]];
    }));
  });

  __publicField(this, "remapMatchIdForResultsMarkets", function (t2, e2) {
    t2[e2.matchId] ? e2.matchId = t2[e2.matchId].id : _this84.idMapping.idMappingFacade.getEntityById(e2.matchId, "match", "native").then(function (i) {
      e2.matchId = i[C[_this84.idMapping.idSchema]];
    });
  });

  __publicField(this, "deleteUnexpectedProperties", function (t2) {
    return t2.status && (console.warn(No.UNEXPECTED_STATUS_PROP), delete t2.status), t2.type && (console.warn(No.UNEXPECTED_TYPE_PROP), delete t2.type), t2;
  });

  this.footballHttps = new Z(t2), this.idMapping = e2, this.matchFacade = new mt(t2, this.footballHttps, e2), this.playerFacade = new dt(t2, this.footballHttps, e2), this.profileNamespace = new L(t2);
};

var le = function le(t2) {
  var _this85 = this;

  _classCallCheck3(this, le);

  __publicField(this, "gameInstanceId", null);

  __publicField(this, "fixtures", []);

  __publicField(this, "tiebreaker", null);

  this.gameInstanceId = t2.gameInstanceId, t2.fixtures.forEach(function (e2) {
    return _this85.fixtures.push(new ht(e2.matchId, e2.market, e2.prediction.value));
  }), this.tiebreaker = t2.tiebreaker ? t2.tiebreaker : null;
};

var pe = function pe(t2, e2) {
  var _this86 = this;

  _classCallCheck3(this, pe);

  __publicField(this, "fixturesRemapper", null);

  __publicField(this, "footballHttps", null);

  __publicField(this, "matchFacade", null);

  __publicField(this, "playerFacade", null);

  __publicField(this, "predictorService", null);

  __publicField(this, "remapRequestBody", function (t2) {
    var e2 = {};
    return e2.game_instance_id = t2.gameInstanceId, e2.fixtures = t2.fixtures.map(function (i) {
      return _this86.fixturesRemapper.remapFixturesRequest(i);
    }), t2 instanceof le && t2.tiebreaker && (e2.tiebreaker = {}, e2.tiebreaker.golden_goal = t2.tiebreaker.goldenGoal ? t2.tiebreaker.goldenGoal : null), e2;
  });

  __publicField(this, "remapResponseArrayBody",
  /*#__PURE__*/
  function () {
    var _ref248 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee212(t2) {
      var _e15, _i50, a, r2, _s14, _p9;

      return _regeneratorRuntime.wrap(function _callee212$(_context213) {
        while (1) {
          switch (_context213.prev = _context213.next) {
            case 0:
              if (!t2.length) {
                _context213.next = 13;
                break;
              }

              _e15 = "OWN_GOAL", _i50 = [], a = [], r2 = {}, _s14 = [];
              t2.forEach(function (n2) {
                n2.fixtures.forEach(function (l2) {
                  _i50.push(l2.match_id), l2.player_id && l2.player_id !== _e15 && a.push(l2.player_id);
                });
              });
              _context213.next = 5;
              return _this86.matchFacade.getMatchesMapWithNativeIds(_i50);

            case 5:
              _p9 = _context213.sent;
              _context213.t0 = a.length > 0;

              if (!_context213.t0) {
                _context213.next = 11;
                break;
              }

              _context213.next = 10;
              return _this86.playerFacade.getPlayersMapWithNativeIds(a);

            case 10:
              r2 = _context213.sent;

            case 11:
              t2.forEach(function (n2) {
                var l2 = new $e(),
                    c2 = [];
                l2.id = n2.id, l2.gameInstanceId = n2.game_instance_id, l2.gameType = n2.game_type, l2.wager = n2.wager, l2.totalFixtures = n2.total_fixtures, l2.settledFixtures = n2.settled_fixtures, l2.userId = n2.user_id, n2.fixtures.forEach(function (d2) {
                  var m2 = new ae();
                  d2.target ? m2.market = _this86.predictorService.convertMarketForResponseModel(d2.market, d2.target) : m2.market = d2.market, m2.matchId = _p9[d2.match_id].id, m2.matchType = d2.match_type, m2.matchModel = _p9[d2.match_id], delete m2.matchModel.availableMarkets, d2.goals_home !== void 0 && d2.goals_away !== void 0 ? m2.prediction.value = d2.goals_home.toString() + ":" + d2.goals_away.toString() : m2.prediction.value = d2.prediction, m2.prediction.playerId = d2.player_id ? d2.player_id : null, m2.prediction.playerId && m2.prediction.playerId !== _e15 && (m2.prediction.playerModel = r2[m2.prediction.playerId], m2.prediction.playerId = r2[m2.prediction.playerId].id), m2.result = _this86.fixturesRemapper.remapResult(d2.result), c2.push(m2);
                }), l2.fixtures = c2, l2.status = n2.status, n2.tiebreaker ? l2.tiebreaker.goldenGoal = n2.tiebreaker.golden_goal : l2.tiebreaker = null, l2.points = n2.points, l2.createdAt = n2.created_at, l2.updatedAt = n2.updated_at, _s14.push(l2);
              });
              return _context213.abrupt("return", _s14);

            case 13:
              return _context213.abrupt("return", t2);

            case 14:
            case "end":
              return _context213.stop();
          }
        }
      }, _callee212);
    }));

    return function (_x307) {
      return _ref248.apply(this, arguments);
    };
  }());

  __publicField(this, "remapResponseObjBody",
  /*#__PURE__*/
  function () {
    var _ref249 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee213(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee213$(_context214) {
        while (1) {
          switch (_context214.prev = _context214.next) {
            case 0:
              e2 = new $e();
              e2.id = t2.id;
              e2.gameInstanceId = t2.game_instance_id;
              e2.gameType = t2.game_type;
              e2.wager = t2.wager;
              e2.totalFixtures = t2.total_fixtures;
              e2.settledFixtures = t2.settled_fixtures;
              e2.userId = t2.user_id;
              _context214.next = 10;
              return _this86.fixturesRemapper.remapFixturesResponse(t2.fixtures);

            case 10:
              e2.fixtures = _context214.sent;
              e2.status = t2.status;
              t2.tiebreaker ? e2.tiebreaker.goldenGoal = t2.tiebreaker.golden_goal : e2.tiebreaker = null;
              e2.points = t2.points;
              e2.createdAt = t2.created_at;
              e2.updatedAt = t2.updated_at;
              return _context214.abrupt("return", e2);

            case 17:
            case "end":
              return _context214.stop();
          }
        }
      }, _callee213);
    }));

    return function (_x308) {
      return _ref249.apply(this, arguments);
    };
  }());

  __publicField(this, "remapPredictionModel", function (t2) {
    var e2 = new Ca();
    return e2.fullTimeOneXTwo = t2.FT_1X2, e2.halfTimeOneXTwo = t2.HT_1X2, e2.bothTeamsScore = t2.BOTH_TEAMS_SCORE, e2.overZeroPointFiveGoals = t2.OVER_GOALS_0_5, e2.overOnePointFiveGoals = t2.OVER_GOALS_1_5, e2.overTwoPointFiveGoals = t2.OVER_GOALS_2_5, e2.overThreePointFiveGoals = t2.OVER_GOALS_3_5, e2.overFourPointFiveGoals = t2.OVER_GOALS_4_5, e2.overFivePointFiveGoals = t2.OVER_GOALS_5_5, e2.overSixPointFiveGoals = t2.OVER_GOALS_6_5, e2.overSixPointFiveCorners = t2.OVER_CORNERS_6_5, e2.overSevenPointFiveCorners = t2.OVER_CORNERS_7_5, e2.overEightPointFiveCorners = t2.OVER_CORNERS_8_5, e2.overNinePointFiveCorners = t2.OVER_CORNERS_9_5, e2.overTenPointFiveCorners = t2.OVER_CORNERS_10_5, e2.overElevenPointFiveCorners = t2.OVER_CORNERS_11_5, e2.overTwelvePointFiveCorners = t2.OVER_CORNERS_12_5, e2.overThirteenPointFiveCorners = t2.OVER_CORNERS_13_5, e2.doubleChance = t2.DOUBLE_CHANCE, e2.halfTimeFullTime = t2.HT_FT, e2.playerScore = t2.PLAYER_SCORE, e2.playerYellowCard = t2.PLAYER_YELLOW_CARD, e2.playerRedCard = t2.PLAYER_RED_CARD, e2.redCardMatch = t2.RED_CARD_MATCH, e2.penaltyMatch = t2.PENALTY_MATCH, e2.playerScoreFirstGoal = t2.PLAYER_SCORE_FIRST_GOAL, e2.cornersMatch = t2.CORNERS_MATCH, e2.correctScore = t2.CORRECT_SCORE, e2.correctScoreHalfTime = t2.CORRECT_SCORE_HT, e2.correctScoreAdvanced = t2.CORRECT_SCORE_ADVANCED, e2.playerScoreHattrick = t2.PLAYER_SCORE_HATTRICK, e2.playerScoreTwice = t2.PLAYER_SCORE_TWICE, e2;
  });

  this.footballHttps = new Z(t2), this.matchFacade = new mt(t2, this.footballHttps, e2), this.playerFacade = new dt(t2, this.footballHttps, e2), this.predictorService = new at(t2, e2), this.fixturesRemapper = new Sa(this.matchFacade, this.playerFacade, this.predictorService);
};

var La = function La() {
  _classCallCheck3(this, La);

  __publicField(this, "matchId", null);

  __publicField(this, "matchType", null);

  __publicField(this, "predictions", null);
};

var Oa = function Oa(t2, e2) {
  var _this87 = this;

  _classCallCheck3(this, Oa);

  __publicField(this, "remapPredictions", null);

  __publicField(this, "remapResponse", function (t2) {
    var e2 = new La();
    return e2.matchId = t2.match_id, e2.matchType = t2.match_type, e2.predictions = _this87.remapPredictions.remapPredictionModel(t2.predictions), e2;
  });

  this.remapPredictions = new pe(t2, e2);
};

var Da = function Da() {
  _classCallCheck3(this, Da);

  __publicField(this, "matchId", null);

  __publicField(this, "matchType", null);

  __publicField(this, "market", null);

  __publicField(this, "matchModel", null);

  __publicField(this, "matchStatus", new $());
};

var xa = function xa() {
  _classCallCheck3(this, xa);

  __publicField(this, "value", null);

  __publicField(this, "target", null);

  __publicField(this, "playerId", null);

  __publicField(this, "playerModel", null);

  __publicField(this, "result", null);
};

var Ba = function Ba() {
  _classCallCheck3(this, Ba);

  __publicField(this, "matchId", null);

  __publicField(this, "matchType", null);

  __publicField(this, "market", null);

  __publicField(this, "matchModel", null);

  __publicField(this, "matchStatus", new $());

  __publicField(this, "prediction", new xa());
};

var Na = function Na() {
  _classCallCheck3(this, Na);

  __publicField(this, "value", null);

  __publicField(this, "result", null);
};

var Ua = function Ua() {
  _classCallCheck3(this, Ua);

  __publicField(this, "matchId", null);

  __publicField(this, "matchType", null);

  __publicField(this, "market", null);

  __publicField(this, "matchModel", null);

  __publicField(this, "matchStatus", new $());

  __publicField(this, "prediction", new Na());
};

var Ha = function Ha() {
  _classCallCheck3(this, Ha);

  __publicField(this, "matchId", null);

  __publicField(this, "matchModel", null);

  __publicField(this, "outcome", null);
};

var ka = function ka() {
  _classCallCheck3(this, ka);

  __publicField(this, "gameId", null);

  __publicField(this, "results", null);

  __publicField(this, "tieBreakers", null);
};

var ce = function ce() {
  _classCallCheck3(this, ce);

  __publicField(this, "entityId", null);

  __publicField(this, "entityType", null);
};

var Ga = function Ga() {
  _classCallCheck3(this, Ga);

  __publicField(this, "contestId", "");

  __publicField(this, "contestType", "GAME");

  __publicField(this, "contestModel", null);

  __publicField(this, "description", "");

  __publicField(this, "userList", []);
};

var Va = function Va() {
  _classCallCheck3(this, Va);

  __publicField(this, "position", "");

  __publicField(this, "profileId", "");

  __publicField(this, "profileModel", null);

  __publicField(this, "note", "");

  __publicField(this, "tags", []);
};

var $a = function $a() {
  var _this88 = this;

  _classCallCheck3(this, $a);

  __publicField(this, "remapPaginatedGames", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this88.remapGamesListResponse(i);
    }), e2;
  });

  __publicField(this, "remapGamesListResponse", function (t2) {
    var e2 = new st();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.status = t2.status, e2.scheduleOpenAt = t2.schedule_open_at, e2.predictionsCutoff = t2.predictions_cutoff, e2.fixtures = t2.fixtures.map(function (i) {
      return _this88.remapFixturesResponse(i);
    }), e2.tiebreaker = t2.tiebreaker ? _this88.remapTimeTiebreaker(t2.tiebreaker.time_tiebreaker) : null, e2.participantsCount = t2.participants_count, e2.related = t2.related ? _this88.remapRelated(t2.related) : null, e2.excludedProfileIds = t2.excluded_profile_ids, e2.rules = t2.rules, e2.labels = t2.labels, e2.customFields = t2.custom_fields, e2.flags = t2.flags, e2.images = t2.images, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapGameByIdResponse", function (t2) {
    var e2 = new ne();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.status = t2.status, e2.scheduleOpenAt = t2.schedule_open_at, e2.predictionsCutoff = t2.predictions_cutoff, e2.fixtures = t2.fixtures.map(function (i) {
      return _this88.remapFixturesResponse(i);
    }), e2.tiebreaker = t2.tiebreaker ? _this88.remapTimeTiebreaker(t2.tiebreaker.time_tiebreaker) : null, e2.participantsCount = t2.participants_count, e2.related = t2.related ? _this88.remapRelated(t2.related) : null, e2.excludedProfileIds = t2.excluded_profile_ids, e2.rules = t2.rules, e2.flags = t2.flags, e2.adContent = t2.ad_content, e2.labels = t2.labels, e2.customFields = t2.custom_fields, e2.images = t2.images, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapFixturesResponse", function (t2) {
    var e2 = new Da();
    return e2.matchId = t2.match_id, e2.matchType = t2.match_type, e2.market = t2.market, e2.matchStatus.type = t2.match_status ? t2.match_status.type : null, e2.matchStatus.subType = t2.match_status ? t2.match_status.sub_type : null, e2;
  });

  __publicField(this, "remapPaginatedUserTopXEditions", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this88.remapUserTopXEditionsResponse(i);
    }), e2;
  });

  __publicField(this, "remapUserTopXEditionsResponse", function (t2) {
    var e2 = new gt();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.status = t2.status, e2.predictionsCutoff = t2.predictions_cutoff, e2.scheduleOpenAt = t2.schedule_open_at, e2.fixtures = t2.fixtures.map(function (i) {
      return _this88.remapTopXFixturesResponse(i);
    }), e2.tiebreaker = t2.tiebreaker ? _this88.remapTimeTiebreaker(t2.tiebreaker.time_tiebreaker) : null, e2.participantsCount = t2.participants_count, e2.related = t2.related ? _this88.remapRelated(t2.related) : null, e2.excludedProfileIds = t2.excluded_profile_ids, e2.rules = t2.rules, e2.flags = t2.flags, e2.images = t2.images, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapTopXFixturesResponse", function (t2) {
    var e2 = new Ua();
    return e2.matchId = t2.match_id, e2.matchType = t2.match_type, e2.market = t2.market, e2.matchStatus.type = t2.match_status ? t2.match_status.type : null, e2.matchStatus.subType = t2.match_status ? t2.match_status.sub_type : null, e2;
  });

  __publicField(this, "remapPaginatedUserMathQuizEditions", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this88.remapUserMatchQuizEditionsResponse(i);
    }), e2;
  });

  __publicField(this, "remapUserMatchQuizEditionsResponse", function (t2) {
    var e2 = new nt();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.status = t2.status, e2.predictionsCutoff = t2.predictions_cutoff, e2.scheduleOpenAt = t2.schedule_open_at, e2.fixtures = t2.fixtures.map(function (i) {
      return _this88.remapMatchQuizFixturesResponse(i);
    }), e2.tiebreaker = t2.tiebreaker ? _this88.remapTimeTiebreaker(t2.tiebreaker.time_tiebreaker) : null, e2.participantsCount = t2.participants_count, e2.related = t2.related ? _this88.remapRelated(t2.related) : null, e2.excludedProfileIds = t2.excluded_profile_ids, e2.rules = t2.rules, e2.flags = t2.flags, e2.images = t2.images, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapMatchQuizFixturesResponse", function (t2) {
    var e2 = new Ba();
    return e2.matchId = t2.match_id, e2.matchType = t2.match_type, e2.market = t2.market, e2.matchStatus.type = t2.match_status ? t2.match_status.type : null, e2.matchStatus.subType = t2.match_status ? t2.match_status.sub_type : null, e2;
  });

  __publicField(this, "remapPaginatedGameResults", function (t2) {
    var e2 = new E();
    return e2.meta.pagination.nextPageStartsAfter = t2.meta.pagination.next_page_starts_after, e2.meta.pagination.itemsPerPage = t2.meta.pagination.items_per_page, e2.data = t2.data.map(function (i) {
      return _this88.remapGameResults(i);
    }), e2;
  });

  __publicField(this, "remapGameResults", function (t2) {
    var e2 = new Et();
    return e2.userId = t2.user_id, e2.points = t2.points ? t2.points : 0, e2.results = t2.results.map(function (i) {
      return _this88.remapResults(i);
    }), e2.tiebreaker = t2.tiebreaker ? _this88.remapTiebreaker(t2.tiebreaker) : null, e2;
  });

  __publicField(this, "remapGameMarketsResults", function (t2) {
    var e2 = new ka();
    return e2.gameId = t2.game_id, e2.results = _this88.remapMarketsResults(t2.results), e2.tieBreakers = t2.tie_breakers ? _this88.remapTieBreakers(t2.tie_breakers) : null, e2;
  });

  __publicField(this, "remapContestWinners", function (t2) {
    var e2 = new Ga();
    return e2.contestId = t2.contest_id, e2.contestType = t2.contest_type, e2.description = t2.description, e2.userList = t2.user_list ? t2.user_list.map(function (i) {
      return _this88.remapUserListWinners(i);
    }) : null, e2;
  });

  __publicField(this, "remapUserListWinners", function (t2) {
    var e2 = new Va();
    return e2.position = t2.position, e2.profileId = t2.profile_id, e2.note = t2.note, e2.tags = t2.tags, e2;
  });

  __publicField(this, "remapTieBreakers", function (t2) {
    var e2 = {
      goldenGoals: []
    };
    return e2.goldenGoals = t2.golden_goals.map(function (i) {
      return {
        minute: i.minute,
        matchId: i.match_id,
        matchModel: null,
        playerId: i.player_id,
        playerModel: null,
        goalType: i.goal_type
      };
    }), e2;
  });

  __publicField(this, "remapMarketsResults", function (t2) {
    var e2 = [];
    return t2.forEach(function (i) {
      var a = {
        matchId: i.match_id,
        market: i.market,
        result: _this88.remapMarketResult(i.market, i.result),
        matchModel: null,
        playerModels: [],
        matchStatus: _this88.remapMarketsResultsMatchStatus(i.match_status)
      };
      e2.push(_this88.deleteUnusefulField(a));
    }), e2;
  });

  __publicField(this, "remapMarketsResultsMatchStatus", function (t2) {
    var e2 = new $();
    return t2 && (e2.type = t2.type, e2.subType = t2.sub_type), e2;
  });

  __publicField(this, "remapMarketResult", function (t2, e2) {
    if (_s.includes(t2)) return e2[0];
    if (tt.includes(t2)) return e2;
    if (e2[0] === "true") return true;
    if (e2[0] === "false") return false;
  });

  __publicField(this, "deleteUnusefulField", function (t2) {
    return (!tt.includes(t2.market) || _this88.isPlayerMarketWithNoResult(t2.market, t2.result)) && delete t2.playerModels, t2;
  });

  __publicField(this, "isPlayerMarketWithNoResult", function (t2, e2) {
    return tt.includes(t2) && e2.length === 0;
  });

  __publicField(this, "remapResults", function (t2) {
    var e2 = new Ha();
    return e2.matchId = t2.match_id, e2.outcome = t2.outcome, e2;
  });

  __publicField(this, "remapTiebreaker", function (t2) {
    var e2 = new et();
    return e2.goldenGoal = t2.golden_goal, e2;
  });

  __publicField(this, "remapTimeTiebreaker", function (t2) {
    var e2 = new it();
    return e2.timeTiebreaker = t2, e2;
  });

  __publicField(this, "remapRelated", function (t2) {
    return t2.map(function (e2) {
      var i = new ce();
      return i.entityId = e2.entity_id, i.entityType = e2.entity_type, i;
    });
  });
};

var Wa = function Wa() {
  _classCallCheck3(this, Wa);

  __publicField(this, "remapMetaData", function (t2) {
    var e2 = new G();
    return e2.pagination.nextPageStartsAfter = t2.pagination.next_page_starts_after, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2;
  });
};

var rt =
/*#__PURE__*/
function (_ref250) {
  _inherits3(rt, _ref250);

  function rt(t2, e2) {
    var _this89;

    _classCallCheck3(this, rt);

    _this89 = _possibleConstructorReturn3(this, _getPrototypeOf4(rt).call(this, t2, R(t2.environment, "predictor")));

    __publicField(_assertThisInitialized3(_this89), "predictionRemapper", null);

    __publicField(_assertThisInitialized3(_this89), "matchSummaryRemapper", null);

    __publicField(_assertThisInitialized3(_this89), "gamesRemapper", null);

    __publicField(_assertThisInitialized3(_this89), "metaRemapper", null);

    __publicField(_assertThisInitialized3(_this89), "makeFootballPrediction",
    /*#__PURE__*/
    function () {
      var _ref251 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee214(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee214$(_context215) {
          while (1) {
            switch (_context215.prev = _context215.next) {
              case 0:
                e2 = "/predictions".concat(_this89.apiSignInUrl);
                i = "There was a problem making POST request";
                a = "POST";
                _context215.next = 5;
                return _this89.fetchWithAuth(e2, i, a, _this89.predictionRemapper.remapRequestBody(t2));

              case 5:
                r2 = _context215.sent;
                _context215.next = 8;
                return _this89.predictionRemapper.remapResponseObjBody(r2);

              case 8:
                return _context215.abrupt("return", _context215.sent);

              case 9:
              case "end":
                return _context215.stop();
            }
          }
        }, _callee214);
      }));

      return function (_x309) {
        return _ref251.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getMatchSummary",
    /*#__PURE__*/
    function () {
      var _ref252 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee215(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee215$(_context216) {
          while (1) {
            switch (_context216.prev = _context216.next) {
              case 0:
                i = P(e2) ? "/predictions/summary/".concat(t2).concat(_this89.apiSignInUrl).concat(w$2()) : "/predictions/summary/".concat(t2).concat(_this89.apiSignInUrl);
                a = "There was a problem fetching predictions for match: ".concat(t2);
                _context216.next = 4;
                return _this89.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context216.sent;
                return _context216.abrupt("return", _this89.matchSummaryRemapper.remapResponse(r2));

              case 6:
              case "end":
                return _context216.stop();
            }
          }
        }, _callee215);
      }));

      return function (_x310, _x311) {
        return _ref252.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "deleteFootballPrediction",
    /*#__PURE__*/
    function () {
      var _ref253 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee216(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee216$(_context217) {
          while (1) {
            switch (_context217.prev = _context217.next) {
              case 0:
                e2 = "/predictions/".concat(t2).concat(_this89.apiSignInUrl), i = "There was a problem deleting your prediction: ".concat(t2), a = "DELETE";
                _context217.next = 3;
                return _this89.fetchWithAuth(e2, i, a);

              case 3:
                return _context217.abrupt("return", true);

              case 4:
              case "end":
                return _context217.stop();
            }
          }
        }, _callee216);
      }));

      return function (_x312) {
        return _ref253.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getMyPredictions",
    /*#__PURE__*/
    function () {
      var _ref254 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee217(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee217$(_context218) {
          while (1) {
            switch (_context218.prev = _context218.next) {
              case 0:
                e2 = new E(), i = "/predictions".concat(_this89.apiSignInUrl), a = "There was a problem fetching own predictions";
                t2 && (i += "".concat(t2.constructFiltersUrl()));
                _context218.next = 4;
                return _this89.fetchWithAuth(i, a);

              case 4:
                r2 = _context218.sent;
                e2.meta = _this89.metaRemapper.remapMetaData(r2.meta);
                _context218.next = 8;
                return _this89.predictionRemapper.remapResponseArrayBody(r2.data);

              case 8:
                e2.data = _context218.sent;
                return _context218.abrupt("return", e2);

              case 10:
              case "end":
                return _context218.stop();
            }
          }
        }, _callee217);
      }));

      return function (_x313) {
        return _ref254.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getMyPredictionsNoRemap",
    /*#__PURE__*/
    function () {
      var _ref255 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee218(t2) {
        var e2, i;
        return _regeneratorRuntime.wrap(function _callee218$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                e2 = "/predictions".concat(_this89.apiSignInUrl).concat(t2.constructFiltersUrl()), i = "There was a problem fetching own predictions";
                _context219.next = 3;
                return _this89.fetchWithAuth(e2, i);

              case 3:
                return _context219.abrupt("return", _context219.sent);

              case 4:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee218);
      }));

      return function (_x314) {
        return _ref255.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getUserPredictions",
    /*#__PURE__*/
    function () {
      var _ref256 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee219(t2, e2, i) {
        var a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee219$(_context220) {
          while (1) {
            switch (_context220.prev = _context220.next) {
              case 0:
                a = new E(), r2 = P(e2) ? "/predictions/users/".concat(t2).concat(_this89.apiSignInUrl).concat(w$2()) : "/predictions/users/".concat(t2).concat(_this89.apiSignInUrl), s = "There was a problem fetching predictions for user: ".concat(t2);
                i && (r2 += "".concat(i.constructFiltersUrl()));
                _context220.next = 4;
                return _this89.fetchWithoutAuth(r2, s);

              case 4:
                p2 = _context220.sent;
                a.meta = _this89.metaRemapper.remapMetaData(p2.meta);
                _context220.next = 8;
                return _this89.predictionRemapper.remapResponseArrayBody(p2.data);

              case 8:
                a.data = _context220.sent;
                return _context220.abrupt("return", a);

              case 10:
              case "end":
                return _context220.stop();
            }
          }
        }, _callee219);
      }));

      return function (_x315, _x316, _x317) {
        return _ref256.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getUserPredictionsNoRemap",
    /*#__PURE__*/
    function () {
      var _ref257 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee220(t2, e2) {
        var i, a;
        return _regeneratorRuntime.wrap(function _callee220$(_context221) {
          while (1) {
            switch (_context221.prev = _context221.next) {
              case 0:
                i = "/predictions/users/".concat(t2).concat(_this89.apiSignInUrl).concat(e2.constructFiltersUrl()), a = "There was a problem fetching predictions for user: ".concat(t2);
                _context221.next = 3;
                return _this89.fetchWithoutAuth(i, a);

              case 3:
                return _context221.abrupt("return", _context221.sent);

              case 4:
              case "end":
                return _context221.stop();
            }
          }
        }, _callee220);
      }));

      return function (_x318, _x319) {
        return _ref257.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getGames",
    /*#__PURE__*/
    function () {
      var _ref258 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee221(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee221$(_context222) {
          while (1) {
            switch (_context222.prev = _context222.next) {
              case 0:
                i = P(e2) ? "/games/".concat(_this89.apiSignInUrl).concat(t2.constructFiltersUrl()).concat(w$2()) : "/games/".concat(_this89.apiSignInUrl).concat(t2.constructFiltersUrl());
                a = "There was a problem fetching the games list";
                _context222.next = 4;
                return _this89.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context222.sent;
                return _context222.abrupt("return", _this89.gamesRemapper.remapPaginatedGames(r2));

              case 6:
              case "end":
                return _context222.stop();
            }
          }
        }, _callee221);
      }));

      return function (_x320, _x321) {
        return _ref258.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getGameById",
    /*#__PURE__*/
    function () {
      var _ref259 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee222(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee222$(_context223) {
          while (1) {
            switch (_context223.prev = _context223.next) {
              case 0:
                i = P(e2) ? "/games/".concat(t2).concat(_this89.apiSignInUrl).concat(w$2()) : "/games/".concat(t2).concat(_this89.apiSignInUrl);
                a = "There was a problem fetching the following game: ".concat(t2);
                _context223.next = 4;
                return _this89.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context223.sent;
                return _context223.abrupt("return", _this89.gamesRemapper.remapGameByIdResponse(r2));

              case 6:
              case "end":
                return _context223.stop();
            }
          }
        }, _callee222);
      }));

      return function (_x322, _x323) {
        return _ref259.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getGamePredictions",
    /*#__PURE__*/
    function () {
      var _ref260 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee223(t2, e2, i) {
        var a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee223$(_context224) {
          while (1) {
            switch (_context224.prev = _context224.next) {
              case 0:
                a = new E(), r2 = P(e2) ? "/games/".concat(t2, "/predictions").concat(_this89.apiSignInUrl).concat(w$2()) : "/games/".concat(t2, "/predictions").concat(_this89.apiSignInUrl), s = "There was a problem fetching the predictions for game: ".concat(t2);
                i && (r2 += "".concat(i.constructFiltersUrl()));
                _context224.next = 4;
                return _this89.fetchWithoutAuth(r2, s);

              case 4:
                p2 = _context224.sent;
                a.meta = _this89.metaRemapper.remapMetaData(p2.meta);
                _context224.next = 8;
                return _this89.predictionRemapper.remapResponseArrayBody(p2.data);

              case 8:
                a.data = _context224.sent;
                return _context224.abrupt("return", a);

              case 10:
              case "end":
                return _context224.stop();
            }
          }
        }, _callee223);
      }));

      return function (_x324, _x325, _x326) {
        return _ref260.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getUserGameEditions",
    /*#__PURE__*/
    function () {
      var _ref261 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee224(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee224$(_context225) {
          while (1) {
            switch (_context225.prev = _context225.next) {
              case 0:
                i = null;
                a = P(e2) ? "/games/".concat(_this89.apiSignInUrl).concat(t2.constructFiltersUrl()).concat(w$2()) : "/games/".concat(_this89.apiSignInUrl).concat(t2.constructFiltersUrl());
                r2 = "There was a problem fetching the games list";
                _context225.next = 5;
                return _this89.fetchWithoutAuth(a, r2);

              case 5:
                s = _context225.sent;
                return _context225.abrupt("return", (s.data.forEach(function (p2) {
                  p2.type === "TOP_X" ? i = _this89.gamesRemapper.remapPaginatedUserTopXEditions(s) : p2.type === "MATCH_QUIZ" && (i = _this89.gamesRemapper.remapPaginatedUserMathQuizEditions(s));
                }), i));

              case 7:
              case "end":
                return _context225.stop();
            }
          }
        }, _callee224);
      }));

      return function (_x327, _x328) {
        return _ref261.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getGameResults",
    /*#__PURE__*/
    function () {
      var _ref262 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee225(t2, e2, i) {
        var a, r2, s;
        return _regeneratorRuntime.wrap(function _callee225$(_context226) {
          while (1) {
            switch (_context226.prev = _context226.next) {
              case 0:
                a = P(e2) ? "/games/".concat(t2, "/results/").concat(_this89.apiSignInUrl).concat(w$2()) : "/games/".concat(t2, "/results/").concat(_this89.apiSignInUrl), r2 = "There was a problem fetching the results for the following game: ".concat(t2);
                i && (a += "".concat(i.constructMainFiltersUrl()));
                _context226.next = 4;
                return _this89.fetchWithoutAuth(a, r2);

              case 4:
                s = _context226.sent;
                return _context226.abrupt("return", _this89.gamesRemapper.remapPaginatedGameResults(s));

              case 6:
              case "end":
                return _context226.stop();
            }
          }
        }, _callee225);
      }));

      return function (_x329, _x330, _x331) {
        return _ref262.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getMarketResultsForGame",
    /*#__PURE__*/
    function () {
      var _ref263 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee226(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee226$(_context227) {
          while (1) {
            switch (_context227.prev = _context227.next) {
              case 0:
                i = "/games/".concat(t2, "/correct-results/").concat(_this89.apiSignInUrl), a = "There was a problem fetching the markets correct results for the following game: ".concat(t2);
                P(e2) && (i += "".concat(w$2()));
                _context227.next = 4;
                return _this89.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context227.sent;
                return _context227.abrupt("return", _this89.gamesRemapper.remapGameMarketsResults(r2.data));

              case 6:
              case "end":
                return _context227.stop();
            }
          }
        }, _callee226);
      }));

      return function (_x332, _x333) {
        return _ref263.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getContestWinners",
    /*#__PURE__*/
    function () {
      var _ref264 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee227(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee227$(_context228) {
          while (1) {
            switch (_context228.prev = _context228.next) {
              case 0:
                i = "/winners/".concat(_this89.apiSignInUrl, "&contest_id=").concat(t2), a = "There was a problem fetching winners for the following game: ".concat(t2);
                e2 && (i += w$2());
                _context228.next = 4;
                return _this89.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context228.sent;
                return _context228.abrupt("return", _this89.gamesRemapper.remapContestWinners(r2));

              case 6:
              case "end":
                return _context228.stop();
            }
          }
        }, _callee227);
      }));

      return function (_x334, _x335) {
        return _ref264.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getPredictionById",
    /*#__PURE__*/
    function () {
      var _ref265 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee228(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee228$(_context229) {
          while (1) {
            switch (_context229.prev = _context229.next) {
              case 0:
                e2 = "/predictions/".concat(t2).concat(_this89.apiSignInUrl);
                i = "There was a problem fetching info for the following prediction: ".concat(t2);
                _context229.next = 4;
                return _this89.fetchWithoutAuth(e2, i);

              case 4:
                a = _context229.sent;
                _context229.next = 7;
                return _this89.predictionRemapper.remapResponseArrayBody([a.data]);

              case 7:
                return _context229.abrupt("return", _context229.sent[0]);

              case 8:
              case "end":
                return _context229.stop();
            }
          }
        }, _callee228);
      }));

      return function (_x336) {
        return _ref265.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this89), "getPredictionsByIds",
    /*#__PURE__*/
    function () {
      var _ref266 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee229(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee229$(_context230) {
          while (1) {
            switch (_context230.prev = _context230.next) {
              case 0:
                e2 = "/predictions/by-ids".concat(_this89.apiSignInUrl, "&prediction_ids=").concat(t2.join(","));
                i = "There was a problem fetching predictions";
                _context230.next = 4;
                return _this89.fetchWithoutAuth(e2, i);

              case 4:
                a = _context230.sent;
                _context230.next = 7;
                return _this89.predictionRemapper.remapResponseArrayBody(a.data);

              case 7:
                return _context230.abrupt("return", _context230.sent);

              case 8:
              case "end":
                return _context230.stop();
            }
          }
        }, _callee229);
      }));

      return function (_x337) {
        return _ref266.apply(this, arguments);
      };
    }());

    _this89.predictionRemapper = new pe(t2, e2), _this89.matchSummaryRemapper = new Oa(t2, e2), _this89.gamesRemapper = new $a(), _this89.metaRemapper = new Wa();
    return _this89;
  }

  return rt;
}(_);

var de = function de() {
  _classCallCheck3(this, de);

  __publicField(this, "gameInstanceId", null);

  __publicField(this, "fixtures", null);
};

var Go = function (i) {
  return i.ONE = "1", i.X = "x", i.TWO = "2", i;
}(Go || {}),
    Vo = function (i) {
  return i.ONE_X = "1x", i.X_TWO = "x2", i.ONE_TWO = "12", i;
}(Vo || {}),
    $o = function (l2) {
  return l2.ONE_ONE = "1/1", l2.ONE_X = "1/x", l2.ONE_TWO = "1/2", l2.X_ONE = "x/1", l2.X_X = "x/x", l2.X_TWO = "x/2", l2.TWO_ONE = "2/1", l2.TWO_X = "2/x", l2.TWO_TWO = "2/2", l2;
}($o || {});

var Ka = function Ka(t2, e2) {
  _classCallCheck3(this, Ka);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "BOTH_TEAMS_SCORE");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new q$2(), this.prediction.value = e2;
};

var ja = function ja() {
  _classCallCheck3(this, ja);

  __publicField(this, "value");
};

var qa = function qa(t2, e2) {
  _classCallCheck3(this, qa);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "CORNERS_MATCH");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new ja(), this.prediction.value = e2;
};

var za = function za() {
  _classCallCheck3(this, za);

  __publicField(this, "value", null);
};

var Qa = function Qa(t2, e2) {
  _classCallCheck3(this, Qa);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "DOUBLE_CHANCE");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new za(), this.prediction.value = e2;
};

var Xa = function Xa() {
  _classCallCheck3(this, Xa);

  __publicField(this, "value", null);
};

var Ya = function Ya(t2, e2, i) {
  _classCallCheck3(this, Ya);

  __publicField(this, "matchId", null);

  __publicField(this, "market", null);

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.market = e2, this.prediction = new Xa(), this.prediction.value = i;
};

var Ja = function Ja() {
  _classCallCheck3(this, Ja);

  __publicField(this, "value", null);
};

var Za = function Za(t2, e2) {
  _classCallCheck3(this, Za);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "HT_FT");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new Ja(), this.prediction.value = e2;
};

var tr = function tr(t2, e2) {
  _classCallCheck3(this, tr);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "PENALTY_MATCH");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new q$2(), this.prediction.value = e2;
};

var er = function er(t2, e2) {
  _classCallCheck3(this, er);

  __publicField(this, "matchId", null);

  __publicField(this, "market", "RED_CARD_MATCH");

  __publicField(this, "matchType", "FOOTBALL");

  __publicField(this, "prediction", null);

  this.matchId = t2, this.prediction = new q$2(), this.prediction.value = e2;
};

var yt = function yt(t2) {
  var _this90 = this;

  _classCallCheck3(this, yt);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "validateBodyFields", function (t2, e2) {
    var i = Object.keys(e2),
        a = Object.keys(new de());

    switch (t2) {
      case "MATCH_QUIZ":
        i.forEach(function (n2) {
          a.includes(n2) || _this90.throwInvalidParamException([n2]);
        });
        break;

      case "TOP_X":
        var _s15 = e2;

        _s15.fixtures.forEach(function (n2) {
          return _this90.validateMarketTopX(n2.market);
        });

        var _p10 = "tiebreaker";
        i.includes(_p10) && _s15.tiebreaker && _this90.validateTiebreaker(_s15.tiebreaker), i.forEach(function (n2) {
          n2 !== "tiebreaker" && !a.includes(n2) && _this90.throwInvalidParamException([n2]);
        });
        break;
    }

    var r2 = a.filter(function (s) {
      return !i.includes(s);
    });
    return r2.length && _this90.throwMissingFieldsException("game prediction body", r2), e2.fixtures.forEach(function (s) {
      _this90.validateFixtureFields(s);
    }), e2;
  });

  __publicField(this, "validateFixture", function (t2, e2, i, a) {
    _this90.validateMarket(e2);

    var r2 = Object.values(Go),
        s = Object.values($o),
        p2 = Object.values(Vo);

    if (e2 === "FT_1X2" || e2 === "HT_1X2") {
      if (r2.includes(i)) return new Ya(t2, e2, i);
    } else if (e2 === "HT_FT") {
      if (s.includes(i)) return new Za(t2, i);
    } else if (e2 === "DOUBLE_CHANCE") {
      if (p2.includes(i)) return new Qa(t2, i);
    } else if (e2 === "CORRECT_SCORE" || e2 === "CORRECT_SCORE_ADVANCED" || e2 === "CORRECT_SCORE_HT") {
      if (typeof i == "string" && /\d+:\d+/.test(i)) return new ht(t2, e2, i);
    } else if (e2 === "CORNERS_MATCH") {
      if (typeof i == "number") return new qa(t2, i);
    } else if (e2 === "BOTH_TEAMS_SCORE") {
      if (_this90.isPredictionBoolean(i)) return new Ka(t2, i);
    } else if (e2 === "RED_CARD_MATCH") {
      if (_this90.isPredictionBoolean(i)) return new er(t2, i);
    } else if (e2 === "PENALTY_MATCH") {
      if (_this90.isPredictionBoolean(i)) return new tr(t2, i);
    } else if (tt.includes(e2)) {
      var n2 = "OWN_GOAL";

      if (_this90.validatePlayerId(e2, a), e2 === He && _this90.isPredictionBoolean(i)) {
        var l2 = a && a === n2 ? n2 : a;
        return new j$1(t2, e2, i, l2);
      }

      if (a && _this90.isPredictionBoolean(i)) return new j$1(t2, e2, i, a);
    } else if (vs.includes(e2)) {
      if (_this90.isPredictionBoolean(i)) return new se(t2, e2, i);
    } else if (Ts.includes(e2) && _this90.isPredictionBoolean(i)) return new oe(t2, e2, i);

    _this90.throwInvalidPredictionException(i, e2);
  });

  __publicField(this, "validateFixtureFields", function (t2) {
    var e2 = Object.keys(t2);
    e2.forEach(function (a) {
      Bo.includes(a) || _this90.throwInvalidParamException([a]);
    });
    var i = Bo.filter(function (a) {
      if (a !== "matchType" && !e2.includes(a)) return a;
    });
    i.length && _this90.throwMissingFieldsException("fixtures", i), _this90.validatePredictionKey(t2.market, t2.prediction);
  });

  __publicField(this, "validateTiebreaker", function (t2) {
    var e2 = Object.keys(t2);
    (!e2.length || typeof t2 != "object") && _this90.throwInvalidType("tiebreaker", "object");
    var i = Object.keys(new et())[0];
    e2.forEach(function (a) {
      i !== a && _this90.throwInvalidParamException([a]);
    }), e2.includes(i) || _this90.throwMissingFieldsException("tiebreaker", [i]), typeof t2.goldenGoal != "number" && _this90.throwInvalidType("goldenGoal", "number");
  });

  __publicField(this, "validatePredictionKey", function (t2, e2) {
    if (typeof e2 == "object") {
      var _i51 = Object.keys(e2),
          a = ["value"];

      if (_i51.length || _this90.throwMissingFieldsException("prediction", a), _i51.length === 1 && !_i51.includes(a[0]) && _this90.throwInvalidParamException(_i51), _i51.length > 1) {
        tt.includes(t2) && a.push("playerId");

        var r2 = _i51.filter(function (s) {
          return !a.includes(s);
        });

        r2.length && _this90.throwInvalidParamException(r2);
      }
    } else _this90.throwInvalidType("prediction", "object");
  });

  __publicField(this, "validatePlayerId", function (t2, e2) {
    var i = "playerId";
    t2 !== He && (e2 || _this90.throwInvalidParamException([i]), typeof e2 != "string" && _this90.throwInvalidType(i, "string"));
  });

  __publicField(this, "validateMarket", function (t2) {
    Object.values(K).includes(t2) || _this90.throwInvalidMarketException(t2);
  });

  __publicField(this, "validateMarketTopX", function (t2) {
    t2 !== "CORRECT_SCORE" && t2 !== "CORRECT_SCORE_ADVANCED" && _this90.throwInvalidMarketException(t2, "TOP_X");
  });

  __publicField(this, "isPredictionBoolean", function (t2) {
    return typeof t2 == "boolean";
  });

  __publicField(this, "throwInvalidPredictionException", function (t2, e2) {
    var i = Jo(t2, e2);
    throw _this90.errorHandlingMode === "default" ? new b$1(400, "INVALID_PREDICTION", i) : new u(400, "INVALID_TYPE", i);
  });

  __publicField(this, "throwInvalidMarketException", function (t2, e2) {
    var i = null;
    throw e2 && e2 === "TOP_X" ? i = Zo(t2) : i = Io(t2), _this90.errorHandlingMode === "default" ? new b$1(400, "INVALID_MARKET", i) : new u(400, "INVALID_TYPE", i);
  });

  __publicField(this, "throwInvalidParamException", function (t2) {
    var e2 = ts(t2);
    throw _this90.errorHandlingMode === "default" ? new b$1(400, "INVALID_FIELD", e2) : new u(400, "INVALID_TYPE", e2);
  });

  __publicField(this, "throwMissingFieldsException", function (t2, e2) {
    var i = es(t2, e2);
    throw _this90.errorHandlingMode === "default" ? new b$1(400, "INVALID_FIELD", i) : new u(400, "INVALID_TYPE", i);
  });

  __publicField(this, "throwInvalidType", function (t2, e2) {
    var i = is(t2, e2);
    throw _this90.errorHandlingMode === "default" ? new b$1(400, "INVALID_TYPE", i) : new u(400, "INVALID_TYPE", i);
  });

  this.errorHandlingMode = t2;
};

var ir = function ir(t2, e2, i, a) {
  var _this91 = this;

  _classCallCheck3(this, ir);

  __publicField(this, "predictorHttps", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "predictorService", null);

  __publicField(this, "predictorValidator", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "makeFootballPrediction",
  /*#__PURE__*/
  function () {
    var _ref267 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee230(t2, e2, i, a) {
      var r2, s, _p11, n2, l2, c2;

      return _regeneratorRuntime.wrap(function _callee230$(_context231) {
        while (1) {
          switch (_context231.prev = _context231.next) {
            case 0:
              r2 = _this91.predictorValidator.validateFixture(t2, e2, i, a), s = new de();

              if (!(_this91.idMapping.idSchema !== "native")) {
                _context231.next = 29;
                break;
              }

              _p11 = r2.matchId;
              n2 = "";
              _context231.next = 6;
              return _this91.predictorService.remapMatchIdToNative([_p11]);

            case 6:
              l2 = _context231.sent;

              if (!(r2.matchId = l2[0], _this91.errorHandlingMode === "default" && !r2.matchId)) {
                _context231.next = 9;
                break;
              }

              throw new b$1(400, "INVALID_FIELD", "Match id is invalid!").errorMessage();

            case 9:
              if (!(_this91.errorHandlingMode === "standard" && !r2.matchId)) {
                _context231.next = 11;
                break;
              }

              throw new u(400, "INVALID_FIELD", "Match id is invalid!");

            case 11:
              if (!(r2 instanceof j$1 && r2.prediction.playerId !== "OWN_GOAL")) {
                _context231.next = 22;
                break;
              }

              _context231.t0 = r2.prediction.playerId;

              if (!_context231.t0) {
                _context231.next = 18;
                break;
              }

              n2 = r2.prediction.playerId;
              _context231.next = 17;
              return _this91.predictorService.remapPlayerIdToNative([n2]);

            case 17:
              r2.prediction.playerId = _context231.sent;

            case 18:
              if (!(_this91.errorHandlingMode === "default" && r2.market !== He && !r2.prediction.playerId)) {
                _context231.next = 20;
                break;
              }

              throw new b$1(400, "INVALID_FIELD", "Player id is invalid!").errorMessage();

            case 20:
              if (!(_this91.errorHandlingMode === "standard" && r2.market !== He && !r2.prediction.playerId)) {
                _context231.next = 22;
                break;
              }

              throw new u(400, "INVALID_FIELD", "Player id is invalid!");

            case 22:
              s.fixtures = [r2];
              _context231.next = 25;
              return _this91.predictorHttps.makeFootballPrediction(s);

            case 25:
              c2 = _context231.sent;
              return _context231.abrupt("return", (c2.fixtures.forEach(function (d2) {
                d2.prediction.playerId && d2.prediction.playerId !== "OWN_GOAL" && (d2.prediction.playerId = n2), d2.matchId = _p11;
              }), c2));

            case 29:
              s.fixtures = [r2];
              _context231.next = 32;
              return _this91.predictorHttps.makeFootballPrediction(s);

            case 32:
              return _context231.abrupt("return", _context231.sent);

            case 33:
            case "end":
              return _context231.stop();
          }
        }
      }, _callee230);
    }));

    return function (_x338, _x339, _x340, _x341) {
      return _ref267.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchSummary",
  /*#__PURE__*/
  function () {
    var _ref268 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee231(t2, e2) {
      var i, a, r2;
      return _regeneratorRuntime.wrap(function _callee231$(_context232) {
        while (1) {
          switch (_context232.prev = _context232.next) {
            case 0:
              _context232.next = 2;
              return _this91.getMatchSummaryBase(t2, e2);

            case 2:
              i = _context232.sent;
              a = JSON.parse(JSON.stringify(i.predictions));
              _context232.next = 6;
              return _this91.predictorService.remapPlayerIdToIdSchema(a);

            case 6:
              r2 = _context232.sent;
              return _context232.abrupt("return", (i.predictions = r2, i));

            case 8:
            case "end":
              return _context232.stop();
          }
        }
      }, _callee231);
    }));

    return function (_x342, _x343) {
      return _ref268.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketSummary",
  /*#__PURE__*/
  function () {
    var _ref269 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee232(t2, e2, i, a) {
      var r2;
      return _regeneratorRuntime.wrap(function _callee232$(_context233) {
        while (1) {
          switch (_context233.prev = _context233.next) {
            case 0:
              _context233.prev = 0;
              _context233.next = 3;
              return _this91.getMatchSummaryBase(t2, a);

            case 3:
              r2 = _context233.sent;
              _context233.next = 6;
              return _this91.predictorService.getMarketSummary(r2, e2, i);

            case 6:
              return _context233.abrupt("return", _context233.sent);

            case 9:
              _context233.prev = 9;
              _context233.t0 = _context233["catch"](0);
              throw _context233.t0;

            case 12:
            case "end":
              return _context233.stop();
          }
        }
      }, _callee232, null, [[0, 9]]);
    }));

    return function (_x344, _x345, _x346, _x347) {
      return _ref269.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchSummaryBase",
  /*#__PURE__*/
  function () {
    var _ref270 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee233(t2, e2) {
      var _a15, r2;

      return _regeneratorRuntime.wrap(function _callee233$(_context234) {
        while (1) {
          switch (_context234.prev = _context234.next) {
            case 0:
              if (!(_this91.idMapping.idSchema !== "native")) {
                _context234.next = 10;
                break;
              }

              _context234.next = 3;
              return _this91.predictorService.remapMatchIdToNative([t2]);

            case 3:
              _a15 = _context234.sent[0];
              _context234.next = 6;
              return _this91.predictorHttps.getMatchSummary(_a15, e2);

            case 6:
              r2 = _context234.sent;
              return _context234.abrupt("return", (r2.matchId = t2, r2));

            case 10:
              _context234.next = 12;
              return _this91.predictorHttps.getMatchSummary(t2, e2);

            case 12:
              return _context234.abrupt("return", _context234.sent);

            case 13:
            case "end":
              return _context234.stop();
          }
        }
      }, _callee233);
    }));

    return function (_x348, _x349) {
      return _ref270.apply(this, arguments);
    };
  }());

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee234() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee234$(_context235) {
      while (1) {
        switch (_context235.prev = _context235.next) {
          case 0:
            _context235.next = 2;
            return _this91.clientHttps.getConfig("predictor");

          case 2:
            t2 = _context235.sent;

            if (!(_this91.idMapping.idSchema !== "native")) {
              _context235.next = 9;
              break;
            }

            _context235.next = 6;
            return _this91.predictorService.remapCompetitionsFromConfig(t2);

          case 6:
            _context235.t0 = _context235.sent;
            _context235.next = 10;
            break;

          case 9:
            _context235.t0 = t2;

          case 10:
            return _context235.abrupt("return", _context235.t0);

          case 11:
          case "end":
            return _context235.stop();
        }
      }
    }, _callee234);
  })));

  __publicField(this, "deleteFootballPrediction",
  /*#__PURE__*/
  function () {
    var _ref272 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee235(t2) {
      return _regeneratorRuntime.wrap(function _callee235$(_context236) {
        while (1) {
          switch (_context236.prev = _context236.next) {
            case 0:
              _context236.next = 2;
              return _this91.predictorHttps.deleteFootballPrediction(t2);

            case 2:
              return _context236.abrupt("return", _context236.sent);

            case 3:
            case "end":
              return _context236.stop();
          }
        }
      }, _callee235);
    }));

    return function (_x350) {
      return _ref272.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPredictions",
  /*#__PURE__*/
  function () {
    var _ref273 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee236(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee236$(_context237) {
        while (1) {
          switch (_context237.prev = _context237.next) {
            case 0:
              e2 = _this91.predictorService.initPredictionsFilters(t2, "user");
              _context237.next = 3;
              return _this91.predictorHttps.getMyPredictions(e2);

            case 3:
              return _context237.abrupt("return", _context237.sent);

            case 4:
            case "end":
              return _context237.stop();
          }
        }
      }, _callee236);
    }));

    return function (_x351) {
      return _ref273.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPredictionsForMatches",
  /*#__PURE__*/
  function () {
    var _ref274 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee237(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee237$(_context238) {
        while (1) {
          switch (_context238.prev = _context238.next) {
            case 0:
              if (!(_this91.errorHandlingMode === "default" && _this91.predictorService.areIdsExceeded(t2))) {
                _context238.next = 2;
                break;
              }

              throw new b$1(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();

            case 2:
              if (!(_this91.errorHandlingMode === "standard" && _this91.predictorService.areIdsExceeded(t2))) {
                _context238.next = 4;
                break;
              }

              throw new u(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.");

            case 4:
              _context238.t0 = _this91.idMapping.idSchema !== "native";

              if (!_context238.t0) {
                _context238.next = 9;
                break;
              }

              _context238.next = 8;
              return _this91.predictorService.remapMatchIdToNative(_toConsumableArray3(t2));

            case 8:
              t2 = _context238.sent;

            case 9:
              i = _this91.predictorService.initPredictionsFilters(e2, "matches", t2);
              _context238.next = 12;
              return _this91.predictorHttps.getMyPredictions(i);

            case 12:
              return _context238.abrupt("return", _context238.sent);

            case 13:
            case "end":
              return _context238.stop();
          }
        }
      }, _callee237);
    }));

    return function (_x352, _x353) {
      return _ref274.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyCurrentPredictions",
  /*#__PURE__*/
  function () {
    var _ref275 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee238(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee238$(_context239) {
        while (1) {
          switch (_context239.prev = _context239.next) {
            case 0:
              e2 = _this91.predictorService.initPredictionsFilters(t2, "current");
              _context239.next = 3;
              return _this91.predictorHttps.getMyPredictions(e2);

            case 3:
              return _context239.abrupt("return", _context239.sent);

            case 4:
            case "end":
              return _context239.stop();
          }
        }
      }, _callee238);
    }));

    return function (_x354) {
      return _ref275.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPastPredictions",
  /*#__PURE__*/
  function () {
    var _ref276 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee239(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee239$(_context240) {
        while (1) {
          switch (_context240.prev = _context240.next) {
            case 0:
              e2 = _this91.predictorService.initPredictionsFilters(t2, "past");
              _context240.next = 3;
              return _this91.predictorHttps.getMyPredictions(e2);

            case 3:
              return _context240.abrupt("return", _context240.sent);

            case 4:
            case "end":
              return _context240.stop();
          }
        }
      }, _callee239);
    }));

    return function (_x355) {
      return _ref276.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPredictions",
  /*#__PURE__*/
  function () {
    var _ref277 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee240(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee240$(_context241) {
        while (1) {
          switch (_context241.prev = _context241.next) {
            case 0:
              a = _this91.predictorService.initPredictionsFilters(e2, "user");
              _context241.next = 3;
              return _this91.predictorHttps.getUserPredictions(t2, i, a);

            case 3:
              return _context241.abrupt("return", _context241.sent);

            case 4:
            case "end":
              return _context241.stop();
          }
        }
      }, _callee240);
    }));

    return function (_x356, _x357, _x358) {
      return _ref277.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserCurrentPredictions",
  /*#__PURE__*/
  function () {
    var _ref278 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee241(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee241$(_context242) {
        while (1) {
          switch (_context242.prev = _context242.next) {
            case 0:
              a = _this91.predictorService.initPredictionsFilters(e2, "current");
              _context242.next = 3;
              return _this91.predictorHttps.getUserPredictions(t2, i, a);

            case 3:
              return _context242.abrupt("return", _context242.sent);

            case 4:
            case "end":
              return _context242.stop();
          }
        }
      }, _callee241);
    }));

    return function (_x359, _x360, _x361) {
      return _ref278.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPastPredictions",
  /*#__PURE__*/
  function () {
    var _ref279 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee242(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee242$(_context243) {
        while (1) {
          switch (_context243.prev = _context243.next) {
            case 0:
              a = _this91.predictorService.initPredictionsFilters(e2, "past");
              _context243.next = 3;
              return _this91.predictorHttps.getUserPredictions(t2, i, a);

            case 3:
              return _context243.abrupt("return", _context243.sent);

            case 4:
            case "end":
              return _context243.stop();
          }
        }
      }, _callee242);
    }));

    return function (_x362, _x363, _x364) {
      return _ref279.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPredictionsForMatches",
  /*#__PURE__*/
  function () {
    var _ref280 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee243(t2, e2, i, a) {
      var r2;
      return _regeneratorRuntime.wrap(function _callee243$(_context244) {
        while (1) {
          switch (_context244.prev = _context244.next) {
            case 0:
              if (!(_this91.errorHandlingMode === "default" && _this91.predictorService.areIdsExceeded(e2))) {
                _context244.next = 2;
                break;
              }

              throw new b$1(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();

            case 2:
              if (!(_this91.errorHandlingMode === "standard" && _this91.predictorService.areIdsExceeded(e2))) {
                _context244.next = 4;
                break;
              }

              throw new u(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.");

            case 4:
              _context244.t0 = _this91.idMapping.idSchema !== "native";

              if (!_context244.t0) {
                _context244.next = 9;
                break;
              }

              _context244.next = 8;
              return _this91.predictorService.remapMatchIdToNative(_toConsumableArray3(e2));

            case 8:
              e2 = _context244.sent;

            case 9:
              r2 = _this91.predictorService.initPredictionsFilters(i, "matches", e2);
              _context244.next = 12;
              return _this91.predictorHttps.getUserPredictions(t2, a, r2);

            case 12:
              return _context244.abrupt("return", _context244.sent);

            case 13:
            case "end":
              return _context244.stop();
          }
        }
      }, _callee243);
    }));

    return function (_x365, _x366, _x367, _x368) {
      return _ref280.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictionById",
  /*#__PURE__*/
  function () {
    var _ref281 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee244(t2) {
      return _regeneratorRuntime.wrap(function _callee244$(_context245) {
        while (1) {
          switch (_context245.prev = _context245.next) {
            case 0:
              _context245.next = 2;
              return _this91.predictorHttps.getPredictionById(t2);

            case 2:
              return _context245.abrupt("return", _context245.sent);

            case 3:
            case "end":
              return _context245.stop();
          }
        }
      }, _callee244);
    }));

    return function (_x369) {
      return _ref281.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictionsByIds",
  /*#__PURE__*/
  function () {
    var _ref282 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee245(t2) {
      return _regeneratorRuntime.wrap(function _callee245$(_context246) {
        while (1) {
          switch (_context246.prev = _context246.next) {
            case 0:
              _context246.next = 2;
              return _this91.predictorHttps.getPredictionsByIds(t2);

            case 2:
              return _context246.abrupt("return", _context246.sent);

            case 3:
            case "end":
              return _context246.stop();
          }
        }
      }, _callee245);
    }));

    return function (_x370) {
      return _ref282.apply(this, arguments);
    };
  }());

  this.predictorHttps = e2, this.idMapping = a, this.clientHttps = i, this.errorHandlingMode = t2.errorHandlingMode, this.predictorValidator = new yt(t2.errorHandlingMode), this.predictorService = new at(t2, a);
};

var me = function me(t2) {
  var _this92 = this;

  _classCallCheck3(this, me);

  __publicField(this, "predictorHttps", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "predictorFacade", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "makeFootballPrediction",
  /*#__PURE__*/
  function () {
    var _ref283 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee246(t2, e2, i, a) {
      return _regeneratorRuntime.wrap(function _callee246$(_context247) {
        while (1) {
          switch (_context247.prev = _context247.next) {
            case 0:
              _context247.next = 2;
              return _this92.predictorFacade.makeFootballPrediction(t2, e2, i, a);

            case 2:
              return _context247.abrupt("return", _context247.sent);

            case 3:
            case "end":
              return _context247.stop();
          }
        }
      }, _callee246);
    }));

    return function (_x371, _x372, _x373, _x374) {
      return _ref283.apply(this, arguments);
    };
  }());

  __publicField(this, "getMatchSummary",
  /*#__PURE__*/
  function () {
    var _ref284 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee247(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee247$(_context248) {
        while (1) {
          switch (_context248.prev = _context248.next) {
            case 0:
              _context248.next = 2;
              return _this92.predictorFacade.getMatchSummary(t2, e2);

            case 2:
              return _context248.abrupt("return", _context248.sent);

            case 3:
            case "end":
              return _context248.stop();
          }
        }
      }, _callee247);
    }));

    return function (_x375, _x376) {
      return _ref284.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketSummary",
  /*#__PURE__*/
  function () {
    var _ref285 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee248(t2, e2, i, a) {
      return _regeneratorRuntime.wrap(function _callee248$(_context249) {
        while (1) {
          switch (_context249.prev = _context249.next) {
            case 0:
              _context249.next = 2;
              return _this92.predictorFacade.getMarketSummary(t2, e2, i, a);

            case 2:
              return _context249.abrupt("return", _context249.sent);

            case 3:
            case "end":
              return _context249.stop();
          }
        }
      }, _callee248);
    }));

    return function (_x377, _x378, _x379, _x380) {
      return _ref285.apply(this, arguments);
    };
  }());

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee249() {
    return _regeneratorRuntime.wrap(function _callee249$(_context250) {
      while (1) {
        switch (_context250.prev = _context250.next) {
          case 0:
            _context250.next = 2;
            return _this92.predictorFacade.getConfig();

          case 2:
            return _context250.abrupt("return", _context250.sent);

          case 3:
          case "end":
            return _context250.stop();
        }
      }
    }, _callee249);
  })));

  __publicField(this, "deleteFootballPrediction",
  /*#__PURE__*/
  function () {
    var _ref287 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee250(t2) {
      return _regeneratorRuntime.wrap(function _callee250$(_context251) {
        while (1) {
          switch (_context251.prev = _context251.next) {
            case 0:
              _context251.next = 2;
              return _this92.predictorFacade.deleteFootballPrediction(t2);

            case 2:
              return _context251.abrupt("return", _context251.sent);

            case 3:
            case "end":
              return _context251.stop();
          }
        }
      }, _callee250);
    }));

    return function (_x381) {
      return _ref287.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPredictions",
  /*#__PURE__*/
  function () {
    var _ref288 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee251(t2) {
      return _regeneratorRuntime.wrap(function _callee251$(_context252) {
        while (1) {
          switch (_context252.prev = _context252.next) {
            case 0:
              _context252.next = 2;
              return _this92.predictorFacade.getMyPredictions(t2);

            case 2:
              return _context252.abrupt("return", _context252.sent);

            case 3:
            case "end":
              return _context252.stop();
          }
        }
      }, _callee251);
    }));

    return function (_x382) {
      return _ref288.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyCurrentPredictions",
  /*#__PURE__*/
  function () {
    var _ref289 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee252(t2) {
      return _regeneratorRuntime.wrap(function _callee252$(_context253) {
        while (1) {
          switch (_context253.prev = _context253.next) {
            case 0:
              _context253.next = 2;
              return _this92.predictorFacade.getMyCurrentPredictions(t2);

            case 2:
              return _context253.abrupt("return", _context253.sent);

            case 3:
            case "end":
              return _context253.stop();
          }
        }
      }, _callee252);
    }));

    return function (_x383) {
      return _ref289.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPastPredictions",
  /*#__PURE__*/
  function () {
    var _ref290 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee253(t2) {
      return _regeneratorRuntime.wrap(function _callee253$(_context254) {
        while (1) {
          switch (_context254.prev = _context254.next) {
            case 0:
              _context254.next = 2;
              return _this92.predictorFacade.getMyPastPredictions(t2);

            case 2:
              return _context254.abrupt("return", _context254.sent);

            case 3:
            case "end":
              return _context254.stop();
          }
        }
      }, _callee253);
    }));

    return function (_x384) {
      return _ref290.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyPredictionsForMatches",
  /*#__PURE__*/
  function () {
    var _ref291 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee254(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee254$(_context255) {
        while (1) {
          switch (_context255.prev = _context255.next) {
            case 0:
              _context255.next = 2;
              return _this92.predictorFacade.getMyPredictionsForMatches(t2, e2);

            case 2:
              return _context255.abrupt("return", _context255.sent);

            case 3:
            case "end":
              return _context255.stop();
          }
        }
      }, _callee254);
    }));

    return function (_x385, _x386) {
      return _ref291.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPredictions",
  /*#__PURE__*/
  function () {
    var _ref292 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee255(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee255$(_context256) {
        while (1) {
          switch (_context256.prev = _context256.next) {
            case 0:
              _context256.next = 2;
              return _this92.predictorFacade.getUserPredictions(t2, e2, i);

            case 2:
              return _context256.abrupt("return", _context256.sent);

            case 3:
            case "end":
              return _context256.stop();
          }
        }
      }, _callee255);
    }));

    return function (_x387, _x388, _x389) {
      return _ref292.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserCurrentPredictions",
  /*#__PURE__*/
  function () {
    var _ref293 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee256(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee256$(_context257) {
        while (1) {
          switch (_context257.prev = _context257.next) {
            case 0:
              _context257.next = 2;
              return _this92.predictorFacade.getUserCurrentPredictions(t2, e2, i);

            case 2:
              return _context257.abrupt("return", _context257.sent);

            case 3:
            case "end":
              return _context257.stop();
          }
        }
      }, _callee256);
    }));

    return function (_x390, _x391, _x392) {
      return _ref293.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPastPredictions",
  /*#__PURE__*/
  function () {
    var _ref294 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee257(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee257$(_context258) {
        while (1) {
          switch (_context258.prev = _context258.next) {
            case 0:
              _context258.next = 2;
              return _this92.predictorFacade.getUserPastPredictions(t2, e2, i);

            case 2:
              return _context258.abrupt("return", _context258.sent);

            case 3:
            case "end":
              return _context258.stop();
          }
        }
      }, _callee257);
    }));

    return function (_x393, _x394, _x395) {
      return _ref294.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPredictionsForMatches",
  /*#__PURE__*/
  function () {
    var _ref295 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee258(t2, e2, i, a) {
      return _regeneratorRuntime.wrap(function _callee258$(_context259) {
        while (1) {
          switch (_context259.prev = _context259.next) {
            case 0:
              _context259.next = 2;
              return _this92.predictorFacade.getUserPredictionsForMatches(t2, e2, i, a);

            case 2:
              return _context259.abrupt("return", _context259.sent);

            case 3:
            case "end":
              return _context259.stop();
          }
        }
      }, _callee258);
    }));

    return function (_x396, _x397, _x398, _x399) {
      return _ref295.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictionById",
  /*#__PURE__*/
  function () {
    var _ref296 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee259(t2) {
      return _regeneratorRuntime.wrap(function _callee259$(_context260) {
        while (1) {
          switch (_context260.prev = _context260.next) {
            case 0:
              _context260.next = 2;
              return _this92.predictorFacade.getPredictionById(t2);

            case 2:
              return _context260.abrupt("return", _context260.sent);

            case 3:
            case "end":
              return _context260.stop();
          }
        }
      }, _callee259);
    }));

    return function (_x400) {
      return _ref296.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictionsByIds",
  /*#__PURE__*/
  function () {
    var _ref297 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee260(t2) {
      return _regeneratorRuntime.wrap(function _callee260$(_context261) {
        while (1) {
          switch (_context261.prev = _context261.next) {
            case 0:
              _context261.next = 2;
              return _this92.predictorFacade.getPredictionsByIds(t2);

            case 2:
              return _context261.abrupt("return", _context261.sent);

            case 3:
            case "end":
              return _context261.stop();
          }
        }
      }, _callee260);
    }));

    return function (_x401) {
      return _ref297.apply(this, arguments);
    };
  }());

  this.idMapping = new F(t2), this.predictorHttps = new rt(t2, this.idMapping), this.clientHttps = new x$1(t2), this.predictorFacade = new ir(t2, this.predictorHttps, this.clientHttps, this.idMapping);
};

var ar = function ar() {
  _classCallCheck3(this, ar);

  __publicField(this, "rankType", null);

  __publicField(this, "fromDate", null);

  __publicField(this, "toDate", null);

  __publicField(this, "pagination", new ut());
};

var ue = function ue() {
  _classCallCheck3(this, ue);

  __publicField(this, "position", null);

  __publicField(this, "profileId", null);

  __publicField(this, "profileModel", null);

  __publicField(this, "points", null);

  __publicField(this, "predictionsMade", null);
};

var rr = function rr() {
  var _this93 = this;

  _classCallCheck3(this, rr);

  __publicField(this, "remapResponse", function (t2) {
    return t2.meta = _this93.remapMeta(t2.meta), t2.data = _this93.remapData(t2.data), t2;
  });

  __publicField(this, "remapMeta", function (t2) {
    var e2 = new ar();
    return e2.rankType = t2.rank_type, e2.fromDate = t2.from_date, e2.toDate = t2.to_date, e2.pagination.currentPage = t2.pagination.current_page, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.totalItems = t2.pagination.total_items, e2.pagination.numberOfPages = t2.pagination.number_of_pages, e2;
  });

  __publicField(this, "remapData", function (t2) {
    var e2 = [];
    return t2.forEach(function (i) {
      var a = new ue();
      a.position = i.position, a.profileId = i.profile_id, a.points = i.points, a.predictionsMade = i.predictions_made, e2.push(a);
    }), e2;
  });
};

var or = function or() {
  _classCallCheck3(this, or);

  __publicField(this, "templateId", "");

  __publicField(this, "templateModel", null);

  __publicField(this, "challengeId", "");

  __publicField(this, "challengeModel", null);

  __publicField(this, "position", "");

  __publicField(this, "points", 0);

  __publicField(this, "type", "challenge");
};

var sr = function sr() {
  _classCallCheck3(this, sr);

  __publicField(this, "templateId", "");

  __publicField(this, "templateModel", null);

  __publicField(this, "privateLeagueId", "");

  __publicField(this, "privateLeagueModel", null);

  __publicField(this, "position", "");

  __publicField(this, "points", 0);

  __publicField(this, "type", "private_league");
};

var nr =
/*#__PURE__*/
function (_ue) {
  _inherits3(nr, _ue);

  function nr() {
    var _this94;

    _classCallCheck3(this, nr);

    _this94 = _possibleConstructorReturn3(this, _getPrototypeOf4(nr).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this94), "id", null);

    __publicField(_assertThisInitialized3(_this94), "rankType", null);

    __publicField(_assertThisInitialized3(_this94), "model", null);

    __publicField(_assertThisInitialized3(_this94), "gameType", null);

    return _this94;
  }

  return nr;
}(ue);

var lr =
/*#__PURE__*/
function () {
  function lr() {
    var _this95 = this;

    _classCallCheck3(this, lr);

    __publicField(this, "remapRankings", function (t2) {
      return t2.meta = _this95.remapMeta(t2.meta), t2.data = _this95.remapData(t2.data), t2;
    });

    __publicField(this, "remapRankingsPrivateLeague", function (t2) {
      return t2.meta = _this95.remapMeta(t2.meta), t2.data = _this95.remapDataUserRankingPrivateLeague(t2.data), t2;
    });

    __publicField(this, "remapRankingsChallenge", function (t2) {
      return t2.meta = _this95.remapMeta(t2.meta), t2.data = _this95.remapDataUserRankingChallenge(t2.data), t2;
    });

    __publicField(this, "remapMeta", function (t2) {
      var e2 = new W();
      return e2.pagination.currentPage = t2.pagination.current_page, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.numberOfPages = t2.pagination.number_of_pages, e2.pagination.totalItems = t2.pagination.total_items, e2;
    });
  }

  _createClass3(lr, [{
    key: "remapData",
    value: function remapData(t2) {
      var e2 = [];
      return t2.forEach(function (i) {
        var a = new nr();
        a.id = i.id, a.rankType = i.rank_type, a.position = i.position, a.points = i.points, a.gameType = i.game_type, delete a.profileId, delete a.profileModel, delete a.predictionsMade, e2.push(a);
      }), e2;
    }
  }, {
    key: "remapDataUserRankingPrivateLeague",
    value: function remapDataUserRankingPrivateLeague(t2) {
      var e2 = [];
      return t2.forEach(function (i) {
        var a = new sr();
        a.templateId = i.template_id, a.privateLeagueId = i.private_league_id, a.position = i.position, a.points = i.points, e2.push(a);
      }), e2;
    }
  }, {
    key: "remapDataUserRankingChallenge",
    value: function remapDataUserRankingChallenge(t2) {
      var e2 = [];
      return t2.forEach(function (i) {
        var a = new or();
        a.templateId = i.template_id, a.challengeId = i.private_league_id, a.position = i.position, a.points = i.points, e2.push(a);
      }), e2;
    }
  }]);

  return lr;
}();

var pr = function pr() {
  _classCallCheck3(this, pr);

  __publicField(this, "flags", "");

  __publicField(this, "status", "");

  __publicField(this, "type", "");

  __publicField(this, "activeFrom", "");

  __publicField(this, "activeTo", "");

  __publicField(this, "createdFrom", "");

  __publicField(this, "createdTo", "");

  __publicField(this, "updatedFrom", "");

  __publicField(this, "updatedTo", "");
};

var cr = function cr() {
  _classCallCheck3(this, cr);

  __publicField(this, "pagination", new ut());

  __publicField(this, "filters", new pr());
};

var he = function he() {
  _classCallCheck3(this, he);

  __publicField(this, "id", null);

  __publicField(this, "name", null);

  __publicField(this, "description", null);

  __publicField(this, "type", null);

  __publicField(this, "fromDate", null);

  __publicField(this, "toDate", null);

  __publicField(this, "markets", []);

  __publicField(this, "teamIds", []);

  __publicField(this, "matchIds", []);

  __publicField(this, "gameIds", []);

  __publicField(this, "gameTypes", []);

  __publicField(this, "competitionIds", []);

  __publicField(this, "excludedProfileIds", []);

  __publicField(this, "rules", null);

  __publicField(this, "labels", null);

  __publicField(this, "customFields", null);

  __publicField(this, "flags", null);

  __publicField(this, "images", new ft());

  __publicField(this, "status", null);

  __publicField(this, "automaticallyChangeStatus", true);

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);

  __publicField(this, "related", null);
};

var dr =
/*#__PURE__*/
function (_he) {
  _inherits3(dr, _he);

  function dr() {
    var _this96;

    _classCallCheck3(this, dr);

    _this96 = _possibleConstructorReturn3(this, _getPrototypeOf4(dr).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this96), "adContent", null);

    return _this96;
  }

  return dr;
}(he);

var mr = function mr() {
  var _this97 = this;

  _classCallCheck3(this, mr);

  __publicField(this, "remapResponse", function (t2) {
    var e2 = [];
    return t2.forEach(function (i) {
      var a = new he();
      a.id = i.id, a.name = i.name, a.description = i.description, a.type = i.type, a.fromDate = i.from_date, a.toDate = i.to_date, a.markets = i.markets ? i.markets : null, a.teamIds = i.team_ids ? i.team_ids : null, a.matchIds = i.match_ids ? i.match_ids : null, a.gameIds = i.game_ids ? i.game_ids : null, a.gameTypes = i.game_types ? i.game_types : null, a.competitionIds = i.competition_ids ? i.competition_ids : null, a.excludedProfileIds = i.excluded_profile_ids ? i.excluded_profile_ids : null, a.rules = i.rules ? i.rules : null, a.labels = i.labels ? i.labels : null, a.customFields = i.custom_fields ? i.custom_fields : null, a.flags = i.flags ? i.flags : null, a.images = i.images ? i.images : null, a.status = i.status ? i.status : null, a.automaticallyChangeStatus = i.automatically_change_status, a.createdAt = i.created_at, a.updatedAt = i.updated_at, a.related = i.related ? _this97.remapRelated(i.related) : null, e2.push(a);
    }), e2;
  });

  __publicField(this, "remapResponseId", function (t2) {
    var e2 = new dr();
    return e2.id = t2.id, e2.name = t2.name, e2.description = t2.description, e2.type = t2.type, e2.fromDate = t2.from_date, e2.toDate = t2.to_date, e2.markets = t2.markets ? t2.markets : null, e2.teamIds = t2.team_ids ? t2.team_ids : null, e2.matchIds = t2.match_ids ? t2.match_ids : null, e2.gameIds = t2.game_ids ? t2.game_ids : null, e2.gameTypes = t2.game_types ? t2.game_types : null, e2.competitionIds = t2.competition_ids ? t2.competition_ids : null, e2.excludedProfileIds = t2.excluded_profile_ids ? t2.excluded_profile_ids : null, e2.rules = t2.rules ? t2.rules : null, e2.flags = t2.flags ? t2.flags : null, e2.images = t2.images ? t2.images : null, e2.status = t2.status ? t2.status : null, e2.automaticallyChangeStatus = t2.automatically_change_status, e2.related = t2.related ? _this97.remapRelated(t2.related) : null, e2.labels = t2.labels, e2.customFields = t2.custom_fields, e2.adContent = t2.ad_content, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapMeta", function (t2) {
    var e2 = new cr();
    return e2.pagination.currentPage = t2.pagination.current_page, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.totalItems = t2.pagination.total_items, e2.pagination.numberOfPages = t2.pagination.number_of_pages, e2.filters.flags = t2.filters.flags, e2.filters.status = t2.filters.status, e2.filters.type = t2.filters.type, e2.filters.activeFrom = t2.filters.active_from, e2.filters.activeTo = t2.filters.active_to, e2.filters.createdFrom = t2.filters.created_from, e2.filters.createdTo = t2.filters.created_to, e2.filters.updatedFrom = t2.filters.updated_from, e2.filters.updatedTo = t2.filters.updated_to, e2;
  });

  __publicField(this, "remapRelated", function (t2) {
    return t2.map(function (e2) {
      var i = new ce();
      return i.entityId = e2.entity_id, i.entityType = e2.entity_type, i;
    });
  });
};

var ur = function ur() {
  _classCallCheck3(this, ur);

  __publicField(this, "position", null);

  __publicField(this, "points", null);

  __publicField(this, "predictionsMade", null);

  __publicField(this, "profileId", null);

  __publicField(this, "profileModel", null);

  __publicField(this, "successRatePercent", null);
};

var hr = function hr() {
  _classCallCheck3(this, hr);

  __publicField(this, "remapHighestSuccessRate", function (t2) {
    return t2.map(function (e2) {
      var i = new ur();
      return i.position = e2.position, i.points = e2.points, i.predictionsMade = e2.predictions_made, i.profileId = e2.profile_id, i.successRatePercent = e2.success_rate_percent, i;
    });
  });
};

var Mt =
/*#__PURE__*/
function (_ref298) {
  _inherits3(Mt, _ref298);

  function Mt(t2) {
    var _this98;

    _classCallCheck3(this, Mt);

    _this98 = _possibleConstructorReturn3(this, _getPrototypeOf4(Mt).call(this, t2, R(t2.environment, "loyalty")));

    __publicField(_assertThisInitialized3(_this98), "templateRemapper", null);

    __publicField(_assertThisInitialized3(_this98), "leaderboardRemapper", null);

    __publicField(_assertThisInitialized3(_this98), "rankingsRemapper", null);

    __publicField(_assertThisInitialized3(_this98), "highestSuccessRateRemapper", null);

    __publicField(_assertThisInitialized3(_this98), "getTemplates",
    /*#__PURE__*/
    function () {
      var _ref299 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee261(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee261$(_context262) {
          while (1) {
            switch (_context262.prev = _context262.next) {
              case 0:
                i = t2 ? "/leaderboard/templates/".concat(_this98.apiSignInUrl).concat(t2.constructFiltersUrl()) : "/leaderboard/templates/".concat(_this98.apiSignInUrl);
                i += P(e2) ? w$2() : "";
                a = "There was a problem fetching the list of templates";
                _context262.next = 5;
                return _this98.fetchWithoutAuth(i, a);

              case 5:
                r2 = _context262.sent;
                s = JSON.parse(JSON.stringify(r2));
                return _context262.abrupt("return", (s.meta = _this98.templateRemapper.remapMeta(r2.meta), s.data = _this98.templateRemapper.remapResponse(r2.data), s));

              case 8:
              case "end":
                return _context262.stop();
            }
          }
        }, _callee261);
      }));

      return function (_x402, _x403) {
        return _ref299.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getTemplateById",
    /*#__PURE__*/
    function () {
      var _ref300 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee262(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee262$(_context263) {
          while (1) {
            switch (_context263.prev = _context263.next) {
              case 0:
                i = P(e2) ? "/leaderboard/templates/".concat(t2).concat(_this98.apiSignInUrl).concat(w$2()) : "/leaderboard/templates/".concat(t2).concat(_this98.apiSignInUrl);
                a = "There was a problem requesting the following template: ".concat(t2);
                _context263.next = 4;
                return _this98.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context263.sent;
                return _context263.abrupt("return", _this98.templateRemapper.remapResponseId(r2.data));

              case 6:
              case "end":
                return _context263.stop();
            }
          }
        }, _callee262);
      }));

      return function (_x404, _x405) {
        return _ref300.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getLeaderboard",
    /*#__PURE__*/
    function () {
      var _ref301 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee263(t2, e2, i) {
        var a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee263$(_context264) {
          while (1) {
            switch (_context264.prev = _context264.next) {
              case 0:
                a = P(e2) ? "/leaderboard/".concat(t2, "/").concat(_this98.apiSignInUrl).concat(w$2()) : "/leaderboard/".concat(t2, "/").concat(_this98.apiSignInUrl), r2 = "There was a problem fetching the leaderboard for the following template: ".concat(t2);
                i && (a += "".concat(i.constructFiltersUrl()));
                _context264.next = 4;
                return _this98.fetchWithoutAuth(a, r2);

              case 4:
                s = _context264.sent;
                p2 = JSON.parse(JSON.stringify(s));
                return _context264.abrupt("return", _this98.leaderboardRemapper.remapResponse(p2));

              case 7:
              case "end":
                return _context264.stop();
            }
          }
        }, _callee263);
      }));

      return function (_x406, _x407, _x408) {
        return _ref301.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getLeaderboardForGame",
    /*#__PURE__*/
    function () {
      var _ref302 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee264(t2, e2, i) {
        var a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee264$(_context265) {
          while (1) {
            switch (_context265.prev = _context265.next) {
              case 0:
                a = P(e2) ? "/leaderboard/games/".concat(t2, "/").concat(_this98.apiSignInUrl).concat(w$2()) : "/leaderboard/games/".concat(t2, "/").concat(_this98.apiSignInUrl), r2 = "There was a problem fetching the leaderboard for the following game: ".concat(t2);
                i && (a += "".concat(i.constructFiltersUrl()));
                _context265.next = 4;
                return _this98.fetchWithoutAuth(a, r2);

              case 4:
                s = _context265.sent;
                p2 = JSON.parse(JSON.stringify(s));
                return _context265.abrupt("return", _this98.leaderboardRemapper.remapResponse(p2));

              case 7:
              case "end":
                return _context265.stop();
            }
          }
        }, _callee264);
      }));

      return function (_x409, _x410, _x411) {
        return _ref302.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getUserRankings",
    /*#__PURE__*/
    function () {
      var _ref303 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee265(t2, e2, i) {
        var a, r2, s;
        return _regeneratorRuntime.wrap(function _callee265$(_context266) {
          while (1) {
            switch (_context266.prev = _context266.next) {
              case 0:
                a = "/leaderboard/users/".concat(t2, "/rankings/").concat(_this98.apiSignInUrl), r2 = "There was a problem fetching the rankings for the following user: ".concat(t2);
                e2 && (a += "".concat(e2.constructFiltersUrl())), P(i) && (a += "".concat(w$2()));
                _context266.next = 4;
                return _this98.fetchWithoutAuth(a, r2);

              case 4:
                s = _context266.sent;
                return _context266.abrupt("return", _this98.rankingsRemapper.remapRankings(s));

              case 6:
              case "end":
                return _context266.stop();
            }
          }
        }, _callee265);
      }));

      return function (_x412, _x413, _x414) {
        return _ref303.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getHighestSuccessRate",
    /*#__PURE__*/
    function () {
      var _ref304 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee266(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee266$(_context267) {
          while (1) {
            switch (_context267.prev = _context267.next) {
              case 0:
                i = "/statistics/top".concat(_this98.apiSignInUrl), a = "There was a problem fetching highest success rate";
                t2 && (i += "".concat(t2.constructFiltersUrl())), P(e2) && (i += "".concat(w$2()));
                _context267.next = 4;
                return _this98.fetchWithoutAuth(i, a);

              case 4:
                r2 = _context267.sent;
                return _context267.abrupt("return", _this98.highestSuccessRateRemapper.remapHighestSuccessRate(r2.data));

              case 6:
              case "end":
                return _context267.stop();
            }
          }
        }, _callee266);
      }));

      return function (_x415, _x416) {
        return _ref304.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getEntitiesFollows",
    /*#__PURE__*/
    function () {
      var _ref305 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee267(t2, e2) {
        var i, a;
        return _regeneratorRuntime.wrap(function _callee267$(_context268) {
          while (1) {
            switch (_context268.prev = _context268.next) {
              case 0:
                i = P(e2) ? "/statistics/follows".concat(_this98.apiSignInUrl).concat(w$2()) : "/statistics/follows".concat(_this98.apiSignInUrl), a = "There was a problem fetching follows for entities";
                t2.footballCompetitions && (i += "&competitions=".concat(t2.footballCompetitions.join(",")));
                t2.footballTeams && (i += "&teams=".concat(t2.footballTeams.join(",")));
                t2.footballPlayers && (i += "&players=".concat(t2.footballPlayers.join(",")));
                _context268.next = 6;
                return _this98.fetchWithoutAuth(i, a);

              case 6:
                return _context268.abrupt("return", _context268.sent.data);

              case 7:
              case "end":
                return _context268.stop();
            }
          }
        }, _callee267);
      }));

      return function (_x417, _x418) {
        return _ref305.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this98), "getUserRankingsForPrivateLeagueAndChallenges",
    /*#__PURE__*/
    function () {
      var _ref306 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee268(t2, e2, i) {
        var a, r2, s;
        return _regeneratorRuntime.wrap(function _callee268$(_context269) {
          while (1) {
            switch (_context269.prev = _context269.next) {
              case 0:
                a = "/private-league/users/".concat(t2, "/rankings/").concat(_this98.apiSignInUrl, "&private_league_type=").concat(e2 === "PRIVATE_LEAGUE" ? "private" : "one_vs_one"), r2 = "There was a problem fetching user rankings for ".concat(e2);
                i && (a += "".concat(i.constructFiltersUrl()));
                _context269.next = 4;
                return _this98.fetchWithoutAuth(a, r2);

              case 4:
                s = _context269.sent;
                return _context269.abrupt("return", e2 === "PRIVATE_LEAGUE" ? _this98.rankingsRemapper.remapRankingsPrivateLeague(s) : _this98.rankingsRemapper.remapRankingsChallenge(s));

              case 6:
              case "end":
                return _context269.stop();
            }
          }
        }, _callee268);
      }));

      return function (_x419, _x420, _x421) {
        return _ref306.apply(this, arguments);
      };
    }());

    _this98.templateRemapper = new mr(), _this98.leaderboardRemapper = new rr(), _this98.rankingsRemapper = new lr(), _this98.highestSuccessRateRemapper = new hr();
    return _this98;
  }

  return Mt;
}(_);

var gr = function gr() {
  _classCallCheck3(this, gr);

  __publicField(this, "general");

  __publicField(this, "predictor");

  __publicField(this, "topX");

  __publicField(this, "matchQuiz");
};

var ge =
/*#__PURE__*/
function () {
  function ge(t2) {
    _classCallCheck3(this, ge);

    __publicField(this, "limit", null);

    __publicField(this, "page", null);

    this.limit = t2.limit ? t2.limit : null, this.page = t2.page ? t2.page : null;
  }

  _createClass3(ge, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t2 = "";
      return this.limit && (t2 += "&", t2 += "limit=".concat(this.limit)), this.page && (t2 += "&", t2 += "page=".concat(this.page)), t2;
    }
  }]);

  return ge;
}();

var fr =
/*#__PURE__*/
function (_ge) {
  _inherits3(fr, _ge);

  function fr(t2) {
    var _this99;

    _classCallCheck3(this, fr);

    _this99 = _possibleConstructorReturn3(this, _getPrototypeOf4(fr).call(this, t2));

    __publicField(_assertThisInitialized3(_this99), "sortOrder", null);

    __publicField(_assertThisInitialized3(_this99), "rankType", null);

    __publicField(_assertThisInitialized3(_this99), "leaderboardIds", null);

    __publicField(_assertThisInitialized3(_this99), "gameType", null);

    __publicField(_assertThisInitialized3(_this99), "constructFiltersUrl", function () {
      var t2 = _get2(_getPrototypeOf4(fr.prototype), "constructFiltersUrl", _assertThisInitialized3(_this99)).call(_assertThisInitialized3(_this99));

      return _this99.sortOrder && (t2 += "&", t2 += "sort_order=".concat(_this99.sortOrder)), _this99.rankType && (t2 += "&", t2 += "rank_type=".concat(_this99.rankType)), _this99.leaderboardIds && (t2 += "&", t2 += "type_ids=".concat(_this99.leaderboardIds.join(","))), _this99.gameType && (t2 += "&", t2 += "game_type=".concat(_this99.gameType)), t2;
    });

    _this99.sortOrder = t2.sortOrder, _this99.rankType = t2.rankType, _this99.leaderboardIds = t2.leaderboardIds, _this99.gameType = t2.type && t2.type.toLowerCase() === "game" ? t2.gameType : null;
    return _this99;
  }

  return fr;
}(ge);

var yr = function yr(t2) {
  var _this100 = this;

  _classCallCheck3(this, yr);

  __publicField(this, "idMappingService", null);

  __publicField(this, "profileNamespace", null);

  __publicField(this, "footballNamespace", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "remapTemplatesIds",
  /*#__PURE__*/
  function () {
    var _ref307 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee269(t2) {
      var e2, a, _s16, n2, l2;

      return _regeneratorRuntime.wrap(function _callee269$(_context270) {
        while (1) {
          switch (_context270.prev = _context270.next) {
            case 0:
              if (!(t2.length > 0)) {
                _context270.next = 8;
                break;
              }

              e2 = [], a = [], _s16 = [];
              t2.forEach(function (c2) {
                c2.teamIds && c2.teamIds.length > 0 && (e2 = [].concat(_toConsumableArray3(e2), _toConsumableArray3(c2.teamIds))), c2.matchIds && c2.matchIds.length > 0 && (a = [].concat(_toConsumableArray3(a), _toConsumableArray3(c2.matchIds))), c2.competitionIds && c2.competitionIds.length > 0 && (_s16 = [].concat(_toConsumableArray3(_s16), _toConsumableArray3(c2.competitionIds)));
              });
              n2 = {
                team: e2,
                match: a,
                competition: _s16
              };
              _context270.next = 6;
              return _this100.idMappingService.idMappingFacade.getEntitiesByIds(n2, "native", _this100.idMappingService.idSchema);

            case 6:
              l2 = _context270.sent;
              return _context270.abrupt("return", (_toConsumableArray3(l2.team), _toConsumableArray3(l2.match), _toConsumableArray3(l2.competition), t2.forEach(function (c2) {
                c2.teamIds && c2.teamIds.length > 0 && (c2.teamIds = c2.teamIds.map(function (d2) {
                  return l2.team.shift();
                })), c2.matchIds && c2.matchIds.length > 0 && (c2.matchIds = c2.matchIds.map(function (d2) {
                  return l2.match.shift();
                })), c2.competitionIds && c2.competitionIds.length > 0 && (c2.competitionIds = c2.competitionIds.map(function (d2) {
                  return l2.competition.shift();
                }));
              }), t2));

            case 8:
              return _context270.abrupt("return", t2);

            case 9:
            case "end":
              return _context270.stop();
          }
        }
      }, _callee269);
    }));

    return function (_x422) {
      return _ref307.apply(this, arguments);
    };
  }());

  __publicField(this, "addProfileModelToLeaderboad",
  /*#__PURE__*/
  function () {
    var _ref308 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee270(t2) {
      var e2, _i52, a;

      return _regeneratorRuntime.wrap(function _callee270$(_context271) {
        while (1) {
          switch (_context271.prev = _context271.next) {
            case 0:
              if (!(t2.length > 0)) {
                _context271.next = 8;
                break;
              }

              e2 = [], _i52 = t2.map(function (r2) {
                return r2.profileId;
              });

              if (_i52.length) {
                _context271.next = 4;
                break;
              }

              return _context271.abrupt("return", t2);

            case 4:
              _context271.next = 6;
              return _this100.profileNamespace.getByIds(_i52);

            case 6:
              a = _context271.sent;
              return _context271.abrupt("return", (t2.forEach(function (r2) {
                a.forEach(function (s) {
                  s.id === r2.profileId && (delete s.interests, r2.profileModel = s);
                }), r2.profileModel || (r2.profileModel = null), e2.push(r2);
              }), e2));

            case 8:
              return _context271.abrupt("return", t2);

            case 9:
            case "end":
              return _context271.stop();
          }
        }
      }, _callee270);
    }));

    return function (_x423) {
      return _ref308.apply(this, arguments);
    };
  }());

  __publicField(this, "buildClientBadges", function (t2) {
    var e2 = new gr();
    return e2.general = _this100.extractEnabledBadgesId(t2.general), e2.predictor = _this100.extractEnabledBadgesId(t2.predictor), e2.topX = _this100.extractEnabledBadgesId(t2.topX), e2.matchQuiz = _this100.extractEnabledBadgesId(t2.matchQuiz), e2;
  });

  __publicField(this, "initFilters", function (t2, e2) {
    switch (e2) {
      case "loyalty":
        t2 && (t2 = new ge(t2));
        break;

      case "rankings":
        t2 && (t2 = new fr(t2));
        break;
    }

    return t2;
  });

  __publicField(this, "addProfileModelToHighestSuccessRate",
  /*#__PURE__*/
  function () {
    var _ref309 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee271(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee271$(_context272) {
        while (1) {
          switch (_context272.prev = _context272.next) {
            case 0:
              e2 = t2.map(function (a) {
                return a.profileId;
              });

              if (e2.length) {
                _context272.next = 3;
                break;
              }

              return _context272.abrupt("return", t2);

            case 3:
              _context272.next = 5;
              return _this100.profileNamespace.getByIds(e2);

            case 5:
              i = _context272.sent;
              return _context272.abrupt("return", t2.map(function (a) {
                return i.forEach(function (r2) {
                  r2.id === a.profileId && (delete r2.interests, a.profileModel = r2);
                }), a;
              }));

            case 7:
            case "end":
              return _context272.stop();
          }
        }
      }, _callee271);
    }));

    return function (_x424) {
      return _ref309.apply(this, arguments);
    };
  }());

  __publicField(this, "extractRankingsIdsMap", function (t2) {
    var e2 = [],
        i = [],
        a = [];
    return t2.forEach(function (r2) {
      r2.rankType === "GAME" && r2.gameType === "TOP_X" ? e2.push(r2.id) : r2.rankType === "GAME" && r2.gameType === "MATCH_QUIZ" ? i.push(r2.id) : r2.rankType === "TEMPLATE" && a.push(r2.id);
    }), [e2, i, a];
  });

  __publicField(this, "setModelsForUserRankings", function (t2, e2, i, a) {
    return a.data.forEach(function (r2) {
      r2.gameType === "MATCH_QUIZ" && e2 ? r2.model = e2.filter(function (s) {
        return s.id === r2.id;
      })[0] : r2.gameType === "TOP_X" && t2 ? r2.model = t2.filter(function (s) {
        return s.id === r2.id;
      })[0] : r2.rankType === "TEMPLATE" && i && (r2.model = i.filter(function (s) {
        return s.id === r2.id;
      })[0]);
    }), a;
  });

  __publicField(this, "completeContestWinners",
  /*#__PURE__*/
  function () {
    var _ref310 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee272(t2) {
      var e2, _i53;

      return _regeneratorRuntime.wrap(function _callee272$(_context273) {
        while (1) {
          switch (_context273.prev = _context273.next) {
            case 0:
              if (!(t2.userList && t2.userList.length)) {
                _context273.next = 6;
                break;
              }

              e2 = t2.userList.map(function (a) {
                return a.profileId;
              });
              _context273.next = 4;
              return _this100.profileNamespace.getByIds(e2);

            case 4:
              _i53 = _context273.sent;
              t2.userList.forEach(function (a) {
                var r2 = _i53.filter(function (s) {
                  return s.id === a.profileId;
                })[0];

                delete r2.interests, a.profileModel = r2;
              });

            case 6:
              return _context273.abrupt("return", t2);

            case 7:
            case "end":
              return _context273.stop();
          }
        }
      }, _callee272);
    }));

    return function (_x425) {
      return _ref310.apply(this, arguments);
    };
  }());

  __publicField(this, "validateEntitiesFollowsFilters", function (t2) {
    if (!t2 || (!t2.footballCompetitions || !t2.footballCompetitions.length) && (!t2.footballTeams || !t2.footballTeams.length) && (!t2.footballPlayers || !t2.footballPlayers.length)) throw _this100.errorHandlingMode === "default" ? new b$1(400, "invalid_filters", "At least one of footballCompetitions, footballTeams or footballPlayers properties should be provided for filters.") : new u(400, "invalid_filters", "At least one of footballCompetitions, footballTeams or footballPlayers properties should be provided for filters.");
    if (t2.footballCompetitions && t2.footballCompetitions.length > 24 || t2.footballTeams && t2.footballTeams.length > 24 || t2.footballPlayers && t2.footballPlayers.length > 24) throw _this100.errorHandlingMode === "default" ? new b$1(400, "EXCEEDED_LENGTH", "Maximum length per entity should be 24 or less.") : new u(400, "EXCEEDED_LENGTH", "Maximum length per entity should be 24 or less.");
  });

  __publicField(this, "remapEntitiesFollowsFilters",
  /*#__PURE__*/
  function () {
    var _ref311 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee273(t2) {
      var e2, i, a, r2;
      return _regeneratorRuntime.wrap(function _callee273$(_context274) {
        while (1) {
          switch (_context274.prev = _context274.next) {
            case 0:
              e2 = JSON.parse(JSON.stringify(t2)), i = {}, a = {};
              e2.footballCompetitions && e2.footballCompetitions.length && (a.competition = e2.footballCompetitions), e2.footballTeams && e2.footballTeams.length && (a.team = e2.footballTeams), e2.footballPlayers && e2.footballPlayers.length && (a.player = e2.footballPlayers);
              _context274.next = 4;
              return _this100.idMappingService.idMappingFacade.getEntitiesByIds(a, _this100.idMappingService.idSchema, "native");

            case 4:
              r2 = _context274.sent;
              return _context274.abrupt("return", (Object.keys(r2).forEach(function (s) {
                s === "competition" ? i.footballCompetitions = r2[s] : s === "team" ? i.footballTeams = r2[s] : s === "player" && (i.footballPlayers = r2[s]);
              }), i));

            case 6:
            case "end":
              return _context274.stop();
          }
        }
      }, _callee273);
    }));

    return function (_x426) {
      return _ref311.apply(this, arguments);
    };
  }());

  __publicField(this, "addModelsToEntitiesFollows",
  /*#__PURE__*/
  function () {
    var _ref312 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee274(t2) {
      var e2, i, a, r2, s, p2, n2, l2, c2;
      return _regeneratorRuntime.wrap(function _callee274$(_context275) {
        while (1) {
          switch (_context275.prev = _context275.next) {
            case 0:
              e2 = [], i = "fb:c:", a =
              /* @__PURE__ */
              new Map(), r2 = [], s = "fb:t:", p2 =
              /* @__PURE__ */
              new Map(), n2 = [], l2 = "fb:p:", c2 = null;
              t2.breakdown.forEach(function (d2) {
                d2.id.includes(i) ? e2.push(d2.id) : d2.id.includes(s) ? r2.push(d2.id) : d2.id.includes(l2) && n2.push(d2.id);
              });
              _context275.t0 = e2.length;

              if (!_context275.t0) {
                _context275.next = 7;
                break;
              }

              _context275.next = 6;
              return _this100.footballNamespace.footballFacade.competitionsFacade.getCompetitionsMapWithNativeIds(e2);

            case 6:
              a = _context275.sent;

            case 7:
              _context275.t1 = r2.length;

              if (!_context275.t1) {
                _context275.next = 12;
                break;
              }

              _context275.next = 11;
              return _this100.footballNamespace.footballFacade.teamsFacade.getTeamsMapWithNativeIds(r2);

            case 11:
              p2 = _context275.sent;

            case 12:
              _context275.t2 = n2.length;

              if (!_context275.t2) {
                _context275.next = 17;
                break;
              }

              _context275.next = 16;
              return _this100.footballNamespace.footballFacade.playerFacade.getPlayersMapWithNativeIds(n2);

            case 16:
              c2 = _context275.sent;

            case 17:
              t2.breakdown.forEach(function (d2) {
                d2.id.includes(i) ? (d2.model = a.get(d2.id), d2.id = d2.model.id) : d2.id.includes(s) ? (d2.model = p2.get(d2.id), d2.id = d2.model.id) : d2.id.includes(l2) && (d2.model = c2[d2.id], d2.id = d2.model.id);
              });
              return _context275.abrupt("return", t2);

            case 19:
            case "end":
              return _context275.stop();
          }
        }
      }, _callee274);
    }));

    return function (_x427) {
      return _ref312.apply(this, arguments);
    };
  }());

  __publicField(this, "extractEnabledBadgesId", function (t2) {
    var e2 = [];
    return t2.forEach(function (i) {
      i.enabled && e2.push(i.id);
    }), e2;
  });

  this.idMappingService = new F(t2), this.profileNamespace = new L(t2), this.footballNamespace = new ie(t2), this.errorHandlingMode = t2.errorHandlingMode;
};

var Mr = function Mr() {
  var _this101 = this;

  _classCallCheck3(this, Mr);

  __publicField(this, "validate", function (t2, e2) {
    t2.market && _this101.validateMarket(t2.market, e2), t2.fromDate && _this101.validateDate(t2.fromDate, "fromDate", e2), t2.toDate && _this101.validateDate(t2.toDate, "toDate", e2), t2.usersCount && _this101.validateNumberFilters(t2.usersCount, "usersCount", e2), t2.minimumPredictions && _this101.validateNumberFilters(t2.minimumPredictions, "minimumPredictions", e2);
  });

  __publicField(this, "validateMarket", function (t2, e2) {
    if (!Object.keys(K).includes(t2)) {
      var a = Io(t2);
      throw e2 === "default" ? new b$1(400, "INVALID_MARKET", a) : new u(400, "INVALID_MARKET", a);
    }
  });

  __publicField(this, "validateDate", function (t2, e2, i) {
    var a = /^\d{4}-\d{2}-\d{2}$/;
    if (typeof t2 != "string") throw i === "default" ? new b$1(400, "invalid_filters", "You have provided invalid type. The valid type is string for ".concat(e2, " filter")) : new u(400, "invalid_filters", "You have provided invalid type. The valid type is string for ".concat(e2, " filter"));
    if (!a.test(t2)) throw i === "default" ? new b$1(400, "invalid_filters", "You have provided invalid value. The valid value is YYYY-MM-DD for ".concat(e2)) : new u(400, "invalid_filters", "You have provided invalid value. The valid value is YYYY-MM-DD for ".concat(e2));
  });

  __publicField(this, "validateNumberFilters", function (t2, e2, i) {
    var a = e2 === "usersCount" ? 1 : 0,
        r2 = e2 === "usersCount" ? 1e3 : 1e6;
    if (typeof t2 != "number") throw i === "default" ? new b$1(400, "invalid_filters", "You have provided invalid type. The valid type is number for ".concat(e2, " filter")) : new u(400, "invalid_filters", "You have provided invalid type. The valid type is number for ".concat(e2, " filter"));
    if (t2 < a || t2 > r2) throw i === "default" ? new b$1(400, "invalid_filters", "You have provided invalid value. The valid value is between ".concat(a, " and ").concat(r2)) : new u(400, "invalid_filters", "You have provided invalid value. The valid value is between ".concat(a, " and ").concat(r2));
  });
};

var fe = function fe(t2, e2) {
  var _this102 = this;

  _classCallCheck3(this, fe);

  __publicField(this, "idMapping", null);

  __publicField(this, "predictorHttps", null);

  __publicField(this, "predictorService", null);

  __publicField(this, "predictorValidator", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee275() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee275$(_context276) {
      while (1) {
        switch (_context276.prev = _context276.next) {
          case 0:
            _context276.next = 2;
            return _this102.clientHttps.getConfig("topX");

          case 2:
            t2 = _context276.sent;

            if (!(_this102.idMapping.idSchema !== "native")) {
              _context276.next = 9;
              break;
            }

            _context276.next = 6;
            return _this102.predictorService.remapCompetitionsFromConfig(t2);

          case 6:
            _context276.t0 = _context276.sent;
            _context276.next = 10;
            break;

          case 9:
            _context276.t0 = t2;

          case 10:
            return _context276.abrupt("return", _context276.t0);

          case 11:
          case "end":
            return _context276.stop();
        }
      }
    }, _callee275);
  })));

  __publicField(this, "getGames",
  /*#__PURE__*/
  function () {
    var _ref314 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee276(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee276$(_context277) {
        while (1) {
          switch (_context277.prev = _context277.next) {
            case 0:
              e2 = e2 || false;
              i = _this102.predictorService.initGameFilters("TOP_X", t2);
              _context277.next = 4;
              return _this102.predictorHttps.getGames(i, e2);

            case 4:
              a = _context277.sent;
              _context277.next = 7;
              return _this102.predictorService.remapMatchIdsFixtures(a);

            case 7:
              return _context277.abrupt("return", _context277.sent);

            case 8:
            case "end":
              return _context277.stop();
          }
        }
      }, _callee276);
    }));

    return function (_x428, _x429) {
      return _ref314.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameById",
  /*#__PURE__*/
  function () {
    var _ref315 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee277(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee277$(_context278) {
        while (1) {
          switch (_context278.prev = _context278.next) {
            case 0:
              e2 = e2 || false;
              _context278.next = 3;
              return _this102.predictorHttps.getGameById(t2, e2);

            case 3:
              i = _context278.sent;
              _context278.next = 6;
              return _this102.predictorService.remapMatchIdsFixtures(i);

            case 6:
              return _context278.abrupt("return", _context278.sent);

            case 7:
            case "end":
              return _context278.stop();
          }
        }
      }, _callee277);
    }));

    return function (_x430, _x431) {
      return _ref315.apply(this, arguments);
    };
  }());

  __publicField(this, "getGamePredictions",
  /*#__PURE__*/
  function () {
    var _ref316 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee278(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee278$(_context279) {
        while (1) {
          switch (_context279.prev = _context279.next) {
            case 0:
              i = i || false;
              e2 && (e2.type && delete e2.type, e2.status && delete e2.status, e2 = new O(e2));
              _context279.next = 4;
              return _this102.predictorHttps.getGamePredictions(t2, i, e2);

            case 4:
              return _context279.abrupt("return", _context279.sent);

            case 5:
            case "end":
              return _context279.stop();
          }
        }
      }, _callee278);
    }));

    return function (_x432, _x433, _x434) {
      return _ref316.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameResults",
  /*#__PURE__*/
  function () {
    var _ref317 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee279(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee279$(_context280) {
        while (1) {
          switch (_context280.prev = _context280.next) {
            case 0:
              i = i || false, e2 && (e2 = new z$1(e2));
              _context280.next = 3;
              return _this102.predictorHttps.getGameResults(t2, i, e2);

            case 3:
              a = _context280.sent;
              _context280.next = 6;
              return _this102.predictorService.remapMatchIdsFixtures(a);

            case 6:
              return _context280.abrupt("return", _context280.sent);

            case 7:
            case "end":
              return _context280.stop();
          }
        }
      }, _callee279);
    }));

    return function (_x435, _x436, _x437) {
      return _ref317.apply(this, arguments);
    };
  }());

  __publicField(this, "getCurrentGameResults",
  /*#__PURE__*/
  function () {
    var _ref318 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee280(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee280$(_context281) {
        while (1) {
          switch (_context281.prev = _context281.next) {
            case 0:
              t2 = t2 || false;
              e2 = {
                status: "OPEN",
                type: "TOP_X"
              };
              e2 = new z$1(e2);
              _context281.next = 5;
              return _this102.predictorHttps.getGames(e2, t2);

            case 5:
              i = _context281.sent;
              a = _this102.predictorService.getCurrentGameId(i);
              _context281.next = 9;
              return _this102.getGameResults(a, null, t2);

            case 9:
              return _context281.abrupt("return", _context281.sent.data[0]);

            case 10:
            case "end":
              return _context281.stop();
          }
        }
      }, _callee280);
    }));

    return function (_x438) {
      return _ref318.apply(this, arguments);
    };
  }());

  __publicField(this, "play",
  /*#__PURE__*/
  function () {
    var _ref319 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee281(t2) {
      var e2, a, r2, i;
      return _regeneratorRuntime.wrap(function _callee281$(_context282) {
        while (1) {
          switch (_context282.prev = _context282.next) {
            case 0:
              e2 = new le(t2);

              if (!(e2 = _this102.predictorValidator.validateBodyFields("TOP_X", e2), e2.fixtures = e2.fixtures.map(function (a) {
                return _this102.predictorValidator.validateFixture(a.matchId, a.market, a.prediction.value);
              }), _this102.idMapping.idSchema !== "native")) {
                _context282.next = 8;
                break;
              }

              a = [];
              e2.fixtures.forEach(function (s) {
                return a.push(s.matchId);
              });
              _context282.next = 6;
              return _this102.predictorService.remapMatchIdToNative(a);

            case 6:
              r2 = _context282.sent;
              e2.fixtures.forEach(function (s) {
                return s.matchId = r2.shift();
              });

            case 8:
              _context282.next = 10;
              return _this102.predictorHttps.makeFootballPrediction(e2);

            case 10:
              i = _context282.sent;
              return _context282.abrupt("return", (i.fixtures.forEach(function (a) {
                a.matchId = a.matchModel.id;
              }), i));

            case 12:
            case "end":
              return _context282.stop();
          }
        }
      }, _callee281);
    }));

    return function (_x439) {
      return _ref319.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref320 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee282(t2) {
      return _regeneratorRuntime.wrap(function _callee282$(_context283) {
        while (1) {
          switch (_context283.prev = _context283.next) {
            case 0:
              _context283.next = 2;
              return _this102.predictorHttps.deleteFootballPrediction(t2);

            case 2:
              return _context283.abrupt("return", _context283.sent);

            case 3:
            case "end":
              return _context283.stop();
          }
        }
      }, _callee282);
    }));

    return function (_x440) {
      return _ref320.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGameEditions",
  /*#__PURE__*/
  function () {
    var _ref321 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee283(t2, e2) {
      var i, a, r2, _s17, _p12;

      return _regeneratorRuntime.wrap(function _callee283$(_context284) {
        while (1) {
          switch (_context284.prev = _context284.next) {
            case 0:
              t2 && t2.limit && _this102.validateLimitFilterOnGames(t2.limit), e2 = e2 || false;
              i = _this102.predictorService.initGameTypePredictions("TOP_X", t2);
              a = [];
              _context284.next = 5;
              return _this102.predictorHttps.getMyPredictionsNoRemap(i);

            case 5:
              r2 = _context284.sent;

              if (!(r2.data.length > 0)) {
                _context284.next = 17;
                break;
              }

              r2.data.forEach(function (n2) {
                n2.game_instance_id && a.push(n2.game_instance_id);
              });
              _s17 = _this102.predictorService.initGameFilters("TOP_X", null, a);
              _context284.next = 11;
              return _this102.predictorHttps.getUserGameEditions(_s17, e2);

            case 11:
              _p12 = _context284.sent;
              _context284.next = 14;
              return _this102.predictorService.addPredictionProp(r2, _p12);

            case 14:
              return _context284.abrupt("return", _context284.sent);

            case 17:
              return _context284.abrupt("return", new E());

            case 18:
            case "end":
              return _context284.stop();
          }
        }
      }, _callee283);
    }));

    return function (_x441, _x442) {
      return _ref321.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref322 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee284(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee284$(_context285) {
        while (1) {
          switch (_context285.prev = _context285.next) {
            case 0:
              e2 = _this102.predictorService.initGameTypePredictions("TOP_X");
              _context285.next = 3;
              return _this102.predictorHttps.getMyPredictions(e2);

            case 3:
              i = _context285.sent;

              if (!(i.data.length > 0)) {
                _context285.next = 7;
                break;
              }

              a = i.data.filter(function (r2) {
                return r2.gameInstanceId === t2;
              });
              return _context285.abrupt("return", a.length ? a[0] : null);

            case 7:
              return _context285.abrupt("return", null);

            case 8:
            case "end":
              return _context285.stop();
          }
        }
      }, _callee284);
    }));

    return function (_x443) {
      return _ref322.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGameEditions",
  /*#__PURE__*/
  function () {
    var _ref323 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee285(t2, e2, i) {
      var a, r2, s, _p13, n2;

      return _regeneratorRuntime.wrap(function _callee285$(_context286) {
        while (1) {
          switch (_context286.prev = _context286.next) {
            case 0:
              e2 && e2.limit && _this102.validateLimitFilterOnGames(e2.limit), i = i || false;
              a = _this102.predictorService.initGameTypePredictions("TOP_X", e2);
              r2 = [];
              _context286.next = 5;
              return _this102.predictorHttps.getUserPredictionsNoRemap(t2, a);

            case 5:
              s = _context286.sent;

              if (!(s.data.length > 0)) {
                _context286.next = 17;
                break;
              }

              s.data.forEach(function (l2) {
                l2.game_instance_id && r2.push(l2.game_instance_id);
              });
              _p13 = _this102.predictorService.initGameFilters("TOP_X", null, r2);
              _context286.next = 11;
              return _this102.predictorHttps.getUserGameEditions(_p13, i);

            case 11:
              n2 = _context286.sent;
              _context286.next = 14;
              return _this102.predictorService.addPredictionProp(s, n2);

            case 14:
              return _context286.abrupt("return", _context286.sent);

            case 17:
              return _context286.abrupt("return", new E());

            case 18:
            case "end":
              return _context286.stop();
          }
        }
      }, _callee285);
    }));

    return function (_x444, _x445, _x446) {
      return _ref323.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref324 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee286(t2, e2, i) {
      var a, r2, _s18;

      return _regeneratorRuntime.wrap(function _callee286$(_context287) {
        while (1) {
          switch (_context287.prev = _context287.next) {
            case 0:
              i = i || false;
              a = _this102.predictorService.initGameTypePredictions("TOP_X");
              _context287.next = 4;
              return _this102.predictorHttps.getUserPredictions(t2, i, a);

            case 4:
              r2 = _context287.sent;

              if (!(r2.data.length > 0)) {
                _context287.next = 10;
                break;
              }

              _s18 = r2.data.filter(function (p2) {
                return p2.gameInstanceId === e2;
              });
              return _context287.abrupt("return", _s18.length ? _s18[0] : null);

            case 10:
              return _context287.abrupt("return", null);

            case 11:
            case "end":
              return _context287.stop();
          }
        }
      }, _callee286);
    }));

    return function (_x447, _x448, _x449) {
      return _ref324.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketsResultsForGame",
  /*#__PURE__*/
  function () {
    var _ref325 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee287(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee287$(_context288) {
        while (1) {
          switch (_context288.prev = _context288.next) {
            case 0:
              _context288.next = 2;
              return _this102.predictorHttps.getMarketResultsForGame(t2, e2);

            case 2:
              i = _context288.sent;
              _context288.next = 5;
              return _this102.predictorService.completeGameMarketResults(i, "TOP_X");

            case 5:
              return _context288.abrupt("return", _context288.sent);

            case 6:
            case "end":
              return _context288.stop();
          }
        }
      }, _callee287);
    }));

    return function (_x450, _x451) {
      return _ref325.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameWinners",
  /*#__PURE__*/
  function () {
    var _ref326 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee288(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee288$(_context289) {
        while (1) {
          switch (_context289.prev = _context289.next) {
            case 0:
              _context289.next = 2;
              return _this102.predictorHttps.getContestWinners(t2, e2);

            case 2:
              i = _context289.sent;
              _context289.next = 5;
              return _this102.getGameById(t2);

            case 5:
              a = _context289.sent;
              return _context289.abrupt("return", (i.contestModel = a, _this102.predictorService.completeContestWinners(i)));

            case 7:
            case "end":
              return _context289.stop();
          }
        }
      }, _callee288);
    }));

    return function (_x452, _x453) {
      return _ref326.apply(this, arguments);
    };
  }());

  __publicField(this, "validateLimitFilterOnGames", function (t2) {
    if (_this102.errorHandlingMode === "default" && t2 > 50) throw new b$1(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
    if (_this102.errorHandlingMode === "standard" && t2 > 50) throw new u(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  });

  this.idMapping = e2, this.errorHandlingMode = t2.errorHandlingMode, this.predictorValidator = new yt(t2.errorHandlingMode), this.predictorHttps = new rt(t2, e2), this.predictorService = new at(t2, e2), this.clientHttps = new x$1(t2);
};

var ye = function ye(t2) {
  var _this103 = this;

  _classCallCheck3(this, ye);

  __publicField(this, "predictorHttps", null);

  __publicField(this, "predictorService", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "predictorValidator", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee289() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee289$(_context290) {
      while (1) {
        switch (_context290.prev = _context290.next) {
          case 0:
            _context290.next = 2;
            return _this103.clientHttps.getConfig("matchQuiz");

          case 2:
            t2 = _context290.sent;

            if (!(_this103.idMapping.idSchema !== "native")) {
              _context290.next = 9;
              break;
            }

            _context290.next = 6;
            return _this103.predictorService.remapCompetitionsFromConfig(t2);

          case 6:
            _context290.t0 = _context290.sent;
            _context290.next = 10;
            break;

          case 9:
            _context290.t0 = t2;

          case 10:
            return _context290.abrupt("return", _context290.t0);

          case 11:
          case "end":
            return _context290.stop();
        }
      }
    }, _callee289);
  })));

  __publicField(this, "play",
  /*#__PURE__*/
  function () {
    var _ref328 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee290(t2) {
      var e2, _i54, a, r2, _s19;

      return _regeneratorRuntime.wrap(function _callee290$(_context291) {
        while (1) {
          switch (_context291.prev = _context291.next) {
            case 0:
              t2 = _this103.predictorValidator.validateBodyFields("MATCH_QUIZ", t2);
              e2 = t2.fixtures.map(function (i) {
                return _this103.predictorValidator.validateFixture(i.matchId, i.market, i.prediction.value, i.prediction.playerId);
              });

              if (!(e2 && e2.length && _this103.idMapping.idSchema !== "native")) {
                _context291.next = 15;
                break;
              }

              _i54 = [], a = [];
              e2.forEach(function (p2) {
                _i54.push(p2.matchId), p2 instanceof j$1 && p2.prediction.playerId && p2.prediction.playerId !== "OWN_GOAL" && a.push(p2.prediction.playerId);
              });
              _context291.next = 7;
              return _this103.predictorService.remapMatchIdToNative(_i54);

            case 7:
              r2 = _context291.sent;
              _s19 = {};
              _context291.t0 = a && a.length > 0;

              if (!_context291.t0) {
                _context291.next = 14;
                break;
              }

              _context291.next = 13;
              return _this103.predictorService.remapPlayerIdMapToNative(a);

            case 13:
              _s19 = _context291.sent;

            case 14:
              e2.forEach(function (p2, n2) {
                p2.matchId = r2[n2], p2 instanceof j$1 && p2.prediction.playerId !== "OWN_GOAL" && (p2.prediction.playerId = _s19[p2.prediction.playerId]);
              });

            case 15:
              t2.fixtures = e2;
              _context291.next = 18;
              return _this103.predictorHttps.makeFootballPrediction(t2);

            case 18:
              return _context291.abrupt("return", _context291.sent);

            case 19:
            case "end":
              return _context291.stop();
          }
        }
      }, _callee290);
    }));

    return function (_x454) {
      return _ref328.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref329 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee291(t2) {
      return _regeneratorRuntime.wrap(function _callee291$(_context292) {
        while (1) {
          switch (_context292.prev = _context292.next) {
            case 0:
              _context292.next = 2;
              return _this103.predictorHttps.deleteFootballPrediction(t2);

            case 2:
              return _context292.abrupt("return", _context292.sent);

            case 3:
            case "end":
              return _context292.stop();
          }
        }
      }, _callee291);
    }));

    return function (_x455) {
      return _ref329.apply(this, arguments);
    };
  }());

  __publicField(this, "getGames",
  /*#__PURE__*/
  function () {
    var _ref330 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee292(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee292$(_context293) {
        while (1) {
          switch (_context293.prev = _context293.next) {
            case 0:
              e2 = e2 || false;
              i = _this103.predictorService.initGameFilters("MATCH_QUIZ", t2);
              _context293.next = 4;
              return _this103.predictorHttps.getGames(i, e2);

            case 4:
              a = _context293.sent;
              _context293.next = 7;
              return _this103.predictorService.remapMatchIdsFixtures(a);

            case 7:
              return _context293.abrupt("return", _context293.sent);

            case 8:
            case "end":
              return _context293.stop();
          }
        }
      }, _callee292);
    }));

    return function (_x456, _x457) {
      return _ref330.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameById",
  /*#__PURE__*/
  function () {
    var _ref331 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee293(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee293$(_context294) {
        while (1) {
          switch (_context294.prev = _context294.next) {
            case 0:
              e2 = e2 || false;
              _context294.next = 3;
              return _this103.predictorHttps.getGameById(t2, e2);

            case 3:
              i = _context294.sent;
              _context294.next = 6;
              return _this103.predictorService.remapMatchIdsFixtures(i);

            case 6:
              return _context294.abrupt("return", _context294.sent);

            case 7:
            case "end":
              return _context294.stop();
          }
        }
      }, _callee293);
    }));

    return function (_x458, _x459) {
      return _ref331.apply(this, arguments);
    };
  }());

  __publicField(this, "getGamePredictions",
  /*#__PURE__*/
  function () {
    var _ref332 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee294(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee294$(_context295) {
        while (1) {
          switch (_context295.prev = _context295.next) {
            case 0:
              i = i || false;
              e2 && (e2.type && delete e2.type, e2.status && delete e2.status, e2 = new O(e2));
              _context295.next = 4;
              return _this103.predictorHttps.getGamePredictions(t2, i, e2);

            case 4:
              return _context295.abrupt("return", _context295.sent);

            case 5:
            case "end":
              return _context295.stop();
          }
        }
      }, _callee294);
    }));

    return function (_x460, _x461, _x462) {
      return _ref332.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameResults",
  /*#__PURE__*/
  function () {
    var _ref333 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee295(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee295$(_context296) {
        while (1) {
          switch (_context296.prev = _context296.next) {
            case 0:
              i = i || false, e2 && (e2 = new N(e2));
              _context296.next = 3;
              return _this103.predictorHttps.getGameResults(t2, i, e2);

            case 3:
              a = _context296.sent;
              _context296.next = 6;
              return _this103.predictorService.remapMatchIdsFixtures(a);

            case 6:
              return _context296.abrupt("return", _context296.sent);

            case 7:
            case "end":
              return _context296.stop();
          }
        }
      }, _callee295);
    }));

    return function (_x463, _x464, _x465) {
      return _ref333.apply(this, arguments);
    };
  }());

  __publicField(this, "getCurrentGameResults",
  /*#__PURE__*/
  function () {
    var _ref334 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee296(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee296$(_context297) {
        while (1) {
          switch (_context297.prev = _context297.next) {
            case 0:
              t2 = t2 || false;
              e2 = {
                status: "OPEN",
                type: "MATCH_QUIZ"
              };
              e2 = new z$1(e2);
              _context297.next = 5;
              return _this103.predictorHttps.getGames(e2, t2);

            case 5:
              i = _context297.sent;
              a = _this103.predictorService.getCurrentGameId(i);
              _context297.next = 9;
              return _this103.getGameResults(a, null, t2);

            case 9:
              return _context297.abrupt("return", _context297.sent.data[0]);

            case 10:
            case "end":
              return _context297.stop();
          }
        }
      }, _callee296);
    }));

    return function (_x466) {
      return _ref334.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGameEditions",
  /*#__PURE__*/
  function () {
    var _ref335 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee297(t2, e2) {
      var i, a, r2, _s20, _p14;

      return _regeneratorRuntime.wrap(function _callee297$(_context298) {
        while (1) {
          switch (_context298.prev = _context298.next) {
            case 0:
              t2 && t2.limit && _this103.validateLimitFilterOnGames(t2.limit), e2 = e2 || false;
              i = _this103.predictorService.initGameTypePredictions("MATCH_QUIZ", t2);
              a = [];
              _context298.next = 5;
              return _this103.predictorHttps.getMyPredictionsNoRemap(i);

            case 5:
              r2 = _context298.sent;

              if (!(r2.data.length > 0)) {
                _context298.next = 17;
                break;
              }

              r2.data.forEach(function (n2) {
                n2.game_instance_id && a.push(n2.game_instance_id);
              });
              _s20 = _this103.predictorService.initGameFilters("MATCH_QUIZ", null, a);
              _context298.next = 11;
              return _this103.predictorHttps.getUserGameEditions(_s20, e2);

            case 11:
              _p14 = _context298.sent;
              _context298.next = 14;
              return _this103.predictorService.addPredictionProp(r2, _p14);

            case 14:
              return _context298.abrupt("return", _context298.sent);

            case 17:
              return _context298.abrupt("return", new E());

            case 18:
            case "end":
              return _context298.stop();
          }
        }
      }, _callee297);
    }));

    return function (_x467, _x468) {
      return _ref335.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref336 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee298(t2) {
      var e2, i, a;
      return _regeneratorRuntime.wrap(function _callee298$(_context299) {
        while (1) {
          switch (_context299.prev = _context299.next) {
            case 0:
              e2 = _this103.predictorService.initGameTypePredictions("MATCH_QUIZ");
              _context299.next = 3;
              return _this103.predictorHttps.getMyPredictions(e2);

            case 3:
              i = _context299.sent;

              if (!(i.data.length > 0)) {
                _context299.next = 7;
                break;
              }

              a = i.data.filter(function (r2) {
                return r2.gameInstanceId === t2;
              });
              return _context299.abrupt("return", a.length ? a[0] : null);

            case 7:
              return _context299.abrupt("return", null);

            case 8:
            case "end":
              return _context299.stop();
          }
        }
      }, _callee298);
    }));

    return function (_x469) {
      return _ref336.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGameEditions",
  /*#__PURE__*/
  function () {
    var _ref337 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee299(t2, e2, i) {
      var a, r2, s, _p15, n2;

      return _regeneratorRuntime.wrap(function _callee299$(_context300) {
        while (1) {
          switch (_context300.prev = _context300.next) {
            case 0:
              e2 && e2.limit && _this103.validateLimitFilterOnGames(e2.limit), i = i || false;
              a = _this103.predictorService.initGameTypePredictions("MATCH_QUIZ", e2);
              r2 = [];
              _context300.next = 5;
              return _this103.predictorHttps.getUserPredictionsNoRemap(t2, a);

            case 5:
              s = _context300.sent;

              if (!(s.data.length > 0)) {
                _context300.next = 17;
                break;
              }

              s.data.forEach(function (l2) {
                l2.game_instance_id && r2.push(l2.game_instance_id);
              });
              _p15 = _this103.predictorService.initGameFilters("MATCH_QUIZ", null, r2);
              _context300.next = 11;
              return _this103.predictorHttps.getUserGameEditions(_p15, i);

            case 11:
              n2 = _context300.sent;
              _context300.next = 14;
              return _this103.predictorService.addPredictionProp(s, n2);

            case 14:
              return _context300.abrupt("return", _context300.sent);

            case 17:
              return _context300.abrupt("return", new E());

            case 18:
            case "end":
              return _context300.stop();
          }
        }
      }, _callee299);
    }));

    return function (_x470, _x471, _x472) {
      return _ref337.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref338 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee300(t2, e2, i) {
      var a, r2, _s21;

      return _regeneratorRuntime.wrap(function _callee300$(_context301) {
        while (1) {
          switch (_context301.prev = _context301.next) {
            case 0:
              i = i || false;
              a = _this103.predictorService.initGameTypePredictions("MATCH_QUIZ");
              _context301.next = 4;
              return _this103.predictorHttps.getUserPredictions(t2, i, a);

            case 4:
              r2 = _context301.sent;

              if (!(r2.data.length > 0)) {
                _context301.next = 10;
                break;
              }

              _s21 = r2.data.filter(function (p2) {
                return p2.gameInstanceId === e2;
              });
              return _context301.abrupt("return", _s21.length ? _s21[0] : null);

            case 10:
              return _context301.abrupt("return", null);

            case 11:
            case "end":
              return _context301.stop();
          }
        }
      }, _callee300);
    }));

    return function (_x473, _x474, _x475) {
      return _ref338.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketsResultsForGame",
  /*#__PURE__*/
  function () {
    var _ref339 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee301(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee301$(_context302) {
        while (1) {
          switch (_context302.prev = _context302.next) {
            case 0:
              _context302.next = 2;
              return _this103.predictorHttps.getMarketResultsForGame(t2, e2);

            case 2:
              i = _context302.sent;
              _context302.next = 5;
              return _this103.predictorService.completeGameMarketResults(i, "MATCH_QUIZ");

            case 5:
              return _context302.abrupt("return", _context302.sent);

            case 6:
            case "end":
              return _context302.stop();
          }
        }
      }, _callee301);
    }));

    return function (_x476, _x477) {
      return _ref339.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameWinners",
  /*#__PURE__*/
  function () {
    var _ref340 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee302(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee302$(_context303) {
        while (1) {
          switch (_context303.prev = _context303.next) {
            case 0:
              _context303.next = 2;
              return _this103.predictorHttps.getContestWinners(t2, e2);

            case 2:
              i = _context303.sent;
              _context303.next = 5;
              return _this103.getGameById(t2);

            case 5:
              a = _context303.sent;
              return _context303.abrupt("return", (i.contestModel = a, _this103.predictorService.completeContestWinners(i)));

            case 7:
            case "end":
              return _context303.stop();
          }
        }
      }, _callee302);
    }));

    return function (_x478, _x479) {
      return _ref340.apply(this, arguments);
    };
  }());

  __publicField(this, "validateLimitFilterOnGames", function (t2) {
    if (_this103.errorHandlingMode === "default" && t2 > 50) throw new b$1(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
    if (_this103.errorHandlingMode === "standard" && t2 > 50) throw new u(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  });

  this.predictorValidator = new yt(t2.errorHandlingMode), this.idMapping = new F(t2), this.predictorHttps = new rt(t2, this.idMapping), this.predictorService = new at(t2, this.idMapping), this.clientHttps = new x$1(t2), this.errorHandlingMode = t2.errorHandlingMode;
};

var br =
/*#__PURE__*/
function () {
  function br(t2) {
    _classCallCheck3(this, br);

    __publicField(this, "market");

    __publicField(this, "fromDate");

    __publicField(this, "toDate");

    __publicField(this, "usersCount");

    __publicField(this, "minimumPredictions");

    this.market = t2.market ? t2.market : null, this.fromDate = t2.fromDate ? t2.fromDate : null, this.toDate = t2.toDate ? t2.toDate : null, this.usersCount = t2.usersCount ? t2.usersCount : null, this.minimumPredictions = t2.minimumPredictions ? t2.minimumPredictions : null;
  }

  _createClass3(br, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t2 = "";
      return this.market && (t2 += "&", t2 += "market=".concat(this.market)), this.fromDate && (t2 += "&", t2 += "from_date=".concat(this.fromDate)), this.toDate && (t2 += "&", t2 += "to_date=".concat(this.toDate)), this.usersCount && (t2 += "&", t2 += "users_count=".concat(this.usersCount)), this.minimumPredictions && (t2 += "&", t2 += "minimum_predictions=".concat(this.minimumPredictions)), t2;
    }
  }]);

  return br;
}();

var wr =
/*#__PURE__*/
function () {
  function wr(t2) {
    _classCallCheck3(this, wr);

    __publicField(this, "flags", null);

    __publicField(this, "status", null);

    __publicField(this, "type", null);

    __publicField(this, "activeFrom", null);

    __publicField(this, "activeTo", null);

    __publicField(this, "createdFrom", null);

    __publicField(this, "createdTo", null);

    __publicField(this, "updatedFrom", null);

    __publicField(this, "updatedTo", null);

    this.flags = t2.flags ? t2.flags : null, this.status = t2.status ? t2.status : null, this.type = t2.type ? t2.type : null, this.activeFrom = t2.activeFrom ? t2.activeFrom : null, this.activeTo = t2.activeTo ? t2.activeTo : null, this.createdFrom = t2.createdFrom ? t2.createdFrom : null, this.createdTo = t2.createdTo ? t2.createdTo : null, this.updatedFrom = t2.updatedFrom ? t2.updatedFrom : null, this.updatedTo = t2.updatedTo ? t2.updatedTo : null;
  }

  _createClass3(wr, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t2 = "";
      return this.flags && (t2 += "&", t2 += "flags=".concat(this.flags)), this.status && (t2 += "&", t2 += "status=".concat(this.status)), this.type && (t2 += "&", t2 += "type=".concat(this.type)), this.activeFrom && (t2 += "&", t2 += "active_from=".concat(this.activeFrom)), this.activeTo && (t2 += "&", t2 += "active_to=".concat(this.activeTo)), this.createdFrom && (t2 += "&", t2 += "created_from=".concat(this.createdFrom)), this.createdTo && (t2 += "&", t2 += "created_to=".concat(this.createdTo)), this.updatedFrom && (t2 += "&", t2 += "updated_from=".concat(this.updatedFrom)), this.updatedTo && (t2 += "&", t2 += "updated_to=".concat(this.updatedTo)), t2;
    }
  }]);

  return wr;
}();

var Ir = function Ir(t2, e2, i, a, r2) {
  var _this104 = this;

  _classCallCheck3(this, Ir);

  __publicField(this, "config", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "loyaltyHttps", null);

  __publicField(this, "loyaltyService", null);

  __publicField(this, "profileFacade", null);

  __publicField(this, "loyaltyValidator", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "topXFacade", null);

  __publicField(this, "matchQuizFacade", null);

  __publicField(this, "predictorHttps", null);

  __publicField(this, "errorHandlingMode", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee303() {
    return _regeneratorRuntime.wrap(function _callee303$(_context304) {
      while (1) {
        switch (_context304.prev = _context304.next) {
          case 0:
            _context304.next = 2;
            return _this104.clientHttps.getConfig("loyalty");

          case 2:
            return _context304.abrupt("return", _context304.sent);

          case 3:
          case "end":
            return _context304.stop();
        }
      }
    }, _callee303);
  })));

  __publicField(this, "getClientBadges",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee304() {
    var t2;
    return _regeneratorRuntime.wrap(function _callee304$(_context305) {
      while (1) {
        switch (_context305.prev = _context305.next) {
          case 0:
            _context305.next = 2;
            return _this104.getConfig();

          case 2:
            t2 = _context305.sent;
            return _context305.abrupt("return", _this104.loyaltyService.buildClientBadges(t2.rewards.badges));

          case 4:
          case "end":
            return _context305.stop();
        }
      }
    }, _callee304);
  })));

  __publicField(this, "getTemplates",
  /*#__PURE__*/
  function () {
    var _ref343 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee305(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee305$(_context306) {
        while (1) {
          switch (_context306.prev = _context306.next) {
            case 0:
              if (!(t2 && (t2 = new wr(t2)), _this104.config.idSchema === "native")) {
                _context306.next = 4;
                break;
              }

              _context306.next = 3;
              return _this104.loyaltyHttps.getTemplates(t2, e2);

            case 3:
              return _context306.abrupt("return", _context306.sent);

            case 4:
              _context306.next = 6;
              return _this104.loyaltyHttps.getTemplates(t2, e2);

            case 6:
              i = _context306.sent;
              _context306.next = 9;
              return _this104.loyaltyService.remapTemplatesIds(_toConsumableArray3(i.data));

            case 9:
              i.data = _context306.sent;
              return _context306.abrupt("return", i);

            case 11:
            case "end":
              return _context306.stop();
          }
        }
      }, _callee305);
    }));

    return function (_x480, _x481) {
      return _ref343.apply(this, arguments);
    };
  }());

  __publicField(this, "getTemplateById",
  /*#__PURE__*/
  function () {
    var _ref344 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee306(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee306$(_context307) {
        while (1) {
          switch (_context307.prev = _context307.next) {
            case 0:
              _context307.next = 2;
              return _this104.loyaltyHttps.getTemplateById(t2, e2);

            case 2:
              i = _context307.sent;

              if (!(_this104.config.idSchema === "native")) {
                _context307.next = 7;
                break;
              }

              _context307.t0 = i;
              _context307.next = 10;
              break;

            case 7:
              _context307.next = 9;
              return _this104.loyaltyService.remapTemplatesIds([i]);

            case 9:
              _context307.t0 = _context307.sent[0];

            case 10:
              return _context307.abrupt("return", _context307.t0);

            case 11:
            case "end":
              return _context307.stop();
          }
        }
      }, _callee306);
    }));

    return function (_x482, _x483) {
      return _ref344.apply(this, arguments);
    };
  }());

  __publicField(this, "getLeaderboard",
  /*#__PURE__*/
  function () {
    var _ref345 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee307(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee307$(_context308) {
        while (1) {
          switch (_context308.prev = _context308.next) {
            case 0:
              e2 = _this104.loyaltyService.initFilters(e2, "loyalty");
              _context308.next = 3;
              return _this104.loyaltyHttps.getLeaderboard(t2, i, e2);

            case 3:
              a = _context308.sent;
              _context308.next = 6;
              return _this104.loyaltyService.addProfileModelToLeaderboad(a.data);

            case 6:
              a.data = _context308.sent;
              return _context308.abrupt("return", a);

            case 8:
            case "end":
              return _context308.stop();
          }
        }
      }, _callee307);
    }));

    return function (_x484, _x485, _x486) {
      return _ref345.apply(this, arguments);
    };
  }());

  __publicField(this, "getLeaderboardForGame",
  /*#__PURE__*/
  function () {
    var _ref346 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee308(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee308$(_context309) {
        while (1) {
          switch (_context309.prev = _context309.next) {
            case 0:
              e2 = _this104.loyaltyService.initFilters(e2, "loyalty");
              _context309.next = 3;
              return _this104.loyaltyHttps.getLeaderboardForGame(t2, i, e2);

            case 3:
              a = _context309.sent;
              _context309.next = 6;
              return _this104.loyaltyService.addProfileModelToLeaderboad(a.data);

            case 6:
              a.data = _context309.sent;
              return _context309.abrupt("return", a);

            case 8:
            case "end":
              return _context309.stop();
          }
        }
      }, _callee308);
    }));

    return function (_x487, _x488, _x489) {
      return _ref346.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwnRankings",
  /*#__PURE__*/
  function () {
    var _ref347 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee309(t2, e2) {
      var _ref348, i;

      return _regeneratorRuntime.wrap(function _callee309$(_context310) {
        while (1) {
          switch (_context310.prev = _context310.next) {
            case 0:
              _context310.next = 2;
              return _this104.profileFacade.getOwn();

            case 2:
              _ref348 = _context310.sent;
              i = _ref348.id;
              return _context310.abrupt("return", _this104.getUserRankings(i, t2, e2));

            case 5:
            case "end":
              return _context310.stop();
          }
        }
      }, _callee309);
    }));

    return function (_x490, _x491) {
      return _ref347.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserRankings",
  /*#__PURE__*/
  function () {
    var _ref349 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee310(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee310$(_context311) {
        while (1) {
          switch (_context311.prev = _context311.next) {
            case 0:
              e2 = _this104.loyaltyService.initFilters(e2, "rankings");
              _context311.next = 3;
              return _this104.loyaltyHttps.getUserRankings(t2, e2, i);

            case 3:
              a = _context311.sent;
              _context311.next = 6;
              return _this104.getModelsForUserRankings(a);

            case 6:
              return _context311.abrupt("return", _context311.sent);

            case 7:
            case "end":
              return _context311.stop();
          }
        }
      }, _callee310);
    }));

    return function (_x492, _x493, _x494) {
      return _ref349.apply(this, arguments);
    };
  }());

  __publicField(this, "getHighestSuccessRate",
  /*#__PURE__*/
  function () {
    var _ref350 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee311(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee311$(_context312) {
        while (1) {
          switch (_context312.prev = _context312.next) {
            case 0:
              t2 && (t2 = new br(t2), _this104.loyaltyValidator.validate(t2, _this104.errorHandlingMode));
              _context312.next = 3;
              return _this104.loyaltyHttps.getHighestSuccessRate(t2, e2);

            case 3:
              i = _context312.sent;
              return _context312.abrupt("return", _this104.loyaltyService.addProfileModelToHighestSuccessRate(i));

            case 5:
            case "end":
              return _context312.stop();
          }
        }
      }, _callee311);
    }));

    return function (_x495, _x496) {
      return _ref350.apply(this, arguments);
    };
  }());

  __publicField(this, "getTemplateWinners",
  /*#__PURE__*/
  function () {
    var _ref351 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee312(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee312$(_context313) {
        while (1) {
          switch (_context313.prev = _context313.next) {
            case 0:
              _context313.next = 2;
              return _this104.predictorHttps.getContestWinners(t2, e2);

            case 2:
              i = _context313.sent;
              _context313.next = 5;
              return _this104.getTemplateById(t2);

            case 5:
              a = _context313.sent;
              return _context313.abrupt("return", (i.contestModel = a, _this104.loyaltyService.completeContestWinners(i)));

            case 7:
            case "end":
              return _context313.stop();
          }
        }
      }, _callee312);
    }));

    return function (_x497, _x498) {
      return _ref351.apply(this, arguments);
    };
  }());

  __publicField(this, "getEntitiesFollows",
  /*#__PURE__*/
  function () {
    var _ref352 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee313(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee313$(_context314) {
        while (1) {
          switch (_context314.prev = _context314.next) {
            case 0:
              _this104.loyaltyService.validateEntitiesFollowsFilters(t2);

              _context314.t0 = _this104.config.idSchema !== "native";

              if (!_context314.t0) {
                _context314.next = 6;
                break;
              }

              _context314.next = 5;
              return _this104.loyaltyService.remapEntitiesFollowsFilters(t2);

            case 5:
              t2 = _context314.sent;

            case 6:
              _context314.next = 8;
              return _this104.loyaltyHttps.getEntitiesFollows(t2, e2);

            case 8:
              i = _context314.sent;
              _context314.next = 11;
              return _this104.loyaltyService.addModelsToEntitiesFollows(i);

            case 11:
              return _context314.abrupt("return", _context314.sent);

            case 12:
            case "end":
              return _context314.stop();
          }
        }
      }, _callee313);
    }));

    return function (_x499, _x500) {
      return _ref352.apply(this, arguments);
    };
  }());

  __publicField(this, "getModelsForUserRankings",
  /*#__PURE__*/
  function () {
    var _ref353 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee314(t2) {
      var e2, i, a, _this104$loyaltyServi, _this104$loyaltyServi2, r2, s, p2, n2, _n4;

      return _regeneratorRuntime.wrap(function _callee314$(_context315) {
        while (1) {
          switch (_context315.prev = _context315.next) {
            case 0:
              e2 = null, i = null, a = null, _this104$loyaltyServi = _this104.loyaltyService.extractRankingsIdsMap(t2.data), _this104$loyaltyServi2 = _slicedToArray3(_this104$loyaltyServi, 3), r2 = _this104$loyaltyServi2[0], s = _this104$loyaltyServi2[1], p2 = _this104$loyaltyServi2[2];
              _context315.t0 = p2.length;

              if (!_context315.t0) {
                _context315.next = 7;
                break;
              }

              _context315.next = 5;
              return _this104.getTemplates();

            case 5:
              _context315.t1 = function (l2) {
                return p2.includes(l2.id);
              };

              e2 = _context315.sent.data.filter(_context315.t1);

            case 7:
              if (!r2.length) {
                _context315.next = 12;
                break;
              }

              n2 = {
                gameIds: r2
              };
              _context315.next = 11;
              return _this104.topXFacade.getGames(n2);

            case 11:
              i = _context315.sent.data;

            case 12:
              if (!s.length) {
                _context315.next = 17;
                break;
              }

              _n4 = {
                gameIds: s
              };
              _context315.next = 16;
              return _this104.matchQuizFacade.getGames(_n4);

            case 16:
              a = _context315.sent.data;

            case 17:
              return _context315.abrupt("return", _this104.loyaltyService.setModelsForUserRankings(i, a, e2, t2));

            case 18:
            case "end":
              return _context315.stop();
          }
        }
      }, _callee314);
    }));

    return function (_x501) {
      return _ref353.apply(this, arguments);
    };
  }());

  this.config = t2, this.clientHttps = e2, this.loyaltyHttps = i, this.profileFacade = new J(r2, a), this.loyaltyService = new yr(this.config), this.loyaltyValidator = new Mr(), this.idMapping = new F(t2), this.topXFacade = new fe(t2, this.idMapping), this.matchQuizFacade = new ye(t2), this.predictorHttps = new rt(t2, this.idMapping), this.errorHandlingMode = t2.errorHandlingMode;
};

var Me = function Me(t2) {
  var _this105 = this;

  _classCallCheck3(this, Me);

  __publicField(this, "clientHttps", null);

  __publicField(this, "profileHttps", null);

  __publicField(this, "loyaltyHttps", null);

  __publicField(this, "loyaltyFacade", null);

  __publicField(this, "localCache", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee315() {
    return _regeneratorRuntime.wrap(function _callee315$(_context316) {
      while (1) {
        switch (_context316.prev = _context316.next) {
          case 0:
            _context316.next = 2;
            return _this105.loyaltyFacade.getConfig();

          case 2:
            return _context316.abrupt("return", _context316.sent);

          case 3:
          case "end":
            return _context316.stop();
        }
      }
    }, _callee315);
  })));

  __publicField(this, "getClientBadges",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee316() {
    return _regeneratorRuntime.wrap(function _callee316$(_context317) {
      while (1) {
        switch (_context317.prev = _context317.next) {
          case 0:
            _context317.next = 2;
            return _this105.loyaltyFacade.getClientBadges();

          case 2:
            return _context317.abrupt("return", _context317.sent);

          case 3:
          case "end":
            return _context317.stop();
        }
      }
    }, _callee316);
  })));

  __publicField(this, "getTemplates",
  /*#__PURE__*/
  function () {
    var _ref356 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee317(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee317$(_context318) {
        while (1) {
          switch (_context318.prev = _context318.next) {
            case 0:
              _context318.next = 2;
              return _this105.loyaltyFacade.getTemplates(t2, e2);

            case 2:
              return _context318.abrupt("return", _context318.sent);

            case 3:
            case "end":
              return _context318.stop();
          }
        }
      }, _callee317);
    }));

    return function (_x502, _x503) {
      return _ref356.apply(this, arguments);
    };
  }());

  __publicField(this, "getTemplateById",
  /*#__PURE__*/
  function () {
    var _ref357 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee318(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee318$(_context319) {
        while (1) {
          switch (_context319.prev = _context319.next) {
            case 0:
              _context319.next = 2;
              return _this105.loyaltyFacade.getTemplateById(t2, e2);

            case 2:
              return _context319.abrupt("return", _context319.sent);

            case 3:
            case "end":
              return _context319.stop();
          }
        }
      }, _callee318);
    }));

    return function (_x504, _x505) {
      return _ref357.apply(this, arguments);
    };
  }());

  __publicField(this, "getLeaderboard",
  /*#__PURE__*/
  function () {
    var _ref358 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee319(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee319$(_context320) {
        while (1) {
          switch (_context320.prev = _context320.next) {
            case 0:
              _context320.next = 2;
              return _this105.loyaltyFacade.getLeaderboard(t2, e2, i);

            case 2:
              return _context320.abrupt("return", _context320.sent);

            case 3:
            case "end":
              return _context320.stop();
          }
        }
      }, _callee319);
    }));

    return function (_x506, _x507, _x508) {
      return _ref358.apply(this, arguments);
    };
  }());

  __publicField(this, "getLeaderboardForGame",
  /*#__PURE__*/
  function () {
    var _ref359 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee320(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee320$(_context321) {
        while (1) {
          switch (_context321.prev = _context321.next) {
            case 0:
              _context321.next = 2;
              return _this105.loyaltyFacade.getLeaderboardForGame(t2, e2, i);

            case 2:
              return _context321.abrupt("return", _context321.sent);

            case 3:
            case "end":
              return _context321.stop();
          }
        }
      }, _callee320);
    }));

    return function (_x509, _x510, _x511) {
      return _ref359.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwnRankings",
  /*#__PURE__*/
  function () {
    var _ref360 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee321(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee321$(_context322) {
        while (1) {
          switch (_context322.prev = _context322.next) {
            case 0:
              _context322.next = 2;
              return _this105.loyaltyFacade.getOwnRankings(t2, e2);

            case 2:
              return _context322.abrupt("return", _context322.sent);

            case 3:
            case "end":
              return _context322.stop();
          }
        }
      }, _callee321);
    }));

    return function (_x512, _x513) {
      return _ref360.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserRankings",
  /*#__PURE__*/
  function () {
    var _ref361 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee322(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee322$(_context323) {
        while (1) {
          switch (_context323.prev = _context323.next) {
            case 0:
              _context323.next = 2;
              return _this105.loyaltyFacade.getUserRankings(t2, e2, i);

            case 2:
              return _context323.abrupt("return", _context323.sent);

            case 3:
            case "end":
              return _context323.stop();
          }
        }
      }, _callee322);
    }));

    return function (_x514, _x515, _x516) {
      return _ref361.apply(this, arguments);
    };
  }());

  __publicField(this, "getHighestSuccessRate",
  /*#__PURE__*/
  function () {
    var _ref362 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee323(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee323$(_context324) {
        while (1) {
          switch (_context324.prev = _context324.next) {
            case 0:
              _context324.next = 2;
              return _this105.loyaltyFacade.getHighestSuccessRate(t2, e2);

            case 2:
              return _context324.abrupt("return", _context324.sent);

            case 3:
            case "end":
              return _context324.stop();
          }
        }
      }, _callee323);
    }));

    return function (_x517, _x518) {
      return _ref362.apply(this, arguments);
    };
  }());

  __publicField(this, "getTemplateWinners",
  /*#__PURE__*/
  function () {
    var _ref363 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee324(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee324$(_context325) {
        while (1) {
          switch (_context325.prev = _context325.next) {
            case 0:
              _context325.next = 2;
              return _this105.loyaltyFacade.getTemplateWinners(t2, e2);

            case 2:
              return _context325.abrupt("return", _context325.sent);

            case 3:
            case "end":
              return _context325.stop();
          }
        }
      }, _callee324);
    }));

    return function (_x519, _x520) {
      return _ref363.apply(this, arguments);
    };
  }());

  __publicField(this, "getEntitiesFollows",
  /*#__PURE__*/
  function () {
    var _ref364 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee325(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee325$(_context326) {
        while (1) {
          switch (_context326.prev = _context326.next) {
            case 0:
              _context326.next = 2;
              return _this105.loyaltyFacade.getEntitiesFollows(t2, e2);

            case 2:
              return _context326.abrupt("return", _context326.sent);

            case 3:
            case "end":
              return _context326.stop();
          }
        }
      }, _callee325);
    }));

    return function (_x521, _x522) {
      return _ref364.apply(this, arguments);
    };
  }());

  this.clientHttps = new x$1(t2), this.profileHttps = new Ot(t2), this.loyaltyHttps = new Mt(t2), this.localCache = new V().createLocalCacheInstance(t2.idSchema), this.loyaltyFacade = new Ir(t2, this.clientHttps, this.loyaltyHttps, this.profileHttps, this.localCache);
};

var Pr = function Pr(t2) {
  var _this106 = this;

  _classCallCheck3(this, Pr);

  __publicField(this, "topXFacade", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee326() {
    return _regeneratorRuntime.wrap(function _callee326$(_context327) {
      while (1) {
        switch (_context327.prev = _context327.next) {
          case 0:
            _context327.next = 2;
            return _this106.topXFacade.getConfig();

          case 2:
            return _context327.abrupt("return", _context327.sent);

          case 3:
          case "end":
            return _context327.stop();
        }
      }
    }, _callee326);
  })));

  __publicField(this, "getGames",
  /*#__PURE__*/
  function () {
    var _ref366 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee327(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee327$(_context328) {
        while (1) {
          switch (_context328.prev = _context328.next) {
            case 0:
              _context328.next = 2;
              return _this106.topXFacade.getGames(t2, e2);

            case 2:
              return _context328.abrupt("return", _context328.sent);

            case 3:
            case "end":
              return _context328.stop();
          }
        }
      }, _callee327);
    }));

    return function (_x523, _x524) {
      return _ref366.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameById",
  /*#__PURE__*/
  function () {
    var _ref367 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee328(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee328$(_context329) {
        while (1) {
          switch (_context329.prev = _context329.next) {
            case 0:
              _context329.next = 2;
              return _this106.topXFacade.getGameById(t2, e2);

            case 2:
              return _context329.abrupt("return", _context329.sent);

            case 3:
            case "end":
              return _context329.stop();
          }
        }
      }, _callee328);
    }));

    return function (_x525, _x526) {
      return _ref367.apply(this, arguments);
    };
  }());

  __publicField(this, "getGamePredictions",
  /*#__PURE__*/
  function () {
    var _ref368 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee329(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee329$(_context330) {
        while (1) {
          switch (_context330.prev = _context330.next) {
            case 0:
              _context330.next = 2;
              return _this106.topXFacade.getGamePredictions(t2, e2, i);

            case 2:
              return _context330.abrupt("return", _context330.sent);

            case 3:
            case "end":
              return _context330.stop();
          }
        }
      }, _callee329);
    }));

    return function (_x527, _x528, _x529) {
      return _ref368.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameResults",
  /*#__PURE__*/
  function () {
    var _ref369 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee330(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee330$(_context331) {
        while (1) {
          switch (_context331.prev = _context331.next) {
            case 0:
              _context331.next = 2;
              return _this106.topXFacade.getGameResults(t2, e2, i);

            case 2:
              return _context331.abrupt("return", _context331.sent);

            case 3:
            case "end":
              return _context331.stop();
          }
        }
      }, _callee330);
    }));

    return function (_x530, _x531, _x532) {
      return _ref369.apply(this, arguments);
    };
  }());

  __publicField(this, "getCurrentGameResults",
  /*#__PURE__*/
  function () {
    var _ref370 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee331(t2) {
      return _regeneratorRuntime.wrap(function _callee331$(_context332) {
        while (1) {
          switch (_context332.prev = _context332.next) {
            case 0:
              _context332.next = 2;
              return _this106.topXFacade.getCurrentGameResults(t2);

            case 2:
              return _context332.abrupt("return", _context332.sent);

            case 3:
            case "end":
              return _context332.stop();
          }
        }
      }, _callee331);
    }));

    return function (_x533) {
      return _ref370.apply(this, arguments);
    };
  }());

  __publicField(this, "play",
  /*#__PURE__*/
  function () {
    var _ref371 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee332(t2) {
      return _regeneratorRuntime.wrap(function _callee332$(_context333) {
        while (1) {
          switch (_context333.prev = _context333.next) {
            case 0:
              _context333.next = 2;
              return _this106.topXFacade.play(t2);

            case 2:
              return _context333.abrupt("return", _context333.sent);

            case 3:
            case "end":
              return _context333.stop();
          }
        }
      }, _callee332);
    }));

    return function (_x534) {
      return _ref371.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref372 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee333(t2) {
      return _regeneratorRuntime.wrap(function _callee333$(_context334) {
        while (1) {
          switch (_context334.prev = _context334.next) {
            case 0:
              _context334.next = 2;
              return _this106.topXFacade.delete(t2);

            case 2:
              return _context334.abrupt("return", _context334.sent);

            case 3:
            case "end":
              return _context334.stop();
          }
        }
      }, _callee333);
    }));

    return function (_x535) {
      return _ref372.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGameEditions",
  /*#__PURE__*/
  function () {
    var _ref373 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee334(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee334$(_context335) {
        while (1) {
          switch (_context335.prev = _context335.next) {
            case 0:
              _context335.next = 2;
              return _this106.topXFacade.getMyGameEditions(t2, e2);

            case 2:
              return _context335.abrupt("return", _context335.sent);

            case 3:
            case "end":
              return _context335.stop();
          }
        }
      }, _callee334);
    }));

    return function (_x536, _x537) {
      return _ref373.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref374 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee335(t2) {
      return _regeneratorRuntime.wrap(function _callee335$(_context336) {
        while (1) {
          switch (_context336.prev = _context336.next) {
            case 0:
              _context336.next = 2;
              return _this106.topXFacade.getMyGamePrediction(t2);

            case 2:
              return _context336.abrupt("return", _context336.sent);

            case 3:
            case "end":
              return _context336.stop();
          }
        }
      }, _callee335);
    }));

    return function (_x538) {
      return _ref374.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGameEditions",
  /*#__PURE__*/
  function () {
    var _ref375 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee336(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee336$(_context337) {
        while (1) {
          switch (_context337.prev = _context337.next) {
            case 0:
              _context337.next = 2;
              return _this106.topXFacade.getUserGameEditions(t2, e2, i);

            case 2:
              return _context337.abrupt("return", _context337.sent);

            case 3:
            case "end":
              return _context337.stop();
          }
        }
      }, _callee336);
    }));

    return function (_x539, _x540, _x541) {
      return _ref375.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref376 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee337(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee337$(_context338) {
        while (1) {
          switch (_context338.prev = _context338.next) {
            case 0:
              _context338.next = 2;
              return _this106.topXFacade.getUserGamePrediction(t2, e2, i);

            case 2:
              return _context338.abrupt("return", _context338.sent);

            case 3:
            case "end":
              return _context338.stop();
          }
        }
      }, _callee337);
    }));

    return function (_x542, _x543, _x544) {
      return _ref376.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketsResultsForGame",
  /*#__PURE__*/
  function () {
    var _ref377 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee338(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee338$(_context339) {
        while (1) {
          switch (_context339.prev = _context339.next) {
            case 0:
              _context339.next = 2;
              return _this106.topXFacade.getMarketsResultsForGame(t2, e2);

            case 2:
              return _context339.abrupt("return", _context339.sent);

            case 3:
            case "end":
              return _context339.stop();
          }
        }
      }, _callee338);
    }));

    return function (_x545, _x546) {
      return _ref377.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameWinners",
  /*#__PURE__*/
  function () {
    var _ref378 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee339(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee339$(_context340) {
        while (1) {
          switch (_context340.prev = _context340.next) {
            case 0:
              _context340.next = 2;
              return _this106.topXFacade.getGameWinners(t2, e2);

            case 2:
              return _context340.abrupt("return", _context340.sent);

            case 3:
            case "end":
              return _context340.stop();
          }
        }
      }, _callee339);
    }));

    return function (_x547, _x548) {
      return _ref378.apply(this, arguments);
    };
  }());

  this.idMapping = new F(t2), this.topXFacade = new fe(t2, this.idMapping);
};

var vr = function vr(t2) {
  var _this107 = this;

  _classCallCheck3(this, vr);

  __publicField(this, "matchQuizFacade", null);

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee340() {
    return _regeneratorRuntime.wrap(function _callee340$(_context341) {
      while (1) {
        switch (_context341.prev = _context341.next) {
          case 0:
            _context341.next = 2;
            return _this107.matchQuizFacade.getConfig();

          case 2:
            return _context341.abrupt("return", _context341.sent);

          case 3:
          case "end":
            return _context341.stop();
        }
      }
    }, _callee340);
  })));

  __publicField(this, "play",
  /*#__PURE__*/
  function () {
    var _ref380 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee341(t2) {
      return _regeneratorRuntime.wrap(function _callee341$(_context342) {
        while (1) {
          switch (_context342.prev = _context342.next) {
            case 0:
              _context342.next = 2;
              return _this107.matchQuizFacade.play(t2);

            case 2:
              return _context342.abrupt("return", _context342.sent);

            case 3:
            case "end":
              return _context342.stop();
          }
        }
      }, _callee341);
    }));

    return function (_x549) {
      return _ref380.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref381 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee342(t2) {
      return _regeneratorRuntime.wrap(function _callee342$(_context343) {
        while (1) {
          switch (_context343.prev = _context343.next) {
            case 0:
              _context343.next = 2;
              return _this107.matchQuizFacade.delete(t2);

            case 2:
              return _context343.abrupt("return", _context343.sent);

            case 3:
            case "end":
              return _context343.stop();
          }
        }
      }, _callee342);
    }));

    return function (_x550) {
      return _ref381.apply(this, arguments);
    };
  }());

  __publicField(this, "getGames",
  /*#__PURE__*/
  function () {
    var _ref382 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee343(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee343$(_context344) {
        while (1) {
          switch (_context344.prev = _context344.next) {
            case 0:
              _context344.next = 2;
              return _this107.matchQuizFacade.getGames(t2, e2);

            case 2:
              return _context344.abrupt("return", _context344.sent);

            case 3:
            case "end":
              return _context344.stop();
          }
        }
      }, _callee343);
    }));

    return function (_x551, _x552) {
      return _ref382.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameById",
  /*#__PURE__*/
  function () {
    var _ref383 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee344(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee344$(_context345) {
        while (1) {
          switch (_context345.prev = _context345.next) {
            case 0:
              _context345.next = 2;
              return _this107.matchQuizFacade.getGameById(t2, e2);

            case 2:
              return _context345.abrupt("return", _context345.sent);

            case 3:
            case "end":
              return _context345.stop();
          }
        }
      }, _callee344);
    }));

    return function (_x553, _x554) {
      return _ref383.apply(this, arguments);
    };
  }());

  __publicField(this, "getGamePredictions",
  /*#__PURE__*/
  function () {
    var _ref384 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee345(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee345$(_context346) {
        while (1) {
          switch (_context346.prev = _context346.next) {
            case 0:
              _context346.next = 2;
              return _this107.matchQuizFacade.getGamePredictions(t2, e2, i);

            case 2:
              return _context346.abrupt("return", _context346.sent);

            case 3:
            case "end":
              return _context346.stop();
          }
        }
      }, _callee345);
    }));

    return function (_x555, _x556, _x557) {
      return _ref384.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameResults",
  /*#__PURE__*/
  function () {
    var _ref385 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee346(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee346$(_context347) {
        while (1) {
          switch (_context347.prev = _context347.next) {
            case 0:
              _context347.next = 2;
              return _this107.matchQuizFacade.getGameResults(t2, e2, i);

            case 2:
              return _context347.abrupt("return", _context347.sent);

            case 3:
            case "end":
              return _context347.stop();
          }
        }
      }, _callee346);
    }));

    return function (_x558, _x559, _x560) {
      return _ref385.apply(this, arguments);
    };
  }());

  __publicField(this, "getCurrentGameResults",
  /*#__PURE__*/
  function () {
    var _ref386 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee347(t2) {
      return _regeneratorRuntime.wrap(function _callee347$(_context348) {
        while (1) {
          switch (_context348.prev = _context348.next) {
            case 0:
              _context348.next = 2;
              return _this107.matchQuizFacade.getCurrentGameResults(t2);

            case 2:
              return _context348.abrupt("return", _context348.sent);

            case 3:
            case "end":
              return _context348.stop();
          }
        }
      }, _callee347);
    }));

    return function (_x561) {
      return _ref386.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGameEditions",
  /*#__PURE__*/
  function () {
    var _ref387 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee348(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee348$(_context349) {
        while (1) {
          switch (_context349.prev = _context349.next) {
            case 0:
              _context349.next = 2;
              return _this107.matchQuizFacade.getMyGameEditions(t2, e2);

            case 2:
              return _context349.abrupt("return", _context349.sent);

            case 3:
            case "end":
              return _context349.stop();
          }
        }
      }, _callee348);
    }));

    return function (_x562, _x563) {
      return _ref387.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref388 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee349(t2) {
      return _regeneratorRuntime.wrap(function _callee349$(_context350) {
        while (1) {
          switch (_context350.prev = _context350.next) {
            case 0:
              _context350.next = 2;
              return _this107.matchQuizFacade.getMyGamePrediction(t2);

            case 2:
              return _context350.abrupt("return", _context350.sent);

            case 3:
            case "end":
              return _context350.stop();
          }
        }
      }, _callee349);
    }));

    return function (_x564) {
      return _ref388.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGameEditions",
  /*#__PURE__*/
  function () {
    var _ref389 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee350(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee350$(_context351) {
        while (1) {
          switch (_context351.prev = _context351.next) {
            case 0:
              _context351.next = 2;
              return _this107.matchQuizFacade.getUserGameEditions(t2, e2, i);

            case 2:
              return _context351.abrupt("return", _context351.sent);

            case 3:
            case "end":
              return _context351.stop();
          }
        }
      }, _callee350);
    }));

    return function (_x565, _x566, _x567) {
      return _ref389.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserGamePrediction",
  /*#__PURE__*/
  function () {
    var _ref390 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee351(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee351$(_context352) {
        while (1) {
          switch (_context352.prev = _context352.next) {
            case 0:
              _context352.next = 2;
              return _this107.matchQuizFacade.getUserGamePrediction(t2, e2, i);

            case 2:
              return _context352.abrupt("return", _context352.sent);

            case 3:
            case "end":
              return _context352.stop();
          }
        }
      }, _callee351);
    }));

    return function (_x568, _x569, _x570) {
      return _ref390.apply(this, arguments);
    };
  }());

  __publicField(this, "getMarketsResultsForGame",
  /*#__PURE__*/
  function () {
    var _ref391 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee352(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee352$(_context353) {
        while (1) {
          switch (_context353.prev = _context353.next) {
            case 0:
              _context353.next = 2;
              return _this107.matchQuizFacade.getMarketsResultsForGame(t2, e2);

            case 2:
              return _context353.abrupt("return", _context353.sent);

            case 3:
            case "end":
              return _context353.stop();
          }
        }
      }, _callee352);
    }));

    return function (_x571, _x572) {
      return _ref391.apply(this, arguments);
    };
  }());

  __publicField(this, "getGameWinners",
  /*#__PURE__*/
  function () {
    var _ref392 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee353(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee353$(_context354) {
        while (1) {
          switch (_context354.prev = _context354.next) {
            case 0:
              _context354.next = 2;
              return _this107.matchQuizFacade.getGameWinners(t2, e2);

            case 2:
              return _context354.abrupt("return", _context354.sent);

            case 3:
            case "end":
              return _context354.stop();
          }
        }
      }, _callee353);
    }));

    return function (_x573, _x574) {
      return _ref392.apply(this, arguments);
    };
  }());

  this.matchQuizFacade = new ye(t2);
};

var We = function We(t2, e2, i, a) {
  _classCallCheck3(this, We);

  __publicField(this, "action", null);

  __publicField(this, "context", new Yt());

  this.action = t2, this.context.tags = e2, i && (this.context.content = i), a && (this.context.campaign = a);
};

var be = function be(t2) {
  var _this108 = this;

  _classCallCheck3(this, be);

  __publicField(this, "idSchema");

  __publicField(this, "idMapping");

  __publicField(this, "remapTagsIds",
  /*#__PURE__*/
  function () {
    var _ref393 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee354(t2, e2, i) {
      var a, r2, s, p2, _loop9, _i55, _Object$entries7, _ref395;

      return _regeneratorRuntime.wrap(function _callee354$(_context355) {
        while (1) {
          switch (_context355.prev = _context355.next) {
            case 0:
              if (!(!t2 || !t2.length)) {
                _context355.next = 2;
                break;
              }

              return _context355.abrupt("return", t2);

            case 2:
              a = {}, r2 = {}, s = [];
              t2.forEach(function (n2) {
                a.hasOwnProperty(n2.type) || (a[n2.type] = [], r2[n2.type] = []), a[n2.type].push(n2.id), r2[n2.type].push(n2);
              });
              _context355.next = 6;
              return _this108.idMapping.idMappingFacade.getEntitiesByIds(a, e2, i);

            case 6:
              p2 = _context355.sent;

              _loop9 = function _loop9() {
                var _ref394 = _Object$entries7[_i55];
                _ref395 = _slicedToArray3(_ref394, 2);
                var n2 = _ref395[0];
                var l2 = _ref395[1];
                l2.forEach(function (c2, d2) {
                  c2.id = p2[n2][d2], s.push(c2);
                });
              };

              for (_i55 = 0, _Object$entries7 = Object.entries(r2); _i55 < _Object$entries7.length; _i55++) {
                _loop9();
              }

              return _context355.abrupt("return", s);

            case 10:
            case "end":
              return _context355.stop();
          }
        }
      }, _callee354);
    }));

    return function (_x575, _x576, _x577) {
      return _ref393.apply(this, arguments);
    };
  }());

  this.idSchema = t2.idSchema, this.idMapping = new F(t2);
};

var we = function we(t2) {
  _classCallCheck3(this, we);

  __publicField(this, "page", null);

  __publicField(this, "limit", null);

  this.page = t2.page ? t2.page : null, this.limit = t2.limit ? t2.limit : null;
};

var Tr =
/*#__PURE__*/
function (_we) {
  _inherits3(Tr, _we);

  function Tr(t2) {
    var _this109;

    _classCallCheck3(this, Tr);

    _this109 = _possibleConstructorReturn3(this, _getPrototypeOf4(Tr).call(this, t2));

    __publicField(_assertThisInitialized3(_this109), "action", null);

    _this109.action = t2.action ? t2.action : null;
    return _this109;
  }

  _createClass3(Tr, [{
    key: "constructFilterUrl",
    value: function constructFilterUrl() {
      var t2 = "";
      return this.action && (t2 += "&", t2 += "action=".concat(this.action)), this.page && (t2 += "&", t2 += "page=".concat(this.page)), this.limit && (t2 += "&", t2 += "limit=".concat(this.limit)), t2;
    }
  }]);

  return Tr;
}(we);

var _r =
/*#__PURE__*/
function (_we2) {
  _inherits3(_r, _we2);

  function _r(t2) {
    var _this110;

    _classCallCheck3(this, _r);

    _this110 = _possibleConstructorReturn3(this, _getPrototypeOf4(_r).call(this, t2));

    __publicField(_assertThisInitialized3(_this110), "action", null);

    _this110.action = t2.action ? t2.action : null;
    return _this110;
  }

  _createClass3(_r, [{
    key: "constructFilterUrl",
    value: function constructFilterUrl() {
      var t2 = "";
      return this.action && (t2 += "&", t2 += "action=".concat(this.action)), this.page && (t2 += "&", t2 += "page=".concat(this.page)), this.limit && (t2 += "&", t2 += "limit=".concat(this.limit)), t2;
    }
  }]);

  return _r;
}(we);

var Fr = function Fr(t2) {
  var _this111 = this;

  _classCallCheck3(this, Fr);

  __publicField(this, "idSchema");

  __publicField(this, "activityHttps");

  __publicField(this, "activityService");

  __publicField(this, "add",
  /*#__PURE__*/
  function () {
    var _ref396 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee355(t2, e2, i, a) {
      var _s22, _p16, n2, l2, r2;

      return _regeneratorRuntime.wrap(function _callee355$(_context356) {
        while (1) {
          switch (_context356.prev = _context356.next) {
            case 0:
              if (!(_this111.idSchema != "native")) {
                _context356.next = 10;
                break;
              }

              _s22 = JSON.parse(JSON.stringify(e2));
              _context356.next = 4;
              return _this111.activityService.remapTagsIds(e2, _this111.idSchema, "native");

            case 4:
              _p16 = _context356.sent;
              n2 = new We(t2, _p16, i, a);
              _context356.next = 8;
              return _this111.activityHttps.createActivity(n2);

            case 8:
              l2 = _context356.sent;
              return _context356.abrupt("return", (l2.context.tags = _s22, l2));

            case 10:
              r2 = new We(t2, e2, i, a);
              return _context356.abrupt("return", _this111.activityHttps.createActivity(r2));

            case 12:
            case "end":
              return _context356.stop();
          }
        }
      }, _callee355);
    }));

    return function (_x578, _x579, _x580, _x581) {
      return _ref396.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref397 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee356(t2) {
      return _regeneratorRuntime.wrap(function _callee356$(_context357) {
        while (1) {
          switch (_context357.prev = _context357.next) {
            case 0:
              _context357.next = 2;
              return _this111.activityHttps.deleteActivity(t2);

            case 2:
              return _context357.abrupt("return", _context357.sent);

            case 3:
            case "end":
              return _context357.stop();
          }
        }
      }, _callee356);
    }));

    return function (_x582) {
      return _ref397.apply(this, arguments);
    };
  }());

  __publicField(this, "like",
  /*#__PURE__*/
  function () {
    var _ref398 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee357(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee357$(_context358) {
        while (1) {
          switch (_context358.prev = _context358.next) {
            case 0:
              a = "like";
              _context358.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context358.abrupt("return", _context358.sent);

            case 4:
            case "end":
              return _context358.stop();
          }
        }
      }, _callee357);
    }));

    return function (_x583, _x584, _x585) {
      return _ref398.apply(this, arguments);
    };
  }());

  __publicField(this, "dislike",
  /*#__PURE__*/
  function () {
    var _ref399 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee358(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee358$(_context359) {
        while (1) {
          switch (_context359.prev = _context359.next) {
            case 0:
              a = "dislike";
              _context359.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context359.abrupt("return", _context359.sent);

            case 4:
            case "end":
              return _context359.stop();
          }
        }
      }, _callee358);
    }));

    return function (_x586, _x587, _x588) {
      return _ref399.apply(this, arguments);
    };
  }());

  __publicField(this, "addPageview",
  /*#__PURE__*/
  function () {
    var _ref400 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee359(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee359$(_context360) {
        while (1) {
          switch (_context360.prev = _context360.next) {
            case 0:
              a = "page_view";
              _context360.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context360.abrupt("return", _context360.sent);

            case 4:
            case "end":
              return _context360.stop();
          }
        }
      }, _callee359);
    }));

    return function (_x589, _x590, _x591) {
      return _ref400.apply(this, arguments);
    };
  }());

  __publicField(this, "addContentConsumed",
  /*#__PURE__*/
  function () {
    var _ref401 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee360(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee360$(_context361) {
        while (1) {
          switch (_context361.prev = _context361.next) {
            case 0:
              a = "content_consumed";
              _context361.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context361.abrupt("return", _context361.sent);

            case 4:
            case "end":
              return _context361.stop();
          }
        }
      }, _callee360);
    }));

    return function (_x592, _x593, _x594) {
      return _ref401.apply(this, arguments);
    };
  }());

  __publicField(this, "addShare",
  /*#__PURE__*/
  function () {
    var _ref402 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee361(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee361$(_context362) {
        while (1) {
          switch (_context362.prev = _context362.next) {
            case 0:
              a = "share";
              _context362.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context362.abrupt("return", _context362.sent);

            case 4:
            case "end":
              return _context362.stop();
          }
        }
      }, _callee361);
    }));

    return function (_x595, _x596, _x597) {
      return _ref402.apply(this, arguments);
    };
  }());

  __publicField(this, "addComment",
  /*#__PURE__*/
  function () {
    var _ref403 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee362(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee362$(_context363) {
        while (1) {
          switch (_context363.prev = _context363.next) {
            case 0:
              a = "comment";
              _context363.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context363.abrupt("return", _context363.sent);

            case 4:
            case "end":
              return _context363.stop();
          }
        }
      }, _callee362);
    }));

    return function (_x598, _x599, _x600) {
      return _ref403.apply(this, arguments);
    };
  }());

  __publicField(this, "addClickAd",
  /*#__PURE__*/
  function () {
    var _ref404 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee363(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee363$(_context364) {
        while (1) {
          switch (_context364.prev = _context364.next) {
            case 0:
              a = "click_ad";
              _context364.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context364.abrupt("return", _context364.sent);

            case 4:
            case "end":
              return _context364.stop();
          }
        }
      }, _callee363);
    }));

    return function (_x601, _x602, _x603) {
      return _ref404.apply(this, arguments);
    };
  }());

  __publicField(this, "addConversion",
  /*#__PURE__*/
  function () {
    var _ref405 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee364(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee364$(_context365) {
        while (1) {
          switch (_context365.prev = _context365.next) {
            case 0:
              a = "conversion";
              _context365.next = 3;
              return _this111.add(a, t2, e2, i);

            case 3:
              return _context365.abrupt("return", _context365.sent);

            case 4:
            case "end":
              return _context365.stop();
          }
        }
      }, _callee364);
    }));

    return function (_x604, _x605, _x606) {
      return _ref405.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwn",
  /*#__PURE__*/
  function () {
    var _ref406 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee365(t2, e2) {
      var _i56, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, a;

      return _regeneratorRuntime.wrap(function _callee365$(_context366) {
        while (1) {
          switch (_context366.prev = _context366.next) {
            case 0:
              if (!(e2 = e2 || false, t2 && (t2 = new Tr(t2)), _this111.idSchema != "native")) {
                _context366.next = 31;
                break;
              }

              _context366.next = 3;
              return _this111.activityHttps.getOwnActivities(t2, e2);

            case 3:
              _i56 = _context366.sent;
              _iteratorNormalCompletion18 = true;
              _didIteratorError18 = false;
              _iteratorError18 = undefined;
              _context366.prev = 7;
              _iterator18 = _i56.data[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
                _context366.next = 16;
                break;
              }

              a = _step18.value;
              _context366.next = 13;
              return _this111.activityService.remapTagsIds(a.context.tags, "native", _this111.idSchema);

            case 13:
              _iteratorNormalCompletion18 = true;
              _context366.next = 9;
              break;

            case 16:
              _context366.next = 22;
              break;

            case 18:
              _context366.prev = 18;
              _context366.t0 = _context366["catch"](7);
              _didIteratorError18 = true;
              _iteratorError18 = _context366.t0;

            case 22:
              _context366.prev = 22;
              _context366.prev = 23;

              if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                _iterator18.return();
              }

            case 25:
              _context366.prev = 25;

              if (!_didIteratorError18) {
                _context366.next = 28;
                break;
              }

              throw _iteratorError18;

            case 28:
              return _context366.finish(25);

            case 29:
              return _context366.finish(22);

            case 30:
              return _context366.abrupt("return", _i56);

            case 31:
              _context366.next = 33;
              return _this111.activityHttps.getOwnActivities(t2, e2);

            case 33:
              return _context366.abrupt("return", _context366.sent);

            case 34:
            case "end":
              return _context366.stop();
          }
        }
      }, _callee365, null, [[7, 18, 22, 30], [23,, 25, 29]]);
    }));

    return function (_x607, _x608) {
      return _ref406.apply(this, arguments);
    };
  }());

  __publicField(this, "getForUser",
  /*#__PURE__*/
  function () {
    var _ref407 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee366(t2, e2, i) {
      var a, r2, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _s23;

      return _regeneratorRuntime.wrap(function _callee366$(_context367) {
        while (1) {
          switch (_context367.prev = _context367.next) {
            case 0:
              if (!(i = i || false, e2 && (e2 = new _r(e2)), _this111.idSchema != "native")) {
                _context367.next = 32;
                break;
              }

              _context367.next = 3;
              return _this111.activityHttps.getActivitiesForUser(t2, e2, i);

            case 3:
              a = _context367.sent;
              r2 = JSON.parse(JSON.stringify(a));
              _iteratorNormalCompletion19 = true;
              _didIteratorError19 = false;
              _iteratorError19 = undefined;
              _context367.prev = 8;
              _iterator19 = r2.data[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
                _context367.next = 17;
                break;
              }

              _s23 = _step19.value;
              _context367.next = 14;
              return _this111.activityService.remapTagsIds(_toConsumableArray3(_s23.context.tags), "native", _this111.idSchema);

            case 14:
              _iteratorNormalCompletion19 = true;
              _context367.next = 10;
              break;

            case 17:
              _context367.next = 23;
              break;

            case 19:
              _context367.prev = 19;
              _context367.t0 = _context367["catch"](8);
              _didIteratorError19 = true;
              _iteratorError19 = _context367.t0;

            case 23:
              _context367.prev = 23;
              _context367.prev = 24;

              if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                _iterator19.return();
              }

            case 26:
              _context367.prev = 26;

              if (!_didIteratorError19) {
                _context367.next = 29;
                break;
              }

              throw _iteratorError19;

            case 29:
              return _context367.finish(26);

            case 30:
              return _context367.finish(23);

            case 31:
              return _context367.abrupt("return", r2);

            case 32:
              _context367.next = 34;
              return _this111.activityHttps.getActivitiesForUser(t2, e2, i);

            case 34:
              return _context367.abrupt("return", _context367.sent);

            case 35:
            case "end":
              return _context367.stop();
          }
        }
      }, _callee366, null, [[8, 19, 23, 31], [24,, 26, 30]]);
    }));

    return function (_x609, _x610, _x611) {
      return _ref407.apply(this, arguments);
    };
  }());

  this.idSchema = t2.idSchema, this.activityHttps = new Zt(t2), this.activityService = new be(t2);
};

var Er = function Er(t2) {
  var _this112 = this;

  _classCallCheck3(this, Er);

  __publicField(this, "activityFacade");

  __publicField(this, "add",
  /*#__PURE__*/
  function () {
    var _ref408 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee367(t2, e2, i, a) {
      return _regeneratorRuntime.wrap(function _callee367$(_context368) {
        while (1) {
          switch (_context368.prev = _context368.next) {
            case 0:
              _context368.next = 2;
              return _this112.activityFacade.add(t2, e2, i, a);

            case 2:
              return _context368.abrupt("return", _context368.sent);

            case 3:
            case "end":
              return _context368.stop();
          }
        }
      }, _callee367);
    }));

    return function (_x612, _x613, _x614, _x615) {
      return _ref408.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref409 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee368(t2) {
      return _regeneratorRuntime.wrap(function _callee368$(_context369) {
        while (1) {
          switch (_context369.prev = _context369.next) {
            case 0:
              _context369.next = 2;
              return _this112.activityFacade.delete(t2);

            case 2:
              return _context369.abrupt("return", _context369.sent);

            case 3:
            case "end":
              return _context369.stop();
          }
        }
      }, _callee368);
    }));

    return function (_x616) {
      return _ref409.apply(this, arguments);
    };
  }());

  __publicField(this, "like",
  /*#__PURE__*/
  function () {
    var _ref410 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee369(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee369$(_context370) {
        while (1) {
          switch (_context370.prev = _context370.next) {
            case 0:
              _context370.next = 2;
              return _this112.activityFacade.like(t2, e2, i);

            case 2:
              return _context370.abrupt("return", _context370.sent);

            case 3:
            case "end":
              return _context370.stop();
          }
        }
      }, _callee369);
    }));

    return function (_x617, _x618, _x619) {
      return _ref410.apply(this, arguments);
    };
  }());

  __publicField(this, "dislike",
  /*#__PURE__*/
  function () {
    var _ref411 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee370(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee370$(_context371) {
        while (1) {
          switch (_context371.prev = _context371.next) {
            case 0:
              _context371.next = 2;
              return _this112.activityFacade.dislike(t2, e2, i);

            case 2:
              return _context371.abrupt("return", _context371.sent);

            case 3:
            case "end":
              return _context371.stop();
          }
        }
      }, _callee370);
    }));

    return function (_x620, _x621, _x622) {
      return _ref411.apply(this, arguments);
    };
  }());

  __publicField(this, "addPageview",
  /*#__PURE__*/
  function () {
    var _ref412 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee371(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee371$(_context372) {
        while (1) {
          switch (_context372.prev = _context372.next) {
            case 0:
              _context372.next = 2;
              return _this112.activityFacade.addPageview(t2, e2, i);

            case 2:
              return _context372.abrupt("return", _context372.sent);

            case 3:
            case "end":
              return _context372.stop();
          }
        }
      }, _callee371);
    }));

    return function (_x623, _x624, _x625) {
      return _ref412.apply(this, arguments);
    };
  }());

  __publicField(this, "addContentConsumed",
  /*#__PURE__*/
  function () {
    var _ref413 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee372(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee372$(_context373) {
        while (1) {
          switch (_context373.prev = _context373.next) {
            case 0:
              _context373.next = 2;
              return _this112.activityFacade.addContentConsumed(t2, e2, i);

            case 2:
              return _context373.abrupt("return", _context373.sent);

            case 3:
            case "end":
              return _context373.stop();
          }
        }
      }, _callee372);
    }));

    return function (_x626, _x627, _x628) {
      return _ref413.apply(this, arguments);
    };
  }());

  __publicField(this, "addShare",
  /*#__PURE__*/
  function () {
    var _ref414 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee373(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee373$(_context374) {
        while (1) {
          switch (_context374.prev = _context374.next) {
            case 0:
              _context374.next = 2;
              return _this112.activityFacade.addShare(t2, e2, i);

            case 2:
              return _context374.abrupt("return", _context374.sent);

            case 3:
            case "end":
              return _context374.stop();
          }
        }
      }, _callee373);
    }));

    return function (_x629, _x630, _x631) {
      return _ref414.apply(this, arguments);
    };
  }());

  __publicField(this, "addComment",
  /*#__PURE__*/
  function () {
    var _ref415 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee374(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee374$(_context375) {
        while (1) {
          switch (_context375.prev = _context375.next) {
            case 0:
              _context375.next = 2;
              return _this112.activityFacade.addComment(t2, e2, i);

            case 2:
              return _context375.abrupt("return", _context375.sent);

            case 3:
            case "end":
              return _context375.stop();
          }
        }
      }, _callee374);
    }));

    return function (_x632, _x633, _x634) {
      return _ref415.apply(this, arguments);
    };
  }());

  __publicField(this, "addClickAd",
  /*#__PURE__*/
  function () {
    var _ref416 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee375(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee375$(_context376) {
        while (1) {
          switch (_context376.prev = _context376.next) {
            case 0:
              _context376.next = 2;
              return _this112.activityFacade.addClickAd(t2, e2, i);

            case 2:
              return _context376.abrupt("return", _context376.sent);

            case 3:
            case "end":
              return _context376.stop();
          }
        }
      }, _callee375);
    }));

    return function (_x635, _x636, _x637) {
      return _ref416.apply(this, arguments);
    };
  }());

  __publicField(this, "addConversion",
  /*#__PURE__*/
  function () {
    var _ref417 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee376(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee376$(_context377) {
        while (1) {
          switch (_context377.prev = _context377.next) {
            case 0:
              _context377.next = 2;
              return _this112.activityFacade.addConversion(t2, e2, i);

            case 2:
              return _context377.abrupt("return", _context377.sent);

            case 3:
            case "end":
              return _context377.stop();
          }
        }
      }, _callee376);
    }));

    return function (_x638, _x639, _x640) {
      return _ref417.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwn",
  /*#__PURE__*/
  function () {
    var _ref418 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee377(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee377$(_context378) {
        while (1) {
          switch (_context378.prev = _context378.next) {
            case 0:
              _context378.next = 2;
              return _this112.activityFacade.getOwn(t2, e2);

            case 2:
              return _context378.abrupt("return", _context378.sent);

            case 3:
            case "end":
              return _context378.stop();
          }
        }
      }, _callee377);
    }));

    return function (_x641, _x642) {
      return _ref418.apply(this, arguments);
    };
  }());

  __publicField(this, "getForUser",
  /*#__PURE__*/
  function () {
    var _ref419 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee378(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee378$(_context379) {
        while (1) {
          switch (_context379.prev = _context379.next) {
            case 0:
              _context379.next = 2;
              return _this112.activityFacade.getForUser(t2, e2, i);

            case 2:
              return _context379.abrupt("return", _context379.sent);

            case 3:
            case "end":
              return _context379.stop();
          }
        }
      }, _callee378);
    }));

    return function (_x643, _x644, _x645) {
      return _ref419.apply(this, arguments);
    };
  }());

  this.activityFacade = new Fr(t2);
};

var Ie = function Ie() {
  _classCallCheck3(this, Ie);

  __publicField(this, "id", null);

  __publicField(this, "title", null);

  __publicField(this, "description", null);

  __publicField(this, "type", null);

  __publicField(this, "images", new ft());

  __publicField(this, "participationCount", null);

  __publicField(this, "questionsCount", null);

  __publicField(this, "status", null);

  __publicField(this, "flags", null);

  __publicField(this, "customFields", null);

  __publicField(this, "labels", null);

  __publicField(this, "time", null);

  __publicField(this, "averageScore", null);

  __publicField(this, "perfectScore", null);

  __publicField(this, "createdAt", null);

  __publicField(this, "updatedAt", null);
};

var Rr =
/*#__PURE__*/
function (_Ie) {
  _inherits3(Rr, _Ie);

  function Rr() {
    var _this113;

    _classCallCheck3(this, Rr);

    _this113 = _possibleConstructorReturn3(this, _getPrototypeOf4(Rr).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this113), "adContent", null);

    __publicField(_assertThisInitialized3(_this113), "rules", null);

    __publicField(_assertThisInitialized3(_this113), "questions", []);

    return _this113;
  }

  return Rr;
}(Ie);

var Sr = function Sr() {
  _classCallCheck3(this, Sr);

  __publicField(this, "questionId", null);

  __publicField(this, "question", null);

  __publicField(this, "images", null);

  __publicField(this, "options", []);
};

var Cr = function Cr() {
  _classCallCheck3(this, Cr);

  __publicField(this, "optionId", null);

  __publicField(this, "option", null);

  __publicField(this, "images", null);
};

var Ar = function Ar() {
  _classCallCheck3(this, Ar);

  __publicField(this, "classicQuizId", null);

  __publicField(this, "userId", null);

  __publicField(this, "questions", []);

  __publicField(this, "correctOptions", null);
};

var Lr = function Lr() {
  _classCallCheck3(this, Lr);

  __publicField(this, "questionId", null);

  __publicField(this, "optionId", null);

  __publicField(this, "correct", null);

  __publicField(this, "correctOptionId", null);
};

var Or = function Or() {
  _classCallCheck3(this, Or);

  __publicField(this, "classicQuizId", null);

  __publicField(this, "correct", null);

  __publicField(this, "classicQuizQuestions", null);
};

var Dr = function Dr() {
  var _this114 = this;

  _classCallCheck3(this, Dr);

  __publicField(this, "remapClassicQuizzes", function (t2) {
    return t2.meta.pagination = _this114.remapMetaPagination(t2.meta.pagination), t2.data = t2.data.map(function (e2) {
      return _this114.remapBasicClassicQuiz(e2);
    }), t2;
  });

  __publicField(this, "remapClassicQuizById", function (t2) {
    var e2 = new Rr();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.images = t2.images, e2.participationCount = t2.participation_count, e2.questionsCount = t2.questions_count, e2.status = t2.status, e2.flags = t2.flags, e2.adContent = t2.ad_content, e2.rules = t2.rules, e2.customFields = t2.custom_fields, e2.labels = t2.labels, e2.time = t2.time, e2.averageScore = t2.average_score, e2.perfectScore = t2.perfect_score, e2.questions = t2.questions.map(function (i) {
      return _this114.remapQuestions(i);
    }), e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapClassicQuizParticipation", function (t2) {
    var e2 = new Ar();
    return e2.classicQuizId = t2.classic_quiz_id, e2.userId = t2.user_id, e2.questions = t2.questions ? t2.questions.map(function (i) {
      return _this114.remapParticipationQuestions(i);
    }) : null, e2.correctOptions = t2.correct_options, e2;
  });

  __publicField(this, "remapClassicQuizParticipationBody", function (t2) {
    return t2.map(function (e2) {
      return {
        question_id: e2.questionId,
        option_id: e2.optionId
      };
    });
  });

  __publicField(this, "remapUserClassicQuizParticipations", function (t2) {
    return t2.map(function (e2) {
      var i = new Or();
      return i.classicQuizId = e2.classic_quiz_id, i.correct = e2.correct, i.classicQuizQuestions = e2.classic_quiz_questions, i;
    });
  });

  __publicField(this, "remapMetaPagination", function (t2) {
    var e2 = new Lt();
    return e2.itemsPerPage = t2.items_per_page, e2.nextPageStartsAfter = t2.next_page_starts_after, e2;
  });

  __publicField(this, "remapBasicClassicQuiz", function (t2) {
    var e2 = new Ie();
    return e2.id = t2.id, e2.title = t2.title, e2.description = t2.description, e2.type = t2.type, e2.images = t2.images, e2.participationCount = t2.participation_count, e2.questionsCount = t2.questions_count, e2.status = t2.status, e2.flags = t2.flags, e2.customFields = t2.custom_fields, e2.labels = t2.labels, e2.time = t2.time, e2.averageScore = t2.average_score, e2.perfectScore = t2.perfect_score, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapQuestions", function (t2) {
    var e2 = new Sr();
    return e2.questionId = t2.question_id, e2.question = t2.question, e2.images = t2.images, e2.options = t2.options.map(function (i) {
      return _this114.remapOptions(i);
    }), e2;
  });

  __publicField(this, "remapOptions", function (t2) {
    var e2 = new Cr();
    return e2.optionId = t2.option_id, e2.option = t2.option, e2.images = t2.images, e2;
  });

  __publicField(this, "remapParticipationQuestions", function (t2) {
    var e2 = new Lr();
    return e2.questionId = t2.question_id, e2.optionId = t2.option_id, e2.correct = t2.correct, e2.correctOptionId = t2.correct_option_id, e2;
  });
};

var xr =
/*#__PURE__*/
function (_ref420) {
  _inherits3(xr, _ref420);

  function xr(t2) {
    var _this115;

    _classCallCheck3(this, xr);

    _this115 = _possibleConstructorReturn3(this, _getPrototypeOf4(xr).call(this, t2, R(t2.environment, "miniGames")));

    __publicField(_assertThisInitialized3(_this115), "remapper", null);

    __publicField(_assertThisInitialized3(_this115), "getClassicQuizzes",
    /*#__PURE__*/
    function () {
      var _ref421 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee379(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee379$(_context380) {
          while (1) {
            switch (_context380.prev = _context380.next) {
              case 0:
                i = "/classic-quizzes".concat(_this115.apiSignInUrl);
                t2 && (i += t2.constructMainFiltersUrl()), i += P(e2) ? w$2() : "";
                a = "There was a problem with fetching classic quizzes";
                _context380.next = 5;
                return _this115.fetchWithoutAuth(i, a);

              case 5:
                r2 = _context380.sent;
                return _context380.abrupt("return", _this115.remapper.remapClassicQuizzes(r2));

              case 7:
              case "end":
                return _context380.stop();
            }
          }
        }, _callee379);
      }));

      return function (_x646, _x647) {
        return _ref421.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this115), "getClassicQuizById",
    /*#__PURE__*/
    function () {
      var _ref422 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee380(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee380$(_context381) {
          while (1) {
            switch (_context381.prev = _context381.next) {
              case 0:
                i = "/classic-quizzes/".concat(t2).concat(_this115.apiSignInUrl);
                P(e2) && (i += w$2());
                a = "There was a problem with fetching classic quiz by ID";
                _context381.next = 5;
                return _this115.fetchWithoutAuth(i, a);

              case 5:
                r2 = _context381.sent;
                return _context381.abrupt("return", _this115.remapper.remapClassicQuizById(r2.data));

              case 7:
              case "end":
                return _context381.stop();
            }
          }
        }, _callee380);
      }));

      return function (_x648, _x649) {
        return _ref422.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this115), "participateInClassicQuiz",
    /*#__PURE__*/
    function () {
      var _ref423 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee381(t2, e2, i) {
        var a, r2, s, p2, n2;
        return _regeneratorRuntime.wrap(function _callee381$(_context382) {
          while (1) {
            switch (_context382.prev = _context382.next) {
              case 0:
                a = "/classic-quizzes/".concat(t2, "/participate").concat(_this115.apiSignInUrl);
                r2 = "There was a problem with participating in the following classic quiz: ".concat(t2);
                s = "POST";
                p2 = {
                  questions: _this115.remapper.remapClassicQuizParticipationBody(e2),
                  include_correct_options: !!i
                };
                _context382.next = 6;
                return _this115.fetchWithAuth(a, r2, s, p2);

              case 6:
                n2 = _context382.sent;
                return _context382.abrupt("return", _this115.remapper.remapClassicQuizParticipation(n2.data));

              case 8:
              case "end":
                return _context382.stop();
            }
          }
        }, _callee381);
      }));

      return function (_x650, _x651, _x652) {
        return _ref423.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this115), "getMyClassicQuizParticipations",
    /*#__PURE__*/
    function () {
      var _ref424 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee382(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee382$(_context383) {
          while (1) {
            switch (_context383.prev = _context383.next) {
              case 0:
                e2 = "/classic-quizzes/participations/".concat(_this115.apiSignInUrl, "&classic_quiz_ids=").concat(t2 ? t2.join(",") : "");
                i = "There was a problem with fetching user's own Classic Quiz participations";
                _context383.next = 4;
                return _this115.fetchWithAuth(e2, i);

              case 4:
                a = _context383.sent;
                return _context383.abrupt("return", _this115.remapper.remapUserClassicQuizParticipations(a.data));

              case 6:
              case "end":
                return _context383.stop();
            }
          }
        }, _callee382);
      }));

      return function (_x653) {
        return _ref424.apply(this, arguments);
      };
    }());

    _this115.remapper = new Dr();
    return _this115;
  }

  return xr;
}(_);

var Br =
/*#__PURE__*/
function (_N2) {
  _inherits3(Br, _N2);

  function Br(t2) {
    var _this116;

    _classCallCheck3(this, Br);

    _this116 = _possibleConstructorReturn3(this, _getPrototypeOf4(Br).call(this, t2));

    __publicField(_assertThisInitialized3(_this116), "flags", null);

    __publicField(_assertThisInitialized3(_this116), "status", null);

    __publicField(_assertThisInitialized3(_this116), "entityIds", null);

    __publicField(_assertThisInitialized3(_this116), "entityType", null);

    __publicField(_assertThisInitialized3(_this116), "constructMainFiltersUrl", function () {
      var t2 = _get2(_getPrototypeOf4(Br.prototype), "constructMainFiltersUrl", _assertThisInitialized3(_this116)).call(_assertThisInitialized3(_this116));

      return _this116.flags && (t2 += "&flags=".concat(_this116.flags.join(","))), _this116.status && (t2 += "&status=".concat(_this116.status)), _this116.entityIds && (t2 += "&entity_ids=".concat(_this116.entityIds)), t2;
    });

    _this116.flags = t2 && t2.flags ? t2.flags : null, _this116.status = t2 && t2.status ? t2.status : null, _this116.entityIds = t2 && t2.entityIds ? t2.entityIds : null, _this116.entityType = t2 && t2.entityType ? t2.entityType : null;
    return _this116;
  }

  return Br;
}(N);

var Nr = function Nr(t2) {
  var _this117 = this;

  _classCallCheck3(this, Nr);

  __publicField(this, "errorHandlingModel", null);

  __publicField(this, "entityTypes", ["competition", "team", "player"]);

  __publicField(this, "validateFilters", function (t2) {
    !t2.entityIds && !t2.entityType || (t2.entityIds && !t2.entityType && _this117.throwException(400, "invalid_filters", "You need to use both 'entityIds' and 'entityType' filters together"), !t2.entityIds && t2.entityType && _this117.throwException(400, "invalid_filters", "You need to use both 'entityIds' and 'entityType' filters together"), _this117.entityTypes.includes(t2.entityType) || _this117.throwException(400, "invalid_filters", "Invalid 'entityType' filter. Please use one of the following valid options: competition, team, or player"));
  });

  __publicField(this, "throwException", function (t2, e2, i) {
    throw _this117.errorHandlingModel === "standard" ? new u(t2, e2, i) : new b$1(t2, e2, i);
  });

  this.errorHandlingModel = t2.errorHandlingMode;
};

var Ur = function Ur(t2) {
  var _this118 = this;

  _classCallCheck3(this, Ur);

  __publicField(this, "idSchema", null);

  __publicField(this, "idMapping", null);

  __publicField(this, "validator", null);

  __publicField(this, "entityTypes", ["competition", "team", "player"]);

  __publicField(this, "finalizeClassicQuizFilters",
  /*#__PURE__*/
  function () {
    var _ref425 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee383(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee383$(_context384) {
        while (1) {
          switch (_context384.prev = _context384.next) {
            case 0:
              if (!(_this118.validator.validateFilters(t2), _this118.idSchema !== "native")) {
                _context384.next = 6;
                break;
              }

              _this118.validator.validateFilters(t2);

              _context384.next = 4;
              return _this118.idMapping.getEntityIdsBySchemaId(Array.from(t2.entityIds), t2.entityType, "native");

            case 4:
              e2 = _context384.sent;
              t2.entityIds = e2[t2.entityType];

            case 6:
            case "end":
              return _context384.stop();
          }
        }
      }, _callee383);
    }));

    return function (_x654) {
      return _ref425.apply(this, arguments);
    };
  }());

  this.idSchema = t2.idSchema, this.idMapping = new F(t2), this.validator = new Nr(t2);
};

var Hr = function Hr(t2) {
  var _this119 = this;

  _classCallCheck3(this, Hr);

  __publicField(this, "https", null);

  __publicField(this, "service", null);

  __publicField(this, "getClassicQuizzes",
  /*#__PURE__*/
  function () {
    var _ref426 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee384(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee384$(_context385) {
        while (1) {
          switch (_context385.prev = _context385.next) {
            case 0:
              _context385.t0 = t2;

              if (!_context385.t0) {
                _context385.next = 5;
                break;
              }

              t2 = new Br(t2);
              _context385.next = 5;
              return _this119.service.finalizeClassicQuizFilters(t2);

            case 5:
              _context385.next = 7;
              return _this119.https.getClassicQuizzes(t2, e2);

            case 7:
              return _context385.abrupt("return", _context385.sent);

            case 8:
            case "end":
              return _context385.stop();
          }
        }
      }, _callee384);
    }));

    return function (_x655, _x656) {
      return _ref426.apply(this, arguments);
    };
  }());

  __publicField(this, "getClassicQuizById",
  /*#__PURE__*/
  function () {
    var _ref427 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee385(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee385$(_context386) {
        while (1) {
          switch (_context386.prev = _context386.next) {
            case 0:
              _context386.next = 2;
              return _this119.https.getClassicQuizById(t2, e2);

            case 2:
              return _context386.abrupt("return", _context386.sent);

            case 3:
            case "end":
              return _context386.stop();
          }
        }
      }, _callee385);
    }));

    return function (_x657, _x658) {
      return _ref427.apply(this, arguments);
    };
  }());

  __publicField(this, "participateInClassicQuiz",
  /*#__PURE__*/
  function () {
    var _ref428 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee386(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee386$(_context387) {
        while (1) {
          switch (_context387.prev = _context387.next) {
            case 0:
              _context387.next = 2;
              return _this119.https.participateInClassicQuiz(t2, e2, i);

            case 2:
              return _context387.abrupt("return", _context387.sent);

            case 3:
            case "end":
              return _context387.stop();
          }
        }
      }, _callee386);
    }));

    return function (_x659, _x660, _x661) {
      return _ref428.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyClassicQuizParticipations",
  /*#__PURE__*/
  function () {
    var _ref429 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee387(t2) {
      return _regeneratorRuntime.wrap(function _callee387$(_context388) {
        while (1) {
          switch (_context388.prev = _context388.next) {
            case 0:
              _context388.next = 2;
              return _this119.https.getMyClassicQuizParticipations(t2);

            case 2:
              return _context388.abrupt("return", _context388.sent);

            case 3:
            case "end":
              return _context388.stop();
          }
        }
      }, _callee387);
    }));

    return function (_x662) {
      return _ref429.apply(this, arguments);
    };
  }());

  this.https = new xr(t2), this.service = new Ur(t2);
};

var kr = function kr(t2) {
  var _this120 = this;

  _classCallCheck3(this, kr);

  __publicField(this, "facade", null);

  __publicField(this, "getClassicQuizzes",
  /*#__PURE__*/
  function () {
    var _ref430 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee388(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee388$(_context389) {
        while (1) {
          switch (_context389.prev = _context389.next) {
            case 0:
              _context389.next = 2;
              return _this120.facade.getClassicQuizzes(t2, e2);

            case 2:
              return _context389.abrupt("return", _context389.sent);

            case 3:
            case "end":
              return _context389.stop();
          }
        }
      }, _callee388);
    }));

    return function (_x663, _x664) {
      return _ref430.apply(this, arguments);
    };
  }());

  __publicField(this, "getClassicQuizById",
  /*#__PURE__*/
  function () {
    var _ref431 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee389(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee389$(_context390) {
        while (1) {
          switch (_context390.prev = _context390.next) {
            case 0:
              _context390.next = 2;
              return _this120.facade.getClassicQuizById(t2, e2);

            case 2:
              return _context390.abrupt("return", _context390.sent);

            case 3:
            case "end":
              return _context390.stop();
          }
        }
      }, _callee389);
    }));

    return function (_x665, _x666) {
      return _ref431.apply(this, arguments);
    };
  }());

  __publicField(this, "participateInClassicQuiz",
  /*#__PURE__*/
  function () {
    var _ref432 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee390(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee390$(_context391) {
        while (1) {
          switch (_context391.prev = _context391.next) {
            case 0:
              _context391.next = 2;
              return _this120.facade.participateInClassicQuiz(t2, e2, i);

            case 2:
              return _context391.abrupt("return", _context391.sent);

            case 3:
            case "end":
              return _context391.stop();
          }
        }
      }, _callee390);
    }));

    return function (_x667, _x668, _x669) {
      return _ref432.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyClassicQuizParticipations",
  /*#__PURE__*/
  function () {
    var _ref433 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee391(t2) {
      return _regeneratorRuntime.wrap(function _callee391$(_context392) {
        while (1) {
          switch (_context392.prev = _context392.next) {
            case 0:
              _context392.next = 2;
              return _this120.facade.getMyClassicQuizParticipations(t2);

            case 2:
              return _context392.abrupt("return", _context392.sent);

            case 3:
            case "end":
              return _context392.stop();
          }
        }
      }, _callee391);
    }));

    return function (_x670) {
      return _ref433.apply(this, arguments);
    };
  }());

  this.facade = new Hr(t2);
};

var Gr = function Gr() {
  _classCallCheck3(this, Gr);

  __publicField(this, "id", "");

  __publicField(this, "label", "");

  __publicField(this, "discussionType", "LEAGUE");

  __publicField(this, "moderationType", "USER");

  __publicField(this, "postsCount", 0);

  __publicField(this, "pinnedPosts", []);

  __publicField(this, "lastPostId", "");

  __publicField(this, "context", null);

  __publicField(this, "createdAt", "");

  __publicField(this, "updatedAt", "");
};

var bt = function bt() {
  _classCallCheck3(this, bt);

  __publicField(this, "pagination", {
    totalItems: 0,
    nextPageStartsAfter: "",
    lastCommentCreateTimestamp: ""
  });
};

var Pe = function Pe() {
  _classCallCheck3(this, Pe);

  __publicField(this, "id", "");

  __publicField(this, "userId", "");

  __publicField(this, "discussionId", "");

  __publicField(this, "content", "");

  __publicField(this, "repliesCount", 0);

  __publicField(this, "replyId", "");

  __publicField(this, "reactions", []);

  __publicField(this, "reactionsCount", 0);

  __publicField(this, "reports", []);

  __publicField(this, "reportsCount", 0);

  __publicField(this, "versions", null);

  __publicField(this, "privatePost", false);

  __publicField(this, "deleted", false);

  __publicField(this, "deletedAt", "");

  __publicField(this, "deletedBy", "");

  __publicField(this, "moderated", false);

  __publicField(this, "moderatedAt", "");

  __publicField(this, "moderatedBy", "");

  __publicField(this, "moderatedReason", "");

  __publicField(this, "createdAt", "");

  __publicField(this, "updatedAt", "");
};

var Vr = function Vr() {
  _classCallCheck3(this, Vr);

  __publicField(this, "meta", new bt());

  __publicField(this, "data", []);
};

var $r = function $r() {
  _classCallCheck3(this, $r);

  __publicField(this, "type", "");

  __publicField(this, "userIds", []);

  __publicField(this, "reactionCount", 0);
};

var Wr = function Wr() {
  _classCallCheck3(this, Wr);

  __publicField(this, "updatedAt", "");

  __publicField(this, "content", "");
};

var Kr = function Kr() {
  _classCallCheck3(this, Kr);

  __publicField(this, "userId", null);

  __publicField(this, "reason", "AD");

  __publicField(this, "reasonDetails", null);
};

var jr =
/*#__PURE__*/
function (_Pe) {
  _inherits3(jr, _Pe);

  function jr() {
    var _this121;

    _classCallCheck3(this, jr);

    _this121 = _possibleConstructorReturn3(this, _getPrototypeOf4(jr).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this121), "userModel", null);

    return _this121;
  }

  return jr;
}(Pe);

var qr = function qr() {
  _classCallCheck3(this, qr);

  __publicField(this, "meta", new bt());

  __publicField(this, "data", []);
};

var zr = function zr() {
  _classCallCheck3(this, zr);

  __publicField(this, "meta", new G());

  __publicField(this, "data", []);
};

var ve = function ve() {
  var _this122 = this;

  _classCallCheck3(this, ve);

  __publicField(this, "remapToDiscussionById", function (t2) {
    var e2 = new Gr();
    return e2.id = t2.id, e2.label = t2.label, e2.discussionType = t2.discussion_type, e2.moderationType = t2.moderation_type, e2.postsCount = t2.posts_count, e2.pinnedPosts = t2.pinned_posts, e2.lastPostId = t2.last_post_id, e2.context = t2.context, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapToPostsForDiscussion", function (t2, e2) {
    var i = new Vr(),
        a = new qr();
    return i.meta = _this122.remapToPostMeta(t2.meta), i.data = t2.data.map(function (r2) {
      return _this122.remapToPostByIdBasic(r2);
    }), a.meta = _this122.remapToPostMeta(t2.meta), a.data = t2.data.map(function (r2) {
      return _this122.remapToPostByIdFull(r2);
    }), e2 === "basic" ? i : a;
  });

  __publicField(this, "remapToPosts", function (t2) {
    var e2 = new zr();
    return e2.meta = _this122.remapToMeta(t2.meta), e2.data = t2.data.map(function (i) {
      return _this122.remapToPostByIdBasic(i);
    }), e2;
  });

  __publicField(this, "remapToPostMeta", function (t2) {
    var e2 = new bt();
    return e2.pagination.totalItems = t2.pagination.total_items, e2.pagination.nextPageStartsAfter = t2.pagination.next_page_starts_after, e2.pagination.lastCommentCreateTimestamp = t2.pagination.last_comment_create_timestamp, e2;
  });

  __publicField(this, "remapToMeta", function (t2) {
    var e2 = new G();
    return e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.nextPageStartsAfter = t2.pagination.next_page_starts_after, e2;
  });

  __publicField(this, "remapToPostByIdBasic", function (t2) {
    var e2 = new Pe();
    return e2.id = t2.id, e2.userId = t2.user_id, e2.discussionId = t2.discussion_id, e2.content = t2.content, e2.reactionsCount = t2.reactions_count, e2.replyId = t2.reply_id, e2.reactions = t2.reactions.length ? t2.reactions.map(function (i) {
      return _this122.remapReactionsPost(i);
    }) : t2.reactions, e2.reactionsCount = t2.reactions_count, e2.reports = t2.reports.length ? t2.reports.map(function (i) {
      return _this122.remapReportPost(i);
    }) : t2.reports, e2.reportsCount = t2.reports_count, e2.versions = t2.versions.length ? t2.versions.map(function (i) {
      return _this122.remapVersionsPost(i);
    }) : t2.versions, e2.privatePost = t2.private_post, e2.deleted = t2.deleted, e2.deletedAt = t2.deleted_at, e2.deletedBy = t2.deleted_by, e2.moderated = t2.moderated, e2.moderatedAt = t2.moderated_at, e2.moderatedBy = t2.moderated_by, e2.moderatedReason = t2.moderated_reason, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapToPostByIdFull", function (t2) {
    var e2 = new jr();
    return e2.id = t2.id, e2.userId = t2.user_id, e2.discussionId = t2.discussion_id, e2.content = t2.content, e2.reactionsCount = t2.reactions_count, e2.replyId = t2.reply_id, e2.reactions = t2.reactions.length ? t2.reactions.map(function (i) {
      return _this122.remapReactionsPost(i);
    }) : t2.reactions, e2.reactionsCount = t2.reactions_count, e2.reports = t2.reports.length ? t2.reports.map(function (i) {
      return _this122.remapReportPost(i);
    }) : t2.reports, e2.reportsCount = t2.reports_count, e2.versions = t2.versions.length ? t2.versions.map(function (i) {
      return _this122.remapVersionsPost(i);
    }) : t2.versions, e2.privatePost = t2.private_post, e2.deleted = t2.deleted, e2.deletedAt = t2.deleted_at, e2.deletedBy = t2.deleted_by, e2.moderated = t2.moderated, e2.moderatedAt = t2.moderated_at, e2.moderatedBy = t2.moderated_by, e2.moderatedReason = t2.moderated_reason, e2.createdAt = t2.created_at, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapReactionsPost", function (t2) {
    var e2 = new $r();
    return e2.type = t2.type, e2.userIds = t2.user_ids, e2.reactionCount = t2.reaction_count, e2;
  });

  __publicField(this, "remapVersionsPost", function (t2) {
    var e2 = new Wr();
    return e2.content = t2.content, e2.updatedAt = t2.updated_at, e2;
  });

  __publicField(this, "remapReportPost", function (t2) {
    var e2 = new Kr();
    return e2.userId = t2.user_id, e2.reason = t2.reason, e2.reasonDetails = t2.reason_details, e2;
  });
};

var Qr =
/*#__PURE__*/
function (_ref434) {
  _inherits3(Qr, _ref434);

  function Qr(t2) {
    var _this123;

    _classCallCheck3(this, Qr);

    _this123 = _possibleConstructorReturn3(this, _getPrototypeOf4(Qr).call(this, t2, R(t2.environment, "discussions")));

    __publicField(_assertThisInitialized3(_this123), "remapper", null);

    __publicField(_assertThisInitialized3(_this123), "getById",
    /*#__PURE__*/
    function () {
      var _ref435 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee392(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee392$(_context393) {
          while (1) {
            switch (_context393.prev = _context393.next) {
              case 0:
                e2 = "/discussions/".concat(t2) + _this123.apiSignInUrl;
                i = "There was a problem getting discussion";
                _context393.next = 4;
                return _this123.fetchWithoutAuth(e2, i);

              case 4:
                a = _context393.sent;
                return _context393.abrupt("return", _this123.remapper.remapToDiscussionById(a.data));

              case 6:
              case "end":
                return _context393.stop();
            }
          }
        }, _callee392);
      }));

      return function (_x671) {
        return _ref435.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "createPost",
    /*#__PURE__*/
    function () {
      var _ref436 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee393(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee393$(_context394) {
          while (1) {
            switch (_context394.prev = _context394.next) {
              case 0:
                i = "/discussions/".concat(t2, "/posts") + _this123.apiSignInUrl;
                a = "There was a problem creating post in discussion";
                r2 = "POST";
                _context394.next = 5;
                return _this123.fetchWithAuth(i, a, r2, e2);

              case 5:
                s = _context394.sent;
                return _context394.abrupt("return", _this123.remapper.remapToPostByIdBasic(s.data));

              case 7:
              case "end":
                return _context394.stop();
            }
          }
        }, _callee393);
      }));

      return function (_x672, _x673) {
        return _ref436.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "getPostById",
    /*#__PURE__*/
    function () {
      var _ref437 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee394(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee394$(_context395) {
          while (1) {
            switch (_context395.prev = _context395.next) {
              case 0:
                e2 = "/posts/".concat(t2) + _this123.apiSignInUrl;
                i = "There was a problem getting post by ID in discussion";
                _context395.next = 4;
                return _this123.fetchWithoutAuth(e2, i);

              case 4:
                a = _context395.sent;
                return _context395.abrupt("return", _this123.remapper.remapToPostByIdFull(a.data));

              case 6:
              case "end":
                return _context395.stop();
            }
          }
        }, _callee394);
      }));

      return function (_x674) {
        return _ref437.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "updatePost",
    /*#__PURE__*/
    function () {
      var _ref438 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee395(t2, e2) {
        var i, a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee395$(_context396) {
          while (1) {
            switch (_context396.prev = _context396.next) {
              case 0:
                i = "/posts/".concat(t2) + _this123.apiSignInUrl;
                a = "There was a problem editing post in discussion";
                r2 = "PUT";
                s = {
                  content: e2
                };
                _context396.next = 6;
                return _this123.fetchWithAuth(i, a, r2, s);

              case 6:
                p2 = _context396.sent;
                return _context396.abrupt("return", _this123.remapper.remapToPostByIdBasic(p2.data));

              case 8:
              case "end":
                return _context396.stop();
            }
          }
        }, _callee395);
      }));

      return function (_x675, _x676) {
        return _ref438.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "reactToPost",
    /*#__PURE__*/
    function () {
      var _ref439 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee396(t2, e2) {
        var i, a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee396$(_context397) {
          while (1) {
            switch (_context397.prev = _context397.next) {
              case 0:
                i = "/posts/".concat(t2, "/reaction") + _this123.apiSignInUrl;
                a = "There was a problem reacting to post in discussion";
                r2 = "PUT";
                s = {
                  reaction: e2.toLocaleLowerCase()
                };
                _context397.next = 6;
                return _this123.fetchWithAuth(i, a, r2, s);

              case 6:
                p2 = _context397.sent;
                return _context397.abrupt("return", _this123.remapper.remapToPostByIdBasic(p2.data));

              case 8:
              case "end":
                return _context397.stop();
            }
          }
        }, _callee396);
      }));

      return function (_x677, _x678) {
        return _ref439.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "deletePost",
    /*#__PURE__*/
    function () {
      var _ref440 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee397(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee397$(_context398) {
          while (1) {
            switch (_context398.prev = _context398.next) {
              case 0:
                e2 = "/posts/".concat(t2) + _this123.apiSignInUrl, i = "There was a problem deleting post in discussion", a = "DELETE";
                _context398.next = 3;
                return _this123.fetchWithAuth(e2, i, a);

              case 3:
                return _context398.abrupt("return", true);

              case 4:
              case "end":
                return _context398.stop();
            }
          }
        }, _callee397);
      }));

      return function (_x679) {
        return _ref440.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "getPosts",
    /*#__PURE__*/
    function () {
      var _ref441 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee398(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee398$(_context399) {
          while (1) {
            switch (_context399.prev = _context399.next) {
              case 0:
                i = "/discussions/".concat(t2, "/posts") + _this123.apiSignInUrl;
                e2 && (i += "".concat(e2.constructMainFiltersUrl()));
                a = "There was a problem getting posts in discussion";
                _context399.next = 5;
                return _this123.fetchWithoutAuth(i, a);

              case 5:
                r2 = _context399.sent;
                return _context399.abrupt("return", _this123.remapper.remapToPostsForDiscussion(r2, "full"));

              case 7:
              case "end":
                return _context399.stop();
            }
          }
        }, _callee398);
      }));

      return function (_x680, _x681) {
        return _ref441.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "getPostReplies",
    /*#__PURE__*/
    function () {
      var _ref442 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee399(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee399$(_context400) {
          while (1) {
            switch (_context400.prev = _context400.next) {
              case 0:
                i = "/posts/".concat(t2, "/replies") + _this123.apiSignInUrl;
                e2 && (i += "".concat(e2.constructMainFiltersUrl()));
                a = "There was a problem getting post's replies in discussion";
                _context400.next = 5;
                return _this123.fetchWithoutAuth(i, a);

              case 5:
                r2 = _context400.sent;
                return _context400.abrupt("return", _this123.remapper.remapToPostsForDiscussion(r2, "full"));

              case 7:
              case "end":
                return _context400.stop();
            }
          }
        }, _callee399);
      }));

      return function (_x682, _x683) {
        return _ref442.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "reportPost",
    /*#__PURE__*/
    function () {
      var _ref443 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee400(t2, e2, i) {
        var a, r2, s, p2, n2;
        return _regeneratorRuntime.wrap(function _callee400$(_context401) {
          while (1) {
            switch (_context401.prev = _context401.next) {
              case 0:
                a = "/posts/".concat(t2, "/report") + _this123.apiSignInUrl;
                r2 = "There was a problem reporting post in discussion";
                s = "POST";
                p2 = {
                  reason: e2.toLocaleUpperCase(),
                  reason_details: i || null
                };
                _context401.next = 6;
                return _this123.fetchWithAuth(a, r2, s, p2);

              case 6:
                n2 = _context401.sent;
                return _context401.abrupt("return", _this123.remapper.remapToPostByIdBasic(n2.data));

              case 8:
              case "end":
                return _context401.stop();
            }
          }
        }, _callee400);
      }));

      return function (_x684, _x685, _x686) {
        return _ref443.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "getOwnPosts",
    /*#__PURE__*/
    function () {
      var _ref444 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee401(t2) {
        var e2, i, a;
        return _regeneratorRuntime.wrap(function _callee401$(_context402) {
          while (1) {
            switch (_context402.prev = _context402.next) {
              case 0:
                e2 = "/posts" + _this123.apiSignInUrl;
                t2 && (e2 += "".concat(t2.constructMainFiltersUrl()));
                i = "There was a problem getting own posts";
                _context402.next = 5;
                return _this123.fetchWithAuth(e2, i);

              case 5:
                a = _context402.sent;
                return _context402.abrupt("return", _this123.remapper.remapToPosts(a));

              case 7:
              case "end":
                return _context402.stop();
            }
          }
        }, _callee401);
      }));

      return function (_x687) {
        return _ref444.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this123), "getUserPosts",
    /*#__PURE__*/
    function () {
      var _ref445 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee402(t2, e2, i) {
        var a, r2, s;
        return _regeneratorRuntime.wrap(function _callee402$(_context403) {
          while (1) {
            switch (_context403.prev = _context403.next) {
              case 0:
                a = "/posts/users/".concat(t2) + _this123.apiSignInUrl;
                e2 && (a += "".concat(e2.constructMainFiltersUrl())), P(i) && (a += w$2());
                r2 = "There was a problem getting user's posts";
                _context403.next = 5;
                return _this123.fetchWithoutAuth(a, r2);

              case 5:
                s = _context403.sent;
                return _context403.abrupt("return", _this123.remapper.remapToPosts(s));

              case 7:
              case "end":
                return _context403.stop();
            }
          }
        }, _callee402);
      }));

      return function (_x688, _x689, _x690) {
        return _ref445.apply(this, arguments);
      };
    }());

    _this123.remapper = new ve();
    return _this123;
  }

  return Qr;
}(_);

var Xr = function Xr() {
  _classCallCheck3(this, Xr);

  __publicField(this, "content", "");

  __publicField(this, "reply_id", "");

  __publicField(this, "context", null);
};

var Yr = function Yr() {
  _classCallCheck3(this, Yr);

  __publicField(this, "createRequestBodyFromParam", function (t2) {
    var e2 = new Xr();
    return e2.content = t2.content, e2.reply_id = t2.replyId, e2.context = t2.context, e2;
  });
};

var Rt =
/*#__PURE__*/
function (_N3) {
  _inherits3(Rt, _N3);

  function Rt(t2) {
    var _this124;

    _classCallCheck3(this, Rt);

    _this124 = _possibleConstructorReturn3(this, _getPrototypeOf4(Rt).call(this, t2));

    __publicField(_assertThisInitialized3(_this124), "skipDeleted");

    __publicField(_assertThisInitialized3(_this124), "sort");

    _this124.skipDeleted = t2 && t2.skipDeleted !== void 0 ? t2.skipDeleted : null, _this124.sort = t2 && t2.sort ? t2.sort.toLocaleLowerCase() : null;
    return _this124;
  }

  _createClass3(Rt, [{
    key: "constructMainFiltersUrl",
    value: function constructMainFiltersUrl() {
      var t2 = _get2(_getPrototypeOf4(Rt.prototype), "constructMainFiltersUrl", this).call(this);

      return this.skipDeleted !== null && (t2 += "&skip_deleted=".concat(this.skipDeleted)), this.sort && (t2 += "&sort=".concat(this.sort)), t2;
    }
  }]);

  return Rt;
}(N);

var wt = function wt(t2) {
  var _this125 = this;

  _classCallCheck3(this, wt);

  __publicField(this, "profile", null);

  __publicField(this, "finalizePostFullModel",
  /*#__PURE__*/
  function () {
    var _ref446 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee403(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee403$(_context404) {
        while (1) {
          switch (_context404.prev = _context404.next) {
            case 0:
              e2 = t2.map(function (a) {
                return a.userId;
              });
              _context404.next = 3;
              return _this125.profile.getByIds(e2);

            case 3:
              i = _context404.sent;
              return _context404.abrupt("return", t2.map(function (a) {
                return a.userModel = _this125.extractModelById(i, a.userId), a;
              }));

            case 5:
            case "end":
              return _context404.stop();
          }
        }
      }, _callee403);
    }));

    return function (_x691) {
      return _ref446.apply(this, arguments);
    };
  }());

  __publicField(this, "extractModelById", function (t2, e2) {
    if (t2.length) {
      var _i57 = t2.find(function (a) {
        return a.id === e2;
      });

      return _i57 ? (delete _i57.interests, _i57) : null;
    }

    return null;
  });

  this.profile = new L(t2);
};

var Jr = function Jr(t2) {
  var _this126 = this;

  _classCallCheck3(this, Jr);

  __publicField(this, "idSchema", null);

  __publicField(this, "https", null);

  __publicField(this, "clientHttps", null);

  __publicField(this, "activityService", null);

  __publicField(this, "service", null);

  __publicField(this, "factory", null);

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref447 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee404(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee404$(_context405) {
        while (1) {
          switch (_context405.prev = _context405.next) {
            case 0:
              _context405.next = 2;
              return _this126.https.getById(t2);

            case 2:
              e2 = _context405.sent;
              _context405.next = 5;
              return _this126.remapTags(e2, "native", _this126.idSchema);

            case 5:
              return _context405.abrupt("return", e2);

            case 6:
            case "end":
              return _context405.stop();
          }
        }
      }, _callee404);
    }));

    return function (_x692) {
      return _ref447.apply(this, arguments);
    };
  }());

  __publicField(this, "createPost",
  /*#__PURE__*/
  function () {
    var _ref448 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee405(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee405$(_context406) {
        while (1) {
          switch (_context406.prev = _context406.next) {
            case 0:
              i = JSON.parse(JSON.stringify(e2));
              _context406.next = 3;
              return _this126.remapTags(i, _this126.idSchema, "native");

            case 3:
              a = _this126.factory.createRequestBodyFromParam(i);
              _context406.next = 6;
              return _this126.https.createPost(t2, a);

            case 6:
              return _context406.abrupt("return", _context406.sent);

            case 7:
            case "end":
              return _context406.stop();
          }
        }
      }, _callee405);
    }));

    return function (_x693, _x694) {
      return _ref448.apply(this, arguments);
    };
  }());

  __publicField(this, "getPostById",
  /*#__PURE__*/
  function () {
    var _ref449 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee406(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee406$(_context407) {
        while (1) {
          switch (_context407.prev = _context407.next) {
            case 0:
              _context407.next = 2;
              return _this126.https.getPostById(t2);

            case 2:
              e2 = _context407.sent;
              _context407.next = 5;
              return _this126.service.finalizePostFullModel([e2]);

            case 5:
              return _context407.abrupt("return", _context407.sent[0]);

            case 6:
            case "end":
              return _context407.stop();
          }
        }
      }, _callee406);
    }));

    return function (_x695) {
      return _ref449.apply(this, arguments);
    };
  }());

  __publicField(this, "updatePost",
  /*#__PURE__*/
  function () {
    var _ref450 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee407(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee407$(_context408) {
        while (1) {
          switch (_context408.prev = _context408.next) {
            case 0:
              _context408.next = 2;
              return _this126.https.updatePost(t2, e2);

            case 2:
              return _context408.abrupt("return", _context408.sent);

            case 3:
            case "end":
              return _context408.stop();
          }
        }
      }, _callee407);
    }));

    return function (_x696, _x697) {
      return _ref450.apply(this, arguments);
    };
  }());

  __publicField(this, "deletePost",
  /*#__PURE__*/
  function () {
    var _ref451 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee408(t2) {
      return _regeneratorRuntime.wrap(function _callee408$(_context409) {
        while (1) {
          switch (_context409.prev = _context409.next) {
            case 0:
              _context409.next = 2;
              return _this126.https.deletePost(t2);

            case 2:
              return _context409.abrupt("return", _context409.sent);

            case 3:
            case "end":
              return _context409.stop();
          }
        }
      }, _callee408);
    }));

    return function (_x698) {
      return _ref451.apply(this, arguments);
    };
  }());

  __publicField(this, "getPosts",
  /*#__PURE__*/
  function () {
    var _ref452 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee409(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee409$(_context410) {
        while (1) {
          switch (_context410.prev = _context410.next) {
            case 0:
              e2 && (e2 = new Rt(e2));
              _context410.next = 3;
              return _this126.https.getPosts(t2, e2);

            case 3:
              i = _context410.sent;
              _context410.next = 6;
              return _this126.service.finalizePostFullModel(i.data);

            case 6:
              i.data = _context410.sent;
              return _context410.abrupt("return", i);

            case 8:
            case "end":
              return _context410.stop();
          }
        }
      }, _callee409);
    }));

    return function (_x699, _x700) {
      return _ref452.apply(this, arguments);
    };
  }());

  __publicField(this, "getPostReplies",
  /*#__PURE__*/
  function () {
    var _ref453 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee410(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee410$(_context411) {
        while (1) {
          switch (_context411.prev = _context411.next) {
            case 0:
              e2 && (e2 = new Rt(e2));
              _context411.next = 3;
              return _this126.https.getPostReplies(t2, e2);

            case 3:
              i = _context411.sent;
              _context411.next = 6;
              return _this126.service.finalizePostFullModel(i.data);

            case 6:
              i.data = _context411.sent;
              return _context411.abrupt("return", i);

            case 8:
            case "end":
              return _context411.stop();
          }
        }
      }, _callee410);
    }));

    return function (_x701, _x702) {
      return _ref453.apply(this, arguments);
    };
  }());

  __publicField(this, "reactToPost",
  /*#__PURE__*/
  function () {
    var _ref454 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee411(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee411$(_context412) {
        while (1) {
          switch (_context412.prev = _context412.next) {
            case 0:
              _context412.next = 2;
              return _this126.https.reactToPost(t2, e2);

            case 2:
              return _context412.abrupt("return", _context412.sent);

            case 3:
            case "end":
              return _context412.stop();
          }
        }
      }, _callee411);
    }));

    return function (_x703, _x704) {
      return _ref454.apply(this, arguments);
    };
  }());

  __publicField(this, "reportPost",
  /*#__PURE__*/
  function () {
    var _ref455 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee412(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee412$(_context413) {
        while (1) {
          switch (_context413.prev = _context413.next) {
            case 0:
              _context413.next = 2;
              return _this126.https.reportPost(t2, e2, i);

            case 2:
              return _context413.abrupt("return", _context413.sent);

            case 3:
            case "end":
              return _context413.stop();
          }
        }
      }, _callee412);
    }));

    return function (_x705, _x706, _x707) {
      return _ref455.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwnPosts",
  /*#__PURE__*/
  function () {
    var _ref456 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee413(t2) {
      return _regeneratorRuntime.wrap(function _callee413$(_context414) {
        while (1) {
          switch (_context414.prev = _context414.next) {
            case 0:
              t2 && (t2 = new Rt(t2));
              _context414.next = 3;
              return _this126.https.getOwnPosts(t2);

            case 3:
              return _context414.abrupt("return", _context414.sent);

            case 4:
            case "end":
              return _context414.stop();
          }
        }
      }, _callee413);
    }));

    return function (_x708) {
      return _ref456.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPosts",
  /*#__PURE__*/
  function () {
    var _ref457 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee414(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee414$(_context415) {
        while (1) {
          switch (_context415.prev = _context415.next) {
            case 0:
              e2 && (e2 = new Rt(e2));
              _context415.next = 3;
              return _this126.https.getUserPosts(t2, e2, i);

            case 3:
              return _context415.abrupt("return", _context415.sent);

            case 4:
            case "end":
              return _context415.stop();
          }
        }
      }, _callee414);
    }));

    return function (_x709, _x710, _x711) {
      return _ref457.apply(this, arguments);
    };
  }());

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee415() {
    return _regeneratorRuntime.wrap(function _callee415$(_context416) {
      while (1) {
        switch (_context416.prev = _context416.next) {
          case 0:
            _context416.next = 2;
            return _this126.clientHttps.getConfig("discussions");

          case 2:
            return _context416.abrupt("return", _context416.sent);

          case 3:
          case "end":
            return _context416.stop();
        }
      }
    }, _callee415);
  })));

  __publicField(this, "remapTags",
  /*#__PURE__*/
  function () {
    var _ref459 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee416(t2, e2, i) {
      var a, r2;
      return _regeneratorRuntime.wrap(function _callee416$(_context417) {
        while (1) {
          switch (_context417.prev = _context417.next) {
            case 0:
              if (!(_this126.idSchema != "native" && t2.context.tags && t2.context.tags.length)) {
                _context417.next = 6;
                break;
              }

              a = JSON.parse(JSON.stringify(t2.context.tags));
              _context417.next = 4;
              return _this126.activityService.remapTagsIds(a, e2, i);

            case 4:
              r2 = _context417.sent;
              t2.context.tags = r2;

            case 6:
            case "end":
              return _context417.stop();
          }
        }
      }, _callee416);
    }));

    return function (_x712, _x713, _x714) {
      return _ref459.apply(this, arguments);
    };
  }());

  this.idSchema = t2.idSchema, this.https = new Qr(t2), this.clientHttps = new x$1(t2), this.activityService = new be(t2), this.service = new wt(t2), this.factory = new Yr();
};

var Zr = function Zr(t2) {
  var _this127 = this;

  _classCallCheck3(this, Zr);

  __publicField(this, "facade", null);

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref460 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee417(t2) {
      return _regeneratorRuntime.wrap(function _callee417$(_context418) {
        while (1) {
          switch (_context418.prev = _context418.next) {
            case 0:
              _context418.next = 2;
              return _this127.facade.getById(t2);

            case 2:
              return _context418.abrupt("return", _context418.sent);

            case 3:
            case "end":
              return _context418.stop();
          }
        }
      }, _callee417);
    }));

    return function (_x715) {
      return _ref460.apply(this, arguments);
    };
  }());

  __publicField(this, "createPost",
  /*#__PURE__*/
  function () {
    var _ref461 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee418(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee418$(_context419) {
        while (1) {
          switch (_context419.prev = _context419.next) {
            case 0:
              _context419.next = 2;
              return _this127.facade.createPost(t2, e2);

            case 2:
              return _context419.abrupt("return", _context419.sent);

            case 3:
            case "end":
              return _context419.stop();
          }
        }
      }, _callee418);
    }));

    return function (_x716, _x717) {
      return _ref461.apply(this, arguments);
    };
  }());

  __publicField(this, "getPostById",
  /*#__PURE__*/
  function () {
    var _ref462 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee419(t2) {
      return _regeneratorRuntime.wrap(function _callee419$(_context420) {
        while (1) {
          switch (_context420.prev = _context420.next) {
            case 0:
              _context420.next = 2;
              return _this127.facade.getPostById(t2);

            case 2:
              return _context420.abrupt("return", _context420.sent);

            case 3:
            case "end":
              return _context420.stop();
          }
        }
      }, _callee419);
    }));

    return function (_x718) {
      return _ref462.apply(this, arguments);
    };
  }());

  __publicField(this, "updatePost",
  /*#__PURE__*/
  function () {
    var _ref463 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee420(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee420$(_context421) {
        while (1) {
          switch (_context421.prev = _context421.next) {
            case 0:
              _context421.next = 2;
              return _this127.facade.updatePost(t2, e2);

            case 2:
              return _context421.abrupt("return", _context421.sent);

            case 3:
            case "end":
              return _context421.stop();
          }
        }
      }, _callee420);
    }));

    return function (_x719, _x720) {
      return _ref463.apply(this, arguments);
    };
  }());

  __publicField(this, "deletePost",
  /*#__PURE__*/
  function () {
    var _ref464 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee421(t2) {
      return _regeneratorRuntime.wrap(function _callee421$(_context422) {
        while (1) {
          switch (_context422.prev = _context422.next) {
            case 0:
              _context422.next = 2;
              return _this127.facade.deletePost(t2);

            case 2:
              return _context422.abrupt("return", _context422.sent);

            case 3:
            case "end":
              return _context422.stop();
          }
        }
      }, _callee421);
    }));

    return function (_x721) {
      return _ref464.apply(this, arguments);
    };
  }());

  __publicField(this, "getPosts",
  /*#__PURE__*/
  function () {
    var _ref465 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee422(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee422$(_context423) {
        while (1) {
          switch (_context423.prev = _context423.next) {
            case 0:
              _context423.next = 2;
              return _this127.facade.getPosts(t2, e2);

            case 2:
              return _context423.abrupt("return", _context423.sent);

            case 3:
            case "end":
              return _context423.stop();
          }
        }
      }, _callee422);
    }));

    return function (_x722, _x723) {
      return _ref465.apply(this, arguments);
    };
  }());

  __publicField(this, "getPostReplies",
  /*#__PURE__*/
  function () {
    var _ref466 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee423(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee423$(_context424) {
        while (1) {
          switch (_context424.prev = _context424.next) {
            case 0:
              _context424.next = 2;
              return _this127.facade.getPostReplies(t2, e2);

            case 2:
              return _context424.abrupt("return", _context424.sent);

            case 3:
            case "end":
              return _context424.stop();
          }
        }
      }, _callee423);
    }));

    return function (_x724, _x725) {
      return _ref466.apply(this, arguments);
    };
  }());

  __publicField(this, "react",
  /*#__PURE__*/
  function () {
    var _ref467 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee424(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee424$(_context425) {
        while (1) {
          switch (_context425.prev = _context425.next) {
            case 0:
              _context425.next = 2;
              return _this127.facade.reactToPost(t2, e2);

            case 2:
              return _context425.abrupt("return", _context425.sent);

            case 3:
            case "end":
              return _context425.stop();
          }
        }
      }, _callee424);
    }));

    return function (_x726, _x727) {
      return _ref467.apply(this, arguments);
    };
  }());

  __publicField(this, "reportPost",
  /*#__PURE__*/
  function () {
    var _ref468 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee425(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee425$(_context426) {
        while (1) {
          switch (_context426.prev = _context426.next) {
            case 0:
              _context426.next = 2;
              return _this127.facade.reportPost(t2, e2, i);

            case 2:
              return _context426.abrupt("return", _context426.sent);

            case 3:
            case "end":
              return _context426.stop();
          }
        }
      }, _callee425);
    }));

    return function (_x728, _x729, _x730) {
      return _ref468.apply(this, arguments);
    };
  }());

  __publicField(this, "getOwnPosts",
  /*#__PURE__*/
  function () {
    var _ref469 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee426(t2) {
      return _regeneratorRuntime.wrap(function _callee426$(_context427) {
        while (1) {
          switch (_context427.prev = _context427.next) {
            case 0:
              _context427.next = 2;
              return _this127.facade.getOwnPosts(t2);

            case 2:
              return _context427.abrupt("return", _context427.sent);

            case 3:
            case "end":
              return _context427.stop();
          }
        }
      }, _callee426);
    }));

    return function (_x731) {
      return _ref469.apply(this, arguments);
    };
  }());

  __publicField(this, "getUserPosts",
  /*#__PURE__*/
  function () {
    var _ref470 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee427(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee427$(_context428) {
        while (1) {
          switch (_context428.prev = _context428.next) {
            case 0:
              _context428.next = 2;
              return _this127.facade.getUserPosts(t2, e2, i);

            case 2:
              return _context428.abrupt("return", _context428.sent);

            case 3:
            case "end":
              return _context428.stop();
          }
        }
      }, _callee427);
    }));

    return function (_x732, _x733, _x734) {
      return _ref470.apply(this, arguments);
    };
  }());

  __publicField(this, "getConfig",
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee428() {
    return _regeneratorRuntime.wrap(function _callee428$(_context429) {
      while (1) {
        switch (_context429.prev = _context429.next) {
          case 0:
            _context429.next = 2;
            return _this127.facade.getConfig();

          case 2:
            return _context429.abrupt("return", _context429.sent);

          case 3:
          case "end":
            return _context429.stop();
        }
      }
    }, _callee428);
  })));

  this.facade = new Jr(t2);
};

var to = function to() {
  _classCallCheck3(this, to);

  __publicField(this, "profileId", "");

  __publicField(this, "profileModel", null);

  __publicField(this, "challengeId", "");

  __publicField(this, "challengeModel", null);

  __publicField(this, "message", "");
};

var eo = function eo() {
  _classCallCheck3(this, eo);

  __publicField(this, "profileId", "");

  __publicField(this, "profileModel", null);

  __publicField(this, "leagueId", "");

  __publicField(this, "leagueModel", null);

  __publicField(this, "message", "");
};

var io = function io() {
  _classCallCheck3(this, io);

  __publicField(this, "id", "");

  __publicField(this, "name", "");

  __publicField(this, "description", "");

  __publicField(this, "type", "");

  __publicField(this, "members", []);

  __publicField(this, "banned", []);

  __publicField(this, "invites", []);

  __publicField(this, "administrators", []);

  __publicField(this, "invitationCode", "");

  __publicField(this, "templateId", "");

  __publicField(this, "templateModel", null);

  __publicField(this, "pastTemplates", []);

  __publicField(this, "usersCanInviteUsers", false);

  __publicField(this, "scoringStartsAt", "");

  __publicField(this, "pinnedPosts", []);
};

var ao = function ao() {
  _classCallCheck3(this, ao);

  __publicField(this, "predictionId", null);

  __publicField(this, "predictionModel", null);

  __publicField(this, "profileId", null);

  __publicField(this, "profileModel", null);
};

var ro = function ro() {
  var _this128 = this;

  _classCallCheck3(this, ro);

  __publicField(this, "remapToPrivateLeagues", function (t2) {
    return t2.meta = _this128.remapMetaPrivateLeagues(t2.meta.pagination), t2.data = t2.data.map(function (e2) {
      return _this128.remapToPrivateLeagueById(e2);
    }), t2;
  });

  __publicField(this, "remapMetaPrivateLeagues", function (t2) {
    var e2 = new G();
    return e2.pagination.itemsPerPage = t2.items_per_page, e2.pagination.nextPageStartsAfter = t2.next_page_starts_after, e2;
  });

  __publicField(this, "remapToPrivateLeagueById", function (t2) {
    var e2 = new io();
    return e2.id = t2.id, e2.name = t2.name, e2.description = t2.description, e2.type = t2.type, e2.members = t2.members, e2.administrators = t2.administrators, e2.banned = t2.banned, e2.invites = t2.invites, e2.usersCanInviteUsers = t2.users_can_invite_users, e2.invitationCode = t2.invitation_code, e2.templateId = t2.template_id, e2.pastTemplates = t2.past_templates, e2.pinnedPosts = t2.pinned_posts, e2.scoringStartsAt = t2.scoring_starts_at, e2;
  });

  __publicField(this, "remapToAcceptPrivateLeague", function (t2) {
    var e2 = new eo();
    return e2.profileId = t2.profile_id, e2.leagueId = t2.league_id, e2.message = t2.message, e2;
  });

  __publicField(this, "remapToAcceptChallenge", function (t2) {
    var e2 = new to();
    return e2.profileId = t2.profile_id, e2.challengeId = t2.league_id, e2.message = t2.message, e2;
  });

  __publicField(this, "remapPredictions", function (t2) {
    return t2.meta = _this128.remapMeta(t2.meta), t2.data = _this128.remapPredictionsData(t2.data), t2;
  });

  __publicField(this, "remapMeta", function (t2) {
    var e2 = new W();
    return e2.pagination.currentPage = t2.pagination.current_page, e2.pagination.itemsPerPage = t2.pagination.items_per_page, e2.pagination.numberOfPages = t2.pagination.number_of_pages, e2.pagination.totalItems = t2.pagination.total_items, e2;
  });

  __publicField(this, "remapPredictionsData", function (t2) {
    return t2.map(function (e2) {
      var i = new ao();
      return i.predictionId = e2.prediction_id, i.profileId = e2.profile_id, i;
    });
  });
};

var Te =
/*#__PURE__*/
function (_ref472) {
  _inherits3(Te, _ref472);

  function Te(t2) {
    var _this129;

    _classCallCheck3(this, Te);

    _this129 = _possibleConstructorReturn3(this, _getPrototypeOf4(Te).call(this, t2, R(t2.environment, "privateLeagues")));

    __publicField(_assertThisInitialized3(_this129), "remapper", null);

    __publicField(_assertThisInitialized3(_this129), "discussionsRemapper", null);

    __publicField(_assertThisInitialized3(_this129), "discussionsBaseURL", null);

    __publicField(_assertThisInitialized3(_this129), "create",
    /*#__PURE__*/
    function () {
      var _ref473 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee429(t2, e2) {
        var i, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee429$(_context430) {
          while (1) {
            switch (_context430.prev = _context430.next) {
              case 0:
                i = "/leagues" + _this129.apiSignInUrl;
                r2 = "There was a problem ".concat(e2 === "PRIVATE_LEAGUE" ? "creating private league" : "issuing challenge");
                s = "POST";
                _context430.next = 5;
                return _this129.fetchWithAuth(i, r2, s, t2);

              case 5:
                p2 = _context430.sent;
                return _context430.abrupt("return", _this129.remapper.remapToPrivateLeagueById(p2.data));

              case 7:
              case "end":
                return _context430.stop();
            }
          }
        }, _callee429);
      }));

      return function (_x735, _x736) {
        return _ref473.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "update",
    /*#__PURE__*/
    function () {
      var _ref474 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee430(t2, e2, i) {
        var a, s, p2, n2;
        return _regeneratorRuntime.wrap(function _callee430$(_context431) {
          while (1) {
            switch (_context431.prev = _context431.next) {
              case 0:
                a = "/leagues/".concat(t2) + _this129.apiSignInUrl;
                s = "There was a problem updating ".concat(i === "PRIVATE_LEAGUE" ? "private league" : "challenge");
                p2 = "PUT";
                _context431.next = 5;
                return _this129.fetchWithAuth(a, s, p2, e2);

              case 5:
                n2 = _context431.sent;
                return _context431.abrupt("return", _this129.remapper.remapToPrivateLeagueById(n2.data));

              case 7:
              case "end":
                return _context431.stop();
            }
          }
        }, _callee430);
      }));

      return function (_x737, _x738, _x739) {
        return _ref474.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "updateLeagueTemplate",
    /*#__PURE__*/
    function () {
      var _ref475 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee431(t2, e2, i, a) {
        var r2, p2, n2, l2, c2;
        return _regeneratorRuntime.wrap(function _callee431$(_context432) {
          while (1) {
            switch (_context432.prev = _context432.next) {
              case 0:
                r2 = "/leagues/".concat(t2, "/template") + _this129.apiSignInUrl;
                p2 = "There was a problem updating template for the ".concat(a === "PRIVATE_LEAGUE" ? "private league" : "challenge");
                n2 = "POST";
                l2 = {
                  new_template_id: e2,
                  past_template_name: i
                };
                _context432.next = 6;
                return _this129.fetchWithAuth(r2, p2, n2, l2);

              case 6:
                c2 = _context432.sent;
                return _context432.abrupt("return", _this129.remapper.remapToPrivateLeagueById(c2.data));

              case 8:
              case "end":
                return _context432.stop();
            }
          }
        }, _callee431);
      }));

      return function (_x740, _x741, _x742, _x743) {
        return _ref475.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "getById",
    /*#__PURE__*/
    function () {
      var _ref476 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee432(t2, e2, i) {
        var a, s, p2;
        return _regeneratorRuntime.wrap(function _callee432$(_context433) {
          while (1) {
            switch (_context433.prev = _context433.next) {
              case 0:
                a = "/leagues/".concat(t2) + _this129.apiSignInUrl;
                P(i) && (a += w$2());
                s = "There was a problem getting ".concat(e2 === "PRIVATE_LEAGUE" ? "private league" : "challenge");
                _context433.next = 5;
                return _this129.fetchWithAuth(a, s);

              case 5:
                p2 = _context433.sent;
                return _context433.abrupt("return", _this129.remapper.remapToPrivateLeagueById(p2.data));

              case 7:
              case "end":
                return _context433.stop();
            }
          }
        }, _callee432);
      }));

      return function (_x744, _x745, _x746) {
        return _ref476.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "delete",
    /*#__PURE__*/
    function () {
      var _ref477 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee433(t2, e2) {
        var i, r2, s;
        return _regeneratorRuntime.wrap(function _callee433$(_context434) {
          while (1) {
            switch (_context434.prev = _context434.next) {
              case 0:
                i = "/leagues/".concat(t2) + _this129.apiSignInUrl, r2 = "There was a problem deleting ".concat(e2 === "PRIVATE_LEAGUE" ? "private league" : "challenge"), s = "DELETE";
                _context434.next = 3;
                return _this129.fetchWithAuth(i, r2, s);

              case 3:
                return _context434.abrupt("return", true);

              case 4:
              case "end":
                return _context434.stop();
            }
          }
        }, _callee433);
      }));

      return function (_x747, _x748) {
        return _ref477.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "invite",
    /*#__PURE__*/
    function () {
      var _ref478 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee434(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee434$(_context435) {
          while (1) {
            switch (_context435.prev = _context435.next) {
              case 0:
                i = "/membership/invite/".concat(t2) + _this129.apiSignInUrl, a = "There was a problem inviting the following users: ".concat(e2.join(",")), r2 = "POST", s = {
                  profiles: e2
                };
                _context435.next = 3;
                return _this129.fetchWithAuth(i, a, r2, s);

              case 3:
                return _context435.abrupt("return", _context435.sent.data);

              case 4:
              case "end":
                return _context435.stop();
            }
          }
        }, _callee434);
      }));

      return function (_x749, _x750) {
        return _ref478.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "deleteInvitation",
    /*#__PURE__*/
    function () {
      var _ref479 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee435(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee435$(_context436) {
          while (1) {
            switch (_context436.prev = _context436.next) {
              case 0:
                i = "/membership/invite/".concat(t2) + _this129.apiSignInUrl, a = "There was a problem deleting invitation for the following users: ".concat(e2.join(",")), r2 = "DELETE", s = {
                  profiles: e2
                };
                _context436.next = 3;
                return _this129.fetchWithAuth(i, a, r2, s);

              case 3:
                return _context436.abrupt("return", true);

              case 4:
              case "end":
                return _context436.stop();
            }
          }
        }, _callee435);
      }));

      return function (_x751, _x752) {
        return _ref479.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "accept",
    /*#__PURE__*/
    function () {
      var _ref480 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee436(t2, e2, i) {
        var a, s, p2, n2;
        return _regeneratorRuntime.wrap(function _callee436$(_context437) {
          while (1) {
            switch (_context437.prev = _context437.next) {
              case 0:
                a = "/membership/accept/".concat(t2) + _this129.apiSignInUrl + "&accept=".concat(e2 ? "ACCEPT" : "REJECT");
                s = "There was a problem ".concat(e2 ? "accepting" : "rejecting", " invitation for ").concat(i === "PRIVATE_LEAGUE" ? "private league" : "challenge", ": ").concat(t2);
                p2 = "POST";
                _context437.next = 5;
                return _this129.fetchWithAuth(a, s, p2);

              case 5:
                n2 = _context437.sent;
                return _context437.abrupt("return", i === "PRIVATE_LEAGUE" ? _this129.remapper.remapToAcceptPrivateLeague(n2.data) : _this129.remapper.remapToAcceptChallenge(n2.data));

              case 7:
              case "end":
                return _context437.stop();
            }
          }
        }, _callee436);
      }));

      return function (_x753, _x754, _x755) {
        return _ref480.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "ban",
    /*#__PURE__*/
    function () {
      var _ref481 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee437(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee437$(_context438) {
          while (1) {
            switch (_context438.prev = _context438.next) {
              case 0:
                i = "/membership/ban/".concat(t2) + _this129.apiSignInUrl, a = "There was a problem banning the following users: ".concat(e2.join(",")), r2 = "POST", s = {
                  profiles: e2
                };
                _context438.next = 3;
                return _this129.fetchWithAuth(i, a, r2, s);

              case 3:
                return _context438.abrupt("return", _context438.sent.data);

              case 4:
              case "end":
                return _context438.stop();
            }
          }
        }, _callee437);
      }));

      return function (_x756, _x757) {
        return _ref481.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "unban",
    /*#__PURE__*/
    function () {
      var _ref482 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee438(t2, e2) {
        var i, a, r2, s;
        return _regeneratorRuntime.wrap(function _callee438$(_context439) {
          while (1) {
            switch (_context439.prev = _context439.next) {
              case 0:
                i = "/membership/unban/".concat(t2) + _this129.apiSignInUrl, a = "There was a problem unbanning the following users: ".concat(e2.join(",")), r2 = "POST", s = {
                  profiles: e2
                };
                _context439.next = 3;
                return _this129.fetchWithAuth(i, a, r2, s);

              case 3:
                return _context439.abrupt("return", _context439.sent.data);

              case 4:
              case "end":
                return _context439.stop();
            }
          }
        }, _callee438);
      }));

      return function (_x758, _x759) {
        return _ref482.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "join",
    /*#__PURE__*/
    function () {
      var _ref483 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee439(t2) {
        var e2, i, a, r2;
        return _regeneratorRuntime.wrap(function _callee439$(_context440) {
          while (1) {
            switch (_context440.prev = _context440.next) {
              case 0:
                e2 = "/membership/join" + _this129.apiSignInUrl + "&invitation_code=".concat(t2);
                i = "There was a problem joining league";
                a = "POST";
                _context440.next = 5;
                return _this129.fetchWithAuth(e2, i, a);

              case 5:
                r2 = _context440.sent;
                return _context440.abrupt("return", _this129.remapper.remapToAcceptPrivateLeague(r2.data));

              case 7:
              case "end":
                return _context440.stop();
            }
          }
        }, _callee439);
      }));

      return function (_x760) {
        return _ref483.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "leave",
    /*#__PURE__*/
    function () {
      var _ref484 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee440(t2, e2) {
        var i, r2, s;
        return _regeneratorRuntime.wrap(function _callee440$(_context441) {
          while (1) {
            switch (_context441.prev = _context441.next) {
              case 0:
                i = "/membership/leave/".concat(t2) + _this129.apiSignInUrl, r2 = "There was a problem leaving the following ".concat(e2 === "PRIVATE_LEAGUE" ? "league" : "challenge", ": ").concat(t2), s = "POST";
                _context441.next = 3;
                return _this129.fetchWithAuth(i, r2, s);

              case 3:
                return _context441.abrupt("return", _context441.sent.data);

              case 4:
              case "end":
                return _context441.stop();
            }
          }
        }, _callee440);
      }));

      return function (_x761, _x762) {
        return _ref484.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "getInvitations",
    /*#__PURE__*/
    function () {
      var _ref485 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee441(t2, e2) {
        var i, r2, s;
        return _regeneratorRuntime.wrap(function _callee441$(_context442) {
          while (1) {
            switch (_context442.prev = _context442.next) {
              case 0:
                i = "/membership/invitations" + _this129.apiSignInUrl + e2.constructMainFiltersUrl();
                r2 = "There was a problem getting invitations for ".concat(t2 === "PRIVATE_LEAGUE" ? "leagues" : "challenges");
                _context442.next = 4;
                return _this129.fetchWithAuth(i, r2);

              case 4:
                s = _context442.sent;
                return _context442.abrupt("return", _this129.remapper.remapToPrivateLeagues(s));

              case 6:
              case "end":
                return _context442.stop();
            }
          }
        }, _callee441);
      }));

      return function (_x763, _x764) {
        return _ref485.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "getReportedPosts",
    /*#__PURE__*/
    function () {
      var _ref486 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee442(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee442$(_context443) {
          while (1) {
            switch (_context443.prev = _context443.next) {
              case 0:
                i = "/discussions/".concat(t2, "/posts/reported").concat(_this129.apiSignInUrl), a = "There was a problem fetching posts for the following: ".concat(t2);
                e2 && (i += e2.constructMainFiltersUrl());
                _context443.next = 4;
                return _this129.fetchWithAuthNewBaseURL(_this129.discussionsBaseURL, i, a);

              case 4:
                r2 = _context443.sent;
                return _context443.abrupt("return", _this129.discussionsRemapper.remapToPostsForDiscussion(r2, "full"));

              case 6:
              case "end":
                return _context443.stop();
            }
          }
        }, _callee442);
      }));

      return function (_x765, _x766) {
        return _ref486.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "getPredictions",
    /*#__PURE__*/
    function () {
      var _ref487 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee443(t2, e2) {
        var i, a, r2;
        return _regeneratorRuntime.wrap(function _callee443$(_context444) {
          while (1) {
            switch (_context444.prev = _context444.next) {
              case 0:
                i = "/leagues/".concat(t2, "/predictions") + _this129.apiSignInUrl, a = "There was a problem getting predictions for private league: ".concat(t2);
                e2 && (i += e2.constructFiltersUrl());
                _context444.next = 4;
                return _this129.fetchWithAuth(i, a);

              case 4:
                r2 = _context444.sent;
                return _context444.abrupt("return", _this129.remapper.remapPredictions(r2));

              case 6:
              case "end":
                return _context444.stop();
            }
          }
        }, _callee443);
      }));

      return function (_x767, _x768) {
        return _ref487.apply(this, arguments);
      };
    }());

    __publicField(_assertThisInitialized3(_this129), "moderatePost",
    /*#__PURE__*/
    function () {
      var _ref488 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee444(t2, e2) {
        var i, a, r2, s, p2;
        return _regeneratorRuntime.wrap(function _callee444$(_context445) {
          while (1) {
            switch (_context445.prev = _context445.next) {
              case 0:
                i = "/posts/".concat(t2, "/admin/moderate").concat(_this129.apiSignInUrl);
                a = "There was a problem moderating the following post: ".concat(t2);
                r2 = "POST";
                s = {
                  moderation_reason: e2
                };
                _context445.next = 6;
                return _this129.fetchWithAuthNewBaseURL(_this129.discussionsBaseURL, i, a, r2, s);

              case 6:
                p2 = _context445.sent;
                return _context445.abrupt("return", _this129.discussionsRemapper.remapToPostByIdBasic(p2.data));

              case 8:
              case "end":
                return _context445.stop();
            }
          }
        }, _callee444);
      }));

      return function (_x769, _x770) {
        return _ref488.apply(this, arguments);
      };
    }());

    _this129.discussionsBaseURL = R(t2.environment, "discussions"), _this129.remapper = new ro(), _this129.discussionsRemapper = new ve();
    return _this129;
  }

  return Te;
}(_);

var _e = function _e() {
  _classCallCheck3(this, _e);

  __publicField(this, "name", "");

  __publicField(this, "description", "");

  __publicField(this, "invitation_code", "");

  __publicField(this, "template_id", "");

  __publicField(this, "users_can_invite_users", false);

  __publicField(this, "administrators", []);

  __publicField(this, "scoring_starts_at", "");
};

var oo =
/*#__PURE__*/
function (_e16) {
  _inherits3(oo, _e16);

  function oo() {
    var _this130;

    _classCallCheck3(this, oo);

    _this130 = _possibleConstructorReturn3(this, _getPrototypeOf4(oo).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this130), "type", "ONE_VS_ONE");

    return _this130;
  }

  return oo;
}(_e);

var so =
/*#__PURE__*/
function (_e17) {
  _inherits3(so, _e17);

  function so() {
    var _this131;

    _classCallCheck3(this, so);

    _this131 = _possibleConstructorReturn3(this, _getPrototypeOf4(so).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this131), "type", "PRIVATE");

    return _this131;
  }

  return so;
}(_e);

var Fe = function Fe() {
  _classCallCheck3(this, Fe);

  __publicField(this, "name", "");

  __publicField(this, "description", "");

  __publicField(this, "invitation_code", "");

  __publicField(this, "template_id", "");

  __publicField(this, "users_can_invite_users", false);

  __publicField(this, "administrators", []);

  __publicField(this, "pinned_posts", []);

  __publicField(this, "scoring_starts_at", "");
};

var no =
/*#__PURE__*/
function (_Fe) {
  _inherits3(no, _Fe);

  function no() {
    var _this132;

    _classCallCheck3(this, no);

    _this132 = _possibleConstructorReturn3(this, _getPrototypeOf4(no).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this132), "type", "PRIVATE");

    return _this132;
  }

  return no;
}(Fe);

var lo =
/*#__PURE__*/
function (_Fe2) {
  _inherits3(lo, _Fe2);

  function lo() {
    var _this133;

    _classCallCheck3(this, lo);

    _this133 = _possibleConstructorReturn3(this, _getPrototypeOf4(lo).apply(this, arguments));

    __publicField(_assertThisInitialized3(_this133), "type", "ONE_VS_ONE");

    return _this133;
  }

  return lo;
}(Fe);

var Ee = function Ee() {
  _classCallCheck3(this, Ee);

  __publicField(this, "createRequestBodyFromParam", function (t2, e2) {
    var i = e2 === "PRIVATE" ? new so() : new oo();
    return i.name = t2.name, i.description = t2.description, i.invitation_code = t2.invitationCode, i.template_id = t2.templateId, i.users_can_invite_users = t2.usersCanInviteUsers, t2.administrators ? i.administrators = t2.administrators : delete i.administrators, t2.scoringStartsAt ? i.scoring_starts_at = t2.scoringStartsAt : delete i.scoring_starts_at, i;
  });

  __publicField(this, "createUpdateRequestBodyFromParam", function (t2, e2) {
    var i = e2 === "PRIVATE" ? new no() : new lo();
    return i.name = t2.name, i.description = t2.description, i.invitation_code = t2.invitationCode, i.template_id = t2.templateId, i.users_can_invite_users = t2.usersCanInviteUsers, i.administrators = t2.administrators, i.pinned_posts = t2.pinnedPosts, i.scoring_starts_at = t2.scoringStartsAt, i;
  });
};

var Re =
/*#__PURE__*/
function (_N4) {
  _inherits3(Re, _N4);

  function Re(t2) {
    var _this134;

    _classCallCheck3(this, Re);

    _this134 = _possibleConstructorReturn3(this, _getPrototypeOf4(Re).call(this, t2));

    __publicField(_assertThisInitialized3(_this134), "type", null);

    __publicField(_assertThisInitialized3(_this134), "constructMainFiltersUrl", function () {
      var t2 = _get2(_getPrototypeOf4(Re.prototype), "constructMainFiltersUrl", _assertThisInitialized3(_this134)).call(_assertThisInitialized3(_this134));

      return _this134.type && (t2 += "&type=".concat(_this134.type)), t2;
    });

    _this134.type = t2 && t2.type ? t2.type : null;
    return _this134;
  }

  return Re;
}(N);

var po = function po(t2) {
  var _this135 = this;

  _classCallCheck3(this, po);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "leagueId", null);

  __publicField(this, "templateId", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "constructFiltersUrl", function () {
    var t2 = "";
    return _this135.limit && (t2 += "&limit=".concat(_this135.limit)), _this135.page && (t2 += "&page=".concat(_this135.page)), _this135.leagueId && (t2 += "&league_id=".concat(_this135.leagueId)), _this135.templateId && (t2 += "&template_id=".concat(_this135.templateId)), _this135.sortOrder && (t2 += "&sort_order=".concat(_this135.sortOrder)), t2;
  });

  this.limit = t2 && t2.limit ? t2.limit : null, this.page = t2 && t2.page ? t2.page : null, this.leagueId = t2 && t2.leagueId ? t2.leagueId : null, this.templateId = t2 && t2.templateId ? t2.templateId : null, this.sortOrder = t2 && t2.sortOrder ? t2.sortOrder : null;
};

var Se =
/*#__PURE__*/
function (_N5) {
  _inherits3(Se, _N5);

  function Se(t2) {
    var _this136;

    _classCallCheck3(this, Se);

    _this136 = _possibleConstructorReturn3(this, _getPrototypeOf4(Se).call(this, t2));

    __publicField(_assertThisInitialized3(_this136), "reportsCount", null);

    __publicField(_assertThisInitialized3(_this136), "constructMainFiltersUrl", function () {
      var t2 = _get2(_getPrototypeOf4(Se.prototype), "constructMainFiltersUrl", _assertThisInitialized3(_this136)).call(_assertThisInitialized3(_this136));

      return _this136.reportsCount && (t2 += "&reports_count=".concat(_this136.reportsCount)), t2;
    });

    _this136.reportsCount = t2.reportsCount ? t2.reportsCount : null;
    return _this136;
  }

  return Se;
}(N);

var Ce = function Ce(t2) {
  var _this137 = this;

  _classCallCheck3(this, Ce);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "profileIds", null);

  __publicField(this, "constructFiltersUrl", function () {
    var t2 = "";
    return _this137.limit && (t2 += "&limit=".concat(_this137.limit)), _this137.page && (t2 += "&page=".concat(_this137.page)), _this137.profileIds && (t2 += "&profile_ids=".concat(_this137.profileIds.join(","))), t2;
  });

  this.limit = t2 && t2.limit ? t2.limit : null, this.page = t2 && t2.page ? t2.page : null, this.profileIds = t2 && t2.profileIds ? t2.leagueId : null;
};

var Ae = function Ae(t2) {
  var _this138 = this;

  _classCallCheck3(this, Ae);

  __publicField(this, "loyalty", null);

  __publicField(this, "profile", null);

  __publicField(this, "predictor", null);

  __publicField(this, "setTemplateModels",
  /*#__PURE__*/
  function () {
    var _ref489 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee445(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee445$(_context446) {
        while (1) {
          switch (_context446.prev = _context446.next) {
            case 0:
              _context446.next = 2;
              return _this138.loyalty.getTemplates();

            case 2:
              e2 = _context446.sent;
              t2.templateModel = e2.data.find(function (i) {
                return i.id === t2.templateId;
              }), t2.pastTemplates && t2.pastTemplates.length > 0 && t2.pastTemplates.forEach(function (i) {
                i.model = e2.data.find(function (a) {
                  return a.id === i.id;
                });
              });

            case 4:
            case "end":
              return _context446.stop();
          }
        }
      }, _callee445);
    }));

    return function (_x771) {
      return _ref489.apply(this, arguments);
    };
  }());

  __publicField(this, "setTemplateModelsInLeagues",
  /*#__PURE__*/
  function () {
    var _ref490 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee446(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee446$(_context447) {
        while (1) {
          switch (_context447.prev = _context447.next) {
            case 0:
              _context447.next = 2;
              return _this138.loyalty.getTemplates();

            case 2:
              e2 = _context447.sent;
              t2.forEach(function (i) {
                i.templateModel = e2.data.find(function (a) {
                  return a.id === i.templateId;
                }), i.pastTemplates && i.pastTemplates.length > 0 && i.pastTemplates.forEach(function (a) {
                  a.model = e2.data.find(function (r2) {
                    return r2.id === a.id;
                  });
                });
              });

            case 4:
            case "end":
              return _context447.stop();
          }
        }
      }, _callee446);
    }));

    return function (_x772) {
      return _ref490.apply(this, arguments);
    };
  }());

  __publicField(this, "setTemplateModelsFromLeagueModels", function (t2, e2) {
    if (e2 === "PRIVATE_LEAGUE") {
      t2.forEach(function (i) {
        i.templateModel = i.templateId === i.privateLeagueModel.templateId ? i.privateLeagueModel.templateModel : i.privateLeagueModel.pastTemplates.find(function (a) {
          return a.id === i.templateId;
        }).model;
      });
      return;
    }

    t2.forEach(function (i) {
      i.templateModel = i.templateId === i.challengeModel.templateId ? i.challengeModel.templateModel : i.challengeModel.pastTemplates.find(function (a) {
        return a.id === i.templateId;
      }).model;
    });
  });

  __publicField(this, "setProfileModel",
  /*#__PURE__*/
  function () {
    var _ref491 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee447(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee447$(_context448) {
        while (1) {
          switch (_context448.prev = _context448.next) {
            case 0:
              _context448.next = 2;
              return _this138.profile.getById(t2.profileId).getInfo();

            case 2:
              e2 = _context448.sent;
              t2.profileModel = e2;

            case 4:
            case "end":
              return _context448.stop();
          }
        }
      }, _callee447);
    }));

    return function (_x773) {
      return _ref491.apply(this, arguments);
    };
  }());

  __publicField(this, "setModelsForPredictions",
  /*#__PURE__*/
  function () {
    var _ref492 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee448(t2) {
      var e2, _i58, a, r2;

      return _regeneratorRuntime.wrap(function _callee448$(_context449) {
        while (1) {
          switch (_context449.prev = _context449.next) {
            case 0:
              if (!t2.data.length) {
                _context449.next = 10;
                break;
              }

              e2 = t2.data.map(function (s) {
                return s.profileId;
              });
              _i58 = t2.data.map(function (s) {
                return s.predictionId;
              });
              _context449.next = 5;
              return _this138.getProfileModels(e2);

            case 5:
              a = _context449.sent;
              _context449.next = 8;
              return _this138.getPredictionModels(_i58);

            case 8:
              r2 = _context449.sent;
              t2.data.forEach(function (s) {
                s.profileModel = a.find(function (p2) {
                  return p2.id === s.profileId;
                }), s.predictionModel = r2.find(function (p2) {
                  return p2.id === s.predictionId;
                });
              });

            case 10:
              return _context449.abrupt("return", t2);

            case 11:
            case "end":
              return _context449.stop();
          }
        }
      }, _callee448);
    }));

    return function (_x774) {
      return _ref492.apply(this, arguments);
    };
  }());

  __publicField(this, "getProfileModels",
  /*#__PURE__*/
  function () {
    var _ref493 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee449(t2) {
      return _regeneratorRuntime.wrap(function _callee449$(_context450) {
        while (1) {
          switch (_context450.prev = _context450.next) {
            case 0:
              _context450.next = 2;
              return _this138.profile.getByIds(t2);

            case 2:
              return _context450.abrupt("return", _context450.sent);

            case 3:
            case "end":
              return _context450.stop();
          }
        }
      }, _callee449);
    }));

    return function (_x775) {
      return _ref493.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictionModels",
  /*#__PURE__*/
  function () {
    var _ref494 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee450(t2) {
      return _regeneratorRuntime.wrap(function _callee450$(_context451) {
        while (1) {
          switch (_context451.prev = _context451.next) {
            case 0:
              _context451.next = 2;
              return _this138.predictor.getPredictionsByIds(t2);

            case 2:
              return _context451.abrupt("return", _context451.sent);

            case 3:
            case "end":
              return _context451.stop();
          }
        }
      }, _callee450);
    }));

    return function (_x776) {
      return _ref494.apply(this, arguments);
    };
  }());

  this.loyalty = new Me(t2), this.profile = new L(t2), this.predictor = new me(t2);
};

var co = function co(t2) {
  var _this139 = this;

  _classCallCheck3(this, co);

  __publicField(this, "factory", null);

  __publicField(this, "privateLeagueHttps", null);

  __publicField(this, "loyaltyHttps", null);

  __publicField(this, "profile", null);

  __publicField(this, "service", null);

  __publicField(this, "discussionsService", null);

  __publicField(this, "create",
  /*#__PURE__*/
  function () {
    var _ref495 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee451(t2) {
      var e2, i;
      return _regeneratorRuntime.wrap(function _callee451$(_context452) {
        while (1) {
          switch (_context452.prev = _context452.next) {
            case 0:
              e2 = _this139.factory.createRequestBodyFromParam(t2, "PRIVATE");
              _context452.next = 3;
              return _this139.privateLeagueHttps.create(e2, "PRIVATE_LEAGUE");

            case 3:
              i = _context452.sent;
              _context452.next = 6;
              return _this139.service.setTemplateModels(i);

            case 6:
              return _context452.abrupt("return", i);

            case 7:
            case "end":
              return _context452.stop();
          }
        }
      }, _callee451);
    }));

    return function (_x777) {
      return _ref495.apply(this, arguments);
    };
  }());

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref496 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee452(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee452$(_context453) {
        while (1) {
          switch (_context453.prev = _context453.next) {
            case 0:
              _context453.next = 2;
              return _this139.privateLeagueHttps.getById(t2, "PRIVATE_LEAGUE", e2);

            case 2:
              i = _context453.sent;
              _context453.next = 5;
              return _this139.service.setTemplateModels(i);

            case 5:
              return _context453.abrupt("return", i);

            case 6:
            case "end":
              return _context453.stop();
          }
        }
      }, _callee452);
    }));

    return function (_x778, _x779) {
      return _ref496.apply(this, arguments);
    };
  }());

  __publicField(this, "update",
  /*#__PURE__*/
  function () {
    var _ref497 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee453(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee453$(_context454) {
        while (1) {
          switch (_context454.prev = _context454.next) {
            case 0:
              i = _this139.factory.createUpdateRequestBodyFromParam(e2, "PRIVATE");
              _context454.next = 3;
              return _this139.privateLeagueHttps.update(t2, i, "PRIVATE_LEAGUE");

            case 3:
              a = _context454.sent;
              _context454.next = 6;
              return _this139.service.setTemplateModels(a);

            case 6:
              return _context454.abrupt("return", a);

            case 7:
            case "end":
              return _context454.stop();
          }
        }
      }, _callee453);
    }));

    return function (_x780, _x781) {
      return _ref497.apply(this, arguments);
    };
  }());

  __publicField(this, "updateTemplate",
  /*#__PURE__*/
  function () {
    var _ref498 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee454(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee454$(_context455) {
        while (1) {
          switch (_context455.prev = _context455.next) {
            case 0:
              _context455.next = 2;
              return _this139.privateLeagueHttps.updateLeagueTemplate(t2, e2, i, "PRIVATE_LEAGUE");

            case 2:
              a = _context455.sent;
              _context455.next = 5;
              return _this139.service.setTemplateModels(a);

            case 5:
              return _context455.abrupt("return", a);

            case 6:
            case "end":
              return _context455.stop();
          }
        }
      }, _callee454);
    }));

    return function (_x782, _x783, _x784) {
      return _ref498.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref499 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee455(t2) {
      return _regeneratorRuntime.wrap(function _callee455$(_context456) {
        while (1) {
          switch (_context456.prev = _context456.next) {
            case 0:
              _context456.next = 2;
              return _this139.privateLeagueHttps.delete(t2, "PRIVATE_LEAGUE");

            case 2:
              return _context456.abrupt("return", _context456.sent);

            case 3:
            case "end":
              return _context456.stop();
          }
        }
      }, _callee455);
    }));

    return function (_x785) {
      return _ref499.apply(this, arguments);
    };
  }());

  __publicField(this, "invite",
  /*#__PURE__*/
  function () {
    var _ref500 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee456(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee456$(_context457) {
        while (1) {
          switch (_context457.prev = _context457.next) {
            case 0:
              _context457.next = 2;
              return _this139.privateLeagueHttps.invite(t2, e2);

            case 2:
              return _context457.abrupt("return", _context457.sent);

            case 3:
            case "end":
              return _context457.stop();
          }
        }
      }, _callee456);
    }));

    return function (_x786, _x787) {
      return _ref500.apply(this, arguments);
    };
  }());

  __publicField(this, "deleteInvitation",
  /*#__PURE__*/
  function () {
    var _ref501 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee457(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee457$(_context458) {
        while (1) {
          switch (_context458.prev = _context458.next) {
            case 0:
              _context458.next = 2;
              return _this139.privateLeagueHttps.deleteInvitation(t2, e2);

            case 2:
              return _context458.abrupt("return", _context458.sent);

            case 3:
            case "end":
              return _context458.stop();
          }
        }
      }, _callee457);
    }));

    return function (_x788, _x789) {
      return _ref501.apply(this, arguments);
    };
  }());

  __publicField(this, "accept",
  /*#__PURE__*/
  function () {
    var _ref502 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee458(t2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee458$(_context459) {
        while (1) {
          switch (_context459.prev = _context459.next) {
            case 0:
              _context459.next = 2;
              return _this139.privateLeagueHttps.accept(t2, true, "PRIVATE_LEAGUE");

            case 2:
              i = _context459.sent;
              _context459.next = 5;
              return _this139.finalizeAcceptModel(i, true);

            case 5:
              return _context459.abrupt("return", _context459.sent);

            case 6:
            case "end":
              return _context459.stop();
          }
        }
      }, _callee458);
    }));

    return function (_x790) {
      return _ref502.apply(this, arguments);
    };
  }());

  __publicField(this, "reject",
  /*#__PURE__*/
  function () {
    var _ref503 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee459(t2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee459$(_context460) {
        while (1) {
          switch (_context460.prev = _context460.next) {
            case 0:
              _context460.next = 2;
              return _this139.privateLeagueHttps.accept(t2, false, "PRIVATE_LEAGUE");

            case 2:
              i = _context460.sent;
              _context460.next = 5;
              return _this139.finalizeAcceptModel(i, false);

            case 5:
              return _context460.abrupt("return", _context460.sent);

            case 6:
            case "end":
              return _context460.stop();
          }
        }
      }, _callee459);
    }));

    return function (_x791) {
      return _ref503.apply(this, arguments);
    };
  }());

  __publicField(this, "banUsers",
  /*#__PURE__*/
  function () {
    var _ref504 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee460(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee460$(_context461) {
        while (1) {
          switch (_context461.prev = _context461.next) {
            case 0:
              _context461.next = 2;
              return _this139.privateLeagueHttps.ban(t2, e2);

            case 2:
              return _context461.abrupt("return", _context461.sent);

            case 3:
            case "end":
              return _context461.stop();
          }
        }
      }, _callee460);
    }));

    return function (_x792, _x793) {
      return _ref504.apply(this, arguments);
    };
  }());

  __publicField(this, "unbanUsers",
  /*#__PURE__*/
  function () {
    var _ref505 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee461(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee461$(_context462) {
        while (1) {
          switch (_context462.prev = _context462.next) {
            case 0:
              _context462.next = 2;
              return _this139.privateLeagueHttps.unban(t2, e2);

            case 2:
              return _context462.abrupt("return", _context462.sent);

            case 3:
            case "end":
              return _context462.stop();
          }
        }
      }, _callee461);
    }));

    return function (_x794, _x795) {
      return _ref505.apply(this, arguments);
    };
  }());

  __publicField(this, "join",
  /*#__PURE__*/
  function () {
    var _ref506 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee462(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee462$(_context463) {
        while (1) {
          switch (_context463.prev = _context463.next) {
            case 0:
              _context463.next = 2;
              return _this139.privateLeagueHttps.join(t2);

            case 2:
              e2 = _context463.sent;
              _context463.next = 5;
              return _this139.finalizeAcceptModel(e2, true);

            case 5:
              return _context463.abrupt("return", _context463.sent);

            case 6:
            case "end":
              return _context463.stop();
          }
        }
      }, _callee462);
    }));

    return function (_x796) {
      return _ref506.apply(this, arguments);
    };
  }());

  __publicField(this, "leave",
  /*#__PURE__*/
  function () {
    var _ref507 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee463(t2) {
      return _regeneratorRuntime.wrap(function _callee463$(_context464) {
        while (1) {
          switch (_context464.prev = _context464.next) {
            case 0:
              _context464.next = 2;
              return _this139.privateLeagueHttps.leave(t2, "PRIVATE_LEAGUE");

            case 2:
              return _context464.abrupt("return", _context464.sent);

            case 3:
            case "end":
              return _context464.stop();
          }
        }
      }, _callee463);
    }));

    return function (_x797) {
      return _ref507.apply(this, arguments);
    };
  }());

  __publicField(this, "finalizeAcceptModel",
  /*#__PURE__*/
  function () {
    var _ref508 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee464(t2, e2) {
      var _i59;

      return _regeneratorRuntime.wrap(function _callee464$(_context465) {
        while (1) {
          switch (_context465.prev = _context465.next) {
            case 0:
              if (!e2) {
                _context465.next = 5;
                break;
              }

              _context465.next = 3;
              return _this139.getById(t2.leagueId);

            case 3:
              _i59 = _context465.sent;
              t2.leagueModel = _i59;

            case 5:
              _context465.next = 7;
              return _this139.service.setProfileModel(t2);

            case 7:
              return _context465.abrupt("return", t2);

            case 8:
            case "end":
              return _context465.stop();
          }
        }
      }, _callee464);
    }));

    return function (_x798, _x799) {
      return _ref508.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyLeagues",
  /*#__PURE__*/
  function () {
    var _ref509 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee465(t2) {
      var e2, i, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, a, r2;

      return _regeneratorRuntime.wrap(function _callee465$(_context466) {
        while (1) {
          switch (_context466.prev = _context466.next) {
            case 0:
              t2 && (t2 = new po(t2));
              _context466.next = 3;
              return _this139.profile.getOwn().getInfo();

            case 3:
              e2 = _context466.sent;
              _context466.next = 6;
              return _this139.loyaltyHttps.getUserRankingsForPrivateLeagueAndChallenges(e2.id, "PRIVATE_LEAGUE", t2);

            case 6:
              i = _context466.sent;
              _iteratorNormalCompletion20 = true;
              _didIteratorError20 = false;
              _iteratorError20 = undefined;
              _context466.prev = 10;
              _iterator20 = i.data[Symbol.iterator]();

            case 12:
              if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                _context466.next = 21;
                break;
              }

              a = _step20.value;
              _context466.next = 16;
              return _this139.getById(a.privateLeagueId);

            case 16:
              r2 = _context466.sent;
              a.privateLeagueModel = r2;

            case 18:
              _iteratorNormalCompletion20 = true;
              _context466.next = 12;
              break;

            case 21:
              _context466.next = 27;
              break;

            case 23:
              _context466.prev = 23;
              _context466.t0 = _context466["catch"](10);
              _didIteratorError20 = true;
              _iteratorError20 = _context466.t0;

            case 27:
              _context466.prev = 27;
              _context466.prev = 28;

              if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                _iterator20.return();
              }

            case 30:
              _context466.prev = 30;

              if (!_didIteratorError20) {
                _context466.next = 33;
                break;
              }

              throw _iteratorError20;

            case 33:
              return _context466.finish(30);

            case 34:
              return _context466.finish(27);

            case 35:
              return _context466.abrupt("return", (_this139.service.setTemplateModelsFromLeagueModels(i.data, "PRIVATE_LEAGUE"), i));

            case 36:
            case "end":
              return _context466.stop();
          }
        }
      }, _callee465, null, [[10, 23, 27, 35], [28,, 30, 34]]);
    }));

    return function (_x800) {
      return _ref509.apply(this, arguments);
    };
  }());

  __publicField(this, "getInvitations",
  /*#__PURE__*/
  function () {
    var _ref510 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee466(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee466$(_context467) {
        while (1) {
          switch (_context467.prev = _context467.next) {
            case 0:
              t2 = new Re(t2), t2.type = "PRIVATE";
              _context467.next = 3;
              return _this139.privateLeagueHttps.getInvitations("PRIVATE_LEAGUE", t2);

            case 3:
              e2 = _context467.sent;
              _context467.next = 6;
              return _this139.service.setTemplateModelsInLeagues(e2.data);

            case 6:
              return _context467.abrupt("return", e2);

            case 7:
            case "end":
              return _context467.stop();
          }
        }
      }, _callee466);
    }));

    return function (_x801) {
      return _ref510.apply(this, arguments);
    };
  }());

  __publicField(this, "getReportedPosts",
  /*#__PURE__*/
  function () {
    var _ref511 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee467(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee467$(_context468) {
        while (1) {
          switch (_context468.prev = _context468.next) {
            case 0:
              e2 && (e2 = new Se(e2));
              _context468.next = 3;
              return _this139.privateLeagueHttps.getReportedPosts(t2, e2);

            case 3:
              i = _context468.sent;
              _context468.next = 6;
              return _this139.discussionsService.finalizePostFullModel(i.data);

            case 6:
              i.data = _context468.sent;
              return _context468.abrupt("return", i);

            case 8:
            case "end":
              return _context468.stop();
          }
        }
      }, _callee467);
    }));

    return function (_x802, _x803) {
      return _ref511.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictions",
  /*#__PURE__*/
  function () {
    var _ref512 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee468(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee468$(_context469) {
        while (1) {
          switch (_context469.prev = _context469.next) {
            case 0:
              if (!e2) {
                _context469.next = 4;
                break;
              }

              if (!(e2.limit && e2.limit > 20)) {
                _context469.next = 3;
                break;
              }

              throw new u(400, "invalid_limit", "Invalid limit filter. The maximum limit is 20");

            case 3:
              e2 = new Ce(e2);

            case 4:
              _context469.next = 6;
              return _this139.privateLeagueHttps.getPredictions(t2, e2);

            case 6:
              i = _context469.sent;
              _context469.next = 9;
              return _this139.service.setModelsForPredictions(i);

            case 9:
              return _context469.abrupt("return", _context469.sent);

            case 10:
            case "end":
              return _context469.stop();
          }
        }
      }, _callee468);
    }));

    return function (_x804, _x805) {
      return _ref512.apply(this, arguments);
    };
  }());

  __publicField(this, "moderatePost",
  /*#__PURE__*/
  function () {
    var _ref513 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee469(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee469$(_context470) {
        while (1) {
          switch (_context470.prev = _context470.next) {
            case 0:
              _context470.next = 2;
              return _this139.privateLeagueHttps.moderatePost(t2, e2);

            case 2:
              return _context470.abrupt("return", _context470.sent);

            case 3:
            case "end":
              return _context470.stop();
          }
        }
      }, _callee469);
    }));

    return function (_x806, _x807) {
      return _ref513.apply(this, arguments);
    };
  }());

  this.factory = new Ee(), this.privateLeagueHttps = new Te(t2), this.loyaltyHttps = new Mt(t2), this.profile = new L(t2), this.service = new Ae(t2), this.discussionsService = new wt(t2);
};

var mo = function mo(t2) {
  var _this140 = this;

  _classCallCheck3(this, mo);

  __publicField(this, "privateLeaguesFacade", null);

  __publicField(this, "create",
  /*#__PURE__*/
  function () {
    var _ref514 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee470(t2) {
      return _regeneratorRuntime.wrap(function _callee470$(_context471) {
        while (1) {
          switch (_context471.prev = _context471.next) {
            case 0:
              _context471.next = 2;
              return _this140.privateLeaguesFacade.create(t2);

            case 2:
              return _context471.abrupt("return", _context471.sent);

            case 3:
            case "end":
              return _context471.stop();
          }
        }
      }, _callee470);
    }));

    return function (_x808) {
      return _ref514.apply(this, arguments);
    };
  }());

  __publicField(this, "update",
  /*#__PURE__*/
  function () {
    var _ref515 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee471(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee471$(_context472) {
        while (1) {
          switch (_context472.prev = _context472.next) {
            case 0:
              _context472.next = 2;
              return _this140.privateLeaguesFacade.update(t2, e2);

            case 2:
              return _context472.abrupt("return", _context472.sent);

            case 3:
            case "end":
              return _context472.stop();
          }
        }
      }, _callee471);
    }));

    return function (_x809, _x810) {
      return _ref515.apply(this, arguments);
    };
  }());

  __publicField(this, "updateTemplate",
  /*#__PURE__*/
  function () {
    var _ref516 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee472(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee472$(_context473) {
        while (1) {
          switch (_context473.prev = _context473.next) {
            case 0:
              _context473.next = 2;
              return _this140.privateLeaguesFacade.updateTemplate(t2, e2, i);

            case 2:
              return _context473.abrupt("return", _context473.sent);

            case 3:
            case "end":
              return _context473.stop();
          }
        }
      }, _callee472);
    }));

    return function (_x811, _x812, _x813) {
      return _ref516.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref517 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee473(t2) {
      return _regeneratorRuntime.wrap(function _callee473$(_context474) {
        while (1) {
          switch (_context474.prev = _context474.next) {
            case 0:
              _context474.next = 2;
              return _this140.privateLeaguesFacade.delete(t2);

            case 2:
              return _context474.abrupt("return", _context474.sent);

            case 3:
            case "end":
              return _context474.stop();
          }
        }
      }, _callee473);
    }));

    return function (_x814) {
      return _ref517.apply(this, arguments);
    };
  }());

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref518 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee474(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee474$(_context475) {
        while (1) {
          switch (_context475.prev = _context475.next) {
            case 0:
              _context475.next = 2;
              return _this140.privateLeaguesFacade.getById(t2, e2);

            case 2:
              return _context475.abrupt("return", _context475.sent);

            case 3:
            case "end":
              return _context475.stop();
          }
        }
      }, _callee474);
    }));

    return function (_x815, _x816) {
      return _ref518.apply(this, arguments);
    };
  }());

  __publicField(this, "invite",
  /*#__PURE__*/
  function () {
    var _ref519 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee475(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee475$(_context476) {
        while (1) {
          switch (_context476.prev = _context476.next) {
            case 0:
              _context476.next = 2;
              return _this140.privateLeaguesFacade.invite(t2, e2);

            case 2:
              return _context476.abrupt("return", _context476.sent);

            case 3:
            case "end":
              return _context476.stop();
          }
        }
      }, _callee475);
    }));

    return function (_x817, _x818) {
      return _ref519.apply(this, arguments);
    };
  }());

  __publicField(this, "deleteInvitation",
  /*#__PURE__*/
  function () {
    var _ref520 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee476(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee476$(_context477) {
        while (1) {
          switch (_context477.prev = _context477.next) {
            case 0:
              _context477.next = 2;
              return _this140.privateLeaguesFacade.deleteInvitation(t2, e2);

            case 2:
              return _context477.abrupt("return", _context477.sent);

            case 3:
            case "end":
              return _context477.stop();
          }
        }
      }, _callee476);
    }));

    return function (_x819, _x820) {
      return _ref520.apply(this, arguments);
    };
  }());

  __publicField(this, "accept",
  /*#__PURE__*/
  function () {
    var _ref521 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee477(t2) {
      return _regeneratorRuntime.wrap(function _callee477$(_context478) {
        while (1) {
          switch (_context478.prev = _context478.next) {
            case 0:
              _context478.next = 2;
              return _this140.privateLeaguesFacade.accept(t2);

            case 2:
              return _context478.abrupt("return", _context478.sent);

            case 3:
            case "end":
              return _context478.stop();
          }
        }
      }, _callee477);
    }));

    return function (_x821) {
      return _ref521.apply(this, arguments);
    };
  }());

  __publicField(this, "reject",
  /*#__PURE__*/
  function () {
    var _ref522 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee478(t2) {
      return _regeneratorRuntime.wrap(function _callee478$(_context479) {
        while (1) {
          switch (_context479.prev = _context479.next) {
            case 0:
              _context479.next = 2;
              return _this140.privateLeaguesFacade.reject(t2);

            case 2:
              return _context479.abrupt("return", _context479.sent);

            case 3:
            case "end":
              return _context479.stop();
          }
        }
      }, _callee478);
    }));

    return function (_x822) {
      return _ref522.apply(this, arguments);
    };
  }());

  __publicField(this, "banUsers",
  /*#__PURE__*/
  function () {
    var _ref523 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee479(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee479$(_context480) {
        while (1) {
          switch (_context480.prev = _context480.next) {
            case 0:
              _context480.next = 2;
              return _this140.privateLeaguesFacade.banUsers(t2, e2);

            case 2:
              return _context480.abrupt("return", _context480.sent);

            case 3:
            case "end":
              return _context480.stop();
          }
        }
      }, _callee479);
    }));

    return function (_x823, _x824) {
      return _ref523.apply(this, arguments);
    };
  }());

  __publicField(this, "unbanUsers",
  /*#__PURE__*/
  function () {
    var _ref524 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee480(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee480$(_context481) {
        while (1) {
          switch (_context481.prev = _context481.next) {
            case 0:
              _context481.next = 2;
              return _this140.privateLeaguesFacade.unbanUsers(t2, e2);

            case 2:
              return _context481.abrupt("return", _context481.sent);

            case 3:
            case "end":
              return _context481.stop();
          }
        }
      }, _callee480);
    }));

    return function (_x825, _x826) {
      return _ref524.apply(this, arguments);
    };
  }());

  __publicField(this, "join",
  /*#__PURE__*/
  function () {
    var _ref525 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee481(t2) {
      return _regeneratorRuntime.wrap(function _callee481$(_context482) {
        while (1) {
          switch (_context482.prev = _context482.next) {
            case 0:
              _context482.next = 2;
              return _this140.privateLeaguesFacade.join(t2);

            case 2:
              return _context482.abrupt("return", _context482.sent);

            case 3:
            case "end":
              return _context482.stop();
          }
        }
      }, _callee481);
    }));

    return function (_x827) {
      return _ref525.apply(this, arguments);
    };
  }());

  __publicField(this, "leave",
  /*#__PURE__*/
  function () {
    var _ref526 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee482(t2) {
      return _regeneratorRuntime.wrap(function _callee482$(_context483) {
        while (1) {
          switch (_context483.prev = _context483.next) {
            case 0:
              _context483.next = 2;
              return _this140.privateLeaguesFacade.leave(t2);

            case 2:
              return _context483.abrupt("return", _context483.sent);

            case 3:
            case "end":
              return _context483.stop();
          }
        }
      }, _callee482);
    }));

    return function (_x828) {
      return _ref526.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyLeagues",
  /*#__PURE__*/
  function () {
    var _ref527 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee483(t2) {
      return _regeneratorRuntime.wrap(function _callee483$(_context484) {
        while (1) {
          switch (_context484.prev = _context484.next) {
            case 0:
              _context484.next = 2;
              return _this140.privateLeaguesFacade.getMyLeagues(t2);

            case 2:
              return _context484.abrupt("return", _context484.sent);

            case 3:
            case "end":
              return _context484.stop();
          }
        }
      }, _callee483);
    }));

    return function (_x829) {
      return _ref527.apply(this, arguments);
    };
  }());

  __publicField(this, "getInvitations",
  /*#__PURE__*/
  function () {
    var _ref528 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee484(t2) {
      return _regeneratorRuntime.wrap(function _callee484$(_context485) {
        while (1) {
          switch (_context485.prev = _context485.next) {
            case 0:
              _context485.next = 2;
              return _this140.privateLeaguesFacade.getInvitations(t2);

            case 2:
              return _context485.abrupt("return", _context485.sent);

            case 3:
            case "end":
              return _context485.stop();
          }
        }
      }, _callee484);
    }));

    return function (_x830) {
      return _ref528.apply(this, arguments);
    };
  }());

  __publicField(this, "getReportedPosts",
  /*#__PURE__*/
  function () {
    var _ref529 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee485(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee485$(_context486) {
        while (1) {
          switch (_context486.prev = _context486.next) {
            case 0:
              _context486.next = 2;
              return _this140.privateLeaguesFacade.getReportedPosts(t2, e2);

            case 2:
              return _context486.abrupt("return", _context486.sent);

            case 3:
            case "end":
              return _context486.stop();
          }
        }
      }, _callee485);
    }));

    return function (_x831, _x832) {
      return _ref529.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictions",
  /*#__PURE__*/
  function () {
    var _ref530 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee486(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee486$(_context487) {
        while (1) {
          switch (_context487.prev = _context487.next) {
            case 0:
              _context487.next = 2;
              return _this140.privateLeaguesFacade.getPredictions(t2, e2);

            case 2:
              return _context487.abrupt("return", _context487.sent);

            case 3:
            case "end":
              return _context487.stop();
          }
        }
      }, _callee486);
    }));

    return function (_x833, _x834) {
      return _ref530.apply(this, arguments);
    };
  }());

  __publicField(this, "moderatePost",
  /*#__PURE__*/
  function () {
    var _ref531 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee487(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee487$(_context488) {
        while (1) {
          switch (_context488.prev = _context488.next) {
            case 0:
              _context488.next = 2;
              return _this140.privateLeaguesFacade.moderatePost(t2, e2);

            case 2:
              return _context488.abrupt("return", _context488.sent);

            case 3:
            case "end":
              return _context488.stop();
          }
        }
      }, _callee487);
    }));

    return function (_x835, _x836) {
      return _ref531.apply(this, arguments);
    };
  }());

  this.privateLeaguesFacade = new co(t2);
};

var uo = function uo(t2) {
  var _this141 = this;

  _classCallCheck3(this, uo);

  __publicField(this, "limit", null);

  __publicField(this, "page", null);

  __publicField(this, "challengeId", null);

  __publicField(this, "templateId", null);

  __publicField(this, "sortOrder", null);

  __publicField(this, "constructFiltersUrl", function () {
    var t2 = "";
    return _this141.limit && (t2 += "&limit=".concat(_this141.limit)), _this141.page && (t2 += "&page=".concat(_this141.page)), _this141.challengeId && (t2 += "&league_id=".concat(_this141.challengeId)), _this141.templateId && (t2 += "&template_id=".concat(_this141.templateId)), _this141.sortOrder && (t2 += "&sort_order=".concat(_this141.sortOrder)), t2;
  });

  this.limit = t2 && t2.limit ? t2.limit : null, this.page = t2 && t2.page ? t2.page : null, this.challengeId = t2 && t2.challengeId ? t2.challengeId : null, this.templateId = t2 && t2.templateId ? t2.templateId : null, this.sortOrder = t2 && t2.sortOrder ? t2.sortOrder : null;
};

var ho = function ho(t2) {
  var _this142 = this;

  _classCallCheck3(this, ho);

  __publicField(this, "factory", null);

  __publicField(this, "https", null);

  __publicField(this, "loyaltyHttps", null);

  __publicField(this, "profile", null);

  __publicField(this, "service", null);

  __publicField(this, "discussionsService", null);

  __publicField(this, "issue",
  /*#__PURE__*/
  function () {
    var _ref532 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee488(t2, e2) {
      var i, a, r2;
      return _regeneratorRuntime.wrap(function _callee488$(_context489) {
        while (1) {
          switch (_context489.prev = _context489.next) {
            case 0:
              i = _this142.factory.createRequestBodyFromParam(t2, "ONE_VS_ONE");
              _context489.next = 3;
              return _this142.https.create(i, "CHALLENGE");

            case 3:
              a = _context489.sent;
              _context489.next = 6;
              return _this142.service.setTemplateModels(a);

            case 6:
              _context489.next = 8;
              return _this142.https.invite(a.id, [e2]);

            case 8:
              r2 = _context489.sent;
              return _context489.abrupt("return", (a.invites = [], a.invites.push(r2[0]), a));

            case 10:
            case "end":
              return _context489.stop();
          }
        }
      }, _callee488);
    }));

    return function (_x837, _x838) {
      return _ref532.apply(this, arguments);
    };
  }());

  __publicField(this, "update",
  /*#__PURE__*/
  function () {
    var _ref533 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee489(t2, e2) {
      var i, a;
      return _regeneratorRuntime.wrap(function _callee489$(_context490) {
        while (1) {
          switch (_context490.prev = _context490.next) {
            case 0:
              i = _this142.factory.createUpdateRequestBodyFromParam(e2, "ONE_VS_ONE");
              _context490.next = 3;
              return _this142.https.update(t2, i, "CHALLENGE");

            case 3:
              a = _context490.sent;
              _context490.next = 6;
              return _this142.service.setTemplateModels(a);

            case 6:
              return _context490.abrupt("return", a);

            case 7:
            case "end":
              return _context490.stop();
          }
        }
      }, _callee489);
    }));

    return function (_x839, _x840) {
      return _ref533.apply(this, arguments);
    };
  }());

  __publicField(this, "updateTemplate",
  /*#__PURE__*/
  function () {
    var _ref534 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee490(t2, e2, i) {
      var a;
      return _regeneratorRuntime.wrap(function _callee490$(_context491) {
        while (1) {
          switch (_context491.prev = _context491.next) {
            case 0:
              _context491.next = 2;
              return _this142.https.updateLeagueTemplate(t2, e2, i, "CHALLENGE");

            case 2:
              a = _context491.sent;
              _context491.next = 5;
              return _this142.service.setTemplateModels(a);

            case 5:
              return _context491.abrupt("return", a);

            case 6:
            case "end":
              return _context491.stop();
          }
        }
      }, _callee490);
    }));

    return function (_x841, _x842, _x843) {
      return _ref534.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref535 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee491(t2) {
      return _regeneratorRuntime.wrap(function _callee491$(_context492) {
        while (1) {
          switch (_context492.prev = _context492.next) {
            case 0:
              _context492.next = 2;
              return _this142.https.delete(t2, "CHALLENGE");

            case 2:
              return _context492.abrupt("return", _context492.sent);

            case 3:
            case "end":
              return _context492.stop();
          }
        }
      }, _callee491);
    }));

    return function (_x844) {
      return _ref535.apply(this, arguments);
    };
  }());

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref536 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee492(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee492$(_context493) {
        while (1) {
          switch (_context493.prev = _context493.next) {
            case 0:
              _context493.next = 2;
              return _this142.https.getById(t2, "CHALLENGE", e2);

            case 2:
              i = _context493.sent;
              _context493.next = 5;
              return _this142.service.setTemplateModels(i);

            case 5:
              return _context493.abrupt("return", i);

            case 6:
            case "end":
              return _context493.stop();
          }
        }
      }, _callee492);
    }));

    return function (_x845, _x846) {
      return _ref536.apply(this, arguments);
    };
  }());

  __publicField(this, "accept",
  /*#__PURE__*/
  function () {
    var _ref537 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee493(t2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee493$(_context494) {
        while (1) {
          switch (_context494.prev = _context494.next) {
            case 0:
              _context494.next = 2;
              return _this142.https.accept(t2, true, "CHALLENGE");

            case 2:
              i = _context494.sent;
              _context494.next = 5;
              return _this142.finalizeAcceptModel(i, true);

            case 5:
              return _context494.abrupt("return", _context494.sent);

            case 6:
            case "end":
              return _context494.stop();
          }
        }
      }, _callee493);
    }));

    return function (_x847) {
      return _ref537.apply(this, arguments);
    };
  }());

  __publicField(this, "reject",
  /*#__PURE__*/
  function () {
    var _ref538 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee494(t2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee494$(_context495) {
        while (1) {
          switch (_context495.prev = _context495.next) {
            case 0:
              _context495.next = 2;
              return _this142.https.accept(t2, false, "CHALLENGE");

            case 2:
              i = _context495.sent;
              _context495.next = 5;
              return _this142.finalizeAcceptModel(i, false);

            case 5:
              return _context495.abrupt("return", _context495.sent);

            case 6:
            case "end":
              return _context495.stop();
          }
        }
      }, _callee494);
    }));

    return function (_x848) {
      return _ref538.apply(this, arguments);
    };
  }());

  __publicField(this, "leave",
  /*#__PURE__*/
  function () {
    var _ref539 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee495(t2) {
      return _regeneratorRuntime.wrap(function _callee495$(_context496) {
        while (1) {
          switch (_context496.prev = _context496.next) {
            case 0:
              _context496.next = 2;
              return _this142.https.leave(t2, "CHALLENGE");

            case 2:
              return _context496.abrupt("return", _context496.sent);

            case 3:
            case "end":
              return _context496.stop();
          }
        }
      }, _callee495);
    }));

    return function (_x849) {
      return _ref539.apply(this, arguments);
    };
  }());

  __publicField(this, "finalizeAcceptModel",
  /*#__PURE__*/
  function () {
    var _ref540 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee496(t2, e2) {
      var _i60;

      return _regeneratorRuntime.wrap(function _callee496$(_context497) {
        while (1) {
          switch (_context497.prev = _context497.next) {
            case 0:
              if (!e2) {
                _context497.next = 5;
                break;
              }

              _context497.next = 3;
              return _this142.getById(t2.challengeId);

            case 3:
              _i60 = _context497.sent;
              t2.challengeModel = _i60;

            case 5:
              _context497.next = 7;
              return _this142.service.setProfileModel(t2);

            case 7:
              return _context497.abrupt("return", t2);

            case 8:
            case "end":
              return _context497.stop();
          }
        }
      }, _callee496);
    }));

    return function (_x850, _x851) {
      return _ref540.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyChallenges",
  /*#__PURE__*/
  function () {
    var _ref541 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee497(t2) {
      var e2, i, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, a, r2;

      return _regeneratorRuntime.wrap(function _callee497$(_context498) {
        while (1) {
          switch (_context498.prev = _context498.next) {
            case 0:
              t2 && (t2 = new uo(t2));
              _context498.next = 3;
              return _this142.profile.getOwn().getInfo();

            case 3:
              e2 = _context498.sent;
              _context498.next = 6;
              return _this142.loyaltyHttps.getUserRankingsForPrivateLeagueAndChallenges(e2.id, "CHALLENGE", t2);

            case 6:
              i = _context498.sent;
              _iteratorNormalCompletion21 = true;
              _didIteratorError21 = false;
              _iteratorError21 = undefined;
              _context498.prev = 10;
              _iterator21 = i.data[Symbol.iterator]();

            case 12:
              if (_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done) {
                _context498.next = 21;
                break;
              }

              a = _step21.value;
              _context498.next = 16;
              return _this142.getById(a.challengeId);

            case 16:
              r2 = _context498.sent;
              a.challengeModel = r2;

            case 18:
              _iteratorNormalCompletion21 = true;
              _context498.next = 12;
              break;

            case 21:
              _context498.next = 27;
              break;

            case 23:
              _context498.prev = 23;
              _context498.t0 = _context498["catch"](10);
              _didIteratorError21 = true;
              _iteratorError21 = _context498.t0;

            case 27:
              _context498.prev = 27;
              _context498.prev = 28;

              if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                _iterator21.return();
              }

            case 30:
              _context498.prev = 30;

              if (!_didIteratorError21) {
                _context498.next = 33;
                break;
              }

              throw _iteratorError21;

            case 33:
              return _context498.finish(30);

            case 34:
              return _context498.finish(27);

            case 35:
              return _context498.abrupt("return", (_this142.service.setTemplateModelsFromLeagueModels(i.data, "CHALLENGE"), i));

            case 36:
            case "end":
              return _context498.stop();
          }
        }
      }, _callee497, null, [[10, 23, 27, 35], [28,, 30, 34]]);
    }));

    return function (_x852) {
      return _ref541.apply(this, arguments);
    };
  }());

  __publicField(this, "getInvitations",
  /*#__PURE__*/
  function () {
    var _ref542 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee498(t2) {
      var e2;
      return _regeneratorRuntime.wrap(function _callee498$(_context499) {
        while (1) {
          switch (_context499.prev = _context499.next) {
            case 0:
              t2 = new Re(t2), t2.type = "ONE_VS_ONE";
              _context499.next = 3;
              return _this142.https.getInvitations("CHALLENGE", t2);

            case 3:
              e2 = _context499.sent;
              _context499.next = 6;
              return _this142.service.setTemplateModelsInLeagues(e2.data);

            case 6:
              return _context499.abrupt("return", e2);

            case 7:
            case "end":
              return _context499.stop();
          }
        }
      }, _callee498);
    }));

    return function (_x853) {
      return _ref542.apply(this, arguments);
    };
  }());

  __publicField(this, "getReportedPosts",
  /*#__PURE__*/
  function () {
    var _ref543 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee499(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee499$(_context500) {
        while (1) {
          switch (_context500.prev = _context500.next) {
            case 0:
              e2 && (e2 = new Se(e2));
              _context500.next = 3;
              return _this142.https.getReportedPosts(t2, e2);

            case 3:
              i = _context500.sent;
              _context500.next = 6;
              return _this142.discussionsService.finalizePostFullModel(i.data);

            case 6:
              i.data = _context500.sent;
              return _context500.abrupt("return", i);

            case 8:
            case "end":
              return _context500.stop();
          }
        }
      }, _callee499);
    }));

    return function (_x854, _x855) {
      return _ref543.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictions",
  /*#__PURE__*/
  function () {
    var _ref544 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee500(t2, e2) {
      var i;
      return _regeneratorRuntime.wrap(function _callee500$(_context501) {
        while (1) {
          switch (_context501.prev = _context501.next) {
            case 0:
              if (!e2) {
                _context501.next = 4;
                break;
              }

              if (!(e2.limit && e2.limit > 20)) {
                _context501.next = 3;
                break;
              }

              throw new u(400, "invalid_limit", "Invalid limit filter. The maximum limit is 20");

            case 3:
              e2 = new Ce(e2);

            case 4:
              _context501.next = 6;
              return _this142.https.getPredictions(t2, e2);

            case 6:
              i = _context501.sent;
              _context501.next = 9;
              return _this142.service.setModelsForPredictions(i);

            case 9:
              return _context501.abrupt("return", _context501.sent);

            case 10:
            case "end":
              return _context501.stop();
          }
        }
      }, _callee500);
    }));

    return function (_x856, _x857) {
      return _ref544.apply(this, arguments);
    };
  }());

  __publicField(this, "moderatePost",
  /*#__PURE__*/
  function () {
    var _ref545 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee501(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee501$(_context502) {
        while (1) {
          switch (_context502.prev = _context502.next) {
            case 0:
              _context502.next = 2;
              return _this142.https.moderatePost(t2, e2);

            case 2:
              return _context502.abrupt("return", _context502.sent);

            case 3:
            case "end":
              return _context502.stop();
          }
        }
      }, _callee501);
    }));

    return function (_x858, _x859) {
      return _ref545.apply(this, arguments);
    };
  }());

  this.factory = new Ee(), this.https = new Te(t2), this.service = new Ae(t2), this.loyaltyHttps = new Mt(t2), this.profile = new L(t2), this.discussionsService = new wt(t2);
};

var go = function go(t2) {
  var _this143 = this;

  _classCallCheck3(this, go);

  __publicField(this, "facade", null);

  __publicField(this, "issue",
  /*#__PURE__*/
  function () {
    var _ref546 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee502(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee502$(_context503) {
        while (1) {
          switch (_context503.prev = _context503.next) {
            case 0:
              _context503.next = 2;
              return _this143.facade.issue(t2, e2);

            case 2:
              return _context503.abrupt("return", _context503.sent);

            case 3:
            case "end":
              return _context503.stop();
          }
        }
      }, _callee502);
    }));

    return function (_x860, _x861) {
      return _ref546.apply(this, arguments);
    };
  }());

  __publicField(this, "update",
  /*#__PURE__*/
  function () {
    var _ref547 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee503(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee503$(_context504) {
        while (1) {
          switch (_context504.prev = _context504.next) {
            case 0:
              _context504.next = 2;
              return _this143.facade.update(t2, e2);

            case 2:
              return _context504.abrupt("return", _context504.sent);

            case 3:
            case "end":
              return _context504.stop();
          }
        }
      }, _callee503);
    }));

    return function (_x862, _x863) {
      return _ref547.apply(this, arguments);
    };
  }());

  __publicField(this, "updateTemplate",
  /*#__PURE__*/
  function () {
    var _ref548 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee504(t2, e2, i) {
      return _regeneratorRuntime.wrap(function _callee504$(_context505) {
        while (1) {
          switch (_context505.prev = _context505.next) {
            case 0:
              _context505.next = 2;
              return _this143.facade.updateTemplate(t2, e2, i);

            case 2:
              return _context505.abrupt("return", _context505.sent);

            case 3:
            case "end":
              return _context505.stop();
          }
        }
      }, _callee504);
    }));

    return function (_x864, _x865, _x866) {
      return _ref548.apply(this, arguments);
    };
  }());

  __publicField(this, "delete",
  /*#__PURE__*/
  function () {
    var _ref549 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee505(t2) {
      return _regeneratorRuntime.wrap(function _callee505$(_context506) {
        while (1) {
          switch (_context506.prev = _context506.next) {
            case 0:
              _context506.next = 2;
              return _this143.facade.delete(t2);

            case 2:
              return _context506.abrupt("return", _context506.sent);

            case 3:
            case "end":
              return _context506.stop();
          }
        }
      }, _callee505);
    }));

    return function (_x867) {
      return _ref549.apply(this, arguments);
    };
  }());

  __publicField(this, "getById",
  /*#__PURE__*/
  function () {
    var _ref550 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee506(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee506$(_context507) {
        while (1) {
          switch (_context507.prev = _context507.next) {
            case 0:
              _context507.next = 2;
              return _this143.facade.getById(t2, e2);

            case 2:
              return _context507.abrupt("return", _context507.sent);

            case 3:
            case "end":
              return _context507.stop();
          }
        }
      }, _callee506);
    }));

    return function (_x868, _x869) {
      return _ref550.apply(this, arguments);
    };
  }());

  __publicField(this, "accept",
  /*#__PURE__*/
  function () {
    var _ref551 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee507(t2) {
      return _regeneratorRuntime.wrap(function _callee507$(_context508) {
        while (1) {
          switch (_context508.prev = _context508.next) {
            case 0:
              _context508.next = 2;
              return _this143.facade.accept(t2);

            case 2:
              return _context508.abrupt("return", _context508.sent);

            case 3:
            case "end":
              return _context508.stop();
          }
        }
      }, _callee507);
    }));

    return function (_x870) {
      return _ref551.apply(this, arguments);
    };
  }());

  __publicField(this, "reject",
  /*#__PURE__*/
  function () {
    var _ref552 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee508(t2) {
      return _regeneratorRuntime.wrap(function _callee508$(_context509) {
        while (1) {
          switch (_context509.prev = _context509.next) {
            case 0:
              _context509.next = 2;
              return _this143.facade.reject(t2);

            case 2:
              return _context509.abrupt("return", _context509.sent);

            case 3:
            case "end":
              return _context509.stop();
          }
        }
      }, _callee508);
    }));

    return function (_x871) {
      return _ref552.apply(this, arguments);
    };
  }());

  __publicField(this, "leave",
  /*#__PURE__*/
  function () {
    var _ref553 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee509(t2) {
      return _regeneratorRuntime.wrap(function _callee509$(_context510) {
        while (1) {
          switch (_context510.prev = _context510.next) {
            case 0:
              _context510.next = 2;
              return _this143.facade.leave(t2);

            case 2:
              return _context510.abrupt("return", _context510.sent);

            case 3:
            case "end":
              return _context510.stop();
          }
        }
      }, _callee509);
    }));

    return function (_x872) {
      return _ref553.apply(this, arguments);
    };
  }());

  __publicField(this, "getMyChallenges",
  /*#__PURE__*/
  function () {
    var _ref554 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee510(t2) {
      return _regeneratorRuntime.wrap(function _callee510$(_context511) {
        while (1) {
          switch (_context511.prev = _context511.next) {
            case 0:
              _context511.next = 2;
              return _this143.facade.getMyChallenges(t2);

            case 2:
              return _context511.abrupt("return", _context511.sent);

            case 3:
            case "end":
              return _context511.stop();
          }
        }
      }, _callee510);
    }));

    return function (_x873) {
      return _ref554.apply(this, arguments);
    };
  }());

  __publicField(this, "getInvitations",
  /*#__PURE__*/
  function () {
    var _ref555 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee511(t2) {
      return _regeneratorRuntime.wrap(function _callee511$(_context512) {
        while (1) {
          switch (_context512.prev = _context512.next) {
            case 0:
              _context512.next = 2;
              return _this143.facade.getInvitations(t2);

            case 2:
              return _context512.abrupt("return", _context512.sent);

            case 3:
            case "end":
              return _context512.stop();
          }
        }
      }, _callee511);
    }));

    return function (_x874) {
      return _ref555.apply(this, arguments);
    };
  }());

  __publicField(this, "getReportedPosts",
  /*#__PURE__*/
  function () {
    var _ref556 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee512(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee512$(_context513) {
        while (1) {
          switch (_context513.prev = _context513.next) {
            case 0:
              _context513.next = 2;
              return _this143.facade.getReportedPosts(t2, e2);

            case 2:
              return _context513.abrupt("return", _context513.sent);

            case 3:
            case "end":
              return _context513.stop();
          }
        }
      }, _callee512);
    }));

    return function (_x875, _x876) {
      return _ref556.apply(this, arguments);
    };
  }());

  __publicField(this, "getPredictions",
  /*#__PURE__*/
  function () {
    var _ref557 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee513(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee513$(_context514) {
        while (1) {
          switch (_context514.prev = _context514.next) {
            case 0:
              _context514.next = 2;
              return _this143.facade.getPredictions(t2, e2);

            case 2:
              return _context514.abrupt("return", _context514.sent);

            case 3:
            case "end":
              return _context514.stop();
          }
        }
      }, _callee513);
    }));

    return function (_x877, _x878) {
      return _ref557.apply(this, arguments);
    };
  }());

  __publicField(this, "moderatePost",
  /*#__PURE__*/
  function () {
    var _ref558 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee514(t2, e2) {
      return _regeneratorRuntime.wrap(function _callee514$(_context515) {
        while (1) {
          switch (_context515.prev = _context515.next) {
            case 0:
              _context515.next = 2;
              return _this143.facade.moderatePost(t2, e2);

            case 2:
              return _context515.abrupt("return", _context515.sent);

            case 3:
            case "end":
              return _context515.stop();
          }
        }
      }, _callee514);
    }));

    return function (_x879, _x880) {
      return _ref558.apply(this, arguments);
    };
  }());

  this.facade = new ho(t2);
};

var So = null,
    Wo = null;

function vT(o) {
  if (qs(o)) {
    var t2 = zs(o);
    if (t2.isValid) return So = {
      profile: new L(o),
      football: new ie(o),
      predictor: new me(o),
      loyalty: new Me(o),
      topX: new Pr(o),
      matchQuiz: new vr(o),
      activity: new Er(o),
      miniGames: new kr(o),
      discussions: new Zr(o),
      privateLeagues: new mo(o),
      challenges: new go(o)
    }, Wo = _objectSpread3({}, o), So;
    Qs(t2);
  }

  return So;
}

var qs = function qs(o) {
  return !So || JSON.stringify(o) !== JSON.stringify(Wo) || o.authProvider.getIdToken() !== Wo.authProvider.getIdToken();
},
    zs = function zs(o) {
  var e2 = new _a().validate(o);
  return (e2.idSchema.validation === "missing" || e2.idSchema.validation === "invalid") && (console.warn(e2.idSchema.message.text), o.idSchema = "native"), (e2.environment.validation === "missing" || e2.environment.validation === "invalid") && (console.warn(e2.environment.message.text), o.environment = "prod"), (e2.lang.validation === "missing" || e2.lang.validation === "invalid") && (console.warn(e2.lang.message.text), o.lang = "en"), (e2.errorHandlingMode.validation === "missing" || e2.errorHandlingMode.validation === "invalid") && (console.warn(e2.errorHandlingMode.message.text), o.errorHandlingMode = "default"), e2.authProvider.validation === "invalid" && console.warn(e2.authProvider.message.text), e2;
},
    Qs = function Qs(o) {
  var t2 = "authProvider",
      e2 = "isValid";
  Object.keys(o).forEach(function (i) {
    var a = o[i];

    if (i !== e2 && i !== t2) {
      if (a.message.type === "error") throw new Error(a.message.text);
    } else i !== e2 && i === t2 && Object.keys(new Ft()).forEach(function (r2) {
      if (a[r2].message.type === "error") throw new Error(a[r2].message.text);
    });
  });
};

var TokenProvider = function TokenProvider() {
  _classCallCheck3(this, TokenProvider);

  this.getIdToken = function () {
    return "";
  };

  this.logout = function () {};
};

var FansUnitedConfigurationModel = function FansUnitedConfigurationModel(apiKey, clientId, lang, environment) {
  _classCallCheck3(this, FansUnitedConfigurationModel);

  this.apiKey = null;
  this.environment = null;
  this.clientId = null;
  this.lang = null;
  this.idSchema = null;
  this.errorHandlingMode = null;
  this.authProvider = new TokenProvider();
  this.apiKey = apiKey;
  this.environment = environment ? environment : "prod";
  this.clientId = clientId;
  this.lang = lang ? lang : null;
  this.idSchema = "native";
  this.errorHandlingMode = "standard";
};

function r$1(e2) {
  var t2,
      f2,
      n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) n2 += e2;else if ("object" == typeof e2) if (Array.isArray(e2)) for (t2 = 0; t2 < e2.length; t2++) {
    e2[t2] && (f2 = r$1(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
  } else for (t2 in e2) {
    e2[t2] && (n2 && (n2 += " "), n2 += t2);
  }
  return n2;
}

function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length;) {
    (e2 = arguments[f2++]) && (t2 = r$1(e2)) && (n2 && (n2 += " "), n2 += t2);
  }

  return n2;
}

var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$a = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    var test1 = new String("abc");
    test1[5] = "de";

    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }

    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
      return test2[n2];
    });

    if (order2.join("") !== "0123456789") {
      return false;
    }

    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
}

shouldUseNative() ? Object.assign : function (target, source2) {
  var from2;
  var to2 = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);

    for (var key in from2) {
      if (hasOwnProperty$a.call(from2, key)) {
        to2[key] = from2[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from2, symbols[i])) {
          to2[symbols[i]] = from2[symbols[i]];
        }
      }
    }
  }

  return to2;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f$1 = React__default,
    g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;

if ("function" === typeof Symbol && Symbol.for) {
  var h$1 = Symbol.for;
  g$1 = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}

var m$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    n$1 = Object.prototype.hasOwnProperty,
    p$1 = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

function q$1(c2, a, k2) {
  var b2,
      d2 = {},
      e2 = null,
      l2 = null;
  void 0 !== k2 && (e2 = "" + k2);
  void 0 !== a.key && (e2 = "" + a.key);
  void 0 !== a.ref && (l2 = a.ref);

  for (b2 in a) {
    n$1.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  }

  if (c2 && c2.defaultProps) for (b2 in a = c2.defaultProps, a) {
    void 0 === d2[b2] && (d2[b2] = a[b2]);
  }
  return {
    $$typeof: g$1,
    type: c2,
    key: e2,
    ref: l2,
    props: d2,
    _owner: m$1.current
  };
}

reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
var jsx$1 = jsxRuntime.exports.jsx;
var jsxs = jsxRuntime.exports.jsxs;
var Fragment = jsxRuntime.exports.Fragment;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source2 = arguments[i];

      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source2, excluded) {
  if (source2 == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source2[key];
  }

  return target;
}

function isNum(v2) {
  return typeof v2 === "number" && !isNaN(v2);
}

function isBool(v2) {
  return typeof v2 === "boolean";
}

function isStr(v2) {
  return typeof v2 === "string";
}

function isFn(v2) {
  return typeof v2 === "function";
}

function parseClassName(v2) {
  return isStr(v2) || isFn(v2) ? v2 : null;
}

function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}

function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}

var canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);

function canBeRendered(content) {
  return isValidElement(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
};
var TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};

function collapseToast(node2, done, duration2) {
  if (duration2 === void 0) {
    duration2 = 300;
  }

  var scrollHeight = node2.scrollHeight,
      style = node2.style;
  requestAnimationFrame(function () {
    style.minHeight = "initial";
    style.height = scrollHeight + "px";
    style.transition = "all " + duration2 + "ms";
    requestAnimationFrame(function () {
      style.height = "0";
      style.padding = "0";
      style.margin = "0";
      setTimeout(done, duration2);
    });
  });
}

function cssTransition(_ref3) {
  var enter = _ref3.enter,
      exit = _ref3.exit,
      _ref$appendPosition = _ref3.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref3.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref3.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref22) {
    var children = _ref22.children,
        position2 = _ref22.position,
        preventExitTransition = _ref22.preventExitTransition,
        done = _ref22.done,
        nodeRef = _ref22.nodeRef,
        isIn = _ref22.isIn;
    var enterClassName = appendPosition ? enter + "--" + position2 : enter;
    var exitClassName = appendPosition ? exit + "--" + position2 : exit;
    var baseClassName = useRef();
    var animationStep = useRef(0);
    useLayoutEffect(function () {
      onEnter();
    }, []);
    useEffect(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node2 = nodeRef.current;
      baseClassName.current = node2.className;
      node2.className += " " + enterClassName;
      node2.addEventListener("animationend", onEntered);
      node2.addEventListener("animationcancel", onEntered);
    }

    function onEntered(e2) {
      if (e2.target !== nodeRef.current) return;
      var node2 = nodeRef.current;
      node2.dispatchEvent(new Event("d"));
      node2.removeEventListener("animationend", onEntered);
      node2.removeEventListener("animationcancel", onEntered);

      if (animationStep.current === 0) {
        node2.className = baseClassName.current;
      }
    }

    function onExit() {
      animationStep.current = 1;
      var node2 = nodeRef.current;
      node2.className += " " + exitClassName;
      node2.addEventListener("animationend", onExited);
    }

    function onExited() {
      var node2 = nodeRef.current;
      node2.removeEventListener("animationend", onExited);
      collapse ? collapseToast(node2, done, collapseDuration) : done();
    }

    return (
      /* @__PURE__ */
      jsx$1(Fragment, {
        children: children
      })
    );
  };
}

var eventManager = {
  list:
  /* @__PURE__ */
  new Map(),
  emitQueue:
  /* @__PURE__ */
  new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb2) {
        return cb2 !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};
var _excluded$6 = ["delay", "staleId"];

function useToastContainer(props) {
  var _useReducer = useReducer(function (x2) {
    return x2 + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useState = useState([]),
      toastIds = _useState[0],
      setToastIds = _useState[1];

  var containerRef = useRef(null);
  var toastToRender = useRef(
  /* @__PURE__ */
  new Map()).current;

  var isToastActive = function isToastActive2(id) {
    return toastIds.indexOf(id) !== -1;
  };

  var instance = useRef({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast2(id) {
      return toastToRender.get(id);
    }
  }).current;
  useEffect(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3).on(0, buildToast).on(1, function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5, clearWaitingQueue).emit(2, instance);
    return function () {
      return eventManager.emit(3, instance);
    };
  }, []);
  useEffect(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
    eventManager.emit(4, toastIds.length, props.containerId);
  }, [toastIds]);
  useEffect(function () {
    instance.props = props;
  });

  function clearWaitingQueue(_ref3) {
    var containerId = _ref3.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }

  function removeToast(toastId) {
    setToastIds(function (state) {
      return isToastIdValid(toastId) ? state.filter(function (id) {
        return id !== toastId;
      }) : [];
    });
  }

  function dequeueToast() {
    var _instance$queue$shift = instance.queue.shift(),
        toastContent = _instance$queue$shift.toastContent,
        toastProps = _instance$queue$shift.toastProps,
        staleId = _instance$queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }

  function isNotValid(options2) {
    return !containerRef.current || instance.props.enableMultiContainer && options2.containerId !== instance.props.containerId || toastToRender.has(options2.toastId) && options2.updateId == null;
  }

  function buildToast(content, _ref22) {
    var delay = _ref22.delay,
        staleId = _ref22.staleId,
        options2 = _objectWithoutPropertiesLoose$2(_ref22, _excluded$6);

    if (!canBeRendered(content) || isNotValid(options2)) return;
    var toastId = options2.toastId,
        updateId = options2.updateId,
        data2 = options2.data;
    var props2 = instance.props;

    var closeToast = function closeToast2() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = updateId == null;
    if (isNotAnUpdate) instance.count++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isLoading: options2.isLoading,
      theme: options2.theme || props2.theme,
      icon: options2.icon != null ? options2.icon : props2.icon,
      isIn: false,
      key: options2.key || instance.toastKey++,
      type: options2.type,
      closeToast: closeToast,
      closeButton: options2.closeButton,
      rtl: props2.rtl,
      position: options2.position || props2.position,
      transition: options2.transition || props2.transition,
      className: parseClassName(options2.className || props2.toastClassName),
      bodyClassName: parseClassName(options2.bodyClassName || props2.bodyClassName),
      style: options2.style || props2.toastStyle,
      bodyStyle: options2.bodyStyle || props2.bodyStyle,
      onClick: options2.onClick || props2.onClick,
      pauseOnHover: isBool(options2.pauseOnHover) ? options2.pauseOnHover : props2.pauseOnHover,
      pauseOnFocusLoss: isBool(options2.pauseOnFocusLoss) ? options2.pauseOnFocusLoss : props2.pauseOnFocusLoss,
      draggable: isBool(options2.draggable) ? options2.draggable : props2.draggable,
      draggablePercent: options2.draggablePercent || props2.draggablePercent,
      draggableDirection: options2.draggableDirection || props2.draggableDirection,
      closeOnClick: isBool(options2.closeOnClick) ? options2.closeOnClick : props2.closeOnClick,
      progressClassName: parseClassName(options2.progressClassName || props2.progressClassName),
      progressStyle: options2.progressStyle || props2.progressStyle,
      autoClose: options2.isLoading ? false : getAutoCloseDelay(options2.autoClose, props2.autoClose),
      hideProgressBar: isBool(options2.hideProgressBar) ? options2.hideProgressBar : props2.hideProgressBar,
      progress: options2.progress,
      role: options2.role || props2.role,
      deleteToast: function deleteToast() {
        toastToRender["delete"](toastId);
        var queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0) instance.count = 0;

        if (queueLen > 0) {
          var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;

            for (var i = 0; i < toDequeue; i++) {
              dequeueToast();
            }
          }
        } else {
          forceUpdate();
        }
      }
    };
    if (isFn(options2.onOpen)) toastProps.onOpen = options2.onOpen;
    if (isFn(options2.onClose)) toastProps.onClose = options2.onClose;
    toastProps.closeButton = props2.closeButton;

    if (options2.closeButton === false || canBeRendered(options2.closeButton)) {
      toastProps.closeButton = options2.closeButton;
    } else if (options2.closeButton === true) {
      toastProps.closeButton = canBeRendered(props2.closeButton) ? props2.closeButton : true;
    }

    var toastContent = content;

    if (isValidElement(content) && !isStr(content.type)) {
      toastContent = cloneElement(content, {
        closeToast: closeToast,
        toastProps: toastProps,
        data: data2
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps,
        data: data2
      });
    }

    if (props2.limit && props2.limit > 0 && instance.count > props2.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) toastToRender["delete"](staleId);
    toastToRender.set(toastId, {
      content: content,
      props: toastProps
    });
    setToastIds(function (state) {
      return [].concat(state, [toastId]).filter(function (id) {
        return id !== staleId;
      });
    });
  }

  function getToastToRender(cb) {
    var toRender =
    /* @__PURE__ */
    new Map();
    var collection = Array.from(toastToRender.values());
    if (props.newestOnTop) collection.reverse();
    collection.forEach(function (toast2) {
      var position2 = toast2.props.position;
      toRender.has(position2) || toRender.set(position2, []);
      toRender.get(position2).push(toast2);
    });
    return Array.from(toRender, function (p2) {
      return cb(p2[0], p2[1]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e2) {
  return e2.targetTouches && e2.targetTouches.length >= 1 ? e2.targetTouches[0].clientX : e2.clientX;
}

function getY(e2) {
  return e2.targetTouches && e2.targetTouches.length >= 1 ? e2.targetTouches[0].clientY : e2.clientY;
}

function useToast(props) {
  var _useState = useState(false),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = useState(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = useRef(null);
  var drag = useRef({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  var syncProps = useRef(props);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  useEffect(function () {
    syncProps.current = props;
  });
  useEffect(function () {
    if (toastRef.current) toastRef.current.addEventListener("d", playToast, {
      once: true
    });
    if (isFn(props.onOpen)) props.onOpen(isValidElement(props.children) && props.children.props);
    return function () {
      var props2 = syncProps.current;
      if (isFn(props2.onClose)) props2.onClose(isValidElement(props2.children) && props2.children.props);
    };
  }, []);
  useEffect(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e2) {
    if (props.draggable) {
      bindDragEvents();
      var toast2 = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast2.getBoundingClientRect();
      toast2.style.transition = "";
      drag.x = getX(e2.nativeEvent);
      drag.y = getY(e2.nativeEvent);

      if (props.draggableDirection === "x") {
        drag.start = drag.x;
        drag.removalDistance = toast2.offsetWidth * (props.draggablePercent / 100);
      } else {
        drag.start = drag.y;
        drag.removalDistance = toast2.offsetHeight * (props.draggablePercent === 80 ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top2 = _drag$boundingRect.top,
          bottom2 = _drag$boundingRect.bottom,
          left2 = _drag$boundingRect.left,
          right2 = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left2 && drag.x <= right2 && drag.y >= top2 && drag.y <= bottom2) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener("focus", playToast);
    window.addEventListener("blur", pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener("focus", playToast);
    window.removeEventListener("blur", pauseToast);
  }

  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragEnd);
    document.addEventListener("touchmove", onDragMove);
    document.addEventListener("touchend", onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener("mousemove", onDragMove);
    document.removeEventListener("mouseup", onDragEnd);
    document.removeEventListener("touchmove", onDragMove);
    document.removeEventListener("touchend", onDragEnd);
  }

  function onDragMove(e2) {
    var toast2 = toastRef.current;

    if (drag.canDrag && toast2) {
      drag.didMove = true;
      if (isRunning) pauseToast();
      drag.x = getX(e2);
      drag.y = getY(e2);

      if (props.draggableDirection === "x") {
        drag.delta = drag.x - drag.start;
      } else {
        drag.delta = drag.y - drag.start;
      }

      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast2.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast2.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    unbindDragEvents();
    var toast2 = toastRef.current;

    if (drag.canDrag && drag.didMove && toast2) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast2.style.transition = "transform 0.2s, opacity 0.2s";
      toast2.style.transform = "translate" + props.draggableDirection + "(0)";
      toast2.style.opacity = "1";
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  }

  if (closeOnClick) {
    eventHandlers.onClick = function (e2) {
      onClick && onClick(e2);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref3) {
  var closeToast = _ref3.closeToast,
      theme = _ref3.theme,
      _ref$ariaLabel = _ref3.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? "close" : _ref$ariaLabel;
  return createElement$1("button", {
    className: "Toastify__close-button Toastify__close-button--" + theme,
    type: "button",
    onClick: function onClick(e2) {
      e2.stopPropagation();
      closeToast(e2);
    },
    "aria-label": ariaLabel
  }, createElement$1("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, createElement$1("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref3) {
  var _cx, _animationEvent;

  var delay = _ref3.delay,
      isRunning = _ref3.isRunning,
      closeToast = _ref3.closeToast,
      type = _ref3.type,
      hide2 = _ref3.hide,
      className = _ref3.className,
      userStyle = _ref3.style,
      controlledProgress = _ref3.controlledProgress,
      progress = _ref3.progress,
      rtl = _ref3.rtl,
      isIn = _ref3.isIn,
      theme = _ref3.theme;

  var style = _extends$1({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? "running" : "paused",
    opacity: hide2 ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + theme, "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
  var classNames2 = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx(defaultClassName, className);
  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent);
  return createElement$1("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide2 ? "true" : "false",
    "aria-label": "notification timer",
    className: classNames2,
    style: style
  }, animationEvent));
}

ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};
var _excluded$1$2 = ["theme", "type"];

var Svg$1 = function Svg(_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type,
      rest = _objectWithoutPropertiesLoose$2(_ref3, _excluded$1$2);

  return createElement$1("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === "colored" ? "currentColor" : "var(--toastify-icon-color-" + type + ")"
  }, rest));
};

function Warning(props) {
  return createElement$1(Svg$1, Object.assign({}, props), createElement$1("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}

function Info(props) {
  return createElement$1(Svg$1, Object.assign({}, props), createElement$1("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}

function Success(props) {
  return createElement$1(Svg$1, Object.assign({}, props), createElement$1("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}

function Error$1(props) {
  return createElement$1(Svg$1, Object.assign({}, props), createElement$1("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}

function Spinner$1() {
  return createElement$1("div", {
    className: "Toastify__spinner"
  });
}

var Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error$1,
  spinner: Spinner$1
};

var Toast = function Toast2(props) {
  var _cx, _cx2;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position2 = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn,
      isLoading = props.isLoading,
      icon = props.icon,
      theme = props.theme;
  var defaultClassName = clsx("Toastify__toast", "Toastify__toast-theme--" + theme, "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position2,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx(defaultClassName, className);
  var isProgressControlled = !!progress;
  var maybeIcon = Icons[type];
  var iconProps = {
    theme: theme,
    type: type
  };
  var Icon = maybeIcon && maybeIcon(iconProps);

  if (icon === false) {
    Icon = void 0;
  } else if (isFn(icon)) {
    Icon = icon(iconProps);
  } else if (isValidElement(icon)) {
    Icon = cloneElement(icon, iconProps);
  } else if (isStr(icon)) {
    Icon = icon;
  } else if (isLoading) {
    Icon = Icons.spinner();
  }

  function renderCloseButton(closeButton2) {
    if (!closeButton2) return;
    var props2 = {
      closeToast: closeToast,
      type: type,
      theme: theme
    };
    if (isFn(closeButton2)) return closeButton2(props2);
    if (isValidElement(closeButton2)) return cloneElement(closeButton2, props2);
  }

  return createElement$1(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position2,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, createElement$1("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), createElement$1("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx("Toastify__toast-body", bodyClassName),
    style: bodyStyle
  }), Icon && createElement$1("div", {
    className: clsx("Toastify__toast-icon", (_cx2 = {}, _cx2["Toastify--animate-icon Toastify__zoom-enter"] = !isLoading, _cx2))
  }, Icon), createElement$1("div", null, children)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && createElement$1(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    theme: theme,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce =
/* @__PURE__ */
cssTransition({
  enter: "Toastify--animate Toastify__bounce-enter",
  exit: "Toastify--animate Toastify__bounce-exit",
  appendPosition: true
});

var ToastContainer = function ToastContainer2(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position2) {
    var _cx;

    var defaultClassName = clsx("Toastify__toast-container", "Toastify__toast-container--" + position2, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position2,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx(defaultClassName, parseClassName(className));
  }

  return createElement$1("div", {
    ref: containerRef,
    className: "Toastify",
    id: containerId
  }, getToastToRender(function (position2, toastList) {
    var containerStyle2 = !toastList.length ? _extends$1({}, style, {
      pointerEvents: "none"
    }) : _extends$1({}, style);
    return createElement$1("div", {
      className: getClassName(position2),
      style: containerStyle2,
      key: "container-" + position2
    }, toastList.map(function (_ref3) {
      var content = _ref3.content,
          toastProps = _ref3.props;
      return createElement$1(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};

ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5e3,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var containers =
/* @__PURE__ */
new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;

function getToast(toastId, _ref3) {
  var containerId = _ref3.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}

function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}

function getToastId(options2) {
  if (options2 && (isStr(options2.toastId) || isNum(options2.toastId))) {
    return options2.toastId;
  }

  return generateToastId();
}

function dispatchToast(content, options2) {
  if (containers.size > 0) {
    eventManager.emit(0, content, options2);
  } else {
    queue.push({
      content: content,
      options: options2
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement("div");
      document.body.appendChild(containerDomNode);
      render$1(createElement$1(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options2.toastId;
}

function mergeOptions(type, options2) {
  return _extends$1({}, options2, {
    type: options2 && options2.type || type,
    toastId: getToastId(options2)
  });
}

function createToastByType(type) {
  return function (content, options2) {
    return dispatchToast(content, mergeOptions(type, options2));
  };
}

function toast(content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options2));
}

toast.loading = function (content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends$1({
    isLoading: true,
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    draggable: false
  }, options2)));
};

function handlePromise(promise, _ref22, options2) {
  var pending = _ref22.pending,
      error = _ref22.error,
      success = _ref22.success;
  var id;

  if (pending) {
    id = isStr(pending) ? toast.loading(pending, options2) : toast.loading(pending.render, _extends$1({}, options2, pending));
  }

  var resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  };

  var resolver = function resolver2(type, input, result) {
    if (input == null) {
      toast.dismiss(id);
      return;
    }

    var baseParams = _extends$1({
      type: type
    }, resetParams, options2, {
      data: result
    });

    var params = isStr(input) ? {
      render: input
    } : input;

    if (id) {
      toast.update(id, _extends$1({}, baseParams, params));
    } else {
      toast(params.render, _extends$1({}, baseParams, params));
    }

    return result;
  };

  var p2 = isFn(promise) ? promise() : promise;
  p2.then(function (result) {
    return resolver("success", success, result);
  })["catch"](function (err) {
    return resolver("error", error, err);
  });
  return p2;
}

toast.promise = handlePromise;
toast.success =
/* @__PURE__ */
createToastByType(TYPE.SUCCESS);
toast.info =
/* @__PURE__ */
createToastByType(TYPE.INFO);
toast.error =
/* @__PURE__ */
createToastByType(TYPE.ERROR);
toast.warning =
/* @__PURE__ */
createToastByType(TYPE.WARNING);
toast.warn = toast.warning;

toast.dark = function (content, options2) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends$1({
    theme: "dark"
  }, options2)));
};

toast.dismiss = function (id) {
  return eventManager.emit(1, id);
};

toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5, params);
};

toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options2) {
  if (options2 === void 0) {
    options2 = {};
  }

  setTimeout(function () {
    var toast2 = getToast(toastId, options2);

    if (toast2) {
      var oldOptions = toast2.props,
          oldContent = toast2.content;

      var nextOptions = _extends$1({}, oldOptions, options2, {
        toastId: options2.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};

toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};

toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4, callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4, callback);
  };
};

toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
eventManager.on(2, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0, item.content, item.options);
  });
  queue = [];
}).on(3, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0).off(1).off(5);
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});

var LabelsModel = function LabelsModel(labels) {
  _classCallCheck3(this, LabelsModel);

  this.userNotFoundMessage = labels && labels.userNotFoundMessage ? labels.userNotFoundMessage : "User not found. Please try again.";
  this.clientFeaturesNotFoundMessage = labels && labels.clientFeaturesNotFoundMessage ? labels.clientFeaturesNotFoundMessage : "There was a problem fetching client's configuration. Please check again your API key and client ID. For more information contact Fans United staff.";
  this.featureDisabled = labels && labels.featureDisabled ? labels.featureDisabled : "Feature disabled!";
  this.noPermissionMessage = labels && labels.noPermissionMessage ? labels.noPermissionMessage : "You have no permission for this feature!";
  this.tryAgainButton = labels && labels.tryAgainButton ? labels.tryAgainButton : "Try again";
  this.noGamesFound = labels && labels.noGamesFound ? labels.noGamesFound : "No games were found. You can create a game by clicking the button 'Create game'";
  this.createEdition = labels && labels.createEdition ? labels.createEdition : "Create";
  this.signOut = labels && labels.signOut ? labels.signOut : "Sign out";
  this.manageWinners = labels && labels.manageWinners ? labels.manageWinners : "Manage winners";
  this.name = labels && labels.name ? labels.name : "Name";
  this.status = labels && labels.status ? labels.status : "Status";
  this.participants = labels && labels.participants ? labels.participants : "Participants";
  this.creationDate = labels && labels.creationDate ? labels.creationDate : "Created at";
  this.acceptUntil = labels && labels.acceptUntil ? labels.acceptUntil : "Accept Until";
  this.actions = labels && labels.actions ? labels.actions : "Actions";
  this.upcoming = labels && labels.upcoming ? labels.upcoming : "Upcoming";
  this.inProgress = labels && labels.inProgress ? labels.inProgress : "In progress";
  this.finished = labels && labels.finished ? labels.finished : "Finished";
  this.pending = labels && labels.pending ? labels.pending : "Pending";
  this.settled = labels && labels.settled ? labels.settled : "Settled";
  this.live = labels && labels.live ? labels.live : "Live";
  this.open = labels && labels.open ? labels.open : "Open";
  this.canceled = labels && labels.canceled ? labels.canceled : "Canceled";
  this.closed = labels && labels.closed ? labels.closed : "Closed";
  this.edit = labels && labels.edit ? labels.edit : "Edit";
  this.report = labels && labels.report ? labels.report : "Report";
  this.winners = labels && labels.winners ? labels.winners : "Winners";
  this.timeFormat = labels && labels.timeFormat ? labels.timeFormat : "DD.MM.YYYY, HH:mm";
  this.previous = labels && labels.previous ? labels.previous : "Previous";
  this.next = labels && labels.next ? labels.next : "Next";
  this.id = labels && labels.id ? labels.id : "ID";
  this.namePlaceholder = labels && labels.namePlaceholder ? labels.namePlaceholder : "Please provide a name for your Top X edition.";
  this.title = labels && labels.title ? labels.title : "Title";
  this.description = labels && labels.description ? labels.description : "Description";
  this.descriptionPlaceholder = labels && labels.descriptionPlaceholder ? labels.descriptionPlaceholder : "Please describe your game.";
  this.matchSelection = labels && labels.matchSelection ? labels.matchSelection : "Match selection";
  this.matchSelectionDescription = labels && labels.matchSelectionDescription ? labels.matchSelectionDescription : "Select a number of matches to include in your game.";
  this.matchNumber = labels && labels.matchNumber ? labels.matchNumber : "Match Number";
  this.selectTeamPlaceholder = labels && labels.selectTeamPlaceholder ? labels.selectTeamPlaceholder : "Type your team...";
  this.selectTeamNoTeamFound = labels && labels.selectTeamNoTeamFound ? labels.selectTeamNoTeamFound : "No Team Found";
  this.selectTeamNoMatchesFound = labels && labels.selectTeamNoMatchesFound ? labels.selectTeamNoMatchesFound : "No matches were found";
  this.gameMarket = labels && labels.gameMarket ? labels.gameMarket : "Game market";
  this.gameMarketDescription = labels && labels.gameMarketDescription ? labels.gameMarketDescription : "The available choices are CORRECT_SCORE and CORRECT_SCORE_ADVANCED. Keep in mind that you can edit the market option only when the game is in PENDING status.";
  this.marketCorrectScore = labels && labels.marketCorrectScore ? labels.marketCorrectScore : "Correct score";
  this.marketCorrectScoreAdvanced = labels && labels.marketCorrectScoreAdvanced ? labels.marketCorrectScoreAdvanced : "Advanced correct score";
  this.gameStatus = labels && labels.gameStatus ? labels.gameStatus : "Game status";
  this.createGameStatusDescription = labels && labels.createGameStatusDescription ? labels.createGameStatusDescription : "The provided choices are PENDING and OPEN. Keep in mind that if you choose OPEN you can NOT edit your game.";
  this.editGameStatusDescription = labels && labels.editGameStatusDescription ? labels.editGameStatusDescription : "The provided choices are PENDING, OPEN and CANCELED. Keep in mind that if you choose OPEN you can NOT edit your game anymore and if you choose CANCELED the game will be canceled.";
  this.timeTiebreaker = labels && labels.timeTiebreaker ? labels.timeTiebreaker : "Time tiebreaker";
  this.timeTiebreakerDescription = labels && labels.timeTiebreakerDescription ? labels.timeTiebreakerDescription : "When enabled the game's leaderboard will have a classic user ranking (1,2,3). In case of same points and same golden goal, the user who placed their predictions eariler will be infront. When disabled the current game's leaderboard behavour is used - the golden goal tiebreaker is used and when 2 or more people have the same golden goal, the ranking will be 1,1,3,4,5,5,7,8.";
  this.enabled = labels && labels.enabled ? labels.enabled : "Enabled";
  this.disabled = labels && labels.disabled ? labels.disabled : "Disabled";
  this.rules = labels && labels.rules ? labels.rules : "Rules";
  this.rulesDescription = labels && labels.rulesDescription ? labels.rulesDescription : "Describe your rules for participating in the game.";
  this.adContent = labels && labels.adContent ? labels.adContent : "Ad content";
  this.adContentDescription = labels && labels.adContentDescription ? labels.adContentDescription : "Place your ad content in the game.";
  this.flags = labels && labels.flags ? labels.flags : "Flags";
  this.flagsPlaceholder = labels && labels.flagsPlaceholder ? labels.flagsPlaceholder : "Type your flag and hit enter";
  this.repeatedValueMessage = labels && labels.repeatedValueMessage ? labels.repeatedValueMessage : "You have entered a repeated value. Please enter a different one.";
  this.searchImage = labels && labels.searchImage ? labels.searchImage : "Search image";
  this.images = labels && labels.images ? labels.images : "Images";
  this.mainImage = labels && labels.mainImage ? labels.mainImage : "Main";
  this.coverImage = labels && labels.coverImage ? labels.coverImage : "Cover";
  this.mobileImage = labels && labels.mobileImage ? labels.mobileImage : "Mobile";
  this.imagePlaceholder = labels && labels.imagePlaceholder ? labels.imagePlaceholder : "Paste your image as valid URL or as relative path";
  this.related = labels && labels.related ? labels.related : "Related";
  this.relatedDescription = labels && labels.relatedDescription ? labels.relatedDescription : "Choose which games or templates you wish to be related to this game.";
  this.games = labels && labels.games ? labels.games : "Games";
  this.gamesPlaceholder = labels && labels.gamesPlaceholder ? labels.gamesPlaceholder : "Select which games (TOP_X and MATCH_QUIZ) are related to this game";
  this.templates = labels && labels.templates ? labels.templates : "Templates";
  this.templatesPlaceholder = labels && labels.templatesPlaceholder ? labels.templatesPlaceholder : "Select which templates are related to this game";
  this.labelsHeading = labels && labels.labelsHeading ? labels.labelsHeading : "Labels";
  this.customFields = labels && labels.customFields ? labels.customFields : "Custom fields";
  this.dynamicFieldsDescription = labels && labels.dynamicFieldsDescription ? labels.dynamicFieldsDescription : "You can create your custom attributes for easier way to connect your game.";
  this.keyDynamicFields = labels && labels.keyDynamicFields ? labels.keyDynamicFields : "Key";
  this.valueDynamicFields = labels && labels.valueDynamicFields ? labels.valueDynamicFields : "Value";
  this.addRecord = labels && labels.addRecord ? labels.addRecord : "Add record";
  this.cutoffTime = labels && labels.cutoffTime ? labels.cutoffTime : "Cutoff time";
  this.cutoffTimeDescriptionOnCreate = labels && labels.cutoffTimeDescriptionOnCreate ? labels.cutoffTimeDescriptionOnCreate : "Predictions will be accepted until this time. If not provided it will be automatically generated 15 minutes from the first match played.";
  this.cutoffTimeDescriptionOnEdit = labels && labels.cutoffTimeDescriptionOnEdit ? labels.cutoffTimeDescriptionOnEdit : "Predictions will be accepted until this time. Keep in mind that this field SHOULD NOT be empty.";
  this.scheduleOpenAt = labels && labels.scheduleOpenAt ? labels.scheduleOpenAt : "Schedule open at";
  this.scheduleOpenAtDescription = labels && labels.scheduleOpenAtDescription ? labels.scheduleOpenAtDescription : "When provided game's status will automatically set from PENDING to OPEN. Keep in mind that the latest time option is 75 minutes before first match kickoff.";
  this.addFixture = labels && labels.addFixture ? labels.addFixture : "Add fixture";
  this.addWinner = labels && labels.addWinner ? labels.addWinner : "Add winner";
  this.removeFixture = labels && labels.removeFixture ? labels.removeFixture : "Remove fixture";
  this.removeWinner = labels && labels.removeWinner ? labels.removeWinner : "Remove winner";
  this.back = labels && labels.back ? labels.back : "Back";
  this.loadMore = labels && labels.loadMore ? labels.loadMore : "Load more";
  this.exportButton = labels && labels.exportButton ? labels.exportButton : "Export";
  this.reportFor = labels && labels.reportFor ? labels.reportFor : "Report for";
  this.position = labels && labels.position ? labels.position : "Position";
  this.points = labels && labels.points ? labels.points : "Points";
  this.winnersDescription = labels && labels.winnersDescription ? labels.winnersDescription : "Describe the winners...";
  this.winner = labels && labels.winner ? labels.winner : "Winner";
  this.winnerDescription = labels && labels.winnerDescription ? labels.winnerDescription : "Select the winner of the game";
  this.insertWinners = labels && labels.insertWinners ? labels.insertWinners : "Insert winners";
  this.insertWinnersDescription = labels && labels.insertWinnersDescription ? labels.insertWinnersDescription : "Type information about each winner of the game.";
  this.note = labels && labels.note ? labels.note : "Note";
  this.notePlaceholder = labels && labels.notePlaceholder ? labels.notePlaceholder : "Provide some note for the winner...";
  this.tags = labels && labels.tags ? labels.tags : "Tags";
  this.tagsPlaceholder = labels && labels.tagsPlaceholder ? labels.tagsPlaceholder : "Provide tags for the winner...";
  this.save = labels && labels.save ? labels.save : "Save";
  this.preview = labels && labels.preview ? labels.preview : "Preview";
  this.gameNotSettledMessage = labels && labels.gameNotSettledMessage ? labels.gameNotSettledMessage : "Not all matches have been played and therefore no points awarded yet. Please come back after the matches finish to see the leaderboard.";
  this.csvModalTitle = labels && labels.csvModalTitle ? labels.csvModalTitle : "Enter how many users should be exported";
  this.csvModalDescription = labels && labels.csvModalDescription ? labels.csvModalDescription : "";
  this.csvModalPlaceholder = labels && labels.csvModalPlaceholder ? labels.csvModalPlaceholder : "Export the first X users...";
  this.cancel = labels && labels.cancel ? labels.cancel : "Cancel";
  this.csvModalDownloadButton = labels && labels.csvModalDownloadButton ? labels.csvModalDownloadButton : "Download as CSV file";
  this.csvModalValidationMessage = labels && labels.csvModalValidationMessage ? labels.csvModalValidationMessage : "Input value has to be an integer number between 1 and 100";
  this.csvModalErrorMessage = labels && labels.csvModalDownloadButton ? labels.csvModalErrorMessage : "There was a problem with fetching game's report data";
  this.clear = labels && labels.clear ? labels.clear : "Clear";
  this.loadingMessage = labels && labels.loadingMessage ? labels.loadingMessage : "Loading...";
  this.createGameMessage = labels && labels.createGameMessage ? labels.createGameMessage : "You have successfully created a game.";
  this.editGameMessage = labels && labels.editGameMessage ? labels.editGameMessage : "You have successfully edited a game.";
  this.clearCutoffMessage = labels && labels.clearCutoffMessage ? labels.clearCutoffMessage : "You have cleared your cutoff time.";
  this.clearSchedulerMessage = labels && labels.clearSchedulerMessage ? labels.clearSchedulerMessage : "You have cleared your schedule open at.";
  this.clearFromToFilterSportal365ImagesMessage = labels && labels.clearFromToFilterSportal365ImagesMessage ? labels.clearFromToFilterSportal365ImagesMessage : "You have cleared from/to filter for Sportal365 search images";
  this.hideFilters = labels && labels.hideFilters ? labels.hideFilters : "Hide filters";
  this.showFilters = labels && labels.showFilters ? labels.showFilters : "Show filters";
  this.dateFromTo = labels && labels.dateFromTo ? labels.dateFromTo : "Date from/to";
  this.dateFromToPlaceholder = labels && labels.dateFromToPlaceholder ? labels.dateFromToPlaceholder : "Select Date...";
  this.minFixturesMessage = labels && labels.minFixturesMessage ? labels.minFixturesMessage : "There is a requirement how many minimum fixtures you need to provide to create/update game and it is:";
  this.sameChosenMatchMessage = labels && labels.sameChosenMatchMessage ? labels.sameChosenMatchMessage : "Some of selected matches are repeating";
  this.invalidCutoffTimeMessage = labels && labels.invalidCutoffTimeMessage ? labels.invalidCutoffTimeMessage : "Some of the provided matches start before cutoff time. Please choose cutoff time that is before the earliest match kickoff time.";
  this.noImagesFound = labels && labels.noImagesFound ? labels.noImagesFound : "No images found";
  this.fillCutoffTimeEditGameMessage = labels && labels.fillCutoffTimeEditGameMessage ? labels.fillCutoffTimeEditGameMessage : "You need to provide a cutoff time to update the game!";
  this.createGameErrorMessage = labels && labels.createGameErrorMessage ? labels.createGameErrorMessage : "There was a problem with creating the game. Please try again.";
  this.editGameErrorMessage = labels && labels.editGameErrorMessage ? labels.editGameErrorMessage : "There was a problem with editing the game. Please try again.";
  this.leaderboardErrorMessage = labels && labels.leaderboardErrorMessage ? labels.leaderboardErrorMessage : "There was a problem with displaying leaderboard. Please try again.";
  this.gamePredictionsErrorMessage = labels && labels.gamePredictionsErrorMessage ? labels.gamePredictionsErrorMessage : "There was a problem with getting predictions for users. Please try again.";
  this.leaderboardNotAvailable = labels && labels.leaderboardNotAvailable ? labels.leaderboardNotAvailable : "No leaderboard is available for this game.";
  this.gameNoSetWinnersMessage = labels && labels.gameNoSetWinnersMessage ? labels.gameNoSetWinnersMessage : "No winners are set for this game.";
  this.positionAndWinnerRequiredMessage = labels && labels.positionAndWinnerRequiredMessage ? labels.positionAndWinnerRequiredMessage : "Position and winner are required!";
  this.sameChosenWinnerMessage = labels && labels.sameChosenWinnerMessage ? labels.sameChosenWinnerMessage : "You have selected same winners. Each winner has to be unique!";
  this.gameWinnersErrorMessage = labels && labels.gameWinnersErrorMessage ? labels.gameWinnersErrorMessage : "There was a problem with fetching information about game winners. Please try again.";
  this.createGameWinnersMessage = labels && labels.createGameWinnersMessage ? labels.createGameWinnersMessage : "You have successfully created winners for the game.";
  this.createGameWinnersErrorMessage = labels && labels.createGameWinnersErrorMessage ? labels.createGameWinnersErrorMessage : "There was a problem with creating winners for the game. Please try again.";
  this.editGameWinnersMessage = labels && labels.editGameWinnersMessage ? labels.editGameWinnersMessage : "You have successfully edited winners for the game.";
  this.editGameWinnersErrorMessage = labels && labels.editGameWinnersErrorMessage ? labels.editGameWinnersErrorMessage : "There was a problem with editing winners for the game. Please try again.";
  this.relatedEntitiesErrorMessage = labels && labels.relatedEntitiesErrorMessage ? labels.relatedEntitiesErrorMessage : "There was a problem with fetching entities. Please try again.";
  this.dynamicFieldsKeysValidationMessage = labels && labels.dynamicFieldsKeysValidationMessage ? labels.dynamicFieldsKeysValidationMessage : "Only lowercase, numbers and underscore are accepted as keys";
  this.gameByIdErrorMessage = labels && labels.gameByIdErrorMessage ? labels.gameByIdErrorMessage : "There was a problem retrieving full information about the game.";
  this.uploadingImageMessage = labels && labels.uploadingImageMessage ? labels.uploadingImageMessage : "You have successfully uploaded image";
  this.generateSignedInUrlErrorMessage = labels && labels.generateSignedInUrlErrorMessage ? labels.generateSignedInUrlErrorMessage : "There was a problem generating signed in URL to store the image in bucket. Please try again";
  this.uploadingImageErrorMessage = labels && labels.uploadingImageErrorMessage ? labels.uploadingImageErrorMessage : "There was a problem with uploading image to bucket. Please try again";
  this.encryptingImageErrorMessage = labels && labels.encryptingImageErrorMessage ? labels.encryptingImageErrorMessage : "There was a problem with encrypting image before uploading it to bucket. Please try again";
  this.searchSportal365ImagesErrorMessage = labels && labels.searchSportal365ImagesErrorMessage ? labels.searchSportal365ImagesErrorMessage : "There was a problem with searching images from Sportal 365 API. Please try again";
};

var AuthContext = React__default.createContext(null);

function __rest(s, e2) {
  var t2 = {};

  for (var p2 in s) {
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0) t2[p2] = s[p2];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p2 = Object.getOwnPropertySymbols(s); i < p2.length; i++) {
    if (e2.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i])) t2[p2[i]] = s[p2[i]];
  }
  return t2;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e2 = new Error(message);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
var ProviderId = {
  FACEBOOK: "facebook.com",
  GITHUB: "github.com",
  GOOGLE: "google.com",
  PASSWORD: "password",
  PHONE: "phone",
  TWITTER: "twitter.com"
};
var ActionCodeOperation = {
  EMAIL_SIGNIN: "EMAIL_SIGNIN",
  PASSWORD_RESET: "PASSWORD_RESET",
  RECOVER_EMAIL: "RECOVER_EMAIL",
  REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
  VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
  VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _debugErrorMap() {
  var _ref559;

  return _ref559 = {}, _defineProperty3(_ref559, "admin-restricted-operation", "This operation is restricted to administrators only."), _defineProperty3(_ref559, "argument-error", ""), _defineProperty3(_ref559, "app-not-authorized", "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), _defineProperty3(_ref559, "app-not-installed", "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), _defineProperty3(_ref559, "captcha-check-failed", "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), _defineProperty3(_ref559, "code-expired", "The SMS code has expired. Please re-send the verification code to try again."), _defineProperty3(_ref559, "cordova-not-ready", "Cordova framework is not ready."), _defineProperty3(_ref559, "cors-unsupported", "This browser is not supported."), _defineProperty3(_ref559, "credential-already-in-use", "This credential is already associated with a different user account."), _defineProperty3(_ref559, "custom-token-mismatch", "The custom token corresponds to a different audience."), _defineProperty3(_ref559, "requires-recent-login", "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), _defineProperty3(_ref559, "dependent-sdk-initialized-before-auth", "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), _defineProperty3(_ref559, "dynamic-link-not-activated", "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), _defineProperty3(_ref559, "email-change-needs-verification", "Multi-factor users must always have a verified email."), _defineProperty3(_ref559, "email-already-in-use", "The email address is already in use by another account."), _defineProperty3(_ref559, "emulator-config-failed", 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), _defineProperty3(_ref559, "expired-action-code", "The action code has expired."), _defineProperty3(_ref559, "cancelled-popup-request", "This operation has been cancelled due to another conflicting popup being opened."), _defineProperty3(_ref559, "internal-error", "An internal AuthError has occurred."), _defineProperty3(_ref559, "invalid-app-credential", "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), _defineProperty3(_ref559, "invalid-app-id", "The mobile app identifier is not registed for the current project."), _defineProperty3(_ref559, "invalid-user-token", "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), _defineProperty3(_ref559, "invalid-auth-event", "An internal AuthError has occurred."), _defineProperty3(_ref559, "invalid-verification-code", "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), _defineProperty3(_ref559, "invalid-continue-uri", "The continue URL provided in the request is invalid."), _defineProperty3(_ref559, "invalid-cordova-configuration", "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), _defineProperty3(_ref559, "invalid-custom-token", "The custom token format is incorrect. Please check the documentation."), _defineProperty3(_ref559, "invalid-dynamic-link-domain", "The provided dynamic link domain is not configured or authorized for the current project."), _defineProperty3(_ref559, "invalid-email", "The email address is badly formatted."), _defineProperty3(_ref559, "invalid-emulator-scheme", "Emulator URL must start with a valid scheme (http:// or https://)."), _defineProperty3(_ref559, "invalid-api-key", "Your API key is invalid, please check you have copied it correctly."), _defineProperty3(_ref559, "invalid-cert-hash", "The SHA-1 certificate hash provided is invalid."), _defineProperty3(_ref559, "invalid-credential", "The supplied auth credential is malformed or has expired."), _defineProperty3(_ref559, "invalid-message-payload", "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), _defineProperty3(_ref559, "invalid-multi-factor-session", "The request does not contain a valid proof of first factor successful sign-in."), _defineProperty3(_ref559, "invalid-oauth-provider", "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), _defineProperty3(_ref559, "invalid-oauth-client-id", "The OAuth client ID provided is either invalid or does not match the specified API key."), _defineProperty3(_ref559, "unauthorized-domain", "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), _defineProperty3(_ref559, "invalid-action-code", "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), _defineProperty3(_ref559, "wrong-password", "The password is invalid or the user does not have a password."), _defineProperty3(_ref559, "invalid-persistence-type", "The specified persistence type is invalid. It can only be local, session or none."), _defineProperty3(_ref559, "invalid-phone-number", "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), _defineProperty3(_ref559, "invalid-provider-id", "The specified provider ID is invalid."), _defineProperty3(_ref559, "invalid-recipient-email", "The email corresponding to this action failed to send as the provided recipient email address is invalid."), _defineProperty3(_ref559, "invalid-sender", "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), _defineProperty3(_ref559, "invalid-verification-id", "The verification ID used to create the phone auth credential is invalid."), _defineProperty3(_ref559, "invalid-tenant-id", "The Auth instance's tenant ID is invalid."), _defineProperty3(_ref559, "login-blocked", "Login blocked by user-provided method: {$originalMessage}"), _defineProperty3(_ref559, "missing-android-pkg-name", "An Android Package Name must be provided if the Android App is required to be installed."), _defineProperty3(_ref559, "auth-domain-config-required", "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), _defineProperty3(_ref559, "missing-app-credential", "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), _defineProperty3(_ref559, "missing-verification-code", "The phone auth credential was created with an empty SMS verification code."), _defineProperty3(_ref559, "missing-continue-uri", "A continue URL must be provided in the request."), _defineProperty3(_ref559, "missing-iframe-start", "An internal AuthError has occurred."), _defineProperty3(_ref559, "missing-ios-bundle-id", "An iOS Bundle ID must be provided if an App Store ID is provided."), _defineProperty3(_ref559, "missing-or-invalid-nonce", "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), _defineProperty3(_ref559, "missing-password", "A non-empty password must be provided"), _defineProperty3(_ref559, "missing-multi-factor-info", "No second factor identifier is provided."), _defineProperty3(_ref559, "missing-multi-factor-session", "The request is missing proof of first factor successful sign-in."), _defineProperty3(_ref559, "missing-phone-number", "To send verification codes, provide a phone number for the recipient."), _defineProperty3(_ref559, "missing-verification-id", "The phone auth credential was created with an empty verification ID."), _defineProperty3(_ref559, "app-deleted", "This instance of FirebaseApp has been deleted."), _defineProperty3(_ref559, "multi-factor-info-not-found", "The user does not have a second factor matching the identifier provided."), _defineProperty3(_ref559, "multi-factor-auth-required", "Proof of ownership of a second factor is required to complete sign-in."), _defineProperty3(_ref559, "account-exists-with-different-credential", "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), _defineProperty3(_ref559, "network-request-failed", "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), _defineProperty3(_ref559, "no-auth-event", "An internal AuthError has occurred."), _defineProperty3(_ref559, "no-such-provider", "User was not linked to an account with the given provider."), _defineProperty3(_ref559, "null-user", "A null user object was provided as the argument for an operation which requires a non-null user object."), _defineProperty3(_ref559, "operation-not-allowed", "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), _defineProperty3(_ref559, "operation-not-supported-in-this-environment", 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), _defineProperty3(_ref559, "popup-blocked", "Unable to establish a connection with the popup. It may have been blocked by the browser."), _defineProperty3(_ref559, "popup-closed-by-user", "The popup has been closed by the user before finalizing the operation."), _defineProperty3(_ref559, "provider-already-linked", "User can only be linked to one identity for the given provider."), _defineProperty3(_ref559, "quota-exceeded", "The project's quota for this operation has been exceeded."), _defineProperty3(_ref559, "redirect-cancelled-by-user", "The redirect operation has been cancelled by the user before finalizing."), _defineProperty3(_ref559, "redirect-operation-pending", "A redirect sign-in operation is already pending."), _defineProperty3(_ref559, "rejected-credential", "The request contains malformed or mismatching credentials."), _defineProperty3(_ref559, "second-factor-already-in-use", "The second factor is already enrolled on this account."), _defineProperty3(_ref559, "maximum-second-factor-count-exceeded", "The maximum allowed number of second factors on a user has been exceeded."), _defineProperty3(_ref559, "tenant-id-mismatch", "The provided tenant ID does not match the Auth instance's tenant ID"), _defineProperty3(_ref559, "timeout", "The operation has timed out."), _defineProperty3(_ref559, "user-token-expired", "The user's credential is no longer valid. The user must sign in again."), _defineProperty3(_ref559, "too-many-requests", "We have blocked all requests from this device due to unusual activity. Try again later."), _defineProperty3(_ref559, "unauthorized-continue-uri", "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), _defineProperty3(_ref559, "unsupported-first-factor", "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), _defineProperty3(_ref559, "unsupported-persistence-type", "The current environment does not support the specified persistence type."), _defineProperty3(_ref559, "unsupported-tenant-operation", "This operation is not supported in a multi-tenant context."), _defineProperty3(_ref559, "unverified-email", "The operation requires a verified email."), _defineProperty3(_ref559, "user-cancelled", "The user did not grant your application the permissions it requested."), _defineProperty3(_ref559, "user-not-found", "There is no user record corresponding to this identifier. The user may have been deleted."), _defineProperty3(_ref559, "user-disabled", "The user account has been disabled by an administrator."), _defineProperty3(_ref559, "user-mismatch", "The supplied credentials do not correspond to the previously signed in user."), _defineProperty3(_ref559, "user-signed-out", ""), _defineProperty3(_ref559, "weak-password", "The password must be 6 characters long or more."), _defineProperty3(_ref559, "web-storage-unsupported", "This browser is not supported or 3rd party cookies and data may be disabled."), _defineProperty3(_ref559, "already-initialized", "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), _defineProperty3(_ref559, "missing-recaptcha-token", "The reCAPTCHA token is missing when sending request to the backend."), _defineProperty3(_ref559, "invalid-recaptcha-token", "The reCAPTCHA token is invalid when sending request to the backend."), _defineProperty3(_ref559, "invalid-recaptcha-action", "The reCAPTCHA action is invalid when sending request to the backend."), _defineProperty3(_ref559, "recaptcha-not-enabled", "reCAPTCHA Enterprise integration is not enabled for this project."), _defineProperty3(_ref559, "missing-client-type", "The reCAPTCHA client type is missing when sending request to the backend."), _defineProperty3(_ref559, "missing-recaptcha-version", "The reCAPTCHA version is missing when sending request to the backend."), _defineProperty3(_ref559, "invalid-req-type", "Invalid request parameters."), _defineProperty3(_ref559, "invalid-recaptcha-version", "The reCAPTCHA version is invalid when sending request to the backend."), _ref559;
}

function _prodErrorMap() {
  return _defineProperty3({}, "dependent-sdk-initialized-before-auth", "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}

var debugErrorMap = _debugErrorMap;
var prodErrorMap = _prodErrorMap;

var _DEFAULT_AUTH_ERROR_FACTORY = new ErrorFactory("auth", "Firebase", _prodErrorMap());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var logClient = new Logger("@firebase/auth");

function _logWarn(msg) {
  if (logClient.logLevel <= LogLevel.WARN) {
    for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
      args[_key16 - 1] = arguments[_key16];
    }

    logClient.warn.apply(logClient, ["Auth (".concat(SDK_VERSION, "): ").concat(msg)].concat(args));
  }
}

function _logError(msg) {
  if (logClient.logLevel <= LogLevel.ERROR) {
    for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
      args[_key17 - 1] = arguments[_key17];
    }

    logClient.error.apply(logClient, ["Auth (".concat(SDK_VERSION, "): ").concat(msg)].concat(args));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _fail(authOrCode) {
  for (var _len18 = arguments.length, rest = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
    rest[_key18 - 1] = arguments[_key18];
  }

  throw createErrorInternal.apply(void 0, [authOrCode].concat(rest));
}

function _createError(authOrCode) {
  for (var _len19 = arguments.length, rest = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
    rest[_key19 - 1] = arguments[_key19];
  }

  return createErrorInternal.apply(void 0, [authOrCode].concat(rest));
}

function _errorWithCustomMessage(auth, code, message) {
  var errorMap = Object.assign(Object.assign({}, prodErrorMap()), _defineProperty3({}, code, message));
  var factory = new ErrorFactory("auth", "Firebase", errorMap);
  return factory.create(code, {
    appName: auth.name
  });
}

function _assertInstanceOf(auth, object, instance) {
  var constructorInstance = instance;

  if (!(object instanceof constructorInstance)) {
    if (constructorInstance.name !== object.constructor.name) {
      _fail(auth, "argument-error");
    }

    throw _errorWithCustomMessage(auth, "argument-error", "Type of ".concat(object.constructor.name, " does not match expected instance.Did you pass a reference from a different Auth SDK?"));
  }
}

function createErrorInternal(authOrCode) {
  for (var _len20 = arguments.length, rest = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
    rest[_key20 - 1] = arguments[_key20];
  }

  if (typeof authOrCode !== "string") {
    var _authOrCode$_errorFac;

    var code = rest[0];

    var fullParams = _toConsumableArray3(rest.slice(1));

    if (fullParams[0]) {
      fullParams[0].appName = authOrCode.name;
    }

    return (_authOrCode$_errorFac = authOrCode._errorFactory).create.apply(_authOrCode$_errorFac, [code].concat(_toConsumableArray3(fullParams)));
  }

  return _DEFAULT_AUTH_ERROR_FACTORY.create.apply(_DEFAULT_AUTH_ERROR_FACTORY, [authOrCode].concat(rest));
}

function _assert$4(assertion, authOrCode) {
  if (!assertion) {
    for (var _len21 = arguments.length, rest = new Array(_len21 > 2 ? _len21 - 2 : 0), _key21 = 2; _key21 < _len21; _key21++) {
      rest[_key21 - 2] = arguments[_key21];
    }

    throw createErrorInternal.apply(void 0, [authOrCode].concat(rest));
  }
}

function debugFail(failure) {
  var message = "INTERNAL ASSERTION FAILED: " + failure;

  _logError(message);

  throw new Error(message);
}

function debugAssert(assertion, message) {
  if (!assertion) {
    debugFail(message);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getCurrentUrl() {
  var _a2;

  return typeof self !== "undefined" && ((_a2 = self.location) === null || _a2 === void 0 ? void 0 : _a2.href) || "";
}

function _isHttpOrHttps$1() {
  return _getCurrentScheme$1() === "http:" || _getCurrentScheme$1() === "https:";
}

function _getCurrentScheme$1() {
  var _a2;

  return typeof self !== "undefined" && ((_a2 = self.location) === null || _a2 === void 0 ? void 0 : _a2.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _isOnline() {
  if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && (_isHttpOrHttps$1() || isBrowserExtension() || "connection" in navigator)) {
    return navigator.onLine;
  }

  return true;
}

function _getUserLanguage() {
  if (typeof navigator === "undefined") {
    return null;
  }

  var navigatorLanguage = navigator;
  return navigatorLanguage.languages && navigatorLanguage.languages[0] || navigatorLanguage.language || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Delay =
/*#__PURE__*/
function () {
  function Delay(shortDelay, longDelay) {
    _classCallCheck3(this, Delay);

    this.shortDelay = shortDelay;
    this.longDelay = longDelay;
    debugAssert(longDelay > shortDelay, "Short delay should be less than long delay!");
    this.isMobile = isMobileCordova() || isReactNative();
  }

  _createClass3(Delay, [{
    key: "get",
    value: function get() {
      if (!_isOnline()) {
        return Math.min(5e3, this.shortDelay);
      }

      return this.isMobile ? this.longDelay : this.shortDelay;
    }
  }]);

  return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _emulatorUrl(config, path) {
  debugAssert(config.emulator, "Emulator should always be set here");
  var url = config.emulator.url;

  if (!path) {
    return url;
  }

  return "".concat(url).concat(path.startsWith("/") ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var FetchProvider =
/*#__PURE__*/
function () {
  function FetchProvider() {
    _classCallCheck3(this, FetchProvider);
  }

  _createClass3(FetchProvider, null, [{
    key: "initialize",
    value: function initialize(fetchImpl, headersImpl, responseImpl) {
      this.fetchImpl = fetchImpl;

      if (headersImpl) {
        this.headersImpl = headersImpl;
      }

      if (responseImpl) {
        this.responseImpl = responseImpl;
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      if (this.fetchImpl) {
        return this.fetchImpl;
      }

      if (typeof self !== "undefined" && "fetch" in self) {
        return self.fetch;
      }

      debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }, {
    key: "headers",
    value: function headers() {
      if (this.headersImpl) {
        return this.headersImpl;
      }

      if (typeof self !== "undefined" && "Headers" in self) {
        return self.Headers;
      }

      debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }, {
    key: "response",
    value: function response() {
      if (this.responseImpl) {
        return this.responseImpl;
      }

      if (typeof self !== "undefined" && "Response" in self) {
        return self.Response;
      }

      debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }]);

  return FetchProvider;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var SERVER_ERROR_MAP = (_SERVER_ERROR_MAP = {}, _defineProperty3(_SERVER_ERROR_MAP, "CREDENTIAL_MISMATCH", "custom-token-mismatch"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_CUSTOM_TOKEN", "internal-error"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_IDENTIFIER", "invalid-email"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_CONTINUE_URI", "internal-error"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_PASSWORD", "wrong-password"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_PASSWORD", "missing-password"), _defineProperty3(_SERVER_ERROR_MAP, "EMAIL_EXISTS", "email-already-in-use"), _defineProperty3(_SERVER_ERROR_MAP, "PASSWORD_LOGIN_DISABLED", "operation-not-allowed"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_IDP_RESPONSE", "invalid-credential"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_PENDING_TOKEN", "invalid-credential"), _defineProperty3(_SERVER_ERROR_MAP, "FEDERATED_USER_ID_ALREADY_LINKED", "credential-already-in-use"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_REQ_TYPE", "internal-error"), _defineProperty3(_SERVER_ERROR_MAP, "EMAIL_NOT_FOUND", "user-not-found"), _defineProperty3(_SERVER_ERROR_MAP, "RESET_PASSWORD_EXCEED_LIMIT", "too-many-requests"), _defineProperty3(_SERVER_ERROR_MAP, "EXPIRED_OOB_CODE", "expired-action-code"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_OOB_CODE", "invalid-action-code"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_OOB_CODE", "internal-error"), _defineProperty3(_SERVER_ERROR_MAP, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN", "requires-recent-login"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_ID_TOKEN", "invalid-user-token"), _defineProperty3(_SERVER_ERROR_MAP, "TOKEN_EXPIRED", "user-token-expired"), _defineProperty3(_SERVER_ERROR_MAP, "USER_NOT_FOUND", "user-token-expired"), _defineProperty3(_SERVER_ERROR_MAP, "TOO_MANY_ATTEMPTS_TRY_LATER", "too-many-requests"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_CODE", "invalid-verification-code"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_SESSION_INFO", "invalid-verification-id"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_TEMPORARY_PROOF", "invalid-credential"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_SESSION_INFO", "missing-verification-id"), _defineProperty3(_SERVER_ERROR_MAP, "SESSION_EXPIRED", "code-expired"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_ANDROID_PACKAGE_NAME", "missing-android-pkg-name"), _defineProperty3(_SERVER_ERROR_MAP, "UNAUTHORIZED_DOMAIN", "unauthorized-continue-uri"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_OAUTH_CLIENT_ID", "invalid-oauth-client-id"), _defineProperty3(_SERVER_ERROR_MAP, "ADMIN_ONLY_OPERATION", "admin-restricted-operation"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_MFA_PENDING_CREDENTIAL", "invalid-multi-factor-session"), _defineProperty3(_SERVER_ERROR_MAP, "MFA_ENROLLMENT_NOT_FOUND", "multi-factor-info-not-found"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_MFA_ENROLLMENT_ID", "missing-multi-factor-info"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_MFA_PENDING_CREDENTIAL", "missing-multi-factor-session"), _defineProperty3(_SERVER_ERROR_MAP, "SECOND_FACTOR_EXISTS", "second-factor-already-in-use"), _defineProperty3(_SERVER_ERROR_MAP, "SECOND_FACTOR_LIMIT_EXCEEDED", "maximum-second-factor-count-exceeded"), _defineProperty3(_SERVER_ERROR_MAP, "BLOCKING_FUNCTION_ERROR_RESPONSE", "internal-error"), _defineProperty3(_SERVER_ERROR_MAP, "RECAPTCHA_NOT_ENABLED", "recaptcha-not-enabled"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_RECAPTCHA_TOKEN", "missing-recaptcha-token"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_TOKEN", "invalid-recaptcha-token"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_ACTION", "invalid-recaptcha-action"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_CLIENT_TYPE", "missing-client-type"), _defineProperty3(_SERVER_ERROR_MAP, "MISSING_RECAPTCHA_VERSION", "missing-recaptcha-version"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_VERSION", "invalid-recaptcha-version"), _defineProperty3(_SERVER_ERROR_MAP, "INVALID_REQ_TYPE", "invalid-req-type"), _SERVER_ERROR_MAP);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DEFAULT_API_TIMEOUT_MS = new Delay(3e4, 6e4);

function _addTidIfNecessary(auth, request2) {
  if (auth.tenantId && !request2.tenantId) {
    return Object.assign(Object.assign({}, request2), {
      tenantId: auth.tenantId
    });
  }

  return request2;
}

function _performApiRequest(_x881, _x882, _x883, _x884) {
  return _performApiRequest2.apply(this, arguments);
}

function _performApiRequest2() {
  _performApiRequest2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee650(auth, method, path, request2) {
    var customErrorMap,
        _args651 = arguments;
    return _regeneratorRuntime.wrap(function _callee650$(_context651) {
      while (1) {
        switch (_context651.prev = _context651.next) {
          case 0:
            customErrorMap = _args651.length > 4 && _args651[4] !== undefined ? _args651[4] : {};
            return _context651.abrupt("return", _performFetchWithErrorHandling(auth, customErrorMap,
            /*#__PURE__*/
            _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee649() {
              var body, params, query, headers;
              return _regeneratorRuntime.wrap(function _callee649$(_context650) {
                while (1) {
                  switch (_context650.prev = _context650.next) {
                    case 0:
                      body = {};
                      params = {};

                      if (request2) {
                        if (method === "GET") {
                          params = request2;
                        } else {
                          body = {
                            body: JSON.stringify(request2)
                          };
                        }
                      }

                      query = querystring(Object.assign({
                        key: auth.config.apiKey
                      }, params)).slice(1);
                      _context650.next = 6;
                      return auth._getAdditionalHeaders();

                    case 6:
                      headers = _context650.sent;
                      headers["Content-Type"] = "application/json";

                      if (auth.languageCode) {
                        headers["X-Firebase-Locale"] = auth.languageCode;
                      }

                      return _context650.abrupt("return", FetchProvider.fetch()(_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                        method: method,
                        headers: headers,
                        referrerPolicy: "no-referrer"
                      }, body)));

                    case 10:
                    case "end":
                      return _context650.stop();
                  }
                }
              }, _callee649);
            }))));

          case 2:
          case "end":
            return _context651.stop();
        }
      }
    }, _callee650);
  }));
  return _performApiRequest2.apply(this, arguments);
}

function _performFetchWithErrorHandling(_x885, _x886, _x887) {
  return _performFetchWithErrorHandling2.apply(this, arguments);
}

function _performFetchWithErrorHandling2() {
  _performFetchWithErrorHandling2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee651(auth, customErrorMap, fetchFn) {
    var errorMap, networkTimeout, response, json, errorMessage, _errorMessage$split, _errorMessage$split2, serverErrorCode, serverErrorMessage, authError;

    return _regeneratorRuntime.wrap(function _callee651$(_context652) {
      while (1) {
        switch (_context652.prev = _context652.next) {
          case 0:
            auth._canInitEmulator = false;
            errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
            _context652.prev = 2;
            networkTimeout = new NetworkTimeout(auth);
            _context652.next = 6;
            return Promise.race([fetchFn(), networkTimeout.promise]);

          case 6:
            response = _context652.sent;
            networkTimeout.clearNetworkTimeout();
            _context652.next = 10;
            return response.json();

          case 10:
            json = _context652.sent;

            if (!("needConfirmation" in json)) {
              _context652.next = 13;
              break;
            }

            throw _makeTaggedError(auth, "account-exists-with-different-credential", json);

          case 13:
            if (!(response.ok && !("errorMessage" in json))) {
              _context652.next = 17;
              break;
            }

            return _context652.abrupt("return", json);

          case 17:
            errorMessage = response.ok ? json.errorMessage : json.error.message;
            _errorMessage$split = errorMessage.split(" : "), _errorMessage$split2 = _slicedToArray3(_errorMessage$split, 2), serverErrorCode = _errorMessage$split2[0], serverErrorMessage = _errorMessage$split2[1];

            if (!(serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED")) {
              _context652.next = 23;
              break;
            }

            throw _makeTaggedError(auth, "credential-already-in-use", json);

          case 23:
            if (!(serverErrorCode === "EMAIL_EXISTS")) {
              _context652.next = 27;
              break;
            }

            throw _makeTaggedError(auth, "email-already-in-use", json);

          case 27:
            if (!(serverErrorCode === "USER_DISABLED")) {
              _context652.next = 29;
              break;
            }

            throw _makeTaggedError(auth, "user-disabled", json);

          case 29:
            authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");

            if (!serverErrorMessage) {
              _context652.next = 34;
              break;
            }

            throw _errorWithCustomMessage(auth, authError, serverErrorMessage);

          case 34:
            _fail(auth, authError);

          case 35:
            _context652.next = 42;
            break;

          case 37:
            _context652.prev = 37;
            _context652.t0 = _context652["catch"](2);

            if (!(_context652.t0 instanceof FirebaseError)) {
              _context652.next = 41;
              break;
            }

            throw _context652.t0;

          case 41:
            _fail(auth, "network-request-failed", {
              "message": String(_context652.t0)
            });

          case 42:
          case "end":
            return _context652.stop();
        }
      }
    }, _callee651, null, [[2, 37]]);
  }));
  return _performFetchWithErrorHandling2.apply(this, arguments);
}

function _performSignInRequest(_x888, _x889, _x890, _x891) {
  return _performSignInRequest2.apply(this, arguments);
}

function _performSignInRequest2() {
  _performSignInRequest2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee652(auth, method, path, request2) {
    var customErrorMap,
        serverResponse,
        _args653 = arguments;
    return _regeneratorRuntime.wrap(function _callee652$(_context653) {
      while (1) {
        switch (_context653.prev = _context653.next) {
          case 0:
            customErrorMap = _args653.length > 4 && _args653[4] !== undefined ? _args653[4] : {};
            _context653.next = 3;
            return _performApiRequest(auth, method, path, request2, customErrorMap);

          case 3:
            serverResponse = _context653.sent;

            if ("mfaPendingCredential" in serverResponse) {
              _fail(auth, "multi-factor-auth-required", {
                _serverResponse: serverResponse
              });
            }

            return _context653.abrupt("return", serverResponse);

          case 6:
          case "end":
            return _context653.stop();
        }
      }
    }, _callee652);
  }));
  return _performSignInRequest2.apply(this, arguments);
}

function _getFinalTarget(auth, host, path, query) {
  var base = "".concat(host).concat(path, "?").concat(query);

  if (!auth.config.emulator) {
    return "".concat(auth.config.apiScheme, "://").concat(base);
  }

  return _emulatorUrl(auth.config, base);
}

var NetworkTimeout =
/*#__PURE__*/
function () {
  function NetworkTimeout(auth) {
    var _this144 = this;

    _classCallCheck3(this, NetworkTimeout);

    this.auth = auth;
    this.timer = null;
    this.promise = new Promise(function (_2, reject) {
      _this144.timer = setTimeout(function () {
        return reject(_createError(_this144.auth, "network-request-failed"));
      }, DEFAULT_API_TIMEOUT_MS.get());
    });
  }

  _createClass3(NetworkTimeout, [{
    key: "clearNetworkTimeout",
    value: function clearNetworkTimeout() {
      clearTimeout(this.timer);
    }
  }]);

  return NetworkTimeout;
}();

function _makeTaggedError(auth, code, response) {
  var errorParams = {
    appName: auth.name
  };

  if (response.email) {
    errorParams.email = response.email;
  }

  if (response.phoneNumber) {
    errorParams.phoneNumber = response.phoneNumber;
  }

  var error = _createError(auth, code, errorParams);

  error.customData._tokenResponse = response;
  return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function deleteAccount(_x892, _x893) {
  return _deleteAccount.apply(this, arguments);
}

function _deleteAccount() {
  _deleteAccount = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee653(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee653$(_context654) {
      while (1) {
        switch (_context654.prev = _context654.next) {
          case 0:
            return _context654.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:delete", request2));

          case 1:
          case "end":
            return _context654.stop();
        }
      }
    }, _callee653);
  }));
  return _deleteAccount.apply(this, arguments);
}

function deleteLinkedAccounts(_x894, _x895) {
  return _deleteLinkedAccounts.apply(this, arguments);
}

function _deleteLinkedAccounts() {
  _deleteLinkedAccounts = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee654(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee654$(_context655) {
      while (1) {
        switch (_context655.prev = _context655.next) {
          case 0:
            return _context655.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:update", request2));

          case 1:
          case "end":
            return _context655.stop();
        }
      }
    }, _callee654);
  }));
  return _deleteLinkedAccounts.apply(this, arguments);
}

function getAccountInfo(_x896, _x897) {
  return _getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getAccountInfo() {
  _getAccountInfo = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee655(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee655$(_context656) {
      while (1) {
        switch (_context656.prev = _context656.next) {
          case 0:
            return _context656.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:lookup", request2));

          case 1:
          case "end":
            return _context656.stop();
        }
      }
    }, _callee655);
  }));
  return _getAccountInfo.apply(this, arguments);
}

function utcTimestampToDateString(utcTimestamp) {
  if (!utcTimestamp) {
    return void 0;
  }

  try {
    var date = new Date(Number(utcTimestamp));

    if (!isNaN(date.getTime())) {
      return date.toUTCString();
    }
  } catch (e2) {}

  return void 0;
}

function _getIdTokenResult2(_x898) {
  return _getIdTokenResult.apply(this, arguments);
}

function _getIdTokenResult() {
  _getIdTokenResult = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee656(user) {
    var forceRefresh,
        userInternal,
        token2,
        claims,
        firebase2,
        signInProvider,
        _args657 = arguments;
    return _regeneratorRuntime.wrap(function _callee656$(_context657) {
      while (1) {
        switch (_context657.prev = _context657.next) {
          case 0:
            forceRefresh = _args657.length > 1 && _args657[1] !== undefined ? _args657[1] : false;
            userInternal = getModularInstance(user);
            _context657.next = 4;
            return userInternal.getIdToken(forceRefresh);

          case 4:
            token2 = _context657.sent;
            claims = _parseToken(token2);

            _assert$4(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error");

            firebase2 = typeof claims.firebase === "object" ? claims.firebase : void 0;
            signInProvider = firebase2 === null || firebase2 === void 0 ? void 0 : firebase2["sign_in_provider"];
            return _context657.abrupt("return", {
              claims: claims,
              token: token2,
              authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
              issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
              expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
              signInProvider: signInProvider || null,
              signInSecondFactor: (firebase2 === null || firebase2 === void 0 ? void 0 : firebase2["sign_in_second_factor"]) || null
            });

          case 10:
          case "end":
            return _context657.stop();
        }
      }
    }, _callee656);
  }));
  return _getIdTokenResult.apply(this, arguments);
}

function secondsStringToMilliseconds(seconds) {
  return Number(seconds) * 1e3;
}

function _parseToken(token2) {
  var _token2$split3 = token2.split("."),
      _token2$split4 = _slicedToArray3(_token2$split3, 3),
      algorithm = _token2$split4[0],
      payload = _token2$split4[1],
      signature = _token2$split4[2];

  if (algorithm === void 0 || payload === void 0 || signature === void 0) {
    _logError("JWT malformed, contained fewer than 3 sections");

    return null;
  }

  try {
    var decoded = base64Decode(payload);

    if (!decoded) {
      _logError("Failed to decode base64 JWT payload");

      return null;
    }

    return JSON.parse(decoded);
  } catch (e2) {
    _logError("Caught error parsing JWT payload as JSON", e2 === null || e2 === void 0 ? void 0 : e2.toString());

    return null;
  }
}

function _tokenExpiresIn(token2) {
  var parsedToken = _parseToken(token2);

  _assert$4(parsedToken, "internal-error");

  _assert$4(typeof parsedToken.exp !== "undefined", "internal-error");

  _assert$4(typeof parsedToken.iat !== "undefined", "internal-error");

  return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _logoutIfInvalidated(_x899, _x900) {
  return _logoutIfInvalidated2.apply(this, arguments);
}

function _logoutIfInvalidated2() {
  _logoutIfInvalidated2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee657(user, promise) {
    var bypassAuthState,
        _args658 = arguments;
    return _regeneratorRuntime.wrap(function _callee657$(_context658) {
      while (1) {
        switch (_context658.prev = _context658.next) {
          case 0:
            bypassAuthState = _args658.length > 2 && _args658[2] !== undefined ? _args658[2] : false;

            if (!bypassAuthState) {
              _context658.next = 3;
              break;
            }

            return _context658.abrupt("return", promise);

          case 3:
            _context658.prev = 3;
            _context658.next = 6;
            return promise;

          case 6:
            return _context658.abrupt("return", _context658.sent);

          case 9:
            _context658.prev = 9;
            _context658.t0 = _context658["catch"](3);

            if (!(_context658.t0 instanceof FirebaseError && isUserInvalidated(_context658.t0))) {
              _context658.next = 15;
              break;
            }

            if (!(user.auth.currentUser === user)) {
              _context658.next = 15;
              break;
            }

            _context658.next = 15;
            return user.auth.signOut();

          case 15:
            throw _context658.t0;

          case 16:
          case "end":
            return _context658.stop();
        }
      }
    }, _callee657, null, [[3, 9]]);
  }));
  return _logoutIfInvalidated2.apply(this, arguments);
}

function isUserInvalidated(_ref561) {
  var code = _ref561.code;
  return code === "auth/".concat("user-disabled") || code === "auth/".concat("user-token-expired");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ProactiveRefresh =
/*#__PURE__*/
function () {
  function ProactiveRefresh(user) {
    _classCallCheck3(this, ProactiveRefresh);

    this.user = user;
    this.isRunning = false;
    this.timerId = null;
    this.errorBackoff = 3e4;
  }

  _createClass3(ProactiveRefresh, [{
    key: "_start",
    value: function _start() {
      if (this.isRunning) {
        return;
      }

      this.isRunning = true;
      this.schedule();
    }
  }, {
    key: "_stop",
    value: function _stop() {
      if (!this.isRunning) {
        return;
      }

      this.isRunning = false;

      if (this.timerId !== null) {
        clearTimeout(this.timerId);
      }
    }
  }, {
    key: "getInterval",
    value: function getInterval(wasError) {
      var _a2;

      if (wasError) {
        var interval = this.errorBackoff;
        this.errorBackoff = Math.min(this.errorBackoff * 2, 96e4);
        return interval;
      } else {
        this.errorBackoff = 3e4;
        var expTime = (_a2 = this.user.stsTokenManager.expirationTime) !== null && _a2 !== void 0 ? _a2 : 0;

        var _interval = expTime - Date.now() - 3e5;

        return Math.max(0, _interval);
      }
    }
  }, {
    key: "schedule",
    value: function schedule() {
      var _this145 = this;

      var wasError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isRunning) {
        return;
      }

      var interval = this.getInterval(wasError);
      this.timerId = setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee515() {
        return _regeneratorRuntime.wrap(function _callee515$(_context516) {
          while (1) {
            switch (_context516.prev = _context516.next) {
              case 0:
                _context516.next = 2;
                return _this145.iteration();

              case 2:
              case "end":
                return _context516.stop();
            }
          }
        }, _callee515);
      })), interval);
    }
  }, {
    key: "iteration",
    value: function () {
      var _iteration = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee516() {
        return _regeneratorRuntime.wrap(function _callee516$(_context517) {
          while (1) {
            switch (_context517.prev = _context517.next) {
              case 0:
                _context517.prev = 0;
                _context517.next = 3;
                return this.user.getIdToken(true);

              case 3:
                _context517.next = 9;
                break;

              case 5:
                _context517.prev = 5;
                _context517.t0 = _context517["catch"](0);

                if ((_context517.t0 === null || _context517.t0 === void 0 ? void 0 : _context517.t0.code) === "auth/".concat("network-request-failed")) {
                  this.schedule(true);
                }

                return _context517.abrupt("return");

              case 9:
                this.schedule();

              case 10:
              case "end":
                return _context517.stop();
            }
          }
        }, _callee516, this, [[0, 5]]);
      }));

      function iteration() {
        return _iteration.apply(this, arguments);
      }

      return iteration;
    }()
  }]);

  return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var UserMetadata =
/*#__PURE__*/
function () {
  function UserMetadata(createdAt, lastLoginAt) {
    _classCallCheck3(this, UserMetadata);

    this.createdAt = createdAt;
    this.lastLoginAt = lastLoginAt;

    this._initializeTime();
  }

  _createClass3(UserMetadata, [{
    key: "_initializeTime",
    value: function _initializeTime() {
      this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
      this.creationTime = utcTimestampToDateString(this.createdAt);
    }
  }, {
    key: "_copy",
    value: function _copy(metadata) {
      this.createdAt = metadata.createdAt;
      this.lastLoginAt = metadata.lastLoginAt;

      this._initializeTime();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        createdAt: this.createdAt,
        lastLoginAt: this.lastLoginAt
      };
    }
  }]);

  return UserMetadata;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reloadWithoutSaving(_x901) {
  return _reloadWithoutSaving2.apply(this, arguments);
}

function _reloadWithoutSaving2() {
  _reloadWithoutSaving2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee658(user) {
    var _a2, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;

    return _regeneratorRuntime.wrap(function _callee658$(_context659) {
      while (1) {
        switch (_context659.prev = _context659.next) {
          case 0:
            auth = user.auth;
            _context659.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context659.sent;
            _context659.next = 6;
            return _logoutIfInvalidated(user, getAccountInfo(auth, {
              idToken: idToken
            }));

          case 6:
            response = _context659.sent;

            _assert$4(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error");

            coreAccount = response.users[0];

            user._notifyReloadListener(coreAccount);

            newProviderData = ((_a2 = coreAccount.providerUserInfo) === null || _a2 === void 0 ? void 0 : _a2.length) ? extractProviderData(coreAccount.providerUserInfo) : [];
            providerData = mergeProviderData(user.providerData, newProviderData);
            oldIsAnonymous = user.isAnonymous;
            newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
            isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
            updates = {
              uid: coreAccount.localId,
              displayName: coreAccount.displayName || null,
              photoURL: coreAccount.photoUrl || null,
              email: coreAccount.email || null,
              emailVerified: coreAccount.emailVerified || false,
              phoneNumber: coreAccount.phoneNumber || null,
              tenantId: coreAccount.tenantId || null,
              providerData: providerData,
              metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
              isAnonymous: isAnonymous
            };
            Object.assign(user, updates);

          case 17:
          case "end":
            return _context659.stop();
        }
      }
    }, _callee658);
  }));
  return _reloadWithoutSaving2.apply(this, arguments);
}

function _reload2(_x902) {
  return _reload.apply(this, arguments);
}

function _reload() {
  _reload = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee659(user) {
    var userInternal;
    return _regeneratorRuntime.wrap(function _callee659$(_context660) {
      while (1) {
        switch (_context660.prev = _context660.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context660.next = 3;
            return _reloadWithoutSaving(userInternal);

          case 3:
            _context660.next = 5;
            return userInternal.auth._persistUserIfCurrent(userInternal);

          case 5:
            userInternal.auth._notifyListenersIfCurrent(userInternal);

          case 6:
          case "end":
            return _context660.stop();
        }
      }
    }, _callee659);
  }));
  return _reload.apply(this, arguments);
}

function mergeProviderData(original, newData) {
  var deduped = original.filter(function (o) {
    return !newData.some(function (n2) {
      return n2.providerId === o.providerId;
    });
  });
  return [].concat(_toConsumableArray3(deduped), _toConsumableArray3(newData));
}

function extractProviderData(providers) {
  return providers.map(function (_a2) {
    var providerId = _a2.providerId,
        provider = __rest(_a2, ["providerId"]);

    return {
      providerId: providerId,
      uid: provider.rawId || "",
      displayName: provider.displayName || null,
      email: provider.email || null,
      phoneNumber: provider.phoneNumber || null,
      photoURL: provider.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function requestStsToken(_x903, _x904) {
  return _requestStsToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _requestStsToken() {
  _requestStsToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee661(auth, refreshToken) {
    var response;
    return _regeneratorRuntime.wrap(function _callee661$(_context662) {
      while (1) {
        switch (_context662.prev = _context662.next) {
          case 0:
            _context662.next = 2;
            return _performFetchWithErrorHandling(auth, {},
            /*#__PURE__*/
            _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee660() {
              var body, _auth$config, tokenApiHost, apiKey, url, headers;

              return _regeneratorRuntime.wrap(function _callee660$(_context661) {
                while (1) {
                  switch (_context661.prev = _context661.next) {
                    case 0:
                      body = querystring({
                        "grant_type": "refresh_token",
                        "refresh_token": refreshToken
                      }).slice(1);
                      _auth$config = auth.config, tokenApiHost = _auth$config.tokenApiHost, apiKey = _auth$config.apiKey;
                      url = _getFinalTarget(auth, tokenApiHost, "/v1/token", "key=".concat(apiKey));
                      _context661.next = 5;
                      return auth._getAdditionalHeaders();

                    case 5:
                      headers = _context661.sent;
                      headers["Content-Type"] = "application/x-www-form-urlencoded";
                      return _context661.abrupt("return", FetchProvider.fetch()(url, {
                        method: "POST",
                        headers: headers,
                        body: body
                      }));

                    case 8:
                    case "end":
                      return _context661.stop();
                  }
                }
              }, _callee660);
            })));

          case 2:
            response = _context662.sent;
            return _context662.abrupt("return", {
              accessToken: response.access_token,
              expiresIn: response.expires_in,
              refreshToken: response.refresh_token
            });

          case 4:
          case "end":
            return _context662.stop();
        }
      }
    }, _callee661);
  }));
  return _requestStsToken.apply(this, arguments);
}

var StsTokenManager =
/*#__PURE__*/
function () {
  function StsTokenManager() {
    _classCallCheck3(this, StsTokenManager);

    this.refreshToken = null;
    this.accessToken = null;
    this.expirationTime = null;
  }

  _createClass3(StsTokenManager, [{
    key: "updateFromServerResponse",
    value: function updateFromServerResponse(response) {
      _assert$4(response.idToken, "internal-error");

      _assert$4(typeof response.idToken !== "undefined", "internal-error");

      _assert$4(typeof response.refreshToken !== "undefined", "internal-error");

      var expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : _tokenExpiresIn(response.idToken);
      this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
  }, {
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee517(auth) {
        var forceRefresh,
            _args518 = arguments;
        return _regeneratorRuntime.wrap(function _callee517$(_context518) {
          while (1) {
            switch (_context518.prev = _context518.next) {
              case 0:
                forceRefresh = _args518.length > 1 && _args518[1] !== undefined ? _args518[1] : false;

                _assert$4(!this.accessToken || this.refreshToken, auth, "user-token-expired");

                if (!(!forceRefresh && this.accessToken && !this.isExpired)) {
                  _context518.next = 4;
                  break;
                }

                return _context518.abrupt("return", this.accessToken);

              case 4:
                if (!this.refreshToken) {
                  _context518.next = 8;
                  break;
                }

                _context518.next = 7;
                return this.refresh(auth, this.refreshToken);

              case 7:
                return _context518.abrupt("return", this.accessToken);

              case 8:
                return _context518.abrupt("return", null);

              case 9:
              case "end":
                return _context518.stop();
            }
          }
        }, _callee517, this);
      }));

      function getToken(_x905) {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "clearRefreshToken",
    value: function clearRefreshToken() {
      this.refreshToken = null;
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee518(auth, oldToken) {
        var _ref563, accessToken, refreshToken, expiresIn;

        return _regeneratorRuntime.wrap(function _callee518$(_context519) {
          while (1) {
            switch (_context519.prev = _context519.next) {
              case 0:
                _context519.next = 2;
                return requestStsToken(auth, oldToken);

              case 2:
                _ref563 = _context519.sent;
                accessToken = _ref563.accessToken;
                refreshToken = _ref563.refreshToken;
                expiresIn = _ref563.expiresIn;
                this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));

              case 7:
              case "end":
                return _context519.stop();
            }
          }
        }, _callee518, this);
      }));

      function refresh(_x906, _x907) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "updateTokensAndExpiration",
    value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
      this.refreshToken = refreshToken || null;
      this.accessToken = accessToken || null;
      this.expirationTime = Date.now() + expiresInSec * 1e3;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        refreshToken: this.refreshToken,
        accessToken: this.accessToken,
        expirationTime: this.expirationTime
      };
    }
  }, {
    key: "_assign",
    value: function _assign(stsTokenManager) {
      this.accessToken = stsTokenManager.accessToken;
      this.refreshToken = stsTokenManager.refreshToken;
      this.expirationTime = stsTokenManager.expirationTime;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      return Object.assign(new StsTokenManager(), this.toJSON());
    }
  }, {
    key: "_performRefresh",
    value: function _performRefresh() {
      return debugFail("not implemented");
    }
  }, {
    key: "isExpired",
    get: function get() {
      return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(appName, object) {
      var refreshToken = object.refreshToken,
          accessToken = object.accessToken,
          expirationTime = object.expirationTime;
      var manager = new StsTokenManager();

      if (refreshToken) {
        _assert$4(typeof refreshToken === "string", "internal-error", {
          appName: appName
        });

        manager.refreshToken = refreshToken;
      }

      if (accessToken) {
        _assert$4(typeof accessToken === "string", "internal-error", {
          appName: appName
        });

        manager.accessToken = accessToken;
      }

      if (expirationTime) {
        _assert$4(typeof expirationTime === "number", "internal-error", {
          appName: appName
        });

        manager.expirationTime = expirationTime;
      }

      return manager;
    }
  }]);

  return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function assertStringOrUndefined(assertion, appName) {
  _assert$4(typeof assertion === "string" || typeof assertion === "undefined", "internal-error", {
    appName: appName
  });
}

var UserImpl =
/*#__PURE__*/
function () {
  function UserImpl(_a2) {
    _classCallCheck3(this, UserImpl);

    var uid = _a2.uid,
        auth = _a2.auth,
        stsTokenManager = _a2.stsTokenManager,
        opt = __rest(_a2, ["uid", "auth", "stsTokenManager"]);

    this.providerId = "firebase";
    this.proactiveRefresh = new ProactiveRefresh(this);
    this.reloadUserInfo = null;
    this.reloadListener = null;
    this.uid = uid;
    this.auth = auth;
    this.stsTokenManager = stsTokenManager;
    this.accessToken = stsTokenManager.accessToken;
    this.displayName = opt.displayName || null;
    this.email = opt.email || null;
    this.emailVerified = opt.emailVerified || false;
    this.phoneNumber = opt.phoneNumber || null;
    this.photoURL = opt.photoURL || null;
    this.isAnonymous = opt.isAnonymous || false;
    this.tenantId = opt.tenantId || null;
    this.providerData = opt.providerData ? _toConsumableArray3(opt.providerData) : [];
    this.metadata = new UserMetadata(opt.createdAt || void 0, opt.lastLoginAt || void 0);
  }

  _createClass3(UserImpl, [{
    key: "getIdToken",
    value: function () {
      var _getIdToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee519(forceRefresh) {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee519$(_context520) {
          while (1) {
            switch (_context520.prev = _context520.next) {
              case 0:
                _context520.next = 2;
                return _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));

              case 2:
                accessToken = _context520.sent;

                _assert$4(accessToken, this.auth, "internal-error");

                if (!(this.accessToken !== accessToken)) {
                  _context520.next = 9;
                  break;
                }

                this.accessToken = accessToken;
                _context520.next = 8;
                return this.auth._persistUserIfCurrent(this);

              case 8:
                this.auth._notifyListenersIfCurrent(this);

              case 9:
                return _context520.abrupt("return", accessToken);

              case 10:
              case "end":
                return _context520.stop();
            }
          }
        }, _callee519, this);
      }));

      function getIdToken(_x908) {
        return _getIdToken.apply(this, arguments);
      }

      return getIdToken;
    }()
  }, {
    key: "getIdTokenResult",
    value: function getIdTokenResult(forceRefresh) {
      return _getIdTokenResult2(this, forceRefresh);
    }
  }, {
    key: "reload",
    value: function reload() {
      return _reload2(this);
    }
  }, {
    key: "_assign",
    value: function _assign(user) {
      if (this === user) {
        return;
      }

      _assert$4(this.uid === user.uid, this.auth, "internal-error");

      this.displayName = user.displayName;
      this.photoURL = user.photoURL;
      this.email = user.email;
      this.emailVerified = user.emailVerified;
      this.phoneNumber = user.phoneNumber;
      this.isAnonymous = user.isAnonymous;
      this.tenantId = user.tenantId;
      this.providerData = user.providerData.map(function (userInfo) {
        return Object.assign({}, userInfo);
      });

      this.metadata._copy(user.metadata);

      this.stsTokenManager._assign(user.stsTokenManager);
    }
  }, {
    key: "_clone",
    value: function _clone(auth) {
      var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
        auth: auth,
        stsTokenManager: this.stsTokenManager._clone()
      }));

      newUser.metadata._copy(this.metadata);

      return newUser;
    }
  }, {
    key: "_onReload",
    value: function _onReload(callback) {
      _assert$4(!this.reloadListener, this.auth, "internal-error");

      this.reloadListener = callback;

      if (this.reloadUserInfo) {
        this._notifyReloadListener(this.reloadUserInfo);

        this.reloadUserInfo = null;
      }
    }
  }, {
    key: "_notifyReloadListener",
    value: function _notifyReloadListener(userInfo) {
      if (this.reloadListener) {
        this.reloadListener(userInfo);
      } else {
        this.reloadUserInfo = userInfo;
      }
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.proactiveRefresh._start();
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.proactiveRefresh._stop();
    }
  }, {
    key: "_updateTokensIfNecessary",
    value: function () {
      var _updateTokensIfNecessary2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee520(response) {
        var reload2,
            tokensRefreshed,
            _args521 = arguments;
        return _regeneratorRuntime.wrap(function _callee520$(_context521) {
          while (1) {
            switch (_context521.prev = _context521.next) {
              case 0:
                reload2 = _args521.length > 1 && _args521[1] !== undefined ? _args521[1] : false;
                tokensRefreshed = false;

                if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
                  this.stsTokenManager.updateFromServerResponse(response);
                  tokensRefreshed = true;
                }

                if (!reload2) {
                  _context521.next = 6;
                  break;
                }

                _context521.next = 6;
                return _reloadWithoutSaving(this);

              case 6:
                _context521.next = 8;
                return this.auth._persistUserIfCurrent(this);

              case 8:
                if (tokensRefreshed) {
                  this.auth._notifyListenersIfCurrent(this);
                }

              case 9:
              case "end":
                return _context521.stop();
            }
          }
        }, _callee520, this);
      }));

      function _updateTokensIfNecessary(_x909) {
        return _updateTokensIfNecessary2.apply(this, arguments);
      }

      return _updateTokensIfNecessary;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee521() {
        var idToken;
        return _regeneratorRuntime.wrap(function _callee521$(_context522) {
          while (1) {
            switch (_context522.prev = _context522.next) {
              case 0:
                _context522.next = 2;
                return this.getIdToken();

              case 2:
                idToken = _context522.sent;
                _context522.next = 5;
                return _logoutIfInvalidated(this, deleteAccount(this.auth, {
                  idToken: idToken
                }));

              case 5:
                this.stsTokenManager.clearRefreshToken();
                return _context522.abrupt("return", this.auth.signOut());

              case 7:
              case "end":
                return _context522.stop();
            }
          }
        }, _callee521, this);
      }));

      function _delete() {
        return _delete3.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.assign(Object.assign({
        uid: this.uid,
        email: this.email || void 0,
        emailVerified: this.emailVerified,
        displayName: this.displayName || void 0,
        isAnonymous: this.isAnonymous,
        photoURL: this.photoURL || void 0,
        phoneNumber: this.phoneNumber || void 0,
        tenantId: this.tenantId || void 0,
        providerData: this.providerData.map(function (userInfo) {
          return Object.assign({}, userInfo);
        }),
        stsTokenManager: this.stsTokenManager.toJSON(),
        _redirectEventId: this._redirectEventId
      }, this.metadata.toJSON()), {
        apiKey: this.auth.config.apiKey,
        appName: this.auth.name
      });
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this.stsTokenManager.refreshToken || "";
    }
  }], [{
    key: "_fromJSON",
    value: function _fromJSON(auth, object) {
      var _a2, _b, _c, _d, _e2, _f, _g, _h;

      var displayName = (_a2 = object.displayName) !== null && _a2 !== void 0 ? _a2 : void 0;
      var email = (_b = object.email) !== null && _b !== void 0 ? _b : void 0;
      var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : void 0;
      var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : void 0;
      var tenantId = (_e2 = object.tenantId) !== null && _e2 !== void 0 ? _e2 : void 0;

      var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : void 0;

      var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : void 0;
      var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : void 0;
      var uid = object.uid,
          emailVerified = object.emailVerified,
          isAnonymous = object.isAnonymous,
          providerData = object.providerData,
          plainObjectTokenManager = object.stsTokenManager;

      _assert$4(uid && plainObjectTokenManager, auth, "internal-error");

      var stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);

      _assert$4(typeof uid === "string", auth, "internal-error");

      assertStringOrUndefined(displayName, auth.name);
      assertStringOrUndefined(email, auth.name);

      _assert$4(typeof emailVerified === "boolean", auth, "internal-error");

      _assert$4(typeof isAnonymous === "boolean", auth, "internal-error");

      assertStringOrUndefined(phoneNumber, auth.name);
      assertStringOrUndefined(photoURL, auth.name);
      assertStringOrUndefined(tenantId, auth.name);
      assertStringOrUndefined(_redirectEventId, auth.name);
      assertStringOrUndefined(createdAt, auth.name);
      assertStringOrUndefined(lastLoginAt, auth.name);
      var user = new UserImpl({
        uid: uid,
        auth: auth,
        email: email,
        emailVerified: emailVerified,
        displayName: displayName,
        isAnonymous: isAnonymous,
        photoURL: photoURL,
        phoneNumber: phoneNumber,
        tenantId: tenantId,
        stsTokenManager: stsTokenManager,
        createdAt: createdAt,
        lastLoginAt: lastLoginAt
      });

      if (providerData && Array.isArray(providerData)) {
        user.providerData = providerData.map(function (userInfo) {
          return Object.assign({}, userInfo);
        });
      }

      if (_redirectEventId) {
        user._redirectEventId = _redirectEventId;
      }

      return user;
    }
  }, {
    key: "_fromIdTokenResponse",
    value: function () {
      var _fromIdTokenResponse2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee522(auth, idTokenResponse) {
        var isAnonymous,
            stsTokenManager,
            user,
            _args523 = arguments;
        return _regeneratorRuntime.wrap(function _callee522$(_context523) {
          while (1) {
            switch (_context523.prev = _context523.next) {
              case 0:
                isAnonymous = _args523.length > 2 && _args523[2] !== undefined ? _args523[2] : false;
                stsTokenManager = new StsTokenManager();
                stsTokenManager.updateFromServerResponse(idTokenResponse);
                user = new UserImpl({
                  uid: idTokenResponse.localId,
                  auth: auth,
                  stsTokenManager: stsTokenManager,
                  isAnonymous: isAnonymous
                });
                _context523.next = 6;
                return _reloadWithoutSaving(user);

              case 6:
                return _context523.abrupt("return", user);

              case 7:
              case "end":
                return _context523.stop();
            }
          }
        }, _callee522);
      }));

      function _fromIdTokenResponse(_x910, _x911) {
        return _fromIdTokenResponse2.apply(this, arguments);
      }

      return _fromIdTokenResponse;
    }()
  }]);

  return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var instanceCache =
/* @__PURE__ */
new Map();

function _getInstance(cls) {
  debugAssert(cls instanceof Function, "Expected a class definition");
  var instance = instanceCache.get(cls);

  if (instance) {
    debugAssert(instance instanceof cls, "Instance stored in cache mismatched with class");
    return instance;
  }

  instance = new cls();
  instanceCache.set(cls, instance);
  return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var InMemoryPersistence =
/*#__PURE__*/
function () {
  function InMemoryPersistence() {
    _classCallCheck3(this, InMemoryPersistence);

    this.type = "NONE";
    this.storage = {};
  }

  _createClass3(InMemoryPersistence, [{
    key: "_isAvailable",
    value: function () {
      var _isAvailable2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee523() {
        return _regeneratorRuntime.wrap(function _callee523$(_context524) {
          while (1) {
            switch (_context524.prev = _context524.next) {
              case 0:
                return _context524.abrupt("return", true);

              case 1:
              case "end":
                return _context524.stop();
            }
          }
        }, _callee523);
      }));

      function _isAvailable() {
        return _isAvailable2.apply(this, arguments);
      }

      return _isAvailable;
    }()
  }, {
    key: "_set",
    value: function () {
      var _set2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee524(key, value) {
        return _regeneratorRuntime.wrap(function _callee524$(_context525) {
          while (1) {
            switch (_context525.prev = _context525.next) {
              case 0:
                this.storage[key] = value;

              case 1:
              case "end":
                return _context525.stop();
            }
          }
        }, _callee524, this);
      }));

      function _set(_x912, _x913) {
        return _set2.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee525(key) {
        var value;
        return _regeneratorRuntime.wrap(function _callee525$(_context526) {
          while (1) {
            switch (_context526.prev = _context526.next) {
              case 0:
                value = this.storage[key];
                return _context526.abrupt("return", value === void 0 ? null : value);

              case 2:
              case "end":
                return _context526.stop();
            }
          }
        }, _callee525, this);
      }));

      function _get(_x914) {
        return _get3.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee526(key) {
        return _regeneratorRuntime.wrap(function _callee526$(_context527) {
          while (1) {
            switch (_context527.prev = _context527.next) {
              case 0:
                delete this.storage[key];

              case 1:
              case "end":
                return _context527.stop();
            }
          }
        }, _callee526, this);
      }));

      function _remove(_x915) {
        return _remove2.apply(this, arguments);
      }

      return _remove;
    }()
  }, {
    key: "_addListener",
    value: function _addListener(_key, _listener) {
      return;
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(_key, _listener) {
      return;
    }
  }]);

  return InMemoryPersistence;
}();

InMemoryPersistence.type = "NONE";
var inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _persistenceKeyName(key, apiKey, appName) {
  return "firebase".concat(":", key, ":").concat(apiKey, ":").concat(appName);
}

var PersistenceUserManager =
/*#__PURE__*/
function () {
  function PersistenceUserManager(persistence, auth, userKey) {
    _classCallCheck3(this, PersistenceUserManager);

    this.persistence = persistence;
    this.auth = auth;
    this.userKey = userKey;
    var _this$auth = this.auth,
        config = _this$auth.config,
        name2 = _this$auth.name;
    this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name2);
    this.fullPersistenceKey = _persistenceKeyName("persistence", config.apiKey, name2);
    this.boundEventHandler = auth._onStorageEvent.bind(auth);

    this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }

  _createClass3(PersistenceUserManager, [{
    key: "setCurrentUser",
    value: function setCurrentUser(user) {
      return this.persistence._set(this.fullUserKey, user.toJSON());
    }
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee527() {
        var blob;
        return _regeneratorRuntime.wrap(function _callee527$(_context528) {
          while (1) {
            switch (_context528.prev = _context528.next) {
              case 0:
                _context528.next = 2;
                return this.persistence._get(this.fullUserKey);

              case 2:
                blob = _context528.sent;
                return _context528.abrupt("return", blob ? UserImpl._fromJSON(this.auth, blob) : null);

              case 4:
              case "end":
                return _context528.stop();
            }
          }
        }, _callee527, this);
      }));

      function getCurrentUser() {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
  }, {
    key: "removeCurrentUser",
    value: function removeCurrentUser() {
      return this.persistence._remove(this.fullUserKey);
    }
  }, {
    key: "savePersistenceForRedirect",
    value: function savePersistenceForRedirect() {
      return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
  }, {
    key: "setPersistence",
    value: function () {
      var _setPersistence = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee528(newPersistence) {
        var currentUser;
        return _regeneratorRuntime.wrap(function _callee528$(_context529) {
          while (1) {
            switch (_context529.prev = _context529.next) {
              case 0:
                if (!(this.persistence === newPersistence)) {
                  _context529.next = 2;
                  break;
                }

                return _context529.abrupt("return");

              case 2:
                _context529.next = 4;
                return this.getCurrentUser();

              case 4:
                currentUser = _context529.sent;
                _context529.next = 7;
                return this.removeCurrentUser();

              case 7:
                this.persistence = newPersistence;

                if (!currentUser) {
                  _context529.next = 10;
                  break;
                }

                return _context529.abrupt("return", this.setCurrentUser(currentUser));

              case 10:
              case "end":
                return _context529.stop();
            }
          }
        }, _callee528, this);
      }));

      function setPersistence(_x916) {
        return _setPersistence.apply(this, arguments);
      }

      return setPersistence;
    }()
  }, {
    key: "delete",
    value: function _delete() {
      this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee531(auth, persistenceHierarchy) {
        var userKey,
            availablePersistences,
            selectedPersistence,
            key,
            userToMigrate,
            _iteratorNormalCompletion22,
            _didIteratorError22,
            _iteratorError22,
            _iterator22,
            _step22,
            persistence,
            blob,
            user,
            migrationHierarchy,
            _args532 = arguments;

        return _regeneratorRuntime.wrap(function _callee531$(_context532) {
          while (1) {
            switch (_context532.prev = _context532.next) {
              case 0:
                userKey = _args532.length > 2 && _args532[2] !== undefined ? _args532[2] : "authUser";

                if (persistenceHierarchy.length) {
                  _context532.next = 3;
                  break;
                }

                return _context532.abrupt("return", new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey));

              case 3:
                _context532.next = 5;
                return Promise.all(persistenceHierarchy.map(
                /*#__PURE__*/
                function () {
                  var _ref564 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee529(persistence) {
                    return _regeneratorRuntime.wrap(function _callee529$(_context530) {
                      while (1) {
                        switch (_context530.prev = _context530.next) {
                          case 0:
                            _context530.next = 2;
                            return persistence._isAvailable();

                          case 2:
                            if (!_context530.sent) {
                              _context530.next = 4;
                              break;
                            }

                            return _context530.abrupt("return", persistence);

                          case 4:
                            return _context530.abrupt("return", void 0);

                          case 5:
                          case "end":
                            return _context530.stop();
                        }
                      }
                    }, _callee529);
                  }));

                  return function (_x919) {
                    return _ref564.apply(this, arguments);
                  };
                }()));

              case 5:
                _context532.t0 = function (persistence) {
                  return persistence;
                };

                availablePersistences = _context532.sent.filter(_context532.t0);
                selectedPersistence = availablePersistences[0] || _getInstance(inMemoryPersistence);
                key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
                userToMigrate = null;
                _iteratorNormalCompletion22 = true;
                _didIteratorError22 = false;
                _iteratorError22 = undefined;
                _context532.prev = 13;
                _iterator22 = persistenceHierarchy[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
                  _context532.next = 33;
                  break;
                }

                persistence = _step22.value;
                _context532.prev = 17;
                _context532.next = 20;
                return persistence._get(key);

              case 20:
                blob = _context532.sent;

                if (!blob) {
                  _context532.next = 26;
                  break;
                }

                user = UserImpl._fromJSON(auth, blob);

                if (persistence !== selectedPersistence) {
                  userToMigrate = user;
                }

                selectedPersistence = persistence;
                return _context532.abrupt("break", 33);

              case 26:
                _context532.next = 30;
                break;

              case 28:
                _context532.prev = 28;
                _context532.t1 = _context532["catch"](17);

              case 30:
                _iteratorNormalCompletion22 = true;
                _context532.next = 15;
                break;

              case 33:
                _context532.next = 39;
                break;

              case 35:
                _context532.prev = 35;
                _context532.t2 = _context532["catch"](13);
                _didIteratorError22 = true;
                _iteratorError22 = _context532.t2;

              case 39:
                _context532.prev = 39;
                _context532.prev = 40;

                if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                  _iterator22.return();
                }

              case 42:
                _context532.prev = 42;

                if (!_didIteratorError22) {
                  _context532.next = 45;
                  break;
                }

                throw _iteratorError22;

              case 45:
                return _context532.finish(42);

              case 46:
                return _context532.finish(39);

              case 47:
                migrationHierarchy = availablePersistences.filter(function (p2) {
                  return p2._shouldAllowMigration;
                });

                if (!(!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length)) {
                  _context532.next = 50;
                  break;
                }

                return _context532.abrupt("return", new PersistenceUserManager(selectedPersistence, auth, userKey));

              case 50:
                selectedPersistence = migrationHierarchy[0];

                if (!userToMigrate) {
                  _context532.next = 54;
                  break;
                }

                _context532.next = 54;
                return selectedPersistence._set(key, userToMigrate.toJSON());

              case 54:
                _context532.next = 56;
                return Promise.all(persistenceHierarchy.map(
                /*#__PURE__*/
                function () {
                  var _ref565 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee530(persistence) {
                    return _regeneratorRuntime.wrap(function _callee530$(_context531) {
                      while (1) {
                        switch (_context531.prev = _context531.next) {
                          case 0:
                            if (!(persistence !== selectedPersistence)) {
                              _context531.next = 8;
                              break;
                            }

                            _context531.prev = 1;
                            _context531.next = 4;
                            return persistence._remove(key);

                          case 4:
                            _context531.next = 8;
                            break;

                          case 6:
                            _context531.prev = 6;
                            _context531.t0 = _context531["catch"](1);

                          case 8:
                          case "end":
                            return _context531.stop();
                        }
                      }
                    }, _callee530, null, [[1, 6]]);
                  }));

                  return function (_x920) {
                    return _ref565.apply(this, arguments);
                  };
                }()));

              case 56:
                return _context532.abrupt("return", new PersistenceUserManager(selectedPersistence, auth, userKey));

              case 57:
              case "end":
                return _context532.stop();
            }
          }
        }, _callee531, null, [[13, 35, 39, 47], [17, 28], [40,, 42, 46]]);
      }));

      function create(_x917, _x918) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getBrowserName(userAgent) {
  var ua2 = userAgent.toLowerCase();

  if (ua2.includes("opera/") || ua2.includes("opr/") || ua2.includes("opios/")) {
    return "Opera";
  } else if (_isIEMobile(ua2)) {
    return "IEMobile";
  } else if (ua2.includes("msie") || ua2.includes("trident/")) {
    return "IE";
  } else if (ua2.includes("edge/")) {
    return "Edge";
  } else if (_isFirefox(ua2)) {
    return "Firefox";
  } else if (ua2.includes("silk/")) {
    return "Silk";
  } else if (_isBlackBerry(ua2)) {
    return "Blackberry";
  } else if (_isWebOS(ua2)) {
    return "Webos";
  } else if (_isSafari(ua2)) {
    return "Safari";
  } else if ((ua2.includes("chrome/") || _isChromeIOS(ua2)) && !ua2.includes("edge/")) {
    return "Chrome";
  } else if (_isAndroid(ua2)) {
    return "Android";
  } else {
    var re2 = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
    var matches = userAgent.match(re2);

    if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) {
      return matches[1];
    }
  }

  return "Other";
}

function _isFirefox() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /firefox\//i.test(ua2);
}

function _isSafari() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  var ua2 = userAgent.toLowerCase();
  return ua2.includes("safari/") && !ua2.includes("chrome/") && !ua2.includes("crios/") && !ua2.includes("android");
}

function _isChromeIOS() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /crios\//i.test(ua2);
}

function _isIEMobile() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /iemobile/i.test(ua2);
}

function _isAndroid() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /android/i.test(ua2);
}

function _isBlackBerry() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /blackberry/i.test(ua2);
}

function _isWebOS() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /webos/i.test(ua2);
}

function _isIOS() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /iphone|ipad|ipod/i.test(ua2) || /macintosh/i.test(ua2) && /mobile/i.test(ua2);
}

function _isIOS7Or8() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua2) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua2);
}

function _isIOSStandalone() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();

  var _a2;

  return _isIOS(ua2) && !!((_a2 = window.navigator) === null || _a2 === void 0 ? void 0 : _a2.standalone);
}

function _isIE10() {
  return isIE() && document.documentMode === 10;
}

function _isMobileBrowser() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return _isIOS(ua2) || _isAndroid(ua2) || _isWebOS(ua2) || _isBlackBerry(ua2) || /windows phone/i.test(ua2) || _isIEMobile(ua2);
}

function _isIframe() {
  try {
    return !!(window && window !== window.top);
  } catch (e2) {
    return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getClientVersion(clientPlatform) {
  var frameworks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reportedPlatform;

  switch (clientPlatform) {
    case "Browser":
      reportedPlatform = _getBrowserName(getUA());
      break;

    case "Worker":
      reportedPlatform = "".concat(_getBrowserName(getUA()), "-").concat(clientPlatform);
      break;

    default:
      reportedPlatform = clientPlatform;
  }

  var reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web";
  return "".concat(reportedPlatform, "/", "JsCore", "/").concat(SDK_VERSION, "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getRecaptchaParams(_x921) {
  return _getRecaptchaParams.apply(this, arguments);
}

function _getRecaptchaParams() {
  _getRecaptchaParams = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee662(auth) {
    return _regeneratorRuntime.wrap(function _callee662$(_context663) {
      while (1) {
        switch (_context663.prev = _context663.next) {
          case 0:
            _context663.next = 2;
            return _performApiRequest(auth, "GET", "/v1/recaptchaParams");

          case 2:
            _context663.t0 = _context663.sent.recaptchaSiteKey;

            if (_context663.t0) {
              _context663.next = 5;
              break;
            }

            _context663.t0 = "";

          case 5:
            return _context663.abrupt("return", _context663.t0);

          case 6:
          case "end":
            return _context663.stop();
        }
      }
    }, _callee662);
  }));
  return _getRecaptchaParams.apply(this, arguments);
}

function getRecaptchaConfig(_x922, _x923) {
  return _getRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getRecaptchaConfig() {
  _getRecaptchaConfig = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee663(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee663$(_context664) {
      while (1) {
        switch (_context664.prev = _context664.next) {
          case 0:
            return _context664.abrupt("return", _performApiRequest(auth, "GET", "/v2/recaptchaConfig", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context664.stop();
        }
      }
    }, _callee663);
  }));
  return _getRecaptchaConfig.apply(this, arguments);
}

function isV2(grecaptcha) {
  return grecaptcha !== void 0 && grecaptcha.getResponse !== void 0;
}

function isEnterprise(grecaptcha) {
  return grecaptcha !== void 0 && grecaptcha.enterprise !== void 0;
}

var RecaptchaConfig = function RecaptchaConfig(response) {
  _classCallCheck3(this, RecaptchaConfig);

  this.siteKey = "";
  this.emailPasswordEnabled = false;

  if (response.recaptchaKey === void 0) {
    throw new Error("recaptchaKey undefined");
  }

  this.siteKey = response.recaptchaKey.split("/")[3];
  this.emailPasswordEnabled = response.recaptchaEnforcementState.some(function (enforcementState) {
    return enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF";
  });
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getScriptParentElement() {
  var _a2, _b;

  return (_b = (_a2 = document.getElementsByTagName("head")) === null || _a2 === void 0 ? void 0 : _a2[0]) !== null && _b !== void 0 ? _b : document;
}

function _loadJS(url) {
  return new Promise(function (resolve, reject) {
    var el = document.createElement("script");
    el.setAttribute("src", url);
    el.onload = resolve;

    el.onerror = function (e2) {
      var error = _createError("internal-error");

      error.customData = e2;
      reject(error);
    };

    el.type = "text/javascript";
    el.charset = "UTF-8";
    getScriptParentElement().appendChild(el);
  });
}

function _generateCallbackName(prefix2) {
  return "__".concat(prefix2).concat(Math.floor(Math.random() * 1e6));
}

var RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
var RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
var FAKE_TOKEN = "NO_RECAPTCHA";

var RecaptchaEnterpriseVerifier =
/*#__PURE__*/
function () {
  function RecaptchaEnterpriseVerifier(authExtern) {
    _classCallCheck3(this, RecaptchaEnterpriseVerifier);

    this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
    this.auth = _castAuth(authExtern);
  }

  _createClass3(RecaptchaEnterpriseVerifier, [{
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee534() {
        var _this146 = this;

        var action,
            forceRefresh,
            retrieveSiteKey,
            _retrieveSiteKey,
            retrieveRecaptchaToken,
            _args535 = arguments;

        return _regeneratorRuntime.wrap(function _callee534$(_context535) {
          while (1) {
            switch (_context535.prev = _context535.next) {
              case 0:
                retrieveRecaptchaToken = function _ref569(siteKey, resolve, reject) {
                  var grecaptcha = window.grecaptcha;

                  if (isEnterprise(grecaptcha)) {
                    grecaptcha.enterprise.ready(function () {
                      grecaptcha.enterprise.execute(siteKey, {
                        action: action
                      }).then(function (token2) {
                        resolve(token2);
                      }).catch(function () {
                        resolve(FAKE_TOKEN);
                      });
                    });
                  } else {
                    reject(Error("No reCAPTCHA enterprise script loaded."));
                  }
                };

                _retrieveSiteKey = function _ref568() {
                  _retrieveSiteKey = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee533(auth) {
                    return _regeneratorRuntime.wrap(function _callee533$(_context534) {
                      while (1) {
                        switch (_context534.prev = _context534.next) {
                          case 0:
                            if (forceRefresh) {
                              _context534.next = 5;
                              break;
                            }

                            if (!(auth.tenantId == null && auth._agentRecaptchaConfig != null)) {
                              _context534.next = 3;
                              break;
                            }

                            return _context534.abrupt("return", auth._agentRecaptchaConfig.siteKey);

                          case 3:
                            if (!(auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== void 0)) {
                              _context534.next = 5;
                              break;
                            }

                            return _context534.abrupt("return", auth._tenantRecaptchaConfigs[auth.tenantId].siteKey);

                          case 5:
                            return _context534.abrupt("return", new Promise(
                            /*#__PURE__*/
                            function () {
                              var _ref566 = _asyncToGenerator(
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee532(resolve, reject) {
                                return _regeneratorRuntime.wrap(function _callee532$(_context533) {
                                  while (1) {
                                    switch (_context533.prev = _context533.next) {
                                      case 0:
                                        getRecaptchaConfig(auth, {
                                          clientType: "CLIENT_TYPE_WEB",
                                          version: "RECAPTCHA_ENTERPRISE"
                                        }).then(function (response) {
                                          if (response.recaptchaKey === void 0) {
                                            reject(new Error("recaptcha Enterprise site key undefined"));
                                          } else {
                                            var config = new RecaptchaConfig(response);

                                            if (auth.tenantId == null) {
                                              auth._agentRecaptchaConfig = config;
                                            } else {
                                              auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                            }

                                            return resolve(config.siteKey);
                                          }
                                        }).catch(function (error) {
                                          reject(error);
                                        });

                                      case 1:
                                      case "end":
                                        return _context533.stop();
                                    }
                                  }
                                }, _callee532);
                              }));

                              return function (_x925, _x926) {
                                return _ref566.apply(this, arguments);
                              };
                            }()));

                          case 6:
                          case "end":
                            return _context534.stop();
                        }
                      }
                    }, _callee533);
                  }));
                  return _retrieveSiteKey.apply(this, arguments);
                };

                retrieveSiteKey = function _ref567(_x924) {
                  return _retrieveSiteKey.apply(this, arguments);
                };

                action = _args535.length > 0 && _args535[0] !== undefined ? _args535[0] : "verify";
                forceRefresh = _args535.length > 1 && _args535[1] !== undefined ? _args535[1] : false;
                return _context535.abrupt("return", new Promise(function (resolve, reject) {
                  retrieveSiteKey(_this146.auth).then(function (siteKey) {
                    if (!forceRefresh && isEnterprise(window.grecaptcha)) {
                      retrieveRecaptchaToken(siteKey, resolve, reject);
                    } else {
                      if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                      }

                      _loadJS(RECAPTCHA_ENTERPRISE_URL + siteKey).then(function () {
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                      }).catch(function (error) {
                        reject(error);
                      });
                    }
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 6:
              case "end":
                return _context535.stop();
            }
          }
        }, _callee534);
      }));

      function verify() {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return RecaptchaEnterpriseVerifier;
}();

function injectRecaptchaFields(_x927, _x928, _x929) {
  return _injectRecaptchaFields.apply(this, arguments);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _injectRecaptchaFields() {
  _injectRecaptchaFields = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee664(auth, request2, action) {
    var captchaResp,
        verifier,
        captchaResponse,
        newRequest,
        _args665 = arguments;
    return _regeneratorRuntime.wrap(function _callee664$(_context665) {
      while (1) {
        switch (_context665.prev = _context665.next) {
          case 0:
            captchaResp = _args665.length > 3 && _args665[3] !== undefined ? _args665[3] : false;
            verifier = new RecaptchaEnterpriseVerifier(auth);
            _context665.prev = 2;
            _context665.next = 5;
            return verifier.verify(action);

          case 5:
            captchaResponse = _context665.sent;
            _context665.next = 13;
            break;

          case 8:
            _context665.prev = 8;
            _context665.t0 = _context665["catch"](2);
            _context665.next = 12;
            return verifier.verify(action, true);

          case 12:
            captchaResponse = _context665.sent;

          case 13:
            newRequest = Object.assign({}, request2);

            if (!captchaResp) {
              Object.assign(newRequest, {
                captchaResponse: captchaResponse
              });
            } else {
              Object.assign(newRequest, {
                "captchaResp": captchaResponse
              });
            }

            Object.assign(newRequest, {
              "clientType": "CLIENT_TYPE_WEB"
            });
            Object.assign(newRequest, {
              "recaptchaVersion": "RECAPTCHA_ENTERPRISE"
            });
            return _context665.abrupt("return", newRequest);

          case 18:
          case "end":
            return _context665.stop();
        }
      }
    }, _callee664, null, [[2, 8]]);
  }));
  return _injectRecaptchaFields.apply(this, arguments);
}

var AuthMiddlewareQueue =
/*#__PURE__*/
function () {
  function AuthMiddlewareQueue(auth) {
    _classCallCheck3(this, AuthMiddlewareQueue);

    this.auth = auth;
    this.queue = [];
  }

  _createClass3(AuthMiddlewareQueue, [{
    key: "pushCallback",
    value: function pushCallback(callback, onAbort) {
      var _this147 = this;

      var wrappedCallback = function wrappedCallback(user) {
        return new Promise(function (resolve, reject) {
          try {
            var result = callback(user);
            resolve(result);
          } catch (e2) {
            reject(e2);
          }
        });
      };

      wrappedCallback.onAbort = onAbort;
      this.queue.push(wrappedCallback);
      var index2 = this.queue.length - 1;
      return function () {
        _this147.queue[index2] = function () {
          return Promise.resolve();
        };
      };
    }
  }, {
    key: "runMiddleware",
    value: function () {
      var _runMiddleware = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee535(nextUser) {
        var onAbortStack, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, beforeStateCallback, _i61, _onAbortStack, onAbort;

        return _regeneratorRuntime.wrap(function _callee535$(_context536) {
          while (1) {
            switch (_context536.prev = _context536.next) {
              case 0:
                if (!(this.auth.currentUser === nextUser)) {
                  _context536.next = 2;
                  break;
                }

                return _context536.abrupt("return");

              case 2:
                onAbortStack = [];
                _context536.prev = 3;
                _iteratorNormalCompletion23 = true;
                _didIteratorError23 = false;
                _iteratorError23 = undefined;
                _context536.prev = 7;
                _iterator23 = this.queue[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                  _context536.next = 17;
                  break;
                }

                beforeStateCallback = _step23.value;
                _context536.next = 13;
                return beforeStateCallback(nextUser);

              case 13:
                if (beforeStateCallback.onAbort) {
                  onAbortStack.push(beforeStateCallback.onAbort);
                }

              case 14:
                _iteratorNormalCompletion23 = true;
                _context536.next = 9;
                break;

              case 17:
                _context536.next = 23;
                break;

              case 19:
                _context536.prev = 19;
                _context536.t0 = _context536["catch"](7);
                _didIteratorError23 = true;
                _iteratorError23 = _context536.t0;

              case 23:
                _context536.prev = 23;
                _context536.prev = 24;

                if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                  _iterator23.return();
                }

              case 26:
                _context536.prev = 26;

                if (!_didIteratorError23) {
                  _context536.next = 29;
                  break;
                }

                throw _iteratorError23;

              case 29:
                return _context536.finish(26);

              case 30:
                return _context536.finish(23);

              case 31:
                _context536.next = 38;
                break;

              case 33:
                _context536.prev = 33;
                _context536.t1 = _context536["catch"](3);
                onAbortStack.reverse();

                for (_i61 = 0, _onAbortStack = onAbortStack; _i61 < _onAbortStack.length; _i61++) {
                  onAbort = _onAbortStack[_i61];

                  try {
                    onAbort();
                  } catch (_2) {}
                }

                throw this.auth._errorFactory.create("login-blocked", {
                  originalMessage: _context536.t1 === null || _context536.t1 === void 0 ? void 0 : _context536.t1.message
                });

              case 38:
              case "end":
                return _context536.stop();
            }
          }
        }, _callee535, this, [[3, 33], [7, 19, 23, 31], [24,, 26, 30]]);
      }));

      function runMiddleware(_x930) {
        return _runMiddleware.apply(this, arguments);
      }

      return runMiddleware;
    }()
  }]);

  return AuthMiddlewareQueue;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var AuthImpl =
/*#__PURE__*/
function () {
  function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
    _classCallCheck3(this, AuthImpl);

    this.app = app;
    this.heartbeatServiceProvider = heartbeatServiceProvider;
    this.appCheckServiceProvider = appCheckServiceProvider;
    this.config = config;
    this.currentUser = null;
    this.emulatorConfig = null;
    this.operations = Promise.resolve();
    this.authStateSubscription = new Subscription(this);
    this.idTokenSubscription = new Subscription(this);
    this.beforeStateQueue = new AuthMiddlewareQueue(this);
    this.redirectUser = null;
    this.isProactiveRefreshEnabled = false;
    this._canInitEmulator = true;
    this._isInitialized = false;
    this._deleted = false;
    this._initializationPromise = null;
    this._popupRedirectResolver = null;
    this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
    this._agentRecaptchaConfig = null;
    this._tenantRecaptchaConfigs = {};
    this.lastNotifiedUid = void 0;
    this.languageCode = null;
    this.tenantId = null;
    this.settings = {
      appVerificationDisabledForTesting: false
    };
    this.frameworks = [];
    this.name = app.name;
    this.clientVersion = config.sdkClientVersion;
  }

  _createClass3(AuthImpl, [{
    key: "_initializeWithPersistence",
    value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
      var _this148 = this;

      if (popupRedirectResolver) {
        this._popupRedirectResolver = _getInstance(popupRedirectResolver);
      }

      this._initializationPromise = this.queue(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee536() {
        var _a2, _b;

        return _regeneratorRuntime.wrap(function _callee536$(_context537) {
          while (1) {
            switch (_context537.prev = _context537.next) {
              case 0:
                if (!_this148._deleted) {
                  _context537.next = 2;
                  break;
                }

                return _context537.abrupt("return");

              case 2:
                _context537.next = 4;
                return PersistenceUserManager.create(_this148, persistenceHierarchy);

              case 4:
                _this148.persistenceManager = _context537.sent;

                if (!_this148._deleted) {
                  _context537.next = 7;
                  break;
                }

                return _context537.abrupt("return");

              case 7:
                if (!((_a2 = _this148._popupRedirectResolver) === null || _a2 === void 0 ? void 0 : _a2._shouldInitProactively)) {
                  _context537.next = 15;
                  break;
                }

                _context537.prev = 8;
                _context537.next = 11;
                return _this148._popupRedirectResolver._initialize(_this148);

              case 11:
                _context537.next = 15;
                break;

              case 13:
                _context537.prev = 13;
                _context537.t0 = _context537["catch"](8);

              case 15:
                _context537.next = 17;
                return _this148.initializeCurrentUser(popupRedirectResolver);

              case 17:
                _this148.lastNotifiedUid = ((_b = _this148.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;

                if (!_this148._deleted) {
                  _context537.next = 20;
                  break;
                }

                return _context537.abrupt("return");

              case 20:
                _this148._isInitialized = true;

              case 21:
              case "end":
                return _context537.stop();
            }
          }
        }, _callee536, null, [[8, 13]]);
      })));
      return this._initializationPromise;
    }
  }, {
    key: "_onStorageEvent",
    value: function () {
      var _onStorageEvent2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee537() {
        var user;
        return _regeneratorRuntime.wrap(function _callee537$(_context538) {
          while (1) {
            switch (_context538.prev = _context538.next) {
              case 0:
                if (!this._deleted) {
                  _context538.next = 2;
                  break;
                }

                return _context538.abrupt("return");

              case 2:
                _context538.next = 4;
                return this.assertedPersistence.getCurrentUser();

              case 4:
                user = _context538.sent;

                if (!(!this.currentUser && !user)) {
                  _context538.next = 7;
                  break;
                }

                return _context538.abrupt("return");

              case 7:
                if (!(this.currentUser && user && this.currentUser.uid === user.uid)) {
                  _context538.next = 12;
                  break;
                }

                this._currentUser._assign(user);

                _context538.next = 11;
                return this.currentUser.getIdToken();

              case 11:
                return _context538.abrupt("return");

              case 12:
                _context538.next = 14;
                return this._updateCurrentUser(user, true);

              case 14:
              case "end":
                return _context538.stop();
            }
          }
        }, _callee537, this);
      }));

      function _onStorageEvent() {
        return _onStorageEvent2.apply(this, arguments);
      }

      return _onStorageEvent;
    }()
  }, {
    key: "initializeCurrentUser",
    value: function () {
      var _initializeCurrentUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee538(popupRedirectResolver) {
        var _a2, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result;

        return _regeneratorRuntime.wrap(function _callee538$(_context539) {
          while (1) {
            switch (_context539.prev = _context539.next) {
              case 0:
                _context539.next = 2;
                return this.assertedPersistence.getCurrentUser();

              case 2:
                previouslyStoredUser = _context539.sent;
                futureCurrentUser = previouslyStoredUser;
                needsTocheckMiddleware = false;

                if (!(popupRedirectResolver && this.config.authDomain)) {
                  _context539.next = 14;
                  break;
                }

                _context539.next = 8;
                return this.getOrInitRedirectPersistenceManager();

              case 8:
                redirectUserEventId = (_a2 = this.redirectUser) === null || _a2 === void 0 ? void 0 : _a2._redirectEventId;
                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                _context539.next = 12;
                return this.tryRedirectSignIn(popupRedirectResolver);

              case 12:
                result = _context539.sent;

                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                  futureCurrentUser = result.user;
                  needsTocheckMiddleware = true;
                }

              case 14:
                if (futureCurrentUser) {
                  _context539.next = 16;
                  break;
                }

                return _context539.abrupt("return", this.directlySetCurrentUser(null));

              case 16:
                if (futureCurrentUser._redirectEventId) {
                  _context539.next = 32;
                  break;
                }

                if (!needsTocheckMiddleware) {
                  _context539.next = 27;
                  break;
                }

                _context539.prev = 18;
                _context539.next = 21;
                return this.beforeStateQueue.runMiddleware(futureCurrentUser);

              case 21:
                _context539.next = 27;
                break;

              case 23:
                _context539.prev = 23;
                _context539.t0 = _context539["catch"](18);
                futureCurrentUser = previouslyStoredUser;

                this._popupRedirectResolver._overrideRedirectResult(this, function () {
                  return Promise.reject(_context539.t0);
                });

              case 27:
                if (!futureCurrentUser) {
                  _context539.next = 31;
                  break;
                }

                return _context539.abrupt("return", this.reloadAndSetCurrentUserOrClear(futureCurrentUser));

              case 31:
                return _context539.abrupt("return", this.directlySetCurrentUser(null));

              case 32:
                _assert$4(this._popupRedirectResolver, this, "argument-error");

                _context539.next = 35;
                return this.getOrInitRedirectPersistenceManager();

              case 35:
                if (!(this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId)) {
                  _context539.next = 37;
                  break;
                }

                return _context539.abrupt("return", this.directlySetCurrentUser(futureCurrentUser));

              case 37:
                return _context539.abrupt("return", this.reloadAndSetCurrentUserOrClear(futureCurrentUser));

              case 38:
              case "end":
                return _context539.stop();
            }
          }
        }, _callee538, this, [[18, 23]]);
      }));

      function initializeCurrentUser(_x931) {
        return _initializeCurrentUser.apply(this, arguments);
      }

      return initializeCurrentUser;
    }()
  }, {
    key: "tryRedirectSignIn",
    value: function () {
      var _tryRedirectSignIn = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee539(redirectResolver) {
        var result;
        return _regeneratorRuntime.wrap(function _callee539$(_context540) {
          while (1) {
            switch (_context540.prev = _context540.next) {
              case 0:
                result = null;
                _context540.prev = 1;
                _context540.next = 4;
                return this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);

              case 4:
                result = _context540.sent;
                _context540.next = 11;
                break;

              case 7:
                _context540.prev = 7;
                _context540.t0 = _context540["catch"](1);
                _context540.next = 11;
                return this._setRedirectUser(null);

              case 11:
                return _context540.abrupt("return", result);

              case 12:
              case "end":
                return _context540.stop();
            }
          }
        }, _callee539, this, [[1, 7]]);
      }));

      function tryRedirectSignIn(_x932) {
        return _tryRedirectSignIn.apply(this, arguments);
      }

      return tryRedirectSignIn;
    }()
  }, {
    key: "reloadAndSetCurrentUserOrClear",
    value: function () {
      var _reloadAndSetCurrentUserOrClear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee540(user) {
        return _regeneratorRuntime.wrap(function _callee540$(_context541) {
          while (1) {
            switch (_context541.prev = _context541.next) {
              case 0:
                _context541.prev = 0;
                _context541.next = 3;
                return _reloadWithoutSaving(user);

              case 3:
                _context541.next = 9;
                break;

              case 5:
                _context541.prev = 5;
                _context541.t0 = _context541["catch"](0);

                if (!((_context541.t0 === null || _context541.t0 === void 0 ? void 0 : _context541.t0.code) !== "auth/".concat("network-request-failed"))) {
                  _context541.next = 9;
                  break;
                }

                return _context541.abrupt("return", this.directlySetCurrentUser(null));

              case 9:
                return _context541.abrupt("return", this.directlySetCurrentUser(user));

              case 10:
              case "end":
                return _context541.stop();
            }
          }
        }, _callee540, this, [[0, 5]]);
      }));

      function reloadAndSetCurrentUserOrClear(_x933) {
        return _reloadAndSetCurrentUserOrClear.apply(this, arguments);
      }

      return reloadAndSetCurrentUserOrClear;
    }()
  }, {
    key: "useDeviceLanguage",
    value: function useDeviceLanguage() {
      this.languageCode = _getUserLanguage();
    }
  }, {
    key: "_delete",
    value: function () {
      var _delete4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee541() {
        return _regeneratorRuntime.wrap(function _callee541$(_context542) {
          while (1) {
            switch (_context542.prev = _context542.next) {
              case 0:
                this._deleted = true;

              case 1:
              case "end":
                return _context542.stop();
            }
          }
        }, _callee541, this);
      }));

      function _delete() {
        return _delete4.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "updateCurrentUser",
    value: function () {
      var _updateCurrentUser2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee542(userExtern) {
        var user;
        return _regeneratorRuntime.wrap(function _callee542$(_context543) {
          while (1) {
            switch (_context543.prev = _context543.next) {
              case 0:
                user = userExtern ? getModularInstance(userExtern) : null;

                if (user) {
                  _assert$4(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token");
                }

                return _context543.abrupt("return", this._updateCurrentUser(user && user._clone(this)));

              case 3:
              case "end":
                return _context543.stop();
            }
          }
        }, _callee542, this);
      }));

      function updateCurrentUser(_x934) {
        return _updateCurrentUser2.apply(this, arguments);
      }

      return updateCurrentUser;
    }()
  }, {
    key: "_updateCurrentUser",
    value: function () {
      var _updateCurrentUser3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee544(user) {
        var _this149 = this;

        var skipBeforeStateCallbacks,
            _args545 = arguments;
        return _regeneratorRuntime.wrap(function _callee544$(_context545) {
          while (1) {
            switch (_context545.prev = _context545.next) {
              case 0:
                skipBeforeStateCallbacks = _args545.length > 1 && _args545[1] !== undefined ? _args545[1] : false;

                if (!this._deleted) {
                  _context545.next = 3;
                  break;
                }

                return _context545.abrupt("return");

              case 3:
                if (user) {
                  _assert$4(this.tenantId === user.tenantId, this, "tenant-id-mismatch");
                }

                if (skipBeforeStateCallbacks) {
                  _context545.next = 7;
                  break;
                }

                _context545.next = 7;
                return this.beforeStateQueue.runMiddleware(user);

              case 7:
                return _context545.abrupt("return", this.queue(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee543() {
                  return _regeneratorRuntime.wrap(function _callee543$(_context544) {
                    while (1) {
                      switch (_context544.prev = _context544.next) {
                        case 0:
                          _context544.next = 2;
                          return _this149.directlySetCurrentUser(user);

                        case 2:
                          _this149.notifyAuthListeners();

                        case 3:
                        case "end":
                          return _context544.stop();
                      }
                    }
                  }, _callee543);
                }))));

              case 8:
              case "end":
                return _context545.stop();
            }
          }
        }, _callee544, this);
      }));

      function _updateCurrentUser(_x935) {
        return _updateCurrentUser3.apply(this, arguments);
      }

      return _updateCurrentUser;
    }()
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee545() {
        return _regeneratorRuntime.wrap(function _callee545$(_context546) {
          while (1) {
            switch (_context546.prev = _context546.next) {
              case 0:
                _context546.next = 2;
                return this.beforeStateQueue.runMiddleware(null);

              case 2:
                if (!(this.redirectPersistenceManager || this._popupRedirectResolver)) {
                  _context546.next = 5;
                  break;
                }

                _context546.next = 5;
                return this._setRedirectUser(null);

              case 5:
                return _context546.abrupt("return", this._updateCurrentUser(null, true));

              case 6:
              case "end":
                return _context546.stop();
            }
          }
        }, _callee545, this);
      }));

      function signOut() {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "setPersistence",
    value: function setPersistence(persistence) {
      var _this150 = this;

      return this.queue(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee546() {
        return _regeneratorRuntime.wrap(function _callee546$(_context547) {
          while (1) {
            switch (_context547.prev = _context547.next) {
              case 0:
                _context547.next = 2;
                return _this150.assertedPersistence.setPersistence(_getInstance(persistence));

              case 2:
              case "end":
                return _context547.stop();
            }
          }
        }, _callee546);
      })));
    }
  }, {
    key: "initializeRecaptchaConfig",
    value: function () {
      var _initializeRecaptchaConfig = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee547() {
        var response, config, verifier;
        return _regeneratorRuntime.wrap(function _callee547$(_context548) {
          while (1) {
            switch (_context548.prev = _context548.next) {
              case 0:
                _context548.next = 2;
                return getRecaptchaConfig(this, {
                  clientType: "CLIENT_TYPE_WEB",
                  version: "RECAPTCHA_ENTERPRISE"
                });

              case 2:
                response = _context548.sent;
                config = new RecaptchaConfig(response);

                if (this.tenantId == null) {
                  this._agentRecaptchaConfig = config;
                } else {
                  this._tenantRecaptchaConfigs[this.tenantId] = config;
                }

                if (config.emailPasswordEnabled) {
                  verifier = new RecaptchaEnterpriseVerifier(this);
                  void verifier.verify();
                }

              case 6:
              case "end":
                return _context548.stop();
            }
          }
        }, _callee547, this);
      }));

      function initializeRecaptchaConfig() {
        return _initializeRecaptchaConfig.apply(this, arguments);
      }

      return initializeRecaptchaConfig;
    }()
  }, {
    key: "_getRecaptchaConfig",
    value: function _getRecaptchaConfig() {
      if (this.tenantId == null) {
        return this._agentRecaptchaConfig;
      } else {
        return this._tenantRecaptchaConfigs[this.tenantId];
      }
    }
  }, {
    key: "_getPersistence",
    value: function _getPersistence() {
      return this.assertedPersistence.persistence.type;
    }
  }, {
    key: "_updateErrorMap",
    value: function _updateErrorMap(errorMap) {
      this._errorFactory = new ErrorFactory("auth", "Firebase", errorMap());
    }
  }, {
    key: "onAuthStateChanged",
    value: function onAuthStateChanged(nextOrObserver, error, completed) {
      return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
  }, {
    key: "beforeAuthStateChanged",
    value: function beforeAuthStateChanged(callback, onAbort) {
      return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
  }, {
    key: "onIdTokenChanged",
    value: function onIdTokenChanged(nextOrObserver, error, completed) {
      return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _a2;

      return {
        apiKey: this.config.apiKey,
        authDomain: this.config.authDomain,
        appName: this.name,
        currentUser: (_a2 = this._currentUser) === null || _a2 === void 0 ? void 0 : _a2.toJSON()
      };
    }
  }, {
    key: "_setRedirectUser",
    value: function () {
      var _setRedirectUser2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee548(user, popupRedirectResolver) {
        var redirectManager;
        return _regeneratorRuntime.wrap(function _callee548$(_context549) {
          while (1) {
            switch (_context549.prev = _context549.next) {
              case 0:
                _context549.next = 2;
                return this.getOrInitRedirectPersistenceManager(popupRedirectResolver);

              case 2:
                redirectManager = _context549.sent;
                return _context549.abrupt("return", user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user));

              case 4:
              case "end":
                return _context549.stop();
            }
          }
        }, _callee548, this);
      }));

      function _setRedirectUser(_x936, _x937) {
        return _setRedirectUser2.apply(this, arguments);
      }

      return _setRedirectUser;
    }()
  }, {
    key: "getOrInitRedirectPersistenceManager",
    value: function () {
      var _getOrInitRedirectPersistenceManager = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee549(popupRedirectResolver) {
        var resolver;
        return _regeneratorRuntime.wrap(function _callee549$(_context550) {
          while (1) {
            switch (_context550.prev = _context550.next) {
              case 0:
                if (this.redirectPersistenceManager) {
                  _context550.next = 9;
                  break;
                }

                resolver = popupRedirectResolver && _getInstance(popupRedirectResolver) || this._popupRedirectResolver;

                _assert$4(resolver, this, "argument-error");

                _context550.next = 5;
                return PersistenceUserManager.create(this, [_getInstance(resolver._redirectPersistence)], "redirectUser");

              case 5:
                this.redirectPersistenceManager = _context550.sent;
                _context550.next = 8;
                return this.redirectPersistenceManager.getCurrentUser();

              case 8:
                this.redirectUser = _context550.sent;

              case 9:
                return _context550.abrupt("return", this.redirectPersistenceManager);

              case 10:
              case "end":
                return _context550.stop();
            }
          }
        }, _callee549, this);
      }));

      function getOrInitRedirectPersistenceManager(_x938) {
        return _getOrInitRedirectPersistenceManager.apply(this, arguments);
      }

      return getOrInitRedirectPersistenceManager;
    }()
  }, {
    key: "_redirectUserForId",
    value: function () {
      var _redirectUserForId2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee551(id) {
        var _a2, _b;

        return _regeneratorRuntime.wrap(function _callee551$(_context552) {
          while (1) {
            switch (_context552.prev = _context552.next) {
              case 0:
                if (!this._isInitialized) {
                  _context552.next = 3;
                  break;
                }

                _context552.next = 3;
                return this.queue(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee550() {
                  return _regeneratorRuntime.wrap(function _callee550$(_context551) {
                    while (1) {
                      switch (_context551.prev = _context551.next) {
                        case 0:
                        case "end":
                          return _context551.stop();
                      }
                    }
                  }, _callee550);
                })));

              case 3:
                if (!(((_a2 = this._currentUser) === null || _a2 === void 0 ? void 0 : _a2._redirectEventId) === id)) {
                  _context552.next = 5;
                  break;
                }

                return _context552.abrupt("return", this._currentUser);

              case 5:
                if (!(((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id)) {
                  _context552.next = 7;
                  break;
                }

                return _context552.abrupt("return", this.redirectUser);

              case 7:
                return _context552.abrupt("return", null);

              case 8:
              case "end":
                return _context552.stop();
            }
          }
        }, _callee551, this);
      }));

      function _redirectUserForId(_x939) {
        return _redirectUserForId2.apply(this, arguments);
      }

      return _redirectUserForId;
    }()
  }, {
    key: "_persistUserIfCurrent",
    value: function () {
      var _persistUserIfCurrent2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee553(user) {
        var _this151 = this;

        return _regeneratorRuntime.wrap(function _callee553$(_context554) {
          while (1) {
            switch (_context554.prev = _context554.next) {
              case 0:
                if (!(user === this.currentUser)) {
                  _context554.next = 2;
                  break;
                }

                return _context554.abrupt("return", this.queue(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee552() {
                  return _regeneratorRuntime.wrap(function _callee552$(_context553) {
                    while (1) {
                      switch (_context553.prev = _context553.next) {
                        case 0:
                          return _context553.abrupt("return", _this151.directlySetCurrentUser(user));

                        case 1:
                        case "end":
                          return _context553.stop();
                      }
                    }
                  }, _callee552);
                }))));

              case 2:
              case "end":
                return _context554.stop();
            }
          }
        }, _callee553, this);
      }));

      function _persistUserIfCurrent(_x940) {
        return _persistUserIfCurrent2.apply(this, arguments);
      }

      return _persistUserIfCurrent;
    }()
  }, {
    key: "_notifyListenersIfCurrent",
    value: function _notifyListenersIfCurrent(user) {
      if (user === this.currentUser) {
        this.notifyAuthListeners();
      }
    }
  }, {
    key: "_key",
    value: function _key() {
      return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.isProactiveRefreshEnabled = true;

      if (this.currentUser) {
        this._currentUser._startProactiveRefresh();
      }
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.isProactiveRefreshEnabled = false;

      if (this.currentUser) {
        this._currentUser._stopProactiveRefresh();
      }
    }
  }, {
    key: "notifyAuthListeners",
    value: function notifyAuthListeners() {
      var _a2, _b;

      if (!this._isInitialized) {
        return;
      }

      this.idTokenSubscription.next(this.currentUser);
      var currentUid = (_b = (_a2 = this.currentUser) === null || _a2 === void 0 ? void 0 : _a2.uid) !== null && _b !== void 0 ? _b : null;

      if (this.lastNotifiedUid !== currentUid) {
        this.lastNotifiedUid = currentUid;
        this.authStateSubscription.next(this.currentUser);
      }
    }
  }, {
    key: "registerStateListener",
    value: function registerStateListener(subscription, nextOrObserver, error, completed) {
      var _this152 = this;

      if (this._deleted) {
        return function () {};
      }

      var cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
      var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;

      _assert$4(promise, this, "internal-error");

      promise.then(function () {
        return cb(_this152.currentUser);
      });

      if (typeof nextOrObserver === "function") {
        return subscription.addObserver(nextOrObserver, error, completed);
      } else {
        return subscription.addObserver(nextOrObserver);
      }
    }
  }, {
    key: "directlySetCurrentUser",
    value: function () {
      var _directlySetCurrentUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee554(user) {
        return _regeneratorRuntime.wrap(function _callee554$(_context555) {
          while (1) {
            switch (_context555.prev = _context555.next) {
              case 0:
                if (this.currentUser && this.currentUser !== user) {
                  this._currentUser._stopProactiveRefresh();
                }

                if (user && this.isProactiveRefreshEnabled) {
                  user._startProactiveRefresh();
                }

                this.currentUser = user;

                if (!user) {
                  _context555.next = 8;
                  break;
                }

                _context555.next = 6;
                return this.assertedPersistence.setCurrentUser(user);

              case 6:
                _context555.next = 10;
                break;

              case 8:
                _context555.next = 10;
                return this.assertedPersistence.removeCurrentUser();

              case 10:
              case "end":
                return _context555.stop();
            }
          }
        }, _callee554, this);
      }));

      function directlySetCurrentUser(_x941) {
        return _directlySetCurrentUser.apply(this, arguments);
      }

      return directlySetCurrentUser;
    }()
  }, {
    key: "queue",
    value: function queue(action) {
      this.operations = this.operations.then(action, action);
      return this.operations;
    }
  }, {
    key: "_logFramework",
    value: function _logFramework(framework) {
      if (!framework || this.frameworks.includes(framework)) {
        return;
      }

      this.frameworks.push(framework);
      this.frameworks.sort();
      this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
  }, {
    key: "_getFrameworks",
    value: function _getFrameworks() {
      return this.frameworks;
    }
  }, {
    key: "_getAdditionalHeaders",
    value: function () {
      var _getAdditionalHeaders2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee555() {
        var _a2, headers, heartbeatsHeader, appCheckToken;

        return _regeneratorRuntime.wrap(function _callee555$(_context556) {
          while (1) {
            switch (_context556.prev = _context556.next) {
              case 0:
                headers = _defineProperty3({}, "X-Client-Version", this.clientVersion);

                if (this.app.options.appId) {
                  headers["X-Firebase-gmpid"] = this.app.options.appId;
                }

                _context556.next = 4;
                return (_a2 = this.heartbeatServiceProvider.getImmediate({
                  optional: true
                })) === null || _a2 === void 0 ? void 0 : _a2.getHeartbeatsHeader();

              case 4:
                heartbeatsHeader = _context556.sent;

                if (heartbeatsHeader) {
                  headers["X-Firebase-Client"] = heartbeatsHeader;
                }

                _context556.next = 8;
                return this._getAppCheckToken();

              case 8:
                appCheckToken = _context556.sent;

                if (appCheckToken) {
                  headers["X-Firebase-AppCheck"] = appCheckToken;
                }

                return _context556.abrupt("return", headers);

              case 11:
              case "end":
                return _context556.stop();
            }
          }
        }, _callee555, this);
      }));

      function _getAdditionalHeaders() {
        return _getAdditionalHeaders2.apply(this, arguments);
      }

      return _getAdditionalHeaders;
    }()
  }, {
    key: "_getAppCheckToken",
    value: function () {
      var _getAppCheckToken2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee556() {
        var _a2, appCheckTokenResult;

        return _regeneratorRuntime.wrap(function _callee556$(_context557) {
          while (1) {
            switch (_context557.prev = _context557.next) {
              case 0:
                _context557.next = 2;
                return (_a2 = this.appCheckServiceProvider.getImmediate({
                  optional: true
                })) === null || _a2 === void 0 ? void 0 : _a2.getToken();

              case 2:
                appCheckTokenResult = _context557.sent;

                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) {
                  _logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                }

                return _context557.abrupt("return", appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token);

              case 5:
              case "end":
                return _context557.stop();
            }
          }
        }, _callee556, this);
      }));

      function _getAppCheckToken() {
        return _getAppCheckToken2.apply(this, arguments);
      }

      return _getAppCheckToken;
    }()
  }, {
    key: "_currentUser",
    get: function get() {
      return this.currentUser;
    }
  }, {
    key: "assertedPersistence",
    get: function get() {
      _assert$4(this.persistenceManager, this, "internal-error");

      return this.persistenceManager;
    }
  }]);

  return AuthImpl;
}();

function _castAuth(auth) {
  return getModularInstance(auth);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(auth) {
    var _this153 = this;

    _classCallCheck3(this, Subscription);

    this.auth = auth;
    this.observer = null;
    this.addObserver = createSubscribe(function (observer) {
      return _this153.observer = observer;
    });
  }

  _createClass3(Subscription, [{
    key: "next",
    get: function get() {
      _assert$4(this.observer, this.auth, "internal-error");

      return this.observer.next.bind(this.observer);
    }
  }]);

  return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function initializeAuth(app, deps) {
  var provider = _getProvider(app, "auth");

  if (provider.isInitialized()) {
    var auth2 = provider.getImmediate();
    var initialOptions = provider.getOptions();

    if (deepEqual$1(initialOptions, deps !== null && deps !== void 0 ? deps : {})) {
      return auth2;
    } else {
      _fail(auth2, "already-initialized");
    }
  }

  var auth = provider.initialize({
    options: deps
  });
  return auth;
}

function _initializeAuthInstance(auth, deps) {
  var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
  var hierarchy = (Array.isArray(persistence) ? persistence : [persistence]).map(_getInstance);

  if (deps === null || deps === void 0 ? void 0 : deps.errorMap) {
    auth._updateErrorMap(deps.errorMap);
  }

  auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}

function connectAuthEmulator(auth, url, options2) {
  var authInternal = _castAuth(auth);

  _assert$4(authInternal._canInitEmulator, authInternal, "emulator-config-failed");

  _assert$4(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme");

  var disableWarnings = !!(options2 === null || options2 === void 0 ? void 0 : options2.disableWarnings);
  var protocol = extractProtocol(url);

  var _extractHostAndPort = extractHostAndPort(url),
      host = _extractHostAndPort.host,
      port = _extractHostAndPort.port;

  var portStr = port === null ? "" : ":".concat(port);
  authInternal.config.emulator = {
    url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
  };
  authInternal.settings.appVerificationDisabledForTesting = true;
  authInternal.emulatorConfig = Object.freeze({
    host: host,
    port: port,
    protocol: protocol.replace(":", ""),
    options: Object.freeze({
      disableWarnings: disableWarnings
    })
  });

  if (!disableWarnings) {
    emitEmulatorWarning();
  }
}

function extractProtocol(url) {
  var protocolEnd = url.indexOf(":");
  return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}

function extractHostAndPort(url) {
  var protocol = extractProtocol(url);
  var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length));

  if (!authority) {
    return {
      host: "",
      port: null
    };
  }

  var hostAndPort = authority[2].split("@").pop() || "";
  var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);

  if (bracketedIPv6) {
    var host = bracketedIPv6[1];
    return {
      host: host,
      port: parsePort(hostAndPort.substr(host.length + 1))
    };
  } else {
    var _hostAndPort$split = hostAndPort.split(":"),
        _hostAndPort$split2 = _slicedToArray3(_hostAndPort$split, 2),
        _host = _hostAndPort$split2[0],
        port = _hostAndPort$split2[1];

    return {
      host: _host,
      port: parsePort(port)
    };
  }
}

function parsePort(portStr) {
  if (!portStr) {
    return null;
  }

  var port = Number(portStr);

  if (isNaN(port)) {
    return null;
  }

  return port;
}

function emitEmulatorWarning() {
  function attachBanner() {
    var el = document.createElement("p");
    var sty = el.style;
    el.innerText = "Running in emulator mode. Do not use with production credentials.";
    sty.position = "fixed";
    sty.width = "100%";
    sty.backgroundColor = "#ffffff";
    sty.border = ".1em solid #000000";
    sty.color = "#b50000";
    sty.bottom = "0px";
    sty.left = "0px";
    sty.margin = "0px";
    sty.zIndex = "10000";
    sty.textAlign = "center";
    el.classList.add("firebase-emulator-warning");
    document.body.appendChild(el);
  }

  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
  }

  if (typeof window !== "undefined" && typeof document !== "undefined") {
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", attachBanner);
    } else {
      attachBanner();
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var AuthCredential =
/*#__PURE__*/
function () {
  function AuthCredential(providerId, signInMethod) {
    _classCallCheck3(this, AuthCredential);

    this.providerId = providerId;
    this.signInMethod = signInMethod;
  }

  _createClass3(AuthCredential, [{
    key: "toJSON",
    value: function toJSON() {
      return debugFail("not implemented");
    }
  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(_auth) {
      return debugFail("not implemented");
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(_auth, _idToken) {
      return debugFail("not implemented");
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(_auth) {
      return debugFail("not implemented");
    }
  }]);

  return AuthCredential;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function resetPassword(_x942, _x943) {
  return _resetPassword.apply(this, arguments);
}

function _resetPassword() {
  _resetPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee665(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee665$(_context666) {
      while (1) {
        switch (_context666.prev = _context666.next) {
          case 0:
            return _context666.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:resetPassword", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context666.stop();
        }
      }
    }, _callee665);
  }));
  return _resetPassword.apply(this, arguments);
}

function updateEmailPassword(_x944, _x945) {
  return _updateEmailPassword.apply(this, arguments);
}

function _updateEmailPassword() {
  _updateEmailPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee666(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee666$(_context667) {
      while (1) {
        switch (_context667.prev = _context667.next) {
          case 0:
            return _context667.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:update", request2));

          case 1:
          case "end":
            return _context667.stop();
        }
      }
    }, _callee666);
  }));
  return _updateEmailPassword.apply(this, arguments);
}

function applyActionCode$1(_x946, _x947) {
  return _applyActionCode$.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _applyActionCode$() {
  _applyActionCode$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee667(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee667$(_context668) {
      while (1) {
        switch (_context668.prev = _context668.next) {
          case 0:
            return _context668.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:update", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context668.stop();
        }
      }
    }, _callee667);
  }));
  return _applyActionCode$.apply(this, arguments);
}

function signInWithPassword(_x948, _x949) {
  return _signInWithPassword.apply(this, arguments);
}

function _signInWithPassword() {
  _signInWithPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee668(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee668$(_context669) {
      while (1) {
        switch (_context669.prev = _context669.next) {
          case 0:
            return _context669.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithPassword", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context669.stop();
        }
      }
    }, _callee668);
  }));
  return _signInWithPassword.apply(this, arguments);
}

function sendOobCode(_x950, _x951) {
  return _sendOobCode.apply(this, arguments);
}

function _sendOobCode() {
  _sendOobCode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee669(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee669$(_context670) {
      while (1) {
        switch (_context670.prev = _context670.next) {
          case 0:
            return _context670.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:sendOobCode", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context670.stop();
        }
      }
    }, _callee669);
  }));
  return _sendOobCode.apply(this, arguments);
}

function sendEmailVerification$1(_x952, _x953) {
  return _sendEmailVerification$.apply(this, arguments);
}

function _sendEmailVerification$() {
  _sendEmailVerification$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee670(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee670$(_context671) {
      while (1) {
        switch (_context671.prev = _context671.next) {
          case 0:
            return _context671.abrupt("return", sendOobCode(auth, request2));

          case 1:
          case "end":
            return _context671.stop();
        }
      }
    }, _callee670);
  }));
  return _sendEmailVerification$.apply(this, arguments);
}

function sendPasswordResetEmail$1(_x954, _x955) {
  return _sendPasswordResetEmail$.apply(this, arguments);
}

function _sendPasswordResetEmail$() {
  _sendPasswordResetEmail$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee671(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee671$(_context672) {
      while (1) {
        switch (_context672.prev = _context672.next) {
          case 0:
            return _context672.abrupt("return", sendOobCode(auth, request2));

          case 1:
          case "end":
            return _context672.stop();
        }
      }
    }, _callee671);
  }));
  return _sendPasswordResetEmail$.apply(this, arguments);
}

function sendSignInLinkToEmail$1(_x956, _x957) {
  return _sendSignInLinkToEmail$.apply(this, arguments);
}

function _sendSignInLinkToEmail$() {
  _sendSignInLinkToEmail$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee672(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee672$(_context673) {
      while (1) {
        switch (_context673.prev = _context673.next) {
          case 0:
            return _context673.abrupt("return", sendOobCode(auth, request2));

          case 1:
          case "end":
            return _context673.stop();
        }
      }
    }, _callee672);
  }));
  return _sendSignInLinkToEmail$.apply(this, arguments);
}

function verifyAndChangeEmail(_x958, _x959) {
  return _verifyAndChangeEmail.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _verifyAndChangeEmail() {
  _verifyAndChangeEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee673(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee673$(_context674) {
      while (1) {
        switch (_context674.prev = _context674.next) {
          case 0:
            return _context674.abrupt("return", sendOobCode(auth, request2));

          case 1:
          case "end":
            return _context674.stop();
        }
      }
    }, _callee673);
  }));
  return _verifyAndChangeEmail.apply(this, arguments);
}

function signInWithEmailLink$1(_x960, _x961) {
  return _signInWithEmailLink$.apply(this, arguments);
}

function _signInWithEmailLink$() {
  _signInWithEmailLink$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee674(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee674$(_context675) {
      while (1) {
        switch (_context675.prev = _context675.next) {
          case 0:
            return _context675.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithEmailLink", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context675.stop();
        }
      }
    }, _callee674);
  }));
  return _signInWithEmailLink$.apply(this, arguments);
}

function signInWithEmailLinkForLinking(_x962, _x963) {
  return _signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithEmailLinkForLinking() {
  _signInWithEmailLinkForLinking = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee675(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee675$(_context676) {
      while (1) {
        switch (_context676.prev = _context676.next) {
          case 0:
            return _context676.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithEmailLink", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context676.stop();
        }
      }
    }, _callee675);
  }));
  return _signInWithEmailLinkForLinking.apply(this, arguments);
}

var EmailAuthCredential =
/*#__PURE__*/
function (_AuthCredential) {
  _inherits3(EmailAuthCredential, _AuthCredential);

  function EmailAuthCredential(_email, _password, signInMethod) {
    var _this154;

    var _tenantId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck3(this, EmailAuthCredential);

    _this154 = _possibleConstructorReturn3(this, _getPrototypeOf4(EmailAuthCredential).call(this, "password", signInMethod));
    _this154._email = _email;
    _this154._password = _password;
    _this154._tenantId = _tenantId;
    return _this154;
  }

  _createClass3(EmailAuthCredential, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        email: this._email,
        password: this._password,
        signInMethod: this.signInMethod,
        tenantId: this._tenantId
      };
    }
  }, {
    key: "_getIdTokenResponse",
    value: function () {
      var _getIdTokenResponse2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee558(auth) {
        var _a2, request2, requestWithRecaptcha;

        return _regeneratorRuntime.wrap(function _callee558$(_context559) {
          while (1) {
            switch (_context559.prev = _context559.next) {
              case 0:
                _context559.t0 = this.signInMethod;
                _context559.next = _context559.t0 === "password" ? 3 : _context559.t0 === "emailLink" ? 12 : 13;
                break;

              case 3:
                request2 = {
                  returnSecureToken: true,
                  email: this._email,
                  password: this._password,
                  clientType: "CLIENT_TYPE_WEB"
                };

                if (!((_a2 = auth._getRecaptchaConfig()) === null || _a2 === void 0 ? void 0 : _a2.emailPasswordEnabled)) {
                  _context559.next = 11;
                  break;
                }

                _context559.next = 7;
                return injectRecaptchaFields(auth, request2, "signInWithPassword");

              case 7:
                requestWithRecaptcha = _context559.sent;
                return _context559.abrupt("return", signInWithPassword(auth, requestWithRecaptcha));

              case 11:
                return _context559.abrupt("return", signInWithPassword(auth, request2).catch(
                /*#__PURE__*/
                function () {
                  var _ref575 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee557(error) {
                    var _requestWithRecaptcha;

                    return _regeneratorRuntime.wrap(function _callee557$(_context558) {
                      while (1) {
                        switch (_context558.prev = _context558.next) {
                          case 0:
                            if (!(error.code === "auth/".concat("missing-recaptcha-token"))) {
                              _context558.next = 8;
                              break;
                            }

                            console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                            _context558.next = 4;
                            return injectRecaptchaFields(auth, request2, "signInWithPassword");

                          case 4:
                            _requestWithRecaptcha = _context558.sent;
                            return _context558.abrupt("return", signInWithPassword(auth, _requestWithRecaptcha));

                          case 8:
                            return _context558.abrupt("return", Promise.reject(error));

                          case 9:
                          case "end":
                            return _context558.stop();
                        }
                      }
                    }, _callee557);
                  }));

                  return function (_x965) {
                    return _ref575.apply(this, arguments);
                  };
                }()));

              case 12:
                return _context559.abrupt("return", signInWithEmailLink$1(auth, {
                  email: this._email,
                  oobCode: this._password
                }));

              case 13:
                _fail(auth, "internal-error");

              case 14:
              case "end":
                return _context559.stop();
            }
          }
        }, _callee558, this);
      }));

      function _getIdTokenResponse(_x964) {
        return _getIdTokenResponse2.apply(this, arguments);
      }

      return _getIdTokenResponse;
    }()
  }, {
    key: "_linkToIdToken",
    value: function () {
      var _linkToIdToken2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee559(auth, idToken) {
        return _regeneratorRuntime.wrap(function _callee559$(_context560) {
          while (1) {
            switch (_context560.prev = _context560.next) {
              case 0:
                _context560.t0 = this.signInMethod;
                _context560.next = _context560.t0 === "password" ? 3 : _context560.t0 === "emailLink" ? 4 : 5;
                break;

              case 3:
                return _context560.abrupt("return", updateEmailPassword(auth, {
                  idToken: idToken,
                  returnSecureToken: true,
                  email: this._email,
                  password: this._password
                }));

              case 4:
                return _context560.abrupt("return", signInWithEmailLinkForLinking(auth, {
                  idToken: idToken,
                  email: this._email,
                  oobCode: this._password
                }));

              case 5:
                _fail(auth, "internal-error");

              case 6:
              case "end":
                return _context560.stop();
            }
          }
        }, _callee559, this);
      }));

      function _linkToIdToken(_x966, _x967) {
        return _linkToIdToken2.apply(this, arguments);
      }

      return _linkToIdToken;
    }()
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      return this._getIdTokenResponse(auth);
    }
  }], [{
    key: "_fromEmailAndPassword",
    value: function _fromEmailAndPassword(email, password) {
      return new EmailAuthCredential(email, password, "password");
    }
  }, {
    key: "_fromEmailAndCode",
    value: function _fromEmailAndCode(email, oobCode) {
      var tenantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new EmailAuthCredential(email, oobCode, "emailLink", tenantId);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = typeof json === "string" ? JSON.parse(json) : json;

      if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
        if (obj.signInMethod === "password") {
          return this._fromEmailAndPassword(obj.email, obj.password);
        } else if (obj.signInMethod === "emailLink") {
          return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
      }

      return null;
    }
  }]);

  return EmailAuthCredential;
}(AuthCredential);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function signInWithIdp(_x968, _x969) {
  return _signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithIdp() {
  _signInWithIdp = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee676(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee676$(_context677) {
      while (1) {
        switch (_context677.prev = _context677.next) {
          case 0:
            return _context677.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithIdp", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context677.stop();
        }
      }
    }, _callee676);
  }));
  return _signInWithIdp.apply(this, arguments);
}

var IDP_REQUEST_URI$1 = "http://localhost";

var OAuthCredential =
/*#__PURE__*/
function (_AuthCredential2) {
  _inherits3(OAuthCredential, _AuthCredential2);

  function OAuthCredential() {
    var _this155;

    _classCallCheck3(this, OAuthCredential);

    _this155 = _possibleConstructorReturn3(this, _getPrototypeOf4(OAuthCredential).apply(this, arguments));
    _this155.pendingToken = null;
    return _this155;
  }

  _createClass3(OAuthCredential, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        idToken: this.idToken,
        accessToken: this.accessToken,
        secret: this.secret,
        nonce: this.nonce,
        pendingToken: this.pendingToken,
        providerId: this.providerId,
        signInMethod: this.signInMethod
      };
    }
  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(auth) {
      var request2 = this.buildRequest();
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      var request2 = this.buildRequest();
      request2.idToken = idToken;
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      var request2 = this.buildRequest();
      request2.autoCreate = false;
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "buildRequest",
    value: function buildRequest() {
      var request2 = {
        requestUri: IDP_REQUEST_URI$1,
        returnSecureToken: true
      };

      if (this.pendingToken) {
        request2.pendingToken = this.pendingToken;
      } else {
        var postBody = {};

        if (this.idToken) {
          postBody["id_token"] = this.idToken;
        }

        if (this.accessToken) {
          postBody["access_token"] = this.accessToken;
        }

        if (this.secret) {
          postBody["oauth_token_secret"] = this.secret;
        }

        postBody["providerId"] = this.providerId;

        if (this.nonce && !this.pendingToken) {
          postBody["nonce"] = this.nonce;
        }

        request2.postBody = querystring(postBody);
      }

      return request2;
    }
  }], [{
    key: "_fromParams",
    value: function _fromParams(params) {
      var cred = new OAuthCredential(params.providerId, params.signInMethod);

      if (params.idToken || params.accessToken) {
        if (params.idToken) {
          cred.idToken = params.idToken;
        }

        if (params.accessToken) {
          cred.accessToken = params.accessToken;
        }

        if (params.nonce && !params.pendingToken) {
          cred.nonce = params.nonce;
        }

        if (params.pendingToken) {
          cred.pendingToken = params.pendingToken;
        }
      } else if (params.oauthToken && params.oauthTokenSecret) {
        cred.accessToken = params.oauthToken;
        cred.secret = params.oauthTokenSecret;
      } else {
        _fail("argument-error");
      }

      return cred;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = typeof json === "string" ? JSON.parse(json) : json;

      var providerId = obj.providerId,
          signInMethod = obj.signInMethod,
          rest = __rest(obj, ["providerId", "signInMethod"]);

      if (!providerId || !signInMethod) {
        return null;
      }

      var cred = new OAuthCredential(providerId, signInMethod);
      cred.idToken = rest.idToken || void 0;
      cred.accessToken = rest.accessToken || void 0;
      cred.secret = rest.secret;
      cred.nonce = rest.nonce;
      cred.pendingToken = rest.pendingToken || null;
      return cred;
    }
  }]);

  return OAuthCredential;
}(AuthCredential);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function sendPhoneVerificationCode(_x970, _x971) {
  return _sendPhoneVerificationCode.apply(this, arguments);
}

function _sendPhoneVerificationCode() {
  _sendPhoneVerificationCode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee677(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee677$(_context678) {
      while (1) {
        switch (_context678.prev = _context678.next) {
          case 0:
            return _context678.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:sendVerificationCode", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context678.stop();
        }
      }
    }, _callee677);
  }));
  return _sendPhoneVerificationCode.apply(this, arguments);
}

function signInWithPhoneNumber$1(_x972, _x973) {
  return _signInWithPhoneNumber$.apply(this, arguments);
}

function _signInWithPhoneNumber$() {
  _signInWithPhoneNumber$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee678(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee678$(_context679) {
      while (1) {
        switch (_context679.prev = _context679.next) {
          case 0:
            return _context679.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithPhoneNumber", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context679.stop();
        }
      }
    }, _callee678);
  }));
  return _signInWithPhoneNumber$.apply(this, arguments);
}

function linkWithPhoneNumber$1(_x974, _x975) {
  return _linkWithPhoneNumber$.apply(this, arguments);
}

function _linkWithPhoneNumber$() {
  _linkWithPhoneNumber$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee679(auth, request2) {
    var response;
    return _regeneratorRuntime.wrap(function _callee679$(_context680) {
      while (1) {
        switch (_context680.prev = _context680.next) {
          case 0:
            _context680.next = 2;
            return _performSignInRequest(auth, "POST", "/v1/accounts:signInWithPhoneNumber", _addTidIfNecessary(auth, request2));

          case 2:
            response = _context680.sent;

            if (!response.temporaryProof) {
              _context680.next = 5;
              break;
            }

            throw _makeTaggedError(auth, "account-exists-with-different-credential", response);

          case 5:
            return _context680.abrupt("return", response);

          case 6:
          case "end":
            return _context680.stop();
        }
      }
    }, _callee679);
  }));
  return _linkWithPhoneNumber$.apply(this, arguments);
}

var VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = _defineProperty3({}, "USER_NOT_FOUND", "user-not-found");

function verifyPhoneNumberForExisting(_x976, _x977) {
  return _verifyPhoneNumberForExisting.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _verifyPhoneNumberForExisting() {
  _verifyPhoneNumberForExisting = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee680(auth, request2) {
    var apiRequest;
    return _regeneratorRuntime.wrap(function _callee680$(_context681) {
      while (1) {
        switch (_context681.prev = _context681.next) {
          case 0:
            apiRequest = Object.assign(Object.assign({}, request2), {
              operation: "REAUTH"
            });
            return _context681.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithPhoneNumber", _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_));

          case 2:
          case "end":
            return _context681.stop();
        }
      }
    }, _callee680);
  }));
  return _verifyPhoneNumberForExisting.apply(this, arguments);
}

var PhoneAuthCredential =
/*#__PURE__*/
function (_AuthCredential3) {
  _inherits3(PhoneAuthCredential, _AuthCredential3);

  function PhoneAuthCredential(params) {
    var _this156;

    _classCallCheck3(this, PhoneAuthCredential);

    _this156 = _possibleConstructorReturn3(this, _getPrototypeOf4(PhoneAuthCredential).call(this, "phone", "phone"));
    _this156.params = params;
    return _this156;
  }

  _createClass3(PhoneAuthCredential, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(auth) {
      return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      return linkWithPhoneNumber$1(auth, Object.assign({
        idToken: idToken
      }, this._makeVerificationRequest()));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
  }, {
    key: "_makeVerificationRequest",
    value: function _makeVerificationRequest() {
      var _this$params = this.params,
          temporaryProof = _this$params.temporaryProof,
          phoneNumber = _this$params.phoneNumber,
          verificationId = _this$params.verificationId,
          verificationCode = _this$params.verificationCode;

      if (temporaryProof && phoneNumber) {
        return {
          temporaryProof: temporaryProof,
          phoneNumber: phoneNumber
        };
      }

      return {
        sessionInfo: verificationId,
        code: verificationCode
      };
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var obj = {
        providerId: this.providerId
      };

      if (this.params.phoneNumber) {
        obj.phoneNumber = this.params.phoneNumber;
      }

      if (this.params.temporaryProof) {
        obj.temporaryProof = this.params.temporaryProof;
      }

      if (this.params.verificationCode) {
        obj.verificationCode = this.params.verificationCode;
      }

      if (this.params.verificationId) {
        obj.verificationId = this.params.verificationId;
      }

      return obj;
    }
  }], [{
    key: "_fromVerification",
    value: function _fromVerification(verificationId, verificationCode) {
      return new PhoneAuthCredential({
        verificationId: verificationId,
        verificationCode: verificationCode
      });
    }
  }, {
    key: "_fromTokenResponse",
    value: function _fromTokenResponse(phoneNumber, temporaryProof) {
      return new PhoneAuthCredential({
        phoneNumber: phoneNumber,
        temporaryProof: temporaryProof
      });
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (typeof json === "string") {
        json = JSON.parse(json);
      }

      var _json = json,
          verificationId = _json.verificationId,
          verificationCode = _json.verificationCode,
          phoneNumber = _json.phoneNumber,
          temporaryProof = _json.temporaryProof;

      if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) {
        return null;
      }

      return new PhoneAuthCredential({
        verificationId: verificationId,
        verificationCode: verificationCode,
        phoneNumber: phoneNumber,
        temporaryProof: temporaryProof
      });
    }
  }]);

  return PhoneAuthCredential;
}(AuthCredential);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function parseMode(mode) {
  switch (mode) {
    case "recoverEmail":
      return "RECOVER_EMAIL";

    case "resetPassword":
      return "PASSWORD_RESET";

    case "signIn":
      return "EMAIL_SIGNIN";

    case "verifyEmail":
      return "VERIFY_EMAIL";

    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";

    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";

    default:
      return null;
  }
}

function parseDeepLink(url) {
  var link = querystringDecode(extractQuerystring(url))["link"];
  var doubleDeepLink = link ? querystringDecode(extractQuerystring(link))["deep_link_id"] : null;
  var iOSDeepLink = querystringDecode(extractQuerystring(url))["deep_link_id"];
  var iOSDoubleDeepLink = iOSDeepLink ? querystringDecode(extractQuerystring(iOSDeepLink))["link"] : null;
  return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}

var ActionCodeURL =
/*#__PURE__*/
function () {
  function ActionCodeURL(actionLink) {
    _classCallCheck3(this, ActionCodeURL);

    var _a2, _b, _c, _d, _e2, _f;

    var searchParams = querystringDecode(extractQuerystring(actionLink));
    var apiKey = (_a2 = searchParams["apiKey"]) !== null && _a2 !== void 0 ? _a2 : null;
    var code = (_b = searchParams["oobCode"]) !== null && _b !== void 0 ? _b : null;
    var operation = parseMode((_c = searchParams["mode"]) !== null && _c !== void 0 ? _c : null);

    _assert$4(apiKey && code && operation, "argument-error");

    this.apiKey = apiKey;
    this.operation = operation;
    this.code = code;
    this.continueUrl = (_d = searchParams["continueUrl"]) !== null && _d !== void 0 ? _d : null;
    this.languageCode = (_e2 = searchParams["languageCode"]) !== null && _e2 !== void 0 ? _e2 : null;
    this.tenantId = (_f = searchParams["tenantId"]) !== null && _f !== void 0 ? _f : null;
  }

  _createClass3(ActionCodeURL, null, [{
    key: "parseLink",
    value: function parseLink(link) {
      var actionLink = parseDeepLink(link);

      try {
        return new ActionCodeURL(actionLink);
      } catch (_a2) {
        return null;
      }
    }
  }]);

  return ActionCodeURL;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var EmailAuthProvider =
/*#__PURE__*/
function () {
  function EmailAuthProvider() {
    _classCallCheck3(this, EmailAuthProvider);

    this.providerId = EmailAuthProvider.PROVIDER_ID;
  }

  _createClass3(EmailAuthProvider, null, [{
    key: "credential",
    value: function credential(email, password) {
      return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
  }, {
    key: "credentialWithLink",
    value: function credentialWithLink(email, emailLink) {
      var actionCodeUrl = ActionCodeURL.parseLink(emailLink);

      _assert$4(actionCodeUrl, "argument-error");

      return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
  }]);

  return EmailAuthProvider;
}();

EmailAuthProvider.PROVIDER_ID = "password";
EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FederatedAuthProvider =
/*#__PURE__*/
function () {
  function FederatedAuthProvider(providerId) {
    _classCallCheck3(this, FederatedAuthProvider);

    this.providerId = providerId;
    this.defaultLanguageCode = null;
    this.customParameters = {};
  }

  _createClass3(FederatedAuthProvider, [{
    key: "setDefaultLanguage",
    value: function setDefaultLanguage(languageCode) {
      this.defaultLanguageCode = languageCode;
    }
  }, {
    key: "setCustomParameters",
    value: function setCustomParameters(customOAuthParameters) {
      this.customParameters = customOAuthParameters;
      return this;
    }
  }, {
    key: "getCustomParameters",
    value: function getCustomParameters() {
      return this.customParameters;
    }
  }]);

  return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var BaseOAuthProvider =
/*#__PURE__*/
function (_FederatedAuthProvide) {
  _inherits3(BaseOAuthProvider, _FederatedAuthProvide);

  function BaseOAuthProvider() {
    var _this157;

    _classCallCheck3(this, BaseOAuthProvider);

    _this157 = _possibleConstructorReturn3(this, _getPrototypeOf4(BaseOAuthProvider).apply(this, arguments));
    _this157.scopes = [];
    return _this157;
  }

  _createClass3(BaseOAuthProvider, [{
    key: "addScope",
    value: function addScope(scope) {
      if (!this.scopes.includes(scope)) {
        this.scopes.push(scope);
      }

      return this;
    }
  }, {
    key: "getScopes",
    value: function getScopes() {
      return _toConsumableArray3(this.scopes);
    }
  }]);

  return BaseOAuthProvider;
}(FederatedAuthProvider);

var OAuthProvider =
/*#__PURE__*/
function (_BaseOAuthProvider) {
  _inherits3(OAuthProvider, _BaseOAuthProvider);

  function OAuthProvider() {
    _classCallCheck3(this, OAuthProvider);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(OAuthProvider).apply(this, arguments));
  }

  _createClass3(OAuthProvider, [{
    key: "credential",
    value: function credential(params) {
      return this._credential(Object.assign(Object.assign({}, params), {
        nonce: params.rawNonce
      }));
    }
  }, {
    key: "_credential",
    value: function _credential(params) {
      _assert$4(params.idToken || params.accessToken, "argument-error");

      return OAuthCredential._fromParams(Object.assign(Object.assign({}, params), {
        providerId: this.providerId,
        signInMethod: this.providerId
      }));
    }
  }], [{
    key: "credentialFromJSON",
    value: function credentialFromJSON(json) {
      var obj = typeof json === "string" ? JSON.parse(json) : json;

      _assert$4("providerId" in obj && "signInMethod" in obj, "argument-error");

      return OAuthCredential._fromParams(obj);
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "oauthCredentialFromTaggedObject",
    value: function oauthCredentialFromTaggedObject(_ref576) {
      var tokenResponse = _ref576._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var oauthIdToken = tokenResponse.oauthIdToken,
          oauthAccessToken = tokenResponse.oauthAccessToken,
          oauthTokenSecret = tokenResponse.oauthTokenSecret,
          pendingToken = tokenResponse.pendingToken,
          nonce = tokenResponse.nonce,
          providerId = tokenResponse.providerId;

      if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) {
        return null;
      }

      if (!providerId) {
        return null;
      }

      try {
        return new OAuthProvider(providerId)._credential({
          idToken: oauthIdToken,
          accessToken: oauthAccessToken,
          nonce: nonce,
          pendingToken: pendingToken
        });
      } catch (e2) {
        return null;
      }
    }
  }]);

  return OAuthProvider;
}(BaseOAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var FacebookAuthProvider =
/*#__PURE__*/
function (_BaseOAuthProvider2) {
  _inherits3(FacebookAuthProvider, _BaseOAuthProvider2);

  function FacebookAuthProvider() {
    _classCallCheck3(this, FacebookAuthProvider);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(FacebookAuthProvider).call(this, "facebook.com"));
  }

  _createClass3(FacebookAuthProvider, null, [{
    key: "credential",
    value: function credential(accessToken) {
      return OAuthCredential._fromParams({
        providerId: FacebookAuthProvider.PROVIDER_ID,
        signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
        accessToken: accessToken
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref577) {
      var tokenResponse = _ref577._tokenResponse;

      if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) {
        return null;
      }

      if (!tokenResponse.oauthAccessToken) {
        return null;
      }

      try {
        return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
      } catch (_a2) {
        return null;
      }
    }
  }]);

  return FacebookAuthProvider;
}(BaseOAuthProvider);

FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
FacebookAuthProvider.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var GoogleAuthProvider =
/*#__PURE__*/
function (_BaseOAuthProvider3) {
  _inherits3(GoogleAuthProvider, _BaseOAuthProvider3);

  function GoogleAuthProvider() {
    var _this158;

    _classCallCheck3(this, GoogleAuthProvider);

    _this158 = _possibleConstructorReturn3(this, _getPrototypeOf4(GoogleAuthProvider).call(this, "google.com"));

    _this158.addScope("profile");

    return _this158;
  }

  _createClass3(GoogleAuthProvider, null, [{
    key: "credential",
    value: function credential(idToken, accessToken) {
      return OAuthCredential._fromParams({
        providerId: GoogleAuthProvider.PROVIDER_ID,
        signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
        idToken: idToken,
        accessToken: accessToken
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref578) {
      var tokenResponse = _ref578._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var oauthIdToken = tokenResponse.oauthIdToken,
          oauthAccessToken = tokenResponse.oauthAccessToken;

      if (!oauthIdToken && !oauthAccessToken) {
        return null;
      }

      try {
        return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
      } catch (_a2) {
        return null;
      }
    }
  }]);

  return GoogleAuthProvider;
}(BaseOAuthProvider);

GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com";
GoogleAuthProvider.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var GithubAuthProvider =
/*#__PURE__*/
function (_BaseOAuthProvider4) {
  _inherits3(GithubAuthProvider, _BaseOAuthProvider4);

  function GithubAuthProvider() {
    _classCallCheck3(this, GithubAuthProvider);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(GithubAuthProvider).call(this, "github.com"));
  }

  _createClass3(GithubAuthProvider, null, [{
    key: "credential",
    value: function credential(accessToken) {
      return OAuthCredential._fromParams({
        providerId: GithubAuthProvider.PROVIDER_ID,
        signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
        accessToken: accessToken
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref579) {
      var tokenResponse = _ref579._tokenResponse;

      if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) {
        return null;
      }

      if (!tokenResponse.oauthAccessToken) {
        return null;
      }

      try {
        return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
      } catch (_a2) {
        return null;
      }
    }
  }]);

  return GithubAuthProvider;
}(BaseOAuthProvider);

GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com";
GithubAuthProvider.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var IDP_REQUEST_URI = "http://localhost";

var SAMLAuthCredential =
/*#__PURE__*/
function (_AuthCredential4) {
  _inherits3(SAMLAuthCredential, _AuthCredential4);

  function SAMLAuthCredential(providerId, pendingToken) {
    var _this159;

    _classCallCheck3(this, SAMLAuthCredential);

    _this159 = _possibleConstructorReturn3(this, _getPrototypeOf4(SAMLAuthCredential).call(this, providerId, providerId));
    _this159.pendingToken = pendingToken;
    return _this159;
  }

  _createClass3(SAMLAuthCredential, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(auth) {
      var request2 = this.buildRequest();
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      var request2 = this.buildRequest();
      request2.idToken = idToken;
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      var request2 = this.buildRequest();
      request2.autoCreate = false;
      return signInWithIdp(auth, request2);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        signInMethod: this.signInMethod,
        providerId: this.providerId,
        pendingToken: this.pendingToken
      };
    }
  }, {
    key: "buildRequest",
    value: function buildRequest() {
      return {
        requestUri: IDP_REQUEST_URI,
        returnSecureToken: true,
        pendingToken: this.pendingToken
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = typeof json === "string" ? JSON.parse(json) : json;
      var providerId = obj.providerId,
          signInMethod = obj.signInMethod,
          pendingToken = obj.pendingToken;

      if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) {
        return null;
      }

      return new SAMLAuthCredential(providerId, pendingToken);
    }
  }, {
    key: "_create",
    value: function _create(providerId, pendingToken) {
      return new SAMLAuthCredential(providerId, pendingToken);
    }
  }]);

  return SAMLAuthCredential;
}(AuthCredential);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var SAML_PROVIDER_PREFIX = "saml.";

var SAMLAuthProvider =
/*#__PURE__*/
function (_FederatedAuthProvide2) {
  _inherits3(SAMLAuthProvider, _FederatedAuthProvide2);

  function SAMLAuthProvider(providerId) {
    _classCallCheck3(this, SAMLAuthProvider);

    _assert$4(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error");

    return _possibleConstructorReturn3(this, _getPrototypeOf4(SAMLAuthProvider).call(this, providerId));
  }

  _createClass3(SAMLAuthProvider, null, [{
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromJSON",
    value: function credentialFromJSON(json) {
      var credential = SAMLAuthCredential.fromJSON(json);

      _assert$4(credential, "argument-error");

      return credential;
    }
  }, {
    key: "samlCredentialFromTaggedObject",
    value: function samlCredentialFromTaggedObject(_ref580) {
      var tokenResponse = _ref580._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var pendingToken = tokenResponse.pendingToken,
          providerId = tokenResponse.providerId;

      if (!pendingToken || !providerId) {
        return null;
      }

      try {
        return SAMLAuthCredential._create(providerId, pendingToken);
      } catch (e2) {
        return null;
      }
    }
  }]);

  return SAMLAuthProvider;
}(FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var TwitterAuthProvider =
/*#__PURE__*/
function (_BaseOAuthProvider5) {
  _inherits3(TwitterAuthProvider, _BaseOAuthProvider5);

  function TwitterAuthProvider() {
    _classCallCheck3(this, TwitterAuthProvider);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(TwitterAuthProvider).call(this, "twitter.com"));
  }

  _createClass3(TwitterAuthProvider, null, [{
    key: "credential",
    value: function credential(token2, secret) {
      return OAuthCredential._fromParams({
        providerId: TwitterAuthProvider.PROVIDER_ID,
        signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
        oauthToken: token2,
        oauthTokenSecret: secret
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref581) {
      var tokenResponse = _ref581._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var oauthAccessToken = tokenResponse.oauthAccessToken,
          oauthTokenSecret = tokenResponse.oauthTokenSecret;

      if (!oauthAccessToken || !oauthTokenSecret) {
        return null;
      }

      try {
        return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
      } catch (_a2) {
        return null;
      }
    }
  }]);

  return TwitterAuthProvider;
}(BaseOAuthProvider);

TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com";
TwitterAuthProvider.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function signUp(_x978, _x979) {
  return _signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signUp() {
  _signUp = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee681(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee681$(_context682) {
      while (1) {
        switch (_context682.prev = _context682.next) {
          case 0:
            return _context682.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signUp", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context682.stop();
        }
      }
    }, _callee681);
  }));
  return _signUp.apply(this, arguments);
}

var UserCredentialImpl =
/*#__PURE__*/
function () {
  function UserCredentialImpl(params) {
    _classCallCheck3(this, UserCredentialImpl);

    this.user = params.user;
    this.providerId = params.providerId;
    this._tokenResponse = params._tokenResponse;
    this.operationType = params.operationType;
  }

  _createClass3(UserCredentialImpl, null, [{
    key: "_fromIdTokenResponse",
    value: function () {
      var _fromIdTokenResponse3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee560(auth, operationType, idTokenResponse) {
        var isAnonymous,
            user,
            providerId,
            userCred,
            _args561 = arguments;
        return _regeneratorRuntime.wrap(function _callee560$(_context561) {
          while (1) {
            switch (_context561.prev = _context561.next) {
              case 0:
                isAnonymous = _args561.length > 3 && _args561[3] !== undefined ? _args561[3] : false;
                _context561.next = 3;
                return UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);

              case 3:
                user = _context561.sent;
                providerId = providerIdForResponse(idTokenResponse);
                userCred = new UserCredentialImpl({
                  user: user,
                  providerId: providerId,
                  _tokenResponse: idTokenResponse,
                  operationType: operationType
                });
                return _context561.abrupt("return", userCred);

              case 7:
              case "end":
                return _context561.stop();
            }
          }
        }, _callee560);
      }));

      function _fromIdTokenResponse(_x980, _x981, _x982) {
        return _fromIdTokenResponse3.apply(this, arguments);
      }

      return _fromIdTokenResponse;
    }()
  }, {
    key: "_forOperation",
    value: function () {
      var _forOperation2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee561(user, operationType, response) {
        var providerId;
        return _regeneratorRuntime.wrap(function _callee561$(_context562) {
          while (1) {
            switch (_context562.prev = _context562.next) {
              case 0:
                _context562.next = 2;
                return user._updateTokensIfNecessary(response, true);

              case 2:
                providerId = providerIdForResponse(response);
                return _context562.abrupt("return", new UserCredentialImpl({
                  user: user,
                  providerId: providerId,
                  _tokenResponse: response,
                  operationType: operationType
                }));

              case 4:
              case "end":
                return _context562.stop();
            }
          }
        }, _callee561);
      }));

      function _forOperation(_x983, _x984, _x985) {
        return _forOperation2.apply(this, arguments);
      }

      return _forOperation;
    }()
  }]);

  return UserCredentialImpl;
}();

function providerIdForResponse(response) {
  if (response.providerId) {
    return response.providerId;
  }

  if ("phoneNumber" in response) {
    return "phone";
  }

  return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInAnonymously2(_x986) {
  return _signInAnonymously.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInAnonymously() {
  _signInAnonymously = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee682(auth) {
    var _a2, authInternal, response, userCredential;

    return _regeneratorRuntime.wrap(function _callee682$(_context683) {
      while (1) {
        switch (_context683.prev = _context683.next) {
          case 0:
            authInternal = _castAuth(auth);
            _context683.next = 3;
            return authInternal._initializationPromise;

          case 3:
            if (!((_a2 = authInternal.currentUser) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
              _context683.next = 5;
              break;
            }

            return _context683.abrupt("return", new UserCredentialImpl({
              user: authInternal.currentUser,
              providerId: null,
              operationType: "signIn"
            }));

          case 5:
            _context683.next = 7;
            return signUp(authInternal, {
              returnSecureToken: true
            });

          case 7:
            response = _context683.sent;
            _context683.next = 10;
            return UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn", response, true);

          case 10:
            userCredential = _context683.sent;
            _context683.next = 13;
            return authInternal._updateCurrentUser(userCredential.user);

          case 13:
            return _context683.abrupt("return", userCredential);

          case 14:
          case "end":
            return _context683.stop();
        }
      }
    }, _callee682);
  }));
  return _signInAnonymously.apply(this, arguments);
}

var MultiFactorError =
/*#__PURE__*/
function (_FirebaseError) {
  _inherits3(MultiFactorError, _FirebaseError);

  function MultiFactorError(auth, error, operationType, user) {
    var _this160;

    _classCallCheck3(this, MultiFactorError);

    var _a2;

    _this160 = _possibleConstructorReturn3(this, _getPrototypeOf4(MultiFactorError).call(this, error.code, error.message));
    _this160.operationType = operationType;
    _this160.user = user;
    Object.setPrototypeOf(_assertThisInitialized3(_this160), MultiFactorError.prototype);
    _this160.customData = {
      appName: auth.name,
      tenantId: (_a2 = auth.tenantId) !== null && _a2 !== void 0 ? _a2 : void 0,
      _serverResponse: error.customData._serverResponse,
      operationType: operationType
    };
    return _this160;
  }

  _createClass3(MultiFactorError, null, [{
    key: "_fromErrorAndOperation",
    value: function _fromErrorAndOperation(auth, error, operationType, user) {
      return new MultiFactorError(auth, error, operationType, user);
    }
  }]);

  return MultiFactorError;
}(FirebaseError);

function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
  var idTokenProvider = operationType === "reauthenticate" ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
  return idTokenProvider.catch(function (error) {
    if (error.code === "auth/".concat("multi-factor-auth-required")) {
      throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
    }

    throw error;
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function providerDataAsNames(providerData) {
  return new Set(providerData.map(function (_ref582) {
    var providerId = _ref582.providerId;
    return providerId;
  }).filter(function (pid) {
    return !!pid;
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _unlink2(_x987, _x988) {
  return _unlink.apply(this, arguments);
}

function _unlink() {
  _unlink = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee683(user, providerId) {
    var userInternal, _ref674, providerUserInfo, providersLeft;

    return _regeneratorRuntime.wrap(function _callee683$(_context684) {
      while (1) {
        switch (_context684.prev = _context684.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context684.next = 3;
            return _assertLinkedStatus(true, userInternal, providerId);

          case 3:
            _context684.t0 = deleteLinkedAccounts;
            _context684.t1 = userInternal.auth;
            _context684.next = 7;
            return userInternal.getIdToken();

          case 7:
            _context684.t2 = _context684.sent;
            _context684.t3 = [providerId];
            _context684.t4 = {
              idToken: _context684.t2,
              deleteProvider: _context684.t3
            };
            _context684.next = 12;
            return (0, _context684.t0)(_context684.t1, _context684.t4);

          case 12:
            _ref674 = _context684.sent;
            providerUserInfo = _ref674.providerUserInfo;
            providersLeft = providerDataAsNames(providerUserInfo || []);
            userInternal.providerData = userInternal.providerData.filter(function (pd) {
              return providersLeft.has(pd.providerId);
            });

            if (!providersLeft.has("phone")) {
              userInternal.phoneNumber = null;
            }

            _context684.next = 19;
            return userInternal.auth._persistUserIfCurrent(userInternal);

          case 19:
            return _context684.abrupt("return", userInternal);

          case 20:
          case "end":
            return _context684.stop();
        }
      }
    }, _callee683);
  }));
  return _unlink.apply(this, arguments);
}

function _link$1(_x989, _x990) {
  return _link$.apply(this, arguments);
}

function _link$() {
  _link$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee684(user, credential) {
    var bypassAuthState,
        response,
        _args685 = arguments;
    return _regeneratorRuntime.wrap(function _callee684$(_context685) {
      while (1) {
        switch (_context685.prev = _context685.next) {
          case 0:
            bypassAuthState = _args685.length > 2 && _args685[2] !== undefined ? _args685[2] : false;
            _context685.t0 = _logoutIfInvalidated;
            _context685.t1 = user;
            _context685.t2 = credential;
            _context685.t3 = user.auth;
            _context685.next = 7;
            return user.getIdToken();

          case 7:
            _context685.t4 = _context685.sent;
            _context685.t5 = _context685.t2._linkToIdToken.call(_context685.t2, _context685.t3, _context685.t4);
            _context685.t6 = bypassAuthState;
            _context685.next = 12;
            return (0, _context685.t0)(_context685.t1, _context685.t5, _context685.t6);

          case 12:
            response = _context685.sent;
            return _context685.abrupt("return", UserCredentialImpl._forOperation(user, "link", response));

          case 14:
          case "end":
            return _context685.stop();
        }
      }
    }, _callee684);
  }));
  return _link$.apply(this, arguments);
}

function _assertLinkedStatus(_x991, _x992, _x993) {
  return _assertLinkedStatus2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _assertLinkedStatus2() {
  _assertLinkedStatus2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee685(expected, user, provider) {
    var providerIds, code;
    return _regeneratorRuntime.wrap(function _callee685$(_context686) {
      while (1) {
        switch (_context686.prev = _context686.next) {
          case 0:
            _context686.next = 2;
            return _reloadWithoutSaving(user);

          case 2:
            providerIds = providerDataAsNames(user.providerData);
            code = expected === false ? "provider-already-linked" : "no-such-provider";

            _assert$4(providerIds.has(provider) === expected, user.auth, code);

          case 5:
          case "end":
            return _context686.stop();
        }
      }
    }, _callee685);
  }));
  return _assertLinkedStatus2.apply(this, arguments);
}

function _reauthenticate(_x994, _x995) {
  return _reauthenticate2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reauthenticate2() {
  _reauthenticate2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee686(user, credential) {
    var bypassAuthState,
        auth,
        operationType,
        response,
        parsed,
        localId,
        _args687 = arguments;
    return _regeneratorRuntime.wrap(function _callee686$(_context687) {
      while (1) {
        switch (_context687.prev = _context687.next) {
          case 0:
            bypassAuthState = _args687.length > 2 && _args687[2] !== undefined ? _args687[2] : false;
            auth = user.auth;
            operationType = "reauthenticate";
            _context687.prev = 3;
            _context687.next = 6;
            return _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);

          case 6:
            response = _context687.sent;

            _assert$4(response.idToken, auth, "internal-error");

            parsed = _parseToken(response.idToken);

            _assert$4(parsed, auth, "internal-error");

            localId = parsed.sub;

            _assert$4(user.uid === localId, auth, "user-mismatch");

            return _context687.abrupt("return", UserCredentialImpl._forOperation(user, operationType, response));

          case 15:
            _context687.prev = 15;
            _context687.t0 = _context687["catch"](3);

            if ((_context687.t0 === null || _context687.t0 === void 0 ? void 0 : _context687.t0.code) === "auth/".concat("user-not-found")) {
              _fail(auth, "user-mismatch");
            }

            throw _context687.t0;

          case 19:
          case "end":
            return _context687.stop();
        }
      }
    }, _callee686, null, [[3, 15]]);
  }));
  return _reauthenticate2.apply(this, arguments);
}

function _signInWithCredential(_x996, _x997) {
  return _signInWithCredential2.apply(this, arguments);
}

function _signInWithCredential2() {
  _signInWithCredential2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee687(auth, credential) {
    var bypassAuthState,
        operationType,
        response,
        userCredential,
        _args688 = arguments;
    return _regeneratorRuntime.wrap(function _callee687$(_context688) {
      while (1) {
        switch (_context688.prev = _context688.next) {
          case 0:
            bypassAuthState = _args688.length > 2 && _args688[2] !== undefined ? _args688[2] : false;
            operationType = "signIn";
            _context688.next = 4;
            return _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);

          case 4:
            response = _context688.sent;
            _context688.next = 7;
            return UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);

          case 7:
            userCredential = _context688.sent;

            if (bypassAuthState) {
              _context688.next = 11;
              break;
            }

            _context688.next = 11;
            return auth._updateCurrentUser(userCredential.user);

          case 11:
            return _context688.abrupt("return", userCredential);

          case 12:
          case "end":
            return _context688.stop();
        }
      }
    }, _callee687);
  }));
  return _signInWithCredential2.apply(this, arguments);
}

function _signInWithCredential4(_x998, _x999) {
  return _signInWithCredential3.apply(this, arguments);
}

function _signInWithCredential3() {
  _signInWithCredential3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee688(auth, credential) {
    return _regeneratorRuntime.wrap(function _callee688$(_context689) {
      while (1) {
        switch (_context689.prev = _context689.next) {
          case 0:
            return _context689.abrupt("return", _signInWithCredential(_castAuth(auth), credential));

          case 1:
          case "end":
            return _context689.stop();
        }
      }
    }, _callee688);
  }));
  return _signInWithCredential3.apply(this, arguments);
}

function _linkWithCredential2(_x1000, _x1001) {
  return _linkWithCredential.apply(this, arguments);
}

function _linkWithCredential() {
  _linkWithCredential = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee689(user, credential) {
    var userInternal;
    return _regeneratorRuntime.wrap(function _callee689$(_context690) {
      while (1) {
        switch (_context690.prev = _context690.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context690.next = 3;
            return _assertLinkedStatus(false, userInternal, credential.providerId);

          case 3:
            return _context690.abrupt("return", _link$1(userInternal, credential));

          case 4:
          case "end":
            return _context690.stop();
        }
      }
    }, _callee689);
  }));
  return _linkWithCredential.apply(this, arguments);
}

function _reauthenticateWithCredential2(_x1002, _x1003) {
  return _reauthenticateWithCredential.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reauthenticateWithCredential() {
  _reauthenticateWithCredential = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee690(user, credential) {
    return _regeneratorRuntime.wrap(function _callee690$(_context691) {
      while (1) {
        switch (_context691.prev = _context691.next) {
          case 0:
            return _context691.abrupt("return", _reauthenticate(getModularInstance(user), credential));

          case 1:
          case "end":
            return _context691.stop();
        }
      }
    }, _callee690);
  }));
  return _reauthenticateWithCredential.apply(this, arguments);
}

function signInWithCustomToken$1(_x1004, _x1005) {
  return _signInWithCustomToken$.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithCustomToken$() {
  _signInWithCustomToken$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee691(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee691$(_context692) {
      while (1) {
        switch (_context692.prev = _context692.next) {
          case 0:
            return _context692.abrupt("return", _performSignInRequest(auth, "POST", "/v1/accounts:signInWithCustomToken", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context692.stop();
        }
      }
    }, _callee691);
  }));
  return _signInWithCustomToken$.apply(this, arguments);
}

function _signInWithCustomToken2(_x1006, _x1007) {
  return _signInWithCustomToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithCustomToken() {
  _signInWithCustomToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee692(auth, customToken) {
    var authInternal, response, cred;
    return _regeneratorRuntime.wrap(function _callee692$(_context693) {
      while (1) {
        switch (_context693.prev = _context693.next) {
          case 0:
            authInternal = _castAuth(auth);
            _context693.next = 3;
            return signInWithCustomToken$1(authInternal, {
              token: customToken,
              returnSecureToken: true
            });

          case 3:
            response = _context693.sent;
            _context693.next = 6;
            return UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn", response);

          case 6:
            cred = _context693.sent;
            _context693.next = 9;
            return authInternal._updateCurrentUser(cred.user);

          case 9:
            return _context693.abrupt("return", cred);

          case 10:
          case "end":
            return _context693.stop();
        }
      }
    }, _callee692);
  }));
  return _signInWithCustomToken.apply(this, arguments);
}

var MultiFactorInfoImpl =
/*#__PURE__*/
function () {
  function MultiFactorInfoImpl(factorId, response) {
    _classCallCheck3(this, MultiFactorInfoImpl);

    this.factorId = factorId;
    this.uid = response.mfaEnrollmentId;
    this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
    this.displayName = response.displayName;
  }

  _createClass3(MultiFactorInfoImpl, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(auth, enrollment) {
      if ("phoneInfo" in enrollment) {
        return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
      } else if ("totpInfo" in enrollment) {
        return TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
      }

      return _fail(auth, "internal-error");
    }
  }]);

  return MultiFactorInfoImpl;
}();

var PhoneMultiFactorInfoImpl =
/*#__PURE__*/
function (_MultiFactorInfoImpl) {
  _inherits3(PhoneMultiFactorInfoImpl, _MultiFactorInfoImpl);

  function PhoneMultiFactorInfoImpl(response) {
    var _this161;

    _classCallCheck3(this, PhoneMultiFactorInfoImpl);

    _this161 = _possibleConstructorReturn3(this, _getPrototypeOf4(PhoneMultiFactorInfoImpl).call(this, "phone", response));
    _this161.phoneNumber = response.phoneInfo;
    return _this161;
  }

  _createClass3(PhoneMultiFactorInfoImpl, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(_auth, enrollment) {
      return new PhoneMultiFactorInfoImpl(enrollment);
    }
  }]);

  return PhoneMultiFactorInfoImpl;
}(MultiFactorInfoImpl);

var TotpMultiFactorInfoImpl =
/*#__PURE__*/
function (_MultiFactorInfoImpl2) {
  _inherits3(TotpMultiFactorInfoImpl, _MultiFactorInfoImpl2);

  function TotpMultiFactorInfoImpl(response) {
    _classCallCheck3(this, TotpMultiFactorInfoImpl);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(TotpMultiFactorInfoImpl).call(this, "totp", response));
  }

  _createClass3(TotpMultiFactorInfoImpl, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(_auth, enrollment) {
      return new TotpMultiFactorInfoImpl(enrollment);
    }
  }]);

  return TotpMultiFactorInfoImpl;
}(MultiFactorInfoImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _setActionCodeSettingsOnRequest(auth, request2, actionCodeSettings) {
  var _a2;

  _assert$4(((_a2 = actionCodeSettings.url) === null || _a2 === void 0 ? void 0 : _a2.length) > 0, auth, "invalid-continue-uri");

  _assert$4(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain");

  request2.continueUrl = actionCodeSettings.url;
  request2.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
  request2.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;

  if (actionCodeSettings.iOS) {
    _assert$4(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id");

    request2.iOSBundleId = actionCodeSettings.iOS.bundleId;
  }

  if (actionCodeSettings.android) {
    _assert$4(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name");

    request2.androidInstallApp = actionCodeSettings.android.installApp;
    request2.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
    request2.androidPackageName = actionCodeSettings.android.packageName;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _sendPasswordResetEmail2(_x1008, _x1009, _x1010) {
  return _sendPasswordResetEmail.apply(this, arguments);
}

function _sendPasswordResetEmail() {
  _sendPasswordResetEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee694(auth, email, actionCodeSettings) {
    var _a2, authInternal, request2, requestWithRecaptcha;

    return _regeneratorRuntime.wrap(function _callee694$(_context695) {
      while (1) {
        switch (_context695.prev = _context695.next) {
          case 0:
            authInternal = _castAuth(auth);
            request2 = {
              requestType: "PASSWORD_RESET",
              email: email,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!((_a2 = authInternal._getRecaptchaConfig()) === null || _a2 === void 0 ? void 0 : _a2.emailPasswordEnabled)) {
              _context695.next = 11;
              break;
            }

            _context695.next = 5;
            return injectRecaptchaFields(authInternal, request2, "getOobCode", true);

          case 5:
            requestWithRecaptcha = _context695.sent;

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
            }

            _context695.next = 9;
            return sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);

          case 9:
            _context695.next = 14;
            break;

          case 11:
            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(authInternal, request2, actionCodeSettings);
            }

            _context695.next = 14;
            return sendPasswordResetEmail$1(authInternal, request2).catch(
            /*#__PURE__*/
            function () {
              var _ref675 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee693(error) {
                var _requestWithRecaptcha2;

                return _regeneratorRuntime.wrap(function _callee693$(_context694) {
                  while (1) {
                    switch (_context694.prev = _context694.next) {
                      case 0:
                        if (!(error.code === "auth/".concat("missing-recaptcha-token"))) {
                          _context694.next = 10;
                          break;
                        }

                        console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                        _context694.next = 4;
                        return injectRecaptchaFields(authInternal, request2, "getOobCode", true);

                      case 4:
                        _requestWithRecaptcha2 = _context694.sent;

                        if (actionCodeSettings) {
                          _setActionCodeSettingsOnRequest(authInternal, _requestWithRecaptcha2, actionCodeSettings);
                        }

                        _context694.next = 8;
                        return sendPasswordResetEmail$1(authInternal, _requestWithRecaptcha2);

                      case 8:
                        _context694.next = 11;
                        break;

                      case 10:
                        return _context694.abrupt("return", Promise.reject(error));

                      case 11:
                      case "end":
                        return _context694.stop();
                    }
                  }
                }, _callee693);
              }));

              return function (_x1188) {
                return _ref675.apply(this, arguments);
              };
            }());

          case 14:
          case "end":
            return _context695.stop();
        }
      }
    }, _callee694);
  }));
  return _sendPasswordResetEmail.apply(this, arguments);
}

function _confirmPasswordReset2(_x1011, _x1012, _x1013) {
  return _confirmPasswordReset.apply(this, arguments);
}

function _confirmPasswordReset() {
  _confirmPasswordReset = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee695(auth, oobCode, newPassword) {
    return _regeneratorRuntime.wrap(function _callee695$(_context696) {
      while (1) {
        switch (_context696.prev = _context696.next) {
          case 0:
            _context696.next = 2;
            return resetPassword(getModularInstance(auth), {
              oobCode: oobCode,
              newPassword: newPassword
            });

          case 2:
          case "end":
            return _context696.stop();
        }
      }
    }, _callee695);
  }));
  return _confirmPasswordReset.apply(this, arguments);
}

function _applyActionCode2(_x1014, _x1015) {
  return _applyActionCode.apply(this, arguments);
}

function _applyActionCode() {
  _applyActionCode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee696(auth, oobCode) {
    return _regeneratorRuntime.wrap(function _callee696$(_context697) {
      while (1) {
        switch (_context697.prev = _context697.next) {
          case 0:
            _context697.next = 2;
            return applyActionCode$1(getModularInstance(auth), {
              oobCode: oobCode
            });

          case 2:
          case "end":
            return _context697.stop();
        }
      }
    }, _callee696);
  }));
  return _applyActionCode.apply(this, arguments);
}

function _checkActionCode2(_x1016, _x1017) {
  return _checkActionCode.apply(this, arguments);
}

function _checkActionCode() {
  _checkActionCode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee697(auth, oobCode) {
    var authModular, response, operation, multiFactorInfo;
    return _regeneratorRuntime.wrap(function _callee697$(_context698) {
      while (1) {
        switch (_context698.prev = _context698.next) {
          case 0:
            authModular = getModularInstance(auth);
            _context698.next = 3;
            return resetPassword(authModular, {
              oobCode: oobCode
            });

          case 3:
            response = _context698.sent;
            operation = response.requestType;

            _assert$4(operation, authModular, "internal-error");

            _context698.t0 = operation;
            _context698.next = _context698.t0 === "EMAIL_SIGNIN" ? 9 : _context698.t0 === "VERIFY_AND_CHANGE_EMAIL" ? 10 : _context698.t0 === "REVERT_SECOND_FACTOR_ADDITION" ? 12 : 13;
            break;

          case 9:
            return _context698.abrupt("break", 14);

          case 10:
            _assert$4(response.newEmail, authModular, "internal-error");

            return _context698.abrupt("break", 14);

          case 12:
            _assert$4(response.mfaInfo, authModular, "internal-error");

          case 13:
            _assert$4(response.email, authModular, "internal-error");

          case 14:
            multiFactorInfo = null;

            if (response.mfaInfo) {
              multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
            }

            return _context698.abrupt("return", {
              data: {
                email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" ? response.newEmail : response.email) || null,
                previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" ? response.email : response.newEmail) || null,
                multiFactorInfo: multiFactorInfo
              },
              operation: operation
            });

          case 17:
          case "end":
            return _context698.stop();
        }
      }
    }, _callee697);
  }));
  return _checkActionCode.apply(this, arguments);
}

function _verifyPasswordResetCode2(_x1018, _x1019) {
  return _verifyPasswordResetCode.apply(this, arguments);
}

function _verifyPasswordResetCode() {
  _verifyPasswordResetCode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee698(auth, code) {
    var _ref676, data2;

    return _regeneratorRuntime.wrap(function _callee698$(_context699) {
      while (1) {
        switch (_context699.prev = _context699.next) {
          case 0:
            _context699.next = 2;
            return _checkActionCode2(getModularInstance(auth), code);

          case 2:
            _ref676 = _context699.sent;
            data2 = _ref676.data;
            return _context699.abrupt("return", data2.email);

          case 5:
          case "end":
            return _context699.stop();
        }
      }
    }, _callee698);
  }));
  return _verifyPasswordResetCode.apply(this, arguments);
}

function _createUserWithEmailAndPassword2(_x1020, _x1021, _x1022) {
  return _createUserWithEmailAndPassword.apply(this, arguments);
}

function _createUserWithEmailAndPassword() {
  _createUserWithEmailAndPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee700(auth, email, password) {
    var _a2, authInternal, request2, signUpResponse, requestWithRecaptcha, response, userCredential;

    return _regeneratorRuntime.wrap(function _callee700$(_context701) {
      while (1) {
        switch (_context701.prev = _context701.next) {
          case 0:
            authInternal = _castAuth(auth);
            request2 = {
              returnSecureToken: true,
              email: email,
              password: password,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!((_a2 = authInternal._getRecaptchaConfig()) === null || _a2 === void 0 ? void 0 : _a2.emailPasswordEnabled)) {
              _context701.next = 9;
              break;
            }

            _context701.next = 5;
            return injectRecaptchaFields(authInternal, request2, "signUpPassword");

          case 5:
            requestWithRecaptcha = _context701.sent;
            signUpResponse = signUp(authInternal, requestWithRecaptcha);
            _context701.next = 10;
            break;

          case 9:
            signUpResponse = signUp(authInternal, request2).catch(
            /*#__PURE__*/
            function () {
              var _ref677 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee699(error) {
                var _requestWithRecaptcha3;

                return _regeneratorRuntime.wrap(function _callee699$(_context700) {
                  while (1) {
                    switch (_context700.prev = _context700.next) {
                      case 0:
                        if (!(error.code === "auth/".concat("missing-recaptcha-token"))) {
                          _context700.next = 8;
                          break;
                        }

                        console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
                        _context700.next = 4;
                        return injectRecaptchaFields(authInternal, request2, "signUpPassword");

                      case 4:
                        _requestWithRecaptcha3 = _context700.sent;
                        return _context700.abrupt("return", signUp(authInternal, _requestWithRecaptcha3));

                      case 8:
                        return _context700.abrupt("return", Promise.reject(error));

                      case 9:
                      case "end":
                        return _context700.stop();
                    }
                  }
                }, _callee699);
              }));

              return function (_x1189) {
                return _ref677.apply(this, arguments);
              };
            }());

          case 10:
            _context701.next = 12;
            return signUpResponse.catch(function (error) {
              return Promise.reject(error);
            });

          case 12:
            response = _context701.sent;
            _context701.next = 15;
            return UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn", response);

          case 15:
            userCredential = _context701.sent;
            _context701.next = 18;
            return authInternal._updateCurrentUser(userCredential.user);

          case 18:
            return _context701.abrupt("return", userCredential);

          case 19:
          case "end":
            return _context701.stop();
        }
      }
    }, _callee700);
  }));
  return _createUserWithEmailAndPassword.apply(this, arguments);
}

function _signInWithEmailAndPassword(auth, email, password) {
  return _signInWithCredential4(getModularInstance(auth), EmailAuthProvider.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _sendSignInLinkToEmail2(_x1023, _x1024, _x1025) {
  return _sendSignInLinkToEmail.apply(this, arguments);
}

function _sendSignInLinkToEmail() {
  _sendSignInLinkToEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee702(auth, email, actionCodeSettings) {
    var _a2, authInternal, request2, setActionCodeSettings, requestWithRecaptcha;

    return _regeneratorRuntime.wrap(function _callee702$(_context703) {
      while (1) {
        switch (_context703.prev = _context703.next) {
          case 0:
            setActionCodeSettings = function _ref679(request3, actionCodeSettings2) {
              _assert$4(actionCodeSettings2.handleCodeInApp, authInternal, "argument-error");

              if (actionCodeSettings2) {
                _setActionCodeSettingsOnRequest(authInternal, request3, actionCodeSettings2);
              }
            };

            authInternal = _castAuth(auth);
            request2 = {
              requestType: "EMAIL_SIGNIN",
              email: email,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!((_a2 = authInternal._getRecaptchaConfig()) === null || _a2 === void 0 ? void 0 : _a2.emailPasswordEnabled)) {
              _context703.next = 12;
              break;
            }

            _context703.next = 6;
            return injectRecaptchaFields(authInternal, request2, "getOobCode", true);

          case 6:
            requestWithRecaptcha = _context703.sent;
            setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
            _context703.next = 10;
            return sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);

          case 10:
            _context703.next = 15;
            break;

          case 12:
            setActionCodeSettings(request2, actionCodeSettings);
            _context703.next = 15;
            return sendSignInLinkToEmail$1(authInternal, request2).catch(
            /*#__PURE__*/
            function () {
              var _ref678 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee701(error) {
                var _requestWithRecaptcha4;

                return _regeneratorRuntime.wrap(function _callee701$(_context702) {
                  while (1) {
                    switch (_context702.prev = _context702.next) {
                      case 0:
                        if (!(error.code === "auth/".concat("missing-recaptcha-token"))) {
                          _context702.next = 10;
                          break;
                        }

                        console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        _context702.next = 4;
                        return injectRecaptchaFields(authInternal, request2, "getOobCode", true);

                      case 4:
                        _requestWithRecaptcha4 = _context702.sent;
                        setActionCodeSettings(_requestWithRecaptcha4, actionCodeSettings);
                        _context702.next = 8;
                        return sendSignInLinkToEmail$1(authInternal, _requestWithRecaptcha4);

                      case 8:
                        _context702.next = 11;
                        break;

                      case 10:
                        return _context702.abrupt("return", Promise.reject(error));

                      case 11:
                      case "end":
                        return _context702.stop();
                    }
                  }
                }, _callee701);
              }));

              return function (_x1190) {
                return _ref678.apply(this, arguments);
              };
            }());

          case 15:
          case "end":
            return _context703.stop();
        }
      }
    }, _callee702);
  }));
  return _sendSignInLinkToEmail.apply(this, arguments);
}

function _isSignInWithEmailLink(auth, emailLink) {
  var actionCodeUrl = ActionCodeURL.parseLink(emailLink);
  return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN";
}

function _signInWithEmailLink2(_x1026, _x1027, _x1028) {
  return _signInWithEmailLink.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithEmailLink() {
  _signInWithEmailLink = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee703(auth, email, emailLink) {
    var authModular, credential;
    return _regeneratorRuntime.wrap(function _callee703$(_context704) {
      while (1) {
        switch (_context704.prev = _context704.next) {
          case 0:
            authModular = getModularInstance(auth);
            credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());

            _assert$4(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch");

            return _context704.abrupt("return", _signInWithCredential4(authModular, credential));

          case 4:
          case "end":
            return _context704.stop();
        }
      }
    }, _callee703);
  }));
  return _signInWithEmailLink.apply(this, arguments);
}

function createAuthUri(_x1029, _x1030) {
  return _createAuthUri.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _createAuthUri() {
  _createAuthUri = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee704(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee704$(_context705) {
      while (1) {
        switch (_context705.prev = _context705.next) {
          case 0:
            return _context705.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:createAuthUri", _addTidIfNecessary(auth, request2)));

          case 1:
          case "end":
            return _context705.stop();
        }
      }
    }, _callee704);
  }));
  return _createAuthUri.apply(this, arguments);
}

function _fetchSignInMethodsForEmail2(_x1031, _x1032) {
  return _fetchSignInMethodsForEmail.apply(this, arguments);
}

function _fetchSignInMethodsForEmail() {
  _fetchSignInMethodsForEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee705(auth, email) {
    var continueUri, request2, _ref680, signinMethods;

    return _regeneratorRuntime.wrap(function _callee705$(_context706) {
      while (1) {
        switch (_context706.prev = _context706.next) {
          case 0:
            continueUri = _isHttpOrHttps$1() ? _getCurrentUrl() : "http://localhost";
            request2 = {
              identifier: email,
              continueUri: continueUri
            };
            _context706.next = 4;
            return createAuthUri(getModularInstance(auth), request2);

          case 4:
            _ref680 = _context706.sent;
            signinMethods = _ref680.signinMethods;
            return _context706.abrupt("return", signinMethods || []);

          case 7:
          case "end":
            return _context706.stop();
        }
      }
    }, _callee705);
  }));
  return _fetchSignInMethodsForEmail.apply(this, arguments);
}

function _sendEmailVerification2(_x1033, _x1034) {
  return _sendEmailVerification.apply(this, arguments);
}

function _sendEmailVerification() {
  _sendEmailVerification = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee706(user, actionCodeSettings) {
    var userInternal, idToken, request2, _ref681, email;

    return _regeneratorRuntime.wrap(function _callee706$(_context707) {
      while (1) {
        switch (_context707.prev = _context707.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context707.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context707.sent;
            request2 = {
              requestType: "VERIFY_EMAIL",
              idToken: idToken
            };

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(userInternal.auth, request2, actionCodeSettings);
            }

            _context707.next = 8;
            return sendEmailVerification$1(userInternal.auth, request2);

          case 8:
            _ref681 = _context707.sent;
            email = _ref681.email;

            if (!(email !== user.email)) {
              _context707.next = 13;
              break;
            }

            _context707.next = 13;
            return user.reload();

          case 13:
          case "end":
            return _context707.stop();
        }
      }
    }, _callee706);
  }));
  return _sendEmailVerification.apply(this, arguments);
}

function _verifyBeforeUpdateEmail2(_x1035, _x1036, _x1037) {
  return _verifyBeforeUpdateEmail.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _verifyBeforeUpdateEmail() {
  _verifyBeforeUpdateEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee707(user, newEmail, actionCodeSettings) {
    var userInternal, idToken, request2, _ref682, email;

    return _regeneratorRuntime.wrap(function _callee707$(_context708) {
      while (1) {
        switch (_context708.prev = _context708.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context708.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context708.sent;
            request2 = {
              requestType: "VERIFY_AND_CHANGE_EMAIL",
              idToken: idToken,
              newEmail: newEmail
            };

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(userInternal.auth, request2, actionCodeSettings);
            }

            _context708.next = 8;
            return verifyAndChangeEmail(userInternal.auth, request2);

          case 8:
            _ref682 = _context708.sent;
            email = _ref682.email;

            if (!(email !== user.email)) {
              _context708.next = 13;
              break;
            }

            _context708.next = 13;
            return user.reload();

          case 13:
          case "end":
            return _context708.stop();
        }
      }
    }, _callee707);
  }));
  return _verifyBeforeUpdateEmail.apply(this, arguments);
}

function updateProfile$1(_x1038, _x1039) {
  return _updateProfile$.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _updateProfile$() {
  _updateProfile$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee708(auth, request2) {
    return _regeneratorRuntime.wrap(function _callee708$(_context709) {
      while (1) {
        switch (_context709.prev = _context709.next) {
          case 0:
            return _context709.abrupt("return", _performApiRequest(auth, "POST", "/v1/accounts:update", request2));

          case 1:
          case "end":
            return _context709.stop();
        }
      }
    }, _callee708);
  }));
  return _updateProfile$.apply(this, arguments);
}

function _updateProfile2(_x1040, _x1041) {
  return _updateProfile.apply(this, arguments);
}

function _updateProfile() {
  _updateProfile = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee709(user, _ref583) {
    var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
    return _regeneratorRuntime.wrap(function _callee709$(_context710) {
      while (1) {
        switch (_context710.prev = _context710.next) {
          case 0:
            displayName = _ref583.displayName, photoUrl = _ref583.photoURL;

            if (!(displayName === void 0 && photoUrl === void 0)) {
              _context710.next = 3;
              break;
            }

            return _context710.abrupt("return");

          case 3:
            userInternal = getModularInstance(user);
            _context710.next = 6;
            return userInternal.getIdToken();

          case 6:
            idToken = _context710.sent;
            profileRequest = {
              idToken: idToken,
              displayName: displayName,
              photoUrl: photoUrl,
              returnSecureToken: true
            };
            _context710.next = 10;
            return _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));

          case 10:
            response = _context710.sent;
            userInternal.displayName = response.displayName || null;
            userInternal.photoURL = response.photoUrl || null;
            passwordProvider = userInternal.providerData.find(function (_ref683) {
              var providerId = _ref683.providerId;
              return providerId === "password";
            });

            if (passwordProvider) {
              passwordProvider.displayName = userInternal.displayName;
              passwordProvider.photoURL = userInternal.photoURL;
            }

            _context710.next = 17;
            return userInternal._updateTokensIfNecessary(response);

          case 17:
          case "end":
            return _context710.stop();
        }
      }
    }, _callee709);
  }));
  return _updateProfile.apply(this, arguments);
}

function _updateEmail(user, newEmail) {
  return updateEmailOrPassword(getModularInstance(user), newEmail, null);
}

function _updatePassword(user, newPassword) {
  return updateEmailOrPassword(getModularInstance(user), null, newPassword);
}

function updateEmailOrPassword(_x1042, _x1043, _x1044) {
  return _updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _updateEmailOrPassword() {
  _updateEmailOrPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee710(user, email, password) {
    var auth, idToken, request2, response;
    return _regeneratorRuntime.wrap(function _callee710$(_context711) {
      while (1) {
        switch (_context711.prev = _context711.next) {
          case 0:
            auth = user.auth;
            _context711.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context711.sent;
            request2 = {
              idToken: idToken,
              returnSecureToken: true
            };

            if (email) {
              request2.email = email;
            }

            if (password) {
              request2.password = password;
            }

            _context711.next = 9;
            return _logoutIfInvalidated(user, updateEmailPassword(auth, request2));

          case 9:
            response = _context711.sent;
            _context711.next = 12;
            return user._updateTokensIfNecessary(response, true);

          case 12:
          case "end":
            return _context711.stop();
        }
      }
    }, _callee710);
  }));
  return _updateEmailOrPassword.apply(this, arguments);
}

function _fromIdTokenResponse(idTokenResponse) {
  var _a2, _b;

  if (!idTokenResponse) {
    return null;
  }

  var providerId = idTokenResponse.providerId;
  var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
  var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse";

  if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
    var signInProvider = (_b = (_a2 = _parseToken(idTokenResponse.idToken)) === null || _a2 === void 0 ? void 0 : _a2.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];

    if (signInProvider) {
      var filteredProviderId = signInProvider !== "anonymous" && signInProvider !== "custom" ? signInProvider : null;
      return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
    }
  }

  if (!providerId) {
    return null;
  }

  switch (providerId) {
    case "facebook.com":
      return new FacebookAdditionalUserInfo(isNewUser, profile);

    case "github.com":
      return new GithubAdditionalUserInfo(isNewUser, profile);

    case "google.com":
      return new GoogleAdditionalUserInfo(isNewUser, profile);

    case "twitter.com":
      return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);

    case "custom":
    case "anonymous":
      return new GenericAdditionalUserInfo(isNewUser, null);

    default:
      return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
  }
}

var GenericAdditionalUserInfo = function GenericAdditionalUserInfo(isNewUser, providerId) {
  var profile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _classCallCheck3(this, GenericAdditionalUserInfo);

  this.isNewUser = isNewUser;
  this.providerId = providerId;
  this.profile = profile;
};

var FederatedAdditionalUserInfoWithUsername =
/*#__PURE__*/
function (_GenericAdditionalUse) {
  _inherits3(FederatedAdditionalUserInfoWithUsername, _GenericAdditionalUse);

  function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
    var _this162;

    _classCallCheck3(this, FederatedAdditionalUserInfoWithUsername);

    _this162 = _possibleConstructorReturn3(this, _getPrototypeOf4(FederatedAdditionalUserInfoWithUsername).call(this, isNewUser, providerId, profile));
    _this162.username = username;
    return _this162;
  }

  return FederatedAdditionalUserInfoWithUsername;
}(GenericAdditionalUserInfo);

var FacebookAdditionalUserInfo =
/*#__PURE__*/
function (_GenericAdditionalUse2) {
  _inherits3(FacebookAdditionalUserInfo, _GenericAdditionalUse2);

  function FacebookAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck3(this, FacebookAdditionalUserInfo);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(FacebookAdditionalUserInfo).call(this, isNewUser, "facebook.com", profile));
  }

  return FacebookAdditionalUserInfo;
}(GenericAdditionalUserInfo);

var GithubAdditionalUserInfo =
/*#__PURE__*/
function (_FederatedAdditionalU) {
  _inherits3(GithubAdditionalUserInfo, _FederatedAdditionalU);

  function GithubAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck3(this, GithubAdditionalUserInfo);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(GithubAdditionalUserInfo).call(this, isNewUser, "github.com", profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null));
  }

  return GithubAdditionalUserInfo;
}(FederatedAdditionalUserInfoWithUsername);

var GoogleAdditionalUserInfo =
/*#__PURE__*/
function (_GenericAdditionalUse3) {
  _inherits3(GoogleAdditionalUserInfo, _GenericAdditionalUse3);

  function GoogleAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck3(this, GoogleAdditionalUserInfo);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(GoogleAdditionalUserInfo).call(this, isNewUser, "google.com", profile));
  }

  return GoogleAdditionalUserInfo;
}(GenericAdditionalUserInfo);

var TwitterAdditionalUserInfo =
/*#__PURE__*/
function (_FederatedAdditionalU2) {
  _inherits3(TwitterAdditionalUserInfo, _FederatedAdditionalU2);

  function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
    _classCallCheck3(this, TwitterAdditionalUserInfo);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(TwitterAdditionalUserInfo).call(this, isNewUser, "twitter.com", profile, screenName));
  }

  return TwitterAdditionalUserInfo;
}(FederatedAdditionalUserInfoWithUsername);

function getAdditionalUserInfo(userCredential) {
  var user = userCredential.user,
      _tokenResponse = userCredential._tokenResponse;

  if (user.isAnonymous && !_tokenResponse) {
    return {
      providerId: null,
      isNewUser: false,
      profile: null
    };
  }

  return _fromIdTokenResponse(_tokenResponse);
}

function onIdTokenChanged(auth, nextOrObserver, error, completed) {
  return getModularInstance(auth).onIdTokenChanged(nextOrObserver, error, completed);
}

function beforeAuthStateChanged(auth, callback, onAbort) {
  return getModularInstance(auth).beforeAuthStateChanged(callback, onAbort);
}

var MultiFactorSessionImpl =
/*#__PURE__*/
function () {
  function MultiFactorSessionImpl(type, credential, auth) {
    _classCallCheck3(this, MultiFactorSessionImpl);

    this.type = type;
    this.credential = credential;
    this.auth = auth;
  }

  _createClass3(MultiFactorSessionImpl, [{
    key: "toJSON",
    value: function toJSON() {
      var key = this.type === "enroll" ? "idToken" : "pendingCredential";
      return {
        multiFactorSession: _defineProperty3({}, key, this.credential)
      };
    }
  }], [{
    key: "_fromIdtoken",
    value: function _fromIdtoken(idToken, auth) {
      return new MultiFactorSessionImpl("enroll", idToken, auth);
    }
  }, {
    key: "_fromMfaPendingCredential",
    value: function _fromMfaPendingCredential(mfaPendingCredential) {
      return new MultiFactorSessionImpl("signin", mfaPendingCredential);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(obj) {
      var _a2, _b;

      if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
        if ((_a2 = obj.multiFactorSession) === null || _a2 === void 0 ? void 0 : _a2.pendingCredential) {
          return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
        } else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) {
          return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
      }

      return null;
    }
  }]);

  return MultiFactorSessionImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var MultiFactorResolverImpl =
/*#__PURE__*/
function () {
  function MultiFactorResolverImpl(session, hints, signInResolver) {
    _classCallCheck3(this, MultiFactorResolverImpl);

    this.session = session;
    this.hints = hints;
    this.signInResolver = signInResolver;
  }

  _createClass3(MultiFactorResolverImpl, [{
    key: "resolveSignIn",
    value: function () {
      var _resolveSignIn = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee562(assertionExtern) {
        var assertion;
        return _regeneratorRuntime.wrap(function _callee562$(_context563) {
          while (1) {
            switch (_context563.prev = _context563.next) {
              case 0:
                assertion = assertionExtern;
                return _context563.abrupt("return", this.signInResolver(assertion));

              case 2:
              case "end":
                return _context563.stop();
            }
          }
        }, _callee562, this);
      }));

      function resolveSignIn(_x1045) {
        return _resolveSignIn.apply(this, arguments);
      }

      return resolveSignIn;
    }()
  }], [{
    key: "_fromError",
    value: function _fromError(authExtern, error) {
      var auth = _castAuth(authExtern);

      var serverResponse = error.customData._serverResponse;
      var hints = (serverResponse.mfaInfo || []).map(function (enrollment) {
        return MultiFactorInfoImpl._fromServerResponse(auth, enrollment);
      });

      _assert$4(serverResponse.mfaPendingCredential, auth, "internal-error");

      var session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);

      return new MultiFactorResolverImpl(session, hints,
      /*#__PURE__*/
      function () {
        var _ref584 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee563(assertion) {
          var mfaResponse, idTokenResponse, userCredential;
          return _regeneratorRuntime.wrap(function _callee563$(_context564) {
            while (1) {
              switch (_context564.prev = _context564.next) {
                case 0:
                  _context564.next = 2;
                  return assertion._process(auth, session);

                case 2:
                  mfaResponse = _context564.sent;
                  delete serverResponse.mfaInfo;
                  delete serverResponse.mfaPendingCredential;
                  idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                    idToken: mfaResponse.idToken,
                    refreshToken: mfaResponse.refreshToken
                  });
                  _context564.t0 = error.operationType;
                  _context564.next = _context564.t0 === "signIn" ? 9 : _context564.t0 === "reauthenticate" ? 15 : 17;
                  break;

                case 9:
                  _context564.next = 11;
                  return UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);

                case 11:
                  userCredential = _context564.sent;
                  _context564.next = 14;
                  return auth._updateCurrentUser(userCredential.user);

                case 14:
                  return _context564.abrupt("return", userCredential);

                case 15:
                  _assert$4(error.user, auth, "internal-error");

                  return _context564.abrupt("return", UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse));

                case 17:
                  _fail(auth, "internal-error");

                case 18:
                case "end":
                  return _context564.stop();
              }
            }
          }, _callee563);
        }));

        return function (_x1046) {
          return _ref584.apply(this, arguments);
        };
      }());
    }
  }]);

  return MultiFactorResolverImpl;
}();

function getMultiFactorResolver(auth, error) {
  var _a2;

  var authModular = getModularInstance(auth);
  var errorInternal = error;

  _assert$4(error.customData.operationType, authModular, "argument-error");

  _assert$4((_a2 = errorInternal.customData._serverResponse) === null || _a2 === void 0 ? void 0 : _a2.mfaPendingCredential, authModular, "argument-error");

  return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function startEnrollPhoneMfa(auth, request2) {
  return _performApiRequest(auth, "POST", "/v2/accounts/mfaEnrollment:start", _addTidIfNecessary(auth, request2));
}

function finalizeEnrollPhoneMfa(auth, request2) {
  return _performApiRequest(auth, "POST", "/v2/accounts/mfaEnrollment:finalize", _addTidIfNecessary(auth, request2));
}

function withdrawMfa(auth, request2) {
  return _performApiRequest(auth, "POST", "/v2/accounts/mfaEnrollment:withdraw", _addTidIfNecessary(auth, request2));
}

var MultiFactorUserImpl =
/*#__PURE__*/
function () {
  function MultiFactorUserImpl(user) {
    var _this163 = this;

    _classCallCheck3(this, MultiFactorUserImpl);

    this.user = user;
    this.enrolledFactors = [];

    user._onReload(function (userInfo) {
      if (userInfo.mfaInfo) {
        _this163.enrolledFactors = userInfo.mfaInfo.map(function (enrollment) {
          return MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment);
        });
      }
    });
  }

  _createClass3(MultiFactorUserImpl, [{
    key: "getSession",
    value: function () {
      var _getSession = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee564() {
        return _regeneratorRuntime.wrap(function _callee564$(_context565) {
          while (1) {
            switch (_context565.prev = _context565.next) {
              case 0:
                _context565.t0 = MultiFactorSessionImpl;
                _context565.next = 3;
                return this.user.getIdToken();

              case 3:
                _context565.t1 = _context565.sent;
                _context565.t2 = this.user.auth;
                return _context565.abrupt("return", _context565.t0._fromIdtoken.call(_context565.t0, _context565.t1, _context565.t2));

              case 6:
              case "end":
                return _context565.stop();
            }
          }
        }, _callee564, this);
      }));

      function getSession() {
        return _getSession.apply(this, arguments);
      }

      return getSession;
    }()
  }, {
    key: "enroll",
    value: function () {
      var _enroll = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee565(assertionExtern, displayName) {
        var assertion, session, finalizeMfaResponse;
        return _regeneratorRuntime.wrap(function _callee565$(_context566) {
          while (1) {
            switch (_context566.prev = _context566.next) {
              case 0:
                assertion = assertionExtern;
                _context566.next = 3;
                return this.getSession();

              case 3:
                session = _context566.sent;
                _context566.next = 6;
                return _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));

              case 6:
                finalizeMfaResponse = _context566.sent;
                _context566.next = 9;
                return this.user._updateTokensIfNecessary(finalizeMfaResponse);

              case 9:
                return _context566.abrupt("return", this.user.reload());

              case 10:
              case "end":
                return _context566.stop();
            }
          }
        }, _callee565, this);
      }));

      function enroll(_x1047, _x1048) {
        return _enroll.apply(this, arguments);
      }

      return enroll;
    }()
  }, {
    key: "unenroll",
    value: function () {
      var _unenroll = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee566(infoOrUid) {
        var mfaEnrollmentId, idToken, idTokenResponse;
        return _regeneratorRuntime.wrap(function _callee566$(_context567) {
          while (1) {
            switch (_context567.prev = _context567.next) {
              case 0:
                mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
                _context567.next = 3;
                return this.user.getIdToken();

              case 3:
                idToken = _context567.sent;
                _context567.prev = 4;
                _context567.next = 7;
                return _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
                  idToken: idToken,
                  mfaEnrollmentId: mfaEnrollmentId
                }));

              case 7:
                idTokenResponse = _context567.sent;
                this.enrolledFactors = this.enrolledFactors.filter(function (_ref585) {
                  var uid = _ref585.uid;
                  return uid !== mfaEnrollmentId;
                });
                _context567.next = 11;
                return this.user._updateTokensIfNecessary(idTokenResponse);

              case 11:
                _context567.next = 13;
                return this.user.reload();

              case 13:
                _context567.next = 18;
                break;

              case 15:
                _context567.prev = 15;
                _context567.t0 = _context567["catch"](4);
                throw _context567.t0;

              case 18:
              case "end":
                return _context567.stop();
            }
          }
        }, _callee566, this, [[4, 15]]);
      }));

      function unenroll(_x1049) {
        return _unenroll.apply(this, arguments);
      }

      return unenroll;
    }()
  }], [{
    key: "_fromUser",
    value: function _fromUser(user) {
      return new MultiFactorUserImpl(user);
    }
  }]);

  return MultiFactorUserImpl;
}();

var multiFactorUserCache =
/* @__PURE__ */
new WeakMap();

function multiFactor(user) {
  var userModular = getModularInstance(user);

  if (!multiFactorUserCache.has(userModular)) {
    multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
  }

  return multiFactorUserCache.get(userModular);
}

var STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var BrowserPersistenceClass =
/*#__PURE__*/
function () {
  function BrowserPersistenceClass(storageRetriever, type) {
    _classCallCheck3(this, BrowserPersistenceClass);

    this.storageRetriever = storageRetriever;
    this.type = type;
  }

  _createClass3(BrowserPersistenceClass, [{
    key: "_isAvailable",
    value: function _isAvailable() {
      try {
        if (!this.storage) {
          return Promise.resolve(false);
        }

        this.storage.setItem(STORAGE_AVAILABLE_KEY, "1");
        this.storage.removeItem(STORAGE_AVAILABLE_KEY);
        return Promise.resolve(true);
      } catch (_a2) {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "_set",
    value: function _set(key, value) {
      this.storage.setItem(key, JSON.stringify(value));
      return Promise.resolve();
    }
  }, {
    key: "_get",
    value: function _get(key) {
      var json = this.storage.getItem(key);
      return Promise.resolve(json ? JSON.parse(json) : null);
    }
  }, {
    key: "_remove",
    value: function _remove(key) {
      this.storage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: "storage",
    get: function get() {
      return this.storageRetriever();
    }
  }]);

  return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _iframeCannotSyncWebStorage() {
  var ua2 = getUA();
  return _isSafari(ua2) || _isIOS(ua2);
}

var _POLLING_INTERVAL_MS$1 = 1e3;
var IE10_LOCAL_STORAGE_SYNC_DELAY = 10;

var BrowserLocalPersistence =
/*#__PURE__*/
function (_BrowserPersistenceCl) {
  _inherits3(BrowserLocalPersistence, _BrowserPersistenceCl);

  function BrowserLocalPersistence() {
    var _this164;

    _classCallCheck3(this, BrowserLocalPersistence);

    _this164 = _possibleConstructorReturn3(this, _getPrototypeOf4(BrowserLocalPersistence).call(this, function () {
      return window.localStorage;
    }, "LOCAL"));

    _this164.boundEventHandler = function (event, poll) {
      return _this164.onStorageEvent(event, poll);
    };

    _this164.listeners = {};
    _this164.localCache = {};
    _this164.pollTimer = null;
    _this164.safariLocalStorageNotSynced = _iframeCannotSyncWebStorage() && _isIframe();
    _this164.fallbackToPolling = _isMobileBrowser();
    _this164._shouldAllowMigration = true;
    return _this164;
  }

  _createClass3(BrowserLocalPersistence, [{
    key: "forAllChangedKeys",
    value: function forAllChangedKeys(cb) {
      for (var _i62 = 0, _Object$keys3 = Object.keys(this.listeners); _i62 < _Object$keys3.length; _i62++) {
        var key = _Object$keys3[_i62];
        var newValue = this.storage.getItem(key);
        var oldValue = this.localCache[key];

        if (newValue !== oldValue) {
          cb(key, oldValue, newValue);
        }
      }
    }
  }, {
    key: "onStorageEvent",
    value: function onStorageEvent(event) {
      var _this165 = this;

      var poll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!event.key) {
        this.forAllChangedKeys(function (key2, _oldValue, newValue) {
          _this165.notifyListeners(key2, newValue);
        });
        return;
      }

      var key = event.key;

      if (poll) {
        this.detachListener();
      } else {
        this.stopPolling();
      }

      if (this.safariLocalStorageNotSynced) {
        var storedValue2 = this.storage.getItem(key);

        if (event.newValue !== storedValue2) {
          if (event.newValue !== null) {
            this.storage.setItem(key, event.newValue);
          } else {
            this.storage.removeItem(key);
          }
        } else if (this.localCache[key] === event.newValue && !poll) {
          return;
        }
      }

      var triggerListeners = function triggerListeners() {
        var storedValue2 = _this165.storage.getItem(key);

        if (!poll && _this165.localCache[key] === storedValue2) {
          return;
        }

        _this165.notifyListeners(key, storedValue2);
      };

      var storedValue = this.storage.getItem(key);

      if (_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) {
        setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
      } else {
        triggerListeners();
      }
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(key, value) {
      this.localCache[key] = value;
      var listeners = this.listeners[key];

      if (listeners) {
        for (var _i63 = 0, _Array$from = Array.from(listeners); _i63 < _Array$from.length; _i63++) {
          var listener = _Array$from[_i63];
          listener(value ? JSON.parse(value) : value);
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this166 = this;

      this.stopPolling();
      this.pollTimer = setInterval(function () {
        _this166.forAllChangedKeys(function (key, oldValue, newValue) {
          _this166.onStorageEvent(new StorageEvent("storage", {
            key: key,
            oldValue: oldValue,
            newValue: newValue
          }), true);
        });
      }, _POLLING_INTERVAL_MS$1);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      window.addEventListener("storage", this.boundEventHandler);
    }
  }, {
    key: "detachListener",
    value: function detachListener() {
      window.removeEventListener("storage", this.boundEventHandler);
    }
  }, {
    key: "_addListener",
    value: function _addListener(key, listener) {
      if (Object.keys(this.listeners).length === 0) {
        if (this.fallbackToPolling) {
          this.startPolling();
        } else {
          this.attachListener();
        }
      }

      if (!this.listeners[key]) {
        this.listeners[key] =
        /* @__PURE__ */
        new Set();
        this.localCache[key] = this.storage.getItem(key);
      }

      this.listeners[key].add(listener);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(key, listener) {
      if (this.listeners[key]) {
        this.listeners[key].delete(listener);

        if (this.listeners[key].size === 0) {
          delete this.listeners[key];
        }
      }

      if (Object.keys(this.listeners).length === 0) {
        this.detachListener();
        this.stopPolling();
      }
    }
  }, {
    key: "_set",
    value: function () {
      var _set3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee567(key, value) {
        return _regeneratorRuntime.wrap(function _callee567$(_context568) {
          while (1) {
            switch (_context568.prev = _context568.next) {
              case 0:
                _context568.next = 2;
                return _get2(_getPrototypeOf4(BrowserLocalPersistence.prototype), "_set", this).call(this, key, value);

              case 2:
                this.localCache[key] = JSON.stringify(value);

              case 3:
              case "end":
                return _context568.stop();
            }
          }
        }, _callee567, this);
      }));

      function _set(_x1050, _x1051) {
        return _set3.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee568(key) {
        var value;
        return _regeneratorRuntime.wrap(function _callee568$(_context569) {
          while (1) {
            switch (_context569.prev = _context569.next) {
              case 0:
                _context569.next = 2;
                return _get2(_getPrototypeOf4(BrowserLocalPersistence.prototype), "_get", this).call(this, key);

              case 2:
                value = _context569.sent;
                this.localCache[key] = JSON.stringify(value);
                return _context569.abrupt("return", value);

              case 5:
              case "end":
                return _context569.stop();
            }
          }
        }, _callee568, this);
      }));

      function _get(_x1052) {
        return _get4.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee569(key) {
        return _regeneratorRuntime.wrap(function _callee569$(_context570) {
          while (1) {
            switch (_context570.prev = _context570.next) {
              case 0:
                _context570.next = 2;
                return _get2(_getPrototypeOf4(BrowserLocalPersistence.prototype), "_remove", this).call(this, key);

              case 2:
                delete this.localCache[key];

              case 3:
              case "end":
                return _context570.stop();
            }
          }
        }, _callee569, this);
      }));

      function _remove(_x1053) {
        return _remove3.apply(this, arguments);
      }

      return _remove;
    }()
  }]);

  return BrowserLocalPersistence;
}(BrowserPersistenceClass);

BrowserLocalPersistence.type = "LOCAL";
var browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var BrowserSessionPersistence =
/*#__PURE__*/
function (_BrowserPersistenceCl2) {
  _inherits3(BrowserSessionPersistence, _BrowserPersistenceCl2);

  function BrowserSessionPersistence() {
    _classCallCheck3(this, BrowserSessionPersistence);

    return _possibleConstructorReturn3(this, _getPrototypeOf4(BrowserSessionPersistence).call(this, function () {
      return window.sessionStorage;
    }, "SESSION"));
  }

  _createClass3(BrowserSessionPersistence, [{
    key: "_addListener",
    value: function _addListener(_key, _listener) {
      return;
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(_key, _listener) {
      return;
    }
  }]);

  return BrowserSessionPersistence;
}(BrowserPersistenceClass);

BrowserSessionPersistence.type = "SESSION";
var browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _allSettled(promises) {
  return Promise.all(promises.map(
  /*#__PURE__*/
  function () {
    var _ref586 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee570(promise) {
      var value;
      return _regeneratorRuntime.wrap(function _callee570$(_context571) {
        while (1) {
          switch (_context571.prev = _context571.next) {
            case 0:
              _context571.prev = 0;
              _context571.next = 3;
              return promise;

            case 3:
              value = _context571.sent;
              return _context571.abrupt("return", {
                fulfilled: true,
                value: value
              });

            case 7:
              _context571.prev = 7;
              _context571.t0 = _context571["catch"](0);
              return _context571.abrupt("return", {
                fulfilled: false,
                reason: _context571.t0
              });

            case 10:
            case "end":
              return _context571.stop();
          }
        }
      }, _callee570, null, [[0, 7]]);
    }));

    return function (_x1054) {
      return _ref586.apply(this, arguments);
    };
  }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Receiver =
/*#__PURE__*/
function () {
  function Receiver(eventTarget) {
    _classCallCheck3(this, Receiver);

    this.eventTarget = eventTarget;
    this.handlersMap = {};
    this.boundEventHandler = this.handleEvent.bind(this);
  }

  _createClass3(Receiver, [{
    key: "isListeningto",
    value: function isListeningto(eventTarget) {
      return this.eventTarget === eventTarget;
    }
  }, {
    key: "handleEvent",
    value: function () {
      var _handleEvent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee572(event) {
        var messageEvent, _messageEvent$data, eventId, eventType, data2, handlers, promises, response;

        return _regeneratorRuntime.wrap(function _callee572$(_context573) {
          while (1) {
            switch (_context573.prev = _context573.next) {
              case 0:
                messageEvent = event;
                _messageEvent$data = messageEvent.data, eventId = _messageEvent$data.eventId, eventType = _messageEvent$data.eventType, data2 = _messageEvent$data.data;
                handlers = this.handlersMap[eventType];

                if (handlers === null || handlers === void 0 ? void 0 : handlers.size) {
                  _context573.next = 5;
                  break;
                }

                return _context573.abrupt("return");

              case 5:
                messageEvent.ports[0].postMessage({
                  status: "ack",
                  eventId: eventId,
                  eventType: eventType
                });
                promises = Array.from(handlers).map(
                /*#__PURE__*/
                function () {
                  var _ref587 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee571(handler) {
                    return _regeneratorRuntime.wrap(function _callee571$(_context572) {
                      while (1) {
                        switch (_context572.prev = _context572.next) {
                          case 0:
                            return _context572.abrupt("return", handler(messageEvent.origin, data2));

                          case 1:
                          case "end":
                            return _context572.stop();
                        }
                      }
                    }, _callee571);
                  }));

                  return function (_x1056) {
                    return _ref587.apply(this, arguments);
                  };
                }());
                _context573.next = 9;
                return _allSettled(promises);

              case 9:
                response = _context573.sent;
                messageEvent.ports[0].postMessage({
                  status: "done",
                  eventId: eventId,
                  eventType: eventType,
                  response: response
                });

              case 11:
              case "end":
                return _context573.stop();
            }
          }
        }, _callee572, this);
      }));

      function handleEvent(_x1055) {
        return _handleEvent.apply(this, arguments);
      }

      return handleEvent;
    }()
  }, {
    key: "_subscribe",
    value: function _subscribe(eventType, eventHandler) {
      if (Object.keys(this.handlersMap).length === 0) {
        this.eventTarget.addEventListener("message", this.boundEventHandler);
      }

      if (!this.handlersMap[eventType]) {
        this.handlersMap[eventType] =
        /* @__PURE__ */
        new Set();
      }

      this.handlersMap[eventType].add(eventHandler);
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(eventType, eventHandler) {
      if (this.handlersMap[eventType] && eventHandler) {
        this.handlersMap[eventType].delete(eventHandler);
      }

      if (!eventHandler || this.handlersMap[eventType].size === 0) {
        delete this.handlersMap[eventType];
      }

      if (Object.keys(this.handlersMap).length === 0) {
        this.eventTarget.removeEventListener("message", this.boundEventHandler);
      }
    }
  }], [{
    key: "_getInstance",
    value: function _getInstance(eventTarget) {
      var existingInstance = this.receivers.find(function (receiver) {
        return receiver.isListeningto(eventTarget);
      });

      if (existingInstance) {
        return existingInstance;
      }

      var newInstance = new Receiver(eventTarget);
      this.receivers.push(newInstance);
      return newInstance;
    }
  }]);

  return Receiver;
}();

Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _generateEventId() {
  var prefix2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var random = "";

  for (var _i64 = 0; _i64 < digits; _i64++) {
    random += Math.floor(Math.random() * 10);
  }

  return prefix2 + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Sender =
/*#__PURE__*/
function () {
  function Sender(target) {
    _classCallCheck3(this, Sender);

    this.target = target;
    this.handlers =
    /* @__PURE__ */
    new Set();
  }

  _createClass3(Sender, [{
    key: "removeMessageHandler",
    value: function removeMessageHandler(handler) {
      if (handler.messageChannel) {
        handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
        handler.messageChannel.port1.close();
      }

      this.handlers.delete(handler);
    }
  }, {
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee573(eventType, data2) {
        var _this167 = this;

        var timeout,
            messageChannel,
            completionTimer,
            handler,
            _args574 = arguments;
        return _regeneratorRuntime.wrap(function _callee573$(_context574) {
          while (1) {
            switch (_context574.prev = _context574.next) {
              case 0:
                timeout = _args574.length > 2 && _args574[2] !== undefined ? _args574[2] : 50;
                messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;

                if (messageChannel) {
                  _context574.next = 4;
                  break;
                }

                throw new Error("connection_unavailable");

              case 4:
                return _context574.abrupt("return", new Promise(function (resolve, reject) {
                  var eventId = _generateEventId("", 20);

                  messageChannel.port1.start();
                  var ackTimer = setTimeout(function () {
                    reject(new Error("unsupported_event"));
                  }, timeout);
                  handler = {
                    messageChannel: messageChannel,
                    onMessage: function onMessage(event) {
                      var messageEvent = event;

                      if (messageEvent.data.eventId !== eventId) {
                        return;
                      }

                      switch (messageEvent.data.status) {
                        case "ack":
                          clearTimeout(ackTimer);
                          completionTimer = setTimeout(function () {
                            reject(new Error("timeout"));
                          }, 3e3);
                          break;

                        case "done":
                          clearTimeout(completionTimer);
                          resolve(messageEvent.data.response);
                          break;

                        default:
                          clearTimeout(ackTimer);
                          clearTimeout(completionTimer);
                          reject(new Error("invalid_response"));
                          break;
                      }
                    }
                  };

                  _this167.handlers.add(handler);

                  messageChannel.port1.addEventListener("message", handler.onMessage);

                  _this167.target.postMessage({
                    eventType: eventType,
                    eventId: eventId,
                    data: data2
                  }, [messageChannel.port2]);
                }).finally(function () {
                  if (handler) {
                    _this167.removeMessageHandler(handler);
                  }
                }));

              case 5:
              case "end":
                return _context574.stop();
            }
          }
        }, _callee573);
      }));

      function _send(_x1057, _x1058) {
        return _send2.apply(this, arguments);
      }

      return _send;
    }()
  }]);

  return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _window() {
  return window;
}

function _setWindowLocation(url) {
  _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _isWorker$1() {
  return typeof _window()["WorkerGlobalScope"] !== "undefined" && typeof _window()["importScripts"] === "function";
}

function _getActiveServiceWorker() {
  return _getActiveServiceWorker2.apply(this, arguments);
}

function _getActiveServiceWorker2() {
  _getActiveServiceWorker2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee711() {
    var registration;
    return _regeneratorRuntime.wrap(function _callee711$(_context712) {
      while (1) {
        switch (_context712.prev = _context712.next) {
          case 0:
            if (navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) {
              _context712.next = 2;
              break;
            }

            return _context712.abrupt("return", null);

          case 2:
            _context712.prev = 2;
            _context712.next = 5;
            return navigator.serviceWorker.ready;

          case 5:
            registration = _context712.sent;
            return _context712.abrupt("return", registration.active);

          case 9:
            _context712.prev = 9;
            _context712.t0 = _context712["catch"](2);
            return _context712.abrupt("return", null);

          case 12:
          case "end":
            return _context712.stop();
        }
      }
    }, _callee711, null, [[2, 9]]);
  }));
  return _getActiveServiceWorker2.apply(this, arguments);
}

function _getServiceWorkerController() {
  var _a2;

  return ((_a2 = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a2 === void 0 ? void 0 : _a2.controller) || null;
}

function _getWorkerGlobalScope() {
  return _isWorker$1() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME = "firebaseLocalStorageDb";
var DB_VERSION = 1;
var DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
var DB_DATA_KEYPATH = "fbase_key";

var DBPromise =
/*#__PURE__*/
function () {
  function DBPromise(request2) {
    _classCallCheck3(this, DBPromise);

    this.request = request2;
  }

  _createClass3(DBPromise, [{
    key: "toPromise",
    value: function toPromise() {
      var _this168 = this;

      return new Promise(function (resolve, reject) {
        _this168.request.addEventListener("success", function () {
          resolve(_this168.request.result);
        });

        _this168.request.addEventListener("error", function () {
          reject(_this168.request.error);
        });
      });
    }
  }]);

  return DBPromise;
}();

function getObjectStore(db, isReadWrite) {
  return db.transaction([DB_OBJECTSTORE_NAME], isReadWrite ? "readwrite" : "readonly").objectStore(DB_OBJECTSTORE_NAME);
}

function _deleteDatabase() {
  var request2 = indexedDB.deleteDatabase(DB_NAME);
  return new DBPromise(request2).toPromise();
}

function _openDatabase() {
  var request2 = indexedDB.open(DB_NAME, DB_VERSION);
  return new Promise(function (resolve, reject) {
    request2.addEventListener("error", function () {
      reject(request2.error);
    });
    request2.addEventListener("upgradeneeded", function () {
      var db = request2.result;

      try {
        db.createObjectStore(DB_OBJECTSTORE_NAME, {
          keyPath: DB_DATA_KEYPATH
        });
      } catch (e2) {
        reject(e2);
      }
    });
    request2.addEventListener("success",
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee574() {
      var db;
      return _regeneratorRuntime.wrap(function _callee574$(_context575) {
        while (1) {
          switch (_context575.prev = _context575.next) {
            case 0:
              db = request2.result;

              if (db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                _context575.next = 12;
                break;
              }

              db.close();
              _context575.next = 5;
              return _deleteDatabase();

            case 5:
              _context575.t0 = resolve;
              _context575.next = 8;
              return _openDatabase();

            case 8:
              _context575.t1 = _context575.sent;
              (0, _context575.t0)(_context575.t1);
              _context575.next = 13;
              break;

            case 12:
              resolve(db);

            case 13:
            case "end":
              return _context575.stop();
          }
        }
      }, _callee574);
    })));
  });
}

function _putObject(_x1059, _x1060, _x1061) {
  return _putObject2.apply(this, arguments);
}

function _putObject2() {
  _putObject2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee712(db, key, value) {
    var _getObjectStore$put;

    var request2;
    return _regeneratorRuntime.wrap(function _callee712$(_context713) {
      while (1) {
        switch (_context713.prev = _context713.next) {
          case 0:
            request2 = getObjectStore(db, true).put((_getObjectStore$put = {}, _defineProperty3(_getObjectStore$put, DB_DATA_KEYPATH, key), _defineProperty3(_getObjectStore$put, "value", value), _getObjectStore$put));
            return _context713.abrupt("return", new DBPromise(request2).toPromise());

          case 2:
          case "end":
            return _context713.stop();
        }
      }
    }, _callee712);
  }));
  return _putObject2.apply(this, arguments);
}

function getObject(_x1062, _x1063) {
  return _getObject.apply(this, arguments);
}

function _getObject() {
  _getObject = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee713(db, key) {
    var request2, data2;
    return _regeneratorRuntime.wrap(function _callee713$(_context714) {
      while (1) {
        switch (_context714.prev = _context714.next) {
          case 0:
            request2 = getObjectStore(db, false).get(key);
            _context714.next = 3;
            return new DBPromise(request2).toPromise();

          case 3:
            data2 = _context714.sent;
            return _context714.abrupt("return", data2 === void 0 ? null : data2.value);

          case 5:
          case "end":
            return _context714.stop();
        }
      }
    }, _callee713);
  }));
  return _getObject.apply(this, arguments);
}

function _deleteObject(db, key) {
  var request2 = getObjectStore(db, true).delete(key);
  return new DBPromise(request2).toPromise();
}

var _POLLING_INTERVAL_MS = 800;
var _TRANSACTION_RETRY_COUNT = 3;

var IndexedDBLocalPersistence =
/*#__PURE__*/
function () {
  function IndexedDBLocalPersistence() {
    _classCallCheck3(this, IndexedDBLocalPersistence);

    this.type = "LOCAL";
    this._shouldAllowMigration = true;
    this.listeners = {};
    this.localCache = {};
    this.pollTimer = null;
    this.pendingWrites = 0;
    this.receiver = null;
    this.sender = null;
    this.serviceWorkerReceiverAvailable = false;
    this.activeServiceWorker = null;
    this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function () {}, function () {});
  }

  _createClass3(IndexedDBLocalPersistence, [{
    key: "_openDb",
    value: function () {
      var _openDb2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee575() {
        return _regeneratorRuntime.wrap(function _callee575$(_context576) {
          while (1) {
            switch (_context576.prev = _context576.next) {
              case 0:
                if (!this.db) {
                  _context576.next = 2;
                  break;
                }

                return _context576.abrupt("return", this.db);

              case 2:
                _context576.next = 4;
                return _openDatabase();

              case 4:
                this.db = _context576.sent;
                return _context576.abrupt("return", this.db);

              case 6:
              case "end":
                return _context576.stop();
            }
          }
        }, _callee575, this);
      }));

      function _openDb() {
        return _openDb2.apply(this, arguments);
      }

      return _openDb;
    }()
  }, {
    key: "_withRetries",
    value: function () {
      var _withRetries2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee576(op) {
        var numAttempts, db;
        return _regeneratorRuntime.wrap(function _callee576$(_context577) {
          while (1) {
            switch (_context577.prev = _context577.next) {
              case 0:
                numAttempts = 0;

              case 1:
                if (!true) {
                  _context577.next = 18;
                  break;
                }

                _context577.prev = 2;
                _context577.next = 5;
                return this._openDb();

              case 5:
                db = _context577.sent;
                _context577.next = 8;
                return op(db);

              case 8:
                return _context577.abrupt("return", _context577.sent);

              case 11:
                _context577.prev = 11;
                _context577.t0 = _context577["catch"](2);

                if (!(numAttempts++ > _TRANSACTION_RETRY_COUNT)) {
                  _context577.next = 15;
                  break;
                }

                throw _context577.t0;

              case 15:
                if (this.db) {
                  this.db.close();
                  this.db = void 0;
                }

              case 16:
                _context577.next = 1;
                break;

              case 18:
              case "end":
                return _context577.stop();
            }
          }
        }, _callee576, this, [[2, 11]]);
      }));

      function _withRetries(_x1064) {
        return _withRetries2.apply(this, arguments);
      }

      return _withRetries;
    }()
  }, {
    key: "initializeServiceWorkerMessaging",
    value: function () {
      var _initializeServiceWorkerMessaging = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee577() {
        return _regeneratorRuntime.wrap(function _callee577$(_context578) {
          while (1) {
            switch (_context578.prev = _context578.next) {
              case 0:
                return _context578.abrupt("return", _isWorker$1() ? this.initializeReceiver() : this.initializeSender());

              case 1:
              case "end":
                return _context578.stop();
            }
          }
        }, _callee577, this);
      }));

      function initializeServiceWorkerMessaging() {
        return _initializeServiceWorkerMessaging.apply(this, arguments);
      }

      return initializeServiceWorkerMessaging;
    }()
  }, {
    key: "initializeReceiver",
    value: function () {
      var _initializeReceiver = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee580() {
        var _this169 = this;

        return _regeneratorRuntime.wrap(function _callee580$(_context581) {
          while (1) {
            switch (_context581.prev = _context581.next) {
              case 0:
                this.receiver = Receiver._getInstance(_getWorkerGlobalScope());

                this.receiver._subscribe("keyChanged",
                /*#__PURE__*/
                function () {
                  var _ref589 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee578(_origin, data2) {
                    var keys2;
                    return _regeneratorRuntime.wrap(function _callee578$(_context579) {
                      while (1) {
                        switch (_context579.prev = _context579.next) {
                          case 0:
                            _context579.next = 2;
                            return _this169._poll();

                          case 2:
                            keys2 = _context579.sent;
                            return _context579.abrupt("return", {
                              keyProcessed: keys2.includes(data2.key)
                            });

                          case 4:
                          case "end":
                            return _context579.stop();
                        }
                      }
                    }, _callee578);
                  }));

                  return function (_x1065, _x1066) {
                    return _ref589.apply(this, arguments);
                  };
                }());

                this.receiver._subscribe("ping",
                /*#__PURE__*/
                function () {
                  var _ref590 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee579(_origin, _data) {
                    return _regeneratorRuntime.wrap(function _callee579$(_context580) {
                      while (1) {
                        switch (_context580.prev = _context580.next) {
                          case 0:
                            return _context580.abrupt("return", ["keyChanged"]);

                          case 1:
                          case "end":
                            return _context580.stop();
                        }
                      }
                    }, _callee579);
                  }));

                  return function (_x1067, _x1068) {
                    return _ref590.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context581.stop();
            }
          }
        }, _callee580, this);
      }));

      function initializeReceiver() {
        return _initializeReceiver.apply(this, arguments);
      }

      return initializeReceiver;
    }()
  }, {
    key: "initializeSender",
    value: function () {
      var _initializeSender = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee581() {
        var _a2, _b, results;

        return _regeneratorRuntime.wrap(function _callee581$(_context582) {
          while (1) {
            switch (_context582.prev = _context582.next) {
              case 0:
                _context582.next = 2;
                return _getActiveServiceWorker();

              case 2:
                this.activeServiceWorker = _context582.sent;

                if (this.activeServiceWorker) {
                  _context582.next = 5;
                  break;
                }

                return _context582.abrupt("return");

              case 5:
                this.sender = new Sender(this.activeServiceWorker);
                _context582.next = 8;
                return this.sender._send("ping", {}, 800);

              case 8:
                results = _context582.sent;

                if (results) {
                  _context582.next = 11;
                  break;
                }

                return _context582.abrupt("return");

              case 11:
                if (((_a2 = results[0]) === null || _a2 === void 0 ? void 0 : _a2.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged"))) {
                  this.serviceWorkerReceiverAvailable = true;
                }

              case 12:
              case "end":
                return _context582.stop();
            }
          }
        }, _callee581, this);
      }));

      function initializeSender() {
        return _initializeSender.apply(this, arguments);
      }

      return initializeSender;
    }()
  }, {
    key: "notifyServiceWorker",
    value: function () {
      var _notifyServiceWorker = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee582(key) {
        return _regeneratorRuntime.wrap(function _callee582$(_context583) {
          while (1) {
            switch (_context583.prev = _context583.next) {
              case 0:
                if (!(!this.sender || !this.activeServiceWorker || _getServiceWorkerController() !== this.activeServiceWorker)) {
                  _context583.next = 2;
                  break;
                }

                return _context583.abrupt("return");

              case 2:
                _context583.prev = 2;
                _context583.next = 5;
                return this.sender._send("keyChanged", {
                  key: key
                }, this.serviceWorkerReceiverAvailable ? 800 : 50);

              case 5:
                _context583.next = 9;
                break;

              case 7:
                _context583.prev = 7;
                _context583.t0 = _context583["catch"](2);

              case 9:
              case "end":
                return _context583.stop();
            }
          }
        }, _callee582, this, [[2, 7]]);
      }));

      function notifyServiceWorker(_x1069) {
        return _notifyServiceWorker.apply(this, arguments);
      }

      return notifyServiceWorker;
    }()
  }, {
    key: "_isAvailable",
    value: function () {
      var _isAvailable3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee583() {
        var db;
        return _regeneratorRuntime.wrap(function _callee583$(_context584) {
          while (1) {
            switch (_context584.prev = _context584.next) {
              case 0:
                _context584.prev = 0;

                if (indexedDB) {
                  _context584.next = 3;
                  break;
                }

                return _context584.abrupt("return", false);

              case 3:
                _context584.next = 5;
                return _openDatabase();

              case 5:
                db = _context584.sent;
                _context584.next = 8;
                return _putObject(db, STORAGE_AVAILABLE_KEY, "1");

              case 8:
                _context584.next = 10;
                return _deleteObject(db, STORAGE_AVAILABLE_KEY);

              case 10:
                return _context584.abrupt("return", true);

              case 13:
                _context584.prev = 13;
                _context584.t0 = _context584["catch"](0);

              case 15:
                return _context584.abrupt("return", false);

              case 16:
              case "end":
                return _context584.stop();
            }
          }
        }, _callee583, null, [[0, 13]]);
      }));

      function _isAvailable() {
        return _isAvailable3.apply(this, arguments);
      }

      return _isAvailable;
    }()
  }, {
    key: "_withPendingWrite",
    value: function () {
      var _withPendingWrite2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee584(write2) {
        return _regeneratorRuntime.wrap(function _callee584$(_context585) {
          while (1) {
            switch (_context585.prev = _context585.next) {
              case 0:
                this.pendingWrites++;
                _context585.prev = 1;
                _context585.next = 4;
                return write2();

              case 4:
                _context585.prev = 4;
                this.pendingWrites--;
                return _context585.finish(4);

              case 7:
              case "end":
                return _context585.stop();
            }
          }
        }, _callee584, this, [[1,, 4, 7]]);
      }));

      function _withPendingWrite(_x1070) {
        return _withPendingWrite2.apply(this, arguments);
      }

      return _withPendingWrite;
    }()
  }, {
    key: "_set",
    value: function () {
      var _set4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee586(key, value) {
        var _this170 = this;

        return _regeneratorRuntime.wrap(function _callee586$(_context587) {
          while (1) {
            switch (_context587.prev = _context587.next) {
              case 0:
                return _context587.abrupt("return", this._withPendingWrite(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee585() {
                  return _regeneratorRuntime.wrap(function _callee585$(_context586) {
                    while (1) {
                      switch (_context586.prev = _context586.next) {
                        case 0:
                          _context586.next = 2;
                          return _this170._withRetries(function (db) {
                            return _putObject(db, key, value);
                          });

                        case 2:
                          _this170.localCache[key] = value;
                          return _context586.abrupt("return", _this170.notifyServiceWorker(key));

                        case 4:
                        case "end":
                          return _context586.stop();
                      }
                    }
                  }, _callee585);
                }))));

              case 1:
              case "end":
                return _context587.stop();
            }
          }
        }, _callee586, this);
      }));

      function _set(_x1071, _x1072) {
        return _set4.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee587(key) {
        var obj;
        return _regeneratorRuntime.wrap(function _callee587$(_context588) {
          while (1) {
            switch (_context588.prev = _context588.next) {
              case 0:
                _context588.next = 2;
                return this._withRetries(function (db) {
                  return getObject(db, key);
                });

              case 2:
                obj = _context588.sent;
                this.localCache[key] = obj;
                return _context588.abrupt("return", obj);

              case 5:
              case "end":
                return _context588.stop();
            }
          }
        }, _callee587, this);
      }));

      function _get(_x1073) {
        return _get5.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee589(key) {
        var _this171 = this;

        return _regeneratorRuntime.wrap(function _callee589$(_context590) {
          while (1) {
            switch (_context590.prev = _context590.next) {
              case 0:
                return _context590.abrupt("return", this._withPendingWrite(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee588() {
                  return _regeneratorRuntime.wrap(function _callee588$(_context589) {
                    while (1) {
                      switch (_context589.prev = _context589.next) {
                        case 0:
                          _context589.next = 2;
                          return _this171._withRetries(function (db) {
                            return _deleteObject(db, key);
                          });

                        case 2:
                          delete _this171.localCache[key];
                          return _context589.abrupt("return", _this171.notifyServiceWorker(key));

                        case 4:
                        case "end":
                          return _context589.stop();
                      }
                    }
                  }, _callee588);
                }))));

              case 1:
              case "end":
                return _context590.stop();
            }
          }
        }, _callee589, this);
      }));

      function _remove(_x1074) {
        return _remove4.apply(this, arguments);
      }

      return _remove;
    }()
  }, {
    key: "_poll",
    value: function () {
      var _poll2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee590() {
        var result, keys2, keysInResult, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _ref594, key, value, _i65, _Object$keys4, localKey;

        return _regeneratorRuntime.wrap(function _callee590$(_context591) {
          while (1) {
            switch (_context591.prev = _context591.next) {
              case 0:
                _context591.next = 2;
                return this._withRetries(function (db) {
                  var getAllRequest = getObjectStore(db, false).getAll();
                  return new DBPromise(getAllRequest).toPromise();
                });

              case 2:
                result = _context591.sent;

                if (result) {
                  _context591.next = 5;
                  break;
                }

                return _context591.abrupt("return", []);

              case 5:
                if (!(this.pendingWrites !== 0)) {
                  _context591.next = 7;
                  break;
                }

                return _context591.abrupt("return", []);

              case 7:
                keys2 = [];
                keysInResult =
                /* @__PURE__ */
                new Set();
                _iteratorNormalCompletion24 = true;
                _didIteratorError24 = false;
                _iteratorError24 = undefined;
                _context591.prev = 12;

                for (_iterator24 = result[Symbol.iterator](); !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                  _ref594 = _step24.value;
                  key = _ref594.fbase_key;
                  value = _ref594.value;
                  keysInResult.add(key);

                  if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                    this.notifyListeners(key, value);
                    keys2.push(key);
                  }
                }

                _context591.next = 20;
                break;

              case 16:
                _context591.prev = 16;
                _context591.t0 = _context591["catch"](12);
                _didIteratorError24 = true;
                _iteratorError24 = _context591.t0;

              case 20:
                _context591.prev = 20;
                _context591.prev = 21;

                if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                  _iterator24.return();
                }

              case 23:
                _context591.prev = 23;

                if (!_didIteratorError24) {
                  _context591.next = 26;
                  break;
                }

                throw _iteratorError24;

              case 26:
                return _context591.finish(23);

              case 27:
                return _context591.finish(20);

              case 28:
                for (_i65 = 0, _Object$keys4 = Object.keys(this.localCache); _i65 < _Object$keys4.length; _i65++) {
                  localKey = _Object$keys4[_i65];

                  if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                    this.notifyListeners(localKey, null);
                    keys2.push(localKey);
                  }
                }

                return _context591.abrupt("return", keys2);

              case 30:
              case "end":
                return _context591.stop();
            }
          }
        }, _callee590, this, [[12, 16, 20, 28], [21,, 23, 27]]);
      }));

      function _poll() {
        return _poll2.apply(this, arguments);
      }

      return _poll;
    }()
  }, {
    key: "notifyListeners",
    value: function notifyListeners(key, newValue) {
      this.localCache[key] = newValue;
      var listeners = this.listeners[key];

      if (listeners) {
        for (var _i66 = 0, _Array$from2 = Array.from(listeners); _i66 < _Array$from2.length; _i66++) {
          var listener = _Array$from2[_i66];
          listener(newValue);
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this172 = this;

      this.stopPolling();
      this.pollTimer = setInterval(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee591() {
        return _regeneratorRuntime.wrap(function _callee591$(_context592) {
          while (1) {
            switch (_context592.prev = _context592.next) {
              case 0:
                return _context592.abrupt("return", _this172._poll());

              case 1:
              case "end":
                return _context592.stop();
            }
          }
        }, _callee591);
      })), _POLLING_INTERVAL_MS);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }
  }, {
    key: "_addListener",
    value: function _addListener(key, listener) {
      if (Object.keys(this.listeners).length === 0) {
        this.startPolling();
      }

      if (!this.listeners[key]) {
        this.listeners[key] =
        /* @__PURE__ */
        new Set();
        void this._get(key);
      }

      this.listeners[key].add(listener);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(key, listener) {
      if (this.listeners[key]) {
        this.listeners[key].delete(listener);

        if (this.listeners[key].size === 0) {
          delete this.listeners[key];
        }
      }

      if (Object.keys(this.listeners).length === 0) {
        this.stopPolling();
      }
    }
  }]);

  return IndexedDBLocalPersistence;
}();

IndexedDBLocalPersistence.type = "LOCAL";
var indexedDBLocalPersistence = IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function startSignInPhoneMfa(auth, request2) {
  return _performApiRequest(auth, "POST", "/v2/accounts/mfaSignIn:start", _addTidIfNecessary(auth, request2));
}

function finalizeSignInPhoneMfa(auth, request2) {
  return _performApiRequest(auth, "POST", "/v2/accounts/mfaSignIn:finalize", _addTidIfNecessary(auth, request2));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _SOLVE_TIME_MS = 500;
var _EXPIRATION_TIME_MS = 6e4;
var _WIDGET_ID_START = 1e12;

var MockReCaptcha =
/*#__PURE__*/
function () {
  function MockReCaptcha(auth) {
    _classCallCheck3(this, MockReCaptcha);

    this.auth = auth;
    this.counter = _WIDGET_ID_START;
    this._widgets =
    /* @__PURE__ */
    new Map();
  }

  _createClass3(MockReCaptcha, [{
    key: "render",
    value: function render(container, parameters) {
      var id = this.counter;

      this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));

      this.counter++;
      return id;
    }
  }, {
    key: "reset",
    value: function reset(optWidgetId) {
      var _a2;

      var id = optWidgetId || _WIDGET_ID_START;
      void ((_a2 = this._widgets.get(id)) === null || _a2 === void 0 ? void 0 : _a2.delete());

      this._widgets.delete(id);
    }
  }, {
    key: "getResponse",
    value: function getResponse(optWidgetId) {
      var _a2;

      var id = optWidgetId || _WIDGET_ID_START;
      return ((_a2 = this._widgets.get(id)) === null || _a2 === void 0 ? void 0 : _a2.getResponse()) || "";
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee592(optWidgetId) {
        var _a2, id;

        return _regeneratorRuntime.wrap(function _callee592$(_context593) {
          while (1) {
            switch (_context593.prev = _context593.next) {
              case 0:
                id = optWidgetId || _WIDGET_ID_START;
                void ((_a2 = this._widgets.get(id)) === null || _a2 === void 0 ? void 0 : _a2.execute());
                return _context593.abrupt("return", "");

              case 3:
              case "end":
                return _context593.stop();
            }
          }
        }, _callee592, this);
      }));

      function execute(_x1075) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return MockReCaptcha;
}();

var MockWidget =
/*#__PURE__*/
function () {
  function MockWidget(containerOrId, appName, params) {
    var _this173 = this;

    _classCallCheck3(this, MockWidget);

    this.params = params;
    this.timerId = null;
    this.deleted = false;
    this.responseToken = null;

    this.clickHandler = function () {
      _this173.execute();
    };

    var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;

    _assert$4(container, "argument-error", {
      appName: appName
    });

    this.container = container;
    this.isVisible = this.params.size !== "invisible";

    if (this.isVisible) {
      this.execute();
    } else {
      this.container.addEventListener("click", this.clickHandler);
    }
  }

  _createClass3(MockWidget, [{
    key: "getResponse",
    value: function getResponse() {
      this.checkIfDeleted();
      return this.responseToken;
    }
  }, {
    key: "delete",
    value: function _delete() {
      this.checkIfDeleted();
      this.deleted = true;

      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }

      this.container.removeEventListener("click", this.clickHandler);
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this174 = this;

      this.checkIfDeleted();

      if (this.timerId) {
        return;
      }

      this.timerId = window.setTimeout(function () {
        _this174.responseToken = generateRandomAlphaNumericString(50);
        var _this174$params = _this174.params,
            callback = _this174$params.callback,
            expiredCallback = _this174$params["expired-callback"];

        if (callback) {
          try {
            callback(_this174.responseToken);
          } catch (e2) {}
        }

        _this174.timerId = window.setTimeout(function () {
          _this174.timerId = null;
          _this174.responseToken = null;

          if (expiredCallback) {
            try {
              expiredCallback();
            } catch (e2) {}
          }

          if (_this174.isVisible) {
            _this174.execute();
          }
        }, _EXPIRATION_TIME_MS);
      }, _SOLVE_TIME_MS);
    }
  }, {
    key: "checkIfDeleted",
    value: function checkIfDeleted() {
      if (this.deleted) {
        throw new Error("reCAPTCHA mock was already deleted!");
      }
    }
  }]);

  return MockWidget;
}();

function generateRandomAlphaNumericString(len) {
  var chars = [];
  var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (var _i67 = 0; _i67 < len; _i67++) {
    chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
  }

  return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _JSLOAD_CALLBACK = _generateCallbackName("rcb");

var NETWORK_TIMEOUT_DELAY = new Delay(3e4, 6e4);
var RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";

var ReCaptchaLoaderImpl =
/*#__PURE__*/
function () {
  function ReCaptchaLoaderImpl() {
    _classCallCheck3(this, ReCaptchaLoaderImpl);

    var _a2;

    this.hostLanguage = "";
    this.counter = 0;
    this.librarySeparatelyLoaded = !!((_a2 = _window().grecaptcha) === null || _a2 === void 0 ? void 0 : _a2.render);
  }

  _createClass3(ReCaptchaLoaderImpl, [{
    key: "load",
    value: function load(auth) {
      var _this175 = this;

      var hl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      _assert$4(isHostLanguageValid(hl), auth, "argument-error");

      if (this.shouldResolveImmediately(hl) && isV2(_window().grecaptcha)) {
        return Promise.resolve(_window().grecaptcha);
      }

      return new Promise(function (resolve, reject) {
        var networkTimeout = _window().setTimeout(function () {
          reject(_createError(auth, "network-request-failed"));
        }, NETWORK_TIMEOUT_DELAY.get());

        _window()[_JSLOAD_CALLBACK] = function () {
          _window().clearTimeout(networkTimeout);

          delete _window()[_JSLOAD_CALLBACK];

          var recaptcha = _window().grecaptcha;

          if (!recaptcha || !isV2(recaptcha)) {
            reject(_createError(auth, "internal-error"));
            return;
          }

          var render2 = recaptcha.render;

          recaptcha.render = function (container, params) {
            var widgetId = render2(container, params);
            _this175.counter++;
            return widgetId;
          };

          _this175.hostLanguage = hl;
          resolve(recaptcha);
        };

        var url = "".concat(RECAPTCHA_BASE, "?").concat(querystring({
          onload: _JSLOAD_CALLBACK,
          render: "explicit",
          hl: hl
        }));

        _loadJS(url).catch(function () {
          clearTimeout(networkTimeout);
          reject(_createError(auth, "internal-error"));
        });
      });
    }
  }, {
    key: "clearedOneInstance",
    value: function clearedOneInstance() {
      this.counter--;
    }
  }, {
    key: "shouldResolveImmediately",
    value: function shouldResolveImmediately(hl) {
      var _a2;

      return !!((_a2 = _window().grecaptcha) === null || _a2 === void 0 ? void 0 : _a2.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
  }]);

  return ReCaptchaLoaderImpl;
}();

function isHostLanguageValid(hl) {
  return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}

var MockReCaptchaLoaderImpl =
/*#__PURE__*/
function () {
  function MockReCaptchaLoaderImpl() {
    _classCallCheck3(this, MockReCaptchaLoaderImpl);
  }

  _createClass3(MockReCaptchaLoaderImpl, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee593(auth) {
        return _regeneratorRuntime.wrap(function _callee593$(_context594) {
          while (1) {
            switch (_context594.prev = _context594.next) {
              case 0:
                return _context594.abrupt("return", new MockReCaptcha(auth));

              case 1:
              case "end":
                return _context594.stop();
            }
          }
        }, _callee593);
      }));

      function load(_x1076) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "clearedOneInstance",
    value: function clearedOneInstance() {}
  }]);

  return MockReCaptchaLoaderImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var RECAPTCHA_VERIFIER_TYPE = "recaptcha";
var DEFAULT_PARAMS = {
  theme: "light",
  type: "image"
};

var RecaptchaVerifier$1 =
/*#__PURE__*/
function () {
  function RecaptchaVerifier$1(containerOrId) {
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.assign({}, DEFAULT_PARAMS);
    var authExtern = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck3(this, RecaptchaVerifier$1);

    this.parameters = parameters;
    this.type = RECAPTCHA_VERIFIER_TYPE;
    this.destroyed = false;
    this.widgetId = null;
    this.tokenChangeListeners =
    /* @__PURE__ */
    new Set();
    this.renderPromise = null;
    this.recaptcha = null;
    this.auth = _castAuth(authExtern);
    this.isInvisible = this.parameters.size === "invisible";

    _assert$4(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment");

    var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;

    _assert$4(container, this.auth, "argument-error");

    this.container = container;
    this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
    this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new MockReCaptchaLoaderImpl() : new ReCaptchaLoaderImpl();
    this.validateStartingState();
  }

  _createClass3(RecaptchaVerifier$1, [{
    key: "verify",
    value: function () {
      var _verify2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee594() {
        var _this176 = this;

        var id, recaptcha, response;
        return _regeneratorRuntime.wrap(function _callee594$(_context595) {
          while (1) {
            switch (_context595.prev = _context595.next) {
              case 0:
                this.assertNotDestroyed();
                _context595.next = 3;
                return this.render();

              case 3:
                id = _context595.sent;
                recaptcha = this.getAssertedRecaptcha();
                response = recaptcha.getResponse(id);

                if (!response) {
                  _context595.next = 8;
                  break;
                }

                return _context595.abrupt("return", response);

              case 8:
                return _context595.abrupt("return", new Promise(function (resolve) {
                  var tokenChange = function tokenChange(token2) {
                    if (!token2) {
                      return;
                    }

                    _this176.tokenChangeListeners.delete(tokenChange);

                    resolve(token2);
                  };

                  _this176.tokenChangeListeners.add(tokenChange);

                  if (_this176.isInvisible) {
                    recaptcha.execute(id);
                  }
                }));

              case 9:
              case "end":
                return _context595.stop();
            }
          }
        }, _callee594, this);
      }));

      function verify() {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this177 = this;

      try {
        this.assertNotDestroyed();
      } catch (e2) {
        return Promise.reject(e2);
      }

      if (this.renderPromise) {
        return this.renderPromise;
      }

      this.renderPromise = this.makeRenderPromise().catch(function (e2) {
        _this177.renderPromise = null;
        throw e2;
      });
      return this.renderPromise;
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.assertNotDestroyed();

      if (this.widgetId !== null) {
        this.getAssertedRecaptcha().reset(this.widgetId);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this178 = this;

      this.assertNotDestroyed();
      this.destroyed = true;

      this._recaptchaLoader.clearedOneInstance();

      if (!this.isInvisible) {
        this.container.childNodes.forEach(function (node2) {
          _this178.container.removeChild(node2);
        });
      }
    }
  }, {
    key: "validateStartingState",
    value: function validateStartingState() {
      _assert$4(!this.parameters.sitekey, this.auth, "argument-error");

      _assert$4(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error");

      _assert$4(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment");
    }
  }, {
    key: "makeTokenCallback",
    value: function makeTokenCallback(existing) {
      var _this179 = this;

      return function (token2) {
        _this179.tokenChangeListeners.forEach(function (listener) {
          return listener(token2);
        });

        if (typeof existing === "function") {
          existing(token2);
        } else if (typeof existing === "string") {
          var globalFunc = _window()[existing];

          if (typeof globalFunc === "function") {
            globalFunc(token2);
          }
        }
      };
    }
  }, {
    key: "assertNotDestroyed",
    value: function assertNotDestroyed() {
      _assert$4(!this.destroyed, this.auth, "internal-error");
    }
  }, {
    key: "makeRenderPromise",
    value: function () {
      var _makeRenderPromise = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee595() {
        var container, guaranteedEmpty;
        return _regeneratorRuntime.wrap(function _callee595$(_context596) {
          while (1) {
            switch (_context596.prev = _context596.next) {
              case 0:
                _context596.next = 2;
                return this.init();

              case 2:
                if (!this.widgetId) {
                  container = this.container;

                  if (!this.isInvisible) {
                    guaranteedEmpty = document.createElement("div");
                    container.appendChild(guaranteedEmpty);
                    container = guaranteedEmpty;
                  }

                  this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
                }

                return _context596.abrupt("return", this.widgetId);

              case 4:
              case "end":
                return _context596.stop();
            }
          }
        }, _callee595, this);
      }));

      function makeRenderPromise() {
        return _makeRenderPromise.apply(this, arguments);
      }

      return makeRenderPromise;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee596() {
        var siteKey;
        return _regeneratorRuntime.wrap(function _callee596$(_context597) {
          while (1) {
            switch (_context597.prev = _context597.next) {
              case 0:
                _assert$4(_isHttpOrHttps$1() && !_isWorker$1(), this.auth, "internal-error");

                _context597.next = 3;
                return domReady();

              case 3:
                _context597.next = 5;
                return this._recaptchaLoader.load(this.auth, this.auth.languageCode || void 0);

              case 5:
                this.recaptcha = _context597.sent;
                _context597.next = 8;
                return getRecaptchaParams(this.auth);

              case 8:
                siteKey = _context597.sent;

                _assert$4(siteKey, this.auth, "internal-error");

                this.parameters.sitekey = siteKey;

              case 11:
              case "end":
                return _context597.stop();
            }
          }
        }, _callee596, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getAssertedRecaptcha",
    value: function getAssertedRecaptcha() {
      _assert$4(this.recaptcha, this.auth, "internal-error");

      return this.recaptcha;
    }
  }]);

  return RecaptchaVerifier$1;
}();

function domReady() {
  var resolver = null;
  return new Promise(function (resolve) {
    if (document.readyState === "complete") {
      resolve();
      return;
    }

    resolver = function resolver() {
      return resolve();
    };

    window.addEventListener("load", resolver);
  }).catch(function (e2) {
    if (resolver) {
      window.removeEventListener("load", resolver);
    }

    throw e2;
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ConfirmationResultImpl =
/*#__PURE__*/
function () {
  function ConfirmationResultImpl(verificationId, onConfirmation) {
    _classCallCheck3(this, ConfirmationResultImpl);

    this.verificationId = verificationId;
    this.onConfirmation = onConfirmation;
  }

  _createClass3(ConfirmationResultImpl, [{
    key: "confirm",
    value: function confirm(verificationCode) {
      var authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);

      return this.onConfirmation(authCredential);
    }
  }]);

  return ConfirmationResultImpl;
}();

function _signInWithPhoneNumber2(_x1077, _x1078, _x1079) {
  return _signInWithPhoneNumber.apply(this, arguments);
}

function _signInWithPhoneNumber() {
  _signInWithPhoneNumber = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee714(auth, phoneNumber, appVerifier) {
    var authInternal, verificationId;
    return _regeneratorRuntime.wrap(function _callee714$(_context715) {
      while (1) {
        switch (_context715.prev = _context715.next) {
          case 0:
            authInternal = _castAuth(auth);
            _context715.next = 3;
            return _verifyPhoneNumber(authInternal, phoneNumber, getModularInstance(appVerifier));

          case 3:
            verificationId = _context715.sent;
            return _context715.abrupt("return", new ConfirmationResultImpl(verificationId, function (cred) {
              return _signInWithCredential4(authInternal, cred);
            }));

          case 5:
          case "end":
            return _context715.stop();
        }
      }
    }, _callee714);
  }));
  return _signInWithPhoneNumber.apply(this, arguments);
}

function _linkWithPhoneNumber2(_x1080, _x1081, _x1082) {
  return _linkWithPhoneNumber.apply(this, arguments);
}

function _linkWithPhoneNumber() {
  _linkWithPhoneNumber = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee715(user, phoneNumber, appVerifier) {
    var userInternal, verificationId;
    return _regeneratorRuntime.wrap(function _callee715$(_context716) {
      while (1) {
        switch (_context716.prev = _context716.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context716.next = 3;
            return _assertLinkedStatus(false, userInternal, "phone");

          case 3:
            _context716.next = 5;
            return _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));

          case 5:
            verificationId = _context716.sent;
            return _context716.abrupt("return", new ConfirmationResultImpl(verificationId, function (cred) {
              return _linkWithCredential2(userInternal, cred);
            }));

          case 7:
          case "end":
            return _context716.stop();
        }
      }
    }, _callee715);
  }));
  return _linkWithPhoneNumber.apply(this, arguments);
}

function _reauthenticateWithPhoneNumber2(_x1083, _x1084, _x1085) {
  return _reauthenticateWithPhoneNumber.apply(this, arguments);
}

function _reauthenticateWithPhoneNumber() {
  _reauthenticateWithPhoneNumber = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee716(user, phoneNumber, appVerifier) {
    var userInternal, verificationId;
    return _regeneratorRuntime.wrap(function _callee716$(_context717) {
      while (1) {
        switch (_context717.prev = _context717.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context717.next = 3;
            return _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));

          case 3:
            verificationId = _context717.sent;
            return _context717.abrupt("return", new ConfirmationResultImpl(verificationId, function (cred) {
              return _reauthenticateWithCredential2(userInternal, cred);
            }));

          case 5:
          case "end":
            return _context717.stop();
        }
      }
    }, _callee716);
  }));
  return _reauthenticateWithPhoneNumber.apply(this, arguments);
}

function _verifyPhoneNumber(_x1086, _x1087, _x1088) {
  return _verifyPhoneNumber2.apply(this, arguments);
}

function _verifyPhoneNumber2() {
  _verifyPhoneNumber2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee717(auth, options2, verifier) {
    var _a2, recaptchaToken, phoneInfoOptions, session, response, mfaEnrollmentId, _response, _ref684, sessionInfo;

    return _regeneratorRuntime.wrap(function _callee717$(_context718) {
      while (1) {
        switch (_context718.prev = _context718.next) {
          case 0:
            _context718.next = 2;
            return verifier.verify();

          case 2:
            recaptchaToken = _context718.sent;
            _context718.prev = 3;

            _assert$4(typeof recaptchaToken === "string", auth, "argument-error");

            _assert$4(verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error");

            if (typeof options2 === "string") {
              phoneInfoOptions = {
                phoneNumber: options2
              };
            } else {
              phoneInfoOptions = options2;
            }

            if (!("session" in phoneInfoOptions)) {
              _context718.next = 26;
              break;
            }

            session = phoneInfoOptions.session;

            if (!("phoneNumber" in phoneInfoOptions)) {
              _context718.next = 17;
              break;
            }

            _assert$4(session.type === "enroll", auth, "internal-error");

            _context718.next = 13;
            return startEnrollPhoneMfa(auth, {
              idToken: session.credential,
              phoneEnrollmentInfo: {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
              }
            });

          case 13:
            response = _context718.sent;
            return _context718.abrupt("return", response.phoneSessionInfo.sessionInfo);

          case 17:
            _assert$4(session.type === "signin", auth, "internal-error");

            mfaEnrollmentId = ((_a2 = phoneInfoOptions.multiFactorHint) === null || _a2 === void 0 ? void 0 : _a2.uid) || phoneInfoOptions.multiFactorUid;

            _assert$4(mfaEnrollmentId, auth, "missing-multi-factor-info");

            _context718.next = 22;
            return startSignInPhoneMfa(auth, {
              mfaPendingCredential: session.credential,
              mfaEnrollmentId: mfaEnrollmentId,
              phoneSignInInfo: {
                recaptchaToken: recaptchaToken
              }
            });

          case 22:
            _response = _context718.sent;
            return _context718.abrupt("return", _response.phoneResponseInfo.sessionInfo);

          case 24:
            _context718.next = 31;
            break;

          case 26:
            _context718.next = 28;
            return sendPhoneVerificationCode(auth, {
              phoneNumber: phoneInfoOptions.phoneNumber,
              recaptchaToken: recaptchaToken
            });

          case 28:
            _ref684 = _context718.sent;
            sessionInfo = _ref684.sessionInfo;
            return _context718.abrupt("return", sessionInfo);

          case 31:
            _context718.prev = 31;

            verifier._reset();

            return _context718.finish(31);

          case 34:
          case "end":
            return _context718.stop();
        }
      }
    }, _callee717, null, [[3,, 31, 34]]);
  }));
  return _verifyPhoneNumber2.apply(this, arguments);
}

function _updatePhoneNumber2(_x1089, _x1090) {
  return _updatePhoneNumber.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _updatePhoneNumber() {
  _updatePhoneNumber = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee718(user, credential) {
    return _regeneratorRuntime.wrap(function _callee718$(_context719) {
      while (1) {
        switch (_context719.prev = _context719.next) {
          case 0:
            _context719.next = 2;
            return _link$1(getModularInstance(user), credential);

          case 2:
          case "end":
            return _context719.stop();
        }
      }
    }, _callee718);
  }));
  return _updatePhoneNumber.apply(this, arguments);
}

var PhoneAuthProvider$1 =
/*#__PURE__*/
function () {
  function PhoneAuthProvider$1(auth) {
    _classCallCheck3(this, PhoneAuthProvider$1);

    this.providerId = PhoneAuthProvider$1.PROVIDER_ID;
    this.auth = _castAuth(auth);
  }

  _createClass3(PhoneAuthProvider$1, [{
    key: "verifyPhoneNumber",
    value: function verifyPhoneNumber(phoneOptions, applicationVerifier) {
      return _verifyPhoneNumber(this.auth, phoneOptions, getModularInstance(applicationVerifier));
    }
  }], [{
    key: "credential",
    value: function credential(verificationId, verificationCode) {
      return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      var credential = userCredential;
      return PhoneAuthProvider$1.credentialFromTaggedObject(credential);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return PhoneAuthProvider$1.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref596) {
      var tokenResponse = _ref596._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var phoneNumber = tokenResponse.phoneNumber,
          temporaryProof = tokenResponse.temporaryProof;

      if (phoneNumber && temporaryProof) {
        return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
      }

      return null;
    }
  }]);

  return PhoneAuthProvider$1;
}();

PhoneAuthProvider$1.PROVIDER_ID = "phone";
PhoneAuthProvider$1.PHONE_SIGN_IN_METHOD = "phone";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _withDefaultResolver(auth, resolverOverride) {
  if (resolverOverride) {
    return _getInstance(resolverOverride);
  }

  _assert$4(auth._popupRedirectResolver, auth, "argument-error");

  return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var IdpCredential =
/*#__PURE__*/
function (_AuthCredential5) {
  _inherits3(IdpCredential, _AuthCredential5);

  function IdpCredential(params) {
    var _this180;

    _classCallCheck3(this, IdpCredential);

    _this180 = _possibleConstructorReturn3(this, _getPrototypeOf4(IdpCredential).call(this, "custom", "custom"));
    _this180.params = params;
    return _this180;
  }

  _createClass3(IdpCredential, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(auth) {
      return signInWithIdp(auth, this._buildIdpRequest());
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      return signInWithIdp(auth, this._buildIdpRequest());
    }
  }, {
    key: "_buildIdpRequest",
    value: function _buildIdpRequest(idToken) {
      var request2 = {
        requestUri: this.params.requestUri,
        sessionId: this.params.sessionId,
        postBody: this.params.postBody,
        tenantId: this.params.tenantId,
        pendingToken: this.params.pendingToken,
        returnSecureToken: true,
        returnIdpCredential: true
      };

      if (idToken) {
        request2.idToken = idToken;
      }

      return request2;
    }
  }]);

  return IdpCredential;
}(AuthCredential);

function _signIn(params) {
  return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}

function _reauth(params) {
  var auth = params.auth,
      user = params.user;

  _assert$4(user, auth, "internal-error");

  return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}

function _link(_x1091) {
  return _link3.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _link3() {
  _link3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee719(params) {
    var auth, user;
    return _regeneratorRuntime.wrap(function _callee719$(_context720) {
      while (1) {
        switch (_context720.prev = _context720.next) {
          case 0:
            auth = params.auth, user = params.user;

            _assert$4(user, auth, "internal-error");

            return _context720.abrupt("return", _link$1(user, new IdpCredential(params), params.bypassAuthState));

          case 3:
          case "end":
            return _context720.stop();
        }
      }
    }, _callee719);
  }));
  return _link3.apply(this, arguments);
}

var AbstractPopupRedirectOperation =
/*#__PURE__*/
function () {
  function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
    var bypassAuthState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck3(this, AbstractPopupRedirectOperation);

    this.auth = auth;
    this.resolver = resolver;
    this.user = user;
    this.bypassAuthState = bypassAuthState;
    this.pendingPromise = null;
    this.eventManager = null;
    this.filter = Array.isArray(filter) ? filter : [filter];
  }

  _createClass3(AbstractPopupRedirectOperation, [{
    key: "execute",
    value: function execute() {
      var _this181 = this;

      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref597 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee597(resolve, reject) {
          return _regeneratorRuntime.wrap(function _callee597$(_context598) {
            while (1) {
              switch (_context598.prev = _context598.next) {
                case 0:
                  _this181.pendingPromise = {
                    resolve: resolve,
                    reject: reject
                  };
                  _context598.prev = 1;
                  _context598.next = 4;
                  return _this181.resolver._initialize(_this181.auth);

                case 4:
                  _this181.eventManager = _context598.sent;
                  _context598.next = 7;
                  return _this181.onExecution();

                case 7:
                  _this181.eventManager.registerConsumer(_this181);

                  _context598.next = 13;
                  break;

                case 10:
                  _context598.prev = 10;
                  _context598.t0 = _context598["catch"](1);

                  _this181.reject(_context598.t0);

                case 13:
                case "end":
                  return _context598.stop();
              }
            }
          }, _callee597, null, [[1, 10]]);
        }));

        return function (_x1092, _x1093) {
          return _ref597.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "onAuthEvent",
    value: function () {
      var _onAuthEvent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee598(event) {
        var urlResponse, sessionId, postBody, tenantId, error, type, params;
        return _regeneratorRuntime.wrap(function _callee598$(_context599) {
          while (1) {
            switch (_context599.prev = _context599.next) {
              case 0:
                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;

                if (!error) {
                  _context599.next = 4;
                  break;
                }

                this.reject(error);
                return _context599.abrupt("return");

              case 4:
                params = {
                  auth: this.auth,
                  requestUri: urlResponse,
                  sessionId: sessionId,
                  tenantId: tenantId || void 0,
                  postBody: postBody || void 0,
                  user: this.user,
                  bypassAuthState: this.bypassAuthState
                };
                _context599.prev = 5;
                _context599.t0 = this;
                _context599.next = 9;
                return this.getIdpTask(type)(params);

              case 9:
                _context599.t1 = _context599.sent;

                _context599.t0.resolve.call(_context599.t0, _context599.t1);

                _context599.next = 16;
                break;

              case 13:
                _context599.prev = 13;
                _context599.t2 = _context599["catch"](5);
                this.reject(_context599.t2);

              case 16:
              case "end":
                return _context599.stop();
            }
          }
        }, _callee598, this, [[5, 13]]);
      }));

      function onAuthEvent(_x1094) {
        return _onAuthEvent.apply(this, arguments);
      }

      return onAuthEvent;
    }()
  }, {
    key: "onError",
    value: function onError(error) {
      this.reject(error);
    }
  }, {
    key: "getIdpTask",
    value: function getIdpTask(type) {
      switch (type) {
        case "signInViaPopup":
        case "signInViaRedirect":
          return _signIn;

        case "linkViaPopup":
        case "linkViaRedirect":
          return _link;

        case "reauthViaPopup":
        case "reauthViaRedirect":
          return _reauth;

        default:
          _fail(this.auth, "internal-error");

      }
    }
  }, {
    key: "resolve",
    value: function resolve(cred) {
      debugAssert(this.pendingPromise, "Pending promise was never set");
      this.pendingPromise.resolve(cred);
      this.unregisterAndCleanUp();
    }
  }, {
    key: "reject",
    value: function reject(error) {
      debugAssert(this.pendingPromise, "Pending promise was never set");
      this.pendingPromise.reject(error);
      this.unregisterAndCleanUp();
    }
  }, {
    key: "unregisterAndCleanUp",
    value: function unregisterAndCleanUp() {
      if (this.eventManager) {
        this.eventManager.unregisterConsumer(this);
      }

      this.pendingPromise = null;
      this.cleanUp();
    }
  }]);

  return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2e3, 1e4);

function _signInWithPopup2(_x1095, _x1096, _x1097) {
  return _signInWithPopup.apply(this, arguments);
}

function _signInWithPopup() {
  _signInWithPopup = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee720(auth, provider, resolver) {
    var authInternal, resolverInternal, action;
    return _regeneratorRuntime.wrap(function _callee720$(_context721) {
      while (1) {
        switch (_context721.prev = _context721.next) {
          case 0:
            authInternal = _castAuth(auth);

            _assertInstanceOf(auth, provider, FederatedAuthProvider);

            resolverInternal = _withDefaultResolver(authInternal, resolver);
            action = new PopupOperation(authInternal, "signInViaPopup", provider, resolverInternal);
            return _context721.abrupt("return", action.executeNotNull());

          case 5:
          case "end":
            return _context721.stop();
        }
      }
    }, _callee720);
  }));
  return _signInWithPopup.apply(this, arguments);
}

function _reauthenticateWithPopup2(_x1098, _x1099, _x1100) {
  return _reauthenticateWithPopup.apply(this, arguments);
}

function _reauthenticateWithPopup() {
  _reauthenticateWithPopup = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee721(user, provider, resolver) {
    var userInternal, resolverInternal, action;
    return _regeneratorRuntime.wrap(function _callee721$(_context722) {
      while (1) {
        switch (_context722.prev = _context722.next) {
          case 0:
            userInternal = getModularInstance(user);

            _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);

            resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
            action = new PopupOperation(userInternal.auth, "reauthViaPopup", provider, resolverInternal, userInternal);
            return _context722.abrupt("return", action.executeNotNull());

          case 5:
          case "end":
            return _context722.stop();
        }
      }
    }, _callee721);
  }));
  return _reauthenticateWithPopup.apply(this, arguments);
}

function _linkWithPopup2(_x1101, _x1102, _x1103) {
  return _linkWithPopup.apply(this, arguments);
}

function _linkWithPopup() {
  _linkWithPopup = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee722(user, provider, resolver) {
    var userInternal, resolverInternal, action;
    return _regeneratorRuntime.wrap(function _callee722$(_context723) {
      while (1) {
        switch (_context723.prev = _context723.next) {
          case 0:
            userInternal = getModularInstance(user);

            _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);

            resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
            action = new PopupOperation(userInternal.auth, "linkViaPopup", provider, resolverInternal, userInternal);
            return _context723.abrupt("return", action.executeNotNull());

          case 5:
          case "end":
            return _context723.stop();
        }
      }
    }, _callee722);
  }));
  return _linkWithPopup.apply(this, arguments);
}

var PopupOperation =
/*#__PURE__*/
function (_AbstractPopupRedirec) {
  _inherits3(PopupOperation, _AbstractPopupRedirec);

  function PopupOperation(auth, filter, provider, resolver, user) {
    var _this182;

    _classCallCheck3(this, PopupOperation);

    _this182 = _possibleConstructorReturn3(this, _getPrototypeOf4(PopupOperation).call(this, auth, filter, resolver, user));
    _this182.provider = provider;
    _this182.authWindow = null;
    _this182.pollId = null;

    if (PopupOperation.currentPopupAction) {
      PopupOperation.currentPopupAction.cancel();
    }

    PopupOperation.currentPopupAction = _assertThisInitialized3(_this182);
    return _this182;
  }

  _createClass3(PopupOperation, [{
    key: "executeNotNull",
    value: function () {
      var _executeNotNull = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee599() {
        var result;
        return _regeneratorRuntime.wrap(function _callee599$(_context600) {
          while (1) {
            switch (_context600.prev = _context600.next) {
              case 0:
                _context600.next = 2;
                return this.execute();

              case 2:
                result = _context600.sent;

                _assert$4(result, this.auth, "internal-error");

                return _context600.abrupt("return", result);

              case 5:
              case "end":
                return _context600.stop();
            }
          }
        }, _callee599, this);
      }));

      function executeNotNull() {
        return _executeNotNull.apply(this, arguments);
      }

      return executeNotNull;
    }()
  }, {
    key: "onExecution",
    value: function () {
      var _onExecution = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee600() {
        var _this183 = this;

        var eventId;
        return _regeneratorRuntime.wrap(function _callee600$(_context601) {
          while (1) {
            switch (_context601.prev = _context601.next) {
              case 0:
                debugAssert(this.filter.length === 1, "Popup operations only handle one event");
                eventId = _generateEventId();
                _context601.next = 4;
                return this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);

              case 4:
                this.authWindow = _context601.sent;
                this.authWindow.associatedEvent = eventId;

                this.resolver._originValidation(this.auth).catch(function (e2) {
                  _this183.reject(e2);
                });

                this.resolver._isIframeWebStorageSupported(this.auth, function (isSupported) {
                  if (!isSupported) {
                    _this183.reject(_createError(_this183.auth, "web-storage-unsupported"));
                  }
                });

                this.pollUserCancellation();

              case 9:
              case "end":
                return _context601.stop();
            }
          }
        }, _callee600, this);
      }));

      function onExecution() {
        return _onExecution.apply(this, arguments);
      }

      return onExecution;
    }()
  }, {
    key: "cancel",
    value: function cancel() {
      this.reject(_createError(this.auth, "cancelled-popup-request"));
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      if (this.authWindow) {
        this.authWindow.close();
      }

      if (this.pollId) {
        window.clearTimeout(this.pollId);
      }

      this.authWindow = null;
      this.pollId = null;
      PopupOperation.currentPopupAction = null;
    }
  }, {
    key: "pollUserCancellation",
    value: function pollUserCancellation() {
      var _this184 = this;

      var poll = function poll() {
        var _a2, _b;

        if ((_b = (_a2 = _this184.authWindow) === null || _a2 === void 0 ? void 0 : _a2.window) === null || _b === void 0 ? void 0 : _b.closed) {
          _this184.pollId = window.setTimeout(function () {
            _this184.pollId = null;

            _this184.reject(_createError(_this184.auth, "popup-closed-by-user"));
          }, 8e3);
          return;
        }

        _this184.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
      };

      poll();
    }
  }, {
    key: "eventId",
    get: function get() {
      var _a2;

      return ((_a2 = this.authWindow) === null || _a2 === void 0 ? void 0 : _a2.associatedEvent) || null;
    }
  }]);

  return PopupOperation;
}(AbstractPopupRedirectOperation);

PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var PENDING_REDIRECT_KEY = "pendingRedirect";
var redirectOutcomeMap =
/* @__PURE__ */
new Map();

var RedirectAction =
/*#__PURE__*/
function (_AbstractPopupRedirec2) {
  _inherits3(RedirectAction, _AbstractPopupRedirec2);

  function RedirectAction(auth, resolver) {
    var _this185;

    var bypassAuthState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck3(this, RedirectAction);

    _this185 = _possibleConstructorReturn3(this, _getPrototypeOf4(RedirectAction).call(this, auth, ["signInViaRedirect", "linkViaRedirect", "reauthViaRedirect", "unknown"], resolver, void 0, bypassAuthState));
    _this185.eventId = null;
    return _this185;
  }

  _createClass3(RedirectAction, [{
    key: "execute",
    value: function () {
      var _execute2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee601() {
        var readyOutcome, hasPendingRedirect, result;
        return _regeneratorRuntime.wrap(function _callee601$(_context602) {
          while (1) {
            switch (_context602.prev = _context602.next) {
              case 0:
                readyOutcome = redirectOutcomeMap.get(this.auth._key());

                if (readyOutcome) {
                  _context602.next = 21;
                  break;
                }

                _context602.prev = 2;
                _context602.next = 5;
                return _getAndClearPendingRedirectStatus(this.resolver, this.auth);

              case 5:
                hasPendingRedirect = _context602.sent;

                if (!hasPendingRedirect) {
                  _context602.next = 12;
                  break;
                }

                _context602.next = 9;
                return _get2(_getPrototypeOf4(RedirectAction.prototype), "execute", this).call(this);

              case 9:
                _context602.t0 = _context602.sent;
                _context602.next = 13;
                break;

              case 12:
                _context602.t0 = null;

              case 13:
                result = _context602.t0;

                readyOutcome = function readyOutcome() {
                  return Promise.resolve(result);
                };

                _context602.next = 20;
                break;

              case 17:
                _context602.prev = 17;
                _context602.t1 = _context602["catch"](2);

                readyOutcome = function readyOutcome() {
                  return Promise.reject(_context602.t1);
                };

              case 20:
                redirectOutcomeMap.set(this.auth._key(), readyOutcome);

              case 21:
                if (!this.bypassAuthState) {
                  redirectOutcomeMap.set(this.auth._key(), function () {
                    return Promise.resolve(null);
                  });
                }

                return _context602.abrupt("return", readyOutcome());

              case 23:
              case "end":
                return _context602.stop();
            }
          }
        }, _callee601, this, [[2, 17]]);
      }));

      function execute() {
        return _execute2.apply(this, arguments);
      }

      return execute;
    }()
  }, {
    key: "onAuthEvent",
    value: function () {
      var _onAuthEvent2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee602(event) {
        var user;
        return _regeneratorRuntime.wrap(function _callee602$(_context603) {
          while (1) {
            switch (_context603.prev = _context603.next) {
              case 0:
                if (!(event.type === "signInViaRedirect")) {
                  _context603.next = 4;
                  break;
                }

                return _context603.abrupt("return", _get2(_getPrototypeOf4(RedirectAction.prototype), "onAuthEvent", this).call(this, event));

              case 4:
                if (!(event.type === "unknown")) {
                  _context603.next = 7;
                  break;
                }

                this.resolve(null);
                return _context603.abrupt("return");

              case 7:
                if (!event.eventId) {
                  _context603.next = 17;
                  break;
                }

                _context603.next = 10;
                return this.auth._redirectUserForId(event.eventId);

              case 10:
                user = _context603.sent;

                if (!user) {
                  _context603.next = 16;
                  break;
                }

                this.user = user;
                return _context603.abrupt("return", _get2(_getPrototypeOf4(RedirectAction.prototype), "onAuthEvent", this).call(this, event));

              case 16:
                this.resolve(null);

              case 17:
              case "end":
                return _context603.stop();
            }
          }
        }, _callee602, this);
      }));

      function onAuthEvent(_x1104) {
        return _onAuthEvent2.apply(this, arguments);
      }

      return onAuthEvent;
    }()
  }, {
    key: "onExecution",
    value: function () {
      var _onExecution2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee603() {
        return _regeneratorRuntime.wrap(function _callee603$(_context604) {
          while (1) {
            switch (_context604.prev = _context604.next) {
              case 0:
              case "end":
                return _context604.stop();
            }
          }
        }, _callee603);
      }));

      function onExecution() {
        return _onExecution2.apply(this, arguments);
      }

      return onExecution;
    }()
  }, {
    key: "cleanUp",
    value: function cleanUp() {}
  }]);

  return RedirectAction;
}(AbstractPopupRedirectOperation);

function _getAndClearPendingRedirectStatus(_x1105, _x1106) {
  return _getAndClearPendingRedirectStatus2.apply(this, arguments);
}

function _getAndClearPendingRedirectStatus2() {
  _getAndClearPendingRedirectStatus2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee723(resolver, auth) {
    var key, persistence, hasPendingRedirect;
    return _regeneratorRuntime.wrap(function _callee723$(_context724) {
      while (1) {
        switch (_context724.prev = _context724.next) {
          case 0:
            key = pendingRedirectKey(auth);
            persistence = resolverPersistence(resolver);
            _context724.next = 4;
            return persistence._isAvailable();

          case 4:
            if (_context724.sent) {
              _context724.next = 6;
              break;
            }

            return _context724.abrupt("return", false);

          case 6:
            _context724.next = 8;
            return persistence._get(key);

          case 8:
            _context724.t0 = _context724.sent;
            hasPendingRedirect = _context724.t0 === "true";
            _context724.next = 12;
            return persistence._remove(key);

          case 12:
            return _context724.abrupt("return", hasPendingRedirect);

          case 13:
          case "end":
            return _context724.stop();
        }
      }
    }, _callee723);
  }));
  return _getAndClearPendingRedirectStatus2.apply(this, arguments);
}

function _setPendingRedirectStatus(_x1107, _x1108) {
  return _setPendingRedirectStatus2.apply(this, arguments);
}

function _setPendingRedirectStatus2() {
  _setPendingRedirectStatus2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee724(resolver, auth) {
    return _regeneratorRuntime.wrap(function _callee724$(_context725) {
      while (1) {
        switch (_context725.prev = _context725.next) {
          case 0:
            return _context725.abrupt("return", resolverPersistence(resolver)._set(pendingRedirectKey(auth), "true"));

          case 1:
          case "end":
            return _context725.stop();
        }
      }
    }, _callee724);
  }));
  return _setPendingRedirectStatus2.apply(this, arguments);
}

function _clearRedirectOutcomes() {
  redirectOutcomeMap.clear();
}

function _overrideRedirectResult(auth, result) {
  redirectOutcomeMap.set(auth._key(), result);
}

function resolverPersistence(resolver) {
  return _getInstance(resolver._redirectPersistence);
}

function pendingRedirectKey(auth) {
  return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithRedirect3(auth, provider, resolver) {
  return _signInWithRedirect(auth, provider, resolver);
}

function _signInWithRedirect(_x1109, _x1110, _x1111) {
  return _signInWithRedirect2.apply(this, arguments);
}

function _signInWithRedirect2() {
  _signInWithRedirect2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee725(auth, provider, resolver) {
    var authInternal, resolverInternal;
    return _regeneratorRuntime.wrap(function _callee725$(_context726) {
      while (1) {
        switch (_context726.prev = _context726.next) {
          case 0:
            authInternal = _castAuth(auth);

            _assertInstanceOf(auth, provider, FederatedAuthProvider);

            _context726.next = 4;
            return authInternal._initializationPromise;

          case 4:
            resolverInternal = _withDefaultResolver(authInternal, resolver);
            _context726.next = 7;
            return _setPendingRedirectStatus(resolverInternal, authInternal);

          case 7:
            return _context726.abrupt("return", resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect"));

          case 8:
          case "end":
            return _context726.stop();
        }
      }
    }, _callee725);
  }));
  return _signInWithRedirect2.apply(this, arguments);
}

function _reauthenticateWithRedirect3(user, provider, resolver) {
  return _reauthenticateWithRedirect(user, provider, resolver);
}

function _reauthenticateWithRedirect(_x1112, _x1113, _x1114) {
  return _reauthenticateWithRedirect2.apply(this, arguments);
}

function _reauthenticateWithRedirect2() {
  _reauthenticateWithRedirect2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee726(user, provider, resolver) {
    var userInternal, resolverInternal, eventId;
    return _regeneratorRuntime.wrap(function _callee726$(_context727) {
      while (1) {
        switch (_context727.prev = _context727.next) {
          case 0:
            userInternal = getModularInstance(user);

            _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);

            _context727.next = 4;
            return userInternal.auth._initializationPromise;

          case 4:
            resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
            _context727.next = 7;
            return _setPendingRedirectStatus(resolverInternal, userInternal.auth);

          case 7:
            _context727.next = 9;
            return prepareUserForRedirect(userInternal);

          case 9:
            eventId = _context727.sent;
            return _context727.abrupt("return", resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect", eventId));

          case 11:
          case "end":
            return _context727.stop();
        }
      }
    }, _callee726);
  }));
  return _reauthenticateWithRedirect2.apply(this, arguments);
}

function _linkWithRedirect3(user, provider, resolver) {
  return _linkWithRedirect(user, provider, resolver);
}

function _linkWithRedirect(_x1115, _x1116, _x1117) {
  return _linkWithRedirect2.apply(this, arguments);
}

function _linkWithRedirect2() {
  _linkWithRedirect2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee727(user, provider, resolver) {
    var userInternal, resolverInternal, eventId;
    return _regeneratorRuntime.wrap(function _callee727$(_context728) {
      while (1) {
        switch (_context728.prev = _context728.next) {
          case 0:
            userInternal = getModularInstance(user);

            _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);

            _context728.next = 4;
            return userInternal.auth._initializationPromise;

          case 4:
            resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
            _context728.next = 7;
            return _assertLinkedStatus(false, userInternal, provider.providerId);

          case 7:
            _context728.next = 9;
            return _setPendingRedirectStatus(resolverInternal, userInternal.auth);

          case 9:
            _context728.next = 11;
            return prepareUserForRedirect(userInternal);

          case 11:
            eventId = _context728.sent;
            return _context728.abrupt("return", resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect", eventId));

          case 13:
          case "end":
            return _context728.stop();
        }
      }
    }, _callee727);
  }));
  return _linkWithRedirect2.apply(this, arguments);
}

function _getRedirectResult4(_x1118, _x1119) {
  return _getRedirectResult2.apply(this, arguments);
}

function _getRedirectResult2() {
  _getRedirectResult2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee728(auth, resolver) {
    return _regeneratorRuntime.wrap(function _callee728$(_context729) {
      while (1) {
        switch (_context729.prev = _context729.next) {
          case 0:
            _context729.next = 2;
            return _castAuth(auth)._initializationPromise;

          case 2:
            return _context729.abrupt("return", _getRedirectResult(auth, resolver, false));

          case 3:
          case "end":
            return _context729.stop();
        }
      }
    }, _callee728);
  }));
  return _getRedirectResult2.apply(this, arguments);
}

function _getRedirectResult(_x1120, _x1121) {
  return _getRedirectResult3.apply(this, arguments);
}

function _getRedirectResult3() {
  _getRedirectResult3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee729(auth, resolverExtern) {
    var bypassAuthState,
        authInternal,
        resolver,
        action,
        result,
        _args730 = arguments;
    return _regeneratorRuntime.wrap(function _callee729$(_context730) {
      while (1) {
        switch (_context730.prev = _context730.next) {
          case 0:
            bypassAuthState = _args730.length > 2 && _args730[2] !== undefined ? _args730[2] : false;
            authInternal = _castAuth(auth);
            resolver = _withDefaultResolver(authInternal, resolverExtern);
            action = new RedirectAction(authInternal, resolver, bypassAuthState);
            _context730.next = 6;
            return action.execute();

          case 6:
            result = _context730.sent;

            if (!(result && !bypassAuthState)) {
              _context730.next = 13;
              break;
            }

            delete result.user._redirectEventId;
            _context730.next = 11;
            return authInternal._persistUserIfCurrent(result.user);

          case 11:
            _context730.next = 13;
            return authInternal._setRedirectUser(null, resolverExtern);

          case 13:
            return _context730.abrupt("return", result);

          case 14:
          case "end":
            return _context730.stop();
        }
      }
    }, _callee729);
  }));
  return _getRedirectResult3.apply(this, arguments);
}

function prepareUserForRedirect(_x1122) {
  return _prepareUserForRedirect.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _prepareUserForRedirect() {
  _prepareUserForRedirect = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee730(user) {
    var eventId;
    return _regeneratorRuntime.wrap(function _callee730$(_context731) {
      while (1) {
        switch (_context731.prev = _context731.next) {
          case 0:
            eventId = _generateEventId("".concat(user.uid, ":::"));
            user._redirectEventId = eventId;
            _context731.next = 4;
            return user.auth._setRedirectUser(user);

          case 4:
            _context731.next = 6;
            return user.auth._persistUserIfCurrent(user);

          case 6:
            return _context731.abrupt("return", eventId);

          case 7:
          case "end":
            return _context731.stop();
        }
      }
    }, _callee730);
  }));
  return _prepareUserForRedirect.apply(this, arguments);
}

var EVENT_DUPLICATION_CACHE_DURATION_MS = 10 * 60 * 1e3;

var AuthEventManager =
/*#__PURE__*/
function () {
  function AuthEventManager(auth) {
    _classCallCheck3(this, AuthEventManager);

    this.auth = auth;
    this.cachedEventUids =
    /* @__PURE__ */
    new Set();
    this.consumers =
    /* @__PURE__ */
    new Set();
    this.queuedRedirectEvent = null;
    this.hasHandledPotentialRedirect = false;
    this.lastProcessedEventTime = Date.now();
  }

  _createClass3(AuthEventManager, [{
    key: "registerConsumer",
    value: function registerConsumer(authEventConsumer) {
      this.consumers.add(authEventConsumer);

      if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
        this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
        this.saveEventToCache(this.queuedRedirectEvent);
        this.queuedRedirectEvent = null;
      }
    }
  }, {
    key: "unregisterConsumer",
    value: function unregisterConsumer(authEventConsumer) {
      this.consumers.delete(authEventConsumer);
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var _this186 = this;

      if (this.hasEventBeenHandled(event)) {
        return false;
      }

      var handled = false;
      this.consumers.forEach(function (consumer) {
        if (_this186.isEventForConsumer(event, consumer)) {
          handled = true;

          _this186.sendToConsumer(event, consumer);

          _this186.saveEventToCache(event);
        }
      });

      if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) {
        return handled;
      }

      this.hasHandledPotentialRedirect = true;

      if (!handled) {
        this.queuedRedirectEvent = event;
        handled = true;
      }

      return handled;
    }
  }, {
    key: "sendToConsumer",
    value: function sendToConsumer(event, consumer) {
      var _a2;

      if (event.error && !isNullRedirectEvent(event)) {
        var code = ((_a2 = event.error.code) === null || _a2 === void 0 ? void 0 : _a2.split("auth/")[1]) || "internal-error";
        consumer.onError(_createError(this.auth, code));
      } else {
        consumer.onAuthEvent(event);
      }
    }
  }, {
    key: "isEventForConsumer",
    value: function isEventForConsumer(event, consumer) {
      var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
      return consumer.filter.includes(event.type) && eventIdMatches;
    }
  }, {
    key: "hasEventBeenHandled",
    value: function hasEventBeenHandled(event) {
      if (Date.now() - this.lastProcessedEventTime >= EVENT_DUPLICATION_CACHE_DURATION_MS) {
        this.cachedEventUids.clear();
      }

      return this.cachedEventUids.has(eventUid(event));
    }
  }, {
    key: "saveEventToCache",
    value: function saveEventToCache(event) {
      this.cachedEventUids.add(eventUid(event));
      this.lastProcessedEventTime = Date.now();
    }
  }]);

  return AuthEventManager;
}();

function eventUid(e2) {
  return [e2.type, e2.eventId, e2.sessionId, e2.tenantId].filter(function (v2) {
    return v2;
  }).join("-");
}

function isNullRedirectEvent(_ref598) {
  var type = _ref598.type,
      error = _ref598.error;
  return type === "unknown" && (error === null || error === void 0 ? void 0 : error.code) === "auth/".concat("no-auth-event");
}

function isRedirectEvent(event) {
  switch (event.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return true;

    case "unknown":
      return isNullRedirectEvent(event);

    default:
      return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getProjectConfig(_x1123) {
  return _getProjectConfig2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getProjectConfig2() {
  _getProjectConfig2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee731(auth) {
    var request2,
        _args732 = arguments;
    return _regeneratorRuntime.wrap(function _callee731$(_context732) {
      while (1) {
        switch (_context732.prev = _context732.next) {
          case 0:
            request2 = _args732.length > 1 && _args732[1] !== undefined ? _args732[1] : {};
            return _context732.abrupt("return", _performApiRequest(auth, "GET", "/v1/projects", request2));

          case 2:
          case "end":
            return _context732.stop();
        }
      }
    }, _callee731);
  }));
  return _getProjectConfig2.apply(this, arguments);
}

var IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var HTTP_REGEX = /^https?/;

function _validateOrigin$1(_x1124) {
  return _validateOrigin$.apply(this, arguments);
}

function _validateOrigin$() {
  _validateOrigin$ = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee732(auth) {
    var _ref685, authorizedDomains, _iteratorNormalCompletion25, _didIteratorError25, _iteratorError25, _iterator25, _step25, domain;

    return _regeneratorRuntime.wrap(function _callee732$(_context733) {
      while (1) {
        switch (_context733.prev = _context733.next) {
          case 0:
            if (!auth.config.emulator) {
              _context733.next = 2;
              break;
            }

            return _context733.abrupt("return");

          case 2:
            _context733.next = 4;
            return _getProjectConfig(auth);

          case 4:
            _ref685 = _context733.sent;
            authorizedDomains = _ref685.authorizedDomains;
            _iteratorNormalCompletion25 = true;
            _didIteratorError25 = false;
            _iteratorError25 = undefined;
            _context733.prev = 9;
            _iterator25 = authorizedDomains[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done) {
              _context733.next = 23;
              break;
            }

            domain = _step25.value;
            _context733.prev = 13;

            if (!matchDomain(domain)) {
              _context733.next = 16;
              break;
            }

            return _context733.abrupt("return");

          case 16:
            _context733.next = 20;
            break;

          case 18:
            _context733.prev = 18;
            _context733.t0 = _context733["catch"](13);

          case 20:
            _iteratorNormalCompletion25 = true;
            _context733.next = 11;
            break;

          case 23:
            _context733.next = 29;
            break;

          case 25:
            _context733.prev = 25;
            _context733.t1 = _context733["catch"](9);
            _didIteratorError25 = true;
            _iteratorError25 = _context733.t1;

          case 29:
            _context733.prev = 29;
            _context733.prev = 30;

            if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
              _iterator25.return();
            }

          case 32:
            _context733.prev = 32;

            if (!_didIteratorError25) {
              _context733.next = 35;
              break;
            }

            throw _iteratorError25;

          case 35:
            return _context733.finish(32);

          case 36:
            return _context733.finish(29);

          case 37:
            _fail(auth, "unauthorized-domain");

          case 38:
          case "end":
            return _context733.stop();
        }
      }
    }, _callee732, null, [[9, 25, 29, 37], [13, 18], [30,, 32, 36]]);
  }));
  return _validateOrigin$.apply(this, arguments);
}

function matchDomain(expected) {
  var currentUrl = _getCurrentUrl();

  var _ref599 = new URL(currentUrl),
      protocol = _ref599.protocol,
      hostname = _ref599.hostname;

  if (expected.startsWith("chrome-extension://")) {
    var ceUrl = new URL(expected);

    if (ceUrl.hostname === "" && hostname === "") {
      return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
    }

    return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
  }

  if (!HTTP_REGEX.test(protocol)) {
    return false;
  }

  if (IP_ADDRESS_REGEX.test(expected)) {
    return hostname === expected;
  }

  var escapedDomainPattern = expected.replace(/\./g, "\\.");
  var re2 = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
  return re2.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var NETWORK_TIMEOUT = new Delay(3e4, 6e4);

function resetUnloadedGapiModules() {
  var beacon = _window().___jsl;

  if (beacon === null || beacon === void 0 ? void 0 : beacon.H) {
    for (var _i68 = 0, _Object$keys5 = Object.keys(beacon.H); _i68 < _Object$keys5.length; _i68++) {
      var hint = _Object$keys5[_i68];
      beacon.H[hint].r = beacon.H[hint].r || [];
      beacon.H[hint].L = beacon.H[hint].L || [];
      beacon.H[hint].r = _toConsumableArray3(beacon.H[hint].L);

      if (beacon.CP) {
        for (var _i69 = 0; _i69 < beacon.CP.length; _i69++) {
          beacon.CP[_i69] = null;
        }
      }
    }
  }
}

function loadGapi(auth) {
  return new Promise(function (resolve, reject) {
    var _a2, _b, _c;

    function loadGapiIframe() {
      resetUnloadedGapiModules();
      gapi.load("gapi.iframes", {
        callback: function callback() {
          resolve(gapi.iframes.getContext());
        },
        ontimeout: function ontimeout() {
          resetUnloadedGapiModules();
          reject(_createError(auth, "network-request-failed"));
        },
        timeout: NETWORK_TIMEOUT.get()
      });
    }

    if ((_b = (_a2 = _window().gapi) === null || _a2 === void 0 ? void 0 : _a2.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) {
      resolve(gapi.iframes.getContext());
    } else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) {
      loadGapiIframe();
    } else {
      var cbName = _generateCallbackName("iframefcb");

      _window()[cbName] = function () {
        if (!!gapi.load) {
          loadGapiIframe();
        } else {
          reject(_createError(auth, "network-request-failed"));
        }
      };

      return _loadJS("https://apis.google.com/js/api.js?onload=".concat(cbName)).catch(function (e2) {
        return reject(e2);
      });
    }
  }).catch(function (error) {
    cachedGApiLoader = null;
    throw error;
  });
}

var cachedGApiLoader = null;

function _loadGapi(auth) {
  cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
  return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var PING_TIMEOUT = new Delay(5e3, 15e3);
var IFRAME_PATH = "__/auth/iframe";
var EMULATED_IFRAME_PATH = "emulator/auth/iframe";
var IFRAME_ATTRIBUTES = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
};
var EID_FROM_APIHOST =
/* @__PURE__ */
new Map([["identitytoolkit.googleapis.com", "p"], ["staging-identitytoolkit.sandbox.googleapis.com", "s"], ["test-identitytoolkit.sandbox.googleapis.com", "t"]]);

function getIframeUrl(auth) {
  var config = auth.config;

  _assert$4(config.authDomain, auth, "auth-domain-config-required");

  var url = config.emulator ? _emulatorUrl(config, EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat(IFRAME_PATH);
  var params = {
    apiKey: config.apiKey,
    appName: auth.name,
    v: SDK_VERSION
  };
  var eid = EID_FROM_APIHOST.get(auth.config.apiHost);

  if (eid) {
    params.eid = eid;
  }

  var frameworks = auth._getFrameworks();

  if (frameworks.length) {
    params.fw = frameworks.join(",");
  }

  return "".concat(url, "?").concat(querystring(params).slice(1));
}

function _openIframe(_x1125) {
  return _openIframe2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _openIframe2() {
  _openIframe2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee734(auth) {
    var context, gapi2;
    return _regeneratorRuntime.wrap(function _callee734$(_context735) {
      while (1) {
        switch (_context735.prev = _context735.next) {
          case 0:
            _context735.next = 2;
            return _loadGapi(auth);

          case 2:
            context = _context735.sent;
            gapi2 = _window().gapi;

            _assert$4(gapi2, auth, "internal-error");

            return _context735.abrupt("return", context.open({
              where: document.body,
              url: getIframeUrl(auth),
              messageHandlersFilter: gapi2.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
              attributes: IFRAME_ATTRIBUTES,
              dontclear: true
            }, function (iframe) {
              return new Promise(
              /*#__PURE__*/
              function () {
                var _ref686 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee733(resolve, reject) {
                  var networkError, networkErrorTimer, clearTimerAndResolve;
                  return _regeneratorRuntime.wrap(function _callee733$(_context734) {
                    while (1) {
                      switch (_context734.prev = _context734.next) {
                        case 0:
                          clearTimerAndResolve = function _ref687() {
                            _window().clearTimeout(networkErrorTimer);

                            resolve(iframe);
                          };

                          _context734.next = 3;
                          return iframe.restyle({
                            setHideOnLeave: false
                          });

                        case 3:
                          networkError = _createError(auth, "network-request-failed");
                          networkErrorTimer = _window().setTimeout(function () {
                            reject(networkError);
                          }, PING_TIMEOUT.get());
                          iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function () {
                            reject(networkError);
                          });

                        case 6:
                        case "end":
                          return _context734.stop();
                      }
                    }
                  }, _callee733);
                }));

                return function (_x1191, _x1192) {
                  return _ref686.apply(this, arguments);
                };
              }());
            }));

          case 6:
          case "end":
            return _context735.stop();
        }
      }
    }, _callee734);
  }));
  return _openIframe2.apply(this, arguments);
}

var BASE_POPUP_OPTIONS = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
};
var DEFAULT_WIDTH = 500;
var DEFAULT_HEIGHT = 600;
var TARGET_BLANK = "_blank";
var FIREFOX_EMPTY_URL = "http://localhost";

var AuthPopup =
/*#__PURE__*/
function () {
  function AuthPopup(window2) {
    _classCallCheck3(this, AuthPopup);

    this.window = window2;
    this.associatedEvent = null;
  }

  _createClass3(AuthPopup, [{
    key: "close",
    value: function close() {
      if (this.window) {
        try {
          this.window.close();
        } catch (e2) {}
      }
    }
  }]);

  return AuthPopup;
}();

function _open(auth, url, name2) {
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_WIDTH;
  var height = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_HEIGHT;
  var top2 = Math.max((window.screen.availHeight - height) / 2, 0).toString();
  var left2 = Math.max((window.screen.availWidth - width) / 2, 0).toString();
  var target = "";
  var options2 = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), {
    width: width.toString(),
    height: height.toString(),
    top: top2,
    left: left2
  });
  var ua2 = getUA().toLowerCase();

  if (name2) {
    target = _isChromeIOS(ua2) ? TARGET_BLANK : name2;
  }

  if (_isFirefox(ua2)) {
    url = url || FIREFOX_EMPTY_URL;
    options2.scrollbars = "yes";
  }

  var optionsString = Object.entries(options2).reduce(function (accum, _ref600) {
    var _ref601 = _slicedToArray3(_ref600, 2),
        key = _ref601[0],
        value = _ref601[1];

    return "".concat(accum).concat(key, "=").concat(value, ",");
  }, "");

  if (_isIOSStandalone(ua2) && target !== "_self") {
    openAsNewWindowIOS(url || "", target);
    return new AuthPopup(null);
  }

  var newWin = window.open(url || "", target, optionsString);

  _assert$4(newWin, auth, "popup-blocked");

  try {
    newWin.focus();
  } catch (e2) {}

  return new AuthPopup(newWin);
}

function openAsNewWindowIOS(url, target) {
  var el = document.createElement("a");
  el.href = url;
  el.target = target;
  var click = document.createEvent("MouseEvent");
  click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
  el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var WIDGET_PATH = "__/auth/handler";
var EMULATOR_WIDGET_PATH = "emulator/auth/handler";
var FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");

function _getRedirectUrl(_x1126, _x1127, _x1128, _x1129, _x1130, _x1131) {
  return _getRedirectUrl2.apply(this, arguments);
}

function _getRedirectUrl2() {
  _getRedirectUrl2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee735(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    var params, _i74, _Object$entries8, _ref690, _ref689, key, value, scopes, paramsDict, _i75, _Object$keys6, _key22, appCheckToken, appCheckTokenFragment;

    return _regeneratorRuntime.wrap(function _callee735$(_context736) {
      while (1) {
        switch (_context736.prev = _context736.next) {
          case 0:
            _assert$4(auth.config.authDomain, auth, "auth-domain-config-required");

            _assert$4(auth.config.apiKey, auth, "invalid-api-key");

            params = {
              apiKey: auth.config.apiKey,
              appName: auth.name,
              authType: authType,
              redirectUrl: redirectUrl,
              v: SDK_VERSION,
              eventId: eventId
            };

            if (provider instanceof FederatedAuthProvider) {
              provider.setDefaultLanguage(auth.languageCode);
              params.providerId = provider.providerId || "";

              if (!isEmpty(provider.getCustomParameters())) {
                params.customParameters = JSON.stringify(provider.getCustomParameters());
              }

              for (_i74 = 0, _Object$entries8 = Object.entries(additionalParams || {}); _i74 < _Object$entries8.length; _i74++) {
                _ref690 = _Object$entries8[_i74];
                _ref689 = _slicedToArray3(_ref690, 2);
                key = _ref689[0];
                value = _ref689[1];
                params[key] = value;
              }
            }

            if (provider instanceof BaseOAuthProvider) {
              scopes = provider.getScopes().filter(function (scope) {
                return scope !== "";
              });

              if (scopes.length > 0) {
                params.scopes = scopes.join(",");
              }
            }

            if (auth.tenantId) {
              params.tid = auth.tenantId;
            }

            paramsDict = params;

            for (_i75 = 0, _Object$keys6 = Object.keys(paramsDict); _i75 < _Object$keys6.length; _i75++) {
              _key22 = _Object$keys6[_i75];

              if (paramsDict[_key22] === void 0) {
                delete paramsDict[_key22];
              }
            }

            _context736.next = 10;
            return auth._getAppCheckToken();

          case 10:
            appCheckToken = _context736.sent;
            appCheckTokenFragment = appCheckToken ? "#".concat(FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : "";
            return _context736.abrupt("return", "".concat(getHandlerBase(auth), "?").concat(querystring(paramsDict).slice(1)).concat(appCheckTokenFragment));

          case 13:
          case "end":
            return _context736.stop();
        }
      }
    }, _callee735);
  }));
  return _getRedirectUrl2.apply(this, arguments);
}

function getHandlerBase(_ref602) {
  var config = _ref602.config;

  if (!config.emulator) {
    return "https://".concat(config.authDomain, "/").concat(WIDGET_PATH);
  }

  return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";

var BrowserPopupRedirectResolver =
/*#__PURE__*/
function () {
  function BrowserPopupRedirectResolver() {
    _classCallCheck3(this, BrowserPopupRedirectResolver);

    this.eventManagers = {};
    this.iframes = {};
    this.originValidationPromises = {};
    this._redirectPersistence = browserSessionPersistence;
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  }

  _createClass3(BrowserPopupRedirectResolver, [{
    key: "_openPopup",
    value: function () {
      var _openPopup2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee604(auth, provider, authType, eventId) {
        var _a2, url;

        return _regeneratorRuntime.wrap(function _callee604$(_context605) {
          while (1) {
            switch (_context605.prev = _context605.next) {
              case 0:
                debugAssert((_a2 = this.eventManagers[auth._key()]) === null || _a2 === void 0 ? void 0 : _a2.manager, "_initialize() not called before _openPopup()");
                _context605.next = 3;
                return _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);

              case 3:
                url = _context605.sent;
                return _context605.abrupt("return", _open(auth, url, _generateEventId()));

              case 5:
              case "end":
                return _context605.stop();
            }
          }
        }, _callee604, this);
      }));

      function _openPopup(_x1132, _x1133, _x1134, _x1135) {
        return _openPopup2.apply(this, arguments);
      }

      return _openPopup;
    }()
  }, {
    key: "_openRedirect",
    value: function () {
      var _openRedirect2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee605(auth, provider, authType, eventId) {
        var url;
        return _regeneratorRuntime.wrap(function _callee605$(_context606) {
          while (1) {
            switch (_context606.prev = _context606.next) {
              case 0:
                _context606.next = 2;
                return this._originValidation(auth);

              case 2:
                _context606.next = 4;
                return _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);

              case 4:
                url = _context606.sent;

                _setWindowLocation(url);

                return _context606.abrupt("return", new Promise(function () {}));

              case 7:
              case "end":
                return _context606.stop();
            }
          }
        }, _callee605, this);
      }));

      function _openRedirect(_x1136, _x1137, _x1138, _x1139) {
        return _openRedirect2.apply(this, arguments);
      }

      return _openRedirect;
    }()
  }, {
    key: "_initialize",
    value: function _initialize(auth) {
      var _this187 = this;

      var key = auth._key();

      if (this.eventManagers[key]) {
        var _this$eventManagers$k = this.eventManagers[key],
            manager = _this$eventManagers$k.manager,
            promise2 = _this$eventManagers$k.promise;

        if (manager) {
          return Promise.resolve(manager);
        } else {
          debugAssert(promise2, "If manager is not set, promise should be");
          return promise2;
        }
      }

      var promise = this.initAndGetManager(auth);
      this.eventManagers[key] = {
        promise: promise
      };
      promise.catch(function () {
        delete _this187.eventManagers[key];
      });
      return promise;
    }
  }, {
    key: "initAndGetManager",
    value: function () {
      var _initAndGetManager = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee606(auth) {
        var iframe, manager;
        return _regeneratorRuntime.wrap(function _callee606$(_context607) {
          while (1) {
            switch (_context607.prev = _context607.next) {
              case 0:
                _context607.next = 2;
                return _openIframe(auth);

              case 2:
                iframe = _context607.sent;
                manager = new AuthEventManager(auth);
                iframe.register("authEvent", function (iframeEvent) {
                  _assert$4(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event");

                  var handled = manager.onEvent(iframeEvent.authEvent);
                  return {
                    status: handled ? "ACK" : "ERROR"
                  };
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                this.eventManagers[auth._key()] = {
                  manager: manager
                };
                this.iframes[auth._key()] = iframe;
                return _context607.abrupt("return", manager);

              case 8:
              case "end":
                return _context607.stop();
            }
          }
        }, _callee606, this);
      }));

      function initAndGetManager(_x1140) {
        return _initAndGetManager.apply(this, arguments);
      }

      return initAndGetManager;
    }()
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(auth, cb) {
      var iframe = this.iframes[auth._key()];

      iframe.send(WEB_STORAGE_SUPPORT_KEY, {
        type: WEB_STORAGE_SUPPORT_KEY
      }, function (result) {
        var _a2;

        var isSupported = (_a2 = result === null || result === void 0 ? void 0 : result[0]) === null || _a2 === void 0 ? void 0 : _a2[WEB_STORAGE_SUPPORT_KEY];

        if (isSupported !== void 0) {
          cb(!!isSupported);
        }

        _fail(auth, "internal-error");
      }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(auth) {
      var key = auth._key();

      if (!this.originValidationPromises[key]) {
        this.originValidationPromises[key] = _validateOrigin$1(auth);
      }

      return this.originValidationPromises[key];
    }
  }, {
    key: "_shouldInitProactively",
    get: function get() {
      return _isMobileBrowser() || _isSafari() || _isIOS();
    }
  }]);

  return BrowserPopupRedirectResolver;
}();

var browserPopupRedirectResolver = BrowserPopupRedirectResolver;

var MultiFactorAssertionImpl =
/*#__PURE__*/
function () {
  function MultiFactorAssertionImpl(factorId) {
    _classCallCheck3(this, MultiFactorAssertionImpl);

    this.factorId = factorId;
  }

  _createClass3(MultiFactorAssertionImpl, [{
    key: "_process",
    value: function _process(auth, session, displayName) {
      switch (session.type) {
        case "enroll":
          return this._finalizeEnroll(auth, session.credential, displayName);

        case "signin":
          return this._finalizeSignIn(auth, session.credential);

        default:
          return debugFail("unexpected MultiFactorSessionType");
      }
    }
  }]);

  return MultiFactorAssertionImpl;
}();

var PhoneMultiFactorAssertionImpl =
/*#__PURE__*/
function (_MultiFactorAssertion) {
  _inherits3(PhoneMultiFactorAssertionImpl, _MultiFactorAssertion);

  function PhoneMultiFactorAssertionImpl(credential) {
    var _this188;

    _classCallCheck3(this, PhoneMultiFactorAssertionImpl);

    _this188 = _possibleConstructorReturn3(this, _getPrototypeOf4(PhoneMultiFactorAssertionImpl).call(this, "phone"));
    _this188.credential = credential;
    return _this188;
  }

  _createClass3(PhoneMultiFactorAssertionImpl, [{
    key: "_finalizeEnroll",
    value: function _finalizeEnroll(auth, idToken, displayName) {
      return finalizeEnrollPhoneMfa(auth, {
        idToken: idToken,
        displayName: displayName,
        phoneVerificationInfo: this.credential._makeVerificationRequest()
      });
    }
  }, {
    key: "_finalizeSignIn",
    value: function _finalizeSignIn(auth, mfaPendingCredential) {
      return finalizeSignInPhoneMfa(auth, {
        mfaPendingCredential: mfaPendingCredential,
        phoneVerificationInfo: this.credential._makeVerificationRequest()
      });
    }
  }], [{
    key: "_fromCredential",
    value: function _fromCredential(credential) {
      return new PhoneMultiFactorAssertionImpl(credential);
    }
  }]);

  return PhoneMultiFactorAssertionImpl;
}(MultiFactorAssertionImpl);

var PhoneMultiFactorGenerator =
/*#__PURE__*/
function () {
  function PhoneMultiFactorGenerator() {
    _classCallCheck3(this, PhoneMultiFactorGenerator);
  }

  _createClass3(PhoneMultiFactorGenerator, null, [{
    key: "assertion",
    value: function assertion(credential) {
      return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
  }]);

  return PhoneMultiFactorGenerator;
}();

PhoneMultiFactorGenerator.FACTOR_ID = "phone";
var name$1 = "@firebase/auth";
var version$1 = "0.23.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var AuthInterop =
/*#__PURE__*/
function () {
  function AuthInterop(auth) {
    _classCallCheck3(this, AuthInterop);

    this.auth = auth;
    this.internalListeners =
    /* @__PURE__ */
    new Map();
  }

  _createClass3(AuthInterop, [{
    key: "getUid",
    value: function getUid() {
      var _a2;

      this.assertAuthConfigured();
      return ((_a2 = this.auth.currentUser) === null || _a2 === void 0 ? void 0 : _a2.uid) || null;
    }
  }, {
    key: "getToken",
    value: function () {
      var _getToken2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee607(forceRefresh) {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee607$(_context608) {
          while (1) {
            switch (_context608.prev = _context608.next) {
              case 0:
                this.assertAuthConfigured();
                _context608.next = 3;
                return this.auth._initializationPromise;

              case 3:
                if (this.auth.currentUser) {
                  _context608.next = 5;
                  break;
                }

                return _context608.abrupt("return", null);

              case 5:
                _context608.next = 7;
                return this.auth.currentUser.getIdToken(forceRefresh);

              case 7:
                accessToken = _context608.sent;
                return _context608.abrupt("return", {
                  accessToken: accessToken
                });

              case 9:
              case "end":
                return _context608.stop();
            }
          }
        }, _callee607, this);
      }));

      function getToken(_x1141) {
        return _getToken2.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "addAuthTokenListener",
    value: function addAuthTokenListener(listener) {
      this.assertAuthConfigured();

      if (this.internalListeners.has(listener)) {
        return;
      }

      var unsubscribe2 = this.auth.onIdTokenChanged(function (user) {
        listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
      });
      this.internalListeners.set(listener, unsubscribe2);
      this.updateProactiveRefresh();
    }
  }, {
    key: "removeAuthTokenListener",
    value: function removeAuthTokenListener(listener) {
      this.assertAuthConfigured();
      var unsubscribe2 = this.internalListeners.get(listener);

      if (!unsubscribe2) {
        return;
      }

      this.internalListeners.delete(listener);
      unsubscribe2();
      this.updateProactiveRefresh();
    }
  }, {
    key: "assertAuthConfigured",
    value: function assertAuthConfigured() {
      _assert$4(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth");
    }
  }, {
    key: "updateProactiveRefresh",
    value: function updateProactiveRefresh() {
      if (this.internalListeners.size > 0) {
        this.auth._startProactiveRefresh();
      } else {
        this.auth._stopProactiveRefresh();
      }
    }
  }]);

  return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getVersionForPlatform(clientPlatform) {
  switch (clientPlatform) {
    case "Node":
      return "node";

    case "ReactNative":
      return "rn";

    case "Worker":
      return "webworker";

    case "Cordova":
      return "cordova";

    default:
      return void 0;
  }
}

function registerAuth(clientPlatform) {
  _registerComponent(new Component("auth", function (container, _ref603) {
    var deps = _ref603.options;
    var app = container.getProvider("app").getImmediate();
    var heartbeatServiceProvider = container.getProvider("heartbeat");
    var appCheckServiceProvider = container.getProvider("app-check-internal");
    var _app$options = app.options,
        apiKey = _app$options.apiKey,
        authDomain = _app$options.authDomain;

    _assert$4(apiKey && !apiKey.includes(":"), "invalid-api-key", {
      appName: app.name
    });

    var config = {
      apiKey: apiKey,
      authDomain: authDomain,
      clientPlatform: clientPlatform,
      apiHost: "identitytoolkit.googleapis.com",
      tokenApiHost: "securetoken.googleapis.com",
      apiScheme: "https",
      sdkClientVersion: _getClientVersion(clientPlatform)
    };
    var authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);

    _initializeAuthInstance(authInstance, deps);

    return authInstance;
  }, "PUBLIC").setInstantiationMode("EXPLICIT").setInstanceCreatedCallback(function (container, _instanceIdentifier, _instance) {
    var authInternalProvider = container.getProvider("auth-internal");
    authInternalProvider.initialize();
  }));

  _registerComponent(new Component("auth-internal", function (container) {
    var auth = _castAuth(container.getProvider("auth").getImmediate());

    return function (auth2) {
      return new AuthInterop(auth2);
    }(auth);
  }, "PRIVATE").setInstantiationMode("EXPLICIT"));

  registerVersion(name$1, version$1, getVersionForPlatform(clientPlatform));
  registerVersion(name$1, version$1, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ID_TOKEN_MAX_AGE = 5 * 60;
var authIdTokenMaxAge = getExperimentalSetting("authIdTokenMaxAge") || DEFAULT_ID_TOKEN_MAX_AGE;
var lastPostedIdToken = null;

var mintCookieFactory = function mintCookieFactory(url) {
  return (
    /*#__PURE__*/
    function () {
      var _ref604 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee608(user) {
        var idTokenResult, idTokenAge, idToken;
        return _regeneratorRuntime.wrap(function _callee608$(_context609) {
          while (1) {
            switch (_context609.prev = _context609.next) {
              case 0:
                _context609.t0 = user;

                if (!_context609.t0) {
                  _context609.next = 5;
                  break;
                }

                _context609.next = 4;
                return user.getIdTokenResult();

              case 4:
                _context609.t0 = _context609.sent;

              case 5:
                idTokenResult = _context609.t0;
                idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1e3;

                if (!(idTokenAge && idTokenAge > authIdTokenMaxAge)) {
                  _context609.next = 9;
                  break;
                }

                return _context609.abrupt("return");

              case 9:
                idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;

                if (!(lastPostedIdToken === idToken)) {
                  _context609.next = 12;
                  break;
                }

                return _context609.abrupt("return");

              case 12:
                lastPostedIdToken = idToken;
                _context609.next = 15;
                return fetch(url, {
                  method: idToken ? "POST" : "DELETE",
                  headers: idToken ? {
                    "Authorization": "Bearer ".concat(idToken)
                  } : {}
                });

              case 15:
              case "end":
                return _context609.stop();
            }
          }
        }, _callee608);
      }));

      return function (_x1142) {
        return _ref604.apply(this, arguments);
      };
    }()
  );
};

function getAuth() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();

  var provider = _getProvider(app, "auth");

  if (provider.isInitialized()) {
    return provider.getImmediate();
  }

  var auth = initializeAuth(app, {
    popupRedirectResolver: browserPopupRedirectResolver,
    persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence]
  });
  var authTokenSyncUrl = getExperimentalSetting("authTokenSyncURL");

  if (authTokenSyncUrl) {
    var mintCookie = mintCookieFactory(authTokenSyncUrl);
    beforeAuthStateChanged(auth, mintCookie, function () {
      return mintCookie(auth.currentUser);
    });
    onIdTokenChanged(auth, function (user) {
      return mintCookie(user);
    });
  }

  var authEmulatorHost = getDefaultEmulatorHost("auth");

  if (authEmulatorHost) {
    connectAuthEmulator(auth, "http://".concat(authEmulatorHost));
  }

  return auth;
}

registerAuth("Browser");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _cordovaWindow() {
  return window;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var REDIRECT_TIMEOUT_MS = 2e3;

function _generateHandlerUrl(_x1143, _x1144, _x1145) {
  return _generateHandlerUrl2.apply(this, arguments);
}

function _generateHandlerUrl2() {
  _generateHandlerUrl2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee736(auth, event, provider) {
    var _a2, _cordovaWindow4, BuildInfo, sessionDigest, additionalParams;

    return _regeneratorRuntime.wrap(function _callee736$(_context737) {
      while (1) {
        switch (_context737.prev = _context737.next) {
          case 0:
            _cordovaWindow4 = _cordovaWindow(), BuildInfo = _cordovaWindow4.BuildInfo;
            debugAssert(event.sessionId, "AuthEvent did not contain a session ID");
            _context737.next = 4;
            return computeSha256(event.sessionId);

          case 4:
            sessionDigest = _context737.sent;
            additionalParams = {};

            if (_isIOS()) {
              additionalParams["ibi"] = BuildInfo.packageName;
            } else if (_isAndroid()) {
              additionalParams["apn"] = BuildInfo.packageName;
            } else {
              _fail(auth, "operation-not-supported-in-this-environment");
            }

            if (BuildInfo.displayName) {
              additionalParams["appDisplayName"] = BuildInfo.displayName;
            }

            additionalParams["sessionId"] = sessionDigest;
            return _context737.abrupt("return", _getRedirectUrl(auth, provider, event.type, void 0, (_a2 = event.eventId) !== null && _a2 !== void 0 ? _a2 : void 0, additionalParams));

          case 10:
          case "end":
            return _context737.stop();
        }
      }
    }, _callee736);
  }));
  return _generateHandlerUrl2.apply(this, arguments);
}

function _validateOrigin(_x1146) {
  return _validateOrigin2.apply(this, arguments);
}

function _validateOrigin2() {
  _validateOrigin2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee737(auth) {
    var _cordovaWindow5, BuildInfo, request2;

    return _regeneratorRuntime.wrap(function _callee737$(_context738) {
      while (1) {
        switch (_context738.prev = _context738.next) {
          case 0:
            _cordovaWindow5 = _cordovaWindow(), BuildInfo = _cordovaWindow5.BuildInfo;
            request2 = {};

            if (_isIOS()) {
              request2.iosBundleId = BuildInfo.packageName;
            } else if (_isAndroid()) {
              request2.androidPackageName = BuildInfo.packageName;
            } else {
              _fail(auth, "operation-not-supported-in-this-environment");
            }

            _context738.next = 5;
            return _getProjectConfig(auth, request2);

          case 5:
          case "end":
            return _context738.stop();
        }
      }
    }, _callee737);
  }));
  return _validateOrigin2.apply(this, arguments);
}

function _performRedirect(handlerUrl) {
  var _cordovaWindow2 = _cordovaWindow(),
      cordova = _cordovaWindow2.cordova;

  return new Promise(function (resolve) {
    cordova.plugins.browsertab.isAvailable(function (browserTabIsAvailable) {
      var iabRef = null;

      if (browserTabIsAvailable) {
        cordova.plugins.browsertab.openUrl(handlerUrl);
      } else {
        iabRef = cordova.InAppBrowser.open(handlerUrl, _isIOS7Or8() ? "_blank" : "_system", "location=yes");
      }

      resolve(iabRef);
    });
  });
}

function _waitForAppResume(_x1147, _x1148, _x1149) {
  return _waitForAppResume2.apply(this, arguments);
}

function _waitForAppResume2() {
  _waitForAppResume2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee738(auth, eventListener, iabRef) {
    var _cordovaWindow6, cordova, cleanup;

    return _regeneratorRuntime.wrap(function _callee738$(_context739) {
      while (1) {
        switch (_context739.prev = _context739.next) {
          case 0:
            _cordovaWindow6 = _cordovaWindow(), cordova = _cordovaWindow6.cordova;

            cleanup = function cleanup() {};

            _context739.prev = 2;
            _context739.next = 5;
            return new Promise(function (resolve, reject) {
              var onCloseTimer = null;

              function authEventSeen() {
                var _a2;

                resolve();
                var closeBrowserTab = (_a2 = cordova.plugins.browsertab) === null || _a2 === void 0 ? void 0 : _a2.close;

                if (typeof closeBrowserTab === "function") {
                  closeBrowserTab();
                }

                if (typeof (iabRef === null || iabRef === void 0 ? void 0 : iabRef.close) === "function") {
                  iabRef.close();
                }
              }

              function resumed() {
                if (onCloseTimer) {
                  return;
                }

                onCloseTimer = window.setTimeout(function () {
                  reject(_createError(auth, "redirect-cancelled-by-user"));
                }, REDIRECT_TIMEOUT_MS);
              }

              function visibilityChanged() {
                if ((document === null || document === void 0 ? void 0 : document.visibilityState) === "visible") {
                  resumed();
                }
              }

              eventListener.addPassiveListener(authEventSeen);
              document.addEventListener("resume", resumed, false);

              if (_isAndroid()) {
                document.addEventListener("visibilitychange", visibilityChanged, false);
              }

              cleanup = function cleanup() {
                eventListener.removePassiveListener(authEventSeen);
                document.removeEventListener("resume", resumed, false);
                document.removeEventListener("visibilitychange", visibilityChanged, false);

                if (onCloseTimer) {
                  window.clearTimeout(onCloseTimer);
                }
              };
            });

          case 5:
            _context739.prev = 5;
            cleanup();
            return _context739.finish(5);

          case 8:
          case "end":
            return _context739.stop();
        }
      }
    }, _callee738, null, [[2,, 5, 8]]);
  }));
  return _waitForAppResume2.apply(this, arguments);
}

function _checkCordovaConfiguration(auth) {
  var _a2, _b, _c, _d, _e2, _f, _g, _h, _j, _k;

  var win = _cordovaWindow();

  _assert$4(typeof ((_a2 = win === null || win === void 0 ? void 0 : win.universalLinks) === null || _a2 === void 0 ? void 0 : _a2.subscribe) === "function", auth, "invalid-cordova-configuration", {
    missingPlugin: "cordova-universal-links-plugin-fix"
  });

  _assert$4(typeof ((_b = win === null || win === void 0 ? void 0 : win.BuildInfo) === null || _b === void 0 ? void 0 : _b.packageName) !== "undefined", auth, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-buildInfo"
  });

  _assert$4(typeof ((_e2 = (_d = (_c = win === null || win === void 0 ? void 0 : win.cordova) === null || _c === void 0 ? void 0 : _c.plugins) === null || _d === void 0 ? void 0 : _d.browsertab) === null || _e2 === void 0 ? void 0 : _e2.openUrl) === "function", auth, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-browsertab"
  });

  _assert$4(typeof ((_h = (_g = (_f = win === null || win === void 0 ? void 0 : win.cordova) === null || _f === void 0 ? void 0 : _f.plugins) === null || _g === void 0 ? void 0 : _g.browsertab) === null || _h === void 0 ? void 0 : _h.isAvailable) === "function", auth, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-browsertab"
  });

  _assert$4(typeof ((_k = (_j = win === null || win === void 0 ? void 0 : win.cordova) === null || _j === void 0 ? void 0 : _j.InAppBrowser) === null || _k === void 0 ? void 0 : _k.open) === "function", auth, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-inappbrowser"
  });
}

function computeSha256(_x1150) {
  return _computeSha.apply(this, arguments);
}

function _computeSha() {
  _computeSha = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee739(sessionId) {
    var bytes, buf, arr;
    return _regeneratorRuntime.wrap(function _callee739$(_context740) {
      while (1) {
        switch (_context740.prev = _context740.next) {
          case 0:
            bytes = stringToArrayBuffer(sessionId);
            _context740.next = 3;
            return crypto.subtle.digest("SHA-256", bytes);

          case 3:
            buf = _context740.sent;
            arr = Array.from(new Uint8Array(buf));
            return _context740.abrupt("return", arr.map(function (num) {
              return num.toString(16).padStart(2, "0");
            }).join(""));

          case 6:
          case "end":
            return _context740.stop();
        }
      }
    }, _callee739);
  }));
  return _computeSha.apply(this, arguments);
}

function stringToArrayBuffer(str) {
  debugAssert(/[0-9a-zA-Z]+/.test(str), "Can only convert alpha-numeric strings");

  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(str);
  }

  var buff = new ArrayBuffer(str.length);
  var view = new Uint8Array(buff);

  for (var _i70 = 0; _i70 < str.length; _i70++) {
    view[_i70] = str.charCodeAt(_i70);
  }

  return view;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var SESSION_ID_LENGTH = 20;

var CordovaAuthEventManager =
/*#__PURE__*/
function (_AuthEventManager) {
  _inherits3(CordovaAuthEventManager, _AuthEventManager);

  function CordovaAuthEventManager() {
    var _this189;

    _classCallCheck3(this, CordovaAuthEventManager);

    _this189 = _possibleConstructorReturn3(this, _getPrototypeOf4(CordovaAuthEventManager).apply(this, arguments));
    _this189.passiveListeners =
    /* @__PURE__ */
    new Set();
    _this189.initPromise = new Promise(function (resolve) {
      _this189.resolveInialized = resolve;
    });
    return _this189;
  }

  _createClass3(CordovaAuthEventManager, [{
    key: "addPassiveListener",
    value: function addPassiveListener(cb) {
      this.passiveListeners.add(cb);
    }
  }, {
    key: "removePassiveListener",
    value: function removePassiveListener(cb) {
      this.passiveListeners.delete(cb);
    }
  }, {
    key: "resetRedirect",
    value: function resetRedirect() {
      this.queuedRedirectEvent = null;
      this.hasHandledPotentialRedirect = false;
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      this.resolveInialized();
      this.passiveListeners.forEach(function (cb) {
        return cb(event);
      });
      return _get2(_getPrototypeOf4(CordovaAuthEventManager.prototype), "onEvent", this).call(this, event);
    }
  }, {
    key: "initialized",
    value: function () {
      var _initialized = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee609() {
        return _regeneratorRuntime.wrap(function _callee609$(_context610) {
          while (1) {
            switch (_context610.prev = _context610.next) {
              case 0:
                _context610.next = 2;
                return this.initPromise;

              case 2:
              case "end":
                return _context610.stop();
            }
          }
        }, _callee609, this);
      }));

      function initialized() {
        return _initialized.apply(this, arguments);
      }

      return initialized;
    }()
  }]);

  return CordovaAuthEventManager;
}(AuthEventManager);

function _generateNewEvent(auth, type) {
  var eventId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: type,
    eventId: eventId,
    urlResponse: null,
    sessionId: generateSessionId(),
    postBody: null,
    tenantId: auth.tenantId,
    error: _createError(auth, "no-auth-event")
  };
}

function _savePartialEvent(auth, event) {
  return storage()._set(persistenceKey(auth), event);
}

function _getAndRemoveEvent(_x1151) {
  return _getAndRemoveEvent2.apply(this, arguments);
}

function _getAndRemoveEvent2() {
  _getAndRemoveEvent2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee740(auth) {
    var event;
    return _regeneratorRuntime.wrap(function _callee740$(_context741) {
      while (1) {
        switch (_context741.prev = _context741.next) {
          case 0:
            _context741.next = 2;
            return storage()._get(persistenceKey(auth));

          case 2:
            event = _context741.sent;

            if (!event) {
              _context741.next = 6;
              break;
            }

            _context741.next = 6;
            return storage()._remove(persistenceKey(auth));

          case 6:
            return _context741.abrupt("return", event);

          case 7:
          case "end":
            return _context741.stop();
        }
      }
    }, _callee740);
  }));
  return _getAndRemoveEvent2.apply(this, arguments);
}

function _eventFromPartialAndUrl(partialEvent, url) {
  var _a2, _b;

  var callbackUrl = _getDeepLinkFromCallback(url);

  if (callbackUrl.includes("/__/auth/callback")) {
    var params = searchParamsOrEmpty(callbackUrl);
    var errorObject = params["firebaseError"] ? parseJsonOrNull(decodeURIComponent(params["firebaseError"])) : null;
    var code = (_b = (_a2 = errorObject === null || errorObject === void 0 ? void 0 : errorObject["code"]) === null || _a2 === void 0 ? void 0 : _a2.split("auth/")) === null || _b === void 0 ? void 0 : _b[1];
    var error = code ? _createError(code) : null;

    if (error) {
      return {
        type: partialEvent.type,
        eventId: partialEvent.eventId,
        tenantId: partialEvent.tenantId,
        error: error,
        urlResponse: null,
        sessionId: null,
        postBody: null
      };
    } else {
      return {
        type: partialEvent.type,
        eventId: partialEvent.eventId,
        tenantId: partialEvent.tenantId,
        sessionId: partialEvent.sessionId,
        urlResponse: callbackUrl,
        postBody: null
      };
    }
  }

  return null;
}

function generateSessionId() {
  var chars = [];
  var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (var _i71 = 0; _i71 < SESSION_ID_LENGTH; _i71++) {
    var idx = Math.floor(Math.random() * allowedChars.length);
    chars.push(allowedChars.charAt(idx));
  }

  return chars.join("");
}

function storage() {
  return _getInstance(browserLocalPersistence);
}

function persistenceKey(auth) {
  return _persistenceKeyName("authEvent", auth.config.apiKey, auth.name);
}

function parseJsonOrNull(json) {
  try {
    return JSON.parse(json);
  } catch (e2) {
    return null;
  }
}

function _getDeepLinkFromCallback(url) {
  var params = searchParamsOrEmpty(url);
  var link = params["link"] ? decodeURIComponent(params["link"]) : void 0;
  var doubleDeepLink = searchParamsOrEmpty(link)["link"];
  var iOSDeepLink = params["deep_link_id"] ? decodeURIComponent(params["deep_link_id"]) : void 0;
  var iOSDoubleDeepLink = searchParamsOrEmpty(iOSDeepLink)["link"];
  return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}

function searchParamsOrEmpty(url) {
  if (!(url === null || url === void 0 ? void 0 : url.includes("?"))) {
    return {};
  }

  var _url$split = url.split("?"),
      _url$split2 = _toArray(_url$split),
      _2 = _url$split2[0],
      rest = _url$split2.slice(1);

  return querystringDecode(rest.join("?"));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var INITIAL_EVENT_TIMEOUT_MS = 500;

var CordovaPopupRedirectResolver =
/*#__PURE__*/
function () {
  function CordovaPopupRedirectResolver() {
    _classCallCheck3(this, CordovaPopupRedirectResolver);

    this._redirectPersistence = browserSessionPersistence;
    this._shouldInitProactively = true;
    this.eventManagers =
    /* @__PURE__ */
    new Map();
    this.originValidationPromises = {};
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  }

  _createClass3(CordovaPopupRedirectResolver, [{
    key: "_initialize",
    value: function () {
      var _initialize2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee610(auth) {
        var key, manager;
        return _regeneratorRuntime.wrap(function _callee610$(_context611) {
          while (1) {
            switch (_context611.prev = _context611.next) {
              case 0:
                key = auth._key();
                manager = this.eventManagers.get(key);

                if (!manager) {
                  manager = new CordovaAuthEventManager(auth);
                  this.eventManagers.set(key, manager);
                  this.attachCallbackListeners(auth, manager);
                }

                return _context611.abrupt("return", manager);

              case 4:
              case "end":
                return _context611.stop();
            }
          }
        }, _callee610, this);
      }));

      function _initialize(_x1152) {
        return _initialize2.apply(this, arguments);
      }

      return _initialize;
    }()
  }, {
    key: "_openPopup",
    value: function _openPopup(auth) {
      _fail(auth, "operation-not-supported-in-this-environment");
    }
  }, {
    key: "_openRedirect",
    value: function () {
      var _openRedirect3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee611(auth, provider, authType, eventId) {
        var manager, event, url, iabRef;
        return _regeneratorRuntime.wrap(function _callee611$(_context612) {
          while (1) {
            switch (_context612.prev = _context612.next) {
              case 0:
                _checkCordovaConfiguration(auth);

                _context612.next = 3;
                return this._initialize(auth);

              case 3:
                manager = _context612.sent;
                _context612.next = 6;
                return manager.initialized();

              case 6:
                manager.resetRedirect();

                _clearRedirectOutcomes();

                _context612.next = 10;
                return this._originValidation(auth);

              case 10:
                event = _generateNewEvent(auth, authType, eventId);
                _context612.next = 13;
                return _savePartialEvent(auth, event);

              case 13:
                _context612.next = 15;
                return _generateHandlerUrl(auth, event, provider);

              case 15:
                url = _context612.sent;
                _context612.next = 18;
                return _performRedirect(url);

              case 18:
                iabRef = _context612.sent;
                return _context612.abrupt("return", _waitForAppResume(auth, manager, iabRef));

              case 20:
              case "end":
                return _context612.stop();
            }
          }
        }, _callee611, this);
      }));

      function _openRedirect(_x1153, _x1154, _x1155, _x1156) {
        return _openRedirect3.apply(this, arguments);
      }

      return _openRedirect;
    }()
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(_auth, _cb) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(auth) {
      var key = auth._key();

      if (!this.originValidationPromises[key]) {
        this.originValidationPromises[key] = _validateOrigin(auth);
      }

      return this.originValidationPromises[key];
    }
  }, {
    key: "attachCallbackListeners",
    value: function attachCallbackListeners(auth, manager) {
      var _cordovaWindow3 = _cordovaWindow(),
          universalLinks = _cordovaWindow3.universalLinks,
          handleOpenURL = _cordovaWindow3.handleOpenURL,
          BuildInfo = _cordovaWindow3.BuildInfo;

      var noEventTimeout = setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee612() {
        return _regeneratorRuntime.wrap(function _callee612$(_context613) {
          while (1) {
            switch (_context613.prev = _context613.next) {
              case 0:
                _context613.next = 2;
                return _getAndRemoveEvent(auth);

              case 2:
                manager.onEvent(generateNoEvent());

              case 3:
              case "end":
                return _context613.stop();
            }
          }
        }, _callee612);
      })), INITIAL_EVENT_TIMEOUT_MS);

      var universalLinksCb =
      /*#__PURE__*/
      function () {
        var _ref606 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee613(eventData) {
          var partialEvent, finalEvent;
          return _regeneratorRuntime.wrap(function _callee613$(_context614) {
            while (1) {
              switch (_context614.prev = _context614.next) {
                case 0:
                  clearTimeout(noEventTimeout);
                  _context614.next = 3;
                  return _getAndRemoveEvent(auth);

                case 3:
                  partialEvent = _context614.sent;
                  finalEvent = null;

                  if (partialEvent && (eventData === null || eventData === void 0 ? void 0 : eventData["url"])) {
                    finalEvent = _eventFromPartialAndUrl(partialEvent, eventData["url"]);
                  }

                  manager.onEvent(finalEvent || generateNoEvent());

                case 7:
                case "end":
                  return _context614.stop();
              }
            }
          }, _callee613);
        }));

        return function universalLinksCb(_x1157) {
          return _ref606.apply(this, arguments);
        };
      }();

      if (typeof universalLinks !== "undefined" && typeof universalLinks.subscribe === "function") {
        universalLinks.subscribe(null, universalLinksCb);
      }

      var existingHandleOpenURL = handleOpenURL;
      var packagePrefix = "".concat(BuildInfo.packageName.toLowerCase(), "://");

      _cordovaWindow().handleOpenURL =
      /*#__PURE__*/
      function () {
        var _ref607 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee614(url) {
          return _regeneratorRuntime.wrap(function _callee614$(_context615) {
            while (1) {
              switch (_context615.prev = _context615.next) {
                case 0:
                  if (url.toLowerCase().startsWith(packagePrefix)) {
                    universalLinksCb({
                      url: url
                    });
                  }

                  if (typeof existingHandleOpenURL === "function") {
                    try {
                      existingHandleOpenURL(url);
                    } catch (e2) {
                      console.error(e2);
                    }
                  }

                case 2:
                case "end":
                  return _context615.stop();
              }
            }
          }, _callee614);
        }));

        return function (_x1158) {
          return _ref607.apply(this, arguments);
        };
      }();
    }
  }]);

  return CordovaPopupRedirectResolver;
}();

var cordovaPopupRedirectResolver = CordovaPopupRedirectResolver;

function generateNoEvent() {
  return {
    type: "unknown",
    eventId: null,
    sessionId: null,
    urlResponse: null,
    postBody: null,
    tenantId: null,
    error: _createError("no-auth-event")
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _addFrameworkForLogging(auth, framework) {
  _castAuth(auth)._logFramework(framework);
}

var name = "@firebase/auth-compat";
var version = "0.4.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CORDOVA_ONDEVICEREADY_TIMEOUT_MS = 1e3;

function _getCurrentScheme() {
  var _a2;

  return ((_a2 = self === null || self === void 0 ? void 0 : self.location) === null || _a2 === void 0 ? void 0 : _a2.protocol) || null;
}

function _isHttpOrHttps() {
  return _getCurrentScheme() === "http:" || _getCurrentScheme() === "https:";
}

function _isAndroidOrIosCordovaScheme() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return !!((_getCurrentScheme() === "file:" || _getCurrentScheme() === "ionic:" || _getCurrentScheme() === "capacitor:") && ua2.toLowerCase().match(/iphone|ipad|ipod|android/));
}

function _isNativeEnvironment() {
  return isReactNative() || isNode$1();
}

function _isIe11() {
  return isIE() && (document === null || document === void 0 ? void 0 : document.documentMode) === 11;
}

function _isEdge() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /Edge\/\d+/.test(ua2);
}

function _isLocalStorageNotSynchronized() {
  var ua2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return _isIe11() || _isEdge(ua2);
}

function _isWebStorageSupported() {
  try {
    var storage2 = self.localStorage;

    var key = _generateEventId();

    if (storage2) {
      storage2["setItem"](key, "1");
      storage2["removeItem"](key);

      if (_isLocalStorageNotSynchronized()) {
        return isIndexedDBAvailable();
      }

      return true;
    }
  } catch (e2) {
    return _isWorker() && isIndexedDBAvailable();
  }

  return false;
}

function _isWorker() {
  return typeof global !== "undefined" && "WorkerGlobalScope" in global && "importScripts" in global;
}

function _isPopupRedirectSupported() {
  return (_isHttpOrHttps() || isBrowserExtension() || _isAndroidOrIosCordovaScheme()) && !_isNativeEnvironment() && _isWebStorageSupported() && !_isWorker();
}

function _isLikelyCordova() {
  return _isAndroidOrIosCordovaScheme() && typeof document !== "undefined";
}

function _isCordova() {
  return _isCordova2.apply(this, arguments);
}

function _isCordova2() {
  _isCordova2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee741() {
    return _regeneratorRuntime.wrap(function _callee741$(_context742) {
      while (1) {
        switch (_context742.prev = _context742.next) {
          case 0:
            if (_isLikelyCordova()) {
              _context742.next = 2;
              break;
            }

            return _context742.abrupt("return", false);

          case 2:
            return _context742.abrupt("return", new Promise(function (resolve) {
              var timeoutId = setTimeout(function () {
                resolve(false);
              }, CORDOVA_ONDEVICEREADY_TIMEOUT_MS);
              document.addEventListener("deviceready", function () {
                clearTimeout(timeoutId);
                resolve(true);
              });
            }));

          case 3:
          case "end":
            return _context742.stop();
        }
      }
    }, _callee741);
  }));
  return _isCordova2.apply(this, arguments);
}

function _getSelfWindow() {
  return typeof window !== "undefined" ? window : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Persistence = {
  LOCAL: "local",
  NONE: "none",
  SESSION: "session"
};
var _assert$3 = _assert$4;
var PERSISTENCE_KEY = "persistence";

function _validatePersistenceArgument(auth, persistence) {
  _assert$3(Object.values(Persistence).includes(persistence), auth, "invalid-persistence-type");

  if (isReactNative()) {
    _assert$3(persistence !== Persistence.SESSION, auth, "unsupported-persistence-type");

    return;
  }

  if (isNode$1()) {
    _assert$3(persistence === Persistence.NONE, auth, "unsupported-persistence-type");

    return;
  }

  if (_isWorker()) {
    _assert$3(persistence === Persistence.NONE || persistence === Persistence.LOCAL && isIndexedDBAvailable(), auth, "unsupported-persistence-type");

    return;
  }

  _assert$3(persistence === Persistence.NONE || _isWebStorageSupported(), auth, "unsupported-persistence-type");
}

function _savePersistenceForRedirect(_x1159) {
  return _savePersistenceForRedirect2.apply(this, arguments);
}

function _savePersistenceForRedirect2() {
  _savePersistenceForRedirect2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee742(auth) {
    var session, key;
    return _regeneratorRuntime.wrap(function _callee742$(_context743) {
      while (1) {
        switch (_context743.prev = _context743.next) {
          case 0:
            _context743.next = 2;
            return auth._initializationPromise;

          case 2:
            session = getSessionStorageIfAvailable();
            key = _persistenceKeyName(PERSISTENCE_KEY, auth.config.apiKey, auth.name);

            if (session) {
              session.setItem(key, auth._getPersistence());
            }

          case 5:
          case "end":
            return _context743.stop();
        }
      }
    }, _callee742);
  }));
  return _savePersistenceForRedirect2.apply(this, arguments);
}

function _getPersistencesFromRedirect(apiKey, appName) {
  var session = getSessionStorageIfAvailable();

  if (!session) {
    return [];
  }

  var key = _persistenceKeyName(PERSISTENCE_KEY, apiKey, appName);

  var persistence = session.getItem(key);

  switch (persistence) {
    case Persistence.NONE:
      return [inMemoryPersistence];

    case Persistence.LOCAL:
      return [indexedDBLocalPersistence, browserSessionPersistence];

    case Persistence.SESSION:
      return [browserSessionPersistence];

    default:
      return [];
  }
}

function getSessionStorageIfAvailable() {
  var _a2;

  try {
    return ((_a2 = _getSelfWindow()) === null || _a2 === void 0 ? void 0 : _a2.sessionStorage) || null;
  } catch (e2) {
    return null;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _assert$2 = _assert$4;

var CompatPopupRedirectResolver =
/*#__PURE__*/
function () {
  function CompatPopupRedirectResolver() {
    _classCallCheck3(this, CompatPopupRedirectResolver);

    this.browserResolver = _getInstance(browserPopupRedirectResolver);
    this.cordovaResolver = _getInstance(cordovaPopupRedirectResolver);
    this.underlyingResolver = null;
    this._redirectPersistence = browserSessionPersistence;
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  }

  _createClass3(CompatPopupRedirectResolver, [{
    key: "_initialize",
    value: function () {
      var _initialize3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee615(auth) {
        return _regeneratorRuntime.wrap(function _callee615$(_context616) {
          while (1) {
            switch (_context616.prev = _context616.next) {
              case 0:
                _context616.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context616.abrupt("return", this.assertedUnderlyingResolver._initialize(auth));

              case 3:
              case "end":
                return _context616.stop();
            }
          }
        }, _callee615, this);
      }));

      function _initialize(_x1160) {
        return _initialize3.apply(this, arguments);
      }

      return _initialize;
    }()
  }, {
    key: "_openPopup",
    value: function () {
      var _openPopup3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee616(auth, provider, authType, eventId) {
        return _regeneratorRuntime.wrap(function _callee616$(_context617) {
          while (1) {
            switch (_context617.prev = _context617.next) {
              case 0:
                _context617.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context617.abrupt("return", this.assertedUnderlyingResolver._openPopup(auth, provider, authType, eventId));

              case 3:
              case "end":
                return _context617.stop();
            }
          }
        }, _callee616, this);
      }));

      function _openPopup(_x1161, _x1162, _x1163, _x1164) {
        return _openPopup3.apply(this, arguments);
      }

      return _openPopup;
    }()
  }, {
    key: "_openRedirect",
    value: function () {
      var _openRedirect4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee617(auth, provider, authType, eventId) {
        return _regeneratorRuntime.wrap(function _callee617$(_context618) {
          while (1) {
            switch (_context618.prev = _context618.next) {
              case 0:
                _context618.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context618.abrupt("return", this.assertedUnderlyingResolver._openRedirect(auth, provider, authType, eventId));

              case 3:
              case "end":
                return _context618.stop();
            }
          }
        }, _callee617, this);
      }));

      function _openRedirect(_x1165, _x1166, _x1167, _x1168) {
        return _openRedirect4.apply(this, arguments);
      }

      return _openRedirect;
    }()
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(auth, cb) {
      this.assertedUnderlyingResolver._isIframeWebStorageSupported(auth, cb);
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(auth) {
      return this.assertedUnderlyingResolver._originValidation(auth);
    }
  }, {
    key: "selectUnderlyingResolver",
    value: function () {
      var _selectUnderlyingResolver = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee618() {
        var isCordova;
        return _regeneratorRuntime.wrap(function _callee618$(_context619) {
          while (1) {
            switch (_context619.prev = _context619.next) {
              case 0:
                if (!this.underlyingResolver) {
                  _context619.next = 2;
                  break;
                }

                return _context619.abrupt("return");

              case 2:
                _context619.next = 4;
                return _isCordova();

              case 4:
                isCordova = _context619.sent;
                this.underlyingResolver = isCordova ? this.cordovaResolver : this.browserResolver;

              case 6:
              case "end":
                return _context619.stop();
            }
          }
        }, _callee618, this);
      }));

      function selectUnderlyingResolver() {
        return _selectUnderlyingResolver.apply(this, arguments);
      }

      return selectUnderlyingResolver;
    }()
  }, {
    key: "_shouldInitProactively",
    get: function get() {
      return _isLikelyCordova() || this.browserResolver._shouldInitProactively;
    }
  }, {
    key: "assertedUnderlyingResolver",
    get: function get() {
      _assert$2(this.underlyingResolver, "internal-error");

      return this.underlyingResolver;
    }
  }]);

  return CompatPopupRedirectResolver;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function unwrap(object) {
  return object.unwrap();
}

function wrapped(object) {
  return object.wrapped();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function credentialFromResponse(userCredential) {
  return credentialFromObject(userCredential);
}

function attachExtraErrorFields(auth, e2) {
  var _a2;

  var response = (_a2 = e2.customData) === null || _a2 === void 0 ? void 0 : _a2._tokenResponse;

  if ((e2 === null || e2 === void 0 ? void 0 : e2.code) === "auth/multi-factor-auth-required") {
    var mfaErr = e2;
    mfaErr.resolver = new MultiFactorResolver(auth, getMultiFactorResolver(auth, e2));
  } else if (response) {
    var credential = credentialFromObject(e2);
    var credErr = e2;

    if (credential) {
      credErr.credential = credential;
      credErr.tenantId = response.tenantId || void 0;
      credErr.email = response.email || void 0;
      credErr.phoneNumber = response.phoneNumber || void 0;
    }
  }
}

function credentialFromObject(object) {
  var _ref608 = object instanceof FirebaseError ? object.customData : object,
      _tokenResponse = _ref608._tokenResponse;

  if (!_tokenResponse) {
    return null;
  }

  if (!(object instanceof FirebaseError)) {
    if ("temporaryProof" in _tokenResponse && "phoneNumber" in _tokenResponse) {
      return PhoneAuthProvider$1.credentialFromResult(object);
    }
  }

  var providerId = _tokenResponse.providerId;

  if (!providerId || providerId === ProviderId.PASSWORD) {
    return null;
  }

  var provider;

  switch (providerId) {
    case ProviderId.GOOGLE:
      provider = GoogleAuthProvider;
      break;

    case ProviderId.FACEBOOK:
      provider = FacebookAuthProvider;
      break;

    case ProviderId.GITHUB:
      provider = GithubAuthProvider;
      break;

    case ProviderId.TWITTER:
      provider = TwitterAuthProvider;
      break;

    default:
      var oauthIdToken = _tokenResponse.oauthIdToken,
          oauthAccessToken = _tokenResponse.oauthAccessToken,
          oauthTokenSecret = _tokenResponse.oauthTokenSecret,
          pendingToken = _tokenResponse.pendingToken,
          nonce = _tokenResponse.nonce;

      if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) {
        return null;
      }

      if (pendingToken) {
        if (providerId.startsWith("saml.")) {
          return SAMLAuthCredential._create(providerId, pendingToken);
        } else {
          return OAuthCredential._fromParams({
            providerId: providerId,
            signInMethod: providerId,
            pendingToken: pendingToken,
            idToken: oauthIdToken,
            accessToken: oauthAccessToken
          });
        }
      }

      return new OAuthProvider(providerId).credential({
        idToken: oauthIdToken,
        accessToken: oauthAccessToken,
        rawNonce: nonce
      });
  }

  return object instanceof FirebaseError ? provider.credentialFromError(object) : provider.credentialFromResult(object);
}

function convertCredential(auth, credentialPromise) {
  return credentialPromise.catch(function (e2) {
    if (e2 instanceof FirebaseError) {
      attachExtraErrorFields(auth, e2);
    }

    throw e2;
  }).then(function (credential) {
    var operationType = credential.operationType;
    var user = credential.user;
    return {
      operationType: operationType,
      credential: credentialFromResponse(credential),
      additionalUserInfo: getAdditionalUserInfo(credential),
      user: User.getOrCreate(user)
    };
  });
}

function convertConfirmationResult(_x1169, _x1170) {
  return _convertConfirmationResult.apply(this, arguments);
}

function _convertConfirmationResult() {
  _convertConfirmationResult = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee743(auth, confirmationResultPromise) {
    var confirmationResultExp;
    return _regeneratorRuntime.wrap(function _callee743$(_context744) {
      while (1) {
        switch (_context744.prev = _context744.next) {
          case 0:
            _context744.next = 2;
            return confirmationResultPromise;

          case 2:
            confirmationResultExp = _context744.sent;
            return _context744.abrupt("return", {
              verificationId: confirmationResultExp.verificationId,
              confirm: function confirm(verificationCode) {
                return convertCredential(auth, confirmationResultExp.confirm(verificationCode));
              }
            });

          case 4:
          case "end":
            return _context744.stop();
        }
      }
    }, _callee743);
  }));
  return _convertConfirmationResult.apply(this, arguments);
}

var MultiFactorResolver =
/*#__PURE__*/
function () {
  function MultiFactorResolver(auth, resolver) {
    _classCallCheck3(this, MultiFactorResolver);

    this.resolver = resolver;
    this.auth = wrapped(auth);
  }

  _createClass3(MultiFactorResolver, [{
    key: "resolveSignIn",
    value: function resolveSignIn(assertion) {
      return convertCredential(unwrap(this.auth), this.resolver.resolveSignIn(assertion));
    }
  }, {
    key: "session",
    get: function get() {
      return this.resolver.session;
    }
  }, {
    key: "hints",
    get: function get() {
      return this.resolver.hints;
    }
  }]);

  return MultiFactorResolver;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var User =
/*#__PURE__*/
function () {
  function User(_delegate) {
    _classCallCheck3(this, User);

    this._delegate = _delegate;
    this.multiFactor = multiFactor(_delegate);
  }

  _createClass3(User, [{
    key: "delete",
    value: function _delete() {
      return this._delegate.delete();
    }
  }, {
    key: "reload",
    value: function reload() {
      return this._delegate.reload();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._delegate.toJSON();
    }
  }, {
    key: "getIdTokenResult",
    value: function getIdTokenResult(forceRefresh) {
      return this._delegate.getIdTokenResult(forceRefresh);
    }
  }, {
    key: "getIdToken",
    value: function getIdToken(forceRefresh) {
      return this._delegate.getIdToken(forceRefresh);
    }
  }, {
    key: "linkAndRetrieveDataWithCredential",
    value: function linkAndRetrieveDataWithCredential(credential) {
      return this.linkWithCredential(credential);
    }
  }, {
    key: "linkWithCredential",
    value: function () {
      var _linkWithCredential3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee619(credential) {
        return _regeneratorRuntime.wrap(function _callee619$(_context620) {
          while (1) {
            switch (_context620.prev = _context620.next) {
              case 0:
                return _context620.abrupt("return", convertCredential(this.auth, _linkWithCredential2(this._delegate, credential)));

              case 1:
              case "end":
                return _context620.stop();
            }
          }
        }, _callee619, this);
      }));

      function linkWithCredential(_x1171) {
        return _linkWithCredential3.apply(this, arguments);
      }

      return linkWithCredential;
    }()
  }, {
    key: "linkWithPhoneNumber",
    value: function () {
      var _linkWithPhoneNumber3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee620(phoneNumber, applicationVerifier) {
        return _regeneratorRuntime.wrap(function _callee620$(_context621) {
          while (1) {
            switch (_context621.prev = _context621.next) {
              case 0:
                return _context621.abrupt("return", convertConfirmationResult(this.auth, _linkWithPhoneNumber2(this._delegate, phoneNumber, applicationVerifier)));

              case 1:
              case "end":
                return _context621.stop();
            }
          }
        }, _callee620, this);
      }));

      function linkWithPhoneNumber(_x1172, _x1173) {
        return _linkWithPhoneNumber3.apply(this, arguments);
      }

      return linkWithPhoneNumber;
    }()
  }, {
    key: "linkWithPopup",
    value: function () {
      var _linkWithPopup3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee621(provider) {
        return _regeneratorRuntime.wrap(function _callee621$(_context622) {
          while (1) {
            switch (_context622.prev = _context622.next) {
              case 0:
                return _context622.abrupt("return", convertCredential(this.auth, _linkWithPopup2(this._delegate, provider, CompatPopupRedirectResolver)));

              case 1:
              case "end":
                return _context622.stop();
            }
          }
        }, _callee621, this);
      }));

      function linkWithPopup(_x1174) {
        return _linkWithPopup3.apply(this, arguments);
      }

      return linkWithPopup;
    }()
  }, {
    key: "linkWithRedirect",
    value: function () {
      var _linkWithRedirect4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee622(provider) {
        return _regeneratorRuntime.wrap(function _callee622$(_context623) {
          while (1) {
            switch (_context623.prev = _context623.next) {
              case 0:
                _context623.next = 2;
                return _savePersistenceForRedirect(_castAuth(this.auth));

              case 2:
                return _context623.abrupt("return", _linkWithRedirect3(this._delegate, provider, CompatPopupRedirectResolver));

              case 3:
              case "end":
                return _context623.stop();
            }
          }
        }, _callee622, this);
      }));

      function linkWithRedirect(_x1175) {
        return _linkWithRedirect4.apply(this, arguments);
      }

      return linkWithRedirect;
    }()
  }, {
    key: "reauthenticateAndRetrieveDataWithCredential",
    value: function reauthenticateAndRetrieveDataWithCredential(credential) {
      return this.reauthenticateWithCredential(credential);
    }
  }, {
    key: "reauthenticateWithCredential",
    value: function () {
      var _reauthenticateWithCredential3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee623(credential) {
        return _regeneratorRuntime.wrap(function _callee623$(_context624) {
          while (1) {
            switch (_context624.prev = _context624.next) {
              case 0:
                return _context624.abrupt("return", convertCredential(this.auth, _reauthenticateWithCredential2(this._delegate, credential)));

              case 1:
              case "end":
                return _context624.stop();
            }
          }
        }, _callee623, this);
      }));

      function reauthenticateWithCredential(_x1176) {
        return _reauthenticateWithCredential3.apply(this, arguments);
      }

      return reauthenticateWithCredential;
    }()
  }, {
    key: "reauthenticateWithPhoneNumber",
    value: function reauthenticateWithPhoneNumber(phoneNumber, applicationVerifier) {
      return convertConfirmationResult(this.auth, _reauthenticateWithPhoneNumber2(this._delegate, phoneNumber, applicationVerifier));
    }
  }, {
    key: "reauthenticateWithPopup",
    value: function reauthenticateWithPopup(provider) {
      return convertCredential(this.auth, _reauthenticateWithPopup2(this._delegate, provider, CompatPopupRedirectResolver));
    }
  }, {
    key: "reauthenticateWithRedirect",
    value: function () {
      var _reauthenticateWithRedirect4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee624(provider) {
        return _regeneratorRuntime.wrap(function _callee624$(_context625) {
          while (1) {
            switch (_context625.prev = _context625.next) {
              case 0:
                _context625.next = 2;
                return _savePersistenceForRedirect(_castAuth(this.auth));

              case 2:
                return _context625.abrupt("return", _reauthenticateWithRedirect3(this._delegate, provider, CompatPopupRedirectResolver));

              case 3:
              case "end":
                return _context625.stop();
            }
          }
        }, _callee624, this);
      }));

      function reauthenticateWithRedirect(_x1177) {
        return _reauthenticateWithRedirect4.apply(this, arguments);
      }

      return reauthenticateWithRedirect;
    }()
  }, {
    key: "sendEmailVerification",
    value: function sendEmailVerification(actionCodeSettings) {
      return _sendEmailVerification2(this._delegate, actionCodeSettings);
    }
  }, {
    key: "unlink",
    value: function () {
      var _unlink3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee625(providerId) {
        return _regeneratorRuntime.wrap(function _callee625$(_context626) {
          while (1) {
            switch (_context626.prev = _context626.next) {
              case 0:
                _context626.next = 2;
                return _unlink2(this._delegate, providerId);

              case 2:
                return _context626.abrupt("return", this);

              case 3:
              case "end":
                return _context626.stop();
            }
          }
        }, _callee625, this);
      }));

      function unlink(_x1178) {
        return _unlink3.apply(this, arguments);
      }

      return unlink;
    }()
  }, {
    key: "updateEmail",
    value: function updateEmail(newEmail) {
      return _updateEmail(this._delegate, newEmail);
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(newPassword) {
      return _updatePassword(this._delegate, newPassword);
    }
  }, {
    key: "updatePhoneNumber",
    value: function updatePhoneNumber(phoneCredential) {
      return _updatePhoneNumber2(this._delegate, phoneCredential);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(profile) {
      return _updateProfile2(this._delegate, profile);
    }
  }, {
    key: "verifyBeforeUpdateEmail",
    value: function verifyBeforeUpdateEmail(newEmail, actionCodeSettings) {
      return _verifyBeforeUpdateEmail2(this._delegate, newEmail, actionCodeSettings);
    }
  }, {
    key: "emailVerified",
    get: function get() {
      return this._delegate.emailVerified;
    }
  }, {
    key: "isAnonymous",
    get: function get() {
      return this._delegate.isAnonymous;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this._delegate.metadata;
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._delegate.phoneNumber;
    }
  }, {
    key: "providerData",
    get: function get() {
      return this._delegate.providerData;
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this._delegate.refreshToken;
    }
  }, {
    key: "tenantId",
    get: function get() {
      return this._delegate.tenantId;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this._delegate.displayName;
    }
  }, {
    key: "email",
    get: function get() {
      return this._delegate.email;
    }
  }, {
    key: "photoURL",
    get: function get() {
      return this._delegate.photoURL;
    }
  }, {
    key: "providerId",
    get: function get() {
      return this._delegate.providerId;
    }
  }, {
    key: "uid",
    get: function get() {
      return this._delegate.uid;
    }
  }, {
    key: "auth",
    get: function get() {
      return this._delegate.auth;
    }
  }], [{
    key: "getOrCreate",
    value: function getOrCreate(user) {
      if (!User.USER_MAP.has(user)) {
        User.USER_MAP.set(user, new User(user));
      }

      return User.USER_MAP.get(user);
    }
  }]);

  return User;
}();

User.USER_MAP =
/* @__PURE__ */
new WeakMap();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _assert$1 = _assert$4;

var Auth =
/*#__PURE__*/
function () {
  function Auth(app, provider) {
    _classCallCheck3(this, Auth);

    this.app = app;

    if (provider.isInitialized()) {
      this._delegate = provider.getImmediate();
      this.linkUnderlyingAuth();
      return;
    }

    var apiKey = app.options.apiKey;

    _assert$1(apiKey, "invalid-api-key", {
      appName: app.name
    });

    _assert$1(apiKey, "invalid-api-key", {
      appName: app.name
    });

    var resolver = typeof window !== "undefined" ? CompatPopupRedirectResolver : void 0;
    this._delegate = provider.initialize({
      options: {
        persistence: buildPersistenceHierarchy(apiKey, app.name),
        popupRedirectResolver: resolver
      }
    });

    this._delegate._updateErrorMap(debugErrorMap);

    this.linkUnderlyingAuth();
  }

  _createClass3(Auth, [{
    key: "useDeviceLanguage",
    value: function useDeviceLanguage() {
      this._delegate.useDeviceLanguage();
    }
  }, {
    key: "signOut",
    value: function signOut() {
      return this._delegate.signOut();
    }
  }, {
    key: "useEmulator",
    value: function useEmulator(url, options2) {
      connectAuthEmulator(this._delegate, url, options2);
    }
  }, {
    key: "applyActionCode",
    value: function applyActionCode(code) {
      return _applyActionCode2(this._delegate, code);
    }
  }, {
    key: "checkActionCode",
    value: function checkActionCode(code) {
      return _checkActionCode2(this._delegate, code);
    }
  }, {
    key: "confirmPasswordReset",
    value: function confirmPasswordReset(code, newPassword) {
      return _confirmPasswordReset2(this._delegate, code, newPassword);
    }
  }, {
    key: "createUserWithEmailAndPassword",
    value: function () {
      var _createUserWithEmailAndPassword3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee626(email, password) {
        return _regeneratorRuntime.wrap(function _callee626$(_context627) {
          while (1) {
            switch (_context627.prev = _context627.next) {
              case 0:
                return _context627.abrupt("return", convertCredential(this._delegate, _createUserWithEmailAndPassword2(this._delegate, email, password)));

              case 1:
              case "end":
                return _context627.stop();
            }
          }
        }, _callee626, this);
      }));

      function createUserWithEmailAndPassword(_x1179, _x1180) {
        return _createUserWithEmailAndPassword3.apply(this, arguments);
      }

      return createUserWithEmailAndPassword;
    }()
  }, {
    key: "fetchProvidersForEmail",
    value: function fetchProvidersForEmail(email) {
      return this.fetchSignInMethodsForEmail(email);
    }
  }, {
    key: "fetchSignInMethodsForEmail",
    value: function fetchSignInMethodsForEmail(email) {
      return _fetchSignInMethodsForEmail2(this._delegate, email);
    }
  }, {
    key: "isSignInWithEmailLink",
    value: function isSignInWithEmailLink(emailLink) {
      return _isSignInWithEmailLink(this._delegate, emailLink);
    }
  }, {
    key: "getRedirectResult",
    value: function () {
      var _getRedirectResult5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee627() {
        var credential;
        return _regeneratorRuntime.wrap(function _callee627$(_context628) {
          while (1) {
            switch (_context628.prev = _context628.next) {
              case 0:
                _assert$1(_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment");

                _context628.next = 3;
                return _getRedirectResult4(this._delegate, CompatPopupRedirectResolver);

              case 3:
                credential = _context628.sent;

                if (credential) {
                  _context628.next = 6;
                  break;
                }

                return _context628.abrupt("return", {
                  credential: null,
                  user: null
                });

              case 6:
                return _context628.abrupt("return", convertCredential(this._delegate, Promise.resolve(credential)));

              case 7:
              case "end":
                return _context628.stop();
            }
          }
        }, _callee627, this);
      }));

      function getRedirectResult() {
        return _getRedirectResult5.apply(this, arguments);
      }

      return getRedirectResult;
    }()
  }, {
    key: "addFrameworkForLogging",
    value: function addFrameworkForLogging(framework) {
      _addFrameworkForLogging(this._delegate, framework);
    }
  }, {
    key: "onAuthStateChanged",
    value: function onAuthStateChanged(nextOrObserver, errorFn, completed) {
      var _wrapObservers = wrapObservers(nextOrObserver, errorFn, completed),
          next2 = _wrapObservers.next,
          error = _wrapObservers.error,
          complete = _wrapObservers.complete;

      return this._delegate.onAuthStateChanged(next2, error, complete);
    }
  }, {
    key: "onIdTokenChanged",
    value: function onIdTokenChanged(nextOrObserver, errorFn, completed) {
      var _wrapObservers2 = wrapObservers(nextOrObserver, errorFn, completed),
          next2 = _wrapObservers2.next,
          error = _wrapObservers2.error,
          complete = _wrapObservers2.complete;

      return this._delegate.onIdTokenChanged(next2, error, complete);
    }
  }, {
    key: "sendSignInLinkToEmail",
    value: function sendSignInLinkToEmail(email, actionCodeSettings) {
      return _sendSignInLinkToEmail2(this._delegate, email, actionCodeSettings);
    }
  }, {
    key: "sendPasswordResetEmail",
    value: function sendPasswordResetEmail(email, actionCodeSettings) {
      return _sendPasswordResetEmail2(this._delegate, email, actionCodeSettings || void 0);
    }
  }, {
    key: "setPersistence",
    value: function () {
      var _setPersistence2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee628(persistence) {
        var converted, isIndexedDBFullySupported;
        return _regeneratorRuntime.wrap(function _callee628$(_context629) {
          while (1) {
            switch (_context629.prev = _context629.next) {
              case 0:
                _validatePersistenceArgument(this._delegate, persistence);

                _context629.t0 = persistence;
                _context629.next = _context629.t0 === Persistence.SESSION ? 4 : _context629.t0 === Persistence.LOCAL ? 6 : _context629.t0 === Persistence.NONE ? 11 : 13;
                break;

              case 4:
                converted = browserSessionPersistence;
                return _context629.abrupt("break", 14);

              case 6:
                _context629.next = 8;
                return _getInstance(indexedDBLocalPersistence)._isAvailable();

              case 8:
                isIndexedDBFullySupported = _context629.sent;
                converted = isIndexedDBFullySupported ? indexedDBLocalPersistence : browserLocalPersistence;
                return _context629.abrupt("break", 14);

              case 11:
                converted = inMemoryPersistence;
                return _context629.abrupt("break", 14);

              case 13:
                return _context629.abrupt("return", _fail("argument-error", {
                  appName: this._delegate.name
                }));

              case 14:
                return _context629.abrupt("return", this._delegate.setPersistence(converted));

              case 15:
              case "end":
                return _context629.stop();
            }
          }
        }, _callee628, this);
      }));

      function setPersistence(_x1181) {
        return _setPersistence2.apply(this, arguments);
      }

      return setPersistence;
    }()
  }, {
    key: "signInAndRetrieveDataWithCredential",
    value: function signInAndRetrieveDataWithCredential(credential) {
      return this.signInWithCredential(credential);
    }
  }, {
    key: "signInAnonymously",
    value: function signInAnonymously() {
      return convertCredential(this._delegate, _signInAnonymously2(this._delegate));
    }
  }, {
    key: "signInWithCredential",
    value: function signInWithCredential(credential) {
      return convertCredential(this._delegate, _signInWithCredential4(this._delegate, credential));
    }
  }, {
    key: "signInWithCustomToken",
    value: function signInWithCustomToken(token2) {
      return convertCredential(this._delegate, _signInWithCustomToken2(this._delegate, token2));
    }
  }, {
    key: "signInWithEmailAndPassword",
    value: function signInWithEmailAndPassword(email, password) {
      return convertCredential(this._delegate, _signInWithEmailAndPassword(this._delegate, email, password));
    }
  }, {
    key: "signInWithEmailLink",
    value: function signInWithEmailLink(email, emailLink) {
      return convertCredential(this._delegate, _signInWithEmailLink2(this._delegate, email, emailLink));
    }
  }, {
    key: "signInWithPhoneNumber",
    value: function signInWithPhoneNumber(phoneNumber, applicationVerifier) {
      return convertConfirmationResult(this._delegate, _signInWithPhoneNumber2(this._delegate, phoneNumber, applicationVerifier));
    }
  }, {
    key: "signInWithPopup",
    value: function () {
      var _signInWithPopup3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee629(provider) {
        return _regeneratorRuntime.wrap(function _callee629$(_context630) {
          while (1) {
            switch (_context630.prev = _context630.next) {
              case 0:
                _assert$1(_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment");

                return _context630.abrupt("return", convertCredential(this._delegate, _signInWithPopup2(this._delegate, provider, CompatPopupRedirectResolver)));

              case 2:
              case "end":
                return _context630.stop();
            }
          }
        }, _callee629, this);
      }));

      function signInWithPopup(_x1182) {
        return _signInWithPopup3.apply(this, arguments);
      }

      return signInWithPopup;
    }()
  }, {
    key: "signInWithRedirect",
    value: function () {
      var _signInWithRedirect4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee630(provider) {
        return _regeneratorRuntime.wrap(function _callee630$(_context631) {
          while (1) {
            switch (_context631.prev = _context631.next) {
              case 0:
                _assert$1(_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment");

                _context631.next = 3;
                return _savePersistenceForRedirect(this._delegate);

              case 3:
                return _context631.abrupt("return", _signInWithRedirect3(this._delegate, provider, CompatPopupRedirectResolver));

              case 4:
              case "end":
                return _context631.stop();
            }
          }
        }, _callee630, this);
      }));

      function signInWithRedirect(_x1183) {
        return _signInWithRedirect4.apply(this, arguments);
      }

      return signInWithRedirect;
    }()
  }, {
    key: "updateCurrentUser",
    value: function updateCurrentUser(user) {
      return this._delegate.updateCurrentUser(user);
    }
  }, {
    key: "verifyPasswordResetCode",
    value: function verifyPasswordResetCode(code) {
      return _verifyPasswordResetCode2(this._delegate, code);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._delegate;
    }
  }, {
    key: "_delete",
    value: function _delete() {
      return this._delegate._delete();
    }
  }, {
    key: "linkUnderlyingAuth",
    value: function linkUnderlyingAuth() {
      var _this190 = this;

      this._delegate.wrapped = function () {
        return _this190;
      };
    }
  }, {
    key: "emulatorConfig",
    get: function get() {
      return this._delegate.emulatorConfig;
    }
  }, {
    key: "currentUser",
    get: function get() {
      if (!this._delegate.currentUser) {
        return null;
      }

      return User.getOrCreate(this._delegate.currentUser);
    }
  }, {
    key: "languageCode",
    get: function get() {
      return this._delegate.languageCode;
    },
    set: function set(languageCode) {
      this._delegate.languageCode = languageCode;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._delegate.settings;
    }
  }, {
    key: "tenantId",
    get: function get() {
      return this._delegate.tenantId;
    },
    set: function set(tid) {
      this._delegate.tenantId = tid;
    }
  }]);

  return Auth;
}();

Auth.Persistence = Persistence;

function wrapObservers(nextOrObserver, error, complete) {
  var next2 = nextOrObserver;

  if (typeof nextOrObserver !== "function") {
    next2 = nextOrObserver.next;
    error = nextOrObserver.error;
    complete = nextOrObserver.complete;
  }

  var oldNext = next2;

  var newNext = function newNext(user) {
    return oldNext(user && User.getOrCreate(user));
  };

  return {
    next: newNext,
    error: error,
    complete: complete
  };
}

function buildPersistenceHierarchy(apiKey, appName) {
  var persistences = _getPersistencesFromRedirect(apiKey, appName);

  if (typeof self !== "undefined" && !persistences.includes(indexedDBLocalPersistence)) {
    persistences.push(indexedDBLocalPersistence);
  }

  if (typeof window !== "undefined") {
    for (var _i72 = 0, _arr2 = [browserLocalPersistence, browserSessionPersistence]; _i72 < _arr2.length; _i72++) {
      var persistence = _arr2[_i72];

      if (!persistences.includes(persistence)) {
        persistences.push(persistence);
      }
    }
  }

  if (!persistences.includes(inMemoryPersistence)) {
    persistences.push(inMemoryPersistence);
  }

  return persistences;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var PhoneAuthProvider =
/*#__PURE__*/
function () {
  function PhoneAuthProvider() {
    _classCallCheck3(this, PhoneAuthProvider);

    this.providerId = "phone";
    this._delegate = new PhoneAuthProvider$1(unwrap(firebase.auth()));
  }

  _createClass3(PhoneAuthProvider, [{
    key: "verifyPhoneNumber",
    value: function verifyPhoneNumber(phoneInfoOptions, applicationVerifier) {
      return this._delegate.verifyPhoneNumber(phoneInfoOptions, applicationVerifier);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._delegate;
    }
  }], [{
    key: "credential",
    value: function credential(verificationId, verificationCode) {
      return PhoneAuthProvider$1.credential(verificationId, verificationCode);
    }
  }]);

  return PhoneAuthProvider;
}();

PhoneAuthProvider.PHONE_SIGN_IN_METHOD = PhoneAuthProvider$1.PHONE_SIGN_IN_METHOD;
PhoneAuthProvider.PROVIDER_ID = PhoneAuthProvider$1.PROVIDER_ID;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _assert = _assert$4;

var RecaptchaVerifier =
/*#__PURE__*/
function () {
  function RecaptchaVerifier(container, parameters) {
    var app = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : firebase.app();

    _classCallCheck3(this, RecaptchaVerifier);

    var _a2;

    _assert((_a2 = app.options) === null || _a2 === void 0 ? void 0 : _a2.apiKey, "invalid-api-key", {
      appName: app.name
    });

    this._delegate = new RecaptchaVerifier$1(container, parameters, app.auth());
    this.type = this._delegate.type;
  }

  _createClass3(RecaptchaVerifier, [{
    key: "clear",
    value: function clear() {
      this._delegate.clear();
    }
  }, {
    key: "render",
    value: function render() {
      return this._delegate.render();
    }
  }, {
    key: "verify",
    value: function verify() {
      return this._delegate.verify();
    }
  }]);

  return RecaptchaVerifier;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var AUTH_TYPE = "auth-compat";

function registerAuthCompat(instance) {
  instance.INTERNAL.registerComponent(new Component(AUTH_TYPE, function (container) {
    var app = container.getProvider("app-compat").getImmediate();
    var authProvider = container.getProvider("auth");
    return new Auth(app, authProvider);
  }, "PUBLIC").setServiceProps({
    ActionCodeInfo: {
      Operation: {
        EMAIL_SIGNIN: ActionCodeOperation.EMAIL_SIGNIN,
        PASSWORD_RESET: ActionCodeOperation.PASSWORD_RESET,
        RECOVER_EMAIL: ActionCodeOperation.RECOVER_EMAIL,
        REVERT_SECOND_FACTOR_ADDITION: ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION,
        VERIFY_AND_CHANGE_EMAIL: ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL,
        VERIFY_EMAIL: ActionCodeOperation.VERIFY_EMAIL
      }
    },
    EmailAuthProvider: EmailAuthProvider,
    FacebookAuthProvider: FacebookAuthProvider,
    GithubAuthProvider: GithubAuthProvider,
    GoogleAuthProvider: GoogleAuthProvider,
    OAuthProvider: OAuthProvider,
    SAMLAuthProvider: SAMLAuthProvider,
    PhoneAuthProvider: PhoneAuthProvider,
    PhoneMultiFactorGenerator: PhoneMultiFactorGenerator,
    RecaptchaVerifier: RecaptchaVerifier,
    TwitterAuthProvider: TwitterAuthProvider,
    Auth: Auth,
    AuthCredential: AuthCredential,
    Error: FirebaseError
  }).setInstantiationMode("LAZY").setMultipleInstances(false));
  instance.registerVersion(name, version);
}

registerAuthCompat(firebase);

var firebaseAuth = function firebaseAuth(fansUnitedEnvironment) {
  if (fansUnitedEnvironment && fansUnitedEnvironment === "dev") {
    firebase.initializeApp({
      apiKey: "123"
    });
    var auth = getAuth();
    connectAuthEmulator(auth, "24PkUfW1ce63mH9jvAAug2QQzdASj9k5smngepPUZD2KUq5cbTFGE98KgZ0zg2wCtuQcoJrHElW7Dr0K");
  } else {
    var apiKey = fansUnitedEnvironment && fansUnitedEnvironment === "staging" ? "AIzaSyBKhAYwkvkmjm16FxCMvCUQjSRpKC0DbM8" : "AIzaSyDPD_SETLswR_U3dKawYkAyRhbzVXziD_4";
    var firebaseConfig = {
      apiKey: apiKey,
      authDomain: "fans-united-clients.firebaseapp.com",
      projectId: "fans-united-clients",
      messagingSenderId: "78627953958",
      appId: "1:78627953958:web:9e4c6caf6bd197b185f5e7",
      measurementId: "G-DPV1TYL0JW"
    };
    firebase.initializeApp(firebaseConfig);
  }

  return firebase.auth();
};

var Login = function Login(_ref609) {
  var userNotFound = _ref609.userNotFound,
      fansUnitedEnvironment = _ref609.fansUnitedEnvironment,
      setNoPermission = _ref609.setNoPermission;

  var _useState19 = useState(""),
      _useState20 = _slicedToArray3(_useState19, 2),
      email = _useState20[0],
      setEmail = _useState20[1];

  var _useState21 = useState(""),
      _useState22 = _slicedToArray3(_useState21, 2),
      password = _useState22[0],
      setPassword = _useState22[1];

  var signIn =
  /*#__PURE__*/
  function () {
    var _ref610 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee631() {
      return _regeneratorRuntime.wrap(function _callee631$(_context632) {
        while (1) {
          switch (_context632.prev = _context632.next) {
            case 0:
              _context632.prev = 0;
              _context632.next = 3;
              return firebaseAuth(fansUnitedEnvironment).signInWithEmailAndPassword(email, password);

            case 3:
              setNoPermission(false);
              _context632.next = 10;
              break;

            case 6:
              _context632.prev = 6;
              _context632.t0 = _context632["catch"](0);
              toast.error(userNotFound);
              console.error(_context632.t0);

            case 10:
            case "end":
              return _context632.stop();
          }
        }
      }, _callee631, null, [[0, 6]]);
    }));

    return function signIn() {
      return _ref610.apply(this, arguments);
    };
  }();

  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-flex topxw-items-center topxw-justify-center topxw-min-h-screen topxw-bg-gray-100",
      children:
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-px-8 topxw-py-6 topxw-mt-4 topxw-text-left topxw-bg-white topxw-shadow-lg",
        children: [
        /* @__PURE__ */
        jsx$1("h3", {
          className: "topxw-text-2xl topxw-font-bold topxw-text-center topxw-mb-4",
          children: "Sign in"
        }),
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-gray-400 topxw-text-xs topxw-mb-4 topxw-text-center",
          children: "Use your account in the Fans United platform."
        }),
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-mt-4",
          children: [
          /* @__PURE__ */
          jsxs("div", {
            children: [
            /* @__PURE__ */
            jsx$1("label", {
              className: "topxw-block",
              htmlFor: "email",
              children: "Email"
            }),
            /* @__PURE__ */
            jsx$1("input", {
              value: email,
              type: "text",
              placeholder: "Email",
              className: "topxw-w-full topxw-px-4 topxw-py-2 topxw-mt-2 topxw-border topxw-rounded-md focus:topxw-outline-none focus:topxw-ring-1 focus:topxw-ring-gray-600",
              onChange: function onChange(event) {
                event.persist();
                setEmail(event.target.value);
              }
            })]
          }),
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-mt-4",
            children: [
            /* @__PURE__ */
            jsx$1("label", {
              className: "topxw-block",
              htmlFor: "password",
              children: "Password"
            }),
            /* @__PURE__ */
            jsx$1("input", {
              value: password,
              type: "password",
              placeholder: "Password",
              className: "topxw-w-full topxw-px-4 topxw-py-2 topxw-mt-2 topxw-border topxw-rounded-md focus:topxw-outline-none focus:topxw-ring-1 focus:topxw-ring-gray-600",
              onChange: function onChange(event) {
                event.persist();
                setPassword(event.target.value);
              }
            })]
          }),
          /* @__PURE__ */
          jsx$1("div", {
            className: "topxw-flex topxw-items-baseline topxw-justify-between",
            children:
            /* @__PURE__ */
            jsx$1("button", {
              onClick: signIn,
              className: "topxw-px-6 topxw-py-2 topxw-mt-4 topxw-text-white topxw-bg-gray-600 topxw-rounded-lg hover:topxw-bg-gray-900",
              children: "Login"
            })
          })]
        })]
      })
    })
  );
};

var ButtonSpinner = function ButtonSpinner() {
  return (
    /* @__PURE__ */
    jsxs("svg", {
      className: "topxw-h-4 topxw-w-4 topxw-animate-spin topxw-mr-2",
      viewBox: "3 3 18 18",
      children: [
      /* @__PURE__ */
      jsx$1("path", {
        d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */
      jsx$1("path", {
        d: "M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z",
        fill: "currentFill"
      })]
    })
  );
};

var ManagementButton = function ManagementButton(_ref611) {
  var mainLabel = _ref611.mainLabel,
      loadingLabel = _ref611.loadingLabel,
      centerButton = _ref611.centerButton,
      isLoading = _ref611.isLoading,
      paddingX = _ref611.paddingX,
      paddingY = _ref611.paddingY,
      onClick = _ref611.onClick;
  var buttonLabel = isLoading ? loadingLabel : mainLabel;
  return (
    /* @__PURE__ */
    jsxs("button", {
      disabled: isLoading,
      "data-testid": "management button",
      onClick: onClick,
      className: "topxw-rounded topxw-bg-gray-700 topxw-text-white ".concat(isLoading ? "" : "hover:topxw-bg-gray-800", " topxw-uppercase topxw-text-xs topxw-font-bold ").concat(paddingY, " ").concat(paddingX, " ").concat(centerButton ? "topxw-flex topxw-items-center topxw-mx-auto" : ""),
      children: [isLoading ?
      /* @__PURE__ */
      jsx$1(ButtonSpinner, {}) : null, buttonLabel]
    })
  );
};

var GamesCard = function GamesCard(_ref612) {
  var children = _ref612.children;
  return (
    /* @__PURE__ */
    jsx$1("div", {
      children:
      /* @__PURE__ */
      jsx$1("section", {
        className: "topxw-mx-auto",
        children:
        /* @__PURE__ */
        jsx$1("div", {
          className: "topxw-mb-8 topxw-overflow-hidden topxw-rounded topxw-bg-white",
          children:
          /* @__PURE__ */
          jsx$1("div", {
            className: "topxw-w-full topxw-overflow-x-auto",
            children: children
          })
        })
      })
    })
  );
};

var TableHeader = function TableHeader(_ref613) {
  var labels = _ref613.labels,
      reportMode = _ref613.reportMode;

  if (reportMode) {
    return (
      /* @__PURE__ */
      jsx$1("thead", {
        className: "topxw-bg-gray-200",
        "data-testid": "report header",
        children:
        /* @__PURE__ */
        jsxs("tr", {
          className: "topxw-uppercase topxw-text-xs",
          children: [
          /* @__PURE__ */
          jsx$1("th", {
            className: "topxw-px-2 topxw-py-4 topxw-font-semibold topxw-text-center topxw-w-20",
            children: "#"
          }),
          /* @__PURE__ */
          jsx$1("th", {
            className: "topxw-text-left md:topxw-table-cell topxw-p-2 topxw-font-semibold",
            children: labels.name
          }),
          /* @__PURE__ */
          jsx$1("th", {
            className: "topxw-text-right topxw-p-2 topxw-font-semibold",
            children: labels.points
          })]
        })
      })
    );
  }

  return (
    /* @__PURE__ */
    jsx$1("thead", {
      className: "topxw-bg-gray-200",
      "data-testid": "games list header",
      children:
      /* @__PURE__ */
      jsxs("tr", {
        className: "topxw-uppercase topxw-text-xs",
        children: [
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-px-2 topxw-py-4 topxw-font-semibold topxw-text-left",
          children: labels.name
        }),
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-text-center topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
          children: labels.status
        }),
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-text-center topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
          children: labels.participants
        }),
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-text-center topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
          children: labels.creationDate
        }),
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-text-center topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
          children: labels.acceptUntil
        }),
        /* @__PURE__ */
        jsx$1("th", {
          className: "topxw-text-right topxw-p-2 topxw-font-semibold",
          children: labels.actions
        })]
      })
    })
  );
};

var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements =
/* @__PURE__ */
basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements =
/* @__PURE__ */
[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName$1(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

function getWindow$1(node2) {
  if (node2 == null) {
    return window;
  }

  if (node2.toString() !== "[object Window]") {
    var ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node2;
}

function isElement$2(node2) {
  var OwnElement = getWindow$1(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}

function isHTMLElement$1(node2) {
  var OwnElement = getWindow$1(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}

function isShadowRoot$1(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }

  var OwnElement = getWindow$1(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}

function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function (name2) {
    var style = state.styles[name2] || {};
    var attributes = state.attributes[name2] || {};
    var element = state.elements[name2];

    if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
      return;
    }

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name3) {
      var value = attributes[name3];

      if (value === false) {
        element.removeAttribute(name3);
      } else {
        element.setAttribute(name3, value === true ? "" : value);
      }
    });
  });
}

function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name2) {
      var element = state.elements[name2];
      var attributes = state.attributes[name2] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});

      if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}

var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};

function getBasePlacement$1(placement) {
  return placement.split("-")[0];
}

var max$1 = Math.max;
var min$1 = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref3 = isElement$2(element) ? getWindow$1(element) : window,
      visualViewport = _ref3.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x2 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y2 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();

  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot$1(rootNode)) {
    var next2 = child;

    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }

      next2 = next2.parentNode || next2.host;
    } while (next2);
  }

  return false;
}

function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName$1(element)) >= 0;
}

function getDocumentElement$1(element) {
  return ((isElement$2(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName$1(element) === "html") {
    return element;
  }

  return element.assignedSlot || element.parentNode || (isShadowRoot$1(element) ? element.host : null) || getDocumentElement$1(element);
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || getComputedStyle$2(element).position === "fixed") {
    return null;
  }

  return element.offsetParent;
}

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE2 = /Trident/i.test(getUAString());

  if (isIE2 && isHTMLElement$1(element)) {
    var elementCss = getComputedStyle$2(element);

    if (elementCss.position === "fixed") {
      return null;
    }
  }

  var currentNode = getParentNode$1(element);

  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$1(currentNode) && ["html", "body"].indexOf(getNodeName$1(currentNode)) < 0) {
    var css4 = getComputedStyle$2(currentNode);

    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
}

function getOffsetParent(element) {
  var window2 = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName$1(offsetParent) === "html" || getNodeName$1(offsetParent) === "body" && getComputedStyle$2(offsetParent).position === "static")) {
    return window2;
  }

  return offsetParent || getContainingBlock(element) || window2;
}

function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

function within(min2, value, max2) {
  return max$1(min2, min$1(value, max2));
}

function withinMaxClamp(min2, value, max2) {
  var v2 = within(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys2) {
  return keys2.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref3) {
  var _state$modifiersData$;

  var state = _ref3.state,
      name2 = _ref3.name,
      options2 = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement$1(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";

  if (!arrowElement || !popperOffsets2) {
    return;
  }

  var paddingObject = toPaddingObject(options2.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}

function effect$1(_ref22) {
  var state = _ref22.state,
      options2 = _ref22.options;
  var _options$element = options2.element,
      arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;

  if (arrowElement == null) {
    return;
  }

  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
}

var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

function getVariation(placement) {
  return placement.split("-")[1];
}

var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};

function roundOffsetsByDPR(_ref3, win) {
  var x2 = _ref3.x,
      y2 = _ref3.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x2 * dpr) / dpr || 0,
    y: round$1(y2 * dpr) / dpr || 0
  };
}

function mapToStyles(_ref22) {
  var _Object$assign2;

  var popper2 = _ref22.popper,
      popperRect = _ref22.popperRect,
      placement = _ref22.placement,
      variation = _ref22.variation,
      offsets = _ref22.offsets,
      position2 = _ref22.position,
      gpuAcceleration = _ref22.gpuAcceleration,
      adaptive = _ref22.adaptive,
      roundOffsets = _ref22.roundOffsets,
      isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x,
      x2 = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y2 = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };

  x2 = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";

    if (offsetParent === getWindow$1(popper2)) {
      offsetParent = getDocumentElement$1(popper2);

      if (getComputedStyle$2(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }

    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y: y2
  }, getWindow$1(popper2)) : {
    x: x2,
    y: y2
  };

  x2 = _ref4.x;
  y2 = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y2 + "px)" : "translate3d(" + x2 + "px, " + y2 + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options2 = _ref5.options;
  var _options$gpuAccelerat = options2.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options2.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options2.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement$1(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}

var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};

function effect(_ref3) {
  var state = _ref3.state,
      instance = _ref3.instance,
      options2 = _ref3.options;
  var _options$scroll = options2.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options2.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }

  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }

    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}

var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect,
  data: {}
};
var hash$2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$2[matched];
  });
}

var hash$1 = {
  start: "end",
  end: "start"
};

function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node2) {
  var win = getWindow$1(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement$1(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x2 = 0;
  var y2 = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x2 + getWindowScrollBarX(element),
    y: y2
  };
}

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement$1(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;

  if (getComputedStyle$2(body || html).direction === "rtl") {
    x2 += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x2,
    y: y2
  };
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$2(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName$1(node2)) >= 0) {
    return node2.ownerDocument.body;
  }

  if (isHTMLElement$1(node2) && isScrollParent(node2)) {
    return node2;
  }

  return getScrollParent$1(getParentNode$1(node2));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect$1(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect$1(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect$1(getViewportRect(element, strategy)) : isElement$2(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect$1(getDocumentRect(getDocumentElement$1(element)));
}

function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

  if (!isElement$2(clipperElement)) {
    return [];
  }

  return clippingParents2.filter(function (clippingParent) {
    return isElement$2(clippingParent) && contains(clippingParent, clipperElement) && getNodeName$1(clippingParent) !== "body";
  });
}

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref3) {
  var reference2 = _ref3.reference,
      element = _ref3.element,
      placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement$1(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;

    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }

  var _options = options2,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$2(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement: placement
  });
  var popperClientRect = rectToClientRect$1(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;

  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }

  var _options = options2,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }

  var overflows = allowedPlacements.reduce(function (acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement$1(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b2) {
    return overflows[a] - overflows[b2];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement$1(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref3) {
  var state = _ref3.state,
      options2 = _ref3.options,
      name2 = _ref3.name;

  if (state.modifiersData[name2]._skip) {
    return;
  }

  var _options$mainAxis = options2.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options2.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options2.fallbackPlacements,
      padding = options2.padding,
      boundary = options2.boundary,
      rootBoundary = options2.rootBoundary,
      altBoundary = options2.altBoundary,
      _options$flipVariatio = options2.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options2.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement$1(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement2) {
    return acc.concat(getBasePlacement$1(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap =
  /* @__PURE__ */
  new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];

  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];

    var _basePlacement = getBasePlacement$1(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop2(_i3) {
      var fittingPlacement = placements2.find(function (placement2) {
        var checks2 = checksMap.get(placement2);

        if (checks2) {
          return checks2.slice(0, _i3).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i2 = numberOfChecks; _i2 > 0; _i2--) {
      var _ret = _loop(_i2);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name2]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}

var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref3) {
  var state = _ref3.state,
      name2 = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name2] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}

var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement$1(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref3 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref3[0],
      distance = _ref3[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref22) {
  var state = _ref22.state,
      options2 = _ref22.options,
      name2 = _ref22.name;
  var _options$offset = options2.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data2 = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data2[state.placement],
      x2 = _data$state$placement.x,
      y2 = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y2;
  }

  state.modifiersData[name2] = data2;
}

var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};

function popperOffsets(_ref3) {
  var state = _ref3.state,
      name2 = _ref3.name;
  state.modifiersData[name2] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}

var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}

function preventOverflow(_ref3) {
  var state = _ref3.state,
      options2 = _ref3.options,
      name2 = _ref3.name;
  var _options$mainAxis = options2.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options2.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options2.boundary,
      rootBoundary = options2.rootBoundary,
      altBoundary = options2.altBoundary,
      padding = options2.padding,
      _options$tether = options2.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options2.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement$1(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data2 = {
    x: 0,
    y: 0
  };

  if (!popperOffsets2) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min2, tetherMin) : min2, offset2, tether ? max$1(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data2[mainAxis] = preventedOffset - offset2;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === "x" ? top : left;

    var _altSide = mainAxis === "x" ? bottom : right;

    var _offset = popperOffsets2[altAxis];

    var _len = altAxis === "y" ? "height" : "width";

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets2[altAxis] = _preventedOffset;
    data2[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name2] = data2;
}

var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node2) {
  if (node2 === getWindow$1(node2) || !isHTMLElement$1(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$1(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map =
  /* @__PURE__ */
  new Map();
  var visited =
  /* @__PURE__ */
  new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$3(fn3) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = void 0;
          resolve(fn3());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options2) {
    if (options2 === void 0) {
      options2 = defaultOptions;
    }

    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options3 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options3);
        state.scrollParents = {
          reference: isElement$2(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference3 = _state$elements.reference,
            popper3 = _state$elements.popper;

        if (!areValidElements(reference3, popper3)) {
          return;
        }

        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index2],
              fn3 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name2 = _state$orderedModifie.name;

          if (typeof fn3 === "function") {
            state = fn3({
              state: state,
              options: _options,
              name: name2,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce$3(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference2, popper2)) {
      return instance;
    }

    instance.setOptions(options2).then(function (state2) {
      if (!isDestroyed && options2.onFirstUpdate) {
        options2.onFirstUpdate(state2);
      }
    });

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name2 = _ref3.name,
            _ref$options = _ref3.options,
            options3 = _ref$options === void 0 ? {} : _ref$options,
            effect3 = _ref3.effect;

        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state: state,
            name: name2,
            instance: instance,
            options: options3
          });

          var noopFn = function noopFn2() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn3) {
        return fn3();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper =
/* @__PURE__ */
popperGenerator({
  defaultModifiers: defaultModifiers
});
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};

var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO2() {
  return document.body;
};

function getValueAtIndexOrReturn(value, index2, defaultValue) {
  if (Array.isArray(value)) {
    var v2 = value[index2];
    return v2 == null ? Array.isArray(defaultValue) ? defaultValue[index2] : defaultValue : v2;
  }

  return value;
}

function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}

function invokeWithArgsOrReturn(value, args) {
  return typeof value === "function" ? value.apply(void 0, args) : value;
}

function debounce$2(fn3, ms) {
  if (ms === 0) {
    return fn3;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn3(arg);
    }, ms);
  };
}

function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}

function normalizeToArray(value) {
  return [].concat(value);
}

function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}

function unique(arr) {
  return arr.filter(function (item, index2) {
    return arr.indexOf(item) === index2;
  });
}

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

function arrayFrom(value) {
  return [].slice.call(value);
}

function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== void 0) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement("div");
}

function isElement$1(value) {
  return ["Element", "Fragment"].some(function (type) {
    return isType(value, type);
  });
}

function isNodeList(value) {
  return isType(value, "NodeList");
}

function isMouseEvent(value) {
  return isType(value, "MouseEvent");
}

function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}

function getArrayOfElements(value) {
  if (isElement$1(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}

function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}

function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute("data-state", state);
    }
  });
}

function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0];

  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}

function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref3) {
    var popperRect = _ref3.popperRect,
        popperState = _ref3.popperState,
        props = _ref3.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
    var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}

function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function (event) {
    box[method](event, listener);
  });
}

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener("mousemove", onDocumentMouseMove);
  }
}

function onDocumentMouseMove() {
  var now2 = performance.now();

  if (now2 - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener("mousemove", onDocumentMouseMove);
  }

  lastMouseMoveTime = now2;
}

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}

function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener("blur", onWindowBlur);
}

var isBrowser$2 = typeof window !== "undefined" && typeof document !== "undefined";
var isIE11 = isBrowser$2 ? !!window.msCrypto : false;
var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: "fade",
  arrow: true,
  content: "",
  inertia: false,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
};
var defaultProps$3 = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: "mouseenter focus",
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps$3);

var setDefaultProps = function setDefaultProps2(partialProps) {
  var keys2 = Object.keys(partialProps);
  keys2.forEach(function (key) {
    defaultProps$3[key] = partialProps[key];
  });
};

function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps2 = plugins.reduce(function (acc, plugin) {
    var name2 = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name2) {
      var _name;

      acc[name2] = passedProps[name2] !== void 0 ? passedProps[name2] : (_name = defaultProps$3[name2]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps2);
}

function getDataAttributeProps(reference2, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps$3, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference2.getAttribute("data-tippy-" + key) || "").trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === "content") {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e2) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}

function evaluateProps(reference2, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference2])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference2, props.plugins));
  out.aria = Object.assign({}, defaultProps$3.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
    content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
  };
  return out;
}

var innerHTML = function innerHTML2() {
  return "innerHTML";
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow2 = div();

  if (value === true) {
    arrow2.className = ARROW_CLASS;
  } else {
    arrow2.className = SVG_ARROW_CLASS;

    if (isElement$1(value)) {
      arrow2.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow2, value);
    }
  }

  return arrow2;
}

function setContent(content, props) {
  if (isElement$1(props.content)) {
    dangerouslySetInnerHTML(content, "");
    content.appendChild(props.content);
  } else if (typeof props.content !== "function") {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}

function getChildren(popper2) {
  var box = popper2.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node2) {
      return node2.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node2) {
      return node2.classList.contains(ARROW_CLASS) || node2.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node2) {
      return node2.classList.contains(BACKDROP_CLASS);
    })
  };
}

function render(instance) {
  var popper2 = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute("data-state", "hidden");
  box.setAttribute("tabindex", "-1");
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute("data-state", "hidden");
  setContent(content, instance.props);
  popper2.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper2),
        box2 = _getChildren.box,
        content2 = _getChildren.content,
        arrow2 = _getChildren.arrow;

    if (nextProps.theme) {
      box2.setAttribute("data-theme", nextProps.theme);
    } else {
      box2.removeAttribute("data-theme");
    }

    if (typeof nextProps.animation === "string") {
      box2.setAttribute("data-animation", nextProps.animation);
    } else {
      box2.removeAttribute("data-animation");
    }

    if (nextProps.inertia) {
      box2.setAttribute("data-inertia", "");
    } else {
      box2.removeAttribute("data-inertia");
    }

    box2.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box2.setAttribute("role", nextProps.role);
    } else {
      box2.removeAttribute("role");
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content2, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow2) {
        box2.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box2.removeChild(arrow2);
        box2.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow2) {
      box2.removeChild(arrow2);
    }
  }

  return {
    popper: popper2,
    onUpdate: onUpdate
  };
}

render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = [];
var mountedInstances = [];

function createTippy(reference2, passedProps) {
  var props = evaluateProps(reference2, Object.assign({}, defaultProps$3, getExtendedPassedProps(removeUndefinedProps(passedProps))));
  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce$2(onMouseMove, props.interactiveDebounce);
  var currentTarget;
  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    isEnabled: true,
    isVisible: false,
    isDestroyed: false,
    isMounted: false,
    isShown: false
  };
  var instance = {
    id: id,
    reference: reference2,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent2,
    show: show,
    hide: hide2,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  };

  if (!props.render) {
    return instance;
  }

  var _props$render = props.render(instance),
      popper2 = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper2.setAttribute("data-tippy-root", "");
  popper2.id = "tippy-" + instance.id;
  instance.popper = popper2;
  reference2._tippy = instance;
  popper2._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference2.hasAttribute("aria-expanded");
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook("onCreate", [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  }

  popper2.addEventListener("mouseenter", function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper2.addEventListener("mouseleave", function () {
    if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) {
      getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    }
  });
  return instance;

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === "hold";
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference2;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper2);
  }

  function getDelay(isShow) {
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps$3.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper2.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
    popper2.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id2 = popper2.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function (node2) {
      var currentValue = node2.getAttribute(attr);

      if (instance.state.isVisible) {
        node2.setAttribute(attr, currentValue ? currentValue + " " + id2 : id2);
      } else {
        var nextValue = currentValue && currentValue.replace(id2, "").trim();

        if (nextValue) {
          node2.setAttribute(attr, nextValue);
        } else {
          node2.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function (node2) {
      if (instance.props.interactive) {
        node2.setAttribute("aria-expanded", instance.state.isVisible && node2 === getCurrentTarget() ? "true" : "false");
      } else {
        node2.removeAttribute("aria-expanded");
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === "mousedown") {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target;

    if (instance.props.interactive && actualContains(popper2, actualTarget)) {
      return;
    }

    if (normalizeToArray(instance.props.triggerTarget || reference2).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) {
        return;
      }
    } else {
      invokeHook("onClickOutside", [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide();
      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      });

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener("mousedown", onDocumentPress, true);
    doc.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener("mousedown", onDocumentPress, true);
    doc.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration2, callback) {
    onTransitionEnd(duration2, function () {
      if (!instance.state.isVisible && popper2.parentNode && popper2.parentNode.contains(popper2)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration2, callback) {
    onTransitionEnd(duration2, callback);
  }

  function onTransitionEnd(duration2, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, "remove", listener);
        callback();
      }
    }

    if (duration2 === 0) {
      return callback();
    }

    updateTransitionEndListener(box, "remove", currentTransitionEndListener);
    updateTransitionEndListener(box, "add", listener);
    currentTransitionEndListener = listener;
  }

  function on2(eventType, handler, options2) {
    if (options2 === void 0) {
      options2 = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function (node2) {
      node2.addEventListener(eventType, handler, options2);
      listeners.push({
        node: node2,
        eventType: eventType,
        handler: handler,
        options: options2
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on2("touchstart", onTrigger2, {
        passive: true
      });
      on2("touchend", onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === "manual") {
        return;
      }

      on2(eventType, onTrigger2);

      switch (eventType) {
        case "mouseenter":
          on2("mouseleave", onMouseLeave);
          break;

        case "focus":
          on2(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
          break;

        case "focusin":
          on2("focusout", onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref3) {
      var node2 = _ref3.node,
          eventType = _ref3.eventType,
          handler = _ref3.handler,
          options2 = _ref3.options;
      node2.removeEventListener(eventType, handler, options2);
    });
    listeners = [];
  }

  function onTrigger2(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    }

    if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === "click") {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper2.contains(target);

    if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper2).map(function (popper3) {
      var _instance$popperInsta;

      var instance2 = popper3._tippy;
      var state2 = (_instance$popperInsta = instance2.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state2) {
        return {
          popperRect: popper3.getBoundingClientRect(),
          popperState: state2,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) {
      return;
    }

    if (instance.props.interactive && event.relatedTarget && popper2.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset2 = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow2 = getIsDefaultRenderFn() ? getChildren(popper2).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference2;
    var tippyModifier = {
      name: "$$tippy",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function fn3(_ref22) {
        var state2 = _ref22.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ["placement", "reference-hidden", "escaped"].forEach(function (attr) {
            if (attr === "placement") {
              box.setAttribute("data-placement", state2.placement);
            } else {
              if (state2.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, "");
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state2.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: "offset",
      options: {
        offset: offset2
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow2) {
      modifiers.push({
        name: "arrow",
        options: {
          element: arrow2,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper2, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode;
    var node2 = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") {
      parentNode = node2.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node2]);
    }

    if (!parentNode.contains(popper2)) {
      parentNode.appendChild(popper2);
    }

    instance.state.isMounted = true;
    createPopperInstance();
  }

  function getNestedPopperTree() {
    return arrayFrom(popper2.querySelectorAll("[data-tippy-root]"));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook("onTrigger", [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === "hold" && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook("onUntrigger", [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    }

    if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  }

  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook("onBeforeUpdate", [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference2, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce$2(onMouseMove, nextProps.interactiveDebounce);
    }

    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node2) {
        node2.removeAttribute("aria-expanded");
      });
    } else if (nextProps.triggerTarget) {
      reference2.removeAttribute("aria-expanded");
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance();
      getNestedPopperTree().forEach(function (nestedPopper) {
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook("onAfterUpdate", [instance, partialProps]);
  }

  function setContent2(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration2 = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps$3.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    }

    if (getCurrentTarget().hasAttribute("disabled")) {
      return;
    }

    invokeHook("onShow", [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "visible";
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper2.style.transition = "none";
    }

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate2() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true;
      void popper2.offsetHeight;
      popper2.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration2);
        setVisibilityState([_box, _content], "visible");
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance);
      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook("onMount", [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration2, function () {
          instance.state.isShown = true;
          invokeHook("onShown", [instance]);
        });
      }
    };

    mount();
  }

  function hide2() {
    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration2 = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps$3.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook("onHide", [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "hidden";
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration2);
        setVisibilityState([box, content], "hidden");
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration2, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance();
    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper2.parentNode) {
      popper2.parentNode.removeChild(popper2);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook("onHidden", [instance]);
  }

  function destroy() {
    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference2._tippy;
    instance.state.isDestroyed = true;
    invokeHook("onDestroy", [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps$3.plugins.concat(optionalProps.plugins || []);
  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  var instances2 = elements.reduce(function (acc, reference2) {
    var instance = reference2 && createTippy(reference2, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement$1(targets) ? instances2[0] : instances2;
}

tippy.defaultProps = defaultProps$3;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles$1, {
  effect: function effect2(_ref3) {
    var state = _ref3.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
  }
});
tippy.setDefaultProps({
  render: render
});

function _objectWithoutPropertiesLoose$1(source2, excluded) {
  if (source2 == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source2[key];
  }

  return target;
}

var isBrowser$1 = typeof window !== "undefined" && typeof document !== "undefined";

function preserveRef(ref, node2) {
  if (ref) {
    if (typeof ref === "function") {
      ref(node2);
    }

    if ({}.hasOwnProperty.call(ref, "current")) {
      ref.current = node2;
    }
  }
}

function ssrSafeCreateDiv() {
  return isBrowser$1 && document.createElement("div");
}

function toDataAttributes(attrs) {
  var dataAttrs = {
    "data-placement": attrs.placement
  };

  if (attrs.referenceHidden) {
    dataAttrs["data-reference-hidden"] = "";
  }

  if (attrs.escaped) {
    dataAttrs["data-escaped"] = "";
  }

  return dataAttrs;
}

function deepEqual(x2, y2) {
  if (x2 === y2) {
    return true;
  } else if (typeof x2 === "object" && x2 != null && typeof y2 === "object" && y2 != null) {
    if (Object.keys(x2).length !== Object.keys(y2).length) {
      return false;
    }

    for (var prop in x2) {
      if (y2.hasOwnProperty(prop)) {
        if (!deepEqual(x2[prop], y2[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
}

function uniqueByShape(arr) {
  var output = [];
  arr.forEach(function (item) {
    if (!output.find(function (outputItem) {
      return deepEqual(item, outputItem);
    })) {
      output.push(item);
    }
  });
  return output;
}

function deepPreserveProps(instanceProps, componentProps) {
  var _instanceProps$popper, _componentProps$poppe;

  return Object.assign({}, componentProps, {
    popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
      modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
    })
  });
}

var useIsomorphicLayoutEffect = isBrowser$1 ? useLayoutEffect : useEffect;

function useMutableBox(initialValue) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
  }

  return ref.current;
}

function updateClassName(box, action, classNames2) {
  classNames2.split(/\s+/).forEach(function (name2) {
    if (name2) {
      box.classList[action](name2);
    }
  });
}

var classNamePlugin = {
  name: "className",
  defaultValue: "",
  fn: function fn2(instance) {
    var box = instance.popper.firstElementChild;

    var isDefaultRenderFn = function isDefaultRenderFn2() {
      var _instance$props$rende;

      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    };

    function add() {
      if (instance.props.className && !isDefaultRenderFn()) {
        return;
      }

      updateClassName(box, "add", instance.props.className);
    }

    function remove() {
      if (isDefaultRenderFn()) {
        updateClassName(box, "remove", instance.props.className);
      }
    }

    return {
      onCreate: add,
      onBeforeUpdate: remove,
      onAfterUpdate: add
    };
  }
};

function TippyGenerator(tippy2) {
  function Tippy2(_ref3) {
    var children = _ref3.children,
        content = _ref3.content,
        visible = _ref3.visible,
        singleton = _ref3.singleton,
        render2 = _ref3.render,
        reference2 = _ref3.reference,
        _ref$disabled = _ref3.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$ignoreAttributes = _ref3.ignoreAttributes,
        ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
    _ref3.__source;
    _ref3.__self;

    var restOfNativeProps = _objectWithoutPropertiesLoose$1(_ref3, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

    var isControlledMode = visible !== void 0;
    var isSingletonMode = singleton !== void 0;

    var _useState = useState(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var _useState2 = useState({}),
        attrs = _useState2[0],
        setAttrs = _useState2[1];

    var _useState3 = useState(),
        singletonContent = _useState3[0],
        setSingletonContent = _useState3[1];

    var mutableBox = useMutableBox(function () {
      return {
        container: ssrSafeCreateDiv(),
        renders: 1
      };
    });
    var props = Object.assign({
      ignoreAttributes: ignoreAttributes
    }, restOfNativeProps, {
      content: mutableBox.container
    });

    if (isControlledMode) {
      props.trigger = "manual";
      props.hideOnClick = false;
    }

    if (isSingletonMode) {
      disabled = true;
    }

    var computedProps = props;
    var plugins = props.plugins || [];

    if (render2) {
      computedProps = Object.assign({}, props, {
        plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
          fn: function fn3() {
            return {
              onTrigger: function onTrigger2(instance, event) {
                var node2 = singleton.data.children.find(function (_ref22) {
                  var instance2 = _ref22.instance;
                  return instance2.reference === event.currentTarget;
                });
                instance.state.$$activeSingletonInstance = node2.instance;
                setSingletonContent(node2.content);
              }
            };
          }
        }]) : plugins,
        render: function render3() {
          return {
            popper: mutableBox.container
          };
        }
      });
    }

    var deps = [reference2].concat(children ? [children.type] : []);
    useIsomorphicLayoutEffect(function () {
      var element = reference2;

      if (reference2 && reference2.hasOwnProperty("current")) {
        element = reference2.current;
      }

      var instance = tippy2(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
        plugins: [classNamePlugin].concat(props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      if (visible) {
        instance.show();
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }

      setMounted(true);
      return function () {
        instance.destroy();
        singleton == null ? void 0 : singleton.cleanup(instance);
      };
    }, deps);
    useIsomorphicLayoutEffect(function () {
      var _instance$popperInsta;

      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps(deepPreserveProps(instance.props, computedProps));
      (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }

      if (isControlledMode) {
        if (visible) {
          instance.show();
        } else {
          instance.hide();
        }
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }
    });
    useIsomorphicLayoutEffect(function () {
      var _instance$props$poppe;

      if (!render2) {
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps({
        popperOptions: Object.assign({}, instance.props.popperOptions, {
          modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref32) {
            var name2 = _ref32.name;
            return name2 !== "$$tippyReact";
          }), [{
            name: "$$tippyReact",
            enabled: true,
            phase: "beforeWrite",
            requires: ["computeStyles"],
            fn: function fn3(_ref4) {
              var _state$modifiersData;

              var state = _ref4.state;
              var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide;

              if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                setAttrs({
                  placement: state.placement,
                  referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                  escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                });
              }

              state.attributes.popper = {};
            }
          }])
        })
      });
    }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
    return (
      /* @__PURE__ */
      jsxs(Fragment, {
        children: [children ?
        /* @__PURE__ */
        cloneElement(children, {
          ref: function ref(node2) {
            mutableBox.ref = node2;
            preserveRef(children.ref, node2);
          }
        }) : null, mounted &&
        /* @__PURE__ */
        createPortal(render2 ? render2(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container)]
      })
    );
  }

  return Tippy2;
}

var forwardRef = function forwardRef(Tippy2, defaultProps2) {
  return (
    /* @__PURE__ */
    forwardRef$1(function TippyWrapper(_ref3, _ref22) {
      var children = _ref3.children,
          props = _objectWithoutPropertiesLoose$1(_ref3, ["children"]);

      return (
        /* @__PURE__ */
        jsx$1(Tippy2, _objectSpread3({}, Object.assign({}, defaultProps2, props), {
          children: children ?
          /* @__PURE__ */
          cloneElement(children, {
            ref: function ref(node2) {
              preserveRef(_ref22, node2);
              preserveRef(children.ref, node2);
            }
          }) : null
        }))
      );
    })
  );
};

var index$1 =
/* @__PURE__ */
forwardRef(
/* @__PURE__ */
TippyGenerator(tippy));
var Tippy = index$1;
var selectStyles = {
  control: function control(provided) {
    return _objectSpread3({}, provided, {
      fontSize: "14px",
      borderRadius: "0.25em",
      padding: "6px 1px",
      "&:hover": {
        borderColor: "gray"
      },
      border: "1px solid lightgray",
      boxShadow: "none"
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return _objectSpread3({}, provided, {
      "&:hover": {
        backGroundColor: "gray"
      },
      cursor: "pointer"
    });
  },
  input: function input(provided) {
    return _objectSpread3({}, provided, {
      "input:focus": {
        boxShadow: "none"
      }
    });
  }
};
var inputStyle$1 = "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-full focus:topxw-outline-none topxw-px-3 topxw-py-2";

var svgSize = function svgSize(size) {
  return "topxw-h-".concat(size, " topxw-w-").concat(size);
};

var titleManageGameStyle = "topxw-text-xs topxw-font-medium topxw-block topxw-mb-1 topxw-uppercase topxw-font-extrabold";
var actionButtonStyle = "topxw-rounded topxw-p-1 topxw-flex topxw-items-center topxw-mr-1";

var isReportButtonDisabled = function isReportButtonDisabled(gameStatus) {
  if (gameStatus !== "PENDING") {
    return false;
  }

  return true;
};

var isWinnersButtonDisabled = function isWinnersButtonDisabled(gameStatus) {
  if (gameStatus === "SETTLED") {
    return false;
  }

  return true;
};

var ActionsButtons = function ActionsButtons(_ref614) {
  var tippyKey = _ref614.tippyKey,
      status = _ref614.status,
      labelEdit = _ref614.labelEdit,
      labelReport = _ref614.labelReport,
      labelWinners = _ref614.labelWinners,
      onClickEdit = _ref614.onClickEdit,
      onClickReport = _ref614.onClickReport,
      onClickWinners = _ref614.onClickWinners;
  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: labelEdit,
        children:
        /* @__PURE__ */
        jsx$1("button", {
          className: "".concat(actionButtonStyle, " topxw-bg-yellow-400"),
          onClick: onClickEdit,
          title: "Edit",
          disabled: status === "LIVE",
          children:
          /* @__PURE__ */
          jsx$1("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: svgSize(6),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            children:
            /* @__PURE__ */
            jsx$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            })
          })
        })
      }, "".concat(tippyKey, "-edit")),
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: labelReport,
        children:
        /* @__PURE__ */
        jsx$1("button", {
          disabled: isReportButtonDisabled(status),
          className: "".concat(actionButtonStyle, " ").concat(isReportButtonDisabled(status) ? "topxw-bg-gray-200" : "topxw-bg-blue-400"),
          onClick: onClickReport,
          title: "Report",
          children:
          /* @__PURE__ */
          jsx$1("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: "".concat(svgSize(6), " ").concat(isReportButtonDisabled(status) ? "topxw-text-gray-400" : ""),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            children:
            /* @__PURE__ */
            jsx$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })
          })
        })
      }, "".concat(tippyKey, "-report")),
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: labelWinners,
        children:
        /* @__PURE__ */
        jsx$1("button", {
          className: "".concat(actionButtonStyle, " ").concat(isWinnersButtonDisabled(status) ? "topxw-bg-gray-200" : "topxw-bg-green-400"),
          onClick: onClickWinners,
          disabled: isWinnersButtonDisabled(status),
          title: "Winners",
          children:
          /* @__PURE__ */
          jsx$1("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "".concat(svgSize(6), " ").concat(isWinnersButtonDisabled(status) ? "topxw-text-gray-400" : ""),
            children:
            /* @__PURE__ */
            jsx$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
            })
          })
        })
      }, "".concat(tippyKey, "-winners"))]
    })
  );
};

var dayjs_min = {
  exports: {}
};

(function (module, exports) {
  !function (t2, e2) {
    module.exports = e2();
  }(commonjsGlobal, function () {
    var t2 = 1e3,
        e2 = 6e4,
        n2 = 36e5,
        r2 = "millisecond",
        i = "second",
        s = "minute",
        u2 = "hour",
        a = "day",
        o = "week",
        c2 = "month",
        f2 = "quarter",
        h2 = "year",
        d2 = "date",
        l2 = "Invalid Date",
        $2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        M2 = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function ordinal(t3) {
        var e3 = ["th", "st", "nd", "rd"],
            n3 = t3 % 100;
        return "[" + t3 + (e3[(n3 - 20) % 10] || e3[n3] || e3[0]) + "]";
      }
    },
        m2 = function m2(t3, e3, n3) {
      var r3 = String(t3);
      return !r3 || r3.length >= e3 ? t3 : "" + Array(e3 + 1 - r3.length).join(n3) + t3;
    },
        v2 = {
      s: m2,
      z: function z(t3) {
        var e3 = -t3.utcOffset(),
            n3 = Math.abs(e3),
            r3 = Math.floor(n3 / 60),
            i2 = n3 % 60;
        return (e3 <= 0 ? "+" : "-") + m2(r3, 2, "0") + ":" + m2(i2, 2, "0");
      },
      m: function t3(e3, n3) {
        if (e3.date() < n3.date()) return -t3(n3, e3);
        var r3 = 12 * (n3.year() - e3.year()) + (n3.month() - e3.month()),
            i2 = e3.clone().add(r3, c2),
            s2 = n3 - i2 < 0,
            u3 = e3.clone().add(r3 + (s2 ? -1 : 1), c2);
        return +(-(r3 + (n3 - i2) / (s2 ? i2 - u3 : u3 - i2)) || 0);
      },
      a: function a(t3) {
        return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
      },
      p: function p(t3) {
        return {
          M: c2,
          y: h2,
          w: o,
          d: a,
          D: d2,
          h: u2,
          m: s,
          s: i,
          ms: r2,
          Q: f2
        }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(t3) {
        return void 0 === t3;
      }
    },
        g2 = "en",
        D2 = {};

    D2[g2] = M2;

    var p2 = "$isDayjsObject",
        S2 = function S2(t3) {
      return t3 instanceof _2 || !(!t3 || !t3[p2]);
    },
        w2 = function t3(e3, n3, r3) {
      var i2;
      if (!e3) return g2;

      if ("string" == typeof e3) {
        var s2 = e3.toLowerCase();
        D2[s2] && (i2 = s2), n3 && (D2[s2] = n3, i2 = s2);
        var u3 = e3.split("-");
        if (!i2 && u3.length > 1) return t3(u3[0]);
      } else {
        var a2 = e3.name;
        D2[a2] = e3, i2 = a2;
      }

      return !r3 && i2 && (g2 = i2), i2 || !r3 && g2;
    },
        O2 = function O2(t3, e3) {
      if (S2(t3)) return t3.clone();
      var n3 = "object" == typeof e3 ? e3 : {};
      return n3.date = t3, n3.args = arguments, new _2(n3);
    },
        b2 = v2;

    b2.l = w2, b2.i = S2, b2.w = function (t3, e3) {
      return O2(t3, {
        locale: e3.$L,
        utc: e3.$u,
        x: e3.$x,
        $offset: e3.$offset
      });
    };

    var _2 = function () {
      function M3(t3) {
        this.$L = w2(t3.locale, null, true), this.parse(t3), this.$x = this.$x || t3.x || {}, this[p2] = true;
      }

      var m3 = M3.prototype;
      return m3.parse = function (t3) {
        this.$d = function (t4) {
          var e3 = t4.date,
              n3 = t4.utc;
          if (null === e3) return new Date(NaN);
          if (b2.u(e3)) return new Date();
          if (e3 instanceof Date) return new Date(e3);

          if ("string" == typeof e3 && !/Z$/i.test(e3)) {
            var r3 = e3.match($2);

            if (r3) {
              var i2 = r3[2] - 1 || 0,
                  s2 = (r3[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2)) : new Date(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2);
            }
          }

          return new Date(e3);
        }(t3), this.init();
      }, m3.init = function () {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function () {
        return b2;
      }, m3.isValid = function () {
        return !(this.$d.toString() === l2);
      }, m3.isSame = function (t3, e3) {
        var n3 = O2(t3);
        return this.startOf(e3) <= n3 && n3 <= this.endOf(e3);
      }, m3.isAfter = function (t3, e3) {
        return O2(t3) < this.startOf(e3);
      }, m3.isBefore = function (t3, e3) {
        return this.endOf(e3) < O2(t3);
      }, m3.$g = function (t3, e3, n3) {
        return b2.u(t3) ? this[e3] : this.set(n3, t3);
      }, m3.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function () {
        return this.$d.getTime();
      }, m3.startOf = function (t3, e3) {
        var n3 = this,
            r3 = !!b2.u(e3) || e3,
            f3 = b2.p(t3),
            l3 = function l3(t4, e4) {
          var i2 = b2.w(n3.$u ? Date.UTC(n3.$y, e4, t4) : new Date(n3.$y, e4, t4), n3);
          return r3 ? i2 : i2.endOf(a);
        },
            $3 = function $3(t4, e4) {
          return b2.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n3);
        },
            y3 = this.$W,
            M4 = this.$M,
            m4 = this.$D,
            v3 = "set" + (this.$u ? "UTC" : "");

        switch (f3) {
          case h2:
            return r3 ? l3(1, 0) : l3(31, 11);

          case c2:
            return r3 ? l3(1, M4) : l3(0, M4 + 1);

          case o:
            var g3 = this.$locale().weekStart || 0,
                D3 = (y3 < g3 ? y3 + 7 : y3) - g3;
            return l3(r3 ? m4 - D3 : m4 + (6 - D3), M4);

          case a:
          case d2:
            return $3(v3 + "Hours", 0);

          case u2:
            return $3(v3 + "Minutes", 1);

          case s:
            return $3(v3 + "Seconds", 2);

          case i:
            return $3(v3 + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, m3.endOf = function (t3) {
        return this.startOf(t3, false);
      }, m3.$set = function (t3, e3) {
        var n3,
            o2 = b2.p(t3),
            f3 = "set" + (this.$u ? "UTC" : ""),
            l3 = (n3 = {}, n3[a] = f3 + "Date", n3[d2] = f3 + "Date", n3[c2] = f3 + "Month", n3[h2] = f3 + "FullYear", n3[u2] = f3 + "Hours", n3[s] = f3 + "Minutes", n3[i] = f3 + "Seconds", n3[r2] = f3 + "Milliseconds", n3)[o2],
            $3 = o2 === a ? this.$D + (e3 - this.$W) : e3;

        if (o2 === c2 || o2 === h2) {
          var y3 = this.clone().set(d2, 1);
          y3.$d[l3]($3), y3.init(), this.$d = y3.set(d2, Math.min(this.$D, y3.daysInMonth())).$d;
        } else l3 && this.$d[l3]($3);

        return this.init(), this;
      }, m3.set = function (t3, e3) {
        return this.clone().$set(t3, e3);
      }, m3.get = function (t3) {
        return this[b2.p(t3)]();
      }, m3.add = function (r3, f3) {
        var d3,
            l3 = this;
        r3 = Number(r3);

        var $3 = b2.p(f3),
            y3 = function y3(t3) {
          var e3 = O2(l3);
          return b2.w(e3.date(e3.date() + Math.round(t3 * r3)), l3);
        };

        if ($3 === c2) return this.set(c2, this.$M + r3);
        if ($3 === h2) return this.set(h2, this.$y + r3);
        if ($3 === a) return y3(1);
        if ($3 === o) return y3(7);
        var M4 = (d3 = {}, d3[s] = e2, d3[u2] = n2, d3[i] = t2, d3)[$3] || 1,
            m4 = this.$d.getTime() + r3 * M4;
        return b2.w(m4, this);
      }, m3.subtract = function (t3, e3) {
        return this.add(-1 * t3, e3);
      }, m3.format = function (t3) {
        var e3 = this,
            n3 = this.$locale();
        if (!this.isValid()) return n3.invalidDate || l2;

        var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ",
            i2 = b2.z(this),
            s2 = this.$H,
            u3 = this.$m,
            a2 = this.$M,
            o2 = n3.weekdays,
            c3 = n3.months,
            f3 = n3.meridiem,
            h3 = function h3(t4, n4, i3, s3) {
          return t4 && (t4[n4] || t4(e3, r3)) || i3[n4].slice(0, s3);
        },
            d3 = function d3(t4) {
          return b2.s(s2 % 12 || 12, t4, "0");
        },
            $3 = f3 || function (t4, e4, n4) {
          var r4 = t4 < 12 ? "AM" : "PM";
          return n4 ? r4.toLowerCase() : r4;
        };

        return r3.replace(y2, function (t4, r4) {
          return r4 || function (t5) {
            switch (t5) {
              case "YY":
                return String(e3.$y).slice(-2);

              case "YYYY":
                return b2.s(e3.$y, 4, "0");

              case "M":
                return a2 + 1;

              case "MM":
                return b2.s(a2 + 1, 2, "0");

              case "MMM":
                return h3(n3.monthsShort, a2, c3, 3);

              case "MMMM":
                return h3(c3, a2);

              case "D":
                return e3.$D;

              case "DD":
                return b2.s(e3.$D, 2, "0");

              case "d":
                return String(e3.$W);

              case "dd":
                return h3(n3.weekdaysMin, e3.$W, o2, 2);

              case "ddd":
                return h3(n3.weekdaysShort, e3.$W, o2, 3);

              case "dddd":
                return o2[e3.$W];

              case "H":
                return String(s2);

              case "HH":
                return b2.s(s2, 2, "0");

              case "h":
                return d3(1);

              case "hh":
                return d3(2);

              case "a":
                return $3(s2, u3, true);

              case "A":
                return $3(s2, u3, false);

              case "m":
                return String(u3);

              case "mm":
                return b2.s(u3, 2, "0");

              case "s":
                return String(e3.$s);

              case "ss":
                return b2.s(e3.$s, 2, "0");

              case "SSS":
                return b2.s(e3.$ms, 3, "0");

              case "Z":
                return i2;
            }

            return null;
          }(t4) || i2.replace(":", "");
        });
      }, m3.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function (r3, d3, l3) {
        var $3,
            y3 = this,
            M4 = b2.p(d3),
            m4 = O2(r3),
            v3 = (m4.utcOffset() - this.utcOffset()) * e2,
            g3 = this - m4,
            D3 = function D3() {
          return b2.m(y3, m4);
        };

        switch (M4) {
          case h2:
            $3 = D3() / 12;
            break;

          case c2:
            $3 = D3();
            break;

          case f2:
            $3 = D3() / 3;
            break;

          case o:
            $3 = (g3 - v3) / 6048e5;
            break;

          case a:
            $3 = (g3 - v3) / 864e5;
            break;

          case u2:
            $3 = g3 / n2;
            break;

          case s:
            $3 = g3 / e2;
            break;

          case i:
            $3 = g3 / t2;
            break;

          default:
            $3 = g3;
        }

        return l3 ? $3 : b2.a($3);
      }, m3.daysInMonth = function () {
        return this.endOf(c2).$D;
      }, m3.$locale = function () {
        return D2[this.$L];
      }, m3.locale = function (t3, e3) {
        if (!t3) return this.$L;
        var n3 = this.clone(),
            r3 = w2(t3, e3, true);
        return r3 && (n3.$L = r3), n3;
      }, m3.clone = function () {
        return b2.w(this.$d, this);
      }, m3.toDate = function () {
        return new Date(this.valueOf());
      }, m3.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function () {
        return this.$d.toISOString();
      }, m3.toString = function () {
        return this.$d.toUTCString();
      }, M3;
    }(),
        k2 = _2.prototype;

    return O2.prototype = k2, [["$ms", r2], ["$s", i], ["$m", s], ["$H", u2], ["$W", a], ["$M", c2], ["$y", h2], ["$D", d2]].forEach(function (t3) {
      k2[t3[1]] = function (e3) {
        return this.$g(e3, t3[0], t3[1]);
      };
    }), O2.extend = function (t3, e3) {
      return t3.$i || (t3(e3, _2, O2), t3.$i = true), O2;
    }, O2.locale = w2, O2.isDayjs = S2, O2.unix = function (t3) {
      return O2(1e3 * t3);
    }, O2.en = D2[g2], O2.Ls = D2, O2.p = {}, O2;
  });
})(dayjs_min);

var dayjs = dayjs_min.exports;
var typeFinishedGames = ["finished", "cancelled", "interrupted"];
var typeInProgressGames = ["inprogress"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source2 = arguments[i];

      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o2) {
    return typeof o2;
  } : function (o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(e2, r2) {
  var t2 = Object.keys(e2);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e2);
    r2 && (o = o.filter(function (r3) {
      return Object.getOwnPropertyDescriptor(e2, r3).enumerable;
    })), t2.push.apply(t2, o);
  }

  return t2;
}

function _objectSpread2(e2) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t2), true).forEach(function (r3) {
      _defineProperty(e2, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function (r3) {
      Object.defineProperty(e2, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }

  return e2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e2) {
    return false;
  }
}

function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self2;
}

function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self2);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);

  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }

  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}

var StyleSheet =
/* @__PURE__ */
function () {
  function StyleSheet2(options2) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet2.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet2;
}();

var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;

function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

function trim(value) {
  return value.trim();
}

function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

function indexof(value, search) {
  return value.indexOf(search);
}

function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}

function substr(value, begin, end2) {
  return value.slice(begin, end2);
}

function strlen(value) {
  return value.length;
}

function sizeof(value) {
  return value.length;
}

function append(value, array) {
  return array.push(value), value;
}

function combine(array, callback) {
  return array.map(callback).join("");
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";

function node(value, root2, parent, type, props, children, length2) {
  return {
    value: value,
    root: root2,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length2,
    return: ""
  };
}

function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, {
    length: -root2.length
  }, props);
}

function _char() {
  return character;
}

function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

function peek() {
  return charat(characters, position);
}

function caret() {
  return position;
}

function slice(begin, end2) {
  return substr(characters, begin, end2);
}

function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}

function dealloc(value) {
  return characters = "", value;
}

function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

function whitespace(type) {
  while (character = peek()) {
    if (character < 33) next();else break;
  }

  return token(type) > 2 || token(character) > 3 ? "" : " ";
}

function escaping(index2, count) {
  while (--count && next()) {
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  }

  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}

function delimiter(type) {
  while (next()) {
    switch (character) {
      case type:
        return position;

      case 34:
      case 39:
        if (type !== 34 && type !== 39) delimiter(character);
        break;

      case 40:
        if (type === 41) delimiter(type);
        break;

      case 92:
        next();
        break;
    }
  }

  return position;
}

function commenter(type, index2) {
  while (next()) {
    if (type + character === 47 + 10) break;else if (type + character === 42 + 42 && peek() === 47) break;
  }

  return "/*" + slice(index2, position - 1) + "*" + from(type === 47 ? type : next());
}

function identifier(index2) {
  while (!token(peek())) {
    next();
  }

  return slice(index2, position);
}

function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}

function parse(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type;

  while (scanning) {
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1) ampersand = -1;
          break;
        }

      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;

      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;

      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;

          default:
            characters2 += "/";
        }

        break;

      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;

      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;

          case 59 + offset2:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2) append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;

          case 59:
            characters2 += ";";

          default:
            append(reference2 = ruleset(characters2, root2, parent, index2, offset2, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123) if (offset2 === 0) parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);else switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
              case 100:
              case 108:
              case 109:
              case 115:
                parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                break;

              default:
                parse(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
            }
        }

        index2 = offset2 = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;

      case 58:
        length2 = 1 + strlen(characters2), property = previous;

      default:
        if (variable < 1) {
          if (character2 == 123) --variable;else if (character2 == 125 && variable++ == 0 && prev() == 125) continue;
        }

        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;

          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;

          case 64:
            if (peek() === 45) characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;

          case 45:
            if (previous === 45 && strlen(characters2) == 2) variable = 0;
        }

    }
  }

  return rulesets;
}

function ruleset(value, root2, parent, index2, offset2, rules, points, type, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);

  for (var i = 0, j = 0, k2 = 0; i < index2; ++i) {
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size; ++x2) {
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2]))) props[k2++] = z2;
    }
  }

  return node(value, root2, parent, offset2 === 0 ? RULESET : type, props, children, length2);
}

function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(_char()), substr(value, 2, -2), 0);
}

function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}

function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);

  for (var i = 0; i < length2; i++) {
    output += callback(children[i], i, children, callback) || "";
  }

  return output;
}

function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;

    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;

    case COMMENT:
      return "";

    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";

    case RULESET:
      element.value = element.props.join(",");
  }

  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

function middleware(collection) {
  var length2 = sizeof(collection);
  return function (element, index2, children, callback) {
    var output = "";

    for (var i = 0; i < length2; i++) {
      output += collection[i](element, index2, children, callback) || "";
    }

    return output;
  };
}

function rulesheet(callback) {
  return function (element) {
    if (!element.root) {
      if (element = element.return) callback(element);
    }
  };
}

function memoize(fn3) {
  var cache =
  /* @__PURE__ */
  Object.create(null);
  return function (arg) {
    if (cache[arg] === void 0) cache[arg] = fn3(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;

  while (true) {
    previous = character2;
    character2 = peek();

    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }

    if (token(character2)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;

  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }

        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;

      case 2:
        parsed[index2] += delimit(character2);
        break;

      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }

      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());

  return parsed;
};

var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};

var fixedElements =
/* @__PURE__ */
new WeakMap();

var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }

  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }

  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};

var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;

    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};

function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;

    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;

    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;

    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;

    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;

    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;

    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        case 109:
          if (charat(value, length2 + 4) !== 45) break;

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;

        case 115:
          return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;

    case 4949:
      if (charat(value, length2 + 1) !== 115) break;

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }

      break;

    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;

      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback);

      case RULESET:
        if (element.length) return combine(element.props, function (value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return serialize([copy(element, {
                props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);

            case "::placeholder":
              return serialize([copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }

          return "";
        });
    }
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache2(options2) {
  var key = options2.key;

  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function (node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");

      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }

      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }

  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function (node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node2);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w$1 = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u2 = a.$$typeof;

    switch (u2) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u2;
            }

        }

      case d:
        return u2;
    }
  }
}

function A(a) {
  return z(a) === m;
}

reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;

reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

reactIs_production_min.isConcurrentMode = A;

reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k;
};

reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h;
};

reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n;
};

reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};

reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};

reactIs_production_min.isMemo = function (a) {
  return z(a) === r;
};

reactIs_production_min.isPortal = function (a) {
  return z(a) === d;
};

reactIs_production_min.isProfiler = function (a) {
  return z(a) === g;
};

reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f;
};

reactIs_production_min.isSuspense = function (a) {
  return z(a) === p;
};

reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w$1 || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function (className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}

var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};

var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};

function murmur2(str) {
  var h2 = 0;
  var k2,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }

  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;

    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;

    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }

  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};

var processStyleName =
/* @__PURE__ */
memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});

var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName":
      {
        if (typeof value === "string") {
          return value.replace(animationRegex, function (match2, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }

  return value;
};

var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }

  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }

  switch (typeof interpolation) {
    case "boolean":
      {
        return "";
      }

    case "object":
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== void 0) {
          var next2 = interpolation.next;

          if (next2 !== void 0) {
            while (next2 !== void 0) {
              cursor = {
                name: next2.name,
                styles: next2.styles,
                next: cursor
              };
              next2 = next2.next;
            }
          }

          var styles = interpolation.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case "function":
      {
        if (mergedProps !== void 0) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  }

  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = "";

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i2 = 0; _i2 < value.length; _i2++) {
            if (isProcessableValue(value[_i2])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i2]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case "animation":
            case "animationName":
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;

var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }

  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];

  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      styles += strings[i];
    }
  }

  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;

  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match2[1];
  }

  var name2 = murmur2(styles) + identifierName;
  return {
    name: name2,
    styles: styles,
    next: cursor
  };
};

var syncFallback = function syncFallback2(create) {
  return create();
};

var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var hasOwnProperty$9 = {}.hasOwnProperty;
var EmotionCacheContext =
/* @__PURE__ */
React.createContext(typeof HTMLElement !== "undefined" ?
/* @__PURE__ */
createCache({
  key: "css"
}) : null);
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache2(func) {
  return (
    /* @__PURE__ */
    forwardRef$1(function (props, ref) {
      var cache = useContext(EmotionCacheContext);
      return func(props, cache, ref);
    })
  );
};

var ThemeContext =
/* @__PURE__ */
React.createContext({});
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";

var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$9.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;
  return newProps;
};

var Insertion = function Insertion2(_ref3) {
  var cache = _ref3.cache,
      serialized = _ref3.serialized,
      isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};

var Emotion =
/* @__PURE__ */
withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css;

  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";

  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$9.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(Insertion, {
      cache: cache,
      serialized: serialized,
      isStringTag: typeof WrappedComponent === "string"
    }),
    /* @__PURE__ */
    React.createElement(WrappedComponent, newProps))
  );
});
var Emotion$1 = Emotion;

var jsx = function jsx2(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$9.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return React.createElement.apply(null, createElementArgArray);
};

function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name2 = "animation-" + insertable.name;
  return {
    name: name2,
    styles: "@keyframes " + name2 + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString3() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];

  if (null != t2) {
    var e2,
        n2,
        i,
        u2,
        a = [],
        f2 = true,
        o = false;

    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f2 = false;
      } else for (; !(f2 = (e2 = i.call(t2)).done) && (a.push(e2.value), a.length !== l2); f2 = true) {
        ;
      }
    } catch (r3) {
      o = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t2["return"] && (u2 = t2["return"](), Object(u2) !== u2)) return;
      } finally {
        if (o) throw n2;
      }
    }

    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source2, excluded) {
  if (source2 == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source2[key];
  }

  return target;
}

function _objectWithoutProperties(source2, excluded) {
  if (source2 == null) return {};

  var target = _objectWithoutPropertiesLoose(source2, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key)) continue;
      target[key] = source2[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;

var createCoords = function createCoords(v2) {
  return {
    x: v2,
    y: v2
  };
};

function rectToClientRect(rect) {
  return _objectSpread3({}, rect, {
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }

  return "#document";
}

function getWindow(node2) {
  var _node$ownerDocument;

  return (node2 == null ? void 0 : (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}

function getDocumentElement(node2) {
  var _ref3;

  return (_ref3 = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref3.documentElement;
}

function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}

function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}

function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}

function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }

  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}

function isOverflowElement(element) {
  var _getComputedStyle$ = getComputedStyle$1(element),
      overflow = _getComputedStyle$.overflow,
      overflowX = _getComputedStyle$.overflowX,
      overflowY = _getComputedStyle$.overflowY,
      display = _getComputedStyle$.display;

  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}

function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}

function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }

  var result = node2.assignedSlot || node2.parentNode || isShadowRoot(node2) && node2.host || getDocumentElement(node2);
  return isShadowRoot(result) ? result.host : result;
}

function getNearestOverflowAncestor(node2) {
  var parentNode = getParentNode(node2);

  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }

  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }

  return getNearestOverflowAncestor(parentNode);
}

function getOverflowAncestors(node2, list, traverseIframes) {
  var _node$ownerDocument2;

  if (list === void 0) {
    list = [];
  }

  if (traverseIframes === void 0) {
    traverseIframes = true;
  }

  var scrollableAncestor = getNearestOverflowAncestor(node2);
  var isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  var win = getWindow(scrollableAncestor);

  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }

  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function getCssDimensions(element) {
  var css4 = getComputedStyle$1(element);
  var width = parseFloat(css4.width) || 0;
  var height = parseFloat(css4.height) || 0;
  var hasOffset = isHTMLElement(element);
  var offsetWidth = hasOffset ? element.offsetWidth : width;
  var offsetHeight = hasOffset ? element.offsetHeight : height;
  var shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;

  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }

  return {
    width: width,
    height: height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  var domElement = unwrapElement(element);

  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }

  var rect = domElement.getBoundingClientRect();

  var _getCssDimensions = getCssDimensions(domElement),
      width = _getCssDimensions.width,
      height = _getCssDimensions.height,
      $2 = _getCssDimensions.$;

  var x2 = ($2 ? round(rect.width) : rect.width) / width;
  var y2 = ($2 ? round(rect.height) : rect.height) / height;

  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }

  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }

  return {
    x: x2,
    y: y2
  };
}

var noOffsets =
/* @__PURE__ */
createCoords(0);

function getVisualOffsets(element) {
  var win = getWindow(element);

  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }

  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}

function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }

  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var domElement = unwrapElement(element);
  var scale = createCoords(1);

  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }

  var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  var x2 = (clientRect.left + visualOffsets.x) / scale.x;
  var y2 = (clientRect.top + visualOffsets.y) / scale.y;
  var width = clientRect.width / scale.x;
  var height = clientRect.height / scale.y;

  if (domElement) {
    var win = getWindow(domElement);
    var offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    var currentIFrame = win.frameElement;

    while (currentIFrame && offsetParent && offsetWin !== win) {
      var iframeScale = getScale(currentIFrame);
      var iframeRect = currentIFrame.getBoundingClientRect();
      var css4 = getComputedStyle$1(currentIFrame);
      var left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css4.paddingLeft)) * iframeScale.x;
      var top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css4.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left2;
      y2 += top2;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }

  return rectToClientRect({
    width: width,
    height: height,
    x: x2,
    y: y2
  });
}

function observeMove(element, onMove) {
  var io2 = null;
  var timeoutId;
  var root2 = getDocumentElement(element);

  function cleanup() {
    clearTimeout(timeoutId);
    io2 && io2.disconnect();
    io2 = null;
  }

  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }

    if (threshold === void 0) {
      threshold = 1;
    }

    cleanup();

    var _element$getBoundingC = element.getBoundingClientRect(),
        left2 = _element$getBoundingC.left,
        top2 = _element$getBoundingC.top,
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    if (!skip) {
      onMove();
    }

    if (!width || !height) {
      return;
    }

    var insetTop = floor(top2);
    var insetRight = floor(root2.clientWidth - (left2 + width));
    var insetBottom = floor(root2.clientHeight - (top2 + height));
    var insetLeft = floor(left2);
    var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    var options2 = {
      rootMargin: rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    var isFirstUpdate = true;

    function handleObserve(entries) {
      var ratio = entries[0].intersectionRatio;

      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }

        if (!ratio) {
          timeoutId = setTimeout(function () {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }

      isFirstUpdate = false;
    }

    try {
      io2 = new IntersectionObserver(handleObserve, _objectSpread3({}, options2, {
        root: root2.ownerDocument
      }));
    } catch (e2) {
      io2 = new IntersectionObserver(handleObserve, options2);
    }

    io2.observe(element);
  }

  refresh(true);
  return cleanup;
}

function autoUpdate(reference2, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }

  var _options2 = options2,
      _options2$ancestorScr = _options2.ancestorScroll,
      ancestorScroll = _options2$ancestorScr === void 0 ? true : _options2$ancestorScr,
      _options2$ancestorRes = _options2.ancestorResize,
      ancestorResize = _options2$ancestorRes === void 0 ? true : _options2$ancestorRes,
      _options2$elementResi = _options2.elementResize,
      elementResize = _options2$elementResi === void 0 ? typeof ResizeObserver === "function" : _options2$elementResi,
      _options2$layoutShift = _options2.layoutShift,
      layoutShift = _options2$layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options2$layoutShift,
      _options2$animationFr = _options2.animationFrame,
      animationFrame = _options2$animationFr === void 0 ? false : _options2$animationFr;
  var referenceEl = unwrapElement(reference2);
  var ancestors = ancestorScroll || ancestorResize ? [].concat(_toConsumableArray3(referenceEl ? getOverflowAncestors(referenceEl) : []), _toConsumableArray3(getOverflowAncestors(floating))) : [];
  ancestors.forEach(function (ancestor) {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  var reobserveFrame = -1;
  var resizeObserver = null;

  if (elementResize) {
    resizeObserver = new ResizeObserver(function (_ref3) {
      var _ref615 = _slicedToArray3(_ref3, 1),
          firstEntry = _ref615[0];

      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(function () {
          resizeObserver && resizeObserver.observe(floating);
        });
      }

      update();
    });

    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }

    resizeObserver.observe(floating);
  }

  var frameId;
  var prevRefRect = animationFrame ? getBoundingClientRect(reference2) : null;

  if (animationFrame) {
    frameLoop();
  }

  function frameLoop() {
    var nextRefRect = getBoundingClientRect(reference2);

    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }

    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }

  update();
  return function () {
    ancestors.forEach(function (ancestor) {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;

    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

var index = useLayoutEffect;
var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];

var noop = function noop2() {};

function applyPrefixToName(prefix2, name2) {
  if (!name2) {
    return prefix2;
  } else if (name2[0] === "-") {
    return prefix2 + name2;
  } else {
    return prefix2 + "__" + name2;
  }
}

function classNames(prefix2, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }

  var arr = [].concat(classNameList);

  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(" ");
}

var cleanValue = function cleanValue2(value) {
  if (isArray$5(value)) return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null) return [value];
  return [];
};

var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;

  var innerProps = _objectWithoutProperties(props, _excluded$4);

  return _objectSpread2({}, innerProps);
};

var getStyleProps = function getStyleProps2(props, name2, classNamesState) {
  var cx = props.cx,
      getStyles = props.getStyles,
      getClassNames = props.getClassNames,
      className = props.className;
  return {
    css: getStyles(name2, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name2, props), className)
  };
};

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);

    if (typeof _newValue === "string") return _newValue;
  }

  return inputValue;
}

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }

  return el.clientHeight;
}

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}

function scrollTo(el, top2) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top2);
    return;
  }

  el.scrollTop = top2;
}

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed") return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === "static") {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
}

function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}

function animatedScrollTo(element, to2) {
  var duration2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop;
  var start2 = getScrollTop(element);
  var change = to2 - start2;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration2);
    scrollTo(element, val);

    if (currentTime < duration2) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
}

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

};
var w = typeof window !== "undefined" ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop, options);
  w.removeEventListener("p", noop, false);
}

var supportsPassiveEvents = passiveOptionAccessed;

function notNullish(item) {
  return item != null;
}

function isArray$5(arg) {
  return Array.isArray(arg);
}

function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}

function singleValueAsValue(singleValue) {
  return singleValue;
}

function multiValueAsValue(multiValue) {
  return multiValue;
}

var removeProps = function removeProps2(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }

  var propsMap = Object.entries(propsObj).filter(function (_ref3) {
    var _ref22 = _slicedToArray(_ref3, 1),
        key = _ref22[0];

    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    newProps[key] = val;
    return newProps;
  }, {});
};

var _excluded$3$1 = ["children", "innerProps"],
    _excluded2$1 = ["children", "innerProps"];

function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight,
      menuEl = _ref3.menuEl,
      minHeight = _ref3.minHeight,
      preferredPlacement = _ref3.placement,
      shouldScroll = _ref3.shouldScroll,
      isFixedPosition = _ref3.isFixedPosition,
      controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }

      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }

      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }

      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }

        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }

      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }

      break;

    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }

      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }

      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }

      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };

    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }

  return defaultState;
}

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}

var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};

var menuCSS = function menuCSS2(_ref22, unstyled) {
  var _objectSpread2$1;

  var placement = _ref22.placement,
      _ref2$theme = _ref22.theme,
      borderRadius2 = _ref2$theme.borderRadius,
      spacing2 = _ref2$theme.spacing,
      colors2 = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$1 = {
    label: "menu"
  }, _defineProperty(_objectSpread2$1, alignToControl(placement), "100%"), _defineProperty(_objectSpread2$1, "position", "absolute"), _defineProperty(_objectSpread2$1, "width", "100%"), _defineProperty(_objectSpread2$1, "zIndex", 1), _objectSpread2$1), unstyled ? {} : {
    backgroundColor: colors2.neutral0,
    borderRadius: borderRadius2,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: spacing2.menuGutter,
    marginTop: spacing2.menuGutter
  });
};

var PortalPlacementContext =
/* @__PURE__ */
createContext(null);

var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children,
      minMenuHeight = props.minMenuHeight,
      maxMenuHeight = props.maxMenuHeight,
      menuPlacement = props.menuPlacement,
      menuPosition = props.menuPosition,
      menuShouldScrollIntoView = props.menuShouldScrollIntoView,
      theme = props.theme;

  var _ref3 = useContext(PortalPlacementContext) || {},
      setPortalPlacement = _ref3.setPortalPlacement;

  var ref = useRef(null);

  var _useState = useState(maxMenuHeight),
      _useState2 = _slicedToArray(_useState, 2),
      maxHeight = _useState2[0],
      setMaxHeight = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      placement = _useState4[0],
      setPlacement = _useState4[1];

  var controlHeight2 = theme.spacing.controlHeight;
  index(function () {
    var menuEl = ref.current;
    if (!menuEl) return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref: ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};

var Menu = function Menu2(props) {
  var children = props.children,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "menu", {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};

var Menu$1 = Menu;

var menuListCSS = function menuListCSS2(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
      baseUnit2 = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight: maxHeight,
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
  }, unstyled ? {} : {
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2
  });
};

var MenuList = function MenuList2(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return jsx("div", _extends({}, getStyleProps(props, "menuList", {
    "menu-list": true,
    "menu-list--is-multi": isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

var noticeCSS = function noticeCSS2(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
      baseUnit2 = _ref5$theme.spacing.baseUnit,
      colors2 = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: "center"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px")
  });
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage2(_ref6) {
  var _ref6$children = _ref6.children,
      children = _ref6$children === void 0 ? "No options" : _ref6$children,
      innerProps = _ref6.innerProps,
      restProps = _objectWithoutProperties(_ref6, _excluded$3$1);

  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), "noOptionsMessage", {
    "menu-notice": true,
    "menu-notice--no-options": true
  }), innerProps), children);
};

var LoadingMessage = function LoadingMessage2(_ref7) {
  var _ref7$children = _ref7.children,
      children = _ref7$children === void 0 ? "Loading..." : _ref7$children,
      innerProps = _ref7.innerProps,
      restProps = _objectWithoutProperties(_ref7, _excluded2$1);

  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), "loadingMessage", {
    "menu-notice": true,
    "menu-notice--loading": true
  }), innerProps), children);
};

var menuPortalCSS = function menuPortalCSS2(_ref8) {
  var rect = _ref8.rect,
      offset2 = _ref8.offset,
      position2 = _ref8.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function MenuPortal2(props) {
  var appendTo = props.appendTo,
      children = props.children,
      controlElement = props.controlElement,
      innerProps = props.innerProps,
      menuPlacement = props.menuPlacement,
      menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);

  var _useState5 = useState(coercePlacement(menuPlacement)),
      _useState6 = _slicedToArray(_useState5, 2),
      placement = _useState6[0],
      setPortalPlacement = _useState6[1];

  var portalPlacementContext = useMemo(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      computedPosition = _useState8[0],
      setComputedPosition = _useState8[1];

  var updateComputedPosition = useCallback(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset2 = rect[placement] + scrollDistance;

    if (offset2 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset2,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function () {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
  var menuWrapper = jsx("div", _extends({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), "menuPortal", {
    "menu-portal": true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ?
  /* @__PURE__ */
  createPortal(menuWrapper, appendTo) : menuWrapper);
};

var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled,
      isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};

var SelectContainer = function SelectContainer2(props) {
  var children = props.children,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends({}, getStyleProps(props, "container", {
    "--is-disabled": isDisabled,
    "--is-rtl": isRtl
  }), innerProps), children);
};

var valueContainerCSS = function valueContainerCSS2(_ref22, unstyled) {
  var spacing2 = _ref22.theme.spacing,
      isMulti = _ref22.isMulti,
      hasValue = _ref22.hasValue,
      controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, unstyled ? {} : {
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px")
  });
};

var ValueContainer = function ValueContainer2(props) {
  var children = props.children,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      hasValue = props.hasValue;
  return jsx("div", _extends({}, getStyleProps(props, "valueContainer", {
    "value-container": true,
    "value-container--is-multi": isMulti,
    "value-container--has-value": hasValue
  }), innerProps), children);
};

var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};

var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "indicatorsContainer", {
    indicators: true
  }), innerProps), children);
};

var _templateObject;

var _excluded$2$1 = ["size"],
    _excluded2 = ["innerProps", "isRtl", "size"];
var _ref2$2 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};

var Svg2 = function Svg3(_ref3) {
  var size = _ref3.size,
      props = _objectWithoutProperties(_ref3, _excluded$2$1);

  return jsx("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};

var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg2, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};

var DownChevron = function DownChevron2(props) {
  return jsx(Svg2, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

var baseCSS = function baseCSS2(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit2 = _ref3$theme.spacing.baseUnit,
      colors2 = _ref3$theme.colors;
  return _objectSpread2({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2,
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  });
};

var dropdownIndicatorCSS = baseCSS;

var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "dropdownIndicator", {
    indicator: true,
    "dropdown-indicator": true
  }), innerProps), children || jsx(DownChevron, null));
};

var clearIndicatorCSS = baseCSS;

var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "clearIndicator", {
    indicator: true,
    "clear-indicator": true
  }), innerProps), children || jsx(CrossIcon, null));
};

var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit2 = _ref4$theme.spacing.baseUnit,
      colors2 = _ref4$theme.colors;
  return _objectSpread2({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2
  });
};

var IndicatorSeparator = function IndicatorSeparator2(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends({}, innerProps, getStyleProps(props, "indicatorSeparator", {
    "indicator-separator": true
  })));
};

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));

var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors2 = _ref5$theme.colors,
      baseUnit2 = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2
  });
};

var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay,
      offset2 = _ref6.offset;
  return jsx("span", {
    css:
    /* @__PURE__ */
    css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};

var LoadingIndicator = function LoadingIndicator2(_ref7) {
  var innerProps = _ref7.innerProps,
      isRtl = _ref7.isRtl,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 4 : _ref7$size,
      restProps = _objectWithoutProperties(_ref7, _excluded2);

  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), "loadingIndicator", {
    indicator: true,
    "loading-indicator": true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

var css$1 = function css(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled,
      isFocused = _ref3.isFocused,
      _ref$theme = _ref3.theme,
      colors2 = _ref$theme.colors,
      borderRadius2 = _ref$theme.borderRadius,
      spacing2 = _ref$theme.spacing;
  return _objectSpread2({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  });
};

var Control = function Control2(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends({
    ref: innerRef
  }, getStyleProps(props, "control", {
    control: true,
    "control--is-disabled": isDisabled,
    "control--is-focused": isFocused,
    "control--menu-is-open": menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || void 0
  }), children);
};

var Control$1 = Control;
var _excluded$1$1 = ["data"];

var groupCSS = function groupCSS2(_ref3, unstyled) {
  var spacing2 = _ref3.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};

var Group = function Group2(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      getClassNames = props.getClassNames,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", _extends({}, getStyleProps(props, "group", {
    group: true
  }), innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme,
      colors2 = _ref2$theme.colors,
      spacing2 = _ref2$theme.spacing;
  return _objectSpread2({
    label: "group",
    cursor: "default",
    display: "block"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  });
};

var GroupHeading = function GroupHeading2(props) {
  var _cleanCommonProps = cleanCommonProps(props);

  _cleanCommonProps.data;

  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);

  return jsx("div", _extends({}, getStyleProps(props, "groupHeading", {
    "group-heading": true
  }), innerProps));
};

var Group$1 = Group;
var _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];

var inputCSS = function inputCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled,
      value = _ref3.value,
      _ref$theme = _ref3.theme,
      spacing2 = _ref$theme.spacing,
      colors2 = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? "hidden" : "visible",
    transform: value ? "translateZ(0)" : ""
  }, containerStyle), unstyled ? {} : {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    color: colors2.neutral80
  });
};

var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};

var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};

var Input = function Input2(props) {
  var cx = props.cx,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$5);

  return jsx("div", _extends({}, getStyleProps(props, "input", {
    "input-container": true
  }), {
    "data-value": value || ""
  }), jsx("input", _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var Input$1 = Input;

var multiValueCSS = function multiValueCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme,
      spacing2 = _ref$theme.spacing,
      borderRadius2 = _ref$theme.borderRadius,
      colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    margin: spacing2.baseUnit / 2
  });
};

var multiValueLabelCSS = function multiValueLabelCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme,
      borderRadius2 = _ref2$theme.borderRadius,
      colors2 = _ref2$theme.colors,
      cropWithEllipsis = _ref22.cropWithEllipsis;
  return _objectSpread2({
    overflow: "hidden",
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
};

var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
      spacing2 = _ref3$theme.spacing,
      borderRadius2 = _ref3$theme.borderRadius,
      colors2 = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: "center",
    display: "flex"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  });
};

var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};

var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;

function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue2(props) {
  var children = props.children,
      components2 = props.components,
      data2 = props.data,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps3 = props.removeProps,
      selectProps = props.selectProps;
  var Container = components2.Container,
      Label = components2.Label,
      Remove = components2.Remove;
  return jsx(Container, {
    data: data2,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValue", {
      "multi-value": true,
      "multi-value--is-disabled": isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data2,
    innerProps: _objectSpread2({}, getStyleProps(props, "multiValueLabel", {
      "multi-value__label": true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data2,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValueRemove", {
      "multi-value__remove": true
    })), {}, {
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps3),
    selectProps: selectProps
  }));
};

var MultiValue$1 = MultiValue;

var optionCSS = function optionCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled,
      isFocused = _ref3.isFocused,
      isSelected = _ref3.isSelected,
      _ref$theme = _ref3.theme,
      spacing2 = _ref$theme.spacing,
      colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  });
};

var Option$1 = function Option(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "option", {
    option: true,
    "option--is-disabled": isDisabled,
    "option--is-focused": isFocused,
    "option--is-selected": isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var Option$1$1 = Option$1;

var placeholderCSS = function placeholderCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme,
      spacing2 = _ref$theme.spacing,
      colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, unstyled ? {} : {
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};

var Placeholder = function Placeholder2(props) {
  var children = props.children,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "placeholder", {
    placeholder: true
  }), innerProps), children);
};

var Placeholder$1 = Placeholder;

var css2 = function css3(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled,
      _ref$theme = _ref3.theme,
      spacing2 = _ref$theme.spacing,
      colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};

var SingleValue = function SingleValue2(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, "singleValue", {
    "single-value": true,
    "single-value--is-disabled": isDisabled
  }), innerProps), children);
};

var SingleValue$1 = SingleValue;
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};

function isEqual$1(first, second) {
  if (first === second) {
    return true;
  }

  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }

  return false;
}

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual$1(newInputs[i], lastInputs[i])) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }

  var cache = null;

  function memoized() {
    var newArgs = [];

    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      newArgs[_i2] = arguments[_i2];
    }

    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }

    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult: lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }

  memoized.clear = function clear() {
    cache = null;
  };

  return memoized;
}

var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};

var A11yText = function A11yText2(props) {
  return jsx("span", _extends({
    css: _ref
  }, props));
};

var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");

      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");

      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";

      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? "" : _props$label,
        labels = props.labels,
        isDisabled = props.isDisabled;

    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");

      case "clear":
        return "All selected options have been cleared.";

      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");

      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        focused = props.focused,
        options2 = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? "" : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };

    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === "menu") {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }

    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};

var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps,
      id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel4 = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled3 = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options2 = selectProps.options,
      screenReaderStatus2 = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function () {
    var message = "";

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          selectedOptions = ariaSelection.options,
          removedValue = ariaSelection.removedValue,
          removedValues = ariaSelection.removedValues,
          value = ariaSelection.value;

      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };

      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];

      var onChangeProps = _objectSpread2({
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function () {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? "menu" : "value",
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue]);
  var ariaResults = useMemo(function () {
    var resultsMsg = "";

    if (menuIsOpen && options2.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2]);
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = "";

    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(Fragment$1, null, jsx(A11yText$1, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var LiveRegion$1 = LiveRegion;
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function (d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function (match2) {
    return diacriticToBase[match2];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);

var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};

var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter2(config) {
  return function (option, rawInput) {
    if (option.data.__isNew__) return true;

    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify2 = _ignoreCase$ignoreAcc.stringify,
        trim2 = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded$3 = ["innerRef"];

function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef,
      props = _objectWithoutProperties(_ref3, _excluded$3);

  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends({
    ref: innerRef
  }, filteredProps, {
    css:
    /* @__PURE__ */
    css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}

var cancelScroll = function cancelScroll2(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled,
      onBottomArrive = _ref3.onBottomArrive,
      onBottomLeave = _ref3.onBottomLeave,
      onTopArrive = _ref3.onTopArrive,
      onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    if (!el) return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};

function preventTouchMove(e2) {
  e2.preventDefault();
}

function allowTouchMove(e2) {
  e2.stopPropagation();
}

function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;

  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};

function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled,
      _ref$accountForScroll = _ref3.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }

    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var blurSelectInput = function blurSelectInput2(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};

var _ref2$1 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};

function ScrollManager(_ref3) {
  var children = _ref3.children,
      lockEnabled = _ref3.lockEnabled,
      _ref$captureEnabled = _ref3.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref3.onBottomArrive,
      onBottomLeave = _ref3.onBottomLeave,
      onTopArrive = _ref3.onTopArrive,
      onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

var _ref2 = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};

var RequiredInput = function RequiredInput2(_ref3) {
  var name2 = _ref3.name,
      onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name: name2,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange2() {}
  });
};

var RequiredInput$1 = RequiredInput;

var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};

var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};
var defaultProps$2 = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};

function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index2
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data2 = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data2
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}

var getOptionLabel2 = function getOptionLabel3(props, data2) {
  return props.getOptionLabel(data2);
};

var getOptionValue2 = function getOptionValue3(props, data2) {
  return props.getOptionValue(data2);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue2(props, option);
  return selectValue.some(function (i) {
    return getOptionValue2(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === void 0) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select =
/* @__PURE__ */
function (_Component) {
  _inherits(Select2, _Component);

  var _super = _createSuper(Select2);

  function Select2(_props) {
    var _this;

    _classCallCheck(this, Select2);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange2 = _this$props.onChange,
          name2 = _this$props.name;
      actionMeta.name = name2;

      _this.ariaOnChange(newValue, actionMeta);

      onChange2(newValue, actionMeta);
    };

    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti,
          inputValue = _this$props2.inputValue;

      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      }

      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name2 = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name: name2
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: "remove-value",
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data2) {
      return getOptionLabel2(_this.props, data2);
    };

    _this.getOptionValue = function (data2) {
      return getOptionValue2(_this.props, data2);
    };

    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;

      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }

      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }

      event.preventDefault();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.preventDefault();
      _this.openAfterFocus = false;

      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue: prevInputValue
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;

      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue: prevInputValue
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onValueInputFocus = function (e2) {
      e2.preventDefault();
      e2.stopPropagation();

      _this.focus();
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === "function") {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      }

      _this.blockOptionHover = true;

      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue) return;

          _this.focusValue("previous");

          break;

        case "ArrowRight":
          if (!isMulti || inputValue) return;

          _this.focusValue("next");

          break;

        case "Delete":
        case "Backspace":
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case "Tab":
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case "Enter":
          if (event.keyCode === 229) {
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case " ":
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu("first");

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }

          break;

        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }

          break;

        case "PageUp":
          if (!menuIsOpen) return;

          _this.focusOption("pageup");

          break;

        case "PageDown":
          if (!menuIsOpen) return;

          _this.focusOption("pagedown");

          break;

        case "Home":
          if (!menuIsOpen) return;

          _this.focusOption("first");

          break;

        case "End":
          if (!menuIsOpen) return;

          _this.focusOption("last");

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);

    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();

      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }

    return _this;
  }

  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }

      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }

      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length) return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1) nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }

      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }

      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getClassNames = this.getClassNames,
          getValue2 = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue2,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options2,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable2 = _this$props7.isClearable,
          isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0) return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data2, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data2, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data2);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data2) {
      return this.props.formatGroupLabel(data2);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form,
          menuIsOpen = _this$props8.menuIsOpen,
          required = _this$props8.required;

      var _this$getComponents = this.getComponents(),
          Input3 = _this$getComponents.Input;

      var _this$state4 = this.state,
          inputIsHidden = _this$state4.inputIsHidden,
          ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId("input");

      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": required,
        role: "combobox"
      }, menuIsOpen && {
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox")
      }), !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });

      if (!isSearchable) {
        return (
          /* @__PURE__ */
          React.createElement(DummyInput, _extends({
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: ""
          }, ariaAttributes))
        );
      }

      return (
        /* @__PURE__ */
        React.createElement(Input3, _extends({}, commonProps, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: id,
          innerRef: this.getInputRef,
          isDisabled: isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: tabIndex,
          form: form,
          type: "text",
          value: inputValue
        }, ariaAttributes))
      );
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue3 = _this$getComponents2.MultiValue,
          MultiValueContainer2 = _this$getComponents2.MultiValueContainer,
          MultiValueLabel2 = _this$getComponents2.MultiValueLabel,
          MultiValueRemove2 = _this$getComponents2.MultiValueRemove,
          SingleValue3 = _this$getComponents2.SingleValue,
          Placeholder3 = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
          selectValue = _this$state5.selectValue,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null :
        /* @__PURE__ */
        React.createElement(Placeholder3, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }

      if (isMulti) {
        return selectValue.map(function (opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return (
            /* @__PURE__ */
            React.createElement(MultiValue3, _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer2,
                Label: MultiValueLabel2,
                Remove: MultiValueRemove2
              },
              isFocused: isOptionFocused,
              isDisabled: isDisabled,
              key: key,
              index: index2,
              removeProps: {
                onClick: function onClick() {
                  return _this3.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this3.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e2) {
                  e2.preventDefault();
                }
              },
              data: opt
            }), _this3.formatOptionLabel(opt, "value"))
          );
        });
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return (
        /* @__PURE__ */
        React.createElement(SingleValue3, _extends({}, commonProps, {
          data: singleValue,
          isDisabled: isDisabled
        }), this.formatOptionLabel(singleValue, "value"))
      );
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator3 = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        React.createElement(ClearIndicator3, _extends({}, commonProps, {
          innerProps: innerProps,
          isFocused: isFocused
        }))
      );
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator3 = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading) return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        React.createElement(LoadingIndicator3, _extends({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }))
      );
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator3 = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;

      if (!DropdownIndicator3 || !IndicatorSeparator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return (
        /* @__PURE__ */
        React.createElement(IndicatorSeparator3, _extends({}, commonProps, {
          isDisabled: isDisabled,
          isFocused: isFocused
        }))
      );
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator3 = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        React.createElement(DropdownIndicator3, _extends({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }))
      );
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group3 = _this$getComponents7.Group,
          GroupHeading3 = _this$getComponents7.GroupHeading,
          Menu3 = _this$getComponents7.Menu,
          MenuList3 = _this$getComponents7.MenuList,
          MenuPortal3 = _this$getComponents7.MenuPortal,
          LoadingMessage3 = _this$getComponents7.LoadingMessage,
          NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage,
          Option3 = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage2 = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage2 = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      var render2 = function render3(props, id) {
        var type = props.type,
            data2 = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data2;
        var onHover = isDisabled ? void 0 : function () {
          return _this4.onOptionHover(data2);
        };
        var onSelect = isDisabled ? void 0 : function () {
          return _this4.selectOption(data2);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return (
          /* @__PURE__ */
          React.createElement(Option3, _extends({}, commonProps, {
            innerProps: innerProps,
            data: data2,
            isDisabled: isDisabled,
            isSelected: isSelected,
            key: optionId,
            label: label,
            type: type,
            value: value,
            isFocused: isFocused,
            innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
          }), _this4.formatOptionLabel(props.data, "menu"))
        );
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === "group") {
            var _data = item.data,
                options2 = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return (
              /* @__PURE__ */
              React.createElement(Group3, _extends({}, commonProps, {
                key: groupId,
                data: _data,
                options: options2,
                Heading: GroupHeading3,
                headingProps: {
                  id: headingId,
                  data: item.data
                },
                label: _this4.formatGroupLabel(item.data)
              }), item.options.map(function (option) {
                return render2(option, "".concat(groupIndex, "-").concat(option.index));
              }))
            );
          } else if (item.type === "option") {
            return render2(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage2({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI =
        /* @__PURE__ */
        React.createElement(LoadingMessage3, commonProps, message);
      } else {
        var _message = noOptionsMessage2({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI =
        /* @__PURE__ */
        React.createElement(NoOptionsMessage3, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement =
      /* @__PURE__ */
      React.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return (
          /* @__PURE__ */
          React.createElement(Menu3, _extends({}, commonProps, menuPlacementProps, {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this4.onMenuMouseDown,
              onMouseMove: _this4.onMenuMouseMove,
              id: _this4.getElementId("listbox")
            },
            isLoading: isLoading,
            placement: placement
          }),
          /* @__PURE__ */
          React.createElement(ScrollManager, {
            captureEnabled: captureMenuScroll,
            onTopArrive: onMenuScrollToTop,
            onBottomArrive: onMenuScrollToBottom,
            lockEnabled: menuShouldBlockScroll
          }, function (scrollTargetRef) {
            return (
              /* @__PURE__ */
              React.createElement(MenuList3, _extends({}, commonProps, {
                innerRef: function innerRef(instance) {
                  _this4.getMenuListRef(instance);

                  scrollTargetRef(instance);
                },
                isLoading: isLoading,
                maxHeight: maxHeight,
                focusedOption: focusedOption
              }), menuUI)
            );
          }))
        );
      });
      return menuPortalTarget || menuPosition === "fixed" ?
      /* @__PURE__ */
      React.createElement(MenuPortal3, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter2 = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name2 = _this$props13.name,
          required = _this$props13.required;
      var selectValue = this.state.selectValue;

      if (required && !this.hasValue() && !isDisabled) {
        return (
          /* @__PURE__ */
          React.createElement(RequiredInput$1, {
            name: name2,
            onFocus: this.onValueInputFocus
          })
        );
      }

      if (!name2 || isDisabled) return;

      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return (
            /* @__PURE__ */
            React.createElement("input", {
              name: name2,
              type: "hidden",
              value: value
            })
          );
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return (
              /* @__PURE__ */
              React.createElement("input", {
                key: "i-".concat(i),
                name: name2,
                type: "hidden",
                value: _this5.getOptionValue(opt)
              })
            );
          }) :
          /* @__PURE__ */
          React.createElement("input", {
            name: name2,
            type: "hidden",
            value: ""
          });
          return (
            /* @__PURE__ */
            React.createElement("div", null, input)
          );
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";

        return (
          /* @__PURE__ */
          React.createElement("input", {
            name: name2,
            type: "hidden",
            value: _value
          })
        );
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
          ariaSelection = _this$state6.ariaSelection,
          focusedOption = _this$state6.focusedOption,
          focusedValue = _this$state6.focusedValue,
          isFocused = _this$state6.isFocused,
          selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return (
        /* @__PURE__ */
        React.createElement(LiveRegion$1, _extends({}, commonProps, {
          id: this.getElementId("live-region"),
          ariaSelection: ariaSelection,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          isFocused: isFocused,
          selectValue: selectValue,
          focusableOptions: focusableOptions
        }))
      );
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$getComponents8 = this.getComponents(),
          Control3 = _this$getComponents8.Control,
          IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer,
          SelectContainer3 = _this$getComponents8.SelectContainer,
          ValueContainer3 = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return (
        /* @__PURE__ */
        React.createElement(SelectContainer3, _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }), this.renderLiveRegion(),
        /* @__PURE__ */
        React.createElement(Control3, _extends({}, commonProps, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: isDisabled,
          isFocused: isFocused,
          menuIsOpen: menuIsOpen
        }),
        /* @__PURE__ */
        React.createElement(ValueContainer3, _extends({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderPlaceholderOrValue(), this.renderInput()),
        /* @__PURE__ */
        React.createElement(IndicatorsContainer3, _extends({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField())
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
          ariaSelection = state.ariaSelection,
          isFocused = state.isFocused,
          prevWasFocused = state.prevWasFocused;
      var options2 = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue,
          isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }

      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;

      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }

      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }

      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);

  return Select2;
}(Component$1);

Select.defaultProps = defaultProps$2;
var _excluded$2 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];

function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue,
      defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu,
      _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
      _ref$defaultValue = _ref3.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      propsInputValue = _ref3.inputValue,
      propsMenuIsOpen = _ref3.menuIsOpen,
      propsOnChange = _ref3.onChange,
      propsOnInputChange = _ref3.onInputChange,
      propsOnMenuClose = _ref3.onMenuClose,
      propsOnMenuOpen = _ref3.onMenuOpen,
      propsValue = _ref3.value,
      restSelectProps = _objectWithoutProperties(_ref3, _excluded$2);

  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateInputValue = _useState2[0],
      setStateInputValue = _useState2[1];

  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      stateMenuIsOpen = _useState4[0],
      setStateMenuIsOpen = _useState4[1];

  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue),
      _useState6 = _slicedToArray(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var onChange2 = useCallback(function (value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }

    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value2, actionMeta) {
    var newValue;

    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }

    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }

    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }

    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange2,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

var _excluded$1 = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];

var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading,
      allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
      _ref$createOptionPosi = _ref3.createOptionPosition,
      createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi,
      _ref$formatCreateLabe = _ref3.formatCreateLabel,
      formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
      _ref$isValidNewOption = _ref3.isValidNewOption,
      isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
      _ref$getNewOptionData = _ref3.getNewOptionData,
      getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
      onCreateOption = _ref3.onCreateOption,
      _ref$options = _ref3.options,
      propsOptions = _ref$options === void 0 ? [] : _ref$options,
      propsOnChange = _ref3.onChange,
      restSelectProps = _objectWithoutProperties(_ref3, _excluded$1);

  var _restSelectProps$getO = restSelectProps.getOptionValue,
      getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO,
      _restSelectProps$getO2 = restSelectProps.getOptionLabel,
      getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2,
      inputValue = restSelectProps.inputValue,
      isLoading = restSelectProps.isLoading,
      isMulti = restSelectProps.isMulti,
      value = restSelectProps.value,
      name2 = restSelectProps.name;
  var newOption = useMemo(function () {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options2 = useMemo(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange2 = useCallback(function (newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }

    var valueArray = Array.isArray(newValue) ? newValue : [newValue];

    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name: name2,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }

    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name2, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    onChange: onChange2
  });
}

var CreatableSelect =
/* @__PURE__ */
forwardRef$1(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return (
    /* @__PURE__ */
    React.createElement(Select, _extends({
      ref: ref
    }, selectProps))
  );
});
var CreatableSelect$1 = CreatableSelect;

var createOption = function createOption(label) {
  return {
    label: label,
    value: label
  };
};

var GameFlags = function GameFlags(_ref616) {
  var labels = _ref616.labels,
      flags = _ref616.flags,
      setGameRequestBody = _ref616.setGameRequestBody;

  var _useState23 = useState(""),
      _useState24 = _slicedToArray3(_useState23, 2),
      input = _useState24[0],
      setInput = _useState24[1];

  var handleChange = function handleChange(value) {
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        flags: value
      });
    });
  };

  var handleInputChange2 = function handleInputChange2(inputValue) {
    setInput(inputValue);
  };

  var handleKeyDown = function handleKeyDown(event) {
    event.persist();
    var key = event.key;
    if (!input) return;

    switch (key) {
      case "Enter":
      case "Tab":
        if (flags.length === 0) {
          setGameRequestBody(function (prevState) {
            return _objectSpread3({}, prevState, {
              flags: [].concat(_toConsumableArray3(flags), [createOption(input)])
            });
          });
        }

        if (flags.length > 0) {
          if (isValidFlagOption()) {
            setGameRequestBody(function (prevState) {
              return _objectSpread3({}, prevState, {
                flags: [].concat(_toConsumableArray3(flags), [createOption(input)])
              });
            });
          }
        }

        setInput("");
        event.preventDefault();
    }
  };

  var isValidFlagOption = function isValidFlagOption() {
    var isValid = false;
    var labelsFlags = flags.map(function (option) {
      return option.label;
    });

    if (labelsFlags.length && labelsFlags.includes(input)) {
      toast.warn(labels.repeatedValueMessage);
      return isValid;
    }

    isValid = true;
    return isValid;
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      "data-testid": "flags creatable select",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: labels.flags,
        className: titleManageGameStyle,
        "data-testid": "flags label",
        children: labels.flags
      }),
      /* @__PURE__ */
      jsx$1(CreatableSelect$1, {
        styles: selectStyles,
        components: {
          DropdownIndicator: null
        },
        inputValue: input,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        onChange: handleChange,
        onInputChange: handleInputChange2,
        onKeyDown: handleKeyDown,
        placeholder: labels.flagsPlaceholder,
        value: flags
      })]
    })
  );
};

var assetsPlaceholder = {
  player: "data:image/png;base64,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",
  lineup: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAe1BMVEUAAABdXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1kzb4jAAAAKHRSTlMA8RC8ca779eLEIATeybamnj40KRzYzpWPFunUmYF5UjmGalsLYEcxGo+DIgAAAWtJREFUSMe11WmPgkAMgGFgBhjuQ1DkkkPX/v9fuNmsMSsdpGXj+/0JCaXFoFWlxu7uAMMOFhhBUHQA0LKYL1svKsNGmfCTx7EZvNYwrGUu8JFMzzKBRTbVDoCTVBxi61pEewNNX0Qc63BCxCWS9Ld9NXVYEUfs6LBz/jwuEGTMynK1uvgHrgMSlqBNMnYRdyFgATjyOTiu4YiAuzXcEXC+hg8GoURvT7QbpJ2zUxikcoc+KFyFKOPmHxhvC2fjw0svw+ePkYc+LkYzetWcjjsfjJe6Z+JpJ8aHv+RZgcfMt3w9KEDVA4leU9CWWpvUF7BaUrylRQJvS/z1dfBgs1i/m5YNpGwLWwnkejxZRiJAS8So+atPwCxFB49Tjk4to/H54JCPy+yBL7AjiX6qjKoHTvfglD8o/Mf1Pb4V9+f+T7biSBXL4PUK5FMVK2eDhaKds7WlPue3/hSLqKmV6Zq/uXUYRl48jnO+YN8ujfTxFYNK5gAAAABJRU5ErkJggg==",
  lineup_player_type: "data:image/png;base64,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",
  coach: "data:image/png;base64,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",
  referee: "data:image/png;base64,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",
  president: "data:image/png;base64,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",
  team: "data:image/png;base64,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",
  imagePlaceholder: "data:image/png;base64,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",
  blankPlaceholder: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox ='0 0 16 9' />",
  tournament: "data:image/png;base64,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",
  stage: "data:image/png;base64,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",
  flag: "data:image/png;base64,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",
  country: "data:image/png;base64,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",
  venue: "data:image/png;base64,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",
  city: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACHAgMAAACqvhmaAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRFAAAAOT9OLTE7LC447an4ogAAAAR0Uk5TAP+/bsRcrF8AAACVSURBVHic7dOxDYAgFARQLSwcgH0YgQKMhYWjOpomIEgCXigwF/OvoPEFCP8cBkmvOJ+lClQQzoAtrlTAmIQuiymJyjGqRVh00Y5i/EiYuIhgEiz9aBL3/7dD4bDQUJhMPN40CguFw+KAQpMIwyhKkxPxJlaSyYnIxSZdbxQ21Hmmn60IzgbxiUf+KCqffawIEUhw5AS6Ec56SSFrSQAAAABJRU5ErkJggg==",
  match_status: "data:image/png;base64,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",
  club: "data:image/png;base64,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",
  upload: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACMklEQVR4nO2aMUtcQRSFP7ERNNgIimJnCgtDCmMlqKCkjYEV0gVJ8gMsYpdWQRCsBCWkVhIiiK3+A1EhfUAJBC1CwCCCe8ODWRges8/n7rjMzp0Dl2X3wc55H+femccuJCUlJSUllZW0sH4D34FplAIQU1VgFehAKQAx9QnlAKrAm9AAPJYGgBfABnBjrfcPmEABAFuLuTV/AcMoAtDrWPcY6EYJgPE6M+EA6EQBgLWCwZhtj1EDGAD+3rM7vCViAN9KbI+3wAyRApgE9s0ZoAjCFTAS6wzI9BzYAe4KIPwAeogUQE1Pgc8m9i4I20QOoKYRk4i8nywhoygAUNMr4DrnaR1FADJ9yHk6QRmA/pynP9oAdLbSlwQIgFABiOfy5aspSQJASoCkFiANQUm7AGkbFMKRPZeq2s8Bmx7vt+0A/ASeoBRAFXhp3i8AFU/33DYAatHvMz+tX5onRa+SVp25Hyg7+ruWvz0tAGbNa8XhsaIBgB39vEevrSABA7Cjn6+9dhmCjWqhxHdXYgXQVyf6j9IKEiCAouh7bwUJDECZ6HttBQloCJaNvtdWkIAAPCT63lpBAgHQSPS9tIIEAKDR6HtpBQkAQDPRb7oVJAAARbpweDz3uYAEDuDM4fFUE4Ajh8dDnwtIgNV/z7/KvsYOYM7yt+24vhU7gCXL36rj+krsAL5Y/pYd1z+iSO8dAN6hSK8dAOZRpGkHgCkU6ZkDwBiKNOQAMIgidTkAZJ/V1X+R0/VqTIhaqgAAAABJRU5ErkJggg==",
  upArrow: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAz0lEQVR4nO3YywrCMBBG4fOE1oWDC/vsCiq+RAuVQLpzvDVtJvAfCJSki/nIqgWllFJKKaUqtwfuwDU/N5kBAzDlNQI9jSOmFjHmIJrCHF8gBmcvvdvMTYzACTg4Z31LiLnwGPsCER5jPyDCYuwPRDiMLUCEwVgBRHWMFURUw9gKiM0xtiJiM4xtgFgdYxsi5opjaiCKY2oiimEiIBZjuoDfDkdnpjSr2y0Y4h0m/dBwewREeJg0q1uXpedPV1epDrjkGXe1h1FKKaWUUrTVE5bz7NyN3sYLAAAAAElFTkSuQmCC"
};

var getTeamLogo = function getTeamLogo(teamAssets) {
  if (teamAssets == null ? void 0 : teamAssets.logo) {
    return teamAssets.logo;
  }

  return assetsPlaceholder.team;
};

var MatchName = function MatchName(_ref617) {
  var homeTeamName = _ref617.homeTeamName,
      awayTeamName = _ref617.awayTeamName,
      homeTeamAssets = _ref617.homeTeamAssets,
      awayTeamAssets = _ref617.awayTeamAssets;
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-flex topxw-items-center",
      children: [
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mr-1 topxw-font-semibold",
        children: homeTeamName
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mr-1",
        children:
        /* @__PURE__ */
        jsx$1("img", {
          className: "topxw-w-6",
          "data-testid": "home team logo",
          src: getTeamLogo(homeTeamAssets)
        })
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mr-1",
        children: "-"
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mr-1",
        children:
        /* @__PURE__ */
        jsx$1("img", {
          className: "topxw-w-6",
          "data-testid": "away team logo",
          src: getTeamLogo(awayTeamAssets)
        })
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mr-1 topxw-font-semibold",
        children: awayTeamName
      })]
    })
  );
};

var utc$1 = {
  exports: {}
};

(function (module, exports) {
  !function (t2, i) {
    module.exports = i();
  }(commonjsGlobal, function () {
    var t2 = "minute",
        i = /[+-]\d\d(?::?\d\d)?/g,
        e2 = /([+-]|\d\d)/g;
    return function (s, f2, n2) {
      var u2 = f2.prototype;
      n2.utc = function (t3) {
        var i2 = {
          date: t3,
          utc: true,
          args: arguments
        };
        return new f2(i2);
      }, u2.utc = function (i2) {
        var e3 = n2(this.toDate(), {
          locale: this.$L,
          utc: true
        });
        return i2 ? e3.add(this.utcOffset(), t2) : e3;
      }, u2.local = function () {
        return n2(this.toDate(), {
          locale: this.$L,
          utc: false
        });
      };
      var o = u2.parse;

      u2.parse = function (t3) {
        t3.utc && (this.$u = true), this.$utils().u(t3.$offset) || (this.$offset = t3.$offset), o.call(this, t3);
      };

      var r2 = u2.init;

      u2.init = function () {
        if (this.$u) {
          var t3 = this.$d;
          this.$y = t3.getUTCFullYear(), this.$M = t3.getUTCMonth(), this.$D = t3.getUTCDate(), this.$W = t3.getUTCDay(), this.$H = t3.getUTCHours(), this.$m = t3.getUTCMinutes(), this.$s = t3.getUTCSeconds(), this.$ms = t3.getUTCMilliseconds();
        } else r2.call(this);
      };

      var a = u2.utcOffset;

      u2.utcOffset = function (s2, f3) {
        var n3 = this.$utils().u;
        if (n3(s2)) return this.$u ? 0 : n3(this.$offset) ? a.call(this) : this.$offset;
        if ("string" == typeof s2 && (s2 = function (t3) {
          void 0 === t3 && (t3 = "");
          var s3 = t3.match(i);
          if (!s3) return null;
          var f4 = ("" + s3[0]).match(e2) || ["-", 0, 0],
              n4 = f4[0],
              u4 = 60 * +f4[1] + +f4[2];
          return 0 === u4 ? 0 : "+" === n4 ? u4 : -u4;
        }(s2), null === s2)) return this;
        var u3 = Math.abs(s2) <= 16 ? 60 * s2 : s2,
            o2 = this;
        if (f3) return o2.$offset = u3, o2.$u = 0 === s2, o2;

        if (0 !== s2) {
          var r3 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (o2 = this.local().add(u3 + r3, t2)).$offset = u3, o2.$x.$localOffset = r3;
        } else o2 = this.utc();

        return o2;
      };

      var h2 = u2.format;
      u2.format = function (t3) {
        var i2 = t3 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h2.call(this, i2);
      }, u2.valueOf = function () {
        var t3 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t3;
      }, u2.isUTC = function () {
        return !!this.$u;
      }, u2.toISOString = function () {
        return this.toDate().toISOString();
      }, u2.toString = function () {
        return this.toDate().toUTCString();
      };
      var l2 = u2.toDate;

      u2.toDate = function (t3) {
        return "s" === t3 && this.$offset ? n2(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l2.call(this);
      };

      var c2 = u2.diff;

      u2.diff = function (t3, i2, e3) {
        if (t3 && this.$u === t3.$u) return c2.call(this, t3, i2, e3);
        var s2 = this.local(),
            f3 = n2(t3).local();
        return c2.call(s2, f3, i2, e3);
      };
    };
  });
})(utc$1);

var utc = utc$1.exports;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$5 = root$8.Symbol;
var _Symbol = Symbol$5;

function arrayMap$1(array, iteratee) {
  var index2 = -1,
      length2 = array == null ? 0 : array.length,
      result = Array(length2);

  while (++index2 < length2) {
    result[index2] = iteratee(array[index2], index2, array);
  }

  return result;
}

var _arrayMap = arrayMap$1;
var isArray$4 = Array.isArray;
var isArray_1 = isArray$4;
var Symbol$4 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;

function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

var _getRawTag = getRawTag$1;
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;

function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;
var Symbol$3 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;
var nullTag = "[object Null]",
    undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;

function baseGetTag$5(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

function isObjectLike$5(value) {
  return value != null && typeof value == "object";
}

var isObjectLike_1 = isObjectLike$5;
var baseGetTag$4 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";

function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike$4(value) && baseGetTag$4(value) == symbolTag$1;
}

var isSymbol_1 = isSymbol$2;
var Symbol$2 = _Symbol,
    arrayMap = _arrayMap,
    isArray$3 = isArray_1,
    isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;

function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }

  if (isArray$3(value)) {
    return arrayMap(value, baseToString$1) + "";
  }

  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }

  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}

var _baseToString = baseToString$1;
var baseToString = _baseToString;

function toString$4(value) {
  return value == null ? "" : baseToString(value);
}

var toString_1 = toString$4;

function baseSlice$1(array, start2, end2) {
  var index2 = -1,
      length2 = array.length;

  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }

  end2 = end2 > length2 ? length2 : end2;

  if (end2 < 0) {
    end2 += length2;
  }

  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);

  while (++index2 < length2) {
    result[index2] = array[index2 + start2];
  }

  return result;
}

var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;

function castSlice$1(array, start2, end2) {
  var length2 = array.length;
  end2 = end2 === void 0 ? length2 : end2;
  return !start2 && end2 >= length2 ? array : baseSlice(array, start2, end2);
}

var _castSlice = castSlice$1;
var rsAstralRange$2 = "\\ud800-\\udfff",
    rsComboMarksRange$3 = "\\u0300-\\u036f",
    reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$3 = "\\u20d0-\\u20ff",
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + "]");

function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

function asciiToArray$1(string) {
  return string.split("");
}

var _asciiToArray = asciiToArray$1;
var rsAstralRange$1 = "\\ud800-\\udfff",
    rsComboMarksRange$2 = "\\u0300-\\u036f",
    reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$2 = "\\u20d0-\\u20ff",
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange$1 + "]",
    rsCombo$2 = "[" + rsComboRange$2 + "]",
    rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
    rsModifier$1 = "(?:" + rsCombo$2 + "|" + rsFitz$1 + ")",
    rsNonAstral$1 = "[^" + rsAstralRange$1 + "]",
    rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?",
    rsOptVar$1 = "[" + rsVarRange$1 + "]?",
    rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*",
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol = "(?:" + [rsNonAstral$1 + rsCombo$2 + "?", rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol + rsSeq$1, "g");

function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}

var _stringToArray = stringToArray$1;
var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$3 = toString_1;

function createCaseFirst$1(methodName) {
  return function (string) {
    string = toString$3(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;
var upperFirst$1 = createCaseFirst("toUpperCase");
var upperFirst_1 = upperFirst$1;
var toString$2 = toString_1,
    upperFirst = upperFirst_1;

function capitalize$1(string) {
  return upperFirst(toString$2(string).toLowerCase());
}

var capitalize_1 = capitalize$1;

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index2 = -1,
      length2 = array == null ? 0 : array.length;

  if (initAccum && length2) {
    accumulator = array[++index2];
  }

  while (++index2 < length2) {
    accumulator = iteratee(accumulator, array[index2], index2, array);
  }

  return accumulator;
}

var _arrayReduce = arrayReduce$1;

function basePropertyOf$1(object) {
  return function (key) {
    return object == null ? void 0 : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;
var deburredLetters = {
  "\xC0": "A",
  "\xC1": "A",
  "\xC2": "A",
  "\xC3": "A",
  "\xC4": "A",
  "\xC5": "A",
  "\xE0": "a",
  "\xE1": "a",
  "\xE2": "a",
  "\xE3": "a",
  "\xE4": "a",
  "\xE5": "a",
  "\xC7": "C",
  "\xE7": "c",
  "\xD0": "D",
  "\xF0": "d",
  "\xC8": "E",
  "\xC9": "E",
  "\xCA": "E",
  "\xCB": "E",
  "\xE8": "e",
  "\xE9": "e",
  "\xEA": "e",
  "\xEB": "e",
  "\xCC": "I",
  "\xCD": "I",
  "\xCE": "I",
  "\xCF": "I",
  "\xEC": "i",
  "\xED": "i",
  "\xEE": "i",
  "\xEF": "i",
  "\xD1": "N",
  "\xF1": "n",
  "\xD2": "O",
  "\xD3": "O",
  "\xD4": "O",
  "\xD5": "O",
  "\xD6": "O",
  "\xD8": "O",
  "\xF2": "o",
  "\xF3": "o",
  "\xF4": "o",
  "\xF5": "o",
  "\xF6": "o",
  "\xF8": "o",
  "\xD9": "U",
  "\xDA": "U",
  "\xDB": "U",
  "\xDC": "U",
  "\xF9": "u",
  "\xFA": "u",
  "\xFB": "u",
  "\xFC": "u",
  "\xDD": "Y",
  "\xFD": "y",
  "\xFF": "y",
  "\xC6": "Ae",
  "\xE6": "ae",
  "\xDE": "Th",
  "\xFE": "th",
  "\xDF": "ss",
  "\u0100": "A",
  "\u0102": "A",
  "\u0104": "A",
  "\u0101": "a",
  "\u0103": "a",
  "\u0105": "a",
  "\u0106": "C",
  "\u0108": "C",
  "\u010A": "C",
  "\u010C": "C",
  "\u0107": "c",
  "\u0109": "c",
  "\u010B": "c",
  "\u010D": "c",
  "\u010E": "D",
  "\u0110": "D",
  "\u010F": "d",
  "\u0111": "d",
  "\u0112": "E",
  "\u0114": "E",
  "\u0116": "E",
  "\u0118": "E",
  "\u011A": "E",
  "\u0113": "e",
  "\u0115": "e",
  "\u0117": "e",
  "\u0119": "e",
  "\u011B": "e",
  "\u011C": "G",
  "\u011E": "G",
  "\u0120": "G",
  "\u0122": "G",
  "\u011D": "g",
  "\u011F": "g",
  "\u0121": "g",
  "\u0123": "g",
  "\u0124": "H",
  "\u0126": "H",
  "\u0125": "h",
  "\u0127": "h",
  "\u0128": "I",
  "\u012A": "I",
  "\u012C": "I",
  "\u012E": "I",
  "\u0130": "I",
  "\u0129": "i",
  "\u012B": "i",
  "\u012D": "i",
  "\u012F": "i",
  "\u0131": "i",
  "\u0134": "J",
  "\u0135": "j",
  "\u0136": "K",
  "\u0137": "k",
  "\u0138": "k",
  "\u0139": "L",
  "\u013B": "L",
  "\u013D": "L",
  "\u013F": "L",
  "\u0141": "L",
  "\u013A": "l",
  "\u013C": "l",
  "\u013E": "l",
  "\u0140": "l",
  "\u0142": "l",
  "\u0143": "N",
  "\u0145": "N",
  "\u0147": "N",
  "\u014A": "N",
  "\u0144": "n",
  "\u0146": "n",
  "\u0148": "n",
  "\u014B": "n",
  "\u014C": "O",
  "\u014E": "O",
  "\u0150": "O",
  "\u014D": "o",
  "\u014F": "o",
  "\u0151": "o",
  "\u0154": "R",
  "\u0156": "R",
  "\u0158": "R",
  "\u0155": "r",
  "\u0157": "r",
  "\u0159": "r",
  "\u015A": "S",
  "\u015C": "S",
  "\u015E": "S",
  "\u0160": "S",
  "\u015B": "s",
  "\u015D": "s",
  "\u015F": "s",
  "\u0161": "s",
  "\u0162": "T",
  "\u0164": "T",
  "\u0166": "T",
  "\u0163": "t",
  "\u0165": "t",
  "\u0167": "t",
  "\u0168": "U",
  "\u016A": "U",
  "\u016C": "U",
  "\u016E": "U",
  "\u0170": "U",
  "\u0172": "U",
  "\u0169": "u",
  "\u016B": "u",
  "\u016D": "u",
  "\u016F": "u",
  "\u0171": "u",
  "\u0173": "u",
  "\u0174": "W",
  "\u0175": "w",
  "\u0176": "Y",
  "\u0177": "y",
  "\u0178": "Y",
  "\u0179": "Z",
  "\u017B": "Z",
  "\u017D": "Z",
  "\u017A": "z",
  "\u017C": "z",
  "\u017E": "z",
  "\u0132": "IJ",
  "\u0133": "ij",
  "\u0152": "Oe",
  "\u0153": "oe",
  "\u0149": "'n",
  "\u017F": "s"
};
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter,
    toString$1 = toString_1;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f",
    reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");

function deburr$1(string) {
  string = toString$1(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}

var deburr_1 = deburr$1;
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;
var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f",
    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange = "\\u20d0-\\u20ff",
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff",
    rsMathOpRange = "\\xac\\xb1\\xd7\\xf7",
    rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
    rsPunctuationRange = "\\u2000-\\u206f",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    rsVarRange = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]",
    rsBreak = "[" + rsBreakRange + "]",
    rsCombo = "[" + rsComboRange + "]",
    rsDigits = "\\d+",
    rsDingbat = "[" + rsDingbatRange + "]",
    rsLower = "[" + rsLowerRange + "]",
    rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]",
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
    rsNonAstral = "[^" + rsAstralRange + "]",
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = "[" + rsUpperRange + "]",
    rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")",
    rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")",
    rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?",
    rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?",
    reOptMod = rsModifier + "?",
    rsOptVar = "[" + rsVarRange + "]?",
    rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*",
    rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
    rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")", rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")", rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower, rsUpper + "+" + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join("|"), "g");

function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString2 = toString_1,
    unicodeWords = _unicodeWords;

function words$1(string, pattern, guard) {
  string = toString2(string);
  pattern = guard ? void 0 : pattern;

  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }

  return string.match(pattern) || [];
}

var words_1 = words$1;
var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, "g");

function createCompounder$2(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
  };
}

var _createCompounder = createCompounder$2;
var capitalize = capitalize_1,
    createCompounder$1 = _createCompounder;
var camelCase = createCompounder$1(function (result, word, index2) {
  word = word.toLowerCase();
  return result + (index2 ? capitalize(word) : word);
});
var camelCase_1 = camelCase;
var createCompounder = _createCompounder;
var snakeCase = createCompounder(function (result, word, index2) {
  return result + (index2 ? "_" : "") + word.toLowerCase();
});
var snakeCase_1 = snakeCase;

var extractEarliestKickoffTime = function extractEarliestKickoffTime(fixtures) {
  var kickoffTimes = [];
  fixtures.forEach(function (fixture) {
    var _a2;

    return kickoffTimes.push((_a2 = fixture.matchModel) == null ? void 0 : _a2.kickoffAt);
  });
  var sortedKickoffTimes = kickoffTimes.sort(function (a, b2) {
    return a.localeCompare(b2);
  });
  return sortedKickoffTimes[0];
};

var matchesKickoffObj = function matchesKickoffObj(fixtures) {
  var kickoffObj = {};
  fixtures.forEach(function (fixture, index2) {
    var _a2;

    kickoffObj["match_".concat(index2 + 1)] = (_a2 = fixture.matchModel) == null ? void 0 : _a2.kickoffAt;
  });
  return kickoffObj;
};

var convertDateToGMTIsoString = function convertDateToGMTIsoString(date) {
  var isoStringApiFormat = "YYYY-MM-DDTHH:mm:ss[Z]";
  dayjs.extend(utc);

  if (Array.isArray(date)) {
    return dayjs(date[0]).utc().format(isoStringApiFormat);
  }

  return dayjs(date).utc().format(isoStringApiFormat);
};

var formatNumber = function formatNumber(value) {
  if (value / 1e9 > 1) {
    return "".concat((value / 1e9).toFixed(1), "b");
  } else if (value / 1e6 > 1) {
    return "".concat((value / 1e6).toFixed(1), "m");
  } else if (value / 1e3 > 1) {
    return "".concat((value / 1e3).toFixed(1), "k");
  }

  return value;
};

var remapKeysToSpecificCase = function remapKeysToSpecificCase(obj, type) {
  if (Array.isArray(obj)) {
    return obj.map(function (v2) {
      return remapKeysToSpecificCase(v2, type);
    });
  } else if (obj != null && obj.constructor === Object) {
    if (type === "camel") return Object.keys(obj).reduce(function (result, key) {
      return _objectSpread3({}, result, _defineProperty3({}, camelCase_1(key), remapKeysToSpecificCase(obj[key], type)));
    }, {});else if (type === "snake") return Object.keys(obj).reduce(function (result, key) {
      return _objectSpread3({}, result, _defineProperty3({}, snakeCase_1(key), remapKeysToSpecificCase(obj[key], type)));
    }, {});
  }

  return obj;
};

var createRelated = function createRelated(entityIds, entityType, gameRequestBody) {
  var related = [];

  if (gameRequestBody.related && gameRequestBody.related.length) {
    if (entityIds.length) {
      var newEntityIds = entityIds.filter(function (newId) {
        return gameRequestBody.related.every(function (related2) {
          return related2.entity_id !== newId;
        });
      });

      if (newEntityIds.length) {
        var newRelated = newEntityIds.map(function (newId) {
          return {
            entity_id: newId,
            entity_type: entityType
          };
        });
        related = [].concat(_toConsumableArray3(gameRequestBody.related), _toConsumableArray3(newRelated));
      } else {
        var relatedToRemove = gameRequestBody.related.filter(function (related2) {
          return !entityIds.includes(related2.entity_id) && related2.entity_type === entityType;
        })[0];
        related = gameRequestBody.related.filter(function (related2) {
          return relatedToRemove.entity_id !== related2.entity_id;
        });
      }
    } else {
      related = gameRequestBody.related.filter(function (related2) {
        return related2.entity_type !== entityType;
      });
    }
  } else {
    related = entityIds.map(function (entityId) {
      return {
        entity_id: entityId,
        entity_type: entityType
      };
    });
  }

  return related;
};

var scrollToComponent = function scrollToComponent(componentId2) {
  document.getElementById(componentId2).scrollIntoView({
    behavior: "smooth"
  });
};

var RelatedGames = function RelatedGames() {
  _classCallCheck3(this, RelatedGames);
};

var StatusGame = function StatusGame(labels, gameStatus) {
  var status = null;
  var styleColor = null;

  switch (gameStatus) {
    case "PENDING":
      status = labels.pending;
      styleColor = "gray";
      break;

    case "SETTLED":
      status = labels.settled;
      styleColor = "gray";
      break;

    case "LIVE":
      status = labels.live;
      styleColor = "green";
      break;

    case "OPEN":
      status = labels.open;
      styleColor = "green";
      break;

    case "CANCELED":
      status = labels.canceled;
      styleColor = "red";
      break;

    case "CLOSED":
      status = labels.closed;
      styleColor = "red";
      break;
  }

  return (
    /* @__PURE__ */
    jsx$1("span", {
      className: "topxw-text-center topxw-text-xs topxw-px-3 topxw-py-2 topxw-font-semibold topxw-leading-tight topxw-text-".concat(styleColor, "-700 topxw-bg-").concat(styleColor, "-100 topxw-rounded"),
      children: status
    })
  );
};

var ParticipantsCount = function ParticipantsCount(participantsCount) {
  var participantsString = participantsCount.toString();
  var minDigitsToFormat = 3;

  if (participantsString.length > minDigitsToFormat) {
    return (
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: participantsCount.toLocaleString("ru-RU"),
        children:
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-bg-transparent topxw-cursor-default",
          children: "".concat(formatNumber(participantsCount))
        })
      })
    );
  }

  return participantsCount;
};

var Game = function Game(_ref618) {
  var game = _ref618.game,
      labels = _ref618.labels,
      sdk = _ref618.sdk,
      setEditMode = _ref618.setEditMode,
      setReportMode = _ref618.setReportMode,
      setWinnersMode = _ref618.setWinnersMode,
      setGame = _ref618.setGame,
      setLoadedFixtures = _ref618.setLoadedFixtures,
      setIsLoading = _ref618.setIsLoading;

  var transformDate = function transformDate(date) {
    return dayjs(date).format(labels.timeFormat);
  };

  var matchStatus = function matchStatus(type) {
    var value = labels.upcoming;
    var badgeStyle = "";

    if (typeInProgressGames.includes(type)) {
      value = labels.inProgress;
      badgeStyle = "topxw-h-3 topxw-w-3 topxw-inline-block topxw-rounded-full topxw-bg-blue-600";
    } else if (typeFinishedGames.includes(type)) {
      value = labels.finished;
      badgeStyle = "topxw-h-3 topxw-w-3 topxw-inline-block topxw-rounded-full topxw-bg-red-600";
    } else {
      badgeStyle = "topxw-h-3 topxw-w-3 topxw-inline-block topxw-rounded-full topxw-bg-green-600";
    }

    return (
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: value,
        children:
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-bg-transparent",
          children:
          /* @__PURE__ */
          jsx$1("span", {
            className: "topxw-mr-1 ".concat(badgeStyle)
          })
        })
      })
    );
  };

  var constructOptionFlags = function constructOptionFlags(flags) {
    var optionsFlags = [];
    flags.forEach(function (flag) {
      optionsFlags.push(createOption(flag));
    });
    return optionsFlags;
  };

  var onClickEdit =
  /*#__PURE__*/
  function () {
    var _ref619 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee632() {
      var disableCache, gameById;
      return _regeneratorRuntime.wrap(function _callee632$(_context633) {
        while (1) {
          switch (_context633.prev = _context633.next) {
            case 0:
              setIsLoading(true);
              _context633.prev = 1;
              disableCache = true;
              _context633.next = 5;
              return sdk.topX.getGameById(game.id, disableCache);

            case 5:
              gameById = _context633.sent;
              gameById.flags = gameById.flags ? constructOptionFlags(gameById.flags) : [];

              if (gameById.related) {
                gameById.related = gameById.related.map(function (related) {
                  var newRelated = new RelatedGames();
                  newRelated.entity_id = related.entityId;
                  newRelated.entity_type = related.entityType.toLocaleUpperCase();
                  return newRelated;
                });
              }

              setGame(gameById);
              setLoadedFixtures(gameById.fixtures);
              setEditMode(true);
              _context633.next = 17;
              break;

            case 13:
              _context633.prev = 13;
              _context633.t0 = _context633["catch"](1);
              console.error(_context633.t0);
              toast.error(labels.gameByIdErrorMessage);

            case 17:
              setIsLoading(false);

            case 18:
            case "end":
              return _context633.stop();
          }
        }
      }, _callee632, null, [[1, 13]]);
    }));

    return function onClickEdit() {
      return _ref619.apply(this, arguments);
    };
  }();

  var onClickReport = function onClickReport() {
    setGame(game);
    setReportMode(true);
  };

  var onClickWinners = function onClickWinners() {
    setGame(game);
    setWinnersMode(true);
  };

  return (
    /* @__PURE__ */
    jsxs("tr", {
      className: "topxw-border-b hover:topxw-bg-gray-50",
      children: [
      /* @__PURE__ */
      jsxs("td", {
        className: "topxw-p-2",
        children: [
        /* @__PURE__ */
        jsx$1("a", {
          className: "topxw-font-semibold topxw-text-black topxw-text-xl topxw-mb-2 topxw-cursor-pointer",
          onClick: onClickEdit,
          "data-testid": "game's title",
          children: game.title
        }), game.fixtures.map(function (fixture, idx) {
          return (
            /* @__PURE__ */
            jsxs("div", {
              className: "topxw-text-black topxw-mb-3 topxw-flex topxw-items-center",
              "data-testid": "game's matches",
              children: [matchStatus(fixture.matchModel.status.type),
              /* @__PURE__ */
              jsxs("span", {
                className: "topxw-mr-2 md:topxw-text-sm topxw-hidden",
                children: ["[", transformDate(fixture.matchModel.kickoffAt), "]"]
              }),
              /* @__PURE__ */
              jsx$1(MatchName, {
                homeTeamName: fixture.matchModel.homeTeam.name,
                awayTeamName: fixture.matchModel.awayTeam.name,
                homeTeamAssets: fixture.matchModel.homeTeam.assets,
                awayTeamAssets: fixture.matchModel.awayTeam.assets
              })]
            }, "".concat(fixture.matchId + idx))
          );
        })]
      }),
      /* @__PURE__ */
      jsx$1("td", {
        className: "topxw-hidden md:topxw-table-cell topxw-text-center topxw-p-2",
        "data-testid": "game's status",
        children: StatusGame(labels, game.status)
      }),
      /* @__PURE__ */
      jsx$1("td", {
        className: "topxw-hidden md:topxw-table-cell topxw-text-center topxw-p-2",
        "data-testid": "game's participants",
        children: ParticipantsCount(game.participantsCount)
      }),
      /* @__PURE__ */
      jsx$1("td", {
        className: "topxw-text-sm topxw-hidden md:topxw-table-cell topxw-text-center topxw-p-2",
        "data-testid": "game's creation date",
        children: transformDate(game.createdAt)
      }),
      /* @__PURE__ */
      jsx$1("td", {
        className: "topxw-text-sm topxw-hidden md:topxw-table-cell topxw-text-center topxw-p-2",
        "data-testid": "game's cutoff time",
        children: transformDate(game.predictionsCutoff)
      }),
      /* @__PURE__ */
      jsx$1("td", {
        className: "topxw-text-right topxw-p-2",
        "data-testid": "game's buttons",
        children:
        /* @__PURE__ */
        jsx$1("div", {
          className: "topxw-flex topxw-items-center topxw-justify-end",
          children:
          /* @__PURE__ */
          jsx$1(ActionsButtons, {
            tippyKey: game.id,
            status: game.status,
            labelEdit: labels.edit,
            labelReport: labels.report,
            labelWinners: labels.winners,
            onClickEdit: onClickEdit,
            onClickReport: onClickReport,
            onClickWinners: onClickWinners
          })
        })
      })]
    })
  );
};

var Spinner = function Spinner(_ref620) {
  var forNextMatches = _ref620.forNextMatches;
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-flex topxw-justify-center ".concat(forNextMatches ? "topxw-my-20" : "topxw-my-80"),
      "data-testid": "spinner",
      children:
      /* @__PURE__ */
      jsxs("svg", {
        role: "status",
        className: "topxw-mr-2 ".concat(forNextMatches ? "topxw-w-10" : "topxw-w-16", " ").concat(forNextMatches ? "topxw-h-10" : "topxw-h-16", " topxw-text-gray-200 topxw-animate-spin topxw-dark:text-gray-600 topxw-fill-gray-600 topxw-dark:fill-gray-300"),
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
        /* @__PURE__ */
        jsx$1("path", {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor"
        }),
        /* @__PURE__ */
        jsx$1("path", {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: "currentFill"
        })]
      })
    })
  );
};

var FixtureModel = function FixtureModel() {
  _classCallCheck3(this, FixtureModel);

  this.match_id = null;
  this.match_type = "FOOTBALL";
  this.market = "";
};

var Images = function Images() {
  _classCallCheck3(this, Images);

  this.main = null;
  this.cover = null;
  this.mobile = null;
};

var GameRequestBody = function GameRequestBody() {
  _classCallCheck3(this, GameRequestBody);

  this.title = null;
  this.description = null;
  this.type = "TOP_X";
  this.status = "PENDING";
  this.tiebreaker = {
    time_tiebreaker: true
  };
  this.ad_content = null;
  this.labels = null;
  this.custom_fields = null;
  this.rules = null;
  this.flags = [];
  this.images = new Images();
  this.predictions_cutoff = null;
  this.schedule_open_at = null;
  this.fixtures = [new FixtureModel()];
  this.related = null;
};

var backButtonStyle = "topxw-rounded topxw-bg-transparent topxw-mr-2 topxw-flex topxw-items-center";

var ScreenHeader = function ScreenHeader(props) {
  var handleOnClick = function handleOnClick() {
    props.editMode ? props.setEditMode(false) : props.setCreateMode(false);
  };

  if (props.reportMode) {
    return (
      /* @__PURE__ */
      jsx$1(Fragment, {
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-flex topxw-items-center topxw-justify-between",
          children: [
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-items-center",
            children: [
            /* @__PURE__ */
            jsx$1(Tippy, {
              content: props.labels.back,
              children:
              /* @__PURE__ */
              jsx$1("button", {
                "data-testid": "back",
                className: "topxw-rounded topxw-bg-transparent topxw-mr-2 topxw-flex topxw-items-center",
                onClick: function onClick() {
                  return props.setReportMode(false);
                },
                children:
                /* @__PURE__ */
                jsx$1("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "topxw-h-7 topxw-w-7",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  children:
                  /* @__PURE__ */
                  jsx$1("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                  })
                })
              })
            }),
            /* @__PURE__ */
            jsxs("h3", {
              className: "topxw-text-xl topxw-font-bold topxw-my-4",
              children: [props.labels.reportFor, " ", props.gameTitle]
            })]
          }),
          /* @__PURE__ */
          jsx$1("button", {
            onClick: function onClick() {
              return props.setShowModal(true);
            },
            className: "topxw-rounded topxw-bg-gray-700 topxw-text-white hover:topxw-bg-gray-800 topxw-uppercase topxw-text-xs topxw-font-bold topxw-py-2 topxw-px-3",
            children: props.labels.exportButton
          })]
        })
      })
    );
  }

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-flex topxw-items-center",
      children: [
      /* @__PURE__ */
      jsx$1(Tippy, {
        content: props.labels.back,
        children:
        /* @__PURE__ */
        jsx$1("button", {
          className: backButtonStyle,
          onClick: handleOnClick,
          "data-testid": "back",
          children:
          /* @__PURE__ */
          jsx$1("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: svgSize(7),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            strokeWidth: "2",
            children:
            /* @__PURE__ */
            jsx$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
            })
          })
        })
      }),
      /* @__PURE__ */
      jsx$1("h3", {
        className: "topxw-text-xl topxw-font-bold topxw-my-4",
        children: props.editMode ? props.labels.edit : props.labels.createEdition
      })]
    })
  );
};

var build = {};
var propTypes$1 = {
  exports: {}
};
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }

    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  }

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

{
  propTypes$1.exports = factoryWithThrowingShims();
}
var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
var defaults = {
  _disable: [],
  allowInput: false,
  allowInvalidPreload: false,
  altFormat: "F j, Y",
  altInput: false,
  altInputClass: "form-control input",
  animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: true,
  clickOpens: true,
  closeOnSelect: true,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: false,
  enableSeconds: false,
  enableTime: false,
  errorHandler: function errorHandler(err) {
    return typeof console !== "undefined" && console.warn(err);
  },
  getWeek: function getWeek(givenDate) {
    var date = new Date(givenDate.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 864e5 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: false,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: false,
  now: new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: false,
  showMonths: 1,
  static: false,
  time_24hr: false,
  weekNumbers: false,
  wrap: false
};
var english = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  months: {
    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function ordinal(nth) {
    var s = nth % 100;
    if (s > 3 && s < 21) return "th";

    switch (s % 10) {
      case 1:
        return "st";

      case 2:
        return "nd";

      case 3:
        return "rd";

      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: false
};

var pad = function pad(number, length2) {
  if (length2 === void 0) {
    length2 = 2;
  }

  return ("000" + number).slice(length2 * -1);
};

var _int = function _int(bool) {
  return bool === true ? 1 : 0;
};

function debounce$1(fn3, wait) {
  var t2;
  return function () {
    var _this = this;

    var args = arguments;
    clearTimeout(t2);
    t2 = setTimeout(function () {
      return fn3.apply(_this, args);
    }, wait);
  };
}

var arrayify = function arrayify(obj) {
  return obj instanceof Array ? obj : [obj];
};

function toggleClass(elem, className, bool) {
  if (bool === true) return elem.classList.add(className);
  elem.classList.remove(className);
}

function createElement(tag, className, content) {
  var e2 = window.document.createElement(tag);
  className = className || "";
  content = content || "";
  e2.className = className;
  if (content !== void 0) e2.textContent = content;
  return e2;
}

function clearNode(node2) {
  while (node2.firstChild) {
    node2.removeChild(node2.firstChild);
  }
}

function findParent(node2, condition) {
  if (condition(node2)) return node2;else if (node2.parentNode) return findParent(node2.parentNode, condition);
  return void 0;
}

function createNumberInput(inputClassName, opts) {
  var wrapper = createElement("div", "numInputWrapper"),
      numInput = createElement("input", "numInput " + inputClassName),
      arrowUp = createElement("span", "arrowUp"),
      arrowDown = createElement("span", "arrowDown");

  if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
    numInput.type = "number";
  } else {
    numInput.type = "text";
    numInput.pattern = "\\d*";
  }

  if (opts !== void 0) for (var key in opts) {
    numInput.setAttribute(key, opts[key]);
  }
  wrapper.appendChild(numInput);
  wrapper.appendChild(arrowUp);
  wrapper.appendChild(arrowDown);
  return wrapper;
}

function getEventTarget(event) {
  try {
    if (typeof event.composedPath === "function") {
      var path = event.composedPath();
      return path[0];
    }

    return event.target;
  } catch (error) {
    return event.target;
  }
}

var doNothing = function doNothing() {
  return void 0;
};

var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
  return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};

var revFormat = {
  D: doNothing,
  F: function F(dateObj, monthName, locale) {
    dateObj.setMonth(locale.months.longhand.indexOf(monthName));
  },
  G: function G(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  H: function H(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  J: function J(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  K: function K(dateObj, amPM, locale) {
    dateObj.setHours(dateObj.getHours() % 12 + 12 * _int(new RegExp(locale.amPM[1], "i").test(amPM)));
  },
  M: function M(dateObj, shortMonth, locale) {
    dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
  },
  S: function S(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  U: function U(_2, unixSeconds) {
    return new Date(parseFloat(unixSeconds) * 1e3);
  },
  W: function W(dateObj, weekNum, locale) {
    var weekNumber = parseInt(weekNum);
    var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
    return date;
  },
  Y: function Y(dateObj, year) {
    dateObj.setFullYear(parseFloat(year));
  },
  Z: function Z(_2, ISODate) {
    return new Date(ISODate);
  },
  d: function d(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  h: function h(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  i: function i(dateObj, minutes) {
    dateObj.setMinutes(parseFloat(minutes));
  },
  j: function j(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  l: doNothing,
  m: function m(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  n: function n(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  s: function s(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  u: function u(_2, unixMillSeconds) {
    return new Date(parseFloat(unixMillSeconds));
  },
  w: doNothing,
  y: function y(dateObj, year) {
    dateObj.setFullYear(2e3 + parseFloat(year));
  }
};
var tokenRegex = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
};
var formats = {
  Z: function Z(date) {
    return date.toISOString();
  },
  D: function D(date, locale, options2) {
    return locale.weekdays.shorthand[formats.w(date, locale, options2)];
  },
  F: function F(date, locale, options2) {
    return monthToStr(formats.n(date, locale, options2) - 1, false, locale);
  },
  G: function G(date, locale, options2) {
    return pad(formats.h(date, locale, options2));
  },
  H: function H(date) {
    return pad(date.getHours());
  },
  J: function J(date, locale) {
    return locale.ordinal !== void 0 ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
  },
  K: function K(date, locale) {
    return locale.amPM[_int(date.getHours() > 11)];
  },
  M: function M(date, locale) {
    return monthToStr(date.getMonth(), true, locale);
  },
  S: function S(date) {
    return pad(date.getSeconds());
  },
  U: function U(date) {
    return date.getTime() / 1e3;
  },
  W: function W(date, _2, options2) {
    return options2.getWeek(date);
  },
  Y: function Y(date) {
    return pad(date.getFullYear(), 4);
  },
  d: function d(date) {
    return pad(date.getDate());
  },
  h: function h(date) {
    return date.getHours() % 12 ? date.getHours() % 12 : 12;
  },
  i: function i(date) {
    return pad(date.getMinutes());
  },
  j: function j(date) {
    return date.getDate();
  },
  l: function l(date, locale) {
    return locale.weekdays.longhand[date.getDay()];
  },
  m: function m(date) {
    return pad(date.getMonth() + 1);
  },
  n: function n(date) {
    return date.getMonth() + 1;
  },
  s: function s(date) {
    return date.getSeconds();
  },
  u: function u(date) {
    return date.getTime();
  },
  w: function w(date) {
    return date.getDay();
  },
  y: function y(date) {
    return String(date.getFullYear()).substring(2);
  }
};

var createDateFormatter = function createDateFormatter(_a2) {
  var _b = _a2.config,
      config = _b === void 0 ? defaults : _b,
      _c = _a2.l10n,
      l10n = _c === void 0 ? english : _c,
      _d = _a2.isMobile,
      isMobile = _d === void 0 ? false : _d;
  return function (dateObj, frmt, overrideLocale) {
    var locale = overrideLocale || l10n;

    if (config.formatDate !== void 0 && !isMobile) {
      return config.formatDate(dateObj, frmt, locale);
    }

    return frmt.split("").map(function (c2, i, arr) {
      return formats[c2] && arr[i - 1] !== "\\" ? formats[c2](dateObj, locale, config) : c2 !== "\\" ? c2 : "";
    }).join("");
  };
};

var createDateParser = function createDateParser(_a2) {
  var _b = _a2.config,
      config = _b === void 0 ? defaults : _b,
      _c = _a2.l10n,
      l10n = _c === void 0 ? english : _c;
  return function (date, givenFormat, timeless, customLocale) {
    if (date !== 0 && !date) return void 0;
    var locale = customLocale || l10n;
    var parsedDate;
    var dateOrig = date;
    if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== void 0) parsedDate = new Date(date);else if (typeof date === "string") {
      var format = givenFormat || (config || defaults).dateFormat;
      var datestr = String(date).trim();

      if (datestr === "today") {
        parsedDate = new Date();
        timeless = true;
      } else if (config && config.parseDate) {
        parsedDate = config.parseDate(date, format);
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) {
        parsedDate = new Date(date);
      } else {
        var matched = void 0,
            ops = [];

        for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
          var token2 = format[i];
          var isBackSlash = token2 === "\\";
          var escaped = format[i - 1] === "\\" || isBackSlash;

          if (tokenRegex[token2] && !escaped) {
            regexStr += tokenRegex[token2];
            var match2 = new RegExp(regexStr).exec(date);

            if (match2 && (matched = true)) {
              ops[token2 !== "Y" ? "push" : "unshift"]({
                fn: revFormat[token2],
                val: match2[++matchIndex]
              });
            }
          } else if (!isBackSlash) regexStr += ".";
        }

        parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
        ops.forEach(function (_a3) {
          var fn3 = _a3.fn,
              val = _a3.val;
          return parsedDate = fn3(parsedDate, val, locale) || parsedDate;
        });
        parsedDate = matched ? parsedDate : void 0;
      }
    }

    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      config.errorHandler(new Error("Invalid date provided: " + dateOrig));
      return void 0;
    }

    if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  };
};

function compareDates(date1, date2, timeless) {
  if (timeless === void 0) {
    timeless = true;
  }

  if (timeless !== false) {
    return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
  }

  return date1.getTime() - date2.getTime();
}

var isBetween = function isBetween(ts2, ts1, ts22) {
  return ts2 > Math.min(ts1, ts22) && ts2 < Math.max(ts1, ts22);
};

var calculateSecondsSinceMidnight = function calculateSecondsSinceMidnight(hours, minutes, seconds) {
  return hours * 3600 + minutes * 60 + seconds;
};

var parseSeconds = function parseSeconds(secondsSinceMidnight) {
  var hours = Math.floor(secondsSinceMidnight / 3600),
      minutes = (secondsSinceMidnight - hours * 3600) / 60;
  return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
};

var duration = {
  DAY: 864e5
};

function getDefaultHours(config) {
  var hours = config.defaultHour;
  var minutes = config.defaultMinute;
  var seconds = config.defaultSeconds;

  if (config.minDate !== void 0) {
    var minHour = config.minDate.getHours();
    var minMinutes = config.minDate.getMinutes();
    var minSeconds = config.minDate.getSeconds();

    if (hours < minHour) {
      hours = minHour;
    }

    if (hours === minHour && minutes < minMinutes) {
      minutes = minMinutes;
    }

    if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
  }

  if (config.maxDate !== void 0) {
    var maxHr = config.maxDate.getHours();
    var maxMinutes = config.maxDate.getMinutes();
    hours = Math.min(hours, maxHr);
    if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
    if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

if (typeof Object.assign !== "function") {
  Object.assign = function (target) {
    var args = [];

    for (var _i2 = 1; _i2 < arguments.length; _i2++) {
      args[_i2 - 1] = arguments[_i2];
    }

    if (!target) {
      throw TypeError("Cannot convert undefined or null to object");
    }

    var _loop_1 = function _loop_1(source3) {
      if (source3) {
        Object.keys(source3).forEach(function (key) {
          return target[key] = source3[key];
        });
      }
    };

    for (var _a2 = 0, args_1 = args; _a2 < args_1.length; _a2++) {
      var source2 = args_1[_a2];

      _loop_1(source2);
    }

    return target;
  };
}

var __assign$1 = globalThis && globalThis.__assign || function () {
  __assign$1 = Object.assign || function (t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];

      for (var p2 in s) {
        if (Object.prototype.hasOwnProperty.call(s, p2)) t2[p2] = s[p2];
      }
    }

    return t2;
  };

  return __assign$1.apply(this, arguments);
};

var __spreadArrays$1 = globalThis && globalThis.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r2 = Array(s), k2 = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k2++) {
      r2[k2] = a[j];
    }
  }

  return r2;
};

var DEBOUNCED_CHANGE_MS = 300;

function FlatpickrInstance(element, instanceConfig) {
  var self2 = {
    config: __assign$1(__assign$1({}, defaults), flatpickr.defaultConfig),
    l10n: english
  };
  self2.parseDate = createDateParser({
    config: self2.config,
    l10n: self2.l10n
  });
  self2._handlers = [];
  self2.pluginElements = [];
  self2.loadedPlugins = [];
  self2._bind = bind3;
  self2._setHoursFromDate = setHoursFromDate;
  self2._positionCalendar = positionCalendar;
  self2.changeMonth = changeMonth;
  self2.changeYear = changeYear;
  self2.clear = clear;
  self2.close = close;
  self2.onMouseOver = onMouseOver;
  self2._createElement = createElement;
  self2.createDay = createDay;
  self2.destroy = destroy;
  self2.isEnabled = isEnabled;
  self2.jumpToDate = jumpToDate;
  self2.updateValue = updateValue;
  self2.open = open;
  self2.redraw = redraw;
  self2.set = set;
  self2.setDate = setDate;
  self2.toggle = toggle;

  function setupHelperFunctions() {
    self2.utils = {
      getDaysInMonth: function getDaysInMonth(month, yr2) {
        if (month === void 0) {
          month = self2.currentMonth;
        }

        if (yr2 === void 0) {
          yr2 = self2.currentYear;
        }

        if (month === 1 && (yr2 % 4 === 0 && yr2 % 100 !== 0 || yr2 % 400 === 0)) return 29;
        return self2.l10n.daysInMonth[month];
      }
    };
  }

  function init() {
    self2.element = self2.input = element;
    self2.isOpen = false;
    parseConfig();
    setupLocale();
    setupInputs();
    setupDates();
    setupHelperFunctions();
    if (!self2.isMobile) build2();
    bindEvents();

    if (self2.selectedDates.length || self2.config.noCalendar) {
      if (self2.config.enableTime) {
        setHoursFromDate(self2.config.noCalendar ? self2.latestSelectedDateObj : void 0);
      }

      updateValue(false);
    }

    setCalendarWidth();
    var isSafari2 = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!self2.isMobile && isSafari2) {
      positionCalendar();
    }

    triggerEvent("onReady");
  }

  function getClosestActiveElement() {
    var _a2;

    return ((_a2 = self2.calendarContainer) === null || _a2 === void 0 ? void 0 : _a2.getRootNode()).activeElement || document.activeElement;
  }

  function bindToInstance(fn3) {
    return fn3.bind(self2);
  }

  function setCalendarWidth() {
    var config = self2.config;

    if (config.weekNumbers === false && config.showMonths === 1) {
      return;
    } else if (config.noCalendar !== true) {
      window.requestAnimationFrame(function () {
        if (self2.calendarContainer !== void 0) {
          self2.calendarContainer.style.visibility = "hidden";
          self2.calendarContainer.style.display = "block";
        }

        if (self2.daysContainer !== void 0) {
          var daysWidth = (self2.days.offsetWidth + 1) * config.showMonths;
          self2.daysContainer.style.width = daysWidth + "px";
          self2.calendarContainer.style.width = daysWidth + (self2.weekWrapper !== void 0 ? self2.weekWrapper.offsetWidth : 0) + "px";
          self2.calendarContainer.style.removeProperty("visibility");
          self2.calendarContainer.style.removeProperty("display");
        }
      });
    }
  }

  function updateTime(e2) {
    if (self2.selectedDates.length === 0) {
      var defaultDate = self2.config.minDate === void 0 || compareDates(new Date(), self2.config.minDate) >= 0 ? new Date() : new Date(self2.config.minDate.getTime());
      var defaults2 = getDefaultHours(self2.config);
      defaultDate.setHours(defaults2.hours, defaults2.minutes, defaults2.seconds, defaultDate.getMilliseconds());
      self2.selectedDates = [defaultDate];
      self2.latestSelectedDateObj = defaultDate;
    }

    if (e2 !== void 0 && e2.type !== "blur") {
      timeWrapper(e2);
    }

    var prevValue = self2._input.value;
    setHoursFromInputs();
    updateValue();

    if (self2._input.value !== prevValue) {
      self2._debouncedChange();
    }
  }

  function ampm2military(hour, amPM) {
    return hour % 12 + 12 * _int(amPM === self2.l10n.amPM[1]);
  }

  function military2ampm(hour) {
    switch (hour % 24) {
      case 0:
      case 12:
        return 12;

      default:
        return hour % 12;
    }
  }

  function setHoursFromInputs() {
    if (self2.hourElement === void 0 || self2.minuteElement === void 0) return;
    var hours = (parseInt(self2.hourElement.value.slice(-2), 10) || 0) % 24,
        minutes = (parseInt(self2.minuteElement.value, 10) || 0) % 60,
        seconds = self2.secondElement !== void 0 ? (parseInt(self2.secondElement.value, 10) || 0) % 60 : 0;

    if (self2.amPM !== void 0) {
      hours = ampm2military(hours, self2.amPM.textContent);
    }

    var limitMinHours = self2.config.minTime !== void 0 || self2.config.minDate && self2.minDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.minDate, true) === 0;
    var limitMaxHours = self2.config.maxTime !== void 0 || self2.config.maxDate && self2.maxDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.maxDate, true) === 0;

    if (self2.config.maxTime !== void 0 && self2.config.minTime !== void 0 && self2.config.minTime > self2.config.maxTime) {
      var minBound = calculateSecondsSinceMidnight(self2.config.minTime.getHours(), self2.config.minTime.getMinutes(), self2.config.minTime.getSeconds());
      var maxBound = calculateSecondsSinceMidnight(self2.config.maxTime.getHours(), self2.config.maxTime.getMinutes(), self2.config.maxTime.getSeconds());
      var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);

      if (currentTime > maxBound && currentTime < minBound) {
        var result = parseSeconds(minBound);
        hours = result[0];
        minutes = result[1];
        seconds = result[2];
      }
    } else {
      if (limitMaxHours) {
        var maxTime = self2.config.maxTime !== void 0 ? self2.config.maxTime : self2.config.maxDate;
        hours = Math.min(hours, maxTime.getHours());
        if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
        if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
      }

      if (limitMinHours) {
        var minTime = self2.config.minTime !== void 0 ? self2.config.minTime : self2.config.minDate;
        hours = Math.max(hours, minTime.getHours());
        if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
        if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
      }
    }

    setHours(hours, minutes, seconds);
  }

  function setHoursFromDate(dateObj) {
    var date = dateObj || self2.latestSelectedDateObj;

    if (date && date instanceof Date) {
      setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }

  function setHours(hours, minutes, seconds) {
    if (self2.latestSelectedDateObj !== void 0) {
      self2.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
    }

    if (!self2.hourElement || !self2.minuteElement || self2.isMobile) return;
    self2.hourElement.value = pad(!self2.config.time_24hr ? (12 + hours) % 12 + 12 * _int(hours % 12 === 0) : hours);
    self2.minuteElement.value = pad(minutes);
    if (self2.amPM !== void 0) self2.amPM.textContent = self2.l10n.amPM[_int(hours >= 12)];
    if (self2.secondElement !== void 0) self2.secondElement.value = pad(seconds);
  }

  function onYearInput(event) {
    var eventTarget = getEventTarget(event);
    var year = parseInt(eventTarget.value) + (event.delta || 0);

    if (year / 1e3 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
      changeYear(year);
    }
  }

  function bind3(element2, event, handler, options2) {
    if (event instanceof Array) return event.forEach(function (ev) {
      return bind3(element2, ev, handler, options2);
    });
    if (element2 instanceof Array) return element2.forEach(function (el) {
      return bind3(el, event, handler, options2);
    });
    element2.addEventListener(event, handler, options2);

    self2._handlers.push({
      remove: function remove() {
        return element2.removeEventListener(event, handler, options2);
      }
    });
  }

  function triggerChange() {
    triggerEvent("onChange");
  }

  function bindEvents() {
    if (self2.config.wrap) {
      ["open", "close", "toggle", "clear"].forEach(function (evt) {
        Array.prototype.forEach.call(self2.element.querySelectorAll("[data-" + evt + "]"), function (el) {
          return bind3(el, "click", self2[evt]);
        });
      });
    }

    if (self2.isMobile) {
      setupMobile();
      return;
    }

    var debouncedResize = debounce$1(onResize, 50);
    self2._debouncedChange = debounce$1(triggerChange, DEBOUNCED_CHANGE_MS);
    if (self2.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind3(self2.daysContainer, "mouseover", function (e2) {
      if (self2.config.mode === "range") onMouseOver(getEventTarget(e2));
    });
    bind3(self2._input, "keydown", onKeyDown);

    if (self2.calendarContainer !== void 0) {
      bind3(self2.calendarContainer, "keydown", onKeyDown);
    }

    if (!self2.config.inline && !self2.config.static) bind3(window, "resize", debouncedResize);
    if (window.ontouchstart !== void 0) bind3(window.document, "touchstart", documentClick);else bind3(window.document, "mousedown", documentClick);
    bind3(window.document, "focus", documentClick, {
      capture: true
    });

    if (self2.config.clickOpens === true) {
      bind3(self2._input, "focus", self2.open);
      bind3(self2._input, "click", self2.open);
    }

    if (self2.daysContainer !== void 0) {
      bind3(self2.monthNav, "click", onMonthNavClick);
      bind3(self2.monthNav, ["keyup", "increment"], onYearInput);
      bind3(self2.daysContainer, "click", selectDate);
    }

    if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0) {
      var selText = function selText(e2) {
        return getEventTarget(e2).select();
      };

      bind3(self2.timeContainer, ["increment"], updateTime);
      bind3(self2.timeContainer, "blur", updateTime, {
        capture: true
      });
      bind3(self2.timeContainer, "click", timeIncrement);
      bind3([self2.hourElement, self2.minuteElement], ["focus", "click"], selText);
      if (self2.secondElement !== void 0) bind3(self2.secondElement, "focus", function () {
        return self2.secondElement && self2.secondElement.select();
      });

      if (self2.amPM !== void 0) {
        bind3(self2.amPM, "click", function (e2) {
          updateTime(e2);
        });
      }
    }

    if (self2.config.allowInput) {
      bind3(self2._input, "blur", onBlur);
    }
  }

  function jumpToDate(jumpDate, triggerChange2) {
    var jumpTo = jumpDate !== void 0 ? self2.parseDate(jumpDate) : self2.latestSelectedDateObj || (self2.config.minDate && self2.config.minDate > self2.now ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate < self2.now ? self2.config.maxDate : self2.now);
    var oldYear = self2.currentYear;
    var oldMonth = self2.currentMonth;

    try {
      if (jumpTo !== void 0) {
        self2.currentYear = jumpTo.getFullYear();
        self2.currentMonth = jumpTo.getMonth();
      }
    } catch (e2) {
      e2.message = "Invalid date supplied: " + jumpTo;
      self2.config.errorHandler(e2);
    }

    if (triggerChange2 && self2.currentYear !== oldYear) {
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    if (triggerChange2 && (self2.currentYear !== oldYear || self2.currentMonth !== oldMonth)) {
      triggerEvent("onMonthChange");
    }

    self2.redraw();
  }

  function timeIncrement(e2) {
    var eventTarget = getEventTarget(e2);
    if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e2, eventTarget.classList.contains("arrowUp") ? 1 : -1);
  }

  function incrementNumInput(e2, delta, inputElem) {
    var target = e2 && getEventTarget(e2);
    var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
    var event = createEvent("increment");
    event.delta = delta;
    input && input.dispatchEvent(event);
  }

  function build2() {
    var fragment = window.document.createDocumentFragment();
    self2.calendarContainer = createElement("div", "flatpickr-calendar");
    self2.calendarContainer.tabIndex = -1;

    if (!self2.config.noCalendar) {
      fragment.appendChild(buildMonthNav());
      self2.innerContainer = createElement("div", "flatpickr-innerContainer");

      if (self2.config.weekNumbers) {
        var _a2 = buildWeeks(),
            weekWrapper = _a2.weekWrapper,
            weekNumbers = _a2.weekNumbers;

        self2.innerContainer.appendChild(weekWrapper);
        self2.weekNumbers = weekNumbers;
        self2.weekWrapper = weekWrapper;
      }

      self2.rContainer = createElement("div", "flatpickr-rContainer");
      self2.rContainer.appendChild(buildWeekdays());

      if (!self2.daysContainer) {
        self2.daysContainer = createElement("div", "flatpickr-days");
        self2.daysContainer.tabIndex = -1;
      }

      buildDays();
      self2.rContainer.appendChild(self2.daysContainer);
      self2.innerContainer.appendChild(self2.rContainer);
      fragment.appendChild(self2.innerContainer);
    }

    if (self2.config.enableTime) {
      fragment.appendChild(buildTime());
    }

    toggleClass(self2.calendarContainer, "rangeMode", self2.config.mode === "range");
    toggleClass(self2.calendarContainer, "animate", self2.config.animate === true);
    toggleClass(self2.calendarContainer, "multiMonth", self2.config.showMonths > 1);
    self2.calendarContainer.appendChild(fragment);
    var customAppend = self2.config.appendTo !== void 0 && self2.config.appendTo.nodeType !== void 0;

    if (self2.config.inline || self2.config.static) {
      self2.calendarContainer.classList.add(self2.config.inline ? "inline" : "static");

      if (self2.config.inline) {
        if (!customAppend && self2.element.parentNode) self2.element.parentNode.insertBefore(self2.calendarContainer, self2._input.nextSibling);else if (self2.config.appendTo !== void 0) self2.config.appendTo.appendChild(self2.calendarContainer);
      }

      if (self2.config.static) {
        var wrapper = createElement("div", "flatpickr-wrapper");
        if (self2.element.parentNode) self2.element.parentNode.insertBefore(wrapper, self2.element);
        wrapper.appendChild(self2.element);
        if (self2.altInput) wrapper.appendChild(self2.altInput);
        wrapper.appendChild(self2.calendarContainer);
      }
    }

    if (!self2.config.static && !self2.config.inline) (self2.config.appendTo !== void 0 ? self2.config.appendTo : window.document.body).appendChild(self2.calendarContainer);
  }

  function createDay(className, date, _dayNumber, i) {
    var dateIsEnabled = isEnabled(date, true),
        dayElement = createElement("span", className, date.getDate().toString());
    dayElement.dateObj = date;
    dayElement.$i = i;
    dayElement.setAttribute("aria-label", self2.formatDate(date, self2.config.ariaDateFormat));

    if (className.indexOf("hidden") === -1 && compareDates(date, self2.now) === 0) {
      self2.todayDateElem = dayElement;
      dayElement.classList.add("today");
      dayElement.setAttribute("aria-current", "date");
    }

    if (dateIsEnabled) {
      dayElement.tabIndex = -1;

      if (isDateSelected(date)) {
        dayElement.classList.add("selected");
        self2.selectedDateElem = dayElement;

        if (self2.config.mode === "range") {
          toggleClass(dayElement, "startRange", self2.selectedDates[0] && compareDates(date, self2.selectedDates[0], true) === 0);
          toggleClass(dayElement, "endRange", self2.selectedDates[1] && compareDates(date, self2.selectedDates[1], true) === 0);
          if (className === "nextMonthDay") dayElement.classList.add("inRange");
        }
      }
    } else {
      dayElement.classList.add("flatpickr-disabled");
    }

    if (self2.config.mode === "range") {
      if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
    }

    if (self2.weekNumbers && self2.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) {
      self2.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self2.config.getWeek(date) + "</span>");
    }

    triggerEvent("onDayCreate", dayElement);
    return dayElement;
  }

  function focusOnDayElem(targetNode) {
    targetNode.focus();
    if (self2.config.mode === "range") onMouseOver(targetNode);
  }

  function getFirstAvailableDay(delta) {
    var startMonth = delta > 0 ? 0 : self2.config.showMonths - 1;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;

    for (var m2 = startMonth; m2 != endMonth; m2 += delta) {
      var month = self2.daysContainer.children[m2];
      var startIndex = delta > 0 ? 0 : month.children.length - 1;
      var endIndex = delta > 0 ? month.children.length : -1;

      for (var i = startIndex; i != endIndex; i += delta) {
        var c2 = month.children[i];
        if (c2.className.indexOf("hidden") === -1 && isEnabled(c2.dateObj)) return c2;
      }
    }

    return void 0;
  }

  function getNextAvailableDay(current, delta) {
    var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self2.currentMonth;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;
    var loopDelta = delta > 0 ? 1 : -1;

    for (var m2 = givenMonth - self2.currentMonth; m2 != endMonth; m2 += loopDelta) {
      var month = self2.daysContainer.children[m2];
      var startIndex = givenMonth - self2.currentMonth === m2 ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
      var numMonthDays = month.children.length;

      for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
        var c2 = month.children[i];
        if (c2.className.indexOf("hidden") === -1 && isEnabled(c2.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c2);
      }
    }

    self2.changeMonth(loopDelta);
    focusOnDay(getFirstAvailableDay(loopDelta), 0);
    return void 0;
  }

  function focusOnDay(current, offset2) {
    var activeElement = getClosestActiveElement();
    var dayFocused = isInView(activeElement || document.body);
    var startElem = current !== void 0 ? current : dayFocused ? activeElement : self2.selectedDateElem !== void 0 && isInView(self2.selectedDateElem) ? self2.selectedDateElem : self2.todayDateElem !== void 0 && isInView(self2.todayDateElem) ? self2.todayDateElem : getFirstAvailableDay(offset2 > 0 ? 1 : -1);

    if (startElem === void 0) {
      self2._input.focus();
    } else if (!dayFocused) {
      focusOnDayElem(startElem);
    } else {
      getNextAvailableDay(startElem, offset2);
    }
  }

  function buildMonthDays(year, month) {
    var firstOfMonth = (new Date(year, month, 1).getDay() - self2.l10n.firstDayOfWeek + 7) % 7;
    var prevMonthDays = self2.utils.getDaysInMonth((month - 1 + 12) % 12, year);
    var daysInMonth = self2.utils.getDaysInMonth(month, year),
        days = window.document.createDocumentFragment(),
        isMultiMonth = self2.config.showMonths > 1,
        prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
        nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
    var dayNumber = prevMonthDays + 1 - firstOfMonth,
        dayIndex = 0;

    for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
    }

    for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
    }

    for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self2.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
    }

    var dayContainer = createElement("div", "dayContainer");
    dayContainer.appendChild(days);
    return dayContainer;
  }

  function buildDays() {
    if (self2.daysContainer === void 0) {
      return;
    }

    clearNode(self2.daysContainer);
    if (self2.weekNumbers) clearNode(self2.weekNumbers);
    var frag = document.createDocumentFragment();

    for (var i = 0; i < self2.config.showMonths; i++) {
      var d2 = new Date(self2.currentYear, self2.currentMonth, 1);
      d2.setMonth(self2.currentMonth + i);
      frag.appendChild(buildMonthDays(d2.getFullYear(), d2.getMonth()));
    }

    self2.daysContainer.appendChild(frag);
    self2.days = self2.daysContainer.firstChild;

    if (self2.config.mode === "range" && self2.selectedDates.length === 1) {
      onMouseOver();
    }
  }

  function buildMonthSwitch() {
    if (self2.config.showMonths > 1 || self2.config.monthSelectorType !== "dropdown") return;

    var shouldBuildMonth = function shouldBuildMonth(month2) {
      if (self2.config.minDate !== void 0 && self2.currentYear === self2.config.minDate.getFullYear() && month2 < self2.config.minDate.getMonth()) {
        return false;
      }

      return !(self2.config.maxDate !== void 0 && self2.currentYear === self2.config.maxDate.getFullYear() && month2 > self2.config.maxDate.getMonth());
    };

    self2.monthsDropdownContainer.tabIndex = -1;
    self2.monthsDropdownContainer.innerHTML = "";

    for (var i = 0; i < 12; i++) {
      if (!shouldBuildMonth(i)) continue;
      var month = createElement("option", "flatpickr-monthDropdown-month");
      month.value = new Date(self2.currentYear, i).getMonth().toString();
      month.textContent = monthToStr(i, self2.config.shorthandCurrentMonth, self2.l10n);
      month.tabIndex = -1;

      if (self2.currentMonth === i) {
        month.selected = true;
      }

      self2.monthsDropdownContainer.appendChild(month);
    }
  }

  function buildMonth() {
    var container = createElement("div", "flatpickr-month");
    var monthNavFragment = window.document.createDocumentFragment();
    var monthElement;

    if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
      monthElement = createElement("span", "cur-month");
    } else {
      self2.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
      self2.monthsDropdownContainer.setAttribute("aria-label", self2.l10n.monthAriaLabel);
      bind3(self2.monthsDropdownContainer, "change", function (e2) {
        var target = getEventTarget(e2);
        var selectedMonth = parseInt(target.value, 10);
        self2.changeMonth(selectedMonth - self2.currentMonth);
        triggerEvent("onMonthChange");
      });
      buildMonthSwitch();
      monthElement = self2.monthsDropdownContainer;
    }

    var yearInput = createNumberInput("cur-year", {
      tabindex: "-1"
    });
    var yearElement = yearInput.getElementsByTagName("input")[0];
    yearElement.setAttribute("aria-label", self2.l10n.yearAriaLabel);

    if (self2.config.minDate) {
      yearElement.setAttribute("min", self2.config.minDate.getFullYear().toString());
    }

    if (self2.config.maxDate) {
      yearElement.setAttribute("max", self2.config.maxDate.getFullYear().toString());
      yearElement.disabled = !!self2.config.minDate && self2.config.minDate.getFullYear() === self2.config.maxDate.getFullYear();
    }

    var currentMonth = createElement("div", "flatpickr-current-month");
    currentMonth.appendChild(monthElement);
    currentMonth.appendChild(yearInput);
    monthNavFragment.appendChild(currentMonth);
    container.appendChild(monthNavFragment);
    return {
      container: container,
      yearElement: yearElement,
      monthElement: monthElement
    };
  }

  function buildMonths() {
    clearNode(self2.monthNav);
    self2.monthNav.appendChild(self2.prevMonthNav);

    if (self2.config.showMonths) {
      self2.yearElements = [];
      self2.monthElements = [];
    }

    for (var m2 = self2.config.showMonths; m2--;) {
      var month = buildMonth();
      self2.yearElements.push(month.yearElement);
      self2.monthElements.push(month.monthElement);
      self2.monthNav.appendChild(month.container);
    }

    self2.monthNav.appendChild(self2.nextMonthNav);
  }

  function buildMonthNav() {
    self2.monthNav = createElement("div", "flatpickr-months");
    self2.yearElements = [];
    self2.monthElements = [];
    self2.prevMonthNav = createElement("span", "flatpickr-prev-month");
    self2.prevMonthNav.innerHTML = self2.config.prevArrow;
    self2.nextMonthNav = createElement("span", "flatpickr-next-month");
    self2.nextMonthNav.innerHTML = self2.config.nextArrow;
    buildMonths();
    Object.defineProperty(self2, "_hidePrevMonthArrow", {
      get: function get() {
        return self2.__hidePrevMonthArrow;
      },
      set: function set(bool) {
        if (self2.__hidePrevMonthArrow !== bool) {
          toggleClass(self2.prevMonthNav, "flatpickr-disabled", bool);
          self2.__hidePrevMonthArrow = bool;
        }
      }
    });
    Object.defineProperty(self2, "_hideNextMonthArrow", {
      get: function get() {
        return self2.__hideNextMonthArrow;
      },
      set: function set(bool) {
        if (self2.__hideNextMonthArrow !== bool) {
          toggleClass(self2.nextMonthNav, "flatpickr-disabled", bool);
          self2.__hideNextMonthArrow = bool;
        }
      }
    });
    self2.currentYearElement = self2.yearElements[0];
    updateNavigationCurrentMonth();
    return self2.monthNav;
  }

  function buildTime() {
    self2.calendarContainer.classList.add("hasTime");
    if (self2.config.noCalendar) self2.calendarContainer.classList.add("noCalendar");
    var defaults2 = getDefaultHours(self2.config);
    self2.timeContainer = createElement("div", "flatpickr-time");
    self2.timeContainer.tabIndex = -1;
    var separator = createElement("span", "flatpickr-time-separator", ":");
    var hourInput = createNumberInput("flatpickr-hour", {
      "aria-label": self2.l10n.hourAriaLabel
    });
    self2.hourElement = hourInput.getElementsByTagName("input")[0];
    var minuteInput = createNumberInput("flatpickr-minute", {
      "aria-label": self2.l10n.minuteAriaLabel
    });
    self2.minuteElement = minuteInput.getElementsByTagName("input")[0];
    self2.hourElement.tabIndex = self2.minuteElement.tabIndex = -1;
    self2.hourElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getHours() : self2.config.time_24hr ? defaults2.hours : military2ampm(defaults2.hours));
    self2.minuteElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getMinutes() : defaults2.minutes);
    self2.hourElement.setAttribute("step", self2.config.hourIncrement.toString());
    self2.minuteElement.setAttribute("step", self2.config.minuteIncrement.toString());
    self2.hourElement.setAttribute("min", self2.config.time_24hr ? "0" : "1");
    self2.hourElement.setAttribute("max", self2.config.time_24hr ? "23" : "12");
    self2.hourElement.setAttribute("maxlength", "2");
    self2.minuteElement.setAttribute("min", "0");
    self2.minuteElement.setAttribute("max", "59");
    self2.minuteElement.setAttribute("maxlength", "2");
    self2.timeContainer.appendChild(hourInput);
    self2.timeContainer.appendChild(separator);
    self2.timeContainer.appendChild(minuteInput);
    if (self2.config.time_24hr) self2.timeContainer.classList.add("time24hr");

    if (self2.config.enableSeconds) {
      self2.timeContainer.classList.add("hasSeconds");
      var secondInput = createNumberInput("flatpickr-second");
      self2.secondElement = secondInput.getElementsByTagName("input")[0];
      self2.secondElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getSeconds() : defaults2.seconds);
      self2.secondElement.setAttribute("step", self2.minuteElement.getAttribute("step"));
      self2.secondElement.setAttribute("min", "0");
      self2.secondElement.setAttribute("max", "59");
      self2.secondElement.setAttribute("maxlength", "2");
      self2.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
      self2.timeContainer.appendChild(secondInput);
    }

    if (!self2.config.time_24hr) {
      self2.amPM = createElement("span", "flatpickr-am-pm", self2.l10n.amPM[_int((self2.latestSelectedDateObj ? self2.hourElement.value : self2.config.defaultHour) > 11)]);
      self2.amPM.title = self2.l10n.toggleTitle;
      self2.amPM.tabIndex = -1;
      self2.timeContainer.appendChild(self2.amPM);
    }

    return self2.timeContainer;
  }

  function buildWeekdays() {
    if (!self2.weekdayContainer) self2.weekdayContainer = createElement("div", "flatpickr-weekdays");else clearNode(self2.weekdayContainer);

    for (var i = self2.config.showMonths; i--;) {
      var container = createElement("div", "flatpickr-weekdaycontainer");
      self2.weekdayContainer.appendChild(container);
    }

    updateWeekdays();
    return self2.weekdayContainer;
  }

  function updateWeekdays() {
    if (!self2.weekdayContainer) {
      return;
    }

    var firstDayOfWeek = self2.l10n.firstDayOfWeek;

    var weekdays = __spreadArrays$1(self2.l10n.weekdays.shorthand);

    if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
      weekdays = __spreadArrays$1(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
    }

    for (var i = self2.config.showMonths; i--;) {
      self2.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
  }

  function buildWeeks() {
    self2.calendarContainer.classList.add("hasWeeks");
    var weekWrapper = createElement("div", "flatpickr-weekwrapper");
    weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self2.l10n.weekAbbreviation));
    var weekNumbers = createElement("div", "flatpickr-weeks");
    weekWrapper.appendChild(weekNumbers);
    return {
      weekWrapper: weekWrapper,
      weekNumbers: weekNumbers
    };
  }

  function changeMonth(value, isOffset) {
    if (isOffset === void 0) {
      isOffset = true;
    }

    var delta = isOffset ? value : value - self2.currentMonth;
    if (delta < 0 && self2._hidePrevMonthArrow === true || delta > 0 && self2._hideNextMonthArrow === true) return;
    self2.currentMonth += delta;

    if (self2.currentMonth < 0 || self2.currentMonth > 11) {
      self2.currentYear += self2.currentMonth > 11 ? 1 : -1;
      self2.currentMonth = (self2.currentMonth + 12) % 12;
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    buildDays();
    triggerEvent("onMonthChange");
    updateNavigationCurrentMonth();
  }

  function clear(triggerChangeEvent, toInitial) {
    if (triggerChangeEvent === void 0) {
      triggerChangeEvent = true;
    }

    if (toInitial === void 0) {
      toInitial = true;
    }

    self2.input.value = "";
    if (self2.altInput !== void 0) self2.altInput.value = "";
    if (self2.mobileInput !== void 0) self2.mobileInput.value = "";
    self2.selectedDates = [];
    self2.latestSelectedDateObj = void 0;

    if (toInitial === true) {
      self2.currentYear = self2._initialDate.getFullYear();
      self2.currentMonth = self2._initialDate.getMonth();
    }

    if (self2.config.enableTime === true) {
      var _a2 = getDefaultHours(self2.config),
          hours = _a2.hours,
          minutes = _a2.minutes,
          seconds = _a2.seconds;

      setHours(hours, minutes, seconds);
    }

    self2.redraw();
    if (triggerChangeEvent) triggerEvent("onChange");
  }

  function close() {
    self2.isOpen = false;

    if (!self2.isMobile) {
      if (self2.calendarContainer !== void 0) {
        self2.calendarContainer.classList.remove("open");
      }

      if (self2._input !== void 0) {
        self2._input.classList.remove("active");
      }
    }

    triggerEvent("onClose");
  }

  function destroy() {
    if (self2.config !== void 0) triggerEvent("onDestroy");

    for (var i = self2._handlers.length; i--;) {
      self2._handlers[i].remove();
    }

    self2._handlers = [];

    if (self2.mobileInput) {
      if (self2.mobileInput.parentNode) self2.mobileInput.parentNode.removeChild(self2.mobileInput);
      self2.mobileInput = void 0;
    } else if (self2.calendarContainer && self2.calendarContainer.parentNode) {
      if (self2.config.static && self2.calendarContainer.parentNode) {
        var wrapper = self2.calendarContainer.parentNode;
        wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);

        if (wrapper.parentNode) {
          while (wrapper.firstChild) {
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          }

          wrapper.parentNode.removeChild(wrapper);
        }
      } else self2.calendarContainer.parentNode.removeChild(self2.calendarContainer);
    }

    if (self2.altInput) {
      self2.input.type = "text";
      if (self2.altInput.parentNode) self2.altInput.parentNode.removeChild(self2.altInput);
      delete self2.altInput;
    }

    if (self2.input) {
      self2.input.type = self2.input._type;
      self2.input.classList.remove("flatpickr-input");
      self2.input.removeAttribute("readonly");
    }

    ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k2) {
      try {
        delete self2[k2];
      } catch (_2) {}
    });
  }

  function isCalendarElem(elem) {
    return self2.calendarContainer.contains(elem);
  }

  function documentClick(e2) {
    if (self2.isOpen && !self2.config.inline) {
      var eventTarget_1 = getEventTarget(e2);
      var isCalendarElement = isCalendarElem(eventTarget_1);
      var isInput = eventTarget_1 === self2.input || eventTarget_1 === self2.altInput || self2.element.contains(eventTarget_1) || e2.path && e2.path.indexOf && (~e2.path.indexOf(self2.input) || ~e2.path.indexOf(self2.altInput));
      var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e2.relatedTarget);
      var isIgnored = !self2.config.ignoredFocusElements.some(function (elem) {
        return elem.contains(eventTarget_1);
      });

      if (lostFocus && isIgnored) {
        if (self2.config.allowInput) {
          self2.setDate(self2._input.value, false, self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
        }

        if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0 && self2.input.value !== "" && self2.input.value !== void 0) {
          updateTime();
        }

        self2.close();
        if (self2.config && self2.config.mode === "range" && self2.selectedDates.length === 1) self2.clear(false);
      }
    }
  }

  function changeYear(newYear) {
    if (!newYear || self2.config.minDate && newYear < self2.config.minDate.getFullYear() || self2.config.maxDate && newYear > self2.config.maxDate.getFullYear()) return;
    var newYearNum = newYear,
        isNewYear = self2.currentYear !== newYearNum;
    self2.currentYear = newYearNum || self2.currentYear;

    if (self2.config.maxDate && self2.currentYear === self2.config.maxDate.getFullYear()) {
      self2.currentMonth = Math.min(self2.config.maxDate.getMonth(), self2.currentMonth);
    } else if (self2.config.minDate && self2.currentYear === self2.config.minDate.getFullYear()) {
      self2.currentMonth = Math.max(self2.config.minDate.getMonth(), self2.currentMonth);
    }

    if (isNewYear) {
      self2.redraw();
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
  }

  function isEnabled(date, timeless) {
    var _a2;

    if (timeless === void 0) {
      timeless = true;
    }

    var dateToCheck = self2.parseDate(date, void 0, timeless);
    if (self2.config.minDate && dateToCheck && compareDates(dateToCheck, self2.config.minDate, timeless !== void 0 ? timeless : !self2.minDateHasTime) < 0 || self2.config.maxDate && dateToCheck && compareDates(dateToCheck, self2.config.maxDate, timeless !== void 0 ? timeless : !self2.maxDateHasTime) > 0) return false;
    if (!self2.config.enable && self2.config.disable.length === 0) return true;
    if (dateToCheck === void 0) return false;
    var bool = !!self2.config.enable,
        array = (_a2 = self2.config.enable) !== null && _a2 !== void 0 ? _a2 : self2.config.disable;

    for (var i = 0, d2 = void 0; i < array.length; i++) {
      d2 = array[i];
      if (typeof d2 === "function" && d2(dateToCheck)) return bool;else if (d2 instanceof Date && dateToCheck !== void 0 && d2.getTime() === dateToCheck.getTime()) return bool;else if (typeof d2 === "string") {
        var parsed = self2.parseDate(d2, void 0, true);
        return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
      } else if (typeof d2 === "object" && dateToCheck !== void 0 && d2.from && d2.to && dateToCheck.getTime() >= d2.from.getTime() && dateToCheck.getTime() <= d2.to.getTime()) return bool;
    }

    return !bool;
  }

  function isInView(elem) {
    if (self2.daysContainer !== void 0) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self2.daysContainer.contains(elem);
    return false;
  }

  function onBlur(e2) {
    var isInput = e2.target === self2._input;
    var valueChanged = self2._input.value.trimEnd() !== getDateStr();

    if (isInput && valueChanged && !(e2.relatedTarget && isCalendarElem(e2.relatedTarget))) {
      self2.setDate(self2._input.value, true, e2.target === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
    }
  }

  function onKeyDown(e2) {
    var eventTarget = getEventTarget(e2);
    var isInput = self2.config.wrap ? element.contains(eventTarget) : eventTarget === self2._input;
    var allowInput = self2.config.allowInput;
    var allowKeydown = self2.isOpen && (!allowInput || !isInput);
    var allowInlineKeydown = self2.config.inline && isInput && !allowInput;

    if (e2.keyCode === 13 && isInput) {
      if (allowInput) {
        self2.setDate(self2._input.value, true, eventTarget === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
        self2.close();
        return eventTarget.blur();
      } else {
        self2.open();
      }
    } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
      var isTimeObj = !!self2.timeContainer && self2.timeContainer.contains(eventTarget);

      switch (e2.keyCode) {
        case 13:
          if (isTimeObj) {
            e2.preventDefault();
            updateTime();
            focusAndClose();
          } else selectDate(e2);

          break;

        case 27:
          e2.preventDefault();
          focusAndClose();
          break;

        case 8:
        case 46:
          if (isInput && !self2.config.allowInput) {
            e2.preventDefault();
            self2.clear();
          }

          break;

        case 37:
        case 39:
          if (!isTimeObj && !isInput) {
            e2.preventDefault();
            var activeElement = getClosestActiveElement();

            if (self2.daysContainer !== void 0 && (allowInput === false || activeElement && isInView(activeElement))) {
              var delta_1 = e2.keyCode === 39 ? 1 : -1;
              if (!e2.ctrlKey) focusOnDay(void 0, delta_1);else {
                e2.stopPropagation();
                changeMonth(delta_1);
                focusOnDay(getFirstAvailableDay(1), 0);
              }
            }
          } else if (self2.hourElement) self2.hourElement.focus();

          break;

        case 38:
        case 40:
          e2.preventDefault();
          var delta = e2.keyCode === 40 ? 1 : -1;

          if (self2.daysContainer && eventTarget.$i !== void 0 || eventTarget === self2.input || eventTarget === self2.altInput) {
            if (e2.ctrlKey) {
              e2.stopPropagation();
              changeYear(self2.currentYear - delta);
              focusOnDay(getFirstAvailableDay(1), 0);
            } else if (!isTimeObj) focusOnDay(void 0, delta * 7);
          } else if (eventTarget === self2.currentYearElement) {
            changeYear(self2.currentYear - delta);
          } else if (self2.config.enableTime) {
            if (!isTimeObj && self2.hourElement) self2.hourElement.focus();
            updateTime(e2);

            self2._debouncedChange();
          }

          break;

        case 9:
          if (isTimeObj) {
            var elems = [self2.hourElement, self2.minuteElement, self2.secondElement, self2.amPM].concat(self2.pluginElements).filter(function (x2) {
              return x2;
            });
            var i = elems.indexOf(eventTarget);

            if (i !== -1) {
              var target = elems[i + (e2.shiftKey ? -1 : 1)];
              e2.preventDefault();

              (target || self2._input).focus();
            }
          } else if (!self2.config.noCalendar && self2.daysContainer && self2.daysContainer.contains(eventTarget) && e2.shiftKey) {
            e2.preventDefault();

            self2._input.focus();
          }

          break;
      }
    }

    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      switch (e2.key) {
        case self2.l10n.amPM[0].charAt(0):
        case self2.l10n.amPM[0].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[0];
          setHoursFromInputs();
          updateValue();
          break;

        case self2.l10n.amPM[1].charAt(0):
        case self2.l10n.amPM[1].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[1];
          setHoursFromInputs();
          updateValue();
          break;
      }
    }

    if (isInput || isCalendarElem(eventTarget)) {
      triggerEvent("onKeyDown", e2);
    }
  }

  function onMouseOver(elem, cellClass) {
    if (cellClass === void 0) {
      cellClass = "flatpickr-day";
    }

    if (self2.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
    var hoverDate = elem ? elem.dateObj.getTime() : self2.days.firstElementChild.dateObj.getTime(),
        initialDate = self2.parseDate(self2.selectedDates[0], void 0, true).getTime(),
        rangeStartDate = Math.min(hoverDate, self2.selectedDates[0].getTime()),
        rangeEndDate = Math.max(hoverDate, self2.selectedDates[0].getTime());
    var containsDisabled = false;
    var minRange = 0,
        maxRange = 0;

    for (var t2 = rangeStartDate; t2 < rangeEndDate; t2 += duration.DAY) {
      if (!isEnabled(new Date(t2), true)) {
        containsDisabled = containsDisabled || t2 > rangeStartDate && t2 < rangeEndDate;
        if (t2 < initialDate && (!minRange || t2 > minRange)) minRange = t2;else if (t2 > initialDate && (!maxRange || t2 < maxRange)) maxRange = t2;
      }
    }

    var hoverableCells = Array.from(self2.rContainer.querySelectorAll("*:nth-child(-n+" + self2.config.showMonths + ") > ." + cellClass));
    hoverableCells.forEach(function (dayElem) {
      var date = dayElem.dateObj;
      var timestamp = date.getTime();
      var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;

      if (outOfRange) {
        dayElem.classList.add("notAllowed");
        ["inRange", "startRange", "endRange"].forEach(function (c2) {
          dayElem.classList.remove(c2);
        });
        return;
      } else if (containsDisabled && !outOfRange) return;

      ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c2) {
        dayElem.classList.remove(c2);
      });

      if (elem !== void 0) {
        elem.classList.add(hoverDate <= self2.selectedDates[0].getTime() ? "startRange" : "endRange");
        if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
        if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
      }
    });
  }

  function onResize() {
    if (self2.isOpen && !self2.config.static && !self2.config.inline) positionCalendar();
  }

  function open(e2, positionElement) {
    if (positionElement === void 0) {
      positionElement = self2._positionElement;
    }

    if (self2.isMobile === true) {
      if (e2) {
        e2.preventDefault();
        var eventTarget = getEventTarget(e2);

        if (eventTarget) {
          eventTarget.blur();
        }
      }

      if (self2.mobileInput !== void 0) {
        self2.mobileInput.focus();
        self2.mobileInput.click();
      }

      triggerEvent("onOpen");
      return;
    } else if (self2._input.disabled || self2.config.inline) {
      return;
    }

    var wasOpen = self2.isOpen;
    self2.isOpen = true;

    if (!wasOpen) {
      self2.calendarContainer.classList.add("open");

      self2._input.classList.add("active");

      triggerEvent("onOpen");
      positionCalendar(positionElement);
    }

    if (self2.config.enableTime === true && self2.config.noCalendar === true) {
      if (self2.config.allowInput === false && (e2 === void 0 || !self2.timeContainer.contains(e2.relatedTarget))) {
        setTimeout(function () {
          return self2.hourElement.select();
        }, 50);
      }
    }
  }

  function minMaxDateSetter(type) {
    return function (date) {
      var dateObj = self2.config["_" + type + "Date"] = self2.parseDate(date, self2.config.dateFormat);
      var inverseDateObj = self2.config["_" + (type === "min" ? "max" : "min") + "Date"];

      if (dateObj !== void 0) {
        self2[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
      }

      if (self2.selectedDates) {
        self2.selectedDates = self2.selectedDates.filter(function (d2) {
          return isEnabled(d2);
        });
        if (!self2.selectedDates.length && type === "min") setHoursFromDate(dateObj);
        updateValue();
      }

      if (self2.daysContainer) {
        redraw();
        if (dateObj !== void 0) self2.currentYearElement[type] = dateObj.getFullYear().toString();else self2.currentYearElement.removeAttribute(type);
        self2.currentYearElement.disabled = !!inverseDateObj && dateObj !== void 0 && inverseDateObj.getFullYear() === dateObj.getFullYear();
      }
    };
  }

  function parseConfig() {
    var boolOpts = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];

    var userConfig = __assign$1(__assign$1({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);

    var formats2 = {};
    self2.config.parseDate = userConfig.parseDate;
    self2.config.formatDate = userConfig.formatDate;
    Object.defineProperty(self2.config, "enable", {
      get: function get() {
        return self2.config._enable;
      },
      set: function set(dates) {
        self2.config._enable = parseDateRules(dates);
      }
    });
    Object.defineProperty(self2.config, "disable", {
      get: function get() {
        return self2.config._disable;
      },
      set: function set(dates) {
        self2.config._disable = parseDateRules(dates);
      }
    });
    var timeMode = userConfig.mode === "time";

    if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
      formats2.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
    }

    if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
      var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
      formats2.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
    }

    Object.defineProperty(self2.config, "minDate", {
      get: function get() {
        return self2.config._minDate;
      },
      set: minMaxDateSetter("min")
    });
    Object.defineProperty(self2.config, "maxDate", {
      get: function get() {
        return self2.config._maxDate;
      },
      set: minMaxDateSetter("max")
    });

    var minMaxTimeSetter = function minMaxTimeSetter(type) {
      return function (val) {
        self2.config[type === "min" ? "_minTime" : "_maxTime"] = self2.parseDate(val, "H:i:S");
      };
    };

    Object.defineProperty(self2.config, "minTime", {
      get: function get() {
        return self2.config._minTime;
      },
      set: minMaxTimeSetter("min")
    });
    Object.defineProperty(self2.config, "maxTime", {
      get: function get() {
        return self2.config._maxTime;
      },
      set: minMaxTimeSetter("max")
    });

    if (userConfig.mode === "time") {
      self2.config.noCalendar = true;
      self2.config.enableTime = true;
    }

    Object.assign(self2.config, formats2, userConfig);

    for (var i = 0; i < boolOpts.length; i++) {
      self2.config[boolOpts[i]] = self2.config[boolOpts[i]] === true || self2.config[boolOpts[i]] === "true";
    }

    HOOKS.filter(function (hook) {
      return self2.config[hook] !== void 0;
    }).forEach(function (hook) {
      self2.config[hook] = arrayify(self2.config[hook] || []).map(bindToInstance);
    });
    self2.isMobile = !self2.config.disableMobile && !self2.config.inline && self2.config.mode === "single" && !self2.config.disable.length && !self2.config.enable && !self2.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    for (var i = 0; i < self2.config.plugins.length; i++) {
      var pluginConf = self2.config.plugins[i](self2) || {};

      for (var key in pluginConf) {
        if (HOOKS.indexOf(key) > -1) {
          self2.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self2.config[key]);
        } else if (typeof userConfig[key] === "undefined") self2.config[key] = pluginConf[key];
      }
    }

    if (!userConfig.altInputClass) {
      self2.config.altInputClass = getInputElem().className + " " + self2.config.altInputClass;
    }

    triggerEvent("onParseConfig");
  }

  function getInputElem() {
    return self2.config.wrap ? element.querySelector("[data-input]") : element;
  }

  function setupLocale() {
    if (typeof self2.config.locale !== "object" && typeof flatpickr.l10ns[self2.config.locale] === "undefined") self2.config.errorHandler(new Error("flatpickr: invalid locale " + self2.config.locale));
    self2.l10n = __assign$1(__assign$1({}, flatpickr.l10ns.default), typeof self2.config.locale === "object" ? self2.config.locale : self2.config.locale !== "default" ? flatpickr.l10ns[self2.config.locale] : void 0);
    tokenRegex.D = "(" + self2.l10n.weekdays.shorthand.join("|") + ")";
    tokenRegex.l = "(" + self2.l10n.weekdays.longhand.join("|") + ")";
    tokenRegex.M = "(" + self2.l10n.months.shorthand.join("|") + ")";
    tokenRegex.F = "(" + self2.l10n.months.longhand.join("|") + ")";
    tokenRegex.K = "(" + self2.l10n.amPM[0] + "|" + self2.l10n.amPM[1] + "|" + self2.l10n.amPM[0].toLowerCase() + "|" + self2.l10n.amPM[1].toLowerCase() + ")";

    var userConfig = __assign$1(__assign$1({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));

    if (userConfig.time_24hr === void 0 && flatpickr.defaultConfig.time_24hr === void 0) {
      self2.config.time_24hr = self2.l10n.time_24hr;
    }

    self2.formatDate = createDateFormatter(self2);
    self2.parseDate = createDateParser({
      config: self2.config,
      l10n: self2.l10n
    });
  }

  function positionCalendar(customPositionElement) {
    if (typeof self2.config.position === "function") {
      return void self2.config.position(self2, customPositionElement);
    }

    if (self2.calendarContainer === void 0) return;
    triggerEvent("onPreCalendarPosition");
    var positionElement = customPositionElement || self2._positionElement;
    var calendarHeight = Array.prototype.reduce.call(self2.calendarContainer.children, function (acc, child) {
      return acc + child.offsetHeight;
    }, 0),
        calendarWidth = self2.calendarContainer.offsetWidth,
        configPos = self2.config.position.split(" "),
        configPosVertical = configPos[0],
        configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
        inputBounds = positionElement.getBoundingClientRect(),
        distanceFromBottom = window.innerHeight - inputBounds.bottom,
        showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
    var top2 = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
    toggleClass(self2.calendarContainer, "arrowTop", !showOnTop);
    toggleClass(self2.calendarContainer, "arrowBottom", showOnTop);
    if (self2.config.inline) return;
    var left2 = window.pageXOffset + inputBounds.left;
    var isCenter = false;
    var isRight = false;

    if (configPosHorizontal === "center") {
      left2 -= (calendarWidth - inputBounds.width) / 2;
      isCenter = true;
    } else if (configPosHorizontal === "right") {
      left2 -= calendarWidth - inputBounds.width;
      isRight = true;
    }

    toggleClass(self2.calendarContainer, "arrowLeft", !isCenter && !isRight);
    toggleClass(self2.calendarContainer, "arrowCenter", isCenter);
    toggleClass(self2.calendarContainer, "arrowRight", isRight);
    var right2 = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
    var rightMost = left2 + calendarWidth > window.document.body.offsetWidth;
    var centerMost = right2 + calendarWidth > window.document.body.offsetWidth;
    toggleClass(self2.calendarContainer, "rightMost", rightMost);
    if (self2.config.static) return;
    self2.calendarContainer.style.top = top2 + "px";

    if (!rightMost) {
      self2.calendarContainer.style.left = left2 + "px";
      self2.calendarContainer.style.right = "auto";
    } else if (!centerMost) {
      self2.calendarContainer.style.left = "auto";
      self2.calendarContainer.style.right = right2 + "px";
    } else {
      var doc = getDocumentStyleSheet();
      if (doc === void 0) return;
      var bodyWidth = window.document.body.offsetWidth;
      var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
      var centerBefore = ".flatpickr-calendar.centerMost:before";
      var centerAfter = ".flatpickr-calendar.centerMost:after";
      var centerIndex = doc.cssRules.length;
      var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
      toggleClass(self2.calendarContainer, "rightMost", false);
      toggleClass(self2.calendarContainer, "centerMost", true);
      doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
      self2.calendarContainer.style.left = centerLeft + "px";
      self2.calendarContainer.style.right = "auto";
    }
  }

  function getDocumentStyleSheet() {
    var editableSheet = null;

    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet = document.styleSheets[i];
      if (!sheet.cssRules) continue;

      try {
        sheet.cssRules;
      } catch (err) {
        continue;
      }

      editableSheet = sheet;
      break;
    }

    return editableSheet != null ? editableSheet : createStyleSheet();
  }

  function createStyleSheet() {
    var style = document.createElement("style");
    document.head.appendChild(style);
    return style.sheet;
  }

  function redraw() {
    if (self2.config.noCalendar || self2.isMobile) return;
    buildMonthSwitch();
    updateNavigationCurrentMonth();
    buildDays();
  }

  function focusAndClose() {
    self2._input.focus();

    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0) {
      setTimeout(self2.close, 0);
    } else {
      self2.close();
    }
  }

  function selectDate(e2) {
    e2.preventDefault();
    e2.stopPropagation();

    var isSelectable = function isSelectable(day) {
      return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
    };

    var t2 = findParent(getEventTarget(e2), isSelectable);
    if (t2 === void 0) return;
    var target = t2;
    var selectedDate = self2.latestSelectedDateObj = new Date(target.dateObj.getTime());
    var shouldChangeMonth = (selectedDate.getMonth() < self2.currentMonth || selectedDate.getMonth() > self2.currentMonth + self2.config.showMonths - 1) && self2.config.mode !== "range";
    self2.selectedDateElem = target;
    if (self2.config.mode === "single") self2.selectedDates = [selectedDate];else if (self2.config.mode === "multiple") {
      var selectedIndex = isDateSelected(selectedDate);
      if (selectedIndex) self2.selectedDates.splice(parseInt(selectedIndex), 1);else self2.selectedDates.push(selectedDate);
    } else if (self2.config.mode === "range") {
      if (self2.selectedDates.length === 2) {
        self2.clear(false, false);
      }

      self2.latestSelectedDateObj = selectedDate;
      self2.selectedDates.push(selectedDate);
      if (compareDates(selectedDate, self2.selectedDates[0], true) !== 0) self2.selectedDates.sort(function (a, b2) {
        return a.getTime() - b2.getTime();
      });
    }
    setHoursFromInputs();

    if (shouldChangeMonth) {
      var isNewYear = self2.currentYear !== selectedDate.getFullYear();
      self2.currentYear = selectedDate.getFullYear();
      self2.currentMonth = selectedDate.getMonth();

      if (isNewYear) {
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }

      triggerEvent("onMonthChange");
    }

    updateNavigationCurrentMonth();
    buildDays();
    updateValue();
    if (!shouldChangeMonth && self2.config.mode !== "range" && self2.config.showMonths === 1) focusOnDayElem(target);else if (self2.selectedDateElem !== void 0 && self2.hourElement === void 0) {
      self2.selectedDateElem && self2.selectedDateElem.focus();
    }
    if (self2.hourElement !== void 0) self2.hourElement !== void 0 && self2.hourElement.focus();

    if (self2.config.closeOnSelect) {
      var single = self2.config.mode === "single" && !self2.config.enableTime;
      var range2 = self2.config.mode === "range" && self2.selectedDates.length === 2 && !self2.config.enableTime;

      if (single || range2) {
        focusAndClose();
      }
    }

    triggerChange();
  }

  var CALLBACKS = {
    locale: [setupLocale, updateWeekdays],
    showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
    minDate: [jumpToDate],
    maxDate: [jumpToDate],
    positionElement: [updatePositionElement],
    clickOpens: [function () {
      if (self2.config.clickOpens === true) {
        bind3(self2._input, "focus", self2.open);
        bind3(self2._input, "click", self2.open);
      } else {
        self2._input.removeEventListener("focus", self2.open);

        self2._input.removeEventListener("click", self2.open);
      }
    }]
  };

  function set(option, value) {
    if (option !== null && typeof option === "object") {
      Object.assign(self2.config, option);

      for (var key in option) {
        if (CALLBACKS[key] !== void 0) CALLBACKS[key].forEach(function (x2) {
          return x2();
        });
      }
    } else {
      self2.config[option] = value;
      if (CALLBACKS[option] !== void 0) CALLBACKS[option].forEach(function (x2) {
        return x2();
      });else if (HOOKS.indexOf(option) > -1) self2.config[option] = arrayify(value);
    }

    self2.redraw();
    updateValue(true);
  }

  function setSelectedDate(inputDate, format) {
    var dates = [];
    if (inputDate instanceof Array) dates = inputDate.map(function (d2) {
      return self2.parseDate(d2, format);
    });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self2.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
      switch (self2.config.mode) {
        case "single":
        case "time":
          dates = [self2.parseDate(inputDate, format)];
          break;

        case "multiple":
          dates = inputDate.split(self2.config.conjunction).map(function (date) {
            return self2.parseDate(date, format);
          });
          break;

        case "range":
          dates = inputDate.split(self2.l10n.rangeSeparator).map(function (date) {
            return self2.parseDate(date, format);
          });
          break;
      }
    } else self2.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
    self2.selectedDates = self2.config.allowInvalidPreload ? dates : dates.filter(function (d2) {
      return d2 instanceof Date && isEnabled(d2, false);
    });
    if (self2.config.mode === "range") self2.selectedDates.sort(function (a, b2) {
      return a.getTime() - b2.getTime();
    });
  }

  function setDate(date, triggerChange2, format) {
    if (triggerChange2 === void 0) {
      triggerChange2 = false;
    }

    if (format === void 0) {
      format = self2.config.dateFormat;
    }

    if (date !== 0 && !date || date instanceof Array && date.length === 0) return self2.clear(triggerChange2);
    setSelectedDate(date, format);
    self2.latestSelectedDateObj = self2.selectedDates[self2.selectedDates.length - 1];
    self2.redraw();
    jumpToDate(void 0, triggerChange2);
    setHoursFromDate();

    if (self2.selectedDates.length === 0) {
      self2.clear(false);
    }

    updateValue(triggerChange2);
    if (triggerChange2) triggerEvent("onChange");
  }

  function parseDateRules(arr) {
    return arr.slice().map(function (rule) {
      if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
        return self2.parseDate(rule, void 0, true);
      } else if (rule && typeof rule === "object" && rule.from && rule.to) return {
        from: self2.parseDate(rule.from, void 0),
        to: self2.parseDate(rule.to, void 0)
      };

      return rule;
    }).filter(function (x2) {
      return x2;
    });
  }

  function setupDates() {
    self2.selectedDates = [];
    self2.now = self2.parseDate(self2.config.now) || new Date();
    var preloadedDate = self2.config.defaultDate || ((self2.input.nodeName === "INPUT" || self2.input.nodeName === "TEXTAREA") && self2.input.placeholder && self2.input.value === self2.input.placeholder ? null : self2.input.value);
    if (preloadedDate) setSelectedDate(preloadedDate, self2.config.dateFormat);
    self2._initialDate = self2.selectedDates.length > 0 ? self2.selectedDates[0] : self2.config.minDate && self2.config.minDate.getTime() > self2.now.getTime() ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate.getTime() < self2.now.getTime() ? self2.config.maxDate : self2.now;
    self2.currentYear = self2._initialDate.getFullYear();
    self2.currentMonth = self2._initialDate.getMonth();
    if (self2.selectedDates.length > 0) self2.latestSelectedDateObj = self2.selectedDates[0];
    if (self2.config.minTime !== void 0) self2.config.minTime = self2.parseDate(self2.config.minTime, "H:i");
    if (self2.config.maxTime !== void 0) self2.config.maxTime = self2.parseDate(self2.config.maxTime, "H:i");
    self2.minDateHasTime = !!self2.config.minDate && (self2.config.minDate.getHours() > 0 || self2.config.minDate.getMinutes() > 0 || self2.config.minDate.getSeconds() > 0);
    self2.maxDateHasTime = !!self2.config.maxDate && (self2.config.maxDate.getHours() > 0 || self2.config.maxDate.getMinutes() > 0 || self2.config.maxDate.getSeconds() > 0);
  }

  function setupInputs() {
    self2.input = getInputElem();

    if (!self2.input) {
      self2.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }

    self2.input._type = self2.input.type;
    self2.input.type = "text";
    self2.input.classList.add("flatpickr-input");
    self2._input = self2.input;

    if (self2.config.altInput) {
      self2.altInput = createElement(self2.input.nodeName, self2.config.altInputClass);
      self2._input = self2.altInput;
      self2.altInput.placeholder = self2.input.placeholder;
      self2.altInput.disabled = self2.input.disabled;
      self2.altInput.required = self2.input.required;
      self2.altInput.tabIndex = self2.input.tabIndex;
      self2.altInput.type = "text";
      self2.input.setAttribute("type", "hidden");
      if (!self2.config.static && self2.input.parentNode) self2.input.parentNode.insertBefore(self2.altInput, self2.input.nextSibling);
    }

    if (!self2.config.allowInput) self2._input.setAttribute("readonly", "readonly");
    updatePositionElement();
  }

  function updatePositionElement() {
    self2._positionElement = self2.config.positionElement || self2._input;
  }

  function setupMobile() {
    var inputType = self2.config.enableTime ? self2.config.noCalendar ? "time" : "datetime-local" : "date";
    self2.mobileInput = createElement("input", self2.input.className + " flatpickr-mobile");
    self2.mobileInput.tabIndex = 1;
    self2.mobileInput.type = inputType;
    self2.mobileInput.disabled = self2.input.disabled;
    self2.mobileInput.required = self2.input.required;
    self2.mobileInput.placeholder = self2.input.placeholder;
    self2.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";

    if (self2.selectedDates.length > 0) {
      self2.mobileInput.defaultValue = self2.mobileInput.value = self2.formatDate(self2.selectedDates[0], self2.mobileFormatStr);
    }

    if (self2.config.minDate) self2.mobileInput.min = self2.formatDate(self2.config.minDate, "Y-m-d");
    if (self2.config.maxDate) self2.mobileInput.max = self2.formatDate(self2.config.maxDate, "Y-m-d");
    if (self2.input.getAttribute("step")) self2.mobileInput.step = String(self2.input.getAttribute("step"));
    self2.input.type = "hidden";
    if (self2.altInput !== void 0) self2.altInput.type = "hidden";

    try {
      if (self2.input.parentNode) self2.input.parentNode.insertBefore(self2.mobileInput, self2.input.nextSibling);
    } catch (_a2) {}

    bind3(self2.mobileInput, "change", function (e2) {
      self2.setDate(getEventTarget(e2).value, false, self2.mobileFormatStr);
      triggerEvent("onChange");
      triggerEvent("onClose");
    });
  }

  function toggle(e2) {
    if (self2.isOpen === true) return self2.close();
    self2.open(e2);
  }

  function triggerEvent(event, data2) {
    if (self2.config === void 0) return;
    var hooks = self2.config[event];

    if (hooks !== void 0 && hooks.length > 0) {
      for (var i = 0; hooks[i] && i < hooks.length; i++) {
        hooks[i](self2.selectedDates, self2.input.value, self2, data2);
      }
    }

    if (event === "onChange") {
      self2.input.dispatchEvent(createEvent("change"));
      self2.input.dispatchEvent(createEvent("input"));
    }
  }

  function createEvent(name2) {
    var e2 = document.createEvent("Event");
    e2.initEvent(name2, true, true);
    return e2;
  }

  function isDateSelected(date) {
    for (var i = 0; i < self2.selectedDates.length; i++) {
      var selectedDate = self2.selectedDates[i];
      if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0) return "" + i;
    }

    return false;
  }

  function isDateInRange(date) {
    if (self2.config.mode !== "range" || self2.selectedDates.length < 2) return false;
    return compareDates(date, self2.selectedDates[0]) >= 0 && compareDates(date, self2.selectedDates[1]) <= 0;
  }

  function updateNavigationCurrentMonth() {
    if (self2.config.noCalendar || self2.isMobile || !self2.monthNav) return;
    self2.yearElements.forEach(function (yearElement, i) {
      var d2 = new Date(self2.currentYear, self2.currentMonth, 1);
      d2.setMonth(self2.currentMonth + i);

      if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
        self2.monthElements[i].textContent = monthToStr(d2.getMonth(), self2.config.shorthandCurrentMonth, self2.l10n) + " ";
      } else {
        self2.monthsDropdownContainer.value = d2.getMonth().toString();
      }

      yearElement.value = d2.getFullYear().toString();
    });
    self2._hidePrevMonthArrow = self2.config.minDate !== void 0 && (self2.currentYear === self2.config.minDate.getFullYear() ? self2.currentMonth <= self2.config.minDate.getMonth() : self2.currentYear < self2.config.minDate.getFullYear());
    self2._hideNextMonthArrow = self2.config.maxDate !== void 0 && (self2.currentYear === self2.config.maxDate.getFullYear() ? self2.currentMonth + 1 > self2.config.maxDate.getMonth() : self2.currentYear > self2.config.maxDate.getFullYear());
  }

  function getDateStr(specificFormat) {
    var format = specificFormat || (self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
    return self2.selectedDates.map(function (dObj) {
      return self2.formatDate(dObj, format);
    }).filter(function (d2, i, arr) {
      return self2.config.mode !== "range" || self2.config.enableTime || arr.indexOf(d2) === i;
    }).join(self2.config.mode !== "range" ? self2.config.conjunction : self2.l10n.rangeSeparator);
  }

  function updateValue(triggerChange2) {
    if (triggerChange2 === void 0) {
      triggerChange2 = true;
    }

    if (self2.mobileInput !== void 0 && self2.mobileFormatStr) {
      self2.mobileInput.value = self2.latestSelectedDateObj !== void 0 ? self2.formatDate(self2.latestSelectedDateObj, self2.mobileFormatStr) : "";
    }

    self2.input.value = getDateStr(self2.config.dateFormat);

    if (self2.altInput !== void 0) {
      self2.altInput.value = getDateStr(self2.config.altFormat);
    }

    if (triggerChange2 !== false) triggerEvent("onValueUpdate");
  }

  function onMonthNavClick(e2) {
    var eventTarget = getEventTarget(e2);
    var isPrevMonth = self2.prevMonthNav.contains(eventTarget);
    var isNextMonth = self2.nextMonthNav.contains(eventTarget);

    if (isPrevMonth || isNextMonth) {
      changeMonth(isPrevMonth ? -1 : 1);
    } else if (self2.yearElements.indexOf(eventTarget) >= 0) {
      eventTarget.select();
    } else if (eventTarget.classList.contains("arrowUp")) {
      self2.changeYear(self2.currentYear + 1);
    } else if (eventTarget.classList.contains("arrowDown")) {
      self2.changeYear(self2.currentYear - 1);
    }
  }

  function timeWrapper(e2) {
    e2.preventDefault();
    var isKeyDown = e2.type === "keydown",
        eventTarget = getEventTarget(e2),
        input = eventTarget;

    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      self2.amPM.textContent = self2.l10n.amPM[_int(self2.amPM.textContent === self2.l10n.amPM[0])];
    }

    var min2 = parseFloat(input.getAttribute("min")),
        max2 = parseFloat(input.getAttribute("max")),
        step = parseFloat(input.getAttribute("step")),
        curValue = parseInt(input.value, 10),
        delta = e2.delta || (isKeyDown ? e2.which === 38 ? 1 : -1 : 0);
    var newValue = curValue + step * delta;

    if (typeof input.value !== "undefined" && input.value.length === 2) {
      var isHourElem = input === self2.hourElement,
          isMinuteElem = input === self2.minuteElement;

      if (newValue < min2) {
        newValue = max2 + newValue + _int(!isHourElem) + (_int(isHourElem) && _int(!self2.amPM));
        if (isMinuteElem) incrementNumInput(void 0, -1, self2.hourElement);
      } else if (newValue > max2) {
        newValue = input === self2.hourElement ? newValue - max2 - _int(!self2.amPM) : min2;
        if (isMinuteElem) incrementNumInput(void 0, 1, self2.hourElement);
      }

      if (self2.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
        self2.amPM.textContent = self2.l10n.amPM[_int(self2.amPM.textContent === self2.l10n.amPM[0])];
      }

      input.value = pad(newValue);
    }
  }

  init();
  return self2;
}

function _flatpickr(nodeList, config) {
  var nodes = Array.prototype.slice.call(nodeList).filter(function (x2) {
    return x2 instanceof HTMLElement;
  });
  var instances2 = [];

  for (var i = 0; i < nodes.length; i++) {
    var node2 = nodes[i];

    try {
      if (node2.getAttribute("data-fp-omit") !== null) continue;

      if (node2._flatpickr !== void 0) {
        node2._flatpickr.destroy();

        node2._flatpickr = void 0;
      }

      node2._flatpickr = FlatpickrInstance(node2, config || {});
      instances2.push(node2._flatpickr);
    } catch (e2) {
      console.error(e2);
    }
  }

  return instances2.length === 1 ? instances2[0] : instances2;
}

if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
  HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
    return _flatpickr(this, config);
  };

  HTMLElement.prototype.flatpickr = function (config) {
    return _flatpickr([this], config);
  };
}

var flatpickr = function flatpickr(selector, config) {
  if (typeof selector === "string") {
    return _flatpickr(window.document.querySelectorAll(selector), config);
  } else if (selector instanceof Node) {
    return _flatpickr([selector], config);
  } else {
    return _flatpickr(selector, config);
  }
};

flatpickr.defaultConfig = {};
flatpickr.l10ns = {
  en: __assign$1({}, english),
  default: __assign$1({}, english)
};

flatpickr.localize = function (l10n) {
  flatpickr.l10ns.default = __assign$1(__assign$1({}, flatpickr.l10ns.default), l10n);
};

flatpickr.setDefaults = function (config) {
  flatpickr.defaultConfig = __assign$1(__assign$1({}, flatpickr.defaultConfig), config);
};

flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;

if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
  jQuery.fn.flatpickr = function (config) {
    return _flatpickr(this, config);
  };
}

Date.prototype.fp_incr = function (days) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};

if (typeof window !== "undefined") {
  window.flatpickr = flatpickr;
}

var esm =
/* @__PURE__ */
Object.freeze(
/* @__PURE__ */
Object.defineProperty({
  __proto__: null,
  "default": flatpickr
}, Symbol.toStringTag, {
  value: "Module"
}));
var require$$2 =
/* @__PURE__ */
getAugmentedNamespace(esm);

(function (exports) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }

    return _typeof2(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1.exports);

  var _flatpickr2 = _interopRequireDefault(require$$2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache =
    /* @__PURE__ */
    new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache2() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _toConsumableArray2(arr) {
    return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2();
  }

  function _nonIterableSpread2() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
    var n2 = Object.prototype.toString.call(o).slice(8, -1);
    if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
    if (n2 === "Map" || n2 === "Set") return Array.from(o);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray2(o, minLen);
  }

  function _iterableToArray2(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _arrayWithoutHoles2(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray2(arr);
  }

  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _extends2() {
    _extends2 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source2 = arguments[i];

        for (var key in source2) {
          if (Object.prototype.hasOwnProperty.call(source2, key)) {
            target[key] = source2[key];
          }
        }
      }

      return target;
    };

    return _extends2.apply(this, arguments);
  }

  function _objectWithoutProperties2(source2, excluded) {
    if (source2 == null) return {};

    var target = _objectWithoutPropertiesLoose2(source2, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source2, key)) continue;
        target[key] = source2[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose2(source2, excluded) {
    if (source2 == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source2);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source2[key];
    }

    return target;
  }

  function ownKeys2(object, enumerableOnly) {
    var keys2 = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys2.push.apply(keys2, symbols);
    }

    return keys2;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source2 = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys2(Object(source2), true).forEach(function (key) {
          _defineProperty2(target, key, source2[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
      } else {
        ownKeys2(Object(source2)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties2(Constructor, staticProps);
    return Constructor;
  }

  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }

  function _setPrototypeOf2(o, p2) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
      o2.__proto__ = p3;
      return o2;
    };

    return _setPrototypeOf2(o, p2);
  }

  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn2(this, result);
    };
  }

  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized2(self2);
  }

  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self2;
  }

  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e2) {
      return false;
    }
  }

  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }

  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var hooks = ["onChange", "onOpen", "onClose", "onMonthChange", "onYearChange", "onReady", "onValueUpdate", "onDayCreate"];

  var hookPropType = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]);

  var callbacks = ["onCreate", "onDestroy"];
  var callbackPropTypes = _propTypes["default"].func;

  var DateTimePicker =
  /* @__PURE__ */
  function (_Component) {
    _inherits2(DateTimePicker2, _Component);

    var _super = _createSuper2(DateTimePicker2);

    function DateTimePicker2() {
      var _this;

      _classCallCheck2(this, DateTimePicker2);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty2(_assertThisInitialized2(_this), "createFlatpickrInstance", function () {
        var options2 = _objectSpread({
          onClose: function onClose() {
            _this.node.blur && _this.node.blur();
          }
        }, _this.props.options);

        hooks.forEach(function (hook) {
          if (_this.props[hook]) {
            options2[hook] = _this.props[hook];
          }
        });
        _this.flatpickr = (0, _flatpickr2["default"])(_this.node, options2);

        if (_this.props.hasOwnProperty("value")) {
          _this.flatpickr.setDate(_this.props.value, false);
        }

        var onCreate2 = _this.props.onCreate;
        if (onCreate2) onCreate2(_this.flatpickr);
      });

      _defineProperty2(_assertThisInitialized2(_this), "destroyFlatpickrInstance", function () {
        var onDestroy2 = _this.props.onDestroy;
        if (onDestroy2) onDestroy2(_this.flatpickr);

        _this.flatpickr.destroy();

        _this.flatpickr = null;
      });

      _defineProperty2(_assertThisInitialized2(_this), "handleNodeChange", function (node2) {
        _this.node = node2;

        if (_this.flatpickr) {
          _this.destroyFlatpickrInstance();

          _this.createFlatpickrInstance();
        }
      });

      return _this;
    }

    _createClass2(DateTimePicker2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        var options2 = this.props.options;
        var prevOptions = prevProps.options;
        hooks.forEach(function (hook) {
          mergeHooks(options2, _this2.props, hook);
          mergeHooks(prevOptions, prevProps, hook);
        });
        var optionsKeys = Object.getOwnPropertyNames(options2);

        for (var index2 = optionsKeys.length - 1; index2 >= 0; index2--) {
          var key = optionsKeys[index2];
          var value = options2[key];

          if (value !== prevOptions[key]) {
            if (hooks.indexOf(key) !== -1 && !Array.isArray(value)) {
              value = [value];
            }

            this.flatpickr.set(key, value);
          }
        }

        if (this.props.hasOwnProperty("value") && !(this.props.value && Array.isArray(this.props.value) && prevProps.value && Array.isArray(prevProps.value) && this.props.value.every(function (v2, i) {
          prevProps[i] === v2;
        })) && this.props.value !== prevProps.value) {
          this.flatpickr.setDate(this.props.value, false);
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.createFlatpickrInstance();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyFlatpickrInstance();
      }
    }, {
      key: "render",
      value: function render2() {
        var _this$props = this.props,
            options2 = _this$props.options,
            defaultValue = _this$props.defaultValue,
            value = _this$props.value,
            children = _this$props.children,
            render3 = _this$props.render,
            props = _objectWithoutProperties2(_this$props, ["options", "defaultValue", "value", "children", "render"]);

        hooks.forEach(function (hook) {
          delete props[hook];
        });
        callbacks.forEach(function (callback) {
          delete props[callback];
        });
        if (render3) return render3(_objectSpread(_objectSpread({}, props), {}, {
          defaultValue: defaultValue,
          value: value
        }), this.handleNodeChange);
        return options2.wrap ?
        /* @__PURE__ */
        _react["default"].createElement("div", _extends2({}, props, {
          ref: this.handleNodeChange
        }), children) :
        /* @__PURE__ */
        _react["default"].createElement("input", _extends2({}, props, {
          defaultValue: defaultValue,
          ref: this.handleNodeChange
        }));
      }
    }]);

    return DateTimePicker2;
  }(_react.Component);

  _defineProperty2(DateTimePicker, "propTypes", {
    defaultValue: _propTypes["default"].string,
    options: _propTypes["default"].object,
    onChange: hookPropType,
    onOpen: hookPropType,
    onClose: hookPropType,
    onMonthChange: hookPropType,
    onYearChange: hookPropType,
    onReady: hookPropType,
    onValueUpdate: hookPropType,
    onDayCreate: hookPropType,
    onCreate: callbackPropTypes,
    onDestroy: callbackPropTypes,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object, _propTypes["default"].number]),
    children: _propTypes["default"].node,
    className: _propTypes["default"].string,
    render: _propTypes["default"].func
  });

  _defineProperty2(DateTimePicker, "defaultProps", {
    options: {}
  });

  function mergeHooks(inputOptions, props, hook) {
    var options2 = _objectSpread({}, inputOptions);

    if (props.hasOwnProperty(hook)) {
      var _options$hook;

      if (options2[hook] && !Array.isArray(options2[hook])) {
        options2[hook] = [options2[hook]];
      } else if (!options2[hook]) {
        options2[hook] = [];
      }

      var propHook = Array.isArray(props[hook]) ? props[hook] : [props[hook]];

      (_options$hook = options2[hook]).push.apply(_options$hook, _toConsumableArray2(propHook));
    }

    return options2;
  }

  var _default = DateTimePicker;
  exports["default"] = _default;
})(build);

var Flatpickr =
/* @__PURE__ */
getDefaultExportFromCjs(build);

var ClearButton = function ClearButton(_ref621) {
  var disabled = _ref621.disabled,
      clear = _ref621.clear,
      onClick = _ref621.onClick;
  return (
    /* @__PURE__ */
    jsx$1(Tippy, {
      content: clear,
      children:
      /* @__PURE__ */
      jsx$1("button", {
        disabled: disabled,
        className: "topxw-border topxw-rounded topxw-ml-2 topxw-px-3 topxw-flex topxw-items-center ".concat(!disabled ? "topxw-cursor-pointer hover:topxw-bg-gray-200" : ""),
        onClick: onClick,
        "data-testid": "clear",
        children:
        /* @__PURE__ */
        jsx$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: svgSize(4),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children:
          /* @__PURE__ */
          jsx$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M6 18L18 6M6 6l12 12"
          })
        })
      })
    })
  );
};

var CuttoffTime = function CuttoffTime(_ref622) {
  var onChange2 = _ref622.onChange,
      cutoffTimeIsFilled = _ref622.cutoffTimeIsFilled,
      value = _ref622.value,
      editMode = _ref622.editMode,
      labels = _ref622.labels,
      gameStatus = _ref622.gameStatus;
  var refFlatpickr = useRef(null);
  var tenMinutes = 10;
  var isEditable = gameStatus === "PENDING" || gameStatus === "OPEN";

  var clearDate = function clearDate() {
    refFlatpickr.current.flatpickr.clear();
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "Cutoff time",
        className: titleManageGameStyle,
        children: labels.cutoffTime
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-flex-row",
        children: [
        /* @__PURE__ */
        jsx$1(Flatpickr, {
          "data-testid": "input date",
          ref: refFlatpickr,
          "data-enable-time": true,
          options: {
            clickOpens: isEditable ? true : false,
            dateFormat: labels.timeFormat,
            altFormat: labels.timeFormat,
            time_24hr: true,
            altInput: true,
            minDate: isEditable ? dayjs().add(tenMinutes, "minute").toDate() : dayjs(value).toDate(),
            position: "above",
            altInputClass: "".concat(inputStyle$1),
            parseDate: function parseDate(dateStr, format) {
              return dayjs(dateStr, format).toDate();
            },
            formatDate: function formatDate(date, format) {
              return dayjs(date).format(format);
            }
          },
          onChange: function onChange(date) {
            return onChange2(date, "cutoff_time");
          },
          defaultValue: editMode && value ? dayjs(value).toISOString() : null
        }),
        /* @__PURE__ */
        jsx$1(ClearButton, {
          disabled: !cutoffTimeIsFilled,
          clear: labels.clear,
          onClick: clearDate
        })]
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs topxw-mt-1",
        children: editMode ? labels.cutoffTimeDescriptionOnEdit : labels.cutoffTimeDescriptionOnCreate
      })]
    })
  );
};

var md5 = {
  exports: {}
};
var core = {
  exports: {}
};

(function (module, exports) {
  (function (root2, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function () {
    var CryptoJS = CryptoJS || function (Math2, undefined$1) {
      var crypto2;

      if (typeof window !== "undefined" && window.crypto) {
        crypto2 = window.crypto;
      }

      if (typeof self !== "undefined" && self.crypto) {
        crypto2 = self.crypto;
      }

      if (typeof globalThis !== "undefined" && globalThis.crypto) {
        crypto2 = globalThis.crypto;
      }

      if (!crypto2 && typeof window !== "undefined" && window.msCrypto) {
        crypto2 = window.msCrypto;
      }

      if (!crypto2 && typeof commonjsGlobal !== "undefined" && commonjsGlobal.crypto) {
        crypto2 = commonjsGlobal.crypto;
      }

      if (!crypto2 && typeof commonjsRequire === "function") {
        try {
          crypto2 = require("crypto");
        } catch (err) {}
      }

      var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
        if (crypto2) {
          if (typeof crypto2.getRandomValues === "function") {
            try {
              return crypto2.getRandomValues(new Uint32Array(1))[0];
            } catch (err) {}
          }

          if (typeof crypto2.randomBytes === "function") {
            try {
              return crypto2.randomBytes(4).readInt32LE();
            } catch (err) {}
          }
        }

        throw new Error("Native crypto module could not be used to get secure random number.");
      };

      var create = Object.create || function () {
        function F2() {}

        return function (obj) {
          var subtype;
          F2.prototype = obj;
          subtype = new F2();
          F2.prototype = null;
          return subtype;
        };
      }();

      var C2 = {};
      var C_lib = C2.lib = {};

      var Base = C_lib.Base = function () {
        return {
          extend: function extend(overrides) {
            var subtype = create(this);

            if (overrides) {
              subtype.mixIn(overrides);
            }

            if (!subtype.hasOwnProperty("init") || this.init === subtype.init) {
              subtype.init = function () {
                subtype.$super.init.apply(this, arguments);
              };
            }

            subtype.init.prototype = subtype;
            subtype.$super = this;
            return subtype;
          },
          create: function create() {
            var instance = this.extend();
            instance.init.apply(instance, arguments);
            return instance;
          },
          init: function init() {},
          mixIn: function mixIn(properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            }

            if (properties.hasOwnProperty("toString")) {
              this.toString = properties.toString;
            }
          },
          clone: function clone() {
            return this.init.prototype.extend(this);
          }
        };
      }();

      var WordArray2 = C_lib.WordArray = Base.extend({
        init: function init(words2, sigBytes) {
          words2 = this.words = words2 || [];

          if (sigBytes != undefined$1) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words2.length * 4;
          }
        },
        toString: function toString(encoder) {
          return (encoder || Hex).stringify(this);
        },
        concat: function concat(wordArray) {
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes;
          this.clamp();

          if (thisSigBytes % 4) {
            for (var i = 0; i < thatSigBytes; i++) {
              var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
            }
          } else {
            for (var j = 0; j < thatSigBytes; j += 4) {
              thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
            }
          }

          this.sigBytes += thatSigBytes;
          return this;
        },
        clamp: function clamp() {
          var words2 = this.words;
          var sigBytes = this.sigBytes;
          words2[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
          words2.length = Math2.ceil(sigBytes / 4);
        },
        clone: function clone() {
          var clone = Base.clone.call(this);
          clone.words = this.words.slice(0);
          return clone;
        },
        random: function random(nBytes) {
          var words2 = [];

          for (var i = 0; i < nBytes; i += 4) {
            words2.push(cryptoSecureRandomInt());
          }

          return new WordArray2.init(words2, nBytes);
        }
      });
      var C_enc = C2.enc = {};
      var Hex = C_enc.Hex = {
        stringify: function stringify(wordArray) {
          var words2 = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var hexChars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words2[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 15).toString(16));
          }

          return hexChars.join("");
        },
        parse: function parse(hexStr) {
          var hexStrLength = hexStr.length;
          var words2 = [];

          for (var i = 0; i < hexStrLength; i += 2) {
            words2[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
          }

          return new WordArray2.init(words2, hexStrLength / 2);
        }
      };
      var Latin1 = C_enc.Latin1 = {
        stringify: function stringify(wordArray) {
          var words2 = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var latin1Chars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words2[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            latin1Chars.push(String.fromCharCode(bite));
          }

          return latin1Chars.join("");
        },
        parse: function parse(latin1Str) {
          var latin1StrLength = latin1Str.length;
          var words2 = [];

          for (var i = 0; i < latin1StrLength; i++) {
            words2[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
          }

          return new WordArray2.init(words2, latin1StrLength);
        }
      };
      var Utf8 = C_enc.Utf8 = {
        stringify: function stringify(wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e2) {
            throw new Error("Malformed UTF-8 data");
          }
        },
        parse: function parse(utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        reset: function reset() {
          this._data = new WordArray2.init();
          this._nDataBytes = 0;
        },
        _append: function _append(data2) {
          if (typeof data2 == "string") {
            data2 = Utf8.parse(data2);
          }

          this._data.concat(data2);

          this._nDataBytes += data2.sigBytes;
        },
        _process: function _process(doFlush) {
          var processedWords;
          var data2 = this._data;
          var dataWords = data2.words;
          var dataSigBytes = data2.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4;
          var nBlocksReady = dataSigBytes / blockSizeBytes;

          if (doFlush) {
            nBlocksReady = Math2.ceil(nBlocksReady);
          } else {
            nBlocksReady = Math2.max((nBlocksReady | 0) - this._minBufferSize, 0);
          }

          var nWordsReady = nBlocksReady * blockSize;
          var nBytesReady = Math2.min(nWordsReady * 4, dataSigBytes);

          if (nWordsReady) {
            for (var offset2 = 0; offset2 < nWordsReady; offset2 += blockSize) {
              this._doProcessBlock(dataWords, offset2);
            }

            processedWords = dataWords.splice(0, nWordsReady);
            data2.sigBytes -= nBytesReady;
          }

          return new WordArray2.init(processedWords, nBytesReady);
        },
        clone: function clone() {
          var clone = Base.clone.call(this);
          clone._data = this._data.clone();
          return clone;
        },
        _minBufferSize: 0
      });
      C_lib.Hasher = BufferedBlockAlgorithm.extend({
        cfg: Base.extend(),
        init: function init(cfg) {
          this.cfg = this.cfg.extend(cfg);
          this.reset();
        },
        reset: function reset() {
          BufferedBlockAlgorithm.reset.call(this);

          this._doReset();
        },
        update: function update(messageUpdate) {
          this._append(messageUpdate);

          this._process();

          return this;
        },
        finalize: function finalize(messageUpdate) {
          if (messageUpdate) {
            this._append(messageUpdate);
          }

          var hash2 = this._doFinalize();

          return hash2;
        },
        blockSize: 512 / 32,
        _createHelper: function _createHelper(hasher) {
          return function (message, cfg) {
            return new hasher.init(cfg).finalize(message);
          };
        },
        _createHmacHelper: function _createHmacHelper(hasher) {
          return function (message, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message);
          };
        }
      });
      var C_algo = C2.algo = {};
      return C2;
    }(Math);

    return CryptoJS;
  });
})(core);

(function (module, exports) {
  (function (root2, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function (Math2) {
      var C2 = CryptoJS;
      var C_lib = C2.lib;
      var WordArray2 = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C2.algo;
      var T = [];

      (function () {
        for (var i = 0; i < 64; i++) {
          T[i] = Math2.abs(Math2.sin(i + 1)) * 4294967296 | 0;
        }
      })();

      var MD52 = C_algo.MD5 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = new WordArray2.init([1732584193, 4023233417, 2562383102, 271733878]);
        },
        _doProcessBlock: function _doProcessBlock(M2, offset2) {
          for (var i = 0; i < 16; i++) {
            var offset_i = offset2 + i;
            var M_offset_i = M2[offset_i];
            M2[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 16711935 | (M_offset_i << 24 | M_offset_i >>> 8) & 4278255360;
          }

          var H2 = this._hash.words;
          var M_offset_0 = M2[offset2 + 0];
          var M_offset_1 = M2[offset2 + 1];
          var M_offset_2 = M2[offset2 + 2];
          var M_offset_3 = M2[offset2 + 3];
          var M_offset_4 = M2[offset2 + 4];
          var M_offset_5 = M2[offset2 + 5];
          var M_offset_6 = M2[offset2 + 6];
          var M_offset_7 = M2[offset2 + 7];
          var M_offset_8 = M2[offset2 + 8];
          var M_offset_9 = M2[offset2 + 9];
          var M_offset_10 = M2[offset2 + 10];
          var M_offset_11 = M2[offset2 + 11];
          var M_offset_12 = M2[offset2 + 12];
          var M_offset_13 = M2[offset2 + 13];
          var M_offset_14 = M2[offset2 + 14];
          var M_offset_15 = M2[offset2 + 15];
          var a = H2[0];
          var b2 = H2[1];
          var c2 = H2[2];
          var d2 = H2[3];
          a = FF(a, b2, c2, d2, M_offset_0, 7, T[0]);
          d2 = FF(d2, a, b2, c2, M_offset_1, 12, T[1]);
          c2 = FF(c2, d2, a, b2, M_offset_2, 17, T[2]);
          b2 = FF(b2, c2, d2, a, M_offset_3, 22, T[3]);
          a = FF(a, b2, c2, d2, M_offset_4, 7, T[4]);
          d2 = FF(d2, a, b2, c2, M_offset_5, 12, T[5]);
          c2 = FF(c2, d2, a, b2, M_offset_6, 17, T[6]);
          b2 = FF(b2, c2, d2, a, M_offset_7, 22, T[7]);
          a = FF(a, b2, c2, d2, M_offset_8, 7, T[8]);
          d2 = FF(d2, a, b2, c2, M_offset_9, 12, T[9]);
          c2 = FF(c2, d2, a, b2, M_offset_10, 17, T[10]);
          b2 = FF(b2, c2, d2, a, M_offset_11, 22, T[11]);
          a = FF(a, b2, c2, d2, M_offset_12, 7, T[12]);
          d2 = FF(d2, a, b2, c2, M_offset_13, 12, T[13]);
          c2 = FF(c2, d2, a, b2, M_offset_14, 17, T[14]);
          b2 = FF(b2, c2, d2, a, M_offset_15, 22, T[15]);
          a = GG(a, b2, c2, d2, M_offset_1, 5, T[16]);
          d2 = GG(d2, a, b2, c2, M_offset_6, 9, T[17]);
          c2 = GG(c2, d2, a, b2, M_offset_11, 14, T[18]);
          b2 = GG(b2, c2, d2, a, M_offset_0, 20, T[19]);
          a = GG(a, b2, c2, d2, M_offset_5, 5, T[20]);
          d2 = GG(d2, a, b2, c2, M_offset_10, 9, T[21]);
          c2 = GG(c2, d2, a, b2, M_offset_15, 14, T[22]);
          b2 = GG(b2, c2, d2, a, M_offset_4, 20, T[23]);
          a = GG(a, b2, c2, d2, M_offset_9, 5, T[24]);
          d2 = GG(d2, a, b2, c2, M_offset_14, 9, T[25]);
          c2 = GG(c2, d2, a, b2, M_offset_3, 14, T[26]);
          b2 = GG(b2, c2, d2, a, M_offset_8, 20, T[27]);
          a = GG(a, b2, c2, d2, M_offset_13, 5, T[28]);
          d2 = GG(d2, a, b2, c2, M_offset_2, 9, T[29]);
          c2 = GG(c2, d2, a, b2, M_offset_7, 14, T[30]);
          b2 = GG(b2, c2, d2, a, M_offset_12, 20, T[31]);
          a = HH(a, b2, c2, d2, M_offset_5, 4, T[32]);
          d2 = HH(d2, a, b2, c2, M_offset_8, 11, T[33]);
          c2 = HH(c2, d2, a, b2, M_offset_11, 16, T[34]);
          b2 = HH(b2, c2, d2, a, M_offset_14, 23, T[35]);
          a = HH(a, b2, c2, d2, M_offset_1, 4, T[36]);
          d2 = HH(d2, a, b2, c2, M_offset_4, 11, T[37]);
          c2 = HH(c2, d2, a, b2, M_offset_7, 16, T[38]);
          b2 = HH(b2, c2, d2, a, M_offset_10, 23, T[39]);
          a = HH(a, b2, c2, d2, M_offset_13, 4, T[40]);
          d2 = HH(d2, a, b2, c2, M_offset_0, 11, T[41]);
          c2 = HH(c2, d2, a, b2, M_offset_3, 16, T[42]);
          b2 = HH(b2, c2, d2, a, M_offset_6, 23, T[43]);
          a = HH(a, b2, c2, d2, M_offset_9, 4, T[44]);
          d2 = HH(d2, a, b2, c2, M_offset_12, 11, T[45]);
          c2 = HH(c2, d2, a, b2, M_offset_15, 16, T[46]);
          b2 = HH(b2, c2, d2, a, M_offset_2, 23, T[47]);
          a = II(a, b2, c2, d2, M_offset_0, 6, T[48]);
          d2 = II(d2, a, b2, c2, M_offset_7, 10, T[49]);
          c2 = II(c2, d2, a, b2, M_offset_14, 15, T[50]);
          b2 = II(b2, c2, d2, a, M_offset_5, 21, T[51]);
          a = II(a, b2, c2, d2, M_offset_12, 6, T[52]);
          d2 = II(d2, a, b2, c2, M_offset_3, 10, T[53]);
          c2 = II(c2, d2, a, b2, M_offset_10, 15, T[54]);
          b2 = II(b2, c2, d2, a, M_offset_1, 21, T[55]);
          a = II(a, b2, c2, d2, M_offset_8, 6, T[56]);
          d2 = II(d2, a, b2, c2, M_offset_15, 10, T[57]);
          c2 = II(c2, d2, a, b2, M_offset_6, 15, T[58]);
          b2 = II(b2, c2, d2, a, M_offset_13, 21, T[59]);
          a = II(a, b2, c2, d2, M_offset_4, 6, T[60]);
          d2 = II(d2, a, b2, c2, M_offset_11, 10, T[61]);
          c2 = II(c2, d2, a, b2, M_offset_2, 15, T[62]);
          b2 = II(b2, c2, d2, a, M_offset_9, 21, T[63]);
          H2[0] = H2[0] + a | 0;
          H2[1] = H2[1] + b2 | 0;
          H2[2] = H2[2] + c2 | 0;
          H2[3] = H2[3] + d2 | 0;
        },
        _doFinalize: function _doFinalize() {
          var data2 = this._data;
          var dataWords = data2.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data2.sigBytes * 8;
          dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
          var nBitsTotalH = Math2.floor(nBitsTotal / 4294967296);
          var nBitsTotalL = nBitsTotal;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 16711935 | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 4278255360;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 16711935 | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 4278255360;
          data2.sigBytes = (dataWords.length + 1) * 4;

          this._process();

          var hash2 = this._hash;
          var H2 = hash2.words;

          for (var i = 0; i < 4; i++) {
            var H_i = H2[i];
            H2[i] = (H_i << 8 | H_i >>> 24) & 16711935 | (H_i << 24 | H_i >>> 8) & 4278255360;
          }

          return hash2;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });

      function FF(a, b2, c2, d2, x2, s, t2) {
        var n2 = a + (b2 & c2 | ~b2 & d2) + x2 + t2;
        return (n2 << s | n2 >>> 32 - s) + b2;
      }

      function GG(a, b2, c2, d2, x2, s, t2) {
        var n2 = a + (b2 & d2 | c2 & ~d2) + x2 + t2;
        return (n2 << s | n2 >>> 32 - s) + b2;
      }

      function HH(a, b2, c2, d2, x2, s, t2) {
        var n2 = a + (b2 ^ c2 ^ d2) + x2 + t2;
        return (n2 << s | n2 >>> 32 - s) + b2;
      }

      function II(a, b2, c2, d2, x2, s, t2) {
        var n2 = a + (c2 ^ (b2 | ~d2)) + x2 + t2;
        return (n2 << s | n2 >>> 32 - s) + b2;
      }

      C2.MD5 = Hasher._createHelper(MD52);
      C2.HmacMD5 = Hasher._createHmacHelper(MD52);
    })(Math);

    return CryptoJS.MD5;
  });
})(md5);

var MD5 = md5.exports;
var libTypedarrays = {
  exports: {}
};

(function (module, exports) {
  (function (root2, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function () {
      if (typeof ArrayBuffer != "function") {
        return;
      }

      var C2 = CryptoJS;
      var C_lib = C2.lib;
      var WordArray2 = C_lib.WordArray;
      var superInit = WordArray2.init;

      var subInit = WordArray2.init = function (typedArray) {
        if (typedArray instanceof ArrayBuffer) {
          typedArray = new Uint8Array(typedArray);
        }

        if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
          typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
        }

        if (typedArray instanceof Uint8Array) {
          var typedArrayByteLength = typedArray.byteLength;
          var words2 = [];

          for (var i = 0; i < typedArrayByteLength; i++) {
            words2[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
          }

          superInit.call(this, words2, typedArrayByteLength);
        } else {
          superInit.apply(this, arguments);
        }
      };

      subInit.prototype = WordArray2;
    })();

    return CryptoJS.lib.WordArray;
  });
})(libTypedarrays);

var WordArray = libTypedarrays.exports;
var encBase64 = {
  exports: {}
};

(function (module, exports) {
  (function (root2, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function (CryptoJS) {
    (function () {
      var C2 = CryptoJS;
      var C_lib = C2.lib;
      var WordArray2 = C_lib.WordArray;
      var C_enc = C2.enc;
      C_enc.Base64 = {
        stringify: function stringify(wordArray) {
          var words2 = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var map = this._map;
          wordArray.clamp();
          var base64Chars = [];

          for (var i = 0; i < sigBytes; i += 3) {
            var byte1 = words2[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            var byte2 = words2[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255;
            var byte3 = words2[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255;
            var triplet = byte1 << 16 | byte2 << 8 | byte3;

            for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
              base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 63));
            }
          }

          var paddingChar = map.charAt(64);

          if (paddingChar) {
            while (base64Chars.length % 4) {
              base64Chars.push(paddingChar);
            }
          }

          return base64Chars.join("");
        },
        parse: function parse(base64Str) {
          var base64StrLength = base64Str.length;
          var map = this._map;
          var reverseMap = this._reverseMap;

          if (!reverseMap) {
            reverseMap = this._reverseMap = [];

            for (var j = 0; j < map.length; j++) {
              reverseMap[map.charCodeAt(j)] = j;
            }
          }

          var paddingChar = map.charAt(64);

          if (paddingChar) {
            var paddingIndex = base64Str.indexOf(paddingChar);

            if (paddingIndex !== -1) {
              base64StrLength = paddingIndex;
            }
          }

          return parseLoop(base64Str, base64StrLength, reverseMap);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };

      function parseLoop(base64Str, base64StrLength, reverseMap) {
        var words2 = [];
        var nBytes = 0;

        for (var i = 0; i < base64StrLength; i++) {
          if (i % 4) {
            var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
            var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
            var bitsCombined = bits1 | bits2;
            words2[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
            nBytes++;
          }
        }

        return WordArray2.create(words2, nBytes);
      }
    })();

    return CryptoJS.enc.Base64;
  });
})(encBase64);

var Base64 = encBase64.exports;

var HashService = function HashService() {
  _classCallCheck3(this, HashService);

  this.readFileAndHash = function (file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function (e2) {
        var data2 = e2.target.result;
        var wordArray = WordArray.create(new Uint8Array(data2));
        var hashed = MD5(wordArray);
        var base642 = hashed.toString(Base64);
        resolve(base642);
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  this.generateHashFileName = function (file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function (e2) {
        var data2 = e2.target.result;
        var wordArray = WordArray.create(new Uint8Array(data2));
        var hashed = MD5(wordArray).toString();
        resolve(hashed);
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };
};

var hashService = new HashService();

var FileUploader = function FileUploader(_ref623) {
  var httpsService = _ref623.httpsService,
      labels = _ref623.labels,
      imageNode = _ref623.imageNode,
      onChangeImages = _ref623.onChangeImages;

  var _useState25 = useState(false),
      _useState26 = _slicedToArray3(_useState25, 2),
      loading = _useState26[0],
      setLoading = _useState26[1];

  var uniqueInputId = "file-upload-".concat(imageNode);

  var handleFileChange =
  /*#__PURE__*/
  function () {
    var _ref624 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee633(event) {
      var selectedFile, imageType, base642, fileName, requestBody, response, googleHeaders, file, url;
      return _regeneratorRuntime.wrap(function _callee633$(_context634) {
        while (1) {
          switch (_context634.prev = _context634.next) {
            case 0:
              event.persist();
              selectedFile = event.target.files[0];

              if (!selectedFile) {
                _context634.next = 44;
                break;
              }

              setLoading(true);
              _context634.prev = 4;
              imageType = selectedFile.type.split("/")[1];
              _context634.next = 8;
              return hashService.readFileAndHash(selectedFile);

            case 8:
              base642 = _context634.sent;
              _context634.next = 11;
              return hashService.generateHashFileName(selectedFile);

            case 11:
              _context634.t0 = _context634.sent;
              _context634.t1 = _context634.t0 + ".";
              _context634.t2 = imageType;
              fileName = _context634.t1 + _context634.t2;
              requestBody = {
                image_type: imageType,
                image_file_name: fileName,
                image_size: selectedFile.size,
                base64_sum: base642
              };
              _context634.prev = 16;
              _context634.next = 19;
              return httpsService.generateSignedInUrl(requestBody);

            case 19:
              response = _context634.sent;
              googleHeaders = {
                "Content-Type": selectedFile.type,
                "Content-MD5": base642
              };
              file = new File([selectedFile], fileName, {
                type: selectedFile.type
              });
              _context634.prev = 22;
              _context634.next = 25;
              return httpsService.storeInBucket(response.data.data.signed_url, file, googleHeaders);

            case 25:
              url = _context634.sent;
              onChangeImages(url, imageNode);
              toast.success(labels.uploadingImageMessage);
              _context634.next = 33;
              break;

            case 30:
              _context634.prev = 30;
              _context634.t3 = _context634["catch"](22);
              toast.error(labels.uploadingImageErrorMessage);

            case 33:
              _context634.next = 38;
              break;

            case 35:
              _context634.prev = 35;
              _context634.t4 = _context634["catch"](16);
              toast.error(labels.generateSignedInUrlErrorMessage);

            case 38:
              _context634.next = 43;
              break;

            case 40:
              _context634.prev = 40;
              _context634.t5 = _context634["catch"](4);
              toast.error(labels.encryptingImageErrorMessage);

            case 43:
              setLoading(false);

            case 44:
            case "end":
              return _context634.stop();
          }
        }
      }, _callee633, null, [[4, 40], [16, 35], [22, 30]]);
    }));

    return function handleFileChange(_x1184) {
      return _ref624.apply(this, arguments);
    };
  }();

  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1("button", {
        className: "".concat(actionButtonStyle, " topxw-p-2 ").concat(loading ? "topxw-bg-gray-200" : "topxw-bg-white", " topxw-border topxw-border-gray-200"),
        onClick: function onClick() {
          return document.getElementById(uniqueInputId).click();
        },
        disabled: loading,
        children:
        /* @__PURE__ */
        jsx$1("img", {
          src: assetsPlaceholder.upload,
          alt: "Upload",
          className: "topxw-w-6 topxw-h-6"
        })
      }),
      /* @__PURE__ */
      jsx$1("input", {
        "data-testid": "file-upload",
        id: uniqueInputId,
        type: "file",
        className: "topxw-hidden",
        accept: "image/*",
        onChange: handleFileChange
      })]
    })
  );
};

var sportal365ButtonImage = "https://uploads.fansunitedassets.com/sportal_bg/34f381025412708291999cd645e288e5.png";

var Sportal365Button = function Sportal365Button(_ref625) {
  var toggleShowImagesContainer = _ref625.toggleShowImagesContainer;
  return (
    /* @__PURE__ */
    jsx$1("button", {
      className: "".concat(actionButtonStyle, " topxw-p-2 topxw-bg-white topxw-border topxw-border-gray-200"),
      onClick: toggleShowImagesContainer,
      children:
      /* @__PURE__ */
      jsx$1("img", {
        src: sportal365ButtonImage,
        alt: "sportal365-button",
        className: "topxw-w-24 topxw-h-6"
      })
    })
  );
};

var Sportal365ImagesFromToFilter = function Sportal365ImagesFromToFilter(_ref626) {
  var labels = _ref626.labels,
      setFilters = _ref626.setFilters;

  var _useState27 = useState(false),
      _useState28 = _slicedToArray3(_useState27, 2),
      dateIsFilled = _useState28[0],
      setDateIsFilled = _useState28[1];

  var refFlatpickr = useRef(null);

  var onChange2 = function onChange2(date) {
    if (date && date.length > 1) {
      setDateIsFilled(true);
      var apiDateFormat = "YYYY-MM-DD";
      var from2 = dayjs(date[0]).format(apiDateFormat);
      var to2 = dayjs(date[1]).format(apiDateFormat);
      setFilters({
        from: from2,
        to: to2
      });
    } else if (date.length === 0 && !dateIsFilled) {
      setFilters(null);
      toast.info(labels.clearFromToFilterSportal365ImagesMessage);
    }
  };

  var clearDate = function clearDate() {
    refFlatpickr.current.flatpickr.clear();
    setDateIsFilled(false);
  };

  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "date from/to",
        className: titleManageGameStyle,
        children: labels.dateFromTo
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-flex-row",
        children: [
        /* @__PURE__ */
        jsx$1(Flatpickr, {
          ref: refFlatpickr,
          className: "lw-flex-1",
          placeholder: labels.dateFromToPlaceholder,
          options: {
            mode: "range",
            enableTime: false,
            dateFormat: "YYYY-MM-DD",
            altFormat: "YYYY-MM-DD",
            altInput: true,
            position: "below",
            altInputClass: inputStyle$1,
            parseDate: function parseDate(dateStr, format) {
              return dayjs(dateStr, format).toDate();
            },
            formatDate: function formatDate(date, format) {
              return dayjs(date).format(format);
            },
            defaultDate: null
          },
          onChange: onChange2
        }),
        /* @__PURE__ */
        jsx$1(ClearButton, {
          onClick: clearDate,
          disabled: !dateIsFilled,
          clear: labels.clear
        })]
      })]
    })
  );
};

function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}

var isObject_1 = isObject$5;
var root$7 = _root;

var now$1 = function now$1() {
  return root$7.Date.now();
};

var now_1 = now$1;
var reWhitespace = /\s/;

function trimmedEndIndex$1(string) {
  var index2 = string.length;

  while (index2-- && reWhitespace.test(string.charAt(index2))) {}

  return index2;
}

var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;

function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}

var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim,
    isObject$4 = isObject_1,
    isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;

function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject$4(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$4(other) ? other + "" : other;
  }

  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber$2;
var isObject$3 = isObject_1,
    now = now_1,
    toNumber$1 = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

function debounce(func, wait, options2) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber$1(wait) || 0;

  if (isObject$3(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax$1(toNumber$1(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }

    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = void 0;

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = void 0;
    return result;
  }

  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }

  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;
var _excluded = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];

function useAsync(_ref3) {
  var _ref$defaultOptions = _ref3.defaultOptions,
      propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions,
      _ref$cacheOptions = _ref3.cacheOptions,
      cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions,
      propsLoadOptions = _ref3.loadOptions;
  _ref3.options;

  var _ref$isLoading = _ref3.isLoading,
      propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      propsOnInputChange = _ref3.onInputChange,
      _ref$filterOption = _ref3.filterOption,
      filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption,
      restSelectProps = _objectWithoutProperties(_ref3, _excluded);

  var propsInputValue = restSelectProps.inputValue;
  var lastRequest = useRef(void 0);
  var mounted = useRef(false);

  var _useState = useState(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : void 0),
      _useState2 = _slicedToArray(_useState, 2),
      defaultOptions = _useState2[0],
      setDefaultOptions = _useState2[1];

  var _useState3 = useState(typeof propsInputValue !== "undefined" ? propsInputValue : ""),
      _useState4 = _slicedToArray(_useState3, 2),
      stateInputValue = _useState4[0],
      setStateInputValue = _useState4[1];

  var _useState5 = useState(propsDefaultOptions === true),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState(void 0),
      _useState8 = _slicedToArray(_useState7, 2),
      loadedInputValue = _useState8[0],
      setLoadedInputValue = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      loadedOptions = _useState10[0],
      setLoadedOptions = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      passEmptyOptions = _useState12[0],
      setPassEmptyOptions = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      optionsCache = _useState14[0],
      setOptionsCache = _useState14[1];

  var _useState15 = useState(void 0),
      _useState16 = _slicedToArray(_useState15, 2),
      prevDefaultOptions = _useState16[0],
      setPrevDefaultOptions = _useState16[1];

  var _useState17 = useState(void 0),
      _useState18 = _slicedToArray(_useState17, 2),
      prevCacheOptions = _useState18[0],
      setPrevCacheOptions = _useState18[1];

  if (cacheOptions !== prevCacheOptions) {
    setOptionsCache({});
    setPrevCacheOptions(cacheOptions);
  }

  if (propsDefaultOptions !== prevDefaultOptions) {
    setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : void 0);
    setPrevDefaultOptions(propsDefaultOptions);
  }

  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var loadOptions = useCallback(function (inputValue, callback) {
    if (!propsLoadOptions) return callback();
    var loader = propsLoadOptions(inputValue, callback);

    if (loader && typeof loader.then === "function") {
      loader.then(callback, function () {
        return callback();
      });
    }
  }, [propsLoadOptions]);
  useEffect(function () {
    if (propsDefaultOptions === true) {
      loadOptions(stateInputValue, function (options3) {
        if (!mounted.current) return;
        setDefaultOptions(options3 || []);
        setIsLoading(!!lastRequest.current);
      });
    }
  }, []);
  var onInputChange = useCallback(function (newValue, actionMeta) {
    var inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);

    if (!inputValue) {
      lastRequest.current = void 0;
      setStateInputValue("");
      setLoadedInputValue("");
      setLoadedOptions([]);
      setIsLoading(false);
      setPassEmptyOptions(false);
      return;
    }

    if (cacheOptions && optionsCache[inputValue]) {
      setStateInputValue(inputValue);
      setLoadedInputValue(inputValue);
      setLoadedOptions(optionsCache[inputValue]);
      setIsLoading(false);
      setPassEmptyOptions(false);
    } else {
      var request2 = lastRequest.current = {};
      setStateInputValue(inputValue);
      setIsLoading(true);
      setPassEmptyOptions(!loadedInputValue);
      loadOptions(inputValue, function (options3) {
        if (!mounted) return;
        if (request2 !== lastRequest.current) return;
        lastRequest.current = void 0;
        setIsLoading(false);
        setLoadedInputValue(inputValue);
        setLoadedOptions(options3 || []);
        setPassEmptyOptions(false);
        setOptionsCache(options3 ? _objectSpread2(_objectSpread2({}, optionsCache), {}, _defineProperty({}, inputValue, options3)) : optionsCache);
      });
    }
  }, [cacheOptions, loadOptions, loadedInputValue, optionsCache, propsOnInputChange]);
  var options2 = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    isLoading: isLoading || propsIsLoading,
    onInputChange: onInputChange,
    filterOption: filterOption
  });
}

var AsyncSelect =
/* @__PURE__ */
forwardRef$1(function (props, ref) {
  var stateManagedProps = useAsync(props);
  var selectProps = useStateManager(stateManagedProps);
  return (
    /* @__PURE__ */
    React.createElement(Select, _extends({
      ref: ref
    }, selectProps))
  );
});
var AsyncSelect$1 = AsyncSelect;

var Sportal365ImagesSearch = function Sportal365ImagesSearch(_ref627) {
  var labels = _ref627.labels,
      query = _ref627.query,
      setQuery = _ref627.setQuery,
      setFilters = _ref627.setFilters;

  var _useState29 = useState(false),
      _useState30 = _slicedToArray3(_useState29, 2),
      showFilters = _useState30[0],
      setShowFilters = _useState30[1];

  var _useState31 = useState(null),
      _useState32 = _slicedToArray3(_useState31, 2),
      options2 = _useState32[0],
      setOptions = _useState32[1];

  var toggleShowFilters = function toggleShowFilters() {
    return setShowFilters(!showFilters);
  };

  var handleOnChange = function handleOnChange(selectedOption) {
    setOptions(selectedOption);
    setQuery((selectedOption == null ? void 0 : selectedOption.value) || "");
  };

  var initOptions = function initOptions(inputValue, callback) {
    if (inputValue) {
      callback([{
        id: inputValue,
        value: inputValue,
        label: inputValue
      }]);
    }
  };

  var loadOptions = debounce_1(initOptions, 300);
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "search image",
        className: titleManageGameStyle,
        children: labels.searchImage
      }),
      /* @__PURE__ */
      jsx$1(AsyncSelect$1, {
        components: {
          DropdownIndicator: null
        },
        loadOptions: loadOptions,
        isClearable: true,
        styles: selectStyles,
        getOptionValue: function getOptionValue(option) {
          return option.id;
        },
        onChange: handleOnChange,
        value: options2,
        placeholder: "",
        className: "topxw-mb-1"
      }),
      /* @__PURE__ */
      jsx$1("a", {
        className: "topxw-flex topxw-justify-end topxw-underline topxw-text-blue-600 hover:topxw-text-blue-800 visited:topxw-text-purple-600 topxw-cursor-pointer topxw-mb-4",
        onClick: toggleShowFilters,
        children: showFilters ? labels.hideFilters : labels.showFilters
      }), showFilters ?
      /* @__PURE__ */
      jsx$1(Sportal365ImagesFromToFilter, {
        labels: labels,
        setFilters: setFilters
      }) :
      /* @__PURE__ */
      jsx$1(Fragment, {})]
    })
  );
};

var Sportal365ImagesPagination = function Sportal365ImagesPagination(props) {
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-flex topxw-items-baseline topxw-flex-wrap",
      children:
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex",
        children: [props.pageCount && props.pageCount !== 1 &&
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-text-base topxw-rounded-r-none focus:topxw-outline-none topxw-flex topxw-justify-center topxw-px-4 topxw-py-2 topxw-rounded topxw-font-bold topxw-cursor-pointer hover:topxw-bg-gray-200 topxw-bg-gray-100 topxw-text-gray-700 topxw-border topxw-duration-200 topxw-ease-in-out topxw-border-gray-300 topxw-transition",
          onClick: props.getPreviousPage,
          children:
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-leading-5 topxw-text-xs topxw-items-center",
            children: [
            /* @__PURE__ */
            jsx$1("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "topxw-feather topxw-feather-chevron-left topxw-w-4 topxw-h-4",
              children:
              /* @__PURE__ */
              jsx$1("polyline", {
                points: "15 18 9 12 15 6"
              })
            }), props.labels.previous]
          })
        }), props.images && props.images.data.length === 20 &&
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-text-base ".concat(props.pageCount !== 1 ? "topxw-text-xs topxw-rounded-l-none topxw-border-l-0" : "", " focus:topxw-outline-none topxw-flex topxw-justify-center topxw-px-4 topxw-py-2 topxw-rounded topxw-font-bold topxw-cursor-pointer hover:topxw-bg-gray-200 topxw-bg-gray-100 topxw-text-gray-700 topxw-border topxw-duration-200 topxw-ease-in-out topxw-border-gray-300 topxw-transition"),
          onClick: props.getNextPage,
          children:
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-text-xs topxw-flex topxw-leading-5 topxw-items-center",
            children: [props.labels.next,
            /* @__PURE__ */
            jsx$1("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "topxw-feather topxw-feather-chevron-right topxw-w-4 topxw-h-4 topxw-ml-1",
              children:
              /* @__PURE__ */
              jsx$1("polyline", {
                points: "9 18 15 12 9 6"
              })
            })]
          })
        })]
      })
    })
  );
};

var sportal365ImagesSearchURL = "https://content.api.sportal365.com/v2/images/search?";
var componentId = "sportal365-images-search";

var sportal365ApiRequestHeaders = function sportal365ApiRequestHeaders(config) {
  return {
    project: config.project,
    Authorization: config.authorization
  };
};

var Sportal365Images = function Sportal365Images(_ref628) {
  var labels = _ref628.labels,
      sportal365Config = _ref628.sportal365Config,
      onChangeImages = _ref628.onChangeImages,
      toggleShowImagesContainer = _ref628.toggleShowImagesContainer;

  var _useState33 = useState(null),
      _useState34 = _slicedToArray3(_useState33, 2),
      images = _useState34[0],
      setImages = _useState34[1];

  var _useState35 = useState(""),
      _useState36 = _slicedToArray3(_useState35, 2),
      query = _useState36[0],
      setQuery = _useState36[1];

  var _useState37 = useState(1),
      _useState38 = _slicedToArray3(_useState37, 2),
      page = _useState38[0],
      setPage = _useState38[1];

  var _useState39 = useState(null),
      _useState40 = _slicedToArray3(_useState39, 2),
      filters = _useState40[0],
      setFilters = _useState40[1];

  var _useState41 = useState(false),
      _useState42 = _slicedToArray3(_useState41, 2),
      isLoading = _useState42[0],
      setIsLoading = _useState42[1];

  var componentDidMount = useRef(false);
  var headers = sportal365ApiRequestHeaders(sportal365Config);
  useEffect(function () {
    if (componentDidMount.current) {
      fetchImages();
    } else {
      componentDidMount.current = true;
    }

    return function () {
      return setImages(null);
    };
  }, [filters, query, page]);

  var fetchImages =
  /*#__PURE__*/
  function () {
    var _ref629 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee634() {
      var queryParams, response, data2;
      return _regeneratorRuntime.wrap(function _callee634$(_context635) {
        while (1) {
          switch (_context635.prev = _context635.next) {
            case 0:
              if (!query) {
                _context635.next = 14;
                break;
              }

              setIsLoading(true);
              queryParams = {
                query: query,
                page: page.toString()
              };

              if (filters) {
                queryParams = _objectSpread3({}, queryParams, {
                  from: filters.from,
                  to: filters.to
                });
              }

              _context635.next = 6;
              return fetch(sportal365ImagesSearchURL + new URLSearchParams(queryParams), {
                headers: headers
              });

            case 6:
              response = _context635.sent;
              _context635.next = 9;
              return response.json();

            case 9:
              data2 = _context635.sent;

              if (response.ok) {
                setImages(data2);
              } else {
                console.error(data2);
                toast.error(labels.searchSportal365ImagesErrorMessage);
              }

              setIsLoading(false);
              _context635.next = 15;
              break;

            case 14:
              setImages(null);

            case 15:
            case "end":
              return _context635.stop();
          }
        }
      }, _callee634);
    }));

    return function fetchImages() {
      return _ref629.apply(this, arguments);
    };
  }();

  var getPreviousPage = function getPreviousPage() {
    setPage(function (prevState) {
      return prevState - 1;
    });
    scrollToComponent(componentId);
  };

  var getNextPage = function getNextPage() {
    setPage(function (prevState) {
      return prevState + 1;
    });
    scrollToComponent(componentId);
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      id: componentId,
      className: "topxw-p-2 topxw-border topxw-border-gray-200 topxw-rounded topxw-bg-gray-100",
      children: [
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-flex topxw-justify-end",
        children:
        /* @__PURE__ */
        jsx$1("button", {
          onClick: toggleShowImagesContainer,
          children:
          /* @__PURE__ */
          jsx$1("img", {
            src: assetsPlaceholder.upArrow,
            alt: "up-arrow",
            className: "topxw-w-4 topxw-h-4"
          })
        })
      }),
      /* @__PURE__ */
      jsx$1(Sportal365ImagesSearch, {
        labels: labels,
        query: query,
        setQuery: setQuery,
        setFilters: setFilters
      }), images ?
      /* @__PURE__ */
      jsxs(Fragment, {
        children: [
        /* @__PURE__ */
        jsx$1("div", {
          className: "topxw-p-8 topxw-grid md:topxw-grid-cols-7 sm:topxw-grid-cols-4 topxw-grid-cols-3 topxw-gap-4",
          children: images.data.map(function (image) {
            var _a2, _b;

            return (
              /* @__PURE__ */
              jsx$1("button", {
                onClick: function onClick() {
                  var _a3, _b2;

                  return onChangeImages((_b2 = (_a3 = image.urls) == null ? void 0 : _a3.uploaded) == null ? void 0 : _b2.embed);
                },
                children:
                /* @__PURE__ */
                jsx$1("img", {
                  src: (_b = (_a2 = image.urls) == null ? void 0 : _a2.uploaded) == null ? void 0 : _b.thumbnail,
                  alt: "sportal365-resource",
                  className: "topxw-w-full topxw-cursor-pointer"
                })
              }, image.id)
            );
          })
        }),
        /* @__PURE__ */
        jsx$1(Sportal365ImagesPagination, {
          pageCount: images == null ? void 0 : images.meta.pagination.current_page,
          images: images,
          labels: labels,
          getPreviousPage: getPreviousPage,
          getNextPage: getNextPage
        })]
      }) :
      /* @__PURE__ */
      jsx$1(Fragment, {}), images && images.data.length === 0 ?
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-center topxw-font-bold topxw-mb-4",
        children: labels.noImagesFound
      }) :
      /* @__PURE__ */
      jsx$1(Fragment, {}), isLoading ?
      /* @__PURE__ */
      jsx$1(Spinner, {
        forNextMatches: false
      }) :
      /* @__PURE__ */
      jsx$1(Fragment, {})]
    })
  );
};

var GameInformation = function GameInformation(_ref630) {
  var httpsService = _ref630.httpsService,
      labels = _ref630.labels,
      title = _ref630.title,
      placeholder = _ref630.placeholder,
      onChange2 = _ref630.onChange,
      _onChangeImages = _ref630.onChangeImages,
      value = _ref630.value,
      imageCase = _ref630.imageCase,
      sportal365Config = _ref630.sportal365Config;

  var _useState43 = useState(false),
      _useState44 = _slicedToArray3(_useState43, 2),
      showImagesContainer = _useState44[0],
      setShowImagesContainer = _useState44[1];

  var toggleShowImagesContainer = function toggleShowImagesContainer() {
    return setShowImagesContainer(!showImagesContainer);
  };

  var onChangeInputImages = function onChangeInputImages(event) {
    event.persist();

    _onChangeImages(event.target.value, imageCase);
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: title,
        className: "".concat(imageCase ? "topxw-text-xs topxw-font-medium topxw-block topxw-mb-1 topxw-uppercase" : titleManageGameStyle),
        children: title
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-items-center ".concat(showImagesContainer ? "topxw-mb-1" : ""),
        children: [
        /* @__PURE__ */
        jsx$1("input", {
          onChange: function onChange(event) {
            return imageCase ? onChangeInputImages(event) : onChange2(event);
          },
          value: value || "",
          type: "text",
          id: title,
          className: inputStyle$1 + " topxw-mr-1",
          placeholder: placeholder
        }), imageCase ?
        /* @__PURE__ */
        jsx$1(FileUploader, {
          httpsService: httpsService,
          labels: labels,
          imageNode: imageCase,
          onChangeImages: _onChangeImages
        }) :
        /* @__PURE__ */
        jsx$1(Fragment, {}), imageCase && sportal365Config ?
        /* @__PURE__ */
        jsx$1(Sportal365Button, {
          toggleShowImagesContainer: toggleShowImagesContainer
        }) :
        /* @__PURE__ */
        jsx$1(Fragment, {})]
      }), showImagesContainer ?
      /* @__PURE__ */
      jsx$1(Sportal365Images, {
        labels: labels,
        sportal365Config: sportal365Config,
        onChangeImages: function onChangeImages(url) {
          return _onChangeImages(url, imageCase);
        },
        toggleShowImagesContainer: toggleShowImagesContainer
      }) :
      /* @__PURE__ */
      jsx$1(Fragment, {})]
    })
  );
};

var GameStatus = function GameStatus(_ref631) {
  var onChange2 = _ref631.onChange,
      labelGameStatus = _ref631.labelGameStatus,
      labelCreateGameStatusDescription = _ref631.labelCreateGameStatusDescription,
      labelEditGameStatusDescription = _ref631.labelEditGameStatusDescription,
      editMode = _ref631.editMode,
      gameStatus = _ref631.gameStatus;
  var isGameLiveOrFinished = gameStatus !== "PENDING" && gameStatus !== "OPEN";
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "gameStatus",
        className: titleManageGameStyle,
        children: labelGameStatus
      }),
      /* @__PURE__ */
      jsxs("select", {
        "data-testid": "game status select option",
        id: "gameStatus",
        className: "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-full focus:topxw-outline-none topxw-px-3 topxw-py-2 topxw-mb-1",
        onChange: onChange2,
        defaultValue: gameStatus,
        disabled: isGameLiveOrFinished ? true : false,
        children: [gameStatus === "PENDING" ?
        /* @__PURE__ */
        jsx$1("option", {
          value: "PENDING",
          children: "PENDING"
        }) : null,
        /* @__PURE__ */
        jsx$1("option", {
          value: "OPEN",
          children: "OPEN"
        }), editMode ?
        /* @__PURE__ */
        jsx$1("option", {
          value: "CANCELED",
          children: "CANCELED"
        }) : null, isGameLiveOrFinished ?
        /* @__PURE__ */
        jsx$1("option", {
          value: gameStatus,
          children: gameStatus
        }) : null]
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs",
        children: editMode ? labelEditGameStatusDescription : labelCreateGameStatusDescription
      })]
    })
  );
};

var nativeCeil = Math.ceil,
    nativeMax = Math.max;

function baseRange$1(start2, end2, step, fromRight) {
  var index2 = -1,
      length2 = nativeMax(nativeCeil((end2 - start2) / (step || 1)), 0),
      result = Array(length2);

  while (length2--) {
    result[fromRight ? length2 : ++index2] = start2;
    start2 += step;
  }

  return result;
}

var _baseRange = baseRange$1;

function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq$3;
var baseGetTag$3 = _baseGetTag,
    isObject$2 = isObject_1;
var asyncTag = "[object AsyncFunction]",
    funcTag$1 = "[object Function]",
    genTag = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction$2(value) {
  if (!isObject$2(value)) {
    return false;
  }

  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;
var MAX_SAFE_INTEGER$1 = 9007199254740991;

function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$2;
var isFunction$1 = isFunction_1,
    isLength$1 = isLength_1;

function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$2;
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;

function isIndex$2(value, length2) {
  var type = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
  return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length2;
}

var _isIndex = isIndex$2;
var eq$2 = eq_1,
    isArrayLike$1 = isArrayLike_1,
    isIndex$1 = _isIndex,
    isObject$1 = isObject_1;

function isIterateeCall$1(value, index2, object) {
  if (!isObject$1(object)) {
    return false;
  }

  var type = typeof index2;

  if (type == "number" ? isArrayLike$1(object) && isIndex$1(index2, object.length) : type == "string" && index2 in object) {
    return eq$2(object[index2], value);
  }

  return false;
}

var _isIterateeCall = isIterateeCall$1;
var toNumber = toNumber_1;
var INFINITY = 1 / 0,
    MAX_INTEGER = 17976931348623157e292;

function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;
var baseRange = _baseRange,
    isIterateeCall = _isIterateeCall,
    toFinite = toFinite_1;

function createRange$1(fromRight) {
  return function (start2, end2, step) {
    if (step && typeof step != "number" && isIterateeCall(start2, end2, step)) {
      end2 = step = void 0;
    }

    start2 = toFinite(start2);

    if (end2 === void 0) {
      end2 = start2;
      start2 = 0;
    } else {
      end2 = toFinite(end2);
    }

    step = step === void 0 ? start2 < end2 ? 1 : -1 : toFinite(step);
    return baseRange(start2, end2, step, fromRight);
  };
}

var _createRange = createRange$1;
var createRange = _createRange;
var range = createRange();
var range_1 = range;

var BaseOption = function BaseOption() {
  _classCallCheck3(this, BaseOption);

  this.id = "";
  this.value = "";
  this.label = "";
};

var Option2 =
/*#__PURE__*/
function (_BaseOption) {
  _inherits3(Option2, _BaseOption);

  function Option2() {
    var _this191;

    _classCallCheck3(this, Option2);

    _this191 = _possibleConstructorReturn3(this, _getPrototypeOf4(Option2).apply(this, arguments));
    _this191.logo = null;
    return _this191;
  }

  return Option2;
}(BaseOption);

var Match = function Match(_ref632) {
  var match2 = _ref632.match,
      index2 = _ref632.index,
      groupRadio = _ref632.groupRadio,
      matchIds = _ref632.matchIds,
      setMatchId = _ref632.setMatchId,
      objKickoffMatches = _ref632.objKickoffMatches,
      setObjKickoffMatches = _ref632.setObjKickoffMatches,
      labelTimeFormat = _ref632.labelTimeFormat,
      loadedFixture = _ref632.loadedFixture,
      loadedFixtures = _ref632.loadedFixtures,
      setLoadedFixtures = _ref632.setLoadedFixtures;
  var matchRef = useRef();

  var isClicked = function isClicked() {
    var id = matchRef.current.id;
    var name2 = matchRef.current.dataset.name;
    setMatchId(_objectSpread3({}, matchIds, _defineProperty3({}, name2, id)));
    setObjKickoffMatches(_objectSpread3({}, objKickoffMatches, _defineProperty3({}, name2, match2.kickoffAt)));

    if (loadedFixture) {
      var copyLoadedFixtures = JSON.parse(JSON.stringify(loadedFixtures));
      var newFixtures = copyLoadedFixtures.map(function (fixture) {
        if (fixture.id === loadedFixture.id) {
          fixture.matchId = id;
          fixture.matchModel = match2;
          return fixture;
        }

        return fixture;
      });
      setLoadedFixtures(newFixtures);
    }
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mt-3 topxw-flex topxw-items-center topxw-cursor-pointer",
      onClick: isClicked,
      id: match2.id,
      "data-name": groupRadio,
      ref: matchRef,
      children: [
      /* @__PURE__ */
      jsx$1("input", {
        id: match2.id,
        type: "radio",
        name: groupRadio,
        className: "topxw-h-5 topxw-w-5 topxw-text-gray-600 topxw-cursor-pointer",
        value: match2.id,
        checked: matchIds && matchIds[groupRadio] && matchIds[groupRadio] === match2.id,
        "data-testid": "radio match button",
        readOnly: true
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-flex-row topxw-mx-2 topxw-text-sm",
        "data-testid": "match date",
        children: [
        /* @__PURE__ */
        jsxs("span", {
          className: "topxw-py-1 topxw-mr-1",
          children: ["[", dayjs(match2.kickoffAt).format(labelTimeFormat), "]"]
        }),
        /* @__PURE__ */
        jsx$1(MatchName, {
          homeTeamName: match2.homeTeam.name,
          awayTeamName: match2.awayTeam.name,
          homeTeamAssets: match2.homeTeam.assets,
          awayTeamAssets: match2.awayTeam.assets
        })]
      })]
    }, index2)
  );
};

var LoadMoreButton = function LoadMoreButton(_ref633) {
  var label = _ref633.label,
      onClick = _ref633.onClick;
  return (
    /* @__PURE__ */
    jsx$1("button", {
      onClick: onClick,
      className: "topxw-rounded topxw-bg-gray-700 topxw-text-white hover:topxw-bg-gray-800 topxw-uppercase topxw-text-xs topxw-font-bold topxw-py-2 topxw-px-3",
      children: label
    })
  );
};

var scrollableNextMatchesContainerStyling = "topxw-flex topxw-flex-col topxw-h-56 topxw-overflow-hidden topxw-overflow-y-scroll topxw-mb-2 topxw-p-2 topxw-bg-gray-100 topxw-rounded-bl topxw-rounded-br";

var NextMatches = function NextMatches(_ref634) {
  var groupRadio = _ref634.groupRadio,
      sdk = _ref634.sdk,
      teamId = _ref634.teamId,
      matchIds = _ref634.matchIds,
      setMatchIds = _ref634.setMatchIds,
      objKickoffMatches = _ref634.objKickoffMatches,
      setObjKickoffMatches = _ref634.setObjKickoffMatches,
      loadedFixture = _ref634.loadedFixture,
      index2 = _ref634.index,
      competitionsScope = _ref634.competitionsScope,
      labels = _ref634.labels,
      loadedFixtures = _ref634.loadedFixtures,
      setLoadedFixtures = _ref634.setLoadedFixtures;
  var limitMatches = 5;

  var _useState45 = useState([]),
      _useState46 = _slicedToArray3(_useState45, 2),
      matches = _useState46[0],
      setMatches = _useState46[1];

  var _useState47 = useState([]),
      _useState48 = _slicedToArray3(_useState47, 2),
      allMatches = _useState48[0],
      setAllMatches = _useState48[1];

  var _useState49 = useState(0),
      _useState50 = _slicedToArray3(_useState49, 2),
      limit = _useState50[0],
      setLimit = _useState50[1];

  var _useState51 = useState(false),
      _useState52 = _slicedToArray3(_useState51, 2),
      showMore = _useState52[0],
      setShowMore = _useState52[1];

  var getMatches =
  /*#__PURE__*/
  function () {
    var _ref635 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee635() {
      var minutesFromNow, fifteenMinutesAfterNow, now2, limitFilter, matchesResponse, response, limitMatchesModels;
      return _regeneratorRuntime.wrap(function _callee635$(_context636) {
        while (1) {
          switch (_context636.prev = _context636.next) {
            case 0:
              minutesFromNow = 15;
              fifteenMinutesAfterNow = dayjs().add(minutesFromNow, "minute").toDate();
              now2 = convertDateToGMTIsoString(fifteenMinutesAfterNow);
              limitFilter = 100;
              matchesResponse = null;
              _context636.prev = 5;
              _context636.next = 8;
              return sdk.football.getMatches({
                teamIds: [teamId],
                fromDate: now2,
                limit: limitFilter,
                competitionIds: competitionsScope
              });

            case 8:
              response = _context636.sent;
              matchesResponse = response.data.filter(function (match2) {
                if (match2.status.subType !== "postponed") {
                  return match2;
                }
              });
              _context636.next = 17;
              break;

            case 12:
              _context636.prev = 12;
              _context636.t0 = _context636["catch"](5);
              console.warn(_context636.t0);
              setMatches(null);
              return _context636.abrupt("return");

            case 17:
              if (matchesResponse && matchesResponse.length === 0) setMatches(null);else if (matchesResponse && matchesResponse.length > limitMatches) {
                setAllMatches(matchesResponse);
                limitMatchesModels = matchesResponse.slice(0, limitMatches);
                setLimit(limitMatches);
                setMatches(function (prevState) {
                  return [].concat(_toConsumableArray3(limitMatchesModels), _toConsumableArray3(prevState));
                });
                setShowMore(true);
              } else {
                setShowMore(false);
                setMatches(function (prevState) {
                  return [].concat(_toConsumableArray3(prevState), _toConsumableArray3(matchesResponse));
                });
              }

            case 18:
            case "end":
              return _context636.stop();
          }
        }
      }, _callee635, null, [[5, 12]]);
    }));

    return function getMatches() {
      return _ref635.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (teamId) {
      getMatches();
    }
  }, [teamId]);

  var loadMore = function loadMore() {
    var newLimit = limit + limitMatches;
    var newListMatches = allMatches.slice(limit, newLimit);
    var hasMore = allMatches.length > newLimit;
    setLimit(newLimit);
    setShowMore(hasMore);
    setMatches(function (prevState) {
      return [].concat(_toConsumableArray3(prevState), _toConsumableArray3(newListMatches));
    });
  };

  var isLoadedFixture = loadedFixture ? true : false;
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-w-full",
      children:
      /* @__PURE__ */
      jsxs(React__default.Fragment, {
        children: [matches && matches.length === 0 && loadedFixture && loadedFixture.matchId && loadedFixture.matchModel &&
        /* @__PURE__ */
        jsxs("label", {
          className: "topxw-flex topxw-items-center topxw-my-3 topxw-text-black",
          children: [
          /* @__PURE__ */
          jsx$1("input", {
            "data-testid": "loaded fixture",
            id: loadedFixture.matchId,
            type: "radio",
            name: groupRadio,
            className: "topxw-radio topxw-h-5 topxw-w-5 topxw-text-gray-600",
            value: loadedFixture.matchId,
            readOnly: true,
            checked: isLoadedFixture
          }),
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-flex-row topxw-mx-1 topxw-text-sm",
            "data-testid": "loaded match date",
            children: [
            /* @__PURE__ */
            jsxs("span", {
              className: "topxw-py-1 topxw-mr-1",
              children: ["[", dayjs(loadedFixture.matchModel.kickoffAt).format(labels.timeFormat), "]"]
            }),
            /* @__PURE__ */
            jsx$1(MatchName, {
              homeTeamName: loadedFixture.matchModel.homeTeam.name,
              awayTeamName: loadedFixture.matchModel.awayTeam.name,
              homeTeamAssets: loadedFixture.matchModel.homeTeam.assets,
              awayTeamAssets: loadedFixture.matchModel.awayTeam.assets
            })]
          })]
        }), matches && matches.length > 0 &&
        /* @__PURE__ */
        jsx$1("div", {
          className: scrollableNextMatchesContainerStyling,
          children: matches && matches.length > 0 && matches.map(function (match2, idx) {
            return (
              /* @__PURE__ */
              jsx$1(Match, {
                match: match2,
                index: idx,
                matchIds: matchIds,
                setMatchId: setMatchIds,
                objKickoffMatches: objKickoffMatches,
                setObjKickoffMatches: setObjKickoffMatches,
                groupRadio: groupRadio,
                labelTimeFormat: labels.timeFormat,
                loadedFixture: loadedFixture,
                loadedFixtures: loadedFixtures,
                setLoadedFixtures: setLoadedFixtures
              }, match2.id)
            );
          })
        }),
        /* @__PURE__ */
        jsx$1(React__default.Fragment, {
          children: showMore &&
          /* @__PURE__ */
          jsx$1(LoadMoreButton, {
            label: labels.loadMore,
            onClick: loadMore
          })
        }), !loadedFixture && !matches &&
        /* @__PURE__ */
        jsx$1("h2", {
          className: "topxw-text-center topxw-font-bold",
          children: labels.selectTeamNoMatchesFound
        })]
      })
    }, index2)
  );
};

var RemoveButton = function RemoveButton(_ref636) {
  var removeFixture = _ref636.removeFixture,
      onClick = _ref636.onClick;
  return (
    /* @__PURE__ */
    jsx$1(Tippy, {
      content: removeFixture,
      children:
      /* @__PURE__ */
      jsx$1("button", {
        className: "topxw-btn topxw-btn-square topxw-btn-sm topxw-btn-ghost",
        title: removeFixture,
        onClick: onClick,
        children:
        /* @__PURE__ */
        jsx$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: svgSize(6),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: "2",
          children:
          /* @__PURE__ */
          jsx$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          })
        })
      })
    })
  );
};

var imagesMap =
/* @__PURE__ */
new Map().set("main", "mainImage").set("cover", "coverImage").set("mobile", "mobileImage");
var defaultGameStatus = "PENDING";

var SelectTeam = function SelectTeam(_ref637) {
  var sdk = _ref637.sdk,
      competitionsScope = _ref637.competitionsScope,
      index2 = _ref637.index,
      groupRadio = _ref637.groupRadio,
      title = _ref637.title,
      matchIds = _ref637.matchIds,
      objKickoffMatches = _ref637.objKickoffMatches,
      loadedFixture = _ref637.loadedFixture,
      labels = _ref637.labels,
      setMatchIds = _ref637.setMatchIds,
      loadedFixtures = _ref637.loadedFixtures,
      setLoadedFixtures = _ref637.setLoadedFixtures,
      removeFixture = _ref637.removeFixture,
      setObjKickoffMatches = _ref637.setObjKickoffMatches,
      gameStatus = _ref637.gameStatus;

  var _useState53 = useState(null),
      _useState54 = _slicedToArray3(_useState53, 2),
      options2 = _useState54[0],
      setOptions = _useState54[1];

  var showRemoveFixtureButtonAndAsyncSelectInput = gameStatus === defaultGameStatus;

  var search = function search(inputValue, callback) {
    if (inputValue) {
      sdk.football.search({
        query: inputValue,
        entities: ["teams"],
        scope: competitionsScope
      }).then(function (response) {
        var options22 = response.teams.map(function (team) {
          return formatOptions(team);
        });
        callback(options22);
      });
    }
  };

  var handleOnChange = function handleOnChange(selectedOption) {
    setOptions(selectedOption);
  };

  var loadOptions = debounce_1(search, 300);

  var formatOptions = function formatOptions(team) {
    var _a2;

    var option = new Option2();
    option.label = team.name;
    option.value = team.name;
    option.id = team.id;
    option.logo = (_a2 = team == null ? void 0 : team.assets) == null ? void 0 : _a2.logo;
    return option;
  };

  var renderNextMatches = function renderNextMatches() {
    if (options2 && options2.id) {
      return (
        /* @__PURE__ */
        jsx$1(NextMatches, {
          sdk: sdk,
          index: index2,
          teamId: options2.id,
          matchIds: matchIds,
          setMatchIds: setMatchIds,
          objKickoffMatches: objKickoffMatches,
          setObjKickoffMatches: setObjKickoffMatches,
          groupRadio: groupRadio,
          competitionsScope: competitionsScope,
          labels: labels,
          loadedFixture: loadedFixture,
          loadedFixtures: loadedFixtures,
          setLoadedFixtures: setLoadedFixtures
        }, options2.id)
      );
    }

    if (loadedFixture && loadedFixture.matchModel !== void 0) {
      return (
        /* @__PURE__ */
        jsx$1(NextMatches, {
          sdk: sdk,
          index: index2,
          matchIds: matchIds,
          setMatchIds: setMatchIds,
          objKickoffMatches: objKickoffMatches,
          setObjKickoffMatches: setObjKickoffMatches,
          groupRadio: groupRadio,
          loadedFixture: loadedFixture,
          loadedFixtures: loadedFixtures,
          setLoadedFixtures: setLoadedFixtures,
          competitionsScope: competitionsScope,
          labels: labels
        }, loadedFixture.matchId)
      );
    }
  };

  var onClick = function onClick() {
    if (options2) {
      options2.id = "";
      setOptions(options2);
    }

    removeFixture(index2);
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-overflow-visible topxw-shadow-l topxw-border topxw-border-gray-200",
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-bg-gray-100 topxw-flex topxw-justify-between topxw-px-3 topxw-py-2",
        children: [
        /* @__PURE__ */
        jsx$1("h2", {
          className: "topxw-card-title",
          children: title ? title : "Match number ".concat(index2)
        }), showRemoveFixtureButtonAndAsyncSelectInput ?
        /* @__PURE__ */
        jsx$1(RemoveButton, {
          removeFixture: labels.removeFixture,
          onClick: onClick
        }) : null]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-card-body topxw-px-3 topxw-pt-3 topxw-pb-4",
        "data-testid": "async select",
        children: [showRemoveFixtureButtonAndAsyncSelectInput ?
        /* @__PURE__ */
        jsx$1(AsyncSelect$1, {
          components: {
            DropdownIndicator: null
          },
          styles: selectStyles,
          onChange: handleOnChange,
          noOptionsMessage: function noOptionsMessage() {
            return gameStatus === "PENDING" ? labels.selectTeamNoTeamFound : null;
          },
          loadingMessage: function loadingMessage() {
            return labels.loadingMessage;
          },
          defaultOptions: false,
          loadOptions: loadOptions,
          placeholder: gameStatus === "PENDING" ? labels.selectTeamPlaceholder : null,
          formatOptionLabel: function formatOptionLabel(option) {
            return (
              /* @__PURE__ */
              jsxs("div", {
                className: "topxw-flex flex-justify-start",
                children: [
                /* @__PURE__ */
                jsx$1("img", {
                  src: option.logo ? option.logo : assetsPlaceholder.team,
                  alt: option.label,
                  className: "topxw-h-6 topxw-w-6 topxw-mr-1"
                }),
                /* @__PURE__ */
                jsx$1("span", {
                  children: option.label
                })]
              }, "option-key-".concat(option.id))
            );
          },
          isSearchable: gameStatus === "PENDING" ? true : false
        }) : null, renderNextMatches()]
      })]
    }, index2)
  );
};

var AddButton = function AddButton(_ref638) {
  var addLabel = _ref638.addLabel,
      onClick = _ref638.onClick;
  return (
    /* @__PURE__ */
    jsx$1(Tippy, {
      content: addLabel,
      children:
      /* @__PURE__ */
      jsx$1("button", {
        className: "topxw-place-self-center topxw-bg-transparent",
        onClick: onClick,
        "data-testid": "add",
        children:
        /* @__PURE__ */
        jsx$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: "topxw-h-12 topxw-w-12 topxw-max-h-max",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: "2",
          children:
          /* @__PURE__ */
          jsx$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          })
        })
      })
    })
  );
};

var MatchSelection = function MatchSelection(_ref639) {
  var sdk = _ref639.sdk,
      matchIds = _ref639.matchIds,
      setMatchIds = _ref639.setMatchIds,
      loadedFixtures = _ref639.loadedFixtures,
      setLoadedFixtures = _ref639.setLoadedFixtures,
      objKickoffMatches = _ref639.objKickoffMatches,
      setObjKickoffMatches = _ref639.setObjKickoffMatches,
      editMode = _ref639.editMode,
      minFixtures = _ref639.minFixtures,
      maxFixtures = _ref639.maxFixtures,
      competitionsScope = _ref639.competitionsScope,
      labels = _ref639.labels,
      gameStatus = _ref639.gameStatus;

  var _useState55 = useState([]),
      _useState56 = _slicedToArray3(_useState55, 2),
      fixtures = _useState56[0],
      setFixtures = _useState56[1];

  var _useState57 = useState([]),
      _useState58 = _slicedToArray3(_useState57, 2),
      addButtons = _useState58[0],
      setAddButtons = _useState58[1];

  var showAddButtonsOnCreate = !editMode && maxFixtures > fixtures.length;
  var showAddButtonsOnEdit = editMode && gameStatus === defaultGameStatus;

  var addIdPropToLoadedFixture = function addIdPropToLoadedFixture() {
    var newLoadedFixtures = JSON.parse(JSON.stringify(loadedFixtures));
    newLoadedFixtures.forEach(function (fixture, index2) {
      fixture.id = index2;
    });
    return newLoadedFixtures;
  };

  var declareFixtures = function declareFixtures() {
    var newFixtures = [];

    for (var _i73 = 0; _i73 < maxFixtures; _i73++) {
      var fixture = {};
      fixture.id = _i73;
      newFixtures.push(fixture);
    }

    return newFixtures;
  };

  useEffect(function () {
    if (editMode) {
      setLoadedFixtures(addIdPropToLoadedFixture());
      setAddButtons(range_1(0, maxFixtures - loadedFixtures.length));
    } else {
      setFixtures(declareFixtures());
    }
  }, []);

  var removeFixture = function removeFixture(fixtureId) {
    var newFixtures = [];

    if (editMode && loadedFixtures && loadedFixtures.length >= minFixtures) {
      newFixtures = loadedFixtures.filter(function (fixture) {
        return fixture.id !== fixtureId;
      });
      setLoadedFixtures(newFixtures);
      setAddButtons(range_1(0, maxFixtures - newFixtures.length));
    } else if (!editMode && fixtures.length > minFixtures) {
      newFixtures = fixtures.filter(function (element) {
        return element.id !== fixtureId;
      });
      setFixtures(newFixtures);
      setAddButtons(range_1(0, maxFixtures - newFixtures.length));
    }
  };

  var addFixture = function addFixture() {
    var newFixtures = [];

    if (editMode && loadedFixtures) {
      newFixtures = JSON.parse(JSON.stringify(loadedFixtures));

      if (newFixtures.length > 0) {
        var lastId = newFixtures[newFixtures.length - 1].id;
        newFixtures.push({
          id: lastId + 1
        });
        setLoadedFixtures(newFixtures);
      } else {
        newFixtures.push({
          id: 0
        });
        setLoadedFixtures(newFixtures);
      }
    } else {
      newFixtures = JSON.parse(JSON.stringify(fixtures));
      var _lastId = newFixtures[newFixtures.length - 1].id;
      newFixtures.push({
        id: _lastId + 1
      });
      setFixtures(newFixtures);
    }

    setAddButtons(range_1(0, addButtons.length - 1));
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-2",
        children: [
        /* @__PURE__ */
        jsx$1("label", {
          htmlFor: "title",
          className: titleManageGameStyle,
          children: labels.matchSelection
        }),
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-gray-400 topxw-text-sm",
          children: labels.matchSelectionDescription
        })]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-grid topxw-grid-cols-1 md:topxw-grid-cols-2 topxw-gap-4 topxw-mb-1",
        children: [loadedFixtures && loadedFixtures.length > 0 && loadedFixtures.map(function (fixture, index2) {
          return (
            /* @__PURE__ */
            jsx$1(SelectTeam, {
              competitionsScope: competitionsScope,
              index: index2,
              sdk: sdk,
              title: labels.matchNumber + " ".concat(index2 + 1),
              matchIds: matchIds,
              setMatchIds: setMatchIds,
              objKickoffMatches: objKickoffMatches,
              setObjKickoffMatches: setObjKickoffMatches,
              groupRadio: "match_group_".concat(index2),
              loadedFixture: fixture,
              loadedFixtures: loadedFixtures,
              setLoadedFixtures: setLoadedFixtures,
              removeFixture: removeFixture,
              labels: labels,
              gameStatus: gameStatus
            }, "select-team-key-".concat(fixture.matchId))
          );
        }), fixtures && fixtures.length > 0 && fixtures.map(function (fixture, index2) {
          return (
            /* @__PURE__ */
            jsx$1(SelectTeam, {
              competitionsScope: competitionsScope,
              index: index2,
              sdk: sdk,
              title: labels.matchNumber + " ".concat(index2 + 1),
              matchIds: matchIds,
              objKickoffMatches: objKickoffMatches,
              groupRadio: "match_group_".concat(index2 + 1),
              labels: labels,
              setMatchIds: setMatchIds,
              setObjKickoffMatches: setObjKickoffMatches,
              removeFixture: removeFixture,
              gameStatus: gameStatus
            }, fixture.id)
          );
        }), showAddButtonsOnEdit && addButtons.map(function (_2) {
          return (
            /* @__PURE__ */
            jsx$1(AddButton, {
              addLabel: labels.addFixture,
              onClick: addFixture
            }, "".concat(Math.random()))
          );
        }), showAddButtonsOnCreate && addButtons.map(function (_2) {
          return (
            /* @__PURE__ */
            jsx$1(AddButton, {
              addLabel: labels.addFixture,
              onClick: addFixture
            }, "".concat(Math.random()))
          );
        })]
      })]
    })
  );
};

var calculate75MinutesBeforeEarliestMatch = function calculate75MinutesBeforeEarliestMatch(objKickoffMatches) {
  if (objKickoffMatches) {
    var minutesBeforeEarliestMatch = 75;
    var kickoffMatches = Object.values(objKickoffMatches);
    var dates = kickoffMatches.map(function (kickoff) {
      return dayjs(kickoff).toDate();
    });
    dates.sort(function (a, b2) {
      return a.getTime() - b2.getTime();
    });
    var earliest = dates[0];
    earliest.setMinutes(earliest.getMinutes() - minutesBeforeEarliestMatch);
    return earliest;
  }

  return null;
};

var calculate60MinutesBeforeCutoff = function calculate60MinutesBeforeCutoff(cutoffTime, objKickoffMatches) {
  if (cutoffTime) {
    var minutesBeforeCutoff = 60;
    var scheduleOpenAtMaxDate = dayjs(cutoffTime).toDate();
    scheduleOpenAtMaxDate.setMinutes(scheduleOpenAtMaxDate.getMinutes() - minutesBeforeCutoff);
    return scheduleOpenAtMaxDate;
  }

  return calculate75MinutesBeforeEarliestMatch(objKickoffMatches);
};

var GameScheduleOpenAt = function GameScheduleOpenAt(_ref640) {
  var labels = _ref640.labels,
      editMode = _ref640.editMode,
      schedulerIsFilled = _ref640.schedulerIsFilled,
      value = _ref640.value,
      objKickoffMatches = _ref640.objKickoffMatches,
      loadedKickoffMatches = _ref640.loadedKickoffMatches,
      cutoffTime = _ref640.cutoffTime,
      onChange2 = _ref640.onChange,
      setEditedGame = _ref640.setEditedGame,
      setSchedulerIsFilled = _ref640.setSchedulerIsFilled,
      gameStatus = _ref640.gameStatus;
  var refFlatpickr = useRef(null);
  var tenMinutes = 10;
  var isNotFilled = useMemo(function () {
    if (editMode && value && loadedKickoffMatches) {
      if (dayjs(value).toDate() > calculate75MinutesBeforeEarliestMatch(loadedKickoffMatches)) {
        setEditedGame(function (prevState) {
          return _objectSpread3({}, prevState, {
            scheduleOpenAt: null
          });
        });
        setSchedulerIsFilled(false);
        return true;
      } else {
        return false;
      }
    }

    return !schedulerIsFilled;
  }, [schedulerIsFilled, editMode, value, loadedKickoffMatches]);

  var clearDate = function clearDate() {
    refFlatpickr.current.flatpickr.clear();
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "Schedule open at",
        className: titleManageGameStyle,
        children: labels.scheduleOpenAt
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-flex-row",
        children: [
        /* @__PURE__ */
        jsx$1(Flatpickr, {
          "data-testid": "schedule open at date",
          ref: refFlatpickr,
          "data-enable-time": true,
          options: {
            clickOpens: gameStatus === "PENDING" ? true : false,
            dateFormat: labels.timeFormat,
            altFormat: labels.timeFormat,
            time_24hr: true,
            altInput: true,
            minDate: dayjs().add(tenMinutes, "minute").toDate(),
            maxDate: editMode ? calculate60MinutesBeforeCutoff(cutoffTime, loadedKickoffMatches) : calculate75MinutesBeforeEarliestMatch(objKickoffMatches),
            position: "above",
            altInputClass: "".concat(inputStyle$1),
            parseDate: function parseDate(dateStr, format) {
              return dayjs(dateStr, format).toDate();
            },
            formatDate: function formatDate(date, format) {
              return dayjs(date).format(format);
            }
          },
          onChange: function onChange(date) {
            return onChange2(date, "scheduler_open_at");
          },
          defaultValue: editMode && value ? dayjs(value).toISOString() : null
        }),
        /* @__PURE__ */
        jsx$1(ClearButton, {
          disabled: isNotFilled,
          clear: labels.clear,
          onClick: clearDate
        })]
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs topxw-mt-1",
        children: labels.scheduleOpenAtDescription
      })]
    })
  );
};

var GameTimeTiebreaker = function GameTimeTiebreaker(_ref641) {
  var labels = _ref641.labels,
      defaultValue = _ref641.defaultValue,
      gameStatus = _ref641.gameStatus,
      onChange2 = _ref641.onChange;
  var isGameTimeTiebreakerEditable = gameStatus === "PENDING";
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "gameStatus",
        className: titleManageGameStyle,
        children: labels.timeTiebreaker
      }),
      /* @__PURE__ */
      jsxs("select", {
        "data-testid": "game tiebreaker select option",
        id: "gameStatus",
        className: "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-full focus:topxw-outline-none topxw-px-3 topxw-py-2 topxw-mb-1",
        onChange: onChange2,
        defaultValue: defaultValue ? "enabled" : "disabled",
        disabled: isGameTimeTiebreakerEditable ? false : true,
        children: [
        /* @__PURE__ */
        jsx$1("option", {
          value: "enabled",
          children: labels.enabled
        }),
        /* @__PURE__ */
        jsx$1("option", {
          value: "disabled",
          children: labels.disabled
        })]
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs",
        children: labels.timeTiebreakerDescription
      })]
    })
  );
};

var GameValidator = function GameValidator(game, labels, objMatchIds, minFixtures, objKickoffMatches, loadedFixtures) {
  var _this192 = this;

  _classCallCheck3(this, GameValidator);

  this.gameRequestBody = null;
  this.labels = null;
  this.objMatchIds = null;
  this.minFixtures = null;
  this.objKickoffMatches = null;
  this.loadedFixtures = null;
  this.isValid = true;
  this.message = null;

  this.validate = function (scenario) {
    if (scenario === "create") {
      _this192.validateMinFixtures();

      _this192.validateCutoffTimeOnCreate();

      _this192.validateSameChoosenMatch();

      _this192.validateDynamicFields();
    } else if (scenario === "edit") {
      _this192.validateLoadedFixtures();

      _this192.validatePredictionsCutoffOnEdit();

      _this192.validateCutoffTimeForNewMatchesOnEdit();

      _this192.validateCutoffTimeForLoadedFixtures();

      _this192.validateDynamicFieldsOnEdit();
    }
  };

  this.validateMinFixtures = function () {
    if (!_this192.objMatchIds || _this192.objMatchIds && Object.values(_this192.objMatchIds).length < _this192.minFixtures) {
      _this192.message = "".concat(_this192.labels.minFixturesMessage, " ").concat(_this192.minFixtures);
      _this192.isValid = false;
    }
  };

  this.validateCutoffTimeOnCreate = function () {
    var kickoffMatches = _this192.objKickoffMatches && Object.values(_this192.objKickoffMatches);

    var earliestKickoff = kickoffMatches && _this192.extractEarliestKickoffMatch(kickoffMatches);

    if (_this192.gameRequestBody.predictions_cutoff && dayjs(_this192.gameRequestBody.predictions_cutoff) > dayjs(earliestKickoff)) {
      _this192.message = _this192.labels.invalidCutoffTimeMessage;
      _this192.isValid = false;
    }
  };

  this.validatePredictionsCutoffOnEdit = function () {
    if (!_this192.gameRequestBody.predictionsCutoff) {
      _this192.message = _this192.labels.fillCutoffTimeEditGameMessage;
      _this192.isValid = false;
    }
  };

  this.validateCutoffTimeForNewMatchesOnEdit = function () {
    if (!_this192.objKickoffMatches) return;
    var kickoffMatches = Object.values(_this192.objKickoffMatches);
    var invalidKickOffMatches = kickoffMatches.filter(function (kickoff) {
      if (dayjs(_this192.gameRequestBody.predictionsCutoff).toDate() > dayjs(kickoff).toDate()) {
        return kickoff;
      }
    });

    if (invalidKickOffMatches.length > 0) {
      _this192.message = _this192.labels.invalidCutoffTimeMessage;
      _this192.isValid = false;
    }
  };

  this.validateCutoffTimeForLoadedFixtures = function () {
    if (_this192.loadedFixtures.length >= _this192.minFixtures) {
      if (dayjs(_this192.gameRequestBody.predictionsCutoff) > dayjs(extractEarliestKickoffTime(_this192.loadedFixtures))) {
        _this192.message = _this192.labels.invalidCutoffTimeMessage;
        _this192.isValid = false;
      }
    } else {
      _this192.message = _this192.labels.minFixturesMessage;
      _this192.isValid = false;
    }
  };

  this.validateSameChoosenMatch = function () {
    var matchIds = _this192.objMatchIds && Object.values(_this192.objMatchIds);
    var newMatchIdsSet = new Set(matchIds);

    if (matchIds && matchIds.length !== newMatchIdsSet.size) {
      _this192.message = _this192.labels.sameChosenMatchMessage;
      _this192.isValid = false;
    }
  };

  this.validateLoadedFixtures = function () {
    var matchIds = [];

    _this192.loadedFixtures.forEach(function (fixture) {
      if (fixture.matchId) {
        return matchIds.push(fixture.matchId);
      }
    });

    if (matchIds.length) {
      var newMatchIdsSet = new Set(matchIds);

      if (matchIds.length !== newMatchIdsSet.size) {
        _this192.message = _this192.labels.sameChosenMatchMessage;
        _this192.isValid = false;
      }
    } else {
      _this192.message = _this192.labels.minFixturesMessage;
      _this192.isValid = false;
    }

    return false;
  };

  this.extractEarliestKickoffMatch = function (kickoffMatches) {
    var sortedKickoffTimes = kickoffMatches.sort(function (a, b2) {
      return a.localeCompare(b2);
    });
    return sortedKickoffTimes[0];
  };

  this.validateDynamicFields = function () {
    if (_this192.gameRequestBody.labels) {
      _this192.validateKeysInObject(_this192.gameRequestBody.labels);
    }

    if (_this192.gameRequestBody.custom_fields) {
      _this192.validateKeysInObject(_this192.gameRequestBody.custom_fields);
    }
  };

  this.validateDynamicFieldsOnEdit = function () {
    if (_this192.gameRequestBody.labels) {
      _this192.validateKeysInObject(_this192.gameRequestBody.labels);
    }

    if (_this192.gameRequestBody.customFields) {
      _this192.validateKeysInObject(_this192.gameRequestBody.customFields);
    }
  };

  this.validateKeysInObject = function (object) {
    var regexValidKey = /^[a-z0-9_]+$/;
    var keysAreValid = Object.keys(object).some(function (key) {
      return regexValidKey.test(key);
    });

    if (!keysAreValid) {
      _this192.isValid = keysAreValid;
      _this192.message = _this192.labels.dynamicFieldsKeysValidationMessage;
    }
  };

  this.gameRequestBody = game;
  this.labels = labels;
  this.objMatchIds = objMatchIds;
  this.minFixtures = minFixtures;
  this.objKickoffMatches = objKickoffMatches;
  this.loadedFixtures = loadedFixtures;
};

var MarketSelect = function MarketSelect(props) {
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: "gameMarket",
        className: titleManageGameStyle,
        children: props.labels.gameMarket
      }),
      /* @__PURE__ */
      jsxs("select", {
        "data-testid": "game market select option",
        id: "gameStatus",
        className: "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-full focus:topxw-outline-none topxw-px-3 topxw-py-2 topxw-mb-1",
        onChange: props.onChange,
        defaultValue: props.gameMarket,
        disabled: props.gameStatus === "PENDING" ? false : true,
        children: [
        /* @__PURE__ */
        jsxs("option", {
          value: "CORRECT_SCORE",
          children: [props.labels.marketCorrectScore, " (CORRECT_SCORE)"]
        }),
        /* @__PURE__ */
        jsxs("option", {
          value: "CORRECT_SCORE_ADVANCED",
          children: [props.labels.marketCorrectScoreAdvanced, " (CORRECT_SCORE_ADVANCED)"]
        })]
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs",
        children: props.labels.gameMarketDescription
      })]
    })
  );
};

var StateManagedSelect =
/* @__PURE__ */
forwardRef$1(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return (
    /* @__PURE__ */
    React.createElement(Select, _extends({
      ref: ref
    }, baseSelectProps))
  );
});
var StateManagedSelect$1 = StateManagedSelect;

var createEntityOption = function createEntityOption(id, name2, type) {
  var value = "";

  if (type && name2) {
    value = "".concat(name2, " (").concat(type, ")");
  } else if (!type && name2) {
    value = name2;
  } else if (type && !name2) {
    value = "Game with no title (".concat(type, ")");
  } else {
    value = "Template with no title";
  }

  return {
    id: id,
    label: value,
    value: value
  };
};

var createLoadedEntityOptions = function createLoadedEntityOptions(entities, loadedRelated) {
  if (!entities || !loadedRelated) return null;
  return entities.filter(function (entity) {
    return loadedRelated.some(function (related) {
      return related.entity_id === entity.id;
    });
  });
};

var EntitySelect = function EntitySelect(props) {
  var _useState59 = useState([]),
      _useState60 = _slicedToArray3(_useState59, 2),
      entities = _useState60[0],
      setEntities = _useState60[1];

  var value = createLoadedEntityOptions(entities, props.loadedRelated);

  var getEntities =
  /*#__PURE__*/
  function () {
    var _ref642 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee636() {
      var topXGames, matchQuizGames, allGames, templates;
      return _regeneratorRuntime.wrap(function _callee636$(_context637) {
        while (1) {
          switch (_context637.prev = _context637.next) {
            case 0:
              _context637.prev = 0;

              if (!(props.entityType === "GAME")) {
                _context637.next = 12;
                break;
              }

              _context637.next = 4;
              return props.sdk.topX.getGames();

            case 4:
              topXGames = _context637.sent;
              _context637.next = 7;
              return props.sdk.matchQuiz.getGames();

            case 7:
              matchQuizGames = _context637.sent;
              allGames = [].concat(_toConsumableArray3(topXGames.data), _toConsumableArray3(matchQuizGames.data));
              setEntities(allGames.map(function (game) {
                return createEntityOption(game.id, game.title, game.type);
              }));
              _context637.next = 17;
              break;

            case 12:
              if (!(props.entityType === "TEMPLATE")) {
                _context637.next = 17;
                break;
              }

              _context637.next = 15;
              return props.sdk.loyalty.getTemplates();

            case 15:
              templates = _context637.sent;
              setEntities(templates.data.map(function (template) {
                return createEntityOption(template.id, template.name);
              }));

            case 17:
              _context637.next = 23;
              break;

            case 19:
              _context637.prev = 19;
              _context637.t0 = _context637["catch"](0);
              console.error(_context637.t0);
              toast.error(props.labels.relatedEntitiesErrorMessage);

            case 23:
            case "end":
              return _context637.stop();
          }
        }
      }, _callee636, null, [[0, 19]]);
    }));

    return function getEntities() {
      return _ref642.apply(this, arguments);
    };
  }();

  var handleOnChange = function handleOnChange(selectedOption) {
    var entityIds = selectedOption.map(function (option) {
      return option.id;
    });
    props.onChange(entityIds, props.entityType);
  };

  useEffect(function () {
    getEntities();
  }, []);
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: props.entityType,
        className: "topxw-text-xs topxw-font-medium topxw-block topxw-mb-1 topxw-uppercase",
        children: props.entityType === "GAME" ? props.labels.games : props.labels.templates
      }),
      /* @__PURE__ */
      jsx$1(StateManagedSelect$1, {
        isMulti: true,
        isClearable: true,
        styles: selectStyles,
        getOptionValue: function getOptionValue(option) {
          return option.id;
        },
        onChange: handleOnChange,
        options: entities,
        value: value,
        placeholder: props.entityType === "GAME" ? props.labels.gamesPlaceholder : props.labels.templatesPlaceholder
      })]
    })
  );
};

var GameRelated = function GameRelated(props) {
  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsxs("div", {
        children: [
        /* @__PURE__ */
        jsx$1("label", {
          className: titleManageGameStyle,
          children: props.labels.related
        }),
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-gray-400 topxw-text-sm",
          children: props.labels.relatedDescription
        })]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-border topxw-border-gray-200 topxw-rounded topxw-p-2 topxw-mb-4",
        children: [
        /* @__PURE__ */
        jsx$1(EntitySelect, {
          entityType: "GAME",
          labels: props.labels,
          sdk: props.sdk,
          loadedRelated: props.loadedEntities,
          onChange: props.onChange
        }),
        /* @__PURE__ */
        jsx$1(EntitySelect, {
          entityType: "TEMPLATE",
          labels: props.labels,
          sdk: props.sdk,
          loadedRelated: props.loadedEntities,
          onChange: props.onChange
        })]
      })]
    })
  );
};

var createIndexing = function createIndexing(field) {
  return Object.keys(field).length++;
};

var GameDynamicFields = function GameDynamicFields(_ref643) {
  var labels = _ref643.labels,
      dynamicField = _ref643.dynamicField,
      field = _ref643.field,
      onChange2 = _ref643.onChange;

  var _useState61 = useState(JSON.parse(JSON.stringify(field))),
      _useState62 = _slicedToArray3(_useState61, 2),
      copyDynamicField = _useState62[0],
      setCopyDynamicFiled = _useState62[1];

  var index2 = createIndexing(field);

  var addField = function addField() {
    var newKey = "new_key" + index2;
    var copyDynamicField2 = JSON.parse(JSON.stringify(field));
    copyDynamicField2[newKey] = "";

    var newObject = _objectSpread3({}, field, {}, copyDynamicField2);

    setCopyDynamicFiled(newObject);
    onChange2(newObject);
  };

  var handleOnChangeKey = function handleOnChangeKey(index22, event) {
    event.persist();
    var newKey = event.target.value;
    var copyObject = JSON.parse(JSON.stringify(field));
    var oldKey = Object.keys(copyObject)[index22];
    copyObject[newKey] = copyObject[oldKey];
    delete copyObject[oldKey];
    onChange2(copyObject);
  };

  var handleOnChangeValue = function handleOnChangeValue(index22, event) {
    event.persist();
    var value = event.target.value;
    var copyObject = JSON.parse(JSON.stringify(field));
    var key = Object.keys(copyObject)[index22] ? Object.keys(copyObject)[index22] : "new_key";
    copyObject[key] = value;
    onChange2(copyObject);
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-2",
        children: [
        /* @__PURE__ */
        jsx$1("h3", {
          className: titleManageGameStyle,
          children: dynamicField === "labels" ? labels.labelsHeading : labels.customFields
        }),
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-gray-400 topxw-text-sm",
          children: labels.dynamicFieldsDescription
        })]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-border topxw-border-gray-200 topxw-rounded topxw-p-2 topxw-mb-4",
        children: [Object.keys(copyDynamicField).map(function (key, index22) {
          return (
            /* @__PURE__ */
            jsxs("div", {
              className: "topxw-flex topxw-items-center topxw-mb-4",
              children: [
              /* @__PURE__ */
              jsxs("div", {
                className: "topxw-mr-4",
                children: [
                /* @__PURE__ */
                jsx$1("label", {
                  htmlFor: labels.keyDynamicFields,
                  className: "topxw-text-xs topxw-font-medium topxw-block topxw-mb-1 topxw-uppercase",
                  children: labels.keyDynamicFields
                }),
                /* @__PURE__ */
                jsx$1("input", {
                  "data-testid": "dynamic-field-key",
                  onChange: function onChange(event) {
                    return handleOnChangeKey(index22, event);
                  },
                  value: Object.keys(field)[index22] && Object.keys(field)[index22].includes("new_key") ? "" : Object.keys(field)[index22],
                  type: "text",
                  id: "".concat(dynamicField, "-key-").concat(index22),
                  className: "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-64 focus:topxw-outline-none topxw-px-3 topxw-py-2"
                })]
              }),
              /* @__PURE__ */
              jsxs("div", {
                className: "topxw-w-full",
                children: [
                /* @__PURE__ */
                jsx$1("label", {
                  htmlFor: labels.keyDynamicFields,
                  className: "topxw-text-xs topxw-font-medium topxw-block topxw-mb-1 topxw-uppercase",
                  children: labels.valueDynamicFields
                }),
                /* @__PURE__ */
                jsx$1("input", {
                  "data-testid": "dynamic-field-value",
                  onChange: function onChange(event) {
                    return handleOnChangeValue(index22, event);
                  },
                  value: field[key],
                  type: "text",
                  id: "".concat(dynamicField, "-value-").concat(index22),
                  className: "topxw-rounded topxw-border topxw-border-gray-200 topxw-w-full focus:topxw-outline-none topxw-px-3 topxw-py-2"
                })]
              })]
            }, "".concat(dynamicField, "-").concat(key, "-").concat(index22))
          );
        }),
        /* @__PURE__ */
        jsx$1(AddButton, {
          addLabel: labels.addRecord,
          onClick: function onClick() {
            return addField();
          }
        })]
      })]
    })
  );
};

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;
var eq$1 = eq_1;

function assocIndexOf$4(array, key) {
  var length2 = array.length;

  while (length2--) {
    if (eq$1(array[length2][0], key)) {
      return length2;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;

function listCacheDelete$1(key) {
  var data2 = this.__data__,
      index2 = assocIndexOf$3(data2, key);

  if (index2 < 0) {
    return false;
  }

  var lastIndex = data2.length - 1;

  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;

function listCacheGet$1(key) {
  var data2 = this.__data__,
      index2 = assocIndexOf$2(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}

var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;

function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;

function listCacheSet$1(key, value) {
  var data2 = this.__data__,
      index2 = assocIndexOf(data2, key);

  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

function ListCache$4(entries) {
  var index2 = -1,
      length2 = entries == null ? 0 : entries.length;
  this.clear();

  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}

ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;

function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}

var _stackClear = stackClear$1;

function stackDelete$1(key) {
  var data2 = this.__data__,
      result = data2["delete"](key);
  this.size = data2.size;
  return result;
}

var _stackDelete = stackDelete$1;

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();

function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;

function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {}

    try {
      return func + "";
    } catch (e2) {}
  }

  return "";
}

var _toSource = toSource$2;
var isFunction = isFunction_1,
    isMasked = _isMasked,
    isObject = isObject_1,
    toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype,
    objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}

var _getValue = getValue$1;
var baseIsNative = _baseIsNative,
    getValue = _getValue;

function getNative$6(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}

var _getNative = getNative$6;
var getNative$5 = _getNative,
    root$5 = _root;
var Map$4 = getNative$5(root$5, "Map");
var _Map = Map$4;
var getNative$4 = _getNative;
var nativeCreate$4 = getNative$4(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;

function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

function hashGet$1(key) {
  var data2 = this.__data__;

  if (nativeCreate$2) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }

  return hasOwnProperty$6.call(data2, key) ? data2[key] : void 0;
}

var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

function hashHas$1(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$5.call(data2, key);
}

var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";

function hashSet$1(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;
var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

function Hash$1(entries) {
  var index2 = -1,
      length2 = entries == null ? 0 : entries.length;
  this.clear();

  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}

Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}

var _mapCacheClear = mapCacheClear$1;

function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}

var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;

function getMapData$4(map, key) {
  var data2 = map.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}

var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;

function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;

function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;

function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;

function mapCacheSet$1(key, value) {
  var data2 = getMapData(this, key),
      size = data2.size;
  data2.set(key, value);
  this.size += data2.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

function MapCache$2(entries) {
  var index2 = -1,
      length2 = entries == null ? 0 : entries.length;
  this.clear();

  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}

MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype["delete"] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;
var _MapCache = MapCache$2;
var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;

function stackSet$1(key, value) {
  var data2 = this.__data__;

  if (data2 instanceof ListCache$1) {
    var pairs = data2.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data2.size;
      return this;
    }

    data2 = this.__data__ = new MapCache$1(pairs);
  }

  data2.set(key, value);
  this.size = data2.size;
  return this;
}

var _stackSet = stackSet$1;
var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

function Stack$1(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}

Stack$1.prototype.clear = stackClear;
Stack$1.prototype["delete"] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;
var _Stack = Stack$1;
var HASH_UNDEFINED = "__lodash_hash_undefined__";

function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

var _setCacheAdd = setCacheAdd$1;

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

function SetCache$1(values) {
  var index2 = -1,
      length2 = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index2 < length2) {
    this.add(values[index2]);
  }
}

SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;

function arraySome$1(array, predicate) {
  var index2 = -1,
      length2 = array == null ? 0 : array.length;

  while (++index2 < length2) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome$1;

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;
var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$3 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }

  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index2 = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);

  while (++index2 < arrLength) {
    var arrValue = array[index2],
        othValue = other[index2];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }

    if (compared !== void 0) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    }

    if (seen) {
      if (!arraySome(other, function (othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack["delete"](array);
  stack["delete"](other);
  return result;
}

var _equalArrays = equalArrays$2;
var root$4 = _root;
var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;

function mapToArray$1(map) {
  var index2 = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index2] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

function setToArray$1(set) {
  var index2 = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index2] = value;
  });
  return result;
}

var _setToArray = setToArray$1;
var Symbol$1 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$2 = 1,
    COMPARE_UNORDERED_FLAG = 2;
var boolTag$1 = "[object Boolean]",
    dateTag$1 = "[object Date]",
    errorTag$1 = "[object Error]",
    mapTag$2 = "[object Map]",
    numberTag$1 = "[object Number]",
    regexpTag$1 = "[object RegExp]",
    setTag$2 = "[object Set]",
    stringTag$1 = "[object String]",
    symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]",
    dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;

function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }

      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      return object == other + "";

    case mapTag$2:
      var convert = mapToArray;

    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }

      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag$1;

function arrayPush$1(array, values) {
  var index2 = -1,
      length2 = values.length,
      offset2 = array.length;

  while (++index2 < length2) {
    array[offset2 + index2] = values[index2];
  }

  return array;
}

var _arrayPush = arrayPush$1;
var arrayPush = _arrayPush,
    isArray$2 = isArray_1;

function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

function arrayFilter$1(array, predicate) {
  var index2 = -1,
      length2 = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index2 < length2) {
    var value = array[index2];

    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter$1;

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;
var objectProto$6 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;

function baseTimes$1(n2, iteratee) {
  var index2 = -1,
      result = Array(n2);

  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }

  return result;
}

var _baseTimes = baseTimes$1;
var baseGetTag$2 = _baseGetTag,
    isObjectLike$3 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";

function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments,
    isObjectLike$2 = isObjectLike_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments$1 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$2(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$1;
var isBuffer$2 = {
  exports: {}
};

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
  var root2 = _root,
      stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$2, isBuffer$2.exports);

var baseGetTag$1 = _baseGetTag,
    isLength = isLength_1,
    isObjectLike$1 = isObjectLike_1;
var argsTag$1 = "[object Arguments]",
    arrayTag$1 = "[object Array]",
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag = "[object Error]",
    funcTag = "[object Function]",
    mapTag$1 = "[object Map]",
    numberTag = "[object Number]",
    objectTag$2 = "[object Object]",
    regexpTag = "[object RegExp]",
    setTag$1 = "[object Set]",
    stringTag = "[object String]",
    weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]",
    dataViewTag$1 = "[object DataView]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;

function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$1;
var _nodeUtil = {
  exports: {}
};

(function (module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;

  var nodeUtil2 = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;

      if (types) {
        return types;
      }

      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {}
  }();

  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex = _isIndex,
    isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType2 = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType2,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length2 = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length2)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$3 = Object.prototype;

function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto;
}

var _isPrototype = isPrototype$1;

function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys$1;
var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike = isArrayLike_1;

function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$1;
var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys = keys_1;

function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index2 = objLength;

  while (index2--) {
    var key = objProps[index2];

    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }

  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }

    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == "constructor");
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack["delete"](object);
  stack["delete"](other);
  return result;
}

var _equalObjects = equalObjects$1;
var getNative$3 = _getNative,
    root$3 = _root;
var DataView$1 = getNative$3(root$3, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative,
    root$2 = _root;
var Promise$2 = getNative$2(root$2, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative,
    root$1 = _root;
var Set$2 = getNative$1(root$1, "Set");
var _Set = Set$2;
var getNative = _getNative,
    root = _root;
var WeakMap$2 = getNative(root, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag = _baseGetTag,
    toSource = _toSource;
var mapTag = "[object Map]",
    objectTag$1 = "[object Object]",
    promiseTag = "[object Promise]",
    setTag = "[object Set]",
    weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;

if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function getTag$1(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : void 0,
        ctorString = Ctor ? toSource(Ctor) : "";

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

var _getTag = getTag$1;
var Stack = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray = isArray_1,
    isBuffer = isBuffer$2.exports,
    isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]",
    arrayTag = "[object Array]",
    objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;

function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;

function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}

var _baseIsEqual = baseIsEqual$1;
var baseIsEqual = _baseIsEqual;

function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1$1 = isEqual;
var quill = {
  exports: {}
};
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */

(function (module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory();
  })(typeof self !== "undefined" ? self : commonjsGlobal, function () {
    return function (modules2) {
      var installedModules = {};

      function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) {
          return installedModules[moduleId].exports;
        }

        var module2 = installedModules[moduleId] = {
          i: moduleId,
          l: false,
          exports: {}
        };
        modules2[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
        module2.l = true;
        return module2.exports;
      }

      __webpack_require__.m = modules2;
      __webpack_require__.c = installedModules;

      __webpack_require__.d = function (exports2, name2, getter) {
        if (!__webpack_require__.o(exports2, name2)) {
          Object.defineProperty(exports2, name2, {
            configurable: false,
            enumerable: true,
            get: getter
          });
        }
      };

      __webpack_require__.n = function (module2) {
        var getter = module2 && module2.__esModule ? function getDefault() {
          return module2["default"];
        } : function getModuleExports() {
          return module2;
        };

        __webpack_require__.d(getter, "a", getter);

        return getter;
      };

      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };

      __webpack_require__.p = "";
      return __webpack_require__(__webpack_require__.s = 109);
    }([function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var container_1 = __webpack_require__(17);

      var format_1 = __webpack_require__(18);

      var leaf_1 = __webpack_require__(19);

      var scroll_1 = __webpack_require__(45);

      var inline_1 = __webpack_require__(46);

      var block_1 = __webpack_require__(47);

      var embed_1 = __webpack_require__(48);

      var text_1 = __webpack_require__(49);

      var attributor_1 = __webpack_require__(12);

      var class_1 = __webpack_require__(32);

      var style_1 = __webpack_require__(33);

      var store_1 = __webpack_require__(31);

      var Registry = __webpack_require__(1);

      var Parchment = {
        Scope: Registry.Scope,
        create: Registry.create,
        find: Registry.find,
        query: Registry.query,
        register: Registry.register,
        Container: container_1.default,
        Format: format_1.default,
        Leaf: leaf_1.default,
        Embed: embed_1.default,
        Scroll: scroll_1.default,
        Block: block_1.default,
        Inline: inline_1.default,
        Text: text_1.default,
        Attributor: {
          Attribute: attributor_1.default,
          Class: class_1.default,
          Style: style_1.default,
          Store: store_1.default
        }
      };
      exports2.default = Parchment;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var ParchmentError = function (_super) {
        __extends2(ParchmentError2, _super);

        function ParchmentError2(message) {
          var _this = this;

          message = "[Parchment] " + message;
          _this = _super.call(this, message) || this;
          _this.message = message;
          _this.name = _this.constructor.name;
          return _this;
        }

        return ParchmentError2;
      }(Error);

      exports2.ParchmentError = ParchmentError;
      var attributes = {};
      var classes = {};
      var tags = {};
      var types = {};
      exports2.DATA_KEY = "__blot";
      var Scope;

      (function (Scope2) {
        Scope2[Scope2["TYPE"] = 3] = "TYPE";
        Scope2[Scope2["LEVEL"] = 12] = "LEVEL";
        Scope2[Scope2["ATTRIBUTE"] = 13] = "ATTRIBUTE";
        Scope2[Scope2["BLOT"] = 14] = "BLOT";
        Scope2[Scope2["INLINE"] = 7] = "INLINE";
        Scope2[Scope2["BLOCK"] = 11] = "BLOCK";
        Scope2[Scope2["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
        Scope2[Scope2["INLINE_BLOT"] = 6] = "INLINE_BLOT";
        Scope2[Scope2["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
        Scope2[Scope2["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
        Scope2[Scope2["ANY"] = 15] = "ANY";
      })(Scope = exports2.Scope || (exports2.Scope = {}));

      function create(input, value) {
        var match2 = query(input);

        if (match2 == null) {
          throw new ParchmentError("Unable to create " + input + " blot");
        }

        var BlotClass = match2;
        var node2 = input instanceof Node || input["nodeType"] === Node.TEXT_NODE ? input : BlotClass.create(value);
        return new BlotClass(node2, value);
      }

      exports2.create = create;

      function find(node2, bubble) {
        if (bubble === void 0) {
          bubble = false;
        }

        if (node2 == null) return null;
        if (node2[exports2.DATA_KEY] != null) return node2[exports2.DATA_KEY].blot;
        if (bubble) return find(node2.parentNode, bubble);
        return null;
      }

      exports2.find = find;

      function query(query2, scope) {
        if (scope === void 0) {
          scope = Scope.ANY;
        }

        var match2;

        if (typeof query2 === "string") {
          match2 = types[query2] || attributes[query2];
        } else if (query2 instanceof Text || query2["nodeType"] === Node.TEXT_NODE) {
          match2 = types["text"];
        } else if (typeof query2 === "number") {
          if (query2 & Scope.LEVEL & Scope.BLOCK) {
            match2 = types["block"];
          } else if (query2 & Scope.LEVEL & Scope.INLINE) {
            match2 = types["inline"];
          }
        } else if (query2 instanceof HTMLElement) {
          var names = (query2.getAttribute("class") || "").split(/\s+/);

          for (var i in names) {
            match2 = classes[names[i]];
            if (match2) break;
          }

          match2 = match2 || tags[query2.tagName];
        }

        if (match2 == null) return null;
        if (scope & Scope.LEVEL & match2.scope && scope & Scope.TYPE & match2.scope) return match2;
        return null;
      }

      exports2.query = query;

      function register() {
        var Definitions = [];

        for (var _i2 = 0; _i2 < arguments.length; _i2++) {
          Definitions[_i2] = arguments[_i2];
        }

        if (Definitions.length > 1) {
          return Definitions.map(function (d2) {
            return register(d2);
          });
        }

        var Definition = Definitions[0];

        if (typeof Definition.blotName !== "string" && typeof Definition.attrName !== "string") {
          throw new ParchmentError("Invalid definition");
        } else if (Definition.blotName === "abstract") {
          throw new ParchmentError("Cannot register abstract class");
        }

        types[Definition.blotName || Definition.attrName] = Definition;

        if (typeof Definition.keyName === "string") {
          attributes[Definition.keyName] = Definition;
        } else {
          if (Definition.className != null) {
            classes[Definition.className] = Definition;
          }

          if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
              Definition.tagName = Definition.tagName.map(function (tagName) {
                return tagName.toUpperCase();
              });
            } else {
              Definition.tagName = Definition.tagName.toUpperCase();
            }

            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
              if (tags[tag] == null || Definition.className == null) {
                tags[tag] = Definition;
              }
            });
          }
        }

        return Definition;
      }

      exports2.register = register;
    }, function (module2, exports2, __webpack_require__) {
      var diff = __webpack_require__(51);

      var equal = __webpack_require__(11);

      var extend2 = __webpack_require__(3);

      var op = __webpack_require__(20);

      var NULL_CHARACTER = String.fromCharCode(0);

      var Delta = function Delta(ops) {
        if (Array.isArray(ops)) {
          this.ops = ops;
        } else if (ops != null && Array.isArray(ops.ops)) {
          this.ops = ops.ops;
        } else {
          this.ops = [];
        }
      };

      Delta.prototype.insert = function (text, attributes) {
        var newOp = {};
        if (text.length === 0) return this;
        newOp.insert = text;

        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }

        return this.push(newOp);
      };

      Delta.prototype["delete"] = function (length2) {
        if (length2 <= 0) return this;
        return this.push({
          "delete": length2
        });
      };

      Delta.prototype.retain = function (length2, attributes) {
        if (length2 <= 0) return this;
        var newOp = {
          retain: length2
        };

        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }

        return this.push(newOp);
      };

      Delta.prototype.push = function (newOp) {
        var index2 = this.ops.length;
        var lastOp = this.ops[index2 - 1];
        newOp = extend2(true, {}, newOp);

        if (typeof lastOp === "object") {
          if (typeof newOp["delete"] === "number" && typeof lastOp["delete"] === "number") {
            this.ops[index2 - 1] = {
              "delete": lastOp["delete"] + newOp["delete"]
            };
            return this;
          }

          if (typeof lastOp["delete"] === "number" && newOp.insert != null) {
            index2 -= 1;
            lastOp = this.ops[index2 - 1];

            if (typeof lastOp !== "object") {
              this.ops.unshift(newOp);
              return this;
            }
          }

          if (equal(newOp.attributes, lastOp.attributes)) {
            if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
              this.ops[index2 - 1] = {
                insert: lastOp.insert + newOp.insert
              };
              if (typeof newOp.attributes === "object") this.ops[index2 - 1].attributes = newOp.attributes;
              return this;
            } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
              this.ops[index2 - 1] = {
                retain: lastOp.retain + newOp.retain
              };
              if (typeof newOp.attributes === "object") this.ops[index2 - 1].attributes = newOp.attributes;
              return this;
            }
          }
        }

        if (index2 === this.ops.length) {
          this.ops.push(newOp);
        } else {
          this.ops.splice(index2, 0, newOp);
        }

        return this;
      };

      Delta.prototype.chop = function () {
        var lastOp = this.ops[this.ops.length - 1];

        if (lastOp && lastOp.retain && !lastOp.attributes) {
          this.ops.pop();
        }

        return this;
      };

      Delta.prototype.filter = function (predicate) {
        return this.ops.filter(predicate);
      };

      Delta.prototype.forEach = function (predicate) {
        this.ops.forEach(predicate);
      };

      Delta.prototype.map = function (predicate) {
        return this.ops.map(predicate);
      };

      Delta.prototype.partition = function (predicate) {
        var passed = [],
            failed = [];
        this.forEach(function (op2) {
          var target = predicate(op2) ? passed : failed;
          target.push(op2);
        });
        return [passed, failed];
      };

      Delta.prototype.reduce = function (predicate, initial) {
        return this.ops.reduce(predicate, initial);
      };

      Delta.prototype.changeLength = function () {
        return this.reduce(function (length2, elem) {
          if (elem.insert) {
            return length2 + op.length(elem);
          } else if (elem.delete) {
            return length2 - elem.delete;
          }

          return length2;
        }, 0);
      };

      Delta.prototype.length = function () {
        return this.reduce(function (length2, elem) {
          return length2 + op.length(elem);
        }, 0);
      };

      Delta.prototype.slice = function (start2, end2) {
        start2 = start2 || 0;
        if (typeof end2 !== "number") end2 = Infinity;
        var ops = [];
        var iter = op.iterator(this.ops);
        var index2 = 0;

        while (index2 < end2 && iter.hasNext()) {
          var nextOp;

          if (index2 < start2) {
            nextOp = iter.next(start2 - index2);
          } else {
            nextOp = iter.next(end2 - index2);
            ops.push(nextOp);
          }

          index2 += op.length(nextOp);
        }

        return new Delta(ops);
      };

      Delta.prototype.compose = function (other) {
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var ops = [];
        var firstOther = otherIter.peek();

        if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
          var firstLeft = firstOther.retain;

          while (thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft) {
            firstLeft -= thisIter.peekLength();
            ops.push(thisIter.next());
          }

          if (firstOther.retain - firstLeft > 0) {
            otherIter.next(firstOther.retain - firstLeft);
          }
        }

        var delta = new Delta(ops);

        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (otherIter.peekType() === "insert") {
            delta.push(otherIter.next());
          } else if (thisIter.peekType() === "delete") {
            delta.push(thisIter.next());
          } else {
            var length2 = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length2);
            var otherOp = otherIter.next(length2);

            if (typeof otherOp.retain === "number") {
              var newOp = {};

              if (typeof thisOp.retain === "number") {
                newOp.retain = length2;
              } else {
                newOp.insert = thisOp.insert;
              }

              var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
              if (attributes) newOp.attributes = attributes;
              delta.push(newOp);

              if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                var rest = new Delta(thisIter.rest());
                return delta.concat(rest).chop();
              }
            } else if (typeof otherOp["delete"] === "number" && typeof thisOp.retain === "number") {
              delta.push(otherOp);
            }
          }
        }

        return delta.chop();
      };

      Delta.prototype.concat = function (other) {
        var delta = new Delta(this.ops.slice());

        if (other.ops.length > 0) {
          delta.push(other.ops[0]);
          delta.ops = delta.ops.concat(other.ops.slice(1));
        }

        return delta;
      };

      Delta.prototype.diff = function (other, index2) {
        if (this.ops === other.ops) {
          return new Delta();
        }

        var strings = [this, other].map(function (delta2) {
          return delta2.map(function (op2) {
            if (op2.insert != null) {
              return typeof op2.insert === "string" ? op2.insert : NULL_CHARACTER;
            }

            var prep = delta2 === other ? "on" : "with";
            throw new Error("diff() called " + prep + " non-document");
          }).join("");
        });
        var delta = new Delta();
        var diffResult = diff(strings[0], strings[1], index2);
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        diffResult.forEach(function (component) {
          var length2 = component[1].length;

          while (length2 > 0) {
            var opLength = 0;

            switch (component[0]) {
              case diff.INSERT:
                opLength = Math.min(otherIter.peekLength(), length2);
                delta.push(otherIter.next(opLength));
                break;

              case diff.DELETE:
                opLength = Math.min(length2, thisIter.peekLength());
                thisIter.next(opLength);
                delta["delete"](opLength);
                break;

              case diff.EQUAL:
                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length2);
                var thisOp = thisIter.next(opLength);
                var otherOp = otherIter.next(opLength);

                if (equal(thisOp.insert, otherOp.insert)) {
                  delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                } else {
                  delta.push(otherOp)["delete"](opLength);
                }

                break;
            }

            length2 -= opLength;
          }
        });
        return delta.chop();
      };

      Delta.prototype.eachLine = function (predicate, newline) {
        newline = newline || "\n";
        var iter = op.iterator(this.ops);
        var line2 = new Delta();
        var i = 0;

        while (iter.hasNext()) {
          if (iter.peekType() !== "insert") return;
          var thisOp = iter.peek();
          var start2 = op.length(thisOp) - iter.peekLength();
          var index2 = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start2) - start2 : -1;

          if (index2 < 0) {
            line2.push(iter.next());
          } else if (index2 > 0) {
            line2.push(iter.next(index2));
          } else {
            if (predicate(line2, iter.next(1).attributes || {}, i) === false) {
              return;
            }

            i += 1;
            line2 = new Delta();
          }
        }

        if (line2.length() > 0) {
          predicate(line2, {}, i);
        }
      };

      Delta.prototype.transform = function (other, priority) {
        priority = !!priority;

        if (typeof other === "number") {
          return this.transformPosition(other, priority);
        }

        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var delta = new Delta();

        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) {
            delta.retain(op.length(thisIter.next()));
          } else if (otherIter.peekType() === "insert") {
            delta.push(otherIter.next());
          } else {
            var length2 = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length2);
            var otherOp = otherIter.next(length2);

            if (thisOp["delete"]) {
              continue;
            } else if (otherOp["delete"]) {
              delta.push(otherOp);
            } else {
              delta.retain(length2, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
            }
          }
        }

        return delta.chop();
      };

      Delta.prototype.transformPosition = function (index2, priority) {
        priority = !!priority;
        var thisIter = op.iterator(this.ops);
        var offset2 = 0;

        while (thisIter.hasNext() && offset2 <= index2) {
          var length2 = thisIter.peekLength();
          var nextType = thisIter.peekType();
          thisIter.next();

          if (nextType === "delete") {
            index2 -= Math.min(length2, index2 - offset2);
            continue;
          } else if (nextType === "insert" && (offset2 < index2 || !priority)) {
            index2 += length2;
          }

          offset2 += length2;
        }

        return index2;
      };

      module2.exports = Delta;
    }, function (module2, exports2) {
      var hasOwn = Object.prototype.hasOwnProperty;
      var toStr = Object.prototype.toString;
      var defineProperty = Object.defineProperty;
      var gOPD = Object.getOwnPropertyDescriptor;

      var isArray2 = function isArray3(arr) {
        if (typeof Array.isArray === "function") {
          return Array.isArray(arr);
        }

        return toStr.call(arr) === "[object Array]";
      };

      var isPlainObject2 = function isPlainObject3(obj) {
        if (!obj || toStr.call(obj) !== "[object Object]") {
          return false;
        }

        var hasOwnConstructor = hasOwn.call(obj, "constructor");
        var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");

        if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
          return false;
        }

        var key;

        for (key in obj) {}

        return typeof key === "undefined" || hasOwn.call(obj, key);
      };

      var setProperty = function setProperty2(target, options2) {
        if (defineProperty && options2.name === "__proto__") {
          defineProperty(target, options2.name, {
            enumerable: true,
            configurable: true,
            value: options2.newValue,
            writable: true
          });
        } else {
          target[options2.name] = options2.newValue;
        }
      };

      var getProperty = function getProperty2(obj, name2) {
        if (name2 === "__proto__") {
          if (!hasOwn.call(obj, name2)) {
            return void 0;
          } else if (gOPD) {
            return gOPD(obj, name2).value;
          }
        }

        return obj[name2];
      };

      module2.exports = function extend2() {
        var options2, name2, src, copy2, copyIsArray, clone;
        var target = arguments[0];
        var i = 1;
        var length2 = arguments.length;
        var deep = false;

        if (typeof target === "boolean") {
          deep = target;
          target = arguments[1] || {};
          i = 2;
        }

        if (target == null || typeof target !== "object" && typeof target !== "function") {
          target = {};
        }

        for (; i < length2; ++i) {
          options2 = arguments[i];

          if (options2 != null) {
            for (name2 in options2) {
              src = getProperty(target, name2);
              copy2 = getProperty(options2, name2);

              if (target !== copy2) {
                if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
                  if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && isArray2(src) ? src : [];
                  } else {
                    clone = src && isPlainObject2(src) ? src : {};
                  }

                  setProperty(target, {
                    name: name2,
                    newValue: extend2(deep, clone, copy2)
                  });
                } else if (typeof copy2 !== "undefined") {
                  setProperty(target, {
                    name: name2,
                    newValue: copy2
                  });
                }
              }
            }
          }
        }

        return target;
      };
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.BlockEmbed = exports2.bubbleFormats = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWLINE_LENGTH = 1;

      var BlockEmbed = function (_Parchment$Embed) {
        _inherits2(BlockEmbed2, _Parchment$Embed);

        function BlockEmbed2() {
          _classCallCheck2(this, BlockEmbed2);

          return _possibleConstructorReturn2(this, (BlockEmbed2.__proto__ || Object.getPrototypeOf(BlockEmbed2)).apply(this, arguments));
        }

        _createClass2(BlockEmbed2, [{
          key: "attach",
          value: function attach() {
            _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "attach", this).call(this);

            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
          }
        }, {
          key: "delta",
          value: function delta() {
            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
          }
        }, {
          key: "format",
          value: function format(name2, value) {
            var attribute = _parchment2.default.query(name2, _parchment2.default.Scope.BLOCK_ATTRIBUTE);

            if (attribute != null) {
              this.attributes.attribute(attribute, value);
            }
          }
        }, {
          key: "formatAt",
          value: function formatAt(index2, length2, name2, value) {
            this.format(name2, value);
          }
        }, {
          key: "insertAt",
          value: function insertAt(index2, value, def) {
            if (typeof value === "string" && value.endsWith("\n")) {
              var block = _parchment2.default.create(Block.blotName);

              this.parent.insertBefore(block, index2 === 0 ? this : this.next);
              block.insertAt(0, value.slice(0, -1));
            } else {
              _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "insertAt", this).call(this, index2, value, def);
            }
          }
        }]);

        return BlockEmbed2;
      }(_parchment2.default.Embed);

      BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;

      var Block = function (_Parchment$Block) {
        _inherits2(Block2, _Parchment$Block);

        function Block2(domNode) {
          _classCallCheck2(this, Block2);

          var _this2 = _possibleConstructorReturn2(this, (Block2.__proto__ || Object.getPrototypeOf(Block2)).call(this, domNode));

          _this2.cache = {};
          return _this2;
        }

        _createClass2(Block2, [{
          key: "delta",
          value: function delta() {
            if (this.cache.delta == null) {
              this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta2, leaf) {
                if (leaf.length() === 0) {
                  return delta2;
                } else {
                  return delta2.insert(leaf.value(), bubbleFormats(leaf));
                }
              }, new _quillDelta2.default()).insert("\n", bubbleFormats(this));
            }

            return this.cache.delta;
          }
        }, {
          key: "deleteAt",
          value: function deleteAt(index2, length2) {
            _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "deleteAt", this).call(this, index2, length2);

            this.cache = {};
          }
        }, {
          key: "formatAt",
          value: function formatAt(index2, length2, name2, value) {
            if (length2 <= 0) return;

            if (_parchment2.default.query(name2, _parchment2.default.Scope.BLOCK)) {
              if (index2 + length2 === this.length()) {
                this.format(name2, value);
              }
            } else {
              _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "formatAt", this).call(this, index2, Math.min(length2, this.length() - index2 - 1), name2, value);
            }

            this.cache = {};
          }
        }, {
          key: "insertAt",
          value: function insertAt(index2, value, def) {
            if (def != null) return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, index2, value, def);
            if (value.length === 0) return;
            var lines = value.split("\n");
            var text = lines.shift();

            if (text.length > 0) {
              if (index2 < this.length() - 1 || this.children.tail == null) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, Math.min(index2, this.length() - 1), text);
              } else {
                this.children.tail.insertAt(this.children.tail.length(), text);
              }

              this.cache = {};
            }

            var block = this;
            lines.reduce(function (index3, line2) {
              block = block.split(index3, true);
              block.insertAt(0, line2);
              return line2.length;
            }, index2 + text.length);
          }
        }, {
          key: "insertBefore",
          value: function insertBefore(blot, ref) {
            var head = this.children.head;

            _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertBefore", this).call(this, blot, ref);

            if (head instanceof _break2.default) {
              head.remove();
            }

            this.cache = {};
          }
        }, {
          key: "length",
          value: function length2() {
            if (this.cache.length == null) {
              this.cache.length = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "length", this).call(this) + NEWLINE_LENGTH;
            }

            return this.cache.length;
          }
        }, {
          key: "moveChildren",
          value: function moveChildren(target, ref) {
            _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "moveChildren", this).call(this, target, ref);

            this.cache = {};
          }
        }, {
          key: "optimize",
          value: function optimize(context) {
            _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "optimize", this).call(this, context);

            this.cache = {};
          }
        }, {
          key: "path",
          value: function path(index2) {
            return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "path", this).call(this, index2, true);
          }
        }, {
          key: "removeChild",
          value: function removeChild(child) {
            _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "removeChild", this).call(this, child);

            this.cache = {};
          }
        }, {
          key: "split",
          value: function split(index2) {
            var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;

            if (force && (index2 === 0 || index2 >= this.length() - NEWLINE_LENGTH)) {
              var clone = this.clone();

              if (index2 === 0) {
                this.parent.insertBefore(clone, this);
                return this;
              } else {
                this.parent.insertBefore(clone, this.next);
                return clone;
              }
            } else {
              var next2 = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "split", this).call(this, index2, force);

              this.cache = {};
              return next2;
            }
          }
        }]);

        return Block2;
      }(_parchment2.default.Block);

      Block.blotName = "block";
      Block.tagName = "P";
      Block.defaultChild = "break";
      Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

      function bubbleFormats(blot) {
        var formats2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (blot == null) return formats2;

        if (typeof blot.formats === "function") {
          formats2 = (0, _extend2.default)(formats2, blot.formats());
        }

        if (blot.parent == null || blot.parent.blotName == "scroll" || blot.parent.statics.scope !== blot.statics.scope) {
          return formats2;
        }

        return bubbleFormats(blot.parent, formats2);
      }

      exports2.bubbleFormats = bubbleFormats;
      exports2.BlockEmbed = BlockEmbed;
      exports2.default = Block;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.overload = exports2.expandConfig = void 0;

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      __webpack_require__(50);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _editor = __webpack_require__(14);

      var _editor2 = _interopRequireDefault(_editor);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _selection = __webpack_require__(15);

      var _selection2 = _interopRequireDefault(_selection);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)("quill");

      var Quill = function () {
        _createClass2(Quill2, null, [{
          key: "debug",
          value: function debug2(limit) {
            if (limit === true) {
              limit = "log";
            }

            _logger2.default.level(limit);
          }
        }, {
          key: "find",
          value: function find(node2) {
            return node2.__quill || _parchment2.default.find(node2);
          }
        }, {
          key: "import",
          value: function _import(name2) {
            if (this.imports[name2] == null) {
              debug.error("Cannot import " + name2 + ". Are you sure it was registered?");
            }

            return this.imports[name2];
          }
        }, {
          key: "register",
          value: function register(path, target) {
            var _this = this;

            var overwrite = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;

            if (typeof path !== "string") {
              var name2 = path.attrName || path.blotName;

              if (typeof name2 === "string") {
                this.register("formats/" + name2, path, target);
              } else {
                Object.keys(path).forEach(function (key) {
                  _this.register(key, path[key], target);
                });
              }
            } else {
              if (this.imports[path] != null && !overwrite) {
                debug.warn("Overwriting " + path + " with", target);
              }

              this.imports[path] = target;

              if ((path.startsWith("blots/") || path.startsWith("formats/")) && target.blotName !== "abstract") {
                _parchment2.default.register(target);
              } else if (path.startsWith("modules") && typeof target.register === "function") {
                target.register();
              }
            }
          }
        }]);

        function Quill2(container) {
          var _this2 = this;

          var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};

          _classCallCheck2(this, Quill2);

          this.options = expandConfig(container, options2);
          this.container = this.options.container;

          if (this.container == null) {
            return debug.error("Invalid Quill container", container);
          }

          if (this.options.debug) {
            Quill2.debug(this.options.debug);
          }

          var html = this.container.innerHTML.trim();
          this.container.classList.add("ql-container");
          this.container.innerHTML = "";
          this.container.__quill = this;
          this.root = this.addContainer("ql-editor");
          this.root.classList.add("ql-blank");
          this.root.setAttribute("data-gramm", false);
          this.scrollingContainer = this.options.scrollingContainer || this.root;
          this.emitter = new _emitter4.default();
          this.scroll = _parchment2.default.create(this.root, {
            emitter: this.emitter,
            whitelist: this.options.formats
          });
          this.editor = new _editor2.default(this.scroll);
          this.selection = new _selection2.default(this.scroll, this.emitter);
          this.theme = new this.options.theme(this, this.options);
          this.keyboard = this.theme.addModule("keyboard");
          this.clipboard = this.theme.addModule("clipboard");
          this.history = this.theme.addModule("history");
          this.theme.init();
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
            if (type === _emitter4.default.events.TEXT_CHANGE) {
              _this2.root.classList.toggle("ql-blank", _this2.editor.isBlank());
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source2, mutations) {
            var range2 = _this2.selection.lastRange;
            var index2 = range2 && range2.length === 0 ? range2.index : void 0;
            modify.call(_this2, function () {
              return _this2.editor.update(null, mutations, index2);
            }, source2);
          });
          var contents = this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">" + html + "<p><br></p></div>");
          this.setContents(contents);
          this.history.clear();

          if (this.options.placeholder) {
            this.root.setAttribute("data-placeholder", this.options.placeholder);
          }

          if (this.options.readOnly) {
            this.disable();
          }
        }

        _createClass2(Quill2, [{
          key: "addContainer",
          value: function addContainer(container) {
            var refNode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;

            if (typeof container === "string") {
              var className = container;
              container = document.createElement("div");
              container.classList.add(className);
            }

            this.container.insertBefore(container, refNode);
            return container;
          }
        }, {
          key: "blur",
          value: function blur() {
            this.selection.setRange(null);
          }
        }, {
          key: "deleteText",
          value: function deleteText(index2, length2, source2) {
            var _this3 = this;

            var _overload = overload(index2, length2, source2);

            var _overload2 = _slicedToArray2(_overload, 4);

            index2 = _overload2[0];
            length2 = _overload2[1];
            source2 = _overload2[3];
            return modify.call(this, function () {
              return _this3.editor.deleteText(index2, length2);
            }, source2, index2, -1 * length2);
          }
        }, {
          key: "disable",
          value: function disable() {
            this.enable(false);
          }
        }, {
          key: "enable",
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            this.scroll.enable(enabled);
            this.container.classList.toggle("ql-disabled", !enabled);
          }
        }, {
          key: "focus",
          value: function focus() {
            var scrollTop = this.scrollingContainer.scrollTop;
            this.selection.focus();
            this.scrollingContainer.scrollTop = scrollTop;
            this.scrollIntoView();
          }
        }, {
          key: "format",
          value: function format(name2, value) {
            var _this4 = this;

            var source2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;
            return modify.call(this, function () {
              var range2 = _this4.getSelection(true);

              var change = new _quillDelta2.default();

              if (range2 == null) {
                return change;
              } else if (_parchment2.default.query(name2, _parchment2.default.Scope.BLOCK)) {
                change = _this4.editor.formatLine(range2.index, range2.length, _defineProperty2({}, name2, value));
              } else if (range2.length === 0) {
                _this4.selection.format(name2, value);

                return change;
              } else {
                change = _this4.editor.formatText(range2.index, range2.length, _defineProperty2({}, name2, value));
              }

              _this4.setSelection(range2, _emitter4.default.sources.SILENT);

              return change;
            }, source2);
          }
        }, {
          key: "formatLine",
          value: function formatLine(index2, length2, name2, value, source2) {
            var _this5 = this;

            var formats2 = void 0;

            var _overload3 = overload(index2, length2, name2, value, source2);

            var _overload4 = _slicedToArray2(_overload3, 4);

            index2 = _overload4[0];
            length2 = _overload4[1];
            formats2 = _overload4[2];
            source2 = _overload4[3];
            return modify.call(this, function () {
              return _this5.editor.formatLine(index2, length2, formats2);
            }, source2, index2, 0);
          }
        }, {
          key: "formatText",
          value: function formatText(index2, length2, name2, value, source2) {
            var _this6 = this;

            var formats2 = void 0;

            var _overload5 = overload(index2, length2, name2, value, source2);

            var _overload6 = _slicedToArray2(_overload5, 4);

            index2 = _overload6[0];
            length2 = _overload6[1];
            formats2 = _overload6[2];
            source2 = _overload6[3];
            return modify.call(this, function () {
              return _this6.editor.formatText(index2, length2, formats2);
            }, source2, index2, 0);
          }
        }, {
          key: "getBounds",
          value: function getBounds(index2) {
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            var bounds = void 0;

            if (typeof index2 === "number") {
              bounds = this.selection.getBounds(index2, length2);
            } else {
              bounds = this.selection.getBounds(index2.index, index2.length);
            }

            var containerBounds = this.container.getBoundingClientRect();
            return {
              bottom: bounds.bottom - containerBounds.top,
              height: bounds.height,
              left: bounds.left - containerBounds.left,
              right: bounds.right - containerBounds.left,
              top: bounds.top - containerBounds.top,
              width: bounds.width
            };
          }
        }, {
          key: "getContents",
          value: function getContents() {
            var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index2;

            var _overload7 = overload(index2, length2);

            var _overload8 = _slicedToArray2(_overload7, 2);

            index2 = _overload8[0];
            length2 = _overload8[1];
            return this.editor.getContents(index2, length2);
          }
        }, {
          key: "getFormat",
          value: function getFormat() {
            var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(true);
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;

            if (typeof index2 === "number") {
              return this.editor.getFormat(index2, length2);
            } else {
              return this.editor.getFormat(index2.index, index2.length);
            }
          }
        }, {
          key: "getIndex",
          value: function getIndex(blot) {
            return blot.offset(this.scroll);
          }
        }, {
          key: "getLength",
          value: function getLength() {
            return this.scroll.length();
          }
        }, {
          key: "getLeaf",
          value: function getLeaf(index2) {
            return this.scroll.leaf(index2);
          }
        }, {
          key: "getLine",
          value: function getLine(index2) {
            return this.scroll.line(index2);
          }
        }, {
          key: "getLines",
          value: function getLines() {
            var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;

            if (typeof index2 !== "number") {
              return this.scroll.lines(index2.index, index2.length);
            } else {
              return this.scroll.lines(index2, length2);
            }
          }
        }, {
          key: "getModule",
          value: function getModule(name2) {
            return this.theme.modules[name2];
          }
        }, {
          key: "getSelection",
          value: function getSelection() {
            var focus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (focus) this.focus();
            this.update();
            return this.selection.getRange()[0];
          }
        }, {
          key: "getText",
          value: function getText() {
            var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index2;

            var _overload9 = overload(index2, length2);

            var _overload10 = _slicedToArray2(_overload9, 2);

            index2 = _overload10[0];
            length2 = _overload10[1];
            return this.editor.getText(index2, length2);
          }
        }, {
          key: "hasFocus",
          value: function hasFocus() {
            return this.selection.hasFocus();
          }
        }, {
          key: "insertEmbed",
          value: function insertEmbed(index2, embed, value) {
            var _this7 = this;

            var source2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Quill2.sources.API;
            return modify.call(this, function () {
              return _this7.editor.insertEmbed(index2, embed, value);
            }, source2, index2);
          }
        }, {
          key: "insertText",
          value: function insertText(index2, text, name2, value, source2) {
            var _this8 = this;

            var formats2 = void 0;

            var _overload11 = overload(index2, 0, name2, value, source2);

            var _overload12 = _slicedToArray2(_overload11, 4);

            index2 = _overload12[0];
            formats2 = _overload12[2];
            source2 = _overload12[3];
            return modify.call(this, function () {
              return _this8.editor.insertText(index2, text, formats2);
            }, source2, index2, text.length);
          }
        }, {
          key: "isEnabled",
          value: function isEnabled() {
            return !this.container.classList.contains("ql-disabled");
          }
        }, {
          key: "off",
          value: function off2() {
            return this.emitter.off.apply(this.emitter, arguments);
          }
        }, {
          key: "on",
          value: function on2() {
            return this.emitter.on.apply(this.emitter, arguments);
          }
        }, {
          key: "once",
          value: function once() {
            return this.emitter.once.apply(this.emitter, arguments);
          }
        }, {
          key: "pasteHTML",
          value: function pasteHTML(index2, html, source2) {
            this.clipboard.dangerouslyPasteHTML(index2, html, source2);
          }
        }, {
          key: "removeFormat",
          value: function removeFormat(index2, length2, source2) {
            var _this9 = this;

            var _overload13 = overload(index2, length2, source2);

            var _overload14 = _slicedToArray2(_overload13, 4);

            index2 = _overload14[0];
            length2 = _overload14[1];
            source2 = _overload14[3];
            return modify.call(this, function () {
              return _this9.editor.removeFormat(index2, length2);
            }, source2, index2);
          }
        }, {
          key: "scrollIntoView",
          value: function scrollIntoView2() {
            this.selection.scrollIntoView(this.scrollingContainer);
          }
        }, {
          key: "setContents",
          value: function setContents(delta) {
            var _this10 = this;

            var source2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);

              var length2 = _this10.getLength();

              var deleted = _this10.editor.deleteText(0, length2);

              var applied = _this10.editor.applyDelta(delta);

              var lastOp = applied.ops[applied.ops.length - 1];

              if (lastOp != null && typeof lastOp.insert === "string" && lastOp.insert[lastOp.insert.length - 1] === "\n") {
                _this10.editor.deleteText(_this10.getLength() - 1, 1);

                applied.delete(1);
              }

              var ret = deleted.compose(applied);
              return ret;
            }, source2);
          }
        }, {
          key: "setSelection",
          value: function setSelection(index2, length2, source2) {
            if (index2 == null) {
              this.selection.setRange(null, length2 || Quill2.sources.API);
            } else {
              var _overload15 = overload(index2, length2, source2);

              var _overload16 = _slicedToArray2(_overload15, 4);

              index2 = _overload16[0];
              length2 = _overload16[1];
              source2 = _overload16[3];
              this.selection.setRange(new _selection.Range(index2, length2), source2);

              if (source2 !== _emitter4.default.sources.SILENT) {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }
          }
        }, {
          key: "setText",
          value: function setText(text) {
            var source2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
            var delta = new _quillDelta2.default().insert(text);
            return this.setContents(delta, source2);
          }
        }, {
          key: "update",
          value: function update() {
            var source2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
            var change = this.scroll.update(source2);
            this.selection.update(source2);
            return change;
          }
        }, {
          key: "updateContents",
          value: function updateContents(delta) {
            var _this11 = this;

            var source2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);
              return _this11.editor.applyDelta(delta, source2);
            }, source2, true);
          }
        }]);

        return Quill2;
      }();

      Quill.DEFAULTS = {
        bounds: null,
        formats: null,
        modules: {},
        placeholder: "",
        readOnly: false,
        scrollingContainer: null,
        strict: true,
        theme: "default"
      };
      Quill.events = _emitter4.default.events;
      Quill.sources = _emitter4.default.sources;
      Quill.version = "1.3.7";
      Quill.imports = {
        "delta": _quillDelta2.default,
        "parchment": _parchment2.default,
        "core/module": _module2.default,
        "core/theme": _theme2.default
      };

      function expandConfig(container, userConfig) {
        userConfig = (0, _extend2.default)(true, {
          container: container,
          modules: {
            clipboard: true,
            keyboard: true,
            history: true
          }
        }, userConfig);

        if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
          userConfig.theme = _theme2.default;
        } else {
          userConfig.theme = Quill.import("themes/" + userConfig.theme);

          if (userConfig.theme == null) {
            throw new Error("Invalid theme " + userConfig.theme + ". Did you register it?");
          }
        }

        var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
        [themeConfig, userConfig].forEach(function (config) {
          config.modules = config.modules || {};
          Object.keys(config.modules).forEach(function (module3) {
            if (config.modules[module3] === true) {
              config.modules[module3] = {};
            }
          });
        });
        var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
        var moduleConfig = moduleNames.reduce(function (config, name2) {
          var moduleClass = Quill.import("modules/" + name2);

          if (moduleClass == null) {
            debug.error("Cannot load " + name2 + " module. Are you sure you registered it?");
          } else {
            config[name2] = moduleClass.DEFAULTS || {};
          }

          return config;
        }, {});

        if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
          userConfig.modules.toolbar = {
            container: userConfig.modules.toolbar
          };
        }

        userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
          modules: moduleConfig
        }, themeConfig, userConfig);
        ["bounds", "container", "scrollingContainer"].forEach(function (key) {
          if (typeof userConfig[key] === "string") {
            userConfig[key] = document.querySelector(userConfig[key]);
          }
        });
        userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name2) {
          if (userConfig.modules[name2]) {
            config[name2] = userConfig.modules[name2];
          }

          return config;
        }, {});
        return userConfig;
      }

      function modify(modifier, source2, index2, shift) {
        if (this.options.strict && !this.isEnabled() && source2 === _emitter4.default.sources.USER) {
          return new _quillDelta2.default();
        }

        var range2 = index2 == null ? null : this.getSelection();
        var oldDelta = this.editor.delta;
        var change = modifier();

        if (range2 != null) {
          if (index2 === true) index2 = range2.index;

          if (shift == null) {
            range2 = shiftRange(range2, change, source2);
          } else if (shift !== 0) {
            range2 = shiftRange(range2, index2, shift, source2);
          }

          this.setSelection(range2, _emitter4.default.sources.SILENT);
        }

        if (change.length() > 0) {
          var _emitter;

          var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source2];

          (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));

          if (source2 !== _emitter4.default.sources.SILENT) {
            var _emitter2;

            (_emitter2 = this.emitter).emit.apply(_emitter2, args);
          }
        }

        return change;
      }

      function overload(index2, length2, name2, value, source2) {
        var formats2 = {};

        if (typeof index2.index === "number" && typeof index2.length === "number") {
          if (typeof length2 !== "number") {
            source2 = value, value = name2, name2 = length2, length2 = index2.length, index2 = index2.index;
          } else {
            length2 = index2.length, index2 = index2.index;
          }
        } else if (typeof length2 !== "number") {
          source2 = value, value = name2, name2 = length2, length2 = 0;
        }

        if ((typeof name2 === "undefined" ? "undefined" : _typeof2(name2)) === "object") {
          formats2 = name2;
          source2 = value;
        } else if (typeof name2 === "string") {
          if (value != null) {
            formats2[name2] = value;
          } else {
            source2 = name2;
          }
        }

        source2 = source2 || _emitter4.default.sources.API;
        return [index2, length2, formats2, source2];
      }

      function shiftRange(range2, index2, length2, source2) {
        if (range2 == null) return null;
        var start2 = void 0,
            end2 = void 0;

        if (index2 instanceof _quillDelta2.default) {
          var _map = [range2.index, range2.index + range2.length].map(function (pos) {
            return index2.transformPosition(pos, source2 !== _emitter4.default.sources.USER);
          });

          var _map2 = _slicedToArray2(_map, 2);

          start2 = _map2[0];
          end2 = _map2[1];
        } else {
          var _map3 = [range2.index, range2.index + range2.length].map(function (pos) {
            if (pos < index2 || pos === index2 && source2 === _emitter4.default.sources.USER) return pos;

            if (length2 >= 0) {
              return pos + length2;
            } else {
              return Math.max(index2, pos + length2);
            }
          });

          var _map4 = _slicedToArray2(_map3, 2);

          start2 = _map4[0];
          end2 = _map4[1];
        }

        return new _selection.Range(start2, end2 - start2);
      }

      exports2.expandConfig = expandConfig;
      exports2.overload = overload;
      exports2.default = Quill;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Inline = function (_Parchment$Inline) {
        _inherits2(Inline2, _Parchment$Inline);

        function Inline2() {
          _classCallCheck2(this, Inline2);

          return _possibleConstructorReturn2(this, (Inline2.__proto__ || Object.getPrototypeOf(Inline2)).apply(this, arguments));
        }

        _createClass2(Inline2, [{
          key: "formatAt",
          value: function formatAt(index2, length2, name2, value) {
            if (Inline2.compare(this.statics.blotName, name2) < 0 && _parchment2.default.query(name2, _parchment2.default.Scope.BLOT)) {
              var blot = this.isolate(index2, length2);

              if (value) {
                blot.wrap(name2, value);
              }
            } else {
              _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "formatAt", this).call(this, index2, length2, name2, value);
            }
          }
        }, {
          key: "optimize",
          value: function optimize(context) {
            _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "optimize", this).call(this, context);

            if (this.parent instanceof Inline2 && Inline2.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
              var parent = this.parent.isolate(this.offset(), this.length());
              this.moveChildren(parent);
              parent.wrap(this);
            }
          }
        }], [{
          key: "compare",
          value: function compare(self2, other) {
            var selfIndex = Inline2.order.indexOf(self2);
            var otherIndex = Inline2.order.indexOf(other);

            if (selfIndex >= 0 || otherIndex >= 0) {
              return selfIndex - otherIndex;
            } else if (self2 === other) {
              return 0;
            } else if (self2 < other) {
              return -1;
            } else {
              return 1;
            }
          }
        }]);

        return Inline2;
      }(_parchment2.default.Inline);

      Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
      Inline.order = ["cursor", "inline", "underline", "strike", "italic", "bold", "script", "link", "code"];
      exports2.default = Inline;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TextBlot = function (_Parchment$Text) {
        _inherits2(TextBlot2, _Parchment$Text);

        function TextBlot2() {
          _classCallCheck2(this, TextBlot2);

          return _possibleConstructorReturn2(this, (TextBlot2.__proto__ || Object.getPrototypeOf(TextBlot2)).apply(this, arguments));
        }

        return TextBlot2;
      }(_parchment2.default.Text);

      exports2.default = TextBlot;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _eventemitter = __webpack_require__(54);

      var _eventemitter2 = _interopRequireDefault(_eventemitter);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)("quill:events");
      var EVENTS = ["selectionchange", "mousedown", "mouseup", "click"];
      EVENTS.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          [].slice.call(document.querySelectorAll(".ql-container")).forEach(function (node2) {
            if (node2.__quill && node2.__quill.emitter) {
              var _node$__quill$emitter;

              (_node$__quill$emitter = node2.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
            }
          });
        });
      });

      var Emitter = function (_EventEmitter) {
        _inherits2(Emitter2, _EventEmitter);

        function Emitter2() {
          _classCallCheck2(this, Emitter2);

          var _this = _possibleConstructorReturn2(this, (Emitter2.__proto__ || Object.getPrototypeOf(Emitter2)).call(this));

          _this.listeners = {};

          _this.on("error", debug.error);

          return _this;
        }

        _createClass2(Emitter2, [{
          key: "emit",
          value: function emit2() {
            debug.log.apply(debug, arguments);

            _get(Emitter2.prototype.__proto__ || Object.getPrototypeOf(Emitter2.prototype), "emit", this).apply(this, arguments);
          }
        }, {
          key: "handleDOM",
          value: function handleDOM(event) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (this.listeners[event.type] || []).forEach(function (_ref3) {
              var node2 = _ref3.node,
                  handler = _ref3.handler;

              if (event.target === node2 || node2.contains(event.target)) {
                handler.apply(void 0, [event].concat(args));
              }
            });
          }
        }, {
          key: "listenDOM",
          value: function listenDOM(eventName, node2, handler) {
            if (!this.listeners[eventName]) {
              this.listeners[eventName] = [];
            }

            this.listeners[eventName].push({
              node: node2,
              handler: handler
            });
          }
        }]);

        return Emitter2;
      }(_eventemitter2.default);

      Emitter.events = {
        EDITOR_CHANGE: "editor-change",
        SCROLL_BEFORE_UPDATE: "scroll-before-update",
        SCROLL_OPTIMIZE: "scroll-optimize",
        SCROLL_UPDATE: "scroll-update",
        SELECTION_CHANGE: "selection-change",
        TEXT_CHANGE: "text-change"
      };
      Emitter.sources = {
        API: "api",
        SILENT: "silent",
        USER: "user"
      };
      exports2.default = Emitter;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Module = function Module2(quill2) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};

        _classCallCheck2(this, Module2);

        this.quill = quill2;
        this.options = options2;
      };

      Module.DEFAULTS = {};
      exports2.default = Module;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var levels = ["error", "warn", "log", "info"];
      var level = "warn";

      function debug(method) {
        if (levels.indexOf(method) <= levels.indexOf(level)) {
          var _console;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_console = console)[method].apply(_console, args);
        }
      }

      function namespace(ns) {
        return levels.reduce(function (logger2, method) {
          logger2[method] = debug.bind(console, method, ns);
          return logger2;
        }, {});
      }

      debug.level = namespace.level = function (newLevel) {
        level = newLevel;
      };

      exports2.default = namespace;
    }, function (module2, exports2, __webpack_require__) {
      var pSlice = Array.prototype.slice;

      var objectKeys = __webpack_require__(52);

      var isArguments2 = __webpack_require__(53);

      var deepEqual2 = module2.exports = function (actual, expected, opts) {
        if (!opts) opts = {};

        if (actual === expected) {
          return true;
        } else if (actual instanceof Date && expected instanceof Date) {
          return actual.getTime() === expected.getTime();
        } else if (!actual || !expected || typeof actual != "object" && typeof expected != "object") {
          return opts.strict ? actual === expected : actual == expected;
        } else {
          return objEquiv(actual, expected, opts);
        }
      };

      function isUndefinedOrNull(value) {
        return value === null || value === void 0;
      }

      function isBuffer2(x2) {
        if (!x2 || typeof x2 !== "object" || typeof x2.length !== "number") return false;

        if (typeof x2.copy !== "function" || typeof x2.slice !== "function") {
          return false;
        }

        if (x2.length > 0 && typeof x2[0] !== "number") return false;
        return true;
      }

      function objEquiv(a, b2, opts) {
        var i, key;
        if (isUndefinedOrNull(a) || isUndefinedOrNull(b2)) return false;
        if (a.prototype !== b2.prototype) return false;

        if (isArguments2(a)) {
          if (!isArguments2(b2)) {
            return false;
          }

          a = pSlice.call(a);
          b2 = pSlice.call(b2);
          return deepEqual2(a, b2, opts);
        }

        if (isBuffer2(a)) {
          if (!isBuffer2(b2)) {
            return false;
          }

          if (a.length !== b2.length) return false;

          for (i = 0; i < a.length; i++) {
            if (a[i] !== b2[i]) return false;
          }

          return true;
        }

        try {
          var ka2 = objectKeys(a),
              kb = objectKeys(b2);
        } catch (e2) {
          return false;
        }

        if (ka2.length != kb.length) return false;
        ka2.sort();
        kb.sort();

        for (i = ka2.length - 1; i >= 0; i--) {
          if (ka2[i] != kb[i]) return false;
        }

        for (i = ka2.length - 1; i >= 0; i--) {
          key = ka2[i];
          if (!deepEqual2(a[key], b2[key], opts)) return false;
        }

        return typeof a === typeof b2;
      }
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var Registry = __webpack_require__(1);

      var Attributor = function () {
        function Attributor2(attrName, keyName, options2) {
          if (options2 === void 0) {
            options2 = {};
          }

          this.attrName = attrName;
          this.keyName = keyName;
          var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;

          if (options2.scope != null) {
            this.scope = options2.scope & Registry.Scope.LEVEL | attributeBit;
          } else {
            this.scope = Registry.Scope.ATTRIBUTE;
          }

          if (options2.whitelist != null) this.whitelist = options2.whitelist;
        }

        Attributor2.keys = function (node2) {
          return [].map.call(node2.attributes, function (item) {
            return item.name;
          });
        };

        Attributor2.prototype.add = function (node2, value) {
          if (!this.canAdd(node2, value)) return false;
          node2.setAttribute(this.keyName, value);
          return true;
        };

        Attributor2.prototype.canAdd = function (node2, value) {
          var match2 = Registry.query(node2, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
          if (match2 == null) return false;
          if (this.whitelist == null) return true;

          if (typeof value === "string") {
            return this.whitelist.indexOf(value.replace(/["']/g, "")) > -1;
          } else {
            return this.whitelist.indexOf(value) > -1;
          }
        };

        Attributor2.prototype.remove = function (node2) {
          node2.removeAttribute(this.keyName);
        };

        Attributor2.prototype.value = function (node2) {
          var value = node2.getAttribute(this.keyName);

          if (this.canAdd(node2, value) && value) {
            return value;
          }

          return "";
        };

        return Attributor2;
      }();

      exports2.default = Attributor;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.Code = void 0;

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Code = function (_Inline) {
        _inherits2(Code2, _Inline);

        function Code2() {
          _classCallCheck2(this, Code2);

          return _possibleConstructorReturn2(this, (Code2.__proto__ || Object.getPrototypeOf(Code2)).apply(this, arguments));
        }

        return Code2;
      }(_inline2.default);

      Code.blotName = "code";
      Code.tagName = "CODE";

      var CodeBlock = function (_Block) {
        _inherits2(CodeBlock2, _Block);

        function CodeBlock2() {
          _classCallCheck2(this, CodeBlock2);

          return _possibleConstructorReturn2(this, (CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2)).apply(this, arguments));
        }

        _createClass2(CodeBlock2, [{
          key: "delta",
          value: function delta() {
            var _this3 = this;

            var text = this.domNode.textContent;

            if (text.endsWith("\n")) {
              text = text.slice(0, -1);
            }

            return text.split("\n").reduce(function (delta2, frag) {
              return delta2.insert(frag).insert("\n", _this3.formats());
            }, new _quillDelta2.default());
          }
        }, {
          key: "format",
          value: function format(name2, value) {
            if (name2 === this.statics.blotName && value) return;

            var _descendant = this.descendant(_text2.default, this.length() - 1),
                _descendant2 = _slicedToArray2(_descendant, 1),
                text = _descendant2[0];

            if (text != null) {
              text.deleteAt(text.length() - 1, 1);
            }

            _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "format", this).call(this, name2, value);
          }
        }, {
          key: "formatAt",
          value: function formatAt(index2, length2, name2, value) {
            if (length2 === 0) return;

            if (_parchment2.default.query(name2, _parchment2.default.Scope.BLOCK) == null || name2 === this.statics.blotName && value === this.statics.formats(this.domNode)) {
              return;
            }

            var nextNewline = this.newlineIndex(index2);
            if (nextNewline < 0 || nextNewline >= index2 + length2) return;
            var prevNewline = this.newlineIndex(index2, true) + 1;
            var isolateLength = nextNewline - prevNewline + 1;
            var blot = this.isolate(prevNewline, isolateLength);
            var next2 = blot.next;
            blot.format(name2, value);

            if (next2 instanceof CodeBlock2) {
              next2.formatAt(0, index2 - prevNewline + length2 - isolateLength, name2, value);
            }
          }
        }, {
          key: "insertAt",
          value: function insertAt(index2, value, def) {
            if (def != null) return;

            var _descendant3 = this.descendant(_text2.default, index2),
                _descendant4 = _slicedToArray2(_descendant3, 2),
                text = _descendant4[0],
                offset2 = _descendant4[1];

            text.insertAt(offset2, value);
          }
        }, {
          key: "length",
          value: function length2() {
            var length3 = this.domNode.textContent.length;

            if (!this.domNode.textContent.endsWith("\n")) {
              return length3 + 1;
            }

            return length3;
          }
        }, {
          key: "newlineIndex",
          value: function newlineIndex(searchIndex) {
            var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;

            if (!reverse) {
              var offset2 = this.domNode.textContent.slice(searchIndex).indexOf("\n");
              return offset2 > -1 ? searchIndex + offset2 : -1;
            } else {
              return this.domNode.textContent.slice(0, searchIndex).lastIndexOf("\n");
            }
          }
        }, {
          key: "optimize",
          value: function optimize(context) {
            if (!this.domNode.textContent.endsWith("\n")) {
              this.appendChild(_parchment2.default.create("text", "\n"));
            }

            _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "optimize", this).call(this, context);

            var next2 = this.next;

            if (next2 != null && next2.prev === this && next2.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next2.statics.formats(next2.domNode)) {
              next2.optimize(context);
              next2.moveChildren(this);
              next2.remove();
            }
          }
        }, {
          key: "replace",
          value: function replace2(target) {
            _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "replace", this).call(this, target);

            [].slice.call(this.domNode.querySelectorAll("*")).forEach(function (node2) {
              var blot = _parchment2.default.find(node2);

              if (blot == null) {
                node2.parentNode.removeChild(node2);
              } else if (blot instanceof _parchment2.default.Embed) {
                blot.remove();
              } else {
                blot.unwrap();
              }
            });
          }
        }], [{
          key: "create",
          value: function create(value) {
            var domNode = _get(CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2), "create", this).call(this, value);

            domNode.setAttribute("spellcheck", false);
            return domNode;
          }
        }, {
          key: "formats",
          value: function formats2() {
            return true;
          }
        }]);

        return CodeBlock2;
      }(_block2.default);

      CodeBlock.blotName = "code-block";
      CodeBlock.tagName = "PRE";
      CodeBlock.TAB = "  ";
      exports2.Code = Code;
      exports2.default = CodeBlock;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _cursor = __webpack_require__(24);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var ASCII = /^[ -~]*$/;

      var Editor = function () {
        function Editor2(scroll) {
          _classCallCheck2(this, Editor2);

          this.scroll = scroll;
          this.delta = this.getDelta();
        }

        _createClass2(Editor2, [{
          key: "applyDelta",
          value: function applyDelta(delta) {
            var _this = this;

            var consumeNextNewline = false;
            this.scroll.update();
            var scrollLength = this.scroll.length();
            this.scroll.batchStart();
            delta = normalizeDelta(delta);
            delta.reduce(function (index2, op) {
              var length2 = op.retain || op.delete || op.insert.length || 1;
              var attributes = op.attributes || {};

              if (op.insert != null) {
                if (typeof op.insert === "string") {
                  var text = op.insert;

                  if (text.endsWith("\n") && consumeNextNewline) {
                    consumeNextNewline = false;
                    text = text.slice(0, -1);
                  }

                  if (index2 >= scrollLength && !text.endsWith("\n")) {
                    consumeNextNewline = true;
                  }

                  _this.scroll.insertAt(index2, text);

                  var _scroll$line = _this.scroll.line(index2),
                      _scroll$line2 = _slicedToArray2(_scroll$line, 2),
                      line2 = _scroll$line2[0],
                      offset2 = _scroll$line2[1];

                  var formats2 = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line2));

                  if (line2 instanceof _block2.default) {
                    var _line$descendant = line2.descendant(_parchment2.default.Leaf, offset2),
                        _line$descendant2 = _slicedToArray2(_line$descendant, 1),
                        leaf = _line$descendant2[0];

                    formats2 = (0, _extend2.default)(formats2, (0, _block.bubbleFormats)(leaf));
                  }

                  attributes = _op2.default.attributes.diff(formats2, attributes) || {};
                } else if (_typeof2(op.insert) === "object") {
                  var key = Object.keys(op.insert)[0];
                  if (key == null) return index2;

                  _this.scroll.insertAt(index2, key, op.insert[key]);
                }

                scrollLength += length2;
              }

              Object.keys(attributes).forEach(function (name2) {
                _this.scroll.formatAt(index2, length2, name2, attributes[name2]);
              });
              return index2 + length2;
            }, 0);
            delta.reduce(function (index2, op) {
              if (typeof op.delete === "number") {
                _this.scroll.deleteAt(index2, op.delete);

                return index2;
              }

              return index2 + (op.retain || op.insert.length || 1);
            }, 0);
            this.scroll.batchEnd();
            return this.update(delta);
          }
        }, {
          key: "deleteText",
          value: function deleteText(index2, length2) {
            this.scroll.deleteAt(index2, length2);
            return this.update(new _quillDelta2.default().retain(index2).delete(length2));
          }
        }, {
          key: "formatLine",
          value: function formatLine(index2, length2) {
            var _this2 = this;

            var formats2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            this.scroll.update();
            Object.keys(formats2).forEach(function (format) {
              if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;

              var lines = _this2.scroll.lines(index2, Math.max(length2, 1));

              var lengthRemaining = length2;
              lines.forEach(function (line2) {
                var lineLength = line2.length();

                if (!(line2 instanceof _code2.default)) {
                  line2.format(format, formats2[format]);
                } else {
                  var codeIndex = index2 - line2.offset(_this2.scroll);
                  var codeLength = line2.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                  line2.formatAt(codeIndex, codeLength, format, formats2[format]);
                }

                lengthRemaining -= lineLength;
              });
            });
            this.scroll.optimize();
            return this.update(new _quillDelta2.default().retain(index2).retain(length2, (0, _clone2.default)(formats2)));
          }
        }, {
          key: "formatText",
          value: function formatText(index2, length2) {
            var _this3 = this;

            var formats2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            Object.keys(formats2).forEach(function (format) {
              _this3.scroll.formatAt(index2, length2, format, formats2[format]);
            });
            return this.update(new _quillDelta2.default().retain(index2).retain(length2, (0, _clone2.default)(formats2)));
          }
        }, {
          key: "getContents",
          value: function getContents(index2, length2) {
            return this.delta.slice(index2, index2 + length2);
          }
        }, {
          key: "getDelta",
          value: function getDelta() {
            return this.scroll.lines().reduce(function (delta, line2) {
              return delta.concat(line2.delta());
            }, new _quillDelta2.default());
          }
        }, {
          key: "getFormat",
          value: function getFormat(index2) {
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            var lines = [],
                leaves = [];

            if (length2 === 0) {
              this.scroll.path(index2).forEach(function (path) {
                var _path = _slicedToArray2(path, 1),
                    blot = _path[0];

                if (blot instanceof _block2.default) {
                  lines.push(blot);
                } else if (blot instanceof _parchment2.default.Leaf) {
                  leaves.push(blot);
                }
              });
            } else {
              lines = this.scroll.lines(index2, length2);
              leaves = this.scroll.descendants(_parchment2.default.Leaf, index2, length2);
            }

            var formatsArr = [lines, leaves].map(function (blots) {
              if (blots.length === 0) return {};
              var formats2 = (0, _block.bubbleFormats)(blots.shift());

              while (Object.keys(formats2).length > 0) {
                var blot = blots.shift();
                if (blot == null) return formats2;
                formats2 = combineFormats((0, _block.bubbleFormats)(blot), formats2);
              }

              return formats2;
            });
            return _extend2.default.apply(_extend2.default, formatsArr);
          }
        }, {
          key: "getText",
          value: function getText(index2, length2) {
            return this.getContents(index2, length2).filter(function (op) {
              return typeof op.insert === "string";
            }).map(function (op) {
              return op.insert;
            }).join("");
          }
        }, {
          key: "insertEmbed",
          value: function insertEmbed(index2, embed, value) {
            this.scroll.insertAt(index2, embed, value);
            return this.update(new _quillDelta2.default().retain(index2).insert(_defineProperty2({}, embed, value)));
          }
        }, {
          key: "insertText",
          value: function insertText(index2, text) {
            var _this4 = this;

            var formats2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            this.scroll.insertAt(index2, text);
            Object.keys(formats2).forEach(function (format) {
              _this4.scroll.formatAt(index2, text.length, format, formats2[format]);
            });
            return this.update(new _quillDelta2.default().retain(index2).insert(text, (0, _clone2.default)(formats2)));
          }
        }, {
          key: "isBlank",
          value: function isBlank() {
            if (this.scroll.children.length == 0) return true;
            if (this.scroll.children.length > 1) return false;
            var block = this.scroll.children.head;
            if (block.statics.blotName !== _block2.default.blotName) return false;
            if (block.children.length > 1) return false;
            return block.children.head instanceof _break2.default;
          }
        }, {
          key: "removeFormat",
          value: function removeFormat(index2, length2) {
            var text = this.getText(index2, length2);

            var _scroll$line3 = this.scroll.line(index2 + length2),
                _scroll$line4 = _slicedToArray2(_scroll$line3, 2),
                line2 = _scroll$line4[0],
                offset2 = _scroll$line4[1];

            var suffixLength = 0,
                suffix = new _quillDelta2.default();

            if (line2 != null) {
              if (!(line2 instanceof _code2.default)) {
                suffixLength = line2.length() - offset2;
              } else {
                suffixLength = line2.newlineIndex(offset2) - offset2 + 1;
              }

              suffix = line2.delta().slice(offset2, offset2 + suffixLength - 1).insert("\n");
            }

            var contents = this.getContents(index2, length2 + suffixLength);
            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
            var delta = new _quillDelta2.default().retain(index2).concat(diff);
            return this.applyDelta(delta);
          }
        }, {
          key: "update",
          value: function update(change) {
            var mutations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            var cursorIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
            var oldDelta = this.delta;

            if (mutations.length === 1 && mutations[0].type === "characterData" && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
              var textBlot = _parchment2.default.find(mutations[0].target);

              var formats2 = (0, _block.bubbleFormats)(textBlot);
              var index2 = textBlot.offset(this.scroll);
              var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, "");
              var oldText = new _quillDelta2.default().insert(oldValue);
              var newText = new _quillDelta2.default().insert(textBlot.value());
              var diffDelta = new _quillDelta2.default().retain(index2).concat(oldText.diff(newText, cursorIndex));
              change = diffDelta.reduce(function (delta, op) {
                if (op.insert) {
                  return delta.insert(op.insert, formats2);
                } else {
                  return delta.push(op);
                }
              }, new _quillDelta2.default());
              this.delta = oldDelta.compose(change);
            } else {
              this.delta = this.getDelta();

              if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                change = oldDelta.diff(this.delta, cursorIndex);
              }
            }

            return change;
          }
        }]);

        return Editor2;
      }();

      function combineFormats(formats2, combined) {
        return Object.keys(combined).reduce(function (merged, name2) {
          if (formats2[name2] == null) return merged;

          if (combined[name2] === formats2[name2]) {
            merged[name2] = combined[name2];
          } else if (Array.isArray(combined[name2])) {
            if (combined[name2].indexOf(formats2[name2]) < 0) {
              merged[name2] = combined[name2].concat([formats2[name2]]);
            }
          } else {
            merged[name2] = [combined[name2], formats2[name2]];
          }

          return merged;
        }, {});
      }

      function normalizeDelta(delta) {
        return delta.reduce(function (delta2, op) {
          if (op.insert === 1) {
            var attributes = (0, _clone2.default)(op.attributes);
            delete attributes["image"];
            return delta2.insert({
              image: op.attributes.image
            }, attributes);
          }

          if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
            op = (0, _clone2.default)(op);

            if (op.attributes.list) {
              op.attributes.list = "ordered";
            } else {
              op.attributes.list = "bullet";
              delete op.attributes.bullet;
            }
          }

          if (typeof op.insert === "string") {
            var text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            return delta2.insert(text, op.attributes);
          }

          return delta2.push(op);
        }, new _quillDelta2.default());
      }

      exports2.default = Editor;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.Range = void 0;

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _toConsumableArray2(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return Array.from(arr);
        }
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)("quill:selection");

      var Range = function Range2(index2) {
        var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;

        _classCallCheck2(this, Range2);

        this.index = index2;
        this.length = length2;
      };

      var Selection = function () {
        function Selection2(scroll, emitter) {
          var _this = this;

          _classCallCheck2(this, Selection2);

          this.emitter = emitter;
          this.scroll = scroll;
          this.composing = false;
          this.mouseDown = false;
          this.root = this.scroll.domNode;
          this.cursor = _parchment2.default.create("cursor", this);
          this.lastRange = this.savedRange = new Range(0, 0);
          this.handleComposition();
          this.handleDragging();
          this.emitter.listenDOM("selectionchange", document, function () {
            if (!_this.mouseDown) {
              setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
            }
          });
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
            if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
              _this.update(_emitter4.default.sources.SILENT);
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
            if (!_this.hasFocus()) return;

            var _native = _this.getNativeRange();

            if (_native == null) return;
            if (_native.start.node === _this.cursor.textNode) return;

            _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
              try {
                _this.setNativeRange(_native.start.node, _native.start.offset, _native.end.node, _native.end.offset);
              } catch (ignored) {}
            });
          });
          this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
            if (context.range) {
              var _context$range = context.range,
                  startNode = _context$range.startNode,
                  startOffset = _context$range.startOffset,
                  endNode = _context$range.endNode,
                  endOffset = _context$range.endOffset;

              _this.setNativeRange(startNode, startOffset, endNode, endOffset);
            }
          });
          this.update(_emitter4.default.sources.SILENT);
        }

        _createClass2(Selection2, [{
          key: "handleComposition",
          value: function handleComposition() {
            var _this2 = this;

            this.root.addEventListener("compositionstart", function () {
              _this2.composing = true;
            });
            this.root.addEventListener("compositionend", function () {
              _this2.composing = false;

              if (_this2.cursor.parent) {
                var range2 = _this2.cursor.restore();

                if (!range2) return;
                setTimeout(function () {
                  _this2.setNativeRange(range2.startNode, range2.startOffset, range2.endNode, range2.endOffset);
                }, 1);
              }
            });
          }
        }, {
          key: "handleDragging",
          value: function handleDragging() {
            var _this3 = this;

            this.emitter.listenDOM("mousedown", document.body, function () {
              _this3.mouseDown = true;
            });
            this.emitter.listenDOM("mouseup", document.body, function () {
              _this3.mouseDown = false;

              _this3.update(_emitter4.default.sources.USER);
            });
          }
        }, {
          key: "focus",
          value: function focus() {
            if (this.hasFocus()) return;
            this.root.focus();
            this.setRange(this.savedRange);
          }
        }, {
          key: "format",
          value: function format(_format, value) {
            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
            this.scroll.update();
            var nativeRange = this.getNativeRange();
            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;

            if (nativeRange.start.node !== this.cursor.textNode) {
              var blot = _parchment2.default.find(nativeRange.start.node, false);

              if (blot == null) return;

              if (blot instanceof _parchment2.default.Leaf) {
                var after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
              } else {
                blot.insertBefore(this.cursor, nativeRange.start.node);
              }

              this.cursor.attach();
            }

            this.cursor.format(_format, value);
            this.scroll.optimize();
            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
            this.update();
          }
        }, {
          key: "getBounds",
          value: function getBounds(index2) {
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            var scrollLength = this.scroll.length();
            index2 = Math.min(index2, scrollLength - 1);
            length2 = Math.min(index2 + length2, scrollLength - 1) - index2;

            var node2 = void 0,
                _scroll$leaf = this.scroll.leaf(index2),
                _scroll$leaf2 = _slicedToArray2(_scroll$leaf, 2),
                leaf = _scroll$leaf2[0],
                offset2 = _scroll$leaf2[1];

            if (leaf == null) return null;

            var _leaf$position = leaf.position(offset2, true);

            var _leaf$position2 = _slicedToArray2(_leaf$position, 2);

            node2 = _leaf$position2[0];
            offset2 = _leaf$position2[1];
            var range2 = document.createRange();

            if (length2 > 0) {
              range2.setStart(node2, offset2);

              var _scroll$leaf3 = this.scroll.leaf(index2 + length2);

              var _scroll$leaf4 = _slicedToArray2(_scroll$leaf3, 2);

              leaf = _scroll$leaf4[0];
              offset2 = _scroll$leaf4[1];
              if (leaf == null) return null;

              var _leaf$position3 = leaf.position(offset2, true);

              var _leaf$position4 = _slicedToArray2(_leaf$position3, 2);

              node2 = _leaf$position4[0];
              offset2 = _leaf$position4[1];
              range2.setEnd(node2, offset2);
              return range2.getBoundingClientRect();
            } else {
              var side = "left";
              var rect = void 0;

              if (node2 instanceof Text) {
                if (offset2 < node2.data.length) {
                  range2.setStart(node2, offset2);
                  range2.setEnd(node2, offset2 + 1);
                } else {
                  range2.setStart(node2, offset2 - 1);
                  range2.setEnd(node2, offset2);
                  side = "right";
                }

                rect = range2.getBoundingClientRect();
              } else {
                rect = leaf.domNode.getBoundingClientRect();
                if (offset2 > 0) side = "right";
              }

              return {
                bottom: rect.top + rect.height,
                height: rect.height,
                left: rect[side],
                right: rect[side],
                top: rect.top,
                width: 0
              };
            }
          }
        }, {
          key: "getNativeRange",
          value: function getNativeRange() {
            var selection = document.getSelection();
            if (selection == null || selection.rangeCount <= 0) return null;
            var nativeRange = selection.getRangeAt(0);
            if (nativeRange == null) return null;
            var range2 = this.normalizeNative(nativeRange);
            debug.info("getNativeRange", range2);
            return range2;
          }
        }, {
          key: "getRange",
          value: function getRange() {
            var normalized = this.getNativeRange();
            if (normalized == null) return [null, null];
            var range2 = this.normalizedToRange(normalized);
            return [range2, normalized];
          }
        }, {
          key: "hasFocus",
          value: function hasFocus() {
            return document.activeElement === this.root;
          }
        }, {
          key: "normalizedToRange",
          value: function normalizedToRange(range2) {
            var _this4 = this;

            var positions = [[range2.start.node, range2.start.offset]];

            if (!range2.native.collapsed) {
              positions.push([range2.end.node, range2.end.offset]);
            }

            var indexes = positions.map(function (position2) {
              var _position = _slicedToArray2(position2, 2),
                  node2 = _position[0],
                  offset2 = _position[1];

              var blot = _parchment2.default.find(node2, true);

              var index2 = blot.offset(_this4.scroll);

              if (offset2 === 0) {
                return index2;
              } else if (blot instanceof _parchment2.default.Container) {
                return index2 + blot.length();
              } else {
                return index2 + blot.index(node2, offset2);
              }
            });
            var end2 = Math.min(Math.max.apply(Math, _toConsumableArray2(indexes)), this.scroll.length() - 1);
            var start2 = Math.min.apply(Math, [end2].concat(_toConsumableArray2(indexes)));
            return new Range(start2, end2 - start2);
          }
        }, {
          key: "normalizeNative",
          value: function normalizeNative(nativeRange) {
            if (!contains2(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains2(this.root, nativeRange.endContainer)) {
              return null;
            }

            var range2 = {
              start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
              },
              end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
              },
              native: nativeRange
            };
            [range2.start, range2.end].forEach(function (position2) {
              var node2 = position2.node,
                  offset2 = position2.offset;

              while (!(node2 instanceof Text) && node2.childNodes.length > 0) {
                if (node2.childNodes.length > offset2) {
                  node2 = node2.childNodes[offset2];
                  offset2 = 0;
                } else if (node2.childNodes.length === offset2) {
                  node2 = node2.lastChild;
                  offset2 = node2 instanceof Text ? node2.data.length : node2.childNodes.length + 1;
                } else {
                  break;
                }
              }

              position2.node = node2, position2.offset = offset2;
            });
            return range2;
          }
        }, {
          key: "rangeToNative",
          value: function rangeToNative(range2) {
            var _this5 = this;

            var indexes = range2.collapsed ? [range2.index] : [range2.index, range2.index + range2.length];
            var args = [];
            var scrollLength = this.scroll.length();
            indexes.forEach(function (index2, i) {
              index2 = Math.min(scrollLength - 1, index2);

              var node2 = void 0,
                  _scroll$leaf5 = _this5.scroll.leaf(index2),
                  _scroll$leaf6 = _slicedToArray2(_scroll$leaf5, 2),
                  leaf = _scroll$leaf6[0],
                  offset2 = _scroll$leaf6[1];

              var _leaf$position5 = leaf.position(offset2, i !== 0);

              var _leaf$position6 = _slicedToArray2(_leaf$position5, 2);

              node2 = _leaf$position6[0];
              offset2 = _leaf$position6[1];
              args.push(node2, offset2);
            });

            if (args.length < 2) {
              args = args.concat(args);
            }

            return args;
          }
        }, {
          key: "scrollIntoView",
          value: function scrollIntoView2(scrollingContainer) {
            var range2 = this.lastRange;
            if (range2 == null) return;
            var bounds = this.getBounds(range2.index, range2.length);
            if (bounds == null) return;
            var limit = this.scroll.length() - 1;

            var _scroll$line = this.scroll.line(Math.min(range2.index, limit)),
                _scroll$line2 = _slicedToArray2(_scroll$line, 1),
                first = _scroll$line2[0];

            var last = first;

            if (range2.length > 0) {
              var _scroll$line3 = this.scroll.line(Math.min(range2.index + range2.length, limit));

              var _scroll$line4 = _slicedToArray2(_scroll$line3, 1);

              last = _scroll$line4[0];
            }

            if (first == null || last == null) return;
            var scrollBounds = scrollingContainer.getBoundingClientRect();

            if (bounds.top < scrollBounds.top) {
              scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
            } else if (bounds.bottom > scrollBounds.bottom) {
              scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
            }
          }
        }, {
          key: "setNativeRange",
          value: function setNativeRange(startNode, startOffset) {
            var endNode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : startNode;
            var endOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : startOffset;
            var force = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
            debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);

            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
              return;
            }

            var selection = document.getSelection();
            if (selection == null) return;

            if (startNode != null) {
              if (!this.hasFocus()) this.root.focus();
              var _native2 = (this.getNativeRange() || {}).native;

              if (_native2 == null || force || startNode !== _native2.startContainer || startOffset !== _native2.startOffset || endNode !== _native2.endContainer || endOffset !== _native2.endOffset) {
                if (startNode.tagName == "BR") {
                  startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                  startNode = startNode.parentNode;
                }

                if (endNode.tagName == "BR") {
                  endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                  endNode = endNode.parentNode;
                }

                var range2 = document.createRange();
                range2.setStart(startNode, startOffset);
                range2.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range2);
              }
            } else {
              selection.removeAllRanges();
              this.root.blur();
              document.body.focus();
            }
          }
        }, {
          key: "setRange",
          value: function setRange(range2) {
            var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var source2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;

            if (typeof force === "string") {
              source2 = force;
              force = false;
            }

            debug.info("setRange", range2);

            if (range2 != null) {
              var args = this.rangeToNative(range2);
              this.setNativeRange.apply(this, _toConsumableArray2(args).concat([force]));
            } else {
              this.setNativeRange(null);
            }

            this.update(source2);
          }
        }, {
          key: "update",
          value: function update() {
            var source2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
            var oldRange = this.lastRange;

            var _getRange = this.getRange(),
                _getRange2 = _slicedToArray2(_getRange, 2),
                lastRange = _getRange2[0],
                nativeRange = _getRange2[1];

            this.lastRange = lastRange;

            if (this.lastRange != null) {
              this.savedRange = this.lastRange;
            }

            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
              var _emitter;

              if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                this.cursor.restore();
              }

              var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source2];

              (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));

              if (source2 !== _emitter4.default.sources.SILENT) {
                var _emitter2;

                (_emitter2 = this.emitter).emit.apply(_emitter2, args);
              }
            }
          }
        }]);

        return Selection2;
      }();

      function contains2(parent, descendant) {
        try {
          descendant.parentNode;
        } catch (e2) {
          return false;
        }

        if (descendant instanceof Text) {
          descendant = descendant.parentNode;
        }

        return parent.contains(descendant);
      }

      exports2.Range = Range;
      exports2.default = Selection;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Break = function (_Parchment$Embed) {
        _inherits2(Break2, _Parchment$Embed);

        function Break2() {
          _classCallCheck2(this, Break2);

          return _possibleConstructorReturn2(this, (Break2.__proto__ || Object.getPrototypeOf(Break2)).apply(this, arguments));
        }

        _createClass2(Break2, [{
          key: "insertInto",
          value: function insertInto(parent, ref) {
            if (parent.children.length === 0) {
              _get(Break2.prototype.__proto__ || Object.getPrototypeOf(Break2.prototype), "insertInto", this).call(this, parent, ref);
            } else {
              this.remove();
            }
          }
        }, {
          key: "length",
          value: function length2() {
            return 0;
          }
        }, {
          key: "value",
          value: function value() {
            return "";
          }
        }], [{
          key: "value",
          value: function value() {
            return void 0;
          }
        }]);

        return Break2;
      }(_parchment2.default.Embed);

      Break.blotName = "break";
      Break.tagName = "BR";
      exports2.default = Break;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var linked_list_1 = __webpack_require__(44);

      var shadow_1 = __webpack_require__(30);

      var Registry = __webpack_require__(1);

      var ContainerBlot = function (_super) {
        __extends2(ContainerBlot2, _super);

        function ContainerBlot2(domNode) {
          var _this = _super.call(this, domNode) || this;

          _this.build();

          return _this;
        }

        ContainerBlot2.prototype.appendChild = function (other) {
          this.insertBefore(other);
        };

        ContainerBlot2.prototype.attach = function () {
          _super.prototype.attach.call(this);

          this.children.forEach(function (child) {
            child.attach();
          });
        };

        ContainerBlot2.prototype.build = function () {
          var _this = this;

          this.children = new linked_list_1.default();
          [].slice.call(this.domNode.childNodes).reverse().forEach(function (node2) {
            try {
              var child = makeBlot(node2);

              _this.insertBefore(child, _this.children.head || void 0);
            } catch (err) {
              if (err instanceof Registry.ParchmentError) return;else throw err;
            }
          });
        };

        ContainerBlot2.prototype.deleteAt = function (index2, length2) {
          if (index2 === 0 && length2 === this.length()) {
            return this.remove();
          }

          this.children.forEachAt(index2, length2, function (child, offset2, length3) {
            child.deleteAt(offset2, length3);
          });
        };

        ContainerBlot2.prototype.descendant = function (criteria, index2) {
          var _a2 = this.children.find(index2),
              child = _a2[0],
              offset2 = _a2[1];

          if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
            return [child, offset2];
          } else if (child instanceof ContainerBlot2) {
            return child.descendant(criteria, offset2);
          } else {
            return [null, -1];
          }
        };

        ContainerBlot2.prototype.descendants = function (criteria, index2, length2) {
          if (index2 === void 0) {
            index2 = 0;
          }

          if (length2 === void 0) {
            length2 = Number.MAX_VALUE;
          }

          var descendants = [];
          var lengthLeft = length2;
          this.children.forEachAt(index2, length2, function (child, index3, length3) {
            if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
              descendants.push(child);
            }

            if (child instanceof ContainerBlot2) {
              descendants = descendants.concat(child.descendants(criteria, index3, lengthLeft));
            }

            lengthLeft -= length3;
          });
          return descendants;
        };

        ContainerBlot2.prototype.detach = function () {
          this.children.forEach(function (child) {
            child.detach();
          });

          _super.prototype.detach.call(this);
        };

        ContainerBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          this.children.forEachAt(index2, length2, function (child, offset2, length3) {
            child.formatAt(offset2, length3, name2, value);
          });
        };

        ContainerBlot2.prototype.insertAt = function (index2, value, def) {
          var _a2 = this.children.find(index2),
              child = _a2[0],
              offset2 = _a2[1];

          if (child) {
            child.insertAt(offset2, value, def);
          } else {
            var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
            this.appendChild(blot);
          }
        };

        ContainerBlot2.prototype.insertBefore = function (childBlot, refBlot) {
          if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function (child) {
            return childBlot instanceof child;
          })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
          }

          childBlot.insertInto(this, refBlot);
        };

        ContainerBlot2.prototype.length = function () {
          return this.children.reduce(function (memo, child) {
            return memo + child.length();
          }, 0);
        };

        ContainerBlot2.prototype.moveChildren = function (targetParent, refNode) {
          this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
          });
        };

        ContainerBlot2.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);

          if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
              var child = Registry.create(this.statics.defaultChild);
              this.appendChild(child);
              child.optimize(context);
            } else {
              this.remove();
            }
          }
        };

        ContainerBlot2.prototype.path = function (index2, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }

          var _a2 = this.children.find(index2, inclusive),
              child = _a2[0],
              offset2 = _a2[1];

          var position2 = [[this, index2]];

          if (child instanceof ContainerBlot2) {
            return position2.concat(child.path(offset2, inclusive));
          } else if (child != null) {
            position2.push([child, offset2]);
          }

          return position2;
        };

        ContainerBlot2.prototype.removeChild = function (child) {
          this.children.remove(child);
        };

        ContainerBlot2.prototype.replace = function (target) {
          if (target instanceof ContainerBlot2) {
            target.moveChildren(this);
          }

          _super.prototype.replace.call(this, target);
        };

        ContainerBlot2.prototype.split = function (index2, force) {
          if (force === void 0) {
            force = false;
          }

          if (!force) {
            if (index2 === 0) return this;
            if (index2 === this.length()) return this.next;
          }

          var after = this.clone();
          this.parent.insertBefore(after, this.next);
          this.children.forEachAt(index2, this.length(), function (child, offset2, length2) {
            child = child.split(offset2, force);
            after.appendChild(child);
          });
          return after;
        };

        ContainerBlot2.prototype.unwrap = function () {
          this.moveChildren(this.parent, this.next);
          this.remove();
        };

        ContainerBlot2.prototype.update = function (mutations, context) {
          var _this = this;

          var addedNodes = [];
          var removedNodes = [];
          mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === "childList") {
              addedNodes.push.apply(addedNodes, mutation.addedNodes);
              removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
          });
          removedNodes.forEach(function (node2) {
            if (node2.parentNode != null && node2.tagName !== "IFRAME" && document.body.compareDocumentPosition(node2) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
              return;
            }

            var blot = Registry.find(node2);
            if (blot == null) return;

            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
              blot.detach();
            }
          });
          addedNodes.filter(function (node2) {
            return node2.parentNode == _this.domNode;
          }).sort(function (a, b2) {
            if (a === b2) return 0;

            if (a.compareDocumentPosition(b2) & Node.DOCUMENT_POSITION_FOLLOWING) {
              return 1;
            }

            return -1;
          }).forEach(function (node2) {
            var refBlot = null;

            if (node2.nextSibling != null) {
              refBlot = Registry.find(node2.nextSibling);
            }

            var blot = makeBlot(node2);

            if (blot.next != refBlot || blot.next == null) {
              if (blot.parent != null) {
                blot.parent.removeChild(_this);
              }

              _this.insertBefore(blot, refBlot || void 0);
            }
          });
        };

        return ContainerBlot2;
      }(shadow_1.default);

      function makeBlot(node2) {
        var blot = Registry.find(node2);

        if (blot == null) {
          try {
            blot = Registry.create(node2);
          } catch (e2) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node2.childNodes).forEach(function (child) {
              blot.domNode.appendChild(child);
            });

            if (node2.parentNode) {
              node2.parentNode.replaceChild(blot.domNode, node2);
            }

            blot.attach();
          }
        }

        return blot;
      }

      exports2.default = ContainerBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var attributor_1 = __webpack_require__(12);

      var store_1 = __webpack_require__(31);

      var container_1 = __webpack_require__(17);

      var Registry = __webpack_require__(1);

      var FormatBlot = function (_super) {
        __extends2(FormatBlot2, _super);

        function FormatBlot2(domNode) {
          var _this = _super.call(this, domNode) || this;

          _this.attributes = new store_1.default(_this.domNode);
          return _this;
        }

        FormatBlot2.formats = function (domNode) {
          if (typeof this.tagName === "string") {
            return true;
          } else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
          }

          return void 0;
        };

        FormatBlot2.prototype.format = function (name2, value) {
          var format = Registry.query(name2);

          if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
          } else if (value) {
            if (format != null && (name2 !== this.statics.blotName || this.formats()[name2] !== value)) {
              this.replaceWith(name2, value);
            }
          }
        };

        FormatBlot2.prototype.formats = function () {
          var formats2 = this.attributes.values();
          var format = this.statics.formats(this.domNode);

          if (format != null) {
            formats2[this.statics.blotName] = format;
          }

          return formats2;
        };

        FormatBlot2.prototype.replaceWith = function (name2, value) {
          var replacement = _super.prototype.replaceWith.call(this, name2, value);

          this.attributes.copy(replacement);
          return replacement;
        };

        FormatBlot2.prototype.update = function (mutations, context) {
          var _this = this;

          _super.prototype.update.call(this, mutations, context);

          if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === "attributes";
          })) {
            this.attributes.build();
          }
        };

        FormatBlot2.prototype.wrap = function (name2, value) {
          var wrapper = _super.prototype.wrap.call(this, name2, value);

          if (wrapper instanceof FormatBlot2 && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
          }

          return wrapper;
        };

        return FormatBlot2;
      }(container_1.default);

      exports2.default = FormatBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var shadow_1 = __webpack_require__(30);

      var Registry = __webpack_require__(1);

      var LeafBlot = function (_super) {
        __extends2(LeafBlot2, _super);

        function LeafBlot2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        LeafBlot2.value = function (domNode) {
          return true;
        };

        LeafBlot2.prototype.index = function (node2, offset2) {
          if (this.domNode === node2 || this.domNode.compareDocumentPosition(node2) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset2, 1);
          }

          return -1;
        };

        LeafBlot2.prototype.position = function (index2, inclusive) {
          var offset2 = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
          if (index2 > 0) offset2 += 1;
          return [this.parent.domNode, offset2];
        };

        LeafBlot2.prototype.value = function () {
          var _a2;

          return _a2 = {}, _a2[this.statics.blotName] = this.statics.value(this.domNode) || true, _a2;
        };

        LeafBlot2.scope = Registry.Scope.INLINE_BLOT;
        return LeafBlot2;
      }(shadow_1.default);

      exports2.default = LeafBlot;
    }, function (module2, exports2, __webpack_require__) {
      var equal = __webpack_require__(11);

      var extend2 = __webpack_require__(3);

      var lib2 = {
        attributes: {
          compose: function compose(a, b2, keepNull) {
            if (typeof a !== "object") a = {};
            if (typeof b2 !== "object") b2 = {};
            var attributes = extend2(true, {}, b2);

            if (!keepNull) {
              attributes = Object.keys(attributes).reduce(function (copy2, key2) {
                if (attributes[key2] != null) {
                  copy2[key2] = attributes[key2];
                }

                return copy2;
              }, {});
            }

            for (var key in a) {
              if (a[key] !== void 0 && b2[key] === void 0) {
                attributes[key] = a[key];
              }
            }

            return Object.keys(attributes).length > 0 ? attributes : void 0;
          },
          diff: function diff(a, b2) {
            if (typeof a !== "object") a = {};
            if (typeof b2 !== "object") b2 = {};
            var attributes = Object.keys(a).concat(Object.keys(b2)).reduce(function (attributes2, key) {
              if (!equal(a[key], b2[key])) {
                attributes2[key] = b2[key] === void 0 ? null : b2[key];
              }

              return attributes2;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : void 0;
          },
          transform: function transform(a, b2, priority) {
            if (typeof a !== "object") return b2;
            if (typeof b2 !== "object") return void 0;
            if (!priority) return b2;
            var attributes = Object.keys(b2).reduce(function (attributes2, key) {
              if (a[key] === void 0) attributes2[key] = b2[key];
              return attributes2;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : void 0;
          }
        },
        iterator: function iterator(ops) {
          return new Iterator(ops);
        },
        length: function length(op) {
          if (typeof op["delete"] === "number") {
            return op["delete"];
          } else if (typeof op.retain === "number") {
            return op.retain;
          } else {
            return typeof op.insert === "string" ? op.insert.length : 1;
          }
        }
      };

      function Iterator(ops) {
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
      }

      Iterator.prototype.hasNext = function () {
        return this.peekLength() < Infinity;
      };

      Iterator.prototype.next = function (length2) {
        if (!length2) length2 = Infinity;
        var nextOp = this.ops[this.index];

        if (nextOp) {
          var offset2 = this.offset;
          var opLength = lib2.length(nextOp);

          if (length2 >= opLength - offset2) {
            length2 = opLength - offset2;
            this.index += 1;
            this.offset = 0;
          } else {
            this.offset += length2;
          }

          if (typeof nextOp["delete"] === "number") {
            return {
              "delete": length2
            };
          } else {
            var retOp = {};

            if (nextOp.attributes) {
              retOp.attributes = nextOp.attributes;
            }

            if (typeof nextOp.retain === "number") {
              retOp.retain = length2;
            } else if (typeof nextOp.insert === "string") {
              retOp.insert = nextOp.insert.substr(offset2, length2);
            } else {
              retOp.insert = nextOp.insert;
            }

            return retOp;
          }
        } else {
          return {
            retain: Infinity
          };
        }
      };

      Iterator.prototype.peek = function () {
        return this.ops[this.index];
      };

      Iterator.prototype.peekLength = function () {
        if (this.ops[this.index]) {
          return lib2.length(this.ops[this.index]) - this.offset;
        } else {
          return Infinity;
        }
      };

      Iterator.prototype.peekType = function () {
        if (this.ops[this.index]) {
          if (typeof this.ops[this.index]["delete"] === "number") {
            return "delete";
          } else if (typeof this.ops[this.index].retain === "number") {
            return "retain";
          } else {
            return "insert";
          }
        }

        return "retain";
      };

      Iterator.prototype.rest = function () {
        if (!this.hasNext()) {
          return [];
        } else if (this.offset === 0) {
          return this.ops.slice(this.index);
        } else {
          var offset2 = this.offset;
          var index2 = this.index;
          var next2 = this.next();
          var rest = this.ops.slice(this.index);
          this.offset = offset2;
          this.index = index2;
          return [next2].concat(rest);
        }
      };

      module2.exports = lib2;
    }, function (module2, exports2) {
      var clone = function () {
        function _instanceof(obj, type) {
          return type != null && obj instanceof type;
        }

        var nativeMap;

        try {
          nativeMap = Map;
        } catch (_2) {
          nativeMap = function nativeMap() {};
        }

        var nativeSet;

        try {
          nativeSet = Set;
        } catch (_2) {
          nativeSet = function nativeSet() {};
        }

        var nativePromise;

        try {
          nativePromise = Promise;
        } catch (_2) {
          nativePromise = function nativePromise() {};
        }

        function clone2(parent, circular, depth, prototype, includeNonEnumerable) {
          if (typeof circular === "object") {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
          }

          var allParents = [];
          var allChildren = [];
          var useBuffer = typeof Buffer != "undefined";
          if (typeof circular == "undefined") circular = true;
          if (typeof depth == "undefined") depth = Infinity;

          function _clone(parent2, depth2) {
            if (parent2 === null) return null;
            if (depth2 === 0) return parent2;
            var child;
            var proto;

            if (typeof parent2 != "object") {
              return parent2;
            }

            if (_instanceof(parent2, nativeMap)) {
              child = new nativeMap();
            } else if (_instanceof(parent2, nativeSet)) {
              child = new nativeSet();
            } else if (_instanceof(parent2, nativePromise)) {
              child = new nativePromise(function (resolve, reject) {
                parent2.then(function (value) {
                  resolve(_clone(value, depth2 - 1));
                }, function (err) {
                  reject(_clone(err, depth2 - 1));
                });
              });
            } else if (clone2.__isArray(parent2)) {
              child = [];
            } else if (clone2.__isRegExp(parent2)) {
              child = new RegExp(parent2.source, __getRegExpFlags(parent2));
              if (parent2.lastIndex) child.lastIndex = parent2.lastIndex;
            } else if (clone2.__isDate(parent2)) {
              child = new Date(parent2.getTime());
            } else if (useBuffer && Buffer.isBuffer(parent2)) {
              if (Buffer.allocUnsafe) {
                child = Buffer.allocUnsafe(parent2.length);
              } else {
                child = new Buffer(parent2.length);
              }

              parent2.copy(child);
              return child;
            } else if (_instanceof(parent2, Error)) {
              child = Object.create(parent2);
            } else {
              if (typeof prototype == "undefined") {
                proto = Object.getPrototypeOf(parent2);
                child = Object.create(proto);
              } else {
                child = Object.create(prototype);
                proto = prototype;
              }
            }

            if (circular) {
              var index2 = allParents.indexOf(parent2);

              if (index2 != -1) {
                return allChildren[index2];
              }

              allParents.push(parent2);
              allChildren.push(child);
            }

            if (_instanceof(parent2, nativeMap)) {
              parent2.forEach(function (value, key) {
                var keyChild = _clone(key, depth2 - 1);

                var valueChild = _clone(value, depth2 - 1);

                child.set(keyChild, valueChild);
              });
            }

            if (_instanceof(parent2, nativeSet)) {
              parent2.forEach(function (value) {
                var entryChild = _clone(value, depth2 - 1);

                child.add(entryChild);
              });
            }

            for (var i in parent2) {
              var attrs;

              if (proto) {
                attrs = Object.getOwnPropertyDescriptor(proto, i);
              }

              if (attrs && attrs.set == null) {
                continue;
              }

              child[i] = _clone(parent2[i], depth2 - 1);
            }

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(parent2);

              for (var i = 0; i < symbols.length; i++) {
                var symbol = symbols[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent2, symbol);

                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                  continue;
                }

                child[symbol] = _clone(parent2[symbol], depth2 - 1);

                if (!descriptor.enumerable) {
                  Object.defineProperty(child, symbol, {
                    enumerable: false
                  });
                }
              }
            }

            if (includeNonEnumerable) {
              var allPropertyNames = Object.getOwnPropertyNames(parent2);

              for (var i = 0; i < allPropertyNames.length; i++) {
                var propertyName = allPropertyNames[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent2, propertyName);

                if (descriptor && descriptor.enumerable) {
                  continue;
                }

                child[propertyName] = _clone(parent2[propertyName], depth2 - 1);
                Object.defineProperty(child, propertyName, {
                  enumerable: false
                });
              }
            }

            return child;
          }

          return _clone(parent, depth);
        }

        clone2.clonePrototype = function clonePrototype(parent) {
          if (parent === null) return null;

          var c2 = function c2() {};

          c2.prototype = parent;
          return new c2();
        };

        function __objToStr(o) {
          return Object.prototype.toString.call(o);
        }

        clone2.__objToStr = __objToStr;

        function __isDate(o) {
          return typeof o === "object" && __objToStr(o) === "[object Date]";
        }

        clone2.__isDate = __isDate;

        function __isArray(o) {
          return typeof o === "object" && __objToStr(o) === "[object Array]";
        }

        clone2.__isArray = __isArray;

        function __isRegExp(o) {
          return typeof o === "object" && __objToStr(o) === "[object RegExp]";
        }

        clone2.__isRegExp = __isRegExp;

        function __getRegExpFlags(re2) {
          var flags = "";
          if (re2.global) flags += "g";
          if (re2.ignoreCase) flags += "i";
          if (re2.multiline) flags += "m";
          return flags;
        }

        clone2.__getRegExpFlags = __getRegExpFlags;
        return clone2;
      }();

      if (typeof module2 === "object" && module2.exports) {
        module2.exports = clone;
      }
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function isLine(blot) {
        return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
      }

      var Scroll = function (_Parchment$Scroll) {
        _inherits2(Scroll2, _Parchment$Scroll);

        function Scroll2(domNode, config) {
          _classCallCheck2(this, Scroll2);

          var _this = _possibleConstructorReturn2(this, (Scroll2.__proto__ || Object.getPrototypeOf(Scroll2)).call(this, domNode));

          _this.emitter = config.emitter;

          if (Array.isArray(config.whitelist)) {
            _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
              whitelist[format] = true;
              return whitelist;
            }, {});
          }

          _this.domNode.addEventListener("DOMNodeInserted", function () {});

          _this.optimize();

          _this.enable();

          return _this;
        }

        _createClass2(Scroll2, [{
          key: "batchStart",
          value: function batchStart() {
            this.batch = true;
          }
        }, {
          key: "batchEnd",
          value: function batchEnd() {
            this.batch = false;
            this.optimize();
          }
        }, {
          key: "deleteAt",
          value: function deleteAt(index2, length2) {
            var _line = this.line(index2),
                _line2 = _slicedToArray2(_line, 2),
                first = _line2[0],
                offset2 = _line2[1];

            var _line3 = this.line(index2 + length2),
                _line4 = _slicedToArray2(_line3, 1),
                last = _line4[0];

            _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "deleteAt", this).call(this, index2, length2);

            if (last != null && first !== last && offset2 > 0) {
              if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                this.optimize();
                return;
              }

              if (first instanceof _code2.default) {
                var newlineIndex = first.newlineIndex(first.length(), true);

                if (newlineIndex > -1) {
                  first = first.split(newlineIndex + 1);

                  if (first === last) {
                    this.optimize();
                    return;
                  }
                }
              } else if (last instanceof _code2.default) {
                var _newlineIndex = last.newlineIndex(0);

                if (_newlineIndex > -1) {
                  last.split(_newlineIndex + 1);
                }
              }

              var ref = last.children.head instanceof _break2.default ? null : last.children.head;
              first.moveChildren(last, ref);
              first.remove();
            }

            this.optimize();
          }
        }, {
          key: "enable",
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            this.domNode.setAttribute("contenteditable", enabled);
          }
        }, {
          key: "formatAt",
          value: function formatAt(index2, length2, format, value) {
            if (this.whitelist != null && !this.whitelist[format]) return;

            _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "formatAt", this).call(this, index2, length2, format, value);

            this.optimize();
          }
        }, {
          key: "insertAt",
          value: function insertAt(index2, value, def) {
            if (def != null && this.whitelist != null && !this.whitelist[value]) return;

            if (index2 >= this.length()) {
              if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                var blot = _parchment2.default.create(this.statics.defaultChild);

                this.appendChild(blot);

                if (def == null && value.endsWith("\n")) {
                  value = value.slice(0, -1);
                }

                blot.insertAt(0, value, def);
              } else {
                var embed = _parchment2.default.create(value, def);

                this.appendChild(embed);
              }
            } else {
              _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertAt", this).call(this, index2, value, def);
            }

            this.optimize();
          }
        }, {
          key: "insertBefore",
          value: function insertBefore(blot, ref) {
            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
              var wrapper = _parchment2.default.create(this.statics.defaultChild);

              wrapper.appendChild(blot);
              blot = wrapper;
            }

            _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertBefore", this).call(this, blot, ref);
          }
        }, {
          key: "leaf",
          value: function leaf(index2) {
            return this.path(index2).pop() || [null, -1];
          }
        }, {
          key: "line",
          value: function line2(index2) {
            if (index2 === this.length()) {
              return this.line(index2 - 1);
            }

            return this.descendant(isLine, index2);
          }
        }, {
          key: "lines",
          value: function lines() {
            var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var length2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;

            var getLines = function getLines2(blot, index3, length3) {
              var lines2 = [],
                  lengthLeft = length3;
              blot.children.forEachAt(index3, length3, function (child, index4, length4) {
                if (isLine(child)) {
                  lines2.push(child);
                } else if (child instanceof _parchment2.default.Container) {
                  lines2 = lines2.concat(getLines2(child, index4, lengthLeft));
                }

                lengthLeft -= length4;
              });
              return lines2;
            };

            return getLines(this, index2, length2);
          }
        }, {
          key: "optimize",
          value: function optimize() {
            var mutations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (this.batch === true) return;

            _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "optimize", this).call(this, mutations, context);

            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
            }
          }
        }, {
          key: "path",
          value: function path(index2) {
            return _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "path", this).call(this, index2).slice(1);
          }
        }, {
          key: "update",
          value: function update(mutations) {
            if (this.batch === true) return;
            var source2 = _emitter2.default.sources.USER;

            if (typeof mutations === "string") {
              source2 = mutations;
            }

            if (!Array.isArray(mutations)) {
              mutations = this.observer.takeRecords();
            }

            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source2, mutations);
            }

            _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "update", this).call(this, mutations.concat([]));

            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source2, mutations);
            }
          }
        }]);

        return Scroll2;
      }(_parchment2.default.Scroll);

      Scroll.blotName = "scroll";
      Scroll.className = "ql-editor";
      Scroll.tagName = "DIV";
      Scroll.defaultChild = "block";
      Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
      exports2.default = Scroll;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.SHORTKEY = exports2.default = void 0;

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)("quill:keyboard");
      var SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";

      var Keyboard = function (_Module) {
        _inherits2(Keyboard2, _Module);

        _createClass2(Keyboard2, null, [{
          key: "match",
          value: function match2(evt, binding) {
            binding = normalize(binding);

            if (["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function (key) {
              return !!binding[key] !== evt[key] && binding[key] !== null;
            })) {
              return false;
            }

            return binding.key === (evt.which || evt.keyCode);
          }
        }]);

        function Keyboard2(quill2, options2) {
          _classCallCheck2(this, Keyboard2);

          var _this = _possibleConstructorReturn2(this, (Keyboard2.__proto__ || Object.getPrototypeOf(Keyboard2)).call(this, quill2, options2));

          _this.bindings = {};
          Object.keys(_this.options.bindings).forEach(function (name2) {
            if (name2 === "list autofill" && quill2.scroll.whitelist != null && !quill2.scroll.whitelist["list"]) {
              return;
            }

            if (_this.options.bindings[name2]) {
              _this.addBinding(_this.options.bindings[name2]);
            }
          });

          _this.addBinding({
            key: Keyboard2.keys.ENTER,
            shiftKey: null
          }, handleEnter);

          _this.addBinding({
            key: Keyboard2.keys.ENTER,
            metaKey: null,
            ctrlKey: null,
            altKey: null
          }, function () {});

          if (/Firefox/i.test(navigator.userAgent)) {
            _this.addBinding({
              key: Keyboard2.keys.BACKSPACE
            }, {
              collapsed: true
            }, handleBackspace);

            _this.addBinding({
              key: Keyboard2.keys.DELETE
            }, {
              collapsed: true
            }, handleDelete);
          } else {
            _this.addBinding({
              key: Keyboard2.keys.BACKSPACE
            }, {
              collapsed: true,
              prefix: /^.?$/
            }, handleBackspace);

            _this.addBinding({
              key: Keyboard2.keys.DELETE
            }, {
              collapsed: true,
              suffix: /^.?$/
            }, handleDelete);
          }

          _this.addBinding({
            key: Keyboard2.keys.BACKSPACE
          }, {
            collapsed: false
          }, handleDeleteRange);

          _this.addBinding({
            key: Keyboard2.keys.DELETE
          }, {
            collapsed: false
          }, handleDeleteRange);

          _this.addBinding({
            key: Keyboard2.keys.BACKSPACE,
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
          }, {
            collapsed: true,
            offset: 0
          }, handleBackspace);

          _this.listen();

          return _this;
        }

        _createClass2(Keyboard2, [{
          key: "addBinding",
          value: function addBinding(key) {
            var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var handler = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var binding = normalize(key);

            if (binding == null || binding.key == null) {
              return debug.warn("Attempted to add invalid keyboard binding", binding);
            }

            if (typeof context === "function") {
              context = {
                handler: context
              };
            }

            if (typeof handler === "function") {
              handler = {
                handler: handler
              };
            }

            binding = (0, _extend2.default)(binding, context, handler);
            this.bindings[binding.key] = this.bindings[binding.key] || [];
            this.bindings[binding.key].push(binding);
          }
        }, {
          key: "listen",
          value: function listen() {
            var _this2 = this;

            this.quill.root.addEventListener("keydown", function (evt) {
              if (evt.defaultPrevented) return;
              var which = evt.which || evt.keyCode;
              var bindings = (_this2.bindings[which] || []).filter(function (binding) {
                return Keyboard2.match(evt, binding);
              });
              if (bindings.length === 0) return;

              var range2 = _this2.quill.getSelection();

              if (range2 == null || !_this2.quill.hasFocus()) return;

              var _quill$getLine = _this2.quill.getLine(range2.index),
                  _quill$getLine2 = _slicedToArray2(_quill$getLine, 2),
                  line2 = _quill$getLine2[0],
                  offset2 = _quill$getLine2[1];

              var _quill$getLeaf = _this2.quill.getLeaf(range2.index),
                  _quill$getLeaf2 = _slicedToArray2(_quill$getLeaf, 2),
                  leafStart = _quill$getLeaf2[0],
                  offsetStart = _quill$getLeaf2[1];

              var _ref3 = range2.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range2.index + range2.length),
                  _ref22 = _slicedToArray2(_ref3, 2),
                  leafEnd = _ref22[0],
                  offsetEnd = _ref22[1];

              var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : "";
              var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : "";
              var curContext = {
                collapsed: range2.length === 0,
                empty: range2.length === 0 && line2.length() <= 1,
                format: _this2.quill.getFormat(range2),
                offset: offset2,
                prefix: prefixText,
                suffix: suffixText
              };
              var prevented = bindings.some(function (binding) {
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;

                if (Array.isArray(binding.format)) {
                  if (binding.format.every(function (name2) {
                    return curContext.format[name2] == null;
                  })) {
                    return false;
                  }
                } else if (_typeof2(binding.format) === "object") {
                  if (!Object.keys(binding.format).every(function (name2) {
                    if (binding.format[name2] === true) return curContext.format[name2] != null;
                    if (binding.format[name2] === false) return curContext.format[name2] == null;
                    return (0, _deepEqual2.default)(binding.format[name2], curContext.format[name2]);
                  })) {
                    return false;
                  }
                }

                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                return binding.handler.call(_this2, range2, curContext) !== true;
              });

              if (prevented) {
                evt.preventDefault();
              }
            });
          }
        }]);

        return Keyboard2;
      }(_module2.default);

      Keyboard.keys = {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46
      };
      Keyboard.DEFAULTS = {
        bindings: {
          "bold": makeFormatHandler("bold"),
          "italic": makeFormatHandler("italic"),
          "underline": makeFormatHandler("underline"),
          "indent": {
            key: Keyboard.keys.TAB,
            format: ["blockquote", "indent", "list"],
            handler: function handler(range2, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format("indent", "+1", _quill2.default.sources.USER);
            }
          },
          "outdent": {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            format: ["blockquote", "indent", "list"],
            handler: function handler(range2, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format("indent", "-1", _quill2.default.sources.USER);
            }
          },
          "outdent backspace": {
            key: Keyboard.keys.BACKSPACE,
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: ["indent", "list"],
            offset: 0,
            handler: function handler(range2, context) {
              if (context.format.indent != null) {
                this.quill.format("indent", "-1", _quill2.default.sources.USER);
              } else if (context.format.list != null) {
                this.quill.format("list", false, _quill2.default.sources.USER);
              }
            }
          },
          "indent code-block": makeCodeBlockHandler(true),
          "outdent code-block": makeCodeBlockHandler(false),
          "remove tab": {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler: function handler(range2) {
              this.quill.deleteText(range2.index - 1, 1, _quill2.default.sources.USER);
            }
          },
          "tab": {
            key: Keyboard.keys.TAB,
            handler: function handler(range2) {
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range2.index).delete(range2.length).insert("	");
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range2.index + 1, _quill2.default.sources.SILENT);
            }
          },
          "list empty enter": {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ["list"],
            empty: true,
            handler: function handler(range2, context) {
              this.quill.format("list", false, _quill2.default.sources.USER);

              if (context.format.indent) {
                this.quill.format("indent", false, _quill2.default.sources.USER);
              }
            }
          },
          "checklist enter": {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: {
              list: "checked"
            },
            handler: function handler(range2) {
              var _quill$getLine3 = this.quill.getLine(range2.index),
                  _quill$getLine4 = _slicedToArray2(_quill$getLine3, 2),
                  line2 = _quill$getLine4[0],
                  offset2 = _quill$getLine4[1];

              var formats2 = (0, _extend2.default)({}, line2.formats(), {
                list: "checked"
              });
              var delta = new _quillDelta2.default().retain(range2.index).insert("\n", formats2).retain(line2.length() - offset2 - 1).retain(1, {
                list: "unchecked"
              });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range2.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          "header enter": {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ["header"],
            suffix: /^$/,
            handler: function handler(range2, context) {
              var _quill$getLine5 = this.quill.getLine(range2.index),
                  _quill$getLine6 = _slicedToArray2(_quill$getLine5, 2),
                  line2 = _quill$getLine6[0],
                  offset2 = _quill$getLine6[1];

              var delta = new _quillDelta2.default().retain(range2.index).insert("\n", context.format).retain(line2.length() - offset2 - 1).retain(1, {
                header: null
              });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range2.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          "list autofill": {
            key: " ",
            collapsed: true,
            format: {
              list: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler: function handler(range2, context) {
              var length2 = context.prefix.length;

              var _quill$getLine7 = this.quill.getLine(range2.index),
                  _quill$getLine8 = _slicedToArray2(_quill$getLine7, 2),
                  line2 = _quill$getLine8[0],
                  offset2 = _quill$getLine8[1];

              if (offset2 > length2) return true;
              var value = void 0;

              switch (context.prefix.trim()) {
                case "[]":
                case "[ ]":
                  value = "unchecked";
                  break;

                case "[x]":
                  value = "checked";
                  break;

                case "-":
                case "*":
                  value = "bullet";
                  break;

                default:
                  value = "ordered";
              }

              this.quill.insertText(range2.index, " ", _quill2.default.sources.USER);
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range2.index - offset2).delete(length2 + 1).retain(line2.length() - 2 - offset2).retain(1, {
                list: value
              });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range2.index - length2, _quill2.default.sources.SILENT);
            }
          },
          "code exit": {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ["code-block"],
            prefix: /\n\n$/,
            suffix: /^\s+$/,
            handler: function handler(range2) {
              var _quill$getLine9 = this.quill.getLine(range2.index),
                  _quill$getLine10 = _slicedToArray2(_quill$getLine9, 2),
                  line2 = _quill$getLine10[0],
                  offset2 = _quill$getLine10[1];

              var delta = new _quillDelta2.default().retain(range2.index + line2.length() - offset2 - 2).retain(1, {
                "code-block": null
              }).delete(1);
              this.quill.updateContents(delta, _quill2.default.sources.USER);
            }
          },
          "embed left": makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
          "embed left shift": makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
          "embed right": makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
          "embed right shift": makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
        }
      };

      function makeEmbedArrowHandler(key, shiftKey) {
        var _ref3;

        var where = key === Keyboard.keys.LEFT ? "prefix" : "suffix";
        return _ref3 = {
          key: key,
          shiftKey: shiftKey,
          altKey: null
        }, _defineProperty2(_ref3, where, /^$/), _defineProperty2(_ref3, "handler", function handler(range2) {
          var index2 = range2.index;

          if (key === Keyboard.keys.RIGHT) {
            index2 += range2.length + 1;
          }

          var _quill$getLeaf3 = this.quill.getLeaf(index2),
              _quill$getLeaf4 = _slicedToArray2(_quill$getLeaf3, 1),
              leaf = _quill$getLeaf4[0];

          if (!(leaf instanceof _parchment2.default.Embed)) return true;

          if (key === Keyboard.keys.LEFT) {
            if (shiftKey) {
              this.quill.setSelection(range2.index - 1, range2.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range2.index - 1, _quill2.default.sources.USER);
            }
          } else {
            if (shiftKey) {
              this.quill.setSelection(range2.index, range2.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range2.index + range2.length + 1, _quill2.default.sources.USER);
            }
          }

          return false;
        }), _ref3;
      }

      function handleBackspace(range2, context) {
        if (range2.index === 0 || this.quill.getLength() <= 1) return;

        var _quill$getLine11 = this.quill.getLine(range2.index),
            _quill$getLine12 = _slicedToArray2(_quill$getLine11, 1),
            line2 = _quill$getLine12[0];

        var formats2 = {};

        if (context.offset === 0) {
          var _quill$getLine13 = this.quill.getLine(range2.index - 1),
              _quill$getLine14 = _slicedToArray2(_quill$getLine13, 1),
              prev2 = _quill$getLine14[0];

          if (prev2 != null && prev2.length() > 1) {
            var curFormats = line2.formats();
            var prevFormats = this.quill.getFormat(range2.index - 1, 1);
            formats2 = _op2.default.attributes.diff(curFormats, prevFormats) || {};
          }
        }

        var length2 = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        this.quill.deleteText(range2.index - length2, length2, _quill2.default.sources.USER);

        if (Object.keys(formats2).length > 0) {
          this.quill.formatLine(range2.index - length2, length2, formats2, _quill2.default.sources.USER);
        }

        this.quill.focus();
      }

      function handleDelete(range2, context) {
        var length2 = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range2.index >= this.quill.getLength() - length2) return;
        var formats2 = {},
            nextLength = 0;

        var _quill$getLine15 = this.quill.getLine(range2.index),
            _quill$getLine16 = _slicedToArray2(_quill$getLine15, 1),
            line2 = _quill$getLine16[0];

        if (context.offset >= line2.length() - 1) {
          var _quill$getLine17 = this.quill.getLine(range2.index + 1),
              _quill$getLine18 = _slicedToArray2(_quill$getLine17, 1),
              next2 = _quill$getLine18[0];

          if (next2) {
            var curFormats = line2.formats();
            var nextFormats = this.quill.getFormat(range2.index, 1);
            formats2 = _op2.default.attributes.diff(curFormats, nextFormats) || {};
            nextLength = next2.length();
          }
        }

        this.quill.deleteText(range2.index, length2, _quill2.default.sources.USER);

        if (Object.keys(formats2).length > 0) {
          this.quill.formatLine(range2.index + nextLength - 1, length2, formats2, _quill2.default.sources.USER);
        }
      }

      function handleDeleteRange(range2) {
        var lines = this.quill.getLines(range2);
        var formats2 = {};

        if (lines.length > 1) {
          var firstFormats = lines[0].formats();
          var lastFormats = lines[lines.length - 1].formats();
          formats2 = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
        }

        this.quill.deleteText(range2, _quill2.default.sources.USER);

        if (Object.keys(formats2).length > 0) {
          this.quill.formatLine(range2.index, 1, formats2, _quill2.default.sources.USER);
        }

        this.quill.setSelection(range2.index, _quill2.default.sources.SILENT);
        this.quill.focus();
      }

      function handleEnter(range2, context) {
        var _this3 = this;

        if (range2.length > 0) {
          this.quill.scroll.deleteAt(range2.index, range2.length);
        }

        var lineFormats = Object.keys(context.format).reduce(function (lineFormats2, format) {
          if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
            lineFormats2[format] = context.format[format];
          }

          return lineFormats2;
        }, {});
        this.quill.insertText(range2.index, "\n", lineFormats, _quill2.default.sources.USER);
        this.quill.setSelection(range2.index + 1, _quill2.default.sources.SILENT);
        this.quill.focus();
        Object.keys(context.format).forEach(function (name2) {
          if (lineFormats[name2] != null) return;
          if (Array.isArray(context.format[name2])) return;
          if (name2 === "link") return;

          _this3.quill.format(name2, context.format[name2], _quill2.default.sources.USER);
        });
      }

      function makeCodeBlockHandler(indent) {
        return {
          key: Keyboard.keys.TAB,
          shiftKey: !indent,
          format: {
            "code-block": true
          },
          handler: function handler(range2) {
            var CodeBlock = _parchment2.default.query("code-block");

            var index2 = range2.index,
                length2 = range2.length;

            var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index2),
                _quill$scroll$descend2 = _slicedToArray2(_quill$scroll$descend, 2),
                block = _quill$scroll$descend2[0],
                offset2 = _quill$scroll$descend2[1];

            if (block == null) return;
            var scrollIndex = this.quill.getIndex(block);
            var start2 = block.newlineIndex(offset2, true) + 1;
            var end2 = block.newlineIndex(scrollIndex + offset2 + length2);
            var lines = block.domNode.textContent.slice(start2, end2).split("\n");
            offset2 = 0;
            lines.forEach(function (line2, i) {
              if (indent) {
                block.insertAt(start2 + offset2, CodeBlock.TAB);
                offset2 += CodeBlock.TAB.length;

                if (i === 0) {
                  index2 += CodeBlock.TAB.length;
                } else {
                  length2 += CodeBlock.TAB.length;
                }
              } else if (line2.startsWith(CodeBlock.TAB)) {
                block.deleteAt(start2 + offset2, CodeBlock.TAB.length);
                offset2 -= CodeBlock.TAB.length;

                if (i === 0) {
                  index2 -= CodeBlock.TAB.length;
                } else {
                  length2 -= CodeBlock.TAB.length;
                }
              }

              offset2 += line2.length + 1;
            });
            this.quill.update(_quill2.default.sources.USER);
            this.quill.setSelection(index2, length2, _quill2.default.sources.SILENT);
          }
        };
      }

      function makeFormatHandler(format) {
        return {
          key: format[0].toUpperCase(),
          shortKey: true,
          handler: function handler(range2, context) {
            this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
          }
        };
      }

      function normalize(binding) {
        if (typeof binding === "string" || typeof binding === "number") {
          return normalize({
            key: binding
          });
        }

        if ((typeof binding === "undefined" ? "undefined" : _typeof2(binding)) === "object") {
          binding = (0, _clone2.default)(binding, false);
        }

        if (typeof binding.key === "string") {
          if (Keyboard.keys[binding.key.toUpperCase()] != null) {
            binding.key = Keyboard.keys[binding.key.toUpperCase()];
          } else if (binding.key.length === 1) {
            binding.key = binding.key.toUpperCase().charCodeAt(0);
          } else {
            return null;
          }
        }

        if (binding.shortKey) {
          binding[SHORTKEY] = binding.shortKey;
          delete binding.shortKey;
        }

        return binding;
      }

      exports2.default = Keyboard;
      exports2.SHORTKEY = SHORTKEY;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Cursor = function (_Parchment$Embed) {
        _inherits2(Cursor2, _Parchment$Embed);

        _createClass2(Cursor2, null, [{
          key: "value",
          value: function value() {
            return void 0;
          }
        }]);

        function Cursor2(domNode, selection) {
          _classCallCheck2(this, Cursor2);

          var _this = _possibleConstructorReturn2(this, (Cursor2.__proto__ || Object.getPrototypeOf(Cursor2)).call(this, domNode));

          _this.selection = selection;
          _this.textNode = document.createTextNode(Cursor2.CONTENTS);

          _this.domNode.appendChild(_this.textNode);

          _this._length = 0;
          return _this;
        }

        _createClass2(Cursor2, [{
          key: "detach",
          value: function detach() {
            if (this.parent != null) this.parent.removeChild(this);
          }
        }, {
          key: "format",
          value: function format(name2, value) {
            if (this._length !== 0) {
              return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "format", this).call(this, name2, value);
            }

            var target = this,
                index2 = 0;

            while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
              index2 += target.offset(target.parent);
              target = target.parent;
            }

            if (target != null) {
              this._length = Cursor2.CONTENTS.length;
              target.optimize();
              target.formatAt(index2, Cursor2.CONTENTS.length, name2, value);
              this._length = 0;
            }
          }
        }, {
          key: "index",
          value: function index2(node2, offset2) {
            if (node2 === this.textNode) return 0;
            return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "index", this).call(this, node2, offset2);
          }
        }, {
          key: "length",
          value: function length2() {
            return this._length;
          }
        }, {
          key: "position",
          value: function position2() {
            return [this.textNode, this.textNode.data.length];
          }
        }, {
          key: "remove",
          value: function remove() {
            _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "remove", this).call(this);

            this.parent = null;
          }
        }, {
          key: "restore",
          value: function restore() {
            if (this.selection.composing || this.parent == null) return;
            var textNode = this.textNode;
            var range2 = this.selection.getNativeRange();
            var restoreText = void 0,
                start2 = void 0,
                end2 = void 0;

            if (range2 != null && range2.start.node === textNode && range2.end.node === textNode) {
              var _ref3 = [textNode, range2.start.offset, range2.end.offset];
              restoreText = _ref3[0];
              start2 = _ref3[1];
              end2 = _ref3[2];
            }

            while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
              this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
            }

            if (this.textNode.data !== Cursor2.CONTENTS) {
              var text = this.textNode.data.split(Cursor2.CONTENTS).join("");

              if (this.next instanceof _text2.default) {
                restoreText = this.next.domNode;
                this.next.insertAt(0, text);
                this.textNode.data = Cursor2.CONTENTS;
              } else {
                this.textNode.data = text;
                this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                this.textNode = document.createTextNode(Cursor2.CONTENTS);
                this.domNode.appendChild(this.textNode);
              }
            }

            this.remove();

            if (start2 != null) {
              var _map = [start2, end2].map(function (offset2) {
                return Math.max(0, Math.min(restoreText.data.length, offset2 - 1));
              });

              var _map2 = _slicedToArray2(_map, 2);

              start2 = _map2[0];
              end2 = _map2[1];
              return {
                startNode: restoreText,
                startOffset: start2,
                endNode: restoreText,
                endOffset: end2
              };
            }
          }
        }, {
          key: "update",
          value: function update(mutations, context) {
            var _this2 = this;

            if (mutations.some(function (mutation) {
              return mutation.type === "characterData" && mutation.target === _this2.textNode;
            })) {
              var range2 = this.restore();
              if (range2) context.range = range2;
            }
          }
        }, {
          key: "value",
          value: function value() {
            return "";
          }
        }]);

        return Cursor2;
      }(_parchment2.default.Embed);

      Cursor.blotName = "cursor";
      Cursor.className = "ql-cursor";
      Cursor.tagName = "span";
      Cursor.CONTENTS = "\uFEFF";
      exports2.default = Cursor;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Container = function (_Parchment$Container) {
        _inherits2(Container2, _Parchment$Container);

        function Container2() {
          _classCallCheck2(this, Container2);

          return _possibleConstructorReturn2(this, (Container2.__proto__ || Object.getPrototypeOf(Container2)).apply(this, arguments));
        }

        return Container2;
      }(_parchment2.default.Container);

      Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
      exports2.default = Container;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ColorStyle = exports2.ColorClass = exports2.ColorAttributor = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorAttributor = function (_Parchment$Attributor) {
        _inherits2(ColorAttributor2, _Parchment$Attributor);

        function ColorAttributor2() {
          _classCallCheck2(this, ColorAttributor2);

          return _possibleConstructorReturn2(this, (ColorAttributor2.__proto__ || Object.getPrototypeOf(ColorAttributor2)).apply(this, arguments));
        }

        _createClass2(ColorAttributor2, [{
          key: "value",
          value: function value(domNode) {
            var value2 = _get(ColorAttributor2.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor2.prototype), "value", this).call(this, domNode);

            if (!value2.startsWith("rgb(")) return value2;
            value2 = value2.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
            return "#" + value2.split(",").map(function (component) {
              return ("00" + parseInt(component).toString(16)).slice(-2);
            }).join("");
          }
        }]);

        return ColorAttributor2;
      }(_parchment2.default.Attributor.Style);

      var ColorClass = new _parchment2.default.Attributor.Class("color", "ql-color", {
        scope: _parchment2.default.Scope.INLINE
      });
      var ColorStyle = new ColorAttributor("color", "color", {
        scope: _parchment2.default.Scope.INLINE
      });
      exports2.ColorAttributor = ColorAttributor;
      exports2.ColorClass = ColorClass;
      exports2.ColorStyle = ColorStyle;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.sanitize = exports2.default = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Link = function (_Inline) {
        _inherits2(Link2, _Inline);

        function Link2() {
          _classCallCheck2(this, Link2);

          return _possibleConstructorReturn2(this, (Link2.__proto__ || Object.getPrototypeOf(Link2)).apply(this, arguments));
        }

        _createClass2(Link2, [{
          key: "format",
          value: function format(name2, value) {
            if (name2 !== this.statics.blotName || !value) return _get(Link2.prototype.__proto__ || Object.getPrototypeOf(Link2.prototype), "format", this).call(this, name2, value);
            value = this.constructor.sanitize(value);
            this.domNode.setAttribute("href", value);
          }
        }], [{
          key: "create",
          value: function create(value) {
            var node2 = _get(Link2.__proto__ || Object.getPrototypeOf(Link2), "create", this).call(this, value);

            value = this.sanitize(value);
            node2.setAttribute("href", value);
            node2.setAttribute("rel", "noopener noreferrer");
            node2.setAttribute("target", "_blank");
            return node2;
          }
        }, {
          key: "formats",
          value: function formats2(domNode) {
            return domNode.getAttribute("href");
          }
        }, {
          key: "sanitize",
          value: function sanitize(url) {
            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
          }
        }]);

        return Link2;
      }(_inline2.default);

      Link.blotName = "link";
      Link.tagName = "A";
      Link.SANITIZED_URL = "about:blank";
      Link.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];

      function _sanitize(url, protocols) {
        var anchor = document.createElement("a");
        anchor.href = url;
        var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
        return protocols.indexOf(protocol) > -1;
      }

      exports2.default = Link;
      exports2.sanitize = _sanitize;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      var _dropdown = __webpack_require__(107);

      var _dropdown2 = _interopRequireDefault(_dropdown);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var optionsCounter = 0;

      function toggleAriaAttribute(element, attribute) {
        element.setAttribute(attribute, !(element.getAttribute(attribute) === "true"));
      }

      var Picker = function () {
        function Picker2(select) {
          var _this = this;

          _classCallCheck2(this, Picker2);

          this.select = select;
          this.container = document.createElement("span");
          this.buildPicker();
          this.select.style.display = "none";
          this.select.parentNode.insertBefore(this.container, this.select);
          this.label.addEventListener("mousedown", function () {
            _this.togglePicker();
          });
          this.label.addEventListener("keydown", function (event) {
            switch (event.keyCode) {
              case _keyboard2.default.keys.ENTER:
                _this.togglePicker();

                break;

              case _keyboard2.default.keys.ESCAPE:
                _this.escape();

                event.preventDefault();
                break;
            }
          });
          this.select.addEventListener("change", this.update.bind(this));
        }

        _createClass2(Picker2, [{
          key: "togglePicker",
          value: function togglePicker() {
            this.container.classList.toggle("ql-expanded");
            toggleAriaAttribute(this.label, "aria-expanded");
            toggleAriaAttribute(this.options, "aria-hidden");
          }
        }, {
          key: "buildItem",
          value: function buildItem(option) {
            var _this2 = this;

            var item = document.createElement("span");
            item.tabIndex = "0";
            item.setAttribute("role", "button");
            item.classList.add("ql-picker-item");

            if (option.hasAttribute("value")) {
              item.setAttribute("data-value", option.getAttribute("value"));
            }

            if (option.textContent) {
              item.setAttribute("data-label", option.textContent);
            }

            item.addEventListener("click", function () {
              _this2.selectItem(item, true);
            });
            item.addEventListener("keydown", function (event) {
              switch (event.keyCode) {
                case _keyboard2.default.keys.ENTER:
                  _this2.selectItem(item, true);

                  event.preventDefault();
                  break;

                case _keyboard2.default.keys.ESCAPE:
                  _this2.escape();

                  event.preventDefault();
                  break;
              }
            });
            return item;
          }
        }, {
          key: "buildLabel",
          value: function buildLabel() {
            var label = document.createElement("span");
            label.classList.add("ql-picker-label");
            label.innerHTML = _dropdown2.default;
            label.tabIndex = "0";
            label.setAttribute("role", "button");
            label.setAttribute("aria-expanded", "false");
            this.container.appendChild(label);
            return label;
          }
        }, {
          key: "buildOptions",
          value: function buildOptions() {
            var _this3 = this;

            var options2 = document.createElement("span");
            options2.classList.add("ql-picker-options");
            options2.setAttribute("aria-hidden", "true");
            options2.tabIndex = "-1";
            options2.id = "ql-picker-options-" + optionsCounter;
            optionsCounter += 1;
            this.label.setAttribute("aria-controls", options2.id);
            this.options = options2;
            [].slice.call(this.select.options).forEach(function (option) {
              var item = _this3.buildItem(option);

              options2.appendChild(item);

              if (option.selected === true) {
                _this3.selectItem(item);
              }
            });
            this.container.appendChild(options2);
          }
        }, {
          key: "buildPicker",
          value: function buildPicker() {
            var _this4 = this;

            [].slice.call(this.select.attributes).forEach(function (item) {
              _this4.container.setAttribute(item.name, item.value);
            });
            this.container.classList.add("ql-picker");
            this.label = this.buildLabel();
            this.buildOptions();
          }
        }, {
          key: "escape",
          value: function escape2() {
            var _this5 = this;

            this.close();
            setTimeout(function () {
              return _this5.label.focus();
            }, 1);
          }
        }, {
          key: "close",
          value: function close() {
            this.container.classList.remove("ql-expanded");
            this.label.setAttribute("aria-expanded", "false");
            this.options.setAttribute("aria-hidden", "true");
          }
        }, {
          key: "selectItem",
          value: function selectItem(item) {
            var trigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var selected = this.container.querySelector(".ql-selected");
            if (item === selected) return;

            if (selected != null) {
              selected.classList.remove("ql-selected");
            }

            if (item == null) return;
            item.classList.add("ql-selected");
            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);

            if (item.hasAttribute("data-value")) {
              this.label.setAttribute("data-value", item.getAttribute("data-value"));
            } else {
              this.label.removeAttribute("data-value");
            }

            if (item.hasAttribute("data-label")) {
              this.label.setAttribute("data-label", item.getAttribute("data-label"));
            } else {
              this.label.removeAttribute("data-label");
            }

            if (trigger) {
              if (typeof Event === "function") {
                this.select.dispatchEvent(new Event("change"));
              } else if ((typeof Event === "undefined" ? "undefined" : _typeof2(Event)) === "object") {
                var event = document.createEvent("Event");
                event.initEvent("change", true, true);
                this.select.dispatchEvent(event);
              }

              this.close();
            }
          }
        }, {
          key: "update",
          value: function update() {
            var option = void 0;

            if (this.select.selectedIndex > -1) {
              var item = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
              option = this.select.options[this.select.selectedIndex];
              this.selectItem(item);
            } else {
              this.selectItem(null);
            }

            var isActive = option != null && option !== this.select.querySelector("option[selected]");
            this.label.classList.toggle("ql-active", isActive);
          }
        }]);

        return Picker2;
      }();

      exports2.default = Picker;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      var _cursor = __webpack_require__(24);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _embed = __webpack_require__(35);

      var _embed2 = _interopRequireDefault(_embed);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _scroll = __webpack_require__(22);

      var _scroll2 = _interopRequireDefault(_scroll);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _clipboard = __webpack_require__(55);

      var _clipboard2 = _interopRequireDefault(_clipboard);

      var _history = __webpack_require__(42);

      var _history2 = _interopRequireDefault(_history);

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      _quill2.default.register({
        "blots/block": _block2.default,
        "blots/block/embed": _block.BlockEmbed,
        "blots/break": _break2.default,
        "blots/container": _container2.default,
        "blots/cursor": _cursor2.default,
        "blots/embed": _embed2.default,
        "blots/inline": _inline2.default,
        "blots/scroll": _scroll2.default,
        "blots/text": _text2.default,
        "modules/clipboard": _clipboard2.default,
        "modules/history": _history2.default,
        "modules/keyboard": _keyboard2.default
      });

      _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

      exports2.default = _quill2.default;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var Registry = __webpack_require__(1);

      var ShadowBlot = function () {
        function ShadowBlot2(domNode) {
          this.domNode = domNode;
          this.domNode[Registry.DATA_KEY] = {
            blot: this
          };
        }

        Object.defineProperty(ShadowBlot2.prototype, "statics", {
          get: function get() {
            return this.constructor;
          },
          enumerable: true,
          configurable: true
        });

        ShadowBlot2.create = function (value) {
          if (this.tagName == null) {
            throw new Registry.ParchmentError("Blot definition missing tagName");
          }

          var node2;

          if (Array.isArray(this.tagName)) {
            if (typeof value === "string") {
              value = value.toUpperCase();

              if (parseInt(value).toString() === value) {
                value = parseInt(value);
              }
            }

            if (typeof value === "number") {
              node2 = document.createElement(this.tagName[value - 1]);
            } else if (this.tagName.indexOf(value) > -1) {
              node2 = document.createElement(value);
            } else {
              node2 = document.createElement(this.tagName[0]);
            }
          } else {
            node2 = document.createElement(this.tagName);
          }

          if (this.className) {
            node2.classList.add(this.className);
          }

          return node2;
        };

        ShadowBlot2.prototype.attach = function () {
          if (this.parent != null) {
            this.scroll = this.parent.scroll;
          }
        };

        ShadowBlot2.prototype.clone = function () {
          var domNode = this.domNode.cloneNode(false);
          return Registry.create(domNode);
        };

        ShadowBlot2.prototype.detach = function () {
          if (this.parent != null) this.parent.removeChild(this);
          delete this.domNode[Registry.DATA_KEY];
        };

        ShadowBlot2.prototype.deleteAt = function (index2, length2) {
          var blot = this.isolate(index2, length2);
          blot.remove();
        };

        ShadowBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          var blot = this.isolate(index2, length2);

          if (Registry.query(name2, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name2, value);
          } else if (Registry.query(name2, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name2, value);
          }
        };

        ShadowBlot2.prototype.insertAt = function (index2, value, def) {
          var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
          var ref = this.split(index2);
          this.parent.insertBefore(blot, ref);
        };

        ShadowBlot2.prototype.insertInto = function (parentBlot, refBlot) {
          if (refBlot === void 0) {
            refBlot = null;
          }

          if (this.parent != null) {
            this.parent.children.remove(this);
          }

          var refDomNode = null;
          parentBlot.children.insertBefore(this, refBlot);

          if (refBlot != null) {
            refDomNode = refBlot.domNode;
          }

          if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
          }

          this.parent = parentBlot;
          this.attach();
        };

        ShadowBlot2.prototype.isolate = function (index2, length2) {
          var target = this.split(index2);
          target.split(length2);
          return target;
        };

        ShadowBlot2.prototype.length = function () {
          return 1;
        };

        ShadowBlot2.prototype.offset = function (root2) {
          if (root2 === void 0) {
            root2 = this.parent;
          }

          if (this.parent == null || this == root2) return 0;
          return this.parent.children.offset(this) + this.parent.offset(root2);
        };

        ShadowBlot2.prototype.optimize = function (context) {
          if (this.domNode[Registry.DATA_KEY] != null) {
            delete this.domNode[Registry.DATA_KEY].mutations;
          }
        };

        ShadowBlot2.prototype.remove = function () {
          if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
          }

          this.detach();
        };

        ShadowBlot2.prototype.replace = function (target) {
          if (target.parent == null) return;
          target.parent.insertBefore(this, target.next);
          target.remove();
        };

        ShadowBlot2.prototype.replaceWith = function (name2, value) {
          var replacement = typeof name2 === "string" ? Registry.create(name2, value) : name2;
          replacement.replace(this);
          return replacement;
        };

        ShadowBlot2.prototype.split = function (index2, force) {
          return index2 === 0 ? this : this.next;
        };

        ShadowBlot2.prototype.update = function (mutations, context) {};

        ShadowBlot2.prototype.wrap = function (name2, value) {
          var wrapper = typeof name2 === "string" ? Registry.create(name2, value) : name2;

          if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
          }

          wrapper.appendChild(this);
          return wrapper;
        };

        ShadowBlot2.blotName = "abstract";
        return ShadowBlot2;
      }();

      exports2.default = ShadowBlot;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var attributor_1 = __webpack_require__(12);

      var class_1 = __webpack_require__(32);

      var style_1 = __webpack_require__(33);

      var Registry = __webpack_require__(1);

      var AttributorStore = function () {
        function AttributorStore2(domNode) {
          this.attributes = {};
          this.domNode = domNode;
          this.build();
        }

        AttributorStore2.prototype.attribute = function (attribute, value) {
          if (value) {
            if (attribute.add(this.domNode, value)) {
              if (attribute.value(this.domNode) != null) {
                this.attributes[attribute.attrName] = attribute;
              } else {
                delete this.attributes[attribute.attrName];
              }
            }
          } else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
          }
        };

        AttributorStore2.prototype.build = function () {
          var _this = this;

          this.attributes = {};
          var attributes = attributor_1.default.keys(this.domNode);
          var classes = class_1.default.keys(this.domNode);
          var styles = style_1.default.keys(this.domNode);
          attributes.concat(classes).concat(styles).forEach(function (name2) {
            var attr = Registry.query(name2, Registry.Scope.ATTRIBUTE);

            if (attr instanceof attributor_1.default) {
              _this.attributes[attr.attrName] = attr;
            }
          });
        };

        AttributorStore2.prototype.copy = function (target) {
          var _this = this;

          Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);

            target.format(key, value);
          });
        };

        AttributorStore2.prototype.move = function (target) {
          var _this = this;

          this.copy(target);
          Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
          });
          this.attributes = {};
        };

        AttributorStore2.prototype.values = function () {
          var _this = this;

          return Object.keys(this.attributes).reduce(function (attributes, name2) {
            attributes[name2] = _this.attributes[name2].value(_this.domNode);
            return attributes;
          }, {});
        };

        return AttributorStore2;
      }();

      exports2.default = AttributorStore;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var attributor_1 = __webpack_require__(12);

      function match2(node2, prefix2) {
        var className = node2.getAttribute("class") || "";
        return className.split(/\s+/).filter(function (name2) {
          return name2.indexOf(prefix2 + "-") === 0;
        });
      }

      var ClassAttributor = function (_super) {
        __extends2(ClassAttributor2, _super);

        function ClassAttributor2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        ClassAttributor2.keys = function (node2) {
          return (node2.getAttribute("class") || "").split(/\s+/).map(function (name2) {
            return name2.split("-").slice(0, -1).join("-");
          });
        };

        ClassAttributor2.prototype.add = function (node2, value) {
          if (!this.canAdd(node2, value)) return false;
          this.remove(node2);
          node2.classList.add(this.keyName + "-" + value);
          return true;
        };

        ClassAttributor2.prototype.remove = function (node2) {
          var matches = match2(node2, this.keyName);
          matches.forEach(function (name2) {
            node2.classList.remove(name2);
          });

          if (node2.classList.length === 0) {
            node2.removeAttribute("class");
          }
        };

        ClassAttributor2.prototype.value = function (node2) {
          var result = match2(node2, this.keyName)[0] || "";
          var value = result.slice(this.keyName.length + 1);
          return this.canAdd(node2, value) ? value : "";
        };

        return ClassAttributor2;
      }(attributor_1.default);

      exports2.default = ClassAttributor;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var attributor_1 = __webpack_require__(12);

      function camelize(name2) {
        var parts = name2.split("-");
        var rest = parts.slice(1).map(function (part) {
          return part[0].toUpperCase() + part.slice(1);
        }).join("");
        return parts[0] + rest;
      }

      var StyleAttributor = function (_super) {
        __extends2(StyleAttributor2, _super);

        function StyleAttributor2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        StyleAttributor2.keys = function (node2) {
          return (node2.getAttribute("style") || "").split(";").map(function (value) {
            var arr = value.split(":");
            return arr[0].trim();
          });
        };

        StyleAttributor2.prototype.add = function (node2, value) {
          if (!this.canAdd(node2, value)) return false;
          node2.style[camelize(this.keyName)] = value;
          return true;
        };

        StyleAttributor2.prototype.remove = function (node2) {
          node2.style[camelize(this.keyName)] = "";

          if (!node2.getAttribute("style")) {
            node2.removeAttribute("style");
          }
        };

        StyleAttributor2.prototype.value = function (node2) {
          var value = node2.style[camelize(this.keyName)];
          return this.canAdd(node2, value) ? value : "";
        };

        return StyleAttributor2;
      }(attributor_1.default);

      exports2.default = StyleAttributor;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Theme = function () {
        function Theme2(quill2, options2) {
          _classCallCheck2(this, Theme2);

          this.quill = quill2;
          this.options = options2;
          this.modules = {};
        }

        _createClass2(Theme2, [{
          key: "init",
          value: function init() {
            var _this = this;

            Object.keys(this.options.modules).forEach(function (name2) {
              if (_this.modules[name2] == null) {
                _this.addModule(name2);
              }
            });
          }
        }, {
          key: "addModule",
          value: function addModule(name2) {
            var moduleClass = this.quill.constructor.import("modules/" + name2);
            this.modules[name2] = new moduleClass(this.quill, this.options.modules[name2] || {});
            return this.modules[name2];
          }
        }]);

        return Theme2;
      }();

      Theme.DEFAULTS = {
        modules: {}
      };
      Theme.themes = {
        "default": Theme
      };
      exports2.default = Theme;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var GUARD_TEXT = "\uFEFF";

      var Embed = function (_Parchment$Embed) {
        _inherits2(Embed2, _Parchment$Embed);

        function Embed2(node2) {
          _classCallCheck2(this, Embed2);

          var _this = _possibleConstructorReturn2(this, (Embed2.__proto__ || Object.getPrototypeOf(Embed2)).call(this, node2));

          _this.contentNode = document.createElement("span");

          _this.contentNode.setAttribute("contenteditable", false);

          [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
            _this.contentNode.appendChild(childNode);
          });
          _this.leftGuard = document.createTextNode(GUARD_TEXT);
          _this.rightGuard = document.createTextNode(GUARD_TEXT);

          _this.domNode.appendChild(_this.leftGuard);

          _this.domNode.appendChild(_this.contentNode);

          _this.domNode.appendChild(_this.rightGuard);

          return _this;
        }

        _createClass2(Embed2, [{
          key: "index",
          value: function index2(node2, offset2) {
            if (node2 === this.leftGuard) return 0;
            if (node2 === this.rightGuard) return 1;
            return _get(Embed2.prototype.__proto__ || Object.getPrototypeOf(Embed2.prototype), "index", this).call(this, node2, offset2);
          }
        }, {
          key: "restore",
          value: function restore(node2) {
            var range2 = void 0,
                textNode = void 0;
            var text = node2.data.split(GUARD_TEXT).join("");

            if (node2 === this.leftGuard) {
              if (this.prev instanceof _text2.default) {
                var prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range2 = {
                  startNode: this.prev.domNode,
                  startOffset: prevLength + text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this);
                range2 = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            } else if (node2 === this.rightGuard) {
              if (this.next instanceof _text2.default) {
                this.next.insertAt(0, text);
                range2 = {
                  startNode: this.next.domNode,
                  startOffset: text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                range2 = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            }

            node2.data = GUARD_TEXT;
            return range2;
          }
        }, {
          key: "update",
          value: function update(mutations, context) {
            var _this2 = this;

            mutations.forEach(function (mutation) {
              if (mutation.type === "characterData" && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                var range2 = _this2.restore(mutation.target);

                if (range2) context.range = range2;
              }
            });
          }
        }]);

        return Embed2;
      }(_parchment2.default.Embed);

      exports2.default = Embed;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.AlignStyle = exports2.AlignClass = exports2.AlignAttribute = void 0;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ["right", "center", "justify"]
      };
      var AlignAttribute = new _parchment2.default.Attributor.Attribute("align", "align", config);
      var AlignClass = new _parchment2.default.Attributor.Class("align", "ql-align", config);
      var AlignStyle = new _parchment2.default.Attributor.Style("align", "text-align", config);
      exports2.AlignAttribute = AlignAttribute;
      exports2.AlignClass = AlignClass;
      exports2.AlignStyle = AlignStyle;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.BackgroundStyle = exports2.BackgroundClass = void 0;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _color = __webpack_require__(26);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var BackgroundClass = new _parchment2.default.Attributor.Class("background", "ql-bg", {
        scope: _parchment2.default.Scope.INLINE
      });
      var BackgroundStyle = new _color.ColorAttributor("background", "background-color", {
        scope: _parchment2.default.Scope.INLINE
      });
      exports2.BackgroundClass = BackgroundClass;
      exports2.BackgroundStyle = BackgroundStyle;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.DirectionStyle = exports2.DirectionClass = exports2.DirectionAttribute = void 0;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ["rtl"]
      };
      var DirectionAttribute = new _parchment2.default.Attributor.Attribute("direction", "dir", config);
      var DirectionClass = new _parchment2.default.Attributor.Class("direction", "ql-direction", config);
      var DirectionStyle = new _parchment2.default.Attributor.Style("direction", "direction", config);
      exports2.DirectionAttribute = DirectionAttribute;
      exports2.DirectionClass = DirectionClass;
      exports2.DirectionStyle = DirectionStyle;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.FontClass = exports2.FontStyle = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var config = {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ["serif", "monospace"]
      };
      var FontClass = new _parchment2.default.Attributor.Class("font", "ql-font", config);

      var FontStyleAttributor = function (_Parchment$Attributor) {
        _inherits2(FontStyleAttributor2, _Parchment$Attributor);

        function FontStyleAttributor2() {
          _classCallCheck2(this, FontStyleAttributor2);

          return _possibleConstructorReturn2(this, (FontStyleAttributor2.__proto__ || Object.getPrototypeOf(FontStyleAttributor2)).apply(this, arguments));
        }

        _createClass2(FontStyleAttributor2, [{
          key: "value",
          value: function value(node2) {
            return _get(FontStyleAttributor2.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor2.prototype), "value", this).call(this, node2).replace(/["']/g, "");
          }
        }]);

        return FontStyleAttributor2;
      }(_parchment2.default.Attributor.Style);

      var FontStyle = new FontStyleAttributor("font", "font-family", config);
      exports2.FontStyle = FontStyle;
      exports2.FontClass = FontClass;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.SizeStyle = exports2.SizeClass = void 0;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var SizeClass = new _parchment2.default.Attributor.Class("size", "ql-size", {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ["small", "large", "huge"]
      });
      var SizeStyle = new _parchment2.default.Attributor.Style("size", "font-size", {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ["10px", "18px", "32px"]
      });
      exports2.SizeClass = SizeClass;
      exports2.SizeStyle = SizeStyle;
    }, function (module2, exports2, __webpack_require__) {
      module2.exports = {
        "align": {
          "": __webpack_require__(76),
          "center": __webpack_require__(77),
          "right": __webpack_require__(78),
          "justify": __webpack_require__(79)
        },
        "background": __webpack_require__(80),
        "blockquote": __webpack_require__(81),
        "bold": __webpack_require__(82),
        "clean": __webpack_require__(83),
        "code": __webpack_require__(58),
        "code-block": __webpack_require__(58),
        "color": __webpack_require__(84),
        "direction": {
          "": __webpack_require__(85),
          "rtl": __webpack_require__(86)
        },
        "float": {
          "center": __webpack_require__(87),
          "full": __webpack_require__(88),
          "left": __webpack_require__(89),
          "right": __webpack_require__(90)
        },
        "formula": __webpack_require__(91),
        "header": {
          "1": __webpack_require__(92),
          "2": __webpack_require__(93)
        },
        "italic": __webpack_require__(94),
        "image": __webpack_require__(95),
        "indent": {
          "+1": __webpack_require__(96),
          "-1": __webpack_require__(97)
        },
        "link": __webpack_require__(98),
        "list": {
          "ordered": __webpack_require__(99),
          "bullet": __webpack_require__(100),
          "check": __webpack_require__(101)
        },
        "script": {
          "sub": __webpack_require__(102),
          "super": __webpack_require__(103)
        },
        "strike": __webpack_require__(104),
        "underline": __webpack_require__(105),
        "video": __webpack_require__(106)
      };
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.getLastChangeIndex = exports2.default = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var History = function (_Module) {
        _inherits2(History2, _Module);

        function History2(quill2, options2) {
          _classCallCheck2(this, History2);

          var _this = _possibleConstructorReturn2(this, (History2.__proto__ || Object.getPrototypeOf(History2)).call(this, quill2, options2));

          _this.lastRecorded = 0;
          _this.ignoreChange = false;

          _this.clear();

          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source2) {
            if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;

            if (!_this.options.userOnly || source2 === _quill2.default.sources.USER) {
              _this.record(delta, oldDelta);
            } else {
              _this.transform(delta);
            }
          });

          _this.quill.keyboard.addBinding({
            key: "Z",
            shortKey: true
          }, _this.undo.bind(_this));

          _this.quill.keyboard.addBinding({
            key: "Z",
            shortKey: true,
            shiftKey: true
          }, _this.redo.bind(_this));

          if (/Win/i.test(navigator.platform)) {
            _this.quill.keyboard.addBinding({
              key: "Y",
              shortKey: true
            }, _this.redo.bind(_this));
          }

          return _this;
        }

        _createClass2(History2, [{
          key: "change",
          value: function change(source2, dest) {
            if (this.stack[source2].length === 0) return;
            var delta = this.stack[source2].pop();
            this.stack[dest].push(delta);
            this.lastRecorded = 0;
            this.ignoreChange = true;
            this.quill.updateContents(delta[source2], _quill2.default.sources.USER);
            this.ignoreChange = false;
            var index2 = getLastChangeIndex(delta[source2]);
            this.quill.setSelection(index2);
          }
        }, {
          key: "clear",
          value: function clear() {
            this.stack = {
              undo: [],
              redo: []
            };
          }
        }, {
          key: "cutoff",
          value: function cutoff() {
            this.lastRecorded = 0;
          }
        }, {
          key: "record",
          value: function record(changeDelta, oldDelta) {
            if (changeDelta.ops.length === 0) return;
            this.stack.redo = [];
            var undoDelta = this.quill.getContents().diff(oldDelta);
            var timestamp = Date.now();

            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
              var delta = this.stack.undo.pop();
              undoDelta = undoDelta.compose(delta.undo);
              changeDelta = delta.redo.compose(changeDelta);
            } else {
              this.lastRecorded = timestamp;
            }

            this.stack.undo.push({
              redo: changeDelta,
              undo: undoDelta
            });

            if (this.stack.undo.length > this.options.maxStack) {
              this.stack.undo.shift();
            }
          }
        }, {
          key: "redo",
          value: function redo() {
            this.change("redo", "undo");
          }
        }, {
          key: "transform",
          value: function transform(delta) {
            this.stack.undo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
            this.stack.redo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
          }
        }, {
          key: "undo",
          value: function undo() {
            this.change("undo", "redo");
          }
        }]);

        return History2;
      }(_module2.default);

      History.DEFAULTS = {
        delay: 1e3,
        maxStack: 100,
        userOnly: false
      };

      function endsWithNewlineChange(delta) {
        var lastOp = delta.ops[delta.ops.length - 1];
        if (lastOp == null) return false;

        if (lastOp.insert != null) {
          return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
        }

        if (lastOp.attributes != null) {
          return Object.keys(lastOp.attributes).some(function (attr) {
            return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
          });
        }

        return false;
      }

      function getLastChangeIndex(delta) {
        var deleteLength = delta.reduce(function (length2, op) {
          length2 += op.delete || 0;
          return length2;
        }, 0);
        var changeIndex = delta.length() - deleteLength;

        if (endsWithNewlineChange(delta)) {
          changeIndex -= 1;
        }

        return changeIndex;
      }

      exports2.default = History;
      exports2.getLastChangeIndex = getLastChangeIndex;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.BaseTooltip = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ALIGNS = [false, "center", "right", "justify"];
      var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
      var FONTS = [false, "serif", "monospace"];
      var HEADERS = ["1", "2", "3", false];
      var SIZES = ["small", false, "large", "huge"];

      var BaseTheme = function (_Theme) {
        _inherits2(BaseTheme2, _Theme);

        function BaseTheme2(quill2, options2) {
          _classCallCheck2(this, BaseTheme2);

          var _this = _possibleConstructorReturn2(this, (BaseTheme2.__proto__ || Object.getPrototypeOf(BaseTheme2)).call(this, quill2, options2));

          var listener = function listener2(e2) {
            if (!document.body.contains(quill2.root)) {
              return document.body.removeEventListener("click", listener2);
            }

            if (_this.tooltip != null && !_this.tooltip.root.contains(e2.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
              _this.tooltip.hide();
            }

            if (_this.pickers != null) {
              _this.pickers.forEach(function (picker) {
                if (!picker.container.contains(e2.target)) {
                  picker.close();
                }
              });
            }
          };

          quill2.emitter.listenDOM("click", document.body, listener);
          return _this;
        }

        _createClass2(BaseTheme2, [{
          key: "addModule",
          value: function addModule(name2) {
            var module3 = _get(BaseTheme2.prototype.__proto__ || Object.getPrototypeOf(BaseTheme2.prototype), "addModule", this).call(this, name2);

            if (name2 === "toolbar") {
              this.extendToolbar(module3);
            }

            return module3;
          }
        }, {
          key: "buildButtons",
          value: function buildButtons(buttons, icons) {
            buttons.forEach(function (button) {
              var className = button.getAttribute("class") || "";
              className.split(/\s+/).forEach(function (name2) {
                if (!name2.startsWith("ql-")) return;
                name2 = name2.slice("ql-".length);
                if (icons[name2] == null) return;

                if (name2 === "direction") {
                  button.innerHTML = icons[name2][""] + icons[name2]["rtl"];
                } else if (typeof icons[name2] === "string") {
                  button.innerHTML = icons[name2];
                } else {
                  var value = button.value || "";

                  if (value != null && icons[name2][value]) {
                    button.innerHTML = icons[name2][value];
                  }
                }
              });
            });
          }
        }, {
          key: "buildPickers",
          value: function buildPickers(selects, icons) {
            var _this2 = this;

            this.pickers = selects.map(function (select) {
              if (select.classList.contains("ql-align")) {
                if (select.querySelector("option") == null) {
                  fillSelect(select, ALIGNS);
                }

                return new _iconPicker2.default(select, icons.align);
              } else if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                var format = select.classList.contains("ql-background") ? "background" : "color";

                if (select.querySelector("option") == null) {
                  fillSelect(select, COLORS, format === "background" ? "#ffffff" : "#000000");
                }

                return new _colorPicker2.default(select, icons[format]);
              } else {
                if (select.querySelector("option") == null) {
                  if (select.classList.contains("ql-font")) {
                    fillSelect(select, FONTS);
                  } else if (select.classList.contains("ql-header")) {
                    fillSelect(select, HEADERS);
                  } else if (select.classList.contains("ql-size")) {
                    fillSelect(select, SIZES);
                  }
                }

                return new _picker2.default(select);
              }
            });

            var update = function update2() {
              _this2.pickers.forEach(function (picker) {
                picker.update();
              });
            };

            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
          }
        }]);

        return BaseTheme2;
      }(_theme2.default);

      BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              formula: function formula() {
                this.quill.theme.tooltip.edit("formula");
              },
              image: function image() {
                var _this3 = this;

                var fileInput = this.container.querySelector("input.ql-image[type=file]");

                if (fileInput == null) {
                  fileInput = document.createElement("input");
                  fileInput.setAttribute("type", "file");
                  fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
                  fileInput.classList.add("ql-image");
                  fileInput.addEventListener("change", function () {
                    if (fileInput.files != null && fileInput.files[0] != null) {
                      var reader = new FileReader();

                      reader.onload = function (e2) {
                        var range2 = _this3.quill.getSelection(true);

                        _this3.quill.updateContents(new _quillDelta2.default().retain(range2.index).delete(range2.length).insert({
                          image: e2.target.result
                        }), _emitter2.default.sources.USER);

                        _this3.quill.setSelection(range2.index + 1, _emitter2.default.sources.SILENT);

                        fileInput.value = "";
                      };

                      reader.readAsDataURL(fileInput.files[0]);
                    }
                  });
                  this.container.appendChild(fileInput);
                }

                fileInput.click();
              },
              video: function video() {
                this.quill.theme.tooltip.edit("video");
              }
            }
          }
        }
      });

      var BaseTooltip = function (_Tooltip) {
        _inherits2(BaseTooltip2, _Tooltip);

        function BaseTooltip2(quill2, boundsContainer) {
          _classCallCheck2(this, BaseTooltip2);

          var _this4 = _possibleConstructorReturn2(this, (BaseTooltip2.__proto__ || Object.getPrototypeOf(BaseTooltip2)).call(this, quill2, boundsContainer));

          _this4.textbox = _this4.root.querySelector('input[type="text"]');

          _this4.listen();

          return _this4;
        }

        _createClass2(BaseTooltip2, [{
          key: "listen",
          value: function listen() {
            var _this5 = this;

            this.textbox.addEventListener("keydown", function (event) {
              if (_keyboard2.default.match(event, "enter")) {
                _this5.save();

                event.preventDefault();
              } else if (_keyboard2.default.match(event, "escape")) {
                _this5.cancel();

                event.preventDefault();
              }
            });
          }
        }, {
          key: "cancel",
          value: function cancel() {
            this.hide();
          }
        }, {
          key: "edit",
          value: function edit() {
            var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link";
            var preview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            this.root.classList.remove("ql-hidden");
            this.root.classList.add("ql-editing");

            if (preview != null) {
              this.textbox.value = preview;
            } else if (mode !== this.root.getAttribute("data-mode")) {
              this.textbox.value = "";
            }

            this.position(this.quill.getBounds(this.quill.selection.savedRange));
            this.textbox.select();
            this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + mode) || "");
            this.root.setAttribute("data-mode", mode);
          }
        }, {
          key: "restoreFocus",
          value: function restoreFocus() {
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.quill.focus();
            this.quill.scrollingContainer.scrollTop = scrollTop;
          }
        }, {
          key: "save",
          value: function save() {
            var value = this.textbox.value;

            switch (this.root.getAttribute("data-mode")) {
              case "link":
                {
                  var scrollTop = this.quill.root.scrollTop;

                  if (this.linkRange) {
                    this.quill.formatText(this.linkRange, "link", value, _emitter2.default.sources.USER);
                    delete this.linkRange;
                  } else {
                    this.restoreFocus();
                    this.quill.format("link", value, _emitter2.default.sources.USER);
                  }

                  this.quill.root.scrollTop = scrollTop;
                  break;
                }

              case "video":
                {
                  value = extractVideoUrl(value);
                }

              case "formula":
                {
                  if (!value) break;
                  var range2 = this.quill.getSelection(true);

                  if (range2 != null) {
                    var index2 = range2.index + range2.length;
                    this.quill.insertEmbed(index2, this.root.getAttribute("data-mode"), value, _emitter2.default.sources.USER);

                    if (this.root.getAttribute("data-mode") === "formula") {
                      this.quill.insertText(index2 + 1, " ", _emitter2.default.sources.USER);
                    }

                    this.quill.setSelection(index2 + 2, _emitter2.default.sources.USER);
                  }

                  break;
                }
            }

            this.textbox.value = "";
            this.hide();
          }
        }]);

        return BaseTooltip2;
      }(_tooltip2.default);

      function extractVideoUrl(url) {
        var match2 = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);

        if (match2) {
          return (match2[1] || "https") + "://www.youtube.com/embed/" + match2[2] + "?showinfo=0";
        }

        if (match2 = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
          return (match2[1] || "https") + "://player.vimeo.com/video/" + match2[2] + "/";
        }

        return url;
      }

      function fillSelect(select, values) {
        var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        values.forEach(function (value) {
          var option = document.createElement("option");

          if (value === defaultValue) {
            option.setAttribute("selected", "selected");
          } else {
            option.setAttribute("value", value);
          }

          select.appendChild(option);
        });
      }

      exports2.BaseTooltip = BaseTooltip;
      exports2.default = BaseTheme;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var LinkedList = function () {
        function LinkedList2() {
          this.head = this.tail = null;
          this.length = 0;
        }

        LinkedList2.prototype.append = function () {
          var nodes = [];

          for (var _i2 = 0; _i2 < arguments.length; _i2++) {
            nodes[_i2] = arguments[_i2];
          }

          this.insertBefore(nodes[0], null);

          if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
          }
        };

        LinkedList2.prototype.contains = function (node2) {
          var cur,
              next2 = this.iterator();

          while (cur = next2()) {
            if (cur === node2) return true;
          }

          return false;
        };

        LinkedList2.prototype.insertBefore = function (node2, refNode) {
          if (!node2) return;
          node2.next = refNode;

          if (refNode != null) {
            node2.prev = refNode.prev;

            if (refNode.prev != null) {
              refNode.prev.next = node2;
            }

            refNode.prev = node2;

            if (refNode === this.head) {
              this.head = node2;
            }
          } else if (this.tail != null) {
            this.tail.next = node2;
            node2.prev = this.tail;
            this.tail = node2;
          } else {
            node2.prev = null;
            this.head = this.tail = node2;
          }

          this.length += 1;
        };

        LinkedList2.prototype.offset = function (target) {
          var index2 = 0,
              cur = this.head;

          while (cur != null) {
            if (cur === target) return index2;
            index2 += cur.length();
            cur = cur.next;
          }

          return -1;
        };

        LinkedList2.prototype.remove = function (node2) {
          if (!this.contains(node2)) return;
          if (node2.prev != null) node2.prev.next = node2.next;
          if (node2.next != null) node2.next.prev = node2.prev;
          if (node2 === this.head) this.head = node2.next;
          if (node2 === this.tail) this.tail = node2.prev;
          this.length -= 1;
        };

        LinkedList2.prototype.iterator = function (curNode) {
          if (curNode === void 0) {
            curNode = this.head;
          }

          return function () {
            var ret = curNode;
            if (curNode != null) curNode = curNode.next;
            return ret;
          };
        };

        LinkedList2.prototype.find = function (index2, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }

          var cur,
              next2 = this.iterator();

          while (cur = next2()) {
            var length2 = cur.length();

            if (index2 < length2 || inclusive && index2 === length2 && (cur.next == null || cur.next.length() !== 0)) {
              return [cur, index2];
            }

            index2 -= length2;
          }

          return [null, 0];
        };

        LinkedList2.prototype.forEach = function (callback) {
          var cur,
              next2 = this.iterator();

          while (cur = next2()) {
            callback(cur);
          }
        };

        LinkedList2.prototype.forEachAt = function (index2, length2, callback) {
          if (length2 <= 0) return;

          var _a2 = this.find(index2),
              startNode = _a2[0],
              offset2 = _a2[1];

          var cur,
              curIndex = index2 - offset2,
              next2 = this.iterator(startNode);

          while ((cur = next2()) && curIndex < index2 + length2) {
            var curLength = cur.length();

            if (index2 > curIndex) {
              callback(cur, index2 - curIndex, Math.min(length2, curIndex + curLength - index2));
            } else {
              callback(cur, 0, Math.min(curLength, index2 + length2 - curIndex));
            }

            curIndex += curLength;
          }
        };

        LinkedList2.prototype.map = function (callback) {
          return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
          }, []);
        };

        LinkedList2.prototype.reduce = function (callback, memo) {
          var cur,
              next2 = this.iterator();

          while (cur = next2()) {
            memo = callback(memo, cur);
          }

          return memo;
        };

        return LinkedList2;
      }();

      exports2.default = LinkedList;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var container_1 = __webpack_require__(17);

      var Registry = __webpack_require__(1);

      var OBSERVER_CONFIG = {
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
      };
      var MAX_OPTIMIZE_ITERATIONS = 100;

      var ScrollBlot = function (_super) {
        __extends2(ScrollBlot2, _super);

        function ScrollBlot2(node2) {
          var _this = _super.call(this, node2) || this;

          _this.scroll = _this;
          _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
          });

          _this.observer.observe(_this.domNode, OBSERVER_CONFIG);

          _this.attach();

          return _this;
        }

        ScrollBlot2.prototype.detach = function () {
          _super.prototype.detach.call(this);

          this.observer.disconnect();
        };

        ScrollBlot2.prototype.deleteAt = function (index2, length2) {
          this.update();

          if (index2 === 0 && length2 === this.length()) {
            this.children.forEach(function (child) {
              child.remove();
            });
          } else {
            _super.prototype.deleteAt.call(this, index2, length2);
          }
        };

        ScrollBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          this.update();

          _super.prototype.formatAt.call(this, index2, length2, name2, value);
        };

        ScrollBlot2.prototype.insertAt = function (index2, value, def) {
          this.update();

          _super.prototype.insertAt.call(this, index2, value, def);
        };

        ScrollBlot2.prototype.optimize = function (mutations, context) {
          var _this = this;

          if (mutations === void 0) {
            mutations = [];
          }

          if (context === void 0) {
            context = {};
          }

          _super.prototype.optimize.call(this, context);

          var records = [].slice.call(this.observer.takeRecords());

          while (records.length > 0) {
            mutations.push(records.pop());
          }

          var mark = function mark(blot, markParent) {
            if (markParent === void 0) {
              markParent = true;
            }

            if (blot == null || blot === _this) return;
            if (blot.domNode.parentNode == null) return;

            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              blot.domNode[Registry.DATA_KEY].mutations = [];
            }

            if (markParent) mark(blot.parent);
          };

          var optimize = function optimize(blot) {
            if (blot.domNode[Registry.DATA_KEY] == null || blot.domNode[Registry.DATA_KEY].mutations == null) {
              return;
            }

            if (blot instanceof container_1.default) {
              blot.children.forEach(optimize);
            }

            blot.optimize(context);
          };

          var remaining = mutations;

          for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
              throw new Error("[Parchment] Maximum optimize iterations reached");
            }

            remaining.forEach(function (mutation) {
              var blot = Registry.find(mutation.target, true);
              if (blot == null) return;

              if (blot.domNode === mutation.target) {
                if (mutation.type === "childList") {
                  mark(Registry.find(mutation.previousSibling, false));
                  [].forEach.call(mutation.addedNodes, function (node2) {
                    var child = Registry.find(node2, false);
                    mark(child, false);

                    if (child instanceof container_1.default) {
                      child.children.forEach(function (grandChild) {
                        mark(grandChild, false);
                      });
                    }
                  });
                } else if (mutation.type === "attributes") {
                  mark(blot.prev);
                }
              }

              mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();

            while (records.length > 0) {
              mutations.push(records.pop());
            }
          }
        };

        ScrollBlot2.prototype.update = function (mutations, context) {
          var _this = this;

          if (context === void 0) {
            context = {};
          }

          mutations = mutations || this.observer.takeRecords();
          mutations.map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null) return null;

            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              blot.domNode[Registry.DATA_KEY].mutations = [mutation];
              return blot;
            } else {
              blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
              return null;
            }
          }).forEach(function (blot) {
            if (blot == null || blot === _this || blot.domNode[Registry.DATA_KEY] == null) return;
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
          });

          if (this.domNode[Registry.DATA_KEY].mutations != null) {
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
          }

          this.optimize(mutations, context);
        };

        ScrollBlot2.blotName = "scroll";
        ScrollBlot2.defaultChild = "block";
        ScrollBlot2.scope = Registry.Scope.BLOCK_BLOT;
        ScrollBlot2.tagName = "DIV";
        return ScrollBlot2;
      }(container_1.default);

      exports2.default = ScrollBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var format_1 = __webpack_require__(18);

      var Registry = __webpack_require__(1);

      function isEqual2(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

        for (var prop in obj1) {
          if (obj1[prop] !== obj2[prop]) return false;
        }

        return true;
      }

      var InlineBlot = function (_super) {
        __extends2(InlineBlot2, _super);

        function InlineBlot2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        InlineBlot2.formats = function (domNode) {
          if (domNode.tagName === InlineBlot2.tagName) return void 0;
          return _super.formats.call(this, domNode);
        };

        InlineBlot2.prototype.format = function (name2, value) {
          var _this = this;

          if (name2 === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
              if (!(child instanceof format_1.default)) {
                child = child.wrap(InlineBlot2.blotName, true);
              }

              _this.attributes.copy(child);
            });
            this.unwrap();
          } else {
            _super.prototype.format.call(this, name2, value);
          }
        };

        InlineBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          if (this.formats()[name2] != null || Registry.query(name2, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index2, length2);
            blot.format(name2, value);
          } else {
            _super.prototype.formatAt.call(this, index2, length2, name2, value);
          }
        };

        InlineBlot2.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);

          var formats2 = this.formats();

          if (Object.keys(formats2).length === 0) {
            return this.unwrap();
          }

          var next2 = this.next;

          if (next2 instanceof InlineBlot2 && next2.prev === this && isEqual2(formats2, next2.formats())) {
            next2.moveChildren(this);
            next2.remove();
          }
        };

        InlineBlot2.blotName = "inline";
        InlineBlot2.scope = Registry.Scope.INLINE_BLOT;
        InlineBlot2.tagName = "SPAN";
        return InlineBlot2;
      }(format_1.default);

      exports2.default = InlineBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var format_1 = __webpack_require__(18);

      var Registry = __webpack_require__(1);

      var BlockBlot = function (_super) {
        __extends2(BlockBlot2, _super);

        function BlockBlot2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        BlockBlot2.formats = function (domNode) {
          var tagName = Registry.query(BlockBlot2.blotName).tagName;
          if (domNode.tagName === tagName) return void 0;
          return _super.formats.call(this, domNode);
        };

        BlockBlot2.prototype.format = function (name2, value) {
          if (Registry.query(name2, Registry.Scope.BLOCK) == null) {
            return;
          } else if (name2 === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot2.blotName);
          } else {
            _super.prototype.format.call(this, name2, value);
          }
        };

        BlockBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          if (Registry.query(name2, Registry.Scope.BLOCK) != null) {
            this.format(name2, value);
          } else {
            _super.prototype.formatAt.call(this, index2, length2, name2, value);
          }
        };

        BlockBlot2.prototype.insertAt = function (index2, value, def) {
          if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            _super.prototype.insertAt.call(this, index2, value, def);
          } else {
            var after = this.split(index2);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
          }
        };

        BlockBlot2.prototype.update = function (mutations, context) {
          if (navigator.userAgent.match(/Trident/)) {
            this.build();
          } else {
            _super.prototype.update.call(this, mutations, context);
          }
        };

        BlockBlot2.blotName = "block";
        BlockBlot2.scope = Registry.Scope.BLOCK_BLOT;
        BlockBlot2.tagName = "P";
        return BlockBlot2;
      }(format_1.default);

      exports2.default = BlockBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var leaf_1 = __webpack_require__(19);

      var EmbedBlot = function (_super) {
        __extends2(EmbedBlot2, _super);

        function EmbedBlot2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        EmbedBlot2.formats = function (domNode) {
          return void 0;
        };

        EmbedBlot2.prototype.format = function (name2, value) {
          _super.prototype.formatAt.call(this, 0, this.length(), name2, value);
        };

        EmbedBlot2.prototype.formatAt = function (index2, length2, name2, value) {
          if (index2 === 0 && length2 === this.length()) {
            this.format(name2, value);
          } else {
            _super.prototype.formatAt.call(this, index2, length2, name2, value);
          }
        };

        EmbedBlot2.prototype.formats = function () {
          return this.statics.formats(this.domNode);
        };

        return EmbedBlot2;
      }(leaf_1.default);

      exports2.default = EmbedBlot;
    }, function (module2, exports2, __webpack_require__) {
      var __extends2 = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d2, b2) {
          d2.__proto__ = b2;
        } || function (d2, b2) {
          for (var p2 in b2) {
            if (b2.hasOwnProperty(p2)) d2[p2] = b2[p2];
          }
        };

        return function (d2, b2) {
          extendStatics(d2, b2);

          function __() {
            this.constructor = d2;
          }

          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        };
      }();

      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var leaf_1 = __webpack_require__(19);

      var Registry = __webpack_require__(1);

      var TextBlot = function (_super) {
        __extends2(TextBlot2, _super);

        function TextBlot2(node2) {
          var _this = _super.call(this, node2) || this;

          _this.text = _this.statics.value(_this.domNode);
          return _this;
        }

        TextBlot2.create = function (value) {
          return document.createTextNode(value);
        };

        TextBlot2.value = function (domNode) {
          var text = domNode.data;
          if (text["normalize"]) text = text["normalize"]();
          return text;
        };

        TextBlot2.prototype.deleteAt = function (index2, length2) {
          this.domNode.data = this.text = this.text.slice(0, index2) + this.text.slice(index2 + length2);
        };

        TextBlot2.prototype.index = function (node2, offset2) {
          if (this.domNode === node2) {
            return offset2;
          }

          return -1;
        };

        TextBlot2.prototype.insertAt = function (index2, value, def) {
          if (def == null) {
            this.text = this.text.slice(0, index2) + value + this.text.slice(index2);
            this.domNode.data = this.text;
          } else {
            _super.prototype.insertAt.call(this, index2, value, def);
          }
        };

        TextBlot2.prototype.length = function () {
          return this.text.length;
        };

        TextBlot2.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);

          this.text = this.statics.value(this.domNode);

          if (this.text.length === 0) {
            this.remove();
          } else if (this.next instanceof TextBlot2 && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
          }
        };

        TextBlot2.prototype.position = function (index2, inclusive) {
          return [this.domNode, index2];
        };

        TextBlot2.prototype.split = function (index2, force) {
          if (force === void 0) {
            force = false;
          }

          if (!force) {
            if (index2 === 0) return this;
            if (index2 === this.length()) return this.next;
          }

          var after = Registry.create(this.domNode.splitText(index2));
          this.parent.insertBefore(after, this.next);
          this.text = this.statics.value(this.domNode);
          return after;
        };

        TextBlot2.prototype.update = function (mutations, context) {
          var _this = this;

          if (mutations.some(function (mutation) {
            return mutation.type === "characterData" && mutation.target === _this.domNode;
          })) {
            this.text = this.statics.value(this.domNode);
          }
        };

        TextBlot2.prototype.value = function () {
          return this.text;
        };

        TextBlot2.blotName = "text";
        TextBlot2.scope = Registry.Scope.INLINE_BLOT;
        return TextBlot2;
      }(leaf_1.default);

      exports2.default = TextBlot;
    }, function (module2, exports2, __webpack_require__) {
      var elem = document.createElement("div");
      elem.classList.toggle("test-class", false);

      if (elem.classList.contains("test-class")) {
        var _toggle = DOMTokenList.prototype.toggle;

        DOMTokenList.prototype.toggle = function (token2, force) {
          if (arguments.length > 1 && !this.contains(token2) === !force) {
            return force;
          } else {
            return _toggle.call(this, token2);
          }
        };
      }

      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position2) {
          position2 = position2 || 0;
          return this.substr(position2, searchString.length) === searchString;
        };
      }

      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (searchString, position2) {
          var subjectString = this.toString();

          if (typeof position2 !== "number" || !isFinite(position2) || Math.floor(position2) !== position2 || position2 > subjectString.length) {
            position2 = subjectString.length;
          }

          position2 -= searchString.length;
          var lastIndex = subjectString.indexOf(searchString, position2);
          return lastIndex !== -1 && lastIndex === position2;
        };
      }

      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
          value: function value(predicate) {
            if (this === null) {
              throw new TypeError("Array.prototype.find called on null or undefined");
            }

            if (typeof predicate !== "function") {
              throw new TypeError("predicate must be a function");
            }

            var list = Object(this);
            var length2 = list.length >>> 0;
            var thisArg = arguments[1];
            var value2;

            for (var i = 0; i < length2; i++) {
              value2 = list[i];

              if (predicate.call(thisArg, value2, i, list)) {
                return value2;
              }
            }

            return void 0;
          }
        });
      }

      document.addEventListener("DOMContentLoaded", function () {
        document.execCommand("enableObjectResizing", false, false);
        document.execCommand("autoUrlDetect", false, false);
      });
    }, function (module2, exports2) {
      var DIFF_DELETE = -1;
      var DIFF_INSERT = 1;
      var DIFF_EQUAL = 0;

      function diff_main(text1, text2, cursor_pos) {
        if (text1 == text2) {
          if (text1) {
            return [[DIFF_EQUAL, text1]];
          }

          return [];
        }

        if (cursor_pos < 0 || text1.length < cursor_pos) {
          cursor_pos = null;
        }

        var commonlength = diff_commonPrefix(text1, text2);
        var commonprefix = text1.substring(0, commonlength);
        text1 = text1.substring(commonlength);
        text2 = text2.substring(commonlength);
        commonlength = diff_commonSuffix(text1, text2);
        var commonsuffix = text1.substring(text1.length - commonlength);
        text1 = text1.substring(0, text1.length - commonlength);
        text2 = text2.substring(0, text2.length - commonlength);
        var diffs = diff_compute_(text1, text2);

        if (commonprefix) {
          diffs.unshift([DIFF_EQUAL, commonprefix]);
        }

        if (commonsuffix) {
          diffs.push([DIFF_EQUAL, commonsuffix]);
        }

        diff_cleanupMerge(diffs);

        if (cursor_pos != null) {
          diffs = fix_cursor(diffs, cursor_pos);
        }

        diffs = fix_emoji(diffs);
        return diffs;
      }

      function diff_compute_(text1, text2) {
        var diffs;

        if (!text1) {
          return [[DIFF_INSERT, text2]];
        }

        if (!text2) {
          return [[DIFF_DELETE, text1]];
        }

        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        var i = longtext.indexOf(shorttext);

        if (i != -1) {
          diffs = [[DIFF_INSERT, longtext.substring(0, i)], [DIFF_EQUAL, shorttext], [DIFF_INSERT, longtext.substring(i + shorttext.length)]];

          if (text1.length > text2.length) {
            diffs[0][0] = diffs[2][0] = DIFF_DELETE;
          }

          return diffs;
        }

        if (shorttext.length == 1) {
          return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
        }

        var hm = diff_halfMatch_(text1, text2);

        if (hm) {
          var text1_a = hm[0];
          var text1_b = hm[1];
          var text2_a = hm[2];
          var text2_b = hm[3];
          var mid_common = hm[4];
          var diffs_a = diff_main(text1_a, text2_a);
          var diffs_b = diff_main(text1_b, text2_b);
          return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
        }

        return diff_bisect_(text1, text2);
      }

      function diff_bisect_(text1, text2) {
        var text1_length = text1.length;
        var text2_length = text2.length;
        var max_d = Math.ceil((text1_length + text2_length) / 2);
        var v_offset = max_d;
        var v_length = 2 * max_d;
        var v1 = new Array(v_length);
        var v2 = new Array(v_length);

        for (var x2 = 0; x2 < v_length; x2++) {
          v1[x2] = -1;
          v2[x2] = -1;
        }

        v1[v_offset + 1] = 0;
        v2[v_offset + 1] = 0;
        var delta = text1_length - text2_length;
        var front = delta % 2 != 0;
        var k1start = 0;
        var k1end = 0;
        var k2start = 0;
        var k2end = 0;

        for (var d2 = 0; d2 < max_d; d2++) {
          for (var k1 = -d2 + k1start; k1 <= d2 - k1end; k1 += 2) {
            var k1_offset = v_offset + k1;
            var x1;

            if (k1 == -d2 || k1 != d2 && v1[k1_offset - 1] < v1[k1_offset + 1]) {
              x1 = v1[k1_offset + 1];
            } else {
              x1 = v1[k1_offset - 1] + 1;
            }

            var y1 = x1 - k1;

            while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)) {
              x1++;
              y1++;
            }

            v1[k1_offset] = x1;

            if (x1 > text1_length) {
              k1end += 2;
            } else if (y1 > text2_length) {
              k1start += 2;
            } else if (front) {
              var k2_offset = v_offset + delta - k1;

              if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                var x22 = text1_length - v2[k2_offset];

                if (x1 >= x22) {
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }

          for (var k2 = -d2 + k2start; k2 <= d2 - k2end; k2 += 2) {
            var k2_offset = v_offset + k2;
            var x22;

            if (k2 == -d2 || k2 != d2 && v2[k2_offset - 1] < v2[k2_offset + 1]) {
              x22 = v2[k2_offset + 1];
            } else {
              x22 = v2[k2_offset - 1] + 1;
            }

            var y2 = x22 - k2;

            while (x22 < text1_length && y2 < text2_length && text1.charAt(text1_length - x22 - 1) == text2.charAt(text2_length - y2 - 1)) {
              x22++;
              y2++;
            }

            v2[k2_offset] = x22;

            if (x22 > text1_length) {
              k2end += 2;
            } else if (y2 > text2_length) {
              k2start += 2;
            } else if (!front) {
              var k1_offset = v_offset + delta - k2;

              if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                var x1 = v1[k1_offset];
                var y1 = v_offset + x1 - k1_offset;
                x22 = text1_length - x22;

                if (x1 >= x22) {
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }
        }

        return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
      }

      function diff_bisectSplit_(text1, text2, x2, y2) {
        var text1a = text1.substring(0, x2);
        var text2a = text2.substring(0, y2);
        var text1b = text1.substring(x2);
        var text2b = text2.substring(y2);
        var diffs = diff_main(text1a, text2a);
        var diffsb = diff_main(text1b, text2b);
        return diffs.concat(diffsb);
      }

      function diff_commonPrefix(text1, text2) {
        if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
          return 0;
        }

        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerstart = 0;

        while (pointermin < pointermid) {
          if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
          } else {
            pointermax = pointermid;
          }

          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }

        return pointermid;
      }

      function diff_commonSuffix(text1, text2) {
        if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
          return 0;
        }

        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerend = 0;

        while (pointermin < pointermid) {
          if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
          } else {
            pointermax = pointermid;
          }

          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }

        return pointermid;
      }

      function diff_halfMatch_(text1, text2) {
        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;

        if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
          return null;
        }

        function diff_halfMatchI_(longtext2, shorttext2, i) {
          var seed = longtext2.substring(i, i + Math.floor(longtext2.length / 4));
          var j = -1;
          var best_common = "";
          var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;

          while ((j = shorttext2.indexOf(seed, j + 1)) != -1) {
            var prefixLength = diff_commonPrefix(longtext2.substring(i), shorttext2.substring(j));
            var suffixLength = diff_commonSuffix(longtext2.substring(0, i), shorttext2.substring(0, j));

            if (best_common.length < suffixLength + prefixLength) {
              best_common = shorttext2.substring(j - suffixLength, j) + shorttext2.substring(j, j + prefixLength);
              best_longtext_a = longtext2.substring(0, i - suffixLength);
              best_longtext_b = longtext2.substring(i + prefixLength);
              best_shorttext_a = shorttext2.substring(0, j - suffixLength);
              best_shorttext_b = shorttext2.substring(j + prefixLength);
            }
          }

          if (best_common.length * 2 >= longtext2.length) {
            return [best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b, best_common];
          } else {
            return null;
          }
        }

        var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
        var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
        var hm;

        if (!hm1 && !hm2) {
          return null;
        } else if (!hm2) {
          hm = hm1;
        } else if (!hm1) {
          hm = hm2;
        } else {
          hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
        }

        var text1_a, text1_b, text2_a, text2_b;

        if (text1.length > text2.length) {
          text1_a = hm[0];
          text1_b = hm[1];
          text2_a = hm[2];
          text2_b = hm[3];
        } else {
          text2_a = hm[0];
          text2_b = hm[1];
          text1_a = hm[2];
          text1_b = hm[3];
        }

        var mid_common = hm[4];
        return [text1_a, text1_b, text2_a, text2_b, mid_common];
      }

      function diff_cleanupMerge(diffs) {
        diffs.push([DIFF_EQUAL, ""]);
        var pointer = 0;
        var count_delete = 0;
        var count_insert = 0;
        var text_delete = "";
        var text_insert = "";
        var commonlength;

        while (pointer < diffs.length) {
          switch (diffs[pointer][0]) {
            case DIFF_INSERT:
              count_insert++;
              text_insert += diffs[pointer][1];
              pointer++;
              break;

            case DIFF_DELETE:
              count_delete++;
              text_delete += diffs[pointer][1];
              pointer++;
              break;

            case DIFF_EQUAL:
              if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                  commonlength = diff_commonPrefix(text_insert, text_delete);

                  if (commonlength !== 0) {
                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) {
                      diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                    } else {
                      diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                      pointer++;
                    }

                    text_insert = text_insert.substring(commonlength);
                    text_delete = text_delete.substring(commonlength);
                  }

                  commonlength = diff_commonSuffix(text_insert, text_delete);

                  if (commonlength !== 0) {
                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                  }
                }

                if (count_delete === 0) {
                  diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
                } else if (count_insert === 0) {
                  diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
                } else {
                  diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
                }

                pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
              } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
              } else {
                pointer++;
              }

              count_insert = 0;
              count_delete = 0;
              text_delete = "";
              text_insert = "";
              break;
          }
        }

        if (diffs[diffs.length - 1][1] === "") {
          diffs.pop();
        }

        var changes = false;
        pointer = 1;

        while (pointer < diffs.length - 1) {
          if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
              diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
              diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
              diffs.splice(pointer - 1, 1);
              changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
              diffs[pointer - 1][1] += diffs[pointer + 1][1];
              diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
              diffs.splice(pointer + 1, 1);
              changes = true;
            }
          }

          pointer++;
        }

        if (changes) {
          diff_cleanupMerge(diffs);
        }
      }

      var diff = diff_main;
      diff.INSERT = DIFF_INSERT;
      diff.DELETE = DIFF_DELETE;
      diff.EQUAL = DIFF_EQUAL;
      module2.exports = diff;

      function cursor_normalize_diff(diffs, cursor_pos) {
        if (cursor_pos === 0) {
          return [DIFF_EQUAL, diffs];
        }

        for (var current_pos = 0, i = 0; i < diffs.length; i++) {
          var d2 = diffs[i];

          if (d2[0] === DIFF_DELETE || d2[0] === DIFF_EQUAL) {
            var next_pos = current_pos + d2[1].length;

            if (cursor_pos === next_pos) {
              return [i + 1, diffs];
            } else if (cursor_pos < next_pos) {
              diffs = diffs.slice();
              var split_pos = cursor_pos - current_pos;
              var d_left = [d2[0], d2[1].slice(0, split_pos)];
              var d_right = [d2[0], d2[1].slice(split_pos)];
              diffs.splice(i, 1, d_left, d_right);
              return [i + 1, diffs];
            } else {
              current_pos = next_pos;
            }
          }
        }

        throw new Error("cursor_pos is out of bounds!");
      }

      function fix_cursor(diffs, cursor_pos) {
        var norm = cursor_normalize_diff(diffs, cursor_pos);
        var ndiffs = norm[1];
        var cursor_pointer = norm[0];
        var d2 = ndiffs[cursor_pointer];
        var d_next = ndiffs[cursor_pointer + 1];

        if (d2 == null) {
          return diffs;
        } else if (d2[0] !== DIFF_EQUAL) {
          return diffs;
        } else {
          if (d_next != null && d2[1] + d_next[1] === d_next[1] + d2[1]) {
            ndiffs.splice(cursor_pointer, 2, d_next, d2);
            return merge_tuples(ndiffs, cursor_pointer, 2);
          } else if (d_next != null && d_next[1].indexOf(d2[1]) === 0) {
            ndiffs.splice(cursor_pointer, 2, [d_next[0], d2[1]], [0, d2[1]]);
            var suffix = d_next[1].slice(d2[1].length);

            if (suffix.length > 0) {
              ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
            }

            return merge_tuples(ndiffs, cursor_pointer, 3);
          } else {
            return diffs;
          }
        }
      }

      function fix_emoji(diffs) {
        var compact = false;

        var starts_with_pair_end = function starts_with_pair_end(str) {
          return str.charCodeAt(0) >= 56320 && str.charCodeAt(0) <= 57343;
        };

        var ends_with_pair_start = function ends_with_pair_start(str) {
          return str.charCodeAt(str.length - 1) >= 55296 && str.charCodeAt(str.length - 1) <= 56319;
        };

        for (var i = 2; i < diffs.length; i += 1) {
          if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
            compact = true;
            diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
            diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
            diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
          }
        }

        if (!compact) {
          return diffs;
        }

        var fixed_diffs = [];

        for (var i = 0; i < diffs.length; i += 1) {
          if (diffs[i][1].length > 0) {
            fixed_diffs.push(diffs[i]);
          }
        }

        return fixed_diffs;
      }

      function merge_tuples(diffs, start2, length2) {
        for (var i = start2 + length2 - 1; i >= 0 && i >= start2 - 1; i--) {
          if (i + 1 < diffs.length) {
            var left_d = diffs[i];
            var right_d = diffs[i + 1];

            if (left_d[0] === right_d[1]) {
              diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
            }
          }
        }

        return diffs;
      }
    }, function (module2, exports2) {
      exports2 = module2.exports = typeof Object.keys === "function" ? Object.keys : shim;
      exports2.shim = shim;

      function shim(obj) {
        var keys2 = [];

        for (var key in obj) {
          keys2.push(key);
        }

        return keys2;
      }
    }, function (module2, exports2) {
      var supportsArgumentsClass = function () {
        return Object.prototype.toString.call(arguments);
      }() == "[object Arguments]";

      exports2 = module2.exports = supportsArgumentsClass ? supported : unsupported;
      exports2.supported = supported;

      function supported(object) {
        return Object.prototype.toString.call(object) == "[object Arguments]";
      }

      exports2.unsupported = unsupported;

      function unsupported(object) {
        return object && typeof object == "object" && typeof object.length == "number" && Object.prototype.hasOwnProperty.call(object, "callee") && !Object.prototype.propertyIsEnumerable.call(object, "callee") || false;
      }
    }, function (module2, exports2) {
      var has = Object.prototype.hasOwnProperty,
          prefix2 = "~";

      function Events() {}

      if (Object.create) {
        Events.prototype =
        /* @__PURE__ */
        Object.create(null);
        if (!new Events().__proto__) prefix2 = false;
      }

      function EE(fn3, context, once) {
        this.fn = fn3;
        this.context = context;
        this.once = once || false;
      }

      function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
      }

      EventEmitter.prototype.eventNames = function eventNames() {
        var names = [],
            events,
            name2;
        if (this._eventsCount === 0) return names;

        for (name2 in events = this._events) {
          if (has.call(events, name2)) names.push(prefix2 ? name2.slice(1) : name2);
        }

        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }

        return names;
      };

      EventEmitter.prototype.listeners = function listeners(event, exists) {
        var evt = prefix2 ? prefix2 + event : event,
            available = this._events[evt];
        if (exists) return !!available;
        if (!available) return [];
        if (available.fn) return [available.fn];

        for (var i = 0, l2 = available.length, ee2 = new Array(l2); i < l2; i++) {
          ee2[i] = available[i].fn;
        }

        return ee2;
      };

      EventEmitter.prototype.emit = function emit2(event, a1, a2, a3, a4, a5) {
        var evt = prefix2 ? prefix2 + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt],
            len = arguments.length,
            args,
            i;

        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);

          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;

            case 2:
              return listeners.fn.call(listeners.context, a1), true;

            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;

            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;

            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }

          for (i = 1, args = new Array(len - 1); i < len; i++) {
            args[i - 1] = arguments[i];
          }

          listeners.fn.apply(listeners.context, args);
        } else {
          var length2 = listeners.length,
              j;

          for (i = 0; i < length2; i++) {
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);

            switch (len) {
              case 1:
                listeners[i].fn.call(listeners[i].context);
                break;

              case 2:
                listeners[i].fn.call(listeners[i].context, a1);
                break;

              case 3:
                listeners[i].fn.call(listeners[i].context, a1, a2);
                break;

              case 4:
                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                break;

              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }
                listeners[i].fn.apply(listeners[i].context, args);
            }
          }
        }

        return true;
      };

      EventEmitter.prototype.on = function on2(event, fn3, context) {
        var listener = new EE(fn3, context || this),
            evt = prefix2 ? prefix2 + event : event;
        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
        return this;
      };

      EventEmitter.prototype.once = function once(event, fn3, context) {
        var listener = new EE(fn3, context || this, true),
            evt = prefix2 ? prefix2 + event : event;
        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
        return this;
      };

      EventEmitter.prototype.removeListener = function removeListener(event, fn3, context, once) {
        var evt = prefix2 ? prefix2 + event : event;
        if (!this._events[evt]) return this;

        if (!fn3) {
          if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          return this;
        }

        var listeners = this._events[evt];

        if (listeners.fn) {
          if (listeners.fn === fn3 && (!once || listeners.once) && (!context || listeners.context === context)) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          for (var i = 0, events = [], length2 = listeners.length; i < length2; i++) {
            if (listeners[i].fn !== fn3 || once && !listeners[i].once || context && listeners[i].context !== context) {
              events.push(listeners[i]);
            }
          }

          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
        }

        return this;
      };

      EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;

        if (event) {
          evt = prefix2 ? prefix2 + event : event;

          if (this._events[evt]) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }

        return this;
      };

      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.addListener = EventEmitter.prototype.on;

      EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
        return this;
      };

      EventEmitter.prefixed = prefix2;
      EventEmitter.EventEmitter = EventEmitter;

      if ("undefined" !== typeof module2) {
        module2.exports = EventEmitter;
      }
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.matchText = exports2.matchSpacing = exports2.matchNewline = exports2.matchBlot = exports2.matchAttributor = exports2.default = void 0;

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _extend2 = __webpack_require__(3);

      var _extend3 = _interopRequireDefault(_extend2);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _align = __webpack_require__(36);

      var _background = __webpack_require__(37);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _color = __webpack_require__(26);

      var _direction = __webpack_require__(38);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)("quill:clipboard");
      var DOM_KEY = "__ql-matcher";
      var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ["br", matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ["li", matchIndent], ["b", matchAlias.bind(matchAlias, "bold")], ["i", matchAlias.bind(matchAlias, "italic")], ["style", matchIgnore]];
      var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});
      var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});

      var Clipboard = function (_Module) {
        _inherits2(Clipboard2, _Module);

        function Clipboard2(quill2, options2) {
          _classCallCheck2(this, Clipboard2);

          var _this = _possibleConstructorReturn2(this, (Clipboard2.__proto__ || Object.getPrototypeOf(Clipboard2)).call(this, quill2, options2));

          _this.quill.root.addEventListener("paste", _this.onPaste.bind(_this));

          _this.container = _this.quill.addContainer("ql-clipboard");

          _this.container.setAttribute("contenteditable", true);

          _this.container.setAttribute("tabindex", -1);

          _this.matchers = [];
          CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref3) {
            var _ref22 = _slicedToArray2(_ref3, 2),
                selector = _ref22[0],
                matcher = _ref22[1];

            if (!options2.matchVisual && matcher === matchSpacing) return;

            _this.addMatcher(selector, matcher);
          });
          return _this;
        }

        _createClass2(Clipboard2, [{
          key: "addMatcher",
          value: function addMatcher(selector, matcher) {
            this.matchers.push([selector, matcher]);
          }
        }, {
          key: "convert",
          value: function convert(html) {
            if (typeof html === "string") {
              this.container.innerHTML = html.replace(/\>\r?\n +\</g, "><");
              return this.convert();
            }

            var formats2 = this.quill.getFormat(this.quill.selection.savedRange.index);

            if (formats2[_code2.default.blotName]) {
              var text = this.container.innerText;
              this.container.innerHTML = "";
              return new _quillDelta2.default().insert(text, _defineProperty2({}, _code2.default.blotName, formats2[_code2.default.blotName]));
            }

            var _prepareMatching = this.prepareMatching(),
                _prepareMatching2 = _slicedToArray2(_prepareMatching, 2),
                elementMatchers = _prepareMatching2[0],
                textMatchers = _prepareMatching2[1];

            var delta = traverse(this.container, elementMatchers, textMatchers);

            if (deltaEndsWith(delta, "\n") && delta.ops[delta.ops.length - 1].attributes == null) {
              delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
            }

            debug.log("convert", this.container.innerHTML, delta);
            this.container.innerHTML = "";
            return delta;
          }
        }, {
          key: "dangerouslyPasteHTML",
          value: function dangerouslyPasteHTML(index2, html) {
            var source2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _quill2.default.sources.API;

            if (typeof index2 === "string") {
              this.quill.setContents(this.convert(index2), html);
              this.quill.setSelection(0, _quill2.default.sources.SILENT);
            } else {
              var paste = this.convert(html);
              this.quill.updateContents(new _quillDelta2.default().retain(index2).concat(paste), source2);
              this.quill.setSelection(index2 + paste.length(), _quill2.default.sources.SILENT);
            }
          }
        }, {
          key: "onPaste",
          value: function onPaste(e2) {
            var _this2 = this;

            if (e2.defaultPrevented || !this.quill.isEnabled()) return;
            var range2 = this.quill.getSelection();
            var delta = new _quillDelta2.default().retain(range2.index);
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.container.focus();
            this.quill.selection.update(_quill2.default.sources.SILENT);
            setTimeout(function () {
              delta = delta.concat(_this2.convert()).delete(range2.length);

              _this2.quill.updateContents(delta, _quill2.default.sources.USER);

              _this2.quill.setSelection(delta.length() - range2.length, _quill2.default.sources.SILENT);

              _this2.quill.scrollingContainer.scrollTop = scrollTop;

              _this2.quill.focus();
            }, 1);
          }
        }, {
          key: "prepareMatching",
          value: function prepareMatching() {
            var _this3 = this;

            var elementMatchers = [],
                textMatchers = [];
            this.matchers.forEach(function (pair) {
              var _pair = _slicedToArray2(pair, 2),
                  selector = _pair[0],
                  matcher = _pair[1];

              switch (selector) {
                case Node.TEXT_NODE:
                  textMatchers.push(matcher);
                  break;

                case Node.ELEMENT_NODE:
                  elementMatchers.push(matcher);
                  break;

                default:
                  [].forEach.call(_this3.container.querySelectorAll(selector), function (node2) {
                    node2[DOM_KEY] = node2[DOM_KEY] || [];
                    node2[DOM_KEY].push(matcher);
                  });
                  break;
              }
            });
            return [elementMatchers, textMatchers];
          }
        }]);

        return Clipboard2;
      }(_module2.default);

      Clipboard.DEFAULTS = {
        matchers: [],
        matchVisual: true
      };

      function applyFormat(delta, format, value) {
        if ((typeof format === "undefined" ? "undefined" : _typeof2(format)) === "object") {
          return Object.keys(format).reduce(function (delta2, key) {
            return applyFormat(delta2, key, format[key]);
          }, delta);
        } else {
          return delta.reduce(function (delta2, op) {
            if (op.attributes && op.attributes[format]) {
              return delta2.push(op);
            } else {
              return delta2.insert(op.insert, (0, _extend3.default)({}, _defineProperty2({}, format, value), op.attributes));
            }
          }, new _quillDelta2.default());
        }
      }

      function computeStyle(node2) {
        if (node2.nodeType !== Node.ELEMENT_NODE) return {};
        var DOM_KEY2 = "__ql-computed-style";
        return node2[DOM_KEY2] || (node2[DOM_KEY2] = window.getComputedStyle(node2));
      }

      function deltaEndsWith(delta, text) {
        var endText = "";

        for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
          var op = delta.ops[i];
          if (typeof op.insert !== "string") break;
          endText = op.insert + endText;
        }

        return endText.slice(-1 * text.length) === text;
      }

      function isLine(node2) {
        if (node2.childNodes.length === 0) return false;
        var style = computeStyle(node2);
        return ["block", "list-item"].indexOf(style.display) > -1;
      }

      function traverse(node2, elementMatchers, textMatchers) {
        if (node2.nodeType === node2.TEXT_NODE) {
          return textMatchers.reduce(function (delta, matcher) {
            return matcher(node2, delta);
          }, new _quillDelta2.default());
        } else if (node2.nodeType === node2.ELEMENT_NODE) {
          return [].reduce.call(node2.childNodes || [], function (delta, childNode) {
            var childrenDelta = traverse(childNode, elementMatchers, textMatchers);

            if (childNode.nodeType === node2.ELEMENT_NODE) {
              childrenDelta = elementMatchers.reduce(function (childrenDelta2, matcher) {
                return matcher(childNode, childrenDelta2);
              }, childrenDelta);
              childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta2, matcher) {
                return matcher(childNode, childrenDelta2);
              }, childrenDelta);
            }

            return delta.concat(childrenDelta);
          }, new _quillDelta2.default());
        } else {
          return new _quillDelta2.default();
        }
      }

      function matchAlias(format, node2, delta) {
        return applyFormat(delta, format, true);
      }

      function matchAttributor(node2, delta) {
        var attributes = _parchment2.default.Attributor.Attribute.keys(node2);

        var classes = _parchment2.default.Attributor.Class.keys(node2);

        var styles = _parchment2.default.Attributor.Style.keys(node2);

        var formats2 = {};
        attributes.concat(classes).concat(styles).forEach(function (name2) {
          var attr = _parchment2.default.query(name2, _parchment2.default.Scope.ATTRIBUTE);

          if (attr != null) {
            formats2[attr.attrName] = attr.value(node2);
            if (formats2[attr.attrName]) return;
          }

          attr = ATTRIBUTE_ATTRIBUTORS[name2];

          if (attr != null && (attr.attrName === name2 || attr.keyName === name2)) {
            formats2[attr.attrName] = attr.value(node2) || void 0;
          }

          attr = STYLE_ATTRIBUTORS[name2];

          if (attr != null && (attr.attrName === name2 || attr.keyName === name2)) {
            attr = STYLE_ATTRIBUTORS[name2];
            formats2[attr.attrName] = attr.value(node2) || void 0;
          }
        });

        if (Object.keys(formats2).length > 0) {
          delta = applyFormat(delta, formats2);
        }

        return delta;
      }

      function matchBlot(node2, delta) {
        var match2 = _parchment2.default.query(node2);

        if (match2 == null) return delta;

        if (match2.prototype instanceof _parchment2.default.Embed) {
          var embed = {};
          var value = match2.value(node2);

          if (value != null) {
            embed[match2.blotName] = value;
            delta = new _quillDelta2.default().insert(embed, match2.formats(node2));
          }
        } else if (typeof match2.formats === "function") {
          delta = applyFormat(delta, match2.blotName, match2.formats(node2));
        }

        return delta;
      }

      function matchBreak(node2, delta) {
        if (!deltaEndsWith(delta, "\n")) {
          delta.insert("\n");
        }

        return delta;
      }

      function matchIgnore() {
        return new _quillDelta2.default();
      }

      function matchIndent(node2, delta) {
        var match2 = _parchment2.default.query(node2);

        if (match2 == null || match2.blotName !== "list-item" || !deltaEndsWith(delta, "\n")) {
          return delta;
        }

        var indent = -1,
            parent = node2.parentNode;

        while (!parent.classList.contains("ql-clipboard")) {
          if ((_parchment2.default.query(parent) || {}).blotName === "list") {
            indent += 1;
          }

          parent = parent.parentNode;
        }

        if (indent <= 0) return delta;
        return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
          indent: indent
        }));
      }

      function matchNewline(node2, delta) {
        if (!deltaEndsWith(delta, "\n")) {
          if (isLine(node2) || delta.length() > 0 && node2.nextSibling && isLine(node2.nextSibling)) {
            delta.insert("\n");
          }
        }

        return delta;
      }

      function matchSpacing(node2, delta) {
        if (isLine(node2) && node2.nextElementSibling != null && !deltaEndsWith(delta, "\n\n")) {
          var nodeHeight = node2.offsetHeight + parseFloat(computeStyle(node2).marginTop) + parseFloat(computeStyle(node2).marginBottom);

          if (node2.nextElementSibling.offsetTop > node2.offsetTop + nodeHeight * 1.5) {
            delta.insert("\n");
          }
        }

        return delta;
      }

      function matchStyles(node2, delta) {
        var formats2 = {};
        var style = node2.style || {};

        if (style.fontStyle && computeStyle(node2).fontStyle === "italic") {
          formats2.italic = true;
        }

        if (style.fontWeight && (computeStyle(node2).fontWeight.startsWith("bold") || parseInt(computeStyle(node2).fontWeight) >= 700)) {
          formats2.bold = true;
        }

        if (Object.keys(formats2).length > 0) {
          delta = applyFormat(delta, formats2);
        }

        if (parseFloat(style.textIndent || 0) > 0) {
          delta = new _quillDelta2.default().insert("	").concat(delta);
        }

        return delta;
      }

      function matchText(node2, delta) {
        var text = node2.data;

        if (node2.parentNode.tagName === "O:P") {
          return delta.insert(text.trim());
        }

        if (text.trim().length === 0 && node2.parentNode.classList.contains("ql-clipboard")) {
          return delta;
        }

        if (!computeStyle(node2.parentNode).whiteSpace.startsWith("pre")) {
          var replacer = function replacer2(collapse, match2) {
            match2 = match2.replace(/[^\u00a0]/g, "");
            return match2.length < 1 && collapse ? " " : match2;
          };

          text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
          text = text.replace(/\s\s+/g, replacer.bind(replacer, true));

          if (node2.previousSibling == null && isLine(node2.parentNode) || node2.previousSibling != null && isLine(node2.previousSibling)) {
            text = text.replace(/^\s+/, replacer.bind(replacer, false));
          }

          if (node2.nextSibling == null && isLine(node2.parentNode) || node2.nextSibling != null && isLine(node2.nextSibling)) {
            text = text.replace(/\s+$/, replacer.bind(replacer, false));
          }
        }

        return delta.insert(text);
      }

      exports2.default = Clipboard;
      exports2.matchAttributor = matchAttributor;
      exports2.matchBlot = matchBlot;
      exports2.matchNewline = matchNewline;
      exports2.matchSpacing = matchSpacing;
      exports2.matchText = matchText;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Bold = function (_Inline) {
        _inherits2(Bold2, _Inline);

        function Bold2() {
          _classCallCheck2(this, Bold2);

          return _possibleConstructorReturn2(this, (Bold2.__proto__ || Object.getPrototypeOf(Bold2)).apply(this, arguments));
        }

        _createClass2(Bold2, [{
          key: "optimize",
          value: function optimize(context) {
            _get(Bold2.prototype.__proto__ || Object.getPrototypeOf(Bold2.prototype), "optimize", this).call(this, context);

            if (this.domNode.tagName !== this.statics.tagName[0]) {
              this.replaceWith(this.statics.blotName);
            }
          }
        }], [{
          key: "create",
          value: function create() {
            return _get(Bold2.__proto__ || Object.getPrototypeOf(Bold2), "create", this).call(this);
          }
        }, {
          key: "formats",
          value: function formats2() {
            return true;
          }
        }]);

        return Bold2;
      }(_inline2.default);

      Bold.blotName = "bold";
      Bold.tagName = ["STRONG", "B"];
      exports2.default = Bold;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.addControls = exports2.default = void 0;

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)("quill:toolbar");

      var Toolbar = function (_Module) {
        _inherits2(Toolbar2, _Module);

        function Toolbar2(quill2, options2) {
          _classCallCheck2(this, Toolbar2);

          var _this = _possibleConstructorReturn2(this, (Toolbar2.__proto__ || Object.getPrototypeOf(Toolbar2)).call(this, quill2, options2));

          if (Array.isArray(_this.options.container)) {
            var container = document.createElement("div");
            addControls(container, _this.options.container);
            quill2.container.parentNode.insertBefore(container, quill2.container);
            _this.container = container;
          } else if (typeof _this.options.container === "string") {
            _this.container = document.querySelector(_this.options.container);
          } else {
            _this.container = _this.options.container;
          }

          if (!(_this.container instanceof HTMLElement)) {
            var _ret;

            return _ret = debug.error("Container required for toolbar", _this.options), _possibleConstructorReturn2(_this, _ret);
          }

          _this.container.classList.add("ql-toolbar");

          _this.controls = [];
          _this.handlers = {};
          Object.keys(_this.options.handlers).forEach(function (format) {
            _this.addHandler(format, _this.options.handlers[format]);
          });
          [].forEach.call(_this.container.querySelectorAll("button, select"), function (input) {
            _this.attach(input);
          });

          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range2) {
            if (type === _quill2.default.events.SELECTION_CHANGE) {
              _this.update(range2);
            }
          });

          _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            var _this$quill$selection = _this.quill.selection.getRange(),
                _this$quill$selection2 = _slicedToArray2(_this$quill$selection, 1),
                range2 = _this$quill$selection2[0];

            _this.update(range2);
          });

          return _this;
        }

        _createClass2(Toolbar2, [{
          key: "addHandler",
          value: function addHandler(format, handler) {
            this.handlers[format] = handler;
          }
        }, {
          key: "attach",
          value: function attach(input) {
            var _this2 = this;

            var format = [].find.call(input.classList, function (className) {
              return className.indexOf("ql-") === 0;
            });
            if (!format) return;
            format = format.slice("ql-".length);

            if (input.tagName === "BUTTON") {
              input.setAttribute("type", "button");
            }

            if (this.handlers[format] == null) {
              if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                debug.warn("ignoring attaching to disabled format", format, input);
                return;
              }

              if (_parchment2.default.query(format) == null) {
                debug.warn("ignoring attaching to nonexistent format", format, input);
                return;
              }
            }

            var eventName = input.tagName === "SELECT" ? "change" : "click";
            input.addEventListener(eventName, function (e2) {
              var value = void 0;

              if (input.tagName === "SELECT") {
                if (input.selectedIndex < 0) return;
                var selected = input.options[input.selectedIndex];

                if (selected.hasAttribute("selected")) {
                  value = false;
                } else {
                  value = selected.value || false;
                }
              } else {
                if (input.classList.contains("ql-active")) {
                  value = false;
                } else {
                  value = input.value || !input.hasAttribute("value");
                }

                e2.preventDefault();
              }

              _this2.quill.focus();

              var _quill$selection$getR = _this2.quill.selection.getRange(),
                  _quill$selection$getR2 = _slicedToArray2(_quill$selection$getR, 1),
                  range2 = _quill$selection$getR2[0];

              if (_this2.handlers[format] != null) {
                _this2.handlers[format].call(_this2, value);
              } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                value = prompt("Enter " + format);
                if (!value) return;

                _this2.quill.updateContents(new _quillDelta2.default().retain(range2.index).delete(range2.length).insert(_defineProperty2({}, format, value)), _quill2.default.sources.USER);
              } else {
                _this2.quill.format(format, value, _quill2.default.sources.USER);
              }

              _this2.update(range2);
            });
            this.controls.push([format, input]);
          }
        }, {
          key: "update",
          value: function update(range2) {
            var formats2 = range2 == null ? {} : this.quill.getFormat(range2);
            this.controls.forEach(function (pair) {
              var _pair = _slicedToArray2(pair, 2),
                  format = _pair[0],
                  input = _pair[1];

              if (input.tagName === "SELECT") {
                var option = void 0;

                if (range2 == null) {
                  option = null;
                } else if (formats2[format] == null) {
                  option = input.querySelector("option[selected]");
                } else if (!Array.isArray(formats2[format])) {
                  var value = formats2[format];

                  if (typeof value === "string") {
                    value = value.replace(/\"/g, '\\"');
                  }

                  option = input.querySelector('option[value="' + value + '"]');
                }

                if (option == null) {
                  input.value = "";
                  input.selectedIndex = -1;
                } else {
                  option.selected = true;
                }
              } else {
                if (range2 == null) {
                  input.classList.remove("ql-active");
                } else if (input.hasAttribute("value")) {
                  var isActive = formats2[format] === input.getAttribute("value") || formats2[format] != null && formats2[format].toString() === input.getAttribute("value") || formats2[format] == null && !input.getAttribute("value");
                  input.classList.toggle("ql-active", isActive);
                } else {
                  input.classList.toggle("ql-active", formats2[format] != null);
                }
              }
            });
          }
        }]);

        return Toolbar2;
      }(_module2.default);

      Toolbar.DEFAULTS = {};

      function addButton(container, format, value) {
        var input = document.createElement("button");
        input.setAttribute("type", "button");
        input.classList.add("ql-" + format);

        if (value != null) {
          input.value = value;
        }

        container.appendChild(input);
      }

      function addControls(container, groups) {
        if (!Array.isArray(groups[0])) {
          groups = [groups];
        }

        groups.forEach(function (controls) {
          var group = document.createElement("span");
          group.classList.add("ql-formats");
          controls.forEach(function (control) {
            if (typeof control === "string") {
              addButton(group, control);
            } else {
              var format = Object.keys(control)[0];
              var value = control[format];

              if (Array.isArray(value)) {
                addSelect(group, format, value);
              } else {
                addButton(group, format, value);
              }
            }
          });
          container.appendChild(group);
        });
      }

      function addSelect(container, format, values) {
        var input = document.createElement("select");
        input.classList.add("ql-" + format);
        values.forEach(function (value) {
          var option = document.createElement("option");

          if (value !== false) {
            option.setAttribute("value", value);
          } else {
            option.setAttribute("selected", "selected");
          }

          input.appendChild(option);
        });
        container.appendChild(input);
      }

      Toolbar.DEFAULTS = {
        container: null,
        handlers: {
          clean: function clean() {
            var _this3 = this;

            var range2 = this.quill.getSelection();
            if (range2 == null) return;

            if (range2.length == 0) {
              var formats2 = this.quill.getFormat();
              Object.keys(formats2).forEach(function (name2) {
                if (_parchment2.default.query(name2, _parchment2.default.Scope.INLINE) != null) {
                  _this3.quill.format(name2, false);
                }
              });
            } else {
              this.quill.removeFormat(range2, _quill2.default.sources.USER);
            }
          },
          direction: function direction(value) {
            var align = this.quill.getFormat()["align"];

            if (value === "rtl" && align == null) {
              this.quill.format("align", "right", _quill2.default.sources.USER);
            } else if (!value && align === "right") {
              this.quill.format("align", false, _quill2.default.sources.USER);
            }

            this.quill.format("direction", value, _quill2.default.sources.USER);
          },
          indent: function indent(value) {
            var range2 = this.quill.getSelection();
            var formats2 = this.quill.getFormat(range2);
            var indent2 = parseInt(formats2.indent || 0);

            if (value === "+1" || value === "-1") {
              var modifier = value === "+1" ? 1 : -1;
              if (formats2.direction === "rtl") modifier *= -1;
              this.quill.format("indent", indent2 + modifier, _quill2.default.sources.USER);
            }
          },
          link: function link(value) {
            if (value === true) {
              value = prompt("Enter link URL:");
            }

            this.quill.format("link", value, _quill2.default.sources.USER);
          },
          list: function list(value) {
            var range2 = this.quill.getSelection();
            var formats2 = this.quill.getFormat(range2);

            if (value === "check") {
              if (formats2["list"] === "checked" || formats2["list"] === "unchecked") {
                this.quill.format("list", false, _quill2.default.sources.USER);
              } else {
                this.quill.format("list", "unchecked", _quill2.default.sources.USER);
              }
            } else {
              this.quill.format("list", value, _quill2.default.sources.USER);
            }
          }
        }
      };
      exports2.default = Toolbar;
      exports2.addControls = addControls;
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorPicker = function (_Picker) {
        _inherits2(ColorPicker2, _Picker);

        function ColorPicker2(select, label) {
          _classCallCheck2(this, ColorPicker2);

          var _this = _possibleConstructorReturn2(this, (ColorPicker2.__proto__ || Object.getPrototypeOf(ColorPicker2)).call(this, select));

          _this.label.innerHTML = label;

          _this.container.classList.add("ql-color-picker");

          [].slice.call(_this.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function (item) {
            item.classList.add("ql-primary");
          });
          return _this;
        }

        _createClass2(ColorPicker2, [{
          key: "buildItem",
          value: function buildItem(option) {
            var item = _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "buildItem", this).call(this, option);

            item.style.backgroundColor = option.getAttribute("value") || "";
            return item;
          }
        }, {
          key: "selectItem",
          value: function selectItem(item, trigger) {
            _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "selectItem", this).call(this, item, trigger);

            var colorLabel = this.label.querySelector(".ql-color-label");
            var value = item ? item.getAttribute("data-value") || "" : "";

            if (colorLabel) {
              if (colorLabel.tagName === "line") {
                colorLabel.style.stroke = value;
              } else {
                colorLabel.style.fill = value;
              }
            }
          }
        }]);

        return ColorPicker2;
      }(_picker2.default);

      exports2.default = ColorPicker;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IconPicker = function (_Picker) {
        _inherits2(IconPicker2, _Picker);

        function IconPicker2(select, icons) {
          _classCallCheck2(this, IconPicker2);

          var _this = _possibleConstructorReturn2(this, (IconPicker2.__proto__ || Object.getPrototypeOf(IconPicker2)).call(this, select));

          _this.container.classList.add("ql-icon-picker");

          [].forEach.call(_this.container.querySelectorAll(".ql-picker-item"), function (item) {
            item.innerHTML = icons[item.getAttribute("data-value") || ""];
          });
          _this.defaultItem = _this.container.querySelector(".ql-selected");

          _this.selectItem(_this.defaultItem);

          return _this;
        }

        _createClass2(IconPicker2, [{
          key: "selectItem",
          value: function selectItem(item, trigger) {
            _get(IconPicker2.prototype.__proto__ || Object.getPrototypeOf(IconPicker2.prototype), "selectItem", this).call(this, item, trigger);

            item = item || this.defaultItem;
            this.label.innerHTML = item.innerHTML;
          }
        }]);

        return IconPicker2;
      }(_picker2.default);

      exports2.default = IconPicker;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Tooltip = function () {
        function Tooltip2(quill2, boundsContainer) {
          var _this = this;

          _classCallCheck2(this, Tooltip2);

          this.quill = quill2;
          this.boundsContainer = boundsContainer || document.body;
          this.root = quill2.addContainer("ql-tooltip");
          this.root.innerHTML = this.constructor.TEMPLATE;

          if (this.quill.root === this.quill.scrollingContainer) {
            this.quill.root.addEventListener("scroll", function () {
              _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + "px";
            });
          }

          this.hide();
        }

        _createClass2(Tooltip2, [{
          key: "hide",
          value: function hide2() {
            this.root.classList.add("ql-hidden");
          }
        }, {
          key: "position",
          value: function position2(reference2) {
            var left2 = reference2.left + reference2.width / 2 - this.root.offsetWidth / 2;
            var top2 = reference2.bottom + this.quill.root.scrollTop;
            this.root.style.left = left2 + "px";
            this.root.style.top = top2 + "px";
            this.root.classList.remove("ql-flip");
            var containerBounds = this.boundsContainer.getBoundingClientRect();
            var rootBounds = this.root.getBoundingClientRect();
            var shift = 0;

            if (rootBounds.right > containerBounds.right) {
              shift = containerBounds.right - rootBounds.right;
              this.root.style.left = left2 + shift + "px";
            }

            if (rootBounds.left < containerBounds.left) {
              shift = containerBounds.left - rootBounds.left;
              this.root.style.left = left2 + shift + "px";
            }

            if (rootBounds.bottom > containerBounds.bottom) {
              var height = rootBounds.bottom - rootBounds.top;
              var verticalShift = reference2.bottom - reference2.top + height;
              this.root.style.top = top2 - verticalShift + "px";
              this.root.classList.add("ql-flip");
            }

            return shift;
          }
        }, {
          key: "show",
          value: function show() {
            this.root.classList.remove("ql-editing");
            this.root.classList.remove("ql-hidden");
          }
        }]);

        return Tooltip2;
      }();

      exports2.default = Tooltip;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _slicedToArray2 = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;

          var _e2 = void 0;

          try {
            for (var _i2 = arr[Symbol.iterator](), _s2; !(_n = (_s2 = _i2.next()).done); _n = true) {
              _arr.push(_s2.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e2 = err;
          } finally {
            try {
              if (!_n && _i2["return"]) _i2["return"]();
            } finally {
              if (_d) throw _e2;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _link2 = __webpack_require__(27);

      var _link22 = _interopRequireDefault(_link2);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [[{
        header: ["1", "2", "3", false]
      }], ["bold", "italic", "underline", "link"], [{
        list: "ordered"
      }, {
        list: "bullet"
      }], ["clean"]];

      var SnowTheme = function (_BaseTheme) {
        _inherits2(SnowTheme2, _BaseTheme);

        function SnowTheme2(quill2, options2) {
          _classCallCheck2(this, SnowTheme2);

          if (options2.modules.toolbar != null && options2.modules.toolbar.container == null) {
            options2.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn2(this, (SnowTheme2.__proto__ || Object.getPrototypeOf(SnowTheme2)).call(this, quill2, options2));

          _this.quill.container.classList.add("ql-snow");

          return _this;
        }

        _createClass2(SnowTheme2, [{
          key: "extendToolbar",
          value: function extendToolbar(toolbar) {
            toolbar.container.classList.add("ql-snow");
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);

            if (toolbar.container.querySelector(".ql-link")) {
              this.quill.keyboard.addBinding({
                key: "K",
                shortKey: true
              }, function (range2, context) {
                toolbar.handlers["link"].call(toolbar, !context.format.link);
              });
            }
          }
        }]);

        return SnowTheme2;
      }(_base2.default);

      SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (value) {
                  var range2 = this.quill.getSelection();
                  if (range2 == null || range2.length == 0) return;
                  var preview = this.quill.getText(range2);

                  if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) {
                    preview = "mailto:" + preview;
                  }

                  var tooltip = this.quill.theme.tooltip;
                  tooltip.edit("link", preview);
                } else {
                  this.quill.format("link", false);
                }
              }
            }
          }
        }
      });

      var SnowTooltip = function (_BaseTooltip) {
        _inherits2(SnowTooltip2, _BaseTooltip);

        function SnowTooltip2(quill2, bounds) {
          _classCallCheck2(this, SnowTooltip2);

          var _this2 = _possibleConstructorReturn2(this, (SnowTooltip2.__proto__ || Object.getPrototypeOf(SnowTooltip2)).call(this, quill2, bounds));

          _this2.preview = _this2.root.querySelector("a.ql-preview");
          return _this2;
        }

        _createClass2(SnowTooltip2, [{
          key: "listen",
          value: function listen() {
            var _this3 = this;

            _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "listen", this).call(this);

            this.root.querySelector("a.ql-action").addEventListener("click", function (event) {
              if (_this3.root.classList.contains("ql-editing")) {
                _this3.save();
              } else {
                _this3.edit("link", _this3.preview.textContent);
              }

              event.preventDefault();
            });
            this.root.querySelector("a.ql-remove").addEventListener("click", function (event) {
              if (_this3.linkRange != null) {
                var range2 = _this3.linkRange;

                _this3.restoreFocus();

                _this3.quill.formatText(range2, "link", false, _emitter2.default.sources.USER);

                delete _this3.linkRange;
              }

              event.preventDefault();

              _this3.hide();
            });
            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range2, oldRange, source2) {
              if (range2 == null) return;

              if (range2.length === 0 && source2 === _emitter2.default.sources.USER) {
                var _quill$scroll$descend = _this3.quill.scroll.descendant(_link22.default, range2.index),
                    _quill$scroll$descend2 = _slicedToArray2(_quill$scroll$descend, 2),
                    link = _quill$scroll$descend2[0],
                    offset2 = _quill$scroll$descend2[1];

                if (link != null) {
                  _this3.linkRange = new _selection.Range(range2.index - offset2, link.length());

                  var preview = _link22.default.formats(link.domNode);

                  _this3.preview.textContent = preview;

                  _this3.preview.setAttribute("href", preview);

                  _this3.show();

                  _this3.position(_this3.quill.getBounds(_this3.linkRange));

                  return;
                }
              } else {
                delete _this3.linkRange;
              }

              _this3.hide();
            });
          }
        }, {
          key: "show",
          value: function show() {
            _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "show", this).call(this);

            this.root.removeAttribute("data-mode");
          }
        }]);

        return SnowTooltip2;
      }(_base.BaseTooltip);

      SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join("");
      exports2.default = SnowTheme;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _core = __webpack_require__(29);

      var _core2 = _interopRequireDefault(_core);

      var _align = __webpack_require__(36);

      var _direction = __webpack_require__(38);

      var _indent = __webpack_require__(64);

      var _blockquote = __webpack_require__(65);

      var _blockquote2 = _interopRequireDefault(_blockquote);

      var _header = __webpack_require__(66);

      var _header2 = _interopRequireDefault(_header);

      var _list = __webpack_require__(67);

      var _list2 = _interopRequireDefault(_list);

      var _background = __webpack_require__(37);

      var _color = __webpack_require__(26);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      var _italic = __webpack_require__(68);

      var _italic2 = _interopRequireDefault(_italic);

      var _link2 = __webpack_require__(27);

      var _link22 = _interopRequireDefault(_link2);

      var _script = __webpack_require__(69);

      var _script2 = _interopRequireDefault(_script);

      var _strike = __webpack_require__(70);

      var _strike2 = _interopRequireDefault(_strike);

      var _underline = __webpack_require__(71);

      var _underline2 = _interopRequireDefault(_underline);

      var _image = __webpack_require__(72);

      var _image2 = _interopRequireDefault(_image);

      var _video = __webpack_require__(73);

      var _video2 = _interopRequireDefault(_video);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _formula = __webpack_require__(74);

      var _formula2 = _interopRequireDefault(_formula);

      var _syntax = __webpack_require__(75);

      var _syntax2 = _interopRequireDefault(_syntax);

      var _toolbar = __webpack_require__(57);

      var _toolbar2 = _interopRequireDefault(_toolbar);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      var _bubble = __webpack_require__(108);

      var _bubble2 = _interopRequireDefault(_bubble);

      var _snow = __webpack_require__(62);

      var _snow2 = _interopRequireDefault(_snow);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      _core2.default.register({
        "attributors/attribute/direction": _direction.DirectionAttribute,
        "attributors/class/align": _align.AlignClass,
        "attributors/class/background": _background.BackgroundClass,
        "attributors/class/color": _color.ColorClass,
        "attributors/class/direction": _direction.DirectionClass,
        "attributors/class/font": _font.FontClass,
        "attributors/class/size": _size.SizeClass,
        "attributors/style/align": _align.AlignStyle,
        "attributors/style/background": _background.BackgroundStyle,
        "attributors/style/color": _color.ColorStyle,
        "attributors/style/direction": _direction.DirectionStyle,
        "attributors/style/font": _font.FontStyle,
        "attributors/style/size": _size.SizeStyle
      }, true);

      _core2.default.register({
        "formats/align": _align.AlignClass,
        "formats/direction": _direction.DirectionClass,
        "formats/indent": _indent.IndentClass,
        "formats/background": _background.BackgroundStyle,
        "formats/color": _color.ColorStyle,
        "formats/font": _font.FontClass,
        "formats/size": _size.SizeClass,
        "formats/blockquote": _blockquote2.default,
        "formats/code-block": _code2.default,
        "formats/header": _header2.default,
        "formats/list": _list2.default,
        "formats/bold": _bold2.default,
        "formats/code": _code.Code,
        "formats/italic": _italic2.default,
        "formats/link": _link22.default,
        "formats/script": _script2.default,
        "formats/strike": _strike2.default,
        "formats/underline": _underline2.default,
        "formats/image": _image2.default,
        "formats/video": _video2.default,
        "formats/list/item": _list.ListItem,
        "modules/formula": _formula2.default,
        "modules/syntax": _syntax2.default,
        "modules/toolbar": _toolbar2.default,
        "themes/bubble": _bubble2.default,
        "themes/snow": _snow2.default,
        "ui/icons": _icons2.default,
        "ui/picker": _picker2.default,
        "ui/icon-picker": _iconPicker2.default,
        "ui/color-picker": _colorPicker2.default,
        "ui/tooltip": _tooltip2.default
      }, true);

      exports2.default = _core2.default;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.IndentClass = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IdentAttributor = function (_Parchment$Attributor) {
        _inherits2(IdentAttributor2, _Parchment$Attributor);

        function IdentAttributor2() {
          _classCallCheck2(this, IdentAttributor2);

          return _possibleConstructorReturn2(this, (IdentAttributor2.__proto__ || Object.getPrototypeOf(IdentAttributor2)).apply(this, arguments));
        }

        _createClass2(IdentAttributor2, [{
          key: "add",
          value: function add(node2, value) {
            if (value === "+1" || value === "-1") {
              var indent = this.value(node2) || 0;
              value = value === "+1" ? indent + 1 : indent - 1;
            }

            if (value === 0) {
              this.remove(node2);
              return true;
            } else {
              return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "add", this).call(this, node2, value);
            }
          }
        }, {
          key: "canAdd",
          value: function canAdd(node2, value) {
            return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node2, value) || _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node2, parseInt(value));
          }
        }, {
          key: "value",
          value: function value(node2) {
            return parseInt(_get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "value", this).call(this, node2)) || void 0;
          }
        }]);

        return IdentAttributor2;
      }(_parchment2.default.Attributor.Class);

      var IndentClass = new IdentAttributor("indent", "ql-indent", {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
      });
      exports2.IndentClass = IndentClass;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Blockquote = function (_Block) {
        _inherits2(Blockquote2, _Block);

        function Blockquote2() {
          _classCallCheck2(this, Blockquote2);

          return _possibleConstructorReturn2(this, (Blockquote2.__proto__ || Object.getPrototypeOf(Blockquote2)).apply(this, arguments));
        }

        return Blockquote2;
      }(_block2.default);

      Blockquote.blotName = "blockquote";
      Blockquote.tagName = "blockquote";
      exports2.default = Blockquote;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Header = function (_Block) {
        _inherits2(Header2, _Block);

        function Header2() {
          _classCallCheck2(this, Header2);

          return _possibleConstructorReturn2(this, (Header2.__proto__ || Object.getPrototypeOf(Header2)).apply(this, arguments));
        }

        _createClass2(Header2, null, [{
          key: "formats",
          value: function formats2(domNode) {
            return this.tagName.indexOf(domNode.tagName) + 1;
          }
        }]);

        return Header2;
      }(_block2.default);

      Header.blotName = "header";
      Header.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"];
      exports2.default = Header;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.ListItem = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty2(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ListItem = function (_Block) {
        _inherits2(ListItem2, _Block);

        function ListItem2() {
          _classCallCheck2(this, ListItem2);

          return _possibleConstructorReturn2(this, (ListItem2.__proto__ || Object.getPrototypeOf(ListItem2)).apply(this, arguments));
        }

        _createClass2(ListItem2, [{
          key: "format",
          value: function format(name2, value) {
            if (name2 === List.blotName && !value) {
              this.replaceWith(_parchment2.default.create(this.statics.scope));
            } else {
              _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "format", this).call(this, name2, value);
            }
          }
        }, {
          key: "remove",
          value: function remove() {
            if (this.prev == null && this.next == null) {
              this.parent.remove();
            } else {
              _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "remove", this).call(this);
            }
          }
        }, {
          key: "replaceWith",
          value: function replaceWith(name2, value) {
            this.parent.isolate(this.offset(this.parent), this.length());

            if (name2 === this.parent.statics.blotName) {
              this.parent.replaceWith(name2, value);
              return this;
            } else {
              this.parent.unwrap();
              return _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "replaceWith", this).call(this, name2, value);
            }
          }
        }], [{
          key: "formats",
          value: function formats2(domNode) {
            return domNode.tagName === this.tagName ? void 0 : _get(ListItem2.__proto__ || Object.getPrototypeOf(ListItem2), "formats", this).call(this, domNode);
          }
        }]);

        return ListItem2;
      }(_block2.default);

      ListItem.blotName = "list-item";
      ListItem.tagName = "LI";

      var List = function (_Container) {
        _inherits2(List2, _Container);

        _createClass2(List2, null, [{
          key: "create",
          value: function create(value) {
            var tagName = value === "ordered" ? "OL" : "UL";

            var node2 = _get(List2.__proto__ || Object.getPrototypeOf(List2), "create", this).call(this, tagName);

            if (value === "checked" || value === "unchecked") {
              node2.setAttribute("data-checked", value === "checked");
            }

            return node2;
          }
        }, {
          key: "formats",
          value: function formats2(domNode) {
            if (domNode.tagName === "OL") return "ordered";

            if (domNode.tagName === "UL") {
              if (domNode.hasAttribute("data-checked")) {
                return domNode.getAttribute("data-checked") === "true" ? "checked" : "unchecked";
              } else {
                return "bullet";
              }
            }

            return void 0;
          }
        }]);

        function List2(domNode) {
          _classCallCheck2(this, List2);

          var _this2 = _possibleConstructorReturn2(this, (List2.__proto__ || Object.getPrototypeOf(List2)).call(this, domNode));

          var listEventHandler = function listEventHandler2(e2) {
            if (e2.target.parentNode !== domNode) return;

            var format = _this2.statics.formats(domNode);

            var blot = _parchment2.default.find(e2.target);

            if (format === "checked") {
              blot.format("list", "unchecked");
            } else if (format === "unchecked") {
              blot.format("list", "checked");
            }
          };

          domNode.addEventListener("touchstart", listEventHandler);
          domNode.addEventListener("mousedown", listEventHandler);
          return _this2;
        }

        _createClass2(List2, [{
          key: "format",
          value: function format(name2, value) {
            if (this.children.length > 0) {
              this.children.tail.format(name2, value);
            }
          }
        }, {
          key: "formats",
          value: function formats2() {
            return _defineProperty2({}, this.statics.blotName, this.statics.formats(this.domNode));
          }
        }, {
          key: "insertBefore",
          value: function insertBefore(blot, ref) {
            if (blot instanceof ListItem) {
              _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "insertBefore", this).call(this, blot, ref);
            } else {
              var index2 = ref == null ? this.length() : ref.offset(this);
              var after = this.split(index2);
              after.parent.insertBefore(blot, after);
            }
          }
        }, {
          key: "optimize",
          value: function optimize(context) {
            _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "optimize", this).call(this, context);

            var next2 = this.next;

            if (next2 != null && next2.prev === this && next2.statics.blotName === this.statics.blotName && next2.domNode.tagName === this.domNode.tagName && next2.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked")) {
              next2.moveChildren(this);
              next2.remove();
            }
          }
        }, {
          key: "replace",
          value: function replace2(target) {
            if (target.statics.blotName !== this.statics.blotName) {
              var item = _parchment2.default.create(this.statics.defaultChild);

              target.moveChildren(item);
              this.appendChild(item);
            }

            _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "replace", this).call(this, target);
          }
        }]);

        return List2;
      }(_container2.default);

      List.blotName = "list";
      List.scope = _parchment2.default.Scope.BLOCK_BLOT;
      List.tagName = ["OL", "UL"];
      List.defaultChild = "list-item";
      List.allowedChildren = [ListItem];
      exports2.ListItem = ListItem;
      exports2.default = List;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Italic = function (_Bold) {
        _inherits2(Italic2, _Bold);

        function Italic2() {
          _classCallCheck2(this, Italic2);

          return _possibleConstructorReturn2(this, (Italic2.__proto__ || Object.getPrototypeOf(Italic2)).apply(this, arguments));
        }

        return Italic2;
      }(_bold2.default);

      Italic.blotName = "italic";
      Italic.tagName = ["EM", "I"];
      exports2.default = Italic;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Script = function (_Inline) {
        _inherits2(Script2, _Inline);

        function Script2() {
          _classCallCheck2(this, Script2);

          return _possibleConstructorReturn2(this, (Script2.__proto__ || Object.getPrototypeOf(Script2)).apply(this, arguments));
        }

        _createClass2(Script2, null, [{
          key: "create",
          value: function create(value) {
            if (value === "super") {
              return document.createElement("sup");
            } else if (value === "sub") {
              return document.createElement("sub");
            } else {
              return _get(Script2.__proto__ || Object.getPrototypeOf(Script2), "create", this).call(this, value);
            }
          }
        }, {
          key: "formats",
          value: function formats2(domNode) {
            if (domNode.tagName === "SUB") return "sub";
            if (domNode.tagName === "SUP") return "super";
            return void 0;
          }
        }]);

        return Script2;
      }(_inline2.default);

      Script.blotName = "script";
      Script.tagName = ["SUB", "SUP"];
      exports2.default = Script;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Strike = function (_Inline) {
        _inherits2(Strike2, _Inline);

        function Strike2() {
          _classCallCheck2(this, Strike2);

          return _possibleConstructorReturn2(this, (Strike2.__proto__ || Object.getPrototypeOf(Strike2)).apply(this, arguments));
        }

        return Strike2;
      }(_inline2.default);

      Strike.blotName = "strike";
      Strike.tagName = "S";
      exports2.default = Strike;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Underline = function (_Inline) {
        _inherits2(Underline2, _Inline);

        function Underline2() {
          _classCallCheck2(this, Underline2);

          return _possibleConstructorReturn2(this, (Underline2.__proto__ || Object.getPrototypeOf(Underline2)).apply(this, arguments));
        }

        return Underline2;
      }(_inline2.default);

      Underline.blotName = "underline";
      Underline.tagName = "U";
      exports2.default = Underline;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _link2 = __webpack_require__(27);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ["alt", "height", "width"];

      var Image = function (_Parchment$Embed) {
        _inherits2(Image2, _Parchment$Embed);

        function Image2() {
          _classCallCheck2(this, Image2);

          return _possibleConstructorReturn2(this, (Image2.__proto__ || Object.getPrototypeOf(Image2)).apply(this, arguments));
        }

        _createClass2(Image2, [{
          key: "format",
          value: function format(name2, value) {
            if (ATTRIBUTES.indexOf(name2) > -1) {
              if (value) {
                this.domNode.setAttribute(name2, value);
              } else {
                this.domNode.removeAttribute(name2);
              }
            } else {
              _get(Image2.prototype.__proto__ || Object.getPrototypeOf(Image2.prototype), "format", this).call(this, name2, value);
            }
          }
        }], [{
          key: "create",
          value: function create(value) {
            var node2 = _get(Image2.__proto__ || Object.getPrototypeOf(Image2), "create", this).call(this, value);

            if (typeof value === "string") {
              node2.setAttribute("src", this.sanitize(value));
            }

            return node2;
          }
        }, {
          key: "formats",
          value: function formats2(domNode) {
            return ATTRIBUTES.reduce(function (formats3, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats3[attribute] = domNode.getAttribute(attribute);
              }

              return formats3;
            }, {});
          }
        }, {
          key: "match",
          value: function match2(url) {
            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
          }
        }, {
          key: "sanitize",
          value: function sanitize(url) {
            return (0, _link2.sanitize)(url, ["http", "https", "data"]) ? url : "//:0";
          }
        }, {
          key: "value",
          value: function value(domNode) {
            return domNode.getAttribute("src");
          }
        }]);

        return Image2;
      }(_parchment2.default.Embed);

      Image.blotName = "image";
      Image.tagName = "IMG";
      exports2.default = Image;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _block = __webpack_require__(4);

      var _link2 = __webpack_require__(27);

      var _link22 = _interopRequireDefault(_link2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ["height", "width"];

      var Video = function (_BlockEmbed) {
        _inherits2(Video2, _BlockEmbed);

        function Video2() {
          _classCallCheck2(this, Video2);

          return _possibleConstructorReturn2(this, (Video2.__proto__ || Object.getPrototypeOf(Video2)).apply(this, arguments));
        }

        _createClass2(Video2, [{
          key: "format",
          value: function format(name2, value) {
            if (ATTRIBUTES.indexOf(name2) > -1) {
              if (value) {
                this.domNode.setAttribute(name2, value);
              } else {
                this.domNode.removeAttribute(name2);
              }
            } else {
              _get(Video2.prototype.__proto__ || Object.getPrototypeOf(Video2.prototype), "format", this).call(this, name2, value);
            }
          }
        }], [{
          key: "create",
          value: function create(value) {
            var node2 = _get(Video2.__proto__ || Object.getPrototypeOf(Video2), "create", this).call(this, value);

            node2.setAttribute("frameborder", "0");
            node2.setAttribute("allowfullscreen", true);
            node2.setAttribute("src", this.sanitize(value));
            return node2;
          }
        }, {
          key: "formats",
          value: function formats2(domNode) {
            return ATTRIBUTES.reduce(function (formats3, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats3[attribute] = domNode.getAttribute(attribute);
              }

              return formats3;
            }, {});
          }
        }, {
          key: "sanitize",
          value: function sanitize(url) {
            return _link22.default.sanitize(url);
          }
        }, {
          key: "value",
          value: function value(domNode) {
            return domNode.getAttribute("src");
          }
        }]);

        return Video2;
      }(_block.BlockEmbed);

      Video.blotName = "video";
      Video.className = "ql-video";
      Video.tagName = "IFRAME";
      exports2.default = Video;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.FormulaBlot = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _embed = __webpack_require__(35);

      var _embed2 = _interopRequireDefault(_embed);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var FormulaBlot = function (_Embed) {
        _inherits2(FormulaBlot2, _Embed);

        function FormulaBlot2() {
          _classCallCheck2(this, FormulaBlot2);

          return _possibleConstructorReturn2(this, (FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2)).apply(this, arguments));
        }

        _createClass2(FormulaBlot2, null, [{
          key: "create",
          value: function create(value) {
            var node2 = _get(FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2), "create", this).call(this, value);

            if (typeof value === "string") {
              window.katex.render(value, node2, {
                throwOnError: false,
                errorColor: "#f00"
              });
              node2.setAttribute("data-value", value);
            }

            return node2;
          }
        }, {
          key: "value",
          value: function value(domNode) {
            return domNode.getAttribute("data-value");
          }
        }]);

        return FormulaBlot2;
      }(_embed2.default);

      FormulaBlot.blotName = "formula";
      FormulaBlot.className = "ql-formula";
      FormulaBlot.tagName = "SPAN";

      var Formula = function (_Module) {
        _inherits2(Formula2, _Module);

        _createClass2(Formula2, null, [{
          key: "register",
          value: function register() {
            _quill2.default.register(FormulaBlot, true);
          }
        }]);

        function Formula2() {
          _classCallCheck2(this, Formula2);

          var _this2 = _possibleConstructorReturn2(this, (Formula2.__proto__ || Object.getPrototypeOf(Formula2)).call(this));

          if (window.katex == null) {
            throw new Error("Formula module requires KaTeX.");
          }

          return _this2;
        }

        return Formula2;
      }(_module2.default);

      exports2.FormulaBlot = FormulaBlot;
      exports2.default = Formula;
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.CodeToken = exports2.CodeBlock = void 0;

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var SyntaxCodeBlock = function (_CodeBlock) {
        _inherits2(SyntaxCodeBlock2, _CodeBlock);

        function SyntaxCodeBlock2() {
          _classCallCheck2(this, SyntaxCodeBlock2);

          return _possibleConstructorReturn2(this, (SyntaxCodeBlock2.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2)).apply(this, arguments));
        }

        _createClass2(SyntaxCodeBlock2, [{
          key: "replaceWith",
          value: function replaceWith(block) {
            this.domNode.textContent = this.domNode.textContent;
            this.attach();

            _get(SyntaxCodeBlock2.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2.prototype), "replaceWith", this).call(this, block);
          }
        }, {
          key: "highlight",
          value: function highlight(_highlight) {
            var text = this.domNode.textContent;

            if (this.cachedText !== text) {
              if (text.trim().length > 0 || this.cachedText == null) {
                this.domNode.innerHTML = _highlight(text);
                this.domNode.normalize();
                this.attach();
              }

              this.cachedText = text;
            }
          }
        }]);

        return SyntaxCodeBlock2;
      }(_code2.default);

      SyntaxCodeBlock.className = "ql-syntax";
      var CodeToken = new _parchment2.default.Attributor.Class("token", "hljs", {
        scope: _parchment2.default.Scope.INLINE
      });

      var Syntax = function (_Module) {
        _inherits2(Syntax2, _Module);

        _createClass2(Syntax2, null, [{
          key: "register",
          value: function register() {
            _quill2.default.register(CodeToken, true);

            _quill2.default.register(SyntaxCodeBlock, true);
          }
        }]);

        function Syntax2(quill2, options2) {
          _classCallCheck2(this, Syntax2);

          var _this2 = _possibleConstructorReturn2(this, (Syntax2.__proto__ || Object.getPrototypeOf(Syntax2)).call(this, quill2, options2));

          if (typeof _this2.options.highlight !== "function") {
            throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
          }

          var timer = null;

          _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              _this2.highlight();

              timer = null;
            }, _this2.options.interval);
          });

          _this2.highlight();

          return _this2;
        }

        _createClass2(Syntax2, [{
          key: "highlight",
          value: function highlight() {
            var _this3 = this;

            if (this.quill.selection.composing) return;
            this.quill.update(_quill2.default.sources.USER);
            var range2 = this.quill.getSelection();
            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
              code.highlight(_this3.options.highlight);
            });
            this.quill.update(_quill2.default.sources.SILENT);

            if (range2 != null) {
              this.quill.setSelection(range2, _quill2.default.sources.SILENT);
            }
          }
        }]);

        return Syntax2;
      }(_module2.default);

      Syntax.DEFAULTS = {
        highlight: function () {
          if (window.hljs == null) return null;
          return function (text) {
            var result = window.hljs.highlightAuto(text);
            return result.value;
          };
        }(),
        interval: 1e3
      };
      exports2.CodeBlock = SyntaxCodeBlock;
      exports2.CodeToken = CodeToken;
      exports2.default = Syntax;
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
    }, function (module2, exports2) {
      module2.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
    }, function (module2, exports2, __webpack_require__) {
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.BubbleTooltip = void 0;

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);

        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object);

          if (parent === null) {
            return void 0;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === void 0) {
            return void 0;
          }

          return getter.call(receiver);
        }
      };

      var _createClass2 = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck2(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn2(self2, call) {
        if (!self2) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self2;
      }

      function _inherits2(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [["bold", "italic", "link"], [{
        header: 1
      }, {
        header: 2
      }, "blockquote"]];

      var BubbleTheme = function (_BaseTheme) {
        _inherits2(BubbleTheme2, _BaseTheme);

        function BubbleTheme2(quill2, options2) {
          _classCallCheck2(this, BubbleTheme2);

          if (options2.modules.toolbar != null && options2.modules.toolbar.container == null) {
            options2.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn2(this, (BubbleTheme2.__proto__ || Object.getPrototypeOf(BubbleTheme2)).call(this, quill2, options2));

          _this.quill.container.classList.add("ql-bubble");

          return _this;
        }

        _createClass2(BubbleTheme2, [{
          key: "extendToolbar",
          value: function extendToolbar(toolbar) {
            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
          }
        }]);

        return BubbleTheme2;
      }(_base2.default);

      BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (!value) {
                  this.quill.format("link", false);
                } else {
                  this.quill.theme.tooltip.edit();
                }
              }
            }
          }
        }
      });

      var BubbleTooltip = function (_BaseTooltip) {
        _inherits2(BubbleTooltip2, _BaseTooltip);

        function BubbleTooltip2(quill2, bounds) {
          _classCallCheck2(this, BubbleTooltip2);

          var _this2 = _possibleConstructorReturn2(this, (BubbleTooltip2.__proto__ || Object.getPrototypeOf(BubbleTooltip2)).call(this, quill2, bounds));

          _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range2, oldRange, source2) {
            if (type !== _emitter2.default.events.SELECTION_CHANGE) return;

            if (range2 != null && range2.length > 0 && source2 === _emitter2.default.sources.USER) {
              _this2.show();

              _this2.root.style.left = "0px";
              _this2.root.style.width = "";
              _this2.root.style.width = _this2.root.offsetWidth + "px";

              var lines = _this2.quill.getLines(range2.index, range2.length);

              if (lines.length === 1) {
                _this2.position(_this2.quill.getBounds(range2));
              } else {
                var lastLine = lines[lines.length - 1];

                var index2 = _this2.quill.getIndex(lastLine);

                var length2 = Math.min(lastLine.length() - 1, range2.index + range2.length - index2);

                var _bounds = _this2.quill.getBounds(new _selection.Range(index2, length2));

                _this2.position(_bounds);
              }
            } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
              _this2.hide();
            }
          });

          return _this2;
        }

        _createClass2(BubbleTooltip2, [{
          key: "listen",
          value: function listen() {
            var _this3 = this;

            _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "listen", this).call(this);

            this.root.querySelector(".ql-close").addEventListener("click", function () {
              _this3.root.classList.remove("ql-editing");
            });
            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
              setTimeout(function () {
                if (_this3.root.classList.contains("ql-hidden")) return;

                var range2 = _this3.quill.getSelection();

                if (range2 != null) {
                  _this3.position(_this3.quill.getBounds(range2));
                }
              }, 1);
            });
          }
        }, {
          key: "cancel",
          value: function cancel() {
            this.show();
          }
        }, {
          key: "position",
          value: function position2(reference2) {
            var shift = _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "position", this).call(this, reference2);

            var arrow2 = this.root.querySelector(".ql-tooltip-arrow");
            arrow2.style.marginLeft = "";
            if (shift === 0) return shift;
            arrow2.style.marginLeft = -1 * shift - arrow2.offsetWidth / 2 + "px";
          }
        }]);

        return BubbleTooltip2;
      }(_base.BaseTooltip);

      BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join("");
      exports2.BubbleTooltip = BubbleTooltip;
      exports2.default = BubbleTheme;
    }, function (module2, exports2, __webpack_require__) {
      module2.exports = __webpack_require__(63);
    }])["default"];
  });
})(quill);

var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
  var _extendStatics = function extendStatics(d2, b2) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d3, b3) {
      d3.__proto__ = b3;
    } || function (d3, b3) {
      for (var p2 in b3) {
        if (b3.hasOwnProperty(p2)) d3[p2] = b3[p2];
      }
    };

    return _extendStatics(d2, b2);
  };

  return function (d2, b2) {
    _extendStatics(d2, b2);

    function __() {
      this.constructor = d2;
    }

    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();

var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
  __assign = Object.assign || function (t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];

      for (var p2 in s) {
        if (Object.prototype.hasOwnProperty.call(s, p2)) t2[p2] = s[p2];
      }
    }

    return t2;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r2 = Array(s), k2 = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k2++) {
      r2[k2] = a[j];
    }
  }

  return r2;
};

var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var react_1 = __importDefault(React__default);

var react_dom_1 = __importDefault(require$$1);

var isEqual_1 = __importDefault(isEqual_1$1);

var quill_1 = __importDefault(quill.exports);

var ReactQuill = function (_super) {
  __extends(ReactQuill2, _super);

  function ReactQuill2(props) {
    var _this = _super.call(this, props) || this;

    _this.dirtyProps = ["modules", "formats", "bounds", "theme", "children"];
    _this.cleanProps = ["id", "className", "style", "placeholder", "tabIndex", "onChange", "onChangeSelection", "onFocus", "onBlur", "onKeyPress", "onKeyDown", "onKeyUp"];
    _this.state = {
      generation: 0
    };
    _this.selection = null;

    _this.onEditorChange = function (eventName, rangeOrDelta, oldRangeOrDelta, source2) {
      var _a2, _b, _c, _d;

      if (eventName === "text-change") {
        (_b = (_a2 = _this).onEditorChangeText) === null || _b === void 0 ? void 0 : _b.call(_a2, _this.editor.root.innerHTML, rangeOrDelta, source2, _this.unprivilegedEditor);
      } else if (eventName === "selection-change") {
        (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, rangeOrDelta, source2, _this.unprivilegedEditor);
      }
    };

    var value = _this.isControlled() ? props.value : props.defaultValue;
    _this.value = value !== null && value !== void 0 ? value : "";
    return _this;
  }

  ReactQuill2.prototype.validateProps = function (props) {
    var _a2;

    if (react_1.default.Children.count(props.children) > 1) throw new Error("The Quill editing area can only be composed of a single React element.");

    if (react_1.default.Children.count(props.children)) {
      var child = react_1.default.Children.only(props.children);
      if (((_a2 = child) === null || _a2 === void 0 ? void 0 : _a2.type) === "textarea") throw new Error("Quill does not support editing on a <textarea>. Use a <div> instead.");
    }

    if (this.lastDeltaChangeSet && props.value === this.lastDeltaChangeSet) throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
  };

  ReactQuill2.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    var _this = this;

    var _a2;

    this.validateProps(nextProps);

    if (!this.editor || this.state.generation !== nextState.generation) {
      return true;
    }

    if ("value" in nextProps) {
      var prevContents = this.getEditorContents();
      var nextContents = (_a2 = nextProps.value, _a2 !== null && _a2 !== void 0 ? _a2 : "");

      if (!this.isEqualValue(nextContents, prevContents)) {
        this.setEditorContents(this.editor, nextContents);
      }
    }

    if (nextProps.readOnly !== this.props.readOnly) {
      this.setEditorReadOnly(this.editor, nextProps.readOnly);
    }

    return __spreadArrays(this.cleanProps, this.dirtyProps).some(function (prop) {
      return !isEqual_1.default(nextProps[prop], _this.props[prop]);
    });
  };

  ReactQuill2.prototype.shouldComponentRegenerate = function (nextProps) {
    var _this = this;

    return this.dirtyProps.some(function (prop) {
      return !isEqual_1.default(nextProps[prop], _this.props[prop]);
    });
  };

  ReactQuill2.prototype.componentDidMount = function () {
    this.instantiateEditor();
    this.setEditorContents(this.editor, this.getEditorContents());
  };

  ReactQuill2.prototype.componentWillUnmount = function () {
    this.destroyEditor();
  };

  ReactQuill2.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;

    if (this.editor && this.shouldComponentRegenerate(prevProps)) {
      var delta = this.editor.getContents();
      var selection = this.editor.getSelection();
      this.regenerationSnapshot = {
        delta: delta,
        selection: selection
      };
      this.setState({
        generation: this.state.generation + 1
      });
      this.destroyEditor();
    }

    if (this.state.generation !== prevState.generation) {
      var _a2 = this.regenerationSnapshot,
          delta = _a2.delta,
          selection_1 = _a2.selection;
      delete this.regenerationSnapshot;
      this.instantiateEditor();
      var editor_1 = this.editor;
      editor_1.setContents(delta);
      postpone(function () {
        return _this.setEditorSelection(editor_1, selection_1);
      });
    }
  };

  ReactQuill2.prototype.instantiateEditor = function () {
    if (this.editor) {
      this.hookEditor(this.editor);
    } else {
      this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
    }
  };

  ReactQuill2.prototype.destroyEditor = function () {
    if (!this.editor) return;
    this.unhookEditor(this.editor);
  };

  ReactQuill2.prototype.isControlled = function () {
    return "value" in this.props;
  };

  ReactQuill2.prototype.getEditorConfig = function () {
    return {
      bounds: this.props.bounds,
      formats: this.props.formats,
      modules: this.props.modules,
      placeholder: this.props.placeholder,
      readOnly: this.props.readOnly,
      scrollingContainer: this.props.scrollingContainer,
      tabIndex: this.props.tabIndex,
      theme: this.props.theme
    };
  };

  ReactQuill2.prototype.getEditor = function () {
    if (!this.editor) throw new Error("Accessing non-instantiated editor");
    return this.editor;
  };

  ReactQuill2.prototype.createEditor = function (element, config) {
    var editor = new quill_1.default(element, config);

    if (config.tabIndex != null) {
      this.setEditorTabIndex(editor, config.tabIndex);
    }

    this.hookEditor(editor);
    return editor;
  };

  ReactQuill2.prototype.hookEditor = function (editor) {
    this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
    editor.on("editor-change", this.onEditorChange);
  };

  ReactQuill2.prototype.unhookEditor = function (editor) {
    editor.off("editor-change", this.onEditorChange);
  };

  ReactQuill2.prototype.getEditorContents = function () {
    return this.value;
  };

  ReactQuill2.prototype.getEditorSelection = function () {
    return this.selection;
  };

  ReactQuill2.prototype.isDelta = function (value) {
    return value && value.ops;
  };

  ReactQuill2.prototype.isEqualValue = function (value, nextValue) {
    if (this.isDelta(value) && this.isDelta(nextValue)) {
      return isEqual_1.default(value.ops, nextValue.ops);
    } else {
      return isEqual_1.default(value, nextValue);
    }
  };

  ReactQuill2.prototype.setEditorContents = function (editor, value) {
    var _this = this;

    this.value = value;
    var sel = this.getEditorSelection();

    if (typeof value === "string") {
      editor.setContents(editor.clipboard.convert(value));
    } else {
      editor.setContents(value);
    }

    postpone(function () {
      return _this.setEditorSelection(editor, sel);
    });
  };

  ReactQuill2.prototype.setEditorSelection = function (editor, range2) {
    this.selection = range2;

    if (range2) {
      var length_1 = editor.getLength();
      range2.index = Math.max(0, Math.min(range2.index, length_1 - 1));
      range2.length = Math.max(0, Math.min(range2.length, length_1 - 1 - range2.index));
      editor.setSelection(range2);
    }
  };

  ReactQuill2.prototype.setEditorTabIndex = function (editor, tabIndex) {
    var _a2, _b;

    if ((_b = (_a2 = editor) === null || _a2 === void 0 ? void 0 : _a2.scroll) === null || _b === void 0 ? void 0 : _b.domNode) {
      editor.scroll.domNode.tabIndex = tabIndex;
    }
  };

  ReactQuill2.prototype.setEditorReadOnly = function (editor, value) {
    if (value) {
      editor.disable();
    } else {
      editor.enable();
    }
  };

  ReactQuill2.prototype.makeUnprivilegedEditor = function (editor) {
    var e2 = editor;
    return {
      getHTML: function getHTML() {
        return e2.root.innerHTML;
      },
      getLength: e2.getLength.bind(e2),
      getText: e2.getText.bind(e2),
      getContents: e2.getContents.bind(e2),
      getSelection: e2.getSelection.bind(e2),
      getBounds: e2.getBounds.bind(e2)
    };
  };

  ReactQuill2.prototype.getEditingArea = function () {
    if (!this.editingArea) {
      throw new Error("Instantiating on missing editing area");
    }

    var element = react_dom_1.default.findDOMNode(this.editingArea);

    if (!element) {
      throw new Error("Cannot find element for editing area");
    }

    if (element.nodeType === 3) {
      throw new Error("Editing area cannot be a text node");
    }

    return element;
  };

  ReactQuill2.prototype.renderEditingArea = function () {
    var _this = this;

    var _a2 = this.props,
        children = _a2.children,
        preserveWhitespace = _a2.preserveWhitespace;
    var generation = this.state.generation;
    var properties = {
      key: generation,
      ref: function ref(instance) {
        _this.editingArea = instance;
      }
    };

    if (react_1.default.Children.count(children)) {
      return react_1.default.cloneElement(react_1.default.Children.only(children), properties);
    }

    return preserveWhitespace ? react_1.default.createElement("pre", __assign({}, properties)) : react_1.default.createElement("div", __assign({}, properties));
  };

  ReactQuill2.prototype.render = function () {
    var _a2;

    return react_1.default.createElement("div", {
      id: this.props.id,
      style: this.props.style,
      key: this.state.generation,
      className: "quill " + (_a2 = this.props.className, _a2 !== null && _a2 !== void 0 ? _a2 : ""),
      onKeyPress: this.props.onKeyPress,
      onKeyDown: this.props.onKeyDown,
      onKeyUp: this.props.onKeyUp
    }, this.renderEditingArea());
  };

  ReactQuill2.prototype.onEditorChangeText = function (value, delta, source2, editor) {
    var _a2, _b;

    if (!this.editor) return;
    var nextContents = this.isDelta(this.value) ? editor.getContents() : editor.getHTML();

    if (nextContents !== this.getEditorContents()) {
      this.lastDeltaChangeSet = delta;
      this.value = nextContents;
      (_b = (_a2 = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, value, delta, source2, editor);
    }
  };

  ReactQuill2.prototype.onEditorChangeSelection = function (nextSelection, source2, editor) {
    var _a2, _b, _c, _d, _e2, _f;

    if (!this.editor) return;
    var currentSelection = this.getEditorSelection();
    var hasGainedFocus = !currentSelection && nextSelection;
    var hasLostFocus = currentSelection && !nextSelection;
    if (isEqual_1.default(nextSelection, currentSelection)) return;
    this.selection = nextSelection;
    (_b = (_a2 = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, nextSelection, source2, editor);

    if (hasGainedFocus) {
      (_d = (_c = this.props).onFocus) === null || _d === void 0 ? void 0 : _d.call(_c, nextSelection, source2, editor);
    } else if (hasLostFocus) {
      (_f = (_e2 = this.props).onBlur) === null || _f === void 0 ? void 0 : _f.call(_e2, currentSelection, source2, editor);
    }
  };

  ReactQuill2.prototype.focus = function () {
    if (!this.editor) return;
    this.editor.focus();
  };

  ReactQuill2.prototype.blur = function () {
    if (!this.editor) return;
    this.selection = null;
    this.editor.blur();
  };

  ReactQuill2.displayName = "React Quill";
  ReactQuill2.Quill = quill_1.default;
  ReactQuill2.defaultProps = {
    theme: "snow",
    modules: {},
    readOnly: false
  };
  return ReactQuill2;
}(react_1.default.Component);

function postpone(fn3) {
  Promise.resolve().then(fn3);
}

var lib = ReactQuill;
var modules = {
  toolbar: [[{
    header: [1, 2, 3, 4, 5, 6, false]
  }], ["bold", "italic", "underline", "strike", "blockquote"], [{
    list: "ordered"
  }, {
    list: "bullet"
  }, {
    indent: "-1"
  }, {
    indent: "+1"
  }, {
    align: []
  }], ["blockquote", "code-block"], [{
    direction: "rtl"
  }], [{
    script: "sub"
  }, {
    script: "super"
  }], [{
    direction: "rtl"
  }], [{
    size: ["small", false, "large", "huge"]
  }], [{
    color: []
  }, {
    background: []
  }], [{
    font: []
  }], ["link", "image", "video"], ["clean"]]
};

var RichText = function RichText(_ref644) {
  var property = _ref644.property,
      defaultValue = _ref644.defaultValue,
      labels = _ref644.labels,
      setValue = _ref644.setValue;

  var onChange2 = function onChange2(value, delta, source2, editor) {
    if (editor.getText().trim() === "") {
      setValue(null);
    } else {
      setValue(value);
    }
  };

  if (property === "description" || property === "winners_description") {
    return (
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-4",
        children: [
        /* @__PURE__ */
        jsx$1("label", {
          className: titleManageGameStyle,
          children: labels.description
        }),
        /* @__PURE__ */
        jsx$1(lib, {
          defaultValue: defaultValue,
          onChange: onChange2,
          modules: modules,
          placeholder: property === "description" ? labels.descriptionPlaceholder : null
        })]
      })
    );
  }

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: labels.rules,
        className: titleManageGameStyle,
        children: property === "rules" ? labels.rules : labels.adContent
      }),
      /* @__PURE__ */
      jsx$1(lib, {
        defaultValue: defaultValue,
        onChange: onChange2,
        modules: modules
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs",
        children: property === "rules" ? labels.rulesDescription : labels.adContentDescription
      })]
    })
  );
};

var ImagesCard = function ImagesCard(_ref645) {
  var images = _ref645.images,
      children = _ref645.children;
  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1("div", {
        children:
        /* @__PURE__ */
        jsx$1("label", {
          className: titleManageGameStyle,
          children: images
        })
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-border topxw-border-gray-200 topxw-rounded topxw-p-2 topxw-mb-4",
        children: children
      })]
    })
  );
};

var GameImages = function GameImages(_ref646) {
  var labels = _ref646.labels,
      onChange2 = _ref646.onChange,
      editMode = _ref646.editMode,
      loadedImages = _ref646.loadedImages,
      httpsService = _ref646.httpsService,
      sportal365Config = _ref646.sportal365Config;
  var imagesKeys = Array.from(imagesMap.keys());
  var imagesValues = Array.from(imagesMap.values());

  if (editMode) {
    return (
      /* @__PURE__ */
      jsx$1(ImagesCard, {
        images: labels.images,
        children: imagesKeys.map(function (key, index2) {
          return (
            /* @__PURE__ */
            jsx$1(GameInformation, {
              title: labels[imagesValues[index2]],
              placeholder: labels.imagePlaceholder,
              onChangeImages: onChange2,
              imageCase: imagesValues[index2],
              value: loadedImages ? loadedImages[key] : null,
              httpsService: httpsService,
              labels: labels,
              sportal365Config: sportal365Config
            }, "".concat(key, "-").concat(index2))
          );
        })
      })
    );
  }

  return (
    /* @__PURE__ */
    jsx$1(ImagesCard, {
      images: labels.images,
      children: imagesKeys.map(function (key, index2) {
        return (
          /* @__PURE__ */
          jsx$1(GameInformation, {
            title: labels[imagesValues[index2]],
            placeholder: labels.imagePlaceholder,
            onChangeImages: onChange2,
            imageCase: imagesValues[index2],
            httpsService: httpsService,
            labels: labels,
            value: loadedImages ? loadedImages[key] : null,
            sportal365Config: sportal365Config
          }, "".concat(key, "-").concat(index2))
        );
      })
    })
  );
};

var extractValuesFlagOptions = function extractValuesFlagOptions(flags) {
  return flags.map(function (flag) {
    return flag.value;
  });
};

var CreateGameScreen = function CreateGameScreen(_ref647) {
  var sdk = _ref647.sdk,
      getGames = _ref647.getGames,
      setCreateMode = _ref647.setCreateMode,
      httpsService = _ref647.httpsService,
      minFixtures = _ref647.minFixtures,
      maxFixtures = _ref647.maxFixtures,
      competitionsScope = _ref647.competitionsScope,
      labels = _ref647.labels,
      sportal365Config = _ref647.sportal365Config;

  var _useState63 = useState(new GameRequestBody()),
      _useState64 = _slicedToArray3(_useState63, 2),
      gameRequestBody = _useState64[0],
      setGameRequestBody = _useState64[1];

  var _useState65 = useState(""),
      _useState66 = _slicedToArray3(_useState65, 2),
      description = _useState66[0],
      setDescription = _useState66[1];

  var _useState67 = useState(""),
      _useState68 = _slicedToArray3(_useState67, 2),
      rules = _useState68[0],
      setRules = _useState68[1];

  var _useState69 = useState(""),
      _useState70 = _slicedToArray3(_useState69, 2),
      adContent = _useState70[0],
      setAdContent = _useState70[1];

  var _useState71 = useState(null),
      _useState72 = _slicedToArray3(_useState71, 2),
      objMatchIds = _useState72[0],
      setObjMatchIds = _useState72[1];

  var _useState73 = useState(null),
      _useState74 = _slicedToArray3(_useState73, 2),
      objKickoffMatches = _useState74[0],
      setObjKickoffMatches = _useState74[1];

  var _useState75 = useState(false),
      _useState76 = _slicedToArray3(_useState75, 2),
      cutoffTimeIsFilled = _useState76[0],
      setCutoffTimeIsFilled = _useState76[1];

  var _useState77 = useState(false),
      _useState78 = _slicedToArray3(_useState77, 2),
      schedulerIsFilled = _useState78[0],
      setSchedulerIsFilled = _useState78[1];

  var _useState79 = useState(false),
      _useState80 = _slicedToArray3(_useState79, 2),
      isLoading = _useState80[0],
      setIsLoading = _useState80[1];

  var _useState81 = useState("CORRECT_SCORE"),
      _useState82 = _slicedToArray3(_useState81, 2),
      gameMarket = _useState82[0],
      setGameMarket = _useState82[1];

  var onChangeTitle = function onChangeTitle(event) {
    event.persist();
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        title: event.target.value ? event.target.value : null
      });
    });
  };

  var onChangeGameMarket = function onChangeGameMarket(event) {
    event.persist();
    setGameMarket(event.target.value);
  };

  var onChangeGameStatus = function onChangeGameStatus(event) {
    event.persist();
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        status: event.target.value
      });
    });
  };

  var onChangeGameTimeTiebreaker = function onChangeGameTimeTiebreaker(event) {
    event.persist();
    var newTiebreaker = {
      time_tiebreaker: event.target.value === "enabled" ? true : false
    };
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        tiebreaker: newTiebreaker
      });
    });
  };

  var onChangeDate = function onChangeDate(date, dateCase) {
    if (date && date.length > 0) {
      var dateIso = convertDateToGMTIsoString(date);

      if (dateCase === "cutoff_time") {
        setCutoffTimeIsFilled(true);
        setGameRequestBody(function (prevState) {
          return _objectSpread3({}, prevState, {
            predictions_cutoff: dateIso
          });
        });
      } else {
        setSchedulerIsFilled(true);
        setGameRequestBody(function (prevState) {
          return _objectSpread3({}, prevState, {
            schedule_open_at: dateIso
          });
        });
      }
    } else if (date.length === 0) {
      if (dateCase === "cutoff_time") {
        setGameRequestBody(function (prevState) {
          return _objectSpread3({}, prevState, {
            predictions_cutoff: null
          });
        });
        setCutoffTimeIsFilled(false);
        toast.info(labels.clearCutoffMessage);
      } else {
        setSchedulerIsFilled(false);
        setGameRequestBody(function (prevState) {
          return _objectSpread3({}, prevState, {
            schedule_open_at: null
          });
        });
        toast.info(labels.clearSchedulerMessage);
      }
    }
  };

  var onChangeImages = function onChangeImages(value, imageCases) {
    var imageValue = value || null;

    switch (imageCases) {
      case "mainImage":
        setGameRequestBody(function (prevState) {
          var newImages = JSON.parse(JSON.stringify(prevState.images));
          newImages.main = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;

      case "coverImage":
        setGameRequestBody(function (prevState) {
          var newImages = JSON.parse(JSON.stringify(prevState.images));
          newImages.cover = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;

      case "mobileImage":
        setGameRequestBody(function (prevState) {
          var newImages = JSON.parse(JSON.stringify(prevState.images));
          newImages.mobile = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;
    }
  };

  var onChangeRelated = function onChangeRelated(entityIds, entityType) {
    var related = createRelated(entityIds, entityType, gameRequestBody);
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        related: related
      });
    });
  };

  var onChangeLabels = function onChangeLabels(field) {
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        labels: field
      });
    });
  };

  var onChangeCustomFields = function onChangeCustomFields(field) {
    setGameRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        custom_fields: field
      });
    });
  };

  var constructRequestBody = function constructRequestBody() {
    var copyRequestBodyState = JSON.parse(JSON.stringify(gameRequestBody));
    var matchIds = objMatchIds && Object.values(objMatchIds);
    copyRequestBodyState.description = description;
    copyRequestBodyState.rules = rules;
    copyRequestBodyState.ad_content = adContent;
    copyRequestBodyState.fixtures = matchIds.map(function (id) {
      var fixture = new FixtureModel();
      fixture.match_id = id;
      fixture.market = gameMarket;
      return fixture;
    });
    copyRequestBodyState.flags = copyRequestBodyState.flags && copyRequestBodyState.flags.length ? extractValuesFlagOptions(copyRequestBodyState.flags) : null;
    copyRequestBodyState.related = copyRequestBodyState.related && copyRequestBodyState.related.length ? copyRequestBodyState.related : null;
    return copyRequestBodyState;
  };

  var createGame = function createGame() {
    setIsLoading(true);
    var validator2 = new GameValidator(gameRequestBody, labels, objMatchIds, minFixtures, objKickoffMatches);
    validator2.validate("create");

    if (!validator2.isValid) {
      console.warn(validator2.message);
      toast.warn(validator2.message);
      setIsLoading(false);
      return;
    }

    var requestBody = constructRequestBody();
    httpsService.createGame(requestBody).then(function () {
      setCreateMode(false);
      setIsLoading(false);
      toast.success(labels.createGameMessage);
      getGames();
    }).catch(function (error) {
      console.error(error);
      setIsLoading(false);
      toast.error(labels.createGameErrorMessage);
    });
  };

  return (
    /* @__PURE__ */
    jsxs(React__default.Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1(ScreenHeader, {
        labels: labels,
        setCreateMode: setCreateMode
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-p-2 topxw-border topxw-border-gray-200 topxw-rounded",
        children: [
        /* @__PURE__ */
        jsx$1(GameInformation, {
          title: labels.name,
          placeholder: labels.namePlaceholder,
          onChange: onChangeTitle,
          httpsService: httpsService,
          labels: labels,
          value: gameRequestBody.title,
          sportal365Config: sportal365Config
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          property: "description",
          labels: labels,
          defaultValue: description,
          setValue: setDescription
        }),
        /* @__PURE__ */
        jsx$1(MatchSelection, {
          sdk: sdk,
          matchIds: objMatchIds,
          objKickoffMatches: objKickoffMatches,
          setObjKickoffMatches: setObjKickoffMatches,
          setMatchIds: setObjMatchIds,
          minFixtures: minFixtures,
          maxFixtures: maxFixtures,
          competitionsScope: competitionsScope,
          labels: labels,
          gameStatus: defaultGameStatus
        }),
        /* @__PURE__ */
        jsx$1(MarketSelect, {
          labels: labels,
          gameMarket: gameMarket,
          gameStatus: defaultGameStatus,
          onChange: onChangeGameMarket
        }),
        /* @__PURE__ */
        jsx$1(GameStatus, {
          labelGameStatus: labels.gameStatus,
          labelCreateGameStatusDescription: labels.createGameStatusDescription,
          labelEditGameStatusDescription: labels.editGameStatusDescription,
          onChange: onChangeGameStatus,
          gameStatus: defaultGameStatus
        }),
        /* @__PURE__ */
        jsx$1(GameTimeTiebreaker, {
          labels: labels,
          onChange: onChangeGameTimeTiebreaker,
          defaultValue: true,
          gameStatus: defaultGameStatus
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          labels: labels,
          defaultValue: rules,
          setValue: setRules,
          property: "rules"
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          labels: labels,
          defaultValue: adContent,
          setValue: setAdContent,
          property: "ad_content"
        }),
        /* @__PURE__ */
        jsx$1(GameFlags, {
          labels: labels,
          flags: gameRequestBody.flags,
          setGameRequestBody: setGameRequestBody
        }),
        /* @__PURE__ */
        jsx$1(GameImages, {
          labels: labels,
          onChange: onChangeImages,
          httpsService: httpsService,
          loadedImages: gameRequestBody.images,
          sportal365Config: sportal365Config
        }),
        /* @__PURE__ */
        jsx$1(GameRelated, {
          sdk: sdk,
          labels: labels,
          loadedEntities: gameRequestBody.related,
          onChange: onChangeRelated
        }),
        /* @__PURE__ */
        jsx$1(GameDynamicFields, {
          labels: labels,
          onChange: onChangeLabels,
          dynamicField: "labels",
          field: gameRequestBody.labels ? gameRequestBody.labels : new Object()
        }, "labels"),
        /* @__PURE__ */
        jsx$1(GameDynamicFields, {
          labels: labels,
          onChange: onChangeCustomFields,
          dynamicField: "custom_fields",
          field: gameRequestBody.custom_fields ? gameRequestBody.custom_fields : new Object()
        }, "custom_fields"),
        /* @__PURE__ */
        jsx$1(CuttoffTime, {
          onChange: onChangeDate,
          labels: labels,
          cutoffTimeIsFilled: cutoffTimeIsFilled,
          gameStatus: defaultGameStatus
        }),
        /* @__PURE__ */
        jsx$1(GameScheduleOpenAt, {
          labels: labels,
          schedulerIsFilled: schedulerIsFilled,
          onChange: onChangeDate,
          objKickoffMatches: objKickoffMatches,
          gameStatus: defaultGameStatus
        }),
        /* @__PURE__ */
        jsx$1("div", {
          className: "topxw-my-4",
          children:
          /* @__PURE__ */
          jsx$1(ManagementButton, {
            paddingX: "topxw-px-24",
            paddingY: "topxw-py-3",
            mainLabel: labels.createEdition,
            centerButton: true,
            loadingLabel: labels.loadingMessage,
            isLoading: isLoading,
            onClick: createGame
          })
        })]
      })]
    })
  );
};

var GameID = function GameID(_ref648) {
  var value = _ref648.value,
      label = _ref648.label;
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: label,
        className: titleManageGameStyle,
        children: label
      }),
      /* @__PURE__ */
      jsx$1("input", {
        defaultValue: value,
        type: "text",
        id: "game-id",
        className: inputStyle$1,
        readOnly: true
      })]
    })
  );
};

var validatePredictionsCutoffOnEdit = function validatePredictionsCutoffOnEdit(gameStatus, predictionsCutoffEditGame) {
  if (gameStatus === "PENDING" || gameStatus === "OPEN") {
    var minutesForValidMinDateFlatpickr = 10;
    var now2 = dayjs().toDate();
    var validPredictionsCutoffDate = dayjs(predictionsCutoffEditGame).subtract(minutesForValidMinDateFlatpickr, "minute").toDate();
    if (now2 > validPredictionsCutoffDate) return null;
    return predictionsCutoffEditGame;
  }

  return predictionsCutoffEditGame;
};

var EditGameScreen = function EditGameScreen(_ref649) {
  var sdk = _ref649.sdk,
      httpsService = _ref649.httpsService,
      editMode = _ref649.editMode,
      game = _ref649.game,
      loadedFixtures = _ref649.loadedFixtures,
      minFixtures = _ref649.minFixtures,
      maxFixtures = _ref649.maxFixtures,
      competitionsScope = _ref649.competitionsScope,
      setLoadedFixtures = _ref649.setLoadedFixtures,
      setEditMode = _ref649.setEditMode,
      getGames = _ref649.getGames,
      labels = _ref649.labels,
      sportal365Config = _ref649.sportal365Config;

  var _a2;

  var isCutoffEditable = game.status === "PENDING" || game.status === "OPEN";
  var loadedGameMarket = game.fixtures[0].market;

  var _useState83 = useState(false),
      _useState84 = _slicedToArray3(_useState83, 2),
      isLoading = _useState84[0],
      setIsLoading = _useState84[1];

  var _useState85 = useState(game),
      _useState86 = _slicedToArray3(_useState85, 2),
      editedGame = _useState86[0],
      setEditedGame = _useState86[1];

  var _useState87 = useState(game.description),
      _useState88 = _slicedToArray3(_useState87, 2),
      description = _useState88[0],
      setDescription = _useState88[1];

  var _useState89 = useState(game.rules),
      _useState90 = _slicedToArray3(_useState89, 2),
      rules = _useState90[0],
      setRules = _useState90[1];

  var _useState91 = useState(game.adContent),
      _useState92 = _slicedToArray3(_useState91, 2),
      adContent = _useState92[0],
      setAdContent = _useState92[1];

  var _useState93 = useState(null),
      _useState94 = _slicedToArray3(_useState93, 2),
      objMatchIds = _useState94[0],
      setObjMatchIds = _useState94[1];

  var _useState95 = useState(null),
      _useState96 = _slicedToArray3(_useState95, 2),
      objKickoffMatches = _useState96[0],
      setObjKickoffMatches = _useState96[1];

  var _useState97 = useState(isCutoffEditable && validatePredictionsCutoffOnEdit(game.status, editedGame.predictionsCutoff) ? true : false),
      _useState98 = _slicedToArray3(_useState97, 2),
      cutoffTimeIsFilled = _useState98[0],
      setCutoffTimeIsFilled = _useState98[1];

  var _useState99 = useState(game.status === "PENDING" && game.scheduleOpenAt ? true : false),
      _useState100 = _slicedToArray3(_useState99, 2),
      schedulerIsFilled = _useState100[0],
      setSchedulerIsFilled = _useState100[1];

  var _useState101 = useState(loadedGameMarket),
      _useState102 = _slicedToArray3(_useState101, 2),
      gameMarket = _useState102[0],
      setGameMarket = _useState102[1];

  var onChangeTitle = function onChangeTitle(event) {
    event.persist();
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        title: event.target.value ? event.target.value : null
      });
    });
  };

  var onChangeGameMarket = function onChangeGameMarket(event) {
    event.persist();
    setGameMarket(event.target.value);
  };

  var onChangeGameStatus = function onChangeGameStatus(event) {
    event.persist();
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        status: event.target.value
      });
    });
  };

  var onChangeGameTimeTiebreaker = function onChangeGameTimeTiebreaker(event) {
    event.persist();
    var newTiebreaker = {
      timeTiebreaker: event.target.value === "enabled" ? true : false
    };
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        tiebreaker: newTiebreaker
      });
    });
  };

  var onChangeDate = function onChangeDate(date, dateCase) {
    if (date && date.length > 0) {
      var dateIso = convertDateToGMTIsoString(date);

      if (dateCase === "cutoff_time") {
        setCutoffTimeIsFilled(true);
        setEditedGame(function (prevState) {
          return _objectSpread3({}, prevState, {
            predictionsCutoff: dateIso
          });
        });
      } else {
        setSchedulerIsFilled(true);
        setEditedGame(function (prevState) {
          return _objectSpread3({}, prevState, {
            scheduleOpenAt: dateIso
          });
        });
      }
    } else if (date.length === 0) {
      if (dateCase === "cutoff_time") {
        setEditedGame(function (prevState) {
          return _objectSpread3({}, prevState, {
            predictionsCutoff: null
          });
        });
        setCutoffTimeIsFilled(false);
        toast.info(labels.clearCutoffMessage);
      } else {
        setSchedulerIsFilled(false);
        setEditedGame(function (prevState) {
          return _objectSpread3({}, prevState, {
            scheduleOpenAt: null
          });
        });
        toast.info(labels.clearSchedulerMessage);
      }
    }
  };

  var onChangeImages = function onChangeImages(value, imageCases) {
    var imageValue = value || null;

    switch (imageCases) {
      case "mainImage":
        setEditedGame(function (prevState) {
          var newImages = prevState.images ? JSON.parse(JSON.stringify(prevState.images)) : new Images();
          newImages.main = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;

      case "coverImage":
        setEditedGame(function (prevState) {
          var newImages = prevState.images ? JSON.parse(JSON.stringify(prevState.images)) : new Images();
          newImages.cover = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;

      case "mobileImage":
        setEditedGame(function (prevState) {
          var newImages = prevState.images ? JSON.parse(JSON.stringify(prevState.images)) : new Images();
          newImages.mobile = imageValue;
          return _objectSpread3({}, prevState, {
            images: newImages
          });
        });
        break;
    }
  };

  var onChangeRelated = function onChangeRelated(entityIds, entityType) {
    var related = createRelated(entityIds, entityType, editedGame);
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        related: related
      });
    });
  };

  var onChangeLabels = function onChangeLabels(field) {
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        labels: field
      });
    });
  };

  var onChangeCustomFields = function onChangeCustomFields(field) {
    setEditedGame(function (prevState) {
      return _objectSpread3({}, prevState, {
        customFields: field
      });
    });
  };

  var buildFixtures = function buildFixtures() {
    var matchIds = [];
    loadedFixtures.forEach(function (fixture) {
      if (fixture.matchId) {
        return matchIds.push(fixture.matchId);
      }
    });
    return matchIds.map(function (id) {
      var fixture = new FixtureModel();
      fixture.match_id = id;
      fixture.market = gameMarket;
      return fixture;
    });
  };

  var constructRequestBody = function constructRequestBody() {
    var _a3;

    var requestBody = new GameRequestBody();
    requestBody.title = editedGame.title;
    requestBody.description = description;

    if (game.status === "OPEN" && editedGame.status === "OPEN") {
      delete requestBody.status;
    } else {
      requestBody.status = editedGame.status;
    }

    if (isCutoffEditable) {
      if (dayjs(game.predictionsCutoff).toDate().getTime() === dayjs(editedGame.predictionsCutoff).toDate().getTime()) {
        delete requestBody.predictions_cutoff;
      } else {
        requestBody.predictions_cutoff = editedGame.predictionsCutoff;
      }
    } else {
      delete requestBody.predictions_cutoff;
    }

    if (game.status === "PENDING") {
      requestBody.fixtures = buildFixtures();
      requestBody.schedule_open_at = editedGame.scheduleOpenAt;
      requestBody.tiebreaker.time_tiebreaker = (_a3 = editedGame.tiebreaker) == null ? void 0 : _a3.timeTiebreaker;
    } else {
      delete requestBody.fixtures;
      delete requestBody.schedule_open_at;
      delete requestBody.tiebreaker;
    }

    requestBody.status = editedGame.status;
    requestBody.flags = editedGame.flags && editedGame.flags.length ? extractValuesFlagOptions(editedGame.flags) : [];
    requestBody.images = editedGame.images;
    requestBody.related = editedGame.related;
    requestBody.labels = editedGame.labels;
    requestBody.custom_fields = editedGame.customFields;
    requestBody.rules = rules;
    requestBody.ad_content = adContent;
    return requestBody;
  };

  var editGame = function editGame() {
    setIsLoading(true);
    var validator2 = new GameValidator(editedGame, labels, objMatchIds, minFixtures, objKickoffMatches, loadedFixtures);
    validator2.validate("edit");

    if (!validator2.isValid) {
      setIsLoading(false);
      console.warn(validator2.message);
      toast.warn(validator2.message);
      return;
    }

    var requestBody = constructRequestBody();
    httpsService.editGame(requestBody, game.id).then(function () {
      setEditMode(false);
      setIsLoading(false);
      getGames();
      toast.success(labels.editGameMessage);
    }).catch(function (error) {
      console.error(error);
      setIsLoading(false);
      toast.error(labels.editGameErrorMessage);
    });
  };

  return (
    /* @__PURE__ */
    jsxs(React__default.Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1(ScreenHeader, {
        labels: labels,
        editMode: editMode,
        setEditMode: setEditMode
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-p-2 topxw-border topxw-border-gray-200 topxw-rounded",
        children: [
        /* @__PURE__ */
        jsx$1(GameID, {
          value: editedGame.id,
          label: labels.id
        }),
        /* @__PURE__ */
        jsx$1(GameInformation, {
          title: labels.name,
          placeholder: labels.namePlaceholder,
          onChange: onChangeTitle,
          value: editedGame.title,
          httpsService: httpsService,
          labels: labels,
          sportal365Config: sportal365Config
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          labels: labels,
          setValue: setDescription,
          defaultValue: description,
          property: "description"
        }),
        /* @__PURE__ */
        jsx$1(MatchSelection, {
          editMode: editMode,
          sdk: sdk,
          matchIds: objMatchIds,
          loadedFixtures: _toConsumableArray3(loadedFixtures),
          setLoadedFixtures: setLoadedFixtures,
          objKickoffMatches: objKickoffMatches,
          setObjKickoffMatches: setObjKickoffMatches,
          minFixtures: minFixtures,
          maxFixtures: maxFixtures,
          competitionsScope: competitionsScope,
          setMatchIds: setObjMatchIds,
          labels: labels,
          gameStatus: game.status
        }),
        /* @__PURE__ */
        jsx$1(MarketSelect, {
          labels: labels,
          gameMarket: loadedGameMarket,
          gameStatus: game.status,
          onChange: onChangeGameMarket
        }),
        /* @__PURE__ */
        jsx$1(GameStatus, {
          onChange: onChangeGameStatus,
          labelGameStatus: labels.gameStatus,
          labelEditGameStatusDescription: labels.editGameStatusDescription,
          editMode: editMode,
          labelCreateGameStatusDescription: labels.createGameStatusDescription,
          gameStatus: game.status
        }),
        /* @__PURE__ */
        jsx$1(GameTimeTiebreaker, {
          labels: labels,
          onChange: onChangeGameTimeTiebreaker,
          defaultValue: (_a2 = game.tiebreaker) == null ? void 0 : _a2.timeTiebreaker,
          gameStatus: game.status
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          labels: labels,
          defaultValue: rules,
          setValue: setRules,
          property: "rules"
        }),
        /* @__PURE__ */
        jsx$1(RichText, {
          labels: labels,
          defaultValue: adContent,
          setValue: setAdContent,
          property: "ad_content"
        }),
        /* @__PURE__ */
        jsx$1(GameFlags, {
          labels: labels,
          flags: editedGame.flags,
          setGameRequestBody: setEditedGame
        }),
        /* @__PURE__ */
        jsx$1(GameImages, {
          labels: labels,
          onChange: onChangeImages,
          editMode: editMode,
          loadedImages: editedGame.images,
          httpsService: httpsService,
          sportal365Config: sportal365Config
        }),
        /* @__PURE__ */
        jsx$1(GameRelated, {
          labels: labels,
          sdk: sdk,
          loadedEntities: editedGame.related,
          onChange: onChangeRelated
        }),
        /* @__PURE__ */
        jsx$1(GameDynamicFields, {
          labels: labels,
          onChange: onChangeLabels,
          dynamicField: "labels",
          field: editedGame.labels ? editedGame.labels : new Object()
        }, "labels"),
        /* @__PURE__ */
        jsx$1(GameDynamicFields, {
          labels: labels,
          onChange: onChangeCustomFields,
          dynamicField: "custom_fields",
          field: editedGame.customFields ? editedGame.customFields : new Object()
        }, "custom_fields"),
        /* @__PURE__ */
        jsx$1(CuttoffTime, {
          onChange: onChangeDate,
          cutoffTimeIsFilled: cutoffTimeIsFilled,
          value: validatePredictionsCutoffOnEdit(game.status, editedGame.predictionsCutoff),
          editMode: editMode,
          labels: labels,
          gameStatus: game.status
        }),
        /* @__PURE__ */
        jsx$1(GameScheduleOpenAt, {
          labels: labels,
          schedulerIsFilled: schedulerIsFilled,
          onChange: onChangeDate,
          loadedKickoffMatches: matchesKickoffObj(loadedFixtures),
          editMode: editMode,
          cutoffTime: editedGame.predictionsCutoff,
          value: editedGame.scheduleOpenAt,
          setEditedGame: setEditedGame,
          setSchedulerIsFilled: setSchedulerIsFilled,
          gameStatus: game.status
        }),
        /* @__PURE__ */
        jsx$1("div", {
          className: "topxw-my-4",
          children:
          /* @__PURE__ */
          jsx$1(ManagementButton, {
            paddingX: "topxw-px-24",
            paddingY: "topxw-py-3",
            mainLabel: labels.edit,
            centerButton: true,
            loadingLabel: labels.loadingMessage,
            isLoading: isLoading,
            onClick: editGame
          })
        })]
      })]
    })
  );
};

var TopXWidgetCard = function TopXWidgetCard(_ref650) {
  var children = _ref650.children;
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-w-full topxw-bg-white",
      children: children
    })
  );
};

var isSafari = function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

var isJsons = function isJsons(array) {
  return Array.isArray(array) && array.every(function (row) {
    return typeof row === "object" && !(row instanceof Array);
  });
};

var isArrays = function isArrays(array) {
  return Array.isArray(array) && array.every(function (row) {
    return Array.isArray(row);
  });
};

var jsonsHeaders = function jsonsHeaders(array) {
  return Array.from(array.map(function (json) {
    return Object.keys(json);
  }).reduce(function (a, b2) {
    return (
      /* @__PURE__ */
      new Set([].concat(_toConsumableArray3(a), _toConsumableArray3(b2)))
    );
  }, []));
};

var jsons2arrays = function jsons2arrays(jsons, headers) {
  headers = headers || jsonsHeaders(jsons);
  var headerLabels = headers;
  var headerKeys = headers;

  if (isJsons(headers)) {
    headerLabels = headers.map(function (header) {
      return header.label;
    });
    headerKeys = headers.map(function (header) {
      return header.key;
    });
  }

  var data2 = jsons.map(function (object) {
    return headerKeys.map(function (header) {
      return getHeaderValue(header, object);
    });
  });
  return [headerLabels].concat(_toConsumableArray3(data2));
};

var getHeaderValue = function getHeaderValue(property, obj) {
  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p2, i, arr) {
    var value = o[p2];

    if (value === void 0 || value === null) {
      arr.splice(1);
    } else {
      return value;
    }
  }, obj);
  return foundValue === void 0 ? property in obj ? obj[property] : "" : foundValue;
};

var elementOrEmpty = function elementOrEmpty(element) {
  return typeof element === "undefined" || element === null ? "" : element;
};

var joiner = function joiner(data2) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
  return data2.filter(function (e2) {
    return e2;
  }).map(function (row) {
    return row.map(function (element) {
      return elementOrEmpty(element);
    }).map(function (column2) {
      return "".concat(enclosingCharacter).concat(column2).concat(enclosingCharacter);
    }).join(separator);
  }).join("\n");
};

var arrays2csv = function arrays2csv(data2, headers, separator, enclosingCharacter) {
  return joiner(headers ? [headers].concat(_toConsumableArray3(data2)) : data2, separator, enclosingCharacter);
};

var jsons2csv = function jsons2csv(data2, headers, separator, enclosingCharacter) {
  return joiner(jsons2arrays(data2, headers), separator, enclosingCharacter);
};

var string2csv = function string2csv(data2, headers, separator, enclosingCharacter) {
  return headers ? "".concat(headers.join(separator), "\n").concat(data2) : data2.replace(/"/g, '""');
};

var toCSV = function toCSV(data2, headers, separator, enclosingCharacter) {
  if (isJsons(data2)) return jsons2csv(data2, headers, separator, enclosingCharacter);
  if (isArrays(data2)) return arrays2csv(data2, headers, separator, enclosingCharacter);
  if (typeof data2 === "string") return string2csv(data2, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};

var _buildURI = function buildURI(data2, uFEFF, headers, separator, enclosingCharacter) {
  var csv = toCSV(data2, headers, separator, enclosingCharacter);
  var type = isSafari() ? "application/csv" : "text/csv";
  var blob = new Blob([uFEFF ? "\uFEFF" : "", csv], {
    type: type
  });
  var dataURI = "data:".concat(type, ";charset=utf-8,").concat(uFEFF ? "\uFEFF" : "").concat(csv);
  var URL2 = window.URL || window.webkitURL;
  return typeof URL2.createObjectURL === "undefined" ? dataURI : URL2.createObjectURL(blob);
};

var propTypes = {
  data: propTypes$1.exports.oneOfType([propTypes$1.exports.string, propTypes$1.exports.array, propTypes$1.exports.func]).isRequired,
  headers: propTypes$1.exports.array,
  target: propTypes$1.exports.string,
  separator: propTypes$1.exports.string,
  filename: propTypes$1.exports.string,
  uFEFF: propTypes$1.exports.bool,
  onClick: propTypes$1.exports.func,
  asyncOnClick: propTypes$1.exports.bool,
  enclosingCharacter: propTypes$1.exports.string
};
var defaultProps$1 = {
  separator: ",",
  filename: "generatedBy_react-csv.csv",
  uFEFF: true,
  asyncOnClick: false,
  enclosingCharacter: '"'
};
var defaultProps = {
  target: "_blank"
};

var CSVDownload =
/*#__PURE__*/
function (_React__default$Compo) {
  _inherits3(CSVDownload, _React__default$Compo);

  function CSVDownload(props) {
    var _this193;

    _classCallCheck3(this, CSVDownload);

    _this193 = _possibleConstructorReturn3(this, _getPrototypeOf4(CSVDownload).call(this, props));
    _this193.state = {};
    return _this193;
  }

  _createClass3(CSVDownload, [{
    key: "buildURI",
    value: function buildURI() {
      return _buildURI.apply(void 0, arguments);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props15 = this.props,
          data2 = _this$props15.data,
          headers = _this$props15.headers,
          separator = _this$props15.separator,
          enclosingCharacter = _this$props15.enclosingCharacter,
          uFEFF = _this$props15.uFEFF,
          target = _this$props15.target,
          specs = _this$props15.specs,
          replace2 = _this$props15.replace;
      this.state.page = window.open(this.buildURI(data2, uFEFF, headers, separator, enclosingCharacter), target, specs, replace2);
    }
  }, {
    key: "getWindow",
    value: function getWindow() {
      return this.state.page;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return CSVDownload;
}(React__default.Component);

__publicField(CSVDownload, "defaultProps", Object.assign(defaultProps$1, defaultProps));

__publicField(CSVDownload, "propTypes", propTypes);

var CSVLink$1 =
/*#__PURE__*/
function (_React__default$Compo2) {
  _inherits3(CSVLink$1, _React__default$Compo2);

  function CSVLink$1(props) {
    var _this194;

    _classCallCheck3(this, CSVLink$1);

    _this194 = _possibleConstructorReturn3(this, _getPrototypeOf4(CSVLink$1).call(this, props));
    _this194.buildURI = _this194.buildURI.bind(_assertThisInitialized3(_this194));
    return _this194;
  }

  _createClass3(CSVLink$1, [{
    key: "buildURI",
    value: function buildURI() {
      return _buildURI.apply(void 0, arguments);
    }
  }, {
    key: "handleLegacy",
    value: function handleLegacy(event) {
      var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (window.navigator.msSaveOrOpenBlob) {
        event.preventDefault();
        var _this$props16 = this.props,
            data2 = _this$props16.data,
            headers = _this$props16.headers,
            separator = _this$props16.separator,
            filename = _this$props16.filename,
            enclosingCharacter = _this$props16.enclosingCharacter,
            uFEFF = _this$props16.uFEFF;
        var csvData = isAsync && typeof data2 === "function" ? data2() : data2;
        var blob = new Blob([uFEFF ? "\uFEFF" : "", toCSV(csvData, headers, separator, enclosingCharacter)]);
        window.navigator.msSaveBlob(blob, filename);
        return false;
      }
    }
  }, {
    key: "handleAsyncClick",
    value: function handleAsyncClick(event) {
      var _this195 = this;

      var done = function done(proceed) {
        if (proceed === false) {
          event.preventDefault();
          return;
        }

        _this195.handleLegacy(event, true);
      };

      this.props.onClick(event, done);
    }
  }, {
    key: "handleSyncClick",
    value: function handleSyncClick(event) {
      var stopEvent = this.props.onClick(event) === false;

      if (stopEvent) {
        event.preventDefault();
        return;
      }

      this.handleLegacy(event);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this196 = this;

      return function (event) {
        if (typeof _this196.props.onClick === "function") {
          return _this196.props.asyncOnClick ? _this196.handleAsyncClick(event) : _this196.handleSyncClick(event);
        }

        _this196.handleLegacy(event);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this197 = this;

      var _this$props17 = this.props,
          data2 = _this$props17.data,
          headers = _this$props17.headers,
          separator = _this$props17.separator,
          filename = _this$props17.filename,
          uFEFF = _this$props17.uFEFF,
          children = _this$props17.children,
          onClick = _this$props17.onClick,
          asyncOnClick = _this$props17.asyncOnClick,
          enclosingCharacter = _this$props17.enclosingCharacter,
          rest = _objectWithoutProperties3(_this$props17, ["data", "headers", "separator", "filename", "uFEFF", "children", "onClick", "asyncOnClick", "enclosingCharacter"]);

      var isNodeEnvironment = typeof window === "undefined";
      var href = isNodeEnvironment ? "" : this.buildURI(data2, uFEFF, headers, separator, enclosingCharacter);
      return (
        /* @__PURE__ */
        jsx$1("a", _objectSpread3({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this197.link = link;
          },
          target: "_self",
          href: href,
          onClick: this.handleClick(),
          children: children
        }))
      );
    }
  }]);

  return CSVLink$1;
}(React__default.Component);

__publicField(CSVLink$1, "defaultProps", defaultProps$1);

__publicField(CSVLink$1, "propTypes", propTypes);

var CSVLink = CSVLink$1;

var CSVModel = function CSVModel() {
  _classCallCheck3(this, CSVModel);

  this.position = 0;
  this.id = "";
  this.name = "";
  this.nickname = "";
  this.email = "";
  this.gender = "";
  this.predictionsMade = 0;
  this.points = 0;
};

var defaultDescription = function defaultDescription() {
  return (
    /* @__PURE__ */
    jsxs("span", {
      children: ["Download a ",
      /* @__PURE__ */
      jsx$1("strong", {
        children: ".csv"
      }), " file with the first ",
      /* @__PURE__ */
      jsx$1("strong", {
        children: "100"
      }), " number of users."]
    })
  );
};

var csvHeaders = [{
  label: "Position",
  key: "position"
}, {
  label: "ID",
  key: "id"
}, {
  label: "Name",
  key: "name"
}, {
  label: "Nickname",
  key: "nickname"
}, {
  label: "Gender",
  key: "gender"
}, {
  label: "Email",
  key: "email"
}, {
  label: "Predictions made",
  key: "predictionsMade"
}, {
  label: "Points",
  key: "points"
}];

var ExportModal = function ExportModal(props) {
  var _useState103 = useState(0),
      _useState104 = _slicedToArray3(_useState103, 2),
      limit = _useState104[0],
      setLimit = _useState104[1];

  var _useState105 = useState(false),
      _useState106 = _slicedToArray3(_useState105, 2),
      isLoading = _useState106[0],
      setIsLoading = _useState106[1];

  var _useState107 = useState([]),
      _useState108 = _slicedToArray3(_useState107, 2),
      csvReport = _useState108[0],
      setCsvReport = _useState108[1];

  var csvRef = useRef(null);
  useEffect(function () {
    if (csvReport.length && csvRef && csvRef.current && csvRef.current.link) {
      csvRef.current.link.click();
      setCsvReport([]);
    }
  }, [csvReport]);

  var closeModal = function closeModal() {
    props.setShowModal(false);
  };

  var onChangeLimit = function onChangeLimit(event) {
    event.persist();
    setLimit(Number(event.target.value));
  };

  var downloadReport =
  /*#__PURE__*/
  function () {
    var _ref651 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee637() {
      var minLimit, maxLimit, response, csvReport2;
      return _regeneratorRuntime.wrap(function _callee637$(_context638) {
        while (1) {
          switch (_context638.prev = _context638.next) {
            case 0:
              minLimit = 1;
              maxLimit = 100;

              if (!(!Number.isInteger(limit) || limit < minLimit || limit > maxLimit)) {
                _context638.next = 5;
                break;
              }

              toast.error(props.labels.csvModalValidationMessage);
              return _context638.abrupt("return");

            case 5:
              setIsLoading(true);
              _context638.prev = 6;
              _context638.next = 9;
              return props.https.exportDetailedLeaderboard(props.gameId, limit);

            case 9:
              response = _context638.sent;
              csvReport2 = response.data.data.map(function (value) {
                var csvModel = new CSVModel();
                csvModel.position = value.position;
                csvModel.id = value.profile_id;
                csvModel.name = value.name;
                csvModel.nickname = value.nickname;
                csvModel.gender = value.gender;
                csvModel.email = value.email;
                csvModel.predictionsMade = value.predictions_made;
                csvModel.points = value.points;
                return csvModel;
              });
              setCsvReport(csvReport2);
              _context638.next = 18;
              break;

            case 14:
              _context638.prev = 14;
              _context638.t0 = _context638["catch"](6);
              console.error(_context638.t0);
              toast.error(props.labels.csvModalErrorMessage);

            case 18:
              setIsLoading(false);

            case 19:
            case "end":
              return _context638.stop();
          }
        }
      }, _callee637, null, [[6, 14]]);
    }));

    return function downloadReport() {
      return _ref651.apply(this, arguments);
    };
  }();

  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-container topxw-mx-auto topxw-w-11/12 topxw-md:w-2/3 topxw-max-w-lg topxw-absolute topxw-z-20 topxw-top-72 topxw-right-0 topxw-bottom-0 topxw-left-0",
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-relative topxw-p-4 topxw-bg-white topxw-shadow-md topxw-rounded topxw-border topxw-border-gray-400",
          children: [
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-items-center topxw-justify-between topxw-mb-4",
            children: [
            /* @__PURE__ */
            jsxs("h1", {
              className: "topxw-text-gray-800 topxw-font-bold topxw-tracking-normal topxw-leading-tight",
              children: [props.labels.csvModalTitle, " "]
            }), !isLoading ?
            /* @__PURE__ */
            jsx$1("button", {
              className: "topxw-bg-transparent topxw-cursor-pointer topxw-text-gray-400 hover:topxw-text-gray-600 topxw-transition topxw-duration-150 topxw-ease-in-out topxw-rounded focus:topxw-ring-2 focus:topxw-outline-none focus:topxw-ring-gray-600",
              role: "button",
              onClick: closeModal,
              "data-testid": "close button",
              children:
              /* @__PURE__ */
              jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                strokeWidth: "2.5",
                stroke: "currentColor",
                fill: "none",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                /* @__PURE__ */
                jsx$1("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z"
                }),
                /* @__PURE__ */
                jsx$1("line", {
                  x1: "18",
                  y1: "6",
                  x2: "6",
                  y2: "18"
                }),
                /* @__PURE__ */
                jsx$1("line", {
                  x1: "6",
                  y1: "6",
                  x2: "18",
                  y2: "18"
                })]
              })
            }) : null]
          }),
          /* @__PURE__ */
          jsx$1("p", {
            className: "topxw-text-gray-800 topxw-text-sm topxw-leading-tight topxw-tracking-normal topxw-mb-4",
            children: props.labels.csvModalDescription ? props.labels.csvModalDescription : defaultDescription()
          }),
          /* @__PURE__ */
          jsx$1("input", {
            className: "topxw-mb-4 topxw-mt-2 topxw-text-gray-600 focus:topxw-outline-none focus:topxw-border focus:topxw-border-indigo-700 topxw-font-normal topxw-w-full topxw-h-10 topxw-flex topxw-items-center topxw-pl-3 topxw-text-sm topxw-border-gray-300 topxw-rounded topxw-border",
            placeholder: props.labels.csvModalPlaceholder,
            onChange: onChangeLimit,
            "data-testid": "export input"
          }),
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-items-center topxw-justify-end topxw-w-full",
            children: [!isLoading ?
            /* @__PURE__ */
            jsx$1("button", {
              onClick: closeModal,
              className: "focus:topxw-outline-none topxw-bg-transparent topxw-font-bold topxw-text-red-500 hover:topxw-text-red-600 topxw-transition topxw-duration-150 topxw-ease-in-out topxw-px-8 topxw-py-2 topxw-text-sm",
              "data-testid": "cancel button",
              children: props.labels.cancel
            }) : null,
            /* @__PURE__ */
            jsx$1("button", {
              disabled: isLoading,
              onClick: downloadReport,
              className: "topxw-rounded topxw-bg-gray-700 topxw-text-white ".concat(isLoading ? "hover:topxw-bg-gray-800 topxw-transition topxw-duration-150 topxw-ease-in-out" : "", " topxw-uppercase topxw-text-xs topxw-font-bold topxw-ml-3 topxw-px-8 topxw-py-2"),
              "data-testid": "download button",
              children: isLoading ? props.labels.loadingMessage : props.labels.csvModalDownloadButton
            }), csvReport.length ?
            /* @__PURE__ */
            jsx$1(CSVLink, {
              ref: csvRef,
              headers: csvHeaders,
              data: csvReport,
              filename: "".concat(props.reportName, "_leaderboard.csv")
            }) : null]
          })]
        })
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-bg-gray-700 topxw-opacity-80 topxw-transition topxw-duration-150 topxw-ease-in-out topxw-z-10 topxw-absolute topxw-top-0 topxw-right-0 topxw-bottom-0 topxw-left-0"
      })]
    })
  );
};

var ProfileAvatarService = function ProfileAvatarService() {
  _classCallCheck3(this, ProfileAvatarService);

  this.checkIfUrlIsValid = function (urlString) {
    if (urlString) {
      try {
        var url = new URL(urlString);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (e2) {
        return false;
      }
    }
  };
};

var ProfileAvatar = function ProfileAvatar(props) {
  var profileAvatarService = new ProfileAvatarService();
  return (
    /* @__PURE__ */
    jsx$1("img", {
      referrerPolicy: "no-referrer",
      "data-testid": "profile avatar",
      src: profileAvatarService.checkIfUrlIsValid(props.imageSrc) ? props.imageSrc : props.placeholder,
      alt: "",
      className: "topxw-w-10 topxw-h-10 topxw-rounded-full topxw-border topxw-border-gray-200"
    })
  );
};

var GameParticipant = function GameParticipant(_ref652) {
  var report = _ref652.report;

  var _a2;

  return (
    /* @__PURE__ */
    jsxs("tr", {
      className: "topxw-border-b",
      children: [
      /* @__PURE__ */
      jsx$1("td", {
        "data-testid": "cell position",
        children:
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-center topxw-font-semibold topxw-text-black",
          children: report.position
        })
      }),
      /* @__PURE__ */
      jsx$1("td", {
        "data-testid": "cell name",
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-flex topxw-items-center topxw-space-x-3 topxw-p-2",
          children: [
          /* @__PURE__ */
          jsx$1(ProfileAvatar, {
            placeholder: assetsPlaceholder.player,
            "data-testid": "profile avatar",
            imageSrc: (_a2 = report.profileModel) == null ? void 0 : _a2.avatar
          }),
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-text-left",
            children: [
            /* @__PURE__ */
            jsx$1("div", {
              "data-testid": "profile name",
              className: "topxw-font-bold",
              children: report.profileModel && report.profileModel.name ? report.profileModel.name : "-------------"
            }),
            /* @__PURE__ */
            jsx$1("div", {
              "data-testid": "profile country",
              className: "topxw-text-sm topxw-opacity-50",
              children: report.profileModel && report.profileModel.country && report.profileModel.country.name
            })]
          })]
        })
      }),
      /* @__PURE__ */
      jsx$1("td", {
        "data-testid": "cell points",
        className: "topxw-text-s topxw-text-right topxw-px-2 topxw-py-3",
        children: report.points
      })]
    }, report.profileId)
  );
};

var Report = function Report(props) {
  var _useState109 = useState(null),
      _useState110 = _slicedToArray3(_useState109, 2),
      leaderboard = _useState110[0],
      setLeaderboard = _useState110[1];

  var _useState111 = useState(false),
      _useState112 = _slicedToArray3(_useState111, 2),
      showModal = _useState112[0],
      setShowModal = _useState112[1];

  var getLeaderboardForGame =
  /*#__PURE__*/
  function () {
    var _ref653 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee638(gameId) {
      var loyaltyFilters, disableCache, leaderboardForGame;
      return _regeneratorRuntime.wrap(function _callee638$(_context639) {
        while (1) {
          switch (_context639.prev = _context639.next) {
            case 0:
              loyaltyFilters = {
                limit: 10,
                page: 1
              };
              disableCache = true;
              _context639.prev = 2;
              _context639.next = 5;
              return props.sdk.loyalty.getLeaderboardForGame(gameId, loyaltyFilters, disableCache);

            case 5:
              leaderboardForGame = _context639.sent;
              setLeaderboard(leaderboardForGame.data);
              _context639.next = 14;
              break;

            case 9:
              _context639.prev = 9;
              _context639.t0 = _context639["catch"](2);
              console.error(_context639.t0);
              toast.error(props.labels.leaderboardErrorMessage);
              throw _context639.t0;

            case 14:
            case "end":
              return _context639.stop();
          }
        }
      }, _callee638, null, [[2, 9]]);
    }));

    return function getLeaderboardForGame(_x1185) {
      return _ref653.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getLeaderboardForGame(props.gameId).catch(function (error) {
      throw error;
    });
  }, []);

  if (!leaderboard) {
    return (
      /* @__PURE__ */
      jsx$1(Spinner, {
        forNextMatches: false
      })
    );
  }

  return (
    /* @__PURE__ */
    jsxs(TopXWidgetCard, {
      children: [showModal ?
      /* @__PURE__ */
      jsx$1(ExportModal, {
        gameId: props.gameId,
        reportName: props.gameTitle,
        labels: props.labels,
        https: props.https,
        setShowModal: setShowModal
      }) : null,
      /* @__PURE__ */
      jsx$1(ScreenHeader, {
        labels: props.labels,
        reportMode: true,
        gameTitle: props.gameTitle,
        setReportMode: props.setReportMode,
        setShowModal: setShowModal
      }),
      /* @__PURE__ */
      jsx$1("hr", {
        className: "topxw-my-4"
      }), leaderboard && leaderboard.length > 0 &&
      /* @__PURE__ */
      jsx$1("div", {
        children:
        /* @__PURE__ */
        jsxs("table", {
          className: "topxw-w-full topxw-border topxw-mb-2 topxw-table",
          children: [
          /* @__PURE__ */
          jsx$1(TableHeader, {
            labels: props.labels,
            reportMode: true
          }),
          /* @__PURE__ */
          jsx$1("tbody", {
            className: "topxw-bg-white",
            children: leaderboard.map(function (report) {
              return (
                /* @__PURE__ */
                jsx$1(GameParticipant, {
                  report: report
                }, report.profileId)
              );
            })
          })]
        })
      }), leaderboard && leaderboard.length === 0 &&
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-font-semibold",
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-px-20 topxw-py-20 topxw-flex topxw-items-center topxw-justify-center",
          children: [
          /* @__PURE__ */
          jsx$1("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            className: "topxw-stroke-current topxw-flex-shrink-0 topxw-w-7 topxw-h-7",
            children:
            /* @__PURE__ */
            jsx$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            })
          }),
          /* @__PURE__ */
          jsx$1("span", {
            children: props.labels.gameNotSettledMessage
          })]
        })
      })]
    })
  );
};

var Pagination = function Pagination(props) {
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-flex topxw-items-baseline topxw-p-2 topxw-flex-wrap",
      children:
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex",
        children: [props.pageCount !== 1 &&
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-text-base topxw-rounded-r-none focus:topxw-outline-none topxw-flex topxw-justify-center topxw-px-4 topxw-py-2 topxw-rounded topxw-font-bold topxw-cursor-pointer hover:topxw-bg-gray-200 topxw-bg-gray-100 topxw-text-gray-700 topxw-border topxw-duration-200 topxw-ease-in-out topxw-border-gray-300 topxw-transition",
          onClick: props.getPreviousPage,
          children:
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-flex topxw-leading-5 topxw-text-xs topxw-items-center",
            children: [
            /* @__PURE__ */
            jsx$1("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "topxw-feather topxw-feather-chevron-left topxw-w-4 topxw-h-4",
              children:
              /* @__PURE__ */
              jsx$1("polyline", {
                points: "15 18 9 12 15 6"
              })
            }), props.labels.previous]
          })
        }), props.pageGames[props.pageCount] && props.pageGames[props.pageCount].length === 10 &&
        /* @__PURE__ */
        jsx$1("button", {
          className: "topxw-text-base ".concat(props.pageCount !== 1 ? "topxw-text-xs topxw-rounded-l-none topxw-border-l-0" : "", " focus:topxw-outline-none topxw-flex topxw-justify-center topxw-px-4 topxw-py-2 topxw-rounded topxw-font-bold topxw-cursor-pointer hover:topxw-bg-gray-200 topxw-bg-gray-100 topxw-text-gray-700 topxw-border topxw-duration-200 topxw-ease-in-out topxw-border-gray-300 topxw-transition"),
          onClick: props.getNextPage,
          children:
          /* @__PURE__ */
          jsxs("div", {
            className: "topxw-text-xs topxw-flex topxw-leading-5 topxw-items-center",
            children: [props.labels.next,
            /* @__PURE__ */
            jsx$1("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "topxw-feather topxw-feather-chevron-right topxw-w-4 topxw-h-4 topxw-ml-1",
              children:
              /* @__PURE__ */
              jsx$1("polyline", {
                points: "9 18 15 12 9 6"
              })
            })]
          })
        })]
      })
    })
  );
};

var useWinners = function useWinners(sdk, gameId, errorMessage) {
  var _useState113 = useState(null),
      _useState114 = _slicedToArray3(_useState113, 2),
      winners = _useState114[0],
      setWinners = _useState114[1];

  var getWinners =
  /*#__PURE__*/
  function () {
    var _ref654 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee639() {
      var winners2, errorCode, errorStatus;
      return _regeneratorRuntime.wrap(function _callee639$(_context640) {
        while (1) {
          switch (_context640.prev = _context640.next) {
            case 0:
              _context640.prev = 0;
              _context640.next = 3;
              return sdk.topX.getGameWinners(gameId, true);

            case 3:
              winners2 = _context640.sent;

              if (winners2.userList) {
                winners2.userList.forEach(function (winner) {
                  if (winner.tags) {
                    winner.tags = winner.tags.map(function (tag) {
                      return createOption(tag);
                    });
                  } else {
                    winner.tags = [];
                  }
                });
              }

              setWinners(winners2);
              _context640.next = 15;
              break;

            case 8:
              _context640.prev = 8;
              _context640.t0 = _context640["catch"](0);
              console.error(_context640.t0);
              errorCode = 404;
              errorStatus = "code_unknown_contest";
              if (_context640.t0.error.code !== errorCode && _context640.t0.error.status !== errorStatus) toast.error(errorMessage);
              setWinners({});

            case 15:
            case "end":
              return _context640.stop();
          }
        }
      }, _callee639, null, [[0, 8]]);
    }));

    return function getWinners() {
      return _ref654.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getWinners();
  }, []);
  return winners;
};

var useLeaderboard = function useLeaderboard(gameId, errorMessage, sdk, page) {
  var _useState115 = useState(null),
      _useState116 = _slicedToArray3(_useState115, 2),
      leaderboard = _useState116[0],
      setLeaderboard = _useState116[1];

  var _useState117 = useState(false),
      _useState118 = _slicedToArray3(_useState117, 2),
      hasMoreParticipants = _useState118[0],
      setHasMoreParticipants = _useState118[1];

  var getLeaderboardForGame =
  /*#__PURE__*/
  function () {
    var _ref655 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee640(gameId2) {
      var filters, disableCache, leaderboardForGame;
      return _regeneratorRuntime.wrap(function _callee640$(_context641) {
        while (1) {
          switch (_context641.prev = _context641.next) {
            case 0:
              filters = {
                limit: 10,
                page: page
              };
              disableCache = true;
              _context641.prev = 2;
              _context641.next = 5;
              return sdk.loyalty.getLeaderboardForGame(gameId2, filters, disableCache);

            case 5:
              leaderboardForGame = _context641.sent;
              if (leaderboardForGame.meta.pagination.numberOfPages > page) setHasMoreParticipants(true);else setHasMoreParticipants(false);
              if (leaderboard && leaderboard.length) setLeaderboard(function (prevState) {
                return [].concat(_toConsumableArray3(prevState), _toConsumableArray3(leaderboardForGame.data));
              });else setLeaderboard(leaderboardForGame.data);
              _context641.next = 15;
              break;

            case 10:
              _context641.prev = 10;
              _context641.t0 = _context641["catch"](2);
              console.error(_context641.t0);
              toast.error(errorMessage);
              setLeaderboard([]);

            case 15:
            case "end":
              return _context641.stop();
          }
        }
      }, _callee640, null, [[2, 10]]);
    }));

    return function getLeaderboardForGame(_x1186) {
      return _ref655.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getLeaderboardForGame(gameId);
  }, [page]);
  return {
    leaderboard: leaderboard,
    hasMoreParticipants: hasMoreParticipants
  };
};

var WinnersUserList = function WinnersUserList() {
  _classCallCheck3(this, WinnersUserList);

  this.position = "";
  this.profileId = "";
  this.note = "";
  this.tags = [];
};

var GameWinnersRequestBody = function GameWinnersRequestBody() {
  _classCallCheck3(this, GameWinnersRequestBody);

  this.contestId = "";
  this.contestType = "GAME";
  this.description = "";
  this.userList = [new WinnersUserList()];
};

var WinnerValidator = function WinnerValidator() {
  var _this198 = this;

  _classCallCheck3(this, WinnerValidator);

  this.isValid = true;
  this.message = null;

  this.validate = function (userList, labels) {
    _this198.validateField(userList, labels);

    _this198.validateWinnerIds(userList, labels);

    return _this198;
  };

  this.validateField = function (userList, labels) {
    var isValid = userList.every(function (value) {
      return value.position && value.profileId;
    });

    if (!isValid) {
      _this198.isValid = isValid;
      _this198.message = labels.positionAndWinnerRequiredMessage;
    }
  };

  this.validateWinnerIds = function (userList, labels) {
    var winnerIds = userList.map(function (value) {
      return value.profileId;
    });
    var winnerIdsSet = new Set(winnerIds);

    if (winnerIds.length !== winnerIdsSet.size) {
      _this198.isValid = false;
      _this198.message = labels.sameChosenWinnerMessage;
    }
  };
};

var PreviewWinners = function PreviewWinners(_ref656) {
  var winners = _ref656.winners,
      labels = _ref656.labels;
  var isWinnerInfoFilled = winners.userList[0].position || winners.userList[0].profileId || winners.userList[0].notes || winners.userList[0].tags.length;
  return (
    /* @__PURE__ */
    jsx$1("div", {
      className: "topxw-border topxw-p-4",
      children: isWinnerInfoFilled ?
      /* @__PURE__ */
      jsxs(Fragment, {
        children: [
        /* @__PURE__ */
        jsxs("h3", {
          className: "topxw-mb-4 topxw-font-bold",
          children: [labels.preview, ":"]
        }),
        /* @__PURE__ */
        jsxs("table", {
          className: "topxw-w-full topxw-border topxw-mb-2 topxw-table",
          children: [
          /* @__PURE__ */
          jsx$1("thead", {
            className: "topxw-bg-gray-200",
            "data-testid": "winners header",
            children:
            /* @__PURE__ */
            jsxs("tr", {
              className: "topxw-uppercase topxw-text-xs",
              children: [
              /* @__PURE__ */
              jsx$1("th", {
                className: "topxw-px-2 topxw-py-4 topxw-font-semibold topxw-text-center topxw-w-20",
                children: "#"
              }),
              /* @__PURE__ */
              jsx$1("th", {
                className: "md:topxw-text-left topxw-p-2 topxw-font-semibold",
                children: labels.name
              }),
              /* @__PURE__ */
              jsx$1("th", {
                className: "topxw-text-center topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
                children: labels.note
              }),
              /* @__PURE__ */
              jsx$1("th", {
                className: "topxw-text-right topxw-hidden md:topxw-table-cell topxw-p-2 topxw-font-semibold",
                children: labels.tags
              })]
            })
          }),
          /* @__PURE__ */
          jsx$1("tbody", {
            className: "topxw-bg-white",
            children: winners.userList.map(function (userWinner) {
              var _a2, _b, _c;

              return (
                /* @__PURE__ */
                jsxs("tr", {
                  className: "topxw-border-b",
                  children: [
                  /* @__PURE__ */
                  jsx$1("td", {
                    "data-testid": "cell position",
                    className: "topxw-px-1",
                    children:
                    /* @__PURE__ */
                    jsx$1("p", {
                      className: "topxw-text-center topxw-font-semibold topxw-text-black",
                      children: userWinner.position
                    })
                  }),
                  /* @__PURE__ */
                  jsx$1("td", {
                    "data-testid": "cell name",
                    children:
                    /* @__PURE__ */
                    jsxs("div", {
                      className: "topxw-flex topxw-items-center md:topxw-justify-start topxw-justify-center topxw-space-x-3 topxw-p-2",
                      children: [
                      /* @__PURE__ */
                      jsx$1(ProfileAvatar, {
                        placeholder: assetsPlaceholder.player,
                        "data-testid": "profile avatar",
                        imageSrc: (_a2 = userWinner.profileModel) == null ? void 0 : _a2.avatar
                      }),
                      /* @__PURE__ */
                      jsxs("div", {
                        className: "topxw-text-left",
                        children: [
                        /* @__PURE__ */
                        jsx$1("div", {
                          "data-testid": "profile name",
                          className: "topxw-font-bold",
                          children: userWinner.profileModel && userWinner.profileModel.name ? userWinner.profileModel.name : "-------------"
                        }),
                        /* @__PURE__ */
                        jsx$1("div", {
                          "data-testid": "profile country",
                          className: "topxw-text-sm topxw-opacity-50",
                          children: (_c = (_b = userWinner.profileModel) == null ? void 0 : _b.country) == null ? void 0 : _c.name
                        })]
                      })]
                    })
                  }),
                  /* @__PURE__ */
                  jsx$1("td", {
                    "data-testid": "cell points",
                    className: "topxw-text-sm topxw-text-center md:topxw-table-cell topxw-hidden",
                    children: userWinner.note
                  }),
                  /* @__PURE__ */
                  jsx$1("td", {
                    "data-testid": "cell points",
                    className: "topxw-text-sm topxw-text-right md:topxw-table-cell topxw-hidden topxw-px-1",
                    children: userWinner.tags.map(function (tag) {
                      return (
                        /* @__PURE__ */
                        jsx$1("span", {
                          className: "topxw-rounded topxw-bg-gray-200 topxw-p-1 topxw-mr-1",
                          children: tag.value
                        }, "".concat(userWinner.profileId, "-").concat(tag.value))
                      );
                    })
                  })]
                }, "".concat(userWinner.profileId, "-").concat(Math.random()))
              );
            })
          })]
        })]
      }) :
      /* @__PURE__ */
      jsx$1("h3", {
        className: "topxw-text-center topxw-font-bold",
        children: labels.gameNoSetWinnersMessage
      })
    })
  );
};

var displayNameOrNicknameForProfile = function displayNameOrNicknameForProfile(profileModel) {
  if (profileModel) {
    if (profileModel.nickname) {
      return profileModel.nickname;
    } else if (profileModel.name) {
      return profileModel.name;
    }
  }

  return "-------------";
};

var WinnerSelect = function WinnerSelect(_ref657) {
  var index2 = _ref657.index,
      title = _ref657.title,
      description = _ref657.description,
      leaderboard = _ref657.leaderboard,
      pointsLabel = _ref657.pointsLabel,
      loadMoreLabel = _ref657.loadMoreLabel,
      leaderboardNotAvailableLabel = _ref657.leaderboardNotAvailableLabel,
      winnerId = _ref657.winnerId,
      hasMoreParticipants = _ref657.hasMoreParticipants,
      onChange2 = _ref657.onChange,
      setPage = _ref657.setPage;
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: title,
        className: titleManageGameStyle,
        children: title
      }),
      /* @__PURE__ */
      jsx$1("p", {
        className: "topxw-text-gray-400 topxw-text-xs topxw-mb-1",
        children: description
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-overflow-visible topxw-shadow-l topxw-border topxw-border-gray-200",
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-flex topxw-flex-col topxw-h-64 topxw-overflow-hidden topxw-overflow-y-scroll topxw-mb-2 topxw-p-2 topxw-bg-gray-100 topxw-rounded-bl topxw-rounded-br",
          children: [leaderboard ? leaderboard.map(function (value) {
            var _a2, _b, _c;

            return (
              /* @__PURE__ */
              jsxs("label", {
                className: "topxw-flex topxw-items-center md:topxw-justify-between topxw-justify-center topxw-text-black topxw-w-full topxw-border-b topxw-cursor-pointer topxw-mb-2",
                onClick: function onClick() {
                  return onChange2(value.profileId, value.profileModel, index2);
                },
                children: [
                /* @__PURE__ */
                jsxs("div", {
                  className: "topxw-flex topxw-items-center",
                  children: [
                  /* @__PURE__ */
                  jsx$1("input", {
                    id: value.profileId,
                    type: "radio",
                    className: "topxw-h-5 topxw-w-5 topxw-text-gray-600",
                    defaultValue: value.profileId,
                    name: "winner-profile-".concat(index2),
                    checked: winnerId ? winnerId === value.profileId : null,
                    readOnly: true
                  }),
                  /* @__PURE__ */
                  jsxs("div", {
                    className: "topxw-flex topxw-items-center md:topxw-justify-start topxw-justify-center topxw-space-x-3 topxw-p-2",
                    children: [
                    /* @__PURE__ */
                    jsx$1(ProfileAvatar, {
                      placeholder: assetsPlaceholder.player,
                      imageSrc: (_a2 = value.profileModel) == null ? void 0 : _a2.avatar
                    }),
                    /* @__PURE__ */
                    jsxs("div", {
                      className: "topxw-text-left",
                      children: [
                      /* @__PURE__ */
                      jsx$1("div", {
                        "data-testid": "profile name",
                        className: "topxw-font-bold",
                        children: displayNameOrNicknameForProfile(value.profileModel)
                      }),
                      /* @__PURE__ */
                      jsx$1("div", {
                        "data-testid": "profile country",
                        className: "topxw-text-sm topxw-opacity-50",
                        children: (_c = (_b = value.profileModel) == null ? void 0 : _b.country) == null ? void 0 : _c.name
                      })]
                    })]
                  })]
                }),
                /* @__PURE__ */
                jsxs("div", {
                  className: "topxw-text-center",
                  children: [
                  /* @__PURE__ */
                  jsx$1("h3", {
                    className: "topxw-font-bold",
                    children: pointsLabel
                  }),
                  /* @__PURE__ */
                  jsx$1("label", {
                    className: "topxw-text-sm",
                    children: value.points ? value.points : 0
                  })]
                })]
              }, value.profileId)
            );
          }) :
          /* @__PURE__ */
          jsx$1(Spinner, {
            forNextMatches: true
          }), leaderboard && hasMoreParticipants ?
          /* @__PURE__ */
          jsx$1("div", {
            className: "topxw-w-4/12 topxw-my-2",
            children:
            /* @__PURE__ */
            jsx$1(LoadMoreButton, {
              label: loadMoreLabel,
              onClick: function onClick() {
                return setPage(function (prevState) {
                  return prevState + 1;
                });
              }
            })
          }) : null, leaderboard && !leaderboard.length ?
          /* @__PURE__ */
          jsx$1("label", {
            className: "topxw-text-center topxw-my-auto topxw-font-bold",
            children: leaderboardNotAvailableLabel
          }) : null]
        })
      })]
    })
  );
};

var WinnersInformation = function WinnersInformation(_ref658) {
  var title = _ref658.title,
      placeholder = _ref658.placeholder,
      index2 = _ref658.index,
      value = _ref658.value,
      onChange2 = _ref658.onChange;
  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: title,
        className: titleManageGameStyle,
        children: title
      }),
      /* @__PURE__ */
      jsx$1("input", {
        onChange: function onChange(event) {
          return onChange2(event, index2);
        },
        defaultValue: value,
        type: "text",
        id: title,
        className: inputStyle$1,
        placeholder: placeholder
      })]
    })
  );
};

var WinnerTags = function WinnerTags(_ref659) {
  var labels = _ref659.labels,
      tags = _ref659.tags,
      index2 = _ref659.index,
      setWinnersRequestBody = _ref659.setWinnersRequestBody;

  var _useState119 = useState(""),
      _useState120 = _slicedToArray3(_useState119, 2),
      input = _useState120[0],
      setInput = _useState120[1];

  var handleChange = function handleChange(value) {
    setWinnersRequestBody(function (prevState) {
      var newUserList = _toConsumableArray3(prevState.userList);

      newUserList[index2].tags = value;
      return _objectSpread3({}, prevState, {
        userList: newUserList
      });
    });
  };

  var handleInputChange2 = function handleInputChange2(inputValue) {
    setInput(inputValue);
  };

  var handleKeyDown = function handleKeyDown(event) {
    event.persist();
    var key = event.key;
    if (!input) return;

    switch (key) {
      case "Enter":
      case "Tab":
        if (tags.length === 0) {
          setWinnersRequestBody(function (prevState) {
            var newUserList = _toConsumableArray3(prevState.userList);

            newUserList[index2].tags = [].concat(_toConsumableArray3(tags), [createOption(input)]);
            return _objectSpread3({}, prevState, {
              userList: newUserList
            });
          });
        }

        if (tags.length > 0) {
          if (isValidTagOption()) {
            setWinnersRequestBody(function (prevState) {
              var newUserList = _toConsumableArray3(prevState.userList);

              newUserList[index2].tags = [].concat(_toConsumableArray3(tags), [createOption(input)]);
              return _objectSpread3({}, prevState, {
                userList: newUserList
              });
            });
          }
        }

        setInput("");
        event.preventDefault();
    }
  };

  var isValidTagOption = function isValidTagOption() {
    var isValid = false;
    var labelsTags = tags.map(function (option) {
      return option.label;
    });

    if (labelsTags.length && labelsTags.includes(input)) {
      toast.warn(labels.repeatedValueMessage);
      return isValid;
    }

    isValid = true;
    return isValid;
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-mb-4",
      children: [
      /* @__PURE__ */
      jsx$1("label", {
        htmlFor: labels.tags,
        className: titleManageGameStyle,
        children: labels.tags
      }),
      /* @__PURE__ */
      jsx$1(CreatableSelect$1, {
        styles: selectStyles,
        components: {
          DropdownIndicator: null
        },
        inputValue: input,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        onChange: handleChange,
        onInputChange: handleInputChange2,
        onKeyDown: handleKeyDown,
        placeholder: labels.tagsPlaceholder,
        value: tags
      })]
    })
  );
};

var WinnersBody = function WinnersBody(props) {
  var onChangePosition = function onChangePosition(event, index2) {
    event.persist();

    var newUsersList = _toConsumableArray3(props.winnersRequestBody.userList);

    newUsersList[index2].position = event.target.value;
    props.setWinnersRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        userList: newUsersList
      });
    });
  };

  var onChangeWinnerId = function onChangeWinnerId(profileId, profileModel, index2) {
    var newUsersList = _toConsumableArray3(props.winnersRequestBody.userList);

    newUsersList[index2].profileId = profileId;
    newUsersList[index2].profileModel = profileModel;
    props.setWinnersRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        userList: newUsersList
      });
    });
  };

  var onChangeNote = function onChangeNote(event, index2) {
    event.persist();

    var newUsersList = _toConsumableArray3(props.winnersRequestBody.userList);

    newUsersList[index2].note = event.target.value;
    props.setWinnersRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        userList: newUsersList
      });
    });
  };

  var addWinner = function addWinner() {
    var newWinner = new WinnersUserList();
    var copyWinnersRequestBody = JSON.parse(JSON.stringify(props.winnersRequestBody));
    copyWinnersRequestBody.userList.push(newWinner);
    props.setWinnersRequestBody(copyWinnersRequestBody);
  };

  var removeWinner = function removeWinner(index2) {
    var copyWinnersRequestBody = JSON.parse(JSON.stringify(props.winnersRequestBody));
    var newUserList = copyWinnersRequestBody.userList.filter(function (_2, idx) {
      return index2 !== idx;
    });
    props.setWinnersRequestBody(function (prevState) {
      return _objectSpread3({}, prevState, {
        userList: newUserList
      });
    });
  };

  return (
    /* @__PURE__ */
    jsxs("div", {
      className: "topxw-p-2 topxw-border topxw-mb-4 topxw-border-gray-200 topxw-rounded",
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-4",
        children: [
        /* @__PURE__ */
        jsx$1(RichText, {
          property: "winners_description",
          defaultValue: props.description,
          labels: props.labels,
          setValue: props.setDescription
        }),
        /* @__PURE__ */
        jsx$1("p", {
          className: "topxw-text-gray-400 topxw-text-xs",
          children: props.labels.winnersDescription
        })]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-4",
        children: [
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-mb-2",
          children: [
          /* @__PURE__ */
          jsx$1("h3", {
            className: titleManageGameStyle,
            children: props.labels.insertWinners
          }),
          /* @__PURE__ */
          jsx$1("p", {
            className: "topxw-text-gray-400 topxw-text-sm",
            children: props.labels.insertWinnersDescription
          })]
        }),
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-grid topxw-grid-cols-1 md:topxw-grid-cols-2 topxw-gap-4 topxw-mb-1",
          children: [props.winnersRequestBody.userList.map(function (winner, idx) {
            return (
              /* @__PURE__ */
              jsxs("div", {
                className: "topxw-shadow-l topxw-border topxw-border-gray-200",
                children: [
                /* @__PURE__ */
                jsxs("div", {
                  className: "topxw-bg-gray-100 topxw-p-3 topxw-flex topxw-justify-between",
                  children: [
                  /* @__PURE__ */
                  jsxs("h3", {
                    children: [props.labels.winner, " ", idx + 1]
                  }), idx > 0 ?
                  /* @__PURE__ */
                  jsx$1(RemoveButton, {
                    removeFixture: props.labels.removeWinner,
                    onClick: function onClick() {
                      return removeWinner(idx);
                    }
                  }) : null]
                }),
                /* @__PURE__ */
                jsxs("div", {
                  className: "topxw-px-3 topxw-pt-3 topxw-pb-4",
                  children: [
                  /* @__PURE__ */
                  jsx$1(WinnersInformation, {
                    title: props.labels.position,
                    placeholder: props.labels.position,
                    onChange: onChangePosition,
                    value: winner.position,
                    index: idx
                  }),
                  /* @__PURE__ */
                  jsx$1(WinnerSelect, {
                    index: idx,
                    title: props.labels.winner,
                    description: props.labels.winnerDescription,
                    leaderboard: props.leaderboard,
                    pointsLabel: props.labels.points,
                    loadMoreLabel: props.labels.loadMore,
                    leaderboardNotAvailableLabel: props.labels.leaderboardNotAvailable,
                    winnerId: winner.profileId,
                    hasMoreParticipants: props.hasMoreParticipants,
                    onChange: onChangeWinnerId,
                    setPage: props.setPage
                  }),
                  /* @__PURE__ */
                  jsx$1(WinnersInformation, {
                    title: props.labels.note,
                    placeholder: props.labels.notePlaceholder,
                    onChange: onChangeNote,
                    value: winner.note,
                    index: idx
                  }),
                  /* @__PURE__ */
                  jsx$1(WinnerTags, {
                    labels: props.labels,
                    tags: winner.tags,
                    setWinnersRequestBody: props.setWinnersRequestBody,
                    index: idx
                  })]
                })]
              }, "new-winner-".concat(idx))
            );
          }),
          /* @__PURE__ */
          jsx$1(AddButton, {
            addLabel: props.labels.addWinner,
            onClick: addWinner
          })]
        })]
      })]
    })
  );
};

var BackButton = function BackButton(_ref660) {
  var labelBack = _ref660.labelBack,
      onClick = _ref660.onClick;
  return (
    /* @__PURE__ */
    jsx$1(Tippy, {
      content: labelBack,
      children:
      /* @__PURE__ */
      jsx$1("button", {
        "data-testid": "back",
        className: "topxw-rounded topxw-bg-transparent topxw-mr-2 topxw-flex topxw-items-center",
        onClick: onClick,
        children:
        /* @__PURE__ */
        jsx$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: "topxw-h-7 topxw-w-7",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: "2",
          children:
          /* @__PURE__ */
          jsx$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
          })
        })
      })
    })
  );
};

var WinnersHeading = function WinnersHeading(props) {
  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-items-center topxw-mb-2",
        children: [
        /* @__PURE__ */
        jsx$1(BackButton, {
          labelBack: props.labels.back,
          onClick: function onClick() {
            return props.setWinnersMode(false);
          }
        }),
        /* @__PURE__ */
        jsx$1("h2", {
          className: "topxw-text-xl topxw-font-bold",
          children: props.labels.manageWinners
        })]
      }),
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-flex topxw-items-center topxw-mb-2",
        children: [
        /* @__PURE__ */
        jsxs("label", {
          className: "topxw-mr-1",
          children: [props.labels.title, ":"]
        }),
        /* @__PURE__ */
        jsx$1("label", {
          className: "topxw-text-xl topxw-font-bold",
          children: props.gameTitle
        })]
      })]
    })
  );
};

var isUserListFulfilled = function isUserListFulfilled(usersList) {
  if (usersList.length === 1) {
    return usersList.every(function (user) {
      return user.note || user.position || user.profileId || user.tags.length;
    });
  }

  return true;
};

var initWinnersRequestBody = function initWinnersRequestBody(winners) {
  if (Object.keys(winners).length) {
    if (!winners.userList) {
      winners.userList = [new WinnersUserList()];
    }

    return winners;
  }

  return new GameWinnersRequestBody();
};

var WinnersLayout = function WinnersLayout(props) {
  var _a2;

  var _useState121 = useState(initWinnersRequestBody(props.winners)),
      _useState122 = _slicedToArray3(_useState121, 2),
      winnersRequestBody = _useState122[0],
      setWinnersRequestBody = _useState122[1];

  var _useState123 = useState(((_a2 = props.winners) == null ? void 0 : _a2.description) || ""),
      _useState124 = _slicedToArray3(_useState123, 2),
      description = _useState124[0],
      setDescription = _useState124[1];

  var _useState125 = useState(false),
      _useState126 = _slicedToArray3(_useState125, 2),
      isLoading = _useState126[0],
      setIsLoading = _useState126[1];

  var _useState127 = useState(1),
      _useState128 = _slicedToArray3(_useState127, 2),
      page = _useState128[0],
      setPage = _useState128[1];

  var _useLeaderboard = useLeaderboard(props.game.id, props.labels.leaderboardErrorMessage, props.sdk, page),
      leaderboard = _useLeaderboard.leaderboard,
      hasMoreParticipants = _useLeaderboard.hasMoreParticipants;

  var manageWinner =
  /*#__PURE__*/
  function () {
    var _ref661 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee641() {
      var copyRequestBody, validator2, remappedReqBody;
      return _regeneratorRuntime.wrap(function _callee641$(_context642) {
        while (1) {
          switch (_context642.prev = _context642.next) {
            case 0:
              setIsLoading(true);
              copyRequestBody = JSON.parse(JSON.stringify(winnersRequestBody));
              copyRequestBody.contestId = props.game.id;
              copyRequestBody.description = description;
              delete copyRequestBody.contestModel;
              copyRequestBody.userList.forEach(function (winner) {
                winner.tags = winner.tags.map(function (tag) {
                  return tag.value;
                });
                delete winner.profileModel;
              });

              if (!isUserListFulfilled(copyRequestBody.userList)) {
                _context642.next = 14;
                break;
              }

              validator2 = new WinnerValidator().validate(copyRequestBody.userList, props.labels);

              if (validator2.isValid) {
                _context642.next = 12;
                break;
              }

              toast.error(validator2.message);
              setIsLoading(false);
              return _context642.abrupt("return");

            case 12:
              _context642.next = 15;
              break;

            case 14:
              delete copyRequestBody.userList;

            case 15:
              remappedReqBody = remapKeysToSpecificCase(copyRequestBody, "snake");
              _context642.prev = 16;
              _context642.next = 19;
              return props.httpsService.createWinners(remappedReqBody);

            case 19:
              toast.success(Object.keys(props.winners).length ? props.labels.editGameWinnersMessage : props.labels.createGameWinnersMessage);
              _context642.next = 26;
              break;

            case 22:
              _context642.prev = 22;
              _context642.t0 = _context642["catch"](16);
              console.error(_context642.t0);
              toast.error(Object.keys(props.winners).length ? props.labels.editGameWinnersErrorMessage : props.labels.createGameWinnersErrorMessage);

            case 26:
              setIsLoading(false);

            case 27:
            case "end":
              return _context642.stop();
          }
        }
      }, _callee641, null, [[16, 22]]);
    }));

    return function manageWinner() {
      return _ref661.apply(this, arguments);
    };
  }();

  return (
    /* @__PURE__ */
    jsxs(Fragment, {
      children: [
      /* @__PURE__ */
      jsx$1(WinnersHeading, {
        labels: props.labels,
        gameTitle: props.game.title,
        winnersDescription: winnersRequestBody.description,
        setWinnersMode: props.setWinnersMode
      }),
      /* @__PURE__ */
      jsx$1(WinnersBody, {
        labels: props.labels,
        winnersRequestBody: winnersRequestBody,
        leaderboard: leaderboard,
        hasMoreParticipants: hasMoreParticipants,
        description: description,
        setDescription: setDescription,
        setWinnersRequestBody: setWinnersRequestBody,
        setPage: setPage
      }),
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-mb-4",
        children:
        /* @__PURE__ */
        jsx$1(ManagementButton, {
          paddingX: "topxw-px-24",
          paddingY: "topxw-py-3",
          mainLabel: props.labels.save,
          centerButton: true,
          loadingLabel: props.labels.loadingMessage,
          isLoading: isLoading,
          onClick: manageWinner
        })
      }), winnersRequestBody && Object.keys(winnersRequestBody).length ?
      /* @__PURE__ */
      jsx$1(PreviewWinners, {
        winners: winnersRequestBody,
        labels: props.labels
      }) : null]
    })
  );
};

var Winners = function Winners(_ref662) {
  var game = _ref662.game,
      sdk = _ref662.sdk,
      labels = _ref662.labels,
      httpsService = _ref662.httpsService,
      setWinnersMode = _ref662.setWinnersMode;
  var winners = useWinners(sdk, game.id, labels.gameWinnersErrorMessage);
  if (!winners) return (
    /* @__PURE__ */
    jsx$1(Spinner, {
      forNextMatches: false
    })
  );
  return (
    /* @__PURE__ */
    jsx$1(WinnersLayout, {
      winners: winners,
      labels: labels,
      game: game,
      sdk: sdk,
      httpsService: httpsService,
      setWinnersMode: setWinnersMode
    })
  );
};

var SignOut = function SignOut(_ref663) {
  var label = _ref663.label,
      fansUnitedEnvironment = _ref663.fansUnitedEnvironment;

  var signOut =
  /*#__PURE__*/
  function () {
    var _ref664 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee642() {
      return _regeneratorRuntime.wrap(function _callee642$(_context643) {
        while (1) {
          switch (_context643.prev = _context643.next) {
            case 0:
              _context643.next = 2;
              return firebaseAuth(fansUnitedEnvironment).signOut();

            case 2:
            case "end":
              return _context643.stop();
          }
        }
      }, _callee642);
    }));

    return function signOut() {
      return _ref664.apply(this, arguments);
    };
  }();

  return (
    /* @__PURE__ */
    jsx$1("button", {
      className: "topxw-rounded topxw-bg-gray-700 topxw-text-white hover:topxw-bg-gray-800 topxw-uppercase topxw-text-xs topxw-font-bold topxw-py-2 topxw-px-6 ",
      onClick: signOut,
      children: label
    })
  );
};

var GamesList = function GamesList(_ref665) {
  var sdk = _ref665.sdk,
      httpsService = _ref665.httpsService,
      minFixtures = _ref665.minFixtures,
      maxFixtures = _ref665.maxFixtures,
      competitionsScope = _ref665.competitionsScope,
      labels = _ref665.labels,
      fansUnitedEnvironment = _ref665.fansUnitedEnvironment,
      sportal365Config = _ref665.sportal365Config;

  var _useState129 = useState(1),
      _useState130 = _slicedToArray3(_useState129, 2),
      pageCount = _useState130[0],
      setPageCount = _useState130[1];

  var _useState131 = useState({}),
      _useState132 = _slicedToArray3(_useState131, 2),
      pageGames = _useState132[0],
      setPageGames = _useState132[1];

  var _useState133 = useState(""),
      _useState134 = _slicedToArray3(_useState133, 2),
      startAfter = _useState134[0],
      setStartAfter = _useState134[1];

  var _useState135 = useState(false),
      _useState136 = _slicedToArray3(_useState135, 2),
      isLoading = _useState136[0],
      setIsLoading = _useState136[1];

  var _useState137 = useState(false),
      _useState138 = _slicedToArray3(_useState137, 2),
      editMode = _useState138[0],
      setEditMode = _useState138[1];

  var _useState139 = useState(false),
      _useState140 = _slicedToArray3(_useState139, 2),
      createMode = _useState140[0],
      setCreateMode = _useState140[1];

  var _useState141 = useState(false),
      _useState142 = _slicedToArray3(_useState141, 2),
      reportMode = _useState142[0],
      setReportMode = _useState142[1];

  var _useState143 = useState(false),
      _useState144 = _slicedToArray3(_useState143, 2),
      winnersMode = _useState144[0],
      setWinnersMode = _useState144[1];

  var _useState145 = useState([]),
      _useState146 = _slicedToArray3(_useState145, 2),
      loadedFixtures = _useState146[0],
      setLoadedFixtures = _useState146[1];

  var _useState147 = useState(null),
      _useState148 = _slicedToArray3(_useState147, 2),
      game = _useState148[0],
      setGame = _useState148[1];

  var gamesPerPage = 10;
  var disableCache = true;

  var getGames =
  /*#__PURE__*/
  function () {
    var _ref666 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee643() {
      var topXGames;
      return _regeneratorRuntime.wrap(function _callee643$(_context644) {
        while (1) {
          switch (_context644.prev = _context644.next) {
            case 0:
              _context644.next = 2;
              return sdk.topX.getGames({
                limit: gamesPerPage
              }, disableCache);

            case 2:
              topXGames = _context644.sent;
              setStartAfter(topXGames.meta.pagination.nextPageStartsAfter);
              setPageGames(_defineProperty3({}, pageCount, topXGames.data));

            case 5:
            case "end":
              return _context644.stop();
          }
        }
      }, _callee643);
    }));

    return function getGames() {
      return _ref666.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getGames().catch(function (error) {
      return console.warn(error);
    });
  }, []);
  useEffect(function () {
    if (Object.keys(pageGames).length > 0) {
      if (!Object.keys(pageGames).includes(pageCount.toString())) {
        var fetchGames =
        /*#__PURE__*/
        function () {
          var _ref667 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee644(startAfter2) {
            var topXGames;
            return _regeneratorRuntime.wrap(function _callee644$(_context645) {
              while (1) {
                switch (_context645.prev = _context645.next) {
                  case 0:
                    _context645.next = 2;
                    return sdk.topX.getGames({
                      limit: gamesPerPage,
                      startAfter: startAfter2
                    }, disableCache);

                  case 2:
                    topXGames = _context645.sent;

                    if (topXGames.data.length > 0) {
                      setPageGames(_objectSpread3({}, pageGames, _defineProperty3({}, pageCount, topXGames.data)));
                      setStartAfter(topXGames.meta.pagination.nextPageStartsAfter);
                    }

                  case 4:
                  case "end":
                    return _context645.stop();
                }
              }
            }, _callee644);
          }));

          return function fetchGames(_x1187) {
            return _ref667.apply(this, arguments);
          };
        }();

        fetchGames(startAfter).catch(function (error) {
          return console.warn(error);
        });
      }
    }
  }, [pageCount]);

  var manageMode = function manageMode() {
    if (editMode) {
      return (
        /* @__PURE__ */
        jsx$1(EditGameScreen, {
          sdk: sdk,
          getGames: getGames,
          httpsService: httpsService,
          editMode: editMode,
          minFixtures: minFixtures,
          maxFixtures: maxFixtures,
          competitionsScope: competitionsScope,
          game: game,
          loadedFixtures: loadedFixtures,
          setEditMode: setEditMode,
          setLoadedFixtures: setLoadedFixtures,
          labels: labels,
          sportal365Config: sportal365Config
        })
      );
    } else if (createMode) {
      return (
        /* @__PURE__ */
        jsx$1(CreateGameScreen, {
          sdk: sdk,
          getGames: getGames,
          setCreateMode: setCreateMode,
          httpsService: httpsService,
          minFixtures: minFixtures,
          maxFixtures: maxFixtures,
          competitionsScope: competitionsScope,
          labels: labels,
          sportal365Config: sportal365Config
        })
      );
    }
  };

  var getPreviousPage = function getPreviousPage() {
    setPageCount(function (prevPage) {
      return prevPage - 1;
    });
  };

  var getNextPage = function getNextPage() {
    setPageCount(function (prevPage) {
      return prevPage + 1;
    });
  };

  if (manageMode()) {
    return manageMode();
  }

  if (reportMode) {
    return (
      /* @__PURE__ */
      jsx$1(Report, {
        sdk: sdk,
        gameId: game.id,
        setReportMode: setReportMode,
        gameTitle: game.title,
        labels: labels,
        https: httpsService
      })
    );
  }

  if (winnersMode) {
    return (
      /* @__PURE__ */
      jsx$1(Winners, {
        sdk: sdk,
        game: game,
        labels: labels,
        httpsService: httpsService,
        setWinnersMode: setWinnersMode
      })
    );
  }

  if (!Object.keys(pageGames).includes(pageCount.toString()) || isLoading) {
    return (
      /* @__PURE__ */
      jsx$1(Spinner, {
        forNextMatches: false
      })
    );
  }

  return (
    /* @__PURE__ */
    jsxs(React__default.Fragment, {
      children: [
      /* @__PURE__ */
      jsxs("div", {
        className: "topxw-mb-4 topxw-flex topxw-p-2 topxw-items-center topxw-justify-between",
        children: [
        /* @__PURE__ */
        jsx$1(ManagementButton, {
          mainLabel: labels.createEdition,
          centerButton: false,
          paddingX: "topxw-px-6",
          paddingY: "topxw-py-2",
          onClick: function onClick() {
            return setCreateMode(true);
          }
        }),
        /* @__PURE__ */
        jsx$1(SignOut, {
          label: labels.signOut,
          fansUnitedEnvironment: fansUnitedEnvironment
        })]
      }),
      /* @__PURE__ */
      jsxs(GamesCard, {
        children: [pageGames && pageGames[pageCount] && pageGames[pageCount].length > 0 &&
        /* @__PURE__ */
        jsxs(React__default.Fragment, {
          children: [
          /* @__PURE__ */
          jsxs("table", {
            "data-testid": "games list",
            className: "topxw-w-full topxw-border topxw-border-gray-200 topxw-mb-2 topxw-table",
            children: [
            /* @__PURE__ */
            jsx$1(TableHeader, {
              labels: labels,
              reportMode: false
            }),
            /* @__PURE__ */
            jsx$1("tbody", {
              "data-testid": "games",
              className: "topxw-bg-white",
              children: pageGames && pageGames[pageCount] && pageGames[pageCount].map(function (game2, idx) {
                return (
                  /* @__PURE__ */
                  jsx$1(Game, {
                    game: game2,
                    index: idx,
                    sdk: sdk,
                    setIsLoading: setIsLoading,
                    labels: labels,
                    setEditMode: setEditMode,
                    setReportMode: setReportMode,
                    setWinnersMode: setWinnersMode,
                    setGame: setGame,
                    setLoadedFixtures: setLoadedFixtures
                  }, "game-key-".concat(game2.id))
                );
              })
            })]
          }),
          /* @__PURE__ */
          jsx$1(Pagination, {
            pageCount: pageCount,
            pageGames: pageGames,
            labels: labels,
            getPreviousPage: getPreviousPage,
            getNextPage: getNextPage
          })]
        }), pageGames && pageGames[pageCount] && pageGames[pageCount].length === 0 &&
        /* @__PURE__ */
        jsx$1("h2", {
          className: "topxw-text-center topxw-font-bold topxw-text-xl topxw-my-60",
          children: labels.noGamesFound
        })]
      })]
    })
  );
};

var NoPermissionCard = function NoPermissionCard(_ref668) {
  var fansUnitedEnvironment = _ref668.fansUnitedEnvironment,
      labels = _ref668.labels,
      setNoPermission = _ref668.setNoPermission;
  var featureDisabled = labels.featureDisabled,
      noPermissionMessage = labels.noPermissionMessage,
      tryAgainButton = labels.tryAgainButton;

  var displayLoginScreen = function displayLoginScreen() {
    firebaseAuth(fansUnitedEnvironment).signOut().then(function (_2) {
      setNoPermission(true);
    }).catch(function (error) {
      console.error("There was a problem loging out the user:", error);
    });
  };

  return (
    /* @__PURE__ */
    jsx$1("div", {
      "data-testid": "no permission card",
      className: "topxw-flex topxw-items-center topxw-justify-center topxw-min-h-screen topxw-bg-white",
      children:
      /* @__PURE__ */
      jsx$1("div", {
        className: "topxw-overflow-hidden topxw-rounded topxw-bg-gray-50",
        children:
        /* @__PURE__ */
        jsxs("div", {
          className: "topxw-p-5 topxw-w-72",
          children: [
          /* @__PURE__ */
          jsx$1("h2", {
            className: "topxw-text-center",
            children: featureDisabled
          }),
          /* @__PURE__ */
          jsx$1("p", {
            className: "topxw-text-medium topxw-mb-5 topxw-text-gray-700",
            children: noPermissionMessage
          }),
          /* @__PURE__ */
          jsx$1("div", {
            className: "topxw-flex topxw-items-center topxw-justify-center",
            children:
            /* @__PURE__ */
            jsx$1("button", {
              className: "topxw-rounded topxw-bg-gray-700 topxw-text-white hover:topxw-bg-gray-800 topxw-uppercase topxw-text-xs topxw-w-full topxw-py-2",
              onClick: displayLoginScreen,
              children: tryAgainButton
            })
          })]
        })
      })
    })
  );
};

var MainRouting = function MainRouting(_ref669) {
  var fansUnitedEnvironment = _ref669.fansUnitedEnvironment,
      sdk = _ref669.sdk,
      labels = _ref669.labels,
      httpsService = _ref669.httpsService,
      sportal365Config = _ref669.sportal365Config;
  var user = useContext(AuthContext);

  var _useState149 = useState(null),
      _useState150 = _slicedToArray3(_useState149, 2),
      enabled = _useState150[0],
      setEnabled = _useState150[1];

  var _useState151 = useState(null),
      _useState152 = _slicedToArray3(_useState151, 2),
      minFixtures = _useState152[0],
      setMinFixtures = _useState152[1];

  var _useState153 = useState(null),
      _useState154 = _slicedToArray3(_useState153, 2),
      maxFixtures = _useState154[0],
      setMaxFixtures = _useState154[1];

  var _useState155 = useState(null),
      _useState156 = _slicedToArray3(_useState155, 2),
      competitionsScope = _useState156[0],
      setCompetitionsScope = _useState156[1];

  var _useState157 = useState(false),
      _useState158 = _slicedToArray3(_useState157, 2),
      noPermission = _useState158[0],
      setNoPermission = _useState158[1];

  var getConfig =
  /*#__PURE__*/
  function () {
    var _ref670 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee645() {
      return _regeneratorRuntime.wrap(function _callee645$(_context646) {
        while (1) {
          switch (_context646.prev = _context646.next) {
            case 0:
              if (user) {
                sdk.topX.getConfig().then(function (config) {
                  setEnabled(config.enabled);
                  setMinFixtures(config.minFixtures);
                  setMaxFixtures(config.maxFixtures);
                  setCompetitionsScope(config.competitionsWhitelist);
                }).catch(function (error) {
                  console.error(error);
                  toast.error(labels.clientFeaturesNotFoundMessage);
                  setEnabled(false);
                });
              }

            case 1:
            case "end":
              return _context646.stop();
          }
        }
      }, _callee645);
    }));

    return function getConfig() {
      return _ref670.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getConfig();
  }, [user]);

  if (!user || noPermission) {
    return (
      /* @__PURE__ */
      jsx$1(Login, {
        userNotFound: labels.userNotFoundMessage,
        setNoPermission: setNoPermission,
        fansUnitedEnvironment: fansUnitedEnvironment
      })
    );
  }

  if (enabled === null) {
    return (
      /* @__PURE__ */
      jsx$1(Spinner, {
        forNextMatches: false
      })
    );
  }

  return (
    /* @__PURE__ */
    jsxs(React__default.Fragment, {
      children: [enabled &&
      /* @__PURE__ */
      jsx$1(TopXWidgetCard, {
        children:
        /* @__PURE__ */
        jsx$1(GamesList, {
          sdk: sdk,
          httpsService: httpsService,
          minFixtures: minFixtures,
          maxFixtures: maxFixtures,
          competitionsScope: competitionsScope,
          labels: labels,
          fansUnitedEnvironment: fansUnitedEnvironment,
          sportal365Config: sportal365Config
        })
      }), !enabled &&
      /* @__PURE__ */
      jsx$1(NoPermissionCard, {
        labels: labels,
        setNoPermission: setNoPermission,
        fansUnitedEnvironment: fansUnitedEnvironment
      })]
    })
  );
};

var AuthProvider = function AuthProvider(_ref671) {
  var children = _ref671.children,
      fansUnitedEnvironment = _ref671.fansUnitedEnvironment;

  var _useState159 = useState(null),
      _useState160 = _slicedToArray3(_useState159, 2),
      user = _useState160[0],
      setUser = _useState160[1];

  var _useState161 = useState(true),
      _useState162 = _slicedToArray3(_useState161, 2),
      loading = _useState162[0],
      setLoading = _useState162[1];

  useEffect(function () {
    var unsubscribe2 = firebaseAuth(fansUnitedEnvironment).onAuthStateChanged(function (firebaseUser) {
      unstable_batchedUpdates(function () {
        setLoading(false);
        setUser(firebaseUser);
      });
    });
    return unsubscribe2;
  }, []);
  return (
    /* @__PURE__ */
    jsx$1(AuthContext.Provider, {
      value: user,
      children: !loading && children
    })
  );
};

var configureSportal365 = function configureSportal365(project, infrastructure) {
  if (!project && !infrastructure) {
    return null;
  }

  if (!project) {
    console.warn("'sportal365Project' prop is not provided. The prop is required when 'sportal365Infrastructure' prop is provided. Functionalities with Sportal365 API will not be exposed");
    return null;
  }

  var token2 = infrastructure && infrastructure === "betway" ? {}.VITE_SPORTAL365_BETWAY_TOKEN : {}.VITE_SPORTAL365_SHARED_TOKEN;
  return {
    project: project,
    authorization: "Bearer ".concat(token2)
  };
};

var Main = function Main(props) {
  var labels = new LabelsModel(props.labels);
  var config = new FansUnitedConfigurationModel(props.fansUnitedApiKey, props.fansUnitedClientId, props.fansUnitedLanguage, props.fansUnitedEnvironment);
  var sportal365Config = configureSportal365(props.sportal365Project, props.sportal365Infrastructure);
  var httpsService = new HttpsService(config);
  var sdk = vT(config);
  return (
    /* @__PURE__ */
    jsx$1(AuthProvider, {
      fansUnitedEnvironment: props.fansUnitedEnvironment,
      children:
      /* @__PURE__ */
      jsxs(React__default.Fragment, {
        children: [
        /* @__PURE__ */
        jsx$1(ToastContainer, {
          position: "top-right",
          autoClose: 5e3,
          hideProgressBar: false,
          limit: 3,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: false,
          draggable: true,
          pauseOnHover: true
        }),
        /* @__PURE__ */
        jsx$1(MainRouting, {
          sdk: sdk,
          httpsService: httpsService,
          labels: labels,
          fansUnitedEnvironment: props.fansUnitedEnvironment,
          sportal365Config: sportal365Config
        })]
      })
    })
  );
};

export { Main as TopXManager };